// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%238b96a0%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%238b96a0%27 opacity=%270.5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%230acf97%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23fa5c7c%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23fa5c7c%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27var%28--ct-navbar-light-color%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27var%28--ct-navbar-dark-color%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--ct-accordion-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--ct-accordion-button-active-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%238b96a0%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/waves.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/Nunito-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/Nunito-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/Nunito-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/Nunito-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/Nunito-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/Nunito-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/Nunito-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/Nunito-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/Nunito-SemiBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/Nunito-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/Nunito-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/Nunito-SemiBold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../fonts/Nunito-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../fonts/Nunito-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../fonts/Nunito-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../fonts/Nunito-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../fonts/unicons.eot?34404611", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../fonts/unicons.woff2?34404611", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../fonts/unicons.woff?34404611", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../fonts/unicons.ttf?34404611", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../fonts/unicons.svg?34404611", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../fonts/dripicons-v2.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../fonts/dripicons-v2.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../fonts/dripicons-v2.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../fonts/dripicons-v2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../fonts/materialdesignicons-webfont.eot?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../fonts/materialdesignicons-webfont.woff?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=6.5.95", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___, { hash: "#Roboto" });
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "#Roboto" });
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#Roboto" });
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___, { hash: "#Roboto" });
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___, { hash: "#unicons" });
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___, { hash: "#dripicons-v2" });
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___, { hash: "?#iefix&v=6.5.95" });
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Hyper - Responsive Bootstrap 5 Admin Dashboard
Version: 3.4.0
Author: CoderThemes
Email: support@coderthemes.com
File: Main Css File
*/
:root {
  --ct-link-color: #0d6efd;
  --ct-link-hover-color: #0a58ca;
}

:root {
  --ct-link-color: #727cf5;
  --ct-link-hover-color: rgb(38%, 41.3333333333%, 81.6666666667%);
  --ct-border-color: #dee2e6;
  --ct-box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
  --ct-box-shadow-sm: 0 .125rem .25rem rgba(0, 0, 0, 0.075);
  --ct-box-shadow-lg: 0 0 45px 0 rgba(0, 0, 0, 0.12);
  --ct-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --ct-component-active-color: #fff;
  --ct-component-active-bg: #727cf5;
  --ct-text-muted: #98a6ad;
  --ct-blockquote-footer-color: #98a6ad;
  --ct-mark-bg: #fcf8e3;
  --ct-table-color: #6c757d;
  --ct-table-bg: transparent;
  --ct-table-accent-bg: transparent;
  --ct-table-striped-color: #6c757d;
  --ct-table-striped-bg: rgba(241, 243, 250, 0.8);
  --ct-table-active-color: var(--ct-table-color);
  --ct-table-active-bg: rgba(222, 226, 230, 0.4);
  --ct-table-hover-color: var(--ct-table-color);
  --ct-table-hover-bg: #f1f3fa;
  --ct-table-border-color: #eef2f7;
  --ct-table-group-separator-color: rgb(92.7484787018%, 93.6274509804%, 94.506423259%);
  --ct-table-caption-color: var(--ct-text-muted);
  --ct-input-btn-focus-color: rgba(114, 124, 245, 0.25);
  --ct-btn-active-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-link-color: #0d6efd;
  --ct-btn-link-hover-color: #0a58ca;
  --ct-btn-link-disabled-color: #adb5bd;
  --ct-form-text-color: var(--ct-text-muted);
  --ct-input-bg: #fff;
  --ct-input-disabled-bg: #eef2f7;
  --ct-input-color: #6c757d;
  --ct-input-border-color: #dee2e6;
  --ct-input-box-shadow: var(--ct-box-shadow-inset);
  --ct-input-focus-bg: var(--ct-input-bg);
  --ct-input-focus-border-color: rgb(78.3529411765%, 79.7647058824%, 81.1764705882%);
  --ct-input-focus-color: var(--ct-input-color);
  --ct-input-placeholder-color: #adb5bd;
  --ct-input-plaintext-color: #6c757d;
  --ct-form-check-input-bg: #fff;
  --ct-form-check-input-border: 1px solid #dee2e6;
  --ct-form-check-input-checked-color: var(--ct-component-active-color);
  --ct-form-check-input-checked-bg-color: var(--ct-component-active-bg);
  --ct-form-check-input-checked-border-color: var(--ct-form-check-input-checked-bg-color);
  --ct-form-check-input-indeterminate-color: var(--ct-component-active-color);
  --ct-form-check-input-indeterminate-bg-color: var(--ct-component-active-bg);
  --ct-form-check-input-indeterminate-border-color: var(--ct-component-active-bg);
  --ct-form-switch-color: #dee2e6;
  --ct-input-group-addon-color: var(--ct-input-color);
  --ct-input-group-addon-bg: #eef2f7;
  --ct-input-group-addon-border-color: #dee2e6;
  --ct-form-select-color: var(--ct-input-color);
  --ct-form-select-bg: var(--ct-input-bg);
  --ct-form-select-disabled-color: #98a6ad;
  --ct-form-select-disabled-bg: #eef2f7;
  --ct-form-select-indicator-color: #343a40;
  --ct-form-range-track-bg: #dee2e6;
  --ct-form-range-track-box-shadow: var(--ct-box-shadow-inset);
  --ct-form-range-thumb-box-shadow: 0 .1rem .25rem rgba(0, 0, 0, 0.1);
  --ct-form-range-thumb-active-bg: rgb(83.4117647059%, 84.5882352941%, 98.8235294118%);
  --ct-form-range-thumb-disabled-bg: #adb5bd;
  --ct-form-file-button-color: var(--ct-input-color);
  --ct-form-file-button-bg: #eef2f7;
  --ct-form-file-button-hover-bg: rgb(88.6666666667%, 90.1568627451%, 92.0196078431%);
  --ct-nav-link-disabled-color: #98a6ad;
  --ct-nav-tabs-border-color: #dee2e6;
  --ct-nav-tabs-link-hover-border-color: #eef2f7 #eef2f7 var(--ct-nav-tabs-border-color);
  --ct-nav-tabs-link-active-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);
  --ct-nav-tabs-link-active-bg: #fff;
  --ct-nav-tabs-link-active-border-color: #dee2e6 #dee2e6 var(--ct-nav-tabs-link-active-bg);
  --ct-navbar-dark-color: rgba(255, 255, 255, 0.55);
  --ct-navbar-dark-hover-color: rgba(255, 255, 255, 0.75);
  --ct-navbar-dark-active-color: #fff;
  --ct-navbar-dark-disabled-color: rgba(255, 255, 255, 0.25);
  --ct-navbar-dark-toggler-border-color: rgba(255, 255, 255, 0.1);
  --ct-navbar-light-color: rgb(40.2352941176%, 43.5882352941%, 46.568627451%);
  --ct-navbar-light-hover-color: #343a40;
  --ct-navbar-light-active-color: rgba(0, 0, 0, 0.9);
  --ct-navbar-light-disabled-color: #adb5bd;
  --ct-dropdown-color: #6c757d;
  --ct-dropdown-bg: #fff;
  --ct-dropdown-border-color: rgb(90.5333333333%, 92.0549019608%, 93.9568627451%);
  --ct-dropdown-divider-bg: rgb(90.5333333333%, 92.0549019608%, 93.9568627451%);
  --ct-dropdown-box-shadow: var(--ct-box-shadow);
  --ct-dropdown-link-color: #6c757d;
  --ct-dropdown-link-hover-color: rgb(17.2941176471%, 20.4705882353%, 24.7058823529%);
  --ct-dropdown-link-hover-bg: rgb(95.7176470588%, 96.3294117647%, 98.4705882353%);
  --ct-dropdown-link-active-color: #313a46;
  --ct-dropdown-link-active-bg: rgb(94.9333333333%, 96.1254901961%, 97.6156862745%);
  --ct-dropdown-link-disabled-color: #98a6ad;
  --ct-dropdown-dark-color: #dee2e6;
  --ct-dropdown-dark-bg: #343a40;
  --ct-dropdown-dark-border-color: var(--ct-dropdown-border-color);
  --ct-dropdown-dark-divider-bg: var(--ct-dropdown-divider-bg);
  --ct-dropdown-dark-link-color: var(--ct-dropdown-dark-color);
  --ct-dropdown-dark-link-hover-color: #fff;
  --ct-dropdown-dark-link-hover-bg: rgba(255, 255, 255, 0.15);
  --ct-dropdown-dark-link-active-color: var(--ct-dropdown-link-active-color);
  --ct-dropdown-dark-link-active-bg: var(--ct-dropdown-link-active-bg);
  --ct-dropdown-dark-link-disabled-color: #adb5bd;
  --ct-dropdown-dark-header-color: #adb5bd;
  --ct-pagination-color: #313a46;
  --ct-pagination-bg: #fff;
  --ct-pagination-border-color: #dee2e6;
  --ct-pagination-focus-color: #0a58ca;
  --ct-pagination-focus-bg: #eef2f7;
  --ct-pagination-focus-box-shadow: 0 0 0 0.2rem var(--ct-input-btn-focus-color);
  --ct-pagination-hover-color: #313a46;
  --ct-pagination-hover-bg: #eef2f7;
  --ct-pagination-hover-border-color: #dee2e6;
  --ct-pagination-disabled-color: #98a6ad;
  --ct-pagination-disabled-bg: #fff;
  --ct-pagination-disabled-border-color: #dee2e6;
  --ct-card-border-color: rgba(0, 0, 0, 0.125);
  --ct-card-box-shadow: var(--ct-box-shadow);
  --ct-card-cap-bg: #fff;
  --ct-card-bg: #fff;
  --ct-accordion-color: #6c757d;
  --ct-accordion-border-color: rgba(0, 0, 0, 0.125);
  --ct-accordion-button-active-bg: rgb(94.4705882353%, 94.862745098%, 99.6078431373%);
  --ct-accordion-button-active-color: rgb(40.2352941176%, 43.7647058824%, 86.4705882353%);
  --ct-accordion-button-focus-border-color: var(--ct-input-focus-border-color);
  --ct-accordion-button-focus-box-shadow: 0 0 0 0.2rem var(--ct-input-btn-focus-color);
  --ct-tooltip-color: #f1f3fa;
  --ct-tooltip-bg: #343a40;
  --ct-popover-bg: #fff;
  --ct-popover-border-color: #dee2e6;
  --ct-popover-header-bg: #f1f3fa;
  --ct-popover-header-color: ;
  --ct-popover-body-color: #6c757d;
  --ct-popover-arrow-color: #fff;
  --ct-popover-arrow-outer-color: #ced4da;
  --ct-toast-background-color: rgba(255, 255, 255, 0.85);
  --ct-toast-border-color: rgba(49, 58, 70, 0.1);
  --ct-toast-header-background-color: rgba(255, 255, 255, 0.85);
  --ct-toast-header-border-color: rgba(49, 58, 70, 0.05);
  --ct-badge-color: #fff;
  --ct-modal-content-bg: #fff;
  --ct-modal-content-box-shadow-xs: var(--ct-box-shadow-sm);
  --ct-modal-content-box-shadow-sm-up: var(--ct-box-shadow);
  --ct-modal-backdrop-bg: #313a46;
  --ct-modal-header-border-color: var(--ct-border-color);
  --ct-modal-footer-border-color: var(--ct-border-color);
  --ct-progress-bg: #eef2f7;
  --ct-progress-box-shadow: var(--ct-box-shadow-inset);
  --ct-progress-bar-color: #fff;
  --ct-progress-bar-bg: #727cf5;
  --ct-list-group-color: #313a46;
  --ct-list-group-bg: #fff;
  --ct-list-group-border-color: #eef2f7;
  --ct-list-group-hover-bg: #f1f3fa;
  --ct-list-group-disabled-color: #6c757d;
  --ct-list-group-disabled-bg: rgb(96.1568627451%, 96.7058823529%, 98.6274509804%);
  --ct-list-group-action-color: #6c757d;
  --ct-list-group-action-active-color: #6c757d;
  --ct-list-group-action-active-bg: #eef2f7;
  --ct-thumbnail-bg: #fff;
  --ct-thumbnail-border-color: #dee2e6;
  --ct-thumbnail-box-shadow: var(--ct-box-shadow-sm);
  --ct-figure-caption-color: #98a6ad;
  --ct-breadcrumb-divider-color: #ced4da;
  --ct-breadcrumb-active-color: #adb5bd;
  --ct-carousel-control-color: #fff;
  --ct-carousel-indicator-active-bg: #fff;
  --ct-carousel-caption-color: #fff;
  --ct-carousel-dark-indicator-active-bg: #000;
  --ct-carousel-dark-caption-color: #000;
  --ct-btn-close-color: #313a46;
  --ct-code-color: #39afd1;
  --ct-kbd-color: #fff;
  --ct-kbd-bg: #313a46;
  --ct-pre-color: ;
  --ct-bg-leftbar: #fff;
  --ct-menu-item: #6c757d;
  --ct-menu-item-hover: #727cf5;
  --ct-menu-item-active: #727cf5;
  --ct-bg-topbar: #fff;
  --ct-bg-topbar-search: #f1f3fa;
  --ct-nav-user-bg-topbar: #3c4655;
  --ct-nav-user-border-topbar: #414d5d;
  --ct-bg-dark-topbar: #313a46;
  --ct-bg-dark-topbar-search: #3c4655;
  --ct-nav-user-bg-dark-topbar: #3c4655;
  --ct-nav-user-border-dark-topbar: #414d5d;
  --ct-rightbar-bg: #fff;
  --ct-rightbar-title-bg: #313a46;
  --ct-rightbar-title-color: #fff;
  --ct-rightbar-title-btn-bg: #444e5a;
  --ct-rightbar-title-btn-color: #fff;
  --ct-rightbar-overlay-bg: #37404a;
  --ct-bg-detached-leftbar: #fff;
  --ct-bg-leftbar-gradient: linear-gradient(135deg, #8f75da 0%, #727cf5 60%);
  --ct-bg-topnav: #313a46;
  --ct-boxed-layout-bg: #fff;
  --ct-help-box-light-bg: rgba(255, 255, 255, 0.07);
  --ct-help-box-dark-bg: #727cf5;
  --ct-nav-pills-bg: #eef2f7;
  --ct-custom-accordion-title-color: #313a46;
  --ct-dragula-bg: #f7f9fb;
  --ct-form-wizard-header-bg: #eef2f7;
  --ct-text-title-color: #6c757d;
  --ct-page-title-color: #6c757d;
  --ct-card-loader-bg: #313a46;
  --ct-chat-primary-user-bg: #fef5e4;
  --ct-chat-secondary-user-bg: #f1f3fa;
  --ct-auth-bg: #fff;
  --ct-apex-grid-color: #f9f9fd;
  --ct-hero-bg: linear-gradient(to bottom, #8669ed, #727cf5);
}

body[data-leftbar-theme=dark] {
  --ct-bg-leftbar: #313a46;
  --ct-dark-menu-item: #8391a2;
  --ct-dark-menu-item-hover: #bccee4;
  --ct-dark-menu-item-active: #fff;
}

body[data-leftbar-theme=default] {
  --ct-menu-item: #cedce4;
  --ct-menu-item-hover: #fff;
  --ct-menu-item-active: #fff;
}

body[data-layout-color=dark] {
  --ct-body-bg: #343a40;
  --ct-body-color: #aab8c5;
  --ct-link-color: #727cf5;
  --ct-link-hover-color: rgb(38%, 41.3333333333%, 81.6666666667%);
  --ct-border-color: #464f5b;
  --ct-box-shadow: 0px 0px 35px 0px rgba(49, 57, 66, 0.5);
  --ct-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --ct-box-shadow-lg: 0 0 45px 0 rgba(0, 0, 0, 0.12);
  --ct-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --ct-component-active-color: #fff;
  --ct-component-active-bg: #727cf5;
  --ct-text-muted: #8391a2;
  --ct-blockquote-footer-color: #ced4da;
  --ct-mark-bg: #fcf8e3;
  --ct-table-color: #aab8c5;
  --ct-table-bg: transparent;
  --ct-table-accent-bg: transparent;
  --ct-table-striped-color: #aab8c5;
  --ct-table-striped-bg: rgba(64, 73, 84, 0.8);
  --ct-table-active-color: var(--ct-table-color);
  --ct-table-active-bg: rgba(70, 79, 91, 0.4);
  --ct-table-hover-color: var(--ct-table-color);
  --ct-table-hover-bg: #404954;
  --ct-table-border-color: #464f5b;
  --ct-table-group-separator-color: rgb(31.7988064791%, 35.887224455%, 41.3384484228%);
  --ct-table-caption-color: var(--ct-text-muted);
  --ct-input-btn-focus-color: rgba(114, 124, 245, 0.25);
  --ct-btn-active-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --ct-btn-link-color: #0d6efd;
  --ct-btn-link-hover-color: #0a58ca;
  --ct-btn-link-disabled-color: #aab8c5;
  --ct-form-text-color: var(--ct-text-muted);
  --ct-input-bg: #404954;
  --ct-input-disabled-bg: #37404a;
  --ct-input-color: #e3eaef;
  --ct-input-border-color: rgb(28.8431372549%, 32.1960784314%, 36.2941176471%);
  --ct-input-box-shadow: var(--ct-box-shadow-inset);
  --ct-input-focus-bg: rgb(27.2602013778%, 31.0936671966%, 35.7790143084%);
  --ct-input-focus-border-color: rgb(33.2711926432%, 37.1388839702%, 41.8660622587%);
  --ct-input-focus-color: var(--ct-input-color);
  --ct-input-placeholder-color: #8391a2;
  --ct-input-plaintext-color: #6c757d;
  --ct-form-check-input-bg: transparent;
  --ct-form-check-input-border: 1px solid rgb(28.8431372549%, 32.1960784314%, 36.2941176471%);
  --ct-form-check-input-checked-color: var(--ct-component-active-color);
  --ct-form-check-input-checked-bg-color: var(--ct-component-active-bg);
  --ct-form-check-input-checked-border-color: var(--ct-form-check-input-checked-bg-color);
  --ct-form-check-input-indeterminate-color: var(--ct-component-active-color);
  --ct-form-check-input-indeterminate-bg-color: var(--ct-component-active-bg);
  --ct-form-check-input-indeterminate-border-color: var(--ct-component-active-bg);
  --ct-form-switch-color: tiny-color(#464f5b, 6%);
  --ct-input-group-addon-color: var(--ct-input-color);
  --ct-input-group-addon-bg: rgb(28.1764705882%, 31.6705882353%, 36.3294117647%);
  --ct-input-group-addon-border-color: var(--ct-input-border-color);
  --ct-form-select-color: var(--ct-input-color);
  --ct-form-select-bg: var(--ct-input-bg);
  --ct-form-select-disabled-color: #ced4da;
  --ct-form-select-disabled-bg: #37404a;
  --ct-form-select-indicator-color: #e3eaef;
  --ct-form-range-track-bg: #464f5b;
  --ct-form-range-track-box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
  --ct-form-range-thumb-box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  --ct-form-range-thumb-active-bg: rgb(83.4117647059%, 84.5882352941%, 98.8235294118%);
  --ct-form-range-thumb-disabled-bg: #aab8c5;
  --ct-form-file-button-color: var(--ct-input-color);
  --ct-form-file-button-bg: rgb(28.1764705882%, 31.6705882353%, 36.3294117647%);
  --ct-form-file-button-hover-bg: rgb(26.0784313725%, 29.431372549%, 33.9019607843%);
  --ct-nav-link-disabled-color: #ced4da;
  --ct-nav-tabs-border-color: #464f5b;
  --ct-nav-tabs-link-hover-border-color: #37404a #37404a var(--ct-nav-tabs-border-color);
  --ct-nav-tabs-link-active-color: #e3eaef;
  --ct-nav-tabs-link-active-bg: rgb(28.8431372549%, 32.1960784314%, 36.2941176471%);
  --ct-nav-tabs-link-active-border-color: #464f5b #464f5b var(--ct-nav-tabs-link-active-bg);
  --ct-navbar-dark-color: rgba(255, 255, 255, 0.55);
  --ct-navbar-dark-hover-color: rgba(255, 255, 255, 0.75);
  --ct-navbar-dark-active-color: #fff;
  --ct-navbar-dark-disabled-color: rgba(255, 255, 255, 0.25);
  --ct-navbar-dark-toggler-border-color: rgba(255, 255, 255, 0.1);
  --ct-navbar-light-color: rgb(82.7058823529%, 84.1960784314%, 85.6862745098%);
  --ct-navbar-light-hover-color: #e3eaef;
  --ct-navbar-light-active-color: rgba(255, 255, 255, 0.9);
  --ct-navbar-light-disabled-color: #aab8c5;
  --ct-dropdown-color: #aab8c5;
  --ct-dropdown-bg: rgb(23.137254902%, 26.5960784314%, 30.4392156863%);
  --ct-dropdown-border-color: rgb(26.2745098039%, 29.5921568627%, 33.2784313725%);
  --ct-dropdown-divider-bg: rgb(30.3529411765%, 33.7411764706%, 38.2588235294%);
  --ct-dropdown-box-shadow: var(--ct-box-shadow);
  --ct-dropdown-link-color: #aab8c5;
  --ct-dropdown-link-hover-color: rgb(85.0588235294%, 85.0588235294%, 85.0588235294%);
  --ct-dropdown-link-hover-bg: rgb(28.1764705882%, 31.6705882353%, 36.3294117647%);
  --ct-dropdown-link-active-color: #fff;
  --ct-dropdown-link-active-bg: rgb(47.7647058824%, 50.3058823529%, 53.6941176471%);
  --ct-dropdown-link-disabled-color: #ced4da;
  --ct-dropdown-dark-color: #464f5b;
  --ct-dropdown-dark-bg: #e3eaef;
  --ct-dropdown-dark-border-color: var(--ct-dropdown-border-color);
  --ct-dropdown-dark-divider-bg: var(--ct-dropdown-divider-bg);
  --ct-dropdown-dark-link-color: var(--ct-dropdown-dark-color);
  --ct-dropdown-dark-link-hover-color: #fff;
  --ct-dropdown-dark-link-hover-bg: rgba(255, 255, 255, 0.15);
  --ct-dropdown-dark-link-active-color: var(--ct-dropdown-link-active-color);
  --ct-dropdown-dark-link-active-bg: var(--ct-dropdown-link-active-bg);
  --ct-dropdown-dark-link-disabled-color: #aab8c5;
  --ct-dropdown-dark-header-color: #aab8c5;
  --ct-pagination-color: #8391a2;
  --ct-pagination-bg: rgb(24.7058823529%, 28.0941176471%, 31.8588235294%);
  --ct-pagination-border-color: #464f5b;
  --ct-pagination-focus-color: #0a58ca;
  --ct-pagination-focus-bg: #37404a;
  --ct-pagination-focus-box-shadow: 0 0 0 0.2rem var(--ct-input-btn-focus-color);
  --ct-pagination-hover-color: #f1f1f1;
  --ct-pagination-hover-bg: rgb(27.8431372549%, 31.0901960784%, 34.6980392157%);
  --ct-pagination-hover-border-color: #464f5b;
  --ct-pagination-disabled-color: #8391a2;
  --ct-pagination-disabled-bg: rgb(29.0736028188%, 33.0608397768%, 37.4911030635%);
  --ct-pagination-disabled-border-color: rgb(29.0736028188%, 33.0608397768%, 37.4911030635%);
  --ct-card-border-color: rgba(0, 0, 0, 0.125);
  --ct-card-box-shadow: var(--ct-box-shadow);
  --ct-card-cap-bg: #464f5b;
  --ct-card-bg: #37404a;
  --ct-accordion-color: #6c757d;
  --ct-accordion-border-color: rgba(0, 0, 0, 0.125);
  --ct-accordion-button-active-bg: rgb(94.4705882353%, 94.862745098%, 99.6078431373%);
  --ct-accordion-button-active-color: rgb(40.2352941176%, 43.7647058824%, 86.4705882353%);
  --ct-accordion-button-focus-border-color: var(--ct-input-focus-border-color);
  --ct-accordion-button-focus-box-shadow: 0 0 0 0.2rem var(--ct-input-btn-focus-color);
  --ct-tooltip-color: #37404a;
  --ct-tooltip-bg: #dee2e6;
  --ct-popover-bg: #37404a;
  --ct-popover-border-color: #464f5b;
  --ct-popover-header-bg: rgb(23.7004103967%, 27.5786593707%, 31.8878248974%);
  --ct-popover-header-color: #dee2e6;
  --ct-popover-body-color: #dee2e6;
  --ct-popover-arrow-color: #37404a;
  --ct-popover-arrow-outer-color: #464f5b;
  --ct-toast-background-color: #404954;
  --ct-toast-border-color: rgba(241, 241, 241, 0.12);
  --ct-toast-header-background-color: rgba(64, 73, 84, 0.2);
  --ct-toast-header-border-color: rgba(241, 241, 241, 0.05);
  --ct-badge-color: #fff;
  --ct-modal-content-bg: rgb(23.137254902%, 26.5960784314%, 30.4392156863%);
  --ct-modal-content-box-shadow-xs: var(--ct-box-shadow-sm);
  --ct-modal-content-box-shadow-sm-up: var(--ct-box-shadow);
  --ct-modal-backdrop-bg: #aab8c5;
  --ct-modal-header-border-color: rgb(31.7988064791%, 35.887224455%, 41.3384484228%);
  --ct-modal-footer-border-color: rgb(31.7988064791%, 35.887224455%, 41.3384484228%);
  --ct-progress-bg: #464f5b;
  --ct-progress-box-shadow: var(--ct-box-shadow-inset);
  --ct-progress-bar-color: #fff;
  --ct-progress-bar-bg: #727cf5;
  --ct-list-group-color: #f1f1f1;
  --ct-list-group-bg: var(--ct-card-bg);
  --ct-list-group-border-color: rgb(30.3529411765%, 33.7411764706%, 38.2588235294%);
  --ct-list-group-hover-bg: #404954;
  --ct-list-group-disabled-color: #8391a2;
  --ct-list-group-disabled-bg: #404954;
  --ct-list-group-action-color: #aab8c5;
  --ct-list-group-action-active-color: #dee2e6;
  --ct-list-group-action-active-bg: #404954;
  --ct-thumbnail-bg: #464f5b;
  --ct-thumbnail-border-color: #464f5b;
  --ct-thumbnail-box-shadow: var(--ct-box-shadow-sm);
  --ct-figure-caption-color: #ced4da;
  --ct-breadcrumb-divider-color: #8391a2;
  --ct-breadcrumb-active-color: #aab8c5;
  --ct-carousel-control-color: #fff;
  --ct-carousel-indicator-active-bg: #fff;
  --ct-carousel-caption-color: #fff;
  --ct-carousel-dark-indicator-active-bg: #000;
  --ct-carousel-dark-caption-color: #000;
  --ct-btn-close-color: #e3eaef;
  --ct-code-color: #39afd1;
  --ct-kbd-color: #fff;
  --ct-kbd-bg: #f1f1f1;
  --ct-pre-color: #aab8c5;
  --ct-bg-leftbar: #3a444e;
  --ct-menu-item: #cedce4;
  --ct-menu-item-hover: #fff;
  --ct-menu-item-active: #fff;
  --ct-bg-topbar: #3a444e;
  --ct-bg-topbar-search: #464f5b;
  --ct-nav-user-bg-topbar: #45515d;
  --ct-nav-user-border-topbar: #4a5764;
  --ct-bg-dark-topbar: #3a444e;
  --ct-bg-dark-topbar-search: #464f5b;
  --ct-nav-user-bg-dark-topbar: #45515d;
  --ct-nav-user-border-dark-topbar: #4a5764;
  --ct-rightbar-bg: #37404a;
  --ct-rightbar-title-bg: #727cf5;
  --ct-rightbar-title-color: #fff;
  --ct-rightbar-title-btn-bg: rgb(54.0436306973%, 57.3029476691%, 96.7406830282%);
  --ct-rightbar-title-btn-color: #fff;
  --ct-rightbar-overlay-bg: #000;
  --ct-bg-detached-leftbar: #37404a;
  --ct-bg-leftbar-gradient: linear-gradient(135deg, #8f75da 0, #727cf5 60%);
  --ct-bg-topnav: linear-gradient(to bottom, #8f75da, #727cf5);
  --ct-boxed-layout-bg: #3e4853;
  --ct-help-box-light-bg: rgba(255, 255, 255, 0.1);
  --ct-help-box-dark-bg: #727cf5;
  --ct-nav-pills-bg: #404954;
  --ct-custom-accordion-title-color: #8391a2;
  --ct-dragula-bg: #404954;
  --ct-form-wizard-header-bg: #404954;
  --ct-text-title-color: #fff;
  --ct-page-title-color: #fff;
  --ct-card-loader-bg: #f1f1f1;
  --ct-chat-primary-user-bg: #404954;
  --ct-chat-secondary-user-bg: #404954;
  --ct-auth-bg: #404954;
  --ct-apex-grid-color: #404954;
  --ct-hero-bg: linear-gradient(to bottom, #697ded, #5e30c1);
}

body[data-layout-color=dark][data-layout=detached] {
  --ct-menu-item: #8391a2;
  --ct-menu-item-hover: #727cf5;
  --ct-menu-item-active: #727cf5;
}

body[data-leftbar-theme=light] {
  --ct-bg-leftbar: #fff;
  --ct-menu-item: #6c757d;
  --ct-menu-item-hover: #727cf5;
  --ct-menu-item-active: #727cf5;
}

/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #2c8ef8;
  --bs-indigo: #727cf5;
  --bs-purple: #6b5eae;
  --bs-pink: #ff679b;
  --bs-red: #fa5c7c;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffbc00;
  --bs-green: #0acf97;
  --bs-teal: #02a8b5;
  --bs-cyan: #39afd1;
  --bs-white: #fff;
  --bs-gray: #98a6ad;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f1f3fa;
  --bs-gray-200: #eef2f7;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #98a6ad;
  --bs-gray-700: #6c757d;
  --bs-gray-800: #343a40;
  --bs-gray-900: #313a46;
  --bs-primary: #727cf5;
  --bs-secondary: #6c757d;
  --bs-success: #0acf97;
  --bs-info: #39afd1;
  --bs-warning: #ffbc00;
  --bs-danger: #fa5c7c;
  --bs-light: #eef2f7;
  --bs-dark: #313a46;
  --bs-primary-rgb: 114, 124, 245;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 10, 207, 151;
  --bs-info-rgb: 57, 175, 209;
  --bs-warning-rgb: 255, 188, 0;
  --bs-danger-rgb: 250, 92, 124;
  --bs-light-rgb: 238, 242, 247;
  --bs-dark-rgb: 49, 58, 70;
  --bs-primary-text-emphasis: rgb(2.0392156863%, 17.2549019608%, 39.6862745098%);
  --bs-secondary-text-emphasis: rgb(16.9411764706%, 18.3529411765%, 19.6078431373%);
  --bs-success-text-emphasis: rgb(3.9215686275%, 21.1764705882%, 13.1764705882%);
  --bs-info-text-emphasis: rgb(2.0392156863%, 31.6862745098%, 37.6470588235%);
  --bs-warning-text-emphasis: rgb(40%, 30.2745098039%, 1.0980392157%);
  --bs-danger-text-emphasis: rgb(34.5098039216%, 8.3137254902%, 10.8235294118%);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(81.0196078431%, 88.6274509804%, 99.8431372549%);
  --bs-secondary-bg-subtle: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);
  --bs-success-bg-subtle: rgb(81.9607843137%, 90.5882352941%, 86.5882352941%);
  --bs-info-bg-subtle: rgb(81.0196078431%, 95.8431372549%, 98.8235294118%);
  --bs-warning-bg-subtle: rgb(100%, 95.137254902%, 80.5490196078%);
  --bs-danger-bg-subtle: rgb(97.2549019608%, 84.1568627451%, 85.4117647059%);
  --bs-light-bg-subtle: rgb(98.6274509804%, 98.8235294118%, 99.0196078431%);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(62.0392156863%, 77.2549019608%, 99.6862745098%);
  --bs-secondary-border-subtle: rgb(76.9411764706%, 78.3529411765%, 79.6078431373%);
  --bs-success-border-subtle: rgb(63.9215686275%, 81.1764705882%, 73.1764705882%);
  --bs-info-border-subtle: rgb(62.0392156863%, 91.6862745098%, 97.6470588235%);
  --bs-warning-border-subtle: rgb(100%, 90.2745098039%, 61.0980392157%);
  --bs-danger-border-subtle: rgb(94.5098039216%, 68.3137254902%, 70.8235294118%);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: "Nunito", sans-serif;
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: "Nunito", sans-serif;
  --bs-body-font-size: 0.9rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #6c757d;
  --bs-body-color-rgb: 108, 117, 125;
  --bs-body-bg: #fafbfe;
  --bs-body-bg-rgb: 250, 251, 254;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: none;
  --bs-link-hover-color: #0a58ca;
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: var(--ct-code-color);
  --bs-highlight-color: #212529;
  --bs-highlight-bg: var(--ct-mark-bg);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: var(--ct-border-color);
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.25rem;
  --bs-border-radius-sm: 0.2rem;
  --bs-border-radius-lg: 0.3rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: var(--ct-box-shadow);
  --bs-box-shadow-sm: var(--ct-box-shadow-sm);
  --bs-box-shadow-lg: var(--ct-box-shadow-lg);
  --bs-box-shadow-inset: var(--ct-box-shadow-inset);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(16.6666666667%, 18.6274509804%, 20.5882352941%);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(43.0588235294%, 65.8823529412%, 99.5294117647%);
  --bs-secondary-text-emphasis: rgb(65.4117647059%, 67.5294117647%, 69.4117647059%);
  --bs-success-text-emphasis: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);
  --bs-info-text-emphasis: rgb(43.0588235294%, 87.5294117647%, 96.4705882353%);
  --bs-warning-text-emphasis: rgb(100%, 85.4117647059%, 41.6470588235%);
  --bs-danger-text-emphasis: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(1.0196078431%, 8.6274509804%, 19.8431372549%);
  --bs-secondary-bg-subtle: rgb(8.4705882353%, 9.1764705882%, 9.8039215686%);
  --bs-success-bg-subtle: rgb(1.9607843137%, 10.5882352941%, 6.5882352941%);
  --bs-info-bg-subtle: rgb(1.0196078431%, 15.8431372549%, 18.8235294118%);
  --bs-warning-bg-subtle: rgb(20%, 15.137254902%, 0.5490196078%);
  --bs-danger-bg-subtle: rgb(17.2549019608%, 4.1568627451%, 5.4117647059%);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(3.0588235294%, 25.8823529412%, 59.5294117647%);
  --bs-secondary-border-subtle: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);
  --bs-success-border-subtle: rgb(5.8823529412%, 31.7647058824%, 19.7647058824%);
  --bs-info-border-subtle: rgb(3.0588235294%, 47.5294117647%, 56.4705882353%);
  --bs-warning-border-subtle: rgb(60%, 45.4117647059%, 1.6470588235%);
  --bs-danger-border-subtle: rgb(51.7647058824%, 12.4705882353%, 16.2352941176%);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(43.0588235294%, 65.8823529412%, 99.5294117647%);
  --bs-link-hover-color: rgb(54.4470588235%, 72.7058823529%, 99.6235294118%);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(90.3529411765%, 52%, 71.0588235294%);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(40%, 30.2745098039%, 1.0980392157%);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);
  --bs-form-valid-border-color: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);
  --bs-form-invalid-color: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);
  --bs-form-invalid-border-color: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: "Nunito", sans-serif;
  font-family: var(--bs-body-font-family);
  font-size: 0.9rem;
  font-size: var(--bs-body-font-size);
  font-weight: 400;
  font-weight: var(--bs-body-font-weight);
  line-height: 1.5;
  line-height: var(--bs-body-line-height);
  color: #6c757d;
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: #fafbfe;
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 0 solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.75rem;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.35rem + 1.2vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.25rem;
  }
}

h2, .h2 {
  font-size: calc(1.3125rem + 0.75vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.875rem;
  }
}

h3, .h3 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.5rem;
  }
}

h4, .h4 {
  font-size: 1.125rem;
}

h5, .h5 {
  font-size: 0.9375rem;
}

h6, .h6 {
  font-size: 0.75rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.75rem;
}

mark, .mark {
  padding: 0.2em;
  color: #212529;
  color: var(--bs-highlight-color);
  background-color: #fcf8e3;
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(13, 110, 253, 1);
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--ct-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 87.5%;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 87.5%;
  color: #39afd1;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  color: var(--ct-kbd-color);
  background-color: #313a46;
  background-color: var(--ct-kbd-bg);
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 700;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.95rem;
  padding-bottom: 0.95rem;
  color: #98a6ad;
  color: var(--ct-table-caption-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend {
  line-height: inherit;
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.125rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}
.display-1 {
  font-weight: 300;
  line-height: 1.1;
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}
.display-2 {
  font-weight: 300;
  line-height: 1.1;
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}
.display-3 {
  font-weight: 300;
  line-height: 1.1;
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}
.display-4 {
  font-weight: 300;
  line-height: 1.1;
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}
.display-5 {
  font-weight: 300;
  line-height: 1.1;
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}
.display-6 {
  font-weight: 300;
  line-height: 1.1;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 6px;
}

.initialism {
  font-size: 0.75rem;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1.5rem;
  font-size: 1.125rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1.5rem;
  margin-bottom: 1.5rem;
  font-size: 0.75rem;
  color: #98a6ad;
  color: var(--ct-blockquote-footer-color);
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  background-color: var(--ct-thumbnail-bg);
  border: 1px solid #dee2e6;
  border: 1px solid var(--ct-thumbnail-border-color);
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.75rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.75rem;
  color: #98a6ad;
  color: var(--ct-figure-caption-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 12px;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 24px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.375rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.375rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.75rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.75rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1.5rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1.5rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 2.25rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 2.25rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 4.5rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 4.5rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.375rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.375rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.75rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.75rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 2.25rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 2.25rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 4.5rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 4.5rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.375rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.375rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.75rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.75rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 2.25rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 2.25rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 4.5rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 4.5rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.375rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.375rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.75rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.75rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 2.25rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 2.25rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 4.5rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 4.5rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.375rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.375rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.75rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.75rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 2.25rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 2.25rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 4.5rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 4.5rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.375rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.375rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.75rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.75rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 2.25rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 2.25rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 4.5rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 4.5rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--ct-table-color);
  --bs-table-bg: var(--ct-table-bg);
  --bs-table-border-color: var(--ct-table-border-color);
  --bs-table-accent-bg: var(--ct-table-accent-bg);
  --bs-table-striped-color: var(--ct-table-striped-color);
  --bs-table-striped-bg: var(--ct-table-striped-bg);
  --bs-table-active-color: var(--ct-table-active-color);
  --bs-table-active-bg: var(--ct-table-active-bg);
  --bs-table-hover-color: var(--ct-table-hover-color);
  --bs-table-hover-bg: var(--ct-table-hover-bg);
  width: 100%;
  margin-bottom: 1.5rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.95rem 0.95rem;
  color: var(--bs-table-color);
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(1px * 2) solid rgb(92.7484787018%, 93.6274509804%, 94.506423259%);
  border-top: calc(1px * 2) solid var(--ct-table-group-separator-color);
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #313a46;
  --bs-table-bg: rgb(88.9411764706%, 89.7254901961%, 99.2156862745%);
  --bs-table-border-color: rgb(81.968627451%, 83.0274509804%, 92.0392156863%);
  --bs-table-striped-bg: #313a46;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(61.0509803922%, 62.9333333333%, 70.5098039216%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(83.7117647059%, 84.7019607843%, 93.8333333333%);
  --bs-table-hover-color: #313a46;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #313a46;
  --bs-table-bg: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);
  --bs-table-border-color: rgb(81.5450980392%, 82.5333333333%, 83.568627451%);
  --bs-table-striped-bg: #313a46;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(60.768627451%, 62.6039215686%, 64.862745098%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(83.2764705882%, 84.1941176471%, 85.1274509804%);
  --bs-table-hover-color: #313a46;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #313a46;
  --bs-table-bg: rgb(80.7843137255%, 96.2352941176%, 91.8431372549%);
  --bs-table-border-color: rgb(74.6274509804%, 88.8862745098%, 85.4039215686%);
  --bs-table-striped-bg: #313a46;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(56.1568627451%, 66.8392156863%, 66.0862745098%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(76.1666666667%, 90.7235294118%, 87.0137254902%);
  --bs-table-hover-color: #313a46;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #313a46;
  --bs-table-bg: rgb(84.4705882353%, 93.7254901961%, 96.3921568627%);
  --bs-table-border-color: rgb(77.9450980392%, 86.6274509804%, 89.4980392157%);
  --bs-table-striped-bg: #313a46;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(58.368627451%, 65.3333333333%, 68.8156862745%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(79.5764705882%, 88.4019607843%, 91.2215686275%);
  --bs-table-hover-color: #313a46;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #313a46;
  --bs-table-bg: rgb(100%, 94.7450980392%, 80%);
  --bs-table-border-color: rgb(91.9215686275%, 87.5450980392%, 74.7450980392%);
  --bs-table-striped-bg: #313a46;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(67.6862745098%, 65.9450980392%, 58.9803921569%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(93.9411764706%, 89.3450980392%, 76.0588235294%);
  --bs-table-hover-color: #313a46;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #313a46;
  --bs-table-bg: rgb(99.6078431373%, 87.2156862745%, 89.7254901961%);
  --bs-table-border-color: rgb(91.568627451%, 80.768627451%, 83.4980392157%);
  --bs-table-striped-bg: #313a46;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(67.4509803922%, 61.4274509804%, 64.8156862745%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(93.5784313725%, 82.3803921569%, 85.0549019608%);
  --bs-table-hover-color: #313a46;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #313a46;
  --bs-table-bg: #eef2f7;
  --bs-table-border-color: rgb(85.9215686275%, 87.6862745098%, 89.9215686275%);
  --bs-table-striped-bg: #313a46;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(63.6862745098%, 66.0392156863%, 69.0980392157%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(87.7745098039%, 89.4901960784%, 91.6568627451%);
  --bs-table-hover-color: #313a46;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #313a46;
  --bs-table-border-color: rgb(27.2941176471%, 30.4705882353%, 34.7058823529%);
  --bs-table-striped-bg: white;
  --bs-table-striped-color: #313a46;
  --bs-table-active-bg: rgb(51.5294117647%, 53.6470588235%, 56.4705882353%);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(25.2745098039%, 28.5392156863%, 32.8921568627%);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.45rem + 1px);
  padding-bottom: calc(0.45rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: calc(1.2501rem + 0.0012vw);
}
@media (min-width: 1200px) {
  .col-form-label-lg {
    font-size: 1.251rem;
  }
}

.col-form-label-sm {
  padding-top: calc(0.28rem + 1px);
  padding-bottom: calc(0.28rem + 1px);
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #98a6ad;
  color: var(--ct-form-text-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.45rem 0.9rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #6c757d;
  color: var(--ct-input-color);
  appearance: none;
  background-color: #fff;
  background-color: var(--ct-input-bg);
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border: 1px solid var(--ct-input-border-color);
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #6c757d;
  color: var(--ct-input-focus-color);
  background-color: #fff;
  background-color: var(--ct-input-focus-bg);
  border-color: rgb(78.3529411765%, 79.7647058824%, 81.1764705882%);
  border-color: var(--ct-input-focus-border-color);
  outline: 0;
  box-shadow: none;
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: #adb5bd;
  color: var(--ct-input-placeholder-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: #eef2f7;
  background-color: var(--ct-input-disabled-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.45rem 0.9rem;
  margin: -0.45rem -0.9rem;
  margin-inline-end: 0.9rem;
  color: #6c757d;
  color: var(--ct-form-file-button-color);
  background-color: #eef2f7;
  background-color: var(--ct-form-file-button-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: rgb(88.6666666667%, 90.1568627451%, 92.0196078431%);
  background-color: var(--ct-form-file-button-hover-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.45rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #6c757d;
  color: var(--ct-input-plaintext-color);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.56rem + 2px);
  padding: 0.28rem 0.8rem;
  font-size: 0.875rem;
  border-radius: 0.2rem;
}
.form-control-sm::file-selector-button {
  padding: 0.28rem 0.8rem;
  margin: -0.28rem -0.8rem;
  margin-inline-end: 0.8rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: calc(1.2501rem + 0.0012vw);
}
@media (min-width: 1200px) {
  .form-control-lg {
    font-size: 1.251rem;
  }
}
.form-control-lg {
  border-radius: 0.3rem;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.9rem + 2px);
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.56rem + 2px);
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.9rem + 2px);
  padding: 0.45rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.25rem;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0.25rem;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.56rem + 2px);
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.45rem 2.7rem 0.45rem 0.9rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #6c757d;
  color: var(--ct-form-select-color);
  appearance: none;
  background-color: #fff;
  background-color: var(--ct-form-select-bg);
  background-image: var(--bs-form-select-bg-img), none;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.9rem center;
  background-size: 14px 10px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--ct-input-border-color);
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(78.3529411765%, 79.7647058824%, 81.1764705882%);
  border-color: var(--ct-input-focus-border-color);
  outline: 0;
  box-shadow: none;
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.9rem;
  background-image: none;
}
.form-select:disabled {
  color: #98a6ad;
  color: var(--ct-form-select-disabled-color);
  background-color: #eef2f7;
  background-color: var(--ct-form-select-disabled-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #6c757d;
  text-shadow: 0 0 0 var(--ct-form-select-color);
}

.form-select-sm {
  padding-top: 0.28rem;
  padding-bottom: 0.28rem;
  padding-left: 0.8rem;
  font-size: 0.875rem;
  border-radius: 0.2rem;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: calc(1.2501rem + 0.0012vw);
}
@media (min-width: 1200px) {
  .form-select-lg {
    font-size: 1.251rem;
  }
}
.form-select-lg {
  border-radius: 0.3rem;
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.35rem;
  padding-left: 1.612em;
  margin-bottom: 0;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.612em;
}

.form-check-reverse {
  padding-right: 1.612em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.612em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--ct-form-check-input-bg);
  flex-shrink: 0;
  width: 1.112em;
  height: 1.112em;
  margin-top: 0.194em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #dee2e6;
  border: var(--ct-form-check-input-border);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-check-input {
    transition: none;
  }
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(78.3529411765%, 79.7647058824%, 81.1764705882%);
  border-color: var(--ct-input-focus-border-color);
  outline: 0;
  box-shadow: none;
}
.form-check-input:checked {
  background-color: #727cf5;
  background-color: var(--ct-form-check-input-checked-bg-color);
  border-color: #727cf5;
  border-color: var(--ct-form-check-input-checked-border-color);
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #727cf5;
  background-color: var(--ct-component-active-bg);
  border-color: #727cf5;
  border-color: var(--ct-component-active-bg);
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fafbfe, none;
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fafbfe, none;
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #727cf5;
  background-color: var(--ct-component-active-bg);
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(83.4117647059%, 84.5882352941%, 98.8235294118%);
  background-color: var(--ct-form-range-thumb-active-bg);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  background-color: var(--ct-form-range-track-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #727cf5;
  background-color: var(--ct-component-active-bg);
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(83.4117647059%, 84.5882352941%, 98.8235294118%);
  background-color: var(--ct-form-range-thumb-active-bg);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  background-color: var(--ct-form-range-track-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
  background-color: var(--ct-form-range-thumb-disabled-bg);
}
.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
  background-color: var(--ct-form-range-thumb-disabled-bg);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  min-height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.9rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.9rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(108, 117, 125, 0.65);
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.45rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: #fff;
  background-color: var(--ct-input-bg);
  border-radius: 0.25rem;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(108, 117, 125, 0.65);
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: #eef2f7;
  background-color: var(--ct-input-disabled-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.45rem 0.9rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #6c757d;
  color: var(--ct-input-group-addon-color);
  text-align: center;
  white-space: nowrap;
  background-color: #eef2f7;
  background-color: var(--ct-input-group-addon-bg);
  border: 1px solid #dee2e6;
  border: 1px solid var(--ct-input-group-addon-border-color);
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: calc(1.2501rem + 0.0012vw);
}
@media (min-width: 1200px) {
  .input-group-lg > .form-control,
  .input-group-lg > .form-select,
  .input-group-lg > .input-group-text,
  .input-group-lg > .btn {
    font-size: 1.251rem;
  }
}
.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  border-radius: 0.3rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.28rem 0.8rem;
  font-size: 0.875rem;
  border-radius: 0.2rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3.6rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(1px * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #0acf97;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.8rem;
  margin-top: 0.1rem;
  font-size: 0.8125rem;
  color: #fff;
  background-color: rgba(10, 207, 151, 0.9);
  border-radius: 0.2rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #0acf97;
  padding-right: calc(1.5em + 0.9rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.225rem) center;
  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #0acf97;
  box-shadow: 0 0 0 0.2rem rgba(10, 207, 151, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.9rem);
  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #0acf97;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  padding-right: 4.95rem;
  background-position: right 0.9rem center, center right 2.7rem;
  background-size: 14px 10px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #0acf97;
  box-shadow: 0 0 0 0.2rem rgba(10, 207, 151, 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.9rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #0acf97;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #0acf97;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.2rem rgba(10, 207, 151, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #0acf97;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #fa5c7c;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.8rem;
  margin-top: 0.1rem;
  font-size: 0.8125rem;
  color: #fff;
  background-color: rgba(250, 92, 124, 0.9);
  border-radius: 0.2rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #fa5c7c;
  padding-right: calc(1.5em + 0.9rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.225rem) center;
  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #fa5c7c;
  box-shadow: 0 0 0 0.2rem rgba(250, 92, 124, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.9rem);
  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #fa5c7c;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.95rem;
  background-position: right 0.9rem center, center right 2.7rem;
  background-size: 14px 10px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #fa5c7c;
  box-shadow: 0 0 0 0.2rem rgba(250, 92, 124, 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.9rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #fa5c7c;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #fa5c7c;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.2rem rgba(250, 92, 124, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #fa5c7c;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.9rem;
  --bs-btn-padding-y: 0.45rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.9rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.15rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: 0px 2px 6px 0px;
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.2rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #727cf5;
  --bs-btn-border-color: #727cf5;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(38%, 41.3333333333%, 81.6666666667%);
  --bs-btn-hover-border-color: rgb(35.7647058824%, 38.9019607843%, 76.862745098%);
  --bs-btn-focus-shadow-rgb: 135, 144, 247;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(35.7647058824%, 38.9019607843%, 76.862745098%);
  --bs-btn-active-border-color: rgb(33.5294117647%, 36.4705882353%, 72.0588235294%);
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #727cf5;
  --bs-btn-disabled-border-color: #727cf5;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(36%, 39%, 41.6666666667%);
  --bs-btn-hover-border-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);
  --bs-btn-active-border-color: rgb(31.7647058824%, 34.4117647059%, 36.7647058824%);
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0acf97;
  --bs-btn-border-color: #0acf97;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(3.3333333333%, 69%, 50.3333333333%);
  --bs-btn-hover-border-color: rgb(3.137254902%, 64.9411764706%, 47.3725490196%);
  --bs-btn-focus-shadow-rgb: 47, 214, 167;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(3.137254902%, 64.9411764706%, 47.3725490196%);
  --bs-btn-active-border-color: rgb(2.9411764706%, 60.8823529412%, 44.4117647059%);
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0acf97;
  --bs-btn-disabled-border-color: #0acf97;
}

.btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #39afd1;
  --bs-btn-border-color: #39afd1;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(19%, 58.3333333333%, 69.6666666667%);
  --bs-btn-hover-border-color: rgb(17.8823529412%, 54.9019607843%, 65.568627451%);
  --bs-btn-focus-shadow-rgb: 87, 187, 216;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(17.8823529412%, 54.9019607843%, 65.568627451%);
  --bs-btn-active-border-color: rgb(16.7647058824%, 51.4705882353%, 61.4705882353%);
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #39afd1;
  --bs-btn-disabled-border-color: #39afd1;
}

.btn-warning {
  --bs-btn-color: #313a46;
  --bs-btn-bg: #ffbc00;
  --bs-btn-border-color: #ffbc00;
  --bs-btn-hover-color: #313a46;
  --bs-btn-hover-bg: rgb(100%, 77.6666666667%, 15%);
  --bs-btn-hover-border-color: rgb(100%, 76.3529411765%, 10%);
  --bs-btn-focus-shadow-rgb: 224, 168, 11;
  --bs-btn-active-color: #313a46;
  --bs-btn-active-bg: rgb(100%, 78.9803921569%, 20%);
  --bs-btn-active-border-color: rgb(100%, 76.3529411765%, 10%);
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #313a46;
  --bs-btn-disabled-bg: #ffbc00;
  --bs-btn-disabled-border-color: #ffbc00;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #fa5c7c;
  --bs-btn-border-color: #fa5c7c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(83.3333333333%, 30.6666666667%, 41.3333333333%);
  --bs-btn-hover-border-color: rgb(78.431372549%, 28.862745098%, 38.9019607843%);
  --bs-btn-focus-shadow-rgb: 251, 116, 144;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(78.431372549%, 28.862745098%, 38.9019607843%);
  --bs-btn-active-border-color: rgb(73.5294117647%, 27.0588235294%, 36.4705882353%);
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #fa5c7c;
  --bs-btn-disabled-border-color: #fa5c7c;
}

.btn-light {
  --bs-btn-color: #313a46;
  --bs-btn-bg: #eef2f7;
  --bs-btn-border-color: #eef2f7;
  --bs-btn-hover-color: #313a46;
  --bs-btn-hover-bg: rgb(79.3333333333%, 80.6666666667%, 82.3333333333%);
  --bs-btn-hover-border-color: rgb(74.6666666667%, 75.9215686275%, 77.4901960784%);
  --bs-btn-focus-shadow-rgb: 210, 214, 220;
  --bs-btn-active-color: #313a46;
  --bs-btn-active-bg: rgb(74.6666666667%, 75.9215686275%, 77.4901960784%);
  --bs-btn-active-border-color: rgb(70%, 71.1764705882%, 72.6470588235%);
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #313a46;
  --bs-btn-disabled-bg: #eef2f7;
  --bs-btn-disabled-border-color: #eef2f7;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #313a46;
  --bs-btn-border-color: #313a46;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(31.3333333333%, 34.3333333333%, 38.3333333333%);
  --bs-btn-hover-border-color: rgb(27.2941176471%, 30.4705882353%, 34.7058823529%);
  --bs-btn-focus-shadow-rgb: 80, 88, 98;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(35.3725490196%, 38.1960784314%, 41.9607843137%);
  --bs-btn-active-border-color: rgb(27.2941176471%, 30.4705882353%, 34.7058823529%);
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #313a46;
  --bs-btn-disabled-border-color: #313a46;
}

.btn-outline-primary {
  --bs-btn-color: #727cf5;
  --bs-btn-border-color: #727cf5;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #727cf5;
  --bs-btn-hover-border-color: #727cf5;
  --bs-btn-focus-shadow-rgb: 114, 124, 245;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #727cf5;
  --bs-btn-active-border-color: #727cf5;
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #727cf5;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #727cf5;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #0acf97;
  --bs-btn-border-color: #0acf97;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0acf97;
  --bs-btn-hover-border-color: #0acf97;
  --bs-btn-focus-shadow-rgb: 10, 207, 151;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0acf97;
  --bs-btn-active-border-color: #0acf97;
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #0acf97;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0acf97;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #39afd1;
  --bs-btn-border-color: #39afd1;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #39afd1;
  --bs-btn-hover-border-color: #39afd1;
  --bs-btn-focus-shadow-rgb: 57, 175, 209;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #39afd1;
  --bs-btn-active-border-color: #39afd1;
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #39afd1;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #39afd1;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffbc00;
  --bs-btn-border-color: #ffbc00;
  --bs-btn-hover-color: #313a46;
  --bs-btn-hover-bg: #ffbc00;
  --bs-btn-hover-border-color: #ffbc00;
  --bs-btn-focus-shadow-rgb: 255, 188, 0;
  --bs-btn-active-color: #313a46;
  --bs-btn-active-bg: #ffbc00;
  --bs-btn-active-border-color: #ffbc00;
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #ffbc00;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffbc00;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #fa5c7c;
  --bs-btn-border-color: #fa5c7c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #fa5c7c;
  --bs-btn-hover-border-color: #fa5c7c;
  --bs-btn-focus-shadow-rgb: 250, 92, 124;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #fa5c7c;
  --bs-btn-active-border-color: #fa5c7c;
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #fa5c7c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #fa5c7c;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #eef2f7;
  --bs-btn-border-color: #eef2f7;
  --bs-btn-hover-color: #313a46;
  --bs-btn-hover-bg: #eef2f7;
  --bs-btn-hover-border-color: #eef2f7;
  --bs-btn-focus-shadow-rgb: 238, 242, 247;
  --bs-btn-active-color: #313a46;
  --bs-btn-active-bg: #eef2f7;
  --bs-btn-active-border-color: #eef2f7;
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #eef2f7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #eef2f7;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #313a46;
  --bs-btn-border-color: #313a46;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #313a46;
  --bs-btn-hover-border-color: #313a46;
  --bs-btn-focus-shadow-rgb: 49, 58, 70;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #313a46;
  --bs-btn-active-border-color: #313a46;
  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);
  --bs-btn-disabled-color: #313a46;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #313a46;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--ct-btn-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--ct-btn-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--ct-btn-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: var(--ct-btn-link-disabled-color);
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: none;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: calc(1.2501rem + 0.0012vw);
}
@media (min-width: 1200px) {
  .btn-lg, .btn-group-lg > .btn {
    --bs-btn-font-size: 1.251rem;
  }
}
.btn-lg, .btn-group-lg > .btn {
  --bs-btn-border-radius: 0.15rem;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.28rem;
  --bs-btn-padding-x: 0.8rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: 0.15rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.2125em;
  vertical-align: 0.2125em;
  content: "";
  border-top: 0.25em solid;
  border-right: 0.25em solid transparent;
  border-bottom: 0;
  border-left: 0.25em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.25rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.9rem;
  --bs-dropdown-color: var(--ct-dropdown-color);
  --bs-dropdown-bg: var(--ct-dropdown-bg);
  --bs-dropdown-border-color: var(--ct-dropdown-border-color);
  --bs-dropdown-border-radius: 0.25rem;
  --bs-dropdown-border-width: 1px;
  --bs-dropdown-inner-border-radius: calc(0.25rem - 1px);
  --bs-dropdown-divider-bg: var(--ct-dropdown-divider-bg);
  --bs-dropdown-divider-margin-y: 0.75rem;
  --bs-dropdown-box-shadow: var(--ct-dropdown-box-shadow);
  --bs-dropdown-link-color: var(--ct-dropdown-link-color);
  --bs-dropdown-link-hover-color: var(--ct-dropdown-link-hover-color);
  --bs-dropdown-link-hover-bg: var(--ct-dropdown-link-hover-bg);
  --bs-dropdown-link-active-color: var(--ct-dropdown-link-active-color);
  --bs-dropdown-link-active-bg: var(--ct-dropdown-link-active-bg);
  --bs-dropdown-link-disabled-color: var(--ct-dropdown-link-disabled-color);
  --bs-dropdown-item-padding-x: 1.5rem;
  --bs-dropdown-item-padding-y: 0.375rem;
  --bs-dropdown-header-color: inherit;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.2125em;
  vertical-align: 0.2125em;
  content: "";
  border-top: 0;
  border-right: 0.25em solid transparent;
  border-bottom: 0.25em solid;
  border-left: 0.25em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.2125em;
  vertical-align: 0.2125em;
  content: "";
  border-top: 0.25em solid transparent;
  border-right: 0;
  border-bottom: 0.25em solid transparent;
  border-left: 0.25em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.2125em;
  vertical-align: 0.2125em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.2125em;
  vertical-align: 0.2125em;
  content: "";
  border-top: 0.25em solid transparent;
  border-right: 0.25em solid;
  border-bottom: 0.25em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: var(--ct-dropdown-dark-color);
  --bs-dropdown-bg: var(--ct-dropdown-dark-bg);
  --bs-dropdown-border-color: var(--ct-dropdown-dark-border-color);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: var(--ct-dropdown-dark-link-color);
  --bs-dropdown-link-hover-color: var(--ct-dropdown-dark-link-hover-color);
  --bs-dropdown-divider-bg: var(--ct-dropdown-dark-divider-bg);
  --bs-dropdown-link-hover-bg: var(--ct-dropdown-dark-link-hover-bg);
  --bs-dropdown-link-active-color: var(--ct-dropdown-dark-link-active-color);
  --bs-dropdown-link-active-bg: var(--ct-dropdown-dark-link-active-bg);
  --bs-dropdown-link-disabled-color: var(--ct-dropdown-dark-link-disabled-color);
  --bs-dropdown-header-color: var(--ct-dropdown-dark-header-color);
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.15rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(1px * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.675rem;
  padding-left: 0.675rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.6rem;
  padding-left: 0.6rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(1px * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--ct-nav-link-disabled-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: 1px;
  --bs-nav-tabs-border-color: var(--ct-nav-tabs-border-color);
  --bs-nav-tabs-border-radius: 0.25rem;
  --bs-nav-tabs-link-hover-border-color: var(--ct-nav-tabs-link-hover-border-color);
  --bs-nav-tabs-link-active-color: var(--ct-nav-tabs-link-active-color);
  --bs-nav-tabs-link-active-bg: var(--ct-nav-tabs-link-active-bg);
  --bs-nav-tabs-link-active-border-color: var(--ct-nav-tabs-link-active-border-color);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 0.25rem;
  --bs-nav-pills-link-active-color: var(--ct-component-active-color);
  --bs-nav-pills-link-active-bg: var(--ct-component-active-bg);
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.75rem;
  --bs-navbar-color: var(--ct-navbar-light-color);
  --bs-navbar-hover-color: var(--ct-navbar-light-hover-color);
  --bs-navbar-disabled-color: var(--ct-navbar-light-disabled-color);
  --bs-navbar-active-color: var(--ct-navbar-light-active-color);
  --bs-navbar-brand-padding-y: 0.23675rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.251rem;
  --bs-navbar-brand-color: var(--ct-navbar-light-active-color);
  --bs-navbar-brand-hover-color: var(--ct-navbar-light-active-color);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.251rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --bs-navbar-toggler-border-radius: 0.15rem;
  --bs-navbar-toggler-focus-width: 0.2rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: 1px solid var(--bs-navbar-toggler-border-color);
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: 75vh;
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: var(--ct-navbar-dark-color);
  --bs-navbar-hover-color: var(--ct-navbar-dark-hover-color);
  --bs-navbar-disabled-color: var(--ct-navbar-dark-disabled-color);
  --bs-navbar-active-color: var(--ct-navbar-dark-active-color);
  --bs-navbar-brand-color: var(--ct-navbar-dark-active-color);
  --bs-navbar-brand-hover-color: var(--ct-navbar-dark-active-color);
  --bs-navbar-toggler-border-color: var(--ct-navbar-dark-toggler-border-color);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.card {
  --bs-card-spacer-y: 1.5rem;
  --bs-card-spacer-x: 1.5rem;
  --bs-card-title-spacer-y: 0.75rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: 1px;
  --bs-card-border-color: var(--ct-card-border-color);
  --bs-card-border-radius: 0.25rem;
  --bs-card-box-shadow: var(--ct-card-box-shadow);
  --bs-card-inner-border-radius: calc(0.25rem - 1px);
  --bs-card-cap-padding-y: 0.75rem;
  --bs-card-cap-padding-x: 1.5rem;
  --bs-card-cap-bg: var(--ct-card-cap-bg);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--ct-card-bg);
  --bs-card-img-overlay-padding: 1.25rem;
  --bs-card-group-margin: 12px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: #6c757d;
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--ct-accordion-color);
  --bs-accordion-bg: transparent;
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--ct-accordion-border-color);
  --bs-accordion-border-width: 1px;
  --bs-accordion-border-radius: 0.25rem;
  --bs-accordion-inner-border-radius: calc(0.25rem - 1px);
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--ct-accordion-color);
  --bs-accordion-btn-bg: transparent;
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-focus-box-shadow: var(--ct-accordion-button-focus-box-shadow);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--ct-accordion-button-active-color);
  --bs-accordion-active-bg: var(--ct-accordion-button-active-bg);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.9rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2843.0588235294%, 65.8823529412%, 99.5294117647%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2843.0588235294%, 65.8823529412%, 99.5294117647%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 1.5rem;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--ct-breadcrumb-divider-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--ct-breadcrumb-active-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: "\\f0142" /* rtl: var(--bs-breadcrumb-divider, "\\f0142") */;
  content: var(--bs-breadcrumb-divider, "\\f0142") /* rtl: var(--bs-breadcrumb-divider, "\\f0142") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--ct-pagination-color);
  --bs-pagination-bg: var(--ct-pagination-bg);
  --bs-pagination-border-width: 1px;
  --bs-pagination-border-color: var(--ct-pagination-border-color);
  --bs-pagination-border-radius: 0.25rem;
  --bs-pagination-hover-color: var(--ct-pagination-hover-color);
  --bs-pagination-hover-bg: var(--ct-pagination-hover-bg);
  --bs-pagination-hover-border-color: var(--ct-pagination-hover-border-color);
  --bs-pagination-focus-color: var(--ct-pagination-focus-color);
  --bs-pagination-focus-bg: var(--ct-pagination-focus-bg);
  --bs-pagination-focus-box-shadow: var(--ct-pagination-focus-box-shadow);
  --bs-pagination-active-color: var(--ct-component-active-color);
  --bs-pagination-active-bg: var(--ct-component-active-bg);
  --bs-pagination-active-border-color: var(--ct-component-active-bg);
  --bs-pagination-disabled-color: var(--ct-pagination-disabled-color);
  --bs-pagination-disabled-bg: var(--ct-pagination-disabled-bg);
  --bs-pagination-disabled-border-color: var(--ct-pagination-disabled-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item .page-link {
  border-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: calc(1.2501rem + 0.0012vw);
}
@media (min-width: 1200px) {
  .pagination-lg {
    --bs-pagination-font-size: 1.251rem;
  }
}
.pagination-lg {
  --bs-pagination-border-radius: 0.3rem;
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: 0.2rem;
}

.badge {
  --bs-badge-padding-x: 0.4em;
  --bs-badge-padding-y: 0.25em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: var(--ct-badge-color);
  --bs-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1.25rem;
  --bs-alert-padding-y: 0.75rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: 1px solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.25rem;
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3.75rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.9375rem 1.25rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.675rem;
  --bs-progress-bg: var(--ct-progress-bg);
  --bs-progress-border-radius: 0.25rem;
  --bs-progress-box-shadow: var(--ct-progress-box-shadow);
  --bs-progress-bar-color: var(--ct-progress-bar-color);
  --bs-progress-bar-bg: var(--ct-progress-bar-bg);
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--ct-list-group-color);
  --bs-list-group-bg: var(--ct-list-group-bg);
  --bs-list-group-border-color: var(--ct-list-group-border-color);
  --bs-list-group-border-width: 1px;
  --bs-list-group-border-radius: 0.25rem;
  --bs-list-group-item-padding-x: 1.2rem;
  --bs-list-group-item-padding-y: 0.75rem;
  --bs-list-group-action-color: var(--ct-list-group-action-color);
  --bs-list-group-action-hover-color: var(--ct-list-group-action-color);
  --bs-list-group-action-hover-bg: var(--ct-list-group-hover-bg);
  --bs-list-group-action-active-color: var(--ct-list-group-action-active-color);
  --bs-list-group-action-active-bg: var(--ct-list-group-action-active-bg);
  --bs-list-group-disabled-color: var(--ct-list-group-disabled-color);
  --bs-list-group-disabled-bg: var(--ct-list-group-disabled-bg);
  --bs-list-group-active-color: var(--ct-component-active-color);
  --bs-list-group-active-bg: var(--ct-component-active-bg);
  --bs-list-group-active-border-color: var(--ct-component-active-bg);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: var(--ct-btn-close-color);
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-btn-close-opacity: 1;
  --bs-btn-close-hover-opacity: 0.8;
  --bs-btn-close-focus-shadow: none;
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 12px;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: inherit;
  --bs-toast-bg: var(--ct-toast-background-color);
  --bs-toast-border-width: 1px;
  --bs-toast-border-color: var(--ct-toast-border-color);
  --bs-toast-border-radius: 0.25rem;
  --bs-toast-box-shadow: var(--ct-box-shadow);
  --bs-toast-header-color: inherit;
  --bs-toast-header-bg: var(--ct-toast-header-background-color);
  --bs-toast-header-border-color: var(--ct-toast-header-border-color);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--ct-modal-content-bg);
  --bs-modal-border-color: transparent;
  --bs-modal-border-width: 1px;
  --bs-modal-border-radius: 0.2rem;
  --bs-modal-box-shadow: var(--ct-modal-content-box-shadow-xs);
  --bs-modal-inner-border-radius: calc(0.2rem - 1px);
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--ct-modal-header-border-color);
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--ct-modal-footer-border-color);
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: var(--ct-modal-backdrop-bg);
  --bs-backdrop-opacity: 0.7;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--ct-modal-content-box-shadow-sm-up);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.8rem;
  --bs-tooltip-padding-y: 0.4rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 0.8125rem;
  --bs-tooltip-color: var(--ct-tooltip-color);
  --bs-tooltip-bg: var(--ct-tooltip-bg);
  --bs-tooltip-border-radius: 0.2rem;
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: "Nunito", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--ct-popover-bg);
  --bs-popover-border-width: 1px;
  --bs-popover-border-color: var(--ct-popover-border-color);
  --bs-popover-border-radius: 0.3rem;
  --bs-popover-inner-border-radius: calc(0.3rem - 1px);
  --bs-popover-box-shadow: var(--ct-box-shadow);
  --bs-popover-header-padding-x: 0.8rem;
  --bs-popover-header-padding-y: 0.7rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: var(--ct-popover-header-color);
  --bs-popover-header-bg: var(--ct-popover-header-bg);
  --bs-popover-body-padding-x: 0.75rem;
  --bs-popover-body-padding-y: 0.5rem;
  --bs-popover-body-color: var(--ct-popover-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: "Nunito", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  color: var(--ct-carousel-control-color);
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  color: var(--ct-carousel-control-color);
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-color: var(--ct-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  color: var(--ct-carousel-caption-color);
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
  background-color: var(--ct-carousel-dark-indicator-active-bg);
}
.carousel-dark .carousel-caption {
  color: #000;
  color: var(--ct-carousel-dark-caption-color);
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
  background-color: var(--ct-carousel-dark-indicator-active-bg);
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
  color: var(--ct-carousel-dark-caption-color);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--ct-modal-content-bg);
  --bs-offcanvas-border-width: 1px;
  --bs-offcanvas-border-color: transparent;
  --bs-offcanvas-box-shadow: var(--ct-modal-content-box-shadow-xs);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #313a46;
  background-color: var(--ct-modal-backdrop-bg);
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.7;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
          mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(114, 124, 245, 1) !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(108, 117, 125, 1) !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(10, 207, 151, 1) !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(57, 175, 209, 1) !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #313a46 !important;
  background-color: RGBA(255, 188, 0, 1) !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(250, 92, 124, 1) !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #313a46 !important;
  background-color: RGBA(238, 242, 247, 1) !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(49, 58, 70, 1) !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(114, 124, 245, 1) !important;
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(114, 124, 245, 1) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(97, 105, 208, 1) !important;
  color: RGBA(97, 105, 208, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(97, 105, 208, 1) !important;
  text-decoration-color: RGBA(97, 105, 208, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(108, 117, 125, 1) !important;
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(108, 117, 125, 1) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(92, 99, 106, 1) !important;
  color: RGBA(92, 99, 106, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(92, 99, 106, 1) !important;
  text-decoration-color: RGBA(92, 99, 106, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(10, 207, 151, 1) !important;
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 207, 151, 1) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(9, 176, 128, 1) !important;
  color: RGBA(9, 176, 128, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(9, 176, 128, 1) !important;
  text-decoration-color: RGBA(9, 176, 128, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(57, 175, 209, 1) !important;
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(57, 175, 209, 1) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(48, 149, 178, 1) !important;
  color: RGBA(48, 149, 178, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(48, 149, 178, 1) !important;
  text-decoration-color: RGBA(48, 149, 178, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(255, 188, 0, 1) !important;
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 188, 0, 1) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 198, 38, 1) !important;
  color: RGBA(255, 198, 38, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 198, 38, 1) !important;
  text-decoration-color: RGBA(255, 198, 38, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(250, 92, 124, 1) !important;
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(250, 92, 124, 1) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(213, 78, 105, 1) !important;
  color: RGBA(213, 78, 105, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(213, 78, 105, 1) !important;
  text-decoration-color: RGBA(213, 78, 105, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(238, 242, 247, 1) !important;
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(238, 242, 247, 1) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(241, 244, 248, 1) !important;
  color: RGBA(241, 244, 248, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(241, 244, 248, 1) !important;
  text-decoration-color: RGBA(241, 244, 248, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(49, 58, 70, 1) !important;
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(49, 58, 70, 1) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(42, 49, 60, 1) !important;
  color: RGBA(42, 49, 60, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(42, 49, 60, 1) !important;
  text-decoration-color: RGBA(42, 49, 60, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(0, 0, 0, 1) !important;
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 0, 0, 1) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(0, 0, 0, 0.75) !important;
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(0, 0, 0, 0.75) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(13, 110, 253, 0.5);
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: translate3d(0.25em, 0, 0);
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15) !important;
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: 0 .125rem .25rem rgba(0, 0, 0, 0.075) !important;
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: 0 0 45px 0 rgba(0, 0, 0, 0.12) !important;
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: 1px solid #dee2e6 !important;
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: 1px solid #dee2e6 !important;
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: 1px solid #dee2e6 !important;
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(114, 124, 245, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(108, 117, 125, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(10, 207, 151, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(57, 175, 209, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(255, 188, 0, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(250, 92, 124, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(238, 242, 247, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(49, 58, 70, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: rgb(62.0392156863%, 77.2549019608%, 99.6862745098%) !important;
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: rgb(76.9411764706%, 78.3529411765%, 79.6078431373%) !important;
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: rgb(63.9215686275%, 81.1764705882%, 73.1764705882%) !important;
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: rgb(62.0392156863%, 91.6862745098%, 97.6470588235%) !important;
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: rgb(100%, 90.2745098039%, 61.0980392157%) !important;
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: rgb(94.5098039216%, 68.3137254902%, 70.8235294118%) !important;
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: #e9ecef !important;
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: #adb5bd !important;
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-0 {
  border-width: 0 !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.375rem !important;
}

.m-2 {
  margin: 0.75rem !important;
}

.m-3 {
  margin: 1.5rem !important;
}

.m-4 {
  margin: 2.25rem !important;
}

.m-5 {
  margin: 4.5rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.375rem !important;
  margin-left: 0.375rem !important;
}

.mx-2 {
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
}

.mx-3 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-4 {
  margin-right: 2.25rem !important;
  margin-left: 2.25rem !important;
}

.mx-5 {
  margin-right: 4.5rem !important;
  margin-left: 4.5rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.375rem !important;
  margin-bottom: 0.375rem !important;
}

.my-2 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.my-3 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-4 {
  margin-top: 2.25rem !important;
  margin-bottom: 2.25rem !important;
}

.my-5 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.375rem !important;
}

.mt-2 {
  margin-top: 0.75rem !important;
}

.mt-3 {
  margin-top: 1.5rem !important;
}

.mt-4 {
  margin-top: 2.25rem !important;
}

.mt-5 {
  margin-top: 4.5rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.375rem !important;
}

.me-2 {
  margin-right: 0.75rem !important;
}

.me-3 {
  margin-right: 1.5rem !important;
}

.me-4 {
  margin-right: 2.25rem !important;
}

.me-5 {
  margin-right: 4.5rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.375rem !important;
}

.mb-2 {
  margin-bottom: 0.75rem !important;
}

.mb-3 {
  margin-bottom: 1.5rem !important;
}

.mb-4 {
  margin-bottom: 2.25rem !important;
}

.mb-5 {
  margin-bottom: 4.5rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.375rem !important;
}

.ms-2 {
  margin-left: 0.75rem !important;
}

.ms-3 {
  margin-left: 1.5rem !important;
}

.ms-4 {
  margin-left: 2.25rem !important;
}

.ms-5 {
  margin-left: 4.5rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.375rem !important;
}

.m-n2 {
  margin: -0.75rem !important;
}

.m-n3 {
  margin: -1.5rem !important;
}

.m-n4 {
  margin: -2.25rem !important;
}

.m-n5 {
  margin: -4.5rem !important;
}

.mx-n1 {
  margin-right: -0.375rem !important;
  margin-left: -0.375rem !important;
}

.mx-n2 {
  margin-right: -0.75rem !important;
  margin-left: -0.75rem !important;
}

.mx-n3 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n4 {
  margin-right: -2.25rem !important;
  margin-left: -2.25rem !important;
}

.mx-n5 {
  margin-right: -4.5rem !important;
  margin-left: -4.5rem !important;
}

.my-n1 {
  margin-top: -0.375rem !important;
  margin-bottom: -0.375rem !important;
}

.my-n2 {
  margin-top: -0.75rem !important;
  margin-bottom: -0.75rem !important;
}

.my-n3 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n4 {
  margin-top: -2.25rem !important;
  margin-bottom: -2.25rem !important;
}

.my-n5 {
  margin-top: -4.5rem !important;
  margin-bottom: -4.5rem !important;
}

.mt-n1 {
  margin-top: -0.375rem !important;
}

.mt-n2 {
  margin-top: -0.75rem !important;
}

.mt-n3 {
  margin-top: -1.5rem !important;
}

.mt-n4 {
  margin-top: -2.25rem !important;
}

.mt-n5 {
  margin-top: -4.5rem !important;
}

.me-n1 {
  margin-right: -0.375rem !important;
}

.me-n2 {
  margin-right: -0.75rem !important;
}

.me-n3 {
  margin-right: -1.5rem !important;
}

.me-n4 {
  margin-right: -2.25rem !important;
}

.me-n5 {
  margin-right: -4.5rem !important;
}

.mb-n1 {
  margin-bottom: -0.375rem !important;
}

.mb-n2 {
  margin-bottom: -0.75rem !important;
}

.mb-n3 {
  margin-bottom: -1.5rem !important;
}

.mb-n4 {
  margin-bottom: -2.25rem !important;
}

.mb-n5 {
  margin-bottom: -4.5rem !important;
}

.ms-n1 {
  margin-left: -0.375rem !important;
}

.ms-n2 {
  margin-left: -0.75rem !important;
}

.ms-n3 {
  margin-left: -1.5rem !important;
}

.ms-n4 {
  margin-left: -2.25rem !important;
}

.ms-n5 {
  margin-left: -4.5rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.375rem !important;
}

.p-2 {
  padding: 0.75rem !important;
}

.p-3 {
  padding: 1.5rem !important;
}

.p-4 {
  padding: 2.25rem !important;
}

.p-5 {
  padding: 4.5rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.375rem !important;
  padding-left: 0.375rem !important;
}

.px-2 {
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
}

.px-3 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-4 {
  padding-right: 2.25rem !important;
  padding-left: 2.25rem !important;
}

.px-5 {
  padding-right: 4.5rem !important;
  padding-left: 4.5rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}

.py-2 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.py-3 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-4 {
  padding-top: 2.25rem !important;
  padding-bottom: 2.25rem !important;
}

.py-5 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.375rem !important;
}

.pt-2 {
  padding-top: 0.75rem !important;
}

.pt-3 {
  padding-top: 1.5rem !important;
}

.pt-4 {
  padding-top: 2.25rem !important;
}

.pt-5 {
  padding-top: 4.5rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.375rem !important;
}

.pe-2 {
  padding-right: 0.75rem !important;
}

.pe-3 {
  padding-right: 1.5rem !important;
}

.pe-4 {
  padding-right: 2.25rem !important;
}

.pe-5 {
  padding-right: 4.5rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.375rem !important;
}

.pb-2 {
  padding-bottom: 0.75rem !important;
}

.pb-3 {
  padding-bottom: 1.5rem !important;
}

.pb-4 {
  padding-bottom: 2.25rem !important;
}

.pb-5 {
  padding-bottom: 4.5rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.375rem !important;
}

.ps-2 {
  padding-left: 0.75rem !important;
}

.ps-3 {
  padding-left: 1.5rem !important;
}

.ps-4 {
  padding-left: 2.25rem !important;
}

.ps-5 {
  padding-left: 4.5rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.375rem !important;
}

.gap-2 {
  gap: 0.75rem !important;
}

.gap-3 {
  gap: 1.5rem !important;
}

.gap-4 {
  gap: 2.25rem !important;
}

.gap-5 {
  gap: 4.5rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.375rem !important;
}

.row-gap-2 {
  row-gap: 0.75rem !important;
}

.row-gap-3 {
  row-gap: 1.5rem !important;
}

.row-gap-4 {
  row-gap: 2.25rem !important;
}

.row-gap-5 {
  row-gap: 4.5rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.375rem !important;
}

.column-gap-2 {
  column-gap: 0.75rem !important;
}

.column-gap-3 {
  column-gap: 1.5rem !important;
}

.column-gap-4 {
  column-gap: 2.25rem !important;
}

.column-gap-5 {
  column-gap: 4.5rem !important;
}

.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.35rem + 1.2vw) !important;
}

.fs-2 {
  font-size: calc(1.3125rem + 0.75vw) !important;
}

.fs-3 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-4 {
  font-size: 1.125rem !important;
}

.fs-5 {
  font-size: 0.9375rem !important;
}

.fs-6 {
  font-size: 0.75rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(114, 124, 245, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(108, 117, 125, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(10, 207, 151, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(57, 175, 209, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(255, 188, 0, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(250, 92, 124, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(238, 242, 247, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(49, 58, 70, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(108, 117, 125, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, 0.75) !important;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, 0.75) !important;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, 0.5) !important;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: #000 !important;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: rgb(2.0392156863%, 17.2549019608%, 39.6862745098%) !important;
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: rgb(16.9411764706%, 18.3529411765%, 19.6078431373%) !important;
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: rgb(3.9215686275%, 21.1764705882%, 13.1764705882%) !important;
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: rgb(2.0392156863%, 31.6862745098%, 37.6470588235%) !important;
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: rgb(40%, 30.2745098039%, 1.0980392157%) !important;
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: rgb(34.5098039216%, 8.3137254902%, 10.8235294118%) !important;
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: #495057 !important;
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: #495057 !important;
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(114, 124, 245, var(--bs-link-underline-opacity)) !important;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(108, 117, 125, var(--bs-link-underline-opacity)) !important;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(10, 207, 151, var(--bs-link-underline-opacity)) !important;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(57, 175, 209, var(--bs-link-underline-opacity)) !important;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(255, 188, 0, var(--bs-link-underline-opacity)) !important;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(250, 92, 124, var(--bs-link-underline-opacity)) !important;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(238, 242, 247, var(--bs-link-underline-opacity)) !important;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(49, 58, 70, var(--bs-link-underline-opacity)) !important;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(13, 110, 253, 1) !important;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(114, 124, 245, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(108, 117, 125, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(10, 207, 151, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(57, 175, 209, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 188, 0, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(250, 92, 124, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(238, 242, 247, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(49, 58, 70, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(250, 251, 254, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(233, 236, 239, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(248, 249, 250, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: rgb(81.0196078431%, 88.6274509804%, 99.8431372549%) !important;
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%) !important;
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: rgb(81.9607843137%, 90.5882352941%, 86.5882352941%) !important;
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: rgb(81.0196078431%, 95.8431372549%, 98.8235294118%) !important;
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: rgb(100%, 95.137254902%, 80.5490196078%) !important;
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: rgb(97.2549019608%, 84.1568627451%, 85.4117647059%) !important;
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: rgb(98.6274509804%, 98.8235294118%, 99.0196078431%) !important;
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: #ced4da !important;
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0)) !important;
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.25rem !important;
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.2rem !important;
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: 0.25rem !important;
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: 0.3rem !important;
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: 1rem !important;
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: 2rem !important;
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: 0.2rem !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: 0.2rem !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: 0.3rem !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: 0.3rem !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: 1rem !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: 1rem !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: 2rem !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: 2rem !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: 50rem !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: 50rem !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: 0.2rem !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: 0.2rem !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: 0.3rem !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: 0.3rem !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: 1rem !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: 1rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: 2rem !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: 2rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: 50rem !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: 50rem !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: 0.2rem !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: 0.2rem !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: 0.3rem !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: 0.3rem !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: 1rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: 1rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: 2rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: 2rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: 50rem !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: 50rem !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: 0.2rem !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: 0.2rem !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: 0.3rem !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: 0.3rem !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: 1rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: 1rem !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: 2rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: 2rem !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: 50rem !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: 50rem !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.375rem !important;
  }
  .m-sm-2 {
    margin: 0.75rem !important;
  }
  .m-sm-3 {
    margin: 1.5rem !important;
  }
  .m-sm-4 {
    margin: 2.25rem !important;
  }
  .m-sm-5 {
    margin: 4.5rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-sm-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-sm-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-sm-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-sm-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-sm-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.375rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.75rem !important;
  }
  .mt-sm-3 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-4 {
    margin-top: 2.25rem !important;
  }
  .mt-sm-5 {
    margin-top: 4.5rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.375rem !important;
  }
  .me-sm-2 {
    margin-right: 0.75rem !important;
  }
  .me-sm-3 {
    margin-right: 1.5rem !important;
  }
  .me-sm-4 {
    margin-right: 2.25rem !important;
  }
  .me-sm-5 {
    margin-right: 4.5rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.375rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.75rem !important;
  }
  .ms-sm-3 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-4 {
    margin-left: 2.25rem !important;
  }
  .ms-sm-5 {
    margin-left: 4.5rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.375rem !important;
  }
  .m-sm-n2 {
    margin: -0.75rem !important;
  }
  .m-sm-n3 {
    margin: -1.5rem !important;
  }
  .m-sm-n4 {
    margin: -2.25rem !important;
  }
  .m-sm-n5 {
    margin: -4.5rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-sm-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-sm-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-sm-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-sm-n5 {
    margin-top: -4.5rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.375rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.75rem !important;
  }
  .me-sm-n3 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n4 {
    margin-right: -2.25rem !important;
  }
  .me-sm-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-sm-n5 {
    margin-left: -4.5rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.375rem !important;
  }
  .p-sm-2 {
    padding: 0.75rem !important;
  }
  .p-sm-3 {
    padding: 1.5rem !important;
  }
  .p-sm-4 {
    padding: 2.25rem !important;
  }
  .p-sm-5 {
    padding: 4.5rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-sm-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-sm-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-sm-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-sm-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-sm-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-sm-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.375rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.75rem !important;
  }
  .pt-sm-3 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-4 {
    padding-top: 2.25rem !important;
  }
  .pt-sm-5 {
    padding-top: 4.5rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.375rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.75rem !important;
  }
  .pe-sm-3 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-4 {
    padding-right: 2.25rem !important;
  }
  .pe-sm-5 {
    padding-right: 4.5rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.375rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.75rem !important;
  }
  .ps-sm-3 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-4 {
    padding-left: 2.25rem !important;
  }
  .ps-sm-5 {
    padding-left: 4.5rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.375rem !important;
  }
  .gap-sm-2 {
    gap: 0.75rem !important;
  }
  .gap-sm-3 {
    gap: 1.5rem !important;
  }
  .gap-sm-4 {
    gap: 2.25rem !important;
  }
  .gap-sm-5 {
    gap: 4.5rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.375rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.75rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 2.25rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 4.5rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.375rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.75rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 2.25rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 4.5rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.375rem !important;
  }
  .m-md-2 {
    margin: 0.75rem !important;
  }
  .m-md-3 {
    margin: 1.5rem !important;
  }
  .m-md-4 {
    margin: 2.25rem !important;
  }
  .m-md-5 {
    margin: 4.5rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-md-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-md-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-md-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-md-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-md-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-md-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.375rem !important;
  }
  .mt-md-2 {
    margin-top: 0.75rem !important;
  }
  .mt-md-3 {
    margin-top: 1.5rem !important;
  }
  .mt-md-4 {
    margin-top: 2.25rem !important;
  }
  .mt-md-5 {
    margin-top: 4.5rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.375rem !important;
  }
  .me-md-2 {
    margin-right: 0.75rem !important;
  }
  .me-md-3 {
    margin-right: 1.5rem !important;
  }
  .me-md-4 {
    margin-right: 2.25rem !important;
  }
  .me-md-5 {
    margin-right: 4.5rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-md-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.375rem !important;
  }
  .ms-md-2 {
    margin-left: 0.75rem !important;
  }
  .ms-md-3 {
    margin-left: 1.5rem !important;
  }
  .ms-md-4 {
    margin-left: 2.25rem !important;
  }
  .ms-md-5 {
    margin-left: 4.5rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.375rem !important;
  }
  .m-md-n2 {
    margin: -0.75rem !important;
  }
  .m-md-n3 {
    margin: -1.5rem !important;
  }
  .m-md-n4 {
    margin: -2.25rem !important;
  }
  .m-md-n5 {
    margin: -4.5rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-md-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-md-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-md-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-md-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-md-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-md-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-md-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-md-n5 {
    margin-top: -4.5rem !important;
  }
  .me-md-n1 {
    margin-right: -0.375rem !important;
  }
  .me-md-n2 {
    margin-right: -0.75rem !important;
  }
  .me-md-n3 {
    margin-right: -1.5rem !important;
  }
  .me-md-n4 {
    margin-right: -2.25rem !important;
  }
  .me-md-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-md-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-md-n5 {
    margin-left: -4.5rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.375rem !important;
  }
  .p-md-2 {
    padding: 0.75rem !important;
  }
  .p-md-3 {
    padding: 1.5rem !important;
  }
  .p-md-4 {
    padding: 2.25rem !important;
  }
  .p-md-5 {
    padding: 4.5rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-md-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-md-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-md-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-md-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-md-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-md-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.375rem !important;
  }
  .pt-md-2 {
    padding-top: 0.75rem !important;
  }
  .pt-md-3 {
    padding-top: 1.5rem !important;
  }
  .pt-md-4 {
    padding-top: 2.25rem !important;
  }
  .pt-md-5 {
    padding-top: 4.5rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.375rem !important;
  }
  .pe-md-2 {
    padding-right: 0.75rem !important;
  }
  .pe-md-3 {
    padding-right: 1.5rem !important;
  }
  .pe-md-4 {
    padding-right: 2.25rem !important;
  }
  .pe-md-5 {
    padding-right: 4.5rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-md-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.375rem !important;
  }
  .ps-md-2 {
    padding-left: 0.75rem !important;
  }
  .ps-md-3 {
    padding-left: 1.5rem !important;
  }
  .ps-md-4 {
    padding-left: 2.25rem !important;
  }
  .ps-md-5 {
    padding-left: 4.5rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.375rem !important;
  }
  .gap-md-2 {
    gap: 0.75rem !important;
  }
  .gap-md-3 {
    gap: 1.5rem !important;
  }
  .gap-md-4 {
    gap: 2.25rem !important;
  }
  .gap-md-5 {
    gap: 4.5rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.375rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.75rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-4 {
    row-gap: 2.25rem !important;
  }
  .row-gap-md-5 {
    row-gap: 4.5rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.375rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.75rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-4 {
    column-gap: 2.25rem !important;
  }
  .column-gap-md-5 {
    column-gap: 4.5rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.375rem !important;
  }
  .m-lg-2 {
    margin: 0.75rem !important;
  }
  .m-lg-3 {
    margin: 1.5rem !important;
  }
  .m-lg-4 {
    margin: 2.25rem !important;
  }
  .m-lg-5 {
    margin: 4.5rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-lg-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-lg-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-lg-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-lg-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-lg-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.375rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.75rem !important;
  }
  .mt-lg-3 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-4 {
    margin-top: 2.25rem !important;
  }
  .mt-lg-5 {
    margin-top: 4.5rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.375rem !important;
  }
  .me-lg-2 {
    margin-right: 0.75rem !important;
  }
  .me-lg-3 {
    margin-right: 1.5rem !important;
  }
  .me-lg-4 {
    margin-right: 2.25rem !important;
  }
  .me-lg-5 {
    margin-right: 4.5rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.375rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.75rem !important;
  }
  .ms-lg-3 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-4 {
    margin-left: 2.25rem !important;
  }
  .ms-lg-5 {
    margin-left: 4.5rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.375rem !important;
  }
  .m-lg-n2 {
    margin: -0.75rem !important;
  }
  .m-lg-n3 {
    margin: -1.5rem !important;
  }
  .m-lg-n4 {
    margin: -2.25rem !important;
  }
  .m-lg-n5 {
    margin: -4.5rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-lg-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-lg-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-lg-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-lg-n5 {
    margin-top: -4.5rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.375rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.75rem !important;
  }
  .me-lg-n3 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n4 {
    margin-right: -2.25rem !important;
  }
  .me-lg-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-lg-n5 {
    margin-left: -4.5rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.375rem !important;
  }
  .p-lg-2 {
    padding: 0.75rem !important;
  }
  .p-lg-3 {
    padding: 1.5rem !important;
  }
  .p-lg-4 {
    padding: 2.25rem !important;
  }
  .p-lg-5 {
    padding: 4.5rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-lg-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-lg-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-lg-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-lg-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-lg-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-lg-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.375rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.75rem !important;
  }
  .pt-lg-3 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-4 {
    padding-top: 2.25rem !important;
  }
  .pt-lg-5 {
    padding-top: 4.5rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.375rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.75rem !important;
  }
  .pe-lg-3 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-4 {
    padding-right: 2.25rem !important;
  }
  .pe-lg-5 {
    padding-right: 4.5rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.375rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.75rem !important;
  }
  .ps-lg-3 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-4 {
    padding-left: 2.25rem !important;
  }
  .ps-lg-5 {
    padding-left: 4.5rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.375rem !important;
  }
  .gap-lg-2 {
    gap: 0.75rem !important;
  }
  .gap-lg-3 {
    gap: 1.5rem !important;
  }
  .gap-lg-4 {
    gap: 2.25rem !important;
  }
  .gap-lg-5 {
    gap: 4.5rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.375rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.75rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 2.25rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 4.5rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.375rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.75rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 2.25rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 4.5rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.375rem !important;
  }
  .m-xl-2 {
    margin: 0.75rem !important;
  }
  .m-xl-3 {
    margin: 1.5rem !important;
  }
  .m-xl-4 {
    margin: 2.25rem !important;
  }
  .m-xl-5 {
    margin: 4.5rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xl-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-xl-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-xl-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xl-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-xl-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.375rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.75rem !important;
  }
  .mt-xl-3 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-4 {
    margin-top: 2.25rem !important;
  }
  .mt-xl-5 {
    margin-top: 4.5rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.375rem !important;
  }
  .me-xl-2 {
    margin-right: 0.75rem !important;
  }
  .me-xl-3 {
    margin-right: 1.5rem !important;
  }
  .me-xl-4 {
    margin-right: 2.25rem !important;
  }
  .me-xl-5 {
    margin-right: 4.5rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.375rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.75rem !important;
  }
  .ms-xl-3 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-4 {
    margin-left: 2.25rem !important;
  }
  .ms-xl-5 {
    margin-left: 4.5rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.375rem !important;
  }
  .m-xl-n2 {
    margin: -0.75rem !important;
  }
  .m-xl-n3 {
    margin: -1.5rem !important;
  }
  .m-xl-n4 {
    margin: -2.25rem !important;
  }
  .m-xl-n5 {
    margin: -4.5rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-xl-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-xl-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-xl-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-xl-n5 {
    margin-top: -4.5rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.375rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.75rem !important;
  }
  .me-xl-n3 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n4 {
    margin-right: -2.25rem !important;
  }
  .me-xl-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-xl-n5 {
    margin-left: -4.5rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.375rem !important;
  }
  .p-xl-2 {
    padding: 0.75rem !important;
  }
  .p-xl-3 {
    padding: 1.5rem !important;
  }
  .p-xl-4 {
    padding: 2.25rem !important;
  }
  .p-xl-5 {
    padding: 4.5rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-xl-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xl-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-xl-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-xl-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xl-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-xl-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.375rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.75rem !important;
  }
  .pt-xl-3 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-4 {
    padding-top: 2.25rem !important;
  }
  .pt-xl-5 {
    padding-top: 4.5rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.375rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.75rem !important;
  }
  .pe-xl-3 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-4 {
    padding-right: 2.25rem !important;
  }
  .pe-xl-5 {
    padding-right: 4.5rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.375rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.75rem !important;
  }
  .ps-xl-3 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-4 {
    padding-left: 2.25rem !important;
  }
  .ps-xl-5 {
    padding-left: 4.5rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.375rem !important;
  }
  .gap-xl-2 {
    gap: 0.75rem !important;
  }
  .gap-xl-3 {
    gap: 1.5rem !important;
  }
  .gap-xl-4 {
    gap: 2.25rem !important;
  }
  .gap-xl-5 {
    gap: 4.5rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.375rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.75rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 2.25rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 4.5rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.375rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.75rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 2.25rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 4.5rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.375rem !important;
  }
  .m-xxl-2 {
    margin: 0.75rem !important;
  }
  .m-xxl-3 {
    margin: 1.5rem !important;
  }
  .m-xxl-4 {
    margin: 2.25rem !important;
  }
  .m-xxl-5 {
    margin: 4.5rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-xxl-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xxl-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-xxl-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.375rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.75rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-4 {
    margin-top: 2.25rem !important;
  }
  .mt-xxl-5 {
    margin-top: 4.5rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.375rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.75rem !important;
  }
  .me-xxl-3 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-4 {
    margin-right: 2.25rem !important;
  }
  .me-xxl-5 {
    margin-right: 4.5rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.375rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.75rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-4 {
    margin-left: 2.25rem !important;
  }
  .ms-xxl-5 {
    margin-left: 4.5rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.375rem !important;
  }
  .m-xxl-n2 {
    margin: -0.75rem !important;
  }
  .m-xxl-n3 {
    margin: -1.5rem !important;
  }
  .m-xxl-n4 {
    margin: -2.25rem !important;
  }
  .m-xxl-n5 {
    margin: -4.5rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-xxl-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -4.5rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.375rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.75rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n4 {
    margin-right: -2.25rem !important;
  }
  .me-xxl-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -4.5rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.375rem !important;
  }
  .p-xxl-2 {
    padding: 0.75rem !important;
  }
  .p-xxl-3 {
    padding: 1.5rem !important;
  }
  .p-xxl-4 {
    padding: 2.25rem !important;
  }
  .p-xxl-5 {
    padding: 4.5rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xxl-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-xxl-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xxl-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-xxl-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.375rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.75rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-4 {
    padding-top: 2.25rem !important;
  }
  .pt-xxl-5 {
    padding-top: 4.5rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.375rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.75rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-4 {
    padding-right: 2.25rem !important;
  }
  .pe-xxl-5 {
    padding-right: 4.5rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.375rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.75rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-4 {
    padding-left: 2.25rem !important;
  }
  .ps-xxl-5 {
    padding-left: 4.5rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.375rem !important;
  }
  .gap-xxl-2 {
    gap: 0.75rem !important;
  }
  .gap-xxl-3 {
    gap: 1.5rem !important;
  }
  .gap-xxl-4 {
    gap: 2.25rem !important;
  }
  .gap-xxl-5 {
    gap: 4.5rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.375rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.75rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 2.25rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 4.5rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.375rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.75rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 2.25rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 4.5rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.25rem !important;
  }
  .fs-2 {
    font-size: 1.875rem !important;
  }
  .fs-3 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
html {
  position: relative;
  min-height: 100%;
}

body {
  overflow-x: hidden;
}

@supports (-webkit-overflow-scrolling: touch) {
  body {
    cursor: pointer;
  }
}
.logo {
  display: block;
  line-height: 70px;
  width: 260px;
  position: fixed;
  top: 0;
}
.logo span.logo-lg {
  display: block;
}
.logo span.logo-sm {
  display: none;
}
.logo.logo-light {
  display: block;
}
.logo.logo-dark {
  display: none;
}

.wrapper {
  height: 100%;
  width: 100%;
}

.content-page {
  margin-left: 260px;
  min-height: 100vh;
}

.leftside-menu {
  width: 260px;
  z-index: 10;
  background: linear-gradient(135deg, #8f75da 0%, #727cf5 60%);
  background: var(--ct-bg-leftbar-gradient);
  bottom: 0;
  position: fixed;
  top: 0;
  padding-top: 70px;
  box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
  box-shadow: var(--ct-box-shadow);
}

.side-nav {
  padding-left: 0;
  list-style-type: none;
}
.side-nav ul {
  list-style-type: none;
}
.side-nav .side-nav-link {
  color: #6c757d;
  color: var(--ct-menu-item);
  display: block;
  padding: 10px 30px;
  font-size: 0.8375rem;
  position: relative;
  transition: all 0.4s;
  list-style: none;
  font-weight: 500 !important;
}
.side-nav .side-nav-link:hover, .side-nav .side-nav-link:focus, .side-nav .side-nav-link:active {
  color: #727cf5;
  color: var(--ct-menu-item-hover);
  text-decoration: none;
}
.side-nav .side-nav-link span {
  vertical-align: middle;
}
.side-nav .side-nav-link i {
  display: inline-block;
  line-height: 1.0625rem;
  margin: 0 10px 0 0;
  font-size: 1.1rem;
  vertical-align: middle;
  width: 20px;
}
.side-nav .menu-arrow {
  transition: transform 0.15s;
  position: absolute;
  right: 30px;
  display: inline-block;
  font-family: "Material Design Icons";
  text-rendering: auto;
  line-height: 1.5rem;
  font-size: 1.1rem;
  transform: translate(0, 0);
}
.side-nav .menu-arrow:before {
  content: "\\f0142";
}
.side-nav .badge {
  margin-top: 3px;
}
.side-nav .side-nav-item > a[aria-expanded=true] > span.menu-arrow {
  transform: rotate(90deg);
}
.side-nav .side-nav-item.menuitem-active > a:not(.collapsed) > span.menu-arrow {
  transform: rotate(90deg);
}
.side-nav .side-nav-title {
  padding: 12px 30px;
  letter-spacing: 0.05em;
  pointer-events: none;
  cursor: default;
  font-size: 0.6875rem;
  text-transform: uppercase;
  color: #6c757d;
  color: var(--ct-menu-item);
  font-weight: 700;
}
.side-nav .menuitem-active > a {
  color: #727cf5 !important;
  color: var(--ct-menu-item-active) !important;
}

*[dir=ltr] .side-nav .side-nav-item .menu-arrow:before {
  content: "\\f0141" !important;
}

.side-nav-second-level,
.side-nav-third-level,
.side-nav-forth-level {
  padding-left: 0;
}
.side-nav-second-level li a,
.side-nav-second-level li .side-nav-link,
.side-nav-third-level li a,
.side-nav-third-level li .side-nav-link,
.side-nav-forth-level li a,
.side-nav-forth-level li .side-nav-link {
  padding: 8px 30px 8px 65px;
  color: #6c757d;
  color: var(--ct-menu-item);
  display: block;
  position: relative;
  transition: all 0.4s;
  font-size: 0.89rem;
}
.side-nav-second-level li a:focus, .side-nav-second-level li a:hover,
.side-nav-second-level li .side-nav-link:focus,
.side-nav-second-level li .side-nav-link:hover,
.side-nav-third-level li a:focus,
.side-nav-third-level li a:hover,
.side-nav-third-level li .side-nav-link:focus,
.side-nav-third-level li .side-nav-link:hover,
.side-nav-forth-level li a:focus,
.side-nav-forth-level li a:hover,
.side-nav-forth-level li .side-nav-link:focus,
.side-nav-forth-level li .side-nav-link:hover {
  color: #727cf5;
  color: var(--ct-menu-item-hover);
}
.side-nav-second-level li a .menu-arrow,
.side-nav-second-level li .side-nav-link .menu-arrow,
.side-nav-third-level li a .menu-arrow,
.side-nav-third-level li .side-nav-link .menu-arrow,
.side-nav-forth-level li a .menu-arrow,
.side-nav-forth-level li .side-nav-link .menu-arrow {
  line-height: 1.3rem;
}
.side-nav-second-level li.active > a,
.side-nav-third-level li.active > a,
.side-nav-forth-level li.active > a {
  color: #727cf5;
  color: var(--ct-menu-item-active);
}

.side-nav-third-level li a,
.side-nav-third-level li .side-nav-link {
  padding: 8px 30px 8px 80px;
}

.side-nav-forth-level li a,
.side-nav-forth-level li .side-nav-link {
  padding: 8px 30px 8px 100px;
}

body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) {
  min-height: 1600px;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .leftside-menu {
  position: absolute;
  padding-top: 0;
  width: 70px;
  z-index: 5;
  padding-top: 70px;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .leftside-menu .simplebar-mask,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .leftside-menu .simplebar-content-wrapper {
  overflow: visible !important;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .leftside-menu .simplebar-scrollbar {
  display: none !important;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .leftside-menu .simplebar-offset {
  bottom: 0 !important;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .leftside-menu .logo {
  width: 70px;
  z-index: 1;
  background: linear-gradient(135deg, #8f75da 0%, #727cf5 60%);
  background: var(--ct-bg-leftbar-gradient);
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .help-box {
  display: none;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .content-page {
  margin-left: 70px;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .navbar-custom,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .footer {
  left: 70px;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-title,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .badge,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .menu-arrow {
  display: none !important;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapse,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapsing {
  display: none;
  height: inherit !important;
  transition: none !important;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapse .side-nav-second-level,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapse .side-nav-third-level,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapse .side-nav-forth-level,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapsing .side-nav-second-level,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapsing .side-nav-third-level,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapsing .side-nav-forth-level {
  display: none !important;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item {
  position: relative;
  white-space: nowrap;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item .side-nav-link {
  padding: 15px 20px;
  min-height: 54px;
  transition: none;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item .side-nav-link:hover, body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item .side-nav-link:active, body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item .side-nav-link:focus {
  color: #727cf5;
  color: var(--ct-menu-item-hover);
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item .side-nav-link i {
  font-size: 1.125rem;
  margin-right: 20px;
  margin-left: 6px;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item .side-nav-link span {
  display: none;
  padding-left: 10px;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover .side-nav-link {
  position: relative;
  width: 260px;
  color: #fff;
  background: linear-gradient(135deg, #8f75da 0%, #727cf5 60%);
  background: var(--ct-bg-leftbar-gradient);
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover .side-nav-link span {
  display: inline;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > ul {
  display: block !important;
  left: 70px;
  position: absolute;
  width: 190px;
  height: auto !important;
  padding: 5px 0;
  z-index: 9999;
  background: linear-gradient(135deg, #8f75da 0%, #727cf5 60%);
  background: var(--ct-bg-leftbar-gradient);
  box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
  box-shadow: var(--ct-box-shadow);
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > ul a {
  padding: 8px 20px;
  position: relative;
  width: 190px;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > ul a:hover {
  color: #727cf5;
  color: var(--ct-menu-item-hover);
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapse,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapsing {
  display: block !important;
  transition: none !important;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapse > ul,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapsing > ul {
  display: block !important;
  left: 70px;
  position: absolute;
  width: 190px;
  background: linear-gradient(135deg, #8f75da 0%, #727cf5 60%);
  background: var(--ct-bg-leftbar-gradient);
  box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
  box-shadow: var(--ct-box-shadow);
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapse > ul a,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapsing > ul a {
  box-shadow: none;
  padding: 8px 20px;
  position: relative;
  width: 190px;
  z-index: 6;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapse > ul a:hover,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapsing > ul a:hover {
  color: #727cf5;
  color: var(--ct-menu-item-hover);
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapse > ul li:hover > .collapse,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapsing > ul li:hover > .collapse {
  display: block !important;
  height: auto !important;
  transition: none !important;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapse > ul li:hover > .collapse > ul,
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapsing > ul li:hover > .collapse > ul {
  display: block;
  left: 190px;
  top: 0;
  position: absolute;
  width: 190px;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .logo span.logo-lg {
  display: none;
}
body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .logo span.logo-sm {
  display: block;
  line-height: 70px;
  color: #727cf5;
}

@media (max-width: 767.98px) {
  body {
    overflow-x: hidden;
  }
  .leftside-menu {
    box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
    box-shadow: var(--ct-box-shadow);
    display: none;
    z-index: 10 !important;
  }
  .sidebar-enable .leftside-menu {
    display: block;
  }
  .navbar-nav.navbar-right {
    float: right;
  }
  .content-page {
    margin-left: 0 !important;
    padding: 65px 10px 65px;
  }
  body[data-leftbar-compact-mode=condensed] .leftside-menu {
    margin-left: 0px;
  }
  .logo span.logo-lg {
    display: block;
  }
  .logo span.logo-sm {
    display: none;
  }
}
.help-box {
  border-radius: 5px;
  padding: 20px;
  margin: 65px 25px 25px;
  position: relative;
  background-color: rgba(255, 255, 255, 0.07);
  background-color: var(--ct-help-box-light-bg);
}
.help-box .close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
}

body[data-leftbar-theme=light] .help-box {
  background-color: #727cf5;
}
body[data-leftbar-theme=light] .logo.logo-light {
  display: none;
}
body[data-leftbar-theme=light] .logo.logo-dark {
  display: block;
}

body[data-layout=topnav] .content-page {
  margin-left: 0 !important;
  padding: 0 0 60px 0;
}

body[data-layout-mode=boxed] {
  background-color: #fff;
  background-color: var(--ct-boxed-layout-bg);
}
body[data-layout-mode=boxed] .wrapper {
  max-width: 1300px;
  margin: 0 auto;
  background-color: #fafbfe;
  box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
  box-shadow: var(--ct-box-shadow);
}
body[data-layout-mode=boxed][data-leftbar-compact-mode=condensed] .logo {
  position: relative;
  margin-top: -70px;
}

@media (min-width: 1200px) {
  body[data-leftbar-compact-mode=scrollable]:not([data-layout=topnav]) {
    padding-bottom: 0;
  }
  body[data-leftbar-compact-mode=scrollable]:not([data-layout=topnav]) .wrapper {
    display: flex;
  }
  body[data-leftbar-compact-mode=scrollable]:not([data-layout=topnav]) .leftside-menu {
    position: relative;
    min-width: 260px;
    max-width: 260px;
    padding-top: 0;
  }
  body[data-leftbar-compact-mode=scrollable]:not([data-layout=topnav]) .logo {
    position: relative;
    margin-top: 0;
  }
  body[data-leftbar-compact-mode=scrollable]:not([data-layout=topnav]) .content-page {
    margin-left: 0;
    width: 100%;
    padding-bottom: 60px;
  }
}
body[data-layout=detached] {
  padding-bottom: 0;
}
@media (min-width: 992px) {
  body[data-layout=detached] .container-fluid, body[data-layout=detached] .container-sm, body[data-layout=detached] .container-md, body[data-layout=detached] .container-lg, body[data-layout=detached] .container-xl, body[data-layout=detached] .container-xxl {
    max-width: 95%;
  }
}
body[data-layout=detached][data-layout-mode=boxed] .wrapper {
  max-width: 100%;
}
body[data-layout=detached] .wrapper {
  display: flex;
  overflow: inherit;
}
body[data-layout=detached] .content-page {
  margin-left: 0;
  overflow: hidden;
  padding: 0 15px 5px 30px;
  position: relative;
  margin-right: -15px;
  width: 100%;
  padding-bottom: 60px;
}
body[data-layout=detached] .leftside-menu {
  position: relative;
  background: #fff !important;
  background: var(--ct-bg-detached-leftbar) !important;
  min-width: 260px;
  max-width: 260px;
  box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
  box-shadow: var(--ct-box-shadow);
  margin-top: 30px;
  padding-top: 0 !important;
  z-index: 1001 !important;
}
body[data-layout=detached] .leftside-menu .side-nav .side-nav-link {
  color: #6c757d !important;
  color: var(--ct-menu-item) !important;
}
body[data-layout=detached] .leftside-menu .side-nav .side-nav-link:hover, body[data-layout=detached] .leftside-menu .side-nav .side-nav-link:focus, body[data-layout=detached] .leftside-menu .side-nav .side-nav-link:active {
  color: #727cf5 !important;
  color: var(--ct-menu-item-hover) !important;
}
body[data-layout=detached] .leftside-menu .side-nav .side-nav-second-level li a,
body[data-layout=detached] .leftside-menu .side-nav .side-nav-third-level li a,
body[data-layout=detached] .leftside-menu .side-nav .side-nav-forth-level li a {
  color: #6c757d;
  color: var(--ct-menu-item);
}
body[data-layout=detached] .leftside-menu .side-nav .side-nav-second-level li a:focus, body[data-layout=detached] .leftside-menu .side-nav .side-nav-second-level li a:hover,
body[data-layout=detached] .leftside-menu .side-nav .side-nav-third-level li a:focus,
body[data-layout=detached] .leftside-menu .side-nav .side-nav-third-level li a:hover,
body[data-layout=detached] .leftside-menu .side-nav .side-nav-forth-level li a:focus,
body[data-layout=detached] .leftside-menu .side-nav .side-nav-forth-level li a:hover {
  color: #727cf5;
  color: var(--ct-menu-item-hover);
}
body[data-layout=detached] .leftside-menu .side-nav .side-nav-second-level li.mm-active > a,
body[data-layout=detached] .leftside-menu .side-nav .side-nav-third-level li.mm-active > a,
body[data-layout=detached] .leftside-menu .side-nav .side-nav-forth-level li.mm-active > a {
  color: #727cf5;
  color: var(--ct-menu-item-active);
}
body[data-layout=detached] .leftside-menu .side-nav .menuitem-active > a {
  color: #727cf5 !important;
  color: var(--ct-menu-item-active) !important;
}
body[data-layout=detached] .leftside-menu .side-nav .side-nav-title {
  color: #6c757d;
  color: var(--ct-menu-item);
}
body[data-layout=detached] .leftbar-user {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat;
  padding: 30px 20px;
  text-align: center;
}
body[data-layout=detached] .leftbar-user .leftbar-user-name {
  font-weight: 700;
  color: #313a46;
  margin-left: 12px;
  margin-top: 8px;
  display: block;
}
@media (max-width: 767.98px) {
  body[data-layout=detached].sidebar-enable .leftside-menu {
    position: fixed;
    left: 0;
    overflow-y: auto;
    margin-top: 70px;
  }
  body[data-layout=detached] .wrapper {
    max-width: 100%;
  }
  body[data-layout=detached] .content-page {
    margin-left: 0 !important;
    padding: 0 10px 60px 10px;
  }
  body[data-layout=detached] .lang-switch {
    display: none;
  }
  body[data-layout=detached][data-leftbar-compact-mode=condensed].sidebar-enable .leftside-menu {
    margin-top: 0px;
  }
}
body[data-layout=detached][data-leftbar-compact-mode=condensed] .wrapper .leftside-menu {
  max-width: 70px;
  min-width: 70px;
  position: relative;
}
body[data-layout=detached][data-leftbar-compact-mode=condensed] .wrapper .leftbar-user {
  display: none;
}
body[data-layout=detached][data-leftbar-compact-mode=condensed] .wrapper .content-page {
  margin-left: 0;
}
body[data-layout=detached][data-leftbar-compact-mode=condensed] .wrapper .footer {
  left: 0;
}
body[data-layout=detached][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:hover, body[data-layout=detached][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:active, body[data-layout=detached][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:focus {
  color: #727cf5;
  color: var(--ct-menu-item-hover);
}
body[data-layout=detached][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover .side-nav-link {
  background: #727cf5;
  color: #fff !important;
  transition: none;
}
body[data-layout=detached][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover ul {
  background: #fff !important;
  background: var(--ct-bg-leftbar) !important;
  box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
  box-shadow: var(--ct-box-shadow);
}
body[data-layout=detached][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover ul a:hover {
  color: #727cf5 !important;
  color: var(--ct-menu-item-hover) !important;
}

@media (min-width: 992px) {
  body[data-layout=detached][data-leftbar-compact-mode=scrollable] .wrapper {
    padding-top: 70px;
  }
}
.button-menu-mobile .lines {
  width: 18px;
  display: block;
  position: relative;
  height: 16px;
  transition: all 0.5s ease;
  margin-top: 26px;
  margin-left: 10px;
}
.button-menu-mobile span {
  height: 2px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: block;
  margin-bottom: 5px;
  transition: transform 0.5s ease;
}
.button-menu-mobile span:nth-of-type(2) {
  width: 24px;
}
.button-menu-mobile.disable-btn {
  display: none;
}

body[data-leftbar-theme=light] .leftside-menu {
  background: #fff;
  background: var(--ct-bg-leftbar);
}
body[data-leftbar-theme=light] .leftside-menu .logo {
  background: #fff !important;
  background: var(--ct-bg-leftbar) !important;
}
body[data-leftbar-theme=light] .side-nav .side-nav-link {
  color: #6c757d;
  color: var(--ct-menu-item);
}
body[data-leftbar-theme=light] .side-nav .side-nav-link:hover, body[data-leftbar-theme=light] .side-nav .side-nav-link:focus, body[data-leftbar-theme=light] .side-nav .side-nav-link:active {
  color: #727cf5;
  color: var(--ct-menu-item-hover);
}
body[data-leftbar-theme=light] .side-nav .menuitem-active > a {
  color: #727cf5 !important;
  color: var(--ct-menu-item-active) !important;
}
body[data-leftbar-theme=light] .side-nav .side-nav-title {
  color: #6c757d;
  color: var(--ct-menu-item);
}
body[data-leftbar-theme=light] .side-nav .side-nav-second-level li a,
body[data-leftbar-theme=light] .side-nav .side-nav-third-level li a,
body[data-leftbar-theme=light] .side-nav .side-nav-forth-level li a {
  color: #6c757d;
  color: var(--ct-menu-item);
}
body[data-leftbar-theme=light] .side-nav .side-nav-second-level li a:focus, body[data-leftbar-theme=light] .side-nav .side-nav-second-level li a:hover,
body[data-leftbar-theme=light] .side-nav .side-nav-third-level li a:focus,
body[data-leftbar-theme=light] .side-nav .side-nav-third-level li a:hover,
body[data-leftbar-theme=light] .side-nav .side-nav-forth-level li a:focus,
body[data-leftbar-theme=light] .side-nav .side-nav-forth-level li a:hover {
  color: #727cf5;
  color: var(--ct-menu-item-hover);
}
body[data-leftbar-theme=light] .side-nav .side-nav-second-level li.active > a,
body[data-leftbar-theme=light] .side-nav .side-nav-third-level li.active > a,
body[data-leftbar-theme=light] .side-nav .side-nav-forth-level li.active > a {
  color: #727cf5;
  color: var(--ct-menu-item-active);
}
body[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:hover, body[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:active, body[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:focus {
  color: #727cf5;
  color: var(--ct-menu-item-hover);
}
body[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover .side-nav-link {
  background: #727cf5;
  color: #fff !important;
  transition: none;
}
body[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > ul {
  background: #fff;
  background: var(--ct-bg-leftbar);
  box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
  box-shadow: var(--ct-box-shadow);
}
body[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > ul a:hover {
  color: #727cf5;
  color: var(--ct-menu-item-hover);
}
body[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > .collapse > ul,
body[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > .collapsing > ul {
  background: #fff;
  background: var(--ct-bg-leftbar);
}
body[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > .collapse > ul a:hover,
body[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > .collapsing > ul a:hover {
  color: #727cf5;
  color: var(--ct-menu-item-hover);
}

body[data-leftbar-theme=dark] .leftside-menu {
  background: #313A46 !important;
}
body[data-leftbar-theme=dark] .leftside-menu .logo {
  background: #313A46 !important;
}
body[data-leftbar-theme=dark] .side-nav .side-nav-link {
  color: var(--ct-dark-menu-item);
}
body[data-leftbar-theme=dark] .side-nav .side-nav-link:hover, body[data-leftbar-theme=dark] .side-nav .side-nav-link:focus, body[data-leftbar-theme=dark] .side-nav .side-nav-link:active {
  color: var(--ct-dark-menu-item-hover);
}
body[data-leftbar-theme=dark] .side-nav .menuitem-active > a {
  color: rgba(236, 172, 55, 0.8901960784) !important;
  font-weight: 700 !important;
}
body[data-leftbar-theme=dark] .side-nav .side-nav-title {
  color: var(--ct-dark-menu-item);
}
body[data-leftbar-theme=dark] .side-nav .side-nav-second-level li a,
body[data-leftbar-theme=dark] .side-nav .side-nav-third-level li a,
body[data-leftbar-theme=dark] .side-nav .side-nav-forth-level li a {
  color: var(--ct-dark-menu-item);
}
body[data-leftbar-theme=dark] .side-nav .side-nav-second-level li a:focus, body[data-leftbar-theme=dark] .side-nav .side-nav-second-level li a:hover,
body[data-leftbar-theme=dark] .side-nav .side-nav-third-level li a:focus,
body[data-leftbar-theme=dark] .side-nav .side-nav-third-level li a:hover,
body[data-leftbar-theme=dark] .side-nav .side-nav-forth-level li a:focus,
body[data-leftbar-theme=dark] .side-nav .side-nav-forth-level li a:hover {
  color: var(--ct-dark-menu-item-hover);
}
body[data-leftbar-theme=dark] .side-nav .side-nav-second-level li.active > a,
body[data-leftbar-theme=dark] .side-nav .side-nav-third-level li.active > a,
body[data-leftbar-theme=dark] .side-nav .side-nav-forth-level li.active > a {
  color: var(--ct-dark-menu-item-active);
}
body[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:hover, body[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:active, body[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:focus {
  color: var(--ct-dark-menu-item-hover);
}
body[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover .side-nav-link {
  background: #727cf5;
  color: #fff !important;
  transition: none;
}
body[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > ul {
  background: #fff;
  background: var(--ct-bg-leftbar);
  box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
  box-shadow: var(--ct-box-shadow);
}
body[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > ul a:hover {
  color: var(--ct-dark-menu-item-hover);
}
body[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > .collapse > ul,
body[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > .collapsing > ul {
  background: #fff;
  background: var(--ct-bg-leftbar);
}

body[data-layout=full] .navbar-custom .button-menu-mobile.disable-btn {
  display: block;
}
body[data-layout=full].hide-menu .wrapper .leftside-menu {
  width: 0 !important;
  padding-top: 0;
}
body[data-layout=full].hide-menu .wrapper .leftside-menu .side-nav {
  opacity: 0.2;
}
body[data-layout=full].hide-menu .wrapper .leftside-menu .logo {
  width: 70px;
  background: linear-gradient(135deg, #8f75da 0%, #727cf5 60%) !important;
  background: var(--ct-bg-leftbar-gradient) !important;
}
body[data-layout=full].hide-menu .wrapper .leftside-menu .logo span.logo-lg {
  display: none;
}
body[data-layout=full].hide-menu .wrapper .leftside-menu .logo span.logo-sm {
  display: block;
}
body[data-layout=full].hide-menu .content-page {
  margin-left: 0 !important;
}
body[data-layout=full].hide-menu .content-page .navbar-custom {
  left: 70px;
}
body[data-layout=full].hide-menu .content-page .footer {
  left: 0 !important;
}
body[data-layout=full].hide-menu[data-leftbar-compact-mode=condensed] .wrapper .leftside-menu {
  padding-top: 70px;
}
body[data-layout=full].hide-menu[data-leftbar-compact-mode=condensed] .wrapper .leftside-menu .side-nav {
  transform: translateX(-50px);
  visibility: hidden;
}
body[data-layout=full][data-leftbar-compact-mode=scrollable].hide-menu .wrapper .leftside-menu {
  max-width: 0px;
  min-width: 0px;
}
body[data-layout=full][data-leftbar-compact-mode=scrollable] .wrapper .leftside-menu {
  padding-top: 0 !important;
}
body[data-layout=full][data-leftbar-theme=dark].hide-menu .wrapper .leftside-menu .logo {
  background: #fff !important;
  background: var(--ct-bg-leftbar) !important;
}
body[data-layout=full][data-leftbar-theme=light].hide-menu .wrapper .leftside-menu .logo {
  background: #fff !important;
  background: var(--ct-bg-leftbar) !important;
}

body[data-layout-color=dark][data-layout-mode=boxed] .wrapper {
  background-color: var(--ct-body-bg);
}
body[data-layout-color=dark][data-layout=detached] .leftbar-user .leftbar-user-name {
  color: #f1f1f1;
}

.navbar-custom {
  padding: 0 24px;
  background-color: #fff;
  background-color: var(--ct-bg-topbar);
  box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
  box-shadow: var(--ct-box-shadow);
  height: "50px!important";
  position: fixed;
  left: 260px;
  top: 0;
  right: 0;
  z-index: 1001;
}
.navbar-custom .topbar-left {
  background-color: #fff;
  background-color: var(--ct-bg-topbar);
  height: 70px;
  position: fixed;
  z-index: 1;
  width: 260px;
  text-align: center;
  top: 0;
  left: 0;
}
.navbar-custom .topbar-left .logo {
  line-height: 70px;
}
.navbar-custom .topbar-left .logo i {
  display: none;
}
.navbar-custom .topbar-menu {
  position: relative;
  z-index: 1;
}
.navbar-custom .topbar-menu li {
  float: left;
  max-height: 70px;
}
.navbar-custom .topbar-menu li .show.nav-link {
  color: #6c757d;
}
.navbar-custom .topbar-menu .nav-link {
  padding: 0;
  color: #98a6ad;
  min-width: 32px;
  display: block;
  text-align: center;
  margin: 0 10px;
  position: relative;
}
.navbar-custom .app-search {
  position: static;
  overflow-y: hidden;
  padding: calc(32px / 2) 5px calc(32px / 2) 0;
}
.navbar-custom .app-search .react-select__control,
.navbar-custom .app-search .react-select__menu {
  overflow: hidden;
  width: 320px !important;
}
.navbar-custom .app-search .react-select__control .react-select__option.react-select__option--is-selected .dropdown-item,
.navbar-custom .app-search .react-select__menu .react-select__option.react-select__option--is-selected .dropdown-item {
  color: rgba(#6c757d, 0.7) !important;
  color: rgba(var(--ct-input-color), 0.7) !important;
}
.navbar-custom .app-search .react-select__control .react-select__value-container .react-select__placeholder,
.navbar-custom .app-search .react-select__menu .react-select__value-container .react-select__placeholder {
  color: #6c757d !important;
  color: var(--ct-input-color) !important;
}
.navbar-custom .app-search .react-select__control .react-select__value-container .react-select__input-container,
.navbar-custom .app-search .react-select__menu .react-select__value-container .react-select__input-container {
  color: #6c757d !important;
  color: var(--ct-input-color) !important;
}
.navbar-custom .app-search .react-select__control .react-select__value-container .react-select__input-container .react-select__input,
.navbar-custom .app-search .react-select__menu .react-select__value-container .react-select__input-container .react-select__input {
  color: #6c757d !important;
  color: var(--ct-input-color) !important;
}

.topbar-dropdown .nav-link {
  line-height: 70px;
}

/* Search */
.app-search .react-select__control {
  border: none;
  height: calc(1.5em + 0.9rem + 2px);
  padding-left: 40px;
  background-color: #f1f3fa;
  background-color: var(--ct-bg-topbar-search);
  box-shadow: none;
}
.app-search .react-select__value-container {
  padding: 0;
}
.app-search .react-select__menu {
  margin-top: 0;
}
.app-search span.search-icon {
  position: absolute;
  z-index: 9;
  font-size: 20px;
  line-height: 38px;
  left: 10px;
  top: 0;
}

.app-search .form-control {
  border: none;
  height: calc(1.5em + 0.9rem + 2px);
  padding-left: 40px;
  padding-right: 20px;
  background-color: #f1f3fa;
  background-color: var(--ct-bg-topbar-search);
  box-shadow: none;
}
.app-search span.search-icon {
  position: absolute;
  z-index: 4;
  font-size: 20px;
  line-height: 38px;
  left: 10px;
  top: 0;
}
.app-search .input-group-text {
  margin-left: 0;
  z-index: 4;
}

/* Notification */
.notification-list {
  margin-left: 0;
}
.notification-list .noti-title {
  background-color: transparent;
  padding: 15px 20px;
}
.notification-list .noti-icon {
  font-size: 22px;
  vertical-align: middle;
  line-height: 70px;
}
.notification-list .noti-icon-badge {
  display: inline-block;
  position: absolute;
  top: 22px;
  right: 6px;
  border-radius: 50%;
  height: 7px;
  width: 7px;
  background-color: #fa5c7c;
}
.notification-list .notify-item {
  padding: 10px 20px;
}
.notification-list .notify-item.unread-noti {
  background-color: rgb(95.3333333333%, 96%, 98.3333333333%);
}
.notification-list .notify-item.read-noti {
  background-color: transparent;
  border: 1px solid #eef2f7;
}
.notification-list .notify-item .card-body {
  padding: 14px;
}
.notification-list .notify-item .card-body .noti-close-btn {
  position: absolute;
  top: 3px;
  right: 5px;
}
.notification-list .notify-item .card-body .noti-item-title {
  margin: 0 0 2px;
}
.notification-list .notify-item .card-body .noti-item-title,
.notification-list .notify-item .card-body .noti-item-subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.notification-list .notify-item .notify-icon {
  float: left;
  height: 36px;
  width: 36px;
  line-height: 36px;
  text-align: center;
  border-radius: 50%;
  color: #fff;
}
.notification-list .notify-item .notify-details {
  margin-bottom: 0;
  overflow: hidden;
  margin-left: 45px;
}
.notification-list .notify-item .notify-details b {
  font-weight: 500;
}
.notification-list .notify-item .notify-details small, .notification-list .notify-item .notify-details .small {
  display: block;
}
.notification-list .notify-item .user-msg {
  margin-left: 45px;
  white-space: normal;
  line-height: 16px;
}
.notification-list .topbar-dropdown-menu .notify-item {
  padding: 7px 20px;
}

.profile-dropdown {
  min-width: 170px;
}
.profile-dropdown i,
.profile-dropdown span {
  vertical-align: middle;
}

.nav-user {
  padding: 0px 0px 0px 61px !important;
  text-align: left !important;
  position: relative;
  border-width: 0 1px;
}
.nav-user .account-user-avatar {
  position: absolute;
  top: calc(70px -8px * 0.5);
  left: 15px;
}
.nav-user .account-user-avatar img {
  height: 32px;
  width: 32px;
}
.nav-user .account-position {
  display: block;
  font-size: 12px;
  margin-top: -3px;
}
.nav-user .account-user-name {
  display: block;
  font-weight: 600;
}

.button-menu-mobile {
  border: none;
  color: #313a46;
  height: 70px;
  line-height: 70px;
  width: 60px;
  background-color: transparent;
  font-size: 24px;
  cursor: pointer;
  float: left;
  z-index: 1;
  position: relative;
  margin-left: -24px;
}
.button-menu-mobile.disable-btn {
  display: none;
}
@media (max-width: 767.98px) {
  .button-menu-mobile {
    margin: 0 !important;
  }
}

[data-keep-enlarged=true] .navbar-custom {
  padding-left: 0;
}
[data-keep-enlarged=true] .button-menu-mobile {
  margin: 0;
}
[data-keep-enlarged=true] .button-menu-mobile.disable-btn {
  display: inline-block;
}

@media (max-width: 576px) {
  .navbar-custom .topbar-menu {
    position: static;
    position: initial;
  }
  .navbar-custom .dropdown {
    position: static;
  }
  .navbar-custom .dropdown .dropdown-menu {
    left: 10px !important;
    right: 10px !important;
  }
}
@media (max-width: 1200px) {
  .navbar-custom {
    right: 0;
  }
  .navbar-custom .app-search {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .nav-user {
    padding: 17px 5px 17px 57px !important;
  }
  .nav-user .account-position,
  .nav-user .account-user-name {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-custom {
    left: 0 !important;
    padding: 0;
  }
  .button-menu-mobile.disable-btn {
    display: inline-block;
  }
}
@media (max-width: 375px) {
  .navbar-custom .topbar-menu .nav-link {
    margin: 0 5px;
  }
  .navbar-custom.topnav-navbar .container-fluid, .navbar-custom.topnav-navbar .container-sm, .navbar-custom.topnav-navbar .container-md, .navbar-custom.topnav-navbar .container-lg, .navbar-custom.topnav-navbar .container-xl, .navbar-custom.topnav-navbar .container-xxl {
    padding-right: 12px;
    padding-left: 12px;
  }
  .navbar-custom.topnav-navbar .navbar-toggle {
    margin: 27px 3px;
  }
  .navbar-custom.topnav-navbar .button-menu-mobile {
    width: auto;
  }
}
@media (min-width: 992px) {
  body[data-leftbar-compact-mode=scrollable]:not([data-layout-mode=boxed]):not([data-layout=topnav]) .navbar-custom {
    position: absolute;
  }
}
.topnav-navbar-dark {
  background-color: #313a46;
  background-color: var(--ct-bg-dark-topbar);
}
.topnav-navbar-dark .nav-user {
  background-color: #3c4655 !important;
  background-color: var(--ct-nav-user-bg-dark-topbar) !important;
  border: 1px solid #414d5d !important;
  border: 1px solid var(--ct-nav-user-border-dark-topbar) !important;
}
.topnav-navbar-dark .topbar-menu li .show.nav-link {
  color: #fff !important;
}
.topnav-navbar-dark .app-search .react-select__control {
  background-color: #3c4655;
  background-color: var(--ct-bg-dark-topbar-search);
  color: #fff;
}
.topnav-navbar-dark .app-search .react-select__input {
  color: #fff;
}
.topnav-navbar-dark .app-search span,
.topnav-navbar-dark .app-search .react-select__placeholder {
  color: #98a6ad;
}
.topnav-navbar-dark .navbar-toggle span {
  background-color: rgba(255, 255, 255, 0.8) !important;
}

body[data-layout-mode=boxed] .navbar-custom {
  position: relative;
  left: 0 !important;
  margin: -70px -12px 0;
}
body[data-layout-mode=boxed][data-layout=topnav] .navbar-custom {
  margin: 0;
}

body[data-layout-color=dark] .navbar-custom .topbar-menu li .show.nav-link {
  color: #dee2e6;
}
body[data-layout-color=dark] .navbar-custom .topbar-menu .nav-link {
  color: #ced4da;
}
body[data-layout-color=dark] .notification-list .notify-item.unread-noti {
  background-color: rgb(28.1764705882%, 31.6705882353%, 36.3294117647%);
}
body[data-layout-color=dark] .notification-list .notify-item.read-noti {
  border: 1px solid #464f5b;
}
body[data-layout-color=dark] .button-menu-mobile {
  color: #f1f1f1;
}
body[data-layout-color=dark] .nav-user {
  background-color: rgb(27.2602013778%, 31.0936671966%, 35.7790143084%);
  border: 1px solid #404954;
}
body[data-layout-color=dark] .topnav-navbar-dark .app-search span,
body[data-layout-color=dark] .topnav-navbar-dark .app-search .react-select__placeholder {
  color: #ced4da;
}

/* rtl:begin:options: {
  "autoRename": true,
  "stringMap":[]
} */
.end-bar {
  background-color: #fff;
  background-color: var(--ct-rightbar-bg);
  box-shadow: 0 0 24px 0 rgba(49, 58, 70, 0.1), 0 1px 0 0 rgba(49, 58, 70, 0.08);
  display: block;
  position: fixed;
  transition: all 200ms ease-out;
  width: 280px;
  z-index: 9999;
  float: right !important;
  right: -290px;
  top: 0;
  bottom: 0;
  padding-bottom: 80px;
}
.end-bar .rightbar-title {
  background-color: #313a46;
  background-color: var(--ct-rightbar-title-bg);
  padding: 27px 25px;
  color: #fff;
  color: var(--ct-rightbar-title-color);
}
.end-bar .end-bar-toggle {
  background-color: #444e5a;
  background-color: var(--ct-rightbar-title-btn-bg);
  height: 24px;
  width: 24px;
  line-height: 22px;
  color: #fff;
  color: var(--ct-rightbar-title-btn-color);
  text-align: center;
  border-radius: 50%;
  margin-top: -4px;
}

.rightbar-overlay {
  background-color: #37404a;
  background-color: var(--ct-rightbar-overlay-bg);
  opacity: 0.2;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
  z-index: 9998;
  transition: all 0.2s ease-out;
}

.end-bar-enabled .end-bar {
  right: 0;
}
.end-bar-enabled .rightbar-overlay {
  display: block;
}

@media (max-width: 767.98px) {
  .end-bar {
    overflow: auto;
  }
}
.page-title-box .page-title {
  font-size: 18px;
  margin: 0;
  line-height: 75px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #6c757d;
  color: var(--ct-page-title-color);
}
.page-title-box .page-title-right {
  float: right;
  margin-top: 20px;
}
.page-title-box .breadcrumb {
  padding-top: 8px;
}

.page-title-box-sm .page-title {
  line-height: 1 !important;
  margin-bottom: 25px;
}
.page-title-box-sm .page-title-right {
  float: right;
  margin-top: 0;
}
.page-title-box-sm .breadcrumb {
  padding-top: 0;
  margin-top: -3px !important;
}

.text-title {
  color: #6c757d;
  color: var(--ct-text-title-color);
}
.text-title:hover {
  color: #6c757d;
  color: var(--ct-text-title-color);
}

@media (max-width: 767.98px) {
  .page-title-box .page-title {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 70px;
  }
  .page-title-box .breadcrumb {
    display: none;
  }
  .page-title-box .page-title-right {
    display: none;
  }
}
@media (max-width: 419px) {
  .page-title-box .breadcrumb {
    display: none;
  }
}
.topnav-navbar {
  padding: 0;
  margin: 0;
  min-height: 70px;
  position: relative;
  left: 0 !important;
  z-index: 1002;
}
.topnav-navbar .topnav-logo {
  line-height: 70px;
  float: left;
  padding-right: 20px;
  min-width: 160px;
}
.topnav-navbar .topnav-logo .topnav-logo-sm {
  display: none;
}
.topnav-navbar .navbar-toggle {
  position: relative;
  cursor: pointer;
  float: left;
  margin: 27px 20px;
  padding: 0;
  background-color: transparent;
  border: none;
}
.topnav-navbar .navbar-toggle .lines {
  width: 25px;
  display: block;
  position: relative;
  height: 16px;
  transition: all 0.5s ease;
}
.topnav-navbar .navbar-toggle span {
  height: 2px;
  width: 100%;
  background-color: rgba(49, 58, 70, 0.8);
  display: block;
  margin-bottom: 5px;
  transition: transform 0.5s ease;
}
.topnav-navbar .navbar-toggle.open span {
  position: absolute;
}
.topnav-navbar .navbar-toggle.open span:first-child {
  top: 7px;
  transform: rotate(45deg);
}
.topnav-navbar .navbar-toggle.open span:nth-child(2) {
  visibility: hidden;
}
.topnav-navbar .navbar-toggle.open span:last-child {
  width: 100%;
  top: 7px;
  transform: rotate(-45deg);
}
.topnav-navbar .app-search {
  float: left;
}

.topnav {
  background: #313a46;
  background: var(--ct-bg-topnav);
}
.topnav .topnav-menu {
  margin: 0;
  padding: 0;
}
.topnav .navbar-nav .nav-link {
  font-size: 0.9375rem;
  position: relative;
  padding: 1rem 1.3rem;
}
.topnav .nav-item.active > a {
  color: #727cf5;
  color: var(--ct-menu-item-active);
}
.topnav .navbar-dark .dropdown.active > .nav-link, .topnav .navbar-dark .dropdown:active > .nav-link {
  color: #fff;
}

.arrow-down {
  display: inline-block;
}
.arrow-down:after {
  border-color: currentColor;
  border-color: initial;
  border-style: solid;
  border-width: 0 0 1px 1px;
  content: "";
  height: 0.4em;
  display: inline-block;
  right: 5px;
  top: 50%;
  margin-left: 10px;
  transform: rotate(-45deg) translateY(-50%);
  transform-origin: top;
  transition: all 0.3s ease-out;
  width: 0.4em;
}

body[data-layout=topnav] .container-fluid, body[data-layout=topnav] .container-sm, body[data-layout=topnav] .container-md, body[data-layout=topnav] .container-lg, body[data-layout=topnav] .container-xl, body[data-layout=topnav] .container-xxl {
  padding-right: 24px;
  padding-left: 24px;
}

@media (min-width: 992px) {
  body[data-layout=topnav] .container-fluid, body[data-layout=topnav] .container-sm, body[data-layout=topnav] .container-md, body[data-layout=topnav] .container-lg, body[data-layout=topnav] .container-xl, body[data-layout=topnav] .container-xxl {
    max-width: 95%;
  }
  body[data-layout=topnav][data-layout-mode=boxed] .container-fluid, body[data-layout=topnav][data-layout-mode=boxed] .container-sm, body[data-layout=topnav][data-layout-mode=boxed] .container-md, body[data-layout=topnav][data-layout-mode=boxed] .container-lg, body[data-layout=topnav][data-layout-mode=boxed] .container-xl, body[data-layout=topnav][data-layout-mode=boxed] .container-xxl {
    max-width: 97%;
  }
  .topnav .navbar-nav .nav-item:first-of-type .nav-link {
    padding-left: 0;
  }
  .topnav .dropdown .dropdown-menu {
    margin-top: 0;
    border-radius: 0 0 0.25rem 0.25rem;
    min-width: calc(10rem + 1.5rem);
    font-size: calc(0.9rem - 0.01rem);
  }
  .topnav .dropdown .dropdown-menu .arrow-down::after {
    right: 15px;
    transform: rotate(-135deg) translateY(-50%);
    position: absolute;
  }
  .topnav .dropdown .dropdown-menu .dropdown .dropdown-menu {
    position: absolute;
    top: 0;
    left: 100%;
    display: none;
  }
  .topnav .dropdown:hover > .dropdown-menu {
    display: block;
  }
  .topnav .dropdown:hover > .dropdown-menu > .dropdown:hover > .dropdown-menu {
    display: block;
  }
  .dropdown.active > a.dropdown-item {
    color: #313a46;
    color: var(--ct-dropdown-link-active-color);
    background-color: rgb(94.9333333333%, 96.1254901961%, 97.6156862745%);
    background-color: var(--ct-dropdown-link-active-bg);
  }
}
@media (min-width: 1400px) {
  body[data-layout=topnav] .container-fluid, body[data-layout=topnav] .container-sm, body[data-layout=topnav] .container-md, body[data-layout=topnav] .container-lg, body[data-layout=topnav] .container-xl, body[data-layout=topnav] .container-xxl {
    max-width: 85%;
  }
}
@media (min-width: 992px) {
  .navbar-toggle {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .topnav-navbar .topnav-logo-lg {
    display: none;
  }
  .topnav-navbar .topnav-logo {
    min-width: 50px;
    padding-right: 0;
    text-align: center;
  }
  .topnav-navbar .topnav-logo-sm {
    display: block !important;
  }
  .topnav .navbar-nav .nav-link {
    padding: 0.75rem 1.3rem;
  }
  .topnav .dropdown .dropdown-menu {
    background-color: transparent;
    border: none;
    box-shadow: none;
    padding-left: 15px;
  }
  .topnav .dropdown .dropdown-item {
    position: relative;
    background-color: transparent;
  }
  .topnav .navbar-dark .dropdown .dropdown-item {
    color: rgba(255, 255, 255, 0.5);
  }
  .topnav .navbar-dark .dropdown .dropdown-item.active, .topnav .navbar-dark .dropdown .dropdown-item:active {
    color: #fff;
  }
  .topnav .arrow-down::after {
    right: 15px;
    position: absolute;
  }
}
@font-face {
  font-family: "Nunito";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  src: local("Nunito Light"), local("Nunito-Light"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("svg");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Nunito";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  src: local("Nunito Regular"), local("Nunito-Regular"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("svg");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Nunito";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  src: local("Nunito SemiBold"), local("Nunito-SemiBold"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("svg");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Nunito";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  src: local("Nunito Bold"), local("Nunito-Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("svg");
  font-weight: 700;
  font-style: normal;
}
/*
Template Name: Hyper - Responsive Bootstrap 5 Admin Dashboard
Version: 1.6.0
Author: CoderThemes
Email: support@coderthemes.com
File: Icons Css File
*/
@font-face {
  font-family: "unicons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_40___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_43___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */
/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */
/*
@media screen and (-webkit-min-device-pixel-ratio:0) {
  @font-face {
    font-family: 'unicons';
    src: url('../font/unicons.svg?34404611#unicons') format('svg');
  }
}
*/
[class^=uil-]:before, [class*=" uil-"]:before {
  font-family: "unicons";
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  text-align: center;
  /* For safety - reset parent styles, that can break glyph codes*/
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  /* fix buttons height, for twitter bootstrap */
  line-height: 1em;
  /* you can be more comfortable with increased icons size */
  /* font-size: 120%; */
  /* Font smoothing. That was taken from TWBS */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Uncomment for 3D effect */
  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */
}

.uil-0-plus:before {
  content: "\\e800";
} /* '' */
.uil-10-plus:before {
  content: "\\e801";
} /* '' */
.uil-12-plus:before {
  content: "\\e802";
} /* '' */
.uil-13-plus:before {
  content: "\\e803";
} /* '' */
.uil-16-plus:before {
  content: "\\e804";
} /* '' */
.uil-17-plus:before {
  content: "\\e805";
} /* '' */
.uil-18-plus:before {
  content: "\\e806";
} /* '' */
.uil-21-plus:before {
  content: "\\e807";
} /* '' */
.uil-3-plus:before {
  content: "\\e808";
} /* '' */
.uil-500px:before {
  content: "\\e809";
} /* '' */
.uil-6-plus:before {
  content: "\\e80a";
} /* '' */
.uil-abacus:before {
  content: "\\e80b";
} /* '' */
.uil-accessible-icon-alt:before {
  content: "\\e80c";
} /* '' */
.uil-adjust-alt:before {
  content: "\\e80d";
} /* '' */
.uil-adjust-circle:before {
  content: "\\e80e";
} /* '' */
.uil-adjust-half:before {
  content: "\\e80f";
} /* '' */
.uil-adjust:before {
  content: "\\e810";
} /* '' */
.uil-adobe:before {
  content: "\\e811";
} /* '' */
.uil-airplay:before {
  content: "\\e812";
} /* '' */
.uil-align-alt:before {
  content: "\\e813";
} /* '' */
.uil-align-center-alt:before {
  content: "\\e814";
} /* '' */
.uil-align-center-h:before {
  content: "\\e815";
} /* '' */
.uil-align-center-justify:before {
  content: "\\e816";
} /* '' */
.uil-align-center-v:before {
  content: "\\e817";
} /* '' */
.uil-align-center:before {
  content: "\\e818";
} /* '' */
.uil-align-justify:before {
  content: "\\e819";
} /* '' */
.uil-align-left-justify:before {
  content: "\\e81a";
} /* '' */
.uil-align-left:before {
  content: "\\e81b";
} /* '' */
.uil-align-letter-right:before {
  content: "\\e81c";
} /* '' */
.uil-align-right-justify:before {
  content: "\\e81d";
} /* '' */
.uil-align-right:before {
  content: "\\e81e";
} /* '' */
.uil-align:before {
  content: "\\e81f";
} /* '' */
.uil-ambulance:before {
  content: "\\e820";
} /* '' */
.uil-analysis:before {
  content: "\\e821";
} /* '' */
.uil-analytics:before {
  content: "\\e822";
} /* '' */
.uil-anchor:before {
  content: "\\e823";
} /* '' */
.uil-android-phone-slash:before {
  content: "\\e824";
} /* '' */
.uil-angle-double-down:before {
  content: "\\e825";
} /* '' */
.uil-angle-double-left:before {
  content: "\\e826";
} /* '' */
.uil-angle-double-right:before {
  content: "\\e827";
} /* '' */
.uil-angle-double-up:before {
  content: "\\e828";
} /* '' */
.uil-angle-down:before {
  content: "\\e829";
} /* '' */
.uil-angle-left:before {
  content: "\\e82a";
} /* '' */
.uil-angle-right-b:before {
  content: "\\e82b";
} /* '' */
.uil-angle-right:before {
  content: "\\e82c";
} /* '' */
.uil-angle-up:before {
  content: "\\e82d";
} /* '' */
.uil-angry:before {
  content: "\\e82e";
} /* '' */
.uil-ankh:before {
  content: "\\e82f";
} /* '' */
.uil-annoyed-alt:before {
  content: "\\e830";
} /* '' */
.uil-annoyed:before {
  content: "\\e831";
} /* '' */
.uil-apple:before {
  content: "\\e832";
} /* '' */
.uil-apps:before {
  content: "\\e833";
} /* '' */
.uil-archive-alt:before {
  content: "\\e834";
} /* '' */
.uil-archive:before {
  content: "\\e835";
} /* '' */
.uil-archway:before {
  content: "\\e836";
} /* '' */
.uil-arrow-break:before {
  content: "\\e837";
} /* '' */
.uil-arrow-circle-down:before {
  content: "\\e838";
} /* '' */
.uil-arrow-circle-left:before {
  content: "\\e839";
} /* '' */
.uil-arrow-circle-right:before {
  content: "\\e83a";
} /* '' */
.uil-arrow-circle-up:before {
  content: "\\e83b";
} /* '' */
.uil-arrow-compress-h:before {
  content: "\\e83c";
} /* '' */
.uil-arrow-down-left:before {
  content: "\\e83d";
} /* '' */
.uil-arrow-down-right:before {
  content: "\\e83e";
} /* '' */
.uil-arrow-down:before {
  content: "\\e83f";
} /* '' */
.uil-arrow-from-right:before {
  content: "\\e840";
} /* '' */
.uil-arrow-from-top:before {
  content: "\\e841";
} /* '' */
.uil-arrow-growth:before {
  content: "\\e842";
} /* '' */
.uil-arrow-left:before {
  content: "\\e843";
} /* '' */
.uil-arrow-random:before {
  content: "\\e844";
} /* '' */
.uil-arrow-resize-diagonal:before {
  content: "\\e845";
} /* '' */
.uil-arrow-right:before {
  content: "\\e846";
} /* '' */
.uil-arrow-to-bottom:before {
  content: "\\e847";
} /* '' */
.uil-arrow-to-right:before {
  content: "\\e848";
} /* '' */
.uil-arrow-up-left:before {
  content: "\\e849";
} /* '' */
.uil-arrow-up-right:before {
  content: "\\e84a";
} /* '' */
.uil-arrow-up:before {
  content: "\\e84b";
} /* '' */
.uil-arrows-h-alt:before {
  content: "\\e84c";
} /* '' */
.uil-arrows-h:before {
  content: "\\e84d";
} /* '' */
.uil-arrows-left-down:before {
  content: "\\e84e";
} /* '' */
.uil-arrows-maximize:before {
  content: "\\e84f";
} /* '' */
.uil-arrows-merge:before {
  content: "\\e850";
} /* '' */
.uil-arrows-resize-h:before {
  content: "\\e851";
} /* '' */
.uil-arrows-resize-v:before {
  content: "\\e852";
} /* '' */
.uil-arrows-resize:before {
  content: "\\e853";
} /* '' */
.uil-arrows-right-down:before {
  content: "\\e854";
} /* '' */
.uil-arrows-shrink-h:before {
  content: "\\e855";
} /* '' */
.uil-arrows-shrink-v:before {
  content: "\\e856";
} /* '' */
.uil-arrows-up-right:before {
  content: "\\e857";
} /* '' */
.uil-arrows-v-alt:before {
  content: "\\e858";
} /* '' */
.uil-arrows-v:before {
  content: "\\e859";
} /* '' */
.uil-assistive-listening-systems:before {
  content: "\\e85a";
} /* '' */
.uil-asterisk:before {
  content: "\\e85b";
} /* '' */
.uil-at:before {
  content: "\\e85c";
} /* '' */
.uil-atm-card:before {
  content: "\\e85d";
} /* '' */
.uil-atom:before {
  content: "\\e85e";
} /* '' */
.uil-auto-flash:before {
  content: "\\e85f";
} /* '' */
.uil-award-alt:before {
  content: "\\e860";
} /* '' */
.uil-award:before {
  content: "\\e861";
} /* '' */
.uil-baby-carriage:before {
  content: "\\e862";
} /* '' */
.uil-backpack:before {
  content: "\\e863";
} /* '' */
.uil-backspace:before {
  content: "\\e864";
} /* '' */
.uil-backward:before {
  content: "\\e865";
} /* '' */
.uil-bag-alt:before {
  content: "\\e866";
} /* '' */
.uil-bag-slash:before {
  content: "\\e867";
} /* '' */
.uil-bag:before {
  content: "\\e868";
} /* '' */
.uil-balance-scale:before {
  content: "\\e869";
} /* '' */
.uil-ball:before {
  content: "\\e86a";
} /* '' */
.uil-ban:before {
  content: "\\e86b";
} /* '' */
.uil-bars:before {
  content: "\\e86c";
} /* '' */
.uil-basketball-hoop:before {
  content: "\\e86d";
} /* '' */
.uil-basketball:before {
  content: "\\e86e";
} /* '' */
.uil-battery-bolt:before {
  content: "\\e86f";
} /* '' */
.uil-battery-empty:before {
  content: "\\e870";
} /* '' */
.uil-bed-double:before {
  content: "\\e871";
} /* '' */
.uil-bed:before {
  content: "\\e872";
} /* '' */
.uil-behance:before {
  content: "\\e873";
} /* '' */
.uil-bell-school:before {
  content: "\\e874";
} /* '' */
.uil-bell-slash:before {
  content: "\\e875";
} /* '' */
.uil-bell:before {
  content: "\\e876";
} /* '' */
.uil-bill:before {
  content: "\\e877";
} /* '' */
.uil-bitcoin-circle:before {
  content: "\\e878";
} /* '' */
.uil-bitcoin:before {
  content: "\\e879";
} /* '' */
.uil-black-berry:before {
  content: "\\e87a";
} /* '' */
.uil-bluetooth-b:before {
  content: "\\e87b";
} /* '' */
.uil-bold:before {
  content: "\\e87c";
} /* '' */
.uil-bolt-alt:before {
  content: "\\e87d";
} /* '' */
.uil-bolt-slash:before {
  content: "\\e87e";
} /* '' */
.uil-bolt:before {
  content: "\\e87f";
} /* '' */
.uil-book-alt:before {
  content: "\\e880";
} /* '' */
.uil-book-medical:before {
  content: "\\e881";
} /* '' */
.uil-book-open:before {
  content: "\\e882";
} /* '' */
.uil-book-reader:before {
  content: "\\e883";
} /* '' */
.uil-book:before {
  content: "\\e884";
} /* '' */
.uil-bookmark-full:before {
  content: "\\e885";
} /* '' */
.uil-bookmark:before {
  content: "\\e886";
} /* '' */
.uil-books:before {
  content: "\\e887";
} /* '' */
.uil-boombox:before {
  content: "\\e888";
} /* '' */
.uil-border-alt:before {
  content: "\\e889";
} /* '' */
.uil-border-bottom:before {
  content: "\\e88a";
} /* '' */
.uil-border-clear:before {
  content: "\\e88b";
} /* '' */
.uil-border-horizontal:before {
  content: "\\e88c";
} /* '' */
.uil-border-inner:before {
  content: "\\e88d";
} /* '' */
.uil-border-left:before {
  content: "\\e88e";
} /* '' */
.uil-border-out:before {
  content: "\\e88f";
} /* '' */
.uil-border-right:before {
  content: "\\e890";
} /* '' */
.uil-border-top:before {
  content: "\\e891";
} /* '' */
.uil-border-vertical:before {
  content: "\\e892";
} /* '' */
.uil-box:before {
  content: "\\e893";
} /* '' */
.uil-briefcase-alt:before {
  content: "\\e894";
} /* '' */
.uil-briefcase:before {
  content: "\\e895";
} /* '' */
.uil-bright:before {
  content: "\\e896";
} /* '' */
.uil-brightness-empty:before {
  content: "\\e897";
} /* '' */
.uil-brightness-half:before {
  content: "\\e898";
} /* '' */
.uil-brightness-low:before {
  content: "\\e899";
} /* '' */
.uil-brightness-minus:before {
  content: "\\e89a";
} /* '' */
.uil-brightness-plus:before {
  content: "\\e89b";
} /* '' */
.uil-brightness:before {
  content: "\\e89c";
} /* '' */
.uil-bring-bottom:before {
  content: "\\e89d";
} /* '' */
.uil-bring-front:before {
  content: "\\e89e";
} /* '' */
.uil-brush-alt:before {
  content: "\\e89f";
} /* '' */
.uil-bug:before {
  content: "\\e8a0";
} /* '' */
.uil-building:before {
  content: "\\e8a1";
} /* '' */
.uil-bullseye:before {
  content: "\\e8a2";
} /* '' */
.uil-bus-alt:before {
  content: "\\e8a3";
} /* '' */
.uil-bus-school:before {
  content: "\\e8a4";
} /* '' */
.uil-bus:before {
  content: "\\e8a5";
} /* '' */
.uil-calcualtor:before {
  content: "\\e8a6";
} /* '' */
.uil-calculator-alt:before {
  content: "\\e8a7";
} /* '' */
.uil-calendar-alt:before {
  content: "\\e8a8";
} /* '' */
.uil-calendar-slash:before {
  content: "\\e8a9";
} /* '' */
.uil-calender:before {
  content: "\\e8aa";
} /* '' */
.uil-calling:before {
  content: "\\e8ab";
} /* '' */
.uil-camera-change:before {
  content: "\\e8ac";
} /* '' */
.uil-camera-plus:before {
  content: "\\e8ad";
} /* '' */
.uil-camera-slash:before {
  content: "\\e8ae";
} /* '' */
.uil-camera:before {
  content: "\\e8af";
} /* '' */
.uil-cancel:before {
  content: "\\e8b0";
} /* '' */
.uil-capsule:before {
  content: "\\e8b1";
} /* '' */
.uil-capture:before {
  content: "\\e8b2";
} /* '' */
.uil-car-sideview:before {
  content: "\\e8b3";
} /* '' */
.uil-car-slash:before {
  content: "\\e8b4";
} /* '' */
.uil-car-wash:before {
  content: "\\e8b5";
} /* '' */
.uil-car:before {
  content: "\\e8b6";
} /* '' */
.uil-card-atm:before {
  content: "\\e8b7";
} /* '' */
.uil-caret-right:before {
  content: "\\e8b8";
} /* '' */
.uil-cart:before {
  content: "\\e8b9";
} /* '' */
.uil-cell:before {
  content: "\\e8ba";
} /* '' */
.uil-celsius:before {
  content: "\\e8bb";
} /* '' */
.uil-chart-bar-alt:before {
  content: "\\e8bc";
} /* '' */
.uil-chart-bar:before {
  content: "\\e8bd";
} /* '' */
.uil-chart-down:before {
  content: "\\e8be";
} /* '' */
.uil-chart-growth-alt:before {
  content: "\\e8bf";
} /* '' */
.uil-chart-growth:before {
  content: "\\e8c0";
} /* '' */
.uil-chart-line:before {
  content: "\\e8c1";
} /* '' */
.uil-chart-pie-alt:before {
  content: "\\e8c2";
} /* '' */
.uil-chart-pie:before {
  content: "\\e8c3";
} /* '' */
.uil-chart:before {
  content: "\\e8c4";
} /* '' */
.uil-chat-bubble-user:before {
  content: "\\e8c5";
} /* '' */
.uil-chat-info:before {
  content: "\\e8c6";
} /* '' */
.uil-chat:before {
  content: "\\e8c7";
} /* '' */
.uil-check-circle:before {
  content: "\\e8c8";
} /* '' */
.uil-check-square:before {
  content: "\\e8c9";
} /* '' */
.uil-check:before {
  content: "\\e8ca";
} /* '' */
.uil-circle-layer:before {
  content: "\\e8cb";
} /* '' */
.uil-circle:before {
  content: "\\e8cc";
} /* '' */
.uil-circuit:before {
  content: "\\e8cd";
} /* '' */
.uil-clapper-board:before {
  content: "\\e8ce";
} /* '' */
.uil-clipboard-alt:before {
  content: "\\e8cf";
} /* '' */
.uil-clipboard-blank:before {
  content: "\\e8d0";
} /* '' */
.uil-clipboard-notes:before {
  content: "\\e8d1";
} /* '' */
.uil-clipboard:before {
  content: "\\e8d2";
} /* '' */
.uil-clock-eight:before {
  content: "\\e8d3";
} /* '' */
.uil-clock-five:before {
  content: "\\e8d4";
} /* '' */
.uil-clock-nine:before {
  content: "\\e8d5";
} /* '' */
.uil-clock-seven:before {
  content: "\\e8d6";
} /* '' */
.uil-clock-ten:before {
  content: "\\e8d7";
} /* '' */
.uil-clock-three:before {
  content: "\\e8d8";
} /* '' */
.uil-clock-two:before {
  content: "\\e8d9";
} /* '' */
.uil-clock:before {
  content: "\\e8da";
} /* '' */
.uil-closed-captioning:before {
  content: "\\e8db";
} /* '' */
.uil-cloud-block:before {
  content: "\\e8dc";
} /* '' */
.uil-cloud-bookmark:before {
  content: "\\e8dd";
} /* '' */
.uil-cloud-check:before {
  content: "\\e8de";
} /* '' */
.uil-cloud-computing:before {
  content: "\\e8df";
} /* '' */
.uil-cloud-data-connection:before {
  content: "\\e8e0";
} /* '' */
.uil-cloud-database-tree:before {
  content: "\\e8e1";
} /* '' */
.uil-cloud-download:before {
  content: "\\e8e2";
} /* '' */
.uil-cloud-drizzle:before {
  content: "\\e8e3";
} /* '' */
.uil-cloud-exclamation:before {
  content: "\\e8e4";
} /* '' */
.uil-cloud-hail:before {
  content: "\\e8e5";
} /* '' */
.uil-cloud-heart:before {
  content: "\\e8e6";
} /* '' */
.uil-cloud-info:before {
  content: "\\e8e7";
} /* '' */
.uil-cloud-lock:before {
  content: "\\e8e8";
} /* '' */
.uil-cloud-meatball:before {
  content: "\\e8e9";
} /* '' */
.uil-cloud-moon-hail:before {
  content: "\\e8ea";
} /* '' */
.uil-cloud-moon-meatball:before {
  content: "\\e8eb";
} /* '' */
.uil-cloud-moon-rain:before {
  content: "\\e8ec";
} /* '' */
.uil-cloud-moon-showers:before {
  content: "\\e8ed";
} /* '' */
.uil-cloud-moon:before {
  content: "\\e8ee";
} /* '' */
.uil-cloud-question:before {
  content: "\\e8ef";
} /* '' */
.uil-cloud-rain-sun:before {
  content: "\\e8f0";
} /* '' */
.uil-cloud-rain:before {
  content: "\\e8f1";
} /* '' */
.uil-cloud-redo:before {
  content: "\\e8f2";
} /* '' */
.uil-cloud-set:before {
  content: "\\e8f3";
} /* '' */
.uil-cloud-share:before {
  content: "\\e8f4";
} /* '' */
.uil-cloud-shield:before {
  content: "\\e8f5";
} /* '' */
.uil-cloud-showers-alt:before {
  content: "\\e8f6";
} /* '' */
.uil-cloud-showers-heavy:before {
  content: "\\e8f7";
} /* '' */
.uil-cloud-showers:before {
  content: "\\e8f8";
} /* '' */
.uil-cloud-slash:before {
  content: "\\e8f9";
} /* '' */
.uil-cloud-sun-hail:before {
  content: "\\e8fa";
} /* '' */
.uil-cloud-sun-meatball:before {
  content: "\\e8fb";
} /* '' */
.uil-cloud-sun-rain-alt:before {
  content: "\\e8fc";
} /* '' */
.uil-cloud-sun-rain:before {
  content: "\\e8fd";
} /* '' */
.uil-cloud-sun-tear:before {
  content: "\\e8fe";
} /* '' */
.uil-cloud-sun:before {
  content: "\\e8ff";
} /* '' */
.uil-cloud-times:before {
  content: "\\e900";
} /* '' */
.uil-cloud-unlock:before {
  content: "\\e901";
} /* '' */
.uil-cloud-upload:before {
  content: "\\e902";
} /* '' */
.uil-cloud-wifi:before {
  content: "\\e903";
} /* '' */
.uil-cloud-wind:before {
  content: "\\e904";
} /* '' */
.uil-cloud:before {
  content: "\\e905";
} /* '' */
.uil-clouds:before {
  content: "\\e906";
} /* '' */
.uil-club:before {
  content: "\\e907";
} /* '' */
.uil-code:before {
  content: "\\e908";
} /* '' */
.uil-coffee:before {
  content: "\\e909";
} /* '' */
.uil-cog:before {
  content: "\\e90a";
} /* '' */
.uil-coins:before {
  content: "\\e90b";
} /* '' */
.uil-columns:before {
  content: "\\e90c";
} /* '' */
.uil-comment-alt-block:before {
  content: "\\e90d";
} /* '' */
.uil-comment-alt-chart-lines:before {
  content: "\\e90e";
} /* '' */
.uil-comment-alt-check:before {
  content: "\\e90f";
} /* '' */
.uil-comment-alt-dots:before {
  content: "\\e910";
} /* '' */
.uil-comment-alt-download:before {
  content: "\\e911";
} /* '' */
.uil-comment-alt-edit:before {
  content: "\\e912";
} /* '' */
.uil-comment-alt-exclamation:before {
  content: "\\e913";
} /* '' */
.uil-comment-alt-heart:before {
  content: "\\e914";
} /* '' */
.uil-comment-alt-image:before {
  content: "\\e915";
} /* '' */
.uil-comment-alt-info:before {
  content: "\\e916";
} /* '' */
.uil-comment-alt-lines:before {
  content: "\\e917";
} /* '' */
.uil-comment-alt-lock:before {
  content: "\\e918";
} /* '' */
.uil-comment-alt-medical:before {
  content: "\\e919";
} /* '' */
.uil-comment-alt-message:before {
  content: "\\e91a";
} /* '' */
.uil-comment-alt-notes:before {
  content: "\\e91b";
} /* '' */
.uil-comment-alt-plus:before {
  content: "\\e91c";
} /* '' */
.uil-comment-alt-question:before {
  content: "\\e91d";
} /* '' */
.uil-comment-alt-redo:before {
  content: "\\e91e";
} /* '' */
.uil-comment-alt-search:before {
  content: "\\e91f";
} /* '' */
.uil-comment-alt-share:before {
  content: "\\e920";
} /* '' */
.uil-comment-alt-shield:before {
  content: "\\e921";
} /* '' */
.uil-comment-alt-slash:before {
  content: "\\e922";
} /* '' */
.uil-comment-alt-upload:before {
  content: "\\e923";
} /* '' */
.uil-comment-alt-verify:before {
  content: "\\e924";
} /* '' */
.uil-comment-alt:before {
  content: "\\e925";
} /* '' */
.uil-comment-block:before {
  content: "\\e926";
} /* '' */
.uil-comment-chart-line:before {
  content: "\\e927";
} /* '' */
.uil-comment-check:before {
  content: "\\e928";
} /* '' */
.uil-comment-dots:before {
  content: "\\e929";
} /* '' */
.uil-comment-download:before {
  content: "\\e92a";
} /* '' */
.uil-comment-edit:before {
  content: "\\e92b";
} /* '' */
.uil-comment-exclamation:before {
  content: "\\e92c";
} /* '' */
.uil-comment-heart:before {
  content: "\\e92d";
} /* '' */
.uil-comment-image:before {
  content: "\\e92e";
} /* '' */
.uil-comment-info-alt:before {
  content: "\\e92f";
} /* '' */
.uil-comment-info:before {
  content: "\\e930";
} /* '' */
.uil-comment-lines:before {
  content: "\\e931";
} /* '' */
.uil-comment-lock:before {
  content: "\\e932";
} /* '' */
.uil-comment-medical:before {
  content: "\\e933";
} /* '' */
.uil-comment-message:before {
  content: "\\e934";
} /* '' */
.uil-comment-notes:before {
  content: "\\e935";
} /* '' */
.uil-comment-plus:before {
  content: "\\e936";
} /* '' */
.uil-comment-question:before {
  content: "\\e937";
} /* '' */
.uil-comment-redo:before {
  content: "\\e938";
} /* '' */
.uil-comment-search:before {
  content: "\\e939";
} /* '' */
.uil-comment-share:before {
  content: "\\e93a";
} /* '' */
.uil-comment-shield:before {
  content: "\\e93b";
} /* '' */
.uil-comment-slash:before {
  content: "\\e93c";
} /* '' */
.uil-comment-upload:before {
  content: "\\e93d";
} /* '' */
.uil-comment-verify:before {
  content: "\\e93e";
} /* '' */
.uil-comment:before {
  content: "\\e93f";
} /* '' */
.uil-comments-alt:before {
  content: "\\e940";
} /* '' */
.uil-comments:before {
  content: "\\e941";
} /* '' */
.uil-commnet-alt-slash:before {
  content: "\\e942";
} /* '' */
.uil-compact-disc:before {
  content: "\\e943";
} /* '' */
.uil-compass:before {
  content: "\\e944";
} /* '' */
.uil-compress-alt-left:before {
  content: "\\e945";
} /* '' */
.uil-compress-alt:before {
  content: "\\e946";
} /* '' */
.uil-compress-arrows:before {
  content: "\\e947";
} /* '' */
.uil-compress-lines:before {
  content: "\\e948";
} /* '' */
.uil-compress-point:before {
  content: "\\e949";
} /* '' */
.uil-compress-v:before {
  content: "\\e94a";
} /* '' */
.uil-compress:before {
  content: "\\e94b";
} /* '' */
.uil-computer-mouse:before {
  content: "\\e94c";
} /* '' */
.uil-confused:before {
  content: "\\e94d";
} /* '' */
.uil-constructor:before {
  content: "\\e94e";
} /* '' */
.uil-copy-alt:before {
  content: "\\e94f";
} /* '' */
.uil-copy-landscape:before {
  content: "\\e950";
} /* '' */
.uil-copy:before {
  content: "\\e951";
} /* '' */
.uil-copyright:before {
  content: "\\e952";
} /* '' */
.uil-corner-down-left:before {
  content: "\\e953";
} /* '' */
.uil-corner-down-right-alt:before {
  content: "\\e954";
} /* '' */
.uil-corner-down-right:before {
  content: "\\e955";
} /* '' */
.uil-corner-left-down:before {
  content: "\\e956";
} /* '' */
.uil-corner-right-down:before {
  content: "\\e957";
} /* '' */
.uil-corner-up-left-alt:before {
  content: "\\e958";
} /* '' */
.uil-corner-up-left:before {
  content: "\\e959";
} /* '' */
.uil-corner-up-right-alt:before {
  content: "\\e95a";
} /* '' */
.uil-corner-up-right:before {
  content: "\\e95b";
} /* '' */
.uil-creative-commons-pd-alt:before {
  content: "\\e95c";
} /* '' */
.uil-creative-commons-pd:before {
  content: "\\e95d";
} /* '' */
.uil-crockery:before {
  content: "\\e95e";
} /* '' */
.uil-crop-alt-rotate-left:before {
  content: "\\e95f";
} /* '' */
.uil-crop-alt-rotate-right:before {
  content: "\\e960";
} /* '' */
.uil-crop-alt:before {
  content: "\\e961";
} /* '' */
.uil-crosshair-alt:before {
  content: "\\e962";
} /* '' */
.uil-crosshair:before {
  content: "\\e963";
} /* '' */
.uil-crosshairs:before {
  content: "\\e964";
} /* '' */
.uil-cube:before {
  content: "\\e965";
} /* '' */
.uil-dashboard:before {
  content: "\\e966";
} /* '' */
.uil-data-sharing:before {
  content: "\\e967";
} /* '' */
.uil-database-alt:before {
  content: "\\e968";
} /* '' */
.uil-database:before {
  content: "\\e969";
} /* '' */
.uil-desert:before {
  content: "\\e96a";
} /* '' */
.uil-desktop-alt-slash:before {
  content: "\\e96b";
} /* '' */
.uil-desktop-alt:before {
  content: "\\e96c";
} /* '' */
.uil-desktop-cloud-alt:before {
  content: "\\e96d";
} /* '' */
.uil-desktop-slash:before {
  content: "\\e96e";
} /* '' */
.uil-desktop:before {
  content: "\\e96f";
} /* '' */
.uil-dialpad-alt:before {
  content: "\\e970";
} /* '' */
.uil-dialpad:before {
  content: "\\e971";
} /* '' */
.uil-diamond:before {
  content: "\\e972";
} /* '' */
.uil-diary-alt:before {
  content: "\\e973";
} /* '' */
.uil-diary:before {
  content: "\\e974";
} /* '' */
.uil-dice-five:before {
  content: "\\e975";
} /* '' */
.uil-dice-four:before {
  content: "\\e976";
} /* '' */
.uil-dice-one:before {
  content: "\\e977";
} /* '' */
.uil-dice-six:before {
  content: "\\e978";
} /* '' */
.uil-dice-three:before {
  content: "\\e979";
} /* '' */
.uil-dice-two:before {
  content: "\\e97a";
} /* '' */
.uil-direction:before {
  content: "\\e97b";
} /* '' */
.uil-directions:before {
  content: "\\e97c";
} /* '' */
.uil-dizzy-meh:before {
  content: "\\e97d";
} /* '' */
.uil-dna:before {
  content: "\\e97e";
} /* '' */
.uil-document-layout-center:before {
  content: "\\e97f";
} /* '' */
.uil-document-layout-left:before {
  content: "\\e980";
} /* '' */
.uil-document-layout-right:before {
  content: "\\e981";
} /* '' */
.uil-document:before {
  content: "\\e982";
} /* '' */
.uil-dollar-alt:before {
  content: "\\e983";
} /* '' */
.uil-dollar-sign-alt:before {
  content: "\\e984";
} /* '' */
.uil-dollar-sign:before {
  content: "\\e985";
} /* '' */
.uil-down-arrow:before {
  content: "\\e986";
} /* '' */
.uil-download-alt:before {
  content: "\\e987";
} /* '' */
.uil-dribbble:before {
  content: "\\e988";
} /* '' */
.uil-drill:before {
  content: "\\e989";
} /* '' */
.uil-dropbox:before {
  content: "\\e98a";
} /* '' */
.uil-dumbbell:before {
  content: "\\e98b";
} /* '' */
.uil-ear:before {
  content: "\\e98c";
} /* '' */
.uil-edit-alt:before {
  content: "\\e98d";
} /* '' */
.uil-edit:before {
  content: "\\e98e";
} /* '' */
.uil-ellipsis-h:before {
  content: "\\e98f";
} /* '' */
.uil-ellipsis-v:before {
  content: "\\e990";
} /* '' */
.uil-emoji:before {
  content: "\\e991";
} /* '' */
.uil-enter:before {
  content: "\\e992";
} /* '' */
.uil-entry:before {
  content: "\\e993";
} /* '' */
.uil-envelope-add:before {
  content: "\\e994";
} /* '' */
.uil-envelope-alt:before {
  content: "\\e995";
} /* '' */
.uil-envelope-block:before {
  content: "\\e996";
} /* '' */
.uil-envelope-bookmark:before {
  content: "\\e997";
} /* '' */
.uil-envelope-check:before {
  content: "\\e998";
} /* '' */
.uil-envelope-download-alt:before {
  content: "\\e999";
} /* '' */
.uil-envelope-download:before {
  content: "\\e99a";
} /* '' */
.uil-envelope-edit:before {
  content: "\\e99b";
} /* '' */
.uil-envelope-exclamation:before {
  content: "\\e99c";
} /* '' */
.uil-envelope-heart:before {
  content: "\\e99d";
} /* '' */
.uil-envelope-info:before {
  content: "\\e99e";
} /* '' */
.uil-envelope-lock:before {
  content: "\\e99f";
} /* '' */
.uil-envelope-minus:before {
  content: "\\e9a0";
} /* '' */
.uil-envelope-open:before {
  content: "\\e9a1";
} /* '' */
.uil-envelope-question:before {
  content: "\\e9a2";
} /* '' */
.uil-envelope-receive:before {
  content: "\\e9a3";
} /* '' */
.uil-envelope-redo:before {
  content: "\\e9a4";
} /* '' */
.uil-envelope-search:before {
  content: "\\e9a5";
} /* '' */
.uil-envelope-send:before {
  content: "\\e9a6";
} /* '' */
.uil-envelope-share:before {
  content: "\\e9a7";
} /* '' */
.uil-envelope-shield:before {
  content: "\\e9a8";
} /* '' */
.uil-envelope-star:before {
  content: "\\e9a9";
} /* '' */
.uil-envelope-times:before {
  content: "\\e9aa";
} /* '' */
.uil-envelope-upload-alt:before {
  content: "\\e9ab";
} /* '' */
.uil-envelope-upload:before {
  content: "\\e9ac";
} /* '' */
.uil-envelope:before {
  content: "\\e9ad";
} /* '' */
.uil-envelopes:before {
  content: "\\e9ae";
} /* '' */
.uil-equal-circle:before {
  content: "\\e9af";
} /* '' */
.uil-euro-circle:before {
  content: "\\e9b0";
} /* '' */
.uil-euro:before {
  content: "\\e9b1";
} /* '' */
.uil-exchange-alt:before {
  content: "\\e9b2";
} /* '' */
.uil-exchange:before {
  content: "\\e9b3";
} /* '' */
.uil-exclamation-circle:before {
  content: "\\e9b4";
} /* '' */
.uil-exclamation-octagon:before {
  content: "\\e9b5";
} /* '' */
.uil-exclamation-triangle:before {
  content: "\\e9b6";
} /* '' */
.uil-exclude:before {
  content: "\\e9b7";
} /* '' */
.uil-exit:before {
  content: "\\e9b8";
} /* '' */
.uil-expand-alt:before {
  content: "\\e9b9";
} /* '' */
.uil-expand-arrows-alt:before {
  content: "\\e9ba";
} /* '' */
.uil-expand-arrows:before {
  content: "\\e9bb";
} /* '' */
.uil-expand-from-corner:before {
  content: "\\e9bc";
} /* '' */
.uil-expand-left:before {
  content: "\\e9bd";
} /* '' */
.uil-expand-right:before {
  content: "\\e9be";
} /* '' */
.uil-export:before {
  content: "\\e9bf";
} /* '' */
.uil-exposure-alt:before {
  content: "\\e9c0";
} /* '' */
.uil-exposure-increase:before {
  content: "\\e9c1";
} /* '' */
.uil-external-link-alt:before {
  content: "\\e9c2";
} /* '' */
.uil-eye-slash:before {
  content: "\\e9c3";
} /* '' */
.uil-eye:before {
  content: "\\e9c4";
} /* '' */
.uil-facebook-f:before {
  content: "\\e9c5";
} /* '' */
.uil-facebook-messenger:before {
  content: "\\e9c6";
} /* '' */
.uil-facebook:before {
  content: "\\e9c7";
} /* '' */
.uil-fahrenheit:before {
  content: "\\e9c8";
} /* '' */
.uil-fast-mail-alt:before {
  content: "\\e9c9";
} /* '' */
.uil-fast-mail:before {
  content: "\\e9ca";
} /* '' */
.uil-favorite:before {
  content: "\\e9cb";
} /* '' */
.uil-feedback:before {
  content: "\\e9cc";
} /* '' */
.uil-file-alt:before {
  content: "\\e9cd";
} /* '' */
.uil-file-blank:before {
  content: "\\e9ce";
} /* '' */
.uil-file-block-alt:before {
  content: "\\e9cf";
} /* '' */
.uil-file-bookmark-alt:before {
  content: "\\e9d0";
} /* '' */
.uil-file-check-alt:before {
  content: "\\e9d1";
} /* '' */
.uil-file-check:before {
  content: "\\e9d2";
} /* '' */
.uil-file-contract-dollar:before {
  content: "\\e9d3";
} /* '' */
.uil-file-copy-alt:before {
  content: "\\e9d4";
} /* '' */
.uil-file-download-alt:before {
  content: "\\e9d5";
} /* '' */
.uil-file-download:before {
  content: "\\e9d6";
} /* '' */
.uil-file-edit-alt:before {
  content: "\\e9d7";
} /* '' */
.uil-file-exclamation-alt:before {
  content: "\\e9d8";
} /* '' */
.uil-file-exclamation:before {
  content: "\\e9d9";
} /* '' */
.uil-file-heart:before {
  content: "\\e9da";
} /* '' */
.uil-file-info-alt:before {
  content: "\\e9db";
} /* '' */
.uil-file-landscape-alt:before {
  content: "\\e9dc";
} /* '' */
.uil-file-landscape:before {
  content: "\\e9dd";
} /* '' */
.uil-file-lanscape-slash:before {
  content: "\\e9de";
} /* '' */
.uil-file-lock-alt:before {
  content: "\\e9df";
} /* '' */
.uil-file-medical-alt:before {
  content: "\\e9e0";
} /* '' */
.uil-file-medical:before {
  content: "\\e9e1";
} /* '' */
.uil-file-minus-alt:before {
  content: "\\e9e2";
} /* '' */
.uil-file-minus:before {
  content: "\\e9e3";
} /* '' */
.uil-file-network:before {
  content: "\\e9e4";
} /* '' */
.uil-file-plus-alt:before {
  content: "\\e9e5";
} /* '' */
.uil-file-plus:before {
  content: "\\e9e6";
} /* '' */
.uil-file-question-alt:before {
  content: "\\e9e7";
} /* '' */
.uil-file-question:before {
  content: "\\e9e8";
} /* '' */
.uil-file-redo-alt:before {
  content: "\\e9e9";
} /* '' */
.uil-file-search-alt:before {
  content: "\\e9ea";
} /* '' */
.uil-file-share-alt:before {
  content: "\\e9eb";
} /* '' */
.uil-file-shield-alt:before {
  content: "\\e9ec";
} /* '' */
.uil-file-slash:before {
  content: "\\e9ed";
} /* '' */
.uil-file-times-alt:before {
  content: "\\e9ee";
} /* '' */
.uil-file-times:before {
  content: "\\e9ef";
} /* '' */
.uil-file-upload-alt:before {
  content: "\\e9f0";
} /* '' */
.uil-file-upload:before {
  content: "\\e9f1";
} /* '' */
.uil-file:before {
  content: "\\e9f2";
} /* '' */
.uil-files-landscapes-alt:before {
  content: "\\e9f3";
} /* '' */
.uil-files-landscapes:before {
  content: "\\e9f4";
} /* '' */
.uil-film:before {
  content: "\\e9f5";
} /* '' */
.uil-filter-slash:before {
  content: "\\e9f6";
} /* '' */
.uil-filter:before {
  content: "\\e9f7";
} /* '' */
.uil-flask-potion:before {
  content: "\\e9f8";
} /* '' */
.uil-flask:before {
  content: "\\e9f9";
} /* '' */
.uil-flip-h-alt:before {
  content: "\\e9fa";
} /* '' */
.uil-flip-h:before {
  content: "\\e9fb";
} /* '' */
.uil-flip-v-alt:before {
  content: "\\e9fc";
} /* '' */
.uil-flip-v:before {
  content: "\\e9fd";
} /* '' */
.uil-flower:before {
  content: "\\e9fe";
} /* '' */
.uil-focus-add:before {
  content: "\\e9ff";
} /* '' */
.uil-focus-target:before {
  content: "\\ea00";
} /* '' */
.uil-focus:before {
  content: "\\ea01";
} /* '' */
.uil-folder-check:before {
  content: "\\ea02";
} /* '' */
.uil-folder-download:before {
  content: "\\ea03";
} /* '' */
.uil-folder-exclamation:before {
  content: "\\ea04";
} /* '' */
.uil-folder-heart:before {
  content: "\\ea05";
} /* '' */
.uil-folder-info:before {
  content: "\\ea06";
} /* '' */
.uil-folder-lock:before {
  content: "\\ea07";
} /* '' */
.uil-folder-medical:before {
  content: "\\ea08";
} /* '' */
.uil-folder-minus:before {
  content: "\\ea09";
} /* '' */
.uil-folder-network:before {
  content: "\\ea0a";
} /* '' */
.uil-folder-plus:before {
  content: "\\ea0b";
} /* '' */
.uil-folder-question:before {
  content: "\\ea0c";
} /* '' */
.uil-folder-slash:before {
  content: "\\ea0d";
} /* '' */
.uil-folder-times:before {
  content: "\\ea0e";
} /* '' */
.uil-folder-upload:before {
  content: "\\ea0f";
} /* '' */
.uil-folder:before {
  content: "\\ea10";
} /* '' */
.uil-food:before {
  content: "\\ea11";
} /* '' */
.uil-football-american:before {
  content: "\\ea12";
} /* '' */
.uil-football-ball:before {
  content: "\\ea13";
} /* '' */
.uil-football:before {
  content: "\\ea14";
} /* '' */
.uil-forecastcloud-moon-tear:before {
  content: "\\ea15";
} /* '' */
.uil-forwaded-call:before {
  content: "\\ea16";
} /* '' */
.uil-forward:before {
  content: "\\ea17";
} /* '' */
.uil-frown:before {
  content: "\\ea18";
} /* '' */
.uil-game-structure:before {
  content: "\\ea19";
} /* '' */
.uil-game:before {
  content: "\\ea1a";
} /* '' */
.uil-gift:before {
  content: "\\ea1b";
} /* '' */
.uil-github-alt:before {
  content: "\\ea1c";
} /* '' */
.uil-github:before {
  content: "\\ea1d";
} /* '' */
.uil-glass-martini-alt-slash:before {
  content: "\\ea1e";
} /* '' */
.uil-glass-martini-alt:before {
  content: "\\ea1f";
} /* '' */
.uil-glass-martini:before {
  content: "\\ea20";
} /* '' */
.uil-glass-tea:before {
  content: "\\ea21";
} /* '' */
.uil-glass:before {
  content: "\\ea22";
} /* '' */
.uil-globe:before {
  content: "\\ea23";
} /* '' */
.uil-gold:before {
  content: "\\ea24";
} /* '' */
.uil-google-drive-alt:before {
  content: "\\ea25";
} /* '' */
.uil-google-drive:before {
  content: "\\ea26";
} /* '' */
.uil-google-hangouts:before {
  content: "\\ea27";
} /* '' */
.uil-google-play:before {
  content: "\\ea28";
} /* '' */
.uil-google:before {
  content: "\\ea29";
} /* '' */
.uil-graduation-hat:before {
  content: "\\ea2a";
} /* '' */
.uil-graph-bar:before {
  content: "\\ea2b";
} /* '' */
.uil-grid:before {
  content: "\\ea2c";
} /* '' */
.uil-grids:before {
  content: "\\ea2d";
} /* '' */
.uil-grin-tongue-wink-alt:before {
  content: "\\ea2e";
} /* '' */
.uil-grin-tongue-wink:before {
  content: "\\ea2f";
} /* '' */
.uil-grin:before {
  content: "\\ea30";
} /* '' */
.uil-grip-horizontal-line:before {
  content: "\\ea31";
} /* '' */
.uil-hdd:before {
  content: "\\ea32";
} /* '' */
.uil-headphones-alt:before {
  content: "\\ea33";
} /* '' */
.uil-headphones:before {
  content: "\\ea34";
} /* '' */
.uil-heart-alt:before {
  content: "\\ea35";
} /* '' */
.uil-heart-medical:before {
  content: "\\ea36";
} /* '' */
.uil-heart-rate:before {
  content: "\\ea37";
} /* '' */
.uil-heart-sign:before {
  content: "\\ea38";
} /* '' */
.uil-heart:before {
  content: "\\ea39";
} /* '' */
.uil-heartbeat:before {
  content: "\\ea3a";
} /* '' */
.uil-history-alt:before {
  content: "\\ea3b";
} /* '' */
.uil-history:before {
  content: "\\ea3c";
} /* '' */
.uil-home-alt:before {
  content: "\\ea3d";
} /* '' */
.uil-home:before {
  content: "\\ea3e";
} /* '' */
.uil-horizontal-align-center:before {
  content: "\\ea3f";
} /* '' */
.uil-horizontal-align-left:before {
  content: "\\ea40";
} /* '' */
.uil-horizontal-align-right:before {
  content: "\\ea41";
} /* '' */
.uil-horizontal-distribution-center:before {
  content: "\\ea42";
} /* '' */
.uil-horizontal-distribution-left:before {
  content: "\\ea43";
} /* '' */
.uil-horizontal-distribution-right:before {
  content: "\\ea44";
} /* '' */
.uil-hunting:before {
  content: "\\ea45";
} /* '' */
.uil-image-alt-slash:before {
  content: "\\ea46";
} /* '' */
.uil-image-block:before {
  content: "\\ea47";
} /* '' */
.uil-image-broken:before {
  content: "\\ea48";
} /* '' */
.uil-image-check:before {
  content: "\\ea49";
} /* '' */
.uil-image-download:before {
  content: "\\ea4a";
} /* '' */
.uil-image-edit:before {
  content: "\\ea4b";
} /* '' */
.uil-image-lock:before {
  content: "\\ea4c";
} /* '' */
.uil-image-minus:before {
  content: "\\ea4d";
} /* '' */
.uil-image-plus:before {
  content: "\\ea4e";
} /* '' */
.uil-image-question:before {
  content: "\\ea4f";
} /* '' */
.uil-image-redo:before {
  content: "\\ea50";
} /* '' */
.uil-image-resize-landscape:before {
  content: "\\ea51";
} /* '' */
.uil-image-resize-square:before {
  content: "\\ea52";
} /* '' */
.uil-image-search:before {
  content: "\\ea53";
} /* '' */
.uil-image-share:before {
  content: "\\ea54";
} /* '' */
.uil-image-shield:before {
  content: "\\ea55";
} /* '' */
.uil-image-slash:before {
  content: "\\ea56";
} /* '' */
.uil-image-times:before {
  content: "\\ea57";
} /* '' */
.uil-image-upload:before {
  content: "\\ea58";
} /* '' */
.uil-image-v:before {
  content: "\\ea59";
} /* '' */
.uil-image:before {
  content: "\\ea5a";
} /* '' */
.uil-images:before {
  content: "\\ea5b";
} /* '' */
.uil-incoming-call:before {
  content: "\\ea5c";
} /* '' */
.uil-info-circle:before {
  content: "\\ea5d";
} /* '' */
.uil-instagram-alt:before {
  content: "\\ea5e";
} /* '' */
.uil-instagram:before {
  content: "\\ea5f";
} /* '' */
.uil-intercom:before {
  content: "\\ea60";
} /* '' */
.uil-invoice:before {
  content: "\\ea61";
} /* '' */
.uil-italic:before {
  content: "\\ea62";
} /* '' */
.uil-jackhammer:before {
  content: "\\ea63";
} /* '' */
.uil-java-script:before {
  content: "\\ea64";
} /* '' */
.uil-kayak:before {
  content: "\\ea65";
} /* '' */
.uil-key-skeleton-alt:before {
  content: "\\ea66";
} /* '' */
.uil-key-skeleton:before {
  content: "\\ea67";
} /* '' */
.uil-keyboard-alt:before {
  content: "\\ea68";
} /* '' */
.uil-keyboard-hide:before {
  content: "\\ea69";
} /* '' */
.uil-keyboard-show:before {
  content: "\\ea6a";
} /* '' */
.uil-keyboard:before {
  content: "\\ea6b";
} /* '' */
.uil-keyhole-circle:before {
  content: "\\ea6c";
} /* '' */
.uil-keyhole-square-full:before {
  content: "\\ea6d";
} /* '' */
.uil-keyhole-square:before {
  content: "\\ea6e";
} /* '' */
.uil-kid:before {
  content: "\\ea6f";
} /* '' */
.uil-label-alt:before {
  content: "\\ea70";
} /* '' */
.uil-label:before {
  content: "\\ea71";
} /* '' */
.uil-lamp:before {
  content: "\\ea72";
} /* '' */
.uil-laptop-cloud:before {
  content: "\\ea73";
} /* '' */
.uil-laptop:before {
  content: "\\ea74";
} /* '' */
.uil-laughing:before {
  content: "\\ea75";
} /* '' */
.uil-layer-group-slash:before {
  content: "\\ea76";
} /* '' */
.uil-layer-group:before {
  content: "\\ea77";
} /* '' */
.uil-layers-alt:before {
  content: "\\ea78";
} /* '' */
.uil-layers-slash:before {
  content: "\\ea79";
} /* '' */
.uil-layers:before {
  content: "\\ea7a";
} /* '' */
.uil-left-arrow-from-left:before {
  content: "\\ea7b";
} /* '' */
.uil-left-arrow-to-left:before {
  content: "\\ea7c";
} /* '' */
.uil-left-indent-alt:before {
  content: "\\ea7d";
} /* '' */
.uil-left-indent:before {
  content: "\\ea7e";
} /* '' */
.uil-left-to-right-text-direction:before {
  content: "\\ea7f";
} /* '' */
.uil-life-ring:before {
  content: "\\ea80";
} /* '' */
.uil-lightbulb-alt:before {
  content: "\\ea81";
} /* '' */
.uil-lightbulb:before {
  content: "\\ea82";
} /* '' */
.uil-line-alt:before {
  content: "\\ea83";
} /* '' */
.uil-line-spacing:before {
  content: "\\ea84";
} /* '' */
.uil-line:before {
  content: "\\ea85";
} /* '' */
.uil-link-alt:before {
  content: "\\ea86";
} /* '' */
.uil-link-broken:before {
  content: "\\ea87";
} /* '' */
.uil-link-h:before {
  content: "\\ea88";
} /* '' */
.uil-link:before {
  content: "\\ea89";
} /* '' */
.uil-linkedin-alt:before {
  content: "\\ea8a";
} /* '' */
.uil-linkedin:before {
  content: "\\ea8b";
} /* '' */
.uil-list-ui-alt:before {
  content: "\\ea8c";
} /* '' */
.uil-list-ul:before {
  content: "\\ea8d";
} /* '' */
.uil-location-arrow-alt:before {
  content: "\\ea8e";
} /* '' */
.uil-location-arrow:before {
  content: "\\ea8f";
} /* '' */
.uil-location-pin-alt:before {
  content: "\\ea90";
} /* '' */
.uil-location-point:before {
  content: "\\ea91";
} /* '' */
.uil-location:before {
  content: "\\ea92";
} /* '' */
.uil-lock-access:before {
  content: "\\ea93";
} /* '' */
.uil-lock-alt:before {
  content: "\\ea94";
} /* '' */
.uil-lock-open-alt:before {
  content: "\\ea95";
} /* '' */
.uil-lock-slash:before {
  content: "\\ea96";
} /* '' */
.uil-lock:before {
  content: "\\ea97";
} /* '' */
.uil-mailbox-alt:before {
  content: "\\ea98";
} /* '' */
.uil-mailbox:before {
  content: "\\ea99";
} /* '' */
.uil-map-marker-alt:before {
  content: "\\ea9a";
} /* '' */
.uil-map-marker-edit:before {
  content: "\\ea9b";
} /* '' */
.uil-map-marker-info:before {
  content: "\\ea9c";
} /* '' */
.uil-map-marker-minus:before {
  content: "\\ea9d";
} /* '' */
.uil-map-marker-plus:before {
  content: "\\ea9e";
} /* '' */
.uil-map-marker-question:before {
  content: "\\ea9f";
} /* '' */
.uil-map-marker-shield:before {
  content: "\\eaa0";
} /* '' */
.uil-map-marker-slash:before {
  content: "\\eaa1";
} /* '' */
.uil-map-marker:before {
  content: "\\eaa2";
} /* '' */
.uil-map-pin-alt:before {
  content: "\\eaa3";
} /* '' */
.uil-map-pin:before {
  content: "\\eaa4";
} /* '' */
.uil-map:before {
  content: "\\eaa5";
} /* '' */
.uil-mars:before {
  content: "\\eaa6";
} /* '' */
.uil-maximize-left:before {
  content: "\\eaa7";
} /* '' */
.uil-medal:before {
  content: "\\eaa8";
} /* '' */
.uil-medical-drip:before {
  content: "\\eaa9";
} /* '' */
.uil-medical-square-full:before {
  content: "\\eaaa";
} /* '' */
.uil-medical-square:before {
  content: "\\eaab";
} /* '' */
.uil-medical:before {
  content: "\\eaac";
} /* '' */
.uil-medium-m:before {
  content: "\\eaad";
} /* '' */
.uil-medkit:before {
  content: "\\eaae";
} /* '' */
.uil-meeting-board:before {
  content: "\\eaaf";
} /* '' */
.uil-meh-alt:before {
  content: "\\eab0";
} /* '' */
.uil-meh-closed-eye:before {
  content: "\\eab1";
} /* '' */
.uil-meh:before {
  content: "\\eab2";
} /* '' */
.uil-message:before {
  content: "\\eab3";
} /* '' */
.uil-microphone-slash:before {
  content: "\\eab4";
} /* '' */
.uil-microphone:before {
  content: "\\eab5";
} /* '' */
.uil-minus-circle:before {
  content: "\\eab6";
} /* '' */
.uil-minus-path:before {
  content: "\\eab7";
} /* '' */
.uil-minus-square-full:before {
  content: "\\eab8";
} /* '' */
.uil-minus-square:before {
  content: "\\eab9";
} /* '' */
.uil-minus:before {
  content: "\\eaba";
} /* '' */
.uil-missed-call:before {
  content: "\\eabb";
} /* '' */
.uil-mobey-bill-slash:before {
  content: "\\eabc";
} /* '' */
.uil-mobile-android-alt:before {
  content: "\\eabd";
} /* '' */
.uil-mobile-android:before {
  content: "\\eabe";
} /* '' */
.uil-mobile-vibrate:before {
  content: "\\eabf";
} /* '' */
.uil-modem:before {
  content: "\\eac0";
} /* '' */
.uil-money-bill-stack:before {
  content: "\\eac1";
} /* '' */
.uil-money-bill:before {
  content: "\\eac2";
} /* '' */
.uil-money-insert:before {
  content: "\\eac3";
} /* '' */
.uil-money-stack:before {
  content: "\\eac4";
} /* '' */
.uil-money-withdraw:before {
  content: "\\eac5";
} /* '' */
.uil-money-withdrawal:before {
  content: "\\eac6";
} /* '' */
.uil-moneybag-alt:before {
  content: "\\eac7";
} /* '' */
.uil-moneybag:before {
  content: "\\eac8";
} /* '' */
.uil-monitor-heart-rate:before {
  content: "\\eac9";
} /* '' */
.uil-monitor:before {
  content: "\\eaca";
} /* '' */
.uil-moon-eclipse:before {
  content: "\\eacb";
} /* '' */
.uil-moon:before {
  content: "\\eacc";
} /* '' */
.uil-moonset:before {
  content: "\\eacd";
} /* '' */
.uil-mountains-sun:before {
  content: "\\eace";
} /* '' */
.uil-mountains:before {
  content: "\\eacf";
} /* '' */
.uil-mouse-alt:before {
  content: "\\ead0";
} /* '' */
.uil-mouse:before {
  content: "\\ead1";
} /* '' */
.uil-multiply:before {
  content: "\\ead2";
} /* '' */
.uil-music-note:before {
  content: "\\ead3";
} /* '' */
.uil-music-tune-slash:before {
  content: "\\ead4";
} /* '' */
.uil-music:before {
  content: "\\ead5";
} /* '' */
.uil-n-a:before {
  content: "\\ead6";
} /* '' */
.uil-navigator:before {
  content: "\\ead7";
} /* '' */
.uil-nerd:before {
  content: "\\ead8";
} /* '' */
.uil-newspaper:before {
  content: "\\ead9";
} /* '' */
.uil-ninja:before {
  content: "\\eada";
} /* '' */
.uil-no-entry:before {
  content: "\\eadb";
} /* '' */
.uil-notebooks:before {
  content: "\\eadc";
} /* '' */
.uil-notes:before {
  content: "\\eadd";
} /* '' */
.uil-object-group:before {
  content: "\\eade";
} /* '' */
.uil-object-ungroup:before {
  content: "\\eadf";
} /* '' */
.uil-octagon:before {
  content: "\\eae0";
} /* '' */
.uil-outgoing-call:before {
  content: "\\eae1";
} /* '' */
.uil-package:before {
  content: "\\eae2";
} /* '' */
.uil-padlock:before {
  content: "\\eae3";
} /* '' */
.uil-paint-tool:before {
  content: "\\eae4";
} /* '' */
.uil-palette:before {
  content: "\\eae5";
} /* '' */
.uil-panorama-h-alt:before {
  content: "\\eae6";
} /* '' */
.uil-panorama-h:before {
  content: "\\eae7";
} /* '' */
.uil-panorama-v:before {
  content: "\\eae8";
} /* '' */
.uil-paperclip:before {
  content: "\\eae9";
} /* '' */
.uil-paragraph:before {
  content: "\\eaea";
} /* '' */
.uil-parcel:before {
  content: "\\eaeb";
} /* '' */
.uil-parking-square:before {
  content: "\\eaec";
} /* '' */
.uil-pathfinder-unite:before {
  content: "\\eaed";
} /* '' */
.uil-pathfinder:before {
  content: "\\eaee";
} /* '' */
.uil-pause-circle:before {
  content: "\\eaef";
} /* '' */
.uil-pause:before {
  content: "\\eaf0";
} /* '' */
.uil-paypal:before {
  content: "\\eaf1";
} /* '' */
.uil-pen:before {
  content: "\\eaf2";
} /* '' */
.uil-pentagon:before {
  content: "\\eaf3";
} /* '' */
.uil-phone-alt:before {
  content: "\\eaf4";
} /* '' */
.uil-phone-pause:before {
  content: "\\eaf5";
} /* '' */
.uil-phone-slash:before {
  content: "\\eaf6";
} /* '' */
.uil-phone-times:before {
  content: "\\eaf7";
} /* '' */
.uil-phone-volume:before {
  content: "\\eaf8";
} /* '' */
.uil-phone:before {
  content: "\\eaf9";
} /* '' */
.uil-picture:before {
  content: "\\eafa";
} /* '' */
.uil-plane-arrival:before {
  content: "\\eafb";
} /* '' */
.uil-plane-departure:before {
  content: "\\eafc";
} /* '' */
.uil-plane-fly:before {
  content: "\\eafd";
} /* '' */
.uil-plane:before {
  content: "\\eafe";
} /* '' */
.uil-play-circle:before {
  content: "\\eaff";
} /* '' */
.uil-play:before {
  content: "\\eb00";
} /* '' */
.uil-plug:before {
  content: "\\eb01";
} /* '' */
.uil-plus-circle:before {
  content: "\\eb02";
} /* '' */
.uil-plus-square:before {
  content: "\\eb03";
} /* '' */
.uil-plus:before {
  content: "\\eb04";
} /* '' */
.uil-podium:before {
  content: "\\eb05";
} /* '' */
.uil-polygon:before {
  content: "\\eb06";
} /* '' */
.uil-post-stamp:before {
  content: "\\eb07";
} /* '' */
.uil-postcard:before {
  content: "\\eb08";
} /* '' */
.uil-pound-circle:before {
  content: "\\eb09";
} /* '' */
.uil-pound:before {
  content: "\\eb0a";
} /* '' */
.uil-power:before {
  content: "\\eb0b";
} /* '' */
.uil-prescription-bottle:before {
  content: "\\eb0c";
} /* '' */
.uil-presentation-check:before {
  content: "\\eb0d";
} /* '' */
.uil-presentation-edit:before {
  content: "\\eb0e";
} /* '' */
.uil-presentation-line:before {
  content: "\\eb0f";
} /* '' */
.uil-presentation-lines-alt:before {
  content: "\\eb10";
} /* '' */
.uil-presentation-minus:before {
  content: "\\eb11";
} /* '' */
.uil-presentation-play:before {
  content: "\\eb12";
} /* '' */
.uil-presentation-plus:before {
  content: "\\eb13";
} /* '' */
.uil-presentation-times:before {
  content: "\\eb14";
} /* '' */
.uil-presentation:before {
  content: "\\eb15";
} /* '' */
.uil-previous:before {
  content: "\\eb16";
} /* '' */
.uil-pricetag-alt:before {
  content: "\\eb17";
} /* '' */
.uil-print-slash:before {
  content: "\\eb18";
} /* '' */
.uil-print:before {
  content: "\\eb19";
} /* '' */
.uil-processor:before {
  content: "\\eb1a";
} /* '' */
.uil-pump:before {
  content: "\\eb1b";
} /* '' */
.uil-puzzle-piece:before {
  content: "\\eb1c";
} /* '' */
.uil-question-circle:before {
  content: "\\eb1d";
} /* '' */
.uil-raddit-alien-alt:before {
  content: "\\eb1e";
} /* '' */
.uil-rainbow:before {
  content: "\\eb1f";
} /* '' */
.uil-raindrops-alt:before {
  content: "\\eb20";
} /* '' */
.uil-raindrops:before {
  content: "\\eb21";
} /* '' */
.uil-receipt-alt:before {
  content: "\\eb22";
} /* '' */
.uil-receipt:before {
  content: "\\eb23";
} /* '' */
.uil-record-audio:before {
  content: "\\eb24";
} /* '' */
.uil-redo:before {
  content: "\\eb25";
} /* '' */
.uil-refresh:before {
  content: "\\eb26";
} /* '' */
.uil-registered:before {
  content: "\\eb27";
} /* '' */
.uil-repeat:before {
  content: "\\eb28";
} /* '' */
.uil-restaurant:before {
  content: "\\eb29";
} /* '' */
.uil-right-indent-alt:before {
  content: "\\eb2a";
} /* '' */
.uil-right-to-left-text-direction:before {
  content: "\\eb2b";
} /* '' */
.uil-robot:before {
  content: "\\eb2c";
} /* '' */
.uil-rope-way:before {
  content: "\\eb2d";
} /* '' */
.uil-rotate-360:before {
  content: "\\eb2e";
} /* '' */
.uil-rss-alt:before {
  content: "\\eb2f";
} /* '' */
.uil-rss-interface:before {
  content: "\\eb30";
} /* '' */
.uil-rss:before {
  content: "\\eb31";
} /* '' */
.uil-ruler-combined:before {
  content: "\\eb32";
} /* '' */
.uil-ruler:before {
  content: "\\eb33";
} /* '' */
.uil-sad-cry:before {
  content: "\\eb34";
} /* '' */
.uil-sad-crying:before {
  content: "\\eb35";
} /* '' */
.uil-sad-dizzy:before {
  content: "\\eb36";
} /* '' */
.uil-sad-squint:before {
  content: "\\eb37";
} /* '' */
.uil-sad:before {
  content: "\\eb38";
} /* '' */
.uil-scaling-left:before {
  content: "\\eb39";
} /* '' */
.uil-scaling-right:before {
  content: "\\eb3a";
} /* '' */
.uil-scenery:before {
  content: "\\eb3b";
} /* '' */
.uil-schedule:before {
  content: "\\eb3c";
} /* '' */
.uil-science:before {
  content: "\\eb3d";
} /* '' */
.uil-screw:before {
  content: "\\eb3e";
} /* '' */
.uil-scroll-h:before {
  content: "\\eb3f";
} /* '' */
.uil-scroll:before {
  content: "\\eb40";
} /* '' */
.uil-search-alt:before {
  content: "\\eb41";
} /* '' */
.uil-search-minus:before {
  content: "\\eb42";
} /* '' */
.uil-search-plus:before {
  content: "\\eb43";
} /* '' */
.uil-search:before {
  content: "\\eb44";
} /* '' */
.uil-selfie:before {
  content: "\\eb45";
} /* '' */
.uil-server-alt:before {
  content: "\\eb46";
} /* '' */
.uil-server-connection:before {
  content: "\\eb47";
} /* '' */
.uil-server-network-alt:before {
  content: "\\eb48";
} /* '' */
.uil-server-network:before {
  content: "\\eb49";
} /* '' */
.uil-server:before {
  content: "\\eb4a";
} /* '' */
.uil-servers:before {
  content: "\\eb4b";
} /* '' */
.uil-servicemark:before {
  content: "\\eb4c";
} /* '' */
.uil-share-alt:before {
  content: "\\eb4d";
} /* '' */
.uil-shield-check:before {
  content: "\\eb4e";
} /* '' */
.uil-shield-exclamation:before {
  content: "\\eb4f";
} /* '' */
.uil-shield-question:before {
  content: "\\eb50";
} /* '' */
.uil-shield-slash:before {
  content: "\\eb51";
} /* '' */
.uil-shield:before {
  content: "\\eb52";
} /* '' */
.uil-ship:before {
  content: "\\eb53";
} /* '' */
.uil-shop:before {
  content: "\\eb54";
} /* '' */
.uil-shopping-basket:before {
  content: "\\eb55";
} /* '' */
.uil-shopping-cart-alt:before {
  content: "\\eb56";
} /* '' */
.uil-shopping-trolley:before {
  content: "\\eb57";
} /* '' */
.uil-shovel:before {
  content: "\\eb58";
} /* '' */
.uil-shrink:before {
  content: "\\eb59";
} /* '' */
.uil-shuffle:before {
  content: "\\eb5a";
} /* '' */
.uil-shutter-alt:before {
  content: "\\eb5b";
} /* '' */
.uil-shutter:before {
  content: "\\eb5c";
} /* '' */
.uil-sick:before {
  content: "\\eb5d";
} /* '' */
.uil-sigma:before {
  content: "\\eb5e";
} /* '' */
.uil-sign-alt:before {
  content: "\\eb5f";
} /* '' */
.uil-sign-in-alt:before {
  content: "\\eb60";
} /* '' */
.uil-sign-left:before {
  content: "\\eb61";
} /* '' */
.uil-sign-out-alt:before {
  content: "\\eb62";
} /* '' */
.uil-sign-right:before {
  content: "\\eb63";
} /* '' */
.uil-signal-alt-3:before {
  content: "\\eb64";
} /* '' */
.uil-signal-alt:before {
  content: "\\eb65";
} /* '' */
.uil-signal:before {
  content: "\\eb66";
} /* '' */
.uil-silence:before {
  content: "\\eb67";
} /* '' */
.uil-silent-squint:before {
  content: "\\eb68";
} /* '' */
.uil-sim-card:before {
  content: "\\eb69";
} /* '' */
.uil-sitemap:before {
  content: "\\eb6a";
} /* '' */
.uil-skip-forward-alt:before {
  content: "\\eb6b";
} /* '' */
.uil-skip-forward-circle:before {
  content: "\\eb6c";
} /* '' */
.uil-skip-forward:before {
  content: "\\eb6d";
} /* '' */
.uil-slack-alt:before {
  content: "\\eb6e";
} /* '' */
.uil-slack:before {
  content: "\\eb6f";
} /* '' */
.uil-sliders-v-alt:before {
  content: "\\eb70";
} /* '' */
.uil-sliders-v:before {
  content: "\\eb71";
} /* '' */
.uil-smile-beam:before {
  content: "\\eb72";
} /* '' */
.uil-smile-dizzy:before {
  content: "\\eb73";
} /* '' */
.uil-smile-squint-wink-alt:before {
  content: "\\eb74";
} /* '' */
.uil-smile-squint-wink:before {
  content: "\\eb75";
} /* '' */
.uil-smile-wink-alt:before {
  content: "\\eb76";
} /* '' */
.uil-smile-wink:before {
  content: "\\eb77";
} /* '' */
.uil-smile:before {
  content: "\\eb78";
} /* '' */
.uil-snapchat-ghost:before {
  content: "\\eb79";
} /* '' */
.uil-snapchat-square:before {
  content: "\\eb7a";
} /* '' */
.uil-snow-flake:before {
  content: "\\eb7b";
} /* '' */
.uil-snowflake-alt:before {
  content: "\\eb7c";
} /* '' */
.uil-snowflake:before {
  content: "\\eb7d";
} /* '' */
.uil-sort-amount-down:before {
  content: "\\eb7e";
} /* '' */
.uil-sort-amount-up:before {
  content: "\\eb7f";
} /* '' */
.uil-sort:before {
  content: "\\eb80";
} /* '' */
.uil-sorting:before {
  content: "\\eb81";
} /* '' */
.uil-space-key:before {
  content: "\\eb82";
} /* '' */
.uil-spade:before {
  content: "\\eb83";
} /* '' */
.uil-sperms:before {
  content: "\\eb84";
} /* '' */
.uil-spin:before {
  content: "\\eb85";
} /* '' */
.uil-sport:before {
  content: "\\eb86";
} /* '' */
.uil-square-full:before {
  content: "\\eb87";
} /* '' */
.uil-square-shape:before {
  content: "\\eb88";
} /* '' */
.uil-square:before {
  content: "\\eb89";
} /* '' */
.uil-squint:before {
  content: "\\eb8a";
} /* '' */
.uil-star-half-alt:before {
  content: "\\eb8b";
} /* '' */
.uil-star:before {
  content: "\\eb8c";
} /* '' */
.uil-step-backward-alt:before {
  content: "\\eb8d";
} /* '' */
.uil-step-backward-circle:before {
  content: "\\eb8e";
} /* '' */
.uil-step-backward:before {
  content: "\\eb8f";
} /* '' */
.uil-step-forward:before {
  content: "\\eb90";
} /* '' */
.uil-stop-circle:before {
  content: "\\eb91";
} /* '' */
.uil-stopwatch-slash:before {
  content: "\\eb92";
} /* '' */
.uil-stopwatch:before {
  content: "\\eb93";
} /* '' */
.uil-store-alt:before {
  content: "\\eb94";
} /* '' */
.uil-store:before {
  content: "\\eb95";
} /* '' */
.uil-streering:before {
  content: "\\eb96";
} /* '' */
.uil-stretcher:before {
  content: "\\eb97";
} /* '' */
.uil-subject:before {
  content: "\\eb98";
} /* '' */
.uil-subway-alt:before {
  content: "\\eb99";
} /* '' */
.uil-subway:before {
  content: "\\eb9a";
} /* '' */
.uil-suitcase-alt:before {
  content: "\\eb9b";
} /* '' */
.uil-suitcase:before {
  content: "\\eb9c";
} /* '' */
.uil-sun:before {
  content: "\\eb9d";
} /* '' */
.uil-sunset:before {
  content: "\\eb9e";
} /* '' */
.uil-surprise:before {
  content: "\\eb9f";
} /* '' */
.uil-swatchbook:before {
  content: "\\eba0";
} /* '' */
.uil-swimmer:before {
  content: "\\eba1";
} /* '' */
.uil-symbol:before {
  content: "\\eba2";
} /* '' */
.uil-sync-exclamation:before {
  content: "\\eba3";
} /* '' */
.uil-sync-slash:before {
  content: "\\eba4";
} /* '' */
.uil-sync:before {
  content: "\\eba5";
} /* '' */
.uil-syringe:before {
  content: "\\eba6";
} /* '' */
.uil-table:before {
  content: "\\eba7";
} /* '' */
.uil-tablet:before {
  content: "\\eba8";
} /* '' */
.uil-tablets:before {
  content: "\\eba9";
} /* '' */
.uil-tachometer-fast:before {
  content: "\\ebaa";
} /* '' */
.uil-tag-alt:before {
  content: "\\ebab";
} /* '' */
.uil-tag:before {
  content: "\\ebac";
} /* '' */
.uil-tape:before {
  content: "\\ebad";
} /* '' */
.uil-taxi:before {
  content: "\\ebae";
} /* '' */
.uil-tear:before {
  content: "\\ebaf";
} /* '' */
.uil-technology:before {
  content: "\\ebb0";
} /* '' */
.uil-telescope:before {
  content: "\\ebb1";
} /* '' */
.uil-temperature-empty:before {
  content: "\\ebb2";
} /* '' */
.uil-temperature-half:before {
  content: "\\ebb3";
} /* '' */
.uil-temperature-minus:before {
  content: "\\ebb4";
} /* '' */
.uil-temperature-plus:before {
  content: "\\ebb5";
} /* '' */
.uil-temperature-quarter:before {
  content: "\\ebb6";
} /* '' */
.uil-temperature-three-quarter:before {
  content: "\\ebb7";
} /* '' */
.uil-temperature:before {
  content: "\\ebb8";
} /* '' */
.uil-text-fields:before {
  content: "\\ebb9";
} /* '' */
.uil-text-size:before {
  content: "\\ebba";
} /* '' */
.uil-text-strike-through:before {
  content: "\\ebbb";
} /* '' */
.uil-text:before {
  content: "\\ebbc";
} /* '' */
.uil-th-large:before {
  content: "\\ebbd";
} /* '' */
.uil-th-slash:before {
  content: "\\ebbe";
} /* '' */
.uil-th:before {
  content: "\\ebbf";
} /* '' */
.uil-thermometer:before {
  content: "\\ebc0";
} /* '' */
.uil-thumbs-down:before {
  content: "\\ebc1";
} /* '' */
.uil-thumbs-up:before {
  content: "\\ebc2";
} /* '' */
.uil-thunderstorm-moon:before {
  content: "\\ebc3";
} /* '' */
.uil-thunderstorm-sun:before {
  content: "\\ebc4";
} /* '' */
.uil-thunderstorm:before {
  content: "\\ebc5";
} /* '' */
.uil-ticket:before {
  content: "\\ebc6";
} /* '' */
.uil-times-circle:before {
  content: "\\ebc7";
} /* '' */
.uil-times-square:before {
  content: "\\ebc8";
} /* '' */
.uil-times:before {
  content: "\\ebc9";
} /* '' */
.uil-toggle-off:before {
  content: "\\ebca";
} /* '' */
.uil-toggle-on:before {
  content: "\\ebcb";
} /* '' */
.uil-top-arrow-from-top:before {
  content: "\\ebcc";
} /* '' */
.uil-top-arrow-to-top:before {
  content: "\\ebcd";
} /* '' */
.uil-tornado:before {
  content: "\\ebce";
} /* '' */
.uil-trademark-circle:before {
  content: "\\ebcf";
} /* '' */
.uil-trademark:before {
  content: "\\ebd0";
} /* '' */
.uil-traffic-barrier:before {
  content: "\\ebd1";
} /* '' */
.uil-trash-alt:before {
  content: "\\ebd2";
} /* '' */
.uil-trash:before {
  content: "\\ebd3";
} /* '' */
.uil-trees:before {
  content: "\\ebd4";
} /* '' */
.uil-triangle:before {
  content: "\\ebd5";
} /* '' */
.uil-trophy:before {
  content: "\\ebd6";
} /* '' */
.uil-trowel:before {
  content: "\\ebd7";
} /* '' */
.uil-truck-case:before {
  content: "\\ebd8";
} /* '' */
.uil-truck-loading:before {
  content: "\\ebd9";
} /* '' */
.uil-truck:before {
  content: "\\ebda";
} /* '' */
.uil-tumblr-square:before {
  content: "\\ebdb";
} /* '' */
.uil-tumblr:before {
  content: "\\ebdc";
} /* '' */
.uil-tv-retro-slash:before {
  content: "\\ebdd";
} /* '' */
.uil-tv-retro:before {
  content: "\\ebde";
} /* '' */
.uil-twitter:before {
  content: "\\ebdf";
} /* '' */
.uil-umbrella:before {
  content: "\\ebe0";
} /* '' */
.uil-unamused:before {
  content: "\\ebe1";
} /* '' */
.uil-underline:before {
  content: "\\ebe2";
} /* '' */
.uil-unlock-alt:before {
  content: "\\ebe3";
} /* '' */
.uil-unlock:before {
  content: "\\ebe4";
} /* '' */
.uil-upload-alt:before {
  content: "\\ebe5";
} /* '' */
.uil-upload:before {
  content: "\\ebe6";
} /* '' */
.uil-usd-circle:before {
  content: "\\ebe7";
} /* '' */
.uil-usd-square:before {
  content: "\\ebe8";
} /* '' */
.uil-user-check:before {
  content: "\\ebe9";
} /* '' */
.uil-user-circle:before {
  content: "\\ebea";
} /* '' */
.uil-user-exclamation:before {
  content: "\\ebeb";
} /* '' */
.uil-user-hard-hat:before {
  content: "\\ebec";
} /* '' */
.uil-user-minus:before {
  content: "\\ebed";
} /* '' */
.uil-user-plus:before {
  content: "\\ebee";
} /* '' */
.uil-user-square:before {
  content: "\\ebef";
} /* '' */
.uil-user-times:before {
  content: "\\ebf0";
} /* '' */
.uil-user:before {
  content: "\\ebf1";
} /* '' */
.uil-users-alt:before {
  content: "\\ebf2";
} /* '' */
.uil-utensils-alt:before {
  content: "\\ebf3";
} /* '' */
.uil-utensils:before {
  content: "\\ebf4";
} /* '' */
.uil-vector-square-alt:before {
  content: "\\ebf5";
} /* '' */
.uil-vector-square:before {
  content: "\\ebf6";
} /* '' */
.uil-venus:before {
  content: "\\ebf7";
} /* '' */
.uil-vertical-align-bottom:before {
  content: "\\ebf8";
} /* '' */
.uil-vertical-align-center:before {
  content: "\\ebf9";
} /* '' */
.uil-vertical-align-top:before {
  content: "\\ebfa";
} /* '' */
.uil-vertical-distribute-bottom:before {
  content: "\\ebfb";
} /* '' */
.uil-vertical-distribution-center:before {
  content: "\\ebfc";
} /* '' */
.uil-vertical-distribution-top:before {
  content: "\\ebfd";
} /* '' */
.uil-video-slash:before {
  content: "\\ebfe";
} /* '' */
.uil-video:before {
  content: "\\ebff";
} /* '' */
.uil-visual-studio:before {
  content: "\\ec00";
} /* '' */
.uil-voicemail-rectangle:before {
  content: "\\ec01";
} /* '' */
.uil-voicemail:before {
  content: "\\ec02";
} /* '' */
.uil-volleyball:before {
  content: "\\ec03";
} /* '' */
.uil-volume-down:before {
  content: "\\ec04";
} /* '' */
.uil-volume-mute:before {
  content: "\\ec05";
} /* '' */
.uil-volume-off:before {
  content: "\\ec06";
} /* '' */
.uil-volume-up:before {
  content: "\\ec07";
} /* '' */
.uil-volume:before {
  content: "\\ec08";
} /* '' */
.uil-vuejs-alt:before {
  content: "\\ec09";
} /* '' */
.uil-vuejs:before {
  content: "\\ec0a";
} /* '' */
.uil-wall:before {
  content: "\\ec0b";
} /* '' */
.uil-wallet:before {
  content: "\\ec0c";
} /* '' */
.uil-watch-alt:before {
  content: "\\ec0d";
} /* '' */
.uil-watch:before {
  content: "\\ec0e";
} /* '' */
.uil-water-drop-slash:before {
  content: "\\ec0f";
} /* '' */
.uil-water-glass:before {
  content: "\\ec10";
} /* '' */
.uil-water:before {
  content: "\\ec11";
} /* '' */
.uil-web-grid-alt:before {
  content: "\\ec12";
} /* '' */
.uil-web-grid:before {
  content: "\\ec13";
} /* '' */
.uil-web-section-alt:before {
  content: "\\ec14";
} /* '' */
.uil-web-section:before {
  content: "\\ec15";
} /* '' */
.uil-webcam:before {
  content: "\\ec16";
} /* '' */
.uil-weight:before {
  content: "\\ec17";
} /* '' */
.uil-whatsapp:before {
  content: "\\ec18";
} /* '' */
.uil-wheel-barrow:before {
  content: "\\ec19";
} /* '' */
.uil-wheelchair-alt:before {
  content: "\\ec1a";
} /* '' */
.uil-wheelchair:before {
  content: "\\ec1b";
} /* '' */
.uil-wifi-router:before {
  content: "\\ec1c";
} /* '' */
.uil-wifi-slash:before {
  content: "\\ec1d";
} /* '' */
.uil-wifi:before {
  content: "\\ec1e";
} /* '' */
.uil-wind:before {
  content: "\\ec1f";
} /* '' */
.uil-window-grid:before {
  content: "\\ec20";
} /* '' */
.uil-window-maximize:before {
  content: "\\ec21";
} /* '' */
.uil-window-restore:before {
  content: "\\ec22";
} /* '' */
.uil-window-section:before {
  content: "\\ec23";
} /* '' */
.uil-window:before {
  content: "\\ec24";
} /* '' */
.uil-windsock:before {
  content: "\\ec25";
} /* '' */
.uil-wrap-text:before {
  content: "\\ec26";
} /* '' */
.uil-wrench:before {
  content: "\\ec27";
} /* '' */
.uil-yellow:before {
  content: "\\ec28";
} /* '' */
.uil-yen-circle:before {
  content: "\\ec29";
} /* '' */
.uil-yen:before {
  content: "\\ec2a";
} /* '' */
.uil-youtube-alt:before {
  content: "\\ec2b";
} /* '' */
.uil-youtube:before {
  content: "\\ec2c";
} /* '' */
@font-face {
  font-family: "dripicons-v2";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_45___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_46___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_47___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_48___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[data-icon]:before {
  font-family: "dripicons-v2" !important;
  content: attr(data-icon);
  font-style: normal !important;
  font-weight: normal !important;
  font-feature-settings: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

[class^=dripicons-]:before,
[class*=" dripicons-"]:before {
  font-family: "dripicons-v2" !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-feature-settings: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  vertical-align: middle;
  display: inline-block;
}

.dripicons-alarm:before {
  content: "a";
}

.dripicons-align-center:before {
  content: "b";
}

.dripicons-align-justify:before {
  content: "c";
}

.dripicons-align-left:before {
  content: "d";
}

.dripicons-align-right:before {
  content: "e";
}

.dripicons-anchor:before {
  content: "f";
}

.dripicons-archive:before {
  content: "g";
}

.dripicons-arrow-down:before {
  content: "h";
}

.dripicons-arrow-left:before {
  content: "i";
}

.dripicons-arrow-right:before {
  content: "j";
}

.dripicons-arrow-thin-down:before {
  content: "k";
}

.dripicons-arrow-thin-left:before {
  content: "l";
}

.dripicons-arrow-thin-right:before {
  content: "m";
}

.dripicons-arrow-thin-up:before {
  content: "n";
}

.dripicons-arrow-up:before {
  content: "o";
}

.dripicons-article:before {
  content: "p";
}

.dripicons-backspace:before {
  content: "q";
}

.dripicons-basket:before {
  content: "r";
}

.dripicons-basketball:before {
  content: "s";
}

.dripicons-battery-empty:before {
  content: "t";
}

.dripicons-battery-full:before {
  content: "u";
}

.dripicons-battery-low:before {
  content: "v";
}

.dripicons-battery-medium:before {
  content: "w";
}

.dripicons-bell:before {
  content: "x";
}

.dripicons-blog:before {
  content: "y";
}

.dripicons-bluetooth:before {
  content: "z";
}

.dripicons-bold:before {
  content: "A";
}

.dripicons-bookmark:before {
  content: "B";
}

.dripicons-bookmarks:before {
  content: "C";
}

.dripicons-box:before {
  content: "D";
}

.dripicons-briefcase:before {
  content: "E";
}

.dripicons-brightness-low:before {
  content: "F";
}

.dripicons-brightness-max:before {
  content: "G";
}

.dripicons-brightness-medium:before {
  content: "H";
}

.dripicons-broadcast:before {
  content: "I";
}

.dripicons-browser:before {
  content: "J";
}

.dripicons-browser-upload:before {
  content: "K";
}

.dripicons-brush:before {
  content: "L";
}

.dripicons-calendar:before {
  content: "M";
}

.dripicons-camcorder:before {
  content: "N";
}

.dripicons-camera:before {
  content: "O";
}

.dripicons-card:before {
  content: "P";
}

.dripicons-cart:before {
  content: "Q";
}

.dripicons-checklist:before {
  content: "R";
}

.dripicons-checkmark:before {
  content: "S";
}

.dripicons-chevron-down:before {
  content: "T";
}

.dripicons-chevron-left:before {
  content: "U";
}

.dripicons-chevron-right:before {
  content: "V";
}

.dripicons-chevron-up:before {
  content: "W";
}

.dripicons-clipboard:before {
  content: "X";
}

.dripicons-clock:before {
  content: "Y";
}

.dripicons-clockwise:before {
  content: "Z";
}

.dripicons-cloud:before {
  content: "0";
}

.dripicons-cloud-download:before {
  content: "1";
}

.dripicons-cloud-upload:before {
  content: "2";
}

.dripicons-code:before {
  content: "3";
}

.dripicons-contract:before {
  content: "4";
}

.dripicons-contract-2:before {
  content: "5";
}

.dripicons-conversation:before {
  content: "6";
}

.dripicons-copy:before {
  content: "7";
}

.dripicons-crop:before {
  content: "8";
}

.dripicons-cross:before {
  content: "9";
}

.dripicons-crosshair:before {
  content: "!";
}

.dripicons-cutlery:before {
  content: '"';
}

.dripicons-device-desktop:before {
  content: "#";
}

.dripicons-device-mobile:before {
  content: "\$";
}

.dripicons-device-tablet:before {
  content: "%";
}

.dripicons-direction:before {
  content: "&";
}

.dripicons-disc:before {
  content: "'";
}

.dripicons-document:before {
  content: "(";
}

.dripicons-document-delete:before {
  content: ")";
}

.dripicons-document-edit:before {
  content: "*";
}

.dripicons-document-new:before {
  content: "+";
}

.dripicons-document-remove:before {
  content: ",";
}

.dripicons-dot:before {
  content: "-";
}

.dripicons-dots-2:before {
  content: ".";
}

.dripicons-dots-3:before {
  content: "/";
}

.dripicons-download:before {
  content: ":";
}

.dripicons-duplicate:before {
  content: ";";
}

.dripicons-enter:before {
  content: "<";
}

.dripicons-exit:before {
  content: "=";
}

.dripicons-expand:before {
  content: ">";
}

.dripicons-expand-2:before {
  content: "?";
}

.dripicons-experiment:before {
  content: "@";
}

.dripicons-export:before {
  content: "[";
}

.dripicons-feed:before {
  content: "]";
}

.dripicons-flag:before {
  content: "^";
}

.dripicons-flashlight:before {
  content: "_";
}

.dripicons-folder:before {
  content: "\`";
}

.dripicons-folder-open:before {
  content: "{";
}

.dripicons-forward:before {
  content: "|";
}

.dripicons-gaming:before {
  content: "}";
}

.dripicons-gear:before {
  content: "~";
}

.dripicons-graduation:before {
  content: "\\\\";
}

.dripicons-graph-bar:before {
  content: "\\e000";
}

.dripicons-graph-line:before {
  content: "\\e001";
}

.dripicons-graph-pie:before {
  content: "\\e002";
}

.dripicons-headset:before {
  content: "\\e003";
}

.dripicons-heart:before {
  content: "\\e004";
}

.dripicons-help:before {
  content: "\\e005";
}

.dripicons-home:before {
  content: "\\e006";
}

.dripicons-hourglass:before {
  content: "\\e007";
}

.dripicons-inbox:before {
  content: "\\e008";
}

.dripicons-information:before {
  content: "\\e009";
}

.dripicons-italic:before {
  content: "\\e00a";
}

.dripicons-jewel:before {
  content: "\\e00b";
}

.dripicons-lifting:before {
  content: "\\e00c";
}

.dripicons-lightbulb:before {
  content: "\\e00d";
}

.dripicons-link:before {
  content: "\\e00e";
}

.dripicons-link-broken:before {
  content: "\\e00f";
}

.dripicons-list:before {
  content: "\\e010";
}

.dripicons-loading:before {
  content: "\\e011";
}

.dripicons-location:before {
  content: "\\e012";
}

.dripicons-lock:before {
  content: "\\e013";
}

.dripicons-lock-open:before {
  content: "\\e014";
}

.dripicons-mail:before {
  content: "\\e015";
}

.dripicons-map:before {
  content: "\\e016";
}

.dripicons-media-loop:before {
  content: "\\e017";
}

.dripicons-media-next:before {
  content: "\\e018";
}

.dripicons-media-pause:before {
  content: "\\e019";
}

.dripicons-media-play:before {
  content: "\\e01a";
}

.dripicons-media-previous:before {
  content: "\\e01b";
}

.dripicons-media-record:before {
  content: "\\e01c";
}

.dripicons-media-shuffle:before {
  content: "\\e01d";
}

.dripicons-media-stop:before {
  content: "\\e01e";
}

.dripicons-medical:before {
  content: "\\e01f";
}

.dripicons-menu:before {
  content: "\\e020";
}

.dripicons-message:before {
  content: "\\e021";
}

.dripicons-meter:before {
  content: "\\e022";
}

.dripicons-microphone:before {
  content: "\\e023";
}

.dripicons-minus:before {
  content: "\\e024";
}

.dripicons-monitor:before {
  content: "\\e025";
}

.dripicons-move:before {
  content: "\\e026";
}

.dripicons-music:before {
  content: "\\e027";
}

.dripicons-network-1:before {
  content: "\\e028";
}

.dripicons-network-2:before {
  content: "\\e029";
}

.dripicons-network-3:before {
  content: "\\e02a";
}

.dripicons-network-4:before {
  content: "\\e02b";
}

.dripicons-network-5:before {
  content: "\\e02c";
}

.dripicons-pamphlet:before {
  content: "\\e02d";
}

.dripicons-paperclip:before {
  content: "\\e02e";
}

.dripicons-pencil:before {
  content: "\\e02f";
}

.dripicons-phone:before {
  content: "\\e030";
}

.dripicons-photo:before {
  content: "\\e031";
}

.dripicons-photo-group:before {
  content: "\\e032";
}

.dripicons-pill:before {
  content: "\\e033";
}

.dripicons-pin:before {
  content: "\\e034";
}

.dripicons-plus:before {
  content: "\\e035";
}

.dripicons-power:before {
  content: "\\e036";
}

.dripicons-preview:before {
  content: "\\e037";
}

.dripicons-print:before {
  content: "\\e038";
}

.dripicons-pulse:before {
  content: "\\e039";
}

.dripicons-question:before {
  content: "\\e03a";
}

.dripicons-reply:before {
  content: "\\e03b";
}

.dripicons-reply-all:before {
  content: "\\e03c";
}

.dripicons-return:before {
  content: "\\e03d";
}

.dripicons-retweet:before {
  content: "\\e03e";
}

.dripicons-rocket:before {
  content: "\\e03f";
}

.dripicons-scale:before {
  content: "\\e040";
}

.dripicons-search:before {
  content: "\\e041";
}

.dripicons-shopping-bag:before {
  content: "\\e042";
}

.dripicons-skip:before {
  content: "\\e043";
}

.dripicons-stack:before {
  content: "\\e044";
}

.dripicons-star:before {
  content: "\\e045";
}

.dripicons-stopwatch:before {
  content: "\\e046";
}

.dripicons-store:before {
  content: "\\e047";
}

.dripicons-suitcase:before {
  content: "\\e048";
}

.dripicons-swap:before {
  content: "\\e049";
}

.dripicons-tag:before {
  content: "\\e04a";
}

.dripicons-tag-delete:before {
  content: "\\e04b";
}

.dripicons-tags:before {
  content: "\\e04c";
}

.dripicons-thumbs-down:before {
  content: "\\e04d";
}

.dripicons-thumbs-up:before {
  content: "\\e04e";
}

.dripicons-ticket:before {
  content: "\\e04f";
}

.dripicons-time-reverse:before {
  content: "\\e050";
}

.dripicons-to-do:before {
  content: "\\e051";
}

.dripicons-toggles:before {
  content: "\\e052";
}

.dripicons-trash:before {
  content: "\\e053";
}

.dripicons-trophy:before {
  content: "\\e054";
}

.dripicons-upload:before {
  content: "\\e055";
}

.dripicons-user:before {
  content: "\\e056";
}

.dripicons-user-group:before {
  content: "\\e057";
}

.dripicons-user-id:before {
  content: "\\e058";
}

.dripicons-vibrate:before {
  content: "\\e059";
}

.dripicons-view-apps:before {
  content: "\\e05a";
}

.dripicons-view-list:before {
  content: "\\e05b";
}

.dripicons-view-list-large:before {
  content: "\\e05c";
}

.dripicons-view-thumb:before {
  content: "\\e05d";
}

.dripicons-volume-full:before {
  content: "\\e05e";
}

.dripicons-volume-low:before {
  content: "\\e05f";
}

.dripicons-volume-medium:before {
  content: "\\e060";
}

.dripicons-volume-off:before {
  content: "\\e061";
}

.dripicons-wallet:before {
  content: "\\e062";
}

.dripicons-warning:before {
  content: "\\e063";
}

.dripicons-web:before {
  content: "\\e064";
}

.dripicons-weight:before {
  content: "\\e065";
}

.dripicons-wifi:before {
  content: "\\e066";
}

.dripicons-wrong:before {
  content: "\\e067";
}

.dripicons-zoom-in:before {
  content: "\\e068";
}

.dripicons-zoom-out:before {
  content: "\\e069";
}

/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_50___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_51___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_52___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mdi-ab-testing::before {
  content: "\\f01c9";
}

.mdi-abacus::before {
  content: "\\f16e0";
}

.mdi-abjad-arabic::before {
  content: "\\f1328";
}

.mdi-abjad-hebrew::before {
  content: "\\f1329";
}

.mdi-abugida-devanagari::before {
  content: "\\f132a";
}

.mdi-abugida-thai::before {
  content: "\\f132b";
}

.mdi-access-point::before {
  content: "\\f0003";
}

.mdi-access-point-check::before {
  content: "\\f1538";
}

.mdi-access-point-minus::before {
  content: "\\f1539";
}

.mdi-access-point-network::before {
  content: "\\f0002";
}

.mdi-access-point-network-off::before {
  content: "\\f0be1";
}

.mdi-access-point-off::before {
  content: "\\f1511";
}

.mdi-access-point-plus::before {
  content: "\\f153a";
}

.mdi-access-point-remove::before {
  content: "\\f153b";
}

.mdi-account::before {
  content: "\\f0004";
}

.mdi-account-alert::before {
  content: "\\f0005";
}

.mdi-account-alert-outline::before {
  content: "\\f0b50";
}

.mdi-account-arrow-down::before {
  content: "\\f1868";
}

.mdi-account-arrow-down-outline::before {
  content: "\\f1869";
}

.mdi-account-arrow-left::before {
  content: "\\f0b51";
}

.mdi-account-arrow-left-outline::before {
  content: "\\f0b52";
}

.mdi-account-arrow-right::before {
  content: "\\f0b53";
}

.mdi-account-arrow-right-outline::before {
  content: "\\f0b54";
}

.mdi-account-arrow-up::before {
  content: "\\f1867";
}

.mdi-account-arrow-up-outline::before {
  content: "\\f186a";
}

.mdi-account-box::before {
  content: "\\f0006";
}

.mdi-account-box-multiple::before {
  content: "\\f0934";
}

.mdi-account-box-multiple-outline::before {
  content: "\\f100a";
}

.mdi-account-box-outline::before {
  content: "\\f0007";
}

.mdi-account-cancel::before {
  content: "\\f12df";
}

.mdi-account-cancel-outline::before {
  content: "\\f12e0";
}

.mdi-account-cash::before {
  content: "\\f1097";
}

.mdi-account-cash-outline::before {
  content: "\\f1098";
}

.mdi-account-check::before {
  content: "\\f0008";
}

.mdi-account-check-outline::before {
  content: "\\f0be2";
}

.mdi-account-child::before {
  content: "\\f0a89";
}

.mdi-account-child-circle::before {
  content: "\\f0a8a";
}

.mdi-account-child-outline::before {
  content: "\\f10c8";
}

.mdi-account-circle::before {
  content: "\\f0009";
}

.mdi-account-circle-outline::before {
  content: "\\f0b55";
}

.mdi-account-clock::before {
  content: "\\f0b56";
}

.mdi-account-clock-outline::before {
  content: "\\f0b57";
}

.mdi-account-cog::before {
  content: "\\f1370";
}

.mdi-account-cog-outline::before {
  content: "\\f1371";
}

.mdi-account-convert::before {
  content: "\\f000a";
}

.mdi-account-convert-outline::before {
  content: "\\f1301";
}

.mdi-account-cowboy-hat::before {
  content: "\\f0e9b";
}

.mdi-account-cowboy-hat-outline::before {
  content: "\\f17f3";
}

.mdi-account-details::before {
  content: "\\f0631";
}

.mdi-account-details-outline::before {
  content: "\\f1372";
}

.mdi-account-edit::before {
  content: "\\f06bc";
}

.mdi-account-edit-outline::before {
  content: "\\f0ffb";
}

.mdi-account-eye::before {
  content: "\\f0420";
}

.mdi-account-eye-outline::before {
  content: "\\f127b";
}

.mdi-account-filter::before {
  content: "\\f0936";
}

.mdi-account-filter-outline::before {
  content: "\\f0f9d";
}

.mdi-account-group::before {
  content: "\\f0849";
}

.mdi-account-group-outline::before {
  content: "\\f0b58";
}

.mdi-account-hard-hat::before {
  content: "\\f05b5";
}

.mdi-account-heart::before {
  content: "\\f0899";
}

.mdi-account-heart-outline::before {
  content: "\\f0be3";
}

.mdi-account-injury::before {
  content: "\\f1815";
}

.mdi-account-injury-outline::before {
  content: "\\f1816";
}

.mdi-account-key::before {
  content: "\\f000b";
}

.mdi-account-key-outline::before {
  content: "\\f0be4";
}

.mdi-account-lock::before {
  content: "\\f115e";
}

.mdi-account-lock-open::before {
  content: "\\f1960";
}

.mdi-account-lock-open-outline::before {
  content: "\\f1961";
}

.mdi-account-lock-outline::before {
  content: "\\f115f";
}

.mdi-account-minus::before {
  content: "\\f000d";
}

.mdi-account-minus-outline::before {
  content: "\\f0aec";
}

.mdi-account-multiple::before {
  content: "\\f000e";
}

.mdi-account-multiple-check::before {
  content: "\\f08c5";
}

.mdi-account-multiple-check-outline::before {
  content: "\\f11fe";
}

.mdi-account-multiple-minus::before {
  content: "\\f05d3";
}

.mdi-account-multiple-minus-outline::before {
  content: "\\f0be5";
}

.mdi-account-multiple-outline::before {
  content: "\\f000f";
}

.mdi-account-multiple-plus::before {
  content: "\\f0010";
}

.mdi-account-multiple-plus-outline::before {
  content: "\\f0800";
}

.mdi-account-multiple-remove::before {
  content: "\\f120a";
}

.mdi-account-multiple-remove-outline::before {
  content: "\\f120b";
}

.mdi-account-music::before {
  content: "\\f0803";
}

.mdi-account-music-outline::before {
  content: "\\f0ce9";
}

.mdi-account-network::before {
  content: "\\f0011";
}

.mdi-account-network-outline::before {
  content: "\\f0be6";
}

.mdi-account-off::before {
  content: "\\f0012";
}

.mdi-account-off-outline::before {
  content: "\\f0be7";
}

.mdi-account-outline::before {
  content: "\\f0013";
}

.mdi-account-plus::before {
  content: "\\f0014";
}

.mdi-account-plus-outline::before {
  content: "\\f0801";
}

.mdi-account-question::before {
  content: "\\f0b59";
}

.mdi-account-question-outline::before {
  content: "\\f0b5a";
}

.mdi-account-reactivate::before {
  content: "\\f152b";
}

.mdi-account-reactivate-outline::before {
  content: "\\f152c";
}

.mdi-account-remove::before {
  content: "\\f0015";
}

.mdi-account-remove-outline::before {
  content: "\\f0aed";
}

.mdi-account-search::before {
  content: "\\f0016";
}

.mdi-account-search-outline::before {
  content: "\\f0935";
}

.mdi-account-settings::before {
  content: "\\f0630";
}

.mdi-account-settings-outline::before {
  content: "\\f10c9";
}

.mdi-account-star::before {
  content: "\\f0017";
}

.mdi-account-star-outline::before {
  content: "\\f0be8";
}

.mdi-account-supervisor::before {
  content: "\\f0a8b";
}

.mdi-account-supervisor-circle::before {
  content: "\\f0a8c";
}

.mdi-account-supervisor-circle-outline::before {
  content: "\\f14ec";
}

.mdi-account-supervisor-outline::before {
  content: "\\f112d";
}

.mdi-account-switch::before {
  content: "\\f0019";
}

.mdi-account-switch-outline::before {
  content: "\\f04cb";
}

.mdi-account-sync::before {
  content: "\\f191b";
}

.mdi-account-sync-outline::before {
  content: "\\f191c";
}

.mdi-account-tie::before {
  content: "\\f0ce3";
}

.mdi-account-tie-hat::before {
  content: "\\f1898";
}

.mdi-account-tie-hat-outline::before {
  content: "\\f1899";
}

.mdi-account-tie-outline::before {
  content: "\\f10ca";
}

.mdi-account-tie-voice::before {
  content: "\\f1308";
}

.mdi-account-tie-voice-off::before {
  content: "\\f130a";
}

.mdi-account-tie-voice-off-outline::before {
  content: "\\f130b";
}

.mdi-account-tie-voice-outline::before {
  content: "\\f1309";
}

.mdi-account-voice::before {
  content: "\\f05cb";
}

.mdi-account-voice-off::before {
  content: "\\f0ed4";
}

.mdi-account-wrench::before {
  content: "\\f189a";
}

.mdi-account-wrench-outline::before {
  content: "\\f189b";
}

.mdi-adjust::before {
  content: "\\f001a";
}

.mdi-advertisements::before {
  content: "\\f192a";
}

.mdi-advertisements-off::before {
  content: "\\f192b";
}

.mdi-air-conditioner::before {
  content: "\\f001b";
}

.mdi-air-filter::before {
  content: "\\f0d43";
}

.mdi-air-horn::before {
  content: "\\f0dac";
}

.mdi-air-humidifier::before {
  content: "\\f1099";
}

.mdi-air-humidifier-off::before {
  content: "\\f1466";
}

.mdi-air-purifier::before {
  content: "\\f0d44";
}

.mdi-airbag::before {
  content: "\\f0be9";
}

.mdi-airballoon::before {
  content: "\\f001c";
}

.mdi-airballoon-outline::before {
  content: "\\f100b";
}

.mdi-airplane::before {
  content: "\\f001d";
}

.mdi-airplane-alert::before {
  content: "\\f187a";
}

.mdi-airplane-check::before {
  content: "\\f187b";
}

.mdi-airplane-clock::before {
  content: "\\f187c";
}

.mdi-airplane-cog::before {
  content: "\\f187d";
}

.mdi-airplane-edit::before {
  content: "\\f187e";
}

.mdi-airplane-landing::before {
  content: "\\f05d4";
}

.mdi-airplane-marker::before {
  content: "\\f187f";
}

.mdi-airplane-minus::before {
  content: "\\f1880";
}

.mdi-airplane-off::before {
  content: "\\f001e";
}

.mdi-airplane-plus::before {
  content: "\\f1881";
}

.mdi-airplane-remove::before {
  content: "\\f1882";
}

.mdi-airplane-search::before {
  content: "\\f1883";
}

.mdi-airplane-settings::before {
  content: "\\f1884";
}

.mdi-airplane-takeoff::before {
  content: "\\f05d5";
}

.mdi-airport::before {
  content: "\\f084b";
}

.mdi-alarm::before {
  content: "\\f0020";
}

.mdi-alarm-bell::before {
  content: "\\f078e";
}

.mdi-alarm-check::before {
  content: "\\f0021";
}

.mdi-alarm-light::before {
  content: "\\f078f";
}

.mdi-alarm-light-off::before {
  content: "\\f171e";
}

.mdi-alarm-light-off-outline::before {
  content: "\\f171f";
}

.mdi-alarm-light-outline::before {
  content: "\\f0bea";
}

.mdi-alarm-multiple::before {
  content: "\\f0022";
}

.mdi-alarm-note::before {
  content: "\\f0e71";
}

.mdi-alarm-note-off::before {
  content: "\\f0e72";
}

.mdi-alarm-off::before {
  content: "\\f0023";
}

.mdi-alarm-panel::before {
  content: "\\f15c4";
}

.mdi-alarm-panel-outline::before {
  content: "\\f15c5";
}

.mdi-alarm-plus::before {
  content: "\\f0024";
}

.mdi-alarm-snooze::before {
  content: "\\f068e";
}

.mdi-album::before {
  content: "\\f0025";
}

.mdi-alert::before {
  content: "\\f0026";
}

.mdi-alert-box::before {
  content: "\\f0027";
}

.mdi-alert-box-outline::before {
  content: "\\f0ce4";
}

.mdi-alert-circle::before {
  content: "\\f0028";
}

.mdi-alert-circle-check::before {
  content: "\\f11ed";
}

.mdi-alert-circle-check-outline::before {
  content: "\\f11ee";
}

.mdi-alert-circle-outline::before {
  content: "\\f05d6";
}

.mdi-alert-decagram::before {
  content: "\\f06bd";
}

.mdi-alert-decagram-outline::before {
  content: "\\f0ce5";
}

.mdi-alert-minus::before {
  content: "\\f14bb";
}

.mdi-alert-minus-outline::before {
  content: "\\f14be";
}

.mdi-alert-octagon::before {
  content: "\\f0029";
}

.mdi-alert-octagon-outline::before {
  content: "\\f0ce6";
}

.mdi-alert-octagram::before {
  content: "\\f0767";
}

.mdi-alert-octagram-outline::before {
  content: "\\f0ce7";
}

.mdi-alert-outline::before {
  content: "\\f002a";
}

.mdi-alert-plus::before {
  content: "\\f14ba";
}

.mdi-alert-plus-outline::before {
  content: "\\f14bd";
}

.mdi-alert-remove::before {
  content: "\\f14bc";
}

.mdi-alert-remove-outline::before {
  content: "\\f14bf";
}

.mdi-alert-rhombus::before {
  content: "\\f11ce";
}

.mdi-alert-rhombus-outline::before {
  content: "\\f11cf";
}

.mdi-alien::before {
  content: "\\f089a";
}

.mdi-alien-outline::before {
  content: "\\f10cb";
}

.mdi-align-horizontal-center::before {
  content: "\\f11c3";
}

.mdi-align-horizontal-distribute::before {
  content: "\\f1962";
}

.mdi-align-horizontal-left::before {
  content: "\\f11c2";
}

.mdi-align-horizontal-right::before {
  content: "\\f11c4";
}

.mdi-align-vertical-bottom::before {
  content: "\\f11c5";
}

.mdi-align-vertical-center::before {
  content: "\\f11c6";
}

.mdi-align-vertical-distribute::before {
  content: "\\f1963";
}

.mdi-align-vertical-top::before {
  content: "\\f11c7";
}

.mdi-all-inclusive::before {
  content: "\\f06be";
}

.mdi-all-inclusive-box::before {
  content: "\\f188d";
}

.mdi-all-inclusive-box-outline::before {
  content: "\\f188e";
}

.mdi-allergy::before {
  content: "\\f1258";
}

.mdi-alpha::before {
  content: "\\f002b";
}

.mdi-alpha-a::before {
  content: "\\f0aee";
}

.mdi-alpha-a-box::before {
  content: "\\f0b08";
}

.mdi-alpha-a-box-outline::before {
  content: "\\f0beb";
}

.mdi-alpha-a-circle::before {
  content: "\\f0bec";
}

.mdi-alpha-a-circle-outline::before {
  content: "\\f0bed";
}

.mdi-alpha-b::before {
  content: "\\f0aef";
}

.mdi-alpha-b-box::before {
  content: "\\f0b09";
}

.mdi-alpha-b-box-outline::before {
  content: "\\f0bee";
}

.mdi-alpha-b-circle::before {
  content: "\\f0bef";
}

.mdi-alpha-b-circle-outline::before {
  content: "\\f0bf0";
}

.mdi-alpha-c::before {
  content: "\\f0af0";
}

.mdi-alpha-c-box::before {
  content: "\\f0b0a";
}

.mdi-alpha-c-box-outline::before {
  content: "\\f0bf1";
}

.mdi-alpha-c-circle::before {
  content: "\\f0bf2";
}

.mdi-alpha-c-circle-outline::before {
  content: "\\f0bf3";
}

.mdi-alpha-d::before {
  content: "\\f0af1";
}

.mdi-alpha-d-box::before {
  content: "\\f0b0b";
}

.mdi-alpha-d-box-outline::before {
  content: "\\f0bf4";
}

.mdi-alpha-d-circle::before {
  content: "\\f0bf5";
}

.mdi-alpha-d-circle-outline::before {
  content: "\\f0bf6";
}

.mdi-alpha-e::before {
  content: "\\f0af2";
}

.mdi-alpha-e-box::before {
  content: "\\f0b0c";
}

.mdi-alpha-e-box-outline::before {
  content: "\\f0bf7";
}

.mdi-alpha-e-circle::before {
  content: "\\f0bf8";
}

.mdi-alpha-e-circle-outline::before {
  content: "\\f0bf9";
}

.mdi-alpha-f::before {
  content: "\\f0af3";
}

.mdi-alpha-f-box::before {
  content: "\\f0b0d";
}

.mdi-alpha-f-box-outline::before {
  content: "\\f0bfa";
}

.mdi-alpha-f-circle::before {
  content: "\\f0bfb";
}

.mdi-alpha-f-circle-outline::before {
  content: "\\f0bfc";
}

.mdi-alpha-g::before {
  content: "\\f0af4";
}

.mdi-alpha-g-box::before {
  content: "\\f0b0e";
}

.mdi-alpha-g-box-outline::before {
  content: "\\f0bfd";
}

.mdi-alpha-g-circle::before {
  content: "\\f0bfe";
}

.mdi-alpha-g-circle-outline::before {
  content: "\\f0bff";
}

.mdi-alpha-h::before {
  content: "\\f0af5";
}

.mdi-alpha-h-box::before {
  content: "\\f0b0f";
}

.mdi-alpha-h-box-outline::before {
  content: "\\f0c00";
}

.mdi-alpha-h-circle::before {
  content: "\\f0c01";
}

.mdi-alpha-h-circle-outline::before {
  content: "\\f0c02";
}

.mdi-alpha-i::before {
  content: "\\f0af6";
}

.mdi-alpha-i-box::before {
  content: "\\f0b10";
}

.mdi-alpha-i-box-outline::before {
  content: "\\f0c03";
}

.mdi-alpha-i-circle::before {
  content: "\\f0c04";
}

.mdi-alpha-i-circle-outline::before {
  content: "\\f0c05";
}

.mdi-alpha-j::before {
  content: "\\f0af7";
}

.mdi-alpha-j-box::before {
  content: "\\f0b11";
}

.mdi-alpha-j-box-outline::before {
  content: "\\f0c06";
}

.mdi-alpha-j-circle::before {
  content: "\\f0c07";
}

.mdi-alpha-j-circle-outline::before {
  content: "\\f0c08";
}

.mdi-alpha-k::before {
  content: "\\f0af8";
}

.mdi-alpha-k-box::before {
  content: "\\f0b12";
}

.mdi-alpha-k-box-outline::before {
  content: "\\f0c09";
}

.mdi-alpha-k-circle::before {
  content: "\\f0c0a";
}

.mdi-alpha-k-circle-outline::before {
  content: "\\f0c0b";
}

.mdi-alpha-l::before {
  content: "\\f0af9";
}

.mdi-alpha-l-box::before {
  content: "\\f0b13";
}

.mdi-alpha-l-box-outline::before {
  content: "\\f0c0c";
}

.mdi-alpha-l-circle::before {
  content: "\\f0c0d";
}

.mdi-alpha-l-circle-outline::before {
  content: "\\f0c0e";
}

.mdi-alpha-m::before {
  content: "\\f0afa";
}

.mdi-alpha-m-box::before {
  content: "\\f0b14";
}

.mdi-alpha-m-box-outline::before {
  content: "\\f0c0f";
}

.mdi-alpha-m-circle::before {
  content: "\\f0c10";
}

.mdi-alpha-m-circle-outline::before {
  content: "\\f0c11";
}

.mdi-alpha-n::before {
  content: "\\f0afb";
}

.mdi-alpha-n-box::before {
  content: "\\f0b15";
}

.mdi-alpha-n-box-outline::before {
  content: "\\f0c12";
}

.mdi-alpha-n-circle::before {
  content: "\\f0c13";
}

.mdi-alpha-n-circle-outline::before {
  content: "\\f0c14";
}

.mdi-alpha-o::before {
  content: "\\f0afc";
}

.mdi-alpha-o-box::before {
  content: "\\f0b16";
}

.mdi-alpha-o-box-outline::before {
  content: "\\f0c15";
}

.mdi-alpha-o-circle::before {
  content: "\\f0c16";
}

.mdi-alpha-o-circle-outline::before {
  content: "\\f0c17";
}

.mdi-alpha-p::before {
  content: "\\f0afd";
}

.mdi-alpha-p-box::before {
  content: "\\f0b17";
}

.mdi-alpha-p-box-outline::before {
  content: "\\f0c18";
}

.mdi-alpha-p-circle::before {
  content: "\\f0c19";
}

.mdi-alpha-p-circle-outline::before {
  content: "\\f0c1a";
}

.mdi-alpha-q::before {
  content: "\\f0afe";
}

.mdi-alpha-q-box::before {
  content: "\\f0b18";
}

.mdi-alpha-q-box-outline::before {
  content: "\\f0c1b";
}

.mdi-alpha-q-circle::before {
  content: "\\f0c1c";
}

.mdi-alpha-q-circle-outline::before {
  content: "\\f0c1d";
}

.mdi-alpha-r::before {
  content: "\\f0aff";
}

.mdi-alpha-r-box::before {
  content: "\\f0b19";
}

.mdi-alpha-r-box-outline::before {
  content: "\\f0c1e";
}

.mdi-alpha-r-circle::before {
  content: "\\f0c1f";
}

.mdi-alpha-r-circle-outline::before {
  content: "\\f0c20";
}

.mdi-alpha-s::before {
  content: "\\f0b00";
}

.mdi-alpha-s-box::before {
  content: "\\f0b1a";
}

.mdi-alpha-s-box-outline::before {
  content: "\\f0c21";
}

.mdi-alpha-s-circle::before {
  content: "\\f0c22";
}

.mdi-alpha-s-circle-outline::before {
  content: "\\f0c23";
}

.mdi-alpha-t::before {
  content: "\\f0b01";
}

.mdi-alpha-t-box::before {
  content: "\\f0b1b";
}

.mdi-alpha-t-box-outline::before {
  content: "\\f0c24";
}

.mdi-alpha-t-circle::before {
  content: "\\f0c25";
}

.mdi-alpha-t-circle-outline::before {
  content: "\\f0c26";
}

.mdi-alpha-u::before {
  content: "\\f0b02";
}

.mdi-alpha-u-box::before {
  content: "\\f0b1c";
}

.mdi-alpha-u-box-outline::before {
  content: "\\f0c27";
}

.mdi-alpha-u-circle::before {
  content: "\\f0c28";
}

.mdi-alpha-u-circle-outline::before {
  content: "\\f0c29";
}

.mdi-alpha-v::before {
  content: "\\f0b03";
}

.mdi-alpha-v-box::before {
  content: "\\f0b1d";
}

.mdi-alpha-v-box-outline::before {
  content: "\\f0c2a";
}

.mdi-alpha-v-circle::before {
  content: "\\f0c2b";
}

.mdi-alpha-v-circle-outline::before {
  content: "\\f0c2c";
}

.mdi-alpha-w::before {
  content: "\\f0b04";
}

.mdi-alpha-w-box::before {
  content: "\\f0b1e";
}

.mdi-alpha-w-box-outline::before {
  content: "\\f0c2d";
}

.mdi-alpha-w-circle::before {
  content: "\\f0c2e";
}

.mdi-alpha-w-circle-outline::before {
  content: "\\f0c2f";
}

.mdi-alpha-x::before {
  content: "\\f0b05";
}

.mdi-alpha-x-box::before {
  content: "\\f0b1f";
}

.mdi-alpha-x-box-outline::before {
  content: "\\f0c30";
}

.mdi-alpha-x-circle::before {
  content: "\\f0c31";
}

.mdi-alpha-x-circle-outline::before {
  content: "\\f0c32";
}

.mdi-alpha-y::before {
  content: "\\f0b06";
}

.mdi-alpha-y-box::before {
  content: "\\f0b20";
}

.mdi-alpha-y-box-outline::before {
  content: "\\f0c33";
}

.mdi-alpha-y-circle::before {
  content: "\\f0c34";
}

.mdi-alpha-y-circle-outline::before {
  content: "\\f0c35";
}

.mdi-alpha-z::before {
  content: "\\f0b07";
}

.mdi-alpha-z-box::before {
  content: "\\f0b21";
}

.mdi-alpha-z-box-outline::before {
  content: "\\f0c36";
}

.mdi-alpha-z-circle::before {
  content: "\\f0c37";
}

.mdi-alpha-z-circle-outline::before {
  content: "\\f0c38";
}

.mdi-alphabet-aurebesh::before {
  content: "\\f132c";
}

.mdi-alphabet-cyrillic::before {
  content: "\\f132d";
}

.mdi-alphabet-greek::before {
  content: "\\f132e";
}

.mdi-alphabet-latin::before {
  content: "\\f132f";
}

.mdi-alphabet-piqad::before {
  content: "\\f1330";
}

.mdi-alphabet-tengwar::before {
  content: "\\f1337";
}

.mdi-alphabetical::before {
  content: "\\f002c";
}

.mdi-alphabetical-off::before {
  content: "\\f100c";
}

.mdi-alphabetical-variant::before {
  content: "\\f100d";
}

.mdi-alphabetical-variant-off::before {
  content: "\\f100e";
}

.mdi-altimeter::before {
  content: "\\f05d7";
}

.mdi-ambulance::before {
  content: "\\f002f";
}

.mdi-ammunition::before {
  content: "\\f0ce8";
}

.mdi-ampersand::before {
  content: "\\f0a8d";
}

.mdi-amplifier::before {
  content: "\\f0030";
}

.mdi-amplifier-off::before {
  content: "\\f11b5";
}

.mdi-anchor::before {
  content: "\\f0031";
}

.mdi-android::before {
  content: "\\f0032";
}

.mdi-android-messages::before {
  content: "\\f0d45";
}

.mdi-android-studio::before {
  content: "\\f0034";
}

.mdi-angle-acute::before {
  content: "\\f0937";
}

.mdi-angle-obtuse::before {
  content: "\\f0938";
}

.mdi-angle-right::before {
  content: "\\f0939";
}

.mdi-angular::before {
  content: "\\f06b2";
}

.mdi-angularjs::before {
  content: "\\f06bf";
}

.mdi-animation::before {
  content: "\\f05d8";
}

.mdi-animation-outline::before {
  content: "\\f0a8f";
}

.mdi-animation-play::before {
  content: "\\f093a";
}

.mdi-animation-play-outline::before {
  content: "\\f0a90";
}

.mdi-ansible::before {
  content: "\\f109a";
}

.mdi-antenna::before {
  content: "\\f1119";
}

.mdi-anvil::before {
  content: "\\f089b";
}

.mdi-apache-kafka::before {
  content: "\\f100f";
}

.mdi-api::before {
  content: "\\f109b";
}

.mdi-api-off::before {
  content: "\\f1257";
}

.mdi-apple::before {
  content: "\\f0035";
}

.mdi-apple-finder::before {
  content: "\\f0036";
}

.mdi-apple-icloud::before {
  content: "\\f0038";
}

.mdi-apple-ios::before {
  content: "\\f0037";
}

.mdi-apple-keyboard-caps::before {
  content: "\\f0632";
}

.mdi-apple-keyboard-command::before {
  content: "\\f0633";
}

.mdi-apple-keyboard-control::before {
  content: "\\f0634";
}

.mdi-apple-keyboard-option::before {
  content: "\\f0635";
}

.mdi-apple-keyboard-shift::before {
  content: "\\f0636";
}

.mdi-apple-safari::before {
  content: "\\f0039";
}

.mdi-application::before {
  content: "\\f08c6";
}

.mdi-application-array::before {
  content: "\\f10f5";
}

.mdi-application-array-outline::before {
  content: "\\f10f6";
}

.mdi-application-braces::before {
  content: "\\f10f7";
}

.mdi-application-braces-outline::before {
  content: "\\f10f8";
}

.mdi-application-brackets::before {
  content: "\\f0c8b";
}

.mdi-application-brackets-outline::before {
  content: "\\f0c8c";
}

.mdi-application-cog::before {
  content: "\\f0675";
}

.mdi-application-cog-outline::before {
  content: "\\f1577";
}

.mdi-application-edit::before {
  content: "\\f00ae";
}

.mdi-application-edit-outline::before {
  content: "\\f0619";
}

.mdi-application-export::before {
  content: "\\f0dad";
}

.mdi-application-import::before {
  content: "\\f0dae";
}

.mdi-application-outline::before {
  content: "\\f0614";
}

.mdi-application-parentheses::before {
  content: "\\f10f9";
}

.mdi-application-parentheses-outline::before {
  content: "\\f10fa";
}

.mdi-application-settings::before {
  content: "\\f0b60";
}

.mdi-application-settings-outline::before {
  content: "\\f1555";
}

.mdi-application-variable::before {
  content: "\\f10fb";
}

.mdi-application-variable-outline::before {
  content: "\\f10fc";
}

.mdi-approximately-equal::before {
  content: "\\f0f9e";
}

.mdi-approximately-equal-box::before {
  content: "\\f0f9f";
}

.mdi-apps::before {
  content: "\\f003b";
}

.mdi-apps-box::before {
  content: "\\f0d46";
}

.mdi-arch::before {
  content: "\\f08c7";
}

.mdi-archive::before {
  content: "\\f003c";
}

.mdi-archive-alert::before {
  content: "\\f14fd";
}

.mdi-archive-alert-outline::before {
  content: "\\f14fe";
}

.mdi-archive-arrow-down::before {
  content: "\\f1259";
}

.mdi-archive-arrow-down-outline::before {
  content: "\\f125a";
}

.mdi-archive-arrow-up::before {
  content: "\\f125b";
}

.mdi-archive-arrow-up-outline::before {
  content: "\\f125c";
}

.mdi-archive-cancel::before {
  content: "\\f174b";
}

.mdi-archive-cancel-outline::before {
  content: "\\f174c";
}

.mdi-archive-check::before {
  content: "\\f174d";
}

.mdi-archive-check-outline::before {
  content: "\\f174e";
}

.mdi-archive-clock::before {
  content: "\\f174f";
}

.mdi-archive-clock-outline::before {
  content: "\\f1750";
}

.mdi-archive-cog::before {
  content: "\\f1751";
}

.mdi-archive-cog-outline::before {
  content: "\\f1752";
}

.mdi-archive-edit::before {
  content: "\\f1753";
}

.mdi-archive-edit-outline::before {
  content: "\\f1754";
}

.mdi-archive-eye::before {
  content: "\\f1755";
}

.mdi-archive-eye-outline::before {
  content: "\\f1756";
}

.mdi-archive-lock::before {
  content: "\\f1757";
}

.mdi-archive-lock-open::before {
  content: "\\f1758";
}

.mdi-archive-lock-open-outline::before {
  content: "\\f1759";
}

.mdi-archive-lock-outline::before {
  content: "\\f175a";
}

.mdi-archive-marker::before {
  content: "\\f175b";
}

.mdi-archive-marker-outline::before {
  content: "\\f175c";
}

.mdi-archive-minus::before {
  content: "\\f175d";
}

.mdi-archive-minus-outline::before {
  content: "\\f175e";
}

.mdi-archive-music::before {
  content: "\\f175f";
}

.mdi-archive-music-outline::before {
  content: "\\f1760";
}

.mdi-archive-off::before {
  content: "\\f1761";
}

.mdi-archive-off-outline::before {
  content: "\\f1762";
}

.mdi-archive-outline::before {
  content: "\\f120e";
}

.mdi-archive-plus::before {
  content: "\\f1763";
}

.mdi-archive-plus-outline::before {
  content: "\\f1764";
}

.mdi-archive-refresh::before {
  content: "\\f1765";
}

.mdi-archive-refresh-outline::before {
  content: "\\f1766";
}

.mdi-archive-remove::before {
  content: "\\f1767";
}

.mdi-archive-remove-outline::before {
  content: "\\f1768";
}

.mdi-archive-search::before {
  content: "\\f1769";
}

.mdi-archive-search-outline::before {
  content: "\\f176a";
}

.mdi-archive-settings::before {
  content: "\\f176b";
}

.mdi-archive-settings-outline::before {
  content: "\\f176c";
}

.mdi-archive-star::before {
  content: "\\f176d";
}

.mdi-archive-star-outline::before {
  content: "\\f176e";
}

.mdi-archive-sync::before {
  content: "\\f176f";
}

.mdi-archive-sync-outline::before {
  content: "\\f1770";
}

.mdi-arm-flex::before {
  content: "\\f0fd7";
}

.mdi-arm-flex-outline::before {
  content: "\\f0fd6";
}

.mdi-arrange-bring-forward::before {
  content: "\\f003d";
}

.mdi-arrange-bring-to-front::before {
  content: "\\f003e";
}

.mdi-arrange-send-backward::before {
  content: "\\f003f";
}

.mdi-arrange-send-to-back::before {
  content: "\\f0040";
}

.mdi-arrow-all::before {
  content: "\\f0041";
}

.mdi-arrow-bottom-left::before {
  content: "\\f0042";
}

.mdi-arrow-bottom-left-bold-box::before {
  content: "\\f1964";
}

.mdi-arrow-bottom-left-bold-box-outline::before {
  content: "\\f1965";
}

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\f09b7";
}

.mdi-arrow-bottom-left-thick::before {
  content: "\\f09b8";
}

.mdi-arrow-bottom-left-thin::before {
  content: "\\f19b6";
}

.mdi-arrow-bottom-left-thin-circle-outline::before {
  content: "\\f1596";
}

.mdi-arrow-bottom-right::before {
  content: "\\f0043";
}

.mdi-arrow-bottom-right-bold-box::before {
  content: "\\f1966";
}

.mdi-arrow-bottom-right-bold-box-outline::before {
  content: "\\f1967";
}

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\f09b9";
}

.mdi-arrow-bottom-right-thick::before {
  content: "\\f09ba";
}

.mdi-arrow-bottom-right-thin::before {
  content: "\\f19b7";
}

.mdi-arrow-bottom-right-thin-circle-outline::before {
  content: "\\f1595";
}

.mdi-arrow-collapse::before {
  content: "\\f0615";
}

.mdi-arrow-collapse-all::before {
  content: "\\f0044";
}

.mdi-arrow-collapse-down::before {
  content: "\\f0792";
}

.mdi-arrow-collapse-horizontal::before {
  content: "\\f084c";
}

.mdi-arrow-collapse-left::before {
  content: "\\f0793";
}

.mdi-arrow-collapse-right::before {
  content: "\\f0794";
}

.mdi-arrow-collapse-up::before {
  content: "\\f0795";
}

.mdi-arrow-collapse-vertical::before {
  content: "\\f084d";
}

.mdi-arrow-decision::before {
  content: "\\f09bb";
}

.mdi-arrow-decision-auto::before {
  content: "\\f09bc";
}

.mdi-arrow-decision-auto-outline::before {
  content: "\\f09bd";
}

.mdi-arrow-decision-outline::before {
  content: "\\f09be";
}

.mdi-arrow-down::before {
  content: "\\f0045";
}

.mdi-arrow-down-bold::before {
  content: "\\f072e";
}

.mdi-arrow-down-bold-box::before {
  content: "\\f072f";
}

.mdi-arrow-down-bold-box-outline::before {
  content: "\\f0730";
}

.mdi-arrow-down-bold-circle::before {
  content: "\\f0047";
}

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\f0048";
}

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\f0049";
}

.mdi-arrow-down-bold-outline::before {
  content: "\\f09bf";
}

.mdi-arrow-down-box::before {
  content: "\\f06c0";
}

.mdi-arrow-down-circle::before {
  content: "\\f0cdb";
}

.mdi-arrow-down-circle-outline::before {
  content: "\\f0cdc";
}

.mdi-arrow-down-drop-circle::before {
  content: "\\f004a";
}

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\f004b";
}

.mdi-arrow-down-left::before {
  content: "\\f17a1";
}

.mdi-arrow-down-left-bold::before {
  content: "\\f17a2";
}

.mdi-arrow-down-right::before {
  content: "\\f17a3";
}

.mdi-arrow-down-right-bold::before {
  content: "\\f17a4";
}

.mdi-arrow-down-thick::before {
  content: "\\f0046";
}

.mdi-arrow-down-thin::before {
  content: "\\f19b3";
}

.mdi-arrow-down-thin-circle-outline::before {
  content: "\\f1599";
}

.mdi-arrow-expand::before {
  content: "\\f0616";
}

.mdi-arrow-expand-all::before {
  content: "\\f004c";
}

.mdi-arrow-expand-down::before {
  content: "\\f0796";
}

.mdi-arrow-expand-horizontal::before {
  content: "\\f084e";
}

.mdi-arrow-expand-left::before {
  content: "\\f0797";
}

.mdi-arrow-expand-right::before {
  content: "\\f0798";
}

.mdi-arrow-expand-up::before {
  content: "\\f0799";
}

.mdi-arrow-expand-vertical::before {
  content: "\\f084f";
}

.mdi-arrow-horizontal-lock::before {
  content: "\\f115b";
}

.mdi-arrow-left::before {
  content: "\\f004d";
}

.mdi-arrow-left-bold::before {
  content: "\\f0731";
}

.mdi-arrow-left-bold-box::before {
  content: "\\f0732";
}

.mdi-arrow-left-bold-box-outline::before {
  content: "\\f0733";
}

.mdi-arrow-left-bold-circle::before {
  content: "\\f004f";
}

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\f0050";
}

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\f0051";
}

.mdi-arrow-left-bold-outline::before {
  content: "\\f09c0";
}

.mdi-arrow-left-bottom::before {
  content: "\\f17a5";
}

.mdi-arrow-left-bottom-bold::before {
  content: "\\f17a6";
}

.mdi-arrow-left-box::before {
  content: "\\f06c1";
}

.mdi-arrow-left-circle::before {
  content: "\\f0cdd";
}

.mdi-arrow-left-circle-outline::before {
  content: "\\f0cde";
}

.mdi-arrow-left-drop-circle::before {
  content: "\\f0052";
}

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\f0053";
}

.mdi-arrow-left-right::before {
  content: "\\f0e73";
}

.mdi-arrow-left-right-bold::before {
  content: "\\f0e74";
}

.mdi-arrow-left-right-bold-outline::before {
  content: "\\f09c1";
}

.mdi-arrow-left-thick::before {
  content: "\\f004e";
}

.mdi-arrow-left-thin::before {
  content: "\\f19b1";
}

.mdi-arrow-left-thin-circle-outline::before {
  content: "\\f159a";
}

.mdi-arrow-left-top::before {
  content: "\\f17a7";
}

.mdi-arrow-left-top-bold::before {
  content: "\\f17a8";
}

.mdi-arrow-projectile::before {
  content: "\\f1840";
}

.mdi-arrow-projectile-multiple::before {
  content: "\\f183f";
}

.mdi-arrow-right::before {
  content: "\\f0054";
}

.mdi-arrow-right-bold::before {
  content: "\\f0734";
}

.mdi-arrow-right-bold-box::before {
  content: "\\f0735";
}

.mdi-arrow-right-bold-box-outline::before {
  content: "\\f0736";
}

.mdi-arrow-right-bold-circle::before {
  content: "\\f0056";
}

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\f0057";
}

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\f0058";
}

.mdi-arrow-right-bold-outline::before {
  content: "\\f09c2";
}

.mdi-arrow-right-bottom::before {
  content: "\\f17a9";
}

.mdi-arrow-right-bottom-bold::before {
  content: "\\f17aa";
}

.mdi-arrow-right-box::before {
  content: "\\f06c2";
}

.mdi-arrow-right-circle::before {
  content: "\\f0cdf";
}

.mdi-arrow-right-circle-outline::before {
  content: "\\f0ce0";
}

.mdi-arrow-right-drop-circle::before {
  content: "\\f0059";
}

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\f005a";
}

.mdi-arrow-right-thick::before {
  content: "\\f0055";
}

.mdi-arrow-right-thin::before {
  content: "\\f19b0";
}

.mdi-arrow-right-thin-circle-outline::before {
  content: "\\f1598";
}

.mdi-arrow-right-top::before {
  content: "\\f17ab";
}

.mdi-arrow-right-top-bold::before {
  content: "\\f17ac";
}

.mdi-arrow-split-horizontal::before {
  content: "\\f093b";
}

.mdi-arrow-split-vertical::before {
  content: "\\f093c";
}

.mdi-arrow-top-left::before {
  content: "\\f005b";
}

.mdi-arrow-top-left-bold-box::before {
  content: "\\f1968";
}

.mdi-arrow-top-left-bold-box-outline::before {
  content: "\\f1969";
}

.mdi-arrow-top-left-bold-outline::before {
  content: "\\f09c3";
}

.mdi-arrow-top-left-bottom-right::before {
  content: "\\f0e75";
}

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\f0e76";
}

.mdi-arrow-top-left-thick::before {
  content: "\\f09c4";
}

.mdi-arrow-top-left-thin::before {
  content: "\\f19b5";
}

.mdi-arrow-top-left-thin-circle-outline::before {
  content: "\\f1593";
}

.mdi-arrow-top-right::before {
  content: "\\f005c";
}

.mdi-arrow-top-right-bold-box::before {
  content: "\\f196a";
}

.mdi-arrow-top-right-bold-box-outline::before {
  content: "\\f196b";
}

.mdi-arrow-top-right-bold-outline::before {
  content: "\\f09c5";
}

.mdi-arrow-top-right-bottom-left::before {
  content: "\\f0e77";
}

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\f0e78";
}

.mdi-arrow-top-right-thick::before {
  content: "\\f09c6";
}

.mdi-arrow-top-right-thin::before {
  content: "\\f19b4";
}

.mdi-arrow-top-right-thin-circle-outline::before {
  content: "\\f1594";
}

.mdi-arrow-u-down-left::before {
  content: "\\f17ad";
}

.mdi-arrow-u-down-left-bold::before {
  content: "\\f17ae";
}

.mdi-arrow-u-down-right::before {
  content: "\\f17af";
}

.mdi-arrow-u-down-right-bold::before {
  content: "\\f17b0";
}

.mdi-arrow-u-left-bottom::before {
  content: "\\f17b1";
}

.mdi-arrow-u-left-bottom-bold::before {
  content: "\\f17b2";
}

.mdi-arrow-u-left-top::before {
  content: "\\f17b3";
}

.mdi-arrow-u-left-top-bold::before {
  content: "\\f17b4";
}

.mdi-arrow-u-right-bottom::before {
  content: "\\f17b5";
}

.mdi-arrow-u-right-bottom-bold::before {
  content: "\\f17b6";
}

.mdi-arrow-u-right-top::before {
  content: "\\f17b7";
}

.mdi-arrow-u-right-top-bold::before {
  content: "\\f17b8";
}

.mdi-arrow-u-up-left::before {
  content: "\\f17b9";
}

.mdi-arrow-u-up-left-bold::before {
  content: "\\f17ba";
}

.mdi-arrow-u-up-right::before {
  content: "\\f17bb";
}

.mdi-arrow-u-up-right-bold::before {
  content: "\\f17bc";
}

.mdi-arrow-up::before {
  content: "\\f005d";
}

.mdi-arrow-up-bold::before {
  content: "\\f0737";
}

.mdi-arrow-up-bold-box::before {
  content: "\\f0738";
}

.mdi-arrow-up-bold-box-outline::before {
  content: "\\f0739";
}

.mdi-arrow-up-bold-circle::before {
  content: "\\f005f";
}

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\f0060";
}

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\f0061";
}

.mdi-arrow-up-bold-outline::before {
  content: "\\f09c7";
}

.mdi-arrow-up-box::before {
  content: "\\f06c3";
}

.mdi-arrow-up-circle::before {
  content: "\\f0ce1";
}

.mdi-arrow-up-circle-outline::before {
  content: "\\f0ce2";
}

.mdi-arrow-up-down::before {
  content: "\\f0e79";
}

.mdi-arrow-up-down-bold::before {
  content: "\\f0e7a";
}

.mdi-arrow-up-down-bold-outline::before {
  content: "\\f09c8";
}

.mdi-arrow-up-drop-circle::before {
  content: "\\f0062";
}

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\f0063";
}

.mdi-arrow-up-left::before {
  content: "\\f17bd";
}

.mdi-arrow-up-left-bold::before {
  content: "\\f17be";
}

.mdi-arrow-up-right::before {
  content: "\\f17bf";
}

.mdi-arrow-up-right-bold::before {
  content: "\\f17c0";
}

.mdi-arrow-up-thick::before {
  content: "\\f005e";
}

.mdi-arrow-up-thin::before {
  content: "\\f19b2";
}

.mdi-arrow-up-thin-circle-outline::before {
  content: "\\f1597";
}

.mdi-arrow-vertical-lock::before {
  content: "\\f115c";
}

.mdi-artstation::before {
  content: "\\f0b5b";
}

.mdi-aspect-ratio::before {
  content: "\\f0a24";
}

.mdi-assistant::before {
  content: "\\f0064";
}

.mdi-asterisk::before {
  content: "\\f06c4";
}

.mdi-at::before {
  content: "\\f0065";
}

.mdi-atlassian::before {
  content: "\\f0804";
}

.mdi-atm::before {
  content: "\\f0d47";
}

.mdi-atom::before {
  content: "\\f0768";
}

.mdi-atom-variant::before {
  content: "\\f0e7b";
}

.mdi-attachment::before {
  content: "\\f0066";
}

.mdi-audio-input-rca::before {
  content: "\\f186b";
}

.mdi-audio-input-stereo-minijack::before {
  content: "\\f186c";
}

.mdi-audio-input-xlr::before {
  content: "\\f186d";
}

.mdi-audio-video::before {
  content: "\\f093d";
}

.mdi-audio-video-off::before {
  content: "\\f11b6";
}

.mdi-augmented-reality::before {
  content: "\\f0850";
}

.mdi-auto-download::before {
  content: "\\f137e";
}

.mdi-auto-fix::before {
  content: "\\f0068";
}

.mdi-auto-upload::before {
  content: "\\f0069";
}

.mdi-autorenew::before {
  content: "\\f006a";
}

.mdi-av-timer::before {
  content: "\\f006b";
}

.mdi-aws::before {
  content: "\\f0e0f";
}

.mdi-axe::before {
  content: "\\f08c8";
}

.mdi-axe-battle::before {
  content: "\\f1842";
}

.mdi-axis::before {
  content: "\\f0d48";
}

.mdi-axis-arrow::before {
  content: "\\f0d49";
}

.mdi-axis-arrow-info::before {
  content: "\\f140e";
}

.mdi-axis-arrow-lock::before {
  content: "\\f0d4a";
}

.mdi-axis-lock::before {
  content: "\\f0d4b";
}

.mdi-axis-x-arrow::before {
  content: "\\f0d4c";
}

.mdi-axis-x-arrow-lock::before {
  content: "\\f0d4d";
}

.mdi-axis-x-rotate-clockwise::before {
  content: "\\f0d4e";
}

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\f0d4f";
}

.mdi-axis-x-y-arrow-lock::before {
  content: "\\f0d50";
}

.mdi-axis-y-arrow::before {
  content: "\\f0d51";
}

.mdi-axis-y-arrow-lock::before {
  content: "\\f0d52";
}

.mdi-axis-y-rotate-clockwise::before {
  content: "\\f0d53";
}

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\f0d54";
}

.mdi-axis-z-arrow::before {
  content: "\\f0d55";
}

.mdi-axis-z-arrow-lock::before {
  content: "\\f0d56";
}

.mdi-axis-z-rotate-clockwise::before {
  content: "\\f0d57";
}

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\f0d58";
}

.mdi-babel::before {
  content: "\\f0a25";
}

.mdi-baby::before {
  content: "\\f006c";
}

.mdi-baby-bottle::before {
  content: "\\f0f39";
}

.mdi-baby-bottle-outline::before {
  content: "\\f0f3a";
}

.mdi-baby-buggy::before {
  content: "\\f13e0";
}

.mdi-baby-carriage::before {
  content: "\\f068f";
}

.mdi-baby-carriage-off::before {
  content: "\\f0fa0";
}

.mdi-baby-face::before {
  content: "\\f0e7c";
}

.mdi-baby-face-outline::before {
  content: "\\f0e7d";
}

.mdi-backburger::before {
  content: "\\f006d";
}

.mdi-backspace::before {
  content: "\\f006e";
}

.mdi-backspace-outline::before {
  content: "\\f0b5c";
}

.mdi-backspace-reverse::before {
  content: "\\f0e7e";
}

.mdi-backspace-reverse-outline::before {
  content: "\\f0e7f";
}

.mdi-backup-restore::before {
  content: "\\f006f";
}

.mdi-bacteria::before {
  content: "\\f0ed5";
}

.mdi-bacteria-outline::before {
  content: "\\f0ed6";
}

.mdi-badge-account::before {
  content: "\\f0da7";
}

.mdi-badge-account-alert::before {
  content: "\\f0da8";
}

.mdi-badge-account-alert-outline::before {
  content: "\\f0da9";
}

.mdi-badge-account-horizontal::before {
  content: "\\f0e0d";
}

.mdi-badge-account-horizontal-outline::before {
  content: "\\f0e0e";
}

.mdi-badge-account-outline::before {
  content: "\\f0daa";
}

.mdi-badminton::before {
  content: "\\f0851";
}

.mdi-bag-carry-on::before {
  content: "\\f0f3b";
}

.mdi-bag-carry-on-check::before {
  content: "\\f0d65";
}

.mdi-bag-carry-on-off::before {
  content: "\\f0f3c";
}

.mdi-bag-checked::before {
  content: "\\f0f3d";
}

.mdi-bag-personal::before {
  content: "\\f0e10";
}

.mdi-bag-personal-off::before {
  content: "\\f0e11";
}

.mdi-bag-personal-off-outline::before {
  content: "\\f0e12";
}

.mdi-bag-personal-outline::before {
  content: "\\f0e13";
}

.mdi-bag-suitcase::before {
  content: "\\f158b";
}

.mdi-bag-suitcase-off::before {
  content: "\\f158d";
}

.mdi-bag-suitcase-off-outline::before {
  content: "\\f158e";
}

.mdi-bag-suitcase-outline::before {
  content: "\\f158c";
}

.mdi-baguette::before {
  content: "\\f0f3e";
}

.mdi-balcony::before {
  content: "\\f1817";
}

.mdi-balloon::before {
  content: "\\f0a26";
}

.mdi-ballot::before {
  content: "\\f09c9";
}

.mdi-ballot-outline::before {
  content: "\\f09ca";
}

.mdi-ballot-recount::before {
  content: "\\f0c39";
}

.mdi-ballot-recount-outline::before {
  content: "\\f0c3a";
}

.mdi-bandage::before {
  content: "\\f0daf";
}

.mdi-bank::before {
  content: "\\f0070";
}

.mdi-bank-check::before {
  content: "\\f1655";
}

.mdi-bank-minus::before {
  content: "\\f0db0";
}

.mdi-bank-off::before {
  content: "\\f1656";
}

.mdi-bank-off-outline::before {
  content: "\\f1657";
}

.mdi-bank-outline::before {
  content: "\\f0e80";
}

.mdi-bank-plus::before {
  content: "\\f0db1";
}

.mdi-bank-remove::before {
  content: "\\f0db2";
}

.mdi-bank-transfer::before {
  content: "\\f0a27";
}

.mdi-bank-transfer-in::before {
  content: "\\f0a28";
}

.mdi-bank-transfer-out::before {
  content: "\\f0a29";
}

.mdi-barcode::before {
  content: "\\f0071";
}

.mdi-barcode-off::before {
  content: "\\f1236";
}

.mdi-barcode-scan::before {
  content: "\\f0072";
}

.mdi-barley::before {
  content: "\\f0073";
}

.mdi-barley-off::before {
  content: "\\f0b5d";
}

.mdi-barn::before {
  content: "\\f0b5e";
}

.mdi-barrel::before {
  content: "\\f0074";
}

.mdi-baseball::before {
  content: "\\f0852";
}

.mdi-baseball-bat::before {
  content: "\\f0853";
}

.mdi-baseball-diamond::before {
  content: "\\f15ec";
}

.mdi-baseball-diamond-outline::before {
  content: "\\f15ed";
}

.mdi-bash::before {
  content: "\\f1183";
}

.mdi-basket::before {
  content: "\\f0076";
}

.mdi-basket-check::before {
  content: "\\f18e5";
}

.mdi-basket-check-outline::before {
  content: "\\f18e6";
}

.mdi-basket-fill::before {
  content: "\\f0077";
}

.mdi-basket-minus::before {
  content: "\\f1523";
}

.mdi-basket-minus-outline::before {
  content: "\\f1524";
}

.mdi-basket-off::before {
  content: "\\f1525";
}

.mdi-basket-off-outline::before {
  content: "\\f1526";
}

.mdi-basket-outline::before {
  content: "\\f1181";
}

.mdi-basket-plus::before {
  content: "\\f1527";
}

.mdi-basket-plus-outline::before {
  content: "\\f1528";
}

.mdi-basket-remove::before {
  content: "\\f1529";
}

.mdi-basket-remove-outline::before {
  content: "\\f152a";
}

.mdi-basket-unfill::before {
  content: "\\f0078";
}

.mdi-basketball::before {
  content: "\\f0806";
}

.mdi-basketball-hoop::before {
  content: "\\f0c3b";
}

.mdi-basketball-hoop-outline::before {
  content: "\\f0c3c";
}

.mdi-bat::before {
  content: "\\f0b5f";
}

.mdi-bathtub::before {
  content: "\\f1818";
}

.mdi-bathtub-outline::before {
  content: "\\f1819";
}

.mdi-battery::before {
  content: "\\f0079";
}

.mdi-battery-10::before {
  content: "\\f007a";
}

.mdi-battery-10-bluetooth::before {
  content: "\\f093e";
}

.mdi-battery-20::before {
  content: "\\f007b";
}

.mdi-battery-20-bluetooth::before {
  content: "\\f093f";
}

.mdi-battery-30::before {
  content: "\\f007c";
}

.mdi-battery-30-bluetooth::before {
  content: "\\f0940";
}

.mdi-battery-40::before {
  content: "\\f007d";
}

.mdi-battery-40-bluetooth::before {
  content: "\\f0941";
}

.mdi-battery-50::before {
  content: "\\f007e";
}

.mdi-battery-50-bluetooth::before {
  content: "\\f0942";
}

.mdi-battery-60::before {
  content: "\\f007f";
}

.mdi-battery-60-bluetooth::before {
  content: "\\f0943";
}

.mdi-battery-70::before {
  content: "\\f0080";
}

.mdi-battery-70-bluetooth::before {
  content: "\\f0944";
}

.mdi-battery-80::before {
  content: "\\f0081";
}

.mdi-battery-80-bluetooth::before {
  content: "\\f0945";
}

.mdi-battery-90::before {
  content: "\\f0082";
}

.mdi-battery-90-bluetooth::before {
  content: "\\f0946";
}

.mdi-battery-alert::before {
  content: "\\f0083";
}

.mdi-battery-alert-bluetooth::before {
  content: "\\f0947";
}

.mdi-battery-alert-variant::before {
  content: "\\f10cc";
}

.mdi-battery-alert-variant-outline::before {
  content: "\\f10cd";
}

.mdi-battery-arrow-down::before {
  content: "\\f17de";
}

.mdi-battery-arrow-down-outline::before {
  content: "\\f17df";
}

.mdi-battery-arrow-up::before {
  content: "\\f17e0";
}

.mdi-battery-arrow-up-outline::before {
  content: "\\f17e1";
}

.mdi-battery-bluetooth::before {
  content: "\\f0948";
}

.mdi-battery-bluetooth-variant::before {
  content: "\\f0949";
}

.mdi-battery-charging::before {
  content: "\\f0084";
}

.mdi-battery-charging-10::before {
  content: "\\f089c";
}

.mdi-battery-charging-100::before {
  content: "\\f0085";
}

.mdi-battery-charging-20::before {
  content: "\\f0086";
}

.mdi-battery-charging-30::before {
  content: "\\f0087";
}

.mdi-battery-charging-40::before {
  content: "\\f0088";
}

.mdi-battery-charging-50::before {
  content: "\\f089d";
}

.mdi-battery-charging-60::before {
  content: "\\f0089";
}

.mdi-battery-charging-70::before {
  content: "\\f089e";
}

.mdi-battery-charging-80::before {
  content: "\\f008a";
}

.mdi-battery-charging-90::before {
  content: "\\f008b";
}

.mdi-battery-charging-high::before {
  content: "\\f12a6";
}

.mdi-battery-charging-low::before {
  content: "\\f12a4";
}

.mdi-battery-charging-medium::before {
  content: "\\f12a5";
}

.mdi-battery-charging-outline::before {
  content: "\\f089f";
}

.mdi-battery-charging-wireless::before {
  content: "\\f0807";
}

.mdi-battery-charging-wireless-10::before {
  content: "\\f0808";
}

.mdi-battery-charging-wireless-20::before {
  content: "\\f0809";
}

.mdi-battery-charging-wireless-30::before {
  content: "\\f080a";
}

.mdi-battery-charging-wireless-40::before {
  content: "\\f080b";
}

.mdi-battery-charging-wireless-50::before {
  content: "\\f080c";
}

.mdi-battery-charging-wireless-60::before {
  content: "\\f080d";
}

.mdi-battery-charging-wireless-70::before {
  content: "\\f080e";
}

.mdi-battery-charging-wireless-80::before {
  content: "\\f080f";
}

.mdi-battery-charging-wireless-90::before {
  content: "\\f0810";
}

.mdi-battery-charging-wireless-alert::before {
  content: "\\f0811";
}

.mdi-battery-charging-wireless-outline::before {
  content: "\\f0812";
}

.mdi-battery-check::before {
  content: "\\f17e2";
}

.mdi-battery-check-outline::before {
  content: "\\f17e3";
}

.mdi-battery-heart::before {
  content: "\\f120f";
}

.mdi-battery-heart-outline::before {
  content: "\\f1210";
}

.mdi-battery-heart-variant::before {
  content: "\\f1211";
}

.mdi-battery-high::before {
  content: "\\f12a3";
}

.mdi-battery-lock::before {
  content: "\\f179c";
}

.mdi-battery-lock-open::before {
  content: "\\f179d";
}

.mdi-battery-low::before {
  content: "\\f12a1";
}

.mdi-battery-medium::before {
  content: "\\f12a2";
}

.mdi-battery-minus::before {
  content: "\\f17e4";
}

.mdi-battery-minus-outline::before {
  content: "\\f17e5";
}

.mdi-battery-minus-variant::before {
  content: "\\f008c";
}

.mdi-battery-negative::before {
  content: "\\f008d";
}

.mdi-battery-off::before {
  content: "\\f125d";
}

.mdi-battery-off-outline::before {
  content: "\\f125e";
}

.mdi-battery-outline::before {
  content: "\\f008e";
}

.mdi-battery-plus::before {
  content: "\\f17e6";
}

.mdi-battery-plus-outline::before {
  content: "\\f17e7";
}

.mdi-battery-plus-variant::before {
  content: "\\f008f";
}

.mdi-battery-positive::before {
  content: "\\f0090";
}

.mdi-battery-remove::before {
  content: "\\f17e8";
}

.mdi-battery-remove-outline::before {
  content: "\\f17e9";
}

.mdi-battery-sync::before {
  content: "\\f1834";
}

.mdi-battery-sync-outline::before {
  content: "\\f1835";
}

.mdi-battery-unknown::before {
  content: "\\f0091";
}

.mdi-battery-unknown-bluetooth::before {
  content: "\\f094a";
}

.mdi-beach::before {
  content: "\\f0092";
}

.mdi-beaker::before {
  content: "\\f0cea";
}

.mdi-beaker-alert::before {
  content: "\\f1229";
}

.mdi-beaker-alert-outline::before {
  content: "\\f122a";
}

.mdi-beaker-check::before {
  content: "\\f122b";
}

.mdi-beaker-check-outline::before {
  content: "\\f122c";
}

.mdi-beaker-minus::before {
  content: "\\f122d";
}

.mdi-beaker-minus-outline::before {
  content: "\\f122e";
}

.mdi-beaker-outline::before {
  content: "\\f0690";
}

.mdi-beaker-plus::before {
  content: "\\f122f";
}

.mdi-beaker-plus-outline::before {
  content: "\\f1230";
}

.mdi-beaker-question::before {
  content: "\\f1231";
}

.mdi-beaker-question-outline::before {
  content: "\\f1232";
}

.mdi-beaker-remove::before {
  content: "\\f1233";
}

.mdi-beaker-remove-outline::before {
  content: "\\f1234";
}

.mdi-bed::before {
  content: "\\f02e3";
}

.mdi-bed-double::before {
  content: "\\f0fd4";
}

.mdi-bed-double-outline::before {
  content: "\\f0fd3";
}

.mdi-bed-empty::before {
  content: "\\f08a0";
}

.mdi-bed-king::before {
  content: "\\f0fd2";
}

.mdi-bed-king-outline::before {
  content: "\\f0fd1";
}

.mdi-bed-outline::before {
  content: "\\f0099";
}

.mdi-bed-queen::before {
  content: "\\f0fd0";
}

.mdi-bed-queen-outline::before {
  content: "\\f0fdb";
}

.mdi-bed-single::before {
  content: "\\f106d";
}

.mdi-bed-single-outline::before {
  content: "\\f106e";
}

.mdi-bee::before {
  content: "\\f0fa1";
}

.mdi-bee-flower::before {
  content: "\\f0fa2";
}

.mdi-beehive-off-outline::before {
  content: "\\f13ed";
}

.mdi-beehive-outline::before {
  content: "\\f10ce";
}

.mdi-beekeeper::before {
  content: "\\f14e2";
}

.mdi-beer::before {
  content: "\\f0098";
}

.mdi-beer-outline::before {
  content: "\\f130c";
}

.mdi-bell::before {
  content: "\\f009a";
}

.mdi-bell-alert::before {
  content: "\\f0d59";
}

.mdi-bell-alert-outline::before {
  content: "\\f0e81";
}

.mdi-bell-badge::before {
  content: "\\f116b";
}

.mdi-bell-badge-outline::before {
  content: "\\f0178";
}

.mdi-bell-cancel::before {
  content: "\\f13e7";
}

.mdi-bell-cancel-outline::before {
  content: "\\f13e8";
}

.mdi-bell-check::before {
  content: "\\f11e5";
}

.mdi-bell-check-outline::before {
  content: "\\f11e6";
}

.mdi-bell-circle::before {
  content: "\\f0d5a";
}

.mdi-bell-circle-outline::before {
  content: "\\f0d5b";
}

.mdi-bell-minus::before {
  content: "\\f13e9";
}

.mdi-bell-minus-outline::before {
  content: "\\f13ea";
}

.mdi-bell-off::before {
  content: "\\f009b";
}

.mdi-bell-off-outline::before {
  content: "\\f0a91";
}

.mdi-bell-outline::before {
  content: "\\f009c";
}

.mdi-bell-plus::before {
  content: "\\f009d";
}

.mdi-bell-plus-outline::before {
  content: "\\f0a92";
}

.mdi-bell-remove::before {
  content: "\\f13eb";
}

.mdi-bell-remove-outline::before {
  content: "\\f13ec";
}

.mdi-bell-ring::before {
  content: "\\f009e";
}

.mdi-bell-ring-outline::before {
  content: "\\f009f";
}

.mdi-bell-sleep::before {
  content: "\\f00a0";
}

.mdi-bell-sleep-outline::before {
  content: "\\f0a93";
}

.mdi-beta::before {
  content: "\\f00a1";
}

.mdi-betamax::before {
  content: "\\f09cb";
}

.mdi-biathlon::before {
  content: "\\f0e14";
}

.mdi-bicycle::before {
  content: "\\f109c";
}

.mdi-bicycle-basket::before {
  content: "\\f1235";
}

.mdi-bicycle-cargo::before {
  content: "\\f189c";
}

.mdi-bicycle-electric::before {
  content: "\\f15b4";
}

.mdi-bicycle-penny-farthing::before {
  content: "\\f15e9";
}

.mdi-bike::before {
  content: "\\f00a3";
}

.mdi-bike-fast::before {
  content: "\\f111f";
}

.mdi-billboard::before {
  content: "\\f1010";
}

.mdi-billiards::before {
  content: "\\f0b61";
}

.mdi-billiards-rack::before {
  content: "\\f0b62";
}

.mdi-binoculars::before {
  content: "\\f00a5";
}

.mdi-bio::before {
  content: "\\f00a6";
}

.mdi-biohazard::before {
  content: "\\f00a7";
}

.mdi-bird::before {
  content: "\\f15c6";
}

.mdi-bitbucket::before {
  content: "\\f00a8";
}

.mdi-bitcoin::before {
  content: "\\f0813";
}

.mdi-black-mesa::before {
  content: "\\f00a9";
}

.mdi-blender::before {
  content: "\\f0ceb";
}

.mdi-blender-outline::before {
  content: "\\f181a";
}

.mdi-blender-software::before {
  content: "\\f00ab";
}

.mdi-blinds::before {
  content: "\\f00ac";
}

.mdi-blinds-open::before {
  content: "\\f1011";
}

.mdi-block-helper::before {
  content: "\\f00ad";
}

.mdi-blood-bag::before {
  content: "\\f0cec";
}

.mdi-bluetooth::before {
  content: "\\f00af";
}

.mdi-bluetooth-audio::before {
  content: "\\f00b0";
}

.mdi-bluetooth-connect::before {
  content: "\\f00b1";
}

.mdi-bluetooth-off::before {
  content: "\\f00b2";
}

.mdi-bluetooth-settings::before {
  content: "\\f00b3";
}

.mdi-bluetooth-transfer::before {
  content: "\\f00b4";
}

.mdi-blur::before {
  content: "\\f00b5";
}

.mdi-blur-linear::before {
  content: "\\f00b6";
}

.mdi-blur-off::before {
  content: "\\f00b7";
}

.mdi-blur-radial::before {
  content: "\\f00b8";
}

.mdi-bolt::before {
  content: "\\f0db3";
}

.mdi-bomb::before {
  content: "\\f0691";
}

.mdi-bomb-off::before {
  content: "\\f06c5";
}

.mdi-bone::before {
  content: "\\f00b9";
}

.mdi-book::before {
  content: "\\f00ba";
}

.mdi-book-account::before {
  content: "\\f13ad";
}

.mdi-book-account-outline::before {
  content: "\\f13ae";
}

.mdi-book-alert::before {
  content: "\\f167c";
}

.mdi-book-alert-outline::before {
  content: "\\f167d";
}

.mdi-book-alphabet::before {
  content: "\\f061d";
}

.mdi-book-arrow-down::before {
  content: "\\f167e";
}

.mdi-book-arrow-down-outline::before {
  content: "\\f167f";
}

.mdi-book-arrow-left::before {
  content: "\\f1680";
}

.mdi-book-arrow-left-outline::before {
  content: "\\f1681";
}

.mdi-book-arrow-right::before {
  content: "\\f1682";
}

.mdi-book-arrow-right-outline::before {
  content: "\\f1683";
}

.mdi-book-arrow-up::before {
  content: "\\f1684";
}

.mdi-book-arrow-up-outline::before {
  content: "\\f1685";
}

.mdi-book-cancel::before {
  content: "\\f1686";
}

.mdi-book-cancel-outline::before {
  content: "\\f1687";
}

.mdi-book-check::before {
  content: "\\f14f3";
}

.mdi-book-check-outline::before {
  content: "\\f14f4";
}

.mdi-book-clock::before {
  content: "\\f1688";
}

.mdi-book-clock-outline::before {
  content: "\\f1689";
}

.mdi-book-cog::before {
  content: "\\f168a";
}

.mdi-book-cog-outline::before {
  content: "\\f168b";
}

.mdi-book-cross::before {
  content: "\\f00a2";
}

.mdi-book-edit::before {
  content: "\\f168c";
}

.mdi-book-edit-outline::before {
  content: "\\f168d";
}

.mdi-book-education::before {
  content: "\\f16c9";
}

.mdi-book-education-outline::before {
  content: "\\f16ca";
}

.mdi-book-information-variant::before {
  content: "\\f106f";
}

.mdi-book-lock::before {
  content: "\\f079a";
}

.mdi-book-lock-open::before {
  content: "\\f079b";
}

.mdi-book-lock-open-outline::before {
  content: "\\f168e";
}

.mdi-book-lock-outline::before {
  content: "\\f168f";
}

.mdi-book-marker::before {
  content: "\\f1690";
}

.mdi-book-marker-outline::before {
  content: "\\f1691";
}

.mdi-book-minus::before {
  content: "\\f05d9";
}

.mdi-book-minus-multiple::before {
  content: "\\f0a94";
}

.mdi-book-minus-multiple-outline::before {
  content: "\\f090b";
}

.mdi-book-minus-outline::before {
  content: "\\f1692";
}

.mdi-book-multiple::before {
  content: "\\f00bb";
}

.mdi-book-multiple-outline::before {
  content: "\\f0436";
}

.mdi-book-music::before {
  content: "\\f0067";
}

.mdi-book-music-outline::before {
  content: "\\f1693";
}

.mdi-book-off::before {
  content: "\\f1694";
}

.mdi-book-off-outline::before {
  content: "\\f1695";
}

.mdi-book-open::before {
  content: "\\f00bd";
}

.mdi-book-open-blank-variant::before {
  content: "\\f00be";
}

.mdi-book-open-outline::before {
  content: "\\f0b63";
}

.mdi-book-open-page-variant::before {
  content: "\\f05da";
}

.mdi-book-open-page-variant-outline::before {
  content: "\\f15d6";
}

.mdi-book-open-variant::before {
  content: "\\f14f7";
}

.mdi-book-outline::before {
  content: "\\f0b64";
}

.mdi-book-play::before {
  content: "\\f0e82";
}

.mdi-book-play-outline::before {
  content: "\\f0e83";
}

.mdi-book-plus::before {
  content: "\\f05db";
}

.mdi-book-plus-multiple::before {
  content: "\\f0a95";
}

.mdi-book-plus-multiple-outline::before {
  content: "\\f0ade";
}

.mdi-book-plus-outline::before {
  content: "\\f1696";
}

.mdi-book-refresh::before {
  content: "\\f1697";
}

.mdi-book-refresh-outline::before {
  content: "\\f1698";
}

.mdi-book-remove::before {
  content: "\\f0a97";
}

.mdi-book-remove-multiple::before {
  content: "\\f0a96";
}

.mdi-book-remove-multiple-outline::before {
  content: "\\f04ca";
}

.mdi-book-remove-outline::before {
  content: "\\f1699";
}

.mdi-book-search::before {
  content: "\\f0e84";
}

.mdi-book-search-outline::before {
  content: "\\f0e85";
}

.mdi-book-settings::before {
  content: "\\f169a";
}

.mdi-book-settings-outline::before {
  content: "\\f169b";
}

.mdi-book-sync::before {
  content: "\\f169c";
}

.mdi-book-sync-outline::before {
  content: "\\f16c8";
}

.mdi-book-variant::before {
  content: "\\f00bf";
}

.mdi-book-variant-multiple::before {
  content: "\\f00bc";
}

.mdi-bookmark::before {
  content: "\\f00c0";
}

.mdi-bookmark-box-multiple::before {
  content: "\\f196c";
}

.mdi-bookmark-box-multiple-outline::before {
  content: "\\f196d";
}

.mdi-bookmark-check::before {
  content: "\\f00c1";
}

.mdi-bookmark-check-outline::before {
  content: "\\f137b";
}

.mdi-bookmark-minus::before {
  content: "\\f09cc";
}

.mdi-bookmark-minus-outline::before {
  content: "\\f09cd";
}

.mdi-bookmark-multiple::before {
  content: "\\f0e15";
}

.mdi-bookmark-multiple-outline::before {
  content: "\\f0e16";
}

.mdi-bookmark-music::before {
  content: "\\f00c2";
}

.mdi-bookmark-music-outline::before {
  content: "\\f1379";
}

.mdi-bookmark-off::before {
  content: "\\f09ce";
}

.mdi-bookmark-off-outline::before {
  content: "\\f09cf";
}

.mdi-bookmark-outline::before {
  content: "\\f00c3";
}

.mdi-bookmark-plus::before {
  content: "\\f00c5";
}

.mdi-bookmark-plus-outline::before {
  content: "\\f00c4";
}

.mdi-bookmark-remove::before {
  content: "\\f00c6";
}

.mdi-bookmark-remove-outline::before {
  content: "\\f137a";
}

.mdi-bookshelf::before {
  content: "\\f125f";
}

.mdi-boom-gate::before {
  content: "\\f0e86";
}

.mdi-boom-gate-alert::before {
  content: "\\f0e87";
}

.mdi-boom-gate-alert-outline::before {
  content: "\\f0e88";
}

.mdi-boom-gate-arrow-down::before {
  content: "\\f0e89";
}

.mdi-boom-gate-arrow-down-outline::before {
  content: "\\f0e8a";
}

.mdi-boom-gate-arrow-up::before {
  content: "\\f0e8c";
}

.mdi-boom-gate-arrow-up-outline::before {
  content: "\\f0e8d";
}

.mdi-boom-gate-outline::before {
  content: "\\f0e8b";
}

.mdi-boom-gate-up::before {
  content: "\\f17f9";
}

.mdi-boom-gate-up-outline::before {
  content: "\\f17fa";
}

.mdi-boombox::before {
  content: "\\f05dc";
}

.mdi-boomerang::before {
  content: "\\f10cf";
}

.mdi-bootstrap::before {
  content: "\\f06c6";
}

.mdi-border-all::before {
  content: "\\f00c7";
}

.mdi-border-all-variant::before {
  content: "\\f08a1";
}

.mdi-border-bottom::before {
  content: "\\f00c8";
}

.mdi-border-bottom-variant::before {
  content: "\\f08a2";
}

.mdi-border-color::before {
  content: "\\f00c9";
}

.mdi-border-horizontal::before {
  content: "\\f00ca";
}

.mdi-border-inside::before {
  content: "\\f00cb";
}

.mdi-border-left::before {
  content: "\\f00cc";
}

.mdi-border-left-variant::before {
  content: "\\f08a3";
}

.mdi-border-none::before {
  content: "\\f00cd";
}

.mdi-border-none-variant::before {
  content: "\\f08a4";
}

.mdi-border-outside::before {
  content: "\\f00ce";
}

.mdi-border-right::before {
  content: "\\f00cf";
}

.mdi-border-right-variant::before {
  content: "\\f08a5";
}

.mdi-border-style::before {
  content: "\\f00d0";
}

.mdi-border-top::before {
  content: "\\f00d1";
}

.mdi-border-top-variant::before {
  content: "\\f08a6";
}

.mdi-border-vertical::before {
  content: "\\f00d2";
}

.mdi-bottle-soda::before {
  content: "\\f1070";
}

.mdi-bottle-soda-classic::before {
  content: "\\f1071";
}

.mdi-bottle-soda-classic-outline::before {
  content: "\\f1363";
}

.mdi-bottle-soda-outline::before {
  content: "\\f1072";
}

.mdi-bottle-tonic::before {
  content: "\\f112e";
}

.mdi-bottle-tonic-outline::before {
  content: "\\f112f";
}

.mdi-bottle-tonic-plus::before {
  content: "\\f1130";
}

.mdi-bottle-tonic-plus-outline::before {
  content: "\\f1131";
}

.mdi-bottle-tonic-skull::before {
  content: "\\f1132";
}

.mdi-bottle-tonic-skull-outline::before {
  content: "\\f1133";
}

.mdi-bottle-wine::before {
  content: "\\f0854";
}

.mdi-bottle-wine-outline::before {
  content: "\\f1310";
}

.mdi-bow-arrow::before {
  content: "\\f1841";
}

.mdi-bow-tie::before {
  content: "\\f0678";
}

.mdi-bowl::before {
  content: "\\f028e";
}

.mdi-bowl-mix::before {
  content: "\\f0617";
}

.mdi-bowl-mix-outline::before {
  content: "\\f02e4";
}

.mdi-bowl-outline::before {
  content: "\\f02a9";
}

.mdi-bowling::before {
  content: "\\f00d3";
}

.mdi-box::before {
  content: "\\f00d4";
}

.mdi-box-cutter::before {
  content: "\\f00d5";
}

.mdi-box-cutter-off::before {
  content: "\\f0b4a";
}

.mdi-box-shadow::before {
  content: "\\f0637";
}

.mdi-boxing-glove::before {
  content: "\\f0b65";
}

.mdi-braille::before {
  content: "\\f09d0";
}

.mdi-brain::before {
  content: "\\f09d1";
}

.mdi-bread-slice::before {
  content: "\\f0cee";
}

.mdi-bread-slice-outline::before {
  content: "\\f0cef";
}

.mdi-bridge::before {
  content: "\\f0618";
}

.mdi-briefcase::before {
  content: "\\f00d6";
}

.mdi-briefcase-account::before {
  content: "\\f0cf0";
}

.mdi-briefcase-account-outline::before {
  content: "\\f0cf1";
}

.mdi-briefcase-check::before {
  content: "\\f00d7";
}

.mdi-briefcase-check-outline::before {
  content: "\\f131e";
}

.mdi-briefcase-clock::before {
  content: "\\f10d0";
}

.mdi-briefcase-clock-outline::before {
  content: "\\f10d1";
}

.mdi-briefcase-download::before {
  content: "\\f00d8";
}

.mdi-briefcase-download-outline::before {
  content: "\\f0c3d";
}

.mdi-briefcase-edit::before {
  content: "\\f0a98";
}

.mdi-briefcase-edit-outline::before {
  content: "\\f0c3e";
}

.mdi-briefcase-eye::before {
  content: "\\f17d9";
}

.mdi-briefcase-eye-outline::before {
  content: "\\f17da";
}

.mdi-briefcase-minus::before {
  content: "\\f0a2a";
}

.mdi-briefcase-minus-outline::before {
  content: "\\f0c3f";
}

.mdi-briefcase-off::before {
  content: "\\f1658";
}

.mdi-briefcase-off-outline::before {
  content: "\\f1659";
}

.mdi-briefcase-outline::before {
  content: "\\f0814";
}

.mdi-briefcase-plus::before {
  content: "\\f0a2b";
}

.mdi-briefcase-plus-outline::before {
  content: "\\f0c40";
}

.mdi-briefcase-remove::before {
  content: "\\f0a2c";
}

.mdi-briefcase-remove-outline::before {
  content: "\\f0c41";
}

.mdi-briefcase-search::before {
  content: "\\f0a2d";
}

.mdi-briefcase-search-outline::before {
  content: "\\f0c42";
}

.mdi-briefcase-upload::before {
  content: "\\f00d9";
}

.mdi-briefcase-upload-outline::before {
  content: "\\f0c43";
}

.mdi-briefcase-variant::before {
  content: "\\f1494";
}

.mdi-briefcase-variant-off::before {
  content: "\\f165a";
}

.mdi-briefcase-variant-off-outline::before {
  content: "\\f165b";
}

.mdi-briefcase-variant-outline::before {
  content: "\\f1495";
}

.mdi-brightness-1::before {
  content: "\\f00da";
}

.mdi-brightness-2::before {
  content: "\\f00db";
}

.mdi-brightness-3::before {
  content: "\\f00dc";
}

.mdi-brightness-4::before {
  content: "\\f00dd";
}

.mdi-brightness-5::before {
  content: "\\f00de";
}

.mdi-brightness-6::before {
  content: "\\f00df";
}

.mdi-brightness-7::before {
  content: "\\f00e0";
}

.mdi-brightness-auto::before {
  content: "\\f00e1";
}

.mdi-brightness-percent::before {
  content: "\\f0cf2";
}

.mdi-broadcast::before {
  content: "\\f1720";
}

.mdi-broadcast-off::before {
  content: "\\f1721";
}

.mdi-broom::before {
  content: "\\f00e2";
}

.mdi-brush::before {
  content: "\\f00e3";
}

.mdi-brush-off::before {
  content: "\\f1771";
}

.mdi-brush-variant::before {
  content: "\\f1813";
}

.mdi-bucket::before {
  content: "\\f1415";
}

.mdi-bucket-outline::before {
  content: "\\f1416";
}

.mdi-buffet::before {
  content: "\\f0578";
}

.mdi-bug::before {
  content: "\\f00e4";
}

.mdi-bug-check::before {
  content: "\\f0a2e";
}

.mdi-bug-check-outline::before {
  content: "\\f0a2f";
}

.mdi-bug-outline::before {
  content: "\\f0a30";
}

.mdi-bugle::before {
  content: "\\f0db4";
}

.mdi-bulldozer::before {
  content: "\\f0b22";
}

.mdi-bullet::before {
  content: "\\f0cf3";
}

.mdi-bulletin-board::before {
  content: "\\f00e5";
}

.mdi-bullhorn::before {
  content: "\\f00e6";
}

.mdi-bullhorn-outline::before {
  content: "\\f0b23";
}

.mdi-bullhorn-variant::before {
  content: "\\f196e";
}

.mdi-bullhorn-variant-outline::before {
  content: "\\f196f";
}

.mdi-bullseye::before {
  content: "\\f05dd";
}

.mdi-bullseye-arrow::before {
  content: "\\f08c9";
}

.mdi-bulma::before {
  content: "\\f12e7";
}

.mdi-bunk-bed::before {
  content: "\\f1302";
}

.mdi-bunk-bed-outline::before {
  content: "\\f0097";
}

.mdi-bus::before {
  content: "\\f00e7";
}

.mdi-bus-alert::before {
  content: "\\f0a99";
}

.mdi-bus-articulated-end::before {
  content: "\\f079c";
}

.mdi-bus-articulated-front::before {
  content: "\\f079d";
}

.mdi-bus-clock::before {
  content: "\\f08ca";
}

.mdi-bus-double-decker::before {
  content: "\\f079e";
}

.mdi-bus-electric::before {
  content: "\\f191d";
}

.mdi-bus-marker::before {
  content: "\\f1212";
}

.mdi-bus-multiple::before {
  content: "\\f0f3f";
}

.mdi-bus-school::before {
  content: "\\f079f";
}

.mdi-bus-side::before {
  content: "\\f07a0";
}

.mdi-bus-stop::before {
  content: "\\f1012";
}

.mdi-bus-stop-covered::before {
  content: "\\f1013";
}

.mdi-bus-stop-uncovered::before {
  content: "\\f1014";
}

.mdi-butterfly::before {
  content: "\\f1589";
}

.mdi-butterfly-outline::before {
  content: "\\f158a";
}

.mdi-cabin-a-frame::before {
  content: "\\f188c";
}

.mdi-cable-data::before {
  content: "\\f1394";
}

.mdi-cached::before {
  content: "\\f00e8";
}

.mdi-cactus::before {
  content: "\\f0db5";
}

.mdi-cake::before {
  content: "\\f00e9";
}

.mdi-cake-layered::before {
  content: "\\f00ea";
}

.mdi-cake-variant::before {
  content: "\\f00eb";
}

.mdi-cake-variant-outline::before {
  content: "\\f17f0";
}

.mdi-calculator::before {
  content: "\\f00ec";
}

.mdi-calculator-variant::before {
  content: "\\f0a9a";
}

.mdi-calculator-variant-outline::before {
  content: "\\f15a6";
}

.mdi-calendar::before {
  content: "\\f00ed";
}

.mdi-calendar-account::before {
  content: "\\f0ed7";
}

.mdi-calendar-account-outline::before {
  content: "\\f0ed8";
}

.mdi-calendar-alert::before {
  content: "\\f0a31";
}

.mdi-calendar-arrow-left::before {
  content: "\\f1134";
}

.mdi-calendar-arrow-right::before {
  content: "\\f1135";
}

.mdi-calendar-blank::before {
  content: "\\f00ee";
}

.mdi-calendar-blank-multiple::before {
  content: "\\f1073";
}

.mdi-calendar-blank-outline::before {
  content: "\\f0b66";
}

.mdi-calendar-check::before {
  content: "\\f00ef";
}

.mdi-calendar-check-outline::before {
  content: "\\f0c44";
}

.mdi-calendar-clock::before {
  content: "\\f00f0";
}

.mdi-calendar-clock-outline::before {
  content: "\\f16e1";
}

.mdi-calendar-collapse-horizontal::before {
  content: "\\f189d";
}

.mdi-calendar-cursor::before {
  content: "\\f157b";
}

.mdi-calendar-edit::before {
  content: "\\f08a7";
}

.mdi-calendar-end::before {
  content: "\\f166c";
}

.mdi-calendar-expand-horizontal::before {
  content: "\\f189e";
}

.mdi-calendar-export::before {
  content: "\\f0b24";
}

.mdi-calendar-heart::before {
  content: "\\f09d2";
}

.mdi-calendar-import::before {
  content: "\\f0b25";
}

.mdi-calendar-lock::before {
  content: "\\f1641";
}

.mdi-calendar-lock-outline::before {
  content: "\\f1642";
}

.mdi-calendar-minus::before {
  content: "\\f0d5c";
}

.mdi-calendar-month::before {
  content: "\\f0e17";
}

.mdi-calendar-month-outline::before {
  content: "\\f0e18";
}

.mdi-calendar-multiple::before {
  content: "\\f00f1";
}

.mdi-calendar-multiple-check::before {
  content: "\\f00f2";
}

.mdi-calendar-multiselect::before {
  content: "\\f0a32";
}

.mdi-calendar-outline::before {
  content: "\\f0b67";
}

.mdi-calendar-plus::before {
  content: "\\f00f3";
}

.mdi-calendar-question::before {
  content: "\\f0692";
}

.mdi-calendar-range::before {
  content: "\\f0679";
}

.mdi-calendar-range-outline::before {
  content: "\\f0b68";
}

.mdi-calendar-refresh::before {
  content: "\\f01e1";
}

.mdi-calendar-refresh-outline::before {
  content: "\\f0203";
}

.mdi-calendar-remove::before {
  content: "\\f00f4";
}

.mdi-calendar-remove-outline::before {
  content: "\\f0c45";
}

.mdi-calendar-search::before {
  content: "\\f094c";
}

.mdi-calendar-star::before {
  content: "\\f09d3";
}

.mdi-calendar-start::before {
  content: "\\f166d";
}

.mdi-calendar-sync::before {
  content: "\\f0e8e";
}

.mdi-calendar-sync-outline::before {
  content: "\\f0e8f";
}

.mdi-calendar-text::before {
  content: "\\f00f5";
}

.mdi-calendar-text-outline::before {
  content: "\\f0c46";
}

.mdi-calendar-today::before {
  content: "\\f00f6";
}

.mdi-calendar-week::before {
  content: "\\f0a33";
}

.mdi-calendar-week-begin::before {
  content: "\\f0a34";
}

.mdi-calendar-weekend::before {
  content: "\\f0ed9";
}

.mdi-calendar-weekend-outline::before {
  content: "\\f0eda";
}

.mdi-call-made::before {
  content: "\\f00f7";
}

.mdi-call-merge::before {
  content: "\\f00f8";
}

.mdi-call-missed::before {
  content: "\\f00f9";
}

.mdi-call-received::before {
  content: "\\f00fa";
}

.mdi-call-split::before {
  content: "\\f00fb";
}

.mdi-camcorder::before {
  content: "\\f00fc";
}

.mdi-camcorder-off::before {
  content: "\\f00ff";
}

.mdi-camera::before {
  content: "\\f0100";
}

.mdi-camera-account::before {
  content: "\\f08cb";
}

.mdi-camera-burst::before {
  content: "\\f0693";
}

.mdi-camera-control::before {
  content: "\\f0b69";
}

.mdi-camera-document::before {
  content: "\\f1871";
}

.mdi-camera-document-off::before {
  content: "\\f1872";
}

.mdi-camera-enhance::before {
  content: "\\f0101";
}

.mdi-camera-enhance-outline::before {
  content: "\\f0b6a";
}

.mdi-camera-flip::before {
  content: "\\f15d9";
}

.mdi-camera-flip-outline::before {
  content: "\\f15da";
}

.mdi-camera-front::before {
  content: "\\f0102";
}

.mdi-camera-front-variant::before {
  content: "\\f0103";
}

.mdi-camera-gopro::before {
  content: "\\f07a1";
}

.mdi-camera-image::before {
  content: "\\f08cc";
}

.mdi-camera-iris::before {
  content: "\\f0104";
}

.mdi-camera-marker::before {
  content: "\\f19a7";
}

.mdi-camera-marker-outline::before {
  content: "\\f19a8";
}

.mdi-camera-metering-center::before {
  content: "\\f07a2";
}

.mdi-camera-metering-matrix::before {
  content: "\\f07a3";
}

.mdi-camera-metering-partial::before {
  content: "\\f07a4";
}

.mdi-camera-metering-spot::before {
  content: "\\f07a5";
}

.mdi-camera-off::before {
  content: "\\f05df";
}

.mdi-camera-off-outline::before {
  content: "\\f19bf";
}

.mdi-camera-outline::before {
  content: "\\f0d5d";
}

.mdi-camera-party-mode::before {
  content: "\\f0105";
}

.mdi-camera-plus::before {
  content: "\\f0edb";
}

.mdi-camera-plus-outline::before {
  content: "\\f0edc";
}

.mdi-camera-rear::before {
  content: "\\f0106";
}

.mdi-camera-rear-variant::before {
  content: "\\f0107";
}

.mdi-camera-retake::before {
  content: "\\f0e19";
}

.mdi-camera-retake-outline::before {
  content: "\\f0e1a";
}

.mdi-camera-switch::before {
  content: "\\f0108";
}

.mdi-camera-switch-outline::before {
  content: "\\f084a";
}

.mdi-camera-timer::before {
  content: "\\f0109";
}

.mdi-camera-wireless::before {
  content: "\\f0db6";
}

.mdi-camera-wireless-outline::before {
  content: "\\f0db7";
}

.mdi-campfire::before {
  content: "\\f0edd";
}

.mdi-cancel::before {
  content: "\\f073a";
}

.mdi-candelabra::before {
  content: "\\f17d2";
}

.mdi-candelabra-fire::before {
  content: "\\f17d3";
}

.mdi-candle::before {
  content: "\\f05e2";
}

.mdi-candy::before {
  content: "\\f1970";
}

.mdi-candy-off::before {
  content: "\\f1971";
}

.mdi-candy-off-outline::before {
  content: "\\f1972";
}

.mdi-candy-outline::before {
  content: "\\f1973";
}

.mdi-candycane::before {
  content: "\\f010a";
}

.mdi-cannabis::before {
  content: "\\f07a6";
}

.mdi-cannabis-off::before {
  content: "\\f166e";
}

.mdi-caps-lock::before {
  content: "\\f0a9b";
}

.mdi-car::before {
  content: "\\f010b";
}

.mdi-car-2-plus::before {
  content: "\\f1015";
}

.mdi-car-3-plus::before {
  content: "\\f1016";
}

.mdi-car-arrow-left::before {
  content: "\\f13b2";
}

.mdi-car-arrow-right::before {
  content: "\\f13b3";
}

.mdi-car-back::before {
  content: "\\f0e1b";
}

.mdi-car-battery::before {
  content: "\\f010c";
}

.mdi-car-brake-abs::before {
  content: "\\f0c47";
}

.mdi-car-brake-alert::before {
  content: "\\f0c48";
}

.mdi-car-brake-fluid-level::before {
  content: "\\f1909";
}

.mdi-car-brake-hold::before {
  content: "\\f0d5e";
}

.mdi-car-brake-low-pressure::before {
  content: "\\f190a";
}

.mdi-car-brake-parking::before {
  content: "\\f0d5f";
}

.mdi-car-brake-retarder::before {
  content: "\\f1017";
}

.mdi-car-brake-temperature::before {
  content: "\\f190b";
}

.mdi-car-brake-worn-linings::before {
  content: "\\f190c";
}

.mdi-car-child-seat::before {
  content: "\\f0fa3";
}

.mdi-car-clock::before {
  content: "\\f1974";
}

.mdi-car-clutch::before {
  content: "\\f1018";
}

.mdi-car-cog::before {
  content: "\\f13cc";
}

.mdi-car-connected::before {
  content: "\\f010d";
}

.mdi-car-convertible::before {
  content: "\\f07a7";
}

.mdi-car-coolant-level::before {
  content: "\\f1019";
}

.mdi-car-cruise-control::before {
  content: "\\f0d60";
}

.mdi-car-defrost-front::before {
  content: "\\f0d61";
}

.mdi-car-defrost-rear::before {
  content: "\\f0d62";
}

.mdi-car-door::before {
  content: "\\f0b6b";
}

.mdi-car-door-lock::before {
  content: "\\f109d";
}

.mdi-car-electric::before {
  content: "\\f0b6c";
}

.mdi-car-electric-outline::before {
  content: "\\f15b5";
}

.mdi-car-emergency::before {
  content: "\\f160f";
}

.mdi-car-esp::before {
  content: "\\f0c49";
}

.mdi-car-estate::before {
  content: "\\f07a8";
}

.mdi-car-hatchback::before {
  content: "\\f07a9";
}

.mdi-car-info::before {
  content: "\\f11be";
}

.mdi-car-key::before {
  content: "\\f0b6d";
}

.mdi-car-lifted-pickup::before {
  content: "\\f152d";
}

.mdi-car-light-alert::before {
  content: "\\f190d";
}

.mdi-car-light-dimmed::before {
  content: "\\f0c4a";
}

.mdi-car-light-fog::before {
  content: "\\f0c4b";
}

.mdi-car-light-high::before {
  content: "\\f0c4c";
}

.mdi-car-limousine::before {
  content: "\\f08cd";
}

.mdi-car-multiple::before {
  content: "\\f0b6e";
}

.mdi-car-off::before {
  content: "\\f0e1c";
}

.mdi-car-outline::before {
  content: "\\f14ed";
}

.mdi-car-parking-lights::before {
  content: "\\f0d63";
}

.mdi-car-pickup::before {
  content: "\\f07aa";
}

.mdi-car-seat::before {
  content: "\\f0fa4";
}

.mdi-car-seat-cooler::before {
  content: "\\f0fa5";
}

.mdi-car-seat-heater::before {
  content: "\\f0fa6";
}

.mdi-car-select::before {
  content: "\\f1879";
}

.mdi-car-settings::before {
  content: "\\f13cd";
}

.mdi-car-shift-pattern::before {
  content: "\\f0f40";
}

.mdi-car-side::before {
  content: "\\f07ab";
}

.mdi-car-speed-limiter::before {
  content: "\\f190e";
}

.mdi-car-sports::before {
  content: "\\f07ac";
}

.mdi-car-tire-alert::before {
  content: "\\f0c4d";
}

.mdi-car-traction-control::before {
  content: "\\f0d64";
}

.mdi-car-turbocharger::before {
  content: "\\f101a";
}

.mdi-car-wash::before {
  content: "\\f010e";
}

.mdi-car-windshield::before {
  content: "\\f101b";
}

.mdi-car-windshield-outline::before {
  content: "\\f101c";
}

.mdi-car-wireless::before {
  content: "\\f1878";
}

.mdi-car-wrench::before {
  content: "\\f1814";
}

.mdi-carabiner::before {
  content: "\\f14c0";
}

.mdi-caravan::before {
  content: "\\f07ad";
}

.mdi-card::before {
  content: "\\f0b6f";
}

.mdi-card-account-details::before {
  content: "\\f05d2";
}

.mdi-card-account-details-outline::before {
  content: "\\f0dab";
}

.mdi-card-account-details-star::before {
  content: "\\f02a3";
}

.mdi-card-account-details-star-outline::before {
  content: "\\f06db";
}

.mdi-card-account-mail::before {
  content: "\\f018e";
}

.mdi-card-account-mail-outline::before {
  content: "\\f0e98";
}

.mdi-card-account-phone::before {
  content: "\\f0e99";
}

.mdi-card-account-phone-outline::before {
  content: "\\f0e9a";
}

.mdi-card-bulleted::before {
  content: "\\f0b70";
}

.mdi-card-bulleted-off::before {
  content: "\\f0b71";
}

.mdi-card-bulleted-off-outline::before {
  content: "\\f0b72";
}

.mdi-card-bulleted-outline::before {
  content: "\\f0b73";
}

.mdi-card-bulleted-settings::before {
  content: "\\f0b74";
}

.mdi-card-bulleted-settings-outline::before {
  content: "\\f0b75";
}

.mdi-card-minus::before {
  content: "\\f1600";
}

.mdi-card-minus-outline::before {
  content: "\\f1601";
}

.mdi-card-multiple::before {
  content: "\\f17f1";
}

.mdi-card-multiple-outline::before {
  content: "\\f17f2";
}

.mdi-card-off::before {
  content: "\\f1602";
}

.mdi-card-off-outline::before {
  content: "\\f1603";
}

.mdi-card-outline::before {
  content: "\\f0b76";
}

.mdi-card-plus::before {
  content: "\\f11ff";
}

.mdi-card-plus-outline::before {
  content: "\\f1200";
}

.mdi-card-remove::before {
  content: "\\f1604";
}

.mdi-card-remove-outline::before {
  content: "\\f1605";
}

.mdi-card-search::before {
  content: "\\f1074";
}

.mdi-card-search-outline::before {
  content: "\\f1075";
}

.mdi-card-text::before {
  content: "\\f0b77";
}

.mdi-card-text-outline::before {
  content: "\\f0b78";
}

.mdi-cards::before {
  content: "\\f0638";
}

.mdi-cards-club::before {
  content: "\\f08ce";
}

.mdi-cards-club-outline::before {
  content: "\\f189f";
}

.mdi-cards-diamond::before {
  content: "\\f08cf";
}

.mdi-cards-diamond-outline::before {
  content: "\\f101d";
}

.mdi-cards-heart::before {
  content: "\\f08d0";
}

.mdi-cards-heart-outline::before {
  content: "\\f18a0";
}

.mdi-cards-outline::before {
  content: "\\f0639";
}

.mdi-cards-playing::before {
  content: "\\f18a1";
}

.mdi-cards-playing-club::before {
  content: "\\f18a2";
}

.mdi-cards-playing-club-multiple::before {
  content: "\\f18a3";
}

.mdi-cards-playing-club-multiple-outline::before {
  content: "\\f18a4";
}

.mdi-cards-playing-club-outline::before {
  content: "\\f18a5";
}

.mdi-cards-playing-diamond::before {
  content: "\\f18a6";
}

.mdi-cards-playing-diamond-multiple::before {
  content: "\\f18a7";
}

.mdi-cards-playing-diamond-multiple-outline::before {
  content: "\\f18a8";
}

.mdi-cards-playing-diamond-outline::before {
  content: "\\f18a9";
}

.mdi-cards-playing-heart::before {
  content: "\\f18aa";
}

.mdi-cards-playing-heart-multiple::before {
  content: "\\f18ab";
}

.mdi-cards-playing-heart-multiple-outline::before {
  content: "\\f18ac";
}

.mdi-cards-playing-heart-outline::before {
  content: "\\f18ad";
}

.mdi-cards-playing-outline::before {
  content: "\\f063a";
}

.mdi-cards-playing-spade::before {
  content: "\\f18ae";
}

.mdi-cards-playing-spade-multiple::before {
  content: "\\f18af";
}

.mdi-cards-playing-spade-multiple-outline::before {
  content: "\\f18b0";
}

.mdi-cards-playing-spade-outline::before {
  content: "\\f18b1";
}

.mdi-cards-spade::before {
  content: "\\f08d1";
}

.mdi-cards-spade-outline::before {
  content: "\\f18b2";
}

.mdi-cards-variant::before {
  content: "\\f06c7";
}

.mdi-carrot::before {
  content: "\\f010f";
}

.mdi-cart::before {
  content: "\\f0110";
}

.mdi-cart-arrow-down::before {
  content: "\\f0d66";
}

.mdi-cart-arrow-right::before {
  content: "\\f0c4e";
}

.mdi-cart-arrow-up::before {
  content: "\\f0d67";
}

.mdi-cart-check::before {
  content: "\\f15ea";
}

.mdi-cart-heart::before {
  content: "\\f18e0";
}

.mdi-cart-minus::before {
  content: "\\f0d68";
}

.mdi-cart-off::before {
  content: "\\f066b";
}

.mdi-cart-outline::before {
  content: "\\f0111";
}

.mdi-cart-plus::before {
  content: "\\f0112";
}

.mdi-cart-remove::before {
  content: "\\f0d69";
}

.mdi-cart-variant::before {
  content: "\\f15eb";
}

.mdi-case-sensitive-alt::before {
  content: "\\f0113";
}

.mdi-cash::before {
  content: "\\f0114";
}

.mdi-cash-100::before {
  content: "\\f0115";
}

.mdi-cash-check::before {
  content: "\\f14ee";
}

.mdi-cash-fast::before {
  content: "\\f185c";
}

.mdi-cash-lock::before {
  content: "\\f14ea";
}

.mdi-cash-lock-open::before {
  content: "\\f14eb";
}

.mdi-cash-marker::before {
  content: "\\f0db8";
}

.mdi-cash-minus::before {
  content: "\\f1260";
}

.mdi-cash-multiple::before {
  content: "\\f0116";
}

.mdi-cash-plus::before {
  content: "\\f1261";
}

.mdi-cash-refund::before {
  content: "\\f0a9c";
}

.mdi-cash-register::before {
  content: "\\f0cf4";
}

.mdi-cash-remove::before {
  content: "\\f1262";
}

.mdi-cassette::before {
  content: "\\f09d4";
}

.mdi-cast::before {
  content: "\\f0118";
}

.mdi-cast-audio::before {
  content: "\\f101e";
}

.mdi-cast-audio-variant::before {
  content: "\\f1749";
}

.mdi-cast-connected::before {
  content: "\\f0119";
}

.mdi-cast-education::before {
  content: "\\f0e1d";
}

.mdi-cast-off::before {
  content: "\\f078a";
}

.mdi-cast-variant::before {
  content: "\\f001f";
}

.mdi-castle::before {
  content: "\\f011a";
}

.mdi-cat::before {
  content: "\\f011b";
}

.mdi-cctv::before {
  content: "\\f07ae";
}

.mdi-cctv-off::before {
  content: "\\f185f";
}

.mdi-ceiling-fan::before {
  content: "\\f1797";
}

.mdi-ceiling-fan-light::before {
  content: "\\f1798";
}

.mdi-ceiling-light::before {
  content: "\\f0769";
}

.mdi-ceiling-light-multiple::before {
  content: "\\f18dd";
}

.mdi-ceiling-light-multiple-outline::before {
  content: "\\f18de";
}

.mdi-ceiling-light-outline::before {
  content: "\\f17c7";
}

.mdi-cellphone::before {
  content: "\\f011c";
}

.mdi-cellphone-arrow-down::before {
  content: "\\f09d5";
}

.mdi-cellphone-basic::before {
  content: "\\f011e";
}

.mdi-cellphone-charging::before {
  content: "\\f1397";
}

.mdi-cellphone-check::before {
  content: "\\f17fd";
}

.mdi-cellphone-cog::before {
  content: "\\f0951";
}

.mdi-cellphone-dock::before {
  content: "\\f011f";
}

.mdi-cellphone-information::before {
  content: "\\f0f41";
}

.mdi-cellphone-key::before {
  content: "\\f094e";
}

.mdi-cellphone-link::before {
  content: "\\f0121";
}

.mdi-cellphone-link-off::before {
  content: "\\f0122";
}

.mdi-cellphone-lock::before {
  content: "\\f094f";
}

.mdi-cellphone-marker::before {
  content: "\\f183a";
}

.mdi-cellphone-message::before {
  content: "\\f08d3";
}

.mdi-cellphone-message-off::before {
  content: "\\f10d2";
}

.mdi-cellphone-nfc::before {
  content: "\\f0e90";
}

.mdi-cellphone-nfc-off::before {
  content: "\\f12d8";
}

.mdi-cellphone-off::before {
  content: "\\f0950";
}

.mdi-cellphone-play::before {
  content: "\\f101f";
}

.mdi-cellphone-remove::before {
  content: "\\f094d";
}

.mdi-cellphone-screenshot::before {
  content: "\\f0a35";
}

.mdi-cellphone-settings::before {
  content: "\\f0123";
}

.mdi-cellphone-sound::before {
  content: "\\f0952";
}

.mdi-cellphone-text::before {
  content: "\\f08d2";
}

.mdi-cellphone-wireless::before {
  content: "\\f0815";
}

.mdi-centos::before {
  content: "\\f111a";
}

.mdi-certificate::before {
  content: "\\f0124";
}

.mdi-certificate-outline::before {
  content: "\\f1188";
}

.mdi-chair-rolling::before {
  content: "\\f0f48";
}

.mdi-chair-school::before {
  content: "\\f0125";
}

.mdi-chandelier::before {
  content: "\\f1793";
}

.mdi-charity::before {
  content: "\\f0c4f";
}

.mdi-chart-arc::before {
  content: "\\f0126";
}

.mdi-chart-areaspline::before {
  content: "\\f0127";
}

.mdi-chart-areaspline-variant::before {
  content: "\\f0e91";
}

.mdi-chart-bar::before {
  content: "\\f0128";
}

.mdi-chart-bar-stacked::before {
  content: "\\f076a";
}

.mdi-chart-bell-curve::before {
  content: "\\f0c50";
}

.mdi-chart-bell-curve-cumulative::before {
  content: "\\f0fa7";
}

.mdi-chart-box::before {
  content: "\\f154d";
}

.mdi-chart-box-outline::before {
  content: "\\f154e";
}

.mdi-chart-box-plus-outline::before {
  content: "\\f154f";
}

.mdi-chart-bubble::before {
  content: "\\f05e3";
}

.mdi-chart-donut::before {
  content: "\\f07af";
}

.mdi-chart-donut-variant::before {
  content: "\\f07b0";
}

.mdi-chart-gantt::before {
  content: "\\f066c";
}

.mdi-chart-histogram::before {
  content: "\\f0129";
}

.mdi-chart-line::before {
  content: "\\f012a";
}

.mdi-chart-line-stacked::before {
  content: "\\f076b";
}

.mdi-chart-line-variant::before {
  content: "\\f07b1";
}

.mdi-chart-multiline::before {
  content: "\\f08d4";
}

.mdi-chart-multiple::before {
  content: "\\f1213";
}

.mdi-chart-pie::before {
  content: "\\f012b";
}

.mdi-chart-ppf::before {
  content: "\\f1380";
}

.mdi-chart-sankey::before {
  content: "\\f11df";
}

.mdi-chart-sankey-variant::before {
  content: "\\f11e0";
}

.mdi-chart-scatter-plot::before {
  content: "\\f0e92";
}

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\f066d";
}

.mdi-chart-timeline::before {
  content: "\\f066e";
}

.mdi-chart-timeline-variant::before {
  content: "\\f0e93";
}

.mdi-chart-timeline-variant-shimmer::before {
  content: "\\f15b6";
}

.mdi-chart-tree::before {
  content: "\\f0e94";
}

.mdi-chart-waterfall::before {
  content: "\\f1918";
}

.mdi-chat::before {
  content: "\\f0b79";
}

.mdi-chat-alert::before {
  content: "\\f0b7a";
}

.mdi-chat-alert-outline::before {
  content: "\\f12c9";
}

.mdi-chat-minus::before {
  content: "\\f1410";
}

.mdi-chat-minus-outline::before {
  content: "\\f1413";
}

.mdi-chat-outline::before {
  content: "\\f0ede";
}

.mdi-chat-plus::before {
  content: "\\f140f";
}

.mdi-chat-plus-outline::before {
  content: "\\f1412";
}

.mdi-chat-processing::before {
  content: "\\f0b7b";
}

.mdi-chat-processing-outline::before {
  content: "\\f12ca";
}

.mdi-chat-question::before {
  content: "\\f1738";
}

.mdi-chat-question-outline::before {
  content: "\\f1739";
}

.mdi-chat-remove::before {
  content: "\\f1411";
}

.mdi-chat-remove-outline::before {
  content: "\\f1414";
}

.mdi-chat-sleep::before {
  content: "\\f12d1";
}

.mdi-chat-sleep-outline::before {
  content: "\\f12d2";
}

.mdi-check::before {
  content: "\\f012c";
}

.mdi-check-all::before {
  content: "\\f012d";
}

.mdi-check-bold::before {
  content: "\\f0e1e";
}

.mdi-check-circle::before {
  content: "\\f05e0";
}

.mdi-check-circle-outline::before {
  content: "\\f05e1";
}

.mdi-check-decagram::before {
  content: "\\f0791";
}

.mdi-check-decagram-outline::before {
  content: "\\f1740";
}

.mdi-check-network::before {
  content: "\\f0c53";
}

.mdi-check-network-outline::before {
  content: "\\f0c54";
}

.mdi-check-outline::before {
  content: "\\f0855";
}

.mdi-check-underline::before {
  content: "\\f0e1f";
}

.mdi-check-underline-circle::before {
  content: "\\f0e20";
}

.mdi-check-underline-circle-outline::before {
  content: "\\f0e21";
}

.mdi-checkbook::before {
  content: "\\f0a9d";
}

.mdi-checkbox-blank::before {
  content: "\\f012e";
}

.mdi-checkbox-blank-badge::before {
  content: "\\f1176";
}

.mdi-checkbox-blank-badge-outline::before {
  content: "\\f0117";
}

.mdi-checkbox-blank-circle::before {
  content: "\\f012f";
}

.mdi-checkbox-blank-circle-outline::before {
  content: "\\f0130";
}

.mdi-checkbox-blank-off::before {
  content: "\\f12ec";
}

.mdi-checkbox-blank-off-outline::before {
  content: "\\f12ed";
}

.mdi-checkbox-blank-outline::before {
  content: "\\f0131";
}

.mdi-checkbox-intermediate::before {
  content: "\\f0856";
}

.mdi-checkbox-marked::before {
  content: "\\f0132";
}

.mdi-checkbox-marked-circle::before {
  content: "\\f0133";
}

.mdi-checkbox-marked-circle-outline::before {
  content: "\\f0134";
}

.mdi-checkbox-marked-circle-plus-outline::before {
  content: "\\f1927";
}

.mdi-checkbox-marked-outline::before {
  content: "\\f0135";
}

.mdi-checkbox-multiple-blank::before {
  content: "\\f0136";
}

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\f063b";
}

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\f063c";
}

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\f0137";
}

.mdi-checkbox-multiple-marked::before {
  content: "\\f0138";
}

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\f063d";
}

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\f063e";
}

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\f0139";
}

.mdi-checkbox-multiple-outline::before {
  content: "\\f0c51";
}

.mdi-checkbox-outline::before {
  content: "\\f0c52";
}

.mdi-checkerboard::before {
  content: "\\f013a";
}

.mdi-checkerboard-minus::before {
  content: "\\f1202";
}

.mdi-checkerboard-plus::before {
  content: "\\f1201";
}

.mdi-checkerboard-remove::before {
  content: "\\f1203";
}

.mdi-cheese::before {
  content: "\\f12b9";
}

.mdi-cheese-off::before {
  content: "\\f13ee";
}

.mdi-chef-hat::before {
  content: "\\f0b7c";
}

.mdi-chemical-weapon::before {
  content: "\\f013b";
}

.mdi-chess-bishop::before {
  content: "\\f085c";
}

.mdi-chess-king::before {
  content: "\\f0857";
}

.mdi-chess-knight::before {
  content: "\\f0858";
}

.mdi-chess-pawn::before {
  content: "\\f0859";
}

.mdi-chess-queen::before {
  content: "\\f085a";
}

.mdi-chess-rook::before {
  content: "\\f085b";
}

.mdi-chevron-double-down::before {
  content: "\\f013c";
}

.mdi-chevron-double-left::before {
  content: "\\f013d";
}

.mdi-chevron-double-right::before {
  content: "\\f013e";
}

.mdi-chevron-double-up::before {
  content: "\\f013f";
}

.mdi-chevron-down::before {
  content: "\\f0140";
}

.mdi-chevron-down-box::before {
  content: "\\f09d6";
}

.mdi-chevron-down-box-outline::before {
  content: "\\f09d7";
}

.mdi-chevron-down-circle::before {
  content: "\\f0b26";
}

.mdi-chevron-down-circle-outline::before {
  content: "\\f0b27";
}

.mdi-chevron-left::before {
  content: "\\f0141";
}

.mdi-chevron-left-box::before {
  content: "\\f09d8";
}

.mdi-chevron-left-box-outline::before {
  content: "\\f09d9";
}

.mdi-chevron-left-circle::before {
  content: "\\f0b28";
}

.mdi-chevron-left-circle-outline::before {
  content: "\\f0b29";
}

.mdi-chevron-right::before {
  content: "\\f0142";
}

.mdi-chevron-right-box::before {
  content: "\\f09da";
}

.mdi-chevron-right-box-outline::before {
  content: "\\f09db";
}

.mdi-chevron-right-circle::before {
  content: "\\f0b2a";
}

.mdi-chevron-right-circle-outline::before {
  content: "\\f0b2b";
}

.mdi-chevron-triple-down::before {
  content: "\\f0db9";
}

.mdi-chevron-triple-left::before {
  content: "\\f0dba";
}

.mdi-chevron-triple-right::before {
  content: "\\f0dbb";
}

.mdi-chevron-triple-up::before {
  content: "\\f0dbc";
}

.mdi-chevron-up::before {
  content: "\\f0143";
}

.mdi-chevron-up-box::before {
  content: "\\f09dc";
}

.mdi-chevron-up-box-outline::before {
  content: "\\f09dd";
}

.mdi-chevron-up-circle::before {
  content: "\\f0b2c";
}

.mdi-chevron-up-circle-outline::before {
  content: "\\f0b2d";
}

.mdi-chili-alert::before {
  content: "\\f17ea";
}

.mdi-chili-alert-outline::before {
  content: "\\f17eb";
}

.mdi-chili-hot::before {
  content: "\\f07b2";
}

.mdi-chili-hot-outline::before {
  content: "\\f17ec";
}

.mdi-chili-medium::before {
  content: "\\f07b3";
}

.mdi-chili-medium-outline::before {
  content: "\\f17ed";
}

.mdi-chili-mild::before {
  content: "\\f07b4";
}

.mdi-chili-mild-outline::before {
  content: "\\f17ee";
}

.mdi-chili-off::before {
  content: "\\f1467";
}

.mdi-chili-off-outline::before {
  content: "\\f17ef";
}

.mdi-chip::before {
  content: "\\f061a";
}

.mdi-church::before {
  content: "\\f0144";
}

.mdi-cigar::before {
  content: "\\f1189";
}

.mdi-cigar-off::before {
  content: "\\f141b";
}

.mdi-circle::before {
  content: "\\f0765";
}

.mdi-circle-box::before {
  content: "\\f15dc";
}

.mdi-circle-box-outline::before {
  content: "\\f15dd";
}

.mdi-circle-double::before {
  content: "\\f0e95";
}

.mdi-circle-edit-outline::before {
  content: "\\f08d5";
}

.mdi-circle-expand::before {
  content: "\\f0e96";
}

.mdi-circle-half::before {
  content: "\\f1395";
}

.mdi-circle-half-full::before {
  content: "\\f1396";
}

.mdi-circle-medium::before {
  content: "\\f09de";
}

.mdi-circle-multiple::before {
  content: "\\f0b38";
}

.mdi-circle-multiple-outline::before {
  content: "\\f0695";
}

.mdi-circle-off-outline::before {
  content: "\\f10d3";
}

.mdi-circle-opacity::before {
  content: "\\f1853";
}

.mdi-circle-outline::before {
  content: "\\f0766";
}

.mdi-circle-slice-1::before {
  content: "\\f0a9e";
}

.mdi-circle-slice-2::before {
  content: "\\f0a9f";
}

.mdi-circle-slice-3::before {
  content: "\\f0aa0";
}

.mdi-circle-slice-4::before {
  content: "\\f0aa1";
}

.mdi-circle-slice-5::before {
  content: "\\f0aa2";
}

.mdi-circle-slice-6::before {
  content: "\\f0aa3";
}

.mdi-circle-slice-7::before {
  content: "\\f0aa4";
}

.mdi-circle-slice-8::before {
  content: "\\f0aa5";
}

.mdi-circle-small::before {
  content: "\\f09df";
}

.mdi-circular-saw::before {
  content: "\\f0e22";
}

.mdi-city::before {
  content: "\\f0146";
}

.mdi-city-variant::before {
  content: "\\f0a36";
}

.mdi-city-variant-outline::before {
  content: "\\f0a37";
}

.mdi-clipboard::before {
  content: "\\f0147";
}

.mdi-clipboard-account::before {
  content: "\\f0148";
}

.mdi-clipboard-account-outline::before {
  content: "\\f0c55";
}

.mdi-clipboard-alert::before {
  content: "\\f0149";
}

.mdi-clipboard-alert-outline::before {
  content: "\\f0cf7";
}

.mdi-clipboard-arrow-down::before {
  content: "\\f014a";
}

.mdi-clipboard-arrow-down-outline::before {
  content: "\\f0c56";
}

.mdi-clipboard-arrow-left::before {
  content: "\\f014b";
}

.mdi-clipboard-arrow-left-outline::before {
  content: "\\f0cf8";
}

.mdi-clipboard-arrow-right::before {
  content: "\\f0cf9";
}

.mdi-clipboard-arrow-right-outline::before {
  content: "\\f0cfa";
}

.mdi-clipboard-arrow-up::before {
  content: "\\f0c57";
}

.mdi-clipboard-arrow-up-outline::before {
  content: "\\f0c58";
}

.mdi-clipboard-check::before {
  content: "\\f014e";
}

.mdi-clipboard-check-multiple::before {
  content: "\\f1263";
}

.mdi-clipboard-check-multiple-outline::before {
  content: "\\f1264";
}

.mdi-clipboard-check-outline::before {
  content: "\\f08a8";
}

.mdi-clipboard-clock::before {
  content: "\\f16e2";
}

.mdi-clipboard-clock-outline::before {
  content: "\\f16e3";
}

.mdi-clipboard-edit::before {
  content: "\\f14e5";
}

.mdi-clipboard-edit-outline::before {
  content: "\\f14e6";
}

.mdi-clipboard-file::before {
  content: "\\f1265";
}

.mdi-clipboard-file-outline::before {
  content: "\\f1266";
}

.mdi-clipboard-flow::before {
  content: "\\f06c8";
}

.mdi-clipboard-flow-outline::before {
  content: "\\f1117";
}

.mdi-clipboard-list::before {
  content: "\\f10d4";
}

.mdi-clipboard-list-outline::before {
  content: "\\f10d5";
}

.mdi-clipboard-minus::before {
  content: "\\f1618";
}

.mdi-clipboard-minus-outline::before {
  content: "\\f1619";
}

.mdi-clipboard-multiple::before {
  content: "\\f1267";
}

.mdi-clipboard-multiple-outline::before {
  content: "\\f1268";
}

.mdi-clipboard-off::before {
  content: "\\f161a";
}

.mdi-clipboard-off-outline::before {
  content: "\\f161b";
}

.mdi-clipboard-outline::before {
  content: "\\f014c";
}

.mdi-clipboard-play::before {
  content: "\\f0c59";
}

.mdi-clipboard-play-multiple::before {
  content: "\\f1269";
}

.mdi-clipboard-play-multiple-outline::before {
  content: "\\f126a";
}

.mdi-clipboard-play-outline::before {
  content: "\\f0c5a";
}

.mdi-clipboard-plus::before {
  content: "\\f0751";
}

.mdi-clipboard-plus-outline::before {
  content: "\\f131f";
}

.mdi-clipboard-pulse::before {
  content: "\\f085d";
}

.mdi-clipboard-pulse-outline::before {
  content: "\\f085e";
}

.mdi-clipboard-remove::before {
  content: "\\f161c";
}

.mdi-clipboard-remove-outline::before {
  content: "\\f161d";
}

.mdi-clipboard-search::before {
  content: "\\f161e";
}

.mdi-clipboard-search-outline::before {
  content: "\\f161f";
}

.mdi-clipboard-text::before {
  content: "\\f014d";
}

.mdi-clipboard-text-clock::before {
  content: "\\f18f9";
}

.mdi-clipboard-text-clock-outline::before {
  content: "\\f18fa";
}

.mdi-clipboard-text-multiple::before {
  content: "\\f126b";
}

.mdi-clipboard-text-multiple-outline::before {
  content: "\\f126c";
}

.mdi-clipboard-text-off::before {
  content: "\\f1620";
}

.mdi-clipboard-text-off-outline::before {
  content: "\\f1621";
}

.mdi-clipboard-text-outline::before {
  content: "\\f0a38";
}

.mdi-clipboard-text-play::before {
  content: "\\f0c5b";
}

.mdi-clipboard-text-play-outline::before {
  content: "\\f0c5c";
}

.mdi-clipboard-text-search::before {
  content: "\\f1622";
}

.mdi-clipboard-text-search-outline::before {
  content: "\\f1623";
}

.mdi-clippy::before {
  content: "\\f014f";
}

.mdi-clock::before {
  content: "\\f0954";
}

.mdi-clock-alert::before {
  content: "\\f0955";
}

.mdi-clock-alert-outline::before {
  content: "\\f05ce";
}

.mdi-clock-check::before {
  content: "\\f0fa8";
}

.mdi-clock-check-outline::before {
  content: "\\f0fa9";
}

.mdi-clock-digital::before {
  content: "\\f0e97";
}

.mdi-clock-edit::before {
  content: "\\f19ba";
}

.mdi-clock-edit-outline::before {
  content: "\\f19bb";
}

.mdi-clock-end::before {
  content: "\\f0151";
}

.mdi-clock-fast::before {
  content: "\\f0152";
}

.mdi-clock-in::before {
  content: "\\f0153";
}

.mdi-clock-minus::before {
  content: "\\f1863";
}

.mdi-clock-minus-outline::before {
  content: "\\f1864";
}

.mdi-clock-out::before {
  content: "\\f0154";
}

.mdi-clock-outline::before {
  content: "\\f0150";
}

.mdi-clock-plus::before {
  content: "\\f1861";
}

.mdi-clock-plus-outline::before {
  content: "\\f1862";
}

.mdi-clock-remove::before {
  content: "\\f1865";
}

.mdi-clock-remove-outline::before {
  content: "\\f1866";
}

.mdi-clock-start::before {
  content: "\\f0155";
}

.mdi-clock-time-eight::before {
  content: "\\f1446";
}

.mdi-clock-time-eight-outline::before {
  content: "\\f1452";
}

.mdi-clock-time-eleven::before {
  content: "\\f1449";
}

.mdi-clock-time-eleven-outline::before {
  content: "\\f1455";
}

.mdi-clock-time-five::before {
  content: "\\f1443";
}

.mdi-clock-time-five-outline::before {
  content: "\\f144f";
}

.mdi-clock-time-four::before {
  content: "\\f1442";
}

.mdi-clock-time-four-outline::before {
  content: "\\f144e";
}

.mdi-clock-time-nine::before {
  content: "\\f1447";
}

.mdi-clock-time-nine-outline::before {
  content: "\\f1453";
}

.mdi-clock-time-one::before {
  content: "\\f143f";
}

.mdi-clock-time-one-outline::before {
  content: "\\f144b";
}

.mdi-clock-time-seven::before {
  content: "\\f1445";
}

.mdi-clock-time-seven-outline::before {
  content: "\\f1451";
}

.mdi-clock-time-six::before {
  content: "\\f1444";
}

.mdi-clock-time-six-outline::before {
  content: "\\f1450";
}

.mdi-clock-time-ten::before {
  content: "\\f1448";
}

.mdi-clock-time-ten-outline::before {
  content: "\\f1454";
}

.mdi-clock-time-three::before {
  content: "\\f1441";
}

.mdi-clock-time-three-outline::before {
  content: "\\f144d";
}

.mdi-clock-time-twelve::before {
  content: "\\f144a";
}

.mdi-clock-time-twelve-outline::before {
  content: "\\f1456";
}

.mdi-clock-time-two::before {
  content: "\\f1440";
}

.mdi-clock-time-two-outline::before {
  content: "\\f144c";
}

.mdi-close::before {
  content: "\\f0156";
}

.mdi-close-box::before {
  content: "\\f0157";
}

.mdi-close-box-multiple::before {
  content: "\\f0c5d";
}

.mdi-close-box-multiple-outline::before {
  content: "\\f0c5e";
}

.mdi-close-box-outline::before {
  content: "\\f0158";
}

.mdi-close-circle::before {
  content: "\\f0159";
}

.mdi-close-circle-multiple::before {
  content: "\\f062a";
}

.mdi-close-circle-multiple-outline::before {
  content: "\\f0883";
}

.mdi-close-circle-outline::before {
  content: "\\f015a";
}

.mdi-close-network::before {
  content: "\\f015b";
}

.mdi-close-network-outline::before {
  content: "\\f0c5f";
}

.mdi-close-octagon::before {
  content: "\\f015c";
}

.mdi-close-octagon-outline::before {
  content: "\\f015d";
}

.mdi-close-outline::before {
  content: "\\f06c9";
}

.mdi-close-thick::before {
  content: "\\f1398";
}

.mdi-closed-caption::before {
  content: "\\f015e";
}

.mdi-closed-caption-outline::before {
  content: "\\f0dbd";
}

.mdi-cloud::before {
  content: "\\f015f";
}

.mdi-cloud-alert::before {
  content: "\\f09e0";
}

.mdi-cloud-braces::before {
  content: "\\f07b5";
}

.mdi-cloud-check::before {
  content: "\\f0160";
}

.mdi-cloud-check-outline::before {
  content: "\\f12cc";
}

.mdi-cloud-circle::before {
  content: "\\f0161";
}

.mdi-cloud-download::before {
  content: "\\f0162";
}

.mdi-cloud-download-outline::before {
  content: "\\f0b7d";
}

.mdi-cloud-lock::before {
  content: "\\f11f1";
}

.mdi-cloud-lock-outline::before {
  content: "\\f11f2";
}

.mdi-cloud-off-outline::before {
  content: "\\f0164";
}

.mdi-cloud-outline::before {
  content: "\\f0163";
}

.mdi-cloud-print::before {
  content: "\\f0165";
}

.mdi-cloud-print-outline::before {
  content: "\\f0166";
}

.mdi-cloud-question::before {
  content: "\\f0a39";
}

.mdi-cloud-refresh::before {
  content: "\\f052a";
}

.mdi-cloud-search::before {
  content: "\\f0956";
}

.mdi-cloud-search-outline::before {
  content: "\\f0957";
}

.mdi-cloud-sync::before {
  content: "\\f063f";
}

.mdi-cloud-sync-outline::before {
  content: "\\f12d6";
}

.mdi-cloud-tags::before {
  content: "\\f07b6";
}

.mdi-cloud-upload::before {
  content: "\\f0167";
}

.mdi-cloud-upload-outline::before {
  content: "\\f0b7e";
}

.mdi-clover::before {
  content: "\\f0816";
}

.mdi-coach-lamp::before {
  content: "\\f1020";
}

.mdi-coat-rack::before {
  content: "\\f109e";
}

.mdi-code-array::before {
  content: "\\f0168";
}

.mdi-code-braces::before {
  content: "\\f0169";
}

.mdi-code-braces-box::before {
  content: "\\f10d6";
}

.mdi-code-brackets::before {
  content: "\\f016a";
}

.mdi-code-equal::before {
  content: "\\f016b";
}

.mdi-code-greater-than::before {
  content: "\\f016c";
}

.mdi-code-greater-than-or-equal::before {
  content: "\\f016d";
}

.mdi-code-json::before {
  content: "\\f0626";
}

.mdi-code-less-than::before {
  content: "\\f016e";
}

.mdi-code-less-than-or-equal::before {
  content: "\\f016f";
}

.mdi-code-not-equal::before {
  content: "\\f0170";
}

.mdi-code-not-equal-variant::before {
  content: "\\f0171";
}

.mdi-code-parentheses::before {
  content: "\\f0172";
}

.mdi-code-parentheses-box::before {
  content: "\\f10d7";
}

.mdi-code-string::before {
  content: "\\f0173";
}

.mdi-code-tags::before {
  content: "\\f0174";
}

.mdi-code-tags-check::before {
  content: "\\f0694";
}

.mdi-codepen::before {
  content: "\\f0175";
}

.mdi-coffee::before {
  content: "\\f0176";
}

.mdi-coffee-maker::before {
  content: "\\f109f";
}

.mdi-coffee-maker-check::before {
  content: "\\f1931";
}

.mdi-coffee-maker-check-outline::before {
  content: "\\f1932";
}

.mdi-coffee-maker-outline::before {
  content: "\\f181b";
}

.mdi-coffee-off::before {
  content: "\\f0faa";
}

.mdi-coffee-off-outline::before {
  content: "\\f0fab";
}

.mdi-coffee-outline::before {
  content: "\\f06ca";
}

.mdi-coffee-to-go::before {
  content: "\\f0177";
}

.mdi-coffee-to-go-outline::before {
  content: "\\f130e";
}

.mdi-coffin::before {
  content: "\\f0b7f";
}

.mdi-cog::before {
  content: "\\f0493";
}

.mdi-cog-box::before {
  content: "\\f0494";
}

.mdi-cog-clockwise::before {
  content: "\\f11dd";
}

.mdi-cog-counterclockwise::before {
  content: "\\f11de";
}

.mdi-cog-off::before {
  content: "\\f13ce";
}

.mdi-cog-off-outline::before {
  content: "\\f13cf";
}

.mdi-cog-outline::before {
  content: "\\f08bb";
}

.mdi-cog-pause::before {
  content: "\\f1933";
}

.mdi-cog-pause-outline::before {
  content: "\\f1934";
}

.mdi-cog-play::before {
  content: "\\f1935";
}

.mdi-cog-play-outline::before {
  content: "\\f1936";
}

.mdi-cog-refresh::before {
  content: "\\f145e";
}

.mdi-cog-refresh-outline::before {
  content: "\\f145f";
}

.mdi-cog-stop::before {
  content: "\\f1937";
}

.mdi-cog-stop-outline::before {
  content: "\\f1938";
}

.mdi-cog-sync::before {
  content: "\\f1460";
}

.mdi-cog-sync-outline::before {
  content: "\\f1461";
}

.mdi-cog-transfer::before {
  content: "\\f105b";
}

.mdi-cog-transfer-outline::before {
  content: "\\f105c";
}

.mdi-cogs::before {
  content: "\\f08d6";
}

.mdi-collage::before {
  content: "\\f0640";
}

.mdi-collapse-all::before {
  content: "\\f0aa6";
}

.mdi-collapse-all-outline::before {
  content: "\\f0aa7";
}

.mdi-color-helper::before {
  content: "\\f0179";
}

.mdi-comma::before {
  content: "\\f0e23";
}

.mdi-comma-box::before {
  content: "\\f0e2b";
}

.mdi-comma-box-outline::before {
  content: "\\f0e24";
}

.mdi-comma-circle::before {
  content: "\\f0e25";
}

.mdi-comma-circle-outline::before {
  content: "\\f0e26";
}

.mdi-comment::before {
  content: "\\f017a";
}

.mdi-comment-account::before {
  content: "\\f017b";
}

.mdi-comment-account-outline::before {
  content: "\\f017c";
}

.mdi-comment-alert::before {
  content: "\\f017d";
}

.mdi-comment-alert-outline::before {
  content: "\\f017e";
}

.mdi-comment-arrow-left::before {
  content: "\\f09e1";
}

.mdi-comment-arrow-left-outline::before {
  content: "\\f09e2";
}

.mdi-comment-arrow-right::before {
  content: "\\f09e3";
}

.mdi-comment-arrow-right-outline::before {
  content: "\\f09e4";
}

.mdi-comment-bookmark::before {
  content: "\\f15ae";
}

.mdi-comment-bookmark-outline::before {
  content: "\\f15af";
}

.mdi-comment-check::before {
  content: "\\f017f";
}

.mdi-comment-check-outline::before {
  content: "\\f0180";
}

.mdi-comment-edit::before {
  content: "\\f11bf";
}

.mdi-comment-edit-outline::before {
  content: "\\f12c4";
}

.mdi-comment-eye::before {
  content: "\\f0a3a";
}

.mdi-comment-eye-outline::before {
  content: "\\f0a3b";
}

.mdi-comment-flash::before {
  content: "\\f15b0";
}

.mdi-comment-flash-outline::before {
  content: "\\f15b1";
}

.mdi-comment-minus::before {
  content: "\\f15df";
}

.mdi-comment-minus-outline::before {
  content: "\\f15e0";
}

.mdi-comment-multiple::before {
  content: "\\f085f";
}

.mdi-comment-multiple-outline::before {
  content: "\\f0181";
}

.mdi-comment-off::before {
  content: "\\f15e1";
}

.mdi-comment-off-outline::before {
  content: "\\f15e2";
}

.mdi-comment-outline::before {
  content: "\\f0182";
}

.mdi-comment-plus::before {
  content: "\\f09e5";
}

.mdi-comment-plus-outline::before {
  content: "\\f0183";
}

.mdi-comment-processing::before {
  content: "\\f0184";
}

.mdi-comment-processing-outline::before {
  content: "\\f0185";
}

.mdi-comment-question::before {
  content: "\\f0817";
}

.mdi-comment-question-outline::before {
  content: "\\f0186";
}

.mdi-comment-quote::before {
  content: "\\f1021";
}

.mdi-comment-quote-outline::before {
  content: "\\f1022";
}

.mdi-comment-remove::before {
  content: "\\f05de";
}

.mdi-comment-remove-outline::before {
  content: "\\f0187";
}

.mdi-comment-search::before {
  content: "\\f0a3c";
}

.mdi-comment-search-outline::before {
  content: "\\f0a3d";
}

.mdi-comment-text::before {
  content: "\\f0188";
}

.mdi-comment-text-multiple::before {
  content: "\\f0860";
}

.mdi-comment-text-multiple-outline::before {
  content: "\\f0861";
}

.mdi-comment-text-outline::before {
  content: "\\f0189";
}

.mdi-compare::before {
  content: "\\f018a";
}

.mdi-compare-horizontal::before {
  content: "\\f1492";
}

.mdi-compare-remove::before {
  content: "\\f18b3";
}

.mdi-compare-vertical::before {
  content: "\\f1493";
}

.mdi-compass::before {
  content: "\\f018b";
}

.mdi-compass-off::before {
  content: "\\f0b80";
}

.mdi-compass-off-outline::before {
  content: "\\f0b81";
}

.mdi-compass-outline::before {
  content: "\\f018c";
}

.mdi-compass-rose::before {
  content: "\\f1382";
}

.mdi-cone::before {
  content: "\\f194c";
}

.mdi-cone-off::before {
  content: "\\f194d";
}

.mdi-connection::before {
  content: "\\f1616";
}

.mdi-console::before {
  content: "\\f018d";
}

.mdi-console-line::before {
  content: "\\f07b7";
}

.mdi-console-network::before {
  content: "\\f08a9";
}

.mdi-console-network-outline::before {
  content: "\\f0c60";
}

.mdi-consolidate::before {
  content: "\\f10d8";
}

.mdi-contactless-payment::before {
  content: "\\f0d6a";
}

.mdi-contactless-payment-circle::before {
  content: "\\f0321";
}

.mdi-contactless-payment-circle-outline::before {
  content: "\\f0408";
}

.mdi-contacts::before {
  content: "\\f06cb";
}

.mdi-contacts-outline::before {
  content: "\\f05b8";
}

.mdi-contain::before {
  content: "\\f0a3e";
}

.mdi-contain-end::before {
  content: "\\f0a3f";
}

.mdi-contain-start::before {
  content: "\\f0a40";
}

.mdi-content-copy::before {
  content: "\\f018f";
}

.mdi-content-cut::before {
  content: "\\f0190";
}

.mdi-content-duplicate::before {
  content: "\\f0191";
}

.mdi-content-paste::before {
  content: "\\f0192";
}

.mdi-content-save::before {
  content: "\\f0193";
}

.mdi-content-save-alert::before {
  content: "\\f0f42";
}

.mdi-content-save-alert-outline::before {
  content: "\\f0f43";
}

.mdi-content-save-all::before {
  content: "\\f0194";
}

.mdi-content-save-all-outline::before {
  content: "\\f0f44";
}

.mdi-content-save-check::before {
  content: "\\f18ea";
}

.mdi-content-save-check-outline::before {
  content: "\\f18eb";
}

.mdi-content-save-cog::before {
  content: "\\f145b";
}

.mdi-content-save-cog-outline::before {
  content: "\\f145c";
}

.mdi-content-save-edit::before {
  content: "\\f0cfb";
}

.mdi-content-save-edit-outline::before {
  content: "\\f0cfc";
}

.mdi-content-save-move::before {
  content: "\\f0e27";
}

.mdi-content-save-move-outline::before {
  content: "\\f0e28";
}

.mdi-content-save-off::before {
  content: "\\f1643";
}

.mdi-content-save-off-outline::before {
  content: "\\f1644";
}

.mdi-content-save-outline::before {
  content: "\\f0818";
}

.mdi-content-save-settings::before {
  content: "\\f061b";
}

.mdi-content-save-settings-outline::before {
  content: "\\f0b2e";
}

.mdi-contrast::before {
  content: "\\f0195";
}

.mdi-contrast-box::before {
  content: "\\f0196";
}

.mdi-contrast-circle::before {
  content: "\\f0197";
}

.mdi-controller-classic::before {
  content: "\\f0b82";
}

.mdi-controller-classic-outline::before {
  content: "\\f0b83";
}

.mdi-cookie::before {
  content: "\\f0198";
}

.mdi-cookie-alert::before {
  content: "\\f16d0";
}

.mdi-cookie-alert-outline::before {
  content: "\\f16d1";
}

.mdi-cookie-check::before {
  content: "\\f16d2";
}

.mdi-cookie-check-outline::before {
  content: "\\f16d3";
}

.mdi-cookie-clock::before {
  content: "\\f16e4";
}

.mdi-cookie-clock-outline::before {
  content: "\\f16e5";
}

.mdi-cookie-cog::before {
  content: "\\f16d4";
}

.mdi-cookie-cog-outline::before {
  content: "\\f16d5";
}

.mdi-cookie-edit::before {
  content: "\\f16e6";
}

.mdi-cookie-edit-outline::before {
  content: "\\f16e7";
}

.mdi-cookie-lock::before {
  content: "\\f16e8";
}

.mdi-cookie-lock-outline::before {
  content: "\\f16e9";
}

.mdi-cookie-minus::before {
  content: "\\f16da";
}

.mdi-cookie-minus-outline::before {
  content: "\\f16db";
}

.mdi-cookie-off::before {
  content: "\\f16ea";
}

.mdi-cookie-off-outline::before {
  content: "\\f16eb";
}

.mdi-cookie-outline::before {
  content: "\\f16de";
}

.mdi-cookie-plus::before {
  content: "\\f16d6";
}

.mdi-cookie-plus-outline::before {
  content: "\\f16d7";
}

.mdi-cookie-refresh::before {
  content: "\\f16ec";
}

.mdi-cookie-refresh-outline::before {
  content: "\\f16ed";
}

.mdi-cookie-remove::before {
  content: "\\f16d8";
}

.mdi-cookie-remove-outline::before {
  content: "\\f16d9";
}

.mdi-cookie-settings::before {
  content: "\\f16dc";
}

.mdi-cookie-settings-outline::before {
  content: "\\f16dd";
}

.mdi-coolant-temperature::before {
  content: "\\f03c8";
}

.mdi-copyleft::before {
  content: "\\f1939";
}

.mdi-copyright::before {
  content: "\\f05e6";
}

.mdi-cordova::before {
  content: "\\f0958";
}

.mdi-corn::before {
  content: "\\f07b8";
}

.mdi-corn-off::before {
  content: "\\f13ef";
}

.mdi-cosine-wave::before {
  content: "\\f1479";
}

.mdi-counter::before {
  content: "\\f0199";
}

.mdi-countertop::before {
  content: "\\f181c";
}

.mdi-countertop-outline::before {
  content: "\\f181d";
}

.mdi-cow::before {
  content: "\\f019a";
}

.mdi-cow-off::before {
  content: "\\f18fc";
}

.mdi-cpu-32-bit::before {
  content: "\\f0edf";
}

.mdi-cpu-64-bit::before {
  content: "\\f0ee0";
}

.mdi-cradle::before {
  content: "\\f198b";
}

.mdi-cradle-outline::before {
  content: "\\f1991";
}

.mdi-crane::before {
  content: "\\f0862";
}

.mdi-creation::before {
  content: "\\f0674";
}

.mdi-creative-commons::before {
  content: "\\f0d6b";
}

.mdi-credit-card::before {
  content: "\\f0fef";
}

.mdi-credit-card-check::before {
  content: "\\f13d0";
}

.mdi-credit-card-check-outline::before {
  content: "\\f13d1";
}

.mdi-credit-card-chip::before {
  content: "\\f190f";
}

.mdi-credit-card-chip-outline::before {
  content: "\\f1910";
}

.mdi-credit-card-clock::before {
  content: "\\f0ee1";
}

.mdi-credit-card-clock-outline::before {
  content: "\\f0ee2";
}

.mdi-credit-card-edit::before {
  content: "\\f17d7";
}

.mdi-credit-card-edit-outline::before {
  content: "\\f17d8";
}

.mdi-credit-card-fast::before {
  content: "\\f1911";
}

.mdi-credit-card-fast-outline::before {
  content: "\\f1912";
}

.mdi-credit-card-lock::before {
  content: "\\f18e7";
}

.mdi-credit-card-lock-outline::before {
  content: "\\f18e8";
}

.mdi-credit-card-marker::before {
  content: "\\f06a8";
}

.mdi-credit-card-marker-outline::before {
  content: "\\f0dbe";
}

.mdi-credit-card-minus::before {
  content: "\\f0fac";
}

.mdi-credit-card-minus-outline::before {
  content: "\\f0fad";
}

.mdi-credit-card-multiple::before {
  content: "\\f0ff0";
}

.mdi-credit-card-multiple-outline::before {
  content: "\\f019c";
}

.mdi-credit-card-off::before {
  content: "\\f0ff1";
}

.mdi-credit-card-off-outline::before {
  content: "\\f05e4";
}

.mdi-credit-card-outline::before {
  content: "\\f019b";
}

.mdi-credit-card-plus::before {
  content: "\\f0ff2";
}

.mdi-credit-card-plus-outline::before {
  content: "\\f0676";
}

.mdi-credit-card-refresh::before {
  content: "\\f1645";
}

.mdi-credit-card-refresh-outline::before {
  content: "\\f1646";
}

.mdi-credit-card-refund::before {
  content: "\\f0ff3";
}

.mdi-credit-card-refund-outline::before {
  content: "\\f0aa8";
}

.mdi-credit-card-remove::before {
  content: "\\f0fae";
}

.mdi-credit-card-remove-outline::before {
  content: "\\f0faf";
}

.mdi-credit-card-scan::before {
  content: "\\f0ff4";
}

.mdi-credit-card-scan-outline::before {
  content: "\\f019d";
}

.mdi-credit-card-search::before {
  content: "\\f1647";
}

.mdi-credit-card-search-outline::before {
  content: "\\f1648";
}

.mdi-credit-card-settings::before {
  content: "\\f0ff5";
}

.mdi-credit-card-settings-outline::before {
  content: "\\f08d7";
}

.mdi-credit-card-sync::before {
  content: "\\f1649";
}

.mdi-credit-card-sync-outline::before {
  content: "\\f164a";
}

.mdi-credit-card-wireless::before {
  content: "\\f0802";
}

.mdi-credit-card-wireless-off::before {
  content: "\\f057a";
}

.mdi-credit-card-wireless-off-outline::before {
  content: "\\f057b";
}

.mdi-credit-card-wireless-outline::before {
  content: "\\f0d6c";
}

.mdi-cricket::before {
  content: "\\f0d6d";
}

.mdi-crop::before {
  content: "\\f019e";
}

.mdi-crop-free::before {
  content: "\\f019f";
}

.mdi-crop-landscape::before {
  content: "\\f01a0";
}

.mdi-crop-portrait::before {
  content: "\\f01a1";
}

.mdi-crop-rotate::before {
  content: "\\f0696";
}

.mdi-crop-square::before {
  content: "\\f01a2";
}

.mdi-cross::before {
  content: "\\f0953";
}

.mdi-cross-bolnisi::before {
  content: "\\f0ced";
}

.mdi-cross-celtic::before {
  content: "\\f0cf5";
}

.mdi-cross-outline::before {
  content: "\\f0cf6";
}

.mdi-crosshairs::before {
  content: "\\f01a3";
}

.mdi-crosshairs-gps::before {
  content: "\\f01a4";
}

.mdi-crosshairs-off::before {
  content: "\\f0f45";
}

.mdi-crosshairs-question::before {
  content: "\\f1136";
}

.mdi-crowd::before {
  content: "\\f1975";
}

.mdi-crown::before {
  content: "\\f01a5";
}

.mdi-crown-circle::before {
  content: "\\f17dc";
}

.mdi-crown-circle-outline::before {
  content: "\\f17dd";
}

.mdi-crown-outline::before {
  content: "\\f11d0";
}

.mdi-cryengine::before {
  content: "\\f0959";
}

.mdi-crystal-ball::before {
  content: "\\f0b2f";
}

.mdi-cube::before {
  content: "\\f01a6";
}

.mdi-cube-off::before {
  content: "\\f141c";
}

.mdi-cube-off-outline::before {
  content: "\\f141d";
}

.mdi-cube-outline::before {
  content: "\\f01a7";
}

.mdi-cube-scan::before {
  content: "\\f0b84";
}

.mdi-cube-send::before {
  content: "\\f01a8";
}

.mdi-cube-unfolded::before {
  content: "\\f01a9";
}

.mdi-cup::before {
  content: "\\f01aa";
}

.mdi-cup-off::before {
  content: "\\f05e5";
}

.mdi-cup-off-outline::before {
  content: "\\f137d";
}

.mdi-cup-outline::before {
  content: "\\f130f";
}

.mdi-cup-water::before {
  content: "\\f01ab";
}

.mdi-cupboard::before {
  content: "\\f0f46";
}

.mdi-cupboard-outline::before {
  content: "\\f0f47";
}

.mdi-cupcake::before {
  content: "\\f095a";
}

.mdi-curling::before {
  content: "\\f0863";
}

.mdi-currency-bdt::before {
  content: "\\f0864";
}

.mdi-currency-brl::before {
  content: "\\f0b85";
}

.mdi-currency-btc::before {
  content: "\\f01ac";
}

.mdi-currency-cny::before {
  content: "\\f07ba";
}

.mdi-currency-eth::before {
  content: "\\f07bb";
}

.mdi-currency-eur::before {
  content: "\\f01ad";
}

.mdi-currency-eur-off::before {
  content: "\\f1315";
}

.mdi-currency-gbp::before {
  content: "\\f01ae";
}

.mdi-currency-ils::before {
  content: "\\f0c61";
}

.mdi-currency-inr::before {
  content: "\\f01af";
}

.mdi-currency-jpy::before {
  content: "\\f07bc";
}

.mdi-currency-krw::before {
  content: "\\f07bd";
}

.mdi-currency-kzt::before {
  content: "\\f0865";
}

.mdi-currency-mnt::before {
  content: "\\f1512";
}

.mdi-currency-ngn::before {
  content: "\\f01b0";
}

.mdi-currency-php::before {
  content: "\\f09e6";
}

.mdi-currency-rial::before {
  content: "\\f0e9c";
}

.mdi-currency-rub::before {
  content: "\\f01b1";
}

.mdi-currency-rupee::before {
  content: "\\f1976";
}

.mdi-currency-sign::before {
  content: "\\f07be";
}

.mdi-currency-try::before {
  content: "\\f01b2";
}

.mdi-currency-twd::before {
  content: "\\f07bf";
}

.mdi-currency-usd::before {
  content: "\\f01c1";
}

.mdi-currency-usd-off::before {
  content: "\\f067a";
}

.mdi-current-ac::before {
  content: "\\f1480";
}

.mdi-current-dc::before {
  content: "\\f095c";
}

.mdi-cursor-default::before {
  content: "\\f01c0";
}

.mdi-cursor-default-click::before {
  content: "\\f0cfd";
}

.mdi-cursor-default-click-outline::before {
  content: "\\f0cfe";
}

.mdi-cursor-default-gesture::before {
  content: "\\f1127";
}

.mdi-cursor-default-gesture-outline::before {
  content: "\\f1128";
}

.mdi-cursor-default-outline::before {
  content: "\\f01bf";
}

.mdi-cursor-move::before {
  content: "\\f01be";
}

.mdi-cursor-pointer::before {
  content: "\\f01bd";
}

.mdi-cursor-text::before {
  content: "\\f05e7";
}

.mdi-curtains::before {
  content: "\\f1846";
}

.mdi-curtains-closed::before {
  content: "\\f1847";
}

.mdi-cylinder::before {
  content: "\\f194e";
}

.mdi-cylinder-off::before {
  content: "\\f194f";
}

.mdi-dance-ballroom::before {
  content: "\\f15fb";
}

.mdi-dance-pole::before {
  content: "\\f1578";
}

.mdi-data-matrix::before {
  content: "\\f153c";
}

.mdi-data-matrix-edit::before {
  content: "\\f153d";
}

.mdi-data-matrix-minus::before {
  content: "\\f153e";
}

.mdi-data-matrix-plus::before {
  content: "\\f153f";
}

.mdi-data-matrix-remove::before {
  content: "\\f1540";
}

.mdi-data-matrix-scan::before {
  content: "\\f1541";
}

.mdi-database::before {
  content: "\\f01bc";
}

.mdi-database-alert::before {
  content: "\\f163a";
}

.mdi-database-alert-outline::before {
  content: "\\f1624";
}

.mdi-database-arrow-down::before {
  content: "\\f163b";
}

.mdi-database-arrow-down-outline::before {
  content: "\\f1625";
}

.mdi-database-arrow-left::before {
  content: "\\f163c";
}

.mdi-database-arrow-left-outline::before {
  content: "\\f1626";
}

.mdi-database-arrow-right::before {
  content: "\\f163d";
}

.mdi-database-arrow-right-outline::before {
  content: "\\f1627";
}

.mdi-database-arrow-up::before {
  content: "\\f163e";
}

.mdi-database-arrow-up-outline::before {
  content: "\\f1628";
}

.mdi-database-check::before {
  content: "\\f0aa9";
}

.mdi-database-check-outline::before {
  content: "\\f1629";
}

.mdi-database-clock::before {
  content: "\\f163f";
}

.mdi-database-clock-outline::before {
  content: "\\f162a";
}

.mdi-database-cog::before {
  content: "\\f164b";
}

.mdi-database-cog-outline::before {
  content: "\\f164c";
}

.mdi-database-edit::before {
  content: "\\f0b86";
}

.mdi-database-edit-outline::before {
  content: "\\f162b";
}

.mdi-database-export::before {
  content: "\\f095e";
}

.mdi-database-export-outline::before {
  content: "\\f162c";
}

.mdi-database-eye::before {
  content: "\\f191f";
}

.mdi-database-eye-off::before {
  content: "\\f1920";
}

.mdi-database-eye-off-outline::before {
  content: "\\f1921";
}

.mdi-database-eye-outline::before {
  content: "\\f1922";
}

.mdi-database-import::before {
  content: "\\f095d";
}

.mdi-database-import-outline::before {
  content: "\\f162d";
}

.mdi-database-lock::before {
  content: "\\f0aaa";
}

.mdi-database-lock-outline::before {
  content: "\\f162e";
}

.mdi-database-marker::before {
  content: "\\f12f6";
}

.mdi-database-marker-outline::before {
  content: "\\f162f";
}

.mdi-database-minus::before {
  content: "\\f01bb";
}

.mdi-database-minus-outline::before {
  content: "\\f1630";
}

.mdi-database-off::before {
  content: "\\f1640";
}

.mdi-database-off-outline::before {
  content: "\\f1631";
}

.mdi-database-outline::before {
  content: "\\f1632";
}

.mdi-database-plus::before {
  content: "\\f01ba";
}

.mdi-database-plus-outline::before {
  content: "\\f1633";
}

.mdi-database-refresh::before {
  content: "\\f05c2";
}

.mdi-database-refresh-outline::before {
  content: "\\f1634";
}

.mdi-database-remove::before {
  content: "\\f0d00";
}

.mdi-database-remove-outline::before {
  content: "\\f1635";
}

.mdi-database-search::before {
  content: "\\f0866";
}

.mdi-database-search-outline::before {
  content: "\\f1636";
}

.mdi-database-settings::before {
  content: "\\f0d01";
}

.mdi-database-settings-outline::before {
  content: "\\f1637";
}

.mdi-database-sync::before {
  content: "\\f0cff";
}

.mdi-database-sync-outline::before {
  content: "\\f1638";
}

.mdi-death-star::before {
  content: "\\f08d8";
}

.mdi-death-star-variant::before {
  content: "\\f08d9";
}

.mdi-deathly-hallows::before {
  content: "\\f0b87";
}

.mdi-debian::before {
  content: "\\f08da";
}

.mdi-debug-step-into::before {
  content: "\\f01b9";
}

.mdi-debug-step-out::before {
  content: "\\f01b8";
}

.mdi-debug-step-over::before {
  content: "\\f01b7";
}

.mdi-decagram::before {
  content: "\\f076c";
}

.mdi-decagram-outline::before {
  content: "\\f076d";
}

.mdi-decimal::before {
  content: "\\f10a1";
}

.mdi-decimal-comma::before {
  content: "\\f10a2";
}

.mdi-decimal-comma-decrease::before {
  content: "\\f10a3";
}

.mdi-decimal-comma-increase::before {
  content: "\\f10a4";
}

.mdi-decimal-decrease::before {
  content: "\\f01b6";
}

.mdi-decimal-increase::before {
  content: "\\f01b5";
}

.mdi-delete::before {
  content: "\\f01b4";
}

.mdi-delete-alert::before {
  content: "\\f10a5";
}

.mdi-delete-alert-outline::before {
  content: "\\f10a6";
}

.mdi-delete-circle::before {
  content: "\\f0683";
}

.mdi-delete-circle-outline::before {
  content: "\\f0b88";
}

.mdi-delete-clock::before {
  content: "\\f1556";
}

.mdi-delete-clock-outline::before {
  content: "\\f1557";
}

.mdi-delete-empty::before {
  content: "\\f06cc";
}

.mdi-delete-empty-outline::before {
  content: "\\f0e9d";
}

.mdi-delete-forever::before {
  content: "\\f05e8";
}

.mdi-delete-forever-outline::before {
  content: "\\f0b89";
}

.mdi-delete-off::before {
  content: "\\f10a7";
}

.mdi-delete-off-outline::before {
  content: "\\f10a8";
}

.mdi-delete-outline::before {
  content: "\\f09e7";
}

.mdi-delete-restore::before {
  content: "\\f0819";
}

.mdi-delete-sweep::before {
  content: "\\f05e9";
}

.mdi-delete-sweep-outline::before {
  content: "\\f0c62";
}

.mdi-delete-variant::before {
  content: "\\f01b3";
}

.mdi-delta::before {
  content: "\\f01c2";
}

.mdi-desk::before {
  content: "\\f1239";
}

.mdi-desk-lamp::before {
  content: "\\f095f";
}

.mdi-deskphone::before {
  content: "\\f01c3";
}

.mdi-desktop-classic::before {
  content: "\\f07c0";
}

.mdi-desktop-mac::before {
  content: "\\f01c4";
}

.mdi-desktop-mac-dashboard::before {
  content: "\\f09e8";
}

.mdi-desktop-tower::before {
  content: "\\f01c5";
}

.mdi-desktop-tower-monitor::before {
  content: "\\f0aab";
}

.mdi-details::before {
  content: "\\f01c6";
}

.mdi-dev-to::before {
  content: "\\f0d6e";
}

.mdi-developer-board::before {
  content: "\\f0697";
}

.mdi-deviantart::before {
  content: "\\f01c7";
}

.mdi-devices::before {
  content: "\\f0fb0";
}

.mdi-dharmachakra::before {
  content: "\\f094b";
}

.mdi-diabetes::before {
  content: "\\f1126";
}

.mdi-dialpad::before {
  content: "\\f061c";
}

.mdi-diameter::before {
  content: "\\f0c63";
}

.mdi-diameter-outline::before {
  content: "\\f0c64";
}

.mdi-diameter-variant::before {
  content: "\\f0c65";
}

.mdi-diamond::before {
  content: "\\f0b8a";
}

.mdi-diamond-outline::before {
  content: "\\f0b8b";
}

.mdi-diamond-stone::before {
  content: "\\f01c8";
}

.mdi-dice-1::before {
  content: "\\f01ca";
}

.mdi-dice-1-outline::before {
  content: "\\f114a";
}

.mdi-dice-2::before {
  content: "\\f01cb";
}

.mdi-dice-2-outline::before {
  content: "\\f114b";
}

.mdi-dice-3::before {
  content: "\\f01cc";
}

.mdi-dice-3-outline::before {
  content: "\\f114c";
}

.mdi-dice-4::before {
  content: "\\f01cd";
}

.mdi-dice-4-outline::before {
  content: "\\f114d";
}

.mdi-dice-5::before {
  content: "\\f01ce";
}

.mdi-dice-5-outline::before {
  content: "\\f114e";
}

.mdi-dice-6::before {
  content: "\\f01cf";
}

.mdi-dice-6-outline::before {
  content: "\\f114f";
}

.mdi-dice-d10::before {
  content: "\\f1153";
}

.mdi-dice-d10-outline::before {
  content: "\\f076f";
}

.mdi-dice-d12::before {
  content: "\\f1154";
}

.mdi-dice-d12-outline::before {
  content: "\\f0867";
}

.mdi-dice-d20::before {
  content: "\\f1155";
}

.mdi-dice-d20-outline::before {
  content: "\\f05ea";
}

.mdi-dice-d4::before {
  content: "\\f1150";
}

.mdi-dice-d4-outline::before {
  content: "\\f05eb";
}

.mdi-dice-d6::before {
  content: "\\f1151";
}

.mdi-dice-d6-outline::before {
  content: "\\f05ed";
}

.mdi-dice-d8::before {
  content: "\\f1152";
}

.mdi-dice-d8-outline::before {
  content: "\\f05ec";
}

.mdi-dice-multiple::before {
  content: "\\f076e";
}

.mdi-dice-multiple-outline::before {
  content: "\\f1156";
}

.mdi-digital-ocean::before {
  content: "\\f1237";
}

.mdi-dip-switch::before {
  content: "\\f07c1";
}

.mdi-directions::before {
  content: "\\f01d0";
}

.mdi-directions-fork::before {
  content: "\\f0641";
}

.mdi-disc::before {
  content: "\\f05ee";
}

.mdi-disc-alert::before {
  content: "\\f01d1";
}

.mdi-disc-player::before {
  content: "\\f0960";
}

.mdi-discord::before {
  content: "\\f066f";
}

.mdi-dishwasher::before {
  content: "\\f0aac";
}

.mdi-dishwasher-alert::before {
  content: "\\f11b8";
}

.mdi-dishwasher-off::before {
  content: "\\f11b9";
}

.mdi-disqus::before {
  content: "\\f01d2";
}

.mdi-distribute-horizontal-center::before {
  content: "\\f11c9";
}

.mdi-distribute-horizontal-left::before {
  content: "\\f11c8";
}

.mdi-distribute-horizontal-right::before {
  content: "\\f11ca";
}

.mdi-distribute-vertical-bottom::before {
  content: "\\f11cb";
}

.mdi-distribute-vertical-center::before {
  content: "\\f11cc";
}

.mdi-distribute-vertical-top::before {
  content: "\\f11cd";
}

.mdi-diversify::before {
  content: "\\f1877";
}

.mdi-diving::before {
  content: "\\f1977";
}

.mdi-diving-flippers::before {
  content: "\\f0dbf";
}

.mdi-diving-helmet::before {
  content: "\\f0dc0";
}

.mdi-diving-scuba::before {
  content: "\\f0dc1";
}

.mdi-diving-scuba-flag::before {
  content: "\\f0dc2";
}

.mdi-diving-scuba-tank::before {
  content: "\\f0dc3";
}

.mdi-diving-scuba-tank-multiple::before {
  content: "\\f0dc4";
}

.mdi-diving-snorkel::before {
  content: "\\f0dc5";
}

.mdi-division::before {
  content: "\\f01d4";
}

.mdi-division-box::before {
  content: "\\f01d5";
}

.mdi-dlna::before {
  content: "\\f0a41";
}

.mdi-dna::before {
  content: "\\f0684";
}

.mdi-dns::before {
  content: "\\f01d6";
}

.mdi-dns-outline::before {
  content: "\\f0b8c";
}

.mdi-dock-bottom::before {
  content: "\\f10a9";
}

.mdi-dock-left::before {
  content: "\\f10aa";
}

.mdi-dock-right::before {
  content: "\\f10ab";
}

.mdi-dock-top::before {
  content: "\\f1513";
}

.mdi-dock-window::before {
  content: "\\f10ac";
}

.mdi-docker::before {
  content: "\\f0868";
}

.mdi-doctor::before {
  content: "\\f0a42";
}

.mdi-dog::before {
  content: "\\f0a43";
}

.mdi-dog-service::before {
  content: "\\f0aad";
}

.mdi-dog-side::before {
  content: "\\f0a44";
}

.mdi-dog-side-off::before {
  content: "\\f16ee";
}

.mdi-dolby::before {
  content: "\\f06b3";
}

.mdi-dolly::before {
  content: "\\f0e9e";
}

.mdi-dolphin::before {
  content: "\\f18b4";
}

.mdi-domain::before {
  content: "\\f01d7";
}

.mdi-domain-off::before {
  content: "\\f0d6f";
}

.mdi-domain-plus::before {
  content: "\\f10ad";
}

.mdi-domain-remove::before {
  content: "\\f10ae";
}

.mdi-dome-light::before {
  content: "\\f141e";
}

.mdi-domino-mask::before {
  content: "\\f1023";
}

.mdi-donkey::before {
  content: "\\f07c2";
}

.mdi-door::before {
  content: "\\f081a";
}

.mdi-door-closed::before {
  content: "\\f081b";
}

.mdi-door-closed-lock::before {
  content: "\\f10af";
}

.mdi-door-open::before {
  content: "\\f081c";
}

.mdi-door-sliding::before {
  content: "\\f181e";
}

.mdi-door-sliding-lock::before {
  content: "\\f181f";
}

.mdi-door-sliding-open::before {
  content: "\\f1820";
}

.mdi-doorbell::before {
  content: "\\f12e6";
}

.mdi-doorbell-video::before {
  content: "\\f0869";
}

.mdi-dot-net::before {
  content: "\\f0aae";
}

.mdi-dots-circle::before {
  content: "\\f1978";
}

.mdi-dots-grid::before {
  content: "\\f15fc";
}

.mdi-dots-hexagon::before {
  content: "\\f15ff";
}

.mdi-dots-horizontal::before {
  content: "\\f01d8";
}

.mdi-dots-horizontal-circle::before {
  content: "\\f07c3";
}

.mdi-dots-horizontal-circle-outline::before {
  content: "\\f0b8d";
}

.mdi-dots-square::before {
  content: "\\f15fd";
}

.mdi-dots-triangle::before {
  content: "\\f15fe";
}

.mdi-dots-vertical::before {
  content: "\\f01d9";
}

.mdi-dots-vertical-circle::before {
  content: "\\f07c4";
}

.mdi-dots-vertical-circle-outline::before {
  content: "\\f0b8e";
}

.mdi-download::before {
  content: "\\f01da";
}

.mdi-download-box::before {
  content: "\\f1462";
}

.mdi-download-box-outline::before {
  content: "\\f1463";
}

.mdi-download-circle::before {
  content: "\\f1464";
}

.mdi-download-circle-outline::before {
  content: "\\f1465";
}

.mdi-download-lock::before {
  content: "\\f1320";
}

.mdi-download-lock-outline::before {
  content: "\\f1321";
}

.mdi-download-multiple::before {
  content: "\\f09e9";
}

.mdi-download-network::before {
  content: "\\f06f4";
}

.mdi-download-network-outline::before {
  content: "\\f0c66";
}

.mdi-download-off::before {
  content: "\\f10b0";
}

.mdi-download-off-outline::before {
  content: "\\f10b1";
}

.mdi-download-outline::before {
  content: "\\f0b8f";
}

.mdi-drag::before {
  content: "\\f01db";
}

.mdi-drag-horizontal::before {
  content: "\\f01dc";
}

.mdi-drag-horizontal-variant::before {
  content: "\\f12f0";
}

.mdi-drag-variant::before {
  content: "\\f0b90";
}

.mdi-drag-vertical::before {
  content: "\\f01dd";
}

.mdi-drag-vertical-variant::before {
  content: "\\f12f1";
}

.mdi-drama-masks::before {
  content: "\\f0d02";
}

.mdi-draw::before {
  content: "\\f0f49";
}

.mdi-draw-pen::before {
  content: "\\f19b9";
}

.mdi-drawing::before {
  content: "\\f01de";
}

.mdi-drawing-box::before {
  content: "\\f01df";
}

.mdi-dresser::before {
  content: "\\f0f4a";
}

.mdi-dresser-outline::before {
  content: "\\f0f4b";
}

.mdi-drone::before {
  content: "\\f01e2";
}

.mdi-dropbox::before {
  content: "\\f01e3";
}

.mdi-drupal::before {
  content: "\\f01e4";
}

.mdi-duck::before {
  content: "\\f01e5";
}

.mdi-dumbbell::before {
  content: "\\f01e6";
}

.mdi-dump-truck::before {
  content: "\\f0c67";
}

.mdi-ear-hearing::before {
  content: "\\f07c5";
}

.mdi-ear-hearing-off::before {
  content: "\\f0a45";
}

.mdi-earbuds::before {
  content: "\\f184f";
}

.mdi-earbuds-off::before {
  content: "\\f1850";
}

.mdi-earbuds-off-outline::before {
  content: "\\f1851";
}

.mdi-earbuds-outline::before {
  content: "\\f1852";
}

.mdi-earth::before {
  content: "\\f01e7";
}

.mdi-earth-arrow-right::before {
  content: "\\f1311";
}

.mdi-earth-box::before {
  content: "\\f06cd";
}

.mdi-earth-box-minus::before {
  content: "\\f1407";
}

.mdi-earth-box-off::before {
  content: "\\f06ce";
}

.mdi-earth-box-plus::before {
  content: "\\f1406";
}

.mdi-earth-box-remove::before {
  content: "\\f1408";
}

.mdi-earth-minus::before {
  content: "\\f1404";
}

.mdi-earth-off::before {
  content: "\\f01e8";
}

.mdi-earth-plus::before {
  content: "\\f1403";
}

.mdi-earth-remove::before {
  content: "\\f1405";
}

.mdi-egg::before {
  content: "\\f0aaf";
}

.mdi-egg-easter::before {
  content: "\\f0ab0";
}

.mdi-egg-fried::before {
  content: "\\f184a";
}

.mdi-egg-off::before {
  content: "\\f13f0";
}

.mdi-egg-off-outline::before {
  content: "\\f13f1";
}

.mdi-egg-outline::before {
  content: "\\f13f2";
}

.mdi-eiffel-tower::before {
  content: "\\f156b";
}

.mdi-eight-track::before {
  content: "\\f09ea";
}

.mdi-eject::before {
  content: "\\f01ea";
}

.mdi-eject-outline::before {
  content: "\\f0b91";
}

.mdi-electric-switch::before {
  content: "\\f0e9f";
}

.mdi-electric-switch-closed::before {
  content: "\\f10d9";
}

.mdi-electron-framework::before {
  content: "\\f1024";
}

.mdi-elephant::before {
  content: "\\f07c6";
}

.mdi-elevation-decline::before {
  content: "\\f01eb";
}

.mdi-elevation-rise::before {
  content: "\\f01ec";
}

.mdi-elevator::before {
  content: "\\f01ed";
}

.mdi-elevator-down::before {
  content: "\\f12c2";
}

.mdi-elevator-passenger::before {
  content: "\\f1381";
}

.mdi-elevator-passenger-off::before {
  content: "\\f1979";
}

.mdi-elevator-passenger-off-outline::before {
  content: "\\f197a";
}

.mdi-elevator-passenger-outline::before {
  content: "\\f197b";
}

.mdi-elevator-up::before {
  content: "\\f12c1";
}

.mdi-ellipse::before {
  content: "\\f0ea0";
}

.mdi-ellipse-outline::before {
  content: "\\f0ea1";
}

.mdi-email::before {
  content: "\\f01ee";
}

.mdi-email-alert::before {
  content: "\\f06cf";
}

.mdi-email-alert-outline::before {
  content: "\\f0d42";
}

.mdi-email-box::before {
  content: "\\f0d03";
}

.mdi-email-check::before {
  content: "\\f0ab1";
}

.mdi-email-check-outline::before {
  content: "\\f0ab2";
}

.mdi-email-edit::before {
  content: "\\f0ee3";
}

.mdi-email-edit-outline::before {
  content: "\\f0ee4";
}

.mdi-email-fast::before {
  content: "\\f186f";
}

.mdi-email-fast-outline::before {
  content: "\\f1870";
}

.mdi-email-lock::before {
  content: "\\f01f1";
}

.mdi-email-mark-as-unread::before {
  content: "\\f0b92";
}

.mdi-email-minus::before {
  content: "\\f0ee5";
}

.mdi-email-minus-outline::before {
  content: "\\f0ee6";
}

.mdi-email-multiple::before {
  content: "\\f0ee7";
}

.mdi-email-multiple-outline::before {
  content: "\\f0ee8";
}

.mdi-email-newsletter::before {
  content: "\\f0fb1";
}

.mdi-email-off::before {
  content: "\\f13e3";
}

.mdi-email-off-outline::before {
  content: "\\f13e4";
}

.mdi-email-open::before {
  content: "\\f01ef";
}

.mdi-email-open-multiple::before {
  content: "\\f0ee9";
}

.mdi-email-open-multiple-outline::before {
  content: "\\f0eea";
}

.mdi-email-open-outline::before {
  content: "\\f05ef";
}

.mdi-email-outline::before {
  content: "\\f01f0";
}

.mdi-email-plus::before {
  content: "\\f09eb";
}

.mdi-email-plus-outline::before {
  content: "\\f09ec";
}

.mdi-email-receive::before {
  content: "\\f10da";
}

.mdi-email-receive-outline::before {
  content: "\\f10db";
}

.mdi-email-remove::before {
  content: "\\f1661";
}

.mdi-email-remove-outline::before {
  content: "\\f1662";
}

.mdi-email-seal::before {
  content: "\\f195b";
}

.mdi-email-seal-outline::before {
  content: "\\f195c";
}

.mdi-email-search::before {
  content: "\\f0961";
}

.mdi-email-search-outline::before {
  content: "\\f0962";
}

.mdi-email-send::before {
  content: "\\f10dc";
}

.mdi-email-send-outline::before {
  content: "\\f10dd";
}

.mdi-email-sync::before {
  content: "\\f12c7";
}

.mdi-email-sync-outline::before {
  content: "\\f12c8";
}

.mdi-email-variant::before {
  content: "\\f05f0";
}

.mdi-ember::before {
  content: "\\f0b30";
}

.mdi-emby::before {
  content: "\\f06b4";
}

.mdi-emoticon::before {
  content: "\\f0c68";
}

.mdi-emoticon-angry::before {
  content: "\\f0c69";
}

.mdi-emoticon-angry-outline::before {
  content: "\\f0c6a";
}

.mdi-emoticon-confused::before {
  content: "\\f10de";
}

.mdi-emoticon-confused-outline::before {
  content: "\\f10df";
}

.mdi-emoticon-cool::before {
  content: "\\f0c6b";
}

.mdi-emoticon-cool-outline::before {
  content: "\\f01f3";
}

.mdi-emoticon-cry::before {
  content: "\\f0c6c";
}

.mdi-emoticon-cry-outline::before {
  content: "\\f0c6d";
}

.mdi-emoticon-dead::before {
  content: "\\f0c6e";
}

.mdi-emoticon-dead-outline::before {
  content: "\\f069b";
}

.mdi-emoticon-devil::before {
  content: "\\f0c6f";
}

.mdi-emoticon-devil-outline::before {
  content: "\\f01f4";
}

.mdi-emoticon-excited::before {
  content: "\\f0c70";
}

.mdi-emoticon-excited-outline::before {
  content: "\\f069c";
}

.mdi-emoticon-frown::before {
  content: "\\f0f4c";
}

.mdi-emoticon-frown-outline::before {
  content: "\\f0f4d";
}

.mdi-emoticon-happy::before {
  content: "\\f0c71";
}

.mdi-emoticon-happy-outline::before {
  content: "\\f01f5";
}

.mdi-emoticon-kiss::before {
  content: "\\f0c72";
}

.mdi-emoticon-kiss-outline::before {
  content: "\\f0c73";
}

.mdi-emoticon-lol::before {
  content: "\\f1214";
}

.mdi-emoticon-lol-outline::before {
  content: "\\f1215";
}

.mdi-emoticon-neutral::before {
  content: "\\f0c74";
}

.mdi-emoticon-neutral-outline::before {
  content: "\\f01f6";
}

.mdi-emoticon-outline::before {
  content: "\\f01f2";
}

.mdi-emoticon-poop::before {
  content: "\\f01f7";
}

.mdi-emoticon-poop-outline::before {
  content: "\\f0c75";
}

.mdi-emoticon-sad::before {
  content: "\\f0c76";
}

.mdi-emoticon-sad-outline::before {
  content: "\\f01f8";
}

.mdi-emoticon-sick::before {
  content: "\\f157c";
}

.mdi-emoticon-sick-outline::before {
  content: "\\f157d";
}

.mdi-emoticon-tongue::before {
  content: "\\f01f9";
}

.mdi-emoticon-tongue-outline::before {
  content: "\\f0c77";
}

.mdi-emoticon-wink::before {
  content: "\\f0c78";
}

.mdi-emoticon-wink-outline::before {
  content: "\\f0c79";
}

.mdi-engine::before {
  content: "\\f01fa";
}

.mdi-engine-off::before {
  content: "\\f0a46";
}

.mdi-engine-off-outline::before {
  content: "\\f0a47";
}

.mdi-engine-outline::before {
  content: "\\f01fb";
}

.mdi-epsilon::before {
  content: "\\f10e0";
}

.mdi-equal::before {
  content: "\\f01fc";
}

.mdi-equal-box::before {
  content: "\\f01fd";
}

.mdi-equalizer::before {
  content: "\\f0ea2";
}

.mdi-equalizer-outline::before {
  content: "\\f0ea3";
}

.mdi-eraser::before {
  content: "\\f01fe";
}

.mdi-eraser-variant::before {
  content: "\\f0642";
}

.mdi-escalator::before {
  content: "\\f01ff";
}

.mdi-escalator-box::before {
  content: "\\f1399";
}

.mdi-escalator-down::before {
  content: "\\f12c0";
}

.mdi-escalator-up::before {
  content: "\\f12bf";
}

.mdi-eslint::before {
  content: "\\f0c7a";
}

.mdi-et::before {
  content: "\\f0ab3";
}

.mdi-ethereum::before {
  content: "\\f086a";
}

.mdi-ethernet::before {
  content: "\\f0200";
}

.mdi-ethernet-cable::before {
  content: "\\f0201";
}

.mdi-ethernet-cable-off::before {
  content: "\\f0202";
}

.mdi-ev-plug-ccs1::before {
  content: "\\f1519";
}

.mdi-ev-plug-ccs2::before {
  content: "\\f151a";
}

.mdi-ev-plug-chademo::before {
  content: "\\f151b";
}

.mdi-ev-plug-tesla::before {
  content: "\\f151c";
}

.mdi-ev-plug-type1::before {
  content: "\\f151d";
}

.mdi-ev-plug-type2::before {
  content: "\\f151e";
}

.mdi-ev-station::before {
  content: "\\f05f1";
}

.mdi-evernote::before {
  content: "\\f0204";
}

.mdi-excavator::before {
  content: "\\f1025";
}

.mdi-exclamation::before {
  content: "\\f0205";
}

.mdi-exclamation-thick::before {
  content: "\\f1238";
}

.mdi-exit-run::before {
  content: "\\f0a48";
}

.mdi-exit-to-app::before {
  content: "\\f0206";
}

.mdi-expand-all::before {
  content: "\\f0ab4";
}

.mdi-expand-all-outline::before {
  content: "\\f0ab5";
}

.mdi-expansion-card::before {
  content: "\\f08ae";
}

.mdi-expansion-card-variant::before {
  content: "\\f0fb2";
}

.mdi-exponent::before {
  content: "\\f0963";
}

.mdi-exponent-box::before {
  content: "\\f0964";
}

.mdi-export::before {
  content: "\\f0207";
}

.mdi-export-variant::before {
  content: "\\f0b93";
}

.mdi-eye::before {
  content: "\\f0208";
}

.mdi-eye-arrow-left::before {
  content: "\\f18fd";
}

.mdi-eye-arrow-left-outline::before {
  content: "\\f18fe";
}

.mdi-eye-arrow-right::before {
  content: "\\f18ff";
}

.mdi-eye-arrow-right-outline::before {
  content: "\\f1900";
}

.mdi-eye-check::before {
  content: "\\f0d04";
}

.mdi-eye-check-outline::before {
  content: "\\f0d05";
}

.mdi-eye-circle::before {
  content: "\\f0b94";
}

.mdi-eye-circle-outline::before {
  content: "\\f0b95";
}

.mdi-eye-minus::before {
  content: "\\f1026";
}

.mdi-eye-minus-outline::before {
  content: "\\f1027";
}

.mdi-eye-off::before {
  content: "\\f0209";
}

.mdi-eye-off-outline::before {
  content: "\\f06d1";
}

.mdi-eye-outline::before {
  content: "\\f06d0";
}

.mdi-eye-plus::before {
  content: "\\f086b";
}

.mdi-eye-plus-outline::before {
  content: "\\f086c";
}

.mdi-eye-refresh::before {
  content: "\\f197c";
}

.mdi-eye-refresh-outline::before {
  content: "\\f197d";
}

.mdi-eye-remove::before {
  content: "\\f15e3";
}

.mdi-eye-remove-outline::before {
  content: "\\f15e4";
}

.mdi-eye-settings::before {
  content: "\\f086d";
}

.mdi-eye-settings-outline::before {
  content: "\\f086e";
}

.mdi-eyedropper::before {
  content: "\\f020a";
}

.mdi-eyedropper-minus::before {
  content: "\\f13dd";
}

.mdi-eyedropper-off::before {
  content: "\\f13df";
}

.mdi-eyedropper-plus::before {
  content: "\\f13dc";
}

.mdi-eyedropper-remove::before {
  content: "\\f13de";
}

.mdi-eyedropper-variant::before {
  content: "\\f020b";
}

.mdi-face-agent::before {
  content: "\\f0d70";
}

.mdi-face-man::before {
  content: "\\f0643";
}

.mdi-face-man-outline::before {
  content: "\\f0b96";
}

.mdi-face-man-profile::before {
  content: "\\f0644";
}

.mdi-face-man-shimmer::before {
  content: "\\f15cc";
}

.mdi-face-man-shimmer-outline::before {
  content: "\\f15cd";
}

.mdi-face-mask::before {
  content: "\\f1586";
}

.mdi-face-mask-outline::before {
  content: "\\f1587";
}

.mdi-face-recognition::before {
  content: "\\f0c7b";
}

.mdi-face-woman::before {
  content: "\\f1077";
}

.mdi-face-woman-outline::before {
  content: "\\f1078";
}

.mdi-face-woman-profile::before {
  content: "\\f1076";
}

.mdi-face-woman-shimmer::before {
  content: "\\f15ce";
}

.mdi-face-woman-shimmer-outline::before {
  content: "\\f15cf";
}

.mdi-facebook::before {
  content: "\\f020c";
}

.mdi-facebook-gaming::before {
  content: "\\f07dd";
}

.mdi-facebook-messenger::before {
  content: "\\f020e";
}

.mdi-facebook-workplace::before {
  content: "\\f0b31";
}

.mdi-factory::before {
  content: "\\f020f";
}

.mdi-family-tree::before {
  content: "\\f160e";
}

.mdi-fan::before {
  content: "\\f0210";
}

.mdi-fan-alert::before {
  content: "\\f146c";
}

.mdi-fan-auto::before {
  content: "\\f171d";
}

.mdi-fan-chevron-down::before {
  content: "\\f146d";
}

.mdi-fan-chevron-up::before {
  content: "\\f146e";
}

.mdi-fan-minus::before {
  content: "\\f1470";
}

.mdi-fan-off::before {
  content: "\\f081d";
}

.mdi-fan-plus::before {
  content: "\\f146f";
}

.mdi-fan-remove::before {
  content: "\\f1471";
}

.mdi-fan-speed-1::before {
  content: "\\f1472";
}

.mdi-fan-speed-2::before {
  content: "\\f1473";
}

.mdi-fan-speed-3::before {
  content: "\\f1474";
}

.mdi-fast-forward::before {
  content: "\\f0211";
}

.mdi-fast-forward-10::before {
  content: "\\f0d71";
}

.mdi-fast-forward-15::before {
  content: "\\f193a";
}

.mdi-fast-forward-30::before {
  content: "\\f0d06";
}

.mdi-fast-forward-5::before {
  content: "\\f11f8";
}

.mdi-fast-forward-60::before {
  content: "\\f160b";
}

.mdi-fast-forward-outline::before {
  content: "\\f06d2";
}

.mdi-fax::before {
  content: "\\f0212";
}

.mdi-feather::before {
  content: "\\f06d3";
}

.mdi-feature-search::before {
  content: "\\f0a49";
}

.mdi-feature-search-outline::before {
  content: "\\f0a4a";
}

.mdi-fedora::before {
  content: "\\f08db";
}

.mdi-fence::before {
  content: "\\f179a";
}

.mdi-fence-electric::before {
  content: "\\f17f6";
}

.mdi-fencing::before {
  content: "\\f14c1";
}

.mdi-ferris-wheel::before {
  content: "\\f0ea4";
}

.mdi-ferry::before {
  content: "\\f0213";
}

.mdi-file::before {
  content: "\\f0214";
}

.mdi-file-account::before {
  content: "\\f073b";
}

.mdi-file-account-outline::before {
  content: "\\f1028";
}

.mdi-file-alert::before {
  content: "\\f0a4b";
}

.mdi-file-alert-outline::before {
  content: "\\f0a4c";
}

.mdi-file-cabinet::before {
  content: "\\f0ab6";
}

.mdi-file-cad::before {
  content: "\\f0eeb";
}

.mdi-file-cad-box::before {
  content: "\\f0eec";
}

.mdi-file-cancel::before {
  content: "\\f0dc6";
}

.mdi-file-cancel-outline::before {
  content: "\\f0dc7";
}

.mdi-file-certificate::before {
  content: "\\f1186";
}

.mdi-file-certificate-outline::before {
  content: "\\f1187";
}

.mdi-file-chart::before {
  content: "\\f0215";
}

.mdi-file-chart-outline::before {
  content: "\\f1029";
}

.mdi-file-check::before {
  content: "\\f0216";
}

.mdi-file-check-outline::before {
  content: "\\f0e29";
}

.mdi-file-clock::before {
  content: "\\f12e1";
}

.mdi-file-clock-outline::before {
  content: "\\f12e2";
}

.mdi-file-cloud::before {
  content: "\\f0217";
}

.mdi-file-cloud-outline::before {
  content: "\\f102a";
}

.mdi-file-code::before {
  content: "\\f022e";
}

.mdi-file-code-outline::before {
  content: "\\f102b";
}

.mdi-file-cog::before {
  content: "\\f107b";
}

.mdi-file-cog-outline::before {
  content: "\\f107c";
}

.mdi-file-compare::before {
  content: "\\f08aa";
}

.mdi-file-delimited::before {
  content: "\\f0218";
}

.mdi-file-delimited-outline::before {
  content: "\\f0ea5";
}

.mdi-file-document::before {
  content: "\\f0219";
}

.mdi-file-document-edit::before {
  content: "\\f0dc8";
}

.mdi-file-document-edit-outline::before {
  content: "\\f0dc9";
}

.mdi-file-document-multiple::before {
  content: "\\f1517";
}

.mdi-file-document-multiple-outline::before {
  content: "\\f1518";
}

.mdi-file-document-outline::before {
  content: "\\f09ee";
}

.mdi-file-download::before {
  content: "\\f0965";
}

.mdi-file-download-outline::before {
  content: "\\f0966";
}

.mdi-file-edit::before {
  content: "\\f11e7";
}

.mdi-file-edit-outline::before {
  content: "\\f11e8";
}

.mdi-file-excel::before {
  content: "\\f021b";
}

.mdi-file-excel-box::before {
  content: "\\f021c";
}

.mdi-file-excel-box-outline::before {
  content: "\\f102c";
}

.mdi-file-excel-outline::before {
  content: "\\f102d";
}

.mdi-file-export::before {
  content: "\\f021d";
}

.mdi-file-export-outline::before {
  content: "\\f102e";
}

.mdi-file-eye::before {
  content: "\\f0dca";
}

.mdi-file-eye-outline::before {
  content: "\\f0dcb";
}

.mdi-file-find::before {
  content: "\\f021e";
}

.mdi-file-find-outline::before {
  content: "\\f0b97";
}

.mdi-file-gif-box::before {
  content: "\\f0d78";
}

.mdi-file-hidden::before {
  content: "\\f0613";
}

.mdi-file-image::before {
  content: "\\f021f";
}

.mdi-file-image-marker::before {
  content: "\\f1772";
}

.mdi-file-image-marker-outline::before {
  content: "\\f1773";
}

.mdi-file-image-minus::before {
  content: "\\f193b";
}

.mdi-file-image-minus-outline::before {
  content: "\\f193c";
}

.mdi-file-image-outline::before {
  content: "\\f0eb0";
}

.mdi-file-image-plus::before {
  content: "\\f193d";
}

.mdi-file-image-plus-outline::before {
  content: "\\f193e";
}

.mdi-file-image-remove::before {
  content: "\\f193f";
}

.mdi-file-image-remove-outline::before {
  content: "\\f1940";
}

.mdi-file-import::before {
  content: "\\f0220";
}

.mdi-file-import-outline::before {
  content: "\\f102f";
}

.mdi-file-jpg-box::before {
  content: "\\f0225";
}

.mdi-file-key::before {
  content: "\\f1184";
}

.mdi-file-key-outline::before {
  content: "\\f1185";
}

.mdi-file-link::before {
  content: "\\f1177";
}

.mdi-file-link-outline::before {
  content: "\\f1178";
}

.mdi-file-lock::before {
  content: "\\f0221";
}

.mdi-file-lock-outline::before {
  content: "\\f1030";
}

.mdi-file-marker::before {
  content: "\\f1774";
}

.mdi-file-marker-outline::before {
  content: "\\f1775";
}

.mdi-file-move::before {
  content: "\\f0ab9";
}

.mdi-file-move-outline::before {
  content: "\\f1031";
}

.mdi-file-multiple::before {
  content: "\\f0222";
}

.mdi-file-multiple-outline::before {
  content: "\\f1032";
}

.mdi-file-music::before {
  content: "\\f0223";
}

.mdi-file-music-outline::before {
  content: "\\f0e2a";
}

.mdi-file-outline::before {
  content: "\\f0224";
}

.mdi-file-pdf-box::before {
  content: "\\f0226";
}

.mdi-file-percent::before {
  content: "\\f081e";
}

.mdi-file-percent-outline::before {
  content: "\\f1033";
}

.mdi-file-phone::before {
  content: "\\f1179";
}

.mdi-file-phone-outline::before {
  content: "\\f117a";
}

.mdi-file-plus::before {
  content: "\\f0752";
}

.mdi-file-plus-outline::before {
  content: "\\f0eed";
}

.mdi-file-png-box::before {
  content: "\\f0e2d";
}

.mdi-file-powerpoint::before {
  content: "\\f0227";
}

.mdi-file-powerpoint-box::before {
  content: "\\f0228";
}

.mdi-file-powerpoint-box-outline::before {
  content: "\\f1034";
}

.mdi-file-powerpoint-outline::before {
  content: "\\f1035";
}

.mdi-file-presentation-box::before {
  content: "\\f0229";
}

.mdi-file-question::before {
  content: "\\f086f";
}

.mdi-file-question-outline::before {
  content: "\\f1036";
}

.mdi-file-refresh::before {
  content: "\\f0918";
}

.mdi-file-refresh-outline::before {
  content: "\\f0541";
}

.mdi-file-remove::before {
  content: "\\f0b98";
}

.mdi-file-remove-outline::before {
  content: "\\f1037";
}

.mdi-file-replace::before {
  content: "\\f0b32";
}

.mdi-file-replace-outline::before {
  content: "\\f0b33";
}

.mdi-file-restore::before {
  content: "\\f0670";
}

.mdi-file-restore-outline::before {
  content: "\\f1038";
}

.mdi-file-search::before {
  content: "\\f0c7c";
}

.mdi-file-search-outline::before {
  content: "\\f0c7d";
}

.mdi-file-send::before {
  content: "\\f022a";
}

.mdi-file-send-outline::before {
  content: "\\f1039";
}

.mdi-file-settings::before {
  content: "\\f1079";
}

.mdi-file-settings-outline::before {
  content: "\\f107a";
}

.mdi-file-sign::before {
  content: "\\f19c3";
}

.mdi-file-star::before {
  content: "\\f103a";
}

.mdi-file-star-outline::before {
  content: "\\f103b";
}

.mdi-file-swap::before {
  content: "\\f0fb4";
}

.mdi-file-swap-outline::before {
  content: "\\f0fb5";
}

.mdi-file-sync::before {
  content: "\\f1216";
}

.mdi-file-sync-outline::before {
  content: "\\f1217";
}

.mdi-file-table::before {
  content: "\\f0c7e";
}

.mdi-file-table-box::before {
  content: "\\f10e1";
}

.mdi-file-table-box-multiple::before {
  content: "\\f10e2";
}

.mdi-file-table-box-multiple-outline::before {
  content: "\\f10e3";
}

.mdi-file-table-box-outline::before {
  content: "\\f10e4";
}

.mdi-file-table-outline::before {
  content: "\\f0c7f";
}

.mdi-file-tree::before {
  content: "\\f0645";
}

.mdi-file-tree-outline::before {
  content: "\\f13d2";
}

.mdi-file-undo::before {
  content: "\\f08dc";
}

.mdi-file-undo-outline::before {
  content: "\\f103c";
}

.mdi-file-upload::before {
  content: "\\f0a4d";
}

.mdi-file-upload-outline::before {
  content: "\\f0a4e";
}

.mdi-file-video::before {
  content: "\\f022b";
}

.mdi-file-video-outline::before {
  content: "\\f0e2c";
}

.mdi-file-word::before {
  content: "\\f022c";
}

.mdi-file-word-box::before {
  content: "\\f022d";
}

.mdi-file-word-box-outline::before {
  content: "\\f103d";
}

.mdi-file-word-outline::before {
  content: "\\f103e";
}

.mdi-film::before {
  content: "\\f022f";
}

.mdi-filmstrip::before {
  content: "\\f0230";
}

.mdi-filmstrip-box::before {
  content: "\\f0332";
}

.mdi-filmstrip-box-multiple::before {
  content: "\\f0d18";
}

.mdi-filmstrip-off::before {
  content: "\\f0231";
}

.mdi-filter::before {
  content: "\\f0232";
}

.mdi-filter-check::before {
  content: "\\f18ec";
}

.mdi-filter-check-outline::before {
  content: "\\f18ed";
}

.mdi-filter-menu::before {
  content: "\\f10e5";
}

.mdi-filter-menu-outline::before {
  content: "\\f10e6";
}

.mdi-filter-minus::before {
  content: "\\f0eee";
}

.mdi-filter-minus-outline::before {
  content: "\\f0eef";
}

.mdi-filter-off::before {
  content: "\\f14ef";
}

.mdi-filter-off-outline::before {
  content: "\\f14f0";
}

.mdi-filter-outline::before {
  content: "\\f0233";
}

.mdi-filter-plus::before {
  content: "\\f0ef0";
}

.mdi-filter-plus-outline::before {
  content: "\\f0ef1";
}

.mdi-filter-remove::before {
  content: "\\f0234";
}

.mdi-filter-remove-outline::before {
  content: "\\f0235";
}

.mdi-filter-variant::before {
  content: "\\f0236";
}

.mdi-filter-variant-minus::before {
  content: "\\f1112";
}

.mdi-filter-variant-plus::before {
  content: "\\f1113";
}

.mdi-filter-variant-remove::before {
  content: "\\f103f";
}

.mdi-finance::before {
  content: "\\f081f";
}

.mdi-find-replace::before {
  content: "\\f06d4";
}

.mdi-fingerprint::before {
  content: "\\f0237";
}

.mdi-fingerprint-off::before {
  content: "\\f0eb1";
}

.mdi-fire::before {
  content: "\\f0238";
}

.mdi-fire-alert::before {
  content: "\\f15d7";
}

.mdi-fire-circle::before {
  content: "\\f1807";
}

.mdi-fire-extinguisher::before {
  content: "\\f0ef2";
}

.mdi-fire-hydrant::before {
  content: "\\f1137";
}

.mdi-fire-hydrant-alert::before {
  content: "\\f1138";
}

.mdi-fire-hydrant-off::before {
  content: "\\f1139";
}

.mdi-fire-off::before {
  content: "\\f1722";
}

.mdi-fire-truck::before {
  content: "\\f08ab";
}

.mdi-firebase::before {
  content: "\\f0967";
}

.mdi-firefox::before {
  content: "\\f0239";
}

.mdi-fireplace::before {
  content: "\\f0e2e";
}

.mdi-fireplace-off::before {
  content: "\\f0e2f";
}

.mdi-firewire::before {
  content: "\\f05be";
}

.mdi-firework::before {
  content: "\\f0e30";
}

.mdi-firework-off::before {
  content: "\\f1723";
}

.mdi-fish::before {
  content: "\\f023a";
}

.mdi-fish-off::before {
  content: "\\f13f3";
}

.mdi-fishbowl::before {
  content: "\\f0ef3";
}

.mdi-fishbowl-outline::before {
  content: "\\f0ef4";
}

.mdi-fit-to-page::before {
  content: "\\f0ef5";
}

.mdi-fit-to-page-outline::before {
  content: "\\f0ef6";
}

.mdi-fit-to-screen::before {
  content: "\\f18f4";
}

.mdi-fit-to-screen-outline::before {
  content: "\\f18f5";
}

.mdi-flag::before {
  content: "\\f023b";
}

.mdi-flag-checkered::before {
  content: "\\f023c";
}

.mdi-flag-minus::before {
  content: "\\f0b99";
}

.mdi-flag-minus-outline::before {
  content: "\\f10b2";
}

.mdi-flag-off::before {
  content: "\\f18ee";
}

.mdi-flag-off-outline::before {
  content: "\\f18ef";
}

.mdi-flag-outline::before {
  content: "\\f023d";
}

.mdi-flag-plus::before {
  content: "\\f0b9a";
}

.mdi-flag-plus-outline::before {
  content: "\\f10b3";
}

.mdi-flag-remove::before {
  content: "\\f0b9b";
}

.mdi-flag-remove-outline::before {
  content: "\\f10b4";
}

.mdi-flag-triangle::before {
  content: "\\f023f";
}

.mdi-flag-variant::before {
  content: "\\f0240";
}

.mdi-flag-variant-outline::before {
  content: "\\f023e";
}

.mdi-flare::before {
  content: "\\f0d72";
}

.mdi-flash::before {
  content: "\\f0241";
}

.mdi-flash-alert::before {
  content: "\\f0ef7";
}

.mdi-flash-alert-outline::before {
  content: "\\f0ef8";
}

.mdi-flash-auto::before {
  content: "\\f0242";
}

.mdi-flash-off::before {
  content: "\\f0243";
}

.mdi-flash-outline::before {
  content: "\\f06d5";
}

.mdi-flash-red-eye::before {
  content: "\\f067b";
}

.mdi-flashlight::before {
  content: "\\f0244";
}

.mdi-flashlight-off::before {
  content: "\\f0245";
}

.mdi-flask::before {
  content: "\\f0093";
}

.mdi-flask-empty::before {
  content: "\\f0094";
}

.mdi-flask-empty-minus::before {
  content: "\\f123a";
}

.mdi-flask-empty-minus-outline::before {
  content: "\\f123b";
}

.mdi-flask-empty-off::before {
  content: "\\f13f4";
}

.mdi-flask-empty-off-outline::before {
  content: "\\f13f5";
}

.mdi-flask-empty-outline::before {
  content: "\\f0095";
}

.mdi-flask-empty-plus::before {
  content: "\\f123c";
}

.mdi-flask-empty-plus-outline::before {
  content: "\\f123d";
}

.mdi-flask-empty-remove::before {
  content: "\\f123e";
}

.mdi-flask-empty-remove-outline::before {
  content: "\\f123f";
}

.mdi-flask-minus::before {
  content: "\\f1240";
}

.mdi-flask-minus-outline::before {
  content: "\\f1241";
}

.mdi-flask-off::before {
  content: "\\f13f6";
}

.mdi-flask-off-outline::before {
  content: "\\f13f7";
}

.mdi-flask-outline::before {
  content: "\\f0096";
}

.mdi-flask-plus::before {
  content: "\\f1242";
}

.mdi-flask-plus-outline::before {
  content: "\\f1243";
}

.mdi-flask-remove::before {
  content: "\\f1244";
}

.mdi-flask-remove-outline::before {
  content: "\\f1245";
}

.mdi-flask-round-bottom::before {
  content: "\\f124b";
}

.mdi-flask-round-bottom-empty::before {
  content: "\\f124c";
}

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\f124d";
}

.mdi-flask-round-bottom-outline::before {
  content: "\\f124e";
}

.mdi-fleur-de-lis::before {
  content: "\\f1303";
}

.mdi-flip-horizontal::before {
  content: "\\f10e7";
}

.mdi-flip-to-back::before {
  content: "\\f0247";
}

.mdi-flip-to-front::before {
  content: "\\f0248";
}

.mdi-flip-vertical::before {
  content: "\\f10e8";
}

.mdi-floor-lamp::before {
  content: "\\f08dd";
}

.mdi-floor-lamp-dual::before {
  content: "\\f1040";
}

.mdi-floor-lamp-dual-outline::before {
  content: "\\f17ce";
}

.mdi-floor-lamp-outline::before {
  content: "\\f17c8";
}

.mdi-floor-lamp-torchiere::before {
  content: "\\f1747";
}

.mdi-floor-lamp-torchiere-outline::before {
  content: "\\f17d6";
}

.mdi-floor-lamp-torchiere-variant::before {
  content: "\\f1041";
}

.mdi-floor-lamp-torchiere-variant-outline::before {
  content: "\\f17cf";
}

.mdi-floor-plan::before {
  content: "\\f0821";
}

.mdi-floppy::before {
  content: "\\f0249";
}

.mdi-floppy-variant::before {
  content: "\\f09ef";
}

.mdi-flower::before {
  content: "\\f024a";
}

.mdi-flower-outline::before {
  content: "\\f09f0";
}

.mdi-flower-pollen::before {
  content: "\\f1885";
}

.mdi-flower-pollen-outline::before {
  content: "\\f1886";
}

.mdi-flower-poppy::before {
  content: "\\f0d08";
}

.mdi-flower-tulip::before {
  content: "\\f09f1";
}

.mdi-flower-tulip-outline::before {
  content: "\\f09f2";
}

.mdi-focus-auto::before {
  content: "\\f0f4e";
}

.mdi-focus-field::before {
  content: "\\f0f4f";
}

.mdi-focus-field-horizontal::before {
  content: "\\f0f50";
}

.mdi-focus-field-vertical::before {
  content: "\\f0f51";
}

.mdi-folder::before {
  content: "\\f024b";
}

.mdi-folder-account::before {
  content: "\\f024c";
}

.mdi-folder-account-outline::before {
  content: "\\f0b9c";
}

.mdi-folder-alert::before {
  content: "\\f0dcc";
}

.mdi-folder-alert-outline::before {
  content: "\\f0dcd";
}

.mdi-folder-check::before {
  content: "\\f197e";
}

.mdi-folder-check-outline::before {
  content: "\\f197f";
}

.mdi-folder-clock::before {
  content: "\\f0aba";
}

.mdi-folder-clock-outline::before {
  content: "\\f0abb";
}

.mdi-folder-cog::before {
  content: "\\f107f";
}

.mdi-folder-cog-outline::before {
  content: "\\f1080";
}

.mdi-folder-download::before {
  content: "\\f024d";
}

.mdi-folder-download-outline::before {
  content: "\\f10e9";
}

.mdi-folder-edit::before {
  content: "\\f08de";
}

.mdi-folder-edit-outline::before {
  content: "\\f0dce";
}

.mdi-folder-eye::before {
  content: "\\f178a";
}

.mdi-folder-eye-outline::before {
  content: "\\f178b";
}

.mdi-folder-google-drive::before {
  content: "\\f024e";
}

.mdi-folder-heart::before {
  content: "\\f10ea";
}

.mdi-folder-heart-outline::before {
  content: "\\f10eb";
}

.mdi-folder-hidden::before {
  content: "\\f179e";
}

.mdi-folder-home::before {
  content: "\\f10b5";
}

.mdi-folder-home-outline::before {
  content: "\\f10b6";
}

.mdi-folder-image::before {
  content: "\\f024f";
}

.mdi-folder-information::before {
  content: "\\f10b7";
}

.mdi-folder-information-outline::before {
  content: "\\f10b8";
}

.mdi-folder-key::before {
  content: "\\f08ac";
}

.mdi-folder-key-network::before {
  content: "\\f08ad";
}

.mdi-folder-key-network-outline::before {
  content: "\\f0c80";
}

.mdi-folder-key-outline::before {
  content: "\\f10ec";
}

.mdi-folder-lock::before {
  content: "\\f0250";
}

.mdi-folder-lock-open::before {
  content: "\\f0251";
}

.mdi-folder-marker::before {
  content: "\\f126d";
}

.mdi-folder-marker-outline::before {
  content: "\\f126e";
}

.mdi-folder-move::before {
  content: "\\f0252";
}

.mdi-folder-move-outline::before {
  content: "\\f1246";
}

.mdi-folder-multiple::before {
  content: "\\f0253";
}

.mdi-folder-multiple-image::before {
  content: "\\f0254";
}

.mdi-folder-multiple-outline::before {
  content: "\\f0255";
}

.mdi-folder-multiple-plus::before {
  content: "\\f147e";
}

.mdi-folder-multiple-plus-outline::before {
  content: "\\f147f";
}

.mdi-folder-music::before {
  content: "\\f1359";
}

.mdi-folder-music-outline::before {
  content: "\\f135a";
}

.mdi-folder-network::before {
  content: "\\f0870";
}

.mdi-folder-network-outline::before {
  content: "\\f0c81";
}

.mdi-folder-open::before {
  content: "\\f0770";
}

.mdi-folder-open-outline::before {
  content: "\\f0dcf";
}

.mdi-folder-outline::before {
  content: "\\f0256";
}

.mdi-folder-plus::before {
  content: "\\f0257";
}

.mdi-folder-plus-outline::before {
  content: "\\f0b9d";
}

.mdi-folder-pound::before {
  content: "\\f0d09";
}

.mdi-folder-pound-outline::before {
  content: "\\f0d0a";
}

.mdi-folder-refresh::before {
  content: "\\f0749";
}

.mdi-folder-refresh-outline::before {
  content: "\\f0542";
}

.mdi-folder-remove::before {
  content: "\\f0258";
}

.mdi-folder-remove-outline::before {
  content: "\\f0b9e";
}

.mdi-folder-search::before {
  content: "\\f0968";
}

.mdi-folder-search-outline::before {
  content: "\\f0969";
}

.mdi-folder-settings::before {
  content: "\\f107d";
}

.mdi-folder-settings-outline::before {
  content: "\\f107e";
}

.mdi-folder-star::before {
  content: "\\f069d";
}

.mdi-folder-star-multiple::before {
  content: "\\f13d3";
}

.mdi-folder-star-multiple-outline::before {
  content: "\\f13d4";
}

.mdi-folder-star-outline::before {
  content: "\\f0b9f";
}

.mdi-folder-swap::before {
  content: "\\f0fb6";
}

.mdi-folder-swap-outline::before {
  content: "\\f0fb7";
}

.mdi-folder-sync::before {
  content: "\\f0d0b";
}

.mdi-folder-sync-outline::before {
  content: "\\f0d0c";
}

.mdi-folder-table::before {
  content: "\\f12e3";
}

.mdi-folder-table-outline::before {
  content: "\\f12e4";
}

.mdi-folder-text::before {
  content: "\\f0c82";
}

.mdi-folder-text-outline::before {
  content: "\\f0c83";
}

.mdi-folder-upload::before {
  content: "\\f0259";
}

.mdi-folder-upload-outline::before {
  content: "\\f10ed";
}

.mdi-folder-zip::before {
  content: "\\f06eb";
}

.mdi-folder-zip-outline::before {
  content: "\\f07b9";
}

.mdi-font-awesome::before {
  content: "\\f003a";
}

.mdi-food::before {
  content: "\\f025a";
}

.mdi-food-apple::before {
  content: "\\f025b";
}

.mdi-food-apple-outline::before {
  content: "\\f0c84";
}

.mdi-food-croissant::before {
  content: "\\f07c8";
}

.mdi-food-drumstick::before {
  content: "\\f141f";
}

.mdi-food-drumstick-off::before {
  content: "\\f1468";
}

.mdi-food-drumstick-off-outline::before {
  content: "\\f1469";
}

.mdi-food-drumstick-outline::before {
  content: "\\f1420";
}

.mdi-food-fork-drink::before {
  content: "\\f05f2";
}

.mdi-food-halal::before {
  content: "\\f1572";
}

.mdi-food-hot-dog::before {
  content: "\\f184b";
}

.mdi-food-kosher::before {
  content: "\\f1573";
}

.mdi-food-off::before {
  content: "\\f05f3";
}

.mdi-food-off-outline::before {
  content: "\\f1915";
}

.mdi-food-outline::before {
  content: "\\f1916";
}

.mdi-food-steak::before {
  content: "\\f146a";
}

.mdi-food-steak-off::before {
  content: "\\f146b";
}

.mdi-food-takeout-box::before {
  content: "\\f1836";
}

.mdi-food-takeout-box-outline::before {
  content: "\\f1837";
}

.mdi-food-turkey::before {
  content: "\\f171c";
}

.mdi-food-variant::before {
  content: "\\f025c";
}

.mdi-food-variant-off::before {
  content: "\\f13e5";
}

.mdi-foot-print::before {
  content: "\\f0f52";
}

.mdi-football::before {
  content: "\\f025d";
}

.mdi-football-australian::before {
  content: "\\f025e";
}

.mdi-football-helmet::before {
  content: "\\f025f";
}

.mdi-forest::before {
  content: "\\f1897";
}

.mdi-forklift::before {
  content: "\\f07c9";
}

.mdi-form-dropdown::before {
  content: "\\f1400";
}

.mdi-form-select::before {
  content: "\\f1401";
}

.mdi-form-textarea::before {
  content: "\\f1095";
}

.mdi-form-textbox::before {
  content: "\\f060e";
}

.mdi-form-textbox-lock::before {
  content: "\\f135d";
}

.mdi-form-textbox-password::before {
  content: "\\f07f5";
}

.mdi-format-align-bottom::before {
  content: "\\f0753";
}

.mdi-format-align-center::before {
  content: "\\f0260";
}

.mdi-format-align-justify::before {
  content: "\\f0261";
}

.mdi-format-align-left::before {
  content: "\\f0262";
}

.mdi-format-align-middle::before {
  content: "\\f0754";
}

.mdi-format-align-right::before {
  content: "\\f0263";
}

.mdi-format-align-top::before {
  content: "\\f0755";
}

.mdi-format-annotation-minus::before {
  content: "\\f0abc";
}

.mdi-format-annotation-plus::before {
  content: "\\f0646";
}

.mdi-format-bold::before {
  content: "\\f0264";
}

.mdi-format-clear::before {
  content: "\\f0265";
}

.mdi-format-color-fill::before {
  content: "\\f0266";
}

.mdi-format-color-highlight::before {
  content: "\\f0e31";
}

.mdi-format-color-marker-cancel::before {
  content: "\\f1313";
}

.mdi-format-color-text::before {
  content: "\\f069e";
}

.mdi-format-columns::before {
  content: "\\f08df";
}

.mdi-format-float-center::before {
  content: "\\f0267";
}

.mdi-format-float-left::before {
  content: "\\f0268";
}

.mdi-format-float-none::before {
  content: "\\f0269";
}

.mdi-format-float-right::before {
  content: "\\f026a";
}

.mdi-format-font::before {
  content: "\\f06d6";
}

.mdi-format-font-size-decrease::before {
  content: "\\f09f3";
}

.mdi-format-font-size-increase::before {
  content: "\\f09f4";
}

.mdi-format-header-1::before {
  content: "\\f026b";
}

.mdi-format-header-2::before {
  content: "\\f026c";
}

.mdi-format-header-3::before {
  content: "\\f026d";
}

.mdi-format-header-4::before {
  content: "\\f026e";
}

.mdi-format-header-5::before {
  content: "\\f026f";
}

.mdi-format-header-6::before {
  content: "\\f0270";
}

.mdi-format-header-decrease::before {
  content: "\\f0271";
}

.mdi-format-header-equal::before {
  content: "\\f0272";
}

.mdi-format-header-increase::before {
  content: "\\f0273";
}

.mdi-format-header-pound::before {
  content: "\\f0274";
}

.mdi-format-horizontal-align-center::before {
  content: "\\f061e";
}

.mdi-format-horizontal-align-left::before {
  content: "\\f061f";
}

.mdi-format-horizontal-align-right::before {
  content: "\\f0620";
}

.mdi-format-indent-decrease::before {
  content: "\\f0275";
}

.mdi-format-indent-increase::before {
  content: "\\f0276";
}

.mdi-format-italic::before {
  content: "\\f0277";
}

.mdi-format-letter-case::before {
  content: "\\f0b34";
}

.mdi-format-letter-case-lower::before {
  content: "\\f0b35";
}

.mdi-format-letter-case-upper::before {
  content: "\\f0b36";
}

.mdi-format-letter-ends-with::before {
  content: "\\f0fb8";
}

.mdi-format-letter-matches::before {
  content: "\\f0fb9";
}

.mdi-format-letter-spacing::before {
  content: "\\f1956";
}

.mdi-format-letter-starts-with::before {
  content: "\\f0fba";
}

.mdi-format-line-spacing::before {
  content: "\\f0278";
}

.mdi-format-line-style::before {
  content: "\\f05c8";
}

.mdi-format-line-weight::before {
  content: "\\f05c9";
}

.mdi-format-list-bulleted::before {
  content: "\\f0279";
}

.mdi-format-list-bulleted-square::before {
  content: "\\f0dd0";
}

.mdi-format-list-bulleted-triangle::before {
  content: "\\f0eb2";
}

.mdi-format-list-bulleted-type::before {
  content: "\\f027a";
}

.mdi-format-list-checkbox::before {
  content: "\\f096a";
}

.mdi-format-list-checks::before {
  content: "\\f0756";
}

.mdi-format-list-group::before {
  content: "\\f1860";
}

.mdi-format-list-numbered::before {
  content: "\\f027b";
}

.mdi-format-list-numbered-rtl::before {
  content: "\\f0d0d";
}

.mdi-format-list-text::before {
  content: "\\f126f";
}

.mdi-format-overline::before {
  content: "\\f0eb3";
}

.mdi-format-page-break::before {
  content: "\\f06d7";
}

.mdi-format-page-split::before {
  content: "\\f1917";
}

.mdi-format-paint::before {
  content: "\\f027c";
}

.mdi-format-paragraph::before {
  content: "\\f027d";
}

.mdi-format-pilcrow::before {
  content: "\\f06d8";
}

.mdi-format-quote-close::before {
  content: "\\f027e";
}

.mdi-format-quote-close-outline::before {
  content: "\\f11a8";
}

.mdi-format-quote-open::before {
  content: "\\f0757";
}

.mdi-format-quote-open-outline::before {
  content: "\\f11a7";
}

.mdi-format-rotate-90::before {
  content: "\\f06aa";
}

.mdi-format-section::before {
  content: "\\f069f";
}

.mdi-format-size::before {
  content: "\\f027f";
}

.mdi-format-strikethrough::before {
  content: "\\f0280";
}

.mdi-format-strikethrough-variant::before {
  content: "\\f0281";
}

.mdi-format-subscript::before {
  content: "\\f0282";
}

.mdi-format-superscript::before {
  content: "\\f0283";
}

.mdi-format-text::before {
  content: "\\f0284";
}

.mdi-format-text-rotation-angle-down::before {
  content: "\\f0fbb";
}

.mdi-format-text-rotation-angle-up::before {
  content: "\\f0fbc";
}

.mdi-format-text-rotation-down::before {
  content: "\\f0d73";
}

.mdi-format-text-rotation-down-vertical::before {
  content: "\\f0fbd";
}

.mdi-format-text-rotation-none::before {
  content: "\\f0d74";
}

.mdi-format-text-rotation-up::before {
  content: "\\f0fbe";
}

.mdi-format-text-rotation-vertical::before {
  content: "\\f0fbf";
}

.mdi-format-text-variant::before {
  content: "\\f0e32";
}

.mdi-format-text-variant-outline::before {
  content: "\\f150f";
}

.mdi-format-text-wrapping-clip::before {
  content: "\\f0d0e";
}

.mdi-format-text-wrapping-overflow::before {
  content: "\\f0d0f";
}

.mdi-format-text-wrapping-wrap::before {
  content: "\\f0d10";
}

.mdi-format-textbox::before {
  content: "\\f0d11";
}

.mdi-format-textdirection-l-to-r::before {
  content: "\\f0285";
}

.mdi-format-textdirection-r-to-l::before {
  content: "\\f0286";
}

.mdi-format-title::before {
  content: "\\f05f4";
}

.mdi-format-underline::before {
  content: "\\f0287";
}

.mdi-format-underline-wavy::before {
  content: "\\f18e9";
}

.mdi-format-vertical-align-bottom::before {
  content: "\\f0621";
}

.mdi-format-vertical-align-center::before {
  content: "\\f0622";
}

.mdi-format-vertical-align-top::before {
  content: "\\f0623";
}

.mdi-format-wrap-inline::before {
  content: "\\f0288";
}

.mdi-format-wrap-square::before {
  content: "\\f0289";
}

.mdi-format-wrap-tight::before {
  content: "\\f028a";
}

.mdi-format-wrap-top-bottom::before {
  content: "\\f028b";
}

.mdi-forum::before {
  content: "\\f028c";
}

.mdi-forum-outline::before {
  content: "\\f0822";
}

.mdi-forward::before {
  content: "\\f028d";
}

.mdi-forwardburger::before {
  content: "\\f0d75";
}

.mdi-fountain::before {
  content: "\\f096b";
}

.mdi-fountain-pen::before {
  content: "\\f0d12";
}

.mdi-fountain-pen-tip::before {
  content: "\\f0d13";
}

.mdi-fraction-one-half::before {
  content: "\\f1992";
}

.mdi-freebsd::before {
  content: "\\f08e0";
}

.mdi-french-fries::before {
  content: "\\f1957";
}

.mdi-frequently-asked-questions::before {
  content: "\\f0eb4";
}

.mdi-fridge::before {
  content: "\\f0290";
}

.mdi-fridge-alert::before {
  content: "\\f11b1";
}

.mdi-fridge-alert-outline::before {
  content: "\\f11b2";
}

.mdi-fridge-bottom::before {
  content: "\\f0292";
}

.mdi-fridge-industrial::before {
  content: "\\f15ee";
}

.mdi-fridge-industrial-alert::before {
  content: "\\f15ef";
}

.mdi-fridge-industrial-alert-outline::before {
  content: "\\f15f0";
}

.mdi-fridge-industrial-off::before {
  content: "\\f15f1";
}

.mdi-fridge-industrial-off-outline::before {
  content: "\\f15f2";
}

.mdi-fridge-industrial-outline::before {
  content: "\\f15f3";
}

.mdi-fridge-off::before {
  content: "\\f11af";
}

.mdi-fridge-off-outline::before {
  content: "\\f11b0";
}

.mdi-fridge-outline::before {
  content: "\\f028f";
}

.mdi-fridge-top::before {
  content: "\\f0291";
}

.mdi-fridge-variant::before {
  content: "\\f15f4";
}

.mdi-fridge-variant-alert::before {
  content: "\\f15f5";
}

.mdi-fridge-variant-alert-outline::before {
  content: "\\f15f6";
}

.mdi-fridge-variant-off::before {
  content: "\\f15f7";
}

.mdi-fridge-variant-off-outline::before {
  content: "\\f15f8";
}

.mdi-fridge-variant-outline::before {
  content: "\\f15f9";
}

.mdi-fruit-cherries::before {
  content: "\\f1042";
}

.mdi-fruit-cherries-off::before {
  content: "\\f13f8";
}

.mdi-fruit-citrus::before {
  content: "\\f1043";
}

.mdi-fruit-citrus-off::before {
  content: "\\f13f9";
}

.mdi-fruit-grapes::before {
  content: "\\f1044";
}

.mdi-fruit-grapes-outline::before {
  content: "\\f1045";
}

.mdi-fruit-pineapple::before {
  content: "\\f1046";
}

.mdi-fruit-watermelon::before {
  content: "\\f1047";
}

.mdi-fuel::before {
  content: "\\f07ca";
}

.mdi-fuel-cell::before {
  content: "\\f18b5";
}

.mdi-fullscreen::before {
  content: "\\f0293";
}

.mdi-fullscreen-exit::before {
  content: "\\f0294";
}

.mdi-function::before {
  content: "\\f0295";
}

.mdi-function-variant::before {
  content: "\\f0871";
}

.mdi-furigana-horizontal::before {
  content: "\\f1081";
}

.mdi-furigana-vertical::before {
  content: "\\f1082";
}

.mdi-fuse::before {
  content: "\\f0c85";
}

.mdi-fuse-alert::before {
  content: "\\f142d";
}

.mdi-fuse-blade::before {
  content: "\\f0c86";
}

.mdi-fuse-off::before {
  content: "\\f142c";
}

.mdi-gamepad::before {
  content: "\\f0296";
}

.mdi-gamepad-circle::before {
  content: "\\f0e33";
}

.mdi-gamepad-circle-down::before {
  content: "\\f0e34";
}

.mdi-gamepad-circle-left::before {
  content: "\\f0e35";
}

.mdi-gamepad-circle-outline::before {
  content: "\\f0e36";
}

.mdi-gamepad-circle-right::before {
  content: "\\f0e37";
}

.mdi-gamepad-circle-up::before {
  content: "\\f0e38";
}

.mdi-gamepad-down::before {
  content: "\\f0e39";
}

.mdi-gamepad-left::before {
  content: "\\f0e3a";
}

.mdi-gamepad-outline::before {
  content: "\\f1919";
}

.mdi-gamepad-right::before {
  content: "\\f0e3b";
}

.mdi-gamepad-round::before {
  content: "\\f0e3c";
}

.mdi-gamepad-round-down::before {
  content: "\\f0e3d";
}

.mdi-gamepad-round-left::before {
  content: "\\f0e3e";
}

.mdi-gamepad-round-outline::before {
  content: "\\f0e3f";
}

.mdi-gamepad-round-right::before {
  content: "\\f0e40";
}

.mdi-gamepad-round-up::before {
  content: "\\f0e41";
}

.mdi-gamepad-square::before {
  content: "\\f0eb5";
}

.mdi-gamepad-square-outline::before {
  content: "\\f0eb6";
}

.mdi-gamepad-up::before {
  content: "\\f0e42";
}

.mdi-gamepad-variant::before {
  content: "\\f0297";
}

.mdi-gamepad-variant-outline::before {
  content: "\\f0eb7";
}

.mdi-gamma::before {
  content: "\\f10ee";
}

.mdi-gantry-crane::before {
  content: "\\f0dd1";
}

.mdi-garage::before {
  content: "\\f06d9";
}

.mdi-garage-alert::before {
  content: "\\f0872";
}

.mdi-garage-alert-variant::before {
  content: "\\f12d5";
}

.mdi-garage-lock::before {
  content: "\\f17fb";
}

.mdi-garage-open::before {
  content: "\\f06da";
}

.mdi-garage-open-variant::before {
  content: "\\f12d4";
}

.mdi-garage-variant::before {
  content: "\\f12d3";
}

.mdi-garage-variant-lock::before {
  content: "\\f17fc";
}

.mdi-gas-cylinder::before {
  content: "\\f0647";
}

.mdi-gas-station::before {
  content: "\\f0298";
}

.mdi-gas-station-off::before {
  content: "\\f1409";
}

.mdi-gas-station-off-outline::before {
  content: "\\f140a";
}

.mdi-gas-station-outline::before {
  content: "\\f0eb8";
}

.mdi-gate::before {
  content: "\\f0299";
}

.mdi-gate-alert::before {
  content: "\\f17f8";
}

.mdi-gate-and::before {
  content: "\\f08e1";
}

.mdi-gate-arrow-left::before {
  content: "\\f17f7";
}

.mdi-gate-arrow-right::before {
  content: "\\f1169";
}

.mdi-gate-nand::before {
  content: "\\f08e2";
}

.mdi-gate-nor::before {
  content: "\\f08e3";
}

.mdi-gate-not::before {
  content: "\\f08e4";
}

.mdi-gate-open::before {
  content: "\\f116a";
}

.mdi-gate-or::before {
  content: "\\f08e5";
}

.mdi-gate-xnor::before {
  content: "\\f08e6";
}

.mdi-gate-xor::before {
  content: "\\f08e7";
}

.mdi-gatsby::before {
  content: "\\f0e43";
}

.mdi-gauge::before {
  content: "\\f029a";
}

.mdi-gauge-empty::before {
  content: "\\f0873";
}

.mdi-gauge-full::before {
  content: "\\f0874";
}

.mdi-gauge-low::before {
  content: "\\f0875";
}

.mdi-gavel::before {
  content: "\\f029b";
}

.mdi-gender-female::before {
  content: "\\f029c";
}

.mdi-gender-male::before {
  content: "\\f029d";
}

.mdi-gender-male-female::before {
  content: "\\f029e";
}

.mdi-gender-male-female-variant::before {
  content: "\\f113f";
}

.mdi-gender-non-binary::before {
  content: "\\f1140";
}

.mdi-gender-transgender::before {
  content: "\\f029f";
}

.mdi-gentoo::before {
  content: "\\f08e8";
}

.mdi-gesture::before {
  content: "\\f07cb";
}

.mdi-gesture-double-tap::before {
  content: "\\f073c";
}

.mdi-gesture-pinch::before {
  content: "\\f0abd";
}

.mdi-gesture-spread::before {
  content: "\\f0abe";
}

.mdi-gesture-swipe::before {
  content: "\\f0d76";
}

.mdi-gesture-swipe-down::before {
  content: "\\f073d";
}

.mdi-gesture-swipe-horizontal::before {
  content: "\\f0abf";
}

.mdi-gesture-swipe-left::before {
  content: "\\f073e";
}

.mdi-gesture-swipe-right::before {
  content: "\\f073f";
}

.mdi-gesture-swipe-up::before {
  content: "\\f0740";
}

.mdi-gesture-swipe-vertical::before {
  content: "\\f0ac0";
}

.mdi-gesture-tap::before {
  content: "\\f0741";
}

.mdi-gesture-tap-box::before {
  content: "\\f12a9";
}

.mdi-gesture-tap-button::before {
  content: "\\f12a8";
}

.mdi-gesture-tap-hold::before {
  content: "\\f0d77";
}

.mdi-gesture-two-double-tap::before {
  content: "\\f0742";
}

.mdi-gesture-two-tap::before {
  content: "\\f0743";
}

.mdi-ghost::before {
  content: "\\f02a0";
}

.mdi-ghost-off::before {
  content: "\\f09f5";
}

.mdi-ghost-off-outline::before {
  content: "\\f165c";
}

.mdi-ghost-outline::before {
  content: "\\f165d";
}

.mdi-gift::before {
  content: "\\f0e44";
}

.mdi-gift-off::before {
  content: "\\f16ef";
}

.mdi-gift-off-outline::before {
  content: "\\f16f0";
}

.mdi-gift-open::before {
  content: "\\f16f1";
}

.mdi-gift-open-outline::before {
  content: "\\f16f2";
}

.mdi-gift-outline::before {
  content: "\\f02a1";
}

.mdi-git::before {
  content: "\\f02a2";
}

.mdi-github::before {
  content: "\\f02a4";
}

.mdi-gitlab::before {
  content: "\\f0ba0";
}

.mdi-glass-cocktail::before {
  content: "\\f0356";
}

.mdi-glass-cocktail-off::before {
  content: "\\f15e6";
}

.mdi-glass-flute::before {
  content: "\\f02a5";
}

.mdi-glass-fragile::before {
  content: "\\f1873";
}

.mdi-glass-mug::before {
  content: "\\f02a6";
}

.mdi-glass-mug-off::before {
  content: "\\f15e7";
}

.mdi-glass-mug-variant::before {
  content: "\\f1116";
}

.mdi-glass-mug-variant-off::before {
  content: "\\f15e8";
}

.mdi-glass-pint-outline::before {
  content: "\\f130d";
}

.mdi-glass-stange::before {
  content: "\\f02a7";
}

.mdi-glass-tulip::before {
  content: "\\f02a8";
}

.mdi-glass-wine::before {
  content: "\\f0876";
}

.mdi-glasses::before {
  content: "\\f02aa";
}

.mdi-globe-light::before {
  content: "\\f12d7";
}

.mdi-globe-model::before {
  content: "\\f08e9";
}

.mdi-gmail::before {
  content: "\\f02ab";
}

.mdi-gnome::before {
  content: "\\f02ac";
}

.mdi-go-kart::before {
  content: "\\f0d79";
}

.mdi-go-kart-track::before {
  content: "\\f0d7a";
}

.mdi-gog::before {
  content: "\\f0ba1";
}

.mdi-gold::before {
  content: "\\f124f";
}

.mdi-golf::before {
  content: "\\f0823";
}

.mdi-golf-cart::before {
  content: "\\f11a4";
}

.mdi-golf-tee::before {
  content: "\\f1083";
}

.mdi-gondola::before {
  content: "\\f0686";
}

.mdi-goodreads::before {
  content: "\\f0d7b";
}

.mdi-google::before {
  content: "\\f02ad";
}

.mdi-google-ads::before {
  content: "\\f0c87";
}

.mdi-google-analytics::before {
  content: "\\f07cc";
}

.mdi-google-assistant::before {
  content: "\\f07cd";
}

.mdi-google-cardboard::before {
  content: "\\f02ae";
}

.mdi-google-chrome::before {
  content: "\\f02af";
}

.mdi-google-circles::before {
  content: "\\f02b0";
}

.mdi-google-circles-communities::before {
  content: "\\f02b1";
}

.mdi-google-circles-extended::before {
  content: "\\f02b2";
}

.mdi-google-circles-group::before {
  content: "\\f02b3";
}

.mdi-google-classroom::before {
  content: "\\f02c0";
}

.mdi-google-cloud::before {
  content: "\\f11f6";
}

.mdi-google-controller::before {
  content: "\\f02b4";
}

.mdi-google-controller-off::before {
  content: "\\f02b5";
}

.mdi-google-downasaur::before {
  content: "\\f1362";
}

.mdi-google-drive::before {
  content: "\\f02b6";
}

.mdi-google-earth::before {
  content: "\\f02b7";
}

.mdi-google-fit::before {
  content: "\\f096c";
}

.mdi-google-glass::before {
  content: "\\f02b8";
}

.mdi-google-hangouts::before {
  content: "\\f02c9";
}

.mdi-google-home::before {
  content: "\\f0824";
}

.mdi-google-keep::before {
  content: "\\f06dc";
}

.mdi-google-lens::before {
  content: "\\f09f6";
}

.mdi-google-maps::before {
  content: "\\f05f5";
}

.mdi-google-my-business::before {
  content: "\\f1048";
}

.mdi-google-nearby::before {
  content: "\\f02b9";
}

.mdi-google-play::before {
  content: "\\f02bc";
}

.mdi-google-plus::before {
  content: "\\f02bd";
}

.mdi-google-podcast::before {
  content: "\\f0eb9";
}

.mdi-google-spreadsheet::before {
  content: "\\f09f7";
}

.mdi-google-street-view::before {
  content: "\\f0c88";
}

.mdi-google-translate::before {
  content: "\\f02bf";
}

.mdi-gradient-horizontal::before {
  content: "\\f174a";
}

.mdi-gradient-vertical::before {
  content: "\\f06a0";
}

.mdi-grain::before {
  content: "\\f0d7c";
}

.mdi-graph::before {
  content: "\\f1049";
}

.mdi-graph-outline::before {
  content: "\\f104a";
}

.mdi-graphql::before {
  content: "\\f0877";
}

.mdi-grass::before {
  content: "\\f1510";
}

.mdi-grave-stone::before {
  content: "\\f0ba2";
}

.mdi-grease-pencil::before {
  content: "\\f0648";
}

.mdi-greater-than::before {
  content: "\\f096d";
}

.mdi-greater-than-or-equal::before {
  content: "\\f096e";
}

.mdi-greenhouse::before {
  content: "\\f002d";
}

.mdi-grid::before {
  content: "\\f02c1";
}

.mdi-grid-large::before {
  content: "\\f0758";
}

.mdi-grid-off::before {
  content: "\\f02c2";
}

.mdi-grill::before {
  content: "\\f0e45";
}

.mdi-grill-outline::before {
  content: "\\f118a";
}

.mdi-group::before {
  content: "\\f02c3";
}

.mdi-guitar-acoustic::before {
  content: "\\f0771";
}

.mdi-guitar-electric::before {
  content: "\\f02c4";
}

.mdi-guitar-pick::before {
  content: "\\f02c5";
}

.mdi-guitar-pick-outline::before {
  content: "\\f02c6";
}

.mdi-guy-fawkes-mask::before {
  content: "\\f0825";
}

.mdi-hail::before {
  content: "\\f0ac1";
}

.mdi-hair-dryer::before {
  content: "\\f10ef";
}

.mdi-hair-dryer-outline::before {
  content: "\\f10f0";
}

.mdi-halloween::before {
  content: "\\f0ba3";
}

.mdi-hamburger::before {
  content: "\\f0685";
}

.mdi-hamburger-check::before {
  content: "\\f1776";
}

.mdi-hamburger-minus::before {
  content: "\\f1777";
}

.mdi-hamburger-off::before {
  content: "\\f1778";
}

.mdi-hamburger-plus::before {
  content: "\\f1779";
}

.mdi-hamburger-remove::before {
  content: "\\f177a";
}

.mdi-hammer::before {
  content: "\\f08ea";
}

.mdi-hammer-screwdriver::before {
  content: "\\f1322";
}

.mdi-hammer-sickle::before {
  content: "\\f1887";
}

.mdi-hammer-wrench::before {
  content: "\\f1323";
}

.mdi-hand-back-left::before {
  content: "\\f0e46";
}

.mdi-hand-back-left-off::before {
  content: "\\f1830";
}

.mdi-hand-back-left-off-outline::before {
  content: "\\f1832";
}

.mdi-hand-back-left-outline::before {
  content: "\\f182c";
}

.mdi-hand-back-right::before {
  content: "\\f0e47";
}

.mdi-hand-back-right-off::before {
  content: "\\f1831";
}

.mdi-hand-back-right-off-outline::before {
  content: "\\f1833";
}

.mdi-hand-back-right-outline::before {
  content: "\\f182d";
}

.mdi-hand-clap::before {
  content: "\\f194b";
}

.mdi-hand-coin::before {
  content: "\\f188f";
}

.mdi-hand-coin-outline::before {
  content: "\\f1890";
}

.mdi-hand-extended::before {
  content: "\\f18b6";
}

.mdi-hand-extended-outline::before {
  content: "\\f18b7";
}

.mdi-hand-front-left::before {
  content: "\\f182b";
}

.mdi-hand-front-left-outline::before {
  content: "\\f182e";
}

.mdi-hand-front-right::before {
  content: "\\f0a4f";
}

.mdi-hand-front-right-outline::before {
  content: "\\f182f";
}

.mdi-hand-heart::before {
  content: "\\f10f1";
}

.mdi-hand-heart-outline::before {
  content: "\\f157e";
}

.mdi-hand-okay::before {
  content: "\\f0a50";
}

.mdi-hand-peace::before {
  content: "\\f0a51";
}

.mdi-hand-peace-variant::before {
  content: "\\f0a52";
}

.mdi-hand-pointing-down::before {
  content: "\\f0a53";
}

.mdi-hand-pointing-left::before {
  content: "\\f0a54";
}

.mdi-hand-pointing-right::before {
  content: "\\f02c7";
}

.mdi-hand-pointing-up::before {
  content: "\\f0a55";
}

.mdi-hand-saw::before {
  content: "\\f0e48";
}

.mdi-hand-wash::before {
  content: "\\f157f";
}

.mdi-hand-wash-outline::before {
  content: "\\f1580";
}

.mdi-hand-water::before {
  content: "\\f139f";
}

.mdi-hand-wave::before {
  content: "\\f1821";
}

.mdi-hand-wave-outline::before {
  content: "\\f1822";
}

.mdi-handball::before {
  content: "\\f0f53";
}

.mdi-handcuffs::before {
  content: "\\f113e";
}

.mdi-hands-pray::before {
  content: "\\f0579";
}

.mdi-handshake::before {
  content: "\\f1218";
}

.mdi-handshake-outline::before {
  content: "\\f15a1";
}

.mdi-hanger::before {
  content: "\\f02c8";
}

.mdi-hard-hat::before {
  content: "\\f096f";
}

.mdi-harddisk::before {
  content: "\\f02ca";
}

.mdi-harddisk-plus::before {
  content: "\\f104b";
}

.mdi-harddisk-remove::before {
  content: "\\f104c";
}

.mdi-hat-fedora::before {
  content: "\\f0ba4";
}

.mdi-hazard-lights::before {
  content: "\\f0c89";
}

.mdi-hdr::before {
  content: "\\f0d7d";
}

.mdi-hdr-off::before {
  content: "\\f0d7e";
}

.mdi-head::before {
  content: "\\f135e";
}

.mdi-head-alert::before {
  content: "\\f1338";
}

.mdi-head-alert-outline::before {
  content: "\\f1339";
}

.mdi-head-check::before {
  content: "\\f133a";
}

.mdi-head-check-outline::before {
  content: "\\f133b";
}

.mdi-head-cog::before {
  content: "\\f133c";
}

.mdi-head-cog-outline::before {
  content: "\\f133d";
}

.mdi-head-dots-horizontal::before {
  content: "\\f133e";
}

.mdi-head-dots-horizontal-outline::before {
  content: "\\f133f";
}

.mdi-head-flash::before {
  content: "\\f1340";
}

.mdi-head-flash-outline::before {
  content: "\\f1341";
}

.mdi-head-heart::before {
  content: "\\f1342";
}

.mdi-head-heart-outline::before {
  content: "\\f1343";
}

.mdi-head-lightbulb::before {
  content: "\\f1344";
}

.mdi-head-lightbulb-outline::before {
  content: "\\f1345";
}

.mdi-head-minus::before {
  content: "\\f1346";
}

.mdi-head-minus-outline::before {
  content: "\\f1347";
}

.mdi-head-outline::before {
  content: "\\f135f";
}

.mdi-head-plus::before {
  content: "\\f1348";
}

.mdi-head-plus-outline::before {
  content: "\\f1349";
}

.mdi-head-question::before {
  content: "\\f134a";
}

.mdi-head-question-outline::before {
  content: "\\f134b";
}

.mdi-head-remove::before {
  content: "\\f134c";
}

.mdi-head-remove-outline::before {
  content: "\\f134d";
}

.mdi-head-snowflake::before {
  content: "\\f134e";
}

.mdi-head-snowflake-outline::before {
  content: "\\f134f";
}

.mdi-head-sync::before {
  content: "\\f1350";
}

.mdi-head-sync-outline::before {
  content: "\\f1351";
}

.mdi-headphones::before {
  content: "\\f02cb";
}

.mdi-headphones-bluetooth::before {
  content: "\\f0970";
}

.mdi-headphones-box::before {
  content: "\\f02cc";
}

.mdi-headphones-off::before {
  content: "\\f07ce";
}

.mdi-headphones-settings::before {
  content: "\\f02cd";
}

.mdi-headset::before {
  content: "\\f02ce";
}

.mdi-headset-dock::before {
  content: "\\f02cf";
}

.mdi-headset-off::before {
  content: "\\f02d0";
}

.mdi-heart::before {
  content: "\\f02d1";
}

.mdi-heart-box::before {
  content: "\\f02d2";
}

.mdi-heart-box-outline::before {
  content: "\\f02d3";
}

.mdi-heart-broken::before {
  content: "\\f02d4";
}

.mdi-heart-broken-outline::before {
  content: "\\f0d14";
}

.mdi-heart-circle::before {
  content: "\\f0971";
}

.mdi-heart-circle-outline::before {
  content: "\\f0972";
}

.mdi-heart-cog::before {
  content: "\\f1663";
}

.mdi-heart-cog-outline::before {
  content: "\\f1664";
}

.mdi-heart-flash::before {
  content: "\\f0ef9";
}

.mdi-heart-half::before {
  content: "\\f06df";
}

.mdi-heart-half-full::before {
  content: "\\f06de";
}

.mdi-heart-half-outline::before {
  content: "\\f06e0";
}

.mdi-heart-minus::before {
  content: "\\f142f";
}

.mdi-heart-minus-outline::before {
  content: "\\f1432";
}

.mdi-heart-multiple::before {
  content: "\\f0a56";
}

.mdi-heart-multiple-outline::before {
  content: "\\f0a57";
}

.mdi-heart-off::before {
  content: "\\f0759";
}

.mdi-heart-off-outline::before {
  content: "\\f1434";
}

.mdi-heart-outline::before {
  content: "\\f02d5";
}

.mdi-heart-plus::before {
  content: "\\f142e";
}

.mdi-heart-plus-outline::before {
  content: "\\f1431";
}

.mdi-heart-pulse::before {
  content: "\\f05f6";
}

.mdi-heart-remove::before {
  content: "\\f1430";
}

.mdi-heart-remove-outline::before {
  content: "\\f1433";
}

.mdi-heart-settings::before {
  content: "\\f1665";
}

.mdi-heart-settings-outline::before {
  content: "\\f1666";
}

.mdi-helicopter::before {
  content: "\\f0ac2";
}

.mdi-help::before {
  content: "\\f02d6";
}

.mdi-help-box::before {
  content: "\\f078b";
}

.mdi-help-circle::before {
  content: "\\f02d7";
}

.mdi-help-circle-outline::before {
  content: "\\f0625";
}

.mdi-help-network::before {
  content: "\\f06f5";
}

.mdi-help-network-outline::before {
  content: "\\f0c8a";
}

.mdi-help-rhombus::before {
  content: "\\f0ba5";
}

.mdi-help-rhombus-outline::before {
  content: "\\f0ba6";
}

.mdi-hexadecimal::before {
  content: "\\f12a7";
}

.mdi-hexagon::before {
  content: "\\f02d8";
}

.mdi-hexagon-multiple::before {
  content: "\\f06e1";
}

.mdi-hexagon-multiple-outline::before {
  content: "\\f10f2";
}

.mdi-hexagon-outline::before {
  content: "\\f02d9";
}

.mdi-hexagon-slice-1::before {
  content: "\\f0ac3";
}

.mdi-hexagon-slice-2::before {
  content: "\\f0ac4";
}

.mdi-hexagon-slice-3::before {
  content: "\\f0ac5";
}

.mdi-hexagon-slice-4::before {
  content: "\\f0ac6";
}

.mdi-hexagon-slice-5::before {
  content: "\\f0ac7";
}

.mdi-hexagon-slice-6::before {
  content: "\\f0ac8";
}

.mdi-hexagram::before {
  content: "\\f0ac9";
}

.mdi-hexagram-outline::before {
  content: "\\f0aca";
}

.mdi-high-definition::before {
  content: "\\f07cf";
}

.mdi-high-definition-box::before {
  content: "\\f0878";
}

.mdi-highway::before {
  content: "\\f05f7";
}

.mdi-hiking::before {
  content: "\\f0d7f";
}

.mdi-history::before {
  content: "\\f02da";
}

.mdi-hockey-puck::before {
  content: "\\f0879";
}

.mdi-hockey-sticks::before {
  content: "\\f087a";
}

.mdi-hololens::before {
  content: "\\f02db";
}

.mdi-home::before {
  content: "\\f02dc";
}

.mdi-home-account::before {
  content: "\\f0826";
}

.mdi-home-alert::before {
  content: "\\f087b";
}

.mdi-home-alert-outline::before {
  content: "\\f15d0";
}

.mdi-home-analytics::before {
  content: "\\f0eba";
}

.mdi-home-assistant::before {
  content: "\\f07d0";
}

.mdi-home-automation::before {
  content: "\\f07d1";
}

.mdi-home-battery::before {
  content: "\\f1901";
}

.mdi-home-battery-outline::before {
  content: "\\f1902";
}

.mdi-home-circle::before {
  content: "\\f07d2";
}

.mdi-home-circle-outline::before {
  content: "\\f104d";
}

.mdi-home-city::before {
  content: "\\f0d15";
}

.mdi-home-city-outline::before {
  content: "\\f0d16";
}

.mdi-home-edit::before {
  content: "\\f1159";
}

.mdi-home-edit-outline::before {
  content: "\\f115a";
}

.mdi-home-export-outline::before {
  content: "\\f0f9b";
}

.mdi-home-flood::before {
  content: "\\f0efa";
}

.mdi-home-floor-0::before {
  content: "\\f0dd2";
}

.mdi-home-floor-1::before {
  content: "\\f0d80";
}

.mdi-home-floor-2::before {
  content: "\\f0d81";
}

.mdi-home-floor-3::before {
  content: "\\f0d82";
}

.mdi-home-floor-a::before {
  content: "\\f0d83";
}

.mdi-home-floor-b::before {
  content: "\\f0d84";
}

.mdi-home-floor-g::before {
  content: "\\f0d85";
}

.mdi-home-floor-l::before {
  content: "\\f0d86";
}

.mdi-home-floor-negative-1::before {
  content: "\\f0dd3";
}

.mdi-home-group::before {
  content: "\\f0dd4";
}

.mdi-home-group-minus::before {
  content: "\\f19c1";
}

.mdi-home-group-plus::before {
  content: "\\f19c0";
}

.mdi-home-group-remove::before {
  content: "\\f19c2";
}

.mdi-home-heart::before {
  content: "\\f0827";
}

.mdi-home-import-outline::before {
  content: "\\f0f9c";
}

.mdi-home-lightbulb::before {
  content: "\\f1251";
}

.mdi-home-lightbulb-outline::before {
  content: "\\f1252";
}

.mdi-home-lightning-bolt::before {
  content: "\\f1903";
}

.mdi-home-lightning-bolt-outline::before {
  content: "\\f1904";
}

.mdi-home-lock::before {
  content: "\\f08eb";
}

.mdi-home-lock-open::before {
  content: "\\f08ec";
}

.mdi-home-map-marker::before {
  content: "\\f05f8";
}

.mdi-home-minus::before {
  content: "\\f0974";
}

.mdi-home-minus-outline::before {
  content: "\\f13d5";
}

.mdi-home-modern::before {
  content: "\\f02dd";
}

.mdi-home-outline::before {
  content: "\\f06a1";
}

.mdi-home-plus::before {
  content: "\\f0975";
}

.mdi-home-plus-outline::before {
  content: "\\f13d6";
}

.mdi-home-remove::before {
  content: "\\f1247";
}

.mdi-home-remove-outline::before {
  content: "\\f13d7";
}

.mdi-home-roof::before {
  content: "\\f112b";
}

.mdi-home-search::before {
  content: "\\f13b0";
}

.mdi-home-search-outline::before {
  content: "\\f13b1";
}

.mdi-home-switch::before {
  content: "\\f1794";
}

.mdi-home-switch-outline::before {
  content: "\\f1795";
}

.mdi-home-thermometer::before {
  content: "\\f0f54";
}

.mdi-home-thermometer-outline::before {
  content: "\\f0f55";
}

.mdi-home-variant::before {
  content: "\\f02de";
}

.mdi-home-variant-outline::before {
  content: "\\f0ba7";
}

.mdi-hook::before {
  content: "\\f06e2";
}

.mdi-hook-off::before {
  content: "\\f06e3";
}

.mdi-hoop-house::before {
  content: "\\f0e56";
}

.mdi-hops::before {
  content: "\\f02df";
}

.mdi-horizontal-rotate-clockwise::before {
  content: "\\f10f3";
}

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\f10f4";
}

.mdi-horse::before {
  content: "\\f15bf";
}

.mdi-horse-human::before {
  content: "\\f15c0";
}

.mdi-horse-variant::before {
  content: "\\f15c1";
}

.mdi-horse-variant-fast::before {
  content: "\\f186e";
}

.mdi-horseshoe::before {
  content: "\\f0a58";
}

.mdi-hospital::before {
  content: "\\f0ff6";
}

.mdi-hospital-box::before {
  content: "\\f02e0";
}

.mdi-hospital-box-outline::before {
  content: "\\f0ff7";
}

.mdi-hospital-building::before {
  content: "\\f02e1";
}

.mdi-hospital-marker::before {
  content: "\\f02e2";
}

.mdi-hot-tub::before {
  content: "\\f0828";
}

.mdi-hours-24::before {
  content: "\\f1478";
}

.mdi-hubspot::before {
  content: "\\f0d17";
}

.mdi-hulu::before {
  content: "\\f0829";
}

.mdi-human::before {
  content: "\\f02e6";
}

.mdi-human-baby-changing-table::before {
  content: "\\f138b";
}

.mdi-human-cane::before {
  content: "\\f1581";
}

.mdi-human-capacity-decrease::before {
  content: "\\f159b";
}

.mdi-human-capacity-increase::before {
  content: "\\f159c";
}

.mdi-human-child::before {
  content: "\\f02e7";
}

.mdi-human-dolly::before {
  content: "\\f1980";
}

.mdi-human-edit::before {
  content: "\\f14e8";
}

.mdi-human-female::before {
  content: "\\f0649";
}

.mdi-human-female-boy::before {
  content: "\\f0a59";
}

.mdi-human-female-dance::before {
  content: "\\f15c9";
}

.mdi-human-female-female::before {
  content: "\\f0a5a";
}

.mdi-human-female-girl::before {
  content: "\\f0a5b";
}

.mdi-human-greeting::before {
  content: "\\f17c4";
}

.mdi-human-greeting-proximity::before {
  content: "\\f159d";
}

.mdi-human-greeting-variant::before {
  content: "\\f064a";
}

.mdi-human-handsdown::before {
  content: "\\f064b";
}

.mdi-human-handsup::before {
  content: "\\f064c";
}

.mdi-human-male::before {
  content: "\\f064d";
}

.mdi-human-male-board::before {
  content: "\\f0890";
}

.mdi-human-male-board-poll::before {
  content: "\\f0846";
}

.mdi-human-male-boy::before {
  content: "\\f0a5c";
}

.mdi-human-male-child::before {
  content: "\\f138c";
}

.mdi-human-male-female::before {
  content: "\\f02e8";
}

.mdi-human-male-female-child::before {
  content: "\\f1823";
}

.mdi-human-male-girl::before {
  content: "\\f0a5d";
}

.mdi-human-male-height::before {
  content: "\\f0efb";
}

.mdi-human-male-height-variant::before {
  content: "\\f0efc";
}

.mdi-human-male-male::before {
  content: "\\f0a5e";
}

.mdi-human-non-binary::before {
  content: "\\f1848";
}

.mdi-human-pregnant::before {
  content: "\\f05cf";
}

.mdi-human-queue::before {
  content: "\\f1571";
}

.mdi-human-scooter::before {
  content: "\\f11e9";
}

.mdi-human-wheelchair::before {
  content: "\\f138d";
}

.mdi-human-white-cane::before {
  content: "\\f1981";
}

.mdi-humble-bundle::before {
  content: "\\f0744";
}

.mdi-hvac::before {
  content: "\\f1352";
}

.mdi-hvac-off::before {
  content: "\\f159e";
}

.mdi-hydraulic-oil-level::before {
  content: "\\f1324";
}

.mdi-hydraulic-oil-temperature::before {
  content: "\\f1325";
}

.mdi-hydro-power::before {
  content: "\\f12e5";
}

.mdi-hydrogen-station::before {
  content: "\\f1894";
}

.mdi-ice-cream::before {
  content: "\\f082a";
}

.mdi-ice-cream-off::before {
  content: "\\f0e52";
}

.mdi-ice-pop::before {
  content: "\\f0efd";
}

.mdi-id-card::before {
  content: "\\f0fc0";
}

.mdi-identifier::before {
  content: "\\f0efe";
}

.mdi-ideogram-cjk::before {
  content: "\\f1331";
}

.mdi-ideogram-cjk-variant::before {
  content: "\\f1332";
}

.mdi-image::before {
  content: "\\f02e9";
}

.mdi-image-album::before {
  content: "\\f02ea";
}

.mdi-image-area::before {
  content: "\\f02eb";
}

.mdi-image-area-close::before {
  content: "\\f02ec";
}

.mdi-image-auto-adjust::before {
  content: "\\f0fc1";
}

.mdi-image-broken::before {
  content: "\\f02ed";
}

.mdi-image-broken-variant::before {
  content: "\\f02ee";
}

.mdi-image-edit::before {
  content: "\\f11e3";
}

.mdi-image-edit-outline::before {
  content: "\\f11e4";
}

.mdi-image-filter-black-white::before {
  content: "\\f02f0";
}

.mdi-image-filter-center-focus::before {
  content: "\\f02f1";
}

.mdi-image-filter-center-focus-strong::before {
  content: "\\f0eff";
}

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\f0f00";
}

.mdi-image-filter-center-focus-weak::before {
  content: "\\f02f2";
}

.mdi-image-filter-drama::before {
  content: "\\f02f3";
}

.mdi-image-filter-frames::before {
  content: "\\f02f4";
}

.mdi-image-filter-hdr::before {
  content: "\\f02f5";
}

.mdi-image-filter-none::before {
  content: "\\f02f6";
}

.mdi-image-filter-tilt-shift::before {
  content: "\\f02f7";
}

.mdi-image-filter-vintage::before {
  content: "\\f02f8";
}

.mdi-image-frame::before {
  content: "\\f0e49";
}

.mdi-image-marker::before {
  content: "\\f177b";
}

.mdi-image-marker-outline::before {
  content: "\\f177c";
}

.mdi-image-minus::before {
  content: "\\f1419";
}

.mdi-image-move::before {
  content: "\\f09f8";
}

.mdi-image-multiple::before {
  content: "\\f02f9";
}

.mdi-image-multiple-outline::before {
  content: "\\f02ef";
}

.mdi-image-off::before {
  content: "\\f082b";
}

.mdi-image-off-outline::before {
  content: "\\f11d1";
}

.mdi-image-outline::before {
  content: "\\f0976";
}

.mdi-image-plus::before {
  content: "\\f087c";
}

.mdi-image-remove::before {
  content: "\\f1418";
}

.mdi-image-search::before {
  content: "\\f0977";
}

.mdi-image-search-outline::before {
  content: "\\f0978";
}

.mdi-image-size-select-actual::before {
  content: "\\f0c8d";
}

.mdi-image-size-select-large::before {
  content: "\\f0c8e";
}

.mdi-image-size-select-small::before {
  content: "\\f0c8f";
}

.mdi-image-text::before {
  content: "\\f160d";
}

.mdi-import::before {
  content: "\\f02fa";
}

.mdi-inbox::before {
  content: "\\f0687";
}

.mdi-inbox-arrow-down::before {
  content: "\\f02fb";
}

.mdi-inbox-arrow-down-outline::before {
  content: "\\f1270";
}

.mdi-inbox-arrow-up::before {
  content: "\\f03d1";
}

.mdi-inbox-arrow-up-outline::before {
  content: "\\f1271";
}

.mdi-inbox-full::before {
  content: "\\f1272";
}

.mdi-inbox-full-outline::before {
  content: "\\f1273";
}

.mdi-inbox-multiple::before {
  content: "\\f08b0";
}

.mdi-inbox-multiple-outline::before {
  content: "\\f0ba8";
}

.mdi-inbox-outline::before {
  content: "\\f1274";
}

.mdi-inbox-remove::before {
  content: "\\f159f";
}

.mdi-inbox-remove-outline::before {
  content: "\\f15a0";
}

.mdi-incognito::before {
  content: "\\f05f9";
}

.mdi-incognito-circle::before {
  content: "\\f1421";
}

.mdi-incognito-circle-off::before {
  content: "\\f1422";
}

.mdi-incognito-off::before {
  content: "\\f0075";
}

.mdi-induction::before {
  content: "\\f184c";
}

.mdi-infinity::before {
  content: "\\f06e4";
}

.mdi-information::before {
  content: "\\f02fc";
}

.mdi-information-off::before {
  content: "\\f178c";
}

.mdi-information-off-outline::before {
  content: "\\f178d";
}

.mdi-information-outline::before {
  content: "\\f02fd";
}

.mdi-information-variant::before {
  content: "\\f064e";
}

.mdi-instagram::before {
  content: "\\f02fe";
}

.mdi-instrument-triangle::before {
  content: "\\f104e";
}

.mdi-integrated-circuit-chip::before {
  content: "\\f1913";
}

.mdi-invert-colors::before {
  content: "\\f0301";
}

.mdi-invert-colors-off::before {
  content: "\\f0e4a";
}

.mdi-iobroker::before {
  content: "\\f12e8";
}

.mdi-ip::before {
  content: "\\f0a5f";
}

.mdi-ip-network::before {
  content: "\\f0a60";
}

.mdi-ip-network-outline::before {
  content: "\\f0c90";
}

.mdi-ip-outline::before {
  content: "\\f1982";
}

.mdi-ipod::before {
  content: "\\f0c91";
}

.mdi-iron::before {
  content: "\\f1824";
}

.mdi-iron-board::before {
  content: "\\f1838";
}

.mdi-iron-outline::before {
  content: "\\f1825";
}

.mdi-island::before {
  content: "\\f104f";
}

.mdi-iv-bag::before {
  content: "\\f10b9";
}

.mdi-jabber::before {
  content: "\\f0dd5";
}

.mdi-jeepney::before {
  content: "\\f0302";
}

.mdi-jellyfish::before {
  content: "\\f0f01";
}

.mdi-jellyfish-outline::before {
  content: "\\f0f02";
}

.mdi-jira::before {
  content: "\\f0303";
}

.mdi-jquery::before {
  content: "\\f087d";
}

.mdi-jsfiddle::before {
  content: "\\f0304";
}

.mdi-jump-rope::before {
  content: "\\f12ff";
}

.mdi-kabaddi::before {
  content: "\\f0d87";
}

.mdi-kangaroo::before {
  content: "\\f1558";
}

.mdi-karate::before {
  content: "\\f082c";
}

.mdi-kayaking::before {
  content: "\\f08af";
}

.mdi-keg::before {
  content: "\\f0305";
}

.mdi-kettle::before {
  content: "\\f05fa";
}

.mdi-kettle-alert::before {
  content: "\\f1317";
}

.mdi-kettle-alert-outline::before {
  content: "\\f1318";
}

.mdi-kettle-off::before {
  content: "\\f131b";
}

.mdi-kettle-off-outline::before {
  content: "\\f131c";
}

.mdi-kettle-outline::before {
  content: "\\f0f56";
}

.mdi-kettle-pour-over::before {
  content: "\\f173c";
}

.mdi-kettle-steam::before {
  content: "\\f1319";
}

.mdi-kettle-steam-outline::before {
  content: "\\f131a";
}

.mdi-kettlebell::before {
  content: "\\f1300";
}

.mdi-key::before {
  content: "\\f0306";
}

.mdi-key-alert::before {
  content: "\\f1983";
}

.mdi-key-alert-outline::before {
  content: "\\f1984";
}

.mdi-key-arrow-right::before {
  content: "\\f1312";
}

.mdi-key-chain::before {
  content: "\\f1574";
}

.mdi-key-chain-variant::before {
  content: "\\f1575";
}

.mdi-key-change::before {
  content: "\\f0307";
}

.mdi-key-link::before {
  content: "\\f119f";
}

.mdi-key-minus::before {
  content: "\\f0308";
}

.mdi-key-outline::before {
  content: "\\f0dd6";
}

.mdi-key-plus::before {
  content: "\\f0309";
}

.mdi-key-remove::before {
  content: "\\f030a";
}

.mdi-key-star::before {
  content: "\\f119e";
}

.mdi-key-variant::before {
  content: "\\f030b";
}

.mdi-key-wireless::before {
  content: "\\f0fc2";
}

.mdi-keyboard::before {
  content: "\\f030c";
}

.mdi-keyboard-backspace::before {
  content: "\\f030d";
}

.mdi-keyboard-caps::before {
  content: "\\f030e";
}

.mdi-keyboard-close::before {
  content: "\\f030f";
}

.mdi-keyboard-esc::before {
  content: "\\f12b7";
}

.mdi-keyboard-f1::before {
  content: "\\f12ab";
}

.mdi-keyboard-f10::before {
  content: "\\f12b4";
}

.mdi-keyboard-f11::before {
  content: "\\f12b5";
}

.mdi-keyboard-f12::before {
  content: "\\f12b6";
}

.mdi-keyboard-f2::before {
  content: "\\f12ac";
}

.mdi-keyboard-f3::before {
  content: "\\f12ad";
}

.mdi-keyboard-f4::before {
  content: "\\f12ae";
}

.mdi-keyboard-f5::before {
  content: "\\f12af";
}

.mdi-keyboard-f6::before {
  content: "\\f12b0";
}

.mdi-keyboard-f7::before {
  content: "\\f12b1";
}

.mdi-keyboard-f8::before {
  content: "\\f12b2";
}

.mdi-keyboard-f9::before {
  content: "\\f12b3";
}

.mdi-keyboard-off::before {
  content: "\\f0310";
}

.mdi-keyboard-off-outline::before {
  content: "\\f0e4b";
}

.mdi-keyboard-outline::before {
  content: "\\f097b";
}

.mdi-keyboard-return::before {
  content: "\\f0311";
}

.mdi-keyboard-settings::before {
  content: "\\f09f9";
}

.mdi-keyboard-settings-outline::before {
  content: "\\f09fa";
}

.mdi-keyboard-space::before {
  content: "\\f1050";
}

.mdi-keyboard-tab::before {
  content: "\\f0312";
}

.mdi-keyboard-tab-reverse::before {
  content: "\\f0325";
}

.mdi-keyboard-variant::before {
  content: "\\f0313";
}

.mdi-khanda::before {
  content: "\\f10fd";
}

.mdi-kickstarter::before {
  content: "\\f0745";
}

.mdi-kite::before {
  content: "\\f1985";
}

.mdi-kite-outline::before {
  content: "\\f1986";
}

.mdi-kitesurfing::before {
  content: "\\f1744";
}

.mdi-klingon::before {
  content: "\\f135b";
}

.mdi-knife::before {
  content: "\\f09fb";
}

.mdi-knife-military::before {
  content: "\\f09fc";
}

.mdi-koala::before {
  content: "\\f173f";
}

.mdi-kodi::before {
  content: "\\f0314";
}

.mdi-kubernetes::before {
  content: "\\f10fe";
}

.mdi-label::before {
  content: "\\f0315";
}

.mdi-label-multiple::before {
  content: "\\f1375";
}

.mdi-label-multiple-outline::before {
  content: "\\f1376";
}

.mdi-label-off::before {
  content: "\\f0acb";
}

.mdi-label-off-outline::before {
  content: "\\f0acc";
}

.mdi-label-outline::before {
  content: "\\f0316";
}

.mdi-label-percent::before {
  content: "\\f12ea";
}

.mdi-label-percent-outline::before {
  content: "\\f12eb";
}

.mdi-label-variant::before {
  content: "\\f0acd";
}

.mdi-label-variant-outline::before {
  content: "\\f0ace";
}

.mdi-ladder::before {
  content: "\\f15a2";
}

.mdi-ladybug::before {
  content: "\\f082d";
}

.mdi-lambda::before {
  content: "\\f0627";
}

.mdi-lamp::before {
  content: "\\f06b5";
}

.mdi-lamp-outline::before {
  content: "\\f17d0";
}

.mdi-lamps::before {
  content: "\\f1576";
}

.mdi-lamps-outline::before {
  content: "\\f17d1";
}

.mdi-lan::before {
  content: "\\f0317";
}

.mdi-lan-check::before {
  content: "\\f12aa";
}

.mdi-lan-connect::before {
  content: "\\f0318";
}

.mdi-lan-disconnect::before {
  content: "\\f0319";
}

.mdi-lan-pending::before {
  content: "\\f031a";
}

.mdi-language-c::before {
  content: "\\f0671";
}

.mdi-language-cpp::before {
  content: "\\f0672";
}

.mdi-language-csharp::before {
  content: "\\f031b";
}

.mdi-language-css3::before {
  content: "\\f031c";
}

.mdi-language-fortran::before {
  content: "\\f121a";
}

.mdi-language-go::before {
  content: "\\f07d3";
}

.mdi-language-haskell::before {
  content: "\\f0c92";
}

.mdi-language-html5::before {
  content: "\\f031d";
}

.mdi-language-java::before {
  content: "\\f0b37";
}

.mdi-language-javascript::before {
  content: "\\f031e";
}

.mdi-language-kotlin::before {
  content: "\\f1219";
}

.mdi-language-lua::before {
  content: "\\f08b1";
}

.mdi-language-markdown::before {
  content: "\\f0354";
}

.mdi-language-markdown-outline::before {
  content: "\\f0f5b";
}

.mdi-language-php::before {
  content: "\\f031f";
}

.mdi-language-python::before {
  content: "\\f0320";
}

.mdi-language-r::before {
  content: "\\f07d4";
}

.mdi-language-ruby::before {
  content: "\\f0d2d";
}

.mdi-language-ruby-on-rails::before {
  content: "\\f0acf";
}

.mdi-language-rust::before {
  content: "\\f1617";
}

.mdi-language-swift::before {
  content: "\\f06e5";
}

.mdi-language-typescript::before {
  content: "\\f06e6";
}

.mdi-language-xaml::before {
  content: "\\f0673";
}

.mdi-laptop::before {
  content: "\\f0322";
}

.mdi-laptop-off::before {
  content: "\\f06e7";
}

.mdi-laravel::before {
  content: "\\f0ad0";
}

.mdi-laser-pointer::before {
  content: "\\f1484";
}

.mdi-lasso::before {
  content: "\\f0f03";
}

.mdi-lastpass::before {
  content: "\\f0446";
}

.mdi-latitude::before {
  content: "\\f0f57";
}

.mdi-launch::before {
  content: "\\f0327";
}

.mdi-lava-lamp::before {
  content: "\\f07d5";
}

.mdi-layers::before {
  content: "\\f0328";
}

.mdi-layers-edit::before {
  content: "\\f1892";
}

.mdi-layers-minus::before {
  content: "\\f0e4c";
}

.mdi-layers-off::before {
  content: "\\f0329";
}

.mdi-layers-off-outline::before {
  content: "\\f09fd";
}

.mdi-layers-outline::before {
  content: "\\f09fe";
}

.mdi-layers-plus::before {
  content: "\\f0e4d";
}

.mdi-layers-remove::before {
  content: "\\f0e4e";
}

.mdi-layers-search::before {
  content: "\\f1206";
}

.mdi-layers-search-outline::before {
  content: "\\f1207";
}

.mdi-layers-triple::before {
  content: "\\f0f58";
}

.mdi-layers-triple-outline::before {
  content: "\\f0f59";
}

.mdi-lead-pencil::before {
  content: "\\f064f";
}

.mdi-leaf::before {
  content: "\\f032a";
}

.mdi-leaf-circle::before {
  content: "\\f1905";
}

.mdi-leaf-circle-outline::before {
  content: "\\f1906";
}

.mdi-leaf-maple::before {
  content: "\\f0c93";
}

.mdi-leaf-maple-off::before {
  content: "\\f12da";
}

.mdi-leaf-off::before {
  content: "\\f12d9";
}

.mdi-leak::before {
  content: "\\f0dd7";
}

.mdi-leak-off::before {
  content: "\\f0dd8";
}

.mdi-led-off::before {
  content: "\\f032b";
}

.mdi-led-on::before {
  content: "\\f032c";
}

.mdi-led-outline::before {
  content: "\\f032d";
}

.mdi-led-strip::before {
  content: "\\f07d6";
}

.mdi-led-strip-variant::before {
  content: "\\f1051";
}

.mdi-led-variant-off::before {
  content: "\\f032e";
}

.mdi-led-variant-on::before {
  content: "\\f032f";
}

.mdi-led-variant-outline::before {
  content: "\\f0330";
}

.mdi-leek::before {
  content: "\\f117d";
}

.mdi-less-than::before {
  content: "\\f097c";
}

.mdi-less-than-or-equal::before {
  content: "\\f097d";
}

.mdi-library::before {
  content: "\\f0331";
}

.mdi-library-shelves::before {
  content: "\\f0ba9";
}

.mdi-license::before {
  content: "\\f0fc3";
}

.mdi-lifebuoy::before {
  content: "\\f087e";
}

.mdi-light-flood-down::before {
  content: "\\f1987";
}

.mdi-light-flood-up::before {
  content: "\\f1988";
}

.mdi-light-recessed::before {
  content: "\\f179b";
}

.mdi-light-switch::before {
  content: "\\f097e";
}

.mdi-lightbulb::before {
  content: "\\f0335";
}

.mdi-lightbulb-auto::before {
  content: "\\f1800";
}

.mdi-lightbulb-auto-outline::before {
  content: "\\f1801";
}

.mdi-lightbulb-cfl::before {
  content: "\\f1208";
}

.mdi-lightbulb-cfl-off::before {
  content: "\\f1209";
}

.mdi-lightbulb-cfl-spiral::before {
  content: "\\f1275";
}

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\f12c3";
}

.mdi-lightbulb-fluorescent-tube::before {
  content: "\\f1804";
}

.mdi-lightbulb-fluorescent-tube-outline::before {
  content: "\\f1805";
}

.mdi-lightbulb-group::before {
  content: "\\f1253";
}

.mdi-lightbulb-group-off::before {
  content: "\\f12cd";
}

.mdi-lightbulb-group-off-outline::before {
  content: "\\f12ce";
}

.mdi-lightbulb-group-outline::before {
  content: "\\f1254";
}

.mdi-lightbulb-multiple::before {
  content: "\\f1255";
}

.mdi-lightbulb-multiple-off::before {
  content: "\\f12cf";
}

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\f12d0";
}

.mdi-lightbulb-multiple-outline::before {
  content: "\\f1256";
}

.mdi-lightbulb-off::before {
  content: "\\f0e4f";
}

.mdi-lightbulb-off-outline::before {
  content: "\\f0e50";
}

.mdi-lightbulb-on::before {
  content: "\\f06e8";
}

.mdi-lightbulb-on-outline::before {
  content: "\\f06e9";
}

.mdi-lightbulb-outline::before {
  content: "\\f0336";
}

.mdi-lightbulb-spot::before {
  content: "\\f17f4";
}

.mdi-lightbulb-spot-off::before {
  content: "\\f17f5";
}

.mdi-lightbulb-variant::before {
  content: "\\f1802";
}

.mdi-lightbulb-variant-outline::before {
  content: "\\f1803";
}

.mdi-lighthouse::before {
  content: "\\f09ff";
}

.mdi-lighthouse-on::before {
  content: "\\f0a00";
}

.mdi-lightning-bolt::before {
  content: "\\f140b";
}

.mdi-lightning-bolt-circle::before {
  content: "\\f0820";
}

.mdi-lightning-bolt-outline::before {
  content: "\\f140c";
}

.mdi-line-scan::before {
  content: "\\f0624";
}

.mdi-lingerie::before {
  content: "\\f1476";
}

.mdi-link::before {
  content: "\\f0337";
}

.mdi-link-box::before {
  content: "\\f0d1a";
}

.mdi-link-box-outline::before {
  content: "\\f0d1b";
}

.mdi-link-box-variant::before {
  content: "\\f0d1c";
}

.mdi-link-box-variant-outline::before {
  content: "\\f0d1d";
}

.mdi-link-lock::before {
  content: "\\f10ba";
}

.mdi-link-off::before {
  content: "\\f0338";
}

.mdi-link-plus::before {
  content: "\\f0c94";
}

.mdi-link-variant::before {
  content: "\\f0339";
}

.mdi-link-variant-minus::before {
  content: "\\f10ff";
}

.mdi-link-variant-off::before {
  content: "\\f033a";
}

.mdi-link-variant-plus::before {
  content: "\\f1100";
}

.mdi-link-variant-remove::before {
  content: "\\f1101";
}

.mdi-linkedin::before {
  content: "\\f033b";
}

.mdi-linux::before {
  content: "\\f033d";
}

.mdi-linux-mint::before {
  content: "\\f08ed";
}

.mdi-lipstick::before {
  content: "\\f13b5";
}

.mdi-liquid-spot::before {
  content: "\\f1826";
}

.mdi-liquor::before {
  content: "\\f191e";
}

.mdi-list-status::before {
  content: "\\f15ab";
}

.mdi-litecoin::before {
  content: "\\f0a61";
}

.mdi-loading::before {
  content: "\\f0772";
}

.mdi-location-enter::before {
  content: "\\f0fc4";
}

.mdi-location-exit::before {
  content: "\\f0fc5";
}

.mdi-lock::before {
  content: "\\f033e";
}

.mdi-lock-alert::before {
  content: "\\f08ee";
}

.mdi-lock-alert-outline::before {
  content: "\\f15d1";
}

.mdi-lock-check::before {
  content: "\\f139a";
}

.mdi-lock-check-outline::before {
  content: "\\f16a8";
}

.mdi-lock-clock::before {
  content: "\\f097f";
}

.mdi-lock-minus::before {
  content: "\\f16a9";
}

.mdi-lock-minus-outline::before {
  content: "\\f16aa";
}

.mdi-lock-off::before {
  content: "\\f1671";
}

.mdi-lock-off-outline::before {
  content: "\\f1672";
}

.mdi-lock-open::before {
  content: "\\f033f";
}

.mdi-lock-open-alert::before {
  content: "\\f139b";
}

.mdi-lock-open-alert-outline::before {
  content: "\\f15d2";
}

.mdi-lock-open-check::before {
  content: "\\f139c";
}

.mdi-lock-open-check-outline::before {
  content: "\\f16ab";
}

.mdi-lock-open-minus::before {
  content: "\\f16ac";
}

.mdi-lock-open-minus-outline::before {
  content: "\\f16ad";
}

.mdi-lock-open-outline::before {
  content: "\\f0340";
}

.mdi-lock-open-plus::before {
  content: "\\f16ae";
}

.mdi-lock-open-plus-outline::before {
  content: "\\f16af";
}

.mdi-lock-open-remove::before {
  content: "\\f16b0";
}

.mdi-lock-open-remove-outline::before {
  content: "\\f16b1";
}

.mdi-lock-open-variant::before {
  content: "\\f0fc6";
}

.mdi-lock-open-variant-outline::before {
  content: "\\f0fc7";
}

.mdi-lock-outline::before {
  content: "\\f0341";
}

.mdi-lock-pattern::before {
  content: "\\f06ea";
}

.mdi-lock-plus::before {
  content: "\\f05fb";
}

.mdi-lock-plus-outline::before {
  content: "\\f16b2";
}

.mdi-lock-question::before {
  content: "\\f08ef";
}

.mdi-lock-remove::before {
  content: "\\f16b3";
}

.mdi-lock-remove-outline::before {
  content: "\\f16b4";
}

.mdi-lock-reset::before {
  content: "\\f0773";
}

.mdi-lock-smart::before {
  content: "\\f08b2";
}

.mdi-locker::before {
  content: "\\f07d7";
}

.mdi-locker-multiple::before {
  content: "\\f07d8";
}

.mdi-login::before {
  content: "\\f0342";
}

.mdi-login-variant::before {
  content: "\\f05fc";
}

.mdi-logout::before {
  content: "\\f0343";
}

.mdi-logout-variant::before {
  content: "\\f05fd";
}

.mdi-longitude::before {
  content: "\\f0f5a";
}

.mdi-looks::before {
  content: "\\f0344";
}

.mdi-lotion::before {
  content: "\\f1582";
}

.mdi-lotion-outline::before {
  content: "\\f1583";
}

.mdi-lotion-plus::before {
  content: "\\f1584";
}

.mdi-lotion-plus-outline::before {
  content: "\\f1585";
}

.mdi-loupe::before {
  content: "\\f0345";
}

.mdi-lumx::before {
  content: "\\f0346";
}

.mdi-lungs::before {
  content: "\\f1084";
}

.mdi-mace::before {
  content: "\\f1843";
}

.mdi-magazine-pistol::before {
  content: "\\f0324";
}

.mdi-magazine-rifle::before {
  content: "\\f0323";
}

.mdi-magic-staff::before {
  content: "\\f1844";
}

.mdi-magnet::before {
  content: "\\f0347";
}

.mdi-magnet-on::before {
  content: "\\f0348";
}

.mdi-magnify::before {
  content: "\\f0349";
}

.mdi-magnify-close::before {
  content: "\\f0980";
}

.mdi-magnify-expand::before {
  content: "\\f1874";
}

.mdi-magnify-minus::before {
  content: "\\f034a";
}

.mdi-magnify-minus-cursor::before {
  content: "\\f0a62";
}

.mdi-magnify-minus-outline::before {
  content: "\\f06ec";
}

.mdi-magnify-plus::before {
  content: "\\f034b";
}

.mdi-magnify-plus-cursor::before {
  content: "\\f0a63";
}

.mdi-magnify-plus-outline::before {
  content: "\\f06ed";
}

.mdi-magnify-remove-cursor::before {
  content: "\\f120c";
}

.mdi-magnify-remove-outline::before {
  content: "\\f120d";
}

.mdi-magnify-scan::before {
  content: "\\f1276";
}

.mdi-mail::before {
  content: "\\f0ebb";
}

.mdi-mailbox::before {
  content: "\\f06ee";
}

.mdi-mailbox-open::before {
  content: "\\f0d88";
}

.mdi-mailbox-open-outline::before {
  content: "\\f0d89";
}

.mdi-mailbox-open-up::before {
  content: "\\f0d8a";
}

.mdi-mailbox-open-up-outline::before {
  content: "\\f0d8b";
}

.mdi-mailbox-outline::before {
  content: "\\f0d8c";
}

.mdi-mailbox-up::before {
  content: "\\f0d8d";
}

.mdi-mailbox-up-outline::before {
  content: "\\f0d8e";
}

.mdi-manjaro::before {
  content: "\\f160a";
}

.mdi-map::before {
  content: "\\f034d";
}

.mdi-map-check::before {
  content: "\\f0ebc";
}

.mdi-map-check-outline::before {
  content: "\\f0ebd";
}

.mdi-map-clock::before {
  content: "\\f0d1e";
}

.mdi-map-clock-outline::before {
  content: "\\f0d1f";
}

.mdi-map-legend::before {
  content: "\\f0a01";
}

.mdi-map-marker::before {
  content: "\\f034e";
}

.mdi-map-marker-account::before {
  content: "\\f18e3";
}

.mdi-map-marker-account-outline::before {
  content: "\\f18e4";
}

.mdi-map-marker-alert::before {
  content: "\\f0f05";
}

.mdi-map-marker-alert-outline::before {
  content: "\\f0f06";
}

.mdi-map-marker-check::before {
  content: "\\f0c95";
}

.mdi-map-marker-check-outline::before {
  content: "\\f12fb";
}

.mdi-map-marker-circle::before {
  content: "\\f034f";
}

.mdi-map-marker-distance::before {
  content: "\\f08f0";
}

.mdi-map-marker-down::before {
  content: "\\f1102";
}

.mdi-map-marker-left::before {
  content: "\\f12db";
}

.mdi-map-marker-left-outline::before {
  content: "\\f12dd";
}

.mdi-map-marker-minus::before {
  content: "\\f0650";
}

.mdi-map-marker-minus-outline::before {
  content: "\\f12f9";
}

.mdi-map-marker-multiple::before {
  content: "\\f0350";
}

.mdi-map-marker-multiple-outline::before {
  content: "\\f1277";
}

.mdi-map-marker-off::before {
  content: "\\f0351";
}

.mdi-map-marker-off-outline::before {
  content: "\\f12fd";
}

.mdi-map-marker-outline::before {
  content: "\\f07d9";
}

.mdi-map-marker-path::before {
  content: "\\f0d20";
}

.mdi-map-marker-plus::before {
  content: "\\f0651";
}

.mdi-map-marker-plus-outline::before {
  content: "\\f12f8";
}

.mdi-map-marker-question::before {
  content: "\\f0f07";
}

.mdi-map-marker-question-outline::before {
  content: "\\f0f08";
}

.mdi-map-marker-radius::before {
  content: "\\f0352";
}

.mdi-map-marker-radius-outline::before {
  content: "\\f12fc";
}

.mdi-map-marker-remove::before {
  content: "\\f0f09";
}

.mdi-map-marker-remove-outline::before {
  content: "\\f12fa";
}

.mdi-map-marker-remove-variant::before {
  content: "\\f0f0a";
}

.mdi-map-marker-right::before {
  content: "\\f12dc";
}

.mdi-map-marker-right-outline::before {
  content: "\\f12de";
}

.mdi-map-marker-star::before {
  content: "\\f1608";
}

.mdi-map-marker-star-outline::before {
  content: "\\f1609";
}

.mdi-map-marker-up::before {
  content: "\\f1103";
}

.mdi-map-minus::before {
  content: "\\f0981";
}

.mdi-map-outline::before {
  content: "\\f0982";
}

.mdi-map-plus::before {
  content: "\\f0983";
}

.mdi-map-search::before {
  content: "\\f0984";
}

.mdi-map-search-outline::before {
  content: "\\f0985";
}

.mdi-mapbox::before {
  content: "\\f0baa";
}

.mdi-margin::before {
  content: "\\f0353";
}

.mdi-marker::before {
  content: "\\f0652";
}

.mdi-marker-cancel::before {
  content: "\\f0dd9";
}

.mdi-marker-check::before {
  content: "\\f0355";
}

.mdi-mastodon::before {
  content: "\\f0ad1";
}

.mdi-material-design::before {
  content: "\\f0986";
}

.mdi-material-ui::before {
  content: "\\f0357";
}

.mdi-math-compass::before {
  content: "\\f0358";
}

.mdi-math-cos::before {
  content: "\\f0c96";
}

.mdi-math-integral::before {
  content: "\\f0fc8";
}

.mdi-math-integral-box::before {
  content: "\\f0fc9";
}

.mdi-math-log::before {
  content: "\\f1085";
}

.mdi-math-norm::before {
  content: "\\f0fca";
}

.mdi-math-norm-box::before {
  content: "\\f0fcb";
}

.mdi-math-sin::before {
  content: "\\f0c97";
}

.mdi-math-tan::before {
  content: "\\f0c98";
}

.mdi-matrix::before {
  content: "\\f0628";
}

.mdi-medal::before {
  content: "\\f0987";
}

.mdi-medal-outline::before {
  content: "\\f1326";
}

.mdi-medical-bag::before {
  content: "\\f06ef";
}

.mdi-meditation::before {
  content: "\\f117b";
}

.mdi-memory::before {
  content: "\\f035b";
}

.mdi-menorah::before {
  content: "\\f17d4";
}

.mdi-menorah-fire::before {
  content: "\\f17d5";
}

.mdi-menu::before {
  content: "\\f035c";
}

.mdi-menu-down::before {
  content: "\\f035d";
}

.mdi-menu-down-outline::before {
  content: "\\f06b6";
}

.mdi-menu-left::before {
  content: "\\f035e";
}

.mdi-menu-left-outline::before {
  content: "\\f0a02";
}

.mdi-menu-open::before {
  content: "\\f0bab";
}

.mdi-menu-right::before {
  content: "\\f035f";
}

.mdi-menu-right-outline::before {
  content: "\\f0a03";
}

.mdi-menu-swap::before {
  content: "\\f0a64";
}

.mdi-menu-swap-outline::before {
  content: "\\f0a65";
}

.mdi-menu-up::before {
  content: "\\f0360";
}

.mdi-menu-up-outline::before {
  content: "\\f06b7";
}

.mdi-merge::before {
  content: "\\f0f5c";
}

.mdi-message::before {
  content: "\\f0361";
}

.mdi-message-alert::before {
  content: "\\f0362";
}

.mdi-message-alert-outline::before {
  content: "\\f0a04";
}

.mdi-message-arrow-left::before {
  content: "\\f12f2";
}

.mdi-message-arrow-left-outline::before {
  content: "\\f12f3";
}

.mdi-message-arrow-right::before {
  content: "\\f12f4";
}

.mdi-message-arrow-right-outline::before {
  content: "\\f12f5";
}

.mdi-message-badge::before {
  content: "\\f1941";
}

.mdi-message-badge-outline::before {
  content: "\\f1942";
}

.mdi-message-bookmark::before {
  content: "\\f15ac";
}

.mdi-message-bookmark-outline::before {
  content: "\\f15ad";
}

.mdi-message-bulleted::before {
  content: "\\f06a2";
}

.mdi-message-bulleted-off::before {
  content: "\\f06a3";
}

.mdi-message-cog::before {
  content: "\\f06f1";
}

.mdi-message-cog-outline::before {
  content: "\\f1172";
}

.mdi-message-draw::before {
  content: "\\f0363";
}

.mdi-message-flash::before {
  content: "\\f15a9";
}

.mdi-message-flash-outline::before {
  content: "\\f15aa";
}

.mdi-message-image::before {
  content: "\\f0364";
}

.mdi-message-image-outline::before {
  content: "\\f116c";
}

.mdi-message-lock::before {
  content: "\\f0fcc";
}

.mdi-message-lock-outline::before {
  content: "\\f116d";
}

.mdi-message-minus::before {
  content: "\\f116e";
}

.mdi-message-minus-outline::before {
  content: "\\f116f";
}

.mdi-message-off::before {
  content: "\\f164d";
}

.mdi-message-off-outline::before {
  content: "\\f164e";
}

.mdi-message-outline::before {
  content: "\\f0365";
}

.mdi-message-plus::before {
  content: "\\f0653";
}

.mdi-message-plus-outline::before {
  content: "\\f10bb";
}

.mdi-message-processing::before {
  content: "\\f0366";
}

.mdi-message-processing-outline::before {
  content: "\\f1170";
}

.mdi-message-question::before {
  content: "\\f173a";
}

.mdi-message-question-outline::before {
  content: "\\f173b";
}

.mdi-message-reply::before {
  content: "\\f0367";
}

.mdi-message-reply-outline::before {
  content: "\\f173d";
}

.mdi-message-reply-text::before {
  content: "\\f0368";
}

.mdi-message-reply-text-outline::before {
  content: "\\f173e";
}

.mdi-message-settings::before {
  content: "\\f06f0";
}

.mdi-message-settings-outline::before {
  content: "\\f1171";
}

.mdi-message-star::before {
  content: "\\f069a";
}

.mdi-message-star-outline::before {
  content: "\\f1250";
}

.mdi-message-text::before {
  content: "\\f0369";
}

.mdi-message-text-clock::before {
  content: "\\f1173";
}

.mdi-message-text-clock-outline::before {
  content: "\\f1174";
}

.mdi-message-text-lock::before {
  content: "\\f0fcd";
}

.mdi-message-text-lock-outline::before {
  content: "\\f1175";
}

.mdi-message-text-outline::before {
  content: "\\f036a";
}

.mdi-message-video::before {
  content: "\\f036b";
}

.mdi-meteor::before {
  content: "\\f0629";
}

.mdi-metronome::before {
  content: "\\f07da";
}

.mdi-metronome-tick::before {
  content: "\\f07db";
}

.mdi-micro-sd::before {
  content: "\\f07dc";
}

.mdi-microphone::before {
  content: "\\f036c";
}

.mdi-microphone-minus::before {
  content: "\\f08b3";
}

.mdi-microphone-off::before {
  content: "\\f036d";
}

.mdi-microphone-outline::before {
  content: "\\f036e";
}

.mdi-microphone-plus::before {
  content: "\\f08b4";
}

.mdi-microphone-question::before {
  content: "\\f1989";
}

.mdi-microphone-question-outline::before {
  content: "\\f198a";
}

.mdi-microphone-settings::before {
  content: "\\f036f";
}

.mdi-microphone-variant::before {
  content: "\\f0370";
}

.mdi-microphone-variant-off::before {
  content: "\\f0371";
}

.mdi-microscope::before {
  content: "\\f0654";
}

.mdi-microsoft::before {
  content: "\\f0372";
}

.mdi-microsoft-access::before {
  content: "\\f138e";
}

.mdi-microsoft-azure::before {
  content: "\\f0805";
}

.mdi-microsoft-azure-devops::before {
  content: "\\f0fd5";
}

.mdi-microsoft-bing::before {
  content: "\\f00a4";
}

.mdi-microsoft-dynamics-365::before {
  content: "\\f0988";
}

.mdi-microsoft-edge::before {
  content: "\\f01e9";
}

.mdi-microsoft-excel::before {
  content: "\\f138f";
}

.mdi-microsoft-internet-explorer::before {
  content: "\\f0300";
}

.mdi-microsoft-office::before {
  content: "\\f03c6";
}

.mdi-microsoft-onedrive::before {
  content: "\\f03ca";
}

.mdi-microsoft-onenote::before {
  content: "\\f0747";
}

.mdi-microsoft-outlook::before {
  content: "\\f0d22";
}

.mdi-microsoft-powerpoint::before {
  content: "\\f1390";
}

.mdi-microsoft-sharepoint::before {
  content: "\\f1391";
}

.mdi-microsoft-teams::before {
  content: "\\f02bb";
}

.mdi-microsoft-visual-studio::before {
  content: "\\f0610";
}

.mdi-microsoft-visual-studio-code::before {
  content: "\\f0a1e";
}

.mdi-microsoft-windows::before {
  content: "\\f05b3";
}

.mdi-microsoft-windows-classic::before {
  content: "\\f0a21";
}

.mdi-microsoft-word::before {
  content: "\\f1392";
}

.mdi-microsoft-xbox::before {
  content: "\\f05b9";
}

.mdi-microsoft-xbox-controller::before {
  content: "\\f05ba";
}

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "\\f074b";
}

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "\\f0a22";
}

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "\\f074c";
}

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "\\f074d";
}

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "\\f074e";
}

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "\\f074f";
}

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "\\f0750";
}

.mdi-microsoft-xbox-controller-menu::before {
  content: "\\f0e6f";
}

.mdi-microsoft-xbox-controller-off::before {
  content: "\\f05bb";
}

.mdi-microsoft-xbox-controller-view::before {
  content: "\\f0e70";
}

.mdi-microwave::before {
  content: "\\f0c99";
}

.mdi-microwave-off::before {
  content: "\\f1423";
}

.mdi-middleware::before {
  content: "\\f0f5d";
}

.mdi-middleware-outline::before {
  content: "\\f0f5e";
}

.mdi-midi::before {
  content: "\\f08f1";
}

.mdi-midi-port::before {
  content: "\\f08f2";
}

.mdi-mine::before {
  content: "\\f0dda";
}

.mdi-minecraft::before {
  content: "\\f0373";
}

.mdi-mini-sd::before {
  content: "\\f0a05";
}

.mdi-minidisc::before {
  content: "\\f0a06";
}

.mdi-minus::before {
  content: "\\f0374";
}

.mdi-minus-box::before {
  content: "\\f0375";
}

.mdi-minus-box-multiple::before {
  content: "\\f1141";
}

.mdi-minus-box-multiple-outline::before {
  content: "\\f1142";
}

.mdi-minus-box-outline::before {
  content: "\\f06f2";
}

.mdi-minus-circle::before {
  content: "\\f0376";
}

.mdi-minus-circle-multiple::before {
  content: "\\f035a";
}

.mdi-minus-circle-multiple-outline::before {
  content: "\\f0ad3";
}

.mdi-minus-circle-off::before {
  content: "\\f1459";
}

.mdi-minus-circle-off-outline::before {
  content: "\\f145a";
}

.mdi-minus-circle-outline::before {
  content: "\\f0377";
}

.mdi-minus-network::before {
  content: "\\f0378";
}

.mdi-minus-network-outline::before {
  content: "\\f0c9a";
}

.mdi-minus-thick::before {
  content: "\\f1639";
}

.mdi-mirror::before {
  content: "\\f11fd";
}

.mdi-mirror-rectangle::before {
  content: "\\f179f";
}

.mdi-mirror-variant::before {
  content: "\\f17a0";
}

.mdi-mixed-martial-arts::before {
  content: "\\f0d8f";
}

.mdi-mixed-reality::before {
  content: "\\f087f";
}

.mdi-molecule::before {
  content: "\\f0bac";
}

.mdi-molecule-co::before {
  content: "\\f12fe";
}

.mdi-molecule-co2::before {
  content: "\\f07e4";
}

.mdi-monitor::before {
  content: "\\f0379";
}

.mdi-monitor-cellphone::before {
  content: "\\f0989";
}

.mdi-monitor-cellphone-star::before {
  content: "\\f098a";
}

.mdi-monitor-dashboard::before {
  content: "\\f0a07";
}

.mdi-monitor-edit::before {
  content: "\\f12c6";
}

.mdi-monitor-eye::before {
  content: "\\f13b4";
}

.mdi-monitor-lock::before {
  content: "\\f0ddb";
}

.mdi-monitor-multiple::before {
  content: "\\f037a";
}

.mdi-monitor-off::before {
  content: "\\f0d90";
}

.mdi-monitor-screenshot::before {
  content: "\\f0e51";
}

.mdi-monitor-share::before {
  content: "\\f1483";
}

.mdi-monitor-shimmer::before {
  content: "\\f1104";
}

.mdi-monitor-small::before {
  content: "\\f1876";
}

.mdi-monitor-speaker::before {
  content: "\\f0f5f";
}

.mdi-monitor-speaker-off::before {
  content: "\\f0f60";
}

.mdi-monitor-star::before {
  content: "\\f0ddc";
}

.mdi-moon-first-quarter::before {
  content: "\\f0f61";
}

.mdi-moon-full::before {
  content: "\\f0f62";
}

.mdi-moon-last-quarter::before {
  content: "\\f0f63";
}

.mdi-moon-new::before {
  content: "\\f0f64";
}

.mdi-moon-waning-crescent::before {
  content: "\\f0f65";
}

.mdi-moon-waning-gibbous::before {
  content: "\\f0f66";
}

.mdi-moon-waxing-crescent::before {
  content: "\\f0f67";
}

.mdi-moon-waxing-gibbous::before {
  content: "\\f0f68";
}

.mdi-moped::before {
  content: "\\f1086";
}

.mdi-moped-electric::before {
  content: "\\f15b7";
}

.mdi-moped-electric-outline::before {
  content: "\\f15b8";
}

.mdi-moped-outline::before {
  content: "\\f15b9";
}

.mdi-more::before {
  content: "\\f037b";
}

.mdi-mortar-pestle::before {
  content: "\\f1748";
}

.mdi-mortar-pestle-plus::before {
  content: "\\f03f1";
}

.mdi-mosque::before {
  content: "\\f1827";
}

.mdi-mother-heart::before {
  content: "\\f1314";
}

.mdi-mother-nurse::before {
  content: "\\f0d21";
}

.mdi-motion::before {
  content: "\\f15b2";
}

.mdi-motion-outline::before {
  content: "\\f15b3";
}

.mdi-motion-pause::before {
  content: "\\f1590";
}

.mdi-motion-pause-outline::before {
  content: "\\f1592";
}

.mdi-motion-play::before {
  content: "\\f158f";
}

.mdi-motion-play-outline::before {
  content: "\\f1591";
}

.mdi-motion-sensor::before {
  content: "\\f0d91";
}

.mdi-motion-sensor-off::before {
  content: "\\f1435";
}

.mdi-motorbike::before {
  content: "\\f037c";
}

.mdi-motorbike-electric::before {
  content: "\\f15ba";
}

.mdi-mouse::before {
  content: "\\f037d";
}

.mdi-mouse-bluetooth::before {
  content: "\\f098b";
}

.mdi-mouse-move-down::before {
  content: "\\f1550";
}

.mdi-mouse-move-up::before {
  content: "\\f1551";
}

.mdi-mouse-move-vertical::before {
  content: "\\f1552";
}

.mdi-mouse-off::before {
  content: "\\f037e";
}

.mdi-mouse-variant::before {
  content: "\\f037f";
}

.mdi-mouse-variant-off::before {
  content: "\\f0380";
}

.mdi-move-resize::before {
  content: "\\f0655";
}

.mdi-move-resize-variant::before {
  content: "\\f0656";
}

.mdi-movie::before {
  content: "\\f0381";
}

.mdi-movie-check::before {
  content: "\\f16f3";
}

.mdi-movie-check-outline::before {
  content: "\\f16f4";
}

.mdi-movie-cog::before {
  content: "\\f16f5";
}

.mdi-movie-cog-outline::before {
  content: "\\f16f6";
}

.mdi-movie-edit::before {
  content: "\\f1122";
}

.mdi-movie-edit-outline::before {
  content: "\\f1123";
}

.mdi-movie-filter::before {
  content: "\\f1124";
}

.mdi-movie-filter-outline::before {
  content: "\\f1125";
}

.mdi-movie-minus::before {
  content: "\\f16f7";
}

.mdi-movie-minus-outline::before {
  content: "\\f16f8";
}

.mdi-movie-off::before {
  content: "\\f16f9";
}

.mdi-movie-off-outline::before {
  content: "\\f16fa";
}

.mdi-movie-open::before {
  content: "\\f0fce";
}

.mdi-movie-open-check::before {
  content: "\\f16fb";
}

.mdi-movie-open-check-outline::before {
  content: "\\f16fc";
}

.mdi-movie-open-cog::before {
  content: "\\f16fd";
}

.mdi-movie-open-cog-outline::before {
  content: "\\f16fe";
}

.mdi-movie-open-edit::before {
  content: "\\f16ff";
}

.mdi-movie-open-edit-outline::before {
  content: "\\f1700";
}

.mdi-movie-open-minus::before {
  content: "\\f1701";
}

.mdi-movie-open-minus-outline::before {
  content: "\\f1702";
}

.mdi-movie-open-off::before {
  content: "\\f1703";
}

.mdi-movie-open-off-outline::before {
  content: "\\f1704";
}

.mdi-movie-open-outline::before {
  content: "\\f0fcf";
}

.mdi-movie-open-play::before {
  content: "\\f1705";
}

.mdi-movie-open-play-outline::before {
  content: "\\f1706";
}

.mdi-movie-open-plus::before {
  content: "\\f1707";
}

.mdi-movie-open-plus-outline::before {
  content: "\\f1708";
}

.mdi-movie-open-remove::before {
  content: "\\f1709";
}

.mdi-movie-open-remove-outline::before {
  content: "\\f170a";
}

.mdi-movie-open-settings::before {
  content: "\\f170b";
}

.mdi-movie-open-settings-outline::before {
  content: "\\f170c";
}

.mdi-movie-open-star::before {
  content: "\\f170d";
}

.mdi-movie-open-star-outline::before {
  content: "\\f170e";
}

.mdi-movie-outline::before {
  content: "\\f0ddd";
}

.mdi-movie-play::before {
  content: "\\f170f";
}

.mdi-movie-play-outline::before {
  content: "\\f1710";
}

.mdi-movie-plus::before {
  content: "\\f1711";
}

.mdi-movie-plus-outline::before {
  content: "\\f1712";
}

.mdi-movie-remove::before {
  content: "\\f1713";
}

.mdi-movie-remove-outline::before {
  content: "\\f1714";
}

.mdi-movie-roll::before {
  content: "\\f07de";
}

.mdi-movie-search::before {
  content: "\\f11d2";
}

.mdi-movie-search-outline::before {
  content: "\\f11d3";
}

.mdi-movie-settings::before {
  content: "\\f1715";
}

.mdi-movie-settings-outline::before {
  content: "\\f1716";
}

.mdi-movie-star::before {
  content: "\\f1717";
}

.mdi-movie-star-outline::before {
  content: "\\f1718";
}

.mdi-mower::before {
  content: "\\f166f";
}

.mdi-mower-bag::before {
  content: "\\f1670";
}

.mdi-muffin::before {
  content: "\\f098c";
}

.mdi-multicast::before {
  content: "\\f1893";
}

.mdi-multiplication::before {
  content: "\\f0382";
}

.mdi-multiplication-box::before {
  content: "\\f0383";
}

.mdi-mushroom::before {
  content: "\\f07df";
}

.mdi-mushroom-off::before {
  content: "\\f13fa";
}

.mdi-mushroom-off-outline::before {
  content: "\\f13fb";
}

.mdi-mushroom-outline::before {
  content: "\\f07e0";
}

.mdi-music::before {
  content: "\\f075a";
}

.mdi-music-accidental-double-flat::before {
  content: "\\f0f69";
}

.mdi-music-accidental-double-sharp::before {
  content: "\\f0f6a";
}

.mdi-music-accidental-flat::before {
  content: "\\f0f6b";
}

.mdi-music-accidental-natural::before {
  content: "\\f0f6c";
}

.mdi-music-accidental-sharp::before {
  content: "\\f0f6d";
}

.mdi-music-box::before {
  content: "\\f0384";
}

.mdi-music-box-multiple::before {
  content: "\\f0333";
}

.mdi-music-box-multiple-outline::before {
  content: "\\f0f04";
}

.mdi-music-box-outline::before {
  content: "\\f0385";
}

.mdi-music-circle::before {
  content: "\\f0386";
}

.mdi-music-circle-outline::before {
  content: "\\f0ad4";
}

.mdi-music-clef-alto::before {
  content: "\\f0f6e";
}

.mdi-music-clef-bass::before {
  content: "\\f0f6f";
}

.mdi-music-clef-treble::before {
  content: "\\f0f70";
}

.mdi-music-note::before {
  content: "\\f0387";
}

.mdi-music-note-bluetooth::before {
  content: "\\f05fe";
}

.mdi-music-note-bluetooth-off::before {
  content: "\\f05ff";
}

.mdi-music-note-eighth::before {
  content: "\\f0388";
}

.mdi-music-note-eighth-dotted::before {
  content: "\\f0f71";
}

.mdi-music-note-half::before {
  content: "\\f0389";
}

.mdi-music-note-half-dotted::before {
  content: "\\f0f72";
}

.mdi-music-note-off::before {
  content: "\\f038a";
}

.mdi-music-note-off-outline::before {
  content: "\\f0f73";
}

.mdi-music-note-outline::before {
  content: "\\f0f74";
}

.mdi-music-note-plus::before {
  content: "\\f0dde";
}

.mdi-music-note-quarter::before {
  content: "\\f038b";
}

.mdi-music-note-quarter-dotted::before {
  content: "\\f0f75";
}

.mdi-music-note-sixteenth::before {
  content: "\\f038c";
}

.mdi-music-note-sixteenth-dotted::before {
  content: "\\f0f76";
}

.mdi-music-note-whole::before {
  content: "\\f038d";
}

.mdi-music-note-whole-dotted::before {
  content: "\\f0f77";
}

.mdi-music-off::before {
  content: "\\f075b";
}

.mdi-music-rest-eighth::before {
  content: "\\f0f78";
}

.mdi-music-rest-half::before {
  content: "\\f0f79";
}

.mdi-music-rest-quarter::before {
  content: "\\f0f7a";
}

.mdi-music-rest-sixteenth::before {
  content: "\\f0f7b";
}

.mdi-music-rest-whole::before {
  content: "\\f0f7c";
}

.mdi-mustache::before {
  content: "\\f15de";
}

.mdi-nail::before {
  content: "\\f0ddf";
}

.mdi-nas::before {
  content: "\\f08f3";
}

.mdi-nativescript::before {
  content: "\\f0880";
}

.mdi-nature::before {
  content: "\\f038e";
}

.mdi-nature-people::before {
  content: "\\f038f";
}

.mdi-navigation::before {
  content: "\\f0390";
}

.mdi-navigation-outline::before {
  content: "\\f1607";
}

.mdi-navigation-variant::before {
  content: "\\f18f0";
}

.mdi-navigation-variant-outline::before {
  content: "\\f18f1";
}

.mdi-near-me::before {
  content: "\\f05cd";
}

.mdi-necklace::before {
  content: "\\f0f0b";
}

.mdi-needle::before {
  content: "\\f0391";
}

.mdi-netflix::before {
  content: "\\f0746";
}

.mdi-network::before {
  content: "\\f06f3";
}

.mdi-network-off::before {
  content: "\\f0c9b";
}

.mdi-network-off-outline::before {
  content: "\\f0c9c";
}

.mdi-network-outline::before {
  content: "\\f0c9d";
}

.mdi-network-strength-1::before {
  content: "\\f08f4";
}

.mdi-network-strength-1-alert::before {
  content: "\\f08f5";
}

.mdi-network-strength-2::before {
  content: "\\f08f6";
}

.mdi-network-strength-2-alert::before {
  content: "\\f08f7";
}

.mdi-network-strength-3::before {
  content: "\\f08f8";
}

.mdi-network-strength-3-alert::before {
  content: "\\f08f9";
}

.mdi-network-strength-4::before {
  content: "\\f08fa";
}

.mdi-network-strength-4-alert::before {
  content: "\\f08fb";
}

.mdi-network-strength-4-cog::before {
  content: "\\f191a";
}

.mdi-network-strength-off::before {
  content: "\\f08fc";
}

.mdi-network-strength-off-outline::before {
  content: "\\f08fd";
}

.mdi-network-strength-outline::before {
  content: "\\f08fe";
}

.mdi-new-box::before {
  content: "\\f0394";
}

.mdi-newspaper::before {
  content: "\\f0395";
}

.mdi-newspaper-check::before {
  content: "\\f1943";
}

.mdi-newspaper-minus::before {
  content: "\\f0f0c";
}

.mdi-newspaper-plus::before {
  content: "\\f0f0d";
}

.mdi-newspaper-remove::before {
  content: "\\f1944";
}

.mdi-newspaper-variant::before {
  content: "\\f1001";
}

.mdi-newspaper-variant-multiple::before {
  content: "\\f1002";
}

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\f1003";
}

.mdi-newspaper-variant-outline::before {
  content: "\\f1004";
}

.mdi-nfc::before {
  content: "\\f0396";
}

.mdi-nfc-search-variant::before {
  content: "\\f0e53";
}

.mdi-nfc-tap::before {
  content: "\\f0397";
}

.mdi-nfc-variant::before {
  content: "\\f0398";
}

.mdi-nfc-variant-off::before {
  content: "\\f0e54";
}

.mdi-ninja::before {
  content: "\\f0774";
}

.mdi-nintendo-game-boy::before {
  content: "\\f1393";
}

.mdi-nintendo-switch::before {
  content: "\\f07e1";
}

.mdi-nintendo-wii::before {
  content: "\\f05ab";
}

.mdi-nintendo-wiiu::before {
  content: "\\f072d";
}

.mdi-nix::before {
  content: "\\f1105";
}

.mdi-nodejs::before {
  content: "\\f0399";
}

.mdi-noodles::before {
  content: "\\f117e";
}

.mdi-not-equal::before {
  content: "\\f098d";
}

.mdi-not-equal-variant::before {
  content: "\\f098e";
}

.mdi-note::before {
  content: "\\f039a";
}

.mdi-note-alert::before {
  content: "\\f177d";
}

.mdi-note-alert-outline::before {
  content: "\\f177e";
}

.mdi-note-check::before {
  content: "\\f177f";
}

.mdi-note-check-outline::before {
  content: "\\f1780";
}

.mdi-note-edit::before {
  content: "\\f1781";
}

.mdi-note-edit-outline::before {
  content: "\\f1782";
}

.mdi-note-minus::before {
  content: "\\f164f";
}

.mdi-note-minus-outline::before {
  content: "\\f1650";
}

.mdi-note-multiple::before {
  content: "\\f06b8";
}

.mdi-note-multiple-outline::before {
  content: "\\f06b9";
}

.mdi-note-off::before {
  content: "\\f1783";
}

.mdi-note-off-outline::before {
  content: "\\f1784";
}

.mdi-note-outline::before {
  content: "\\f039b";
}

.mdi-note-plus::before {
  content: "\\f039c";
}

.mdi-note-plus-outline::before {
  content: "\\f039d";
}

.mdi-note-remove::before {
  content: "\\f1651";
}

.mdi-note-remove-outline::before {
  content: "\\f1652";
}

.mdi-note-search::before {
  content: "\\f1653";
}

.mdi-note-search-outline::before {
  content: "\\f1654";
}

.mdi-note-text::before {
  content: "\\f039e";
}

.mdi-note-text-outline::before {
  content: "\\f11d7";
}

.mdi-notebook::before {
  content: "\\f082e";
}

.mdi-notebook-check::before {
  content: "\\f14f5";
}

.mdi-notebook-check-outline::before {
  content: "\\f14f6";
}

.mdi-notebook-edit::before {
  content: "\\f14e7";
}

.mdi-notebook-edit-outline::before {
  content: "\\f14e9";
}

.mdi-notebook-minus::before {
  content: "\\f1610";
}

.mdi-notebook-minus-outline::before {
  content: "\\f1611";
}

.mdi-notebook-multiple::before {
  content: "\\f0e55";
}

.mdi-notebook-outline::before {
  content: "\\f0ebf";
}

.mdi-notebook-plus::before {
  content: "\\f1612";
}

.mdi-notebook-plus-outline::before {
  content: "\\f1613";
}

.mdi-notebook-remove::before {
  content: "\\f1614";
}

.mdi-notebook-remove-outline::before {
  content: "\\f1615";
}

.mdi-notification-clear-all::before {
  content: "\\f039f";
}

.mdi-npm::before {
  content: "\\f06f7";
}

.mdi-nuke::before {
  content: "\\f06a4";
}

.mdi-null::before {
  content: "\\f07e2";
}

.mdi-numeric::before {
  content: "\\f03a0";
}

.mdi-numeric-0::before {
  content: "\\f0b39";
}

.mdi-numeric-0-box::before {
  content: "\\f03a1";
}

.mdi-numeric-0-box-multiple::before {
  content: "\\f0f0e";
}

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\f03a2";
}

.mdi-numeric-0-box-outline::before {
  content: "\\f03a3";
}

.mdi-numeric-0-circle::before {
  content: "\\f0c9e";
}

.mdi-numeric-0-circle-outline::before {
  content: "\\f0c9f";
}

.mdi-numeric-1::before {
  content: "\\f0b3a";
}

.mdi-numeric-1-box::before {
  content: "\\f03a4";
}

.mdi-numeric-1-box-multiple::before {
  content: "\\f0f0f";
}

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\f03a5";
}

.mdi-numeric-1-box-outline::before {
  content: "\\f03a6";
}

.mdi-numeric-1-circle::before {
  content: "\\f0ca0";
}

.mdi-numeric-1-circle-outline::before {
  content: "\\f0ca1";
}

.mdi-numeric-10::before {
  content: "\\f0fe9";
}

.mdi-numeric-10-box::before {
  content: "\\f0f7d";
}

.mdi-numeric-10-box-multiple::before {
  content: "\\f0fea";
}

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\f0feb";
}

.mdi-numeric-10-box-outline::before {
  content: "\\f0f7e";
}

.mdi-numeric-10-circle::before {
  content: "\\f0fec";
}

.mdi-numeric-10-circle-outline::before {
  content: "\\f0fed";
}

.mdi-numeric-2::before {
  content: "\\f0b3b";
}

.mdi-numeric-2-box::before {
  content: "\\f03a7";
}

.mdi-numeric-2-box-multiple::before {
  content: "\\f0f10";
}

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\f03a8";
}

.mdi-numeric-2-box-outline::before {
  content: "\\f03a9";
}

.mdi-numeric-2-circle::before {
  content: "\\f0ca2";
}

.mdi-numeric-2-circle-outline::before {
  content: "\\f0ca3";
}

.mdi-numeric-3::before {
  content: "\\f0b3c";
}

.mdi-numeric-3-box::before {
  content: "\\f03aa";
}

.mdi-numeric-3-box-multiple::before {
  content: "\\f0f11";
}

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\f03ab";
}

.mdi-numeric-3-box-outline::before {
  content: "\\f03ac";
}

.mdi-numeric-3-circle::before {
  content: "\\f0ca4";
}

.mdi-numeric-3-circle-outline::before {
  content: "\\f0ca5";
}

.mdi-numeric-4::before {
  content: "\\f0b3d";
}

.mdi-numeric-4-box::before {
  content: "\\f03ad";
}

.mdi-numeric-4-box-multiple::before {
  content: "\\f0f12";
}

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\f03b2";
}

.mdi-numeric-4-box-outline::before {
  content: "\\f03ae";
}

.mdi-numeric-4-circle::before {
  content: "\\f0ca6";
}

.mdi-numeric-4-circle-outline::before {
  content: "\\f0ca7";
}

.mdi-numeric-5::before {
  content: "\\f0b3e";
}

.mdi-numeric-5-box::before {
  content: "\\f03b1";
}

.mdi-numeric-5-box-multiple::before {
  content: "\\f0f13";
}

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\f03af";
}

.mdi-numeric-5-box-outline::before {
  content: "\\f03b0";
}

.mdi-numeric-5-circle::before {
  content: "\\f0ca8";
}

.mdi-numeric-5-circle-outline::before {
  content: "\\f0ca9";
}

.mdi-numeric-6::before {
  content: "\\f0b3f";
}

.mdi-numeric-6-box::before {
  content: "\\f03b3";
}

.mdi-numeric-6-box-multiple::before {
  content: "\\f0f14";
}

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\f03b4";
}

.mdi-numeric-6-box-outline::before {
  content: "\\f03b5";
}

.mdi-numeric-6-circle::before {
  content: "\\f0caa";
}

.mdi-numeric-6-circle-outline::before {
  content: "\\f0cab";
}

.mdi-numeric-7::before {
  content: "\\f0b40";
}

.mdi-numeric-7-box::before {
  content: "\\f03b6";
}

.mdi-numeric-7-box-multiple::before {
  content: "\\f0f15";
}

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\f03b7";
}

.mdi-numeric-7-box-outline::before {
  content: "\\f03b8";
}

.mdi-numeric-7-circle::before {
  content: "\\f0cac";
}

.mdi-numeric-7-circle-outline::before {
  content: "\\f0cad";
}

.mdi-numeric-8::before {
  content: "\\f0b41";
}

.mdi-numeric-8-box::before {
  content: "\\f03b9";
}

.mdi-numeric-8-box-multiple::before {
  content: "\\f0f16";
}

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\f03ba";
}

.mdi-numeric-8-box-outline::before {
  content: "\\f03bb";
}

.mdi-numeric-8-circle::before {
  content: "\\f0cae";
}

.mdi-numeric-8-circle-outline::before {
  content: "\\f0caf";
}

.mdi-numeric-9::before {
  content: "\\f0b42";
}

.mdi-numeric-9-box::before {
  content: "\\f03bc";
}

.mdi-numeric-9-box-multiple::before {
  content: "\\f0f17";
}

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\f03bd";
}

.mdi-numeric-9-box-outline::before {
  content: "\\f03be";
}

.mdi-numeric-9-circle::before {
  content: "\\f0cb0";
}

.mdi-numeric-9-circle-outline::before {
  content: "\\f0cb1";
}

.mdi-numeric-9-plus::before {
  content: "\\f0fee";
}

.mdi-numeric-9-plus-box::before {
  content: "\\f03bf";
}

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\f0f18";
}

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\f03c0";
}

.mdi-numeric-9-plus-box-outline::before {
  content: "\\f03c1";
}

.mdi-numeric-9-plus-circle::before {
  content: "\\f0cb2";
}

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\f0cb3";
}

.mdi-numeric-negative-1::before {
  content: "\\f1052";
}

.mdi-numeric-positive-1::before {
  content: "\\f15cb";
}

.mdi-nut::before {
  content: "\\f06f8";
}

.mdi-nutrition::before {
  content: "\\f03c2";
}

.mdi-nuxt::before {
  content: "\\f1106";
}

.mdi-oar::before {
  content: "\\f067c";
}

.mdi-ocarina::before {
  content: "\\f0de0";
}

.mdi-oci::before {
  content: "\\f12e9";
}

.mdi-ocr::before {
  content: "\\f113a";
}

.mdi-octagon::before {
  content: "\\f03c3";
}

.mdi-octagon-outline::before {
  content: "\\f03c4";
}

.mdi-octagram::before {
  content: "\\f06f9";
}

.mdi-octagram-outline::before {
  content: "\\f0775";
}

.mdi-octahedron::before {
  content: "\\f1950";
}

.mdi-octahedron-off::before {
  content: "\\f1951";
}

.mdi-odnoklassniki::before {
  content: "\\f03c5";
}

.mdi-offer::before {
  content: "\\f121b";
}

.mdi-office-building::before {
  content: "\\f0991";
}

.mdi-office-building-cog::before {
  content: "\\f1949";
}

.mdi-office-building-cog-outline::before {
  content: "\\f194a";
}

.mdi-office-building-marker::before {
  content: "\\f1520";
}

.mdi-office-building-marker-outline::before {
  content: "\\f1521";
}

.mdi-office-building-outline::before {
  content: "\\f151f";
}

.mdi-oil::before {
  content: "\\f03c7";
}

.mdi-oil-lamp::before {
  content: "\\f0f19";
}

.mdi-oil-level::before {
  content: "\\f1053";
}

.mdi-oil-temperature::before {
  content: "\\f0ff8";
}

.mdi-om::before {
  content: "\\f0973";
}

.mdi-omega::before {
  content: "\\f03c9";
}

.mdi-one-up::before {
  content: "\\f0bad";
}

.mdi-onepassword::before {
  content: "\\f0881";
}

.mdi-opacity::before {
  content: "\\f05cc";
}

.mdi-open-in-app::before {
  content: "\\f03cb";
}

.mdi-open-in-new::before {
  content: "\\f03cc";
}

.mdi-open-source-initiative::before {
  content: "\\f0bae";
}

.mdi-openid::before {
  content: "\\f03cd";
}

.mdi-opera::before {
  content: "\\f03ce";
}

.mdi-orbit::before {
  content: "\\f0018";
}

.mdi-orbit-variant::before {
  content: "\\f15db";
}

.mdi-order-alphabetical-ascending::before {
  content: "\\f020d";
}

.mdi-order-alphabetical-descending::before {
  content: "\\f0d07";
}

.mdi-order-bool-ascending::before {
  content: "\\f02be";
}

.mdi-order-bool-ascending-variant::before {
  content: "\\f098f";
}

.mdi-order-bool-descending::before {
  content: "\\f1384";
}

.mdi-order-bool-descending-variant::before {
  content: "\\f0990";
}

.mdi-order-numeric-ascending::before {
  content: "\\f0545";
}

.mdi-order-numeric-descending::before {
  content: "\\f0546";
}

.mdi-origin::before {
  content: "\\f0b43";
}

.mdi-ornament::before {
  content: "\\f03cf";
}

.mdi-ornament-variant::before {
  content: "\\f03d0";
}

.mdi-outdoor-lamp::before {
  content: "\\f1054";
}

.mdi-overscan::before {
  content: "\\f1005";
}

.mdi-owl::before {
  content: "\\f03d2";
}

.mdi-pac-man::before {
  content: "\\f0baf";
}

.mdi-package::before {
  content: "\\f03d3";
}

.mdi-package-down::before {
  content: "\\f03d4";
}

.mdi-package-up::before {
  content: "\\f03d5";
}

.mdi-package-variant::before {
  content: "\\f03d6";
}

.mdi-package-variant-closed::before {
  content: "\\f03d7";
}

.mdi-page-first::before {
  content: "\\f0600";
}

.mdi-page-last::before {
  content: "\\f0601";
}

.mdi-page-layout-body::before {
  content: "\\f06fa";
}

.mdi-page-layout-footer::before {
  content: "\\f06fb";
}

.mdi-page-layout-header::before {
  content: "\\f06fc";
}

.mdi-page-layout-header-footer::before {
  content: "\\f0f7f";
}

.mdi-page-layout-sidebar-left::before {
  content: "\\f06fd";
}

.mdi-page-layout-sidebar-right::before {
  content: "\\f06fe";
}

.mdi-page-next::before {
  content: "\\f0bb0";
}

.mdi-page-next-outline::before {
  content: "\\f0bb1";
}

.mdi-page-previous::before {
  content: "\\f0bb2";
}

.mdi-page-previous-outline::before {
  content: "\\f0bb3";
}

.mdi-pail::before {
  content: "\\f1417";
}

.mdi-pail-minus::before {
  content: "\\f1437";
}

.mdi-pail-minus-outline::before {
  content: "\\f143c";
}

.mdi-pail-off::before {
  content: "\\f1439";
}

.mdi-pail-off-outline::before {
  content: "\\f143e";
}

.mdi-pail-outline::before {
  content: "\\f143a";
}

.mdi-pail-plus::before {
  content: "\\f1436";
}

.mdi-pail-plus-outline::before {
  content: "\\f143b";
}

.mdi-pail-remove::before {
  content: "\\f1438";
}

.mdi-pail-remove-outline::before {
  content: "\\f143d";
}

.mdi-palette::before {
  content: "\\f03d8";
}

.mdi-palette-advanced::before {
  content: "\\f03d9";
}

.mdi-palette-outline::before {
  content: "\\f0e0c";
}

.mdi-palette-swatch::before {
  content: "\\f08b5";
}

.mdi-palette-swatch-outline::before {
  content: "\\f135c";
}

.mdi-palette-swatch-variant::before {
  content: "\\f195a";
}

.mdi-palm-tree::before {
  content: "\\f1055";
}

.mdi-pan::before {
  content: "\\f0bb4";
}

.mdi-pan-bottom-left::before {
  content: "\\f0bb5";
}

.mdi-pan-bottom-right::before {
  content: "\\f0bb6";
}

.mdi-pan-down::before {
  content: "\\f0bb7";
}

.mdi-pan-horizontal::before {
  content: "\\f0bb8";
}

.mdi-pan-left::before {
  content: "\\f0bb9";
}

.mdi-pan-right::before {
  content: "\\f0bba";
}

.mdi-pan-top-left::before {
  content: "\\f0bbb";
}

.mdi-pan-top-right::before {
  content: "\\f0bbc";
}

.mdi-pan-up::before {
  content: "\\f0bbd";
}

.mdi-pan-vertical::before {
  content: "\\f0bbe";
}

.mdi-panda::before {
  content: "\\f03da";
}

.mdi-pandora::before {
  content: "\\f03db";
}

.mdi-panorama::before {
  content: "\\f03dc";
}

.mdi-panorama-fisheye::before {
  content: "\\f03dd";
}

.mdi-panorama-horizontal::before {
  content: "\\f1928";
}

.mdi-panorama-horizontal-outline::before {
  content: "\\f03de";
}

.mdi-panorama-outline::before {
  content: "\\f198c";
}

.mdi-panorama-sphere::before {
  content: "\\f198d";
}

.mdi-panorama-sphere-outline::before {
  content: "\\f198e";
}

.mdi-panorama-variant::before {
  content: "\\f198f";
}

.mdi-panorama-variant-outline::before {
  content: "\\f1990";
}

.mdi-panorama-vertical::before {
  content: "\\f1929";
}

.mdi-panorama-vertical-outline::before {
  content: "\\f03df";
}

.mdi-panorama-wide-angle::before {
  content: "\\f195f";
}

.mdi-panorama-wide-angle-outline::before {
  content: "\\f03e0";
}

.mdi-paper-cut-vertical::before {
  content: "\\f03e1";
}

.mdi-paper-roll::before {
  content: "\\f1157";
}

.mdi-paper-roll-outline::before {
  content: "\\f1158";
}

.mdi-paperclip::before {
  content: "\\f03e2";
}

.mdi-parachute::before {
  content: "\\f0cb4";
}

.mdi-parachute-outline::before {
  content: "\\f0cb5";
}

.mdi-paragliding::before {
  content: "\\f1745";
}

.mdi-parking::before {
  content: "\\f03e3";
}

.mdi-party-popper::before {
  content: "\\f1056";
}

.mdi-passport::before {
  content: "\\f07e3";
}

.mdi-passport-biometric::before {
  content: "\\f0de1";
}

.mdi-pasta::before {
  content: "\\f1160";
}

.mdi-patio-heater::before {
  content: "\\f0f80";
}

.mdi-patreon::before {
  content: "\\f0882";
}

.mdi-pause::before {
  content: "\\f03e4";
}

.mdi-pause-circle::before {
  content: "\\f03e5";
}

.mdi-pause-circle-outline::before {
  content: "\\f03e6";
}

.mdi-pause-octagon::before {
  content: "\\f03e7";
}

.mdi-pause-octagon-outline::before {
  content: "\\f03e8";
}

.mdi-paw::before {
  content: "\\f03e9";
}

.mdi-paw-off::before {
  content: "\\f0657";
}

.mdi-paw-off-outline::before {
  content: "\\f1676";
}

.mdi-paw-outline::before {
  content: "\\f1675";
}

.mdi-peace::before {
  content: "\\f0884";
}

.mdi-peanut::before {
  content: "\\f0ffc";
}

.mdi-peanut-off::before {
  content: "\\f0ffd";
}

.mdi-peanut-off-outline::before {
  content: "\\f0fff";
}

.mdi-peanut-outline::before {
  content: "\\f0ffe";
}

.mdi-pen::before {
  content: "\\f03ea";
}

.mdi-pen-lock::before {
  content: "\\f0de2";
}

.mdi-pen-minus::before {
  content: "\\f0de3";
}

.mdi-pen-off::before {
  content: "\\f0de4";
}

.mdi-pen-plus::before {
  content: "\\f0de5";
}

.mdi-pen-remove::before {
  content: "\\f0de6";
}

.mdi-pencil::before {
  content: "\\f03eb";
}

.mdi-pencil-box::before {
  content: "\\f03ec";
}

.mdi-pencil-box-multiple::before {
  content: "\\f1144";
}

.mdi-pencil-box-multiple-outline::before {
  content: "\\f1145";
}

.mdi-pencil-box-outline::before {
  content: "\\f03ed";
}

.mdi-pencil-circle::before {
  content: "\\f06ff";
}

.mdi-pencil-circle-outline::before {
  content: "\\f0776";
}

.mdi-pencil-lock::before {
  content: "\\f03ee";
}

.mdi-pencil-lock-outline::before {
  content: "\\f0de7";
}

.mdi-pencil-minus::before {
  content: "\\f0de8";
}

.mdi-pencil-minus-outline::before {
  content: "\\f0de9";
}

.mdi-pencil-off::before {
  content: "\\f03ef";
}

.mdi-pencil-off-outline::before {
  content: "\\f0dea";
}

.mdi-pencil-outline::before {
  content: "\\f0cb6";
}

.mdi-pencil-plus::before {
  content: "\\f0deb";
}

.mdi-pencil-plus-outline::before {
  content: "\\f0dec";
}

.mdi-pencil-remove::before {
  content: "\\f0ded";
}

.mdi-pencil-remove-outline::before {
  content: "\\f0dee";
}

.mdi-pencil-ruler::before {
  content: "\\f1353";
}

.mdi-penguin::before {
  content: "\\f0ec0";
}

.mdi-pentagon::before {
  content: "\\f0701";
}

.mdi-pentagon-outline::before {
  content: "\\f0700";
}

.mdi-pentagram::before {
  content: "\\f1667";
}

.mdi-percent::before {
  content: "\\f03f0";
}

.mdi-percent-outline::before {
  content: "\\f1278";
}

.mdi-periodic-table::before {
  content: "\\f08b6";
}

.mdi-perspective-less::before {
  content: "\\f0d23";
}

.mdi-perspective-more::before {
  content: "\\f0d24";
}

.mdi-ph::before {
  content: "\\f17c5";
}

.mdi-phone::before {
  content: "\\f03f2";
}

.mdi-phone-alert::before {
  content: "\\f0f1a";
}

.mdi-phone-alert-outline::before {
  content: "\\f118e";
}

.mdi-phone-bluetooth::before {
  content: "\\f03f3";
}

.mdi-phone-bluetooth-outline::before {
  content: "\\f118f";
}

.mdi-phone-cancel::before {
  content: "\\f10bc";
}

.mdi-phone-cancel-outline::before {
  content: "\\f1190";
}

.mdi-phone-check::before {
  content: "\\f11a9";
}

.mdi-phone-check-outline::before {
  content: "\\f11aa";
}

.mdi-phone-classic::before {
  content: "\\f0602";
}

.mdi-phone-classic-off::before {
  content: "\\f1279";
}

.mdi-phone-dial::before {
  content: "\\f1559";
}

.mdi-phone-dial-outline::before {
  content: "\\f155a";
}

.mdi-phone-forward::before {
  content: "\\f03f4";
}

.mdi-phone-forward-outline::before {
  content: "\\f1191";
}

.mdi-phone-hangup::before {
  content: "\\f03f5";
}

.mdi-phone-hangup-outline::before {
  content: "\\f1192";
}

.mdi-phone-in-talk::before {
  content: "\\f03f6";
}

.mdi-phone-in-talk-outline::before {
  content: "\\f1182";
}

.mdi-phone-incoming::before {
  content: "\\f03f7";
}

.mdi-phone-incoming-outline::before {
  content: "\\f1193";
}

.mdi-phone-lock::before {
  content: "\\f03f8";
}

.mdi-phone-lock-outline::before {
  content: "\\f1194";
}

.mdi-phone-log::before {
  content: "\\f03f9";
}

.mdi-phone-log-outline::before {
  content: "\\f1195";
}

.mdi-phone-message::before {
  content: "\\f1196";
}

.mdi-phone-message-outline::before {
  content: "\\f1197";
}

.mdi-phone-minus::before {
  content: "\\f0658";
}

.mdi-phone-minus-outline::before {
  content: "\\f1198";
}

.mdi-phone-missed::before {
  content: "\\f03fa";
}

.mdi-phone-missed-outline::before {
  content: "\\f11a5";
}

.mdi-phone-off::before {
  content: "\\f0def";
}

.mdi-phone-off-outline::before {
  content: "\\f11a6";
}

.mdi-phone-outgoing::before {
  content: "\\f03fb";
}

.mdi-phone-outgoing-outline::before {
  content: "\\f1199";
}

.mdi-phone-outline::before {
  content: "\\f0df0";
}

.mdi-phone-paused::before {
  content: "\\f03fc";
}

.mdi-phone-paused-outline::before {
  content: "\\f119a";
}

.mdi-phone-plus::before {
  content: "\\f0659";
}

.mdi-phone-plus-outline::before {
  content: "\\f119b";
}

.mdi-phone-refresh::before {
  content: "\\f1993";
}

.mdi-phone-refresh-outline::before {
  content: "\\f1994";
}

.mdi-phone-remove::before {
  content: "\\f152f";
}

.mdi-phone-remove-outline::before {
  content: "\\f1530";
}

.mdi-phone-return::before {
  content: "\\f082f";
}

.mdi-phone-return-outline::before {
  content: "\\f119c";
}

.mdi-phone-ring::before {
  content: "\\f11ab";
}

.mdi-phone-ring-outline::before {
  content: "\\f11ac";
}

.mdi-phone-rotate-landscape::before {
  content: "\\f0885";
}

.mdi-phone-rotate-portrait::before {
  content: "\\f0886";
}

.mdi-phone-settings::before {
  content: "\\f03fd";
}

.mdi-phone-settings-outline::before {
  content: "\\f119d";
}

.mdi-phone-sync::before {
  content: "\\f1995";
}

.mdi-phone-sync-outline::before {
  content: "\\f1996";
}

.mdi-phone-voip::before {
  content: "\\f03fe";
}

.mdi-pi::before {
  content: "\\f03ff";
}

.mdi-pi-box::before {
  content: "\\f0400";
}

.mdi-pi-hole::before {
  content: "\\f0df1";
}

.mdi-piano::before {
  content: "\\f067d";
}

.mdi-piano-off::before {
  content: "\\f0698";
}

.mdi-pickaxe::before {
  content: "\\f08b7";
}

.mdi-picture-in-picture-bottom-right::before {
  content: "\\f0e57";
}

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\f0e58";
}

.mdi-picture-in-picture-top-right::before {
  content: "\\f0e59";
}

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\f0e5a";
}

.mdi-pier::before {
  content: "\\f0887";
}

.mdi-pier-crane::before {
  content: "\\f0888";
}

.mdi-pig::before {
  content: "\\f0401";
}

.mdi-pig-variant::before {
  content: "\\f1006";
}

.mdi-pig-variant-outline::before {
  content: "\\f1678";
}

.mdi-piggy-bank::before {
  content: "\\f1007";
}

.mdi-piggy-bank-outline::before {
  content: "\\f1679";
}

.mdi-pill::before {
  content: "\\f0402";
}

.mdi-pillar::before {
  content: "\\f0702";
}

.mdi-pin::before {
  content: "\\f0403";
}

.mdi-pin-off::before {
  content: "\\f0404";
}

.mdi-pin-off-outline::before {
  content: "\\f0930";
}

.mdi-pin-outline::before {
  content: "\\f0931";
}

.mdi-pine-tree::before {
  content: "\\f0405";
}

.mdi-pine-tree-box::before {
  content: "\\f0406";
}

.mdi-pine-tree-fire::before {
  content: "\\f141a";
}

.mdi-pinterest::before {
  content: "\\f0407";
}

.mdi-pinwheel::before {
  content: "\\f0ad5";
}

.mdi-pinwheel-outline::before {
  content: "\\f0ad6";
}

.mdi-pipe::before {
  content: "\\f07e5";
}

.mdi-pipe-disconnected::before {
  content: "\\f07e6";
}

.mdi-pipe-leak::before {
  content: "\\f0889";
}

.mdi-pipe-valve::before {
  content: "\\f184d";
}

.mdi-pipe-wrench::before {
  content: "\\f1354";
}

.mdi-pirate::before {
  content: "\\f0a08";
}

.mdi-pistol::before {
  content: "\\f0703";
}

.mdi-piston::before {
  content: "\\f088a";
}

.mdi-pitchfork::before {
  content: "\\f1553";
}

.mdi-pizza::before {
  content: "\\f0409";
}

.mdi-play::before {
  content: "\\f040a";
}

.mdi-play-box::before {
  content: "\\f127a";
}

.mdi-play-box-multiple::before {
  content: "\\f0d19";
}

.mdi-play-box-multiple-outline::before {
  content: "\\f13e6";
}

.mdi-play-box-outline::before {
  content: "\\f040b";
}

.mdi-play-circle::before {
  content: "\\f040c";
}

.mdi-play-circle-outline::before {
  content: "\\f040d";
}

.mdi-play-network::before {
  content: "\\f088b";
}

.mdi-play-network-outline::before {
  content: "\\f0cb7";
}

.mdi-play-outline::before {
  content: "\\f0f1b";
}

.mdi-play-pause::before {
  content: "\\f040e";
}

.mdi-play-protected-content::before {
  content: "\\f040f";
}

.mdi-play-speed::before {
  content: "\\f08ff";
}

.mdi-playlist-check::before {
  content: "\\f05c7";
}

.mdi-playlist-edit::before {
  content: "\\f0900";
}

.mdi-playlist-minus::before {
  content: "\\f0410";
}

.mdi-playlist-music::before {
  content: "\\f0cb8";
}

.mdi-playlist-music-outline::before {
  content: "\\f0cb9";
}

.mdi-playlist-play::before {
  content: "\\f0411";
}

.mdi-playlist-plus::before {
  content: "\\f0412";
}

.mdi-playlist-remove::before {
  content: "\\f0413";
}

.mdi-playlist-star::before {
  content: "\\f0df2";
}

.mdi-plex::before {
  content: "\\f06ba";
}

.mdi-pliers::before {
  content: "\\f19a4";
}

.mdi-plus::before {
  content: "\\f0415";
}

.mdi-plus-box::before {
  content: "\\f0416";
}

.mdi-plus-box-multiple::before {
  content: "\\f0334";
}

.mdi-plus-box-multiple-outline::before {
  content: "\\f1143";
}

.mdi-plus-box-outline::before {
  content: "\\f0704";
}

.mdi-plus-circle::before {
  content: "\\f0417";
}

.mdi-plus-circle-multiple::before {
  content: "\\f034c";
}

.mdi-plus-circle-multiple-outline::before {
  content: "\\f0418";
}

.mdi-plus-circle-outline::before {
  content: "\\f0419";
}

.mdi-plus-minus::before {
  content: "\\f0992";
}

.mdi-plus-minus-box::before {
  content: "\\f0993";
}

.mdi-plus-minus-variant::before {
  content: "\\f14c9";
}

.mdi-plus-network::before {
  content: "\\f041a";
}

.mdi-plus-network-outline::before {
  content: "\\f0cba";
}

.mdi-plus-outline::before {
  content: "\\f0705";
}

.mdi-plus-thick::before {
  content: "\\f11ec";
}

.mdi-podcast::before {
  content: "\\f0994";
}

.mdi-podium::before {
  content: "\\f0d25";
}

.mdi-podium-bronze::before {
  content: "\\f0d26";
}

.mdi-podium-gold::before {
  content: "\\f0d27";
}

.mdi-podium-silver::before {
  content: "\\f0d28";
}

.mdi-point-of-sale::before {
  content: "\\f0d92";
}

.mdi-pokeball::before {
  content: "\\f041d";
}

.mdi-pokemon-go::before {
  content: "\\f0a09";
}

.mdi-poker-chip::before {
  content: "\\f0830";
}

.mdi-polaroid::before {
  content: "\\f041e";
}

.mdi-police-badge::before {
  content: "\\f1167";
}

.mdi-police-badge-outline::before {
  content: "\\f1168";
}

.mdi-police-station::before {
  content: "\\f1839";
}

.mdi-poll::before {
  content: "\\f041f";
}

.mdi-polo::before {
  content: "\\f14c3";
}

.mdi-polymer::before {
  content: "\\f0421";
}

.mdi-pool::before {
  content: "\\f0606";
}

.mdi-popcorn::before {
  content: "\\f0422";
}

.mdi-post::before {
  content: "\\f1008";
}

.mdi-post-outline::before {
  content: "\\f1009";
}

.mdi-postage-stamp::before {
  content: "\\f0cbb";
}

.mdi-pot::before {
  content: "\\f02e5";
}

.mdi-pot-mix::before {
  content: "\\f065b";
}

.mdi-pot-mix-outline::before {
  content: "\\f0677";
}

.mdi-pot-outline::before {
  content: "\\f02ff";
}

.mdi-pot-steam::before {
  content: "\\f065a";
}

.mdi-pot-steam-outline::before {
  content: "\\f0326";
}

.mdi-pound::before {
  content: "\\f0423";
}

.mdi-pound-box::before {
  content: "\\f0424";
}

.mdi-pound-box-outline::before {
  content: "\\f117f";
}

.mdi-power::before {
  content: "\\f0425";
}

.mdi-power-cycle::before {
  content: "\\f0901";
}

.mdi-power-off::before {
  content: "\\f0902";
}

.mdi-power-on::before {
  content: "\\f0903";
}

.mdi-power-plug::before {
  content: "\\f06a5";
}

.mdi-power-plug-off::before {
  content: "\\f06a6";
}

.mdi-power-plug-off-outline::before {
  content: "\\f1424";
}

.mdi-power-plug-outline::before {
  content: "\\f1425";
}

.mdi-power-settings::before {
  content: "\\f0426";
}

.mdi-power-sleep::before {
  content: "\\f0904";
}

.mdi-power-socket::before {
  content: "\\f0427";
}

.mdi-power-socket-au::before {
  content: "\\f0905";
}

.mdi-power-socket-ch::before {
  content: "\\f0fb3";
}

.mdi-power-socket-de::before {
  content: "\\f1107";
}

.mdi-power-socket-eu::before {
  content: "\\f07e7";
}

.mdi-power-socket-fr::before {
  content: "\\f1108";
}

.mdi-power-socket-it::before {
  content: "\\f14ff";
}

.mdi-power-socket-jp::before {
  content: "\\f1109";
}

.mdi-power-socket-uk::before {
  content: "\\f07e8";
}

.mdi-power-socket-us::before {
  content: "\\f07e9";
}

.mdi-power-standby::before {
  content: "\\f0906";
}

.mdi-powershell::before {
  content: "\\f0a0a";
}

.mdi-prescription::before {
  content: "\\f0706";
}

.mdi-presentation::before {
  content: "\\f0428";
}

.mdi-presentation-play::before {
  content: "\\f0429";
}

.mdi-pretzel::before {
  content: "\\f1562";
}

.mdi-printer::before {
  content: "\\f042a";
}

.mdi-printer-3d::before {
  content: "\\f042b";
}

.mdi-printer-3d-nozzle::before {
  content: "\\f0e5b";
}

.mdi-printer-3d-nozzle-alert::before {
  content: "\\f11c0";
}

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\f11c1";
}

.mdi-printer-3d-nozzle-heat::before {
  content: "\\f18b8";
}

.mdi-printer-3d-nozzle-heat-outline::before {
  content: "\\f18b9";
}

.mdi-printer-3d-nozzle-outline::before {
  content: "\\f0e5c";
}

.mdi-printer-alert::before {
  content: "\\f042c";
}

.mdi-printer-check::before {
  content: "\\f1146";
}

.mdi-printer-eye::before {
  content: "\\f1458";
}

.mdi-printer-off::before {
  content: "\\f0e5d";
}

.mdi-printer-off-outline::before {
  content: "\\f1785";
}

.mdi-printer-outline::before {
  content: "\\f1786";
}

.mdi-printer-pos::before {
  content: "\\f1057";
}

.mdi-printer-search::before {
  content: "\\f1457";
}

.mdi-printer-settings::before {
  content: "\\f0707";
}

.mdi-printer-wireless::before {
  content: "\\f0a0b";
}

.mdi-priority-high::before {
  content: "\\f0603";
}

.mdi-priority-low::before {
  content: "\\f0604";
}

.mdi-professional-hexagon::before {
  content: "\\f042d";
}

.mdi-progress-alert::before {
  content: "\\f0cbc";
}

.mdi-progress-check::before {
  content: "\\f0995";
}

.mdi-progress-clock::before {
  content: "\\f0996";
}

.mdi-progress-close::before {
  content: "\\f110a";
}

.mdi-progress-download::before {
  content: "\\f0997";
}

.mdi-progress-pencil::before {
  content: "\\f1787";
}

.mdi-progress-question::before {
  content: "\\f1522";
}

.mdi-progress-star::before {
  content: "\\f1788";
}

.mdi-progress-upload::before {
  content: "\\f0998";
}

.mdi-progress-wrench::before {
  content: "\\f0cbd";
}

.mdi-projector::before {
  content: "\\f042e";
}

.mdi-projector-screen::before {
  content: "\\f042f";
}

.mdi-projector-screen-off::before {
  content: "\\f180d";
}

.mdi-projector-screen-off-outline::before {
  content: "\\f180e";
}

.mdi-projector-screen-outline::before {
  content: "\\f1724";
}

.mdi-projector-screen-variant::before {
  content: "\\f180f";
}

.mdi-projector-screen-variant-off::before {
  content: "\\f1810";
}

.mdi-projector-screen-variant-off-outline::before {
  content: "\\f1811";
}

.mdi-projector-screen-variant-outline::before {
  content: "\\f1812";
}

.mdi-propane-tank::before {
  content: "\\f1357";
}

.mdi-propane-tank-outline::before {
  content: "\\f1358";
}

.mdi-protocol::before {
  content: "\\f0fd8";
}

.mdi-publish::before {
  content: "\\f06a7";
}

.mdi-publish-off::before {
  content: "\\f1945";
}

.mdi-pulse::before {
  content: "\\f0430";
}

.mdi-pump::before {
  content: "\\f1402";
}

.mdi-pumpkin::before {
  content: "\\f0bbf";
}

.mdi-purse::before {
  content: "\\f0f1c";
}

.mdi-purse-outline::before {
  content: "\\f0f1d";
}

.mdi-puzzle::before {
  content: "\\f0431";
}

.mdi-puzzle-check::before {
  content: "\\f1426";
}

.mdi-puzzle-check-outline::before {
  content: "\\f1427";
}

.mdi-puzzle-edit::before {
  content: "\\f14d3";
}

.mdi-puzzle-edit-outline::before {
  content: "\\f14d9";
}

.mdi-puzzle-heart::before {
  content: "\\f14d4";
}

.mdi-puzzle-heart-outline::before {
  content: "\\f14da";
}

.mdi-puzzle-minus::before {
  content: "\\f14d1";
}

.mdi-puzzle-minus-outline::before {
  content: "\\f14d7";
}

.mdi-puzzle-outline::before {
  content: "\\f0a66";
}

.mdi-puzzle-plus::before {
  content: "\\f14d0";
}

.mdi-puzzle-plus-outline::before {
  content: "\\f14d6";
}

.mdi-puzzle-remove::before {
  content: "\\f14d2";
}

.mdi-puzzle-remove-outline::before {
  content: "\\f14d8";
}

.mdi-puzzle-star::before {
  content: "\\f14d5";
}

.mdi-puzzle-star-outline::before {
  content: "\\f14db";
}

.mdi-pyramid::before {
  content: "\\f1952";
}

.mdi-pyramid-off::before {
  content: "\\f1953";
}

.mdi-qi::before {
  content: "\\f0999";
}

.mdi-qqchat::before {
  content: "\\f0605";
}

.mdi-qrcode::before {
  content: "\\f0432";
}

.mdi-qrcode-edit::before {
  content: "\\f08b8";
}

.mdi-qrcode-minus::before {
  content: "\\f118c";
}

.mdi-qrcode-plus::before {
  content: "\\f118b";
}

.mdi-qrcode-remove::before {
  content: "\\f118d";
}

.mdi-qrcode-scan::before {
  content: "\\f0433";
}

.mdi-quadcopter::before {
  content: "\\f0434";
}

.mdi-quality-high::before {
  content: "\\f0435";
}

.mdi-quality-low::before {
  content: "\\f0a0c";
}

.mdi-quality-medium::before {
  content: "\\f0a0d";
}

.mdi-quora::before {
  content: "\\f0d29";
}

.mdi-rabbit::before {
  content: "\\f0907";
}

.mdi-racing-helmet::before {
  content: "\\f0d93";
}

.mdi-racquetball::before {
  content: "\\f0d94";
}

.mdi-radar::before {
  content: "\\f0437";
}

.mdi-radiator::before {
  content: "\\f0438";
}

.mdi-radiator-disabled::before {
  content: "\\f0ad7";
}

.mdi-radiator-off::before {
  content: "\\f0ad8";
}

.mdi-radio::before {
  content: "\\f0439";
}

.mdi-radio-am::before {
  content: "\\f0cbe";
}

.mdi-radio-fm::before {
  content: "\\f0cbf";
}

.mdi-radio-handheld::before {
  content: "\\f043a";
}

.mdi-radio-off::before {
  content: "\\f121c";
}

.mdi-radio-tower::before {
  content: "\\f043b";
}

.mdi-radioactive::before {
  content: "\\f043c";
}

.mdi-radioactive-circle::before {
  content: "\\f185d";
}

.mdi-radioactive-circle-outline::before {
  content: "\\f185e";
}

.mdi-radioactive-off::before {
  content: "\\f0ec1";
}

.mdi-radiobox-blank::before {
  content: "\\f043d";
}

.mdi-radiobox-marked::before {
  content: "\\f043e";
}

.mdi-radiology-box::before {
  content: "\\f14c5";
}

.mdi-radiology-box-outline::before {
  content: "\\f14c6";
}

.mdi-radius::before {
  content: "\\f0cc0";
}

.mdi-radius-outline::before {
  content: "\\f0cc1";
}

.mdi-railroad-light::before {
  content: "\\f0f1e";
}

.mdi-rake::before {
  content: "\\f1544";
}

.mdi-raspberry-pi::before {
  content: "\\f043f";
}

.mdi-ray-end::before {
  content: "\\f0440";
}

.mdi-ray-end-arrow::before {
  content: "\\f0441";
}

.mdi-ray-start::before {
  content: "\\f0442";
}

.mdi-ray-start-arrow::before {
  content: "\\f0443";
}

.mdi-ray-start-end::before {
  content: "\\f0444";
}

.mdi-ray-start-vertex-end::before {
  content: "\\f15d8";
}

.mdi-ray-vertex::before {
  content: "\\f0445";
}

.mdi-razor-double-edge::before {
  content: "\\f1997";
}

.mdi-razor-single-edge::before {
  content: "\\f1998";
}

.mdi-react::before {
  content: "\\f0708";
}

.mdi-read::before {
  content: "\\f0447";
}

.mdi-receipt::before {
  content: "\\f0449";
}

.mdi-record::before {
  content: "\\f044a";
}

.mdi-record-circle::before {
  content: "\\f0ec2";
}

.mdi-record-circle-outline::before {
  content: "\\f0ec3";
}

.mdi-record-player::before {
  content: "\\f099a";
}

.mdi-record-rec::before {
  content: "\\f044b";
}

.mdi-rectangle::before {
  content: "\\f0e5e";
}

.mdi-rectangle-outline::before {
  content: "\\f0e5f";
}

.mdi-recycle::before {
  content: "\\f044c";
}

.mdi-recycle-variant::before {
  content: "\\f139d";
}

.mdi-reddit::before {
  content: "\\f044d";
}

.mdi-redhat::before {
  content: "\\f111b";
}

.mdi-redo::before {
  content: "\\f044e";
}

.mdi-redo-variant::before {
  content: "\\f044f";
}

.mdi-reflect-horizontal::before {
  content: "\\f0a0e";
}

.mdi-reflect-vertical::before {
  content: "\\f0a0f";
}

.mdi-refresh::before {
  content: "\\f0450";
}

.mdi-refresh-auto::before {
  content: "\\f18f2";
}

.mdi-refresh-circle::before {
  content: "\\f1377";
}

.mdi-regex::before {
  content: "\\f0451";
}

.mdi-registered-trademark::before {
  content: "\\f0a67";
}

.mdi-reiterate::before {
  content: "\\f1588";
}

.mdi-relation-many-to-many::before {
  content: "\\f1496";
}

.mdi-relation-many-to-one::before {
  content: "\\f1497";
}

.mdi-relation-many-to-one-or-many::before {
  content: "\\f1498";
}

.mdi-relation-many-to-only-one::before {
  content: "\\f1499";
}

.mdi-relation-many-to-zero-or-many::before {
  content: "\\f149a";
}

.mdi-relation-many-to-zero-or-one::before {
  content: "\\f149b";
}

.mdi-relation-one-or-many-to-many::before {
  content: "\\f149c";
}

.mdi-relation-one-or-many-to-one::before {
  content: "\\f149d";
}

.mdi-relation-one-or-many-to-one-or-many::before {
  content: "\\f149e";
}

.mdi-relation-one-or-many-to-only-one::before {
  content: "\\f149f";
}

.mdi-relation-one-or-many-to-zero-or-many::before {
  content: "\\f14a0";
}

.mdi-relation-one-or-many-to-zero-or-one::before {
  content: "\\f14a1";
}

.mdi-relation-one-to-many::before {
  content: "\\f14a2";
}

.mdi-relation-one-to-one::before {
  content: "\\f14a3";
}

.mdi-relation-one-to-one-or-many::before {
  content: "\\f14a4";
}

.mdi-relation-one-to-only-one::before {
  content: "\\f14a5";
}

.mdi-relation-one-to-zero-or-many::before {
  content: "\\f14a6";
}

.mdi-relation-one-to-zero-or-one::before {
  content: "\\f14a7";
}

.mdi-relation-only-one-to-many::before {
  content: "\\f14a8";
}

.mdi-relation-only-one-to-one::before {
  content: "\\f14a9";
}

.mdi-relation-only-one-to-one-or-many::before {
  content: "\\f14aa";
}

.mdi-relation-only-one-to-only-one::before {
  content: "\\f14ab";
}

.mdi-relation-only-one-to-zero-or-many::before {
  content: "\\f14ac";
}

.mdi-relation-only-one-to-zero-or-one::before {
  content: "\\f14ad";
}

.mdi-relation-zero-or-many-to-many::before {
  content: "\\f14ae";
}

.mdi-relation-zero-or-many-to-one::before {
  content: "\\f14af";
}

.mdi-relation-zero-or-many-to-one-or-many::before {
  content: "\\f14b0";
}

.mdi-relation-zero-or-many-to-only-one::before {
  content: "\\f14b1";
}

.mdi-relation-zero-or-many-to-zero-or-many::before {
  content: "\\f14b2";
}

.mdi-relation-zero-or-many-to-zero-or-one::before {
  content: "\\f14b3";
}

.mdi-relation-zero-or-one-to-many::before {
  content: "\\f14b4";
}

.mdi-relation-zero-or-one-to-one::before {
  content: "\\f14b5";
}

.mdi-relation-zero-or-one-to-one-or-many::before {
  content: "\\f14b6";
}

.mdi-relation-zero-or-one-to-only-one::before {
  content: "\\f14b7";
}

.mdi-relation-zero-or-one-to-zero-or-many::before {
  content: "\\f14b8";
}

.mdi-relation-zero-or-one-to-zero-or-one::before {
  content: "\\f14b9";
}

.mdi-relative-scale::before {
  content: "\\f0452";
}

.mdi-reload::before {
  content: "\\f0453";
}

.mdi-reload-alert::before {
  content: "\\f110b";
}

.mdi-reminder::before {
  content: "\\f088c";
}

.mdi-remote::before {
  content: "\\f0454";
}

.mdi-remote-desktop::before {
  content: "\\f08b9";
}

.mdi-remote-off::before {
  content: "\\f0ec4";
}

.mdi-remote-tv::before {
  content: "\\f0ec5";
}

.mdi-remote-tv-off::before {
  content: "\\f0ec6";
}

.mdi-rename-box::before {
  content: "\\f0455";
}

.mdi-reorder-horizontal::before {
  content: "\\f0688";
}

.mdi-reorder-vertical::before {
  content: "\\f0689";
}

.mdi-repeat::before {
  content: "\\f0456";
}

.mdi-repeat-off::before {
  content: "\\f0457";
}

.mdi-repeat-once::before {
  content: "\\f0458";
}

.mdi-repeat-variant::before {
  content: "\\f0547";
}

.mdi-replay::before {
  content: "\\f0459";
}

.mdi-reply::before {
  content: "\\f045a";
}

.mdi-reply-all::before {
  content: "\\f045b";
}

.mdi-reply-all-outline::before {
  content: "\\f0f1f";
}

.mdi-reply-circle::before {
  content: "\\f11ae";
}

.mdi-reply-outline::before {
  content: "\\f0f20";
}

.mdi-reproduction::before {
  content: "\\f045c";
}

.mdi-resistor::before {
  content: "\\f0b44";
}

.mdi-resistor-nodes::before {
  content: "\\f0b45";
}

.mdi-resize::before {
  content: "\\f0a68";
}

.mdi-resize-bottom-right::before {
  content: "\\f045d";
}

.mdi-responsive::before {
  content: "\\f045e";
}

.mdi-restart::before {
  content: "\\f0709";
}

.mdi-restart-alert::before {
  content: "\\f110c";
}

.mdi-restart-off::before {
  content: "\\f0d95";
}

.mdi-restore::before {
  content: "\\f099b";
}

.mdi-restore-alert::before {
  content: "\\f110d";
}

.mdi-rewind::before {
  content: "\\f045f";
}

.mdi-rewind-10::before {
  content: "\\f0d2a";
}

.mdi-rewind-15::before {
  content: "\\f1946";
}

.mdi-rewind-30::before {
  content: "\\f0d96";
}

.mdi-rewind-5::before {
  content: "\\f11f9";
}

.mdi-rewind-60::before {
  content: "\\f160c";
}

.mdi-rewind-outline::before {
  content: "\\f070a";
}

.mdi-rhombus::before {
  content: "\\f070b";
}

.mdi-rhombus-medium::before {
  content: "\\f0a10";
}

.mdi-rhombus-medium-outline::before {
  content: "\\f14dc";
}

.mdi-rhombus-outline::before {
  content: "\\f070c";
}

.mdi-rhombus-split::before {
  content: "\\f0a11";
}

.mdi-rhombus-split-outline::before {
  content: "\\f14dd";
}

.mdi-ribbon::before {
  content: "\\f0460";
}

.mdi-rice::before {
  content: "\\f07ea";
}

.mdi-rickshaw::before {
  content: "\\f15bb";
}

.mdi-rickshaw-electric::before {
  content: "\\f15bc";
}

.mdi-ring::before {
  content: "\\f07eb";
}

.mdi-rivet::before {
  content: "\\f0e60";
}

.mdi-road::before {
  content: "\\f0461";
}

.mdi-road-variant::before {
  content: "\\f0462";
}

.mdi-robber::before {
  content: "\\f1058";
}

.mdi-robot::before {
  content: "\\f06a9";
}

.mdi-robot-angry::before {
  content: "\\f169d";
}

.mdi-robot-angry-outline::before {
  content: "\\f169e";
}

.mdi-robot-confused::before {
  content: "\\f169f";
}

.mdi-robot-confused-outline::before {
  content: "\\f16a0";
}

.mdi-robot-dead::before {
  content: "\\f16a1";
}

.mdi-robot-dead-outline::before {
  content: "\\f16a2";
}

.mdi-robot-excited::before {
  content: "\\f16a3";
}

.mdi-robot-excited-outline::before {
  content: "\\f16a4";
}

.mdi-robot-happy::before {
  content: "\\f1719";
}

.mdi-robot-happy-outline::before {
  content: "\\f171a";
}

.mdi-robot-industrial::before {
  content: "\\f0b46";
}

.mdi-robot-love::before {
  content: "\\f16a5";
}

.mdi-robot-love-outline::before {
  content: "\\f16a6";
}

.mdi-robot-mower::before {
  content: "\\f11f7";
}

.mdi-robot-mower-outline::before {
  content: "\\f11f3";
}

.mdi-robot-off::before {
  content: "\\f16a7";
}

.mdi-robot-off-outline::before {
  content: "\\f167b";
}

.mdi-robot-outline::before {
  content: "\\f167a";
}

.mdi-robot-vacuum::before {
  content: "\\f070d";
}

.mdi-robot-vacuum-variant::before {
  content: "\\f0908";
}

.mdi-rocket::before {
  content: "\\f0463";
}

.mdi-rocket-launch::before {
  content: "\\f14de";
}

.mdi-rocket-launch-outline::before {
  content: "\\f14df";
}

.mdi-rocket-outline::before {
  content: "\\f13af";
}

.mdi-rodent::before {
  content: "\\f1327";
}

.mdi-roller-skate::before {
  content: "\\f0d2b";
}

.mdi-roller-skate-off::before {
  content: "\\f0145";
}

.mdi-rollerblade::before {
  content: "\\f0d2c";
}

.mdi-rollerblade-off::before {
  content: "\\f002e";
}

.mdi-rollupjs::before {
  content: "\\f0bc0";
}

.mdi-roman-numeral-1::before {
  content: "\\f1088";
}

.mdi-roman-numeral-10::before {
  content: "\\f1091";
}

.mdi-roman-numeral-2::before {
  content: "\\f1089";
}

.mdi-roman-numeral-3::before {
  content: "\\f108a";
}

.mdi-roman-numeral-4::before {
  content: "\\f108b";
}

.mdi-roman-numeral-5::before {
  content: "\\f108c";
}

.mdi-roman-numeral-6::before {
  content: "\\f108d";
}

.mdi-roman-numeral-7::before {
  content: "\\f108e";
}

.mdi-roman-numeral-8::before {
  content: "\\f108f";
}

.mdi-roman-numeral-9::before {
  content: "\\f1090";
}

.mdi-room-service::before {
  content: "\\f088d";
}

.mdi-room-service-outline::before {
  content: "\\f0d97";
}

.mdi-rotate-360::before {
  content: "\\f1999";
}

.mdi-rotate-3d::before {
  content: "\\f0ec7";
}

.mdi-rotate-3d-variant::before {
  content: "\\f0464";
}

.mdi-rotate-left::before {
  content: "\\f0465";
}

.mdi-rotate-left-variant::before {
  content: "\\f0466";
}

.mdi-rotate-orbit::before {
  content: "\\f0d98";
}

.mdi-rotate-right::before {
  content: "\\f0467";
}

.mdi-rotate-right-variant::before {
  content: "\\f0468";
}

.mdi-rounded-corner::before {
  content: "\\f0607";
}

.mdi-router::before {
  content: "\\f11e2";
}

.mdi-router-network::before {
  content: "\\f1087";
}

.mdi-router-wireless::before {
  content: "\\f0469";
}

.mdi-router-wireless-off::before {
  content: "\\f15a3";
}

.mdi-router-wireless-settings::before {
  content: "\\f0a69";
}

.mdi-routes::before {
  content: "\\f046a";
}

.mdi-routes-clock::before {
  content: "\\f1059";
}

.mdi-rowing::before {
  content: "\\f0608";
}

.mdi-rss::before {
  content: "\\f046b";
}

.mdi-rss-box::before {
  content: "\\f046c";
}

.mdi-rss-off::before {
  content: "\\f0f21";
}

.mdi-rug::before {
  content: "\\f1475";
}

.mdi-rugby::before {
  content: "\\f0d99";
}

.mdi-ruler::before {
  content: "\\f046d";
}

.mdi-ruler-square::before {
  content: "\\f0cc2";
}

.mdi-ruler-square-compass::before {
  content: "\\f0ebe";
}

.mdi-run::before {
  content: "\\f070e";
}

.mdi-run-fast::before {
  content: "\\f046e";
}

.mdi-rv-truck::before {
  content: "\\f11d4";
}

.mdi-sack::before {
  content: "\\f0d2e";
}

.mdi-sack-percent::before {
  content: "\\f0d2f";
}

.mdi-safe::before {
  content: "\\f0a6a";
}

.mdi-safe-square::before {
  content: "\\f127c";
}

.mdi-safe-square-outline::before {
  content: "\\f127d";
}

.mdi-safety-goggles::before {
  content: "\\f0d30";
}

.mdi-sail-boat::before {
  content: "\\f0ec8";
}

.mdi-sale::before {
  content: "\\f046f";
}

.mdi-salesforce::before {
  content: "\\f088e";
}

.mdi-sass::before {
  content: "\\f07ec";
}

.mdi-satellite::before {
  content: "\\f0470";
}

.mdi-satellite-uplink::before {
  content: "\\f0909";
}

.mdi-satellite-variant::before {
  content: "\\f0471";
}

.mdi-sausage::before {
  content: "\\f08ba";
}

.mdi-sausage-off::before {
  content: "\\f1789";
}

.mdi-saw-blade::before {
  content: "\\f0e61";
}

.mdi-sawtooth-wave::before {
  content: "\\f147a";
}

.mdi-saxophone::before {
  content: "\\f0609";
}

.mdi-scale::before {
  content: "\\f0472";
}

.mdi-scale-balance::before {
  content: "\\f05d1";
}

.mdi-scale-bathroom::before {
  content: "\\f0473";
}

.mdi-scale-off::before {
  content: "\\f105a";
}

.mdi-scale-unbalanced::before {
  content: "\\f19b8";
}

.mdi-scan-helper::before {
  content: "\\f13d8";
}

.mdi-scanner::before {
  content: "\\f06ab";
}

.mdi-scanner-off::before {
  content: "\\f090a";
}

.mdi-scatter-plot::before {
  content: "\\f0ec9";
}

.mdi-scatter-plot-outline::before {
  content: "\\f0eca";
}

.mdi-scent::before {
  content: "\\f1958";
}

.mdi-scent-off::before {
  content: "\\f1959";
}

.mdi-school::before {
  content: "\\f0474";
}

.mdi-school-outline::before {
  content: "\\f1180";
}

.mdi-scissors-cutting::before {
  content: "\\f0a6b";
}

.mdi-scooter::before {
  content: "\\f15bd";
}

.mdi-scooter-electric::before {
  content: "\\f15be";
}

.mdi-scoreboard::before {
  content: "\\f127e";
}

.mdi-scoreboard-outline::before {
  content: "\\f127f";
}

.mdi-screen-rotation::before {
  content: "\\f0475";
}

.mdi-screen-rotation-lock::before {
  content: "\\f0478";
}

.mdi-screw-flat-top::before {
  content: "\\f0df3";
}

.mdi-screw-lag::before {
  content: "\\f0df4";
}

.mdi-screw-machine-flat-top::before {
  content: "\\f0df5";
}

.mdi-screw-machine-round-top::before {
  content: "\\f0df6";
}

.mdi-screw-round-top::before {
  content: "\\f0df7";
}

.mdi-screwdriver::before {
  content: "\\f0476";
}

.mdi-script::before {
  content: "\\f0bc1";
}

.mdi-script-outline::before {
  content: "\\f0477";
}

.mdi-script-text::before {
  content: "\\f0bc2";
}

.mdi-script-text-key::before {
  content: "\\f1725";
}

.mdi-script-text-key-outline::before {
  content: "\\f1726";
}

.mdi-script-text-outline::before {
  content: "\\f0bc3";
}

.mdi-script-text-play::before {
  content: "\\f1727";
}

.mdi-script-text-play-outline::before {
  content: "\\f1728";
}

.mdi-sd::before {
  content: "\\f0479";
}

.mdi-seal::before {
  content: "\\f047a";
}

.mdi-seal-variant::before {
  content: "\\f0fd9";
}

.mdi-search-web::before {
  content: "\\f070f";
}

.mdi-seat::before {
  content: "\\f0cc3";
}

.mdi-seat-flat::before {
  content: "\\f047b";
}

.mdi-seat-flat-angled::before {
  content: "\\f047c";
}

.mdi-seat-individual-suite::before {
  content: "\\f047d";
}

.mdi-seat-legroom-extra::before {
  content: "\\f047e";
}

.mdi-seat-legroom-normal::before {
  content: "\\f047f";
}

.mdi-seat-legroom-reduced::before {
  content: "\\f0480";
}

.mdi-seat-outline::before {
  content: "\\f0cc4";
}

.mdi-seat-passenger::before {
  content: "\\f1249";
}

.mdi-seat-recline-extra::before {
  content: "\\f0481";
}

.mdi-seat-recline-normal::before {
  content: "\\f0482";
}

.mdi-seatbelt::before {
  content: "\\f0cc5";
}

.mdi-security::before {
  content: "\\f0483";
}

.mdi-security-network::before {
  content: "\\f0484";
}

.mdi-seed::before {
  content: "\\f0e62";
}

.mdi-seed-off::before {
  content: "\\f13fd";
}

.mdi-seed-off-outline::before {
  content: "\\f13fe";
}

.mdi-seed-outline::before {
  content: "\\f0e63";
}

.mdi-seesaw::before {
  content: "\\f15a4";
}

.mdi-segment::before {
  content: "\\f0ecb";
}

.mdi-select::before {
  content: "\\f0485";
}

.mdi-select-all::before {
  content: "\\f0486";
}

.mdi-select-color::before {
  content: "\\f0d31";
}

.mdi-select-compare::before {
  content: "\\f0ad9";
}

.mdi-select-drag::before {
  content: "\\f0a6c";
}

.mdi-select-group::before {
  content: "\\f0f82";
}

.mdi-select-inverse::before {
  content: "\\f0487";
}

.mdi-select-marker::before {
  content: "\\f1280";
}

.mdi-select-multiple::before {
  content: "\\f1281";
}

.mdi-select-multiple-marker::before {
  content: "\\f1282";
}

.mdi-select-off::before {
  content: "\\f0488";
}

.mdi-select-place::before {
  content: "\\f0fda";
}

.mdi-select-remove::before {
  content: "\\f17c1";
}

.mdi-select-search::before {
  content: "\\f1204";
}

.mdi-selection::before {
  content: "\\f0489";
}

.mdi-selection-drag::before {
  content: "\\f0a6d";
}

.mdi-selection-ellipse::before {
  content: "\\f0d32";
}

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\f0f22";
}

.mdi-selection-ellipse-remove::before {
  content: "\\f17c2";
}

.mdi-selection-marker::before {
  content: "\\f1283";
}

.mdi-selection-multiple::before {
  content: "\\f1285";
}

.mdi-selection-multiple-marker::before {
  content: "\\f1284";
}

.mdi-selection-off::before {
  content: "\\f0777";
}

.mdi-selection-remove::before {
  content: "\\f17c3";
}

.mdi-selection-search::before {
  content: "\\f1205";
}

.mdi-semantic-web::before {
  content: "\\f1316";
}

.mdi-send::before {
  content: "\\f048a";
}

.mdi-send-check::before {
  content: "\\f1161";
}

.mdi-send-check-outline::before {
  content: "\\f1162";
}

.mdi-send-circle::before {
  content: "\\f0df8";
}

.mdi-send-circle-outline::before {
  content: "\\f0df9";
}

.mdi-send-clock::before {
  content: "\\f1163";
}

.mdi-send-clock-outline::before {
  content: "\\f1164";
}

.mdi-send-lock::before {
  content: "\\f07ed";
}

.mdi-send-lock-outline::before {
  content: "\\f1166";
}

.mdi-send-outline::before {
  content: "\\f1165";
}

.mdi-serial-port::before {
  content: "\\f065c";
}

.mdi-server::before {
  content: "\\f048b";
}

.mdi-server-minus::before {
  content: "\\f048c";
}

.mdi-server-network::before {
  content: "\\f048d";
}

.mdi-server-network-off::before {
  content: "\\f048e";
}

.mdi-server-off::before {
  content: "\\f048f";
}

.mdi-server-plus::before {
  content: "\\f0490";
}

.mdi-server-remove::before {
  content: "\\f0491";
}

.mdi-server-security::before {
  content: "\\f0492";
}

.mdi-set-all::before {
  content: "\\f0778";
}

.mdi-set-center::before {
  content: "\\f0779";
}

.mdi-set-center-right::before {
  content: "\\f077a";
}

.mdi-set-left::before {
  content: "\\f077b";
}

.mdi-set-left-center::before {
  content: "\\f077c";
}

.mdi-set-left-right::before {
  content: "\\f077d";
}

.mdi-set-merge::before {
  content: "\\f14e0";
}

.mdi-set-none::before {
  content: "\\f077e";
}

.mdi-set-right::before {
  content: "\\f077f";
}

.mdi-set-split::before {
  content: "\\f14e1";
}

.mdi-set-square::before {
  content: "\\f145d";
}

.mdi-set-top-box::before {
  content: "\\f099f";
}

.mdi-settings-helper::before {
  content: "\\f0a6e";
}

.mdi-shaker::before {
  content: "\\f110e";
}

.mdi-shaker-outline::before {
  content: "\\f110f";
}

.mdi-shape::before {
  content: "\\f0831";
}

.mdi-shape-circle-plus::before {
  content: "\\f065d";
}

.mdi-shape-outline::before {
  content: "\\f0832";
}

.mdi-shape-oval-plus::before {
  content: "\\f11fa";
}

.mdi-shape-plus::before {
  content: "\\f0495";
}

.mdi-shape-polygon-plus::before {
  content: "\\f065e";
}

.mdi-shape-rectangle-plus::before {
  content: "\\f065f";
}

.mdi-shape-square-plus::before {
  content: "\\f0660";
}

.mdi-shape-square-rounded-plus::before {
  content: "\\f14fa";
}

.mdi-share::before {
  content: "\\f0496";
}

.mdi-share-all::before {
  content: "\\f11f4";
}

.mdi-share-all-outline::before {
  content: "\\f11f5";
}

.mdi-share-circle::before {
  content: "\\f11ad";
}

.mdi-share-off::before {
  content: "\\f0f23";
}

.mdi-share-off-outline::before {
  content: "\\f0f24";
}

.mdi-share-outline::before {
  content: "\\f0932";
}

.mdi-share-variant::before {
  content: "\\f0497";
}

.mdi-share-variant-outline::before {
  content: "\\f1514";
}

.mdi-shark::before {
  content: "\\f18ba";
}

.mdi-shark-fin::before {
  content: "\\f1673";
}

.mdi-shark-fin-outline::before {
  content: "\\f1674";
}

.mdi-shark-off::before {
  content: "\\f18bb";
}

.mdi-sheep::before {
  content: "\\f0cc6";
}

.mdi-shield::before {
  content: "\\f0498";
}

.mdi-shield-account::before {
  content: "\\f088f";
}

.mdi-shield-account-outline::before {
  content: "\\f0a12";
}

.mdi-shield-account-variant::before {
  content: "\\f15a7";
}

.mdi-shield-account-variant-outline::before {
  content: "\\f15a8";
}

.mdi-shield-airplane::before {
  content: "\\f06bb";
}

.mdi-shield-airplane-outline::before {
  content: "\\f0cc7";
}

.mdi-shield-alert::before {
  content: "\\f0ecc";
}

.mdi-shield-alert-outline::before {
  content: "\\f0ecd";
}

.mdi-shield-bug::before {
  content: "\\f13da";
}

.mdi-shield-bug-outline::before {
  content: "\\f13db";
}

.mdi-shield-car::before {
  content: "\\f0f83";
}

.mdi-shield-check::before {
  content: "\\f0565";
}

.mdi-shield-check-outline::before {
  content: "\\f0cc8";
}

.mdi-shield-cross::before {
  content: "\\f0cc9";
}

.mdi-shield-cross-outline::before {
  content: "\\f0cca";
}

.mdi-shield-crown::before {
  content: "\\f18bc";
}

.mdi-shield-crown-outline::before {
  content: "\\f18bd";
}

.mdi-shield-edit::before {
  content: "\\f11a0";
}

.mdi-shield-edit-outline::before {
  content: "\\f11a1";
}

.mdi-shield-half::before {
  content: "\\f1360";
}

.mdi-shield-half-full::before {
  content: "\\f0780";
}

.mdi-shield-home::before {
  content: "\\f068a";
}

.mdi-shield-home-outline::before {
  content: "\\f0ccb";
}

.mdi-shield-key::before {
  content: "\\f0bc4";
}

.mdi-shield-key-outline::before {
  content: "\\f0bc5";
}

.mdi-shield-link-variant::before {
  content: "\\f0d33";
}

.mdi-shield-link-variant-outline::before {
  content: "\\f0d34";
}

.mdi-shield-lock::before {
  content: "\\f099d";
}

.mdi-shield-lock-open::before {
  content: "\\f199a";
}

.mdi-shield-lock-open-outline::before {
  content: "\\f199b";
}

.mdi-shield-lock-outline::before {
  content: "\\f0ccc";
}

.mdi-shield-moon::before {
  content: "\\f1828";
}

.mdi-shield-moon-outline::before {
  content: "\\f1829";
}

.mdi-shield-off::before {
  content: "\\f099e";
}

.mdi-shield-off-outline::before {
  content: "\\f099c";
}

.mdi-shield-outline::before {
  content: "\\f0499";
}

.mdi-shield-plus::before {
  content: "\\f0ada";
}

.mdi-shield-plus-outline::before {
  content: "\\f0adb";
}

.mdi-shield-refresh::before {
  content: "\\f00aa";
}

.mdi-shield-refresh-outline::before {
  content: "\\f01e0";
}

.mdi-shield-remove::before {
  content: "\\f0adc";
}

.mdi-shield-remove-outline::before {
  content: "\\f0add";
}

.mdi-shield-search::before {
  content: "\\f0d9a";
}

.mdi-shield-star::before {
  content: "\\f113b";
}

.mdi-shield-star-outline::before {
  content: "\\f113c";
}

.mdi-shield-sun::before {
  content: "\\f105d";
}

.mdi-shield-sun-outline::before {
  content: "\\f105e";
}

.mdi-shield-sword::before {
  content: "\\f18be";
}

.mdi-shield-sword-outline::before {
  content: "\\f18bf";
}

.mdi-shield-sync::before {
  content: "\\f11a2";
}

.mdi-shield-sync-outline::before {
  content: "\\f11a3";
}

.mdi-shimmer::before {
  content: "\\f1545";
}

.mdi-ship-wheel::before {
  content: "\\f0833";
}

.mdi-shipping-pallet::before {
  content: "\\f184e";
}

.mdi-shoe-ballet::before {
  content: "\\f15ca";
}

.mdi-shoe-cleat::before {
  content: "\\f15c7";
}

.mdi-shoe-formal::before {
  content: "\\f0b47";
}

.mdi-shoe-heel::before {
  content: "\\f0b48";
}

.mdi-shoe-print::before {
  content: "\\f0dfa";
}

.mdi-shoe-sneaker::before {
  content: "\\f15c8";
}

.mdi-shopping::before {
  content: "\\f049a";
}

.mdi-shopping-music::before {
  content: "\\f049b";
}

.mdi-shopping-outline::before {
  content: "\\f11d5";
}

.mdi-shopping-search::before {
  content: "\\f0f84";
}

.mdi-shore::before {
  content: "\\f14f9";
}

.mdi-shovel::before {
  content: "\\f0710";
}

.mdi-shovel-off::before {
  content: "\\f0711";
}

.mdi-shower::before {
  content: "\\f09a0";
}

.mdi-shower-head::before {
  content: "\\f09a1";
}

.mdi-shredder::before {
  content: "\\f049c";
}

.mdi-shuffle::before {
  content: "\\f049d";
}

.mdi-shuffle-disabled::before {
  content: "\\f049e";
}

.mdi-shuffle-variant::before {
  content: "\\f049f";
}

.mdi-shuriken::before {
  content: "\\f137f";
}

.mdi-sickle::before {
  content: "\\f18c0";
}

.mdi-sigma::before {
  content: "\\f04a0";
}

.mdi-sigma-lower::before {
  content: "\\f062b";
}

.mdi-sign-caution::before {
  content: "\\f04a1";
}

.mdi-sign-direction::before {
  content: "\\f0781";
}

.mdi-sign-direction-minus::before {
  content: "\\f1000";
}

.mdi-sign-direction-plus::before {
  content: "\\f0fdc";
}

.mdi-sign-direction-remove::before {
  content: "\\f0fdd";
}

.mdi-sign-pole::before {
  content: "\\f14f8";
}

.mdi-sign-real-estate::before {
  content: "\\f1118";
}

.mdi-sign-text::before {
  content: "\\f0782";
}

.mdi-signal::before {
  content: "\\f04a2";
}

.mdi-signal-2g::before {
  content: "\\f0712";
}

.mdi-signal-3g::before {
  content: "\\f0713";
}

.mdi-signal-4g::before {
  content: "\\f0714";
}

.mdi-signal-5g::before {
  content: "\\f0a6f";
}

.mdi-signal-cellular-1::before {
  content: "\\f08bc";
}

.mdi-signal-cellular-2::before {
  content: "\\f08bd";
}

.mdi-signal-cellular-3::before {
  content: "\\f08be";
}

.mdi-signal-cellular-outline::before {
  content: "\\f08bf";
}

.mdi-signal-distance-variant::before {
  content: "\\f0e64";
}

.mdi-signal-hspa::before {
  content: "\\f0715";
}

.mdi-signal-hspa-plus::before {
  content: "\\f0716";
}

.mdi-signal-off::before {
  content: "\\f0783";
}

.mdi-signal-variant::before {
  content: "\\f060a";
}

.mdi-signature::before {
  content: "\\f0dfb";
}

.mdi-signature-freehand::before {
  content: "\\f0dfc";
}

.mdi-signature-image::before {
  content: "\\f0dfd";
}

.mdi-signature-text::before {
  content: "\\f0dfe";
}

.mdi-silo::before {
  content: "\\f0b49";
}

.mdi-silverware::before {
  content: "\\f04a3";
}

.mdi-silverware-clean::before {
  content: "\\f0fde";
}

.mdi-silverware-fork::before {
  content: "\\f04a4";
}

.mdi-silverware-fork-knife::before {
  content: "\\f0a70";
}

.mdi-silverware-spoon::before {
  content: "\\f04a5";
}

.mdi-silverware-variant::before {
  content: "\\f04a6";
}

.mdi-sim::before {
  content: "\\f04a7";
}

.mdi-sim-alert::before {
  content: "\\f04a8";
}

.mdi-sim-alert-outline::before {
  content: "\\f15d3";
}

.mdi-sim-off::before {
  content: "\\f04a9";
}

.mdi-sim-off-outline::before {
  content: "\\f15d4";
}

.mdi-sim-outline::before {
  content: "\\f15d5";
}

.mdi-simple-icons::before {
  content: "\\f131d";
}

.mdi-sina-weibo::before {
  content: "\\f0adf";
}

.mdi-sine-wave::before {
  content: "\\f095b";
}

.mdi-sitemap::before {
  content: "\\f04aa";
}

.mdi-sitemap-outline::before {
  content: "\\f199c";
}

.mdi-size-l::before {
  content: "\\f13a6";
}

.mdi-size-m::before {
  content: "\\f13a5";
}

.mdi-size-s::before {
  content: "\\f13a4";
}

.mdi-size-xl::before {
  content: "\\f13a7";
}

.mdi-size-xs::before {
  content: "\\f13a3";
}

.mdi-size-xxl::before {
  content: "\\f13a8";
}

.mdi-size-xxs::before {
  content: "\\f13a2";
}

.mdi-size-xxxl::before {
  content: "\\f13a9";
}

.mdi-skate::before {
  content: "\\f0d35";
}

.mdi-skate-off::before {
  content: "\\f0699";
}

.mdi-skateboard::before {
  content: "\\f14c2";
}

.mdi-skateboarding::before {
  content: "\\f0501";
}

.mdi-skew-less::before {
  content: "\\f0d36";
}

.mdi-skew-more::before {
  content: "\\f0d37";
}

.mdi-ski::before {
  content: "\\f1304";
}

.mdi-ski-cross-country::before {
  content: "\\f1305";
}

.mdi-ski-water::before {
  content: "\\f1306";
}

.mdi-skip-backward::before {
  content: "\\f04ab";
}

.mdi-skip-backward-outline::before {
  content: "\\f0f25";
}

.mdi-skip-forward::before {
  content: "\\f04ac";
}

.mdi-skip-forward-outline::before {
  content: "\\f0f26";
}

.mdi-skip-next::before {
  content: "\\f04ad";
}

.mdi-skip-next-circle::before {
  content: "\\f0661";
}

.mdi-skip-next-circle-outline::before {
  content: "\\f0662";
}

.mdi-skip-next-outline::before {
  content: "\\f0f27";
}

.mdi-skip-previous::before {
  content: "\\f04ae";
}

.mdi-skip-previous-circle::before {
  content: "\\f0663";
}

.mdi-skip-previous-circle-outline::before {
  content: "\\f0664";
}

.mdi-skip-previous-outline::before {
  content: "\\f0f28";
}

.mdi-skull::before {
  content: "\\f068c";
}

.mdi-skull-crossbones::before {
  content: "\\f0bc6";
}

.mdi-skull-crossbones-outline::before {
  content: "\\f0bc7";
}

.mdi-skull-outline::before {
  content: "\\f0bc8";
}

.mdi-skull-scan::before {
  content: "\\f14c7";
}

.mdi-skull-scan-outline::before {
  content: "\\f14c8";
}

.mdi-skype::before {
  content: "\\f04af";
}

.mdi-skype-business::before {
  content: "\\f04b0";
}

.mdi-slack::before {
  content: "\\f04b1";
}

.mdi-slash-forward::before {
  content: "\\f0fdf";
}

.mdi-slash-forward-box::before {
  content: "\\f0fe0";
}

.mdi-sledding::before {
  content: "\\f041b";
}

.mdi-sleep::before {
  content: "\\f04b2";
}

.mdi-sleep-off::before {
  content: "\\f04b3";
}

.mdi-slide::before {
  content: "\\f15a5";
}

.mdi-slope-downhill::before {
  content: "\\f0dff";
}

.mdi-slope-uphill::before {
  content: "\\f0e00";
}

.mdi-slot-machine::before {
  content: "\\f1114";
}

.mdi-slot-machine-outline::before {
  content: "\\f1115";
}

.mdi-smart-card::before {
  content: "\\f10bd";
}

.mdi-smart-card-off::before {
  content: "\\f18f7";
}

.mdi-smart-card-off-outline::before {
  content: "\\f18f8";
}

.mdi-smart-card-outline::before {
  content: "\\f10be";
}

.mdi-smart-card-reader::before {
  content: "\\f10bf";
}

.mdi-smart-card-reader-outline::before {
  content: "\\f10c0";
}

.mdi-smog::before {
  content: "\\f0a71";
}

.mdi-smoke::before {
  content: "\\f1799";
}

.mdi-smoke-detector::before {
  content: "\\f0392";
}

.mdi-smoke-detector-alert::before {
  content: "\\f192e";
}

.mdi-smoke-detector-alert-outline::before {
  content: "\\f192f";
}

.mdi-smoke-detector-off::before {
  content: "\\f1809";
}

.mdi-smoke-detector-off-outline::before {
  content: "\\f180a";
}

.mdi-smoke-detector-outline::before {
  content: "\\f1808";
}

.mdi-smoke-detector-variant::before {
  content: "\\f180b";
}

.mdi-smoke-detector-variant-alert::before {
  content: "\\f1930";
}

.mdi-smoke-detector-variant-off::before {
  content: "\\f180c";
}

.mdi-smoking::before {
  content: "\\f04b4";
}

.mdi-smoking-off::before {
  content: "\\f04b5";
}

.mdi-smoking-pipe::before {
  content: "\\f140d";
}

.mdi-smoking-pipe-off::before {
  content: "\\f1428";
}

.mdi-snail::before {
  content: "\\f1677";
}

.mdi-snake::before {
  content: "\\f150e";
}

.mdi-snapchat::before {
  content: "\\f04b6";
}

.mdi-snowboard::before {
  content: "\\f1307";
}

.mdi-snowflake::before {
  content: "\\f0717";
}

.mdi-snowflake-alert::before {
  content: "\\f0f29";
}

.mdi-snowflake-melt::before {
  content: "\\f12cb";
}

.mdi-snowflake-off::before {
  content: "\\f14e3";
}

.mdi-snowflake-variant::before {
  content: "\\f0f2a";
}

.mdi-snowman::before {
  content: "\\f04b7";
}

.mdi-snowmobile::before {
  content: "\\f06dd";
}

.mdi-soccer::before {
  content: "\\f04b8";
}

.mdi-soccer-field::before {
  content: "\\f0834";
}

.mdi-social-distance-2-meters::before {
  content: "\\f1579";
}

.mdi-social-distance-6-feet::before {
  content: "\\f157a";
}

.mdi-sofa::before {
  content: "\\f04b9";
}

.mdi-sofa-outline::before {
  content: "\\f156d";
}

.mdi-sofa-single::before {
  content: "\\f156e";
}

.mdi-sofa-single-outline::before {
  content: "\\f156f";
}

.mdi-solar-panel::before {
  content: "\\f0d9b";
}

.mdi-solar-panel-large::before {
  content: "\\f0d9c";
}

.mdi-solar-power::before {
  content: "\\f0a72";
}

.mdi-soldering-iron::before {
  content: "\\f1092";
}

.mdi-solid::before {
  content: "\\f068d";
}

.mdi-sony-playstation::before {
  content: "\\f0414";
}

.mdi-sort::before {
  content: "\\f04ba";
}

.mdi-sort-alphabetical-ascending::before {
  content: "\\f05bd";
}

.mdi-sort-alphabetical-ascending-variant::before {
  content: "\\f1148";
}

.mdi-sort-alphabetical-descending::before {
  content: "\\f05bf";
}

.mdi-sort-alphabetical-descending-variant::before {
  content: "\\f1149";
}

.mdi-sort-alphabetical-variant::before {
  content: "\\f04bb";
}

.mdi-sort-ascending::before {
  content: "\\f04bc";
}

.mdi-sort-bool-ascending::before {
  content: "\\f1385";
}

.mdi-sort-bool-ascending-variant::before {
  content: "\\f1386";
}

.mdi-sort-bool-descending::before {
  content: "\\f1387";
}

.mdi-sort-bool-descending-variant::before {
  content: "\\f1388";
}

.mdi-sort-calendar-ascending::before {
  content: "\\f1547";
}

.mdi-sort-calendar-descending::before {
  content: "\\f1548";
}

.mdi-sort-clock-ascending::before {
  content: "\\f1549";
}

.mdi-sort-clock-ascending-outline::before {
  content: "\\f154a";
}

.mdi-sort-clock-descending::before {
  content: "\\f154b";
}

.mdi-sort-clock-descending-outline::before {
  content: "\\f154c";
}

.mdi-sort-descending::before {
  content: "\\f04bd";
}

.mdi-sort-numeric-ascending::before {
  content: "\\f1389";
}

.mdi-sort-numeric-ascending-variant::before {
  content: "\\f090d";
}

.mdi-sort-numeric-descending::before {
  content: "\\f138a";
}

.mdi-sort-numeric-descending-variant::before {
  content: "\\f0ad2";
}

.mdi-sort-numeric-variant::before {
  content: "\\f04be";
}

.mdi-sort-reverse-variant::before {
  content: "\\f033c";
}

.mdi-sort-variant::before {
  content: "\\f04bf";
}

.mdi-sort-variant-lock::before {
  content: "\\f0ccd";
}

.mdi-sort-variant-lock-open::before {
  content: "\\f0cce";
}

.mdi-sort-variant-remove::before {
  content: "\\f1147";
}

.mdi-soundbar::before {
  content: "\\f17db";
}

.mdi-soundcloud::before {
  content: "\\f04c0";
}

.mdi-source-branch::before {
  content: "\\f062c";
}

.mdi-source-branch-check::before {
  content: "\\f14cf";
}

.mdi-source-branch-minus::before {
  content: "\\f14cb";
}

.mdi-source-branch-plus::before {
  content: "\\f14ca";
}

.mdi-source-branch-refresh::before {
  content: "\\f14cd";
}

.mdi-source-branch-remove::before {
  content: "\\f14cc";
}

.mdi-source-branch-sync::before {
  content: "\\f14ce";
}

.mdi-source-commit::before {
  content: "\\f0718";
}

.mdi-source-commit-end::before {
  content: "\\f0719";
}

.mdi-source-commit-end-local::before {
  content: "\\f071a";
}

.mdi-source-commit-local::before {
  content: "\\f071b";
}

.mdi-source-commit-next-local::before {
  content: "\\f071c";
}

.mdi-source-commit-start::before {
  content: "\\f071d";
}

.mdi-source-commit-start-next-local::before {
  content: "\\f071e";
}

.mdi-source-fork::before {
  content: "\\f04c1";
}

.mdi-source-merge::before {
  content: "\\f062d";
}

.mdi-source-pull::before {
  content: "\\f04c2";
}

.mdi-source-repository::before {
  content: "\\f0ccf";
}

.mdi-source-repository-multiple::before {
  content: "\\f0cd0";
}

.mdi-soy-sauce::before {
  content: "\\f07ee";
}

.mdi-soy-sauce-off::before {
  content: "\\f13fc";
}

.mdi-spa::before {
  content: "\\f0cd1";
}

.mdi-spa-outline::before {
  content: "\\f0cd2";
}

.mdi-space-invaders::before {
  content: "\\f0bc9";
}

.mdi-space-station::before {
  content: "\\f1383";
}

.mdi-spade::before {
  content: "\\f0e65";
}

.mdi-speaker::before {
  content: "\\f04c3";
}

.mdi-speaker-bluetooth::before {
  content: "\\f09a2";
}

.mdi-speaker-multiple::before {
  content: "\\f0d38";
}

.mdi-speaker-off::before {
  content: "\\f04c4";
}

.mdi-speaker-wireless::before {
  content: "\\f071f";
}

.mdi-spear::before {
  content: "\\f1845";
}

.mdi-speedometer::before {
  content: "\\f04c5";
}

.mdi-speedometer-medium::before {
  content: "\\f0f85";
}

.mdi-speedometer-slow::before {
  content: "\\f0f86";
}

.mdi-spellcheck::before {
  content: "\\f04c6";
}

.mdi-sphere::before {
  content: "\\f1954";
}

.mdi-sphere-off::before {
  content: "\\f1955";
}

.mdi-spider::before {
  content: "\\f11ea";
}

.mdi-spider-thread::before {
  content: "\\f11eb";
}

.mdi-spider-web::before {
  content: "\\f0bca";
}

.mdi-spirit-level::before {
  content: "\\f14f1";
}

.mdi-spoon-sugar::before {
  content: "\\f1429";
}

.mdi-spotify::before {
  content: "\\f04c7";
}

.mdi-spotlight::before {
  content: "\\f04c8";
}

.mdi-spotlight-beam::before {
  content: "\\f04c9";
}

.mdi-spray::before {
  content: "\\f0665";
}

.mdi-spray-bottle::before {
  content: "\\f0ae0";
}

.mdi-sprinkler::before {
  content: "\\f105f";
}

.mdi-sprinkler-fire::before {
  content: "\\f199d";
}

.mdi-sprinkler-variant::before {
  content: "\\f1060";
}

.mdi-sprout::before {
  content: "\\f0e66";
}

.mdi-sprout-outline::before {
  content: "\\f0e67";
}

.mdi-square::before {
  content: "\\f0764";
}

.mdi-square-circle::before {
  content: "\\f1500";
}

.mdi-square-edit-outline::before {
  content: "\\f090c";
}

.mdi-square-medium::before {
  content: "\\f0a13";
}

.mdi-square-medium-outline::before {
  content: "\\f0a14";
}

.mdi-square-off::before {
  content: "\\f12ee";
}

.mdi-square-off-outline::before {
  content: "\\f12ef";
}

.mdi-square-opacity::before {
  content: "\\f1854";
}

.mdi-square-outline::before {
  content: "\\f0763";
}

.mdi-square-root::before {
  content: "\\f0784";
}

.mdi-square-root-box::before {
  content: "\\f09a3";
}

.mdi-square-rounded::before {
  content: "\\f14fb";
}

.mdi-square-rounded-outline::before {
  content: "\\f14fc";
}

.mdi-square-small::before {
  content: "\\f0a15";
}

.mdi-square-wave::before {
  content: "\\f147b";
}

.mdi-squeegee::before {
  content: "\\f0ae1";
}

.mdi-ssh::before {
  content: "\\f08c0";
}

.mdi-stack-exchange::before {
  content: "\\f060b";
}

.mdi-stack-overflow::before {
  content: "\\f04cc";
}

.mdi-stackpath::before {
  content: "\\f0359";
}

.mdi-stadium::before {
  content: "\\f0ff9";
}

.mdi-stadium-variant::before {
  content: "\\f0720";
}

.mdi-stairs::before {
  content: "\\f04cd";
}

.mdi-stairs-box::before {
  content: "\\f139e";
}

.mdi-stairs-down::before {
  content: "\\f12be";
}

.mdi-stairs-up::before {
  content: "\\f12bd";
}

.mdi-stamper::before {
  content: "\\f0d39";
}

.mdi-standard-definition::before {
  content: "\\f07ef";
}

.mdi-star::before {
  content: "\\f04ce";
}

.mdi-star-box::before {
  content: "\\f0a73";
}

.mdi-star-box-multiple::before {
  content: "\\f1286";
}

.mdi-star-box-multiple-outline::before {
  content: "\\f1287";
}

.mdi-star-box-outline::before {
  content: "\\f0a74";
}

.mdi-star-check::before {
  content: "\\f1566";
}

.mdi-star-check-outline::before {
  content: "\\f156a";
}

.mdi-star-circle::before {
  content: "\\f04cf";
}

.mdi-star-circle-outline::before {
  content: "\\f09a4";
}

.mdi-star-cog::before {
  content: "\\f1668";
}

.mdi-star-cog-outline::before {
  content: "\\f1669";
}

.mdi-star-crescent::before {
  content: "\\f0979";
}

.mdi-star-david::before {
  content: "\\f097a";
}

.mdi-star-face::before {
  content: "\\f09a5";
}

.mdi-star-four-points::before {
  content: "\\f0ae2";
}

.mdi-star-four-points-outline::before {
  content: "\\f0ae3";
}

.mdi-star-half::before {
  content: "\\f0246";
}

.mdi-star-half-full::before {
  content: "\\f04d0";
}

.mdi-star-minus::before {
  content: "\\f1564";
}

.mdi-star-minus-outline::before {
  content: "\\f1568";
}

.mdi-star-off::before {
  content: "\\f04d1";
}

.mdi-star-off-outline::before {
  content: "\\f155b";
}

.mdi-star-outline::before {
  content: "\\f04d2";
}

.mdi-star-plus::before {
  content: "\\f1563";
}

.mdi-star-plus-outline::before {
  content: "\\f1567";
}

.mdi-star-remove::before {
  content: "\\f1565";
}

.mdi-star-remove-outline::before {
  content: "\\f1569";
}

.mdi-star-settings::before {
  content: "\\f166a";
}

.mdi-star-settings-outline::before {
  content: "\\f166b";
}

.mdi-star-shooting::before {
  content: "\\f1741";
}

.mdi-star-shooting-outline::before {
  content: "\\f1742";
}

.mdi-star-three-points::before {
  content: "\\f0ae4";
}

.mdi-star-three-points-outline::before {
  content: "\\f0ae5";
}

.mdi-state-machine::before {
  content: "\\f11ef";
}

.mdi-steam::before {
  content: "\\f04d3";
}

.mdi-steering::before {
  content: "\\f04d4";
}

.mdi-steering-off::before {
  content: "\\f090e";
}

.mdi-step-backward::before {
  content: "\\f04d5";
}

.mdi-step-backward-2::before {
  content: "\\f04d6";
}

.mdi-step-forward::before {
  content: "\\f04d7";
}

.mdi-step-forward-2::before {
  content: "\\f04d8";
}

.mdi-stethoscope::before {
  content: "\\f04d9";
}

.mdi-sticker::before {
  content: "\\f1364";
}

.mdi-sticker-alert::before {
  content: "\\f1365";
}

.mdi-sticker-alert-outline::before {
  content: "\\f1366";
}

.mdi-sticker-check::before {
  content: "\\f1367";
}

.mdi-sticker-check-outline::before {
  content: "\\f1368";
}

.mdi-sticker-circle-outline::before {
  content: "\\f05d0";
}

.mdi-sticker-emoji::before {
  content: "\\f0785";
}

.mdi-sticker-minus::before {
  content: "\\f1369";
}

.mdi-sticker-minus-outline::before {
  content: "\\f136a";
}

.mdi-sticker-outline::before {
  content: "\\f136b";
}

.mdi-sticker-plus::before {
  content: "\\f136c";
}

.mdi-sticker-plus-outline::before {
  content: "\\f136d";
}

.mdi-sticker-remove::before {
  content: "\\f136e";
}

.mdi-sticker-remove-outline::before {
  content: "\\f136f";
}

.mdi-sticker-text::before {
  content: "\\f178e";
}

.mdi-sticker-text-outline::before {
  content: "\\f178f";
}

.mdi-stocking::before {
  content: "\\f04da";
}

.mdi-stomach::before {
  content: "\\f1093";
}

.mdi-stool::before {
  content: "\\f195d";
}

.mdi-stool-outline::before {
  content: "\\f195e";
}

.mdi-stop::before {
  content: "\\f04db";
}

.mdi-stop-circle::before {
  content: "\\f0666";
}

.mdi-stop-circle-outline::before {
  content: "\\f0667";
}

.mdi-store::before {
  content: "\\f04dc";
}

.mdi-store-24-hour::before {
  content: "\\f04dd";
}

.mdi-store-alert::before {
  content: "\\f18c1";
}

.mdi-store-alert-outline::before {
  content: "\\f18c2";
}

.mdi-store-check::before {
  content: "\\f18c3";
}

.mdi-store-check-outline::before {
  content: "\\f18c4";
}

.mdi-store-clock::before {
  content: "\\f18c5";
}

.mdi-store-clock-outline::before {
  content: "\\f18c6";
}

.mdi-store-cog::before {
  content: "\\f18c7";
}

.mdi-store-cog-outline::before {
  content: "\\f18c8";
}

.mdi-store-edit::before {
  content: "\\f18c9";
}

.mdi-store-edit-outline::before {
  content: "\\f18ca";
}

.mdi-store-marker::before {
  content: "\\f18cb";
}

.mdi-store-marker-outline::before {
  content: "\\f18cc";
}

.mdi-store-minus::before {
  content: "\\f165e";
}

.mdi-store-minus-outline::before {
  content: "\\f18cd";
}

.mdi-store-off::before {
  content: "\\f18ce";
}

.mdi-store-off-outline::before {
  content: "\\f18cf";
}

.mdi-store-outline::before {
  content: "\\f1361";
}

.mdi-store-plus::before {
  content: "\\f165f";
}

.mdi-store-plus-outline::before {
  content: "\\f18d0";
}

.mdi-store-remove::before {
  content: "\\f1660";
}

.mdi-store-remove-outline::before {
  content: "\\f18d1";
}

.mdi-store-search::before {
  content: "\\f18d2";
}

.mdi-store-search-outline::before {
  content: "\\f18d3";
}

.mdi-store-settings::before {
  content: "\\f18d4";
}

.mdi-store-settings-outline::before {
  content: "\\f18d5";
}

.mdi-storefront::before {
  content: "\\f07c7";
}

.mdi-storefront-outline::before {
  content: "\\f10c1";
}

.mdi-stove::before {
  content: "\\f04de";
}

.mdi-strategy::before {
  content: "\\f11d6";
}

.mdi-stretch-to-page::before {
  content: "\\f0f2b";
}

.mdi-stretch-to-page-outline::before {
  content: "\\f0f2c";
}

.mdi-string-lights::before {
  content: "\\f12ba";
}

.mdi-string-lights-off::before {
  content: "\\f12bb";
}

.mdi-subdirectory-arrow-left::before {
  content: "\\f060c";
}

.mdi-subdirectory-arrow-right::before {
  content: "\\f060d";
}

.mdi-submarine::before {
  content: "\\f156c";
}

.mdi-subtitles::before {
  content: "\\f0a16";
}

.mdi-subtitles-outline::before {
  content: "\\f0a17";
}

.mdi-subway::before {
  content: "\\f06ac";
}

.mdi-subway-alert-variant::before {
  content: "\\f0d9d";
}

.mdi-subway-variant::before {
  content: "\\f04df";
}

.mdi-summit::before {
  content: "\\f0786";
}

.mdi-sun-compass::before {
  content: "\\f19a5";
}

.mdi-sun-snowflake::before {
  content: "\\f1796";
}

.mdi-sun-thermometer::before {
  content: "\\f18d6";
}

.mdi-sun-thermometer-outline::before {
  content: "\\f18d7";
}

.mdi-sun-wireless::before {
  content: "\\f17fe";
}

.mdi-sun-wireless-outline::before {
  content: "\\f17ff";
}

.mdi-sunglasses::before {
  content: "\\f04e0";
}

.mdi-surfing::before {
  content: "\\f1746";
}

.mdi-surround-sound::before {
  content: "\\f05c5";
}

.mdi-surround-sound-2-0::before {
  content: "\\f07f0";
}

.mdi-surround-sound-2-1::before {
  content: "\\f1729";
}

.mdi-surround-sound-3-1::before {
  content: "\\f07f1";
}

.mdi-surround-sound-5-1::before {
  content: "\\f07f2";
}

.mdi-surround-sound-5-1-2::before {
  content: "\\f172a";
}

.mdi-surround-sound-7-1::before {
  content: "\\f07f3";
}

.mdi-svg::before {
  content: "\\f0721";
}

.mdi-swap-horizontal::before {
  content: "\\f04e1";
}

.mdi-swap-horizontal-bold::before {
  content: "\\f0bcd";
}

.mdi-swap-horizontal-circle::before {
  content: "\\f0fe1";
}

.mdi-swap-horizontal-circle-outline::before {
  content: "\\f0fe2";
}

.mdi-swap-horizontal-variant::before {
  content: "\\f08c1";
}

.mdi-swap-vertical::before {
  content: "\\f04e2";
}

.mdi-swap-vertical-bold::before {
  content: "\\f0bce";
}

.mdi-swap-vertical-circle::before {
  content: "\\f0fe3";
}

.mdi-swap-vertical-circle-outline::before {
  content: "\\f0fe4";
}

.mdi-swap-vertical-variant::before {
  content: "\\f08c2";
}

.mdi-swim::before {
  content: "\\f04e3";
}

.mdi-switch::before {
  content: "\\f04e4";
}

.mdi-sword::before {
  content: "\\f04e5";
}

.mdi-sword-cross::before {
  content: "\\f0787";
}

.mdi-syllabary-hangul::before {
  content: "\\f1333";
}

.mdi-syllabary-hiragana::before {
  content: "\\f1334";
}

.mdi-syllabary-katakana::before {
  content: "\\f1335";
}

.mdi-syllabary-katakana-halfwidth::before {
  content: "\\f1336";
}

.mdi-symbol::before {
  content: "\\f1501";
}

.mdi-symfony::before {
  content: "\\f0ae6";
}

.mdi-sync::before {
  content: "\\f04e6";
}

.mdi-sync-alert::before {
  content: "\\f04e7";
}

.mdi-sync-circle::before {
  content: "\\f1378";
}

.mdi-sync-off::before {
  content: "\\f04e8";
}

.mdi-tab::before {
  content: "\\f04e9";
}

.mdi-tab-minus::before {
  content: "\\f0b4b";
}

.mdi-tab-plus::before {
  content: "\\f075c";
}

.mdi-tab-remove::before {
  content: "\\f0b4c";
}

.mdi-tab-search::before {
  content: "\\f199e";
}

.mdi-tab-unselected::before {
  content: "\\f04ea";
}

.mdi-table::before {
  content: "\\f04eb";
}

.mdi-table-account::before {
  content: "\\f13b9";
}

.mdi-table-alert::before {
  content: "\\f13ba";
}

.mdi-table-arrow-down::before {
  content: "\\f13bb";
}

.mdi-table-arrow-left::before {
  content: "\\f13bc";
}

.mdi-table-arrow-right::before {
  content: "\\f13bd";
}

.mdi-table-arrow-up::before {
  content: "\\f13be";
}

.mdi-table-border::before {
  content: "\\f0a18";
}

.mdi-table-cancel::before {
  content: "\\f13bf";
}

.mdi-table-chair::before {
  content: "\\f1061";
}

.mdi-table-check::before {
  content: "\\f13c0";
}

.mdi-table-clock::before {
  content: "\\f13c1";
}

.mdi-table-cog::before {
  content: "\\f13c2";
}

.mdi-table-column::before {
  content: "\\f0835";
}

.mdi-table-column-plus-after::before {
  content: "\\f04ec";
}

.mdi-table-column-plus-before::before {
  content: "\\f04ed";
}

.mdi-table-column-remove::before {
  content: "\\f04ee";
}

.mdi-table-column-width::before {
  content: "\\f04ef";
}

.mdi-table-edit::before {
  content: "\\f04f0";
}

.mdi-table-eye::before {
  content: "\\f1094";
}

.mdi-table-eye-off::before {
  content: "\\f13c3";
}

.mdi-table-furniture::before {
  content: "\\f05bc";
}

.mdi-table-headers-eye::before {
  content: "\\f121d";
}

.mdi-table-headers-eye-off::before {
  content: "\\f121e";
}

.mdi-table-heart::before {
  content: "\\f13c4";
}

.mdi-table-key::before {
  content: "\\f13c5";
}

.mdi-table-large::before {
  content: "\\f04f1";
}

.mdi-table-large-plus::before {
  content: "\\f0f87";
}

.mdi-table-large-remove::before {
  content: "\\f0f88";
}

.mdi-table-lock::before {
  content: "\\f13c6";
}

.mdi-table-merge-cells::before {
  content: "\\f09a6";
}

.mdi-table-minus::before {
  content: "\\f13c7";
}

.mdi-table-multiple::before {
  content: "\\f13c8";
}

.mdi-table-network::before {
  content: "\\f13c9";
}

.mdi-table-of-contents::before {
  content: "\\f0836";
}

.mdi-table-off::before {
  content: "\\f13ca";
}

.mdi-table-picnic::before {
  content: "\\f1743";
}

.mdi-table-pivot::before {
  content: "\\f183c";
}

.mdi-table-plus::before {
  content: "\\f0a75";
}

.mdi-table-refresh::before {
  content: "\\f13a0";
}

.mdi-table-remove::before {
  content: "\\f0a76";
}

.mdi-table-row::before {
  content: "\\f0837";
}

.mdi-table-row-height::before {
  content: "\\f04f2";
}

.mdi-table-row-plus-after::before {
  content: "\\f04f3";
}

.mdi-table-row-plus-before::before {
  content: "\\f04f4";
}

.mdi-table-row-remove::before {
  content: "\\f04f5";
}

.mdi-table-search::before {
  content: "\\f090f";
}

.mdi-table-settings::before {
  content: "\\f0838";
}

.mdi-table-split-cell::before {
  content: "\\f142a";
}

.mdi-table-star::before {
  content: "\\f13cb";
}

.mdi-table-sync::before {
  content: "\\f13a1";
}

.mdi-table-tennis::before {
  content: "\\f0e68";
}

.mdi-tablet::before {
  content: "\\f04f6";
}

.mdi-tablet-android::before {
  content: "\\f04f7";
}

.mdi-tablet-cellphone::before {
  content: "\\f09a7";
}

.mdi-tablet-dashboard::before {
  content: "\\f0ece";
}

.mdi-taco::before {
  content: "\\f0762";
}

.mdi-tag::before {
  content: "\\f04f9";
}

.mdi-tag-arrow-down::before {
  content: "\\f172b";
}

.mdi-tag-arrow-down-outline::before {
  content: "\\f172c";
}

.mdi-tag-arrow-left::before {
  content: "\\f172d";
}

.mdi-tag-arrow-left-outline::before {
  content: "\\f172e";
}

.mdi-tag-arrow-right::before {
  content: "\\f172f";
}

.mdi-tag-arrow-right-outline::before {
  content: "\\f1730";
}

.mdi-tag-arrow-up::before {
  content: "\\f1731";
}

.mdi-tag-arrow-up-outline::before {
  content: "\\f1732";
}

.mdi-tag-faces::before {
  content: "\\f04fa";
}

.mdi-tag-heart::before {
  content: "\\f068b";
}

.mdi-tag-heart-outline::before {
  content: "\\f0bcf";
}

.mdi-tag-minus::before {
  content: "\\f0910";
}

.mdi-tag-minus-outline::before {
  content: "\\f121f";
}

.mdi-tag-multiple::before {
  content: "\\f04fb";
}

.mdi-tag-multiple-outline::before {
  content: "\\f12f7";
}

.mdi-tag-off::before {
  content: "\\f1220";
}

.mdi-tag-off-outline::before {
  content: "\\f1221";
}

.mdi-tag-outline::before {
  content: "\\f04fc";
}

.mdi-tag-plus::before {
  content: "\\f0722";
}

.mdi-tag-plus-outline::before {
  content: "\\f1222";
}

.mdi-tag-remove::before {
  content: "\\f0723";
}

.mdi-tag-remove-outline::before {
  content: "\\f1223";
}

.mdi-tag-search::before {
  content: "\\f1907";
}

.mdi-tag-search-outline::before {
  content: "\\f1908";
}

.mdi-tag-text::before {
  content: "\\f1224";
}

.mdi-tag-text-outline::before {
  content: "\\f04fd";
}

.mdi-tailwind::before {
  content: "\\f13ff";
}

.mdi-tangram::before {
  content: "\\f04f8";
}

.mdi-tank::before {
  content: "\\f0d3a";
}

.mdi-tanker-truck::before {
  content: "\\f0fe5";
}

.mdi-tape-drive::before {
  content: "\\f16df";
}

.mdi-tape-measure::before {
  content: "\\f0b4d";
}

.mdi-target::before {
  content: "\\f04fe";
}

.mdi-target-account::before {
  content: "\\f0bd0";
}

.mdi-target-variant::before {
  content: "\\f0a77";
}

.mdi-taxi::before {
  content: "\\f04ff";
}

.mdi-tea::before {
  content: "\\f0d9e";
}

.mdi-tea-outline::before {
  content: "\\f0d9f";
}

.mdi-teamviewer::before {
  content: "\\f0500";
}

.mdi-teddy-bear::before {
  content: "\\f18fb";
}

.mdi-telescope::before {
  content: "\\f0b4e";
}

.mdi-television::before {
  content: "\\f0502";
}

.mdi-television-ambient-light::before {
  content: "\\f1356";
}

.mdi-television-box::before {
  content: "\\f0839";
}

.mdi-television-classic::before {
  content: "\\f07f4";
}

.mdi-television-classic-off::before {
  content: "\\f083a";
}

.mdi-television-guide::before {
  content: "\\f0503";
}

.mdi-television-off::before {
  content: "\\f083b";
}

.mdi-television-pause::before {
  content: "\\f0f89";
}

.mdi-television-play::before {
  content: "\\f0ecf";
}

.mdi-television-shimmer::before {
  content: "\\f1110";
}

.mdi-television-stop::before {
  content: "\\f0f8a";
}

.mdi-temperature-celsius::before {
  content: "\\f0504";
}

.mdi-temperature-fahrenheit::before {
  content: "\\f0505";
}

.mdi-temperature-kelvin::before {
  content: "\\f0506";
}

.mdi-tennis::before {
  content: "\\f0da0";
}

.mdi-tennis-ball::before {
  content: "\\f0507";
}

.mdi-tent::before {
  content: "\\f0508";
}

.mdi-terraform::before {
  content: "\\f1062";
}

.mdi-terrain::before {
  content: "\\f0509";
}

.mdi-test-tube::before {
  content: "\\f0668";
}

.mdi-test-tube-empty::before {
  content: "\\f0911";
}

.mdi-test-tube-off::before {
  content: "\\f0912";
}

.mdi-text::before {
  content: "\\f09a8";
}

.mdi-text-account::before {
  content: "\\f1570";
}

.mdi-text-box::before {
  content: "\\f021a";
}

.mdi-text-box-check::before {
  content: "\\f0ea6";
}

.mdi-text-box-check-outline::before {
  content: "\\f0ea7";
}

.mdi-text-box-minus::before {
  content: "\\f0ea8";
}

.mdi-text-box-minus-outline::before {
  content: "\\f0ea9";
}

.mdi-text-box-multiple::before {
  content: "\\f0ab7";
}

.mdi-text-box-multiple-outline::before {
  content: "\\f0ab8";
}

.mdi-text-box-outline::before {
  content: "\\f09ed";
}

.mdi-text-box-plus::before {
  content: "\\f0eaa";
}

.mdi-text-box-plus-outline::before {
  content: "\\f0eab";
}

.mdi-text-box-remove::before {
  content: "\\f0eac";
}

.mdi-text-box-remove-outline::before {
  content: "\\f0ead";
}

.mdi-text-box-search::before {
  content: "\\f0eae";
}

.mdi-text-box-search-outline::before {
  content: "\\f0eaf";
}

.mdi-text-long::before {
  content: "\\f09aa";
}

.mdi-text-recognition::before {
  content: "\\f113d";
}

.mdi-text-search::before {
  content: "\\f13b8";
}

.mdi-text-shadow::before {
  content: "\\f0669";
}

.mdi-text-short::before {
  content: "\\f09a9";
}

.mdi-text-to-speech::before {
  content: "\\f050a";
}

.mdi-text-to-speech-off::before {
  content: "\\f050b";
}

.mdi-texture::before {
  content: "\\f050c";
}

.mdi-texture-box::before {
  content: "\\f0fe6";
}

.mdi-theater::before {
  content: "\\f050d";
}

.mdi-theme-light-dark::before {
  content: "\\f050e";
}

.mdi-thermometer::before {
  content: "\\f050f";
}

.mdi-thermometer-alert::before {
  content: "\\f0e01";
}

.mdi-thermometer-bluetooth::before {
  content: "\\f1895";
}

.mdi-thermometer-chevron-down::before {
  content: "\\f0e02";
}

.mdi-thermometer-chevron-up::before {
  content: "\\f0e03";
}

.mdi-thermometer-high::before {
  content: "\\f10c2";
}

.mdi-thermometer-lines::before {
  content: "\\f0510";
}

.mdi-thermometer-low::before {
  content: "\\f10c3";
}

.mdi-thermometer-minus::before {
  content: "\\f0e04";
}

.mdi-thermometer-off::before {
  content: "\\f1531";
}

.mdi-thermometer-plus::before {
  content: "\\f0e05";
}

.mdi-thermostat::before {
  content: "\\f0393";
}

.mdi-thermostat-box::before {
  content: "\\f0891";
}

.mdi-thought-bubble::before {
  content: "\\f07f6";
}

.mdi-thought-bubble-outline::before {
  content: "\\f07f7";
}

.mdi-thumb-down::before {
  content: "\\f0511";
}

.mdi-thumb-down-outline::before {
  content: "\\f0512";
}

.mdi-thumb-up::before {
  content: "\\f0513";
}

.mdi-thumb-up-outline::before {
  content: "\\f0514";
}

.mdi-thumbs-up-down::before {
  content: "\\f0515";
}

.mdi-thumbs-up-down-outline::before {
  content: "\\f1914";
}

.mdi-ticket::before {
  content: "\\f0516";
}

.mdi-ticket-account::before {
  content: "\\f0517";
}

.mdi-ticket-confirmation::before {
  content: "\\f0518";
}

.mdi-ticket-confirmation-outline::before {
  content: "\\f13aa";
}

.mdi-ticket-outline::before {
  content: "\\f0913";
}

.mdi-ticket-percent::before {
  content: "\\f0724";
}

.mdi-ticket-percent-outline::before {
  content: "\\f142b";
}

.mdi-tie::before {
  content: "\\f0519";
}

.mdi-tilde::before {
  content: "\\f0725";
}

.mdi-tilde-off::before {
  content: "\\f18f3";
}

.mdi-timelapse::before {
  content: "\\f051a";
}

.mdi-timeline::before {
  content: "\\f0bd1";
}

.mdi-timeline-alert::before {
  content: "\\f0f95";
}

.mdi-timeline-alert-outline::before {
  content: "\\f0f98";
}

.mdi-timeline-check::before {
  content: "\\f1532";
}

.mdi-timeline-check-outline::before {
  content: "\\f1533";
}

.mdi-timeline-clock::before {
  content: "\\f11fb";
}

.mdi-timeline-clock-outline::before {
  content: "\\f11fc";
}

.mdi-timeline-help::before {
  content: "\\f0f99";
}

.mdi-timeline-help-outline::before {
  content: "\\f0f9a";
}

.mdi-timeline-minus::before {
  content: "\\f1534";
}

.mdi-timeline-minus-outline::before {
  content: "\\f1535";
}

.mdi-timeline-outline::before {
  content: "\\f0bd2";
}

.mdi-timeline-plus::before {
  content: "\\f0f96";
}

.mdi-timeline-plus-outline::before {
  content: "\\f0f97";
}

.mdi-timeline-remove::before {
  content: "\\f1536";
}

.mdi-timeline-remove-outline::before {
  content: "\\f1537";
}

.mdi-timeline-text::before {
  content: "\\f0bd3";
}

.mdi-timeline-text-outline::before {
  content: "\\f0bd4";
}

.mdi-timer::before {
  content: "\\f13ab";
}

.mdi-timer-10::before {
  content: "\\f051c";
}

.mdi-timer-3::before {
  content: "\\f051d";
}

.mdi-timer-cog::before {
  content: "\\f1925";
}

.mdi-timer-cog-outline::before {
  content: "\\f1926";
}

.mdi-timer-off::before {
  content: "\\f13ac";
}

.mdi-timer-off-outline::before {
  content: "\\f051e";
}

.mdi-timer-outline::before {
  content: "\\f051b";
}

.mdi-timer-sand::before {
  content: "\\f051f";
}

.mdi-timer-sand-complete::before {
  content: "\\f199f";
}

.mdi-timer-sand-empty::before {
  content: "\\f06ad";
}

.mdi-timer-sand-full::before {
  content: "\\f078c";
}

.mdi-timer-sand-paused::before {
  content: "\\f19a0";
}

.mdi-timer-settings::before {
  content: "\\f1923";
}

.mdi-timer-settings-outline::before {
  content: "\\f1924";
}

.mdi-timetable::before {
  content: "\\f0520";
}

.mdi-tire::before {
  content: "\\f1896";
}

.mdi-toaster::before {
  content: "\\f1063";
}

.mdi-toaster-off::before {
  content: "\\f11b7";
}

.mdi-toaster-oven::before {
  content: "\\f0cd3";
}

.mdi-toggle-switch::before {
  content: "\\f0521";
}

.mdi-toggle-switch-off::before {
  content: "\\f0522";
}

.mdi-toggle-switch-off-outline::before {
  content: "\\f0a19";
}

.mdi-toggle-switch-outline::before {
  content: "\\f0a1a";
}

.mdi-toilet::before {
  content: "\\f09ab";
}

.mdi-toolbox::before {
  content: "\\f09ac";
}

.mdi-toolbox-outline::before {
  content: "\\f09ad";
}

.mdi-tools::before {
  content: "\\f1064";
}

.mdi-tooltip::before {
  content: "\\f0523";
}

.mdi-tooltip-account::before {
  content: "\\f000c";
}

.mdi-tooltip-cellphone::before {
  content: "\\f183b";
}

.mdi-tooltip-check::before {
  content: "\\f155c";
}

.mdi-tooltip-check-outline::before {
  content: "\\f155d";
}

.mdi-tooltip-edit::before {
  content: "\\f0524";
}

.mdi-tooltip-edit-outline::before {
  content: "\\f12c5";
}

.mdi-tooltip-image::before {
  content: "\\f0525";
}

.mdi-tooltip-image-outline::before {
  content: "\\f0bd5";
}

.mdi-tooltip-minus::before {
  content: "\\f155e";
}

.mdi-tooltip-minus-outline::before {
  content: "\\f155f";
}

.mdi-tooltip-outline::before {
  content: "\\f0526";
}

.mdi-tooltip-plus::before {
  content: "\\f0bd6";
}

.mdi-tooltip-plus-outline::before {
  content: "\\f0527";
}

.mdi-tooltip-remove::before {
  content: "\\f1560";
}

.mdi-tooltip-remove-outline::before {
  content: "\\f1561";
}

.mdi-tooltip-text::before {
  content: "\\f0528";
}

.mdi-tooltip-text-outline::before {
  content: "\\f0bd7";
}

.mdi-tooth::before {
  content: "\\f08c3";
}

.mdi-tooth-outline::before {
  content: "\\f0529";
}

.mdi-toothbrush::before {
  content: "\\f1129";
}

.mdi-toothbrush-electric::before {
  content: "\\f112c";
}

.mdi-toothbrush-paste::before {
  content: "\\f112a";
}

.mdi-torch::before {
  content: "\\f1606";
}

.mdi-tortoise::before {
  content: "\\f0d3b";
}

.mdi-toslink::before {
  content: "\\f12b8";
}

.mdi-tournament::before {
  content: "\\f09ae";
}

.mdi-tow-truck::before {
  content: "\\f083c";
}

.mdi-tower-beach::before {
  content: "\\f0681";
}

.mdi-tower-fire::before {
  content: "\\f0682";
}

.mdi-town-hall::before {
  content: "\\f1875";
}

.mdi-toy-brick::before {
  content: "\\f1288";
}

.mdi-toy-brick-marker::before {
  content: "\\f1289";
}

.mdi-toy-brick-marker-outline::before {
  content: "\\f128a";
}

.mdi-toy-brick-minus::before {
  content: "\\f128b";
}

.mdi-toy-brick-minus-outline::before {
  content: "\\f128c";
}

.mdi-toy-brick-outline::before {
  content: "\\f128d";
}

.mdi-toy-brick-plus::before {
  content: "\\f128e";
}

.mdi-toy-brick-plus-outline::before {
  content: "\\f128f";
}

.mdi-toy-brick-remove::before {
  content: "\\f1290";
}

.mdi-toy-brick-remove-outline::before {
  content: "\\f1291";
}

.mdi-toy-brick-search::before {
  content: "\\f1292";
}

.mdi-toy-brick-search-outline::before {
  content: "\\f1293";
}

.mdi-track-light::before {
  content: "\\f0914";
}

.mdi-trackpad::before {
  content: "\\f07f8";
}

.mdi-trackpad-lock::before {
  content: "\\f0933";
}

.mdi-tractor::before {
  content: "\\f0892";
}

.mdi-tractor-variant::before {
  content: "\\f14c4";
}

.mdi-trademark::before {
  content: "\\f0a78";
}

.mdi-traffic-cone::before {
  content: "\\f137c";
}

.mdi-traffic-light::before {
  content: "\\f052b";
}

.mdi-traffic-light-outline::before {
  content: "\\f182a";
}

.mdi-train::before {
  content: "\\f052c";
}

.mdi-train-car::before {
  content: "\\f0bd8";
}

.mdi-train-car-passenger::before {
  content: "\\f1733";
}

.mdi-train-car-passenger-door::before {
  content: "\\f1734";
}

.mdi-train-car-passenger-door-open::before {
  content: "\\f1735";
}

.mdi-train-car-passenger-variant::before {
  content: "\\f1736";
}

.mdi-train-variant::before {
  content: "\\f08c4";
}

.mdi-tram::before {
  content: "\\f052d";
}

.mdi-tram-side::before {
  content: "\\f0fe7";
}

.mdi-transcribe::before {
  content: "\\f052e";
}

.mdi-transcribe-close::before {
  content: "\\f052f";
}

.mdi-transfer::before {
  content: "\\f1065";
}

.mdi-transfer-down::before {
  content: "\\f0da1";
}

.mdi-transfer-left::before {
  content: "\\f0da2";
}

.mdi-transfer-right::before {
  content: "\\f0530";
}

.mdi-transfer-up::before {
  content: "\\f0da3";
}

.mdi-transit-connection::before {
  content: "\\f0d3c";
}

.mdi-transit-connection-horizontal::before {
  content: "\\f1546";
}

.mdi-transit-connection-variant::before {
  content: "\\f0d3d";
}

.mdi-transit-detour::before {
  content: "\\f0f8b";
}

.mdi-transit-skip::before {
  content: "\\f1515";
}

.mdi-transit-transfer::before {
  content: "\\f06ae";
}

.mdi-transition::before {
  content: "\\f0915";
}

.mdi-transition-masked::before {
  content: "\\f0916";
}

.mdi-translate::before {
  content: "\\f05ca";
}

.mdi-translate-off::before {
  content: "\\f0e06";
}

.mdi-transmission-tower::before {
  content: "\\f0d3e";
}

.mdi-transmission-tower-export::before {
  content: "\\f192c";
}

.mdi-transmission-tower-import::before {
  content: "\\f192d";
}

.mdi-trash-can::before {
  content: "\\f0a79";
}

.mdi-trash-can-outline::before {
  content: "\\f0a7a";
}

.mdi-tray::before {
  content: "\\f1294";
}

.mdi-tray-alert::before {
  content: "\\f1295";
}

.mdi-tray-arrow-down::before {
  content: "\\f0120";
}

.mdi-tray-arrow-up::before {
  content: "\\f011d";
}

.mdi-tray-full::before {
  content: "\\f1296";
}

.mdi-tray-minus::before {
  content: "\\f1297";
}

.mdi-tray-plus::before {
  content: "\\f1298";
}

.mdi-tray-remove::before {
  content: "\\f1299";
}

.mdi-treasure-chest::before {
  content: "\\f0726";
}

.mdi-tree::before {
  content: "\\f0531";
}

.mdi-tree-outline::before {
  content: "\\f0e69";
}

.mdi-trello::before {
  content: "\\f0532";
}

.mdi-trending-down::before {
  content: "\\f0533";
}

.mdi-trending-neutral::before {
  content: "\\f0534";
}

.mdi-trending-up::before {
  content: "\\f0535";
}

.mdi-triangle::before {
  content: "\\f0536";
}

.mdi-triangle-outline::before {
  content: "\\f0537";
}

.mdi-triangle-wave::before {
  content: "\\f147c";
}

.mdi-triforce::before {
  content: "\\f0bd9";
}

.mdi-trophy::before {
  content: "\\f0538";
}

.mdi-trophy-award::before {
  content: "\\f0539";
}

.mdi-trophy-broken::before {
  content: "\\f0da4";
}

.mdi-trophy-outline::before {
  content: "\\f053a";
}

.mdi-trophy-variant::before {
  content: "\\f053b";
}

.mdi-trophy-variant-outline::before {
  content: "\\f053c";
}

.mdi-truck::before {
  content: "\\f053d";
}

.mdi-truck-cargo-container::before {
  content: "\\f18d8";
}

.mdi-truck-check::before {
  content: "\\f0cd4";
}

.mdi-truck-check-outline::before {
  content: "\\f129a";
}

.mdi-truck-delivery::before {
  content: "\\f053e";
}

.mdi-truck-delivery-outline::before {
  content: "\\f129b";
}

.mdi-truck-fast::before {
  content: "\\f0788";
}

.mdi-truck-fast-outline::before {
  content: "\\f129c";
}

.mdi-truck-flatbed::before {
  content: "\\f1891";
}

.mdi-truck-minus::before {
  content: "\\f19ae";
}

.mdi-truck-minus-outline::before {
  content: "\\f19bd";
}

.mdi-truck-outline::before {
  content: "\\f129d";
}

.mdi-truck-plus::before {
  content: "\\f19ad";
}

.mdi-truck-plus-outline::before {
  content: "\\f19bc";
}

.mdi-truck-remove::before {
  content: "\\f19af";
}

.mdi-truck-remove-outline::before {
  content: "\\f19be";
}

.mdi-truck-snowflake::before {
  content: "\\f19a6";
}

.mdi-truck-trailer::before {
  content: "\\f0727";
}

.mdi-trumpet::before {
  content: "\\f1096";
}

.mdi-tshirt-crew::before {
  content: "\\f0a7b";
}

.mdi-tshirt-crew-outline::before {
  content: "\\f053f";
}

.mdi-tshirt-v::before {
  content: "\\f0a7c";
}

.mdi-tshirt-v-outline::before {
  content: "\\f0540";
}

.mdi-tumble-dryer::before {
  content: "\\f0917";
}

.mdi-tumble-dryer-alert::before {
  content: "\\f11ba";
}

.mdi-tumble-dryer-off::before {
  content: "\\f11bb";
}

.mdi-tune::before {
  content: "\\f062e";
}

.mdi-tune-variant::before {
  content: "\\f1542";
}

.mdi-tune-vertical::before {
  content: "\\f066a";
}

.mdi-tune-vertical-variant::before {
  content: "\\f1543";
}

.mdi-tunnel::before {
  content: "\\f183d";
}

.mdi-tunnel-outline::before {
  content: "\\f183e";
}

.mdi-turkey::before {
  content: "\\f171b";
}

.mdi-turnstile::before {
  content: "\\f0cd5";
}

.mdi-turnstile-outline::before {
  content: "\\f0cd6";
}

.mdi-turtle::before {
  content: "\\f0cd7";
}

.mdi-twitch::before {
  content: "\\f0543";
}

.mdi-twitter::before {
  content: "\\f0544";
}

.mdi-two-factor-authentication::before {
  content: "\\f09af";
}

.mdi-typewriter::before {
  content: "\\f0f2d";
}

.mdi-ubisoft::before {
  content: "\\f0bda";
}

.mdi-ubuntu::before {
  content: "\\f0548";
}

.mdi-ufo::before {
  content: "\\f10c4";
}

.mdi-ufo-outline::before {
  content: "\\f10c5";
}

.mdi-ultra-high-definition::before {
  content: "\\f07f9";
}

.mdi-umbraco::before {
  content: "\\f0549";
}

.mdi-umbrella::before {
  content: "\\f054a";
}

.mdi-umbrella-beach::before {
  content: "\\f188a";
}

.mdi-umbrella-beach-outline::before {
  content: "\\f188b";
}

.mdi-umbrella-closed::before {
  content: "\\f09b0";
}

.mdi-umbrella-closed-outline::before {
  content: "\\f13e2";
}

.mdi-umbrella-closed-variant::before {
  content: "\\f13e1";
}

.mdi-umbrella-outline::before {
  content: "\\f054b";
}

.mdi-undo::before {
  content: "\\f054c";
}

.mdi-undo-variant::before {
  content: "\\f054d";
}

.mdi-unfold-less-horizontal::before {
  content: "\\f054e";
}

.mdi-unfold-less-vertical::before {
  content: "\\f0760";
}

.mdi-unfold-more-horizontal::before {
  content: "\\f054f";
}

.mdi-unfold-more-vertical::before {
  content: "\\f0761";
}

.mdi-ungroup::before {
  content: "\\f0550";
}

.mdi-unicode::before {
  content: "\\f0ed0";
}

.mdi-unicorn::before {
  content: "\\f15c2";
}

.mdi-unicorn-variant::before {
  content: "\\f15c3";
}

.mdi-unicycle::before {
  content: "\\f15e5";
}

.mdi-unity::before {
  content: "\\f06af";
}

.mdi-unreal::before {
  content: "\\f09b1";
}

.mdi-update::before {
  content: "\\f06b0";
}

.mdi-upload::before {
  content: "\\f0552";
}

.mdi-upload-lock::before {
  content: "\\f1373";
}

.mdi-upload-lock-outline::before {
  content: "\\f1374";
}

.mdi-upload-multiple::before {
  content: "\\f083d";
}

.mdi-upload-network::before {
  content: "\\f06f6";
}

.mdi-upload-network-outline::before {
  content: "\\f0cd8";
}

.mdi-upload-off::before {
  content: "\\f10c6";
}

.mdi-upload-off-outline::before {
  content: "\\f10c7";
}

.mdi-upload-outline::before {
  content: "\\f0e07";
}

.mdi-usb::before {
  content: "\\f0553";
}

.mdi-usb-flash-drive::before {
  content: "\\f129e";
}

.mdi-usb-flash-drive-outline::before {
  content: "\\f129f";
}

.mdi-usb-port::before {
  content: "\\f11f0";
}

.mdi-vacuum::before {
  content: "\\f19a1";
}

.mdi-vacuum-outline::before {
  content: "\\f19a2";
}

.mdi-valve::before {
  content: "\\f1066";
}

.mdi-valve-closed::before {
  content: "\\f1067";
}

.mdi-valve-open::before {
  content: "\\f1068";
}

.mdi-van-passenger::before {
  content: "\\f07fa";
}

.mdi-van-utility::before {
  content: "\\f07fb";
}

.mdi-vanish::before {
  content: "\\f07fc";
}

.mdi-vanish-quarter::before {
  content: "\\f1554";
}

.mdi-vanity-light::before {
  content: "\\f11e1";
}

.mdi-variable::before {
  content: "\\f0ae7";
}

.mdi-variable-box::before {
  content: "\\f1111";
}

.mdi-vector-arrange-above::before {
  content: "\\f0554";
}

.mdi-vector-arrange-below::before {
  content: "\\f0555";
}

.mdi-vector-bezier::before {
  content: "\\f0ae8";
}

.mdi-vector-circle::before {
  content: "\\f0556";
}

.mdi-vector-circle-variant::before {
  content: "\\f0557";
}

.mdi-vector-combine::before {
  content: "\\f0558";
}

.mdi-vector-curve::before {
  content: "\\f0559";
}

.mdi-vector-difference::before {
  content: "\\f055a";
}

.mdi-vector-difference-ab::before {
  content: "\\f055b";
}

.mdi-vector-difference-ba::before {
  content: "\\f055c";
}

.mdi-vector-ellipse::before {
  content: "\\f0893";
}

.mdi-vector-intersection::before {
  content: "\\f055d";
}

.mdi-vector-line::before {
  content: "\\f055e";
}

.mdi-vector-link::before {
  content: "\\f0fe8";
}

.mdi-vector-point::before {
  content: "\\f055f";
}

.mdi-vector-polygon::before {
  content: "\\f0560";
}

.mdi-vector-polygon-variant::before {
  content: "\\f1856";
}

.mdi-vector-polyline::before {
  content: "\\f0561";
}

.mdi-vector-polyline-edit::before {
  content: "\\f1225";
}

.mdi-vector-polyline-minus::before {
  content: "\\f1226";
}

.mdi-vector-polyline-plus::before {
  content: "\\f1227";
}

.mdi-vector-polyline-remove::before {
  content: "\\f1228";
}

.mdi-vector-radius::before {
  content: "\\f074a";
}

.mdi-vector-rectangle::before {
  content: "\\f05c6";
}

.mdi-vector-selection::before {
  content: "\\f0562";
}

.mdi-vector-square::before {
  content: "\\f0001";
}

.mdi-vector-square-close::before {
  content: "\\f1857";
}

.mdi-vector-square-edit::before {
  content: "\\f18d9";
}

.mdi-vector-square-minus::before {
  content: "\\f18da";
}

.mdi-vector-square-open::before {
  content: "\\f1858";
}

.mdi-vector-square-plus::before {
  content: "\\f18db";
}

.mdi-vector-square-remove::before {
  content: "\\f18dc";
}

.mdi-vector-triangle::before {
  content: "\\f0563";
}

.mdi-vector-union::before {
  content: "\\f0564";
}

.mdi-vhs::before {
  content: "\\f0a1b";
}

.mdi-vibrate::before {
  content: "\\f0566";
}

.mdi-vibrate-off::before {
  content: "\\f0cd9";
}

.mdi-video::before {
  content: "\\f0567";
}

.mdi-video-3d::before {
  content: "\\f07fd";
}

.mdi-video-3d-off::before {
  content: "\\f13d9";
}

.mdi-video-3d-variant::before {
  content: "\\f0ed1";
}

.mdi-video-4k-box::before {
  content: "\\f083e";
}

.mdi-video-account::before {
  content: "\\f0919";
}

.mdi-video-box::before {
  content: "\\f00fd";
}

.mdi-video-box-off::before {
  content: "\\f00fe";
}

.mdi-video-check::before {
  content: "\\f1069";
}

.mdi-video-check-outline::before {
  content: "\\f106a";
}

.mdi-video-high-definition::before {
  content: "\\f152e";
}

.mdi-video-image::before {
  content: "\\f091a";
}

.mdi-video-input-antenna::before {
  content: "\\f083f";
}

.mdi-video-input-component::before {
  content: "\\f0840";
}

.mdi-video-input-hdmi::before {
  content: "\\f0841";
}

.mdi-video-input-scart::before {
  content: "\\f0f8c";
}

.mdi-video-input-svideo::before {
  content: "\\f0842";
}

.mdi-video-marker::before {
  content: "\\f19a9";
}

.mdi-video-marker-outline::before {
  content: "\\f19aa";
}

.mdi-video-minus::before {
  content: "\\f09b2";
}

.mdi-video-minus-outline::before {
  content: "\\f02ba";
}

.mdi-video-off::before {
  content: "\\f0568";
}

.mdi-video-off-outline::before {
  content: "\\f0bdb";
}

.mdi-video-outline::before {
  content: "\\f0bdc";
}

.mdi-video-plus::before {
  content: "\\f09b3";
}

.mdi-video-plus-outline::before {
  content: "\\f01d3";
}

.mdi-video-stabilization::before {
  content: "\\f091b";
}

.mdi-video-switch::before {
  content: "\\f0569";
}

.mdi-video-switch-outline::before {
  content: "\\f0790";
}

.mdi-video-vintage::before {
  content: "\\f0a1c";
}

.mdi-video-wireless::before {
  content: "\\f0ed2";
}

.mdi-video-wireless-outline::before {
  content: "\\f0ed3";
}

.mdi-view-agenda::before {
  content: "\\f056a";
}

.mdi-view-agenda-outline::before {
  content: "\\f11d8";
}

.mdi-view-array::before {
  content: "\\f056b";
}

.mdi-view-array-outline::before {
  content: "\\f1485";
}

.mdi-view-carousel::before {
  content: "\\f056c";
}

.mdi-view-carousel-outline::before {
  content: "\\f1486";
}

.mdi-view-column::before {
  content: "\\f056d";
}

.mdi-view-column-outline::before {
  content: "\\f1487";
}

.mdi-view-comfy::before {
  content: "\\f0e6a";
}

.mdi-view-comfy-outline::before {
  content: "\\f1488";
}

.mdi-view-compact::before {
  content: "\\f0e6b";
}

.mdi-view-compact-outline::before {
  content: "\\f0e6c";
}

.mdi-view-dashboard::before {
  content: "\\f056e";
}

.mdi-view-dashboard-edit::before {
  content: "\\f1947";
}

.mdi-view-dashboard-edit-outline::before {
  content: "\\f1948";
}

.mdi-view-dashboard-outline::before {
  content: "\\f0a1d";
}

.mdi-view-dashboard-variant::before {
  content: "\\f0843";
}

.mdi-view-dashboard-variant-outline::before {
  content: "\\f1489";
}

.mdi-view-day::before {
  content: "\\f056f";
}

.mdi-view-day-outline::before {
  content: "\\f148a";
}

.mdi-view-gallery::before {
  content: "\\f1888";
}

.mdi-view-gallery-outline::before {
  content: "\\f1889";
}

.mdi-view-grid::before {
  content: "\\f0570";
}

.mdi-view-grid-outline::before {
  content: "\\f11d9";
}

.mdi-view-grid-plus::before {
  content: "\\f0f8d";
}

.mdi-view-grid-plus-outline::before {
  content: "\\f11da";
}

.mdi-view-headline::before {
  content: "\\f0571";
}

.mdi-view-list::before {
  content: "\\f0572";
}

.mdi-view-list-outline::before {
  content: "\\f148b";
}

.mdi-view-module::before {
  content: "\\f0573";
}

.mdi-view-module-outline::before {
  content: "\\f148c";
}

.mdi-view-parallel::before {
  content: "\\f0728";
}

.mdi-view-parallel-outline::before {
  content: "\\f148d";
}

.mdi-view-quilt::before {
  content: "\\f0574";
}

.mdi-view-quilt-outline::before {
  content: "\\f148e";
}

.mdi-view-sequential::before {
  content: "\\f0729";
}

.mdi-view-sequential-outline::before {
  content: "\\f148f";
}

.mdi-view-split-horizontal::before {
  content: "\\f0bcb";
}

.mdi-view-split-vertical::before {
  content: "\\f0bcc";
}

.mdi-view-stream::before {
  content: "\\f0575";
}

.mdi-view-stream-outline::before {
  content: "\\f1490";
}

.mdi-view-week::before {
  content: "\\f0576";
}

.mdi-view-week-outline::before {
  content: "\\f1491";
}

.mdi-vimeo::before {
  content: "\\f0577";
}

.mdi-violin::before {
  content: "\\f060f";
}

.mdi-virtual-reality::before {
  content: "\\f0894";
}

.mdi-virus::before {
  content: "\\f13b6";
}

.mdi-virus-off::before {
  content: "\\f18e1";
}

.mdi-virus-off-outline::before {
  content: "\\f18e2";
}

.mdi-virus-outline::before {
  content: "\\f13b7";
}

.mdi-vlc::before {
  content: "\\f057c";
}

.mdi-voicemail::before {
  content: "\\f057d";
}

.mdi-volleyball::before {
  content: "\\f09b4";
}

.mdi-volume-high::before {
  content: "\\f057e";
}

.mdi-volume-low::before {
  content: "\\f057f";
}

.mdi-volume-medium::before {
  content: "\\f0580";
}

.mdi-volume-minus::before {
  content: "\\f075e";
}

.mdi-volume-mute::before {
  content: "\\f075f";
}

.mdi-volume-off::before {
  content: "\\f0581";
}

.mdi-volume-plus::before {
  content: "\\f075d";
}

.mdi-volume-source::before {
  content: "\\f1120";
}

.mdi-volume-variant-off::before {
  content: "\\f0e08";
}

.mdi-volume-vibrate::before {
  content: "\\f1121";
}

.mdi-vote::before {
  content: "\\f0a1f";
}

.mdi-vote-outline::before {
  content: "\\f0a20";
}

.mdi-vpn::before {
  content: "\\f0582";
}

.mdi-vuejs::before {
  content: "\\f0844";
}

.mdi-vuetify::before {
  content: "\\f0e6d";
}

.mdi-walk::before {
  content: "\\f0583";
}

.mdi-wall::before {
  content: "\\f07fe";
}

.mdi-wall-sconce::before {
  content: "\\f091c";
}

.mdi-wall-sconce-flat::before {
  content: "\\f091d";
}

.mdi-wall-sconce-flat-outline::before {
  content: "\\f17c9";
}

.mdi-wall-sconce-flat-variant::before {
  content: "\\f041c";
}

.mdi-wall-sconce-flat-variant-outline::before {
  content: "\\f17ca";
}

.mdi-wall-sconce-outline::before {
  content: "\\f17cb";
}

.mdi-wall-sconce-round::before {
  content: "\\f0748";
}

.mdi-wall-sconce-round-outline::before {
  content: "\\f17cc";
}

.mdi-wall-sconce-round-variant::before {
  content: "\\f091e";
}

.mdi-wall-sconce-round-variant-outline::before {
  content: "\\f17cd";
}

.mdi-wallet::before {
  content: "\\f0584";
}

.mdi-wallet-giftcard::before {
  content: "\\f0585";
}

.mdi-wallet-membership::before {
  content: "\\f0586";
}

.mdi-wallet-outline::before {
  content: "\\f0bdd";
}

.mdi-wallet-plus::before {
  content: "\\f0f8e";
}

.mdi-wallet-plus-outline::before {
  content: "\\f0f8f";
}

.mdi-wallet-travel::before {
  content: "\\f0587";
}

.mdi-wallpaper::before {
  content: "\\f0e09";
}

.mdi-wan::before {
  content: "\\f0588";
}

.mdi-wardrobe::before {
  content: "\\f0f90";
}

.mdi-wardrobe-outline::before {
  content: "\\f0f91";
}

.mdi-warehouse::before {
  content: "\\f0f81";
}

.mdi-washing-machine::before {
  content: "\\f072a";
}

.mdi-washing-machine-alert::before {
  content: "\\f11bc";
}

.mdi-washing-machine-off::before {
  content: "\\f11bd";
}

.mdi-watch::before {
  content: "\\f0589";
}

.mdi-watch-export::before {
  content: "\\f058a";
}

.mdi-watch-export-variant::before {
  content: "\\f0895";
}

.mdi-watch-import::before {
  content: "\\f058b";
}

.mdi-watch-import-variant::before {
  content: "\\f0896";
}

.mdi-watch-variant::before {
  content: "\\f0897";
}

.mdi-watch-vibrate::before {
  content: "\\f06b1";
}

.mdi-watch-vibrate-off::before {
  content: "\\f0cda";
}

.mdi-water::before {
  content: "\\f058c";
}

.mdi-water-alert::before {
  content: "\\f1502";
}

.mdi-water-alert-outline::before {
  content: "\\f1503";
}

.mdi-water-boiler::before {
  content: "\\f0f92";
}

.mdi-water-boiler-alert::before {
  content: "\\f11b3";
}

.mdi-water-boiler-off::before {
  content: "\\f11b4";
}

.mdi-water-check::before {
  content: "\\f1504";
}

.mdi-water-check-outline::before {
  content: "\\f1505";
}

.mdi-water-circle::before {
  content: "\\f1806";
}

.mdi-water-minus::before {
  content: "\\f1506";
}

.mdi-water-minus-outline::before {
  content: "\\f1507";
}

.mdi-water-off::before {
  content: "\\f058d";
}

.mdi-water-off-outline::before {
  content: "\\f1508";
}

.mdi-water-opacity::before {
  content: "\\f1855";
}

.mdi-water-outline::before {
  content: "\\f0e0a";
}

.mdi-water-percent::before {
  content: "\\f058e";
}

.mdi-water-percent-alert::before {
  content: "\\f1509";
}

.mdi-water-plus::before {
  content: "\\f150a";
}

.mdi-water-plus-outline::before {
  content: "\\f150b";
}

.mdi-water-polo::before {
  content: "\\f12a0";
}

.mdi-water-pump::before {
  content: "\\f058f";
}

.mdi-water-pump-off::before {
  content: "\\f0f93";
}

.mdi-water-remove::before {
  content: "\\f150c";
}

.mdi-water-remove-outline::before {
  content: "\\f150d";
}

.mdi-water-sync::before {
  content: "\\f17c6";
}

.mdi-water-well::before {
  content: "\\f106b";
}

.mdi-water-well-outline::before {
  content: "\\f106c";
}

.mdi-waterfall::before {
  content: "\\f1849";
}

.mdi-watering-can::before {
  content: "\\f1481";
}

.mdi-watering-can-outline::before {
  content: "\\f1482";
}

.mdi-watermark::before {
  content: "\\f0612";
}

.mdi-wave::before {
  content: "\\f0f2e";
}

.mdi-waveform::before {
  content: "\\f147d";
}

.mdi-waves::before {
  content: "\\f078d";
}

.mdi-waves-arrow-left::before {
  content: "\\f1859";
}

.mdi-waves-arrow-right::before {
  content: "\\f185a";
}

.mdi-waves-arrow-up::before {
  content: "\\f185b";
}

.mdi-waze::before {
  content: "\\f0bde";
}

.mdi-weather-cloudy::before {
  content: "\\f0590";
}

.mdi-weather-cloudy-alert::before {
  content: "\\f0f2f";
}

.mdi-weather-cloudy-arrow-right::before {
  content: "\\f0e6e";
}

.mdi-weather-cloudy-clock::before {
  content: "\\f18f6";
}

.mdi-weather-fog::before {
  content: "\\f0591";
}

.mdi-weather-hail::before {
  content: "\\f0592";
}

.mdi-weather-hazy::before {
  content: "\\f0f30";
}

.mdi-weather-hurricane::before {
  content: "\\f0898";
}

.mdi-weather-lightning::before {
  content: "\\f0593";
}

.mdi-weather-lightning-rainy::before {
  content: "\\f067e";
}

.mdi-weather-night::before {
  content: "\\f0594";
}

.mdi-weather-night-partly-cloudy::before {
  content: "\\f0f31";
}

.mdi-weather-partly-cloudy::before {
  content: "\\f0595";
}

.mdi-weather-partly-lightning::before {
  content: "\\f0f32";
}

.mdi-weather-partly-rainy::before {
  content: "\\f0f33";
}

.mdi-weather-partly-snowy::before {
  content: "\\f0f34";
}

.mdi-weather-partly-snowy-rainy::before {
  content: "\\f0f35";
}

.mdi-weather-pouring::before {
  content: "\\f0596";
}

.mdi-weather-rainy::before {
  content: "\\f0597";
}

.mdi-weather-snowy::before {
  content: "\\f0598";
}

.mdi-weather-snowy-heavy::before {
  content: "\\f0f36";
}

.mdi-weather-snowy-rainy::before {
  content: "\\f067f";
}

.mdi-weather-sunny::before {
  content: "\\f0599";
}

.mdi-weather-sunny-alert::before {
  content: "\\f0f37";
}

.mdi-weather-sunny-off::before {
  content: "\\f14e4";
}

.mdi-weather-sunset::before {
  content: "\\f059a";
}

.mdi-weather-sunset-down::before {
  content: "\\f059b";
}

.mdi-weather-sunset-up::before {
  content: "\\f059c";
}

.mdi-weather-tornado::before {
  content: "\\f0f38";
}

.mdi-weather-windy::before {
  content: "\\f059d";
}

.mdi-weather-windy-variant::before {
  content: "\\f059e";
}

.mdi-web::before {
  content: "\\f059f";
}

.mdi-web-box::before {
  content: "\\f0f94";
}

.mdi-web-cancel::before {
  content: "\\f1790";
}

.mdi-web-check::before {
  content: "\\f0789";
}

.mdi-web-clock::before {
  content: "\\f124a";
}

.mdi-web-minus::before {
  content: "\\f10a0";
}

.mdi-web-off::before {
  content: "\\f0a8e";
}

.mdi-web-plus::before {
  content: "\\f0033";
}

.mdi-web-refresh::before {
  content: "\\f1791";
}

.mdi-web-remove::before {
  content: "\\f0551";
}

.mdi-web-sync::before {
  content: "\\f1792";
}

.mdi-webcam::before {
  content: "\\f05a0";
}

.mdi-webcam-off::before {
  content: "\\f1737";
}

.mdi-webhook::before {
  content: "\\f062f";
}

.mdi-webpack::before {
  content: "\\f072b";
}

.mdi-webrtc::before {
  content: "\\f1248";
}

.mdi-wechat::before {
  content: "\\f0611";
}

.mdi-weight::before {
  content: "\\f05a1";
}

.mdi-weight-gram::before {
  content: "\\f0d3f";
}

.mdi-weight-kilogram::before {
  content: "\\f05a2";
}

.mdi-weight-lifter::before {
  content: "\\f115d";
}

.mdi-weight-pound::before {
  content: "\\f09b5";
}

.mdi-whatsapp::before {
  content: "\\f05a3";
}

.mdi-wheel-barrow::before {
  content: "\\f14f2";
}

.mdi-wheelchair-accessibility::before {
  content: "\\f05a4";
}

.mdi-whistle::before {
  content: "\\f09b6";
}

.mdi-whistle-outline::before {
  content: "\\f12bc";
}

.mdi-white-balance-auto::before {
  content: "\\f05a5";
}

.mdi-white-balance-incandescent::before {
  content: "\\f05a6";
}

.mdi-white-balance-iridescent::before {
  content: "\\f05a7";
}

.mdi-white-balance-sunny::before {
  content: "\\f05a8";
}

.mdi-widgets::before {
  content: "\\f072c";
}

.mdi-widgets-outline::before {
  content: "\\f1355";
}

.mdi-wifi::before {
  content: "\\f05a9";
}

.mdi-wifi-alert::before {
  content: "\\f16b5";
}

.mdi-wifi-arrow-down::before {
  content: "\\f16b6";
}

.mdi-wifi-arrow-left::before {
  content: "\\f16b7";
}

.mdi-wifi-arrow-left-right::before {
  content: "\\f16b8";
}

.mdi-wifi-arrow-right::before {
  content: "\\f16b9";
}

.mdi-wifi-arrow-up::before {
  content: "\\f16ba";
}

.mdi-wifi-arrow-up-down::before {
  content: "\\f16bb";
}

.mdi-wifi-cancel::before {
  content: "\\f16bc";
}

.mdi-wifi-check::before {
  content: "\\f16bd";
}

.mdi-wifi-cog::before {
  content: "\\f16be";
}

.mdi-wifi-lock::before {
  content: "\\f16bf";
}

.mdi-wifi-lock-open::before {
  content: "\\f16c0";
}

.mdi-wifi-marker::before {
  content: "\\f16c1";
}

.mdi-wifi-minus::before {
  content: "\\f16c2";
}

.mdi-wifi-off::before {
  content: "\\f05aa";
}

.mdi-wifi-plus::before {
  content: "\\f16c3";
}

.mdi-wifi-refresh::before {
  content: "\\f16c4";
}

.mdi-wifi-remove::before {
  content: "\\f16c5";
}

.mdi-wifi-settings::before {
  content: "\\f16c6";
}

.mdi-wifi-star::before {
  content: "\\f0e0b";
}

.mdi-wifi-strength-1::before {
  content: "\\f091f";
}

.mdi-wifi-strength-1-alert::before {
  content: "\\f0920";
}

.mdi-wifi-strength-1-lock::before {
  content: "\\f0921";
}

.mdi-wifi-strength-1-lock-open::before {
  content: "\\f16cb";
}

.mdi-wifi-strength-2::before {
  content: "\\f0922";
}

.mdi-wifi-strength-2-alert::before {
  content: "\\f0923";
}

.mdi-wifi-strength-2-lock::before {
  content: "\\f0924";
}

.mdi-wifi-strength-2-lock-open::before {
  content: "\\f16cc";
}

.mdi-wifi-strength-3::before {
  content: "\\f0925";
}

.mdi-wifi-strength-3-alert::before {
  content: "\\f0926";
}

.mdi-wifi-strength-3-lock::before {
  content: "\\f0927";
}

.mdi-wifi-strength-3-lock-open::before {
  content: "\\f16cd";
}

.mdi-wifi-strength-4::before {
  content: "\\f0928";
}

.mdi-wifi-strength-4-alert::before {
  content: "\\f0929";
}

.mdi-wifi-strength-4-lock::before {
  content: "\\f092a";
}

.mdi-wifi-strength-4-lock-open::before {
  content: "\\f16ce";
}

.mdi-wifi-strength-alert-outline::before {
  content: "\\f092b";
}

.mdi-wifi-strength-lock-open-outline::before {
  content: "\\f16cf";
}

.mdi-wifi-strength-lock-outline::before {
  content: "\\f092c";
}

.mdi-wifi-strength-off::before {
  content: "\\f092d";
}

.mdi-wifi-strength-off-outline::before {
  content: "\\f092e";
}

.mdi-wifi-strength-outline::before {
  content: "\\f092f";
}

.mdi-wifi-sync::before {
  content: "\\f16c7";
}

.mdi-wikipedia::before {
  content: "\\f05ac";
}

.mdi-wind-turbine::before {
  content: "\\f0da5";
}

.mdi-wind-turbine-alert::before {
  content: "\\f19ab";
}

.mdi-wind-turbine-check::before {
  content: "\\f19ac";
}

.mdi-window-close::before {
  content: "\\f05ad";
}

.mdi-window-closed::before {
  content: "\\f05ae";
}

.mdi-window-closed-variant::before {
  content: "\\f11db";
}

.mdi-window-maximize::before {
  content: "\\f05af";
}

.mdi-window-minimize::before {
  content: "\\f05b0";
}

.mdi-window-open::before {
  content: "\\f05b1";
}

.mdi-window-open-variant::before {
  content: "\\f11dc";
}

.mdi-window-restore::before {
  content: "\\f05b2";
}

.mdi-window-shutter::before {
  content: "\\f111c";
}

.mdi-window-shutter-alert::before {
  content: "\\f111d";
}

.mdi-window-shutter-open::before {
  content: "\\f111e";
}

.mdi-windsock::before {
  content: "\\f15fa";
}

.mdi-wiper::before {
  content: "\\f0ae9";
}

.mdi-wiper-wash::before {
  content: "\\f0da6";
}

.mdi-wiper-wash-alert::before {
  content: "\\f18df";
}

.mdi-wizard-hat::before {
  content: "\\f1477";
}

.mdi-wordpress::before {
  content: "\\f05b4";
}

.mdi-wrap::before {
  content: "\\f05b6";
}

.mdi-wrap-disabled::before {
  content: "\\f0bdf";
}

.mdi-wrench::before {
  content: "\\f05b7";
}

.mdi-wrench-clock::before {
  content: "\\f19a3";
}

.mdi-wrench-outline::before {
  content: "\\f0be0";
}

.mdi-xamarin::before {
  content: "\\f0845";
}

.mdi-xml::before {
  content: "\\f05c0";
}

.mdi-xmpp::before {
  content: "\\f07ff";
}

.mdi-yahoo::before {
  content: "\\f0b4f";
}

.mdi-yeast::before {
  content: "\\f05c1";
}

.mdi-yin-yang::before {
  content: "\\f0680";
}

.mdi-yoga::before {
  content: "\\f117c";
}

.mdi-youtube::before {
  content: "\\f05c3";
}

.mdi-youtube-gaming::before {
  content: "\\f0848";
}

.mdi-youtube-studio::before {
  content: "\\f0847";
}

.mdi-youtube-subscription::before {
  content: "\\f0d40";
}

.mdi-youtube-tv::before {
  content: "\\f0448";
}

.mdi-yurt::before {
  content: "\\f1516";
}

.mdi-z-wave::before {
  content: "\\f0aea";
}

.mdi-zend::before {
  content: "\\f0aeb";
}

.mdi-zigbee::before {
  content: "\\f0d41";
}

.mdi-zip-box::before {
  content: "\\f05c4";
}

.mdi-zip-box-outline::before {
  content: "\\f0ffa";
}

.mdi-zip-disk::before {
  content: "\\f0a23";
}

.mdi-zodiac-aquarius::before {
  content: "\\f0a7d";
}

.mdi-zodiac-aries::before {
  content: "\\f0a7e";
}

.mdi-zodiac-cancer::before {
  content: "\\f0a7f";
}

.mdi-zodiac-capricorn::before {
  content: "\\f0a80";
}

.mdi-zodiac-gemini::before {
  content: "\\f0a81";
}

.mdi-zodiac-leo::before {
  content: "\\f0a82";
}

.mdi-zodiac-libra::before {
  content: "\\f0a83";
}

.mdi-zodiac-pisces::before {
  content: "\\f0a84";
}

.mdi-zodiac-sagittarius::before {
  content: "\\f0a85";
}

.mdi-zodiac-scorpio::before {
  content: "\\f0a86";
}

.mdi-zodiac-taurus::before {
  content: "\\f0a87";
}

.mdi-zodiac-virgo::before {
  content: "\\f0a88";
}

.mdi-blank::before {
  content: "\\f68c";
  visibility: hidden;
}

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px;
}

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px;
}

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px;
}

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px;
}

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54);
}

.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26);
}

.mdi-light:before {
  color: white;
}

.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3);
}

.mdi-rotate-45 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(45deg);
            transform: scaleX(-1) rotate(45deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: scaleY(-1) rotate(45deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-45:before {
  transform: rotate(45deg);
}

.mdi-rotate-90 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(90deg);
            transform: scaleX(-1) rotate(90deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: scaleY(-1) rotate(90deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-90:before {
  transform: rotate(90deg);
}

.mdi-rotate-135 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(135deg);
            -ms-transform: rotate(135deg);
            transform: scaleY(-1) rotate(135deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-135:before {
  transform: rotate(135deg);
}

.mdi-rotate-180 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(180deg);
            transform: scaleX(-1) rotate(180deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: scaleY(-1) rotate(180deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-180:before {
  transform: rotate(180deg);
}

.mdi-rotate-225 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(225deg);
            transform: scaleX(-1) rotate(225deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: scaleY(-1) rotate(225deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-225:before {
  transform: rotate(225deg);
}

.mdi-rotate-270 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(270deg);
            transform: scaleX(-1) rotate(270deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: scaleY(-1) rotate(270deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-270:before {
  transform: rotate(270deg);
}

.mdi-rotate-315 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(315deg);
            transform: scaleX(-1) rotate(315deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(315deg);
            -ms-transform: rotate(315deg);
            transform: scaleY(-1) rotate(315deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-315:before {
  transform: rotate(315deg);
}

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear;
}
@keyframes mdi-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/scss/Saas.scss","webpack://./src/assets/scss/app.scss","webpack://./src/assets/scss/config/saas/_variables.scss","webpack://./src/assets/scss/config/saas/_light-mode.scss","webpack://./src/assets/scss/config/saas/_dark-mode.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/custom/structure/_general.scss","webpack://./src/assets/scss/custom/structure/_left-menu.scss","webpack://./src/assets/scss/config/saas/_custom-variables.scss","webpack://./src/assets/scss/custom/structure/_topbar.scss","webpack://./src/assets/scss/custom/structure/_right-sidebar.scss","webpack://./src/assets/scss/custom/structure/_page-head.scss","webpack://./src/assets/scss/custom/structure/_horizontal-nav.scss","webpack://./src/assets/scss/custom/fonts/_nunito.scss","webpack://./src/assets/scss/icons.scss","webpack://./src/assets/scss/custom/plugins/icons/_unicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_dripicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_materialdesignicons.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;CAAA;ACmnDA;EACE,wBAAA;EACA,8BAAA;AF1mDF;;AGNA;EAOI,wBAAA;EACA,+DAAA;EAGA,0BAAA;EAGA,2DAAA;EACA,yDAAA;EACA,kDAAA;EACA,2DAAA;EAGA,iCAAA;EACA,iCAAA;EAGA,wBAAA;EACA,qCAAA;EAEA,qBAAA;EAGA,yBAAA;EACA,0BAAA;EACA,iCAAA;EACA,iCAAA;EACA,+CAAA;EACA,8CAAA;EACA,8CAAA;EACA,6CAAA;EACA,4BAAA;EACA,gCAAA;EACA,oFAAA;EACA,8CAAA;EAGA,qDAAA;EAGA,gEAAA;EACA,4BAAA;EACA,kCAAA;EACA,qCAAA;EAGA,0CAAA;EAGA,mBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gCAAA;EACA,iDAAA;EACA,uCAAA;EACA,kFAAA;EACA,6CAAA;EACA,qCAAA;EACA,mCAAA;EAGA,8BAAA;EACA,+CAAA;EACA,qEAAA;EACA,qEAAA;EACA,uFAAA;EACA,2EAAA;EACA,2EAAA;EACA,+EAAA;EAGA,+BAAA;EAGA,mDAAA;EACA,kCAAA;EACA,4CAAA;EAGA,6CAAA;EACA,uCAAA;EACA,wCAAA;EACA,qCAAA;EACA,yCAAA;EAGA,iCAAA;EACA,4DAAA;EACA,mEAAA;EACA,oFAAA;EACA,0CAAA;EAGA,kDAAA;EACA,iCAAA;EACA,mFAAA;EAGA,qCAAA;EACA,mCAAA;EACA,sFAAA;EACA,oFAAA;EACA,kCAAA;EACA,yFAAA;EAGA,iDAAA;EACA,uDAAA;EACA,mCAAA;EACA,0DAAA;EACA,+DAAA;EACA,2EAAA;EACA,sCAAA;EACA,kDAAA;EACA,yCAAA;EAGA,4BAAA;EACA,sBAAA;EACA,+EAAA;EACA,6EAAA;EACA,8CAAA;EACA,iCAAA;EACA,mFAAA;EACA,gFAAA;EACA,wCAAA;EACA,iFAAA;EACA,0CAAA;EAGA,iCAAA;EACA,8BAAA;EACA,gEAAA;EACA,4DAAA;EACA,4DAAA;EACA,yCAAA;EACA,2DAAA;EACA,0EAAA;EACA,oEAAA;EACA,+CAAA;EACA,wCAAA;EAGA,8BAAA;EACA,wBAAA;EACA,qCAAA;EACA,oCAAA;EACA,iCAAA;EACA,8EAAA;EACA,oCAAA;EACA,iCAAA;EACA,2CAAA;EACA,uCAAA;EACA,iCAAA;EACA,8CAAA;EAGA,4CAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;EAGA,6BAAA;EACA,iDAAA;EACA,mFAAA;EACA,uFAAA;EACA,4EAAA;EACA,oFAAA;EAGA,2BAAA;EACA,wBAAA;EAGA,qBAAA;EACA,kCAAA;EACA,+BAAA;EACA,2BAAA;EACA,gCAAA;EACA,8BAAA;EACA,uCAAA;EAGA,sDAAA;EACA,8CAAA;EACA,6DAAA;EACA,sDAAA;EAGA,sBAAA;EAGA,2BAAA;EACA,yDAAA;EACA,yDAAA;EACA,+BAAA;EACA,sDAAA;EACA,sDAAA;EAGA,yBAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EAGA,8BAAA;EACA,wBAAA;EACA,qCAAA;EACA,iCAAA;EACA,uCAAA;EACA,gFAAA;EACA,qCAAA;EACA,4CAAA;EACA,yCAAA;EAGA,uBAAA;EACA,oCAAA;EACA,kDAAA;EAGA,kCAAA;EAGA,sCAAA;EACA,qCAAA;EAGA,iCAAA;EACA,uCAAA;EACA,iCAAA;EACA,4CAAA;EACA,sCAAA;EAGA,6BAAA;EAGA,wBAAA;EAEA,oBAAA;EACA,oBAAA;EACA,gBAAA;EASA,qBAAA;EAGA,uBAAA;EACA,6BAAA;EACA,8BAAA;EAGA,oBAAA;EACA,8BAAA;EACA,gCAAA;EACA,oCAAA;EAGA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,yCAAA;EAKA,sBAAA;EACA,+BAAA;EACA,+BAAA;EACA,mCAAA;EACA,mCAAA;EACA,iCAAA;EAGA,8BAAA;EAGA,0EAAA;EACA,uBAAA;EAGA,0BAAA;EAGA,iDAAA;EACA,8BAAA;EAGA,0BAAA;EAGA,0CAAA;EAGA,wBAAA;EAGA,mCAAA;EAGA,8BAAA;EAGA,8BAAA;EAGA,4BAAA;EAGA,kCAAA;EACA,oCAAA;EAGA,kBAAA;EAGA,6BAAA;EAGA,0DAAA;AHrHJ;;AGwHA;EAEG,wBAAA;EAGA,4BAAA;EACA,kCAAA;EACA,gCAAA;AHxHH;;AG6HA;EAEA,uBAAA;EACA,0BAAA;EACA,2BAAA;AH3HA;;AIjLA;EAMK,qBAAA;EACA,wBAAA;EAGA,wBAAA;EACA,+DAAA;EAGA,0BAAA;EAGA,uDAAA;EACA,2DAAA;EACA,kDAAA;EACA,2DAAA;EAGA,iCAAA;EACA,iCAAA;EAGA,wBAAA;EACA,qCAAA;EAEA,qBAAA;EAGA,yBAAA;EACA,0BAAA;EACA,iCAAA;EACA,iCAAA;EACA,4CAAA;EACA,8CAAA;EACA,2CAAA;EACA,6CAAA;EACA,4BAAA;EACA,gCAAA;EACA,oFAAA;EACA,8CAAA;EAGA,qDAAA;EAGA,gEAAA;EACA,4BAAA;EACA,kCAAA;EACA,qCAAA;EAGA,0CAAA;EAGA,sBAAA;EACA,+BAAA;EACA,yBAAA;EACA,4EAAA;EACA,iDAAA;EACA,wEAAA;EACA,kFAAA;EACA,6CAAA;EACA,qCAAA;EACA,mCAAA;EAGA,qCAAA;EACA,2FAAA;EACA,qEAAA;EACA,qEAAA;EACA,uFAAA;EACA,2EAAA;EACA,2EAAA;EACA,+EAAA;EAGA,+CAAA;EAGA,mDAAA;EACA,8EAAA;EACA,iEAAA;EAGA,6CAAA;EACA,uCAAA;EACA,wCAAA;EACA,qCAAA;EACA,yCAAA;EAGA,iCAAA;EACA,4EAAA;EACA,qEAAA;EACA,oFAAA;EACA,0CAAA;EAGA,kDAAA;EACA,6EAAA;EACA,kFAAA;EAGA,qCAAA;EACA,mCAAA;EACA,sFAAA;EAIA,wCAAA;EACA,iFAAA;EACA,yFAAA;EAIA,iDAAA;EACA,uDAAA;EACA,mCAAA;EACA,0DAAA;EACA,+DAAA;EACA,4EAAA;EACA,sCAAA;EACA,wDAAA;EACA,yCAAA;EAGA,4BAAA;EACA,oEAAA;EACA,+EAAA;EACA,6EAAA;EACA,8CAAA;EACA,iCAAA;EACA,mFAAA;EACA,gFAAA;EACA,qCAAA;EACA,iFAAA;EACA,0CAAA;EAGA,iCAAA;EACA,8BAAA;EACA,gEAAA;EACA,4DAAA;EACA,4DAAA;EACA,yCAAA;EACA,2DAAA;EACA,0EAAA;EACA,oEAAA;EACA,+CAAA;EACA,wCAAA;EAGA,8BAAA;EACA,uEAAA;EACA,qCAAA;EACA,oCAAA;EACA,iCAAA;EACA,8EAAA;EACA,oCAAA;EACA,6EAAA;EACA,2CAAA;EACA,uCAAA;EACA,gFAAA;EACA,0FAAA;EAGA,4CAAA;EACA,0CAAA;EACA,yBAAA;EACA,qBAAA;EAGA,6BAAA;EACA,iDAAA;EACA,mFAAA;EACA,uFAAA;EACA,4EAAA;EACA,oFAAA;EAGA,2BAAA;EACA,wBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,2EAAA;EACA,kCAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EAGA,oCAAA;EACA,kDAAA;EACA,yDAAA;EACA,yDAAA;EAGA,sBAAA;EAGA,yEAAA;EACA,yDAAA;EACA,yDAAA;EACA,+BAAA;EACA,kFAAA;EACA,kFAAA;EAGA,yBAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EAGA,8BAAA;EACA,qCAAA;EACA,iFAAA;EACA,iCAAA;EACA,uCAAA;EACA,oCAAA;EACA,qCAAA;EACA,4CAAA;EACA,yCAAA;EAGA,0BAAA;EACA,oCAAA;EACA,kDAAA;EAGA,kCAAA;EAGA,sCAAA;EACA,qCAAA;EAGA,iCAAA;EACA,uCAAA;EACA,iCAAA;EACA,4CAAA;EACA,sCAAA;EAGA,6BAAA;EAGA,wBAAA;EAEA,oBAAA;EACA,oBAAA;EACA,uBAAA;EAOA,wBAAA;EAGA,uBAAA;EACA,0BAAA;EACA,2BAAA;EAGA,uBAAA;EACA,8BAAA;EACA,gCAAA;EACA,oCAAA;EAGA,4BAAA;EACA,mCAAA;EACA,qCAAA;EACA,yCAAA;EAGA,yBAAA;EACA,+BAAA;EACA,+BAAA;EACA,+EAAA;EACA,mCAAA;EACA,8BAAA;EAGA,iCAAA;EAGA,yEAAA;EACA,4DAAA;EAGA,6BAAA;EAGA,gDAAA;EACA,8BAAA;EAGA,0BAAA;EAGA,0CAAA;EAGA,wBAAA;EAGA,mCAAA;EAGA,2BAAA;EAGA,2BAAA;EAGA,4BAAA;EAGA,kCAAA;EACA,oCAAA;EAGA,qBAAA;EAGA,6BAAA;EAGA,0DAAA;AJqDL;;AIlDA;EAEK,uBAAA;EACA,6BAAA;EACA,8BAAA;AJoDL;;AIjDA;EAEK,qBAAA;EAGA,uBAAA;EACA,6BAAA;EACA,8BAAA;AJiDL;;AK9cE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,8EAAA;EAAA,iFAAA;EAAA,8EAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,6EAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,2EAAA;EAAA,6EAAA;EAAA,2EAAA;EAAA,wEAAA;EAAA,gEAAA;EAAA,0EAAA;EAAA,yEAAA;EAAA,4BAAA;EAIA,+EAAA;EAAA,iFAAA;EAAA,+EAAA;EAAA,4EAAA;EAAA,qEAAA;EAAA,8EAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,0CAAA;EACA,yGAAA;EACA,yFAAA;EAOA,2CAAA;EC2OI,2BALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,0BAAA;EAEA,8BAAA;EACA,sCAAA;EAMA,qCAAA;EACA,6BAAA;EACA,oCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,yCAAA;EACA,mDAAA;EAEA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,qCAAA;EACA,2CAAA;EACA,2CAAA;EACA,iDAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AN6cF;;AQ7jBI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,qEAAA;EACA,gCAAA;EAGE,+EAAA;EAAA,iFAAA;EAAA,+EAAA;EAAA,4EAAA;EAAA,qEAAA;EAAA,8EAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,yEAAA;EAAA,0EAAA;EAAA,yEAAA;EAAA,uEAAA;EAAA,8DAAA;EAAA,wEAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,8EAAA;EAAA,iFAAA;EAAA,8EAAA;EAAA,2EAAA;EAAA,mEAAA;EAAA,8EAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,oEAAA;EACA,0EAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yDAAA;EACA,6BAAA;EACA,0DAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,0EAAA;EACA,iFAAA;EACA,4EAAA;EACA,mFAAA;AN6cJ;;ASrnBA;;;EAGE,sBAAA;ATwnBF;;ASzmBI;EANJ;IAOM,uBAAA;ET6mBJ;AACF;;AShmBA;EACE,SAAA;EACA,iCAAA;EAAA,uCAAA;EF6OI,iBALI;EAKJ,mCALI;EEtOR,gBAAA;EAAA,uCAAA;EACA,gBAAA;EAAA,uCAAA;EACA,cAAA;EAAA,2BAAA;EACA,qCAAA;EACA,yBAAA;EAAA,mCAAA;EACA,8BAAA;EACA,6CAAA;ATmmBF;;AS1lBA;EACE,cAAA;EACA,cPilB4B;EOhlB5B,SAAA;EACA,mBAAA;EACA,aPklB4B;AFW9B;;ASnlBA;EACE,aAAA;EACA,sBP0hB4B;EOvhB5B,gBP0hB4B;EOzhB5B,gBP0hB4B;EOzhB5B,cAAA;EAAA,8BAAA;ATolBF;;ASjlBA;EFuMQ,gCAAA;AP8YR;AO1iBI;EE3CJ;IF8MQ,kBAAA;EP2YN;AACF;;ASrlBA;EFkMQ,mCAAA;APuZR;AOnjBI;EEtCJ;IFyMQ,mBAAA;EPoZN;AACF;;ASzlBA;EF6LQ,iCAAA;APgaR;AO5jBI;EEjCJ;IFoMQ,iBAAA;EP6ZN;AACF;;AS7lBA;EFoLM,mBALI;APkbV;;AS5lBA;EF+KM,oBALI;APsbV;;AS3lBA;EF0KM,kBALI;AP0bV;;ASplBA;EACE,aAAA;EACA,mBPuU0B;AFgR5B;;AS7kBA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,sCAAA;UAAA,8BAAA;ATglBF;;AS1kBA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AT6kBF;;ASvkBA;;EAEE,kBAAA;AT0kBF;;ASvkBA;;;EAGE,aAAA;EACA,mBAAA;AT0kBF;;ASvkBA;;;;EAIE,gBAAA;AT0kBF;;ASvkBA;EACE,gBP+Z4B;AF2K9B;;ASrkBA;EACE,qBAAA;EACA,cAAA;ATwkBF;;ASlkBA;EACE,gBAAA;ATqkBF;;AS7jBA;;EAEE,mBPwY4B;AFwL9B;;ASxjBA;EF6EM,kBALI;APofV;;ASrjBA;EACE,cPsc4B;EOrc5B,cAAA;EAAA,gCAAA;EACA,yBAAA;EAAA,wCAAA;ATwjBF;;AS/iBA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ATkjBF;;AS/iBA;EAAM,eAAA;ATmjBN;;ASljBA;EAAM,WAAA;ATsjBN;;ASjjBA;EACE,4BAAA;EAAA,gEAAA;EACA,qBPwMwC;AF4W1C;ASljBE;EACE,mDAAA;ATojBJ;;ASziBE;EAEE,cAAA;EACA,qBAAA;AT2iBJ;;ASpiBA;;;;EAIE,qCPoT4B;EKtSxB,cALI;AP+hBV;;AShiBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,gBALI;APuiBV;AS/hBE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;ATiiBJ;;AS7hBA;EFVM,gBALI;EEiBR,cAAA;EAAA,2BAAA;EACA,qBAAA;ATgiBF;AS7hBE;EACE,cAAA;AT+hBJ;;AS3hBA;EACE,sBAAA;EFtBI,gBALI;EE6BR,WPgzCkC;EOhzClC,0BPgzCkC;EO/yClC,yBPgzCkC;EOhzClC,kCPgzCkC;EQrlDhC,qBAAA;AVo0BJ;AS5hBE;EACE,UAAA;EF7BE,cALI;EEoCN,gBPmR0B;AF2Q9B;;ASrhBA;EACE,gBAAA;ATwhBF;;ASlhBA;;EAEE,sBAAA;ATqhBF;;AS7gBA;EACE,oBAAA;EACA,yBAAA;ATghBF;;AS7gBA;EACE,oBPmV4B;EOlV5B,uBPkV4B;EOjV5B,cPkX4B;EOlX5B,oCPkX4B;EOjX5B,gBAAA;ATghBF;;ASzgBA;EAEE,mBAAA;EACA,gCAAA;AT2gBF;;ASxgBA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AT2gBF;;ASngBA;EACE,qBAAA;ATsgBF;;AShgBA;EAEE,gBAAA;ATkgBF;;AS1fA;EACE,UAAA;AT6fF;;ASxfA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AT2fF;;ASvfA;;EAEE,oBAAA;AT0fF;;ASrfA;EACE,eAAA;ATwfF;;ASrfA;EAGE,iBAAA;ATsfF;ASnfE;EACE,UAAA;ATqfJ;;AS9eA;EACE,wBAAA;ATifF;;ASzeA;;;;EAIE,0BAAA;AT4eF;ASzeI;;;;EACE,eAAA;AT8eN;;ASveA;EACE,UAAA;EACA,kBAAA;AT0eF;;ASreA;EACE,gBAAA;ATweF;;AS9dA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ATieF;;ASzdA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBPwK4B;EKzXtB,iCAAA;AP8qBR;AO10BI;EEyWJ;IFtMQ,iBAAA;EP2qBN;AACF;ASteA;EAOE,oBAAA;ATkeF;ASheE;EACE,WAAA;ATkeJ;;AS3dA;;;;;;;EAOE,UAAA;AT8dF;;AS3dA;EACE,YAAA;AT8dF;;ASrdA;EACE,6BAAA;EACA,oBAAA;ATwdF;;AShdA;;;;;;;CAAA;AAWA;EACE,wBAAA;ATgdF;;AS3cA;EACE,UAAA;AT8cF;;ASvcA;EACE,aAAA;EACA,0BAAA;AT0cF;;ASrcA;EACE,qBAAA;ATwcF;;ASncA;EACE,SAAA;ATscF;;AS/bA;EACE,kBAAA;EACA,eAAA;ATkcF;;AS1bA;EACE,wBAAA;AT6bF;;ASrbA;EACE,wBAAA;ATwbF;;AW7/BA;EJmQM,mBALI;EI5PR,gBTwmB4B;AFwZ9B;;AW3/BE;EJgQM,iCAAA;AP+vBR;AO35BI;EIpGF;IJuQM,eAAA;EP4vBN;AACF;AWpgCE;EAIE,gBTylBkB;ESxlBlB,gBT0kB0B;AFyb9B;;AWxgCE;EJgQM,iCAAA;AP4wBR;AOx6BI;EIpGF;IJuQM,iBAAA;EPywBN;AACF;AWjhCE;EAIE,gBTylBkB;ESxlBlB,gBT0kB0B;AFsc9B;;AWrhCE;EJgQM,iCAAA;APyxBR;AOr7BI;EIpGF;IJuQM,eAAA;EPsxBN;AACF;AW9hCE;EAIE,gBTylBkB;ESxlBlB,gBT0kB0B;AFmd9B;;AWliCE;EJgQM,iCAAA;APsyBR;AOl8BI;EIpGF;IJuQM,iBAAA;EPmyBN;AACF;AW3iCE;EAIE,gBTylBkB;ESxlBlB,gBT0kB0B;AFge9B;;AW/iCE;EJgQM,iCAAA;APmzBR;AO/8BI;EIpGF;IJuQM,eAAA;EPgzBN;AACF;AWxjCE;EAIE,gBTylBkB;ESxlBlB,gBT0kB0B;AF6e9B;;AW5jCE;EJgQM,iCAAA;APg0BR;AO59BI;EIpGF;IJuQM,iBAAA;EP6zBN;AACF;AWrkCE;EAIE,gBTylBkB;ESxlBlB,gBT0kB0B;AF0f9B;;AWjjCA;ECvDE,eAAA;EACA,gBAAA;AZ4mCF;;AWjjCA;EC5DE,eAAA;EACA,gBAAA;AZinCF;;AWnjCA;EACE,qBAAA;AXsjCF;AWpjCE;EACE,iBT+lB0B;AFud9B;;AW5iCA;EJ8MM,kBALI;EIvMR,yBAAA;AX+iCF;;AW3iCA;EACE,qBT8RO;EKvFH,mBALI;AP62BV;AW5iCE;EACE,gBAAA;AX8iCJ;;AW1iCA;EACE,mBAAA;EACA,qBToRO;EKvFH,kBALI;EItLR,cT8iB4B;ES9iB5B,wCT8iB4B;AF+f9B;AW3iCE;EACE,aAAA;AX6iCJ;;Aa7oCA;ECIE,eAAA;EAGA,YAAA;Ad2oCF;;Aa5oCA;EACE,gBXw9CkC;EWv9ClC,sBXw9CkC;EWx9ClC,wCXw9CkC;EWv9ClC,yBAAA;EAAA,kDAAA;EHGE,sBAAA;EIRF,eAAA;EAGA,YAAA;AdopCF;;AatoCA;EAEE,qBAAA;AbwoCF;;AaroCA;EACE,sBAAA;EACA,cAAA;AbwoCF;;AaroCA;ENyPM,kBALI;EMlPR,cX28CkC;EW38ClC,qCX28CkC;AFnUpC;;Ae1qCE;;;;;;;ECHA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AhBurCF;;AiBjoCI;EF5CE;IACE,gBbide;EFguBrB;AACF;AiBvoCI;EF5CE;IACE,gBbide;EFquBrB;AACF;AiB5oCI;EF5CE;IACE,gBbide;EF0uBrB;AACF;AiBjpCI;EF5CE;IACE,iBbide;EF+uBrB;AACF;AiBtpCI;EF5CE;IACE,iBbide;EFovBrB;AACF;AkBttCA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AlB4tCJ;;AkBvtCE;ECNA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AnBguCF;AkB9tCI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AnB0tCF;;AmB3qCM;EACE,SAAA;AnB8qCR;;AmB3qCM;EApCJ,cAAA;EACA,WAAA;AnBmtCF;;AmBrsCE;EACE,cAAA;EACA,WAAA;AnBwsCJ;;AmB1sCE;EACE,cAAA;EACA,UAAA;AnB6sCJ;;AmB/sCE;EACE,cAAA;EACA,mBAAA;AnBktCJ;;AmBptCE;EACE,cAAA;EACA,UAAA;AnButCJ;;AmBztCE;EACE,cAAA;EACA,UAAA;AnB4tCJ;;AmB9tCE;EACE,cAAA;EACA,mBAAA;AnBiuCJ;;AmBlsCM;EAhDJ,cAAA;EACA,WAAA;AnBsvCF;;AmBjsCU;EAhEN,cAAA;EACA,kBAAA;AnBqwCJ;;AmBtsCU;EAhEN,cAAA;EACA,mBAAA;AnB0wCJ;;AmB3sCU;EAhEN,cAAA;EACA,UAAA;AnB+wCJ;;AmBhtCU;EAhEN,cAAA;EACA,mBAAA;AnBoxCJ;;AmBrtCU;EAhEN,cAAA;EACA,mBAAA;AnByxCJ;;AmB1tCU;EAhEN,cAAA;EACA,UAAA;AnB8xCJ;;AmB/tCU;EAhEN,cAAA;EACA,mBAAA;AnBmyCJ;;AmBpuCU;EAhEN,cAAA;EACA,mBAAA;AnBwyCJ;;AmBzuCU;EAhEN,cAAA;EACA,UAAA;AnB6yCJ;;AmB9uCU;EAhEN,cAAA;EACA,mBAAA;AnBkzCJ;;AmBnvCU;EAhEN,cAAA;EACA,mBAAA;AnBuzCJ;;AmBxvCU;EAhEN,cAAA;EACA,WAAA;AnB4zCJ;;AmBrvCY;EAxDV,wBAAA;AnBizCF;;AmBzvCY;EAxDV,yBAAA;AnBqzCF;;AmB7vCY;EAxDV,gBAAA;AnByzCF;;AmBjwCY;EAxDV,yBAAA;AnB6zCF;;AmBrwCY;EAxDV,yBAAA;AnBi0CF;;AmBzwCY;EAxDV,gBAAA;AnBq0CF;;AmB7wCY;EAxDV,yBAAA;AnBy0CF;;AmBjxCY;EAxDV,yBAAA;AnB60CF;;AmBrxCY;EAxDV,gBAAA;AnBi1CF;;AmBzxCY;EAxDV,yBAAA;AnBq1CF;;AmB7xCY;EAxDV,yBAAA;AnBy1CF;;AmBtxCQ;;EAEE,gBAAA;AnByxCV;;AmBtxCQ;;EAEE,gBAAA;AnByxCV;;AmBhyCQ;;EAEE,uBAAA;AnBmyCV;;AmBhyCQ;;EAEE,uBAAA;AnBmyCV;;AmB1yCQ;;EAEE,sBAAA;AnB6yCV;;AmB1yCQ;;EAEE,sBAAA;AnB6yCV;;AmBpzCQ;;EAEE,qBAAA;AnBuzCV;;AmBpzCQ;;EAEE,qBAAA;AnBuzCV;;AmB9zCQ;;EAEE,sBAAA;AnBi0CV;;AmB9zCQ;;EAEE,sBAAA;AnBi0CV;;AmBx0CQ;;EAEE,qBAAA;AnB20CV;;AmBx0CQ;;EAEE,qBAAA;AnB20CV;;AiBr4CI;EEUE;IACE,SAAA;EnB+3CN;EmB53CI;IApCJ,cAAA;IACA,WAAA;EnBm6CA;EmBr5CA;IACE,cAAA;IACA,WAAA;EnBu5CF;EmBz5CA;IACE,cAAA;IACA,UAAA;EnB25CF;EmB75CA;IACE,cAAA;IACA,mBAAA;EnB+5CF;EmBj6CA;IACE,cAAA;IACA,UAAA;EnBm6CF;EmBr6CA;IACE,cAAA;IACA,UAAA;EnBu6CF;EmBz6CA;IACE,cAAA;IACA,mBAAA;EnB26CF;EmB54CI;IAhDJ,cAAA;IACA,WAAA;EnB+7CA;EmB14CQ;IAhEN,cAAA;IACA,kBAAA;EnB68CF;EmB94CQ;IAhEN,cAAA;IACA,mBAAA;EnBi9CF;EmBl5CQ;IAhEN,cAAA;IACA,UAAA;EnBq9CF;EmBt5CQ;IAhEN,cAAA;IACA,mBAAA;EnBy9CF;EmB15CQ;IAhEN,cAAA;IACA,mBAAA;EnB69CF;EmB95CQ;IAhEN,cAAA;IACA,UAAA;EnBi+CF;EmBl6CQ;IAhEN,cAAA;IACA,mBAAA;EnBq+CF;EmBt6CQ;IAhEN,cAAA;IACA,mBAAA;EnBy+CF;EmB16CQ;IAhEN,cAAA;IACA,UAAA;EnB6+CF;EmB96CQ;IAhEN,cAAA;IACA,mBAAA;EnBi/CF;EmBl7CQ;IAhEN,cAAA;IACA,mBAAA;EnBq/CF;EmBt7CQ;IAhEN,cAAA;IACA,WAAA;EnBy/CF;EmBl7CU;IAxDV,cAAA;EnB6+CA;EmBr7CU;IAxDV,wBAAA;EnBg/CA;EmBx7CU;IAxDV,yBAAA;EnBm/CA;EmB37CU;IAxDV,gBAAA;EnBs/CA;EmB97CU;IAxDV,yBAAA;EnBy/CA;EmBj8CU;IAxDV,yBAAA;EnB4/CA;EmBp8CU;IAxDV,gBAAA;EnB+/CA;EmBv8CU;IAxDV,yBAAA;EnBkgDA;EmB18CU;IAxDV,yBAAA;EnBqgDA;EmB78CU;IAxDV,gBAAA;EnBwgDA;EmBh9CU;IAxDV,yBAAA;EnB2gDA;EmBn9CU;IAxDV,yBAAA;EnB8gDA;EmB38CM;;IAEE,gBAAA;EnB68CR;EmB18CM;;IAEE,gBAAA;EnB48CR;EmBn9CM;;IAEE,uBAAA;EnBq9CR;EmBl9CM;;IAEE,uBAAA;EnBo9CR;EmB39CM;;IAEE,sBAAA;EnB69CR;EmB19CM;;IAEE,sBAAA;EnB49CR;EmBn+CM;;IAEE,qBAAA;EnBq+CR;EmBl+CM;;IAEE,qBAAA;EnBo+CR;EmB3+CM;;IAEE,sBAAA;EnB6+CR;EmB1+CM;;IAEE,sBAAA;EnB4+CR;EmBn/CM;;IAEE,qBAAA;EnBq/CR;EmBl/CM;;IAEE,qBAAA;EnBo/CR;AACF;AiB/iDI;EEUE;IACE,SAAA;EnBwiDN;EmBriDI;IApCJ,cAAA;IACA,WAAA;EnB4kDA;EmB9jDA;IACE,cAAA;IACA,WAAA;EnBgkDF;EmBlkDA;IACE,cAAA;IACA,UAAA;EnBokDF;EmBtkDA;IACE,cAAA;IACA,mBAAA;EnBwkDF;EmB1kDA;IACE,cAAA;IACA,UAAA;EnB4kDF;EmB9kDA;IACE,cAAA;IACA,UAAA;EnBglDF;EmBllDA;IACE,cAAA;IACA,mBAAA;EnBolDF;EmBrjDI;IAhDJ,cAAA;IACA,WAAA;EnBwmDA;EmBnjDQ;IAhEN,cAAA;IACA,kBAAA;EnBsnDF;EmBvjDQ;IAhEN,cAAA;IACA,mBAAA;EnB0nDF;EmB3jDQ;IAhEN,cAAA;IACA,UAAA;EnB8nDF;EmB/jDQ;IAhEN,cAAA;IACA,mBAAA;EnBkoDF;EmBnkDQ;IAhEN,cAAA;IACA,mBAAA;EnBsoDF;EmBvkDQ;IAhEN,cAAA;IACA,UAAA;EnB0oDF;EmB3kDQ;IAhEN,cAAA;IACA,mBAAA;EnB8oDF;EmB/kDQ;IAhEN,cAAA;IACA,mBAAA;EnBkpDF;EmBnlDQ;IAhEN,cAAA;IACA,UAAA;EnBspDF;EmBvlDQ;IAhEN,cAAA;IACA,mBAAA;EnB0pDF;EmB3lDQ;IAhEN,cAAA;IACA,mBAAA;EnB8pDF;EmB/lDQ;IAhEN,cAAA;IACA,WAAA;EnBkqDF;EmB3lDU;IAxDV,cAAA;EnBspDA;EmB9lDU;IAxDV,wBAAA;EnBypDA;EmBjmDU;IAxDV,yBAAA;EnB4pDA;EmBpmDU;IAxDV,gBAAA;EnB+pDA;EmBvmDU;IAxDV,yBAAA;EnBkqDA;EmB1mDU;IAxDV,yBAAA;EnBqqDA;EmB7mDU;IAxDV,gBAAA;EnBwqDA;EmBhnDU;IAxDV,yBAAA;EnB2qDA;EmBnnDU;IAxDV,yBAAA;EnB8qDA;EmBtnDU;IAxDV,gBAAA;EnBirDA;EmBznDU;IAxDV,yBAAA;EnBorDA;EmB5nDU;IAxDV,yBAAA;EnBurDA;EmBpnDM;;IAEE,gBAAA;EnBsnDR;EmBnnDM;;IAEE,gBAAA;EnBqnDR;EmB5nDM;;IAEE,uBAAA;EnB8nDR;EmB3nDM;;IAEE,uBAAA;EnB6nDR;EmBpoDM;;IAEE,sBAAA;EnBsoDR;EmBnoDM;;IAEE,sBAAA;EnBqoDR;EmB5oDM;;IAEE,qBAAA;EnB8oDR;EmB3oDM;;IAEE,qBAAA;EnB6oDR;EmBppDM;;IAEE,sBAAA;EnBspDR;EmBnpDM;;IAEE,sBAAA;EnBqpDR;EmB5pDM;;IAEE,qBAAA;EnB8pDR;EmB3pDM;;IAEE,qBAAA;EnB6pDR;AACF;AiBxtDI;EEUE;IACE,SAAA;EnBitDN;EmB9sDI;IApCJ,cAAA;IACA,WAAA;EnBqvDA;EmBvuDA;IACE,cAAA;IACA,WAAA;EnByuDF;EmB3uDA;IACE,cAAA;IACA,UAAA;EnB6uDF;EmB/uDA;IACE,cAAA;IACA,mBAAA;EnBivDF;EmBnvDA;IACE,cAAA;IACA,UAAA;EnBqvDF;EmBvvDA;IACE,cAAA;IACA,UAAA;EnByvDF;EmB3vDA;IACE,cAAA;IACA,mBAAA;EnB6vDF;EmB9tDI;IAhDJ,cAAA;IACA,WAAA;EnBixDA;EmB5tDQ;IAhEN,cAAA;IACA,kBAAA;EnB+xDF;EmBhuDQ;IAhEN,cAAA;IACA,mBAAA;EnBmyDF;EmBpuDQ;IAhEN,cAAA;IACA,UAAA;EnBuyDF;EmBxuDQ;IAhEN,cAAA;IACA,mBAAA;EnB2yDF;EmB5uDQ;IAhEN,cAAA;IACA,mBAAA;EnB+yDF;EmBhvDQ;IAhEN,cAAA;IACA,UAAA;EnBmzDF;EmBpvDQ;IAhEN,cAAA;IACA,mBAAA;EnBuzDF;EmBxvDQ;IAhEN,cAAA;IACA,mBAAA;EnB2zDF;EmB5vDQ;IAhEN,cAAA;IACA,UAAA;EnB+zDF;EmBhwDQ;IAhEN,cAAA;IACA,mBAAA;EnBm0DF;EmBpwDQ;IAhEN,cAAA;IACA,mBAAA;EnBu0DF;EmBxwDQ;IAhEN,cAAA;IACA,WAAA;EnB20DF;EmBpwDU;IAxDV,cAAA;EnB+zDA;EmBvwDU;IAxDV,wBAAA;EnBk0DA;EmB1wDU;IAxDV,yBAAA;EnBq0DA;EmB7wDU;IAxDV,gBAAA;EnBw0DA;EmBhxDU;IAxDV,yBAAA;EnB20DA;EmBnxDU;IAxDV,yBAAA;EnB80DA;EmBtxDU;IAxDV,gBAAA;EnBi1DA;EmBzxDU;IAxDV,yBAAA;EnBo1DA;EmB5xDU;IAxDV,yBAAA;EnBu1DA;EmB/xDU;IAxDV,gBAAA;EnB01DA;EmBlyDU;IAxDV,yBAAA;EnB61DA;EmBryDU;IAxDV,yBAAA;EnBg2DA;EmB7xDM;;IAEE,gBAAA;EnB+xDR;EmB5xDM;;IAEE,gBAAA;EnB8xDR;EmBryDM;;IAEE,uBAAA;EnBuyDR;EmBpyDM;;IAEE,uBAAA;EnBsyDR;EmB7yDM;;IAEE,sBAAA;EnB+yDR;EmB5yDM;;IAEE,sBAAA;EnB8yDR;EmBrzDM;;IAEE,qBAAA;EnBuzDR;EmBpzDM;;IAEE,qBAAA;EnBszDR;EmB7zDM;;IAEE,sBAAA;EnB+zDR;EmB5zDM;;IAEE,sBAAA;EnB8zDR;EmBr0DM;;IAEE,qBAAA;EnBu0DR;EmBp0DM;;IAEE,qBAAA;EnBs0DR;AACF;AiBj4DI;EEUE;IACE,SAAA;EnB03DN;EmBv3DI;IApCJ,cAAA;IACA,WAAA;EnB85DA;EmBh5DA;IACE,cAAA;IACA,WAAA;EnBk5DF;EmBp5DA;IACE,cAAA;IACA,UAAA;EnBs5DF;EmBx5DA;IACE,cAAA;IACA,mBAAA;EnB05DF;EmB55DA;IACE,cAAA;IACA,UAAA;EnB85DF;EmBh6DA;IACE,cAAA;IACA,UAAA;EnBk6DF;EmBp6DA;IACE,cAAA;IACA,mBAAA;EnBs6DF;EmBv4DI;IAhDJ,cAAA;IACA,WAAA;EnB07DA;EmBr4DQ;IAhEN,cAAA;IACA,kBAAA;EnBw8DF;EmBz4DQ;IAhEN,cAAA;IACA,mBAAA;EnB48DF;EmB74DQ;IAhEN,cAAA;IACA,UAAA;EnBg9DF;EmBj5DQ;IAhEN,cAAA;IACA,mBAAA;EnBo9DF;EmBr5DQ;IAhEN,cAAA;IACA,mBAAA;EnBw9DF;EmBz5DQ;IAhEN,cAAA;IACA,UAAA;EnB49DF;EmB75DQ;IAhEN,cAAA;IACA,mBAAA;EnBg+DF;EmBj6DQ;IAhEN,cAAA;IACA,mBAAA;EnBo+DF;EmBr6DQ;IAhEN,cAAA;IACA,UAAA;EnBw+DF;EmBz6DQ;IAhEN,cAAA;IACA,mBAAA;EnB4+DF;EmB76DQ;IAhEN,cAAA;IACA,mBAAA;EnBg/DF;EmBj7DQ;IAhEN,cAAA;IACA,WAAA;EnBo/DF;EmB76DU;IAxDV,cAAA;EnBw+DA;EmBh7DU;IAxDV,wBAAA;EnB2+DA;EmBn7DU;IAxDV,yBAAA;EnB8+DA;EmBt7DU;IAxDV,gBAAA;EnBi/DA;EmBz7DU;IAxDV,yBAAA;EnBo/DA;EmB57DU;IAxDV,yBAAA;EnBu/DA;EmB/7DU;IAxDV,gBAAA;EnB0/DA;EmBl8DU;IAxDV,yBAAA;EnB6/DA;EmBr8DU;IAxDV,yBAAA;EnBggEA;EmBx8DU;IAxDV,gBAAA;EnBmgEA;EmB38DU;IAxDV,yBAAA;EnBsgEA;EmB98DU;IAxDV,yBAAA;EnBygEA;EmBt8DM;;IAEE,gBAAA;EnBw8DR;EmBr8DM;;IAEE,gBAAA;EnBu8DR;EmB98DM;;IAEE,uBAAA;EnBg9DR;EmB78DM;;IAEE,uBAAA;EnB+8DR;EmBt9DM;;IAEE,sBAAA;EnBw9DR;EmBr9DM;;IAEE,sBAAA;EnBu9DR;EmB99DM;;IAEE,qBAAA;EnBg+DR;EmB79DM;;IAEE,qBAAA;EnB+9DR;EmBt+DM;;IAEE,sBAAA;EnBw+DR;EmBr+DM;;IAEE,sBAAA;EnBu+DR;EmB9+DM;;IAEE,qBAAA;EnBg/DR;EmB7+DM;;IAEE,qBAAA;EnB++DR;AACF;AiB1iEI;EEUE;IACE,SAAA;EnBmiEN;EmBhiEI;IApCJ,cAAA;IACA,WAAA;EnBukEA;EmBzjEA;IACE,cAAA;IACA,WAAA;EnB2jEF;EmB7jEA;IACE,cAAA;IACA,UAAA;EnB+jEF;EmBjkEA;IACE,cAAA;IACA,mBAAA;EnBmkEF;EmBrkEA;IACE,cAAA;IACA,UAAA;EnBukEF;EmBzkEA;IACE,cAAA;IACA,UAAA;EnB2kEF;EmB7kEA;IACE,cAAA;IACA,mBAAA;EnB+kEF;EmBhjEI;IAhDJ,cAAA;IACA,WAAA;EnBmmEA;EmB9iEQ;IAhEN,cAAA;IACA,kBAAA;EnBinEF;EmBljEQ;IAhEN,cAAA;IACA,mBAAA;EnBqnEF;EmBtjEQ;IAhEN,cAAA;IACA,UAAA;EnBynEF;EmB1jEQ;IAhEN,cAAA;IACA,mBAAA;EnB6nEF;EmB9jEQ;IAhEN,cAAA;IACA,mBAAA;EnBioEF;EmBlkEQ;IAhEN,cAAA;IACA,UAAA;EnBqoEF;EmBtkEQ;IAhEN,cAAA;IACA,mBAAA;EnByoEF;EmB1kEQ;IAhEN,cAAA;IACA,mBAAA;EnB6oEF;EmB9kEQ;IAhEN,cAAA;IACA,UAAA;EnBipEF;EmBllEQ;IAhEN,cAAA;IACA,mBAAA;EnBqpEF;EmBtlEQ;IAhEN,cAAA;IACA,mBAAA;EnBypEF;EmB1lEQ;IAhEN,cAAA;IACA,WAAA;EnB6pEF;EmBtlEU;IAxDV,cAAA;EnBipEA;EmBzlEU;IAxDV,wBAAA;EnBopEA;EmB5lEU;IAxDV,yBAAA;EnBupEA;EmB/lEU;IAxDV,gBAAA;EnB0pEA;EmBlmEU;IAxDV,yBAAA;EnB6pEA;EmBrmEU;IAxDV,yBAAA;EnBgqEA;EmBxmEU;IAxDV,gBAAA;EnBmqEA;EmB3mEU;IAxDV,yBAAA;EnBsqEA;EmB9mEU;IAxDV,yBAAA;EnByqEA;EmBjnEU;IAxDV,gBAAA;EnB4qEA;EmBpnEU;IAxDV,yBAAA;EnB+qEA;EmBvnEU;IAxDV,yBAAA;EnBkrEA;EmB/mEM;;IAEE,gBAAA;EnBinER;EmB9mEM;;IAEE,gBAAA;EnBgnER;EmBvnEM;;IAEE,uBAAA;EnBynER;EmBtnEM;;IAEE,uBAAA;EnBwnER;EmB/nEM;;IAEE,sBAAA;EnBioER;EmB9nEM;;IAEE,sBAAA;EnBgoER;EmBvoEM;;IAEE,qBAAA;EnByoER;EmBtoEM;;IAEE,qBAAA;EnBwoER;EmB/oEM;;IAEE,sBAAA;EnBipER;EmB9oEM;;IAEE,sBAAA;EnBgpER;EmBvpEM;;IAEE,qBAAA;EnBypER;EmBtpEM;;IAEE,qBAAA;EnBwpER;AACF;AoB9wEA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,uCAAA;EACA,iCAAA;EACA,qDAAA;EACA,+CAAA;EACA,uDAAA;EACA,iDAAA;EACA,qDAAA;EACA,+CAAA;EACA,mDAAA;EACA,6CAAA;EAEA,WAAA;EACA,qBlB+VO;EkB9VP,mBlB8pB4B;EkB7pB5B,0CAAA;ApB6wEF;AoBtwEE;EACE,wBAAA;EAEA,4BAAA;EAAA,qFAAA;EACA,oCAAA;EACA,wBlBge0B;EkB/d1B,wDAAA;EAAA,2GAAA;ApBuwEJ;AoBpwEE;EACE,uBAAA;ApBswEJ;AoBnwEE;EACE,sBAAA;ApBqwEJ;;AoBjwEA;EACE,kFAAA;EAAA,qEAAA;ApBowEF;;AoB7vEA;EACE,iBAAA;ApBgwEF;;AoBtvEE;EACE,sBAAA;ApByvEJ;;AoB1uEE;EACE,mBAAA;ApB6uEJ;AoB1uEI;EACE,mBAAA;ApB4uEN;;AoBruEE;EACE,sBAAA;ApBwuEJ;AoBruEE;EACE,mBAAA;ApBuuEJ;;AoB7tEE;EACE,oDAAA;EACA,8CAAA;ApBguEJ;;AoB1tEE;EACE,oDAAA;EACA,8CAAA;ApB6tEJ;;AoBrtEA;EACE,oDAAA;EACA,8CAAA;ApBwtEF;;AoBhtEE;EACE,mDAAA;EACA,6CAAA;ApBmtEJ;;AqB/1EE;EAOE,yBAAA;EACA,kEAAA;EACA,2EAAA;EACA,8BAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArB21EJ;;AqB72EE;EAOE,yBAAA;EACA,kEAAA;EACA,2EAAA;EACA,8BAAA;EACA,8BAAA;EACA,uEAAA;EACA,6BAAA;EACA,wEAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArBy2EJ;;AqB33EE;EAOE,yBAAA;EACA,kEAAA;EACA,4EAAA;EACA,8BAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArBu3EJ;;AqBz4EE;EAOE,yBAAA;EACA,kEAAA;EACA,4EAAA;EACA,8BAAA;EACA,8BAAA;EACA,wEAAA;EACA,6BAAA;EACA,wEAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArBq4EJ;;AqBv5EE;EAOE,yBAAA;EACA,6CAAA;EACA,4EAAA;EACA,8BAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArBm5EJ;;AqBr6EE;EAOE,yBAAA;EACA,kEAAA;EACA,0EAAA;EACA,8BAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArBi6EJ;;AqBn7EE;EAOE,yBAAA;EACA,sBAAA;EACA,4EAAA;EACA,8BAAA;EACA,8BAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ArB+6EJ;;AqBj8EE;EAOE,sBAAA;EACA,sBAAA;EACA,4EAAA;EACA,4BAAA;EACA,iCAAA;EACA,yEAAA;EACA,6BAAA;EACA,wEAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ArB67EJ;;AoB5yEI;EACE,gBAAA;EACA,iCAAA;ApB+yEN;;AiB14EI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpBqzEJ;AACF;AiBj5EI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpB2zEJ;AACF;AiBv5EI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpBi0EJ;AACF;AiB75EI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpBu0EJ;AACF;AiBn6EI;EGyFA;IACE,gBAAA;IACA,iCAAA;EpB60EJ;AACF;AsBj/EA;EACE,qBpB2zBsC;AFwrDxC;;AsB1+EA;EACE,gCAAA;EACA,mCAAA;EACA,gBAAA;Ef8QI,kBALI;EerQR,gBpBikB4B;AF06D9B;;AsBv+EA;EACE,+BAAA;EACA,kCAAA;EfwQM,qCAAA;APmuER;AO/3EI;Ee9GJ;IfiRQ,mBAAA;EPguEN;AACF;;AsB5+EA;EACE,gCAAA;EACA,mCAAA;Ef8PI,mBALI;APuvEV;;AuB7gFA;EACE,mBrBmzBsC;EKzhBlC,kBALI;EgBjRR,crBmzBsC;EqBnzBtC,gCrBmzBsC;AF2tDxC;;AwBnhFA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EjBwRI,iBALI;EiBhRR,gBtBskB4B;EsBrkB5B,gBtB2kB4B;EsB1kB5B,ctB+0BsC;EsB/0BtC,4BtB+0BsC;EsB90BtC,gBAAA;EACA,sBtBy0BsC;EsBz0BtC,oCtBy0BsC;EsBx0BtC,4BAAA;EACA,yBAAA;EAAA,8CAAA;EdGE,sBAAA;EeHE,wEDMJ;AxBihFF;AyBnhFM;EDhBN;ICiBQ,gBAAA;EzBshFN;AACF;AwBphFE;EACE,gBAAA;AxBshFJ;AwBphFI;EACE,eAAA;AxBshFN;AwBjhFE;EACE,ctBo0BoC;EsBp0BpC,kCtBo0BoC;EsBn0BpC,sBtBi0BoC;EsBj0BpC,0CtBi0BoC;EsBh0BpC,iEtBi0BoC;EsBj0BpC,gDtBi0BoC;EsBh0BpC,UAAA;EAKE,gBtB8zBkC;AFitDxC;AwB3gFE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AxB+/EJ;AwB1/EE;EACE,cAAA;EACA,UAAA;AxB4/EJ;AwBx/EE;EACE,ctB+xBoC;EsB/xBpC,wCtB+xBoC;EsB7xBpC,UAAA;AxBy/EJ;AwBj/EE;EAEE,yBtBiwBoC;EsBjwBpC,6CtBiwBoC;EsB9vBpC,UAAA;AxBg/EJ;AwB5+EE;EACE,uBAAA;EACA,wBAAA;EACA,yBtB0oB0B;EsBzoB1B,ctBy5B8B;EsBz5B9B,uCtBy5B8B;EwBv/BhC,yBxBw/BgC;EwBx/BhC,+CxBw/BgC;EsBx5B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BtBqvBoC;EsBpvBpC,gBAAA;ECzFE,qID0FF;AxB8+EJ;AyBpkFM;ED0EJ;ICzEM,gBAAA;EzBukFN;AACF;AwBh/EE;EACE,qEtB+4B8B;EsB/4B9B,qDtB+4B8B;AFmmDlC;;AwBz+EA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBtB0d4B;EsBzd5B,ctB8uBsC;EsB9uBtC,sCtB8uBsC;EsB7uBtC,6BAAA;EACA,yBAAA;EACA,mBAAA;AxB4+EF;AwB1+EE;EACE,UAAA;AxB4+EJ;AwBz+EE;EAEE,gBAAA;EACA,eAAA;AxB0+EJ;;AwB/9EA;EACE,uCtB+tBsC;EsB9tBtC,uBAAA;EjByII,mBALI;EGvQN,qBAAA;AVumFJ;AwBh+EE;EACE,uBAAA;EACA,wBAAA;EACA,yBtB0lB0B;AFw4D9B;;AwB99EA;EACE,oCtBmtBsC;EsBltBtC,oBAAA;EjBgIM,qCAAA;APk2ER;AO9/EI;EiB0BJ;IjByIQ,mBAAA;EP+1EN;AACF;AwBz+EA;Ed9II,qBAAA;AV0nFJ;AwBt+EE;EACE,oBAAA;EACA,qBAAA;EACA,uBtBilB0B;AFu5D9B;;AwBh+EE;EACE,sCtBgsBoC;AFmyDxC;AwBh+EE;EACE,uCtB6rBoC;AFqyDxC;AwB/9EE;EACE,oCtB0rBoC;AFuyDxC;;AwB59EA;EACE,WtBwrBsC;EsBvrBtC,kCtBirBsC;EsBhrBtC,gBtBuiB4B;AFw7D9B;AwB79EE;EACE,eAAA;AxB+9EJ;AwB59EE;EACE,oBAAA;EdvLA,sBAAA;AVspFJ;AwB39EE;EACE,oBAAA;Ed5LA,sBAAA;AV0pFJ;AwB19EE;EAAoB,mCtBiqBkB;AF4zDxC;AwB59EE;EAAoB,gCtBiqBkB;AF8zDxC;;A2B9qFA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,sCAAA;EpBqRI,iBALI;EoB7QR,gBzBmkB4B;EyBlkB5B,gBzBwkB4B;EyBvkB5B,czBk7BkC;EyBl7BlC,kCzBk7BkC;EyBj7BlC,gBAAA;EACA,sBzBi7BkC;EyBj7BlC,0CzBi7BkC;EyBh7BlC,oDAAA;EAAA,mFAAA;EACA,4BAAA;EACA,wCzBk7BkC;EyBj7BlC,0BzBk7BkC;EyBj7BlC,yBAAA;EAAA,8CAAA;EjBHE,sBAAA;EeHE,wEESJ;A3B8qFF;AyBnrFM;EEfN;IFgBQ,gBAAA;EzBsrFN;AACF;A2BjrFE;EACE,iEzBy0BoC;EyBz0BpC,gDzBy0BoC;EyBx0BpC,UAAA;EAKE,gBzBo7B4B;AF2vDlC;A2B3qFE;EAEE,qBzBm5BgC;EyBl5BhC,sBAAA;A3B4qFJ;A2BzqFE;EACE,czBs5BgC;EyBt5BhC,2CzBs5BgC;EyBr5BhC,yBzBs5BgC;EyBt5BhC,mDzBs5BgC;AFqxDpC;A2BtqFE;EACE,kBAAA;EACA,0BAAA;EAAA,8CAAA;A3BwqFJ;;A2BpqFA;EACE,oBzB4rB4B;EyB3rB5B,uBzB2rB4B;EyB1rB5B,oBzB2rB4B;EKxdxB,mBALI;EGvQN,qBAAA;AVktFJ;;A2BpqFA;EACE,mBzBwrB4B;EyBvrB5B,sBzBurB4B;EyBtrB5B,kBzBurB4B;EKxdtB,qCAAA;APy8ER;AOrmFI;EoBtEJ;IpByOQ,mBAAA;EPs8EN;AACF;A2BhrFA;EjB9CI,qBAAA;AViuFJ;;A2BzqFI;EACE,gEAAA;A3B4qFN;;A4BpvFA;EACE,cAAA;EACA,mB1Bw3BwC;E0Bv3BxC,qB1Bw3BwC;E0Bv3BxC,gB1Bw3BwC;AF+3D1C;A4BrvFE;EACE,WAAA;EACA,qBAAA;A5BuvFJ;;A4BnvFA;EACE,sB1B82BwC;E0B72BxC,eAAA;EACA,iBAAA;A5BsvFF;A4BpvFE;EACE,YAAA;EACA,sBAAA;EACA,cAAA;A5BsvFJ;;A4BlvFA;EACE,iDAAA;EAEA,cAAA;EACA,c1B61BwC;E0B51BxC,e1B41BwC;E0B31BxC,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,yB1B81BwC;E0B91BxC,yC1B81BwC;E0B71BxC,iCAAA;UAAA,yBAAA;EH3BI,mJG4BJ;A5BovFF;AyB5wFM;EGQN;IHPQ,gBAAA;EzB+wFN;AACF;A4BvvFE;ElB3BE,qBAAA;AVqxFJ;A4BtvFE;EAEE,kB1Bs1BsC;AFi6D1C;A4BpvFE;EACE,uB1B60BsC;AFy6D1C;A4BnvFE;EACE,iE1ByyBoC;E0BzyBpC,gD1ByyBoC;E0BxyBpC,UAAA;EACA,gB1B80BsC;AFu6D1C;A4BlvFE;EACE,yB1B60BsC;E0B70BtC,6D1B60BsC;E0B50BtC,qB1B60BsC;E0B70BtC,6D1B60BsC;AFu6D1C;A4BlvFI;EAII,iEAAA;A5BivFR;A4B7uFI;EAII,iEAAA;A5B4uFR;A4BvuFE;EACE,yB1B0c0B;E0B1c1B,+C1B0c0B;E0Bzc1B,qB1Byc0B;E0Bzc1B,2C1Byc0B;E0BpcxB,iEAAA;A5BquFN;A4BjuFE;EACE,oBAAA;EACA,YAAA;EACA,Y1BqzBuC;AF86D3C;A4B5tFI;EACE,eAAA;EACA,Y1B4yBqC;AFk7D3C;;A4BhtFA;EACE,mB1BuyBgC;AF46DlC;A4BjtFE;EACE,4DAAA;EAEA,U1BiyB8B;E0BhyB9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;A5BktFJ;AyBp0FM;EG0GJ;IHzGM,gBAAA;EzBu0FN;AACF;A4BrtFI;EACE,4DAAA;A5ButFN;A4BptFI;EACE,iC1BgyB4B;E0B3xB1B,4DAAA;A5BktFR;A4B7sFE;EACE,oB1B2wB8B;E0B1wB9B,eAAA;A5B+sFJ;A4B7sFI;EACE,oBAAA;EACA,cAAA;A5B+sFN;;A4B1sFA;EACE,qBAAA;EACA,kB1ByvBgC;AFo9DlC;;A4B1sFA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A5B6sFF;A4BzsFI;EACE,oBAAA;EACA,YAAA;EACA,a1B2mBwB;AFgmE9B;;A4BpsFI;EACE,4DAAA;A5BusFN;;A6B13FA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A7B63FF;A6B33FE;EACE,UAAA;A7B63FJ;A6Bz3FI;EAA0B,mC3Bi+Ba;AF25D3C;A6B33FI;EAA0B,mC3Bg+Ba;AF85D3C;A6B33FE;EACE,SAAA;A7B63FJ;A6B13FE;EACE,W3Bk9BuC;E2Bj9BvC,Y3Bi9BuC;E2Bh9BvC,oBAAA;EACA,gBAAA;EH1BF,yBxB6hB4B;EwB7hB5B,+CxB6hB4B;E2BjgB1B,S3Bg9BuC;EQ79BvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A7B23FJ;AyB14FM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EzB64FN;AACF;A6B93FI;EHjCF,qExBi/ByC;EwBj/BzC,sDxBi/ByC;AFi7D3C;A6B53FE;EACE,W3B27B8B;E2B17B9B,c3B27B8B;E2B17B9B,kBAAA;EACA,e3B07B8B;E2Bz7B9B,yB3B07B8B;E2B17B9B,+C3B07B8B;E2Bz7B9B,yBAAA;EnB7BA,mBAAA;AV45FJ;A6B13FE;EACE,W3Bu7BuC;E2Bt7BvC,Y3Bs7BuC;E2Br7BvC,gBAAA;EHpDF,yBxB6hB4B;EwB7hB5B,+CxB6hB4B;E2Bve1B,S3Bs7BuC;EQ79BvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A7B23FJ;AyBp6FM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EzBu6FN;AACF;A6B93FI;EH3DF,qExBi/ByC;EwBj/BzC,sDxBi/ByC;AF28D3C;A6B53FE;EACE,W3Bi6B8B;E2Bh6B9B,c3Bi6B8B;E2Bh6B9B,kBAAA;EACA,e3Bg6B8B;E2B/5B9B,yB3Bg6B8B;E2Bh6B9B,+C3Bg6B8B;E2B/5B9B,yBAAA;EnBvDA,mBAAA;AVs7FJ;A6B13FE;EACE,oBAAA;A7B43FJ;A6B13FI;EACE,yB3Bm6BqC;E2Bn6BrC,wD3Bm6BqC;AFy9D3C;A6Bz3FI;EACE,yB3B+5BqC;E2B/5BrC,wD3B+5BqC;AF49D3C;;A8Bl9FA;EACE,kBAAA;A9Bq9FF;A8Bn9FE;;;EAGE,0B5B2/B8B;E4B1/B9B,8B5B0/B8B;E4Bz/B9B,iB5B0/B8B;AF29DlC;A8Bl9FE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELRE,gEKSF;A9Bo9FJ;AyBz9FM;EKTJ;ILUM,gBAAA;EzB49FN;AACF;A8Bt9FE;;EAEE,oBAAA;A9Bw9FJ;A8Bt9FI;;EACE,kBAAA;A9By9FN;A8Bt9FI;;;EAEE,qB5B+9B4B;E4B99B5B,wB5B+9B4B;AF0/DlC;A8Bt9FI;;EACE,qB5B09B4B;E4Bz9B5B,wB5B09B4B;AF+/DlC;A8Br9FE;EACE,qB5Bo9B8B;E4Bn9B9B,wB5Bo9B8B;AFmgElC;A8Bh9FI;;;;EACE,gCAAA;EAAA,2CAAA;EACA,8D5B68B4B;AFwgElC;A8Bn9FM;;;;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aCm/BgC;EDl/BhC,WAAA;EACA,sB5BoxBgC;E4BpxBhC,oC5BoxBgC;EQp0BpC,sBAAA;AVygGJ;A8Bl9FI;EACE,gCAAA;EAAA,2CAAA;EACA,8D5B47B4B;AFwhElC;A8B/8FI;EACE,mBAAA;A9Bi9FN;A8B78FE;;EAEE,cC1EO;A/ByhGX;A8B78FI;;EACE,yB5B6vBkC;E4B7vBlC,6C5B6vBkC;AFmtExC;;AgCviGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AhC0iGF;AgCxiGE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AhC0iGJ;AgCtiGE;;;EAGE,UAAA;AhCwiGJ;AgCliGE;EACE,kBAAA;EACA,UAAA;AhCoiGJ;AgCliGI;EACE,UAAA;AhCoiGN;;AgCzhGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EzB8OI,iBALI;EyBvOR,gB9B6hB4B;E8B5hB5B,gB9BkiB4B;E8BjiB5B,c9B+3BsC;E8B/3BtC,wC9B+3BsC;E8B93BtC,kBAAA;EACA,mBAAA;EACA,yB9B63BsC;E8B73BtC,gD9B63BsC;E8B53BtC,yBAAA;EAAA,0DAAA;EtBtCE,sBAAA;AVmkGJ;;AgCnhGA;;;;EAIE,oBAAA;EzB4NM,qCAAA;AP2zFR;AOv9FI;EyBpEJ;;;;IzBuOQ,mBAAA;EP2zFN;AACF;AgCniGA;;;;EtBhDI,qBAAA;AVylGJ;;AgChiGA;;;;EAIE,uBAAA;EzB+MI,mBALI;EGvQN,qBAAA;AVkmGJ;;AgChiGA;;EAEE,qBAAA;AhCmiGF;;AgCthGI;;;;EtBjEA,0BAAA;EACA,6BAAA;AV8lGJ;AgCrhGI;;;;EtB1EA,0BAAA;EACA,6BAAA;AVqmGJ;AgC/gGE;EACE,2BAAA;EtB1EA,yBAAA;EACA,4BAAA;AV4lGJ;AgC/gGE;;EtB9EE,yBAAA;EACA,4BAAA;AVimGJ;;AiCznGE;EACE,aAAA;EACA,WAAA;EACA,mB/B2xBoC;EKzhBlC,kBALI;E0B1PN,c/B4/BqB;AF+nEzB;;AiCxnGE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;E1BqPE,oBALI;E0B7ON,WAxBc;EAyBd,yCAxBiB;EvBHjB,qBAAA;AVspGJ;;AiCtnGI;;;;EAEE,cAAA;AjC2nGN;;AiC1qGI;EAqDE,qB/Bi+BmB;E+B99BjB,mC/BizBgC;E+BhzBhC,yDAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;AjCunGR;AiCpnGM;EACE,qB/Bs9BiB;E+Bj9Bf,iDApDW;AjCsqGrB;;AiCvrGI;EA+EI,mC/B0xBgC;E+BzxBhC,gFAAA;AjC4mGR;;AiC5rGI;EAuFE,qB/B+7BmB;AF0qEzB;AiCtmGQ;EAEE,iEAAA;EACA,sB/Bw2B8B;E+Bv2B9B,6DAAA;EACA,yEAAA;AjCumGV;AiCnmGM;EACE,qB/Bk7BiB;E+B76Bf,iDAxFW;AjCyrGrB;;AiC1sGI;EAkHI,wCAAA;AjC4lGR;;AiC9sGI;EAyHE,qB/B65BmB;AF4rEzB;AiCvlGM;EACE,yB/B05BiB;AF+rEzB;AiCtlGM;EACE,iDA/Ga;AjCusGrB;AiCrlGM;EACE,c/Bk5BiB;AFqsEzB;;AiCllGI;EACE,kBAAA;AjCqlGN;;AiC/tGI;;;;;EAoJM,UAAA;AjCmlGV;;AiCntGE;EACE,aAAA;EACA,WAAA;EACA,mB/B2xBoC;EKzhBlC,kBALI;E0B1PN,c/B4/BqB;AFytEzB;;AiCltGE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;E1BqPE,oBALI;E0B7ON,WAxBc;EAyBd,yCAxBiB;EvBHjB,qBAAA;AVgvGJ;;AiChtGI;;;;EAEE,cAAA;AjCqtGN;;AiCpwGI;EAqDE,qB/Bi+BmB;E+B99BjB,mC/BizBgC;E+BhzBhC,yDAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;AjCitGR;AiC9sGM;EACE,qB/Bs9BiB;E+Bj9Bf,iDApDW;AjCgwGrB;;AiCjxGI;EA+EI,mC/B0xBgC;E+BzxBhC,gFAAA;AjCssGR;;AiCtxGI;EAuFE,qB/B+7BmB;AFowEzB;AiChsGQ;EAEE,iEAAA;EACA,sB/Bw2B8B;E+Bv2B9B,6DAAA;EACA,yEAAA;AjCisGV;AiC7rGM;EACE,qB/Bk7BiB;E+B76Bf,iDAxFW;AjCmxGrB;;AiCpyGI;EAkHI,wCAAA;AjCsrGR;;AiCxyGI;EAyHE,qB/B65BmB;AFsxEzB;AiCjrGM;EACE,yB/B05BiB;AFyxEzB;AiChrGM;EACE,iDA/Ga;AjCiyGrB;AiC/qGM;EACE,c/Bk5BiB;AF+xEzB;;AiC5qGI;EACE,kBAAA;AjC+qGN;;AiCzzGI;;;;;EAsJM,UAAA;AjC2qGV;;AkCn0GA;EAEE,0BAAA;EACA,2BAAA;EACA,sBAAA;E3BuRI,0BALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,+BAAA;EACA,wCAAA;EACA,oCAAA;EACA,+BAAA;EACA,gFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;ExBjBE,0CAAA;EgBfF,kCQkCqB;ETtBjB,qISwBJ;AlCg0GF;AyBp1GM;EShBN;ITiBQ,gBAAA;EzBu1GN;AACF;AkCn0GE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;AlCo0GJ;AkCj0GE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AlCk0GJ;AkC/zGE;EACE,gCAAA;ERrDF,wCQsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;AlC6zGN;AkCzzGE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;AlCuzGN;AkCnzGE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;AlC+yGJ;AkC5yGI;EAKI,0CAAA;AlC0yGR;AkCryGE;EAKI,0CAAA;AlCmyGN;AkC/xGE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;AlC8xGJ;;AkClxGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2DAAA;EACA,+EAAA;EACA,wCAAA;EACA,2BAAA;EACA,sEAAA;EACA,iFAAA;EACA,uDAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AnCq4GF;;AkCnyGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,gDAAA;EACA,gFAAA;EACA,wCAAA;EACA,2BAAA;EACA,uEAAA;EACA,iFAAA;EACA,uDAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AnCs5GF;;AkCpzGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0DAAA;EACA,8EAAA;EACA,uCAAA;EACA,2BAAA;EACA,qEAAA;EACA,gFAAA;EACA,uDAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AnCu6GF;;AkCr0GE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2DAAA;EACA,+EAAA;EACA,uCAAA;EACA,2BAAA;EACA,sEAAA;EACA,iFAAA;EACA,uDAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AnCw7GF;;AkCt1GE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,iDAAA;EACA,2DAAA;EACA,uCAAA;EACA,8BAAA;EACA,kDAAA;EACA,4DAAA;EACA,uDAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AnCy8GF;;AkCv2GE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,sEAAA;EACA,8EAAA;EACA,wCAAA;EACA,2BAAA;EACA,qEAAA;EACA,iFAAA;EACA,uDAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AnC09GF;;AkCx3GE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sEAAA;EACA,gFAAA;EACA,wCAAA;EACA,8BAAA;EACA,uEAAA;EACA,sEAAA;EACA,uDAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AnC2+GF;;AkCz4GE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,sEAAA;EACA,gFAAA;EACA,qCAAA;EACA,2BAAA;EACA,uEAAA;EACA,iFAAA;EACA,uDAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AnC4/GF;;AkCh4GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uDAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AnCo/GF;;AkCj5GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uDAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AnCqgHF;;AkCl6GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uDAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AnCshHF;;AkCn7GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uDAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AnCuiHF;;AkCp8GE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uDAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AnCwjHF;;AkCr9GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uDAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AnCykHF;;AkCt+GE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uDAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AnC0lHF;;AkCv/GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uDAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AnC2mHF;;AkC5/GA;EACE,yBAAA;EACA,wCAAA;EACA,wBAAA;EACA,kCAAA;EACA,oDAAA;EACA,wCAAA;EACA,qDAAA;EACA,yCAAA;EACA,0DAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,qBhCsQwC;AFwvG1C;AkCp/GE;EACE,0BAAA;AlCs/GJ;AkCn/GE;EACE,gCAAA;AlCq/GJ;;AkC1+GA;ECjJE,0BAAA;EACA,wBAAA;E5BkOM,8CAAA;AP85GR;AO1jHI;E2B0EJ;I3ByFQ,4BAAA;EP25GN;AACF;AkCr/GA;EC9IE,+BAAA;AnCsoHF;;AkCp/GA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,+BAAA;AnC6oHF;;AoChtHA;EXgBM,gCWfJ;ApCmtHF;AyBhsHM;EWpBN;IXqBQ,gBAAA;EzBmsHN;AACF;AoCttHE;EACE,UAAA;ApCwtHJ;;AoCltHE;EACE,aAAA;ApCqtHJ;;AoCjtHA;EACE,SAAA;EACA,gBAAA;EXDI,6BWEJ;ApCotHF;AyBltHM;EWLN;IXMQ,gBAAA;EzBqtHN;AACF;AoCvtHE;EACE,QAAA;EACA,YAAA;EXNE,4BWOF;ApCytHJ;AyB5tHM;EWAJ;IXCM,gBAAA;EzB+tHN;AACF;;AqCpvHA;;;;;;EAME,kBAAA;ArCuvHF;;AqCpvHA;EACE,mBAAA;ArCuvHF;AsC/tHI;EACE,qBAAA;EACA,qBpCigBwB;EoChgBxB,wBpC+fwB;EoC9fxB,WAAA;EArCJ,wBAAA;EACA,sCAAA;EACA,gBAAA;EACA,qCAAA;AtCuwHF;AsC7sHI;EACE,cAAA;AtC+sHN;;AqC7vHA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,gCAAA;EACA,8BAAA;E9BuQI,+BALI;E8BhQR,6CAAA;EACA,uCAAA;EACA,2DAAA;EACA,oCAAA;EACA,+BAAA;EACA,sDAAA;EACA,uDAAA;EACA,uCAAA;EACA,uDAAA;EACA,uDAAA;EACA,mEAAA;EACA,6DAAA;EACA,qEAAA;EACA,+DAAA;EACA,yEAAA;EACA,oCAAA;EACA,sCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E3BzCE,+CAAA;AVuyHJ;AqC1vHE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;ArC4vHJ;;AqCpuHI;EACE,oBAAA;ArCuuHN;AqCruHM;EACE,WAAA;EACA,OAAA;ArCuuHR;;AqCnuHI;EACE,kBAAA;ArCsuHN;AqCpuHM;EACE,QAAA;EACA,UAAA;ArCsuHR;;AiBhxHI;EoB4BA;IACE,oBAAA;ErCwvHJ;EqCtvHI;IACE,WAAA;IACA,OAAA;ErCwvHN;EqCpvHE;IACE,kBAAA;ErCsvHJ;EqCpvHI;IACE,QAAA;IACA,UAAA;ErCsvHN;AACF;AiBjyHI;EoB4BA;IACE,oBAAA;ErCwwHJ;EqCtwHI;IACE,WAAA;IACA,OAAA;ErCwwHN;EqCpwHE;IACE,kBAAA;ErCswHJ;EqCpwHI;IACE,QAAA;IACA,UAAA;ErCswHN;AACF;AiBjzHI;EoB4BA;IACE,oBAAA;ErCwxHJ;EqCtxHI;IACE,WAAA;IACA,OAAA;ErCwxHN;EqCpxHE;IACE,kBAAA;ErCsxHJ;EqCpxHI;IACE,QAAA;IACA,UAAA;ErCsxHN;AACF;AiBj0HI;EoB4BA;IACE,oBAAA;ErCwyHJ;EqCtyHI;IACE,WAAA;IACA,OAAA;ErCwyHN;EqCpyHE;IACE,kBAAA;ErCsyHJ;EqCpyHI;IACE,QAAA;IACA,UAAA;ErCsyHN;AACF;AiBj1HI;EoB4BA;IACE,oBAAA;ErCwzHJ;EqCtzHI;IACE,WAAA;IACA,OAAA;ErCwzHN;EqCpzHE;IACE,kBAAA;ErCszHJ;EqCpzHI;IACE,QAAA;IACA,UAAA;ErCszHN;AACF;AqC7yHE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;ArC+yHJ;AsCn4HI;EACE,qBAAA;EACA,qBpCigBwB;EoChgBxB,wBpC+fwB;EoC9fxB,WAAA;EA9BJ,aAAA;EACA,sCAAA;EACA,2BAAA;EACA,qCAAA;AtCo6HF;AsCj3HI;EACE,cAAA;AtCm3HN;;AqCnzHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;ArCszHJ;AsCx5HI;EACE,qBAAA;EACA,qBpCigBwB;EoChgBxB,wBpC+fwB;EoC9fxB,WAAA;EAvBJ,oCAAA;EACA,eAAA;EACA,uCAAA;EACA,yBAAA;AtCk7HF;AsCt4HI;EACE,cAAA;AtCw4HN;AqC9zHI;EACE,iBAAA;ArCg0HN;;AqC1zHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;ArC6zHJ;AsCh7HI;EACE,qBAAA;EACA,qBpCigBwB;EoChgBxB,wBpC+fwB;EoC9fxB,WAAA;AtCk7HN;AsCv6HM;EACE,aAAA;AtCy6HR;AsCt6HM;EACE,qBAAA;EACA,sBpC8esB;EoC7etB,wBpC4esB;EoC3etB,WAAA;EAnCN,oCAAA;EACA,0BAAA;EACA,uCAAA;AtC48HF;AsCt6HI;EACE,cAAA;AtCw6HN;AqC70HI;EACE,iBAAA;ArC+0HN;;AqCx0HA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;ArC20HF;;AqCr0HA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gBnC6Z4B;EmC5Z5B,oCAAA;EACA,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;E3BtKE,gBAAA;EAAA,uDAAA;AV8+HJ;AqCr0HE;EAEE,0CAAA;EX1LF,kDW4LuB;ArCq0HzB;AqCl0HE;EAEE,2CAAA;EACA,qBAAA;EXlMF,mDWmMuB;ArCm0HzB;AqCh0HE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;ArCi0HJ;;AqC3zHA;EACE,cAAA;ArC8zHF;;AqC1zHA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;ArC6zHF;;AqCzzHA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;ArC4zHF;;AqCxzHA;EAEE,kDAAA;EACA,4CAAA;EACA,gEAAA;EACA,0BAAA;EACA,4DAAA;EACA,wEAAA;EACA,4DAAA;EACA,kEAAA;EACA,0EAAA;EACA,oEAAA;EACA,8EAAA;EACA,gEAAA;ArC0zHF;;AuChjIA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AvCmjIF;AuCjjIE;;EACE,kBAAA;EACA,cAAA;AvCojIJ;AuC/iIE;;;;;;;;;;;;EAME,UAAA;AvCujIJ;;AuCljIA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AvCqjIF;AuCnjIE;EACE,WAAA;AvCqjIJ;;AuCjjIA;E7BhBI,sBAAA;AVqkIJ;AuCjjIE;;EAEE,2BAAA;AvCmjIJ;AuC/iIE;;;E7BVE,0BAAA;EACA,6BAAA;AV8jIJ;AuC3iIE;;;E7BNE,yBAAA;EACA,4BAAA;AVsjIJ;;AuC9hIA;EACE,uBAAA;EACA,sBAAA;AvCiiIF;AuC/hIE;EAGE,cAAA;AvC+hIJ;AuC5hIE;EACE,eAAA;AvC8hIJ;;AuC1hIA;EACE,qBAAA;EACA,oBAAA;AvC6hIF;;AuC1hIA;EACE,sBAAA;EACA,qBAAA;AvC6hIF;;AuCzgIA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AvC4gIF;AuC1gIE;;EAEE,WAAA;AvC4gIJ;AuCzgIE;;EAEE,0BAAA;AvC2gIJ;AuCvgIE;;E7B1FE,6BAAA;EACA,4BAAA;AVqmIJ;AuCvgIE;;E7B7GE,yBAAA;EACA,0BAAA;AVwnIJ;;AwChpIA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,+DAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AxC+oIF;;AwC5oIA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EAEA,gBAAA;EACA,SAAA;EffI,uGegBJ;AxC8oIF;AyB1pIM;EeGN;IfFQ,gBAAA;EzB6pIN;AACF;AwCjpIE;EAEE,qCAAA;AxCkpIJ;AwC9oIE;EACE,UAAA;EACA,kDTkhBoB;A/B8nHxB;AwC5oIE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;AxC6oIJ;;AwCroIA;EAEE,+BAAA;EACA,2DAAA;EACA,oCAAA;EACA,iFAAA;EACA,qEAAA;EACA,+DAAA;EACA,mFAAA;EAGA,oFAAA;AxCqoIF;AwCnoIE;EACE,yDAAA;EACA,yDAAA;E9B7CA,wDAAA;EACA,yDAAA;AVmrIJ;AwCpoII;EAGE,kBAAA;EACA,wDAAA;AxCooIN;AwChoIE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AxCkoIJ;AwC/nIE;EAEE,sDAAA;E9BjEA,yBAAA;EACA,0BAAA;AVksIJ;;AwCvnIA;EAEE,qCAAA;EACA,kEAAA;EACA,4DAAA;AxCynIF;AwCtnIE;E9B5FE,gDAAA;AVqtIJ;AwCrnIE;;EAEE,4CAAA;EdjHF,oDckHuB;AxCunIzB;;AwC9mIA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;AxC8mIF;AwC5mIE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AxC8mIJ;AwC5mII;EAEE,iCAAA;AxC6mIN;AwCzmIE;;EAEE,gBtC4b0B;EsC3b1B,gDAAA;EACA,iCAAA;AxC2mIJ;;AwCjmIE;;EAEE,cAAA;EACA,kBAAA;AxComIJ;;AwC/lIE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AxCkmIJ;;AwC5lIE;;EACE,WAAA;AxCgmIJ;;AwCtlIE;EACE,aAAA;AxCylIJ;AwCvlIE;EACE,cAAA;AxCylIJ;;AyCtxIA;EAEE,wBAAA;EACA,8BAAA;EACA,+CAAA;EACA,2DAAA;EACA,iEAAA;EACA,6DAAA;EACA,uCAAA;EACA,kCAAA;EACA,qCAAA;EACA,4DAAA;EACA,kEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,uCAAA;EACA,qEAAA;EACA,oDAAA;EACA,0CAAA;EACA,uCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AzCsxIF;AyChxIE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AzCwxIJ;AyCpwIA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EAEA,mBAAA;AzCqwIF;AyCnwIE;EAEE,yCAAA;AzCowIJ;;AyC1vIA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AzCyvIF;AyCtvII;EAEE,oCAAA;AzCuvIN;AyCnvIE;EACE,gBAAA;AzCqvIJ;;AyC5uIA;EACE,mBvCq8BkC;EuCp8BlC,sBvCo8BkC;EuCn8BlC,6BAAA;AzC+uIF;AyC7uIE;;;EAGE,oCAAA;AzC+uIJ;;AyCluIA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AzCmuIF;;AyC/tIA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,uDAAA;EAAA,0EAAA;E/BxIE,qDAAA;EeHE,+CgB6IJ;AzCkuIF;AyB32IM;EgBiIN;IhBhIQ,gBAAA;EzB82IN;AACF;AyCruIE;EACE,qBAAA;AzCuuIJ;AyCpuIE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AzCsuIJ;;AyChuIA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AzCmuIF;;AyChuIA;EACE,gBAAA;EAAA,yCAAA;EACA,gBAAA;AzCmuIF;;AiB71II;EwBsIA;IAEI,iBAAA;IACA,2BAAA;EzC0tIN;EyCxtIM;IACE,mBAAA;EzC0tIR;EyCxtIQ;IACE,kBAAA;EzC0tIV;EyCvtIQ;IACE,kDAAA;IACA,iDAAA;EzCytIV;EyCrtIM;IACE,iBAAA;EzCutIR;EyCptIM;IACE,wBAAA;IACA,gBAAA;EzCstIR;EyCntIM;IACE,aAAA;EzCqtIR;EyCltIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IhB9NJ,gBgBgOI;EzCktIR;EyC/sIQ;IACE,aAAA;EzCitIV;EyC9sIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzCgtIV;AACF;AiB74II;EwBsIA;IAEI,iBAAA;IACA,2BAAA;EzCywIN;EyCvwIM;IACE,mBAAA;EzCywIR;EyCvwIQ;IACE,kBAAA;EzCywIV;EyCtwIQ;IACE,kDAAA;IACA,iDAAA;EzCwwIV;EyCpwIM;IACE,iBAAA;EzCswIR;EyCnwIM;IACE,wBAAA;IACA,gBAAA;EzCqwIR;EyClwIM;IACE,aAAA;EzCowIR;EyCjwIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IhB9NJ,gBgBgOI;EzCiwIR;EyC9vIQ;IACE,aAAA;EzCgwIV;EyC7vIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzC+vIV;AACF;AiB57II;EwBsIA;IAEI,iBAAA;IACA,2BAAA;EzCwzIN;EyCtzIM;IACE,mBAAA;EzCwzIR;EyCtzIQ;IACE,kBAAA;EzCwzIV;EyCrzIQ;IACE,kDAAA;IACA,iDAAA;EzCuzIV;EyCnzIM;IACE,iBAAA;EzCqzIR;EyClzIM;IACE,wBAAA;IACA,gBAAA;EzCozIR;EyCjzIM;IACE,aAAA;EzCmzIR;EyChzIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IhB9NJ,gBgBgOI;EzCgzIR;EyC7yIQ;IACE,aAAA;EzC+yIV;EyC5yIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzC8yIV;AACF;AiB3+II;EwBsIA;IAEI,iBAAA;IACA,2BAAA;EzCu2IN;EyCr2IM;IACE,mBAAA;EzCu2IR;EyCr2IQ;IACE,kBAAA;EzCu2IV;EyCp2IQ;IACE,kDAAA;IACA,iDAAA;EzCs2IV;EyCl2IM;IACE,iBAAA;EzCo2IR;EyCj2IM;IACE,wBAAA;IACA,gBAAA;EzCm2IR;EyCh2IM;IACE,aAAA;EzCk2IR;EyC/1IM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IhB9NJ,gBgBgOI;EzC+1IR;EyC51IQ;IACE,aAAA;EzC81IV;EyC31IQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzC61IV;AACF;AiB1hJI;EwBsIA;IAEI,iBAAA;IACA,2BAAA;EzCs5IN;EyCp5IM;IACE,mBAAA;EzCs5IR;EyCp5IQ;IACE,kBAAA;EzCs5IV;EyCn5IQ;IACE,kDAAA;IACA,iDAAA;EzCq5IV;EyCj5IM;IACE,iBAAA;EzCm5IR;EyCh5IM;IACE,wBAAA;IACA,gBAAA;EzCk5IR;EyC/4IM;IACE,aAAA;EzCi5IR;EyC94IM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IhB9NJ,gBgBgOI;EzC84IR;EyC34IQ;IACE,aAAA;EzC64IV;EyC14IQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzC44IV;AACF;AyCn8II;EAEI,iBAAA;EACA,2BAAA;AzCo8IR;AyCl8IQ;EACE,mBAAA;AzCo8IV;AyCl8IU;EACE,kBAAA;AzCo8IZ;AyCj8IU;EACE,kDAAA;EACA,iDAAA;AzCm8IZ;AyC/7IQ;EACE,iBAAA;AzCi8IV;AyC97IQ;EACE,wBAAA;EACA,gBAAA;AzCg8IV;AyC77IQ;EACE,aAAA;AzC+7IV;AyC57IQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;EhB9NJ,gBgBgOI;AzC47IV;AyCz7IU;EACE,aAAA;AzC27IZ;AyCx7IU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AzC07IZ;;AyCz6IA;;EAGE,8CAAA;EACA,0DAAA;EACA,gEAAA;EACA,4DAAA;EACA,2DAAA;EACA,iEAAA;EACA,4EAAA;EACA,qEAAA;AzC26IF;;AyCr6II;EACE,qEAAA;AzCw6IN;;A0CjsJA;EAEE,0BAAA;EACA,0BAAA;EACA,iCAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,mDAAA;EACA,gCAAA;EACA,+CAAA;EACA,kDAAA;EACA,gCAAA;EACA,+BAAA;EACA,uCAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,sCAAA;EACA,4BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EAAA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;EhCjBE,2CAAA;AVmtJJ;A0C9rJE;EACE,eAAA;EACA,cAAA;A1CgsJJ;A0C7rJE;EACE,mBAAA;EACA,sBAAA;A1C+rJJ;A0C7rJI;EACE,mBAAA;EhCtBF,0DAAA;EACA,2DAAA;AVstJJ;A0C7rJI;EACE,sBAAA;EhCbF,8DAAA;EACA,6DAAA;AV6sJJ;A0C1rJE;;EAEE,aAAA;A1C4rJJ;;A0CxrJA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;A1CyrJF;;A0CtrJA;EACE,4CAAA;EACA,iCAAA;A1CyrJF;;A0CtrJA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;A1CyrJF;;A0CtrJA;EACE,gBAAA;A1CyrJF;;A0CjrJE;EACE,oCAAA;A1CorJJ;;A0C5qJA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;A1C+qJF;A0C7qJE;EhC7FE,wFAAA;AV6wJJ;;A0C3qJA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;A1C8qJF;A0C5qJE;EhCxGE,wFAAA;AVuxJJ;;A0CrqJA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;A1CwqJF;A0CtqJE;EACE,mCAAA;EACA,sCAAA;A1CwqJJ;;A0CpqJA;EACE,uDAAA;EACA,sDAAA;A1CuqJF;;A0CnqJA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;EhC1IE,iDAAA;AVizJJ;;A0CnqJA;;;EAGE,WAAA;A1CsqJF;;A0CnqJA;;EhC3II,0DAAA;EACA,2DAAA;AVmzJJ;;A0CpqJA;;EhClII,8DAAA;EACA,6DAAA;AV2yJJ;;A0C7pJE;EACE,0CAAA;A1CgqJJ;AiB3xJI;EyBuHJ;IAQI,aAAA;IACA,mBAAA;E1CgqJF;E0C7pJE;IAEE,SAAA;IACA,gBAAA;E1C8pJJ;E0C5pJI;IACE,cAAA;IACA,cAAA;E1C8pJN;E0CzpJM;IhC3KJ,0BAAA;IACA,6BAAA;EVu0JF;E0C1pJQ;;IAGE,0BAAA;E1C2pJV;E0CzpJQ;;IAGE,6BAAA;E1C0pJV;E0CtpJM;IhC5KJ,yBAAA;IACA,4BAAA;EVq0JF;E0CvpJQ;;IAGE,yBAAA;E1CwpJV;E0CtpJQ;;IAGE,4BAAA;E1CupJV;AACF;;A2C53JA;EAEE,+CAAA;EACA,8BAAA;EACA,8KAAA;EACA,6DAAA;EACA,gCAAA;EACA,qCAAA;EACA,uDAAA;EACA,qCAAA;EACA,kCAAA;EACA,mDAAA;EACA,kCAAA;EACA,iEAAA;EACA,sCAAA;EACA,iDAAA;EACA,8DAAA;EACA,wEAAA;EACA,gFAAA;EACA,sCAAA;EACA,mCAAA;EACA,oEAAA;EACA,8DAAA;A3C83JF;;A2C13JA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,iBALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EjCrBE,gBAAA;EiCuBF,qBAAA;ElB1BI,0CkB2BJ;A3C63JF;AyBp5JM;EkBUN;IlBTQ,gBAAA;EzBu5JN;AACF;A2Ch4JE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;A3Ck4JJ;A2Ch4JI;EACE,qDAAA;EACA,iDAAA;A3Ck4JN;A2C73JE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;ElBjDE,mDkBkDF;A3C+3JJ;AyB76JM;EkBqCJ;IlBpCM,gBAAA;EzBg7JN;AACF;A2Cj4JE;EACE,UAAA;A3Cm4JJ;A2Ch4JE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;A3Ck4JJ;;A2C93JA;EACE,gBAAA;A3Ci4JF;;A2C93JA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;A3Ci4JF;A2C/3JE;EjC7DE,yDAAA;EACA,0DAAA;AV+7JJ;A2Ch4JI;EjChEA,+DAAA;EACA,gEAAA;AVm8JJ;A2C/3JE;EACE,aAAA;A3Ci4JJ;A2C73JE;EjC5DE,6DAAA;EACA,4DAAA;AV47JJ;A2C73JM;EjChEF,mEAAA;EACA,kEAAA;AVg8JJ;A2C53JI;EjCrEA,6DAAA;EACA,4DAAA;AVo8JJ;;A2C13JA;EACE,8EAAA;A3C63JF;;A2Cp3JE;EACE,eAAA;EACA,cAAA;EjC9GA,gBAAA;AVs+JJ;A2Cr3JI;EAAgB,aAAA;A3Cw3JpB;A2Cv3JI;EAAe,gBAAA;A3C03JnB;A2Ct3JM;EjCtHF,gBAAA;AV++JJ;A2Cl3JI;EjC7HA,gBAAA;AVk/JJ;;A2C72JI;EACE,sVAAA;EACA,6VAAA;A3Cg3JN;;A4C1gKA;EAEE,4BAAA;EACA,iCAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,iEAAA;EACA,sCAAA;EACA,oEAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;ElCAE,iDAAA;AV0gKJ;;A4CpgKE;EACE,iDAAA;A5CugKJ;A4CrgKI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,mEAAA;EAAA,iGAAA;A5CugKN;A4CngKE;EACE,6CAAA;A5CqgKJ;;A6C1iKA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,iDAAA;EACA,2CAAA;EACA,iCAAA;EACA,+DAAA;EACA,sCAAA;EACA,6DAAA;EACA,uDAAA;EACA,2EAAA;EACA,6DAAA;EACA,uDAAA;EACA,uEAAA;EACA,8DAAA;EACA,wDAAA;EACA,kEAAA;EACA,mEAAA;EACA,6DAAA;EACA,iFAAA;EAGA,aAAA;EjCpBA,eAAA;EACA,gBAAA;AZ+jKF;;A6CxiKA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EAEA,yCAAA;EACA,iFAAA;EpBpBI,qIoBqBJ;A7C0iKF;AyB3jKM;EoBQN;IpBPQ,gBAAA;EzB8jKN;AACF;A6C7iKE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A7C8iKJ;A6C3iKE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,U3CspCgC;E2CrpChC,iDAAA;A7C6iKJ;A6C1iKE;EAEE,UAAA;EACA,wCAAA;EnBtDF,gDmBuDuB;EACrB,sDAAA;A7C2iKJ;A6CxiKE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A7CyiKJ;;A6CpiKE;EACE,iB3CynCgC;AF86HpC;A6CthKI;EnCxEA,iDAAA;AVimKJ;;A6C9gKA;EClGE,iCAAA;EACA,kCAAA;EvC8RM,qDAAA;APu1JR;AOn/JI;EsCjCJ;ItCoMQ,mCAAA;EPo1JN;AACF;A6CzhKA;EC/FE,qCAAA;A9C2nKF;;A6CxhKA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,qCAAA;A9CkoKF;;A+CpoKA;EAEE,2BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,uCAAA;EACA,iCAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;ErCJE,4CAAA;AVyoKJ;A+ChoKE;EACE,aAAA;A/CkoKJ;;A+C7nKA;EACE,kBAAA;EACA,SAAA;A/CgoKF;;AgDhqKA;EAEE,0BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,yDAAA;EACA,iCAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EtCHE,4CAAA;AVoqKJ;;AgD5pKA;EAEE,cAAA;AhD8pKF;;AgD1pKA;EACE,gB9C+iB4B;E8C9iB5B,iCAAA;AhD6pKF;;AgDrpKA;EACE,sB9Cs4C8B;AFkxHhC;AgDrpKE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,0BAAA;AhDupKJ;;AgD/oKE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AhDkpKJ;;AgDtpKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;AhDypKJ;;AgD7pKE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AhDgqKJ;;AgDpqKE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AhDuqKJ;;AgD3qKE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;AhD8qKJ;;AgDlrKE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;AhDqrKJ;;AgDzrKE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;AhD4rKJ;;AgDhsKE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;AhDmsKJ;;AiD/vKE;EACE;IAAK,2B/Co7C2B;EF+0HlC;AACF;AiD/vKA;;EAGE,0BAAA;E1CkRI,iCALI;E0C3QR,uCAAA;EACA,oCAAA;EACA,uDAAA;EACA,qDAAA;EACA,+CAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EvCRE,+CAAA;AVuwKJ;;AiD1vKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;ExBxBI,6CwByBJ;AjD6vKF;AyBlxKM;EwBYN;IxBXQ,gBAAA;EzBqxKN;AACF;;AiD/vKA;EvBAE,qMAAA;EuBEA,oEAAA;AjDkwKF;;AiD/vKA;EACE,iBAAA;AjDkwKF;;AiD/vKA;EACE,WAAA;AjDkwKF;;AiD9vKE;EACE,kDAAA;AjDiwKJ;AiD9vKM;EAJJ;IAKM,eAAA;EjDiwKN;AACF;;AkD7zKA;EAEE,iDAAA;EACA,2CAAA;EACA,+DAAA;EACA,iCAAA;EACA,sCAAA;EACA,sCAAA;EACA,uCAAA;EACA,+DAAA;EACA,qEAAA;EACA,8DAAA;EACA,6EAAA;EACA,uEAAA;EACA,mEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wDAAA;EACA,kEAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ExCXE,iDAAA;AVu0KJ;;AkDxzKA;EACE,qBAAA;EACA,sBAAA;AlD2zKF;AkDzzKE;EAEE,oCAAA;EACA,0BAAA;AlD0zKJ;;AkDjzKA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AlDozKF;AkDjzKE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AlDkzKJ;AkD/yKE;EACE,+CAAA;EACA,uDAAA;AlDizKJ;;AkDzyKA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EAEA,yCAAA;EACA,iFAAA;AlD2yKF;AkDzyKE;ExCvDE,+BAAA;EACA,gCAAA;AVm2KJ;AkDzyKE;ExC7CE,mCAAA;EACA,kCAAA;AVy1KJ;AkDzyKE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AlD0yKJ;AkDtyKE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AlDwyKJ;AkDpyKE;EACE,mBAAA;AlDsyKJ;AkDpyKI;EACE,wDAAA;EACA,mDAAA;AlDsyKN;;AkDzxKI;EACE,mBAAA;AlD4xKN;AkDzxKQ;ExCvDJ,6DAAA;EAZA,0BAAA;AVg2KJ;AkDxxKQ;ExCxEJ,2DAAA;EAYA,4BAAA;AVw1KJ;AkDvxKQ;EACE,aAAA;AlDyxKV;AkDtxKQ;EACE,mDAAA;EACA,oBAAA;AlDwxKV;AkDtxKU;EACE,yDAAA;EACA,oDAAA;AlDwxKZ;;AiB92KI;EiC8DA;IACE,mBAAA;ElDozKJ;EkDjzKM;IxCvDJ,6DAAA;IAZA,0BAAA;EVw3KF;EkDhzKM;IxCxEJ,2DAAA;IAYA,4BAAA;EVg3KF;EkD/yKM;IACE,aAAA;ElDizKR;EkD9yKM;IACE,mDAAA;IACA,oBAAA;ElDgzKR;EkD9yKQ;IACE,yDAAA;IACA,oDAAA;ElDgzKV;AACF;AiBv4KI;EiC8DA;IACE,mBAAA;ElD40KJ;EkDz0KM;IxCvDJ,6DAAA;IAZA,0BAAA;EVg5KF;EkDx0KM;IxCxEJ,2DAAA;IAYA,4BAAA;EVw4KF;EkDv0KM;IACE,aAAA;ElDy0KR;EkDt0KM;IACE,mDAAA;IACA,oBAAA;ElDw0KR;EkDt0KQ;IACE,yDAAA;IACA,oDAAA;ElDw0KV;AACF;AiB/5KI;EiC8DA;IACE,mBAAA;ElDo2KJ;EkDj2KM;IxCvDJ,6DAAA;IAZA,0BAAA;EVw6KF;EkDh2KM;IxCxEJ,2DAAA;IAYA,4BAAA;EVg6KF;EkD/1KM;IACE,aAAA;ElDi2KR;EkD91KM;IACE,mDAAA;IACA,oBAAA;ElDg2KR;EkD91KQ;IACE,yDAAA;IACA,oDAAA;ElDg2KV;AACF;AiBv7KI;EiC8DA;IACE,mBAAA;ElD43KJ;EkDz3KM;IxCvDJ,6DAAA;IAZA,0BAAA;EVg8KF;EkDx3KM;IxCxEJ,2DAAA;IAYA,4BAAA;EVw7KF;EkDv3KM;IACE,aAAA;ElDy3KR;EkDt3KM;IACE,mDAAA;IACA,oBAAA;ElDw3KR;EkDt3KQ;IACE,yDAAA;IACA,oDAAA;ElDw3KV;AACF;AiB/8KI;EiC8DA;IACE,mBAAA;ElDo5KJ;EkDj5KM;IxCvDJ,6DAAA;IAZA,0BAAA;EVw9KF;EkDh5KM;IxCxEJ,2DAAA;IAYA,4BAAA;EVg9KF;EkD/4KM;IACE,aAAA;ElDi5KR;EkD94KM;IACE,mDAAA;IACA,oBAAA;ElDg5KR;EkD94KQ;IACE,yDAAA;IACA,oDAAA;ElDg5KV;AACF;AkDn4KA;ExChJI,gBAAA;AVshLJ;AkDn4KE;EACE,mDAAA;AlDq4KJ;AkDn4KI;EACE,sBAAA;AlDq4KN;;AkDx3KE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AlD23KJ;;AkDr4KE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AlDw4KJ;;AkDl5KE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AlDq5KJ;;AkD/5KE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AlDk6KJ;;AkD56KE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AlD+6KJ;;AkDz7KE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AlD47KJ;;AkDt8KE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AlDy8KJ;;AkDn9KE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AlDs9KJ;;AmDlpLA;EAEE,+CAAA;EACA,2DAAA;EACA,yBAAA;EACA,iCAAA;EACA,iCAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,UjD4iD2B;EiD3iD3B,WjD2iD2B;EiD1iD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;EzCJE,sBAAA;EyCMF,oCAAA;AnDkpLF;AmD/oLE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AnDipLJ;AmD9oLE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AnDgpLJ;AmD7oLE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AnD8oLJ;;AmDtoLA;EAHE,wCAAA;AnD6oLF;;AmDpoLI;EATF,wCAAA;AnDipLF;;AoDlsLA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,yBAAA;EACA,+CAAA;EACA,4BAAA;EACA,qDAAA;EACA,iCAAA;EACA,2CAAA;EACA,gCAAA;EACA,6DAAA;EACA,mEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;E1CRE,4CAAA;AV2sLJ;AoDhsLE;EACE,UAAA;ApDksLJ;AoD/rLE;EACE,aAAA;ApDisLJ;;AoD7rLA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;ApD+rLF;AoD7rLE;EACE,sCAAA;ApD+rLJ;;AoD3rLA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;E1ChCE,0FAAA;EACA,2FAAA;AV+tLJ;AoD7rLE;EACE,oDAAA;EACA,sCAAA;ApD+rLJ;;AoD3rLA;EACE,kCAAA;EACA,qBAAA;ApD8rLF;;AqD5vLA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,oCAAA;EACA,4BAAA;EACA,gCAAA;EACA,4DAAA;EACA,kDAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,mEAAA;EACA,mCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,mEAAA;EACA,mCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;ArD0vLF;;AqDnvLA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;ArDqvLF;AqDlvLE;E5B5CI,mC4B6CF;ArDovLJ;AyB7xLM;E4BwCJ;I5BvCM,gBAAA;EzBgyLN;AACF;AqD1vLE;EAEE,8BnD+1CgC;AF45IpC;AqDzvLE;EACE,enD61CgC;AF85IpC;AqDvvLE;EACE,sBnD01CgC;AF+5IpC;;AqDrvLA;EACE,+CAAA;ArDwvLF;AqDtvLE;EACE,gBAAA;EACA,gBAAA;ArDwvLJ;AqDrvLE;EACE,gBAAA;ArDuvLJ;;AqDnvLA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;ArDsvLF;;AqDlvLA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E3CrFE,4CAAA;E2CyFF,UAAA;ArDkvLF;;AqD9uLA;EAEE,0BAAA;EACA,6CAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;ArDovL9D;AsDh2LE;EAAS,UAAA;AtDm2LX;AsDl2LE;EAAS,mCD2GiF;ArD0vL5F;;AqDrvLA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E3CrGE,2DAAA;EACA,4DAAA;AV81LJ;AqDvvLE;EACE,kGAAA;EACA,sJAAA;ArDyvLJ;;AqDpvLA;EACE,gBAAA;EACA,8CAAA;ArDuvLF;;AqDlvLA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;ArDmvLF;;AqD/uLA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E3CzHE,+DAAA;EACA,8DAAA;AV42LJ;AqD9uLE;EACE,8CAAA;ArDgvLJ;;AiB31LI;EoCiHF;IACE,0BAAA;IACA,+DAAA;ErD8uLF;EqD1uLA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;ErD4uLF;EqDzuLA;IACE,uBAAA;ErD2uLF;AACF;AiB12LI;EoCmIF;;IAEE,uBAAA;ErD0uLF;AACF;AiBh3LI;EoC0IF;IACE,wBAAA;ErDyuLF;AACF;AqDhuLI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;ArDkuLN;AqDhuLM;EACE,YAAA;EACA,SAAA;E3CzMJ,gBAAA;AV46LJ;AqD/tLM;;E3C7MF,gBAAA;AVg7LJ;AqD9tLM;EACE,gBAAA;ArDguLR;;AiB13LI;EoCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErDsvLJ;EqDpvLI;IACE,YAAA;IACA,SAAA;I3CzMJ,gBAAA;EVg8LF;EqDnvLI;;I3C7MF,gBAAA;EVo8LF;EqDlvLI;IACE,gBAAA;ErDovLN;AACF;AiB/4LI;EoCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErD0wLJ;EqDxwLI;IACE,YAAA;IACA,SAAA;I3CzMJ,gBAAA;EVo9LF;EqDvwLI;;I3C7MF,gBAAA;EVw9LF;EqDtwLI;IACE,gBAAA;ErDwwLN;AACF;AiBn6LI;EoCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErD8xLJ;EqD5xLI;IACE,YAAA;IACA,SAAA;I3CzMJ,gBAAA;EVw+LF;EqD3xLI;;I3C7MF,gBAAA;EV4+LF;EqD1xLI;IACE,gBAAA;ErD4xLN;AACF;AiBv7LI;EoCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErDkzLJ;EqDhzLI;IACE,YAAA;IACA,SAAA;I3CzMJ,gBAAA;EV4/LF;EqD/yLI;;I3C7MF,gBAAA;EVggMF;EqD9yLI;IACE,gBAAA;ErDgzLN;AACF;AiB38LI;EoCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErDs0LJ;EqDp0LI;IACE,YAAA;IACA,SAAA;I3CzMJ,gBAAA;EVghMF;EqDn0LI;;I3C7MF,gBAAA;EVohMF;EqDl0LI;IACE,gBAAA;ErDo0LN;AACF;AuD1iMA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,sBAAA;EhDwRI,iCALI;EgDjRR,2CAAA;EACA,qCAAA;EACA,kCAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,iCtDgkB4B;EsD9jB5B,kBAAA;EACA,gBtD4kB4B;EsD3kB5B,gBtDilB4B;EsDhlB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AvDkjMF;AuDhjME;EAAS,kCAAA;AvDmjMX;AuDjjME;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AvDmjMJ;AuDjjMI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AvDmjMN;;AuD9iMA;EACE,iDAAA;AvDijMF;AuD/iME;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AvDijMJ;;AuD7iMA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AvDgjMF;AuD9iME;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AvDgjMJ;;AuD5iMA,mBAAA;AAEA;EACE,8CAAA;AvD8iMF;AuD5iME;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AvD8iMJ;;AuD1iMA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AvD6iMF;AuD3iME;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AvD6iMJ;;AuDziMA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E7CjGE,8CAAA;AV6nMJ;;AyDhpMA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,qCAAA;EACA,8BAAA;EACA,yDAAA;EACA,kCAAA;EACA,oDAAA;EACA,6CAAA;EACA,qCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,yDAAA;EACA,mDAAA;EACA,oCAAA;EACA,mCAAA;EACA,qDAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,iCtDgkB4B;EsD9jB5B,kBAAA;EACA,gBtD4kB4B;EsD3kB5B,gBtDilB4B;EsDhlB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E/ChBE,8CAAA;AV2qMJ;AyDvpME;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AzDypMJ;AyDvpMI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AzDwpMN;;AyDlpME;EACE,oFAAA;AzDqpMJ;AyDnpMI;EAEE,wFAAA;AzDopMN;AyDjpMI;EACE,SAAA;EACA,gDAAA;AzDmpMN;AyDhpMI;EACE,sCAAA;EACA,sCAAA;AzDkpMN;;AyD7oMA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AzD+oMJ;AyD7oMI;EAEE,kIAAA;AzD8oMN;AyD3oMI;EACE,OAAA;EACA,kDAAA;AzD6oMN;AyD1oMI;EACE,oCAAA;EACA,wCAAA;AzD4oMN;;AyDvoMA,mBAAA;AAGE;EACE,iFAAA;AzDwoMJ;AyDtoMI;EAEE,wFAAA;AzDuoMN;AyDpoMI;EACE,MAAA;EACA,mDAAA;AzDsoMN;AyDnoMI;EACE,mCAAA;EACA,yCAAA;AzDqoMN;AyDhoME;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AzDkoMJ;;AyD9nMA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AzDgoMJ;AyD9nMI;EAEE,kIAAA;AzD+nMN;AyD5nMI;EACE,QAAA;EACA,iDAAA;AzD8nMN;AyD3nMI;EACE,qCAAA;EACA,uCAAA;AzD6nMN;;AyDxnMA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E/C5JE,6DAAA;EACA,8DAAA;AVuwMJ;AyDzmME;EACE,aAAA;AzD2mMJ;;AyDvmMA;EACE,0EAAA;EACA,mCAAA;AzD0mMF;;A0D/xMA;EACE,kBAAA;A1DkyMF;;A0D/xMA;EACE,mBAAA;A1DkyMF;;A0D/xMA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A1DkyMF;A2DxzME;EACE,cAAA;EACA,WAAA;EACA,WAAA;A3D0zMJ;;A0DnyMA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;A1DsyMF;AyBrzMM;EiCQN;IjCPQ,gBAAA;EzBwzMN;AACF;;A0DxyMA;;;EAGE,cAAA;A1D2yMF;;A0DxyMA;;EAEE,2BAAA;A1D2yMF;;A0DxyMA;;EAEE,4BAAA;A1D2yMF;;A0DlyME;EACE,UAAA;EACA,4BAAA;EACA,eAAA;A1DqyMJ;A0DlyME;;;EAGE,UAAA;EACA,UAAA;A1DoyMJ;A0DjyME;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;A1DmyMJ;AyB51MM;EiCqDJ;;IjCpDM,gBAAA;EzBg2MN;AACF;;A0DhyMA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UxD26CmC;EwD16CnC,UAAA;EACA,WxDw6CmC;EwDx6CnC,uCxDw6CmC;EwDv6CnC,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YxDs6CmC;EuB5/C/B,8BiCuFJ;A1DkyMF;AyBr3MM;EiCkEN;;IjCjEQ,gBAAA;EzBy3MN;AACF;A0DryME;;;EAEE,WxD85CiC;EwD95CjC,uCxD85CiC;EwD75CjC,qBAAA;EACA,UAAA;EACA,YxD85CiC;AF04JrC;;A0DryMA;EACE,OAAA;A1DwyMF;;A0DryMA;EACE,QAAA;A1DwyMF;;A0DnyMA;;EAEE,qBAAA;EACA,WxD+5CmC;EwD95CnC,YxD85CmC;EwD75CnC,4BAAA;EACA,wBAAA;EACA,0BAAA;A1DsyMF;;A0DnyMA;EACE,2TAAA;A1DsyMF;;A0DpyMA;EACE,0TAAA;A1DuyMF;;A0D/xMA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBxD+2CmC;EwD92CnC,mBAAA;EACA,gBxD62CmC;AFo7JrC;A0D/xME;EACE,uBAAA;EACA,cAAA;EACA,WxD62CiC;EwD52CjC,WxD62CiC;EwD52CjC,UAAA;EACA,iBxD62CiC;EwD52CjC,gBxD42CiC;EwD32CjC,mBAAA;EACA,eAAA;EACA,sBxD22CiC;EwD32CjC,wDxD22CiC;EwD12CjC,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YxDo2CiC;EuBpgD/B,6BiCiKF;A1DgyMJ;AyB77MM;EiC4IJ;IjC3IM,gBAAA;EzBg8MN;AACF;A0DlyME;EACE,UxDi2CiC;AFm8JrC;;A0D3xMA;EACE,kBAAA;EACA,UAAA;EACA,exD21CmC;EwD11CnC,SAAA;EACA,oBxDw1CmC;EwDv1CnC,uBxDu1CmC;EwDt1CnC,WxDq1CmC;EwDr1CnC,uCxDq1CmC;EwDp1CnC,kBAAA;A1D8xMF;;A0DxxME;;EAEE,gCxD01CiC;AFi8JrC;A0DxxME;EACE,sBxDo1CiC;EwDp1CjC,6DxDo1CiC;AFs8JrC;A0DvxME;EACE,WxDi1CiC;EwDj1CjC,4CxDi1CiC;AFw8JrC;;A0DnyME;;;EAEE,gCxD01CiC;AF68JrC;A0DpyME;EACE,sBxDo1CiC;EwDp1CjC,6DxDo1CiC;AFk9JrC;A0DnyME;EACE,WxDi1CiC;EwDj1CjC,4CxDi1CiC;AFo9JrC;;A4Dv/MA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A5Dy/MF;;A4Dr/MA;EACE;IAAK,0CAAA;E5Dy/ML;AACF;A4Dt/MA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A5Dq/MF;;A4Dl/MA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A5Do/MF;;A4D3+MA;EACE;IACE,mBAAA;E5D8+MF;E4D5+MA;IACE,UAAA;IACA,eAAA;E5D8+MF;AACF;A4D1+MA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A5Dy+MF;;A4Dt+MA;EACE,wBAAA;EACA,yBAAA;A5Dy+MF;;A4Dr+ME;EACE;;IAEE,kCAAA;E5Dw+MJ;AACF;A6DxjNA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,6CAAA;EACA,gCAAA;EACA,wCAAA;EACA,gEAAA;EACA,qDAAA;EACA,qCAAA;A7DyjNF;;AiB5/MI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,0CoC8BA;E7D0iNJ;AACF;AyBrkNM;EoCYJ;IpCXM,gBAAA;EzBwkNN;AACF;AiBlhNI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E7DijNN;E6D9iNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E7DgjNN;E6D7iNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E7D+iNN;E6D5iNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E7D8iNN;E6D3iNI;IAEE,eAAA;E7D4iNN;E6DziNI;IAGE,mBAAA;E7DyiNN;AACF;AiBtkNI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E7DwiNN;E6DtiNM;IACE,aAAA;E7DwiNR;E6DriNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7DsiNR;AACF;;AiB1kNI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,0CoC8BA;E7DwnNJ;AACF;AyBnpNM;EoCYJ;IpCXM,gBAAA;EzBspNN;AACF;AiBhmNI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E7D+nNN;E6D5nNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E7D8nNN;E6D3nNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E7D6nNN;E6D1nNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E7D4nNN;E6DznNI;IAEE,eAAA;E7D0nNN;E6DvnNI;IAGE,mBAAA;E7DunNN;AACF;AiBppNI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E7DsnNN;E6DpnNM;IACE,aAAA;E7DsnNR;E6DnnNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7DonNR;AACF;;AiBxpNI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,0CoC8BA;E7DssNJ;AACF;AyBjuNM;EoCYJ;IpCXM,gBAAA;EzBouNN;AACF;AiB9qNI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E7D6sNN;E6D1sNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E7D4sNN;E6DzsNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E7D2sNN;E6DxsNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E7D0sNN;E6DvsNI;IAEE,eAAA;E7DwsNN;E6DrsNI;IAGE,mBAAA;E7DqsNN;AACF;AiBluNI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E7DosNN;E6DlsNM;IACE,aAAA;E7DosNR;E6DjsNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7DksNR;AACF;;AiBtuNI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,0CoC8BA;E7DoxNJ;AACF;AyB/yNM;EoCYJ;IpCXM,gBAAA;EzBkzNN;AACF;AiB5vNI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E7D2xNN;E6DxxNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E7D0xNN;E6DvxNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E7DyxNN;E6DtxNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E7DwxNN;E6DrxNI;IAEE,eAAA;E7DsxNN;E6DnxNI;IAGE,mBAAA;E7DmxNN;AACF;AiBhzNI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E7DkxNN;E6DhxNM;IACE,aAAA;E7DkxNR;E6D/wNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7DgxNR;AACF;;AiBpzNI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC5BA,0CoC8BA;E7Dk2NJ;AACF;AyB73NM;EoCYJ;IpCXM,gBAAA;EzBg4NN;AACF;AiB10NI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E7Dy2NN;E6Dt2NI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E7Dw2NN;E6Dr2NI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E7Du2NN;E6Dp2NI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E7Ds2NN;E6Dn2NI;IAEE,eAAA;E7Do2NN;E6Dj2NI;IAGE,mBAAA;E7Di2NN;AACF;AiB93NI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E7Dg2NN;E6D91NM;IACE,aAAA;E7Dg2NR;E6D71NM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7D81NR;AACF;;A6D96NE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EpC5BA,0CoC8BA;A7D+6NN;AyBz8NM;EoCYJ;IpCXM,gBAAA;EzB48NN;AACF;A6Dl7NM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A7Do7NR;A6Dj7NM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A7Dm7NR;A6Dh7NM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A7Dk7NR;A6D/6NM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A7Di7NR;A6D96NM;EAEE,eAAA;A7D+6NR;A6D56NM;EAGE,mBAAA;A7D46NR;;A6Dj5NA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,apD4iCkC;EoD3iClC,YAAA;EACA,aAAA;EACA,yBpDs4CkC;EoDt4ClC,6CpDs4CkC;AFmoLpC;AsDtgOE;EAAS,UAAA;AtDygOX;AsDxgOE;EAAS,YpDm4CyB;AFwoLpC;;A6D75NA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;A7Dg6NF;A6D95NE;EACE,4FAAA;EACA,6IAAA;A7Dg6NJ;;A6D55NA;EACE,gBAAA;EACA,kDAAA;A7D+5NF;;A6D55NA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A7D+5NF;;A8D5iOA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,Y5D2tCkC;AFo1LpC;A8D7iOE;EACE,qBAAA;EACA,WAAA;A9D+iOJ;;A8D1iOA;EACE,iBAAA;A9D6iOF;;A8D1iOA;EACE,iBAAA;A9D6iOF;;A8D1iOA;EACE,iBAAA;A9D6iOF;;A8DxiOE;EACE,mDAAA;A9D2iOJ;;A8DviOA;EACE;IACE,Y5D8rCgC;EF42LlC;AACF;A8DviOA;EACE,uFAAA;UAAA,+EAAA;EACA,4BAAA;UAAA,oBAAA;EACA,8CAAA;A9DyiOF;;A8DtiOA;EACE;IACE,+BAAA;YAAA,uBAAA;E9DyiOF;AACF;A2DxlOE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A3D0lOJ;;A+D7lOE;EACE,sBAAA;EACA,mDAAA;EAAA,iFAAA;A/DgmOJ;;A+DlmOE;EACE,sBAAA;EACA,mDAAA;EAAA,mFAAA;A/DqmOJ;;A+DvmOE;EACE,sBAAA;EACA,kDAAA;EAAA,iFAAA;A/D0mOJ;;A+D5mOE;EACE,sBAAA;EACA,kDAAA;EAAA,8EAAA;A/D+mOJ;;A+DjnOE;EACE,yBAAA;EACA,iDAAA;EAAA,iFAAA;A/DonOJ;;A+DtnOE;EACE,sBAAA;EACA,kDAAA;EAAA,gFAAA;A/DynOJ;;A+D3nOE;EACE,yBAAA;EACA,mDAAA;EAAA,+EAAA;A/D8nOJ;;A+DhoOE;EACE,sBAAA;EACA,gDAAA;EAAA,8EAAA;A/DmoOJ;;AgEroOE;EACE,wCAAA;EAAA,wEAAA;EACA,wDAAA;EAAA,kGAAA;AhEwoOJ;AgEroOM;EAGE,uCAAA;EAAA,+DAAA;EACA,uDAAA;EAAA,yFAAA;AhEqoOR;;AgE9oOE;EACE,wCAAA;EAAA,0EAAA;EACA,wDAAA;EAAA,oGAAA;AhEipOJ;AgE9oOM;EAGE,sCAAA;EAAA,8DAAA;EACA,sDAAA;EAAA,wFAAA;AhE8oOR;;AgEvpOE;EACE,uCAAA;EAAA,wEAAA;EACA,uDAAA;EAAA,kGAAA;AhE0pOJ;AgEvpOM;EAGE,sCAAA;EAAA,8DAAA;EACA,sDAAA;EAAA,wFAAA;AhEupOR;;AgEhqOE;EACE,uCAAA;EAAA,qEAAA;EACA,uDAAA;EAAA,+FAAA;AhEmqOJ;AgEhqOM;EAGE,uCAAA;EAAA,+DAAA;EACA,uDAAA;EAAA,yFAAA;AhEgqOR;;AgEzqOE;EACE,sCAAA;EAAA,wEAAA;EACA,sDAAA;EAAA,kGAAA;AhE4qOJ;AgEzqOM;EAGE,uCAAA;EAAA,+DAAA;EACA,uDAAA;EAAA,yFAAA;AhEyqOR;;AgElrOE;EACE,uCAAA;EAAA,uEAAA;EACA,uDAAA;EAAA,iGAAA;AhEqrOJ;AgElrOM;EAGE,uCAAA;EAAA,+DAAA;EACA,uDAAA;EAAA,yFAAA;AhEkrOR;;AgE3rOE;EACE,wCAAA;EAAA,sEAAA;EACA,wDAAA;EAAA,gGAAA;AhE8rOJ;AgE3rOM;EAGE,wCAAA;EAAA,gEAAA;EACA,wDAAA;EAAA,0FAAA;AhE2rOR;;AgEpsOE;EACE,qCAAA;EAAA,qEAAA;EACA,qDAAA;EAAA,+FAAA;AhEusOJ;AgEpsOM;EAGE,qCAAA;EAAA,6DAAA;EACA,qDAAA;EAAA,uFAAA;AhEosOR;;AgE7rOA;EACE,kCAAA;EAAA,+EAAA;EACA,kDAAA;EAAA,yGAAA;AhEgsOF;AgE7rOI;EAEE,qCAAA;EAAA,kFAAA;EACA,qDAAA;EAAA,4GAAA;AhE8rON;;AiExtOA;EACE,UAAA;EAEA,kDAAA;EAAA,kJAAA;AjE0tOF;;AkE7tOA;EACE,oBAAA;EACA,anC6c4B;EmC5c5B,mBAAA;EACA,8CAAA;EAAA,kFAAA;EACA,6BnC2c4B;EmC1c5B,2BAAA;AlEguOF;AkE9tOE;EACE,cAAA;EACA,UnCuc0B;EmCtc1B,WnCsc0B;EmCrc1B,kBAAA;EzCIE,sCyCHF;AlEguOJ;AyBztOM;EyCZJ;IzCaM,gBAAA;EzB4tON;AACF;;AkE9tOI;EACE,oCAAA;EAAA,mEAAA;AlEiuON;;AmEpvOA;EACE,kBAAA;EACA,WAAA;AnEuvOF;AmErvOE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AnEuvOJ;AmEpvOE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AnEsvOJ;;AmEjvOE;EACE,uBAAA;AnEovOJ;;AmErvOE;EACE,sBAAA;AnEwvOJ;;AmEzvOE;EACE,yBAAA;AnE4vOJ;;AmE7vOE;EACE,iCAAA;AnEgwOJ;;AoErxOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,alEyiCkC;AF+uMpC;;AoErxOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,alEiiCkC;AFuvMpC;;AoEhxOI;EACE,gBAAA;EACA,MAAA;EACA,alEqhC8B;AF8vMpC;;AoEhxOI;EACE,gBAAA;EACA,SAAA;EACA,alE+gC8B;AFowMpC;;AiBpvOI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,alEqhC8B;EF2wMlC;EoE7xOE;IACE,gBAAA;IACA,SAAA;IACA,alE+gC8B;EFgxMlC;AACF;AiBjwOI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,alEqhC8B;EFuxMlC;EoEzyOE;IACE,gBAAA;IACA,SAAA;IACA,alE+gC8B;EF4xMlC;AACF;AiB7wOI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,alEqhC8B;EFmyMlC;EoErzOE;IACE,gBAAA;IACA,SAAA;IACA,alE+gC8B;EFwyMlC;AACF;AiBzxOI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,alEqhC8B;EF+yMlC;EoEj0OE;IACE,gBAAA;IACA,SAAA;IACA,alE+gC8B;EFozMlC;AACF;AiBryOI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,alEqhC8B;EF2zMlC;EoE70OE;IACE,gBAAA;IACA,SAAA;IACA,alE+gC8B;EFg0MlC;AACF;AqE/2OA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;ArEi3OF;;AqE92OA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;ArEi3OF;;AsEz3OA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AvE03OF;AuEv3OE;;EACE,6BAAA;AvE03OJ;;AwEx4OE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UtEwbsC;EsEvbtC,WAAA;AxE24OJ;;AyEn5OA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;A1Eu5OF;;A2E75OA;EACE,qBAAA;EACA,mBAAA;EACA,U5CisB4B;E4CjsB5B,6B5CisB4B;E4ChsB5B,eAAA;EACA,8BAAA;EACA,azEopB4B;AF4wN9B;;A4Ep2OQ;EAOI,mCAAA;A5Ei2OZ;;A4Ex2OQ;EAOI,8BAAA;A5Eq2OZ;;A4E52OQ;EAOI,iCAAA;A5Ey2OZ;;A4Eh3OQ;EAOI,iCAAA;A5E62OZ;;A4Ep3OQ;EAOI,sCAAA;A5Ei3OZ;;A4Ex3OQ;EAOI,mCAAA;A5Eq3OZ;;A4E53OQ;EAOI,sBAAA;A5Ey3OZ;;A4Eh4OQ;EAOI,uBAAA;A5E63OZ;;A4Ep4OQ;EAOI,sBAAA;A5Ei4OZ;;A4Ex4OQ;EAOI,8BAAA;A5Eq4OZ;;A4E54OQ;EAOI,4BAAA;A5Ey4OZ;;A4Eh5OQ;EAOI,2BAAA;A5E64OZ;;A4Ep5OQ;EAOI,iCAAA;A5Ei5OZ;;A4Ex5OQ;EAOI,2BAAA;A5Eq5OZ;;A4E55OQ;EAOI,qBAAA;A5Ey5OZ;;A4Eh6OQ;EAOI,wBAAA;A5E65OZ;;A4Ep6OQ;EAOI,uBAAA;A5Ei6OZ;;A4Ex6OQ;EAOI,wBAAA;A5Eq6OZ;;A4E56OQ;EAOI,qBAAA;A5Ey6OZ;;A4Eh7OQ;EAOI,yBAAA;A5E66OZ;;A4Ep7OQ;EAOI,2BAAA;A5Ei7OZ;;A4Ex7OQ;EAOI,4BAAA;A5Eq7OZ;;A4E57OQ;EAOI,2BAAA;A5Ey7OZ;;A4Eh8OQ;EAOI,2BAAA;A5E67OZ;;A4Ep8OQ;EAOI,6BAAA;A5Ei8OZ;;A4Ex8OQ;EAOI,8BAAA;A5Eq8OZ;;A4E58OQ;EAOI,6BAAA;A5Ey8OZ;;A4Eh9OQ;EAOI,2BAAA;A5E68OZ;;A4Ep9OQ;EAOI,6BAAA;A5Ei9OZ;;A4Ex9OQ;EAOI,8BAAA;A5Eq9OZ;;A4E59OQ;EAOI,6BAAA;A5Ey9OZ;;A4Eh+OQ;EAOI,0BAAA;A5E69OZ;;A4Ep+OQ;EAOI,gCAAA;A5Ei+OZ;;A4Ex+OQ;EAOI,yBAAA;A5Eq+OZ;;A4E5+OQ;EAOI,wBAAA;A5Ey+OZ;;A4Eh/OQ;EAOI,+BAAA;A5E6+OZ;;A4Ep/OQ;EAOI,yBAAA;A5Ei/OZ;;A4Ex/OQ;EAOI,6BAAA;A5Eq/OZ;;A4E5/OQ;EAOI,8BAAA;A5Ey/OZ;;A4EhgPQ;EAOI,wBAAA;A5E6/OZ;;A4EpgPQ;EAOI,+BAAA;A5EigPZ;;A4ExgPQ;EAOI,wBAAA;A5EqgPZ;;A4E5gPQ;EAOI,iEAAA;EAAA,2CAAA;A5EygPZ;;A4EhhPQ;EAOI,4DAAA;EAAA,8CAAA;A5E6gPZ;;A4EphPQ;EAOI,qDAAA;EAAA,8CAAA;A5EihPZ;;A4ExhPQ;EAOI,2BAAA;A5EqhPZ;;A4EtiPQ;EACE,gFAAA;A5EyiPV;;A4E1iPQ;EACE,kFAAA;A5E6iPV;;A4E9iPQ;EACE,gFAAA;A5EijPV;;A4EljPQ;EACE,6EAAA;A5EqjPV;;A4EtjPQ;EACE,gFAAA;A5EyjPV;;A4E1jPQ;EACE,+EAAA;A5E6jPV;;A4E9jPQ;EACE,8EAAA;A5EikPV;;A4ElkPQ;EACE,6EAAA;A5EqkPV;;A4E5jPQ;EAOI,2BAAA;A5EyjPZ;;A4EhkPQ;EAOI,6BAAA;A5E6jPZ;;A4EpkPQ;EAOI,6BAAA;A5EikPZ;;A4ExkPQ;EAOI,0BAAA;A5EqkPZ;;A4E5kPQ;EAOI,2BAAA;A5EykPZ;;A4EhlPQ;EAOI,iBAAA;A5E6kPZ;;A4EplPQ;EAOI,mBAAA;A5EilPZ;;A4ExlPQ;EAOI,oBAAA;A5EqlPZ;;A4E5lPQ;EAOI,oBAAA;A5EylPZ;;A4EhmPQ;EAOI,sBAAA;A5E6lPZ;;A4EpmPQ;EAOI,uBAAA;A5EimPZ;;A4ExmPQ;EAOI,kBAAA;A5EqmPZ;;A4E5mPQ;EAOI,oBAAA;A5EymPZ;;A4EhnPQ;EAOI,qBAAA;A5E6mPZ;;A4EpnPQ;EAOI,mBAAA;A5EinPZ;;A4ExnPQ;EAOI,qBAAA;A5EqnPZ;;A4E5nPQ;EAOI,sBAAA;A5EynPZ;;A4EhoPQ;EAOI,2CAAA;A5E6nPZ;;A4EpoPQ;EAOI,sCAAA;A5EioPZ;;A4ExoPQ;EAOI,sCAAA;A5EqoPZ;;A4E5oPQ;EAOI,oCAAA;EAAA,uFAAA;A5EyoPZ;;A4EhpPQ;EAOI,oBAAA;A5E6oPZ;;A4EppPQ;EAOI,wCAAA;EAAA,2FAAA;A5EipPZ;;A4ExpPQ;EAOI,wBAAA;A5EqpPZ;;A4E5pPQ;EAOI,0CAAA;EAAA,6FAAA;A5EypPZ;;A4EhqPQ;EAOI,0BAAA;A5E6pPZ;;A4EpqPQ;EAOI,2CAAA;EAAA,8FAAA;A5EiqPZ;;A4ExqPQ;EAOI,2BAAA;A5EqqPZ;;A4E5qPQ;EAOI,yCAAA;EAAA,4FAAA;A5EyqPZ;;A4EhrPQ;EAOI,yBAAA;A5E6qPZ;;A4EprPQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,8EAAA;A5EkrPZ;;A4EzrPQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,gFAAA;A5EurPZ;;A4E9rPQ;EAIQ,sBAAA;EAGJ,qEAAA;EAAA,8EAAA;A5E4rPZ;;A4EnsPQ;EAIQ,sBAAA;EAGJ,qEAAA;EAAA,2EAAA;A5EisPZ;;A4ExsPQ;EAIQ,sBAAA;EAGJ,oEAAA;EAAA,8EAAA;A5EssPZ;;A4E7sPQ;EAIQ,sBAAA;EAGJ,qEAAA;EAAA,6EAAA;A5E2sPZ;;A4EltPQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,4EAAA;A5EgtPZ;;A4EvtPQ;EAIQ,sBAAA;EAGJ,mEAAA;EAAA,2EAAA;A5EqtPZ;;A4E5tPQ;EAIQ,sBAAA;EAGJ,gEAAA;EAAA,4EAAA;A5E0tPZ;;A4EjuPQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,4EAAA;A5E+tPZ;;A4EtuPQ;EAOI,4EAAA;EAAA,wDAAA;A5EmuPZ;;A4E1uPQ;EAOI,4EAAA;EAAA,0DAAA;A5EuuPZ;;A4E9uPQ;EAOI,4EAAA;EAAA,wDAAA;A5E2uPZ;;A4ElvPQ;EAOI,4EAAA;EAAA,qDAAA;A5E+uPZ;;A4EtvPQ;EAOI,kEAAA;EAAA,wDAAA;A5EmvPZ;;A4E1vPQ;EAOI,4EAAA;EAAA,uDAAA;A5EuvPZ;;A4E9vPQ;EAOI,gCAAA;EAAA,sDAAA;A5E2vPZ;;A4ElwPQ;EAOI,gCAAA;EAAA,qDAAA;A5E+vPZ;;A4EtwPQ;EAOI,0BAAA;A5EmwPZ;;A4E1wPQ;EAOI,4BAAA;A5EuwPZ;;A4E9wPQ;EAOI,4BAAA;A5E2wPZ;;A4ElxPQ;EAOI,4BAAA;A5E+wPZ;;A4EtxPQ;EAOI,4BAAA;A5EmxPZ;;A4E1xPQ;EAOI,4BAAA;A5EuxPZ;;A4ExyPQ;EACE,wBAAA;A5E2yPV;;A4E5yPQ;EACE,yBAAA;A5E+yPV;;A4EhzPQ;EACE,wBAAA;A5EmzPV;;A4EpzPQ;EACE,yBAAA;A5EuzPV;;A4ExzPQ;EACE,sBAAA;A5E2zPV;;A4ElzPQ;EAOI,qBAAA;A5E+yPZ;;A4EtzPQ;EAOI,qBAAA;A5EmzPZ;;A4E1zPQ;EAOI,qBAAA;A5EuzPZ;;A4E9zPQ;EAOI,sBAAA;A5E2zPZ;;A4El0PQ;EAOI,sBAAA;A5E+zPZ;;A4Et0PQ;EAOI,0BAAA;A5Em0PZ;;A4E10PQ;EAOI,uBAAA;A5Eu0PZ;;A4E90PQ;EAOI,2BAAA;A5E20PZ;;A4El1PQ;EAOI,sBAAA;A5E+0PZ;;A4Et1PQ;EAOI,sBAAA;A5Em1PZ;;A4E11PQ;EAOI,sBAAA;A5Eu1PZ;;A4E91PQ;EAOI,uBAAA;A5E21PZ;;A4El2PQ;EAOI,uBAAA;A5E+1PZ;;A4Et2PQ;EAOI,2BAAA;A5Em2PZ;;A4E12PQ;EAOI,wBAAA;A5Eu2PZ;;A4E92PQ;EAOI,4BAAA;A5E22PZ;;A4El3PQ;EAOI,yBAAA;A5E+2PZ;;A4Et3PQ;EAOI,8BAAA;A5Em3PZ;;A4E13PQ;EAOI,iCAAA;A5Eu3PZ;;A4E93PQ;EAOI,sCAAA;A5E23PZ;;A4El4PQ;EAOI,yCAAA;A5E+3PZ;;A4Et4PQ;EAOI,uBAAA;A5Em4PZ;;A4E14PQ;EAOI,uBAAA;A5Eu4PZ;;A4E94PQ;EAOI,yBAAA;A5E24PZ;;A4El5PQ;EAOI,yBAAA;A5E+4PZ;;A4Et5PQ;EAOI,0BAAA;A5Em5PZ;;A4E15PQ;EAOI,4BAAA;A5Eu5PZ;;A4E95PQ;EAOI,kCAAA;A5E25PZ;;A4El6PQ;EAOI,sCAAA;A5E+5PZ;;A4Et6PQ;EAOI,oCAAA;A5Em6PZ;;A4E16PQ;EAOI,kCAAA;A5Eu6PZ;;A4E96PQ;EAOI,yCAAA;A5E26PZ;;A4El7PQ;EAOI,wCAAA;A5E+6PZ;;A4Et7PQ;EAOI,wCAAA;A5Em7PZ;;A4E17PQ;EAOI,kCAAA;A5Eu7PZ;;A4E97PQ;EAOI,gCAAA;A5E27PZ;;A4El8PQ;EAOI,8BAAA;A5E+7PZ;;A4Et8PQ;EAOI,gCAAA;A5Em8PZ;;A4E18PQ;EAOI,+BAAA;A5Eu8PZ;;A4E98PQ;EAOI,oCAAA;A5E28PZ;;A4El9PQ;EAOI,kCAAA;A5E+8PZ;;A4Et9PQ;EAOI,gCAAA;A5Em9PZ;;A4E19PQ;EAOI,uCAAA;A5Eu9PZ;;A4E99PQ;EAOI,sCAAA;A5E29PZ;;A4El+PQ;EAOI,iCAAA;A5E+9PZ;;A4Et+PQ;EAOI,2BAAA;A5Em+PZ;;A4E1+PQ;EAOI,iCAAA;A5Eu+PZ;;A4E9+PQ;EAOI,+BAAA;A5E2+PZ;;A4El/PQ;EAOI,6BAAA;A5E++PZ;;A4Et/PQ;EAOI,+BAAA;A5Em/PZ;;A4E1/PQ;EAOI,8BAAA;A5Eu/PZ;;A4E9/PQ;EAOI,oBAAA;A5E2/PZ;;A4ElgQQ;EAOI,mBAAA;A5E+/PZ;;A4EtgQQ;EAOI,mBAAA;A5EmgQZ;;A4E1gQQ;EAOI,mBAAA;A5EugQZ;;A4E9gQQ;EAOI,mBAAA;A5E2gQZ;;A4ElhQQ;EAOI,mBAAA;A5E+gQZ;;A4EthQQ;EAOI,mBAAA;A5EmhQZ;;A4E1hQQ;EAOI,mBAAA;A5EuhQZ;;A4E9hQQ;EAOI,oBAAA;A5E2hQZ;;A4EliQQ;EAOI,2BAAA;A5E+hQZ;;A4EtiQQ;EAOI,0BAAA;A5EmiQZ;;A4E1iQQ;EAOI,yBAAA;A5EuiQZ;;A4E9iQQ;EAOI,0BAAA;A5E2iQZ;;A4EljQQ;EAOI,yBAAA;A5E+iQZ;;A4EtjQQ;EAOI,uBAAA;A5EmjQZ;;A4E1jQQ;EAOI,0BAAA;EAAA,yBAAA;A5EwjQZ;;A4E/jQQ;EAOI,iCAAA;EAAA,gCAAA;A5E6jQZ;;A4EpkQQ;EAOI,gCAAA;EAAA,+BAAA;A5EkkQZ;;A4EzkQQ;EAOI,+BAAA;EAAA,8BAAA;A5EukQZ;;A4E9kQQ;EAOI,gCAAA;EAAA,+BAAA;A5E4kQZ;;A4EnlQQ;EAOI,+BAAA;EAAA,8BAAA;A5EilQZ;;A4ExlQQ;EAOI,6BAAA;EAAA,4BAAA;A5EslQZ;;A4E7lQQ;EAOI,wBAAA;EAAA,2BAAA;A5E2lQZ;;A4ElmQQ;EAOI,+BAAA;EAAA,kCAAA;A5EgmQZ;;A4EvmQQ;EAOI,8BAAA;EAAA,iCAAA;A5EqmQZ;;A4E5mQQ;EAOI,6BAAA;EAAA,gCAAA;A5E0mQZ;;A4EjnQQ;EAOI,8BAAA;EAAA,iCAAA;A5E+mQZ;;A4EtnQQ;EAOI,6BAAA;EAAA,gCAAA;A5EonQZ;;A4E3nQQ;EAOI,2BAAA;EAAA,8BAAA;A5EynQZ;;A4EhoQQ;EAOI,wBAAA;A5E6nQZ;;A4EpoQQ;EAOI,+BAAA;A5EioQZ;;A4ExoQQ;EAOI,8BAAA;A5EqoQZ;;A4E5oQQ;EAOI,6BAAA;A5EyoQZ;;A4EhpQQ;EAOI,8BAAA;A5E6oQZ;;A4EppQQ;EAOI,6BAAA;A5EipQZ;;A4ExpQQ;EAOI,2BAAA;A5EqpQZ;;A4E5pQQ;EAOI,0BAAA;A5EypQZ;;A4EhqQQ;EAOI,iCAAA;A5E6pQZ;;A4EpqQQ;EAOI,gCAAA;A5EiqQZ;;A4ExqQQ;EAOI,+BAAA;A5EqqQZ;;A4E5qQQ;EAOI,gCAAA;A5EyqQZ;;A4EhrQQ;EAOI,+BAAA;A5E6qQZ;;A4EprQQ;EAOI,6BAAA;A5EirQZ;;A4ExrQQ;EAOI,2BAAA;A5EqrQZ;;A4E5rQQ;EAOI,kCAAA;A5EyrQZ;;A4EhsQQ;EAOI,iCAAA;A5E6rQZ;;A4EpsQQ;EAOI,gCAAA;A5EisQZ;;A4ExsQQ;EAOI,iCAAA;A5EqsQZ;;A4E5sQQ;EAOI,gCAAA;A5EysQZ;;A4EhtQQ;EAOI,8BAAA;A5E6sQZ;;A4EptQQ;EAOI,yBAAA;A5EitQZ;;A4ExtQQ;EAOI,gCAAA;A5EqtQZ;;A4E5tQQ;EAOI,+BAAA;A5EytQZ;;A4EhuQQ;EAOI,8BAAA;A5E6tQZ;;A4EpuQQ;EAOI,+BAAA;A5EiuQZ;;A4ExuQQ;EAOI,8BAAA;A5EquQZ;;A4E5uQQ;EAOI,4BAAA;A5EyuQZ;;A4EhvQQ;EAOI,4BAAA;A5E6uQZ;;A4EpvQQ;EAOI,2BAAA;A5EivQZ;;A4ExvQQ;EAOI,0BAAA;A5EqvQZ;;A4E5vQQ;EAOI,2BAAA;A5EyvQZ;;A4EhwQQ;EAOI,0BAAA;A5E6vQZ;;A4EpwQQ;EAOI,kCAAA;EAAA,iCAAA;A5EkwQZ;;A4EzwQQ;EAOI,iCAAA;EAAA,gCAAA;A5EuwQZ;;A4E9wQQ;EAOI,gCAAA;EAAA,+BAAA;A5E4wQZ;;A4EnxQQ;EAOI,iCAAA;EAAA,gCAAA;A5EixQZ;;A4ExxQQ;EAOI,gCAAA;EAAA,+BAAA;A5EsxQZ;;A4E7xQQ;EAOI,gCAAA;EAAA,mCAAA;A5E2xQZ;;A4ElyQQ;EAOI,+BAAA;EAAA,kCAAA;A5EgyQZ;;A4EvyQQ;EAOI,8BAAA;EAAA,iCAAA;A5EqyQZ;;A4E5yQQ;EAOI,+BAAA;EAAA,kCAAA;A5E0yQZ;;A4EjzQQ;EAOI,8BAAA;EAAA,iCAAA;A5E+yQZ;;A4EtzQQ;EAOI,gCAAA;A5EmzQZ;;A4E1zQQ;EAOI,+BAAA;A5EuzQZ;;A4E9zQQ;EAOI,8BAAA;A5E2zQZ;;A4El0QQ;EAOI,+BAAA;A5E+zQZ;;A4Et0QQ;EAOI,8BAAA;A5Em0QZ;;A4E10QQ;EAOI,kCAAA;A5Eu0QZ;;A4E90QQ;EAOI,iCAAA;A5E20QZ;;A4El1QQ;EAOI,gCAAA;A5E+0QZ;;A4Et1QQ;EAOI,iCAAA;A5Em1QZ;;A4E11QQ;EAOI,gCAAA;A5Eu1QZ;;A4E91QQ;EAOI,mCAAA;A5E21QZ;;A4El2QQ;EAOI,kCAAA;A5E+1QZ;;A4Et2QQ;EAOI,iCAAA;A5Em2QZ;;A4E12QQ;EAOI,kCAAA;A5Eu2QZ;;A4E92QQ;EAOI,iCAAA;A5E22QZ;;A4El3QQ;EAOI,iCAAA;A5E+2QZ;;A4Et3QQ;EAOI,gCAAA;A5Em3QZ;;A4E13QQ;EAOI,+BAAA;A5Eu3QZ;;A4E93QQ;EAOI,gCAAA;A5E23QZ;;A4El4QQ;EAOI,+BAAA;A5E+3QZ;;A4Et4QQ;EAOI,qBAAA;A5Em4QZ;;A4E14QQ;EAOI,4BAAA;A5Eu4QZ;;A4E94QQ;EAOI,2BAAA;A5E24QZ;;A4El5QQ;EAOI,0BAAA;A5E+4QZ;;A4Et5QQ;EAOI,2BAAA;A5Em5QZ;;A4E15QQ;EAOI,0BAAA;A5Eu5QZ;;A4E95QQ;EAOI,2BAAA;EAAA,0BAAA;A5E45QZ;;A4En6QQ;EAOI,kCAAA;EAAA,iCAAA;A5Ei6QZ;;A4Ex6QQ;EAOI,iCAAA;EAAA,gCAAA;A5Es6QZ;;A4E76QQ;EAOI,gCAAA;EAAA,+BAAA;A5E26QZ;;A4El7QQ;EAOI,iCAAA;EAAA,gCAAA;A5Eg7QZ;;A4Ev7QQ;EAOI,gCAAA;EAAA,+BAAA;A5Eq7QZ;;A4E57QQ;EAOI,yBAAA;EAAA,4BAAA;A5E07QZ;;A4Ej8QQ;EAOI,gCAAA;EAAA,mCAAA;A5E+7QZ;;A4Et8QQ;EAOI,+BAAA;EAAA,kCAAA;A5Eo8QZ;;A4E38QQ;EAOI,8BAAA;EAAA,iCAAA;A5Ey8QZ;;A4Eh9QQ;EAOI,+BAAA;EAAA,kCAAA;A5E88QZ;;A4Er9QQ;EAOI,8BAAA;EAAA,iCAAA;A5Em9QZ;;A4E19QQ;EAOI,yBAAA;A5Eu9QZ;;A4E99QQ;EAOI,gCAAA;A5E29QZ;;A4El+QQ;EAOI,+BAAA;A5E+9QZ;;A4Et+QQ;EAOI,8BAAA;A5Em+QZ;;A4E1+QQ;EAOI,+BAAA;A5Eu+QZ;;A4E9+QQ;EAOI,8BAAA;A5E2+QZ;;A4El/QQ;EAOI,2BAAA;A5E++QZ;;A4Et/QQ;EAOI,kCAAA;A5Em/QZ;;A4E1/QQ;EAOI,iCAAA;A5Eu/QZ;;A4E9/QQ;EAOI,gCAAA;A5E2/QZ;;A4ElgRQ;EAOI,iCAAA;A5E+/QZ;;A4EtgRQ;EAOI,gCAAA;A5EmgRZ;;A4E1gRQ;EAOI,4BAAA;A5EugRZ;;A4E9gRQ;EAOI,mCAAA;A5E2gRZ;;A4ElhRQ;EAOI,kCAAA;A5E+gRZ;;A4EthRQ;EAOI,iCAAA;A5EmhRZ;;A4E1hRQ;EAOI,kCAAA;A5EuhRZ;;A4E9hRQ;EAOI,iCAAA;A5E2hRZ;;A4EliRQ;EAOI,0BAAA;A5E+hRZ;;A4EtiRQ;EAOI,iCAAA;A5EmiRZ;;A4E1iRQ;EAOI,gCAAA;A5EuiRZ;;A4E9iRQ;EAOI,+BAAA;A5E2iRZ;;A4EljRQ;EAOI,gCAAA;A5E+iRZ;;A4EtjRQ;EAOI,+BAAA;A5EmjRZ;;A4E1jRQ;EAOI,iBAAA;A5EujRZ;;A4E9jRQ;EAOI,wBAAA;A5E2jRZ;;A4ElkRQ;EAOI,uBAAA;A5E+jRZ;;A4EtkRQ;EAOI,sBAAA;A5EmkRZ;;A4E1kRQ;EAOI,uBAAA;A5EukRZ;;A4E9kRQ;EAOI,sBAAA;A5E2kRZ;;A4EllRQ;EAOI,qBAAA;A5E+kRZ;;A4EtlRQ;EAOI,4BAAA;A5EmlRZ;;A4E1lRQ;EAOI,2BAAA;A5EulRZ;;A4E9lRQ;EAOI,0BAAA;A5E2lRZ;;A4ElmRQ;EAOI,2BAAA;A5E+lRZ;;A4EtmRQ;EAOI,0BAAA;A5EmmRZ;;A4E1mRQ;EAOI,wBAAA;A5EumRZ;;A4E9mRQ;EAOI,+BAAA;A5E2mRZ;;A4ElnRQ;EAOI,8BAAA;A5E+mRZ;;A4EtnRQ;EAOI,6BAAA;A5EmnRZ;;A4E1nRQ;EAOI,8BAAA;A5EunRZ;;A4E9nRQ;EAOI,6BAAA;A5E2nRZ;;A4EloRQ;EAOI,4GAAA;EAAA,gDAAA;A5E+nRZ;;A4EtoRQ;EAOI,2CAAA;A5EmoRZ;;A4E1oRQ;EAOI,8CAAA;A5EuoRZ;;A4E9oRQ;EAOI,4CAAA;A5E2oRZ;;A4ElpRQ;EAOI,8BAAA;A5E+oRZ;;A4EtpRQ;EAOI,+BAAA;A5EmpRZ;;A4E1pRQ;EAOI,6BAAA;A5EupRZ;;A4E9pRQ;EAOI,6BAAA;A5E2pRZ;;A4ElqRQ;EAOI,6BAAA;A5E+pRZ;;A4EtqRQ;EAOI,+BAAA;A5EmqRZ;;A4E1qRQ;EAOI,2BAAA;A5EuqRZ;;A4E9qRQ;EAOI,2BAAA;A5E2qRZ;;A4ElrRQ;EAOI,2BAAA;A5E+qRZ;;A4EtrRQ;EAOI,2BAAA;A5EmrRZ;;A4E1rRQ;EAOI,2BAAA;A5EurRZ;;A4E9rRQ;EAOI,8BAAA;A5E2rRZ;;A4ElsRQ;EAOI,yBAAA;A5E+rRZ;;A4EtsRQ;EAOI,4BAAA;A5EmsRZ;;A4E1sRQ;EAOI,2BAAA;A5EusRZ;;A4E9sRQ;EAOI,yBAAA;A5E2sRZ;;A4EltRQ;EAOI,2BAAA;A5E+sRZ;;A4EttRQ;EAOI,4BAAA;A5EmtRZ;;A4E1tRQ;EAOI,6BAAA;A5EutRZ;;A4E9tRQ;EAOI,gCAAA;A5E2tRZ;;A4EluRQ;EAOI,qCAAA;A5E+tRZ;;A4EtuRQ;EAOI,wCAAA;A5EmuRZ;;A4E1uRQ;EAOI,oCAAA;A5EuuRZ;;A4E9uRQ;EAOI,oCAAA;A5E2uRZ;;A4ElvRQ;EAOI,qCAAA;A5E+uRZ;;A4EtvRQ;EAOI,8BAAA;A5EmvRZ;;A4E1vRQ;EAOI,8BAAA;A5EuvRZ;;A4E5wRQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A5E6vRZ;;A4E1uRQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,qEAAA;A5EmwRZ;;A4E1wRQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,uEAAA;A5EwwRZ;;A4E/wRQ;EAIQ,oBAAA;EAGJ,4DAAA;EAAA,qEAAA;A5E6wRZ;;A4EpxRQ;EAIQ,oBAAA;EAGJ,4DAAA;EAAA,kEAAA;A5EkxRZ;;A4EzxRQ;EAIQ,oBAAA;EAGJ,2DAAA;EAAA,qEAAA;A5EuxRZ;;A4E9xRQ;EAIQ,oBAAA;EAGJ,4DAAA;EAAA,oEAAA;A5E4xRZ;;A4EnyRQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,mEAAA;A5EiyRZ;;A4ExyRQ;EAIQ,oBAAA;EAGJ,0DAAA;EAAA,kEAAA;A5EsyRZ;;A4E7yRQ;EAIQ,oBAAA;EAGJ,uDAAA;EAAA,mEAAA;A5E2yRZ;;A4ElzRQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,mEAAA;A5EgzRZ;;A4EvzRQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,wEAAA;A5EqzRZ;;A4E5zRQ;EAIQ,oBAAA;EAGJ,wCAAA;EAAA,2CAAA;A5E0zRZ;;A4Ej0RQ;EAIQ,oBAAA;EAGJ,oCAAA;A5E+zRZ;;A4Et0RQ;EAIQ,oBAAA;EAGJ,0CAAA;A5Eo0RZ;;A4E30RQ;EAIQ,oBAAA;EAGJ,wCAAA;EAAA,2CAAA;A5Ey0RZ;;A4Eh1RQ;EAIQ,oBAAA;EAGJ,uCAAA;EAAA,0CAAA;A5E80RZ;;A4Er1RQ;EAIQ,oBAAA;EAGJ,sBAAA;EAAA,0CAAA;A5Em1RZ;;A4E11RQ;EAIQ,oBAAA;EAGJ,yBAAA;A5Ew1RZ;;A4Ez2RQ;EACE,uBAAA;A5E42RV;;A4E72RQ;EACE,sBAAA;A5Eg3RV;;A4Ej3RQ;EACE,uBAAA;A5Eo3RV;;A4Er3RQ;EACE,oBAAA;A5Ew3RV;;A4E/2RQ;EAOI,oEAAA;EAAA,iDAAA;A5E42RZ;;A4En3RQ;EAOI,qEAAA;EAAA,mDAAA;A5Eg3RZ;;A4Ev3RQ;EAOI,oEAAA;EAAA,iDAAA;A5Eo3RZ;;A4E33RQ;EAOI,oEAAA;EAAA,8CAAA;A5Ew3RZ;;A4E/3RQ;EAOI,yDAAA;EAAA,iDAAA;A5E43RZ;;A4En4RQ;EAOI,oEAAA;EAAA,gDAAA;A5Eg4RZ;;A4Ev4RQ;EAOI,yBAAA;EAAA,+CAAA;A5Eo4RZ;;A4E34RQ;EAOI,yBAAA;EAAA,8CAAA;A5Ew4RZ;;A4Ez5RQ;EACE,sBAAA;A5E45RV;;A4Ex5RU;EACE,sBAAA;A5E25RZ;;A4Ej6RQ;EACE,uBAAA;A5Eo6RV;;A4Eh6RU;EACE,uBAAA;A5Em6RZ;;A4Ez6RQ;EACE,sBAAA;A5E46RV;;A4Ex6RU;EACE,sBAAA;A5E26RZ;;A4Ej7RQ;EACE,uBAAA;A5Eo7RV;;A4Eh7RU;EACE,uBAAA;A5Em7RZ;;A4Ez7RQ;EACE,oBAAA;A5E47RV;;A4Ex7RU;EACE,oBAAA;A5E27RZ;;A4Ev7RQ;EAOI,yCAAA;A5Eo7RZ;;A4E/6RU;EAOI,yCAAA;A5E46Rd;;A4E/7RQ;EAOI,wCAAA;A5E47RZ;;A4Ev7RU;EAOI,wCAAA;A5Eo7Rd;;A4Ev8RQ;EAOI,yCAAA;A5Eo8RZ;;A4E/7RU;EAOI,yCAAA;A5E47Rd;;A4E/8RQ;EAIQ,8BAAA;EAGJ,uFAAA;EAAA,+FAAA;A5E68RZ;;A4Ep9RQ;EAIQ,8BAAA;EAGJ,uFAAA;EAAA,iGAAA;A5Ek9RZ;;A4Ez9RQ;EAIQ,8BAAA;EAGJ,sFAAA;EAAA,+FAAA;A5Eu9RZ;;A4E99RQ;EAIQ,8BAAA;EAGJ,sFAAA;EAAA,4FAAA;A5E49RZ;;A4En+RQ;EAIQ,8BAAA;EAGJ,qFAAA;EAAA,+FAAA;A5Ei+RZ;;A4Ex+RQ;EAIQ,8BAAA;EAGJ,sFAAA;EAAA,8FAAA;A5Es+RZ;;A4E7+RQ;EAIQ,8BAAA;EAGJ,uFAAA;EAAA,6FAAA;A5E2+RZ;;A4El/RQ;EAIQ,8BAAA;EAGJ,oFAAA;EAAA,4FAAA;A5Eg/RZ;;A4Ev/RQ;EAIQ,8BAAA;EAGJ,uDAAA;EAAA,qGAAA;A5Eq/RZ;;A4EtgSQ;EACE,8BAAA;A5EygSV;;A4ErgSU;EACE,8BAAA;A5EwgSZ;;A4E9gSQ;EACE,gCAAA;A5EihSV;;A4E7gSU;EACE,gCAAA;A5EghSZ;;A4EthSQ;EACE,iCAAA;A5EyhSV;;A4ErhSU;EACE,iCAAA;A5EwhSZ;;A4E9hSQ;EACE,gCAAA;A5EiiSV;;A4E7hSU;EACE,gCAAA;A5EgiSZ;;A4EtiSQ;EACE,iCAAA;A5EyiSV;;A4EriSU;EACE,iCAAA;A5EwiSZ;;A4E9iSQ;EACE,8BAAA;A5EijSV;;A4E7iSU;EACE,8BAAA;A5EgjSZ;;A4E5iSQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,8EAAA;A5E0iSZ;;A4EjjSQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,gFAAA;A5E+iSZ;;A4EtjSQ;EAIQ,kBAAA;EAGJ,qEAAA;EAAA,8EAAA;A5EojSZ;;A4E3jSQ;EAIQ,kBAAA;EAGJ,qEAAA;EAAA,2EAAA;A5EyjSZ;;A4EhkSQ;EAIQ,kBAAA;EAGJ,oEAAA;EAAA,8EAAA;A5E8jSZ;;A4ErkSQ;EAIQ,kBAAA;EAGJ,qEAAA;EAAA,6EAAA;A5EmkSZ;;A4E1kSQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,4EAAA;A5EwkSZ;;A4E/kSQ;EAIQ,kBAAA;EAGJ,mEAAA;EAAA,2EAAA;A5E6kSZ;;A4EplSQ;EAIQ,kBAAA;EAGJ,gEAAA;EAAA,4EAAA;A5EklSZ;;A4EzlSQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,4EAAA;A5EulSZ;;A4E9lSQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,8EAAA;A5E4lSZ;;A4EnmSQ;EAIQ,kBAAA;EAGJ,wCAAA;A5EimSZ;;A4ExmSQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,mFAAA;A5EsmSZ;;A4E7mSQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,kFAAA;A5E2mSZ;;A4E5nSQ;EACE,oBAAA;A5E+nSV;;A4EhoSQ;EACE,qBAAA;A5EmoSV;;A4EpoSQ;EACE,oBAAA;A5EuoSV;;A4ExoSQ;EACE,qBAAA;A5E2oSV;;A4E5oSQ;EACE,kBAAA;A5E+oSV;;A4EtoSQ;EAOI,gFAAA;EAAA,wDAAA;A5EmoSZ;;A4E1oSQ;EAOI,gFAAA;EAAA,0DAAA;A5EuoSZ;;A4E9oSQ;EAOI,gFAAA;EAAA,wDAAA;A5E2oSZ;;A4ElpSQ;EAOI,gFAAA;EAAA,qDAAA;A5E+oSZ;;A4EtpSQ;EAOI,qEAAA;EAAA,wDAAA;A5EmpSZ;;A4E1pSQ;EAOI,gFAAA;EAAA,uDAAA;A5EupSZ;;A4E9pSQ;EAOI,gFAAA;EAAA,sDAAA;A5E2pSZ;;A4ElqSQ;EAOI,oCAAA;EAAA,qDAAA;A5E+pSZ;;A4EtqSQ;EAOI,uGAAA;EAAA,+CAAA;A5EmqSZ;;A4E1qSQ;EAOI,mCAAA;UAAA,2BAAA;A5EuqSZ;;A4E9qSQ;EAOI,oCAAA;UAAA,4BAAA;A5E2qSZ;;A4ElrSQ;EAOI,oCAAA;UAAA,4BAAA;A5E+qSZ;;A4EtrSQ;EAOI,+BAAA;A5EmrSZ;;A4E1rSQ;EAOI,+BAAA;A5EurSZ;;A4E9rSQ;EAOI,iCAAA;EAAA,iDAAA;A5E2rSZ;;A4ElsSQ;EAOI,2BAAA;A5E+rSZ;;A4EtsSQ;EAOI,gCAAA;EAAA,oDAAA;A5EmsSZ;;A4E1sSQ;EAOI,iCAAA;EAAA,iDAAA;A5EusSZ;;A4E9sSQ;EAOI,gCAAA;EAAA,oDAAA;A5E2sSZ;;A4EltSQ;EAOI,8BAAA;EAAA,oDAAA;A5E+sSZ;;A4EttSQ;EAOI,8BAAA;EAAA,qDAAA;A5EmtSZ;;A4E1tSQ;EAOI,6BAAA;A5EutSZ;;A4E9tSQ;EAOI,+BAAA;EAAA,sDAAA;A5E2tSZ;;A4EluSQ;EAOI,0CAAA;EAAA,0DAAA;EAAA,2CAAA;EAAA,2DAAA;A5EguSZ;;A4EvuSQ;EAOI,oCAAA;EAAA,qCAAA;A5EquSZ;;A4E5uSQ;EAOI,yCAAA;EAAA,6DAAA;EAAA,0CAAA;EAAA,8DAAA;A5E0uSZ;;A4EjvSQ;EAOI,0CAAA;EAAA,0DAAA;EAAA,2CAAA;EAAA,2DAAA;A5E+uSZ;;A4EtvSQ;EAOI,yCAAA;EAAA,6DAAA;EAAA,0CAAA;EAAA,8DAAA;A5EovSZ;;A4E3vSQ;EAOI,uCAAA;EAAA,6DAAA;EAAA,wCAAA;EAAA,8DAAA;A5EyvSZ;;A4EhwSQ;EAOI,uCAAA;EAAA,8DAAA;EAAA,wCAAA;EAAA,+DAAA;A5E8vSZ;;A4ErwSQ;EAOI,sCAAA;EAAA,uCAAA;A5EmwSZ;;A4E1wSQ;EAOI,wCAAA;EAAA,+DAAA;EAAA,yCAAA;EAAA,gEAAA;A5EwwSZ;;A4E/wSQ;EAOI,2CAAA;EAAA,2DAAA;EAAA,8CAAA;EAAA,8DAAA;A5E6wSZ;;A4EpxSQ;EAOI,qCAAA;EAAA,wCAAA;A5EkxSZ;;A4EzxSQ;EAOI,0CAAA;EAAA,8DAAA;EAAA,6CAAA;EAAA,iEAAA;A5EuxSZ;;A4E9xSQ;EAOI,2CAAA;EAAA,2DAAA;EAAA,8CAAA;EAAA,8DAAA;A5E4xSZ;;A4EnySQ;EAOI,0CAAA;EAAA,8DAAA;EAAA,6CAAA;EAAA,iEAAA;A5EiySZ;;A4ExySQ;EAOI,wCAAA;EAAA,8DAAA;EAAA,2CAAA;EAAA,iEAAA;A5EsySZ;;A4E7ySQ;EAOI,wCAAA;EAAA,+DAAA;EAAA,2CAAA;EAAA,kEAAA;A5E2ySZ;;A4ElzSQ;EAOI,uCAAA;EAAA,0CAAA;A5EgzSZ;;A4EvzSQ;EAOI,yCAAA;EAAA,gEAAA;EAAA,4CAAA;EAAA,mEAAA;A5EqzSZ;;A4E5zSQ;EAOI,8CAAA;EAAA,8DAAA;EAAA,6CAAA;EAAA,6DAAA;A5E0zSZ;;A4Ej0SQ;EAOI,wCAAA;EAAA,uCAAA;A5E+zSZ;;A4Et0SQ;EAOI,6CAAA;EAAA,iEAAA;EAAA,4CAAA;EAAA,gEAAA;A5Eo0SZ;;A4E30SQ;EAOI,8CAAA;EAAA,8DAAA;EAAA,6CAAA;EAAA,6DAAA;A5Ey0SZ;;A4Eh1SQ;EAOI,6CAAA;EAAA,iEAAA;EAAA,4CAAA;EAAA,gEAAA;A5E80SZ;;A4Er1SQ;EAOI,2CAAA;EAAA,iEAAA;EAAA,0CAAA;EAAA,gEAAA;A5Em1SZ;;A4E11SQ;EAOI,2CAAA;EAAA,kEAAA;EAAA,0CAAA;EAAA,iEAAA;A5Ew1SZ;;A4E/1SQ;EAOI,0CAAA;EAAA,yCAAA;A5E61SZ;;A4Ep2SQ;EAOI,4CAAA;EAAA,mEAAA;EAAA,2CAAA;EAAA,kEAAA;A5Ek2SZ;;A4Ez2SQ;EAOI,6CAAA;EAAA,6DAAA;EAAA,0CAAA;EAAA,0DAAA;A5Eu2SZ;;A4E92SQ;EAOI,uCAAA;EAAA,oCAAA;A5E42SZ;;A4En3SQ;EAOI,4CAAA;EAAA,gEAAA;EAAA,yCAAA;EAAA,6DAAA;A5Ei3SZ;;A4Ex3SQ;EAOI,6CAAA;EAAA,6DAAA;EAAA,0CAAA;EAAA,0DAAA;A5Es3SZ;;A4E73SQ;EAOI,4CAAA;EAAA,gEAAA;EAAA,yCAAA;EAAA,6DAAA;A5E23SZ;;A4El4SQ;EAOI,0CAAA;EAAA,gEAAA;EAAA,uCAAA;EAAA,6DAAA;A5Eg4SZ;;A4Ev4SQ;EAOI,0CAAA;EAAA,iEAAA;EAAA,uCAAA;EAAA,8DAAA;A5Eq4SZ;;A4E54SQ;EAOI,yCAAA;EAAA,sCAAA;A5E04SZ;;A4Ej5SQ;EAOI,2CAAA;EAAA,kEAAA;EAAA,wCAAA;EAAA,+DAAA;A5E+4SZ;;A4Et5SQ;EAOI,8BAAA;A5Em5SZ;;A4E15SQ;EAOI,6BAAA;A5Eu5SZ;;A4E95SQ;EAOI,sBAAA;A5E25SZ;;A4El6SQ;EAOI,qBAAA;A5E+5SZ;;A4Et6SQ;EAOI,qBAAA;A5Em6SZ;;A4E16SQ;EAOI,qBAAA;A5Eu6SZ;;A4E96SQ;EAOI,qBAAA;A5E26SZ;;AiBr7SI;E2DGI;IAOI,sBAAA;E5Eg7SV;E4Ev7SM;IAOI,uBAAA;E5Em7SV;E4E17SM;IAOI,sBAAA;E5Es7SV;E4E77SM;IAOI,8BAAA;E5Ey7SV;E4Eh8SM;IAOI,4BAAA;E5E47SV;E4En8SM;IAOI,2BAAA;E5E+7SV;E4Et8SM;IAOI,iCAAA;E5Ek8SV;E4Ez8SM;IAOI,2BAAA;E5Eq8SV;E4E58SM;IAOI,0BAAA;E5Ew8SV;E4E/8SM;IAOI,gCAAA;E5E28SV;E4El9SM;IAOI,yBAAA;E5E88SV;E4Er9SM;IAOI,wBAAA;E5Ei9SV;E4Ex9SM;IAOI,+BAAA;E5Eo9SV;E4E39SM;IAOI,yBAAA;E5Eu9SV;E4E99SM;IAOI,6BAAA;E5E09SV;E4Ej+SM;IAOI,8BAAA;E5E69SV;E4Ep+SM;IAOI,wBAAA;E5Eg+SV;E4Ev+SM;IAOI,+BAAA;E5Em+SV;E4E1+SM;IAOI,wBAAA;E5Es+SV;E4E7+SM;IAOI,yBAAA;E5Ey+SV;E4Eh/SM;IAOI,8BAAA;E5E4+SV;E4En/SM;IAOI,iCAAA;E5E++SV;E4Et/SM;IAOI,sCAAA;E5Ek/SV;E4Ez/SM;IAOI,yCAAA;E5Eq/SV;E4E5/SM;IAOI,uBAAA;E5Ew/SV;E4E//SM;IAOI,uBAAA;E5E2/SV;E4ElgTM;IAOI,yBAAA;E5E8/SV;E4ErgTM;IAOI,yBAAA;E5EigTV;E4ExgTM;IAOI,0BAAA;E5EogTV;E4E3gTM;IAOI,4BAAA;E5EugTV;E4E9gTM;IAOI,kCAAA;E5E0gTV;E4EjhTM;IAOI,sCAAA;E5E6gTV;E4EphTM;IAOI,oCAAA;E5EghTV;E4EvhTM;IAOI,kCAAA;E5EmhTV;E4E1hTM;IAOI,yCAAA;E5EshTV;E4E7hTM;IAOI,wCAAA;E5EyhTV;E4EhiTM;IAOI,wCAAA;E5E4hTV;E4EniTM;IAOI,kCAAA;E5E+hTV;E4EtiTM;IAOI,gCAAA;E5EkiTV;E4EziTM;IAOI,8BAAA;E5EqiTV;E4E5iTM;IAOI,gCAAA;E5EwiTV;E4E/iTM;IAOI,+BAAA;E5E2iTV;E4EljTM;IAOI,oCAAA;E5E8iTV;E4ErjTM;IAOI,kCAAA;E5EijTV;E4ExjTM;IAOI,gCAAA;E5EojTV;E4E3jTM;IAOI,uCAAA;E5EujTV;E4E9jTM;IAOI,sCAAA;E5E0jTV;E4EjkTM;IAOI,iCAAA;E5E6jTV;E4EpkTM;IAOI,2BAAA;E5EgkTV;E4EvkTM;IAOI,iCAAA;E5EmkTV;E4E1kTM;IAOI,+BAAA;E5EskTV;E4E7kTM;IAOI,6BAAA;E5EykTV;E4EhlTM;IAOI,+BAAA;E5E4kTV;E4EnlTM;IAOI,8BAAA;E5E+kTV;E4EtlTM;IAOI,oBAAA;E5EklTV;E4EzlTM;IAOI,mBAAA;E5EqlTV;E4E5lTM;IAOI,mBAAA;E5EwlTV;E4E/lTM;IAOI,mBAAA;E5E2lTV;E4ElmTM;IAOI,mBAAA;E5E8lTV;E4ErmTM;IAOI,mBAAA;E5EimTV;E4ExmTM;IAOI,mBAAA;E5EomTV;E4E3mTM;IAOI,mBAAA;E5EumTV;E4E9mTM;IAOI,oBAAA;E5E0mTV;E4EjnTM;IAOI,2BAAA;E5E6mTV;E4EpnTM;IAOI,0BAAA;E5EgnTV;E4EvnTM;IAOI,yBAAA;E5EmnTV;E4E1nTM;IAOI,0BAAA;E5EsnTV;E4E7nTM;IAOI,yBAAA;E5EynTV;E4EhoTM;IAOI,uBAAA;E5E4nTV;E4EnoTM;IAOI,0BAAA;IAAA,yBAAA;E5EgoTV;E4EvoTM;IAOI,iCAAA;IAAA,gCAAA;E5EooTV;E4E3oTM;IAOI,gCAAA;IAAA,+BAAA;E5EwoTV;E4E/oTM;IAOI,+BAAA;IAAA,8BAAA;E5E4oTV;E4EnpTM;IAOI,gCAAA;IAAA,+BAAA;E5EgpTV;E4EvpTM;IAOI,+BAAA;IAAA,8BAAA;E5EopTV;E4E3pTM;IAOI,6BAAA;IAAA,4BAAA;E5EwpTV;E4E/pTM;IAOI,wBAAA;IAAA,2BAAA;E5E4pTV;E4EnqTM;IAOI,+BAAA;IAAA,kCAAA;E5EgqTV;E4EvqTM;IAOI,8BAAA;IAAA,iCAAA;E5EoqTV;E4E3qTM;IAOI,6BAAA;IAAA,gCAAA;E5EwqTV;E4E/qTM;IAOI,8BAAA;IAAA,iCAAA;E5E4qTV;E4EnrTM;IAOI,6BAAA;IAAA,gCAAA;E5EgrTV;E4EvrTM;IAOI,2BAAA;IAAA,8BAAA;E5EorTV;E4E3rTM;IAOI,wBAAA;E5EurTV;E4E9rTM;IAOI,+BAAA;E5E0rTV;E4EjsTM;IAOI,8BAAA;E5E6rTV;E4EpsTM;IAOI,6BAAA;E5EgsTV;E4EvsTM;IAOI,8BAAA;E5EmsTV;E4E1sTM;IAOI,6BAAA;E5EssTV;E4E7sTM;IAOI,2BAAA;E5EysTV;E4EhtTM;IAOI,0BAAA;E5E4sTV;E4EntTM;IAOI,iCAAA;E5E+sTV;E4EttTM;IAOI,gCAAA;E5EktTV;E4EztTM;IAOI,+BAAA;E5EqtTV;E4E5tTM;IAOI,gCAAA;E5EwtTV;E4E/tTM;IAOI,+BAAA;E5E2tTV;E4EluTM;IAOI,6BAAA;E5E8tTV;E4EruTM;IAOI,2BAAA;E5EiuTV;E4ExuTM;IAOI,kCAAA;E5EouTV;E4E3uTM;IAOI,iCAAA;E5EuuTV;E4E9uTM;IAOI,gCAAA;E5E0uTV;E4EjvTM;IAOI,iCAAA;E5E6uTV;E4EpvTM;IAOI,gCAAA;E5EgvTV;E4EvvTM;IAOI,8BAAA;E5EmvTV;E4E1vTM;IAOI,yBAAA;E5EsvTV;E4E7vTM;IAOI,gCAAA;E5EyvTV;E4EhwTM;IAOI,+BAAA;E5E4vTV;E4EnwTM;IAOI,8BAAA;E5E+vTV;E4EtwTM;IAOI,+BAAA;E5EkwTV;E4EzwTM;IAOI,8BAAA;E5EqwTV;E4E5wTM;IAOI,4BAAA;E5EwwTV;E4E/wTM;IAOI,4BAAA;E5E2wTV;E4ElxTM;IAOI,2BAAA;E5E8wTV;E4ErxTM;IAOI,0BAAA;E5EixTV;E4ExxTM;IAOI,2BAAA;E5EoxTV;E4E3xTM;IAOI,0BAAA;E5EuxTV;E4E9xTM;IAOI,kCAAA;IAAA,iCAAA;E5E2xTV;E4ElyTM;IAOI,iCAAA;IAAA,gCAAA;E5E+xTV;E4EtyTM;IAOI,gCAAA;IAAA,+BAAA;E5EmyTV;E4E1yTM;IAOI,iCAAA;IAAA,gCAAA;E5EuyTV;E4E9yTM;IAOI,gCAAA;IAAA,+BAAA;E5E2yTV;E4ElzTM;IAOI,gCAAA;IAAA,mCAAA;E5E+yTV;E4EtzTM;IAOI,+BAAA;IAAA,kCAAA;E5EmzTV;E4E1zTM;IAOI,8BAAA;IAAA,iCAAA;E5EuzTV;E4E9zTM;IAOI,+BAAA;IAAA,kCAAA;E5E2zTV;E4El0TM;IAOI,8BAAA;IAAA,iCAAA;E5E+zTV;E4Et0TM;IAOI,gCAAA;E5Ek0TV;E4Ez0TM;IAOI,+BAAA;E5Eq0TV;E4E50TM;IAOI,8BAAA;E5Ew0TV;E4E/0TM;IAOI,+BAAA;E5E20TV;E4El1TM;IAOI,8BAAA;E5E80TV;E4Er1TM;IAOI,kCAAA;E5Ei1TV;E4Ex1TM;IAOI,iCAAA;E5Eo1TV;E4E31TM;IAOI,gCAAA;E5Eu1TV;E4E91TM;IAOI,iCAAA;E5E01TV;E4Ej2TM;IAOI,gCAAA;E5E61TV;E4Ep2TM;IAOI,mCAAA;E5Eg2TV;E4Ev2TM;IAOI,kCAAA;E5Em2TV;E4E12TM;IAOI,iCAAA;E5Es2TV;E4E72TM;IAOI,kCAAA;E5Ey2TV;E4Eh3TM;IAOI,iCAAA;E5E42TV;E4En3TM;IAOI,iCAAA;E5E+2TV;E4Et3TM;IAOI,gCAAA;E5Ek3TV;E4Ez3TM;IAOI,+BAAA;E5Eq3TV;E4E53TM;IAOI,gCAAA;E5Ew3TV;E4E/3TM;IAOI,+BAAA;E5E23TV;E4El4TM;IAOI,qBAAA;E5E83TV;E4Er4TM;IAOI,4BAAA;E5Ei4TV;E4Ex4TM;IAOI,2BAAA;E5Eo4TV;E4E34TM;IAOI,0BAAA;E5Eu4TV;E4E94TM;IAOI,2BAAA;E5E04TV;E4Ej5TM;IAOI,0BAAA;E5E64TV;E4Ep5TM;IAOI,2BAAA;IAAA,0BAAA;E5Ei5TV;E4Ex5TM;IAOI,kCAAA;IAAA,iCAAA;E5Eq5TV;E4E55TM;IAOI,iCAAA;IAAA,gCAAA;E5Ey5TV;E4Eh6TM;IAOI,gCAAA;IAAA,+BAAA;E5E65TV;E4Ep6TM;IAOI,iCAAA;IAAA,gCAAA;E5Ei6TV;E4Ex6TM;IAOI,gCAAA;IAAA,+BAAA;E5Eq6TV;E4E56TM;IAOI,yBAAA;IAAA,4BAAA;E5Ey6TV;E4Eh7TM;IAOI,gCAAA;IAAA,mCAAA;E5E66TV;E4Ep7TM;IAOI,+BAAA;IAAA,kCAAA;E5Ei7TV;E4Ex7TM;IAOI,8BAAA;IAAA,iCAAA;E5Eq7TV;E4E57TM;IAOI,+BAAA;IAAA,kCAAA;E5Ey7TV;E4Eh8TM;IAOI,8BAAA;IAAA,iCAAA;E5E67TV;E4Ep8TM;IAOI,yBAAA;E5Eg8TV;E4Ev8TM;IAOI,gCAAA;E5Em8TV;E4E18TM;IAOI,+BAAA;E5Es8TV;E4E78TM;IAOI,8BAAA;E5Ey8TV;E4Eh9TM;IAOI,+BAAA;E5E48TV;E4En9TM;IAOI,8BAAA;E5E+8TV;E4Et9TM;IAOI,2BAAA;E5Ek9TV;E4Ez9TM;IAOI,kCAAA;E5Eq9TV;E4E59TM;IAOI,iCAAA;E5Ew9TV;E4E/9TM;IAOI,gCAAA;E5E29TV;E4El+TM;IAOI,iCAAA;E5E89TV;E4Er+TM;IAOI,gCAAA;E5Ei+TV;E4Ex+TM;IAOI,4BAAA;E5Eo+TV;E4E3+TM;IAOI,mCAAA;E5Eu+TV;E4E9+TM;IAOI,kCAAA;E5E0+TV;E4Ej/TM;IAOI,iCAAA;E5E6+TV;E4Ep/TM;IAOI,kCAAA;E5Eg/TV;E4Ev/TM;IAOI,iCAAA;E5Em/TV;E4E1/TM;IAOI,0BAAA;E5Es/TV;E4E7/TM;IAOI,iCAAA;E5Ey/TV;E4EhgUM;IAOI,gCAAA;E5E4/TV;E4EngUM;IAOI,+BAAA;E5E+/TV;E4EtgUM;IAOI,gCAAA;E5EkgUV;E4EzgUM;IAOI,+BAAA;E5EqgUV;E4E5gUM;IAOI,iBAAA;E5EwgUV;E4E/gUM;IAOI,wBAAA;E5E2gUV;E4ElhUM;IAOI,uBAAA;E5E8gUV;E4ErhUM;IAOI,sBAAA;E5EihUV;E4ExhUM;IAOI,uBAAA;E5EohUV;E4E3hUM;IAOI,sBAAA;E5EuhUV;E4E9hUM;IAOI,qBAAA;E5E0hUV;E4EjiUM;IAOI,4BAAA;E5E6hUV;E4EpiUM;IAOI,2BAAA;E5EgiUV;E4EviUM;IAOI,0BAAA;E5EmiUV;E4E1iUM;IAOI,2BAAA;E5EsiUV;E4E7iUM;IAOI,0BAAA;E5EyiUV;E4EhjUM;IAOI,wBAAA;E5E4iUV;E4EnjUM;IAOI,+BAAA;E5E+iUV;E4EtjUM;IAOI,8BAAA;E5EkjUV;E4EzjUM;IAOI,6BAAA;E5EqjUV;E4E5jUM;IAOI,8BAAA;E5EwjUV;E4E/jUM;IAOI,6BAAA;E5E2jUV;E4ElkUM;IAOI,2BAAA;E5E8jUV;E4ErkUM;IAOI,4BAAA;E5EikUV;E4ExkUM;IAOI,6BAAA;E5EokUV;AACF;AiB/kUI;E2DGI;IAOI,sBAAA;E5EykUV;E4EhlUM;IAOI,uBAAA;E5E4kUV;E4EnlUM;IAOI,sBAAA;E5E+kUV;E4EtlUM;IAOI,8BAAA;E5EklUV;E4EzlUM;IAOI,4BAAA;E5EqlUV;E4E5lUM;IAOI,2BAAA;E5EwlUV;E4E/lUM;IAOI,iCAAA;E5E2lUV;E4ElmUM;IAOI,2BAAA;E5E8lUV;E4ErmUM;IAOI,0BAAA;E5EimUV;E4ExmUM;IAOI,gCAAA;E5EomUV;E4E3mUM;IAOI,yBAAA;E5EumUV;E4E9mUM;IAOI,wBAAA;E5E0mUV;E4EjnUM;IAOI,+BAAA;E5E6mUV;E4EpnUM;IAOI,yBAAA;E5EgnUV;E4EvnUM;IAOI,6BAAA;E5EmnUV;E4E1nUM;IAOI,8BAAA;E5EsnUV;E4E7nUM;IAOI,wBAAA;E5EynUV;E4EhoUM;IAOI,+BAAA;E5E4nUV;E4EnoUM;IAOI,wBAAA;E5E+nUV;E4EtoUM;IAOI,yBAAA;E5EkoUV;E4EzoUM;IAOI,8BAAA;E5EqoUV;E4E5oUM;IAOI,iCAAA;E5EwoUV;E4E/oUM;IAOI,sCAAA;E5E2oUV;E4ElpUM;IAOI,yCAAA;E5E8oUV;E4ErpUM;IAOI,uBAAA;E5EipUV;E4ExpUM;IAOI,uBAAA;E5EopUV;E4E3pUM;IAOI,yBAAA;E5EupUV;E4E9pUM;IAOI,yBAAA;E5E0pUV;E4EjqUM;IAOI,0BAAA;E5E6pUV;E4EpqUM;IAOI,4BAAA;E5EgqUV;E4EvqUM;IAOI,kCAAA;E5EmqUV;E4E1qUM;IAOI,sCAAA;E5EsqUV;E4E7qUM;IAOI,oCAAA;E5EyqUV;E4EhrUM;IAOI,kCAAA;E5E4qUV;E4EnrUM;IAOI,yCAAA;E5E+qUV;E4EtrUM;IAOI,wCAAA;E5EkrUV;E4EzrUM;IAOI,wCAAA;E5EqrUV;E4E5rUM;IAOI,kCAAA;E5EwrUV;E4E/rUM;IAOI,gCAAA;E5E2rUV;E4ElsUM;IAOI,8BAAA;E5E8rUV;E4ErsUM;IAOI,gCAAA;E5EisUV;E4ExsUM;IAOI,+BAAA;E5EosUV;E4E3sUM;IAOI,oCAAA;E5EusUV;E4E9sUM;IAOI,kCAAA;E5E0sUV;E4EjtUM;IAOI,gCAAA;E5E6sUV;E4EptUM;IAOI,uCAAA;E5EgtUV;E4EvtUM;IAOI,sCAAA;E5EmtUV;E4E1tUM;IAOI,iCAAA;E5EstUV;E4E7tUM;IAOI,2BAAA;E5EytUV;E4EhuUM;IAOI,iCAAA;E5E4tUV;E4EnuUM;IAOI,+BAAA;E5E+tUV;E4EtuUM;IAOI,6BAAA;E5EkuUV;E4EzuUM;IAOI,+BAAA;E5EquUV;E4E5uUM;IAOI,8BAAA;E5EwuUV;E4E/uUM;IAOI,oBAAA;E5E2uUV;E4ElvUM;IAOI,mBAAA;E5E8uUV;E4ErvUM;IAOI,mBAAA;E5EivUV;E4ExvUM;IAOI,mBAAA;E5EovUV;E4E3vUM;IAOI,mBAAA;E5EuvUV;E4E9vUM;IAOI,mBAAA;E5E0vUV;E4EjwUM;IAOI,mBAAA;E5E6vUV;E4EpwUM;IAOI,mBAAA;E5EgwUV;E4EvwUM;IAOI,oBAAA;E5EmwUV;E4E1wUM;IAOI,2BAAA;E5EswUV;E4E7wUM;IAOI,0BAAA;E5EywUV;E4EhxUM;IAOI,yBAAA;E5E4wUV;E4EnxUM;IAOI,0BAAA;E5E+wUV;E4EtxUM;IAOI,yBAAA;E5EkxUV;E4EzxUM;IAOI,uBAAA;E5EqxUV;E4E5xUM;IAOI,0BAAA;IAAA,yBAAA;E5EyxUV;E4EhyUM;IAOI,iCAAA;IAAA,gCAAA;E5E6xUV;E4EpyUM;IAOI,gCAAA;IAAA,+BAAA;E5EiyUV;E4ExyUM;IAOI,+BAAA;IAAA,8BAAA;E5EqyUV;E4E5yUM;IAOI,gCAAA;IAAA,+BAAA;E5EyyUV;E4EhzUM;IAOI,+BAAA;IAAA,8BAAA;E5E6yUV;E4EpzUM;IAOI,6BAAA;IAAA,4BAAA;E5EizUV;E4ExzUM;IAOI,wBAAA;IAAA,2BAAA;E5EqzUV;E4E5zUM;IAOI,+BAAA;IAAA,kCAAA;E5EyzUV;E4Eh0UM;IAOI,8BAAA;IAAA,iCAAA;E5E6zUV;E4Ep0UM;IAOI,6BAAA;IAAA,gCAAA;E5Ei0UV;E4Ex0UM;IAOI,8BAAA;IAAA,iCAAA;E5Eq0UV;E4E50UM;IAOI,6BAAA;IAAA,gCAAA;E5Ey0UV;E4Eh1UM;IAOI,2BAAA;IAAA,8BAAA;E5E60UV;E4Ep1UM;IAOI,wBAAA;E5Eg1UV;E4Ev1UM;IAOI,+BAAA;E5Em1UV;E4E11UM;IAOI,8BAAA;E5Es1UV;E4E71UM;IAOI,6BAAA;E5Ey1UV;E4Eh2UM;IAOI,8BAAA;E5E41UV;E4En2UM;IAOI,6BAAA;E5E+1UV;E4Et2UM;IAOI,2BAAA;E5Ek2UV;E4Ez2UM;IAOI,0BAAA;E5Eq2UV;E4E52UM;IAOI,iCAAA;E5Ew2UV;E4E/2UM;IAOI,gCAAA;E5E22UV;E4El3UM;IAOI,+BAAA;E5E82UV;E4Er3UM;IAOI,gCAAA;E5Ei3UV;E4Ex3UM;IAOI,+BAAA;E5Eo3UV;E4E33UM;IAOI,6BAAA;E5Eu3UV;E4E93UM;IAOI,2BAAA;E5E03UV;E4Ej4UM;IAOI,kCAAA;E5E63UV;E4Ep4UM;IAOI,iCAAA;E5Eg4UV;E4Ev4UM;IAOI,gCAAA;E5Em4UV;E4E14UM;IAOI,iCAAA;E5Es4UV;E4E74UM;IAOI,gCAAA;E5Ey4UV;E4Eh5UM;IAOI,8BAAA;E5E44UV;E4En5UM;IAOI,yBAAA;E5E+4UV;E4Et5UM;IAOI,gCAAA;E5Ek5UV;E4Ez5UM;IAOI,+BAAA;E5Eq5UV;E4E55UM;IAOI,8BAAA;E5Ew5UV;E4E/5UM;IAOI,+BAAA;E5E25UV;E4El6UM;IAOI,8BAAA;E5E85UV;E4Er6UM;IAOI,4BAAA;E5Ei6UV;E4Ex6UM;IAOI,4BAAA;E5Eo6UV;E4E36UM;IAOI,2BAAA;E5Eu6UV;E4E96UM;IAOI,0BAAA;E5E06UV;E4Ej7UM;IAOI,2BAAA;E5E66UV;E4Ep7UM;IAOI,0BAAA;E5Eg7UV;E4Ev7UM;IAOI,kCAAA;IAAA,iCAAA;E5Eo7UV;E4E37UM;IAOI,iCAAA;IAAA,gCAAA;E5Ew7UV;E4E/7UM;IAOI,gCAAA;IAAA,+BAAA;E5E47UV;E4En8UM;IAOI,iCAAA;IAAA,gCAAA;E5Eg8UV;E4Ev8UM;IAOI,gCAAA;IAAA,+BAAA;E5Eo8UV;E4E38UM;IAOI,gCAAA;IAAA,mCAAA;E5Ew8UV;E4E/8UM;IAOI,+BAAA;IAAA,kCAAA;E5E48UV;E4En9UM;IAOI,8BAAA;IAAA,iCAAA;E5Eg9UV;E4Ev9UM;IAOI,+BAAA;IAAA,kCAAA;E5Eo9UV;E4E39UM;IAOI,8BAAA;IAAA,iCAAA;E5Ew9UV;E4E/9UM;IAOI,gCAAA;E5E29UV;E4El+UM;IAOI,+BAAA;E5E89UV;E4Er+UM;IAOI,8BAAA;E5Ei+UV;E4Ex+UM;IAOI,+BAAA;E5Eo+UV;E4E3+UM;IAOI,8BAAA;E5Eu+UV;E4E9+UM;IAOI,kCAAA;E5E0+UV;E4Ej/UM;IAOI,iCAAA;E5E6+UV;E4Ep/UM;IAOI,gCAAA;E5Eg/UV;E4Ev/UM;IAOI,iCAAA;E5Em/UV;E4E1/UM;IAOI,gCAAA;E5Es/UV;E4E7/UM;IAOI,mCAAA;E5Ey/UV;E4EhgVM;IAOI,kCAAA;E5E4/UV;E4EngVM;IAOI,iCAAA;E5E+/UV;E4EtgVM;IAOI,kCAAA;E5EkgVV;E4EzgVM;IAOI,iCAAA;E5EqgVV;E4E5gVM;IAOI,iCAAA;E5EwgVV;E4E/gVM;IAOI,gCAAA;E5E2gVV;E4ElhVM;IAOI,+BAAA;E5E8gVV;E4ErhVM;IAOI,gCAAA;E5EihVV;E4ExhVM;IAOI,+BAAA;E5EohVV;E4E3hVM;IAOI,qBAAA;E5EuhVV;E4E9hVM;IAOI,4BAAA;E5E0hVV;E4EjiVM;IAOI,2BAAA;E5E6hVV;E4EpiVM;IAOI,0BAAA;E5EgiVV;E4EviVM;IAOI,2BAAA;E5EmiVV;E4E1iVM;IAOI,0BAAA;E5EsiVV;E4E7iVM;IAOI,2BAAA;IAAA,0BAAA;E5E0iVV;E4EjjVM;IAOI,kCAAA;IAAA,iCAAA;E5E8iVV;E4ErjVM;IAOI,iCAAA;IAAA,gCAAA;E5EkjVV;E4EzjVM;IAOI,gCAAA;IAAA,+BAAA;E5EsjVV;E4E7jVM;IAOI,iCAAA;IAAA,gCAAA;E5E0jVV;E4EjkVM;IAOI,gCAAA;IAAA,+BAAA;E5E8jVV;E4ErkVM;IAOI,yBAAA;IAAA,4BAAA;E5EkkVV;E4EzkVM;IAOI,gCAAA;IAAA,mCAAA;E5EskVV;E4E7kVM;IAOI,+BAAA;IAAA,kCAAA;E5E0kVV;E4EjlVM;IAOI,8BAAA;IAAA,iCAAA;E5E8kVV;E4ErlVM;IAOI,+BAAA;IAAA,kCAAA;E5EklVV;E4EzlVM;IAOI,8BAAA;IAAA,iCAAA;E5EslVV;E4E7lVM;IAOI,yBAAA;E5EylVV;E4EhmVM;IAOI,gCAAA;E5E4lVV;E4EnmVM;IAOI,+BAAA;E5E+lVV;E4EtmVM;IAOI,8BAAA;E5EkmVV;E4EzmVM;IAOI,+BAAA;E5EqmVV;E4E5mVM;IAOI,8BAAA;E5EwmVV;E4E/mVM;IAOI,2BAAA;E5E2mVV;E4ElnVM;IAOI,kCAAA;E5E8mVV;E4ErnVM;IAOI,iCAAA;E5EinVV;E4ExnVM;IAOI,gCAAA;E5EonVV;E4E3nVM;IAOI,iCAAA;E5EunVV;E4E9nVM;IAOI,gCAAA;E5E0nVV;E4EjoVM;IAOI,4BAAA;E5E6nVV;E4EpoVM;IAOI,mCAAA;E5EgoVV;E4EvoVM;IAOI,kCAAA;E5EmoVV;E4E1oVM;IAOI,iCAAA;E5EsoVV;E4E7oVM;IAOI,kCAAA;E5EyoVV;E4EhpVM;IAOI,iCAAA;E5E4oVV;E4EnpVM;IAOI,0BAAA;E5E+oVV;E4EtpVM;IAOI,iCAAA;E5EkpVV;E4EzpVM;IAOI,gCAAA;E5EqpVV;E4E5pVM;IAOI,+BAAA;E5EwpVV;E4E/pVM;IAOI,gCAAA;E5E2pVV;E4ElqVM;IAOI,+BAAA;E5E8pVV;E4ErqVM;IAOI,iBAAA;E5EiqVV;E4ExqVM;IAOI,wBAAA;E5EoqVV;E4E3qVM;IAOI,uBAAA;E5EuqVV;E4E9qVM;IAOI,sBAAA;E5E0qVV;E4EjrVM;IAOI,uBAAA;E5E6qVV;E4EprVM;IAOI,sBAAA;E5EgrVV;E4EvrVM;IAOI,qBAAA;E5EmrVV;E4E1rVM;IAOI,4BAAA;E5EsrVV;E4E7rVM;IAOI,2BAAA;E5EyrVV;E4EhsVM;IAOI,0BAAA;E5E4rVV;E4EnsVM;IAOI,2BAAA;E5E+rVV;E4EtsVM;IAOI,0BAAA;E5EksVV;E4EzsVM;IAOI,wBAAA;E5EqsVV;E4E5sVM;IAOI,+BAAA;E5EwsVV;E4E/sVM;IAOI,8BAAA;E5E2sVV;E4EltVM;IAOI,6BAAA;E5E8sVV;E4ErtVM;IAOI,8BAAA;E5EitVV;E4ExtVM;IAOI,6BAAA;E5EotVV;E4E3tVM;IAOI,2BAAA;E5EutVV;E4E9tVM;IAOI,4BAAA;E5E0tVV;E4EjuVM;IAOI,6BAAA;E5E6tVV;AACF;AiBxuVI;E2DGI;IAOI,sBAAA;E5EkuVV;E4EzuVM;IAOI,uBAAA;E5EquVV;E4E5uVM;IAOI,sBAAA;E5EwuVV;E4E/uVM;IAOI,8BAAA;E5E2uVV;E4ElvVM;IAOI,4BAAA;E5E8uVV;E4ErvVM;IAOI,2BAAA;E5EivVV;E4ExvVM;IAOI,iCAAA;E5EovVV;E4E3vVM;IAOI,2BAAA;E5EuvVV;E4E9vVM;IAOI,0BAAA;E5E0vVV;E4EjwVM;IAOI,gCAAA;E5E6vVV;E4EpwVM;IAOI,yBAAA;E5EgwVV;E4EvwVM;IAOI,wBAAA;E5EmwVV;E4E1wVM;IAOI,+BAAA;E5EswVV;E4E7wVM;IAOI,yBAAA;E5EywVV;E4EhxVM;IAOI,6BAAA;E5E4wVV;E4EnxVM;IAOI,8BAAA;E5E+wVV;E4EtxVM;IAOI,wBAAA;E5EkxVV;E4EzxVM;IAOI,+BAAA;E5EqxVV;E4E5xVM;IAOI,wBAAA;E5EwxVV;E4E/xVM;IAOI,yBAAA;E5E2xVV;E4ElyVM;IAOI,8BAAA;E5E8xVV;E4EryVM;IAOI,iCAAA;E5EiyVV;E4ExyVM;IAOI,sCAAA;E5EoyVV;E4E3yVM;IAOI,yCAAA;E5EuyVV;E4E9yVM;IAOI,uBAAA;E5E0yVV;E4EjzVM;IAOI,uBAAA;E5E6yVV;E4EpzVM;IAOI,yBAAA;E5EgzVV;E4EvzVM;IAOI,yBAAA;E5EmzVV;E4E1zVM;IAOI,0BAAA;E5EszVV;E4E7zVM;IAOI,4BAAA;E5EyzVV;E4Eh0VM;IAOI,kCAAA;E5E4zVV;E4En0VM;IAOI,sCAAA;E5E+zVV;E4Et0VM;IAOI,oCAAA;E5Ek0VV;E4Ez0VM;IAOI,kCAAA;E5Eq0VV;E4E50VM;IAOI,yCAAA;E5Ew0VV;E4E/0VM;IAOI,wCAAA;E5E20VV;E4El1VM;IAOI,wCAAA;E5E80VV;E4Er1VM;IAOI,kCAAA;E5Ei1VV;E4Ex1VM;IAOI,gCAAA;E5Eo1VV;E4E31VM;IAOI,8BAAA;E5Eu1VV;E4E91VM;IAOI,gCAAA;E5E01VV;E4Ej2VM;IAOI,+BAAA;E5E61VV;E4Ep2VM;IAOI,oCAAA;E5Eg2VV;E4Ev2VM;IAOI,kCAAA;E5Em2VV;E4E12VM;IAOI,gCAAA;E5Es2VV;E4E72VM;IAOI,uCAAA;E5Ey2VV;E4Eh3VM;IAOI,sCAAA;E5E42VV;E4En3VM;IAOI,iCAAA;E5E+2VV;E4Et3VM;IAOI,2BAAA;E5Ek3VV;E4Ez3VM;IAOI,iCAAA;E5Eq3VV;E4E53VM;IAOI,+BAAA;E5Ew3VV;E4E/3VM;IAOI,6BAAA;E5E23VV;E4El4VM;IAOI,+BAAA;E5E83VV;E4Er4VM;IAOI,8BAAA;E5Ei4VV;E4Ex4VM;IAOI,oBAAA;E5Eo4VV;E4E34VM;IAOI,mBAAA;E5Eu4VV;E4E94VM;IAOI,mBAAA;E5E04VV;E4Ej5VM;IAOI,mBAAA;E5E64VV;E4Ep5VM;IAOI,mBAAA;E5Eg5VV;E4Ev5VM;IAOI,mBAAA;E5Em5VV;E4E15VM;IAOI,mBAAA;E5Es5VV;E4E75VM;IAOI,mBAAA;E5Ey5VV;E4Eh6VM;IAOI,oBAAA;E5E45VV;E4En6VM;IAOI,2BAAA;E5E+5VV;E4Et6VM;IAOI,0BAAA;E5Ek6VV;E4Ez6VM;IAOI,yBAAA;E5Eq6VV;E4E56VM;IAOI,0BAAA;E5Ew6VV;E4E/6VM;IAOI,yBAAA;E5E26VV;E4El7VM;IAOI,uBAAA;E5E86VV;E4Er7VM;IAOI,0BAAA;IAAA,yBAAA;E5Ek7VV;E4Ez7VM;IAOI,iCAAA;IAAA,gCAAA;E5Es7VV;E4E77VM;IAOI,gCAAA;IAAA,+BAAA;E5E07VV;E4Ej8VM;IAOI,+BAAA;IAAA,8BAAA;E5E87VV;E4Er8VM;IAOI,gCAAA;IAAA,+BAAA;E5Ek8VV;E4Ez8VM;IAOI,+BAAA;IAAA,8BAAA;E5Es8VV;E4E78VM;IAOI,6BAAA;IAAA,4BAAA;E5E08VV;E4Ej9VM;IAOI,wBAAA;IAAA,2BAAA;E5E88VV;E4Er9VM;IAOI,+BAAA;IAAA,kCAAA;E5Ek9VV;E4Ez9VM;IAOI,8BAAA;IAAA,iCAAA;E5Es9VV;E4E79VM;IAOI,6BAAA;IAAA,gCAAA;E5E09VV;E4Ej+VM;IAOI,8BAAA;IAAA,iCAAA;E5E89VV;E4Er+VM;IAOI,6BAAA;IAAA,gCAAA;E5Ek+VV;E4Ez+VM;IAOI,2BAAA;IAAA,8BAAA;E5Es+VV;E4E7+VM;IAOI,wBAAA;E5Ey+VV;E4Eh/VM;IAOI,+BAAA;E5E4+VV;E4En/VM;IAOI,8BAAA;E5E++VV;E4Et/VM;IAOI,6BAAA;E5Ek/VV;E4Ez/VM;IAOI,8BAAA;E5Eq/VV;E4E5/VM;IAOI,6BAAA;E5Ew/VV;E4E//VM;IAOI,2BAAA;E5E2/VV;E4ElgWM;IAOI,0BAAA;E5E8/VV;E4ErgWM;IAOI,iCAAA;E5EigWV;E4ExgWM;IAOI,gCAAA;E5EogWV;E4E3gWM;IAOI,+BAAA;E5EugWV;E4E9gWM;IAOI,gCAAA;E5E0gWV;E4EjhWM;IAOI,+BAAA;E5E6gWV;E4EphWM;IAOI,6BAAA;E5EghWV;E4EvhWM;IAOI,2BAAA;E5EmhWV;E4E1hWM;IAOI,kCAAA;E5EshWV;E4E7hWM;IAOI,iCAAA;E5EyhWV;E4EhiWM;IAOI,gCAAA;E5E4hWV;E4EniWM;IAOI,iCAAA;E5E+hWV;E4EtiWM;IAOI,gCAAA;E5EkiWV;E4EziWM;IAOI,8BAAA;E5EqiWV;E4E5iWM;IAOI,yBAAA;E5EwiWV;E4E/iWM;IAOI,gCAAA;E5E2iWV;E4EljWM;IAOI,+BAAA;E5E8iWV;E4ErjWM;IAOI,8BAAA;E5EijWV;E4ExjWM;IAOI,+BAAA;E5EojWV;E4E3jWM;IAOI,8BAAA;E5EujWV;E4E9jWM;IAOI,4BAAA;E5E0jWV;E4EjkWM;IAOI,4BAAA;E5E6jWV;E4EpkWM;IAOI,2BAAA;E5EgkWV;E4EvkWM;IAOI,0BAAA;E5EmkWV;E4E1kWM;IAOI,2BAAA;E5EskWV;E4E7kWM;IAOI,0BAAA;E5EykWV;E4EhlWM;IAOI,kCAAA;IAAA,iCAAA;E5E6kWV;E4EplWM;IAOI,iCAAA;IAAA,gCAAA;E5EilWV;E4ExlWM;IAOI,gCAAA;IAAA,+BAAA;E5EqlWV;E4E5lWM;IAOI,iCAAA;IAAA,gCAAA;E5EylWV;E4EhmWM;IAOI,gCAAA;IAAA,+BAAA;E5E6lWV;E4EpmWM;IAOI,gCAAA;IAAA,mCAAA;E5EimWV;E4ExmWM;IAOI,+BAAA;IAAA,kCAAA;E5EqmWV;E4E5mWM;IAOI,8BAAA;IAAA,iCAAA;E5EymWV;E4EhnWM;IAOI,+BAAA;IAAA,kCAAA;E5E6mWV;E4EpnWM;IAOI,8BAAA;IAAA,iCAAA;E5EinWV;E4ExnWM;IAOI,gCAAA;E5EonWV;E4E3nWM;IAOI,+BAAA;E5EunWV;E4E9nWM;IAOI,8BAAA;E5E0nWV;E4EjoWM;IAOI,+BAAA;E5E6nWV;E4EpoWM;IAOI,8BAAA;E5EgoWV;E4EvoWM;IAOI,kCAAA;E5EmoWV;E4E1oWM;IAOI,iCAAA;E5EsoWV;E4E7oWM;IAOI,gCAAA;E5EyoWV;E4EhpWM;IAOI,iCAAA;E5E4oWV;E4EnpWM;IAOI,gCAAA;E5E+oWV;E4EtpWM;IAOI,mCAAA;E5EkpWV;E4EzpWM;IAOI,kCAAA;E5EqpWV;E4E5pWM;IAOI,iCAAA;E5EwpWV;E4E/pWM;IAOI,kCAAA;E5E2pWV;E4ElqWM;IAOI,iCAAA;E5E8pWV;E4ErqWM;IAOI,iCAAA;E5EiqWV;E4ExqWM;IAOI,gCAAA;E5EoqWV;E4E3qWM;IAOI,+BAAA;E5EuqWV;E4E9qWM;IAOI,gCAAA;E5E0qWV;E4EjrWM;IAOI,+BAAA;E5E6qWV;E4EprWM;IAOI,qBAAA;E5EgrWV;E4EvrWM;IAOI,4BAAA;E5EmrWV;E4E1rWM;IAOI,2BAAA;E5EsrWV;E4E7rWM;IAOI,0BAAA;E5EyrWV;E4EhsWM;IAOI,2BAAA;E5E4rWV;E4EnsWM;IAOI,0BAAA;E5E+rWV;E4EtsWM;IAOI,2BAAA;IAAA,0BAAA;E5EmsWV;E4E1sWM;IAOI,kCAAA;IAAA,iCAAA;E5EusWV;E4E9sWM;IAOI,iCAAA;IAAA,gCAAA;E5E2sWV;E4EltWM;IAOI,gCAAA;IAAA,+BAAA;E5E+sWV;E4EttWM;IAOI,iCAAA;IAAA,gCAAA;E5EmtWV;E4E1tWM;IAOI,gCAAA;IAAA,+BAAA;E5EutWV;E4E9tWM;IAOI,yBAAA;IAAA,4BAAA;E5E2tWV;E4EluWM;IAOI,gCAAA;IAAA,mCAAA;E5E+tWV;E4EtuWM;IAOI,+BAAA;IAAA,kCAAA;E5EmuWV;E4E1uWM;IAOI,8BAAA;IAAA,iCAAA;E5EuuWV;E4E9uWM;IAOI,+BAAA;IAAA,kCAAA;E5E2uWV;E4ElvWM;IAOI,8BAAA;IAAA,iCAAA;E5E+uWV;E4EtvWM;IAOI,yBAAA;E5EkvWV;E4EzvWM;IAOI,gCAAA;E5EqvWV;E4E5vWM;IAOI,+BAAA;E5EwvWV;E4E/vWM;IAOI,8BAAA;E5E2vWV;E4ElwWM;IAOI,+BAAA;E5E8vWV;E4ErwWM;IAOI,8BAAA;E5EiwWV;E4ExwWM;IAOI,2BAAA;E5EowWV;E4E3wWM;IAOI,kCAAA;E5EuwWV;E4E9wWM;IAOI,iCAAA;E5E0wWV;E4EjxWM;IAOI,gCAAA;E5E6wWV;E4EpxWM;IAOI,iCAAA;E5EgxWV;E4EvxWM;IAOI,gCAAA;E5EmxWV;E4E1xWM;IAOI,4BAAA;E5EsxWV;E4E7xWM;IAOI,mCAAA;E5EyxWV;E4EhyWM;IAOI,kCAAA;E5E4xWV;E4EnyWM;IAOI,iCAAA;E5E+xWV;E4EtyWM;IAOI,kCAAA;E5EkyWV;E4EzyWM;IAOI,iCAAA;E5EqyWV;E4E5yWM;IAOI,0BAAA;E5EwyWV;E4E/yWM;IAOI,iCAAA;E5E2yWV;E4ElzWM;IAOI,gCAAA;E5E8yWV;E4ErzWM;IAOI,+BAAA;E5EizWV;E4ExzWM;IAOI,gCAAA;E5EozWV;E4E3zWM;IAOI,+BAAA;E5EuzWV;E4E9zWM;IAOI,iBAAA;E5E0zWV;E4Ej0WM;IAOI,wBAAA;E5E6zWV;E4Ep0WM;IAOI,uBAAA;E5Eg0WV;E4Ev0WM;IAOI,sBAAA;E5Em0WV;E4E10WM;IAOI,uBAAA;E5Es0WV;E4E70WM;IAOI,sBAAA;E5Ey0WV;E4Eh1WM;IAOI,qBAAA;E5E40WV;E4En1WM;IAOI,4BAAA;E5E+0WV;E4Et1WM;IAOI,2BAAA;E5Ek1WV;E4Ez1WM;IAOI,0BAAA;E5Eq1WV;E4E51WM;IAOI,2BAAA;E5Ew1WV;E4E/1WM;IAOI,0BAAA;E5E21WV;E4El2WM;IAOI,wBAAA;E5E81WV;E4Er2WM;IAOI,+BAAA;E5Ei2WV;E4Ex2WM;IAOI,8BAAA;E5Eo2WV;E4E32WM;IAOI,6BAAA;E5Eu2WV;E4E92WM;IAOI,8BAAA;E5E02WV;E4Ej3WM;IAOI,6BAAA;E5E62WV;E4Ep3WM;IAOI,2BAAA;E5Eg3WV;E4Ev3WM;IAOI,4BAAA;E5Em3WV;E4E13WM;IAOI,6BAAA;E5Es3WV;AACF;AiBj4WI;E2DGI;IAOI,sBAAA;E5E23WV;E4El4WM;IAOI,uBAAA;E5E83WV;E4Er4WM;IAOI,sBAAA;E5Ei4WV;E4Ex4WM;IAOI,8BAAA;E5Eo4WV;E4E34WM;IAOI,4BAAA;E5Eu4WV;E4E94WM;IAOI,2BAAA;E5E04WV;E4Ej5WM;IAOI,iCAAA;E5E64WV;E4Ep5WM;IAOI,2BAAA;E5Eg5WV;E4Ev5WM;IAOI,0BAAA;E5Em5WV;E4E15WM;IAOI,gCAAA;E5Es5WV;E4E75WM;IAOI,yBAAA;E5Ey5WV;E4Eh6WM;IAOI,wBAAA;E5E45WV;E4En6WM;IAOI,+BAAA;E5E+5WV;E4Et6WM;IAOI,yBAAA;E5Ek6WV;E4Ez6WM;IAOI,6BAAA;E5Eq6WV;E4E56WM;IAOI,8BAAA;E5Ew6WV;E4E/6WM;IAOI,wBAAA;E5E26WV;E4El7WM;IAOI,+BAAA;E5E86WV;E4Er7WM;IAOI,wBAAA;E5Ei7WV;E4Ex7WM;IAOI,yBAAA;E5Eo7WV;E4E37WM;IAOI,8BAAA;E5Eu7WV;E4E97WM;IAOI,iCAAA;E5E07WV;E4Ej8WM;IAOI,sCAAA;E5E67WV;E4Ep8WM;IAOI,yCAAA;E5Eg8WV;E4Ev8WM;IAOI,uBAAA;E5Em8WV;E4E18WM;IAOI,uBAAA;E5Es8WV;E4E78WM;IAOI,yBAAA;E5Ey8WV;E4Eh9WM;IAOI,yBAAA;E5E48WV;E4En9WM;IAOI,0BAAA;E5E+8WV;E4Et9WM;IAOI,4BAAA;E5Ek9WV;E4Ez9WM;IAOI,kCAAA;E5Eq9WV;E4E59WM;IAOI,sCAAA;E5Ew9WV;E4E/9WM;IAOI,oCAAA;E5E29WV;E4El+WM;IAOI,kCAAA;E5E89WV;E4Er+WM;IAOI,yCAAA;E5Ei+WV;E4Ex+WM;IAOI,wCAAA;E5Eo+WV;E4E3+WM;IAOI,wCAAA;E5Eu+WV;E4E9+WM;IAOI,kCAAA;E5E0+WV;E4Ej/WM;IAOI,gCAAA;E5E6+WV;E4Ep/WM;IAOI,8BAAA;E5Eg/WV;E4Ev/WM;IAOI,gCAAA;E5Em/WV;E4E1/WM;IAOI,+BAAA;E5Es/WV;E4E7/WM;IAOI,oCAAA;E5Ey/WV;E4EhgXM;IAOI,kCAAA;E5E4/WV;E4EngXM;IAOI,gCAAA;E5E+/WV;E4EtgXM;IAOI,uCAAA;E5EkgXV;E4EzgXM;IAOI,sCAAA;E5EqgXV;E4E5gXM;IAOI,iCAAA;E5EwgXV;E4E/gXM;IAOI,2BAAA;E5E2gXV;E4ElhXM;IAOI,iCAAA;E5E8gXV;E4ErhXM;IAOI,+BAAA;E5EihXV;E4ExhXM;IAOI,6BAAA;E5EohXV;E4E3hXM;IAOI,+BAAA;E5EuhXV;E4E9hXM;IAOI,8BAAA;E5E0hXV;E4EjiXM;IAOI,oBAAA;E5E6hXV;E4EpiXM;IAOI,mBAAA;E5EgiXV;E4EviXM;IAOI,mBAAA;E5EmiXV;E4E1iXM;IAOI,mBAAA;E5EsiXV;E4E7iXM;IAOI,mBAAA;E5EyiXV;E4EhjXM;IAOI,mBAAA;E5E4iXV;E4EnjXM;IAOI,mBAAA;E5E+iXV;E4EtjXM;IAOI,mBAAA;E5EkjXV;E4EzjXM;IAOI,oBAAA;E5EqjXV;E4E5jXM;IAOI,2BAAA;E5EwjXV;E4E/jXM;IAOI,0BAAA;E5E2jXV;E4ElkXM;IAOI,yBAAA;E5E8jXV;E4ErkXM;IAOI,0BAAA;E5EikXV;E4ExkXM;IAOI,yBAAA;E5EokXV;E4E3kXM;IAOI,uBAAA;E5EukXV;E4E9kXM;IAOI,0BAAA;IAAA,yBAAA;E5E2kXV;E4EllXM;IAOI,iCAAA;IAAA,gCAAA;E5E+kXV;E4EtlXM;IAOI,gCAAA;IAAA,+BAAA;E5EmlXV;E4E1lXM;IAOI,+BAAA;IAAA,8BAAA;E5EulXV;E4E9lXM;IAOI,gCAAA;IAAA,+BAAA;E5E2lXV;E4ElmXM;IAOI,+BAAA;IAAA,8BAAA;E5E+lXV;E4EtmXM;IAOI,6BAAA;IAAA,4BAAA;E5EmmXV;E4E1mXM;IAOI,wBAAA;IAAA,2BAAA;E5EumXV;E4E9mXM;IAOI,+BAAA;IAAA,kCAAA;E5E2mXV;E4ElnXM;IAOI,8BAAA;IAAA,iCAAA;E5E+mXV;E4EtnXM;IAOI,6BAAA;IAAA,gCAAA;E5EmnXV;E4E1nXM;IAOI,8BAAA;IAAA,iCAAA;E5EunXV;E4E9nXM;IAOI,6BAAA;IAAA,gCAAA;E5E2nXV;E4EloXM;IAOI,2BAAA;IAAA,8BAAA;E5E+nXV;E4EtoXM;IAOI,wBAAA;E5EkoXV;E4EzoXM;IAOI,+BAAA;E5EqoXV;E4E5oXM;IAOI,8BAAA;E5EwoXV;E4E/oXM;IAOI,6BAAA;E5E2oXV;E4ElpXM;IAOI,8BAAA;E5E8oXV;E4ErpXM;IAOI,6BAAA;E5EipXV;E4ExpXM;IAOI,2BAAA;E5EopXV;E4E3pXM;IAOI,0BAAA;E5EupXV;E4E9pXM;IAOI,iCAAA;E5E0pXV;E4EjqXM;IAOI,gCAAA;E5E6pXV;E4EpqXM;IAOI,+BAAA;E5EgqXV;E4EvqXM;IAOI,gCAAA;E5EmqXV;E4E1qXM;IAOI,+BAAA;E5EsqXV;E4E7qXM;IAOI,6BAAA;E5EyqXV;E4EhrXM;IAOI,2BAAA;E5E4qXV;E4EnrXM;IAOI,kCAAA;E5E+qXV;E4EtrXM;IAOI,iCAAA;E5EkrXV;E4EzrXM;IAOI,gCAAA;E5EqrXV;E4E5rXM;IAOI,iCAAA;E5EwrXV;E4E/rXM;IAOI,gCAAA;E5E2rXV;E4ElsXM;IAOI,8BAAA;E5E8rXV;E4ErsXM;IAOI,yBAAA;E5EisXV;E4ExsXM;IAOI,gCAAA;E5EosXV;E4E3sXM;IAOI,+BAAA;E5EusXV;E4E9sXM;IAOI,8BAAA;E5E0sXV;E4EjtXM;IAOI,+BAAA;E5E6sXV;E4EptXM;IAOI,8BAAA;E5EgtXV;E4EvtXM;IAOI,4BAAA;E5EmtXV;E4E1tXM;IAOI,4BAAA;E5EstXV;E4E7tXM;IAOI,2BAAA;E5EytXV;E4EhuXM;IAOI,0BAAA;E5E4tXV;E4EnuXM;IAOI,2BAAA;E5E+tXV;E4EtuXM;IAOI,0BAAA;E5EkuXV;E4EzuXM;IAOI,kCAAA;IAAA,iCAAA;E5EsuXV;E4E7uXM;IAOI,iCAAA;IAAA,gCAAA;E5E0uXV;E4EjvXM;IAOI,gCAAA;IAAA,+BAAA;E5E8uXV;E4ErvXM;IAOI,iCAAA;IAAA,gCAAA;E5EkvXV;E4EzvXM;IAOI,gCAAA;IAAA,+BAAA;E5EsvXV;E4E7vXM;IAOI,gCAAA;IAAA,mCAAA;E5E0vXV;E4EjwXM;IAOI,+BAAA;IAAA,kCAAA;E5E8vXV;E4ErwXM;IAOI,8BAAA;IAAA,iCAAA;E5EkwXV;E4EzwXM;IAOI,+BAAA;IAAA,kCAAA;E5EswXV;E4E7wXM;IAOI,8BAAA;IAAA,iCAAA;E5E0wXV;E4EjxXM;IAOI,gCAAA;E5E6wXV;E4EpxXM;IAOI,+BAAA;E5EgxXV;E4EvxXM;IAOI,8BAAA;E5EmxXV;E4E1xXM;IAOI,+BAAA;E5EsxXV;E4E7xXM;IAOI,8BAAA;E5EyxXV;E4EhyXM;IAOI,kCAAA;E5E4xXV;E4EnyXM;IAOI,iCAAA;E5E+xXV;E4EtyXM;IAOI,gCAAA;E5EkyXV;E4EzyXM;IAOI,iCAAA;E5EqyXV;E4E5yXM;IAOI,gCAAA;E5EwyXV;E4E/yXM;IAOI,mCAAA;E5E2yXV;E4ElzXM;IAOI,kCAAA;E5E8yXV;E4ErzXM;IAOI,iCAAA;E5EizXV;E4ExzXM;IAOI,kCAAA;E5EozXV;E4E3zXM;IAOI,iCAAA;E5EuzXV;E4E9zXM;IAOI,iCAAA;E5E0zXV;E4Ej0XM;IAOI,gCAAA;E5E6zXV;E4Ep0XM;IAOI,+BAAA;E5Eg0XV;E4Ev0XM;IAOI,gCAAA;E5Em0XV;E4E10XM;IAOI,+BAAA;E5Es0XV;E4E70XM;IAOI,qBAAA;E5Ey0XV;E4Eh1XM;IAOI,4BAAA;E5E40XV;E4En1XM;IAOI,2BAAA;E5E+0XV;E4Et1XM;IAOI,0BAAA;E5Ek1XV;E4Ez1XM;IAOI,2BAAA;E5Eq1XV;E4E51XM;IAOI,0BAAA;E5Ew1XV;E4E/1XM;IAOI,2BAAA;IAAA,0BAAA;E5E41XV;E4En2XM;IAOI,kCAAA;IAAA,iCAAA;E5Eg2XV;E4Ev2XM;IAOI,iCAAA;IAAA,gCAAA;E5Eo2XV;E4E32XM;IAOI,gCAAA;IAAA,+BAAA;E5Ew2XV;E4E/2XM;IAOI,iCAAA;IAAA,gCAAA;E5E42XV;E4En3XM;IAOI,gCAAA;IAAA,+BAAA;E5Eg3XV;E4Ev3XM;IAOI,yBAAA;IAAA,4BAAA;E5Eo3XV;E4E33XM;IAOI,gCAAA;IAAA,mCAAA;E5Ew3XV;E4E/3XM;IAOI,+BAAA;IAAA,kCAAA;E5E43XV;E4En4XM;IAOI,8BAAA;IAAA,iCAAA;E5Eg4XV;E4Ev4XM;IAOI,+BAAA;IAAA,kCAAA;E5Eo4XV;E4E34XM;IAOI,8BAAA;IAAA,iCAAA;E5Ew4XV;E4E/4XM;IAOI,yBAAA;E5E24XV;E4El5XM;IAOI,gCAAA;E5E84XV;E4Er5XM;IAOI,+BAAA;E5Ei5XV;E4Ex5XM;IAOI,8BAAA;E5Eo5XV;E4E35XM;IAOI,+BAAA;E5Eu5XV;E4E95XM;IAOI,8BAAA;E5E05XV;E4Ej6XM;IAOI,2BAAA;E5E65XV;E4Ep6XM;IAOI,kCAAA;E5Eg6XV;E4Ev6XM;IAOI,iCAAA;E5Em6XV;E4E16XM;IAOI,gCAAA;E5Es6XV;E4E76XM;IAOI,iCAAA;E5Ey6XV;E4Eh7XM;IAOI,gCAAA;E5E46XV;E4En7XM;IAOI,4BAAA;E5E+6XV;E4Et7XM;IAOI,mCAAA;E5Ek7XV;E4Ez7XM;IAOI,kCAAA;E5Eq7XV;E4E57XM;IAOI,iCAAA;E5Ew7XV;E4E/7XM;IAOI,kCAAA;E5E27XV;E4El8XM;IAOI,iCAAA;E5E87XV;E4Er8XM;IAOI,0BAAA;E5Ei8XV;E4Ex8XM;IAOI,iCAAA;E5Eo8XV;E4E38XM;IAOI,gCAAA;E5Eu8XV;E4E98XM;IAOI,+BAAA;E5E08XV;E4Ej9XM;IAOI,gCAAA;E5E68XV;E4Ep9XM;IAOI,+BAAA;E5Eg9XV;E4Ev9XM;IAOI,iBAAA;E5Em9XV;E4E19XM;IAOI,wBAAA;E5Es9XV;E4E79XM;IAOI,uBAAA;E5Ey9XV;E4Eh+XM;IAOI,sBAAA;E5E49XV;E4En+XM;IAOI,uBAAA;E5E+9XV;E4Et+XM;IAOI,sBAAA;E5Ek+XV;E4Ez+XM;IAOI,qBAAA;E5Eq+XV;E4E5+XM;IAOI,4BAAA;E5Ew+XV;E4E/+XM;IAOI,2BAAA;E5E2+XV;E4El/XM;IAOI,0BAAA;E5E8+XV;E4Er/XM;IAOI,2BAAA;E5Ei/XV;E4Ex/XM;IAOI,0BAAA;E5Eo/XV;E4E3/XM;IAOI,wBAAA;E5Eu/XV;E4E9/XM;IAOI,+BAAA;E5E0/XV;E4EjgYM;IAOI,8BAAA;E5E6/XV;E4EpgYM;IAOI,6BAAA;E5EggYV;E4EvgYM;IAOI,8BAAA;E5EmgYV;E4E1gYM;IAOI,6BAAA;E5EsgYV;E4E7gYM;IAOI,2BAAA;E5EygYV;E4EhhYM;IAOI,4BAAA;E5E4gYV;E4EnhYM;IAOI,6BAAA;E5E+gYV;AACF;AiB1hYI;E2DGI;IAOI,sBAAA;E5EohYV;E4E3hYM;IAOI,uBAAA;E5EuhYV;E4E9hYM;IAOI,sBAAA;E5E0hYV;E4EjiYM;IAOI,8BAAA;E5E6hYV;E4EpiYM;IAOI,4BAAA;E5EgiYV;E4EviYM;IAOI,2BAAA;E5EmiYV;E4E1iYM;IAOI,iCAAA;E5EsiYV;E4E7iYM;IAOI,2BAAA;E5EyiYV;E4EhjYM;IAOI,0BAAA;E5E4iYV;E4EnjYM;IAOI,gCAAA;E5E+iYV;E4EtjYM;IAOI,yBAAA;E5EkjYV;E4EzjYM;IAOI,wBAAA;E5EqjYV;E4E5jYM;IAOI,+BAAA;E5EwjYV;E4E/jYM;IAOI,yBAAA;E5E2jYV;E4ElkYM;IAOI,6BAAA;E5E8jYV;E4ErkYM;IAOI,8BAAA;E5EikYV;E4ExkYM;IAOI,wBAAA;E5EokYV;E4E3kYM;IAOI,+BAAA;E5EukYV;E4E9kYM;IAOI,wBAAA;E5E0kYV;E4EjlYM;IAOI,yBAAA;E5E6kYV;E4EplYM;IAOI,8BAAA;E5EglYV;E4EvlYM;IAOI,iCAAA;E5EmlYV;E4E1lYM;IAOI,sCAAA;E5EslYV;E4E7lYM;IAOI,yCAAA;E5EylYV;E4EhmYM;IAOI,uBAAA;E5E4lYV;E4EnmYM;IAOI,uBAAA;E5E+lYV;E4EtmYM;IAOI,yBAAA;E5EkmYV;E4EzmYM;IAOI,yBAAA;E5EqmYV;E4E5mYM;IAOI,0BAAA;E5EwmYV;E4E/mYM;IAOI,4BAAA;E5E2mYV;E4ElnYM;IAOI,kCAAA;E5E8mYV;E4ErnYM;IAOI,sCAAA;E5EinYV;E4ExnYM;IAOI,oCAAA;E5EonYV;E4E3nYM;IAOI,kCAAA;E5EunYV;E4E9nYM;IAOI,yCAAA;E5E0nYV;E4EjoYM;IAOI,wCAAA;E5E6nYV;E4EpoYM;IAOI,wCAAA;E5EgoYV;E4EvoYM;IAOI,kCAAA;E5EmoYV;E4E1oYM;IAOI,gCAAA;E5EsoYV;E4E7oYM;IAOI,8BAAA;E5EyoYV;E4EhpYM;IAOI,gCAAA;E5E4oYV;E4EnpYM;IAOI,+BAAA;E5E+oYV;E4EtpYM;IAOI,oCAAA;E5EkpYV;E4EzpYM;IAOI,kCAAA;E5EqpYV;E4E5pYM;IAOI,gCAAA;E5EwpYV;E4E/pYM;IAOI,uCAAA;E5E2pYV;E4ElqYM;IAOI,sCAAA;E5E8pYV;E4ErqYM;IAOI,iCAAA;E5EiqYV;E4ExqYM;IAOI,2BAAA;E5EoqYV;E4E3qYM;IAOI,iCAAA;E5EuqYV;E4E9qYM;IAOI,+BAAA;E5E0qYV;E4EjrYM;IAOI,6BAAA;E5E6qYV;E4EprYM;IAOI,+BAAA;E5EgrYV;E4EvrYM;IAOI,8BAAA;E5EmrYV;E4E1rYM;IAOI,oBAAA;E5EsrYV;E4E7rYM;IAOI,mBAAA;E5EyrYV;E4EhsYM;IAOI,mBAAA;E5E4rYV;E4EnsYM;IAOI,mBAAA;E5E+rYV;E4EtsYM;IAOI,mBAAA;E5EksYV;E4EzsYM;IAOI,mBAAA;E5EqsYV;E4E5sYM;IAOI,mBAAA;E5EwsYV;E4E/sYM;IAOI,mBAAA;E5E2sYV;E4EltYM;IAOI,oBAAA;E5E8sYV;E4ErtYM;IAOI,2BAAA;E5EitYV;E4ExtYM;IAOI,0BAAA;E5EotYV;E4E3tYM;IAOI,yBAAA;E5EutYV;E4E9tYM;IAOI,0BAAA;E5E0tYV;E4EjuYM;IAOI,yBAAA;E5E6tYV;E4EpuYM;IAOI,uBAAA;E5EguYV;E4EvuYM;IAOI,0BAAA;IAAA,yBAAA;E5EouYV;E4E3uYM;IAOI,iCAAA;IAAA,gCAAA;E5EwuYV;E4E/uYM;IAOI,gCAAA;IAAA,+BAAA;E5E4uYV;E4EnvYM;IAOI,+BAAA;IAAA,8BAAA;E5EgvYV;E4EvvYM;IAOI,gCAAA;IAAA,+BAAA;E5EovYV;E4E3vYM;IAOI,+BAAA;IAAA,8BAAA;E5EwvYV;E4E/vYM;IAOI,6BAAA;IAAA,4BAAA;E5E4vYV;E4EnwYM;IAOI,wBAAA;IAAA,2BAAA;E5EgwYV;E4EvwYM;IAOI,+BAAA;IAAA,kCAAA;E5EowYV;E4E3wYM;IAOI,8BAAA;IAAA,iCAAA;E5EwwYV;E4E/wYM;IAOI,6BAAA;IAAA,gCAAA;E5E4wYV;E4EnxYM;IAOI,8BAAA;IAAA,iCAAA;E5EgxYV;E4EvxYM;IAOI,6BAAA;IAAA,gCAAA;E5EoxYV;E4E3xYM;IAOI,2BAAA;IAAA,8BAAA;E5EwxYV;E4E/xYM;IAOI,wBAAA;E5E2xYV;E4ElyYM;IAOI,+BAAA;E5E8xYV;E4EryYM;IAOI,8BAAA;E5EiyYV;E4ExyYM;IAOI,6BAAA;E5EoyYV;E4E3yYM;IAOI,8BAAA;E5EuyYV;E4E9yYM;IAOI,6BAAA;E5E0yYV;E4EjzYM;IAOI,2BAAA;E5E6yYV;E4EpzYM;IAOI,0BAAA;E5EgzYV;E4EvzYM;IAOI,iCAAA;E5EmzYV;E4E1zYM;IAOI,gCAAA;E5EszYV;E4E7zYM;IAOI,+BAAA;E5EyzYV;E4Eh0YM;IAOI,gCAAA;E5E4zYV;E4En0YM;IAOI,+BAAA;E5E+zYV;E4Et0YM;IAOI,6BAAA;E5Ek0YV;E4Ez0YM;IAOI,2BAAA;E5Eq0YV;E4E50YM;IAOI,kCAAA;E5Ew0YV;E4E/0YM;IAOI,iCAAA;E5E20YV;E4El1YM;IAOI,gCAAA;E5E80YV;E4Er1YM;IAOI,iCAAA;E5Ei1YV;E4Ex1YM;IAOI,gCAAA;E5Eo1YV;E4E31YM;IAOI,8BAAA;E5Eu1YV;E4E91YM;IAOI,yBAAA;E5E01YV;E4Ej2YM;IAOI,gCAAA;E5E61YV;E4Ep2YM;IAOI,+BAAA;E5Eg2YV;E4Ev2YM;IAOI,8BAAA;E5Em2YV;E4E12YM;IAOI,+BAAA;E5Es2YV;E4E72YM;IAOI,8BAAA;E5Ey2YV;E4Eh3YM;IAOI,4BAAA;E5E42YV;E4En3YM;IAOI,4BAAA;E5E+2YV;E4Et3YM;IAOI,2BAAA;E5Ek3YV;E4Ez3YM;IAOI,0BAAA;E5Eq3YV;E4E53YM;IAOI,2BAAA;E5Ew3YV;E4E/3YM;IAOI,0BAAA;E5E23YV;E4El4YM;IAOI,kCAAA;IAAA,iCAAA;E5E+3YV;E4Et4YM;IAOI,iCAAA;IAAA,gCAAA;E5Em4YV;E4E14YM;IAOI,gCAAA;IAAA,+BAAA;E5Eu4YV;E4E94YM;IAOI,iCAAA;IAAA,gCAAA;E5E24YV;E4El5YM;IAOI,gCAAA;IAAA,+BAAA;E5E+4YV;E4Et5YM;IAOI,gCAAA;IAAA,mCAAA;E5Em5YV;E4E15YM;IAOI,+BAAA;IAAA,kCAAA;E5Eu5YV;E4E95YM;IAOI,8BAAA;IAAA,iCAAA;E5E25YV;E4El6YM;IAOI,+BAAA;IAAA,kCAAA;E5E+5YV;E4Et6YM;IAOI,8BAAA;IAAA,iCAAA;E5Em6YV;E4E16YM;IAOI,gCAAA;E5Es6YV;E4E76YM;IAOI,+BAAA;E5Ey6YV;E4Eh7YM;IAOI,8BAAA;E5E46YV;E4En7YM;IAOI,+BAAA;E5E+6YV;E4Et7YM;IAOI,8BAAA;E5Ek7YV;E4Ez7YM;IAOI,kCAAA;E5Eq7YV;E4E57YM;IAOI,iCAAA;E5Ew7YV;E4E/7YM;IAOI,gCAAA;E5E27YV;E4El8YM;IAOI,iCAAA;E5E87YV;E4Er8YM;IAOI,gCAAA;E5Ei8YV;E4Ex8YM;IAOI,mCAAA;E5Eo8YV;E4E38YM;IAOI,kCAAA;E5Eu8YV;E4E98YM;IAOI,iCAAA;E5E08YV;E4Ej9YM;IAOI,kCAAA;E5E68YV;E4Ep9YM;IAOI,iCAAA;E5Eg9YV;E4Ev9YM;IAOI,iCAAA;E5Em9YV;E4E19YM;IAOI,gCAAA;E5Es9YV;E4E79YM;IAOI,+BAAA;E5Ey9YV;E4Eh+YM;IAOI,gCAAA;E5E49YV;E4En+YM;IAOI,+BAAA;E5E+9YV;E4Et+YM;IAOI,qBAAA;E5Ek+YV;E4Ez+YM;IAOI,4BAAA;E5Eq+YV;E4E5+YM;IAOI,2BAAA;E5Ew+YV;E4E/+YM;IAOI,0BAAA;E5E2+YV;E4El/YM;IAOI,2BAAA;E5E8+YV;E4Er/YM;IAOI,0BAAA;E5Ei/YV;E4Ex/YM;IAOI,2BAAA;IAAA,0BAAA;E5Eq/YV;E4E5/YM;IAOI,kCAAA;IAAA,iCAAA;E5Ey/YV;E4EhgZM;IAOI,iCAAA;IAAA,gCAAA;E5E6/YV;E4EpgZM;IAOI,gCAAA;IAAA,+BAAA;E5EigZV;E4ExgZM;IAOI,iCAAA;IAAA,gCAAA;E5EqgZV;E4E5gZM;IAOI,gCAAA;IAAA,+BAAA;E5EygZV;E4EhhZM;IAOI,yBAAA;IAAA,4BAAA;E5E6gZV;E4EphZM;IAOI,gCAAA;IAAA,mCAAA;E5EihZV;E4ExhZM;IAOI,+BAAA;IAAA,kCAAA;E5EqhZV;E4E5hZM;IAOI,8BAAA;IAAA,iCAAA;E5EyhZV;E4EhiZM;IAOI,+BAAA;IAAA,kCAAA;E5E6hZV;E4EpiZM;IAOI,8BAAA;IAAA,iCAAA;E5EiiZV;E4ExiZM;IAOI,yBAAA;E5EoiZV;E4E3iZM;IAOI,gCAAA;E5EuiZV;E4E9iZM;IAOI,+BAAA;E5E0iZV;E4EjjZM;IAOI,8BAAA;E5E6iZV;E4EpjZM;IAOI,+BAAA;E5EgjZV;E4EvjZM;IAOI,8BAAA;E5EmjZV;E4E1jZM;IAOI,2BAAA;E5EsjZV;E4E7jZM;IAOI,kCAAA;E5EyjZV;E4EhkZM;IAOI,iCAAA;E5E4jZV;E4EnkZM;IAOI,gCAAA;E5E+jZV;E4EtkZM;IAOI,iCAAA;E5EkkZV;E4EzkZM;IAOI,gCAAA;E5EqkZV;E4E5kZM;IAOI,4BAAA;E5EwkZV;E4E/kZM;IAOI,mCAAA;E5E2kZV;E4EllZM;IAOI,kCAAA;E5E8kZV;E4ErlZM;IAOI,iCAAA;E5EilZV;E4ExlZM;IAOI,kCAAA;E5EolZV;E4E3lZM;IAOI,iCAAA;E5EulZV;E4E9lZM;IAOI,0BAAA;E5E0lZV;E4EjmZM;IAOI,iCAAA;E5E6lZV;E4EpmZM;IAOI,gCAAA;E5EgmZV;E4EvmZM;IAOI,+BAAA;E5EmmZV;E4E1mZM;IAOI,gCAAA;E5EsmZV;E4E7mZM;IAOI,+BAAA;E5EymZV;E4EhnZM;IAOI,iBAAA;E5E4mZV;E4EnnZM;IAOI,wBAAA;E5E+mZV;E4EtnZM;IAOI,uBAAA;E5EknZV;E4EznZM;IAOI,sBAAA;E5EqnZV;E4E5nZM;IAOI,uBAAA;E5EwnZV;E4E/nZM;IAOI,sBAAA;E5E2nZV;E4EloZM;IAOI,qBAAA;E5E8nZV;E4EroZM;IAOI,4BAAA;E5EioZV;E4ExoZM;IAOI,2BAAA;E5EooZV;E4E3oZM;IAOI,0BAAA;E5EuoZV;E4E9oZM;IAOI,2BAAA;E5E0oZV;E4EjpZM;IAOI,0BAAA;E5E6oZV;E4EppZM;IAOI,wBAAA;E5EgpZV;E4EvpZM;IAOI,+BAAA;E5EmpZV;E4E1pZM;IAOI,8BAAA;E5EspZV;E4E7pZM;IAOI,6BAAA;E5EypZV;E4EhqZM;IAOI,8BAAA;E5E4pZV;E4EnqZM;IAOI,6BAAA;E5E+pZV;E4EtqZM;IAOI,2BAAA;E5EkqZV;E4EzqZM;IAOI,4BAAA;E5EqqZV;E4E5qZM;IAOI,6BAAA;E5EwqZV;AACF;A6E/tZA;ED+CQ;IAOI,6BAAA;E5E6qZV;E4EprZM;IAOI,8BAAA;E5EgrZV;E4EvrZM;IAOI,4BAAA;E5EmrZV;AACF;A6EvtZA;ED4BQ;IAOI,0BAAA;E5EwrZV;E4E/rZM;IAOI,gCAAA;E5E2rZV;E4ElsZM;IAOI,yBAAA;E5E8rZV;E4ErsZM;IAOI,wBAAA;E5EisZV;E4ExsZM;IAOI,+BAAA;E5EosZV;E4E3sZM;IAOI,yBAAA;E5EusZV;E4E9sZM;IAOI,6BAAA;E5E0sZV;E4EjtZM;IAOI,8BAAA;E5E6sZV;E4EptZM;IAOI,wBAAA;E5EgtZV;E4EvtZM;IAOI,+BAAA;E5EmtZV;E4E1tZM;IAOI,wBAAA;E5EstZV;AACF;A8E5xZA;EACE,kBAAA;EACA,gBAAA;A9E8xZF;;A8E3xZA;EACE,kBAAA;A9E8xZF;;A8E1xZA;EACE;IACE,eAAA;E9E6xZF;AACF;A+EzyZA;EACI,cAAA;EACA,iBCagC;EDZhC,YCFgC;EDGhC,eAAA;EACA,MAAA;A/E2yZJ;A+EzyZI;EACI,cAAA;A/E2yZR;A+EzyZI;EACI,aAAA;A/E2yZR;A+ExyZI;EACI,cC+E4B;AhF2tZpC;A+ExyZI;EACI,aC6E4B;AhF6tZpC;;A+EryZA;EACI,YAAA;EAEA,WAAA;A/EuyZJ;;A+EnyZA;EACI,kBC9BgC;EDiChC,iBAAA;A/EoyZJ;;A+E/xZA;EACI,YCvCgC;EDwChC,WAAA;EACA,4DCD8B;EDC9B,yCCD8B;EDE9B,SAAA;EACA,eAAA;EACA,MAAA;EACA,iBC/BgC;EDgChC,sD7Ese0B;E6Ete1B,gC7Ese0B;AF4zY9B;;A+E9xZA;EACI,eAAA;EACA,qBAAA;A/EiyZJ;A+EhyZI;EACI,qBAAA;A/EkyZR;A+EhyZI;EACI,cCrD4B;EDqD5B,0BCrD4B;EDsD5B,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,2BAAA;A/EkyZR;A+EhyZQ;EAGI,cChEwB;EDgExB,gCChEwB;EDiExB,qBAAA;A/EgyZZ;A+E7xZQ;EACI,sBAAA;A/E+xZZ;A+E5xZQ;EACI,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;A/E8xZZ;A+E1xZI;EACI,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,oCAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;A/E4xZR;A+E3xZQ;EACI,iBAAA;A/E6xZZ;A+EzxZI;EACI,eAAA;A/E2xZR;A+EtxZY;EACI,wBAAA;A/EwxZhB;A+ElxZgB;EACI,wBAAA;A/EoxZpB;A+E9wZI;EACI,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,cC7H4B;ED6H5B,0BC7H4B;ED8H5B,gB7EycsB;AFu0Y9B;A+E5wZQ;EACI,yBAAA;EAAA,4CAAA;A/E8wZZ;;A+ErwZgB;EACI,4BAAA;A/EwwZpB;;A+EjwZA;;;EAGI,eAAA;A/EowZJ;A+EjwZQ;;;;;;EAEI,0BAAA;EACA,cC7JwB;ED6JxB,0BC7JwB;ED8JxB,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;A/EuwZZ;A+EtwZY;;;;;;;;;;;EAEI,cCnKoB;EDmKpB,gCCnKoB;AhFo7ZpC;A+E9wZY;;;;;;EACI,mBAAA;A/EqxZhB;A+EjxZY;;;EACI,cC3KoB;ED2KpB,iCC3KoB;AhFg8ZpC;;A+E7wZQ;;EAEI,0BAAA;A/EgxZZ;;A+EzwZQ;;EAEI,2BAAA;A/E4wZZ;;A+EtwZA;EACI,kBAAA;A/EywZJ;A+ErwZQ;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,iBCtMwB;AhF68ZpC;A+ErwZY;;EAEI,4BAAA;A/EuwZhB;A+EpwZY;EACI,wBAAA;A/EswZhB;A+EnwZY;EACI,oBAAA;A/EqwZhB;A+ElwZY;EACI,WAAA;EACA,UAAA;EACA,4DC9LkB;ED8LlB,yCC9LkB;AhFk8ZlC;A+E/vZQ;EACI,aAAA;A/EiwZZ;A+E7vZQ;EACI,iBAAA;A/E+vZZ;A+E3vZQ;;EAEI,UAAA;A/E6vZZ;A+EvvZQ;;;EAGI,wBAAA;A/EyvZZ;A+EvvZQ;;EAEI,aAAA;EACA,0BAAA;EACA,2BAAA;A/EyvZZ;A+EvvZY;;;;;;EAGI,wBAAA;A/E4vZhB;A+ExvZQ;EACI,kBAAA;EACA,mBAAA;A/E0vZZ;A+ExvZY;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;A/E0vZhB;A+ExvZgB;EAGI,cCtRgB;EDsRhB,gCCtRgB;AhF8gapC;A+ErvZgB;EACI,mBAAA;EACA,kBAAA;EACA,gBAAA;A/EuvZpB;A+EpvZgB;EACI,aAAA;EACA,kBAAA;A/EsvZpB;A+EjvZgB;EACI,kBAAA;EACA,YAAA;EACA,WhD5ST;EgD6SS,4DCvQc;EDuQd,yCCvQc;AhF0/ZlC;A+EjvZoB;EACI,eAAA;A/EmvZxB;A+E/uZgB;EACI,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,4DCtRc;EDsRd,yCCtRc;EDuRd,sD7EqNU;E6ErNV,gC7EqNU;AF4hZ9B;A+E/uZoB;EACI,iBAAA;EACA,kBAAA;EACA,YAAA;A/EivZxB;A+E/uZwB;EACI,cClUQ;EDkUR,gCClUQ;AhFmjapC;A+E5uZgB;;EAEI,yBAAA;EACA,2BAAA;A/E8uZpB;A+E5uZoB;;EACI,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,4DC9SU;ED8SV,yCC9SU;ED+SV,sD7E6LM;E6E7LN,gC7E6LM;AFkjZ9B;A+E7uZwB;;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;A/EgvZ5B;A+E9uZ4B;;EACI,cC5VI;ED4VJ,gCC5VI;AhF6kapC;A+E3uZgC;;EACI,yBAAA;EACA,uBAAA;EACA,2BAAA;A/E8uZpC;A+E5uZoC;;EACI,cAAA;EACA,WAAA;EACA,MAAA;EACA,kBAAA;EACA,YAAA;A/E+uZxC;A+EnuZQ;EACI,aAAA;A/EquZZ;A+EnuZQ;EACI,cAAA;EACA,iBAAA;EACA,c7E/VC;AFokab;;AiBliaI;E8DmUA;IACI,kBAAA;E/EmuZN;E+EjuZE;IACI,sD7EuIsB;I6EvItB,gC7EuIsB;I6EtItB,aAAA;IACA,sBAAA;E/EmuZN;E+EhuZM;IACI,cAAA;E/EkuZV;E+E/tZE;IACI,YAAA;E/EiuZN;E+E/tZE;IACI,yBAAA;IACA,uBAAA;E/EiuZN;E+E9tZM;IACI,gBAAA;E/EguZV;E+E5tZM;IACI,cAAA;E/E8tZV;E+E5tZM;IACI,aAAA;E/E8tZV;AACF;A+EztZA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,2CClY8B;EDkY9B,6CClY8B;AhF6lalC;A+EztZI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;A/E2tZR;;A+EttZI;EACI,yB7EzZK;AFknab;A+ErtZQ;EACI,aCpWwB;AhF2japC;A+ErtZQ;EACI,cCxWwB;AhF+japC;;A+EhtZI;EACI,yBAAA;EACA,mBAAA;A/EmtZR;;A+E9sZA;EACI,sBCva8B;EDua9B,2CCva8B;AhFwnalC;A+E/sZI;EACI,iBC3a0B;ED4a1B,cAAA;EACA,yB7E5EoB;E6E6EpB,sD7E0DsB;E6E1DtB,gC7E0DsB;AFupZ9B;A+E7sZQ;EACI,kBAAA;EACA,iBAAA;A/E+sZZ;;AiBtnaI;E8D+aA;IACI,iBAAA;E/E2sZN;E+EzsZM;IACI,aAAA;E/E2sZV;E+ExsZM;IACI,kBAAA;IACA,gBCjfwB;IDkfxB,gBClfwB;IDmfxB,cAAA;E/E0sZV;E+EvsZM;IACI,kBAAA;IACA,aAAA;E/EysZV;E+EtsZM;IACI,cAAA;IACA,WAAA;IACA,oBAAA;E/EwsZV;AACF;A+ElsZA;EACI,iBAAA;A/EosZJ;AiBjpaI;E8DgdI;IACI,cAAA;E/EosZV;AACF;A+EhsZQ;EACI,eAAA;A/EksZZ;A+E9rZI;EACI,aAAA;EACA,iBAAA;A/EgsZR;A+E9rZI;EACI,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;A/EgsZR;A+E7rZI;EACI,kBAAA;EACA,2BAAA;EAAA,oDAAA;EACA,gBCriB4B;EDsiB5B,gBCtiB4B;EDuiB5B,sD7EnBsB;E6EmBtB,gC7EnBsB;E6EoBtB,gBAAA;EACA,yBAAA;EACA,wBAAA;A/E+rZR;A+E5rZY;EACI,yBAAA;EAAA,qCAAA;A/E8rZhB;A+E7rZgB;EAGI,yBAAA;EAAA,2CAAA;A/E6rZpB;A+ErrZoB;;;EACI,cCvjBY;EDujBZ,0BCvjBY;AhFgvapC;A+ExrZwB;;;;;EAEI,cCzjBQ;EDyjBR,gCCzjBQ;AhFsvapC;A+EzrZwB;;;EACI,cC7jBQ;ED6jBR,iCC7jBQ;AhF0vapC;A+EtrZgB;EACI,yBAAA;EAAA,4CAAA;A/EwrZpB;A+EprZY;EACI,cC5kBoB;ED4kBpB,0BC5kBoB;AhFkwapC;A+EjrZI;EACI,8DAAA;EACA,kBAAA;EACA,kBAAA;A/EmrZR;A+EjrZQ;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;A/EmrZZ;AiB5saI;E8D+hBQ;IACI,eAAA;IACA,OAAA;IACA,gBAAA;IACA,gBAAA;E/EgrZd;E+E7qZM;IACI,eAAA;E/E+qZV;E+E7qZM;IACI,yBAAA;IACA,yBAAA;E/E+qZV;E+E5qZM;IACI,aAAA;E/E8qZV;E+E1qZc;IACI,eAAA;E/E4qZlB;AACF;A+EnqZY;EACI,eAAA;EACA,eAAA;EACA,kBAAA;A/EqqZhB;A+EnqZY;EACI,aAAA;A/EqqZhB;A+EjqZY;EACI,cAAA;A/EmqZhB;A+E/pZY;EACI,OAAA;A/EiqZhB;A+E1pZoB;EAGI,cCzpBY;EDypBZ,gCCzpBY;AhFmzapC;A+ErpZoB;EACI,mB7EhoBX;E6EioBW,sBAAA;EACA,gBAAA;A/EupZxB;A+EppZoB;EACI,2BAAA;EAAA,2CAAA;EACA,sD7EvJM;E6EuJN,gC7EvJM;AF6yZ9B;A+EnpZ4B;EACI,yBAAA;EAAA,2CAAA;A/EqpZhC;;AiB3waI;E8DooBQ;IACI,iBAAA;E/E2oZd;AACF;A+EroZI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;A/EuoZR;A+EroZI;EACI,WAAA;EACA,WAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;A/EuoZR;A+EroZQ;EACI,WAAA;A/EuoZZ;A+EnoZI;EACI,aAAA;A/EqoZR;;A+E9nZI;EACI,gBCnuB4B;EDmuB5B,gCCnuB4B;AhFo2apC;A+E/nZQ;EACI,2BAAA;EAAA,2CAAA;A/EioZZ;A+E5nZQ;EACI,cCzuBwB;EDyuBxB,0BCzuBwB;AhFu2apC;A+E7nZY;EAGI,cC5uBoB;ED4uBpB,gCC5uBoB;AhFy2apC;A+ExnZY;EACI,yBAAA;EAAA,4CAAA;A/E0nZhB;A+EtnZQ;EACI,cCxvBwB;EDwvBxB,0BCxvBwB;AhFg3apC;A+EjnZgB;;;EACI,cChwBgB;EDgwBhB,0BChwBgB;AhFq3apC;A+EpnZoB;;;;;EAEI,cClwBY;EDkwBZ,gCClwBY;AhF23apC;A+ErnZoB;;;EACI,cCtwBY;EDswBZ,iCCtwBY;AhF+3apC;A+E5mZoB;EAGI,cCvxBY;EDuxBZ,gCCvxBY;AhFm4apC;A+EvmZoB;EACI,mB7E9vBX;E6E+vBW,sBAAA;EACA,gBAAA;A/EymZxB;A+EtmZoB;EACI,gBCvyBY;EDuyBZ,gCCvyBY;EDwyBZ,sD7ErRM;E6EqRN,gC7ErRM;AF63Z9B;A+ErmZ4B;EACI,cCxyBI;EDwyBJ,gCCxyBI;AhF+4apC;A+EhmZwB;;EACI,gBCpzBQ;EDozBR,gCCpzBQ;AhFu5apC;A+EhmZgC;;EACI,cCpzBA;EDozBA,gCCpzBA;AhFu5apC;;A+EtlZI;EACI,8BAAA;A/EylZR;A+EvlZQ;EACI,8BAAA;A/EylZZ;A+EplZQ;EACI,+BCv0BsB;AhF65alC;A+ErlZY;EAGI,qCC10BkB;AhF+5alC;A+EhlZY;EACI,kDAAA;EACA,2BAAA;A/EklZhB;A+E9kZQ;EACI,+BCv1BsB;AhFu6alC;A+EzkZgB;;;EACI,+BC/1Bc;AhF46alC;A+E5kZoB;;;;;EAEI,qCCj2BU;AhFk7alC;A+E7kZoB;;;EACI,sCCr2BU;AhFs7alC;A+EpkZoB;EAGI,qCCt3BU;AhF07alC;A+E/jZoB;EACI,mB7El2BX;E6Em2BW,sBAAA;EACA,gBAAA;A/EikZxB;A+E9jZoB;EACI,gBC34BY;ED24BZ,gCC34BY;ED44BZ,sD7EzXM;E6EyXN,gC7EzXM;AFy7Z9B;A+E7jZ4B;EACI,qCCv4BE;AhFs8alC;A+ExjZwB;;EACI,gBCx5BQ;EDw5BR,gCCx5BQ;AhFm9apC;;A+E5iZgB;EACI,cAAA;A/E+iZpB;A+EziZgB;EACI,mBAAA;EACA,cAAA;A/E2iZpB;A+E1iZoB;EACI,YAAA;A/E4iZxB;A+E1iZoB;EACI,WAAA;EACA,uEAAA;EAAA,oDAAA;A/E4iZxB;A+EziZ4B;EACI,aAAA;A/E2iZhC;A+EziZ4B;EACI,cAAA;A/E2iZhC;A+EriZY;EACI,yBAAA;A/EuiZhB;A+EtiZgB;EACI,UAAA;A/EwiZpB;A+EtiZgB;EACI,kBAAA;A/EwiZpB;A+EniZoB;EACI,iBCl8BY;AhFu+apC;A+EpiZwB;EACI,4BAAA;EACA,kBAAA;A/EsiZ5B;A+E7hZoB;EACI,cAAA;EACA,cAAA;A/E+hZxB;A+EzhZgB;EACI,yBAAA;A/E2hZpB;A+EnhZwB;EACI,2BAAA;EAAA,2CAAA;A/EqhZ5B;A+E3gZwB;EACI,2BAAA;EAAA,2CAAA;A/E6gZ5B;;A+EjgZQ;EACI,mCAAA;A/EogZZ;A+E//YY;EACI,cAAA;A/EigZhB;;AiF/gbA;EACI,eAAA;EACA,sBDegC;ECfhC,qCDegC;ECdhC,sD/EmhB0B;E+EnhB1B,gC/EmhB0B;E+EjhB1B,wBAAA;EACA,eAAA;EACA,WDLgC;ECMhC,MAAA;EACA,QAAA;EACA,aAAA;AjFihbJ;AiF/gbI;EACI,sBDI4B;ECJ5B,qCDI4B;ECH5B,YDE4B;ECD5B,eAAA;EACA,UAAA;EACA,YDf4B;ECgB5B,kBAAA;EACA,MAAA;EACA,OAAA;AjFihbR;AiFhhbQ;EACI,iBDNwB;AhFwhbpC;AiFjhbY;EACI,aAAA;AjFmhbhB;AiF/gbI;EACI,kBAAA;EACA,UAAA;AjFihbR;AiF/gbQ;EACI,WAAA;EACA,gBDlBwB;AhFmibpC;AiF9gbgB;EACI,cAAA;AjFghbpB;AiF5gbQ;EACI,UAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AjF8gbZ;AiF1gbI;EACI,gBAAA;EACA,kBAAA;EACA,4CAAA;AjF4gbR;AiF1gbQ;;EAEI,gBAAA;EACA,uBAAA;AjF4gbZ;AiFxgboB;;EACI,oCAAA;EAAA,kDAAA;AjF2gbxB;AiFtgbgB;;EACI,yBAAA;EAAA,uCAAA;AjFygbpB;AiFvgbgB;;EACI,yBAAA;EAAA,uCAAA;AjF0gbpB;AiFzgboB;;EACI,yBAAA;EAAA,uCAAA;AjF4gbxB;;AiFngbI;EACI,iBDvE4B;AhF6kbpC;;AiFlgbA,WAAA;AAGI;EACI,YAAA;EACA,kC/E+wBgC;E+E9wBhC,kBAAA;EACA,yBDhF4B;ECgF5B,4CDhF4B;ECiF5B,gBAAA;AjFmgbR;AiFjgbI;EACI,UAAA;AjFmgbR;AiFjgbI;EACI,aAAA;AjFmgbR;AiFjgbI;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,MAAA;AjFmgbR;;AiF9/aI;EACI,YAAA;EACA,kC/EuvBgC;E+EtvBhC,kBAAA;EACA,mBAAA;EACA,yBDzG4B;ECyG5B,4CDzG4B;EC0G5B,gBAAA;AjFigbR;AiF//aI;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,MAAA;AjFigbR;AiF//aI;EACI,cAAA;EACA,UAAA;AjFigbR;;AiF7/aA,iBAAA;AACA;EACI,cAAA;AjFggbJ;AiF9/aI;EACI,6BAAA;EACA,kBAAA;AjFggbR;AiF7/aI;EACI,eAAA;EACA,sBAAA;EACA,iBDxI4B;AhFuobpC;AiF5/aI;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yB/E1HK;AFwnbb;AiF3/aI;EACI,kBAAA;AjF6/aR;AiF5/aQ;EACI,0DAAA;AjF8/aZ;AiF5/aQ;EACI,6BAAA;EACA,yBAAA;AjF8/aZ;AiF5/aQ;EACI,aAAA;AjF8/aZ;AiF7/aY;EACI,kBAAA;EACA,QAAA;EACA,UAAA;AjF+/ahB;AiF7/aY;EACI,eAAA;AjF+/ahB;AiF7/aY;;EAEI,gBAAA;EACA,uBAAA;EACA,mBAAA;AjF+/ahB;AiF3/aQ;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WlDpMD;A/BisbX;AiF1/aQ;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;AjF4/aZ;AiF1/aY;EACI,gBAAA;AjF4/ahB;AiF1/aY;EACI,cAAA;AjF4/ahB;AiFx/aQ;EACI,iBAAA;EACA,mBAAA;EACA,iBAAA;AjF0/aZ;AiFt/aQ;EACI,iBAAA;AjFw/aZ;;AiFn/aA;EACI,gBAAA;AjFs/aJ;AiFp/aI;;EAEI,sBAAA;AjFs/aR;;AiFl/aA;EACI,oCAAA;EACA,2BAAA;EACA,kBAAA;EAGA,mBAAA;AjFm/aJ;AiFh/aI;EACI,kBAAA;EACA,0BAAA;EACA,UAAA;AjFk/aR;AiFh/aQ;EACI,YAAA;EACA,WAAA;AjFk/aZ;AiF/+aI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AjFi/aR;AiF/+aI;EACI,cAAA;EACA,gBDlN0B;AhFmsblC;;AiF7+aA;EACI,YAAA;EACA,cAAA;EACA,YD/PgC;ECgQhC,iBDhQgC;ECiQhC,WAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;AjFg/aJ;AiF9+aI;EACI,aAAA;AjFg/aR;AiBnsbI;EgEoMJ;IAmBQ,oBAAA;EjFg/aN;AACF;;AiF5+aI;EACI,eAAA;AjF++aR;AiF5+aI;EACI,SAAA;AjF8+aR;AiF5+aQ;EACI,qBAAA;AjF8+aZ;;AiFz+aA;EAEQ;IACI,gBAAA;IAAA,iBAAA;EjF2+aV;EiFx+aM;IACI,gBAAA;EjF0+aV;EiFx+aU;IACI,qBAAA;IACA,sBAAA;EjF0+ad;AACF;AiFr+aA;EACI;IACI,QAAA;EjFu+aN;EiFr+aM;IACI,aAAA;EjFu+aV;AACF;AiBvubI;EgEqQA;IACI,sCAAA;EjFq+aN;EiFn+aM;;IAEI,aAAA;EjFq+aV;AACF;AiBhvbI;EgEgRA;IACI,kBAAA;IACA,UAAA;EjFm+aN;EiFh+aM;IACI,qBAAA;EjFk+aV;AACF;AiF99aA;EAGY;IACI,aAAA;EjF89ad;EiFz9aU;IACI,mBAAA;IACA,kBAAA;EjF29ad;EiFz9aU;IACI,gBAAA;EjF29ad;EiFz9aU;IACI,WAAA;EjF29ad;AACF;AiBrxbI;EgEmUI;IACI,kBAAA;EjFq9aV;AACF;AiFh9aA;EACI,yBD9W8B;EC8W9B,0CD9W8B;AhFg0blC;AiFh9aI;EACI,oCAAA;EAAA,8DAAA;EACA,oCAAA;EAAA,kEAAA;AjFk9aR;AiF58agB;EACI,sBAAA;AjF88apB;AiFv8aQ;EACI,yBDhYsB;ECgYtB,iDDhYsB;ECiYtB,WlDtZD;A/B+1bX;AiFv8aQ;EACI,WlDzZD;A/Bk2bX;AiFv8aQ;;EAEI,cAAA;AjFy8aZ;AiFp8aQ;EACI,qDAAA;AjFs8aZ;;AiFh8aI;EACI,kBAAA;EACA,kBAAA;EACA,qBAAA;AjFm8aR;AiF/7aQ;EACI,SAAA;AjFi8aZ;;AiFt7aoB;EACI,cAAA;AjFy7axB;AiFr7aY;EACI,cAAA;AjFu7ahB;AiFj7aY;EACI,qEAAA;AjFm7ahB;AiFj7aY;EACI,yBAAA;AjFm7ahB;AiF96aI;EACI,cAAA;AjFg7aR;AiF76aI;EACI,qEAAA;EACA,yBAAA;AjF+6aR;AiF16aY;;EAEI,cAAA;AjF46ahB;;AkF94bA;;;GAAA;AAKA;EACI,sBFyB8B;EEzB9B,uCFyB8B;EExB9B,8EAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,YFmB8B;EElB9B,aAAA;EACA,uBAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;EACA,oBAAA;AlFg5bJ;AkF94bI;EACI,yBFY0B;EEZ1B,6CFY0B;EEX1B,kBAAA;EACA,WFW0B;EEX1B,qCFW0B;AhFq4blC;AkF94bI;EACI,yBFS0B;EET1B,iDFS0B;EER1B,YAAA;EACA,WAAA;EACA,iBAAA;EACA,WFM0B;EEN1B,yCFM0B;EEL1B,kBAAA;EACA,kBAAA;EACA,gBAAA;AlFg5bR;;AkF54bA;EACI,yBFD8B;EEC9B,+CFD8B;EEE9B,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;AlF+4bJ;;AkF34bI;EACI,QAAA;AlF84bR;AkF54bI;EACI,cAAA;AlF84bR;;AiB53bI;EiEZA;IACI,cAAA;ElF44bN;AACF;AmFz8bI;EACI,eAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cHoD0B;EGpD1B,iCHoD0B;AhFu5blC;AmFz8bI;EACI,YAAA;EACA,gBAAA;AnF28bR;AmFx8bI;EACI,gBAAA;AnF08bR;;AmFr8bI;EACI,yBAAA;EACA,mBAAA;AnFw8bR;AmFt8bI;EACI,YAAA;EACA,aAAA;AnFw8bR;AmFr8bI;EACI,cAAA;EACA,2BAAA;AnFu8bR;;AmFl8bA;EACI,cHqC8B;EGrC9B,iCHqC8B;AhFg6blC;AmFn8bI;EACI,cHkC0B;EGlC1B,iCHkC0B;AhFm6blC;;AiBt6bI;EkEzBI;IACI,cAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;IACA,iBAAA;EnFm8bV;EmFj8bM;IACI,aAAA;EnFm8bV;EmFj8bM;IACI,aAAA;EnFm8bV;AACF;AmF/7bA;EACI;IACI,aAAA;EnFi8bN;AACF;AoFngcA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;ApFqgcJ;AoFngcI;EACI,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;ApFqgcR;AoFngcQ;EACI,aAAA;ApFqgcZ;AoFjgcI;EACI,kBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;EACA,6BAAA;EACA,YAAA;ApFmgcR;AoFjgcQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;ApFmgcZ;AoFjgcQ;EACI,WAAA;EACA,WAAA;EACA,uCAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;ApFmgcZ;AoFhgcY;EACI,kBAAA;ApFkgchB;AoFjgcgB;EACI,QAAA;EACA,wBAAA;ApFmgcpB;AoFjgcgB;EACI,kBAAA;ApFmgcpB;AoFjgcgB;EACI,WAAA;EACA,QAAA;EACA,yBAAA;ApFmgcpB;AoF7/bI;EACI,WAAA;ApF+/bR;;AoF3/bA;EACI,mBJzB8B;EIyB9B,+BJzB8B;AhFuhclC;AoF5/bI;EACI,SAAA;EACA,UAAA;ApF8/bR;AoF3/bQ;EACI,oBAAA;EACA,kBAAA;EACA,oBAAA;ApF6/bZ;AoFx/bY;EACI,cJ5EoB;EI4EpB,iCJ5EoB;AhFskcpC;AoFn/bgB;EACI,WrDxFT;A/B6kcX;;AoF9+bA;EACI,qBAAA;ApFi/bJ;AoF/+bI;EACI,0BAAA;EAAA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;ApFi/bR;;AoF5+bI;EACI,mBlFyXsB;EkFxXtB,kBlFwXsB;AFunb9B;;AiB9icI;EmEqEI;IACI,cAAA;EpF6+bV;EoF1+bU;IACI,cAAA;EpF4+bd;EoFn+bkB;IACI,eAAA;EpFq+btB;EoF/9bU;IACI,aAAA;IACA,kCAAA;IACA,+BAAA;I7EmIV,iCALI;EPo2bR;EoF99bkB;IACI,WAAA;IACA,2CAAA;IACA,kBAAA;EpFg+btB;EoF39bkB;IACI,kBAAA;IACA,MAAA;IACA,UAAA;IACA,aAAA;EpF69btB;EoFv9bc;IACI,cAAA;EpFy9blB;EoFr9bM;IACI,cAAA;EpFu9bV;EoFn9bE;IACI,clF49B4B;IkF59B5B,2ClF49B4B;IwBrpClC,qExBspCkC;IwBtpClC,mDxBspCkC;EFy/ZlC;AACF;AiBrlcI;EmEqII;IACI,cAAA;EpFm9bV;AACF;AiB1lcI;EmE4IA;IACI,aAAA;EpFi9bN;AACF;AiBllcI;EmEsII;IACI,aAAA;EpF+8bV;EoF78bM;IACI,eAAA;IACA,gBAAA;IACA,kBAAA;EpF+8bV;EoF78bM;IACI,yBAAA;EpF+8bV;EoFz8bU;IACI,uBAAA;EpF28bd;EoFv8bU;IACI,6BAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;EpFy8bd;EoFv8bU;IACI,kBAAA;IACA,6BAAA;EpFy8bd;EoFp8bc;IACI,+BAAA;EpFs8blB;EoFp8bkB;IACI,WrD/Ob;E/BqrcT;EoFh8bU;IACI,WAAA;IACA,kBAAA;EpFk8bd;AACF;AqF9rcA;EACE,qBAAA;EACA,6CAAA;EACA,qSAAA;EACA,gBAAA;EACA,kBAAA;ArFgscF;AqF7rcA;EACE,qBAAA;EACA,6CAAA;EACA,ySAAA;EACA,gBAAA;EACA,kBAAA;ArF+rcF;AqF5rcA;EACE,qBAAA;EACA,6CAAA;EACA,2SAAA;EACA,gBAAA;EACA,kBAAA;ArF8rcF;AqF3rcA;EACE,qBAAA;EACA,6CAAA;EACA,mSAAA;EACA,gBAAA;EACA,kBAAA;ArF6rcF;AsF9tcA;;;;;;CAAA;ACAA;EACE,sBAAA;EACA,6CAAA;EACA,iTAAA;EAKA,mBAAA;EACA,kBAAA;AvFmucF;AuFjucA,gGAAA;AACA,2FAAA;AACA;;;;;;;CAAA;AASC;EACC,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gEAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EAEA,8CAAA;EACA,gBAAA;EAEA,0DAAA;EACA,qBAAA;EAEA,6CAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,uDAAA;AvF8tcF;;AuF3tcA;EAAqB,gBAAA;AvF+tcrB,EuF/tcyC,QAAA;AACzC;EAAsB,gBAAA;AvFiuctB,EuFjuc0C,QAAA;AAC1C;EAAsB,gBAAA;AvFmuctB,EuFnuc0C,QAAA;AAC1C;EAAsB,gBAAA;AvFquctB,EuFruc0C,QAAA;AAC1C;EAAsB,gBAAA;AvFuuctB,EuFvuc0C,QAAA;AAC1C;EAAsB,gBAAA;AvFyuctB,EuFzuc0C,QAAA;AAC1C;EAAsB,gBAAA;AvF2uctB,EuF3uc0C,QAAA;AAC1C;EAAsB,gBAAA;AvF6uctB,EuF7uc0C,QAAA;AAC1C;EAAqB,gBAAA;AvF+ucrB,EuF/ucyC,QAAA;AACzC;EAAoB,gBAAA;AvFivcpB,EuFjvcwC,QAAA;AACxC;EAAqB,gBAAA;AvFmvcrB,EuFnvcyC,QAAA;AACzC;EAAqB,gBAAA;AvFqvcrB,EuFrvcyC,QAAA;AACzC;EAAkC,gBAAA;AvFuvclC,EuFvvcsD,QAAA;AACtD;EAAyB,gBAAA;AvFyvczB,EuFzvc6C,QAAA;AAC7C;EAA4B,gBAAA;AvF2vc5B,EuF3vcgD,QAAA;AAChD;EAA0B,gBAAA;AvF6vc1B,EuF7vc8C,QAAA;AAC9C;EAAqB,gBAAA;AvF+vcrB,EuF/vcyC,QAAA;AACzC;EAAoB,gBAAA;AvFiwcpB,EuFjwcwC,QAAA;AACxC;EAAsB,gBAAA;AvFmwctB,EuFnwc0C,QAAA;AAC1C;EAAwB,gBAAA;AvFqwcxB,EuFrwc4C,QAAA;AAC5C;EAA+B,gBAAA;AvFuwc/B,EuFvwcmD,QAAA;AACnD;EAA6B,gBAAA;AvFywc7B,EuFzwciD,QAAA;AACjD;EAAmC,gBAAA;AvF2wcnC,EuF3wcuD,QAAA;AACvD;EAA6B,gBAAA;AvF6wc7B,EuF7wciD,QAAA;AACjD;EAA2B,gBAAA;AvF+wc3B,EuF/wc+C,QAAA;AAC/C;EAA4B,gBAAA;AvFixc5B,EuFjxcgD,QAAA;AAChD;EAAiC,gBAAA;AvFmxcjC,EuFnxcqD,QAAA;AACrD;EAAyB,gBAAA;AvFqxczB,EuFrxc6C,QAAA;AAC7C;EAAiC,gBAAA;AvFuxcjC,EuFvxcqD,QAAA;AACrD;EAAkC,gBAAA;AvFyxclC,EuFzxcsD,QAAA;AACtD;EAA0B,gBAAA;AvF2xc1B,EuF3xc8C,QAAA;AAC9C;EAAoB,gBAAA;AvF6xcpB,EuF7xcwC,QAAA;AACxC;EAAwB,gBAAA;AvF+xcxB,EuF/xc4C,QAAA;AAC5C;EAAuB,gBAAA;AvFiycvB,EuFjyc2C,QAAA;AAC3C;EAAwB,gBAAA;AvFmycxB,EuFnyc4C,QAAA;AAC5C;EAAqB,gBAAA;AvFqycrB,EuFrycyC,QAAA;AACzC;EAAkC,gBAAA;AvFuyclC,EuFvycsD,QAAA;AACtD;EAAgC,gBAAA;AvFyychC,EuFzycoD,QAAA;AACpD;EAAgC,gBAAA;AvF2ychC,EuF3ycoD,QAAA;AACpD;EAAiC,gBAAA;AvF6ycjC,EuF7ycqD,QAAA;AACrD;EAA8B,gBAAA;AvF+yc9B,EuF/yckD,QAAA;AAClD;EAAyB,gBAAA;AvFizczB,EuFjzc6C,QAAA;AAC7C;EAAyB,gBAAA;AvFmzczB,EuFnzc6C,QAAA;AAC7C;EAA4B,gBAAA;AvFqzc5B,EuFrzcgD,QAAA;AAChD;EAA0B,gBAAA;AvFuzc1B,EuFvzc8C,QAAA;AAC9C;EAAuB,gBAAA;AvFyzcvB,EuFzzc2C,QAAA;AAC3C;EAAoB,gBAAA;AvF2zcpB,EuF3zcwC,QAAA;AACxC;EAAmB,gBAAA;AvF6zcnB,EuF7zcuC,QAAA;AACvC;EAA0B,gBAAA;AvF+zc1B,EuF/zc8C,QAAA;AAC9C;EAAsB,gBAAA;AvFi0ctB,EuFj0c0C,QAAA;AAC1C;EAAoB,gBAAA;AvFm0cpB,EuFn0cwC,QAAA;AACxC;EAAmB,gBAAA;AvFq0cnB,EuFr0cuC,QAAA;AACvC;EAA0B,gBAAA;AvFu0c1B,EuFv0c8C,QAAA;AAC9C;EAAsB,gBAAA;AvFy0ctB,EuFz0c0C,QAAA;AAC1C;EAAsB,gBAAA;AvF20ctB,EuF30c0C,QAAA;AAC1C;EAA0B,gBAAA;AvF60c1B,EuF70c8C,QAAA;AAC9C;EAAgC,gBAAA;AvF+0chC,EuF/0coD,QAAA;AACpD;EAAgC,gBAAA;AvFi1chC,EuFj1coD,QAAA;AACpD;EAAiC,gBAAA;AvFm1cjC,EuFn1cqD,QAAA;AACrD;EAA8B,gBAAA;AvFq1c9B,EuFr1ckD,QAAA;AAClD;EAA+B,gBAAA;AvFu1c/B,EuFv1cmD,QAAA;AACnD;EAA8B,gBAAA;AvFy1c9B,EuFz1ckD,QAAA;AAClD;EAA+B,gBAAA;AvF21c/B,EuF31cmD,QAAA;AACnD;EAAyB,gBAAA;AvF61czB,EuF71c6C,QAAA;AAC7C;EAA+B,gBAAA;AvF+1c/B,EuF/1cmD,QAAA;AACnD;EAA6B,gBAAA;AvFi2c7B,EuFj2ciD,QAAA;AACjD;EAA2B,gBAAA;AvFm2c3B,EuFn2c+C,QAAA;AAC/C;EAAyB,gBAAA;AvFq2czB,EuFr2c6C,QAAA;AAC7C;EAA2B,gBAAA;AvFu2c3B,EuFv2c+C,QAAA;AAC/C;EAAoC,gBAAA;AvFy2cpC,EuFz2cwD,QAAA;AACxD;EAA0B,gBAAA;AvF22c1B,EuF32c8C,QAAA;AAC9C;EAA8B,gBAAA;AvF62c9B,EuF72ckD,QAAA;AAClD;EAA6B,gBAAA;AvF+2c7B,EuF/2ciD,QAAA;AACjD;EAA4B,gBAAA;AvFi3c5B,EuFj3cgD,QAAA;AAChD;EAA6B,gBAAA;AvFm3c7B,EuFn3ciD,QAAA;AACjD;EAAuB,gBAAA;AvFq3cvB,EuFr3c2C,QAAA;AAC3C;EAA2B,gBAAA;AvFu3c3B,EuFv3c+C,QAAA;AAC/C;EAAuB,gBAAA;AvFy3cvB,EuFz3c2C,QAAA;AAC3C;EAA+B,gBAAA;AvF23c/B,EuF33cmD,QAAA;AACnD;EAA8B,gBAAA;AvF63c9B,EuF73ckD,QAAA;AAClD;EAA2B,gBAAA;AvF+3c3B,EuF/3c+C,QAAA;AAC/C;EAA8B,gBAAA;AvFi4c9B,EuFj4ckD,QAAA;AAClD;EAA8B,gBAAA;AvFm4c9B,EuFn4ckD,QAAA;AAClD;EAA4B,gBAAA;AvFq4c5B,EuFr4cgD,QAAA;AAChD;EAAgC,gBAAA;AvFu4chC,EuFv4coD,QAAA;AACpD;EAA8B,gBAAA;AvFy4c9B,EuFz4ckD,QAAA;AAClD;EAA8B,gBAAA;AvF24c9B,EuF34ckD,QAAA;AAClD;EAA8B,gBAAA;AvF64c9B,EuF74ckD,QAAA;AAClD;EAA2B,gBAAA;AvF+4c3B,EuF/4c+C,QAAA;AAC/C;EAAuB,gBAAA;AvFi5cvB,EuFj5c2C,QAAA;AAC3C;EAA0C,gBAAA;AvFm5c1C,EuFn5c8D,QAAA;AAC9D;EAAuB,gBAAA;AvFq5cvB,EuFr5c2C,QAAA;AAC3C;EAAiB,gBAAA;AvFu5cjB,EuFv5cqC,QAAA;AACrC;EAAuB,gBAAA;AvFy5cvB,EuFz5c2C,QAAA;AAC3C;EAAmB,gBAAA;AvF25cnB,EuF35cuC,QAAA;AACvC;EAAyB,gBAAA;AvF65czB,EuF75c6C,QAAA;AAC7C;EAAwB,gBAAA;AvF+5cxB,EuF/5c4C,QAAA;AAC5C;EAAoB,gBAAA;AvFi6cpB,EuFj6cwC,QAAA;AACxC;EAA4B,gBAAA;AvFm6c5B,EuFn6cgD,QAAA;AAChD;EAAuB,gBAAA;AvFq6cvB,EuFr6c2C,QAAA;AAC3C;EAAwB,gBAAA;AvFu6cxB,EuFv6c4C,QAAA;AAC5C;EAAuB,gBAAA;AvFy6cvB,EuFz6c2C,QAAA;AAC3C;EAAsB,gBAAA;AvF26ctB,EuF36c0C,QAAA;AAC1C;EAAwB,gBAAA;AvF66cxB,EuF76c4C,QAAA;AAC5C;EAAkB,gBAAA;AvF+6clB,EuF/6csC,QAAA;AACtC;EAA4B,gBAAA;AvFi7c5B,EuFj7cgD,QAAA;AAChD;EAAmB,gBAAA;AvFm7cnB,EuFn7cuC,QAAA;AACvC;EAAkB,gBAAA;AvFq7clB,EuFr7csC,QAAA;AACtC;EAAmB,gBAAA;AvFu7cnB,EuFv7cuC,QAAA;AACvC;EAA8B,gBAAA;AvFy7c9B,EuFz7ckD,QAAA;AAClD;EAAyB,gBAAA;AvF27czB,EuF37c6C,QAAA;AAC7C;EAA2B,gBAAA;AvF67c3B,EuF77c+C,QAAA;AAC/C;EAA4B,gBAAA;AvF+7c5B,EuF/7cgD,QAAA;AAChD;EAAyB,gBAAA;AvFi8czB,EuFj8c6C,QAAA;AAC7C;EAAkB,gBAAA;AvFm8clB,EuFn8csC,QAAA;AACtC;EAAsB,gBAAA;AvFq8ctB,EuFr8c0C,QAAA;AAC1C;EAA0B,gBAAA;AvFu8c1B,EuFv8c8C,QAAA;AAC9C;EAAyB,gBAAA;AvFy8czB,EuFz8c6C,QAAA;AAC7C;EAAmB,gBAAA;AvF28cnB,EuF38cuC,QAAA;AACvC;EAAmB,gBAAA;AvF68cnB,EuF78cuC,QAAA;AACvC;EAA6B,gBAAA;AvF+8c7B,EuF/8ciD,QAAA;AACjD;EAAsB,gBAAA;AvFi9ctB,EuFj9c0C,QAAA;AAC1C;EAA0B,gBAAA;AvFm9c1B,EuFn9c8C,QAAA;AAC9C;EAA0B,gBAAA;AvFq9c1B,EuFr9c8C,QAAA;AAC9C;EAAmB,gBAAA;AvFu9cnB,EuFv9cuC,QAAA;AACvC;EAAuB,gBAAA;AvFy9cvB,EuFz9c2C,QAAA;AAC3C;EAAyB,gBAAA;AvF29czB,EuF39c6C,QAAA;AAC7C;EAAmB,gBAAA;AvF69cnB,EuF79cuC,QAAA;AACvC;EAAuB,gBAAA;AvF+9cvB,EuF/9c2C,QAAA;AAC3C;EAA2B,gBAAA;AvFi+c3B,EuFj+c+C,QAAA;AAC/C;EAAwB,gBAAA;AvFm+cxB,EuFn+c4C,QAAA;AAC5C;EAA0B,gBAAA;AvFq+c1B,EuFr+c8C,QAAA;AAC9C;EAAmB,gBAAA;AvFu+cnB,EuFv+cuC,QAAA;AACvC;EAA4B,gBAAA;AvFy+c5B,EuFz+cgD,QAAA;AAChD;EAAuB,gBAAA;AvF2+cvB,EuF3+c2C,QAAA;AAC3C;EAAoB,gBAAA;AvF6+cpB,EuF7+cwC,QAAA;AACxC;EAAsB,gBAAA;AvF++ctB,EuF/+c0C,QAAA;AAC1C;EAAyB,gBAAA;AvFi/czB,EuFj/c6C,QAAA;AAC7C;EAA4B,gBAAA;AvFm/c5B,EuFn/cgD,QAAA;AAChD;EAA2B,gBAAA;AvFq/c3B,EuFr/c+C,QAAA;AAC/C;EAAgC,gBAAA;AvFu/chC,EuFv/coD,QAAA;AACpD;EAA2B,gBAAA;AvFy/c3B,EuFz/c+C,QAAA;AAC/C;EAA0B,gBAAA;AvF2/c1B,EuF3/c8C,QAAA;AAC9C;EAAyB,gBAAA;AvF6/czB,EuF7/c6C,QAAA;AAC7C;EAA2B,gBAAA;AvF+/c3B,EuF//c+C,QAAA;AAC/C;EAAyB,gBAAA;AvFigdzB,EuFjgd6C,QAAA;AAC7C;EAA8B,gBAAA;AvFmgd9B,EuFngdkD,QAAA;AAClD;EAAkB,gBAAA;AvFqgdlB,EuFrgdsC,QAAA;AACtC;EAA4B,gBAAA;AvFugd5B,EuFvgdgD,QAAA;AAChD;EAAwB,gBAAA;AvFygdxB,EuFzgd4C,QAAA;AAC5C;EAAqB,gBAAA;AvF2gdrB,EuF3gdyC,QAAA;AACzC;EAA+B,gBAAA;AvF6gd/B,EuF7gdmD,QAAA;AACnD;EAA8B,gBAAA;AvF+gd9B,EuF/gdkD,QAAA;AAClD;EAA6B,gBAAA;AvFihd7B,EuFjhdiD,QAAA;AACjD;EAA+B,gBAAA;AvFmhd/B,EuFnhdmD,QAAA;AACnD;EAA8B,gBAAA;AvFqhd9B,EuFrhdkD,QAAA;AAClD;EAAyB,gBAAA;AvFuhdzB,EuFvhd6C,QAAA;AAC7C;EAA2B,gBAAA;AvFyhd3B,EuFzhd+C,QAAA;AAC/C;EAA0B,gBAAA;AvF2hd1B,EuF3hd8C,QAAA;AAC9C;EAAwB,gBAAA;AvF6hdxB,EuF7hd4C,QAAA;AAC5C;EAAkB,gBAAA;AvF+hdlB,EuF/hdsC,QAAA;AACtC;EAAuB,gBAAA;AvFiidvB,EuFjid2C,QAAA;AAC3C;EAAuB,gBAAA;AvFmidvB,EuFnid2C,QAAA;AAC3C;EAAsB,gBAAA;AvFqidtB,EuFrid0C,QAAA;AAC1C;EAAyB,gBAAA;AvFuidzB,EuFvid6C,QAAA;AAC7C;EAAkB,gBAAA;AvFyidlB,EuFzidsC,QAAA;AACtC;EAAyB,gBAAA;AvF2idzB,EuF3id6C,QAAA;AAC7C;EAA6B,gBAAA;AvF6id7B,EuF7idiD,QAAA;AACjD;EAA2B,gBAAA;AvF+id3B,EuF/id+C,QAAA;AAC/C;EAA6B,gBAAA;AvFijd7B,EuFjjdiD,QAAA;AACjD;EAAuB,gBAAA;AvFmjdvB,EuFnjd2C,QAAA;AAC3C;EAAsB,gBAAA;AvFqjdtB,EuFrjd0C,QAAA;AAC1C;EAA4B,gBAAA;AvFujd5B,EuFvjdgD,QAAA;AAChD;EAA0B,gBAAA;AvFyjd1B,EuFzjd8C,QAAA;AAC9C;EAA2B,gBAAA;AvF2jd3B,EuF3jd+C,QAAA;AAC/C;EAAqB,gBAAA;AvF6jdrB,EuF7jdyC,QAAA;AACzC;EAAqB,gBAAA;AvF+jdrB,EuF/jdyC,QAAA;AACzC;EAAsB,gBAAA;AvFikdtB,EuFjkd0C,QAAA;AAC1C;EAAsB,gBAAA;AvFmkdtB,EuFnkd0C,QAAA;AAC1C;EAA2B,gBAAA;AvFqkd3B,EuFrkd+C,QAAA;AAC/C;EAAwB,gBAAA;AvFukdxB,EuFvkd4C,QAAA;AAC5C;EAAuB,gBAAA;AvFykdvB,EuFzkd2C,QAAA;AAC3C;EAAkB,gBAAA;AvF2kdlB,EuF3kdsC,QAAA;AACtC;EAAuB,gBAAA;AvF6kdvB,EuF7kd2C,QAAA;AAC3C;EAA0B,gBAAA;AvF+kd1B,EuF/kd8C,QAAA;AAC9C;EAAmB,gBAAA;AvFildnB,EuFjlduC,QAAA;AACvC;EAAmB,gBAAA;AvFmldnB,EuFnlduC,QAAA;AACvC;EAAsB,gBAAA;AvFqldtB,EuFrld0C,QAAA;AAC1C;EAA4B,gBAAA;AvFuld5B,EuFvldgD,QAAA;AAChD;EAAwB,gBAAA;AvFyldxB,EuFzld4C,QAAA;AAC5C;EAAyB,gBAAA;AvF2ldzB,EuF3ld6C,QAAA;AAC7C;EAA+B,gBAAA;AvF6ld/B,EuF7ldmD,QAAA;AACnD;EAA2B,gBAAA;AvF+ld3B,EuF/ld+C,QAAA;AAC/C;EAAyB,gBAAA;AvFimdzB,EuFjmd6C,QAAA;AAC7C;EAA4B,gBAAA;AvFmmd5B,EuFnmdgD,QAAA;AAChD;EAAwB,gBAAA;AvFqmdxB,EuFrmd4C,QAAA;AAC5C;EAAoB,gBAAA;AvFumdpB,EuFvmdwC,QAAA;AACxC;EAA+B,gBAAA;AvFymd/B,EuFzmdmD,QAAA;AACnD;EAAwB,gBAAA;AvF2mdxB,EuF3md4C,QAAA;AAC5C;EAAmB,gBAAA;AvF6mdnB,EuF7mduC,QAAA;AACvC;EAA2B,gBAAA;AvF+md3B,EuF/md+C,QAAA;AAC/C;EAA2B,gBAAA;AvFind3B,EuFjnd+C,QAAA;AAC/C;EAAoB,gBAAA;AvFmndpB,EuFnndwC,QAAA;AACxC;EAA2B,gBAAA;AvFqnd3B,EuFrnd+C,QAAA;AAC/C;EAAqB,gBAAA;AvFundrB,EuFvndyC,QAAA;AACzC;EAAsB,gBAAA;AvFyndtB,EuFznd0C,QAAA;AAC1C;EAA4B,gBAAA;AvF2nd5B,EuF3ndgD,QAAA;AAChD;EAA4B,gBAAA;AvF6nd5B,EuF7ndgD,QAAA;AAChD;EAA8B,gBAAA;AvF+nd9B,EuF/ndkD,QAAA;AAClD;EAA8B,gBAAA;AvFiod9B,EuFjodkD,QAAA;AAClD;EAAwB,gBAAA;AvFmodxB,EuFnod4C,QAAA;AAC5C;EAA0B,gBAAA;AvFqod1B,EuFrod8C,QAAA;AAC9C;EAAyB,gBAAA;AvFuodzB,EuFvod6C,QAAA;AAC7C;EAAyB,gBAAA;AvFyodzB,EuFzod6C,QAAA;AAC7C;EAA0B,gBAAA;AvF2od1B,EuF3od8C,QAAA;AAC9C;EAAwB,gBAAA;AvF6odxB,EuF7od4C,QAAA;AAC5C;EAA0B,gBAAA;AvF+od1B,EuF/od8C,QAAA;AAC9C;EAAwB,gBAAA;AvFipdxB,EuFjpd4C,QAAA;AAC5C;EAAoB,gBAAA;AvFmpdpB,EuFnpdwC,QAAA;AACxC;EAAgC,gBAAA;AvFqpdhC,EuFrpdoD,QAAA;AACpD;EAA0B,gBAAA;AvFupd1B,EuFvpd8C,QAAA;AAC9C;EAA6B,gBAAA;AvFypd7B,EuFzpdiD,QAAA;AACjD;EAA0B,gBAAA;AvF2pd1B,EuF3pd8C,QAAA;AAC9C;EAA8B,gBAAA;AvF6pd9B,EuF7pdkD,QAAA;AAClD;EAAoC,gBAAA;AvF+pdpC,EuF/pdwD,QAAA;AACxD;EAAkC,gBAAA;AvFiqdlC,EuFjqdsD,QAAA;AACtD;EAA6B,gBAAA;AvFmqd7B,EuFnqdiD,QAAA;AACjD;EAA4B,gBAAA;AvFqqd5B,EuFrqdgD,QAAA;AAChD;EAAgC,gBAAA;AvFuqdhC,EuFvqdoD,QAAA;AACpD;EAAyB,gBAAA;AvFyqdzB,EuFzqd6C,QAAA;AAC7C;EAA0B,gBAAA;AvF2qd1B,EuF3qd8C,QAAA;AAC9C;EAAyB,gBAAA;AvF6qdzB,EuF7qd6C,QAAA;AAC7C;EAAyB,gBAAA;AvF+qdzB,EuF/qd6C,QAAA;AAC7C;EAA6B,gBAAA;AvFird7B,EuFjrdiD,QAAA;AACjD;EAA8B,gBAAA;AvFmrd9B,EuFnrdkD,QAAA;AAClD;EAAkC,gBAAA;AvFqrdlC,EuFrrdsD,QAAA;AACtD;EAA8B,gBAAA;AvFurd9B,EuFvrdkD,QAAA;AAClD;EAAiC,gBAAA;AvFyrdjC,EuFzrdqD,QAAA;AACrD;EAAyB,gBAAA;AvF2rdzB,EuF3rd6C,QAAA;AAC7C;EAA6B,gBAAA;AvF6rd7B,EuF7rdiD,QAAA;AACjD;EAA6B,gBAAA;AvF+rd7B,EuF/rdiD,QAAA;AACjD;EAAyB,gBAAA;AvFisdzB,EuFjsd6C,QAAA;AAC7C;EAAyB,gBAAA;AvFmsdzB,EuFnsd6C,QAAA;AAC7C;EAAwB,gBAAA;AvFqsdxB,EuFrsd4C,QAAA;AAC5C;EAA0B,gBAAA;AvFusd1B,EuFvsd8C,QAAA;AAC9C;EAA2B,gBAAA;AvFysd3B,EuFzsd+C,QAAA;AAC/C;EAAgC,gBAAA;AvF2sdhC,EuF3sdoD,QAAA;AACpD;EAAkC,gBAAA;AvF6sdlC,EuF7sdsD,QAAA;AACtD;EAA4B,gBAAA;AvF+sd5B,EuF/sdgD,QAAA;AAChD;EAA0B,gBAAA;AvFitd1B,EuFjtd8C,QAAA;AAC9C;EAA6B,gBAAA;AvFmtd7B,EuFntdiD,QAAA;AACjD;EAAiC,gBAAA;AvFqtdjC,EuFrtdqD,QAAA;AACrD;EAAiC,gBAAA;AvFutdjC,EuFvtdqD,QAAA;AACrD;EAA6B,gBAAA;AvFytd7B,EuFztdiD,QAAA;AACjD;EAA6B,gBAAA;AvF2td7B,EuF3tdiD,QAAA;AACjD;EAAwB,gBAAA;AvF6tdxB,EuF7td4C,QAAA;AAC5C;EAA0B,gBAAA;AvF+td1B,EuF/td8C,QAAA;AAC9C;EAA2B,gBAAA;AvFiud3B,EuFjud+C,QAAA;AAC/C;EAA2B,gBAAA;AvFmud3B,EuFnud+C,QAAA;AAC/C;EAAyB,gBAAA;AvFqudzB,EuFrud6C,QAAA;AAC7C;EAAyB,gBAAA;AvFuudzB,EuFvud6C,QAAA;AAC7C;EAAoB,gBAAA;AvFyudpB,EuFzudwC,QAAA;AACxC;EAAqB,gBAAA;AvF2udrB,EuF3udyC,QAAA;AACzC;EAAmB,gBAAA;AvF6udnB,EuF7uduC,QAAA;AACvC;EAAmB,gBAAA;AvF+udnB,EuF/uduC,QAAA;AACvC;EAAqB,gBAAA;AvFivdrB,EuFjvdyC,QAAA;AACzC;EAAkB,gBAAA;AvFmvdlB,EuFnvdsC,QAAA;AACtC;EAAoB,gBAAA;AvFqvdpB,EuFrvdwC,QAAA;AACxC;EAAsB,gBAAA;AvFuvdtB,EuFvvd0C,QAAA;AAC1C;EAAgC,gBAAA;AvFyvdhC,EuFzvdoD,QAAA;AACpD;EAAsC,gBAAA;AvF2vdtC,EuF3vd0D,QAAA;AAC1D;EAAgC,gBAAA;AvF6vdhC,EuF7vdoD,QAAA;AACpD;EAA+B,gBAAA;AvF+vd/B,EuF/vdmD,QAAA;AACnD;EAAmC,gBAAA;AvFiwdnC,EuFjwduD,QAAA;AACvD;EAA+B,gBAAA;AvFmwd/B,EuFnwdmD,QAAA;AACnD;EAAsC,gBAAA;AvFqwdtC,EuFrwd0D,QAAA;AAC1D;EAAgC,gBAAA;AvFuwdhC,EuFvwdoD,QAAA;AACpD;EAAgC,gBAAA;AvFywdhC,EuFzwdoD,QAAA;AACpD;EAA+B,gBAAA;AvF2wd/B,EuF3wdmD,QAAA;AACnD;EAAgC,gBAAA;AvF6wdhC,EuF7wdoD,QAAA;AACpD;EAA+B,gBAAA;AvF+wd/B,EuF/wdmD,QAAA;AACnD;EAAkC,gBAAA;AvFixdlC,EuFjxdsD,QAAA;AACtD;EAAkC,gBAAA;AvFmxdlC,EuFnxdsD,QAAA;AACtD;EAAgC,gBAAA;AvFqxdhC,EuFrxdoD,QAAA;AACpD;EAA+B,gBAAA;AvFuxd/B,EuFvxdmD,QAAA;AACnD;EAAmC,gBAAA;AvFyxdnC,EuFzxduD,QAAA;AACvD;EAA+B,gBAAA;AvF2xd/B,EuF3xdmD,QAAA;AACnD;EAAiC,gBAAA;AvF6xdjC,EuF7xdqD,QAAA;AACrD;EAAgC,gBAAA;AvF+xdhC,EuF/xdoD,QAAA;AACpD;EAAiC,gBAAA;AvFiydjC,EuFjydqD,QAAA;AACrD;EAAgC,gBAAA;AvFmydhC,EuFnydoD,QAAA;AACpD;EAAiC,gBAAA;AvFqydjC,EuFrydqD,QAAA;AACrD;EAAiC,gBAAA;AvFuydjC,EuFvydqD,QAAA;AACrD;EAA0B,gBAAA;AvFyyd1B,EuFzyd8C,QAAA;AAC9C;EAA4B,gBAAA;AvF2yd5B,EuF3ydgD,QAAA;AAChD;EAAiC,gBAAA;AvF6ydjC,EuF7ydqD,QAAA;AACrD;EAA4B,gBAAA;AvF+yd5B,EuF/ydgD,QAAA;AAChD;EAA2B,gBAAA;AvFizd3B,EuFjzd+C,QAAA;AAC/C;EAA+B,gBAAA;AvFmzd/B,EuFnzdmD,QAAA;AACnD;EAA2B,gBAAA;AvFqzd3B,EuFrzd+C,QAAA;AAC/C;EAAkC,gBAAA;AvFuzdlC,EuFvzdsD,QAAA;AACtD;EAA4B,gBAAA;AvFyzd5B,EuFzzdgD,QAAA;AAChD;EAA4B,gBAAA;AvF2zd5B,EuF3zdgD,QAAA;AAChD;EAA+B,gBAAA;AvF6zd/B,EuF7zdmD,QAAA;AACnD;EAA2B,gBAAA;AvF+zd3B,EuF/zd+C,QAAA;AAC/C;EAA4B,gBAAA;AvFi0d5B,EuFj0dgD,QAAA;AAChD;EAA2B,gBAAA;AvFm0d3B,EuFn0d+C,QAAA;AAC/C;EAA8B,gBAAA;AvFq0d9B,EuFr0dkD,QAAA;AAClD;EAA8B,gBAAA;AvFu0d9B,EuFv0dkD,QAAA;AAClD;EAA4B,gBAAA;AvFy0d5B,EuFz0dgD,QAAA;AAChD;EAA2B,gBAAA;AvF20d3B,EuF30d+C,QAAA;AAC/C;EAA+B,gBAAA;AvF60d/B,EuF70dmD,QAAA;AACnD;EAA2B,gBAAA;AvF+0d3B,EuF/0d+C,QAAA;AAC/C;EAA6B,gBAAA;AvFi1d7B,EuFj1diD,QAAA;AACjD;EAA4B,gBAAA;AvFm1d5B,EuFn1dgD,QAAA;AAChD;EAA6B,gBAAA;AvFq1d7B,EuFr1diD,QAAA;AACjD;EAA4B,gBAAA;AvFu1d5B,EuFv1dgD,QAAA;AAChD;EAA6B,gBAAA;AvFy1d7B,EuFz1diD,QAAA;AACjD;EAA6B,gBAAA;AvF21d7B,EuF31diD,QAAA;AACjD;EAAsB,gBAAA;AvF61dtB,EuF71d0C,QAAA;AAC1C;EAA2B,gBAAA;AvF+1d3B,EuF/1d+C,QAAA;AAC/C;EAAuB,gBAAA;AvFi2dvB,EuFj2d2C,QAAA;AAC3C;EAAgC,gBAAA;AvFm2dhC,EuFn2doD,QAAA;AACpD;EAA2B,gBAAA;AvFq2d3B,EuFr2d+C,QAAA;AAC/C;EAAsB,gBAAA;AvFu2dtB,EuFv2d0C,QAAA;AAC1C;EAAgC,gBAAA;AvFy2dhC,EuFz2doD,QAAA;AACpD;EAA2B,gBAAA;AvF22d3B,EuF32d+C,QAAA;AAC/C;EAA8B,gBAAA;AvF62d9B,EuF72dkD,QAAA;AAClD;EAA6B,gBAAA;AvF+2d7B,EuF/2diD,QAAA;AACjD;EAA6B,gBAAA;AvFi3d7B,EuFj3diD,QAAA;AACjD;EAAyB,gBAAA;AvFm3dzB,EuFn3d6C,QAAA;AAC7C;EAAuB,gBAAA;AvFq3dvB,EuFr3d2C,QAAA;AAC3C;EAA6B,gBAAA;AvFu3d7B,EuFv3diD,QAAA;AACjD;EAAuB,gBAAA;AvFy3dvB,EuFz3d2C,QAAA;AAC3C;EAA0B,gBAAA;AvF23d1B,EuF33d8C,QAAA;AAC9C;EAAuB,gBAAA;AvF63dvB,EuF73d2C,QAAA;AAC3C;EAA6B,gBAAA;AvF+3d7B,EuF/3diD,QAAA;AACjD;EAAmB,gBAAA;AvFi4dnB,EuFj4duC,QAAA;AACvC;EAAwB,gBAAA;AvFm4dxB,EuFn4d4C,QAAA;AAC5C;EAA+B,gBAAA;AvFq4d/B,EuFr4dmD,QAAA;AACnD;EAAoC,gBAAA;AvFu4dpC,EuFv4dwD,QAAA;AACxD;EAAgC,gBAAA;AvFy4dhC,EuFz4doD,QAAA;AACpD;EAA+B,gBAAA;AvF24d/B,EuF34dmD,QAAA;AACnD;EAAgC,gBAAA;AvF64dhC,EuF74doD,QAAA;AACpD;EAAiC,gBAAA;AvF+4djC,EuF/4dqD,QAAA;AACrD;EAA6B,gBAAA;AvFi5d7B,EuFj5diD,QAAA;AACjD;EAAkC,gBAAA;AvFm5dlC,EuFn5dsD,QAAA;AACtD;EAA8B,gBAAA;AvFq5d9B,EuFr5dkD,QAAA;AAClD;EAAsC,gBAAA;AvFu5dtC,EuFv5d0D,QAAA;AAC1D;EAAkC,gBAAA;AvFy5dlC,EuFz5dsD,QAAA;AACtD;EAAuB,gBAAA;AvF25dvB,EuF35d2C,QAAA;AAC3C;EAAmC,gBAAA;AvF65dnC,EuF75duD,QAAA;AACvD;EAAoC,gBAAA;AvF+5dpC,EuF/5dwD,QAAA;AACxD;EAAuB,gBAAA;AvFi6dvB,EuFj6d2C,QAAA;AAC3C;EAA4B,gBAAA;AvFm6d5B,EuFn6dgD,QAAA;AAChD;EAAwB,gBAAA;AvFq6dxB,EuFr6d4C,QAAA;AAC5C;EAAyB,gBAAA;AvFu6dzB,EuFv6d6C,QAAA;AAC7C;EAAmB,gBAAA;AvFy6dnB,EuFz6duC,QAAA;AACvC;EAAwB,gBAAA;AvF26dxB,EuF36d4C,QAAA;AAC5C;EAA2B,gBAAA;AvF66d3B,EuF76d+C,QAAA;AAC/C;EAA2B,gBAAA;AvF+6d3B,EuF/6d+C,QAAA;AAC/C;EAAuB,gBAAA;AvFi7dvB,EuFj7d2C,QAAA;AAC3C;EAAqB,gBAAA;AvFm7drB,EuFn7dyC,QAAA;AACzC;EAAgC,gBAAA;AvFq7dhC,EuFr7doD,QAAA;AACpD;EAA0B,gBAAA;AvFu7d1B,EuFv7d8C,QAAA;AAC9C;EAAgC,gBAAA;AvFy7dhC,EuFz7doD,QAAA;AACpD;EAA4B,gBAAA;AvF27d5B,EuF37dgD,QAAA;AAChD;EAAsB,gBAAA;AvF67dtB,EuF77d0C,QAAA;AAC1C;EAA0B,gBAAA;AvF+7d1B,EuF/7d8C,QAAA;AAC9C;EAAsB,gBAAA;AvFi8dtB,EuFj8d0C,QAAA;AAC1C;EAAsB,gBAAA;AvFm8dtB,EuFn8d0C,QAAA;AAC1C;EAAwB,gBAAA;AvFq8dxB,EuFr8d4C,QAAA;AAC5C;EAAoB,gBAAA;AvFu8dpB,EuFv8dwC,QAAA;AACxC;EAAwB,gBAAA;AvFy8dxB,EuFz8d4C,QAAA;AAC5C;EAAwB,gBAAA;AvF28dxB,EuF38d4C,QAAA;AAC5C;EAAuB,gBAAA;AvF68dvB,EuF78d2C,QAAA;AAC3C;EAAuB,gBAAA;AvF+8dvB,EuF/8d2C,QAAA;AAC3C;EAAyB,gBAAA;AvFi9dzB,EuFj9d6C,QAAA;AAC7C;EAAuB,gBAAA;AvFm9dvB,EuFn9d2C,QAAA;AAC3C;EAAwB,gBAAA;AvFq9dxB,EuFr9d4C,QAAA;AAC5C;EAAyB,gBAAA;AvFu9dzB,EuFv9d6C,QAAA;AAC7C;EAAwB,gBAAA;AvFy9dxB,EuFz9d4C,QAAA;AAC5C;EAAkB,gBAAA;AvF29dlB,EuF39dsC,QAAA;AACtC;EAAqC,gBAAA;AvF69drC,EuF79dyD,QAAA;AACzD;EAAmC,gBAAA;AvF+9dnC,EuF/9duD,QAAA;AACvD;EAAoC,gBAAA;AvFi+dpC,EuFj+dwD,QAAA;AACxD;EAAuB,gBAAA;AvFm+dvB,EuFn+d2C,QAAA;AAC3C;EAAyB,gBAAA;AvFq+dzB,EuFr+d6C,QAAA;AAC7C;EAA8B,gBAAA;AvFu+d9B,EuFv+dkD,QAAA;AAClD;EAA0B,gBAAA;AvFy+d1B,EuFz+d8C,QAAA;AAC9C;EAAyB,gBAAA;AvF2+dzB,EuF3+d6C,QAAA;AAC7C;EAA2B,gBAAA;AvF6+d3B,EuF7+d+C,QAAA;AAC/C;EAAuB,gBAAA;AvF++dvB,EuF/+d2C,QAAA;AAC3C;EAAoB,gBAAA;AvFi/dpB,EuFj/dwC,QAAA;AACxC;EAAsB,gBAAA;AvFm/dtB,EuFn/d0C,QAAA;AAC1C;EAAuB,gBAAA;AvFq/dvB,EuFr/d2C,QAAA;AAC3C;EAAkB,gBAAA;AvFu/dlB,EuFv/dsC,QAAA;AACtC;EAAuB,gBAAA;AvFy/dvB,EuFz/d2C,QAAA;AAC3C;EAAmB,gBAAA;AvF2/dnB,EuF3/duC,QAAA;AACvC;EAAyB,gBAAA;AvF6/dzB,EuF7/d6C,QAAA;AAC7C;EAAyB,gBAAA;AvF+/dzB,EuF//d6C,QAAA;AAC7C;EAAoB,gBAAA;AvFigepB,EuFjgewC,QAAA;AACxC;EAAoB,gBAAA;AvFmgepB,EuFngewC,QAAA;AACxC;EAAoB,gBAAA;AvFqgepB,EuFrgewC,QAAA;AACxC;EAA2B,gBAAA;AvFuge3B,EuFvge+C,QAAA;AAC/C;EAA2B,gBAAA;AvFyge3B,EuFzge+C,QAAA;AAC/C;EAA6B,gBAAA;AvF2ge7B,EuF3geiD,QAAA;AACjD;EAAgC,gBAAA;AvF6gehC,EuF7geoD,QAAA;AACpD;EAA6B,gBAAA;AvF+ge7B,EuF/geiD,QAAA;AACjD;EAAoC,gBAAA;AvFihepC,EuFjhewD,QAAA;AACxD;EAAgC,gBAAA;AvFmhehC,EuFnheoD,QAAA;AACpD;EAA4B,gBAAA;AvFqhe5B,EuFrhegD,QAAA;AAChD;EAAmC,gBAAA;AvFuhenC,EuFvheuD,QAAA;AACvD;EAA6B,gBAAA;AvFyhe7B,EuFzheiD,QAAA;AACjD;EAA4B,gBAAA;AvF2he5B,EuF3hegD,QAAA;AAChD;EAA4B,gBAAA;AvF6he5B,EuF7hegD,QAAA;AAChD;EAA6B,gBAAA;AvF+he7B,EuF/heiD,QAAA;AACjD;EAA4B,gBAAA;AvFiie5B,EuFjiegD,QAAA;AAChD;EAAgC,gBAAA;AvFmiehC,EuFnieoD,QAAA;AACpD;EAA+B,gBAAA;AvFqie/B,EuFriemD,QAAA;AACnD;EAA4B,gBAAA;AvFuie5B,EuFviegD,QAAA;AAChD;EAA8B,gBAAA;AvFyie9B,EuFziekD,QAAA;AAClD;EAA4B,gBAAA;AvF2ie5B,EuF3iegD,QAAA;AAChD;EAA6B,gBAAA;AvF6ie7B,EuF7ieiD,QAAA;AACjD;EAA8B,gBAAA;AvF+ie9B,EuF/iekD,QAAA;AAClD;EAA4B,gBAAA;AvFije5B,EuFjjegD,QAAA;AAChD;EAA6B,gBAAA;AvFmje7B,EuFnjeiD,QAAA;AACjD;EAAkC,gBAAA;AvFqjelC,EuFrjesD,QAAA;AACtD;EAA8B,gBAAA;AvFuje9B,EuFvjekD,QAAA;AAClD;EAAuB,gBAAA;AvFyjevB,EuFzje2C,QAAA;AAC3C;EAAwB,gBAAA;AvF2jexB,EuF3je4C,QAAA;AAC5C;EAA2B,gBAAA;AvF6je3B,EuF7je+C,QAAA;AAC/C;EAA0B,gBAAA;AvF+je1B,EuF/je8C,QAAA;AAC9C;EAAmB,gBAAA;AvFikenB,EuFjkeuC,QAAA;AACvC;EAA2B,gBAAA;AvFmke3B,EuFnke+C,QAAA;AAC/C;EAAuB,gBAAA;AvFqkevB,EuFrke2C,QAAA;AAC3C;EAAiC,gBAAA;AvFukejC,EuFvkeqD,QAAA;AACrD;EAAkC,gBAAA;AvFykelC,EuFzkesD,QAAA;AACtD;EAAmC,gBAAA;AvF2kenC,EuF3keuD,QAAA;AACvD;EAAsB,gBAAA;AvF6ketB,EuF7ke0C,QAAA;AAC1C;EAAmB,gBAAA;AvF+kenB,EuF/keuC,QAAA;AACvC;EAAyB,gBAAA;AvFilezB,EuFjle6C,QAAA;AAC7C;EAAgC,gBAAA;AvFmlehC,EuFnleoD,QAAA;AACpD;EAA4B,gBAAA;AvFqle5B,EuFrlegD,QAAA;AAChD;EAAiC,gBAAA;AvFulejC,EuFvleqD,QAAA;AACrD;EAA0B,gBAAA;AvFyle1B,EuFzle8C,QAAA;AAC9C;EAA2B,gBAAA;AvF2le3B,EuF3le+C,QAAA;AAC/C;EAAqB,gBAAA;AvF6lerB,EuF7leyC,QAAA;AACzC;EAA2B,gBAAA;AvF+le3B,EuF/le+C,QAAA;AAC/C;EAAgC,gBAAA;AvFimehC,EuFjmeoD,QAAA;AACpD;EAAgC,gBAAA;AvFmmehC,EuFnmeoD,QAAA;AACpD;EAAwB,gBAAA;AvFqmexB,EuFrme4C,QAAA;AAC5C;EAAkB,gBAAA;AvFumelB,EuFvmesC,QAAA;AACtC;EAAyB,gBAAA;AvFymezB,EuFzme6C,QAAA;AAC7C;EAAiC,gBAAA;AvF2mejC,EuF3meqD,QAAA;AACrD;EAAuB,gBAAA;AvF6mevB,EuF7me2C,QAAA;AAC3C;EAAyB,gBAAA;AvF+mezB,EuF/me6C,QAAA;AAC7C;EAA4B,gBAAA;AvFine5B,EuFjnegD,QAAA;AAChD;EAAwB,gBAAA;AvFmnexB,EuFnne4C,QAAA;AAC5C;EAAuB,gBAAA;AvFqnevB,EuFrne2C,QAAA;AAC3C;EAAuB,gBAAA;AvFunevB,EuFvne2C,QAAA;AAC3C;EAAuB,gBAAA;AvFynevB,EuFzne2C,QAAA;AAC3C;EAAyB,gBAAA;AvF2nezB,EuF3ne6C,QAAA;AAC7C;EAA6B,gBAAA;AvF6ne7B,EuF7neiD,QAAA;AACjD;EAAgC,gBAAA;AvF+nehC,EuF/neoD,QAAA;AACpD;EAA6B,gBAAA;AvFioe7B,EuFjoeiD,QAAA;AACjD;EAAyB,gBAAA;AvFmoezB,EuFnoe6C,QAAA;AAC7C;EAAmC,gBAAA;AvFqoenC,EuFroeuD,QAAA;AACvD;EAA4B,gBAAA;AvFuoe5B,EuFvoegD,QAAA;AAChD;EAAgC,gBAAA;AvFyoehC,EuFzoeoD,QAAA;AACpD;EAA4B,gBAAA;AvF2oe5B,EuF3oegD,QAAA;AAChD;EAA4B,gBAAA;AvF6oe5B,EuF7oegD,QAAA;AAChD;EAAmC,gBAAA;AvF+oenC,EuF/oeuD,QAAA;AACvD;EAA+B,gBAAA;AvFipe/B,EuFjpemD,QAAA;AACnD;EAAyB,gBAAA;AvFmpezB,EuFnpe6C,QAAA;AAC7C;EAA4B,gBAAA;AvFqpe5B,EuFrpegD,QAAA;AAChD;EAAiC,gBAAA;AvFupejC,EuFvpeqD,QAAA;AACrD;EAA6B,gBAAA;AvFype7B,EuFzpeiD,QAAA;AACjD;EAAkC,gBAAA;AvF2pelC,EuF3pesD,QAAA;AACtD;EAA4B,gBAAA;AvF6pe5B,EuF7pegD,QAAA;AAChD;EAA+B,gBAAA;AvF+pe/B,EuF/pemD,QAAA;AACnD;EAA2B,gBAAA;AvFiqe3B,EuFjqe+C,QAAA;AAC/C;EAA6B,gBAAA;AvFmqe7B,EuFnqeiD,QAAA;AACjD;EAAyB,gBAAA;AvFqqezB,EuFrqe6C,QAAA;AAC7C;EAA2B,gBAAA;AvFuqe3B,EuFvqe+C,QAAA;AAC/C;EAA4B,gBAAA;AvFyqe5B,EuFzqegD,QAAA;AAChD;EAAwB,gBAAA;AvF2qexB,EuF3qe4C,QAAA;AAC5C;EAAgC,gBAAA;AvF6qehC,EuF7qeoD,QAAA;AACpD;EAA4B,gBAAA;AvF+qe5B,EuF/qegD,QAAA;AAChD;EAA4B,gBAAA;AvFire5B,EuFjregD,QAAA;AAChD;EAA8B,gBAAA;AvFmre9B,EuFnrekD,QAAA;AAClD;EAA6B,gBAAA;AvFqre7B,EuFrreiD,QAAA;AACjD;EAA8B,gBAAA;AvFure9B,EuFvrekD,QAAA;AAClD;EAAyB,gBAAA;AvFyrezB,EuFzre6C,QAAA;AAC7C;EAA6B,gBAAA;AvF2re7B,EuF3reiD,QAAA;AACjD;EAAyB,gBAAA;AvF6rezB,EuF7re6C,QAAA;AAC7C;EAA8B,gBAAA;AvF+re9B,EuF/rekD,QAAA;AAClD;EAA0B,gBAAA;AvFise1B,EuFjse8C,QAAA;AAC9C;EAAmB,gBAAA;AvFmsenB,EuFnseuC,QAAA;AACvC;EAAmC,gBAAA;AvFqsenC,EuFrseuD,QAAA;AACvD;EAA+B,gBAAA;AvFuse/B,EuFvsemD,QAAA;AACnD;EAAmB,gBAAA;AvFysenB,EuFzseuC,QAAA;AACvC;EAA2B,gBAAA;AvF2se3B,EuF3se+C,QAAA;AAC/C;EAAqB,gBAAA;AvF6serB,EuF7seyC,QAAA;AACzC;EAA2B,gBAAA;AvF+se3B,EuF/se+C,QAAA;AAC/C;EAAoB,gBAAA;AvFitepB,EuFjtewC,QAAA;AACxC;EAAyB,gBAAA;AvFmtezB,EuFnte6C,QAAA;AAC7C;EAAqB,gBAAA;AvFqterB,EuFrteyC,QAAA;AACzC;EAAyB,gBAAA;AvFutezB,EuFvte6C,QAAA;AAC7C;EAAqB,gBAAA;AvFyterB,EuFzteyC,QAAA;AACzC;EAAqB,gBAAA;AvF2terB,EuF3teyC,QAAA;AACzC;EAAwB,gBAAA;AvF6texB,EuF7te4C,QAAA;AAC5C;EAA2B,gBAAA;AvF+te3B,EuF/te+C,QAAA;AAC/C;EAAoB,gBAAA;AvFiuepB,EuFjuewC,QAAA;AACxC;EAA2B,gBAAA;AvFmue3B,EuFnue+C,QAAA;AAC/C;EAA8B,gBAAA;AvFque9B,EuFruekD,QAAA;AAClD;EAAiC,gBAAA;AvFuuejC,EuFvueqD,QAAA;AACrD;EAA2B,gBAAA;AvFyue3B,EuFzue+C,QAAA;AAC/C;EAA0B,gBAAA;AvF2ue1B,EuF3ue8C,QAAA;AAC9C;EAA0B,gBAAA;AvF6ue1B,EuF7ue8C,QAAA;AAC9C;EAA6B,gBAAA;AvF+ue7B,EuF/ueiD,QAAA;AACjD;EAA2B,gBAAA;AvFive3B,EuFjve+C,QAAA;AAC/C;EAA6B,gBAAA;AvFmve7B,EuFnveiD,QAAA;AACjD;EAA0B,gBAAA;AvFqve1B,EuFrve8C,QAAA;AAC9C;EAA8B,gBAAA;AvFuve9B,EuFvvekD,QAAA;AAClD;EAA2B,gBAAA;AvFyve3B,EuFzve+C,QAAA;AAC/C;EAA2B,gBAAA;AvF2ve3B,EuF3ve+C,QAAA;AAC/C;EAA4B,gBAAA;AvF6ve5B,EuF7vegD,QAAA;AAChD;EAAqB,gBAAA;AvF+verB,EuF/veyC,QAAA;AACzC;EAAmB,gBAAA;AvFiwenB,EuFjweuC,QAAA;AACvC;EAAgC,gBAAA;AvFmwehC,EuFnweoD,QAAA;AACpD;EAA4B,gBAAA;AvFqwe5B,EuFrwegD,QAAA;AAChD;EAAuB,gBAAA;AvFuwevB,EuFvwe2C,QAAA;AAC3C;EAAsC,gBAAA;AvFywetC,EuFzwe0D,QAAA;AAC1D;EAA4B,gBAAA;AvF2we5B,EuF3wegD,QAAA;AAChD;EAAsB,gBAAA;AvF6wetB,EuF7we0C,QAAA;AAC1C;EAAoB,gBAAA;AvF+wepB,EuF/wewC,QAAA;AACxC;EAA6B,gBAAA;AvFixe7B,EuFjxeiD,QAAA;AACjD;EAAmB,gBAAA;AvFmxenB,EuFnxeuC,QAAA;AACvC;EAAmB,gBAAA;AvFqxenB,EuFrxeuC,QAAA;AACvC;EAAyB,gBAAA;AvFuxezB,EuFvxe6C,QAAA;AAC7C;EAAqB,gBAAA;AvFyxerB,EuFzxeyC,QAAA;AACzC;EAAsC,gBAAA;AvF2xetC,EuF3xe0D,QAAA;AAC1D;EAAgC,gBAAA;AvF6xehC,EuF7xeoD,QAAA;AACpD;EAA4B,gBAAA;AvF+xe5B,EuF/xegD,QAAA;AAChD;EAAwB,gBAAA;AvFiyexB,EuFjye4C,QAAA;AAC5C;EAAoB,gBAAA;AvFmyepB,EuFnyewC,QAAA;AACxC;EAAoB,gBAAA;AvFqyepB,EuFryewC,QAAA;AACxC;EAAmB,gBAAA;AvFuyenB,EuFvyeuC,QAAA;AACvC;EAA+B,gBAAA;AvFyye/B,EuFzyemD,QAAA;AACnD;EAA2B,gBAAA;AvF2ye3B,EuF3ye+C,QAAA;AAC/C;EAA8B,gBAAA;AvF6ye9B,EuF7yekD,QAAA;AAClD;EAA0B,gBAAA;AvF+ye1B,EuF/ye8C,QAAA;AAC9C;EAAqB,gBAAA;AvFizerB,EuFjzeyC,QAAA;AACzC;EAA6B,gBAAA;AvFmze7B,EuFnzeiD,QAAA;AACjD;EAAwB,gBAAA;AvFqzexB,EuFrze4C,QAAA;AAC5C;EAAmB,gBAAA;AvFuzenB,EuFvzeuC,QAAA;AACvC;EAAoB,gBAAA;AvFyzepB,EuFzzewC,QAAA;AACxC;EAAmC,gBAAA;AvF2zenC,EuF3zeuD,QAAA;AACvD;EAA+B,gBAAA;AvF6ze/B,EuF7zemD,QAAA;AACnD;EAAmB,gBAAA;AvF+zenB,EuF/zeuC,QAAA;AACvC;EAAmC,gBAAA;AvFi0enC,EuFj0euD,QAAA;AACvD;EAAkB,gBAAA;AvFm0elB,EuFn0esC,QAAA;AACtC;EAA6B,gBAAA;AvFq0e7B,EuFr0eiD,QAAA;AACjD;EAAyB,gBAAA;AvFu0ezB,EuFv0e6C,QAAA;AAC7C;EAAwB,gBAAA;AvFy0exB,EuFz0e4C,QAAA;AAC5C;EAA4B,gBAAA;AvF20e5B,EuF30egD,QAAA;AAChD;EAAyB,gBAAA;AvF60ezB,EuF70e6C,QAAA;AAC7C;EAAyB,gBAAA;AvF+0ezB,EuF/0e6C,QAAA;AAC7C;EAAoB,gBAAA;AvFi1epB,EuFj1ewC,QAAA;AACxC;EAAwB,gBAAA;AvFm1exB,EuFn1e4C,QAAA;AAC5C;EAA0B,gBAAA;AvFq1e1B,EuFr1e8C,QAAA;AAC9C;EAAsB,gBAAA;AvFu1etB,EuFv1e0C,QAAA;AAC1C;EAAuB,gBAAA;AvFy1evB,EuFz1e2C,QAAA;AAC3C;EAAmB,gBAAA;AvF21enB,EuF31euC,QAAA;AACvC;EAAsC,gBAAA;AvF61etC,EuF71e0D,QAAA;AAC1D;EAAoC,gBAAA;AvF+1epC,EuF/1ewD,QAAA;AACxD;EAAqC,gBAAA;AvFi2erC,EuFj2eyD,QAAA;AACzD;EAA6C,gBAAA;AvFm2e7C,EuFn2eiE,QAAA;AACjE;EAA2C,gBAAA;AvFq2e3C,EuFr2e+D,QAAA;AAC/D;EAA4C,gBAAA;AvFu2e5C,EuFv2egE,QAAA;AAChE;EAAsB,gBAAA;AvFy2etB,EuFz2e0C,QAAA;AAC1C;EAA8B,gBAAA;AvF22e9B,EuF32ekD,QAAA;AAClD;EAA0B,gBAAA;AvF62e1B,EuF72e8C,QAAA;AAC9C;EAA2B,gBAAA;AvF+2e3B,EuF/2e+C,QAAA;AAC/C;EAA0B,gBAAA;AvFi3e1B,EuFj3e8C,QAAA;AAC9C;EAA6B,gBAAA;AvFm3e7B,EuFn3eiD,QAAA;AACjD;EAAyB,gBAAA;AvFq3ezB,EuFr3e6C,QAAA;AAC7C;EAAyB,gBAAA;AvFu3ezB,EuFv3e6C,QAAA;AAC7C;EAA0B,gBAAA;AvFy3e1B,EuFz3e8C,QAAA;AAC9C;EAAyB,gBAAA;AvF23ezB,EuF33e6C,QAAA;AAC7C;EAA6B,gBAAA;AvF63e7B,EuF73eiD,QAAA;AACjD;EAAyB,gBAAA;AvF+3ezB,EuF/3e6C,QAAA;AAC7C;EAAqC,gBAAA;AvFi4erC,EuFj4eyD,QAAA;AACzD;EAAkC,gBAAA;AvFm4elC,EuFn4esD,QAAA;AACtD;EAA2B,gBAAA;AvFq4e3B,EuFr4e+C,QAAA;AAC/C;EAA0B,gBAAA;AvFu4e1B,EuFv4e8C,QAAA;AAC9C;EAA2B,gBAAA;AvFy4e3B,EuFz4e+C,QAAA;AAC/C;EAA0B,gBAAA;AvF24e1B,EuF34e8C,QAAA;AAC9C;EAA0B,gBAAA;AvF64e1B,EuF74e8C,QAAA;AAC9C;EAA2B,gBAAA;AvF+4e3B,EuF/4e+C,QAAA;AAC/C;EAAsB,gBAAA;AvFi5etB,EuFj5e0C,QAAA;AAC1C;EAAoB,gBAAA;AvFm5epB,EuFn5ewC,QAAA;AACxC;EAAqB,gBAAA;AvFq5erB,EuFr5eyC,QAAA;AACzC;EAA4B,gBAAA;AvFu5e5B,EuFv5egD,QAAA;AAChD;EAA0B,gBAAA;AvFy5e1B,EuFz5e8C,QAAA;AAC9C;EAA4B,gBAAA;AvF25e5B,EuF35egD,QAAA;AAChD;EAAwB,gBAAA;AvF65exB,EuF75e4C,QAAA;AAC5C;EAAuB,gBAAA;AvF+5evB,EuF/5e2C,QAAA;AAC3C;EAAsB,gBAAA;AvFi6etB,EuFj6e0C,QAAA;AAC1C;EAAqB,gBAAA;AvFm6erB,EuFn6eyC,QAAA;AACzC;EAAyB,gBAAA;AvFq6ezB,EuFr6e6C,QAAA;AAC7C;EAA0B,gBAAA;AvFu6e1B,EuFv6e8C,QAAA;AAC9C;EAAoB,gBAAA;AvFy6epB,EuFz6ewC,QAAA;AACxC;EAA+B,gBAAA;AvF26e/B,EuF36emD,QAAA;AACnD;EAA2B,gBAAA;AvF66e3B,EuF76e+C,QAAA;AAC/C;EAA2B,gBAAA;AvF+6e3B,EuF/6e+C,QAAA;AAC/C;EAA4B,gBAAA;AvFi7e5B,EuFj7egD,QAAA;AAChD;EAA4B,gBAAA;AvFm7e5B,EuFn7egD,QAAA;AAChD;EAAuB,gBAAA;AvFq7evB,EuFr7e2C,QAAA;AAC3C;EAA6B,gBAAA;AvFu7e7B,EuFv7eiD,QAAA;AACjD;EAAkC,gBAAA;AvFy7elC,EuFz7esD,QAAA;AACtD;EAA6B,gBAAA;AvF27e7B,EuF37eiD,QAAA;AACjD;EAAkB,gBAAA;AvF67elB,EuF77esC,QAAA;AACtC;EAAwB,gBAAA;AvF+7exB,EuF/7e4C,QAAA;AAC5C;EAAoB,gBAAA;AvFi8epB,EuFj8ewC,QAAA;AACxC;EAAmB,gBAAA;AvFm8enB,EuFn8euC,QAAA;AACvC;EAA2B,gBAAA;AvFq8e3B,EuFr8e+C,QAAA;AAC/C;EAAqB,gBAAA;AvFu8erB,EuFv8eyC,QAAA;AACzC;EAAuB,gBAAA;AvFy8evB,EuFz8e2C,QAAA;AAC3C;EAAgC,gBAAA;AvF28ehC,EuF38eoD,QAAA;AACpD;EAA0B,gBAAA;AvF68e1B,EuF78e8C,QAAA;AAC9C;EAAyB,gBAAA;AvF+8ezB,EuF/8e6C,QAAA;AAC7C;EAA2B,gBAAA;AvFi9e3B,EuFj9e+C,QAAA;AAC/C;EAAqB,gBAAA;AvFm9erB,EuFn9eyC,QAAA;AACzC;EAAmC,gBAAA;AvFq9enC,EuFr9euD,QAAA;AACvD;EAAiC,gBAAA;AvFu9ejC,EuFv9eqD,QAAA;AACrD;EAA8B,gBAAA;AvFy9e9B,EuFz9ekD,QAAA;AAClD;EAA0B,gBAAA;AvF29e1B,EuF39e8C,QAAA;AAC9C;EAA2C,gBAAA;AvF69e3C,EuF79e+D,QAAA;AAC/D;EAAwB,gBAAA;AvF+9exB,EuF/9e4C,QAAA;AAC5C;EAA4B,gBAAA;AvFi+e5B,EuFj+egD,QAAA;AAChD;EAAwB,gBAAA;AvFm+exB,EuFn+e4C,QAAA;AAC5C;EAAuB,gBAAA;AvFq+evB,EuFr+e2C,QAAA;AAC3C;EAA2B,gBAAA;AvFu+e3B,EuFv+e+C,QAAA;AAC/C;EAAmB,gBAAA;AvFy+enB,EuFz+euC,QAAA;AACvC;EAAuB,gBAAA;AvF2+evB,EuF3+e2C,QAAA;AAC3C;EAA0B,gBAAA;AvF6+e1B,EuF7+e8C,QAAA;AAC9C;EAAqB,gBAAA;AvF++erB,EuF/+eyC,QAAA;AACzC;EAAmB,gBAAA;AvFi/enB,EuFj/euC,QAAA;AACvC;EAA2B,gBAAA;AvFm/e3B,EuFn/e+C,QAAA;AAC/C;EAAuB,gBAAA;AvFq/evB,EuFr/e2C,QAAA;AAC3C;EAA0B,gBAAA;AvFu/e1B,EuFv/e8C,QAAA;AAC9C;EAAsB,gBAAA;AvFy/etB,EuFz/e0C,QAAA;AAC1C;EAAiC,gBAAA;AvF2/ejC,EuF3/eqD,QAAA;AACrD;EAA6B,gBAAA;AvF6/e7B,EuF7/eiD,QAAA;AACjD;EAA+B,gBAAA;AvF+/e/B,EuF//emD,QAAA;AACnD;EAA6B,gBAAA;AvFigf7B,EuFjgfiD,QAAA;AACjD;EAAuB,gBAAA;AvFmgfvB,EuFngf2C,QAAA;AAC3C;EAA0B,gBAAA;AvFqgf1B,EuFrgf8C,QAAA;AAC9C;EAAuB,gBAAA;AvFugfvB,EuFvgf2C,QAAA;AAC3C;EAA4B,gBAAA;AvFygf5B,EuFzgfgD,QAAA;AAChD;EAAyB,gBAAA;AvF2gfzB,EuF3gf6C,QAAA;AAC7C;EAAmB,gBAAA;AvF6gfnB,EuF7gfuC,QAAA;AACvC;EAA0B,gBAAA;AvF+gf1B,EuF/gf8C,QAAA;AAC9C;EAAsB,gBAAA;AvFihftB,EuFjhf0C,QAAA;AAC1C;EAA6B,gBAAA;AvFmhf7B,EuFnhfiD,QAAA;AACjD;EAA8B,gBAAA;AvFqhf9B,EuFrhfkD,QAAA;AAClD;EAA8B,gBAAA;AvFuhf9B,EuFvhfkD,QAAA;AAClD;EAA+B,gBAAA;AvFyhf/B,EuFzhfmD,QAAA;AACnD;EAA8B,gBAAA;AvF2hf9B,EuF3hfkD,QAAA;AAClD;EAAkC,gBAAA;AvF6hflC,EuF7hfsD,QAAA;AACtD;EAAgC,gBAAA;AvF+hfhC,EuF/hfoD,QAAA;AACpD;EAA+B,gBAAA;AvFiif/B,EuFjifmD,QAAA;AACnD;EAAyB,gBAAA;AvFmifzB,EuFnif6C,QAAA;AAC7C;EAA0B,gBAAA;AvFqif1B,EuFrif8C,QAAA;AAC9C;EAAsB,gBAAA;AvFuiftB,EuFvif0C,QAAA;AAC1C;EAAkB,gBAAA;AvFyiflB,EuFzifsC,QAAA;AACtC;EAAmB,gBAAA;AvF2ifnB,EuF3ifuC,QAAA;AACvC;EAA4B,gBAAA;AvF6if5B,EuF7ifgD,QAAA;AAChD;EAAoB,gBAAA;AvF+ifpB,EuF/ifwC,QAAA;AACxC;EAA2B,gBAAA;AvFijf3B,EuFjjf+C,QAAA;AAC/C;EAAkC,gBAAA;AvFmjflC,EuFnjfsD,QAAA;AACtD;EAA6B,gBAAA;AvFqjf7B,EuFrjfiD,QAAA;AACjD;EAAsB,gBAAA;AvFujftB,EuFvjf0C,QAAA;AAC1C;EAAuB,gBAAA;AvFyjfvB,EuFzjf2C,QAAA;AAC3C;EAAqB,gBAAA;AvF2jfrB,EuF3jfyC,QAAA;AACzC;EAA4B,gBAAA;AvF6jf5B,EuF7jfgD,QAAA;AAChD;EAAsB,gBAAA;AvF+jftB,EuF/jf0C,QAAA;AAC1C;EAA6B,gBAAA;AvFikf7B,EuFjkfiD,QAAA;AACjD;EAAkB,gBAAA;AvFmkflB,EuFnkfsC,QAAA;AACtC;EAAsB,gBAAA;AvFqkftB,EuFrkf0C,QAAA;AAC1C;EAA+B,gBAAA;AvFukf/B,EuFvkfmD,QAAA;AACnD;EAAyB,gBAAA;AvFykfzB,EuFzkf6C,QAAA;AAC7C;EAA2B,gBAAA;AvF2kf3B,EuF3kf+C,QAAA;AAC/C;EAAyB,gBAAA;AvF6kfzB,EuF7kf6C,QAAA;AAC7C;EAAgC,gBAAA;AvF+kfhC,EuF/kfoD,QAAA;AACpD;EAA2B,gBAAA;AvFilf3B,EuFjlf+C,QAAA;AAC/C;EAAoB,gBAAA;AvFmlfpB,EuFnlfwC,QAAA;AACxC;EAA0B,gBAAA;AvFqlf1B,EuFrlf8C,QAAA;AAC9C;EAA+B,gBAAA;AvFulf/B,EuFvlfmD,QAAA;AACnD;EAAiC,gBAAA;AvFylfjC,EuFzlfqD,QAAA;AACrD;EAA6B,gBAAA;AvF2lf7B,EuF3lfiD,QAAA;AACjD;EAA6B,gBAAA;AvF6lf7B,EuF7lfiD,QAAA;AACjD;EAAoB,gBAAA;AvF+lfpB,EuF/lfwC,QAAA;AACxC;EAA+B,gBAAA;AvFimf/B,EuFjmfmD,QAAA;AACnD;EAAyB,gBAAA;AvFmmfzB,EuFnmf6C,QAAA;AAC7C;EAA2B,gBAAA;AvFqmf3B,EuFrmf+C,QAAA;AAC/C;EAA0B,gBAAA;AvFumf1B,EuFvmf8C,QAAA;AAC9C;EAA6B,gBAAA;AvFymf7B,EuFzmfiD,QAAA;AACjD;EAA+B,gBAAA;AvF2mf/B,EuF3mfmD,QAAA;AACnD;EAA2B,gBAAA;AvF6mf3B,EuF7mf+C,QAAA;AAC/C;EAAuB,gBAAA;AvF+mfvB,EuF/mf2C,QAAA;AAC3C;EAAiC,gBAAA;AvFinfjC,EuFjnfqD,QAAA;AACrD;EAAsB,gBAAA;AvFmnftB,EuFnnf0C,QAAA;AAC1C;EAA2B,gBAAA;AvFqnf3B,EuFrnf+C,QAAA;AAC/C;EAAmB,gBAAA;AvFunfnB,EuFvnfuC,QAAA;AACvC;EAAsB,gBAAA;AvFynftB,EuFznf0C,QAAA;AAC1C;EAA4B,gBAAA;AvF2nf5B,EuF3nfgD,QAAA;AAChD;EAAwB,gBAAA;AvF6nfxB,EuF7nf4C,QAAA;AAC5C;EAAwB,gBAAA;AvF+nfxB,EuF/nf4C,QAAA;AAC5C;EAAoB,gBAAA;AvFiofpB,EuFjofwC,QAAA;AACxC;EAAuB,gBAAA;AvFmofvB,EuFnof2C,QAAA;AAC3C;EAAyB,gBAAA;AvFqofzB,EuFrof6C,QAAA;AAC7C;EAA+B,gBAAA;AvFuof/B,EuFvofmD,QAAA;AACnD;EAAoB,gBAAA;AvFyofpB,EuFzofwC,QAAA;AACxC;EAAkB,gBAAA;AvF2oflB,EuF3ofsC,QAAA;AACtC;EAAwB,gBAAA;AvF6ofxB,EuF7of4C,QAAA;AAC5C;EAAmB,gBAAA;AvF+ofnB,EuF/ofuC,QAAA;AACvC;EAAwB,gBAAA;AvFipfxB,EuFjpf4C,QAAA;AAC5C;EAAoB,gBAAA;AvFmpfpB,EuFnpfwC,QAAA;AACxC;EAAuB,gBAAA;AvFqpfvB,EuFrpf2C,QAAA;AAC3C;EAAwB,gBAAA;AvFupfxB,EuFvpf4C,QAAA;AAC5C;EAAoB,gBAAA;AvFypfpB,EuFzpfwC,QAAA;AACxC;EAA2B,gBAAA;AvF2pf3B,EuF3pf+C,QAAA;AAC/C;EAA6B,gBAAA;AvF6pf7B,EuF7pfiD,QAAA;AACjD;EAAsB,gBAAA;AvF+pftB,EuF/pf0C,QAAA;AAC1C;EAA4B,gBAAA;AvFiqf5B,EuFjqfgD,QAAA;AAChD;EAAsB,gBAAA;AvFmqftB,EuFnqf0C,QAAA;AAC1C;EAAsB,gBAAA;AvFqqftB,EuFrqf0C,QAAA;AAC1C;EAAyB,gBAAA;AvFuqfzB,EuFvqf6C,QAAA;AAC7C;EAAsB,gBAAA;AvFyqftB,EuFzqf0C,QAAA;AAC1C;EAA6B,gBAAA;AvF2qf7B,EuF3qfiD,QAAA;AACjD;EAAyB,gBAAA;AvF6qfzB,EuF7qf6C,QAAA;AAC7C;EAAyB,gBAAA;AvF+qfzB,EuF/qf6C,QAAA;AAC7C;EAAwB,gBAAA;AvFirfxB,EuFjrf4C,QAAA;AAC5C;EAAwB,gBAAA;AvFmrfxB,EuFnrf4C,QAAA;AAC5C;EAAqB,gBAAA;AvFqrfrB,EuFrrfyC,QAAA;AACzC;EAA6B,gBAAA;AvFurf7B,EuFvrfiD,QAAA;AACjD;EAA+B,gBAAA;AvFyrf/B,EuFzrfmD,QAAA;AACnD;EAAyB,gBAAA;AvF2rfzB,EuF3rf6C,QAAA;AAC7C;EAA2B,gBAAA;AvF6rf3B,EuF7rf+C,QAAA;AAC/C;EAAoB,gBAAA;AvF+rfpB,EuF/rfwC,QAAA;AACxC;EAAqB,gBAAA;AvFisfrB,EuFjsfyC,QAAA;AACzC;EAAkB,gBAAA;AvFmsflB,EuFnsfsC,QAAA;AACtC;EAAuB,gBAAA;AvFqsfvB,EuFrsf2C,QAAA;AAC3C;EAAwB,gBAAA;AvFusfxB,EuFvsf4C,QAAA;AAC5C;EAA0B,gBAAA;AvFysf1B,EuFzsf8C,QAAA;AAC9C;EAA0B,gBAAA;AvF2sf1B,EuF3sf8C,QAAA;AAC9C;EAA0B,gBAAA;AvF6sf1B,EuF7sf8C,QAAA;AAC9C;EAA2B,gBAAA;AvF+sf3B,EuF/sf+C,QAAA;AAC/C;EAAoB,gBAAA;AvFitfpB,EuFjtfwC,QAAA;AACxC;EAAsB,gBAAA;AvFmtftB,EuFntf0C,QAAA;AAC1C;EAA4B,gBAAA;AvFqtf5B,EuFrtfgD,QAAA;AAChD;EAA8B,gBAAA;AvFutf9B,EuFvtfkD,QAAA;AAClD;EAAwB,gBAAA;AvFytfxB,EuFztf4C,QAAA;AAC5C;EAAoB,gBAAA;AvF2tfpB,EuF3tfwC,QAAA;AACxC;EAA0B,gBAAA;AvF6tf1B,EuF7tf8C,QAAA;AAC9C;EAAmB,gBAAA;AvF+tfnB,EuF/tfuC,QAAA;AACvC;EAAmB,gBAAA;AvFiufnB,EuFjufuC,QAAA;AACvC;EAA0B,gBAAA;AvFmuf1B,EuFnuf8C,QAAA;AAC9C;EAA0B,gBAAA;AvFquf1B,EuFruf8C,QAAA;AAC9C;EAAmB,gBAAA;AvFuufnB,EuFvufuC,QAAA;AACvC;EAAqB,gBAAA;AvFyufrB,EuFzufyC,QAAA;AACzC;EAAsB,gBAAA;AvF2uftB,EuF3uf0C,QAAA;AAC1C;EAAyB,gBAAA;AvF6ufzB,EuF7uf6C,QAAA;AAC7C;EAAuB,gBAAA;AvF+ufvB,EuF/uf2C,QAAA;AAC3C;EAA2B,gBAAA;AvFivf3B,EuFjvf+C,QAAA;AAC/C;EAAoB,gBAAA;AvFmvfpB,EuFnvfwC,QAAA;AACxC;EAAoB,gBAAA;AvFqvfpB,EuFrvfwC,QAAA;AACxC;EAAkC,gBAAA;AvFuvflC,EuFvvfsD,QAAA;AACtD;EAAiC,gBAAA;AvFyvfjC,EuFzvfqD,QAAA;AACrD;EAAgC,gBAAA;AvF2vfhC,EuF3vfoD,QAAA;AACpD;EAAgC,gBAAA;AvF6vfhC,EuF7vfoD,QAAA;AACpD;EAAqC,gBAAA;AvF+vfrC,EuF/vfyD,QAAA;AACzD;EAAiC,gBAAA;AvFiwfjC,EuFjwfqD,QAAA;AACrD;EAAgC,gBAAA;AvFmwfhC,EuFnwfoD,QAAA;AACpD;EAAgC,gBAAA;AvFqwfhC,EuFrwfoD,QAAA;AACpD;EAAiC,gBAAA;AvFuwfjC,EuFvwfqD,QAAA;AACrD;EAA2B,gBAAA;AvFywf3B,EuFzwf+C,QAAA;AAC/C;EAAuB,gBAAA;AvF2wfvB,EuF3wf2C,QAAA;AAC3C;EAA2B,gBAAA;AvF6wf3B,EuF7wf+C,QAAA;AAC/C;EAA0B,gBAAA;AvF+wf1B,EuF/wf8C,QAAA;AAC9C;EAAoB,gBAAA;AvFixfpB,EuFjxfwC,QAAA;AACxC;EAAwB,gBAAA;AvFmxfxB,EuFnxf4C,QAAA;AAC5C;EAAmB,gBAAA;AvFqxfnB,EuFrxfuC,QAAA;AACvC;EAA2B,gBAAA;AvFuxf3B,EuFvxf+C,QAAA;AAC/C;EAA8B,gBAAA;AvFyxf9B,EuFzxfkD,QAAA;AAClD;EAA+B,gBAAA;AvF2xf/B,EuF3xfmD,QAAA;AACnD;EAAsB,gBAAA;AvF6xftB,EuF7xf0C,QAAA;AAC1C;EAA4B,gBAAA;AvF+xf5B,EuF/xfgD,QAAA;AAChD;EAAwB,gBAAA;AvFiyfxB,EuFjyf4C,QAAA;AAC5C;EAA0B,gBAAA;AvFmyf1B,EuFnyf8C,QAAA;AAC9C;EAAsB,gBAAA;AvFqyftB,EuFryf0C,QAAA;AAC1C;EAA2B,gBAAA;AvFuyf3B,EuFvyf+C,QAAA;AAC/C;EAAmB,gBAAA;AvFyyfnB,EuFzyfuC,QAAA;AACvC;EAAsB,gBAAA;AvF2yftB,EuF3yf0C,QAAA;AAC1C;EAAyB,gBAAA;AvF6yfzB,EuF7yf6C,QAAA;AAC7C;EAAqB,gBAAA;AvF+yfrB,EuF/yfyC,QAAA;AACzC;EAAyB,gBAAA;AvFizfzB,EuFjzf6C,QAAA;AAC7C;EAA+B,gBAAA;AvFmzf/B,EuFnzfmD,QAAA;AACnD;EAA2C,gBAAA;AvFqzf3C,EuFrzf+D,QAAA;AAC/D;EAAoB,gBAAA;AvFuzfpB,EuFvzfwC,QAAA;AACxC;EAAuB,gBAAA;AvFyzfvB,EuFzzf2C,QAAA;AAC3C;EAAyB,gBAAA;AvF2zfzB,EuF3zf6C,QAAA;AAC7C;EAAsB,gBAAA;AvF6zftB,EuF7zf0C,QAAA;AAC1C;EAA4B,gBAAA;AvF+zf5B,EuF/zfgD,QAAA;AAChD;EAAkB,gBAAA;AvFi0flB,EuFj0fsC,QAAA;AACtC;EAA6B,gBAAA;AvFm0f7B,EuFn0fiD,QAAA;AACjD;EAAoB,gBAAA;AvFq0fpB,EuFr0fwC,QAAA;AACxC;EAAsB,gBAAA;AvFu0ftB,EuFv0f0C,QAAA;AAC1C;EAAyB,gBAAA;AvFy0fzB,EuFz0f6C,QAAA;AAC7C;EAAwB,gBAAA;AvF20fxB,EuF30f4C,QAAA;AAC5C;EAAyB,gBAAA;AvF60fzB,EuF70f6C,QAAA;AAC7C;EAAkB,gBAAA;AvF+0flB,EuF/0fsC,QAAA;AACtC;EAA2B,gBAAA;AvFi1f3B,EuFj1f+C,QAAA;AAC/C;EAA4B,gBAAA;AvFm1f5B,EuFn1fgD,QAAA;AAChD;EAAsB,gBAAA;AvFq1ftB,EuFr1f0C,QAAA;AAC1C;EAAuB,gBAAA;AvFu1fvB,EuFv1f2C,QAAA;AAC3C;EAAsB,gBAAA;AvFy1ftB,EuFz1f0C,QAAA;AAC1C;EAAoB,gBAAA;AvF21fpB,EuF31fwC,QAAA;AACxC;EAAuB,gBAAA;AvF61fvB,EuF71f2C,QAAA;AAC3C;EAAqB,gBAAA;AvF+1frB,EuF/1fyC,QAAA;AACzC;EAAyB,gBAAA;AvFi2fzB,EuFj2f6C,QAAA;AAC7C;EAA2B,gBAAA;AvFm2f3B,EuFn2f+C,QAAA;AAC/C;EAA0B,gBAAA;AvFq2f1B,EuFr2f8C,QAAA;AAC9C;EAAqB,gBAAA;AvFu2frB,EuFv2fyC,QAAA;AACzC;EAAqB,gBAAA;AvFy2frB,EuFz2fyC,QAAA;AACzC;EAAyB,gBAAA;AvF22fzB,EuF32f6C,QAAA;AAC7C;EAAgC,gBAAA;AvF62fhC,EuF72foD,QAAA;AACpD;EAAiC,gBAAA;AvF+2fjC,EuF/2fqD,QAAA;AACrD;EAA6B,gBAAA;AvFi3f7B,EuFj3fiD,QAAA;AACjD;EAAqB,gBAAA;AvFm3frB,EuFn3fyC,QAAA;AACzC;EAAsB,gBAAA;AvFq3ftB,EuFr3f0C,QAAA;AAC1C;EAA0B,gBAAA;AvFu3f1B,EuFv3f8C,QAAA;AAC9C;EAAwB,gBAAA;AvFy3fxB,EuFz3f4C,QAAA;AAC5C;EAA2B,gBAAA;AvF23f3B,EuF33f+C,QAAA;AAC/C;EAAiC,gBAAA;AvF63fjC,EuF73fqD,QAAA;AACrD;EAA8B,gBAAA;AvF+3f9B,EuF/3fkD,QAAA;AAClD;EAA2B,gBAAA;AvFi4f3B,EuFj4f+C,QAAA;AAC/C;EAAqB,gBAAA;AvFm4frB,EuFn4fyC,QAAA;AACzC;EAAmB,gBAAA;AvFq4fnB,EuFr4fuC,QAAA;AACvC;EAAmB,gBAAA;AvFu4fnB,EuFv4fuC,QAAA;AACvC;EAA8B,gBAAA;AvFy4f9B,EuFz4fkD,QAAA;AAClD;EAAgC,gBAAA;AvF24fhC,EuF34foD,QAAA;AACpD;EAA+B,gBAAA;AvF64f/B,EuF74fmD,QAAA;AACnD;EAAqB,gBAAA;AvF+4frB,EuF/4fyC,QAAA;AACzC;EAAqB,gBAAA;AvFi5frB,EuFj5fyC,QAAA;AACzC;EAAsB,gBAAA;AvFm5ftB,EuFn5f0C,QAAA;AAC1C;EAA0B,gBAAA;AvFq5f1B,EuFr5f8C,QAAA;AAC9C;EAAsB,gBAAA;AvFu5ftB,EuFv5f0C,QAAA;AAC1C;EAAmB,gBAAA;AvFy5fnB,EuFz5fuC,QAAA;AACvC;EAAoB,gBAAA;AvF25fpB,EuF35fwC,QAAA;AACxC;EAAuB,gBAAA;AvF65fvB,EuF75f2C,QAAA;AAC3C;EAA0B,gBAAA;AvF+5f1B,EuF/5f8C,QAAA;AAC9C;EAAwB,gBAAA;AvFi6fxB,EuFj6f4C,QAAA;AAC5C;EAA2B,gBAAA;AvFm6f3B,EuFn6f+C,QAAA;AAC/C;EAAyB,gBAAA;AvFq6fzB,EuFr6f6C,QAAA;AAC7C;EAA2B,gBAAA;AvFu6f3B,EuFv6f+C,QAAA;AAC/C;EAAyB,gBAAA;AvFy6fzB,EuFz6f6C,QAAA;AAC7C;EAAqB,gBAAA;AvF26frB,EuF36fyC,QAAA;AACzC;EAAsB,gBAAA;AvF66ftB,EuF76f0C,QAAA;AAC1C;EAA4B,gBAAA;AvF+6f5B,EuF/6fgD,QAAA;AAChD;EAAuB,gBAAA;AvFi7fvB,EuFj7f2C,QAAA;AAC3C;EAAsB,gBAAA;AvFm7ftB,EuFn7f0C,QAAA;AAC1C;EAA+B,gBAAA;AvFq7f/B,EuFr7fmD,QAAA;AACnD;EAAkC,gBAAA;AvFu7flC,EuFv7fsD,QAAA;AACtD;EAA2B,gBAAA;AvFy7f3B,EuFz7f+C,QAAA;AAC/C;EAAwB,gBAAA;AvF27fxB,EuF37f4C,QAAA;AAC5C;EAAoB,gBAAA;AvF67fpB,EuF77fwC,QAAA;AACxC;EAA4B,gBAAA;AvF+7f5B,EuF/7fgD,QAAA;AAChD;EAAwB,gBAAA;AvFi8fxB,EuFj8f4C,QAAA;AAC5C;EAAyB,gBAAA;AvFm8fzB,EuFn8f6C,QAAA;AAC7C;EAA0B,gBAAA;AvFq8f1B,EuFr8f8C,QAAA;AAC9C;EAAoC,gBAAA;AvFu8fpC,EuFv8fwD,QAAA;AACxD;EAAgC,gBAAA;AvFy8fhC,EuFz8foD,QAAA;AACpD;EAA6B,gBAAA;AvF28f7B,EuF38fiD,QAAA;AACjD;EAAyB,gBAAA;AvF68fzB,EuF78f6C,QAAA;AAC7C;EAAoB,gBAAA;AvF+8fpB,EuF/8fwC,QAAA;AACxC;EAA6B,gBAAA;AvFi9f7B,EuFj9fiD,QAAA;AACjD;EAA8B,gBAAA;AvFm9f9B,EuFn9fkD,QAAA;AAClD;EAAyB,gBAAA;AvFq9fzB,EuFr9f6C,QAAA;AAC7C;EAA4B,gBAAA;AvFu9f5B,EuFv9fgD,QAAA;AAChD;EAAwB,gBAAA;AvFy9fxB,EuFz9f4C,QAAA;AAC5C;EAA+B,gBAAA;AvF29f/B,EuF39fmD,QAAA;AACnD;EAA6B,gBAAA;AvF69f7B,EuF79fiD,QAAA;AACjD;EAAmB,gBAAA;AvF+9fnB,EuF/9fuC,QAAA;AACvC;EAAsB,gBAAA;AvFi+ftB,EuFj+f0C,QAAA;AAC1C;EAAwB,gBAAA;AvFm+fxB,EuFn+f4C,QAAA;AAC5C;EAAoB,gBAAA;AvFq+fpB,EuFr+fwC,QAAA;AACxC;EAAqB,gBAAA;AvFu+frB,EuFv+fyC,QAAA;AACzC;EAAmB,gBAAA;AvFy+fnB,EuFz+fuC,QAAA;AACvC;EAAoB,gBAAA;AvF2+fpB,EuF3+fwC,QAAA;AACxC;EAA0B,gBAAA;AvF6+f1B,EuF7+f8C,QAAA;AAC9C;EAA2B,gBAAA;AvF++f3B,EuF/+f+C,QAAA;AAC/C;EAAqB,gBAAA;AvFi/frB,EuFj/fyC,QAAA;AACzC;EAAqB,gBAAA;AvFm/frB,EuFn/fyC,QAAA;AACzC;EAA4B,gBAAA;AvFq/f5B,EuFr/fgD,QAAA;AAChD;EAAmB,gBAAA;AvFu/fnB,EuFv/fuC,QAAA;AACvC;EAAgC,gBAAA;AvFy/fhC,EuFz/foD,QAAA;AACpD;EAAmC,gBAAA;AvF2/fnC,EuF3/fuD,QAAA;AACvD;EAA4B,gBAAA;AvF6/f5B,EuF7/fgD,QAAA;AAChD;EAA2B,gBAAA;AvF+/f3B,EuF//f+C,QAAA;AAC/C;EAA0B,gBAAA;AvFiggB1B,EuFjggB8C,QAAA;AAC9C;EAA8B,gBAAA;AvFmggB9B,EuFnggBkD,QAAA;AAClD;EAAwB,gBAAA;AvFqggBxB,EuFrggB4C,QAAA;AAC5C;EAAwB,gBAAA;AvFuggBxB,EuFvggB4C,QAAA;AAC5C;EAAoB,gBAAA;AvFyggBpB,EuFzggBwC,QAAA;AACxC;EAAwB,gBAAA;AvF2ggBxB,EuF3ggB4C,QAAA;AAC5C;EAAwB,gBAAA;AvF6ggBxB,EuF7ggB4C,QAAA;AAC5C;EAAsB,gBAAA;AvF+ggBtB,EuF/ggB0C,QAAA;AAC1C;EAAyB,gBAAA;AvFihgBzB,EuFjhgB6C,QAAA;AAC7C;EAAqB,gBAAA;AvFmhgBrB,EuFnhgByC,QAAA;AACzC;EAA2B,gBAAA;AvFqhgB3B,EuFrhgB+C,QAAA;AAC/C;EAAuB,gBAAA;AvFuhgBvB,EuFvhgB2C,QAAA;AAC3C;EAAkB,gBAAA;AvFyhgBlB,EuFzhgBsC,QAAA;AACtC;EAAqB,gBAAA;AvF2hgBrB,EuF3hgByC,QAAA;AACzC;EAAuB,gBAAA;AvF6hgBvB,EuF7hgB2C,QAAA;AAC3C;EAAyB,gBAAA;AvF+hgBzB,EuF/hgB6C,QAAA;AAC7C;EAAsB,gBAAA;AvFiigBtB,EuFjigB0C,QAAA;AAC1C;EAAqB,gBAAA;AvFmigBrB,EuFnigByC,QAAA;AACzC;EAA+B,gBAAA;AvFqigB/B,EuFrigBmD,QAAA;AACnD;EAAyB,gBAAA;AvFuigBzB,EuFvigB6C,QAAA;AAC7C;EAAmB,gBAAA;AvFyigBnB,EuFzigBuC,QAAA;AACvC;EAAsB,gBAAA;AvF2igBtB,EuF3igB0C,QAAA;AAC1C;EAAoB,gBAAA;AvF6igBpB,EuF7igBwC,QAAA;AACxC;EAAqB,gBAAA;AvF+igBrB,EuF/igByC,QAAA;AACzC;EAAsB,gBAAA;AvFijgBtB,EuFjjgB0C,QAAA;AAC1C;EAA8B,gBAAA;AvFmjgB9B,EuFnjgBkD,QAAA;AAClD;EAAsB,gBAAA;AvFqjgBtB,EuFrjgB0C,QAAA;AAC1C;EAAkB,gBAAA;AvFujgBlB,EuFvjgBsC,QAAA;AACtC;EAAmB,gBAAA;AvFyjgBnB,EuFzjgBuC,QAAA;AACvC;EAAmB,gBAAA;AvF2jgBnB,EuF3jgBuC,QAAA;AACvC;EAAmB,gBAAA;AvF6jgBnB,EuF7jgBuC,QAAA;AACvC;EAAyB,gBAAA;AvF+jgBzB,EuF/jgB6C,QAAA;AAC7C;EAAwB,gBAAA;AvFikgBxB,EuFjkgB4C,QAAA;AAC5C;EAAgC,gBAAA;AvFmkgBhC,EuFnkgBoD,QAAA;AACpD;EAA+B,gBAAA;AvFqkgB/B,EuFrkgBmD,QAAA;AACnD;EAAgC,gBAAA;AvFukgBhC,EuFvkgBoD,QAAA;AACpD;EAA+B,gBAAA;AvFykgB/B,EuFzkgBmD,QAAA;AACnD;EAAkC,gBAAA;AvF2kgBlC,EuF3kgBsD,QAAA;AACtD;EAAwC,gBAAA;AvF6kgBxC,EuF7kgB4D,QAAA;AAC5D;EAA0B,gBAAA;AvF+kgB1B,EuF/kgB8C,QAAA;AAC9C;EAA0B,gBAAA;AvFilgB1B,EuFjlgB8C,QAAA;AAC9C;EAAwB,gBAAA;AvFmlgBxB,EuFnlgB4C,QAAA;AAC5C;EAAkC,gBAAA;AvFqlgBlC,EuFrlgBsD,QAAA;AACtD;EAAmB,gBAAA;AvFulgBnB,EuFvlgBuC,QAAA;AACvC;EAAuB,gBAAA;AvFylgBvB,EuFzlgB2C,QAAA;AAC3C;EAAuB,gBAAA;AvF2lgBvB,EuF3lgB2C,QAAA;AAC3C;EAAiB,gBAAA;AvF6lgBjB,EuF7lgBqC,QAAA;AACrC;EAA0B,gBAAA;AvF+lgB1B,EuF/lgB8C,QAAA;AAC9C;EAA0B,gBAAA;AvFimgB1B,EuFjmgB8C,QAAA;AAC9C;EAAwB,gBAAA;AvFmmgBxB,EuFnmgB4C,QAAA;AAC5C;EAAgC,gBAAA;AvFqmgBhC,EuFrmgBoD,QAAA;AACpD;EAA+B,gBAAA;AvFumgB/B,EuFvmgBmD,QAAA;AACnD;EAA2B,gBAAA;AvFymgB3B,EuFzmgB+C,QAAA;AAC/C;EAAqB,gBAAA;AvF2mgBrB,EuF3mgByC,QAAA;AACzC;EAA2B,gBAAA;AvF6mgB3B,EuF7mgB+C,QAAA;AAC/C;EAA2B,gBAAA;AvF+mgB3B,EuF/mgB+C,QAAA;AAC/C;EAAoB,gBAAA;AvFingBpB,EuFjngBwC,QAAA;AACxC;EAAyB,gBAAA;AvFmngBzB,EuFnngB6C,QAAA;AAC7C;EAAwB,gBAAA;AvFqngBxB,EuFrngB4C,QAAA;AAC5C;EAAiC,gBAAA;AvFungBjC,EuFvngBqD,QAAA;AACrD;EAA+B,gBAAA;AvFyngB/B,EuFzngBmD,QAAA;AACnD;EAAsB,gBAAA;AvF2ngBtB,EuF3ngB0C,QAAA;AAC1C;EAA+B,gBAAA;AvF6ngB/B,EuF7ngBmD,QAAA;AACnD;EAAwB,gBAAA;AvF+ngBxB,EuF/ngB4C,QAAA;AAC5C;EAA8B,gBAAA;AvFiogB9B,EuFjogBkD,QAAA;AAClD;EAAwB,gBAAA;AvFmogBxB,EuFnogB4C,QAAA;AAC5C;EAAoB,gBAAA;AvFqogBpB,EuFrogBwC,QAAA;AACxC;EAAoB,gBAAA;AvFuogBpB,EuFvogBwC,QAAA;AACxC;EAAuB,gBAAA;AvFyogBvB,EuFzogB2C,QAAA;AAC3C;EAAqB,gBAAA;AvF2ogBrB,EuF3ogByC,QAAA;AACzC;EAAqB,gBAAA;AvF6ogBrB,EuF7ogByC,QAAA;AACzC;EAAyB,gBAAA;AvF+ogBzB,EuF/ogB6C,QAAA;AAC7C;EAA4B,gBAAA;AvFipgB5B,EuFjpgBgD,QAAA;AAChD;EAAoB,gBAAA;AvFmpgBpB,EuFnpgBwC,QAAA;AACxC;EAA4B,gBAAA;AvFqpgB5B,EuFrpgBgD,QAAA;AAChD;EAAqB,gBAAA;AvFupgBrB,EuFvpgByC,QAAA;AACzC;EAA6B,gBAAA;AvFypgB7B,EuFzpgBiD,QAAA;AACjD;EAAuB,gBAAA;AvF2pgBvB,EuF3pgB2C,QAAA;AAC3C;EAAsB,gBAAA;AvF6pgBtB,EuF7pgB0C,QAAA;AAC1C;EAAuB,gBAAA;AvF+pgBvB,EuF/pgB2C,QAAA;AAC3C;EAAuB,gBAAA;AvFiqgBvB,EuFjqgB2C,QAAA;AAC3C;EAAwB,gBAAA;AvFmqgBxB,EuFnqgB4C,QAAA;AAC5C;EAAyB,gBAAA;AvFqqgBzB,EuFrqgB6C,QAAA;AAC7C;EAAqB,gBAAA;AvFuqgBrB,EuFvqgByC,QAAA;AACzC;EAAyB,gBAAA;AvFyqgBzB,EuFzqgB6C,QAAA;AAC7C;EAAqB,gBAAA;AvF2qgBrB,EuF3qgByC,QAAA;AACzC;EAAyB,gBAAA;AvF6qgBzB,EuF7qgB6C,QAAA;AAC7C;EAAyB,gBAAA;AvF+qgBzB,EuF/qgB6C,QAAA;AAC7C;EAAyB,gBAAA;AvFirgBzB,EuFjrgB6C,QAAA;AAC7C;EAA0B,gBAAA;AvFmrgB1B,EuFnrgB8C,QAAA;AAC9C;EAA+B,gBAAA;AvFqrgB/B,EuFrrgBmD,QAAA;AACnD;EAA4B,gBAAA;AvFurgB5B,EuFvrgBgD,QAAA;AAChD;EAAyB,gBAAA;AvFyrgBzB,EuFzrgB6C,QAAA;AAC7C;EAAwB,gBAAA;AvF2rgBxB,EuF3rgB4C,QAAA;AAC5C;EAA0B,gBAAA;AvF6rgB1B,EuF7rgB8C,QAAA;AAC9C;EAAyB,gBAAA;AvF+rgBzB,EuF/rgB6C,QAAA;AAC7C;EAAmB,gBAAA;AvFisgBnB,EuFjsgBuC,QAAA;AACvC;EAAwB,gBAAA;AvFmsgBxB,EuFnsgB4C,QAAA;AAC5C;EAA2B,gBAAA;AvFqsgB3B,EuFrsgB+C,QAAA;AAC/C;EAAuB,gBAAA;AvFusgBvB,EuFvsgB2C,QAAA;AAC3C;EAAgC,gBAAA;AvFysgBhC,EuFzsgBoD,QAAA;AACpD;EAA4B,gBAAA;AvF2sgB5B,EuF3sgBgD,QAAA;AAChD;EAAoB,gBAAA;AvF6sgBpB,EuF7sgBwC,QAAA;AACxC;EAAoC,gBAAA;AvF+sgBpC,EuF/sgBwD,QAAA;AACxD;EAAoC,gBAAA;AvFitgBpC,EuFjtgBwD,QAAA;AACxD;EAAiC,gBAAA;AvFmtgBjC,EuFntgBqD,QAAA;AACrD;EAAyC,gBAAA;AvFqtgBzC,EuFrtgB6D,QAAA;AAC7D;EAA2C,gBAAA;AvFutgB3C,EuFvtgB+D,QAAA;AAC/D;EAAwC,gBAAA;AvFytgBxC,EuFztgB4D,QAAA;AAC5D;EAA0B,gBAAA;AvF2tgB1B,EuF3tgB8C,QAAA;AAC9C;EAAoB,gBAAA;AvF6tgBpB,EuF7tgBwC,QAAA;AACxC;EAA4B,gBAAA;AvF+tgB5B,EuF/tgBgD,QAAA;AAChD;EAAkC,gBAAA;AvFiugBlC,EuFjugBsD,QAAA;AACtD;EAAwB,gBAAA;AvFmugBxB,EuFnugB4C,QAAA;AAC5C;EAAyB,gBAAA;AvFqugBzB,EuFrugB6C,QAAA;AAC7C;EAA0B,gBAAA;AvFuugB1B,EuFvugB8C,QAAA;AAC9C;EAA0B,gBAAA;AvFyugB1B,EuFzugB8C,QAAA;AAC9C;EAAyB,gBAAA;AvF2ugBzB,EuF3ugB6C,QAAA;AAC7C;EAAwB,gBAAA;AvF6ugBxB,EuF7ugB4C,QAAA;AAC5C;EAAqB,gBAAA;AvF+ugBrB,EuF/ugByC,QAAA;AACzC;EAAwB,gBAAA;AvFivgBxB,EuFjvgB4C,QAAA;AAC5C;EAAoB,gBAAA;AvFmvgBpB,EuFnvgBwC,QAAA;AACxC;EAAmB,gBAAA;AvFqvgBnB,EuFrvgBuC,QAAA;AACvC;EAAqB,gBAAA;AvFuvgBrB,EuFvvgByC,QAAA;AACzC;EAAwB,gBAAA;AvFyvgBxB,EuFzvgB4C,QAAA;AAC5C;EAAoB,gBAAA;AvF2vgBpB,EuF3vgBwC,QAAA;AACxC;EAA+B,gBAAA;AvF6vgB/B,EuF7vgBmD,QAAA;AACnD;EAA0B,gBAAA;AvF+vgB1B,EuF/vgB8C,QAAA;AAC9C;EAAoB,gBAAA;AvFiwgBpB,EuFjwgBwC,QAAA;AACxC;EAA2B,gBAAA;AvFmwgB3B,EuFnwgB+C,QAAA;AAC/C;EAAuB,gBAAA;AvFqwgBvB,EuFrwgB2C,QAAA;AAC3C;EAA8B,gBAAA;AvFuwgB9B,EuFvwgBkD,QAAA;AAClD;EAA0B,gBAAA;AvFywgB1B,EuFzwgB8C,QAAA;AAC9C;EAAqB,gBAAA;AvF2wgBrB,EuF3wgByC,QAAA;AACzC;EAAqB,gBAAA;AvF6wgBrB,EuF7wgByC,QAAA;AACzC;EAAuB,gBAAA;AvF+wgBvB,EuF/wgB2C,QAAA;AAC3C;EAA2B,gBAAA;AvFixgB3B,EuFjxgB+C,QAAA;AAC/C;EAA6B,gBAAA;AvFmxgB7B,EuFnxgBiD,QAAA;AACjD;EAAyB,gBAAA;AvFqxgBzB,EuFrxgB6C,QAAA;AAC7C;EAA0B,gBAAA;AvFuxgB1B,EuFvxgB8C,QAAA;AAC9C;EAAyB,gBAAA;AvFyxgBzB,EuFzxgB6C,QAAA;AAC7C;EAAmB,gBAAA;AvF2xgBnB,EuF3xgBuC,QAAA;AACvC;EAAmB,gBAAA;AvF6xgBnB,EuF7xgBuC,QAAA;AACvC;EAA0B,gBAAA;AvF+xgB1B,EuF/xgB8C,QAAA;AAC9C;EAA8B,gBAAA;AvFiygB9B,EuFjygBkD,QAAA;AAClD;EAA6B,gBAAA;AvFmygB7B,EuFnygBiD,QAAA;AACjD;EAA6B,gBAAA;AvFqygB7B,EuFrygBiD,QAAA;AACjD;EAAqB,gBAAA;AvFuygBrB,EuFvygByC,QAAA;AACzC;EAAuB,gBAAA;AvFyygBvB,EuFzygB2C,QAAA;AAC3C;EAAwB,gBAAA;AvF2ygBxB,EuF3ygB4C,QAAA;AAC5C;EAAqB,gBAAA;AvF6ygBrB,EuF7ygByC,QAAA;AACzC;EAAqB,gBAAA;AvF+ygBrB,EuF/ygByC,QAAA;AACzC;EAAyB,gBAAA;AvFizgBzB,EuFjzgB6C,QAAA;AAC7C;EAAkB,gBAAA;AvFmzgBlB,EuFnzgBsC,QAAA;AACtC;EAA0B,gBAAA;AvFqzgB1B,EuFrzgB8C,QAAA;AAC9C;EAAsB,gBAAA;AvFuzgBtB,EuFvzgB0C,QAAA;AC1lC1C;EACE,2BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;AxFg5iBF;AwF74iBA;EACE,sCAAA;EACA,wBAAA;EACA,6BAAA;EACA,8BAAA;EACA,wCAAA;EAAA,+BAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AxF+4iBF;;AwF54iBA;;EAEE,sCAAA;EACA,6BAAA;EACA,8BAAA;EACA,wCAAA;EAAA,+BAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;EACA,sBAAA;EACA,qBAAA;AxF+4iBF;;AwF54iBA;EACE,YAAA;AxF+4iBF;;AwF74iBA;EACE,YAAA;AxFg5iBF;;AwF94iBA;EACE,YAAA;AxFi5iBF;;AwF/4iBA;EACE,YAAA;AxFk5iBF;;AwFh5iBA;EACE,YAAA;AxFm5iBF;;AwFj5iBA;EACE,YAAA;AxFo5iBF;;AwFl5iBA;EACE,YAAA;AxFq5iBF;;AwFn5iBA;EACE,YAAA;AxFs5iBF;;AwFp5iBA;EACE,YAAA;AxFu5iBF;;AwFr5iBA;EACE,YAAA;AxFw5iBF;;AwFt5iBA;EACE,YAAA;AxFy5iBF;;AwFv5iBA;EACE,YAAA;AxF05iBF;;AwFx5iBA;EACE,YAAA;AxF25iBF;;AwFz5iBA;EACE,YAAA;AxF45iBF;;AwF15iBA;EACE,YAAA;AxF65iBF;;AwF35iBA;EACE,YAAA;AxF85iBF;;AwF55iBA;EACE,YAAA;AxF+5iBF;;AwF75iBA;EACE,YAAA;AxFg6iBF;;AwF95iBA;EACE,YAAA;AxFi6iBF;;AwF/5iBA;EACE,YAAA;AxFk6iBF;;AwFh6iBA;EACE,YAAA;AxFm6iBF;;AwFj6iBA;EACE,YAAA;AxFo6iBF;;AwFl6iBA;EACE,YAAA;AxFq6iBF;;AwFn6iBA;EACE,YAAA;AxFs6iBF;;AwFp6iBA;EACE,YAAA;AxFu6iBF;;AwFr6iBA;EACE,YAAA;AxFw6iBF;;AwFt6iBA;EACE,YAAA;AxFy6iBF;;AwFv6iBA;EACE,YAAA;AxF06iBF;;AwFx6iBA;EACE,YAAA;AxF26iBF;;AwFz6iBA;EACE,YAAA;AxF46iBF;;AwF16iBA;EACE,YAAA;AxF66iBF;;AwF36iBA;EACE,YAAA;AxF86iBF;;AwF56iBA;EACE,YAAA;AxF+6iBF;;AwF76iBA;EACE,YAAA;AxFg7iBF;;AwF96iBA;EACE,YAAA;AxFi7iBF;;AwF/6iBA;EACE,YAAA;AxFk7iBF;;AwFh7iBA;EACE,YAAA;AxFm7iBF;;AwFj7iBA;EACE,YAAA;AxFo7iBF;;AwFl7iBA;EACE,YAAA;AxFq7iBF;;AwFn7iBA;EACE,YAAA;AxFs7iBF;;AwFp7iBA;EACE,YAAA;AxFu7iBF;;AwFr7iBA;EACE,YAAA;AxFw7iBF;;AwFt7iBA;EACE,YAAA;AxFy7iBF;;AwFv7iBA;EACE,YAAA;AxF07iBF;;AwFx7iBA;EACE,YAAA;AxF27iBF;;AwFz7iBA;EACE,YAAA;AxF47iBF;;AwF17iBA;EACE,YAAA;AxF67iBF;;AwF37iBA;EACE,YAAA;AxF87iBF;;AwF57iBA;EACE,YAAA;AxF+7iBF;;AwF77iBA;EACE,YAAA;AxFg8iBF;;AwF97iBA;EACE,YAAA;AxFi8iBF;;AwF/7iBA;EACE,YAAA;AxFk8iBF;;AwFh8iBA;EACE,YAAA;AxFm8iBF;;AwFj8iBA;EACE,YAAA;AxFo8iBF;;AwFl8iBA;EACE,YAAA;AxFq8iBF;;AwFn8iBA;EACE,YAAA;AxFs8iBF;;AwFp8iBA;EACE,YAAA;AxFu8iBF;;AwFr8iBA;EACE,YAAA;AxFw8iBF;;AwFt8iBA;EACE,YAAA;AxFy8iBF;;AwFv8iBA;EACE,YAAA;AxF08iBF;;AwFx8iBA;EACE,YAAA;AxF28iBF;;AwFz8iBA;EACE,YAAA;AxF48iBF;;AwF18iBA;EACE,YAAA;AxF68iBF;;AwF38iBA;EACE,YAAA;AxF88iBF;;AwF58iBA;EACE,YAAA;AxF+8iBF;;AwF78iBA;EACE,YAAA;AxFg9iBF;;AwF98iBA;EACE,YAAA;AxFi9iBF;;AwF/8iBA;EACE,YAAA;AxFk9iBF;;AwFh9iBA;EACE,YAAA;AxFm9iBF;;AwFj9iBA;EACE,YAAA;AxFo9iBF;;AwFl9iBA;EACE,YAAA;AxFq9iBF;;AwFn9iBA;EACE,YAAA;AxFs9iBF;;AwFp9iBA;EACE,YAAA;AxFu9iBF;;AwFr9iBA;EACE,YAAA;AxFw9iBF;;AwFt9iBA;EACE,YAAA;AxFy9iBF;;AwFv9iBA;EACE,YAAA;AxF09iBF;;AwFx9iBA;EACE,YAAA;AxF29iBF;;AwFz9iBA;EACE,YAAA;AxF49iBF;;AwF19iBA;EACE,YAAA;AxF69iBF;;AwF39iBA;EACE,YAAA;AxF89iBF;;AwF59iBA;EACE,YAAA;AxF+9iBF;;AwF79iBA;EACE,YAAA;AxFg+iBF;;AwF99iBA;EACE,YAAA;AxFi+iBF;;AwF/9iBA;EACE,YAAA;AxFk+iBF;;AwFh+iBA;EACE,YAAA;AxFm+iBF;;AwFj+iBA;EACE,YAAA;AxFo+iBF;;AwFl+iBA;EACE,YAAA;AxFq+iBF;;AwFn+iBA;EACE,YAAA;AxFs+iBF;;AwFp+iBA;EACE,YAAA;AxFu+iBF;;AwFr+iBA;EACE,YAAA;AxFw+iBF;;AwFt+iBA;EACE,YAAA;AxFy+iBF;;AwFv+iBA;EACE,YAAA;AxF0+iBF;;AwFx+iBA;EACE,YAAA;AxF2+iBF;;AwFz+iBA;EACE,aAAA;AxF4+iBF;;AwF1+iBA;EACE,gBAAA;AxF6+iBF;;AwF3+iBA;EACE,gBAAA;AxF8+iBF;;AwF5+iBA;EACE,gBAAA;AxF++iBF;;AwF7+iBA;EACE,gBAAA;AxFg/iBF;;AwF9+iBA;EACE,gBAAA;AxFi/iBF;;AwF/+iBA;EACE,gBAAA;AxFk/iBF;;AwFh/iBA;EACE,gBAAA;AxFm/iBF;;AwFj/iBA;EACE,gBAAA;AxFo/iBF;;AwFl/iBA;EACE,gBAAA;AxFq/iBF;;AwFn/iBA;EACE,gBAAA;AxFs/iBF;;AwFp/iBA;EACE,gBAAA;AxFu/iBF;;AwFr/iBA;EACE,gBAAA;AxFw/iBF;;AwFt/iBA;EACE,gBAAA;AxFy/iBF;;AwFv/iBA;EACE,gBAAA;AxF0/iBF;;AwFx/iBA;EACE,gBAAA;AxF2/iBF;;AwFz/iBA;EACE,gBAAA;AxF4/iBF;;AwF1/iBA;EACE,gBAAA;AxF6/iBF;;AwF3/iBA;EACE,gBAAA;AxF8/iBF;;AwF5/iBA;EACE,gBAAA;AxF+/iBF;;AwF7/iBA;EACE,gBAAA;AxFggjBF;;AwF9/iBA;EACE,gBAAA;AxFigjBF;;AwF//iBA;EACE,gBAAA;AxFkgjBF;;AwFhgjBA;EACE,gBAAA;AxFmgjBF;;AwFjgjBA;EACE,gBAAA;AxFogjBF;;AwFlgjBA;EACE,gBAAA;AxFqgjBF;;AwFngjBA;EACE,gBAAA;AxFsgjBF;;AwFpgjBA;EACE,gBAAA;AxFugjBF;;AwFrgjBA;EACE,gBAAA;AxFwgjBF;;AwFtgjBA;EACE,gBAAA;AxFygjBF;;AwFvgjBA;EACE,gBAAA;AxF0gjBF;;AwFxgjBA;EACE,gBAAA;AxF2gjBF;;AwFzgjBA;EACE,gBAAA;AxF4gjBF;;AwF1gjBA;EACE,gBAAA;AxF6gjBF;;AwF3gjBA;EACE,gBAAA;AxF8gjBF;;AwF5gjBA;EACE,gBAAA;AxF+gjBF;;AwF7gjBA;EACE,gBAAA;AxFghjBF;;AwF9gjBA;EACE,gBAAA;AxFihjBF;;AwF/gjBA;EACE,gBAAA;AxFkhjBF;;AwFhhjBA;EACE,gBAAA;AxFmhjBF;;AwFjhjBA;EACE,gBAAA;AxFohjBF;;AwFlhjBA;EACE,gBAAA;AxFqhjBF;;AwFnhjBA;EACE,gBAAA;AxFshjBF;;AwFphjBA;EACE,gBAAA;AxFuhjBF;;AwFrhjBA;EACE,gBAAA;AxFwhjBF;;AwFthjBA;EACE,gBAAA;AxFyhjBF;;AwFvhjBA;EACE,gBAAA;AxF0hjBF;;AwFxhjBA;EACE,gBAAA;AxF2hjBF;;AwFzhjBA;EACE,gBAAA;AxF4hjBF;;AwF1hjBA;EACE,gBAAA;AxF6hjBF;;AwF3hjBA;EACE,gBAAA;AxF8hjBF;;AwF5hjBA;EACE,gBAAA;AxF+hjBF;;AwF7hjBA;EACE,gBAAA;AxFgijBF;;AwF9hjBA;EACE,gBAAA;AxFiijBF;;AwF/hjBA;EACE,gBAAA;AxFkijBF;;AwFhijBA;EACE,gBAAA;AxFmijBF;;AwFjijBA;EACE,gBAAA;AxFoijBF;;AwFlijBA;EACE,gBAAA;AxFqijBF;;AwFnijBA;EACE,gBAAA;AxFsijBF;;AwFpijBA;EACE,gBAAA;AxFuijBF;;AwFrijBA;EACE,gBAAA;AxFwijBF;;AwFtijBA;EACE,gBAAA;AxFyijBF;;AwFvijBA;EACE,gBAAA;AxF0ijBF;;AwFxijBA;EACE,gBAAA;AxF2ijBF;;AwFzijBA;EACE,gBAAA;AxF4ijBF;;AwF1ijBA;EACE,gBAAA;AxF6ijBF;;AwF3ijBA;EACE,gBAAA;AxF8ijBF;;AwF5ijBA;EACE,gBAAA;AxF+ijBF;;AwF7ijBA;EACE,gBAAA;AxFgjjBF;;AwF9ijBA;EACE,gBAAA;AxFijjBF;;AwF/ijBA;EACE,gBAAA;AxFkjjBF;;AwFhjjBA;EACE,gBAAA;AxFmjjBF;;AwFjjjBA;EACE,gBAAA;AxFojjBF;;AwFljjBA;EACE,gBAAA;AxFqjjBF;;AwFnjjBA;EACE,gBAAA;AxFsjjBF;;AwFpjjBA;EACE,gBAAA;AxFujjBF;;AwFrjjBA;EACE,gBAAA;AxFwjjBF;;AwFtjjBA;EACE,gBAAA;AxFyjjBF;;AwFvjjBA;EACE,gBAAA;AxF0jjBF;;AwFxjjBA;EACE,gBAAA;AxF2jjBF;;AwFzjjBA;EACE,gBAAA;AxF4jjBF;;AwF1jjBA;EACE,gBAAA;AxF6jjBF;;AwF3jjBA;EACE,gBAAA;AxF8jjBF;;AwF5jjBA;EACE,gBAAA;AxF+jjBF;;AwF7jjBA;EACE,gBAAA;AxFgkjBF;;AwF9jjBA;EACE,gBAAA;AxFikjBF;;AwF/jjBA;EACE,gBAAA;AxFkkjBF;;AwFhkjBA;EACE,gBAAA;AxFmkjBF;;AwFjkjBA;EACE,gBAAA;AxFokjBF;;AwFlkjBA;EACE,gBAAA;AxFqkjBF;;AwFnkjBA;EACE,gBAAA;AxFskjBF;;AwFpkjBA;EACE,gBAAA;AxFukjBF;;AwFrkjBA;EACE,gBAAA;AxFwkjBF;;AwFtkjBA;EACE,gBAAA;AxFykjBF;;AwFvkjBA;EACE,gBAAA;AxF0kjBF;;AwFxkjBA;EACE,gBAAA;AxF2kjBF;;AwFzkjBA;EACE,gBAAA;AxF4kjBF;;AwF1kjBA;EACE,gBAAA;AxF6kjBF;;AwF3kjBA;EACE,gBAAA;AxF8kjBF;;AwF5kjBA;EACE,gBAAA;AxF+kjBF;;AwF7kjBA;EACE,gBAAA;AxFgljBF;;AwF9kjBA;EACE,gBAAA;AxFiljBF;;AwF/kjBA;EACE,gBAAA;AxFkljBF;;AwFhljBA;EACE,gBAAA;AxFmljBF;;AwFjljBA;EACE,gBAAA;AxFoljBF;;AwFlljBA;EACE,gBAAA;AxFqljBF;;AwFnljBA;EACE,gBAAA;AxFsljBF;;AyFrtkBA,4BAAA;AACA;EACE,oCAAA;EACA,6CAAA;EACA,yPAAA;EACA,mBAAA;EACA,kBAAA;AzFwtkBF;AyFrtkBA;;EAEE,qBAAA;EACA,yDAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,iBAAA;AzFutkBF;;AyFptkBA;EACE,gBAAA;EACA,kBAAA;AzFutkBF;;AyFptkBA;EACE,eAAA;AzFutkBF;;AyFptkBA;EACE,eAAA;AzFutkBF;;AyFptkBA;EACE,eAAA;AzFutkBF;;AyFptkBA;EACE,eAAA;AzFutkBF;;AyFptkBA;EACE,0BAAA;AzFutkBF;;AyFptkBA;EACE,0BAAA;AzFutkBF;;AyFptkBA;EACE,YAAA;AzFutkBF;;AyFptkBA;EACE,+BAAA;AzFutkBF;;AyFptkBA;EACE;;;;;;;;;;;;;;;SAAA;AzFsukBF;;AyFptkBA;EAGE,wBAAA;AzFutkBF;;AyFptkBA;EACE;;;;;;;;;;;;;;;SAAA;AzFsukBF;;AyFptkBA;EAGE,wBAAA;AzFutkBF;;AyFptkBA;EACE;;;;;;;;;;;;;;;SAAA;AzFsukBF;;AyFptkBA;EAGE,yBAAA;AzFutkBF;;AyFptkBA;EACE;;;;;;;;;;;;;;;SAAA;AzFsukBF;;AyFptkBA;EAGE,yBAAA;AzFutkBF;;AyFptkBA;EACE;;;;;;;;;;;;;;;SAAA;AzFsukBF;;AyFptkBA;EAGE,yBAAA;AzFutkBF;;AyFptkBA;EACE;;;;;;;;;;;;;;;SAAA;AzFsukBF;;AyFptkBA;EAGE,yBAAA;AzFutkBF;;AyFptkBA;EACE;;;;;;;;;;;;;;;SAAA;AzFsukBF;;AyFptkBA;EAGE,yBAAA;AzFutkBF;;AyFptkBA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AzFutkBF;;AyFptkBA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AzFutkBF;;AyFptkBA;EAEE,sCAAA;AzFutkBF;AyFzskBA;EACE;IAEE,uBAAA;EzFstkBF;EyFptkBA;IAEE,yBAAA;EzFstkBF;AACF","sourcesContent":["@charset \"UTF-8\";\n/*\nTemplate Name: Hyper - Responsive Bootstrap 5 Admin Dashboard\nVersion: 3.4.0\nAuthor: CoderThemes\nEmail: support@coderthemes.com\nFile: Main Css File\n*/\n:root {\n  --ct-link-color: #0d6efd;\n  --ct-link-hover-color: #0a58ca;\n}\n\n:root {\n  --ct-link-color: #727cf5;\n  --ct-link-hover-color: rgb(38%, 41.3333333333%, 81.6666666667%);\n  --ct-border-color: #dee2e6;\n  --ct-box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);\n  --ct-box-shadow-sm: 0 .125rem .25rem rgba(0, 0, 0, 0.075);\n  --ct-box-shadow-lg: 0 0 45px 0 rgba(0, 0, 0, 0.12);\n  --ct-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --ct-component-active-color: #fff;\n  --ct-component-active-bg: #727cf5;\n  --ct-text-muted: #98a6ad;\n  --ct-blockquote-footer-color: #98a6ad;\n  --ct-mark-bg: #fcf8e3;\n  --ct-table-color: #6c757d;\n  --ct-table-bg: transparent;\n  --ct-table-accent-bg: transparent;\n  --ct-table-striped-color: #6c757d;\n  --ct-table-striped-bg: rgba(241, 243, 250, 0.8);\n  --ct-table-active-color: var(--ct-table-color);\n  --ct-table-active-bg: rgba(222, 226, 230, 0.4);\n  --ct-table-hover-color: var(--ct-table-color);\n  --ct-table-hover-bg: #f1f3fa;\n  --ct-table-border-color: #eef2f7;\n  --ct-table-group-separator-color: rgb(92.7484787018%, 93.6274509804%, 94.506423259%);\n  --ct-table-caption-color: var(--ct-text-muted);\n  --ct-input-btn-focus-color: rgba(114, 124, 245, 0.25);\n  --ct-btn-active-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-link-color: #0d6efd;\n  --ct-btn-link-hover-color: #0a58ca;\n  --ct-btn-link-disabled-color: #adb5bd;\n  --ct-form-text-color: var(--ct-text-muted);\n  --ct-input-bg: #fff;\n  --ct-input-disabled-bg: #eef2f7;\n  --ct-input-color: #6c757d;\n  --ct-input-border-color: #dee2e6;\n  --ct-input-box-shadow: var(--ct-box-shadow-inset);\n  --ct-input-focus-bg: var(--ct-input-bg);\n  --ct-input-focus-border-color: rgb(78.3529411765%, 79.7647058824%, 81.1764705882%);\n  --ct-input-focus-color: var(--ct-input-color);\n  --ct-input-placeholder-color: #adb5bd;\n  --ct-input-plaintext-color: #6c757d;\n  --ct-form-check-input-bg: #fff;\n  --ct-form-check-input-border: 1px solid #dee2e6;\n  --ct-form-check-input-checked-color: var(--ct-component-active-color);\n  --ct-form-check-input-checked-bg-color: var(--ct-component-active-bg);\n  --ct-form-check-input-checked-border-color: var(--ct-form-check-input-checked-bg-color);\n  --ct-form-check-input-indeterminate-color: var(--ct-component-active-color);\n  --ct-form-check-input-indeterminate-bg-color: var(--ct-component-active-bg);\n  --ct-form-check-input-indeterminate-border-color: var(--ct-component-active-bg);\n  --ct-form-switch-color: #dee2e6;\n  --ct-input-group-addon-color: var(--ct-input-color);\n  --ct-input-group-addon-bg: #eef2f7;\n  --ct-input-group-addon-border-color: #dee2e6;\n  --ct-form-select-color: var(--ct-input-color);\n  --ct-form-select-bg: var(--ct-input-bg);\n  --ct-form-select-disabled-color: #98a6ad;\n  --ct-form-select-disabled-bg: #eef2f7;\n  --ct-form-select-indicator-color: #343a40;\n  --ct-form-range-track-bg: #dee2e6;\n  --ct-form-range-track-box-shadow: var(--ct-box-shadow-inset);\n  --ct-form-range-thumb-box-shadow: 0 .1rem .25rem rgba(0, 0, 0, 0.1);\n  --ct-form-range-thumb-active-bg: rgb(83.4117647059%, 84.5882352941%, 98.8235294118%);\n  --ct-form-range-thumb-disabled-bg: #adb5bd;\n  --ct-form-file-button-color: var(--ct-input-color);\n  --ct-form-file-button-bg: #eef2f7;\n  --ct-form-file-button-hover-bg: rgb(88.6666666667%, 90.1568627451%, 92.0196078431%);\n  --ct-nav-link-disabled-color: #98a6ad;\n  --ct-nav-tabs-border-color: #dee2e6;\n  --ct-nav-tabs-link-hover-border-color: #eef2f7 #eef2f7 var(--ct-nav-tabs-border-color);\n  --ct-nav-tabs-link-active-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);\n  --ct-nav-tabs-link-active-bg: #fff;\n  --ct-nav-tabs-link-active-border-color: #dee2e6 #dee2e6 var(--ct-nav-tabs-link-active-bg);\n  --ct-navbar-dark-color: rgba(255, 255, 255, 0.55);\n  --ct-navbar-dark-hover-color: rgba(255, 255, 255, 0.75);\n  --ct-navbar-dark-active-color: #fff;\n  --ct-navbar-dark-disabled-color: rgba(255, 255, 255, 0.25);\n  --ct-navbar-dark-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --ct-navbar-light-color: rgb(40.2352941176%, 43.5882352941%, 46.568627451%);\n  --ct-navbar-light-hover-color: #343a40;\n  --ct-navbar-light-active-color: rgba(0, 0, 0, 0.9);\n  --ct-navbar-light-disabled-color: #adb5bd;\n  --ct-dropdown-color: #6c757d;\n  --ct-dropdown-bg: #fff;\n  --ct-dropdown-border-color: rgb(90.5333333333%, 92.0549019608%, 93.9568627451%);\n  --ct-dropdown-divider-bg: rgb(90.5333333333%, 92.0549019608%, 93.9568627451%);\n  --ct-dropdown-box-shadow: var(--ct-box-shadow);\n  --ct-dropdown-link-color: #6c757d;\n  --ct-dropdown-link-hover-color: rgb(17.2941176471%, 20.4705882353%, 24.7058823529%);\n  --ct-dropdown-link-hover-bg: rgb(95.7176470588%, 96.3294117647%, 98.4705882353%);\n  --ct-dropdown-link-active-color: #313a46;\n  --ct-dropdown-link-active-bg: rgb(94.9333333333%, 96.1254901961%, 97.6156862745%);\n  --ct-dropdown-link-disabled-color: #98a6ad;\n  --ct-dropdown-dark-color: #dee2e6;\n  --ct-dropdown-dark-bg: #343a40;\n  --ct-dropdown-dark-border-color: var(--ct-dropdown-border-color);\n  --ct-dropdown-dark-divider-bg: var(--ct-dropdown-divider-bg);\n  --ct-dropdown-dark-link-color: var(--ct-dropdown-dark-color);\n  --ct-dropdown-dark-link-hover-color: #fff;\n  --ct-dropdown-dark-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --ct-dropdown-dark-link-active-color: var(--ct-dropdown-link-active-color);\n  --ct-dropdown-dark-link-active-bg: var(--ct-dropdown-link-active-bg);\n  --ct-dropdown-dark-link-disabled-color: #adb5bd;\n  --ct-dropdown-dark-header-color: #adb5bd;\n  --ct-pagination-color: #313a46;\n  --ct-pagination-bg: #fff;\n  --ct-pagination-border-color: #dee2e6;\n  --ct-pagination-focus-color: #0a58ca;\n  --ct-pagination-focus-bg: #eef2f7;\n  --ct-pagination-focus-box-shadow: 0 0 0 0.2rem var(--ct-input-btn-focus-color);\n  --ct-pagination-hover-color: #313a46;\n  --ct-pagination-hover-bg: #eef2f7;\n  --ct-pagination-hover-border-color: #dee2e6;\n  --ct-pagination-disabled-color: #98a6ad;\n  --ct-pagination-disabled-bg: #fff;\n  --ct-pagination-disabled-border-color: #dee2e6;\n  --ct-card-border-color: rgba(0, 0, 0, 0.125);\n  --ct-card-box-shadow: var(--ct-box-shadow);\n  --ct-card-cap-bg: #fff;\n  --ct-card-bg: #fff;\n  --ct-accordion-color: #6c757d;\n  --ct-accordion-border-color: rgba(0, 0, 0, 0.125);\n  --ct-accordion-button-active-bg: rgb(94.4705882353%, 94.862745098%, 99.6078431373%);\n  --ct-accordion-button-active-color: rgb(40.2352941176%, 43.7647058824%, 86.4705882353%);\n  --ct-accordion-button-focus-border-color: var(--ct-input-focus-border-color);\n  --ct-accordion-button-focus-box-shadow: 0 0 0 0.2rem var(--ct-input-btn-focus-color);\n  --ct-tooltip-color: #f1f3fa;\n  --ct-tooltip-bg: #343a40;\n  --ct-popover-bg: #fff;\n  --ct-popover-border-color: #dee2e6;\n  --ct-popover-header-bg: #f1f3fa;\n  --ct-popover-header-color: ;\n  --ct-popover-body-color: #6c757d;\n  --ct-popover-arrow-color: #fff;\n  --ct-popover-arrow-outer-color: #ced4da;\n  --ct-toast-background-color: rgba(255, 255, 255, 0.85);\n  --ct-toast-border-color: rgba(49, 58, 70, 0.1);\n  --ct-toast-header-background-color: rgba(255, 255, 255, 0.85);\n  --ct-toast-header-border-color: rgba(49, 58, 70, 0.05);\n  --ct-badge-color: #fff;\n  --ct-modal-content-bg: #fff;\n  --ct-modal-content-box-shadow-xs: var(--ct-box-shadow-sm);\n  --ct-modal-content-box-shadow-sm-up: var(--ct-box-shadow);\n  --ct-modal-backdrop-bg: #313a46;\n  --ct-modal-header-border-color: var(--ct-border-color);\n  --ct-modal-footer-border-color: var(--ct-border-color);\n  --ct-progress-bg: #eef2f7;\n  --ct-progress-box-shadow: var(--ct-box-shadow-inset);\n  --ct-progress-bar-color: #fff;\n  --ct-progress-bar-bg: #727cf5;\n  --ct-list-group-color: #313a46;\n  --ct-list-group-bg: #fff;\n  --ct-list-group-border-color: #eef2f7;\n  --ct-list-group-hover-bg: #f1f3fa;\n  --ct-list-group-disabled-color: #6c757d;\n  --ct-list-group-disabled-bg: rgb(96.1568627451%, 96.7058823529%, 98.6274509804%);\n  --ct-list-group-action-color: #6c757d;\n  --ct-list-group-action-active-color: #6c757d;\n  --ct-list-group-action-active-bg: #eef2f7;\n  --ct-thumbnail-bg: #fff;\n  --ct-thumbnail-border-color: #dee2e6;\n  --ct-thumbnail-box-shadow: var(--ct-box-shadow-sm);\n  --ct-figure-caption-color: #98a6ad;\n  --ct-breadcrumb-divider-color: #ced4da;\n  --ct-breadcrumb-active-color: #adb5bd;\n  --ct-carousel-control-color: #fff;\n  --ct-carousel-indicator-active-bg: #fff;\n  --ct-carousel-caption-color: #fff;\n  --ct-carousel-dark-indicator-active-bg: #000;\n  --ct-carousel-dark-caption-color: #000;\n  --ct-btn-close-color: #313a46;\n  --ct-code-color: #39afd1;\n  --ct-kbd-color: #fff;\n  --ct-kbd-bg: #313a46;\n  --ct-pre-color: ;\n  --ct-bg-leftbar: #fff;\n  --ct-menu-item: #6c757d;\n  --ct-menu-item-hover: #727cf5;\n  --ct-menu-item-active: #727cf5;\n  --ct-bg-topbar: #fff;\n  --ct-bg-topbar-search: #f1f3fa;\n  --ct-nav-user-bg-topbar: #3c4655;\n  --ct-nav-user-border-topbar: #414d5d;\n  --ct-bg-dark-topbar: #313a46;\n  --ct-bg-dark-topbar-search: #3c4655;\n  --ct-nav-user-bg-dark-topbar: #3c4655;\n  --ct-nav-user-border-dark-topbar: #414d5d;\n  --ct-rightbar-bg: #fff;\n  --ct-rightbar-title-bg: #313a46;\n  --ct-rightbar-title-color: #fff;\n  --ct-rightbar-title-btn-bg: #444e5a;\n  --ct-rightbar-title-btn-color: #fff;\n  --ct-rightbar-overlay-bg: #37404a;\n  --ct-bg-detached-leftbar: #fff;\n  --ct-bg-leftbar-gradient: linear-gradient(135deg, #8f75da 0%, #727cf5 60%);\n  --ct-bg-topnav: #313a46;\n  --ct-boxed-layout-bg: #fff;\n  --ct-help-box-light-bg: rgba(255, 255, 255, 0.07);\n  --ct-help-box-dark-bg: #727cf5;\n  --ct-nav-pills-bg: #eef2f7;\n  --ct-custom-accordion-title-color: #313a46;\n  --ct-dragula-bg: #f7f9fb;\n  --ct-form-wizard-header-bg: #eef2f7;\n  --ct-text-title-color: #6c757d;\n  --ct-page-title-color: #6c757d;\n  --ct-card-loader-bg: #313a46;\n  --ct-chat-primary-user-bg: #fef5e4;\n  --ct-chat-secondary-user-bg: #f1f3fa;\n  --ct-auth-bg: #fff;\n  --ct-apex-grid-color: #f9f9fd;\n  --ct-hero-bg: linear-gradient(to bottom, #8669ed, #727cf5);\n}\n\nbody[data-leftbar-theme=dark] {\n  --ct-bg-leftbar: #313a46;\n  --ct-dark-menu-item: #8391a2;\n  --ct-dark-menu-item-hover: #bccee4;\n  --ct-dark-menu-item-active: #fff;\n}\n\nbody[data-leftbar-theme=default] {\n  --ct-menu-item: #cedce4;\n  --ct-menu-item-hover: #fff;\n  --ct-menu-item-active: #fff;\n}\n\nbody[data-layout-color=dark] {\n  --ct-body-bg: #343a40;\n  --ct-body-color: #aab8c5;\n  --ct-link-color: #727cf5;\n  --ct-link-hover-color: rgb(38%, 41.3333333333%, 81.6666666667%);\n  --ct-border-color: #464f5b;\n  --ct-box-shadow: 0px 0px 35px 0px rgba(49, 57, 66, 0.5);\n  --ct-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  --ct-box-shadow-lg: 0 0 45px 0 rgba(0, 0, 0, 0.12);\n  --ct-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --ct-component-active-color: #fff;\n  --ct-component-active-bg: #727cf5;\n  --ct-text-muted: #8391a2;\n  --ct-blockquote-footer-color: #ced4da;\n  --ct-mark-bg: #fcf8e3;\n  --ct-table-color: #aab8c5;\n  --ct-table-bg: transparent;\n  --ct-table-accent-bg: transparent;\n  --ct-table-striped-color: #aab8c5;\n  --ct-table-striped-bg: rgba(64, 73, 84, 0.8);\n  --ct-table-active-color: var(--ct-table-color);\n  --ct-table-active-bg: rgba(70, 79, 91, 0.4);\n  --ct-table-hover-color: var(--ct-table-color);\n  --ct-table-hover-bg: #404954;\n  --ct-table-border-color: #464f5b;\n  --ct-table-group-separator-color: rgb(31.7988064791%, 35.887224455%, 41.3384484228%);\n  --ct-table-caption-color: var(--ct-text-muted);\n  --ct-input-btn-focus-color: rgba(114, 124, 245, 0.25);\n  --ct-btn-active-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --ct-btn-link-color: #0d6efd;\n  --ct-btn-link-hover-color: #0a58ca;\n  --ct-btn-link-disabled-color: #aab8c5;\n  --ct-form-text-color: var(--ct-text-muted);\n  --ct-input-bg: #404954;\n  --ct-input-disabled-bg: #37404a;\n  --ct-input-color: #e3eaef;\n  --ct-input-border-color: rgb(28.8431372549%, 32.1960784314%, 36.2941176471%);\n  --ct-input-box-shadow: var(--ct-box-shadow-inset);\n  --ct-input-focus-bg: rgb(27.2602013778%, 31.0936671966%, 35.7790143084%);\n  --ct-input-focus-border-color: rgb(33.2711926432%, 37.1388839702%, 41.8660622587%);\n  --ct-input-focus-color: var(--ct-input-color);\n  --ct-input-placeholder-color: #8391a2;\n  --ct-input-plaintext-color: #6c757d;\n  --ct-form-check-input-bg: transparent;\n  --ct-form-check-input-border: 1px solid rgb(28.8431372549%, 32.1960784314%, 36.2941176471%);\n  --ct-form-check-input-checked-color: var(--ct-component-active-color);\n  --ct-form-check-input-checked-bg-color: var(--ct-component-active-bg);\n  --ct-form-check-input-checked-border-color: var(--ct-form-check-input-checked-bg-color);\n  --ct-form-check-input-indeterminate-color: var(--ct-component-active-color);\n  --ct-form-check-input-indeterminate-bg-color: var(--ct-component-active-bg);\n  --ct-form-check-input-indeterminate-border-color: var(--ct-component-active-bg);\n  --ct-form-switch-color: tiny-color(#464f5b, 6%);\n  --ct-input-group-addon-color: var(--ct-input-color);\n  --ct-input-group-addon-bg: rgb(28.1764705882%, 31.6705882353%, 36.3294117647%);\n  --ct-input-group-addon-border-color: var(--ct-input-border-color);\n  --ct-form-select-color: var(--ct-input-color);\n  --ct-form-select-bg: var(--ct-input-bg);\n  --ct-form-select-disabled-color: #ced4da;\n  --ct-form-select-disabled-bg: #37404a;\n  --ct-form-select-indicator-color: #e3eaef;\n  --ct-form-range-track-bg: #464f5b;\n  --ct-form-range-track-box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);\n  --ct-form-range-thumb-box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  --ct-form-range-thumb-active-bg: rgb(83.4117647059%, 84.5882352941%, 98.8235294118%);\n  --ct-form-range-thumb-disabled-bg: #aab8c5;\n  --ct-form-file-button-color: var(--ct-input-color);\n  --ct-form-file-button-bg: rgb(28.1764705882%, 31.6705882353%, 36.3294117647%);\n  --ct-form-file-button-hover-bg: rgb(26.0784313725%, 29.431372549%, 33.9019607843%);\n  --ct-nav-link-disabled-color: #ced4da;\n  --ct-nav-tabs-border-color: #464f5b;\n  --ct-nav-tabs-link-hover-border-color: #37404a #37404a var(--ct-nav-tabs-border-color);\n  --ct-nav-tabs-link-active-color: #e3eaef;\n  --ct-nav-tabs-link-active-bg: rgb(28.8431372549%, 32.1960784314%, 36.2941176471%);\n  --ct-nav-tabs-link-active-border-color: #464f5b #464f5b var(--ct-nav-tabs-link-active-bg);\n  --ct-navbar-dark-color: rgba(255, 255, 255, 0.55);\n  --ct-navbar-dark-hover-color: rgba(255, 255, 255, 0.75);\n  --ct-navbar-dark-active-color: #fff;\n  --ct-navbar-dark-disabled-color: rgba(255, 255, 255, 0.25);\n  --ct-navbar-dark-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --ct-navbar-light-color: rgb(82.7058823529%, 84.1960784314%, 85.6862745098%);\n  --ct-navbar-light-hover-color: #e3eaef;\n  --ct-navbar-light-active-color: rgba(255, 255, 255, 0.9);\n  --ct-navbar-light-disabled-color: #aab8c5;\n  --ct-dropdown-color: #aab8c5;\n  --ct-dropdown-bg: rgb(23.137254902%, 26.5960784314%, 30.4392156863%);\n  --ct-dropdown-border-color: rgb(26.2745098039%, 29.5921568627%, 33.2784313725%);\n  --ct-dropdown-divider-bg: rgb(30.3529411765%, 33.7411764706%, 38.2588235294%);\n  --ct-dropdown-box-shadow: var(--ct-box-shadow);\n  --ct-dropdown-link-color: #aab8c5;\n  --ct-dropdown-link-hover-color: rgb(85.0588235294%, 85.0588235294%, 85.0588235294%);\n  --ct-dropdown-link-hover-bg: rgb(28.1764705882%, 31.6705882353%, 36.3294117647%);\n  --ct-dropdown-link-active-color: #fff;\n  --ct-dropdown-link-active-bg: rgb(47.7647058824%, 50.3058823529%, 53.6941176471%);\n  --ct-dropdown-link-disabled-color: #ced4da;\n  --ct-dropdown-dark-color: #464f5b;\n  --ct-dropdown-dark-bg: #e3eaef;\n  --ct-dropdown-dark-border-color: var(--ct-dropdown-border-color);\n  --ct-dropdown-dark-divider-bg: var(--ct-dropdown-divider-bg);\n  --ct-dropdown-dark-link-color: var(--ct-dropdown-dark-color);\n  --ct-dropdown-dark-link-hover-color: #fff;\n  --ct-dropdown-dark-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --ct-dropdown-dark-link-active-color: var(--ct-dropdown-link-active-color);\n  --ct-dropdown-dark-link-active-bg: var(--ct-dropdown-link-active-bg);\n  --ct-dropdown-dark-link-disabled-color: #aab8c5;\n  --ct-dropdown-dark-header-color: #aab8c5;\n  --ct-pagination-color: #8391a2;\n  --ct-pagination-bg: rgb(24.7058823529%, 28.0941176471%, 31.8588235294%);\n  --ct-pagination-border-color: #464f5b;\n  --ct-pagination-focus-color: #0a58ca;\n  --ct-pagination-focus-bg: #37404a;\n  --ct-pagination-focus-box-shadow: 0 0 0 0.2rem var(--ct-input-btn-focus-color);\n  --ct-pagination-hover-color: #f1f1f1;\n  --ct-pagination-hover-bg: rgb(27.8431372549%, 31.0901960784%, 34.6980392157%);\n  --ct-pagination-hover-border-color: #464f5b;\n  --ct-pagination-disabled-color: #8391a2;\n  --ct-pagination-disabled-bg: rgb(29.0736028188%, 33.0608397768%, 37.4911030635%);\n  --ct-pagination-disabled-border-color: rgb(29.0736028188%, 33.0608397768%, 37.4911030635%);\n  --ct-card-border-color: rgba(0, 0, 0, 0.125);\n  --ct-card-box-shadow: var(--ct-box-shadow);\n  --ct-card-cap-bg: #464f5b;\n  --ct-card-bg: #37404a;\n  --ct-accordion-color: #6c757d;\n  --ct-accordion-border-color: rgba(0, 0, 0, 0.125);\n  --ct-accordion-button-active-bg: rgb(94.4705882353%, 94.862745098%, 99.6078431373%);\n  --ct-accordion-button-active-color: rgb(40.2352941176%, 43.7647058824%, 86.4705882353%);\n  --ct-accordion-button-focus-border-color: var(--ct-input-focus-border-color);\n  --ct-accordion-button-focus-box-shadow: 0 0 0 0.2rem var(--ct-input-btn-focus-color);\n  --ct-tooltip-color: #37404a;\n  --ct-tooltip-bg: #dee2e6;\n  --ct-popover-bg: #37404a;\n  --ct-popover-border-color: #464f5b;\n  --ct-popover-header-bg: rgb(23.7004103967%, 27.5786593707%, 31.8878248974%);\n  --ct-popover-header-color: #dee2e6;\n  --ct-popover-body-color: #dee2e6;\n  --ct-popover-arrow-color: #37404a;\n  --ct-popover-arrow-outer-color: #464f5b;\n  --ct-toast-background-color: #404954;\n  --ct-toast-border-color: rgba(241, 241, 241, 0.12);\n  --ct-toast-header-background-color: rgba(64, 73, 84, 0.2);\n  --ct-toast-header-border-color: rgba(241, 241, 241, 0.05);\n  --ct-badge-color: #fff;\n  --ct-modal-content-bg: rgb(23.137254902%, 26.5960784314%, 30.4392156863%);\n  --ct-modal-content-box-shadow-xs: var(--ct-box-shadow-sm);\n  --ct-modal-content-box-shadow-sm-up: var(--ct-box-shadow);\n  --ct-modal-backdrop-bg: #aab8c5;\n  --ct-modal-header-border-color: rgb(31.7988064791%, 35.887224455%, 41.3384484228%);\n  --ct-modal-footer-border-color: rgb(31.7988064791%, 35.887224455%, 41.3384484228%);\n  --ct-progress-bg: #464f5b;\n  --ct-progress-box-shadow: var(--ct-box-shadow-inset);\n  --ct-progress-bar-color: #fff;\n  --ct-progress-bar-bg: #727cf5;\n  --ct-list-group-color: #f1f1f1;\n  --ct-list-group-bg: var(--ct-card-bg);\n  --ct-list-group-border-color: rgb(30.3529411765%, 33.7411764706%, 38.2588235294%);\n  --ct-list-group-hover-bg: #404954;\n  --ct-list-group-disabled-color: #8391a2;\n  --ct-list-group-disabled-bg: #404954;\n  --ct-list-group-action-color: #aab8c5;\n  --ct-list-group-action-active-color: #dee2e6;\n  --ct-list-group-action-active-bg: #404954;\n  --ct-thumbnail-bg: #464f5b;\n  --ct-thumbnail-border-color: #464f5b;\n  --ct-thumbnail-box-shadow: var(--ct-box-shadow-sm);\n  --ct-figure-caption-color: #ced4da;\n  --ct-breadcrumb-divider-color: #8391a2;\n  --ct-breadcrumb-active-color: #aab8c5;\n  --ct-carousel-control-color: #fff;\n  --ct-carousel-indicator-active-bg: #fff;\n  --ct-carousel-caption-color: #fff;\n  --ct-carousel-dark-indicator-active-bg: #000;\n  --ct-carousel-dark-caption-color: #000;\n  --ct-btn-close-color: #e3eaef;\n  --ct-code-color: #39afd1;\n  --ct-kbd-color: #fff;\n  --ct-kbd-bg: #f1f1f1;\n  --ct-pre-color: #aab8c5;\n  --ct-bg-leftbar: #3a444e;\n  --ct-menu-item: #cedce4;\n  --ct-menu-item-hover: #fff;\n  --ct-menu-item-active: #fff;\n  --ct-bg-topbar: #3a444e;\n  --ct-bg-topbar-search: #464f5b;\n  --ct-nav-user-bg-topbar: #45515d;\n  --ct-nav-user-border-topbar: #4a5764;\n  --ct-bg-dark-topbar: #3a444e;\n  --ct-bg-dark-topbar-search: #464f5b;\n  --ct-nav-user-bg-dark-topbar: #45515d;\n  --ct-nav-user-border-dark-topbar: #4a5764;\n  --ct-rightbar-bg: #37404a;\n  --ct-rightbar-title-bg: #727cf5;\n  --ct-rightbar-title-color: #fff;\n  --ct-rightbar-title-btn-bg: rgb(54.0436306973%, 57.3029476691%, 96.7406830282%);\n  --ct-rightbar-title-btn-color: #fff;\n  --ct-rightbar-overlay-bg: #000;\n  --ct-bg-detached-leftbar: #37404a;\n  --ct-bg-leftbar-gradient: linear-gradient(135deg, #8f75da 0, #727cf5 60%);\n  --ct-bg-topnav: linear-gradient(to bottom, #8f75da, #727cf5);\n  --ct-boxed-layout-bg: #3e4853;\n  --ct-help-box-light-bg: rgba(255, 255, 255, 0.1);\n  --ct-help-box-dark-bg: #727cf5;\n  --ct-nav-pills-bg: #404954;\n  --ct-custom-accordion-title-color: #8391a2;\n  --ct-dragula-bg: #404954;\n  --ct-form-wizard-header-bg: #404954;\n  --ct-text-title-color: #fff;\n  --ct-page-title-color: #fff;\n  --ct-card-loader-bg: #f1f1f1;\n  --ct-chat-primary-user-bg: #404954;\n  --ct-chat-secondary-user-bg: #404954;\n  --ct-auth-bg: #404954;\n  --ct-apex-grid-color: #404954;\n  --ct-hero-bg: linear-gradient(to bottom, #697ded, #5e30c1);\n}\n\nbody[data-layout-color=dark][data-layout=detached] {\n  --ct-menu-item: #8391a2;\n  --ct-menu-item-hover: #727cf5;\n  --ct-menu-item-active: #727cf5;\n}\n\nbody[data-leftbar-theme=light] {\n  --ct-bg-leftbar: #fff;\n  --ct-menu-item: #6c757d;\n  --ct-menu-item-hover: #727cf5;\n  --ct-menu-item-active: #727cf5;\n}\n\n/*!\n * Bootstrap  v5.3.3 (https://getbootstrap.com/)\n * Copyright 2011-2024 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #2c8ef8;\n  --bs-indigo: #727cf5;\n  --bs-purple: #6b5eae;\n  --bs-pink: #ff679b;\n  --bs-red: #fa5c7c;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffbc00;\n  --bs-green: #0acf97;\n  --bs-teal: #02a8b5;\n  --bs-cyan: #39afd1;\n  --bs-white: #fff;\n  --bs-gray: #98a6ad;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f1f3fa;\n  --bs-gray-200: #eef2f7;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #98a6ad;\n  --bs-gray-700: #6c757d;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #313a46;\n  --bs-primary: #727cf5;\n  --bs-secondary: #6c757d;\n  --bs-success: #0acf97;\n  --bs-info: #39afd1;\n  --bs-warning: #ffbc00;\n  --bs-danger: #fa5c7c;\n  --bs-light: #eef2f7;\n  --bs-dark: #313a46;\n  --bs-primary-rgb: 114, 124, 245;\n  --bs-secondary-rgb: 108, 117, 125;\n  --bs-success-rgb: 10, 207, 151;\n  --bs-info-rgb: 57, 175, 209;\n  --bs-warning-rgb: 255, 188, 0;\n  --bs-danger-rgb: 250, 92, 124;\n  --bs-light-rgb: 238, 242, 247;\n  --bs-dark-rgb: 49, 58, 70;\n  --bs-primary-text-emphasis: rgb(2.0392156863%, 17.2549019608%, 39.6862745098%);\n  --bs-secondary-text-emphasis: rgb(16.9411764706%, 18.3529411765%, 19.6078431373%);\n  --bs-success-text-emphasis: rgb(3.9215686275%, 21.1764705882%, 13.1764705882%);\n  --bs-info-text-emphasis: rgb(2.0392156863%, 31.6862745098%, 37.6470588235%);\n  --bs-warning-text-emphasis: rgb(40%, 30.2745098039%, 1.0980392157%);\n  --bs-danger-text-emphasis: rgb(34.5098039216%, 8.3137254902%, 10.8235294118%);\n  --bs-light-text-emphasis: #495057;\n  --bs-dark-text-emphasis: #495057;\n  --bs-primary-bg-subtle: rgb(81.0196078431%, 88.6274509804%, 99.8431372549%);\n  --bs-secondary-bg-subtle: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);\n  --bs-success-bg-subtle: rgb(81.9607843137%, 90.5882352941%, 86.5882352941%);\n  --bs-info-bg-subtle: rgb(81.0196078431%, 95.8431372549%, 98.8235294118%);\n  --bs-warning-bg-subtle: rgb(100%, 95.137254902%, 80.5490196078%);\n  --bs-danger-bg-subtle: rgb(97.2549019608%, 84.1568627451%, 85.4117647059%);\n  --bs-light-bg-subtle: rgb(98.6274509804%, 98.8235294118%, 99.0196078431%);\n  --bs-dark-bg-subtle: #ced4da;\n  --bs-primary-border-subtle: rgb(62.0392156863%, 77.2549019608%, 99.6862745098%);\n  --bs-secondary-border-subtle: rgb(76.9411764706%, 78.3529411765%, 79.6078431373%);\n  --bs-success-border-subtle: rgb(63.9215686275%, 81.1764705882%, 73.1764705882%);\n  --bs-info-border-subtle: rgb(62.0392156863%, 91.6862745098%, 97.6470588235%);\n  --bs-warning-border-subtle: rgb(100%, 90.2745098039%, 61.0980392157%);\n  --bs-danger-border-subtle: rgb(94.5098039216%, 68.3137254902%, 70.8235294118%);\n  --bs-light-border-subtle: #e9ecef;\n  --bs-dark-border-subtle: #adb5bd;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-font-sans-serif: \"Nunito\", sans-serif;\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: \"Nunito\", sans-serif;\n  --bs-body-font-size: 0.9rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #6c757d;\n  --bs-body-color-rgb: 108, 117, 125;\n  --bs-body-bg: #fafbfe;\n  --bs-body-bg-rgb: 250, 251, 254;\n  --bs-emphasis-color: #000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: rgba(33, 37, 41, 0.75);\n  --bs-secondary-color-rgb: 33, 37, 41;\n  --bs-secondary-bg: #e9ecef;\n  --bs-secondary-bg-rgb: 233, 236, 239;\n  --bs-tertiary-color: rgba(33, 37, 41, 0.5);\n  --bs-tertiary-color-rgb: 33, 37, 41;\n  --bs-tertiary-bg: #f8f9fa;\n  --bs-tertiary-bg-rgb: 248, 249, 250;\n  --bs-heading-color: inherit;\n  --bs-link-color: #0d6efd;\n  --bs-link-color-rgb: 13, 110, 253;\n  --bs-link-decoration: none;\n  --bs-link-hover-color: #0a58ca;\n  --bs-link-hover-color-rgb: 10, 88, 202;\n  --bs-code-color: var(--ct-code-color);\n  --bs-highlight-color: #212529;\n  --bs-highlight-bg: var(--ct-mark-bg);\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: var(--ct-border-color);\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.25rem;\n  --bs-border-radius-sm: 0.2rem;\n  --bs-border-radius-lg: 0.3rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-xxl: 2rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: var(--ct-box-shadow);\n  --bs-box-shadow-sm: var(--ct-box-shadow-sm);\n  --bs-box-shadow-lg: var(--ct-box-shadow-lg);\n  --bs-box-shadow-inset: var(--ct-box-shadow-inset);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);\n  --bs-form-valid-color: #198754;\n  --bs-form-valid-border-color: #198754;\n  --bs-form-invalid-color: #dc3545;\n  --bs-form-invalid-border-color: #dc3545;\n}\n\n[data-bs-theme=dark] {\n  color-scheme: dark;\n  --bs-body-color: #dee2e6;\n  --bs-body-color-rgb: 222, 226, 230;\n  --bs-body-bg: #212529;\n  --bs-body-bg-rgb: 33, 37, 41;\n  --bs-emphasis-color: #fff;\n  --bs-emphasis-color-rgb: 255, 255, 255;\n  --bs-secondary-color: rgba(222, 226, 230, 0.75);\n  --bs-secondary-color-rgb: 222, 226, 230;\n  --bs-secondary-bg: #343a40;\n  --bs-secondary-bg-rgb: 52, 58, 64;\n  --bs-tertiary-color: rgba(222, 226, 230, 0.5);\n  --bs-tertiary-color-rgb: 222, 226, 230;\n  --bs-tertiary-bg: rgb(16.6666666667%, 18.6274509804%, 20.5882352941%);\n  --bs-tertiary-bg-rgb: 43, 48, 53;\n  --bs-primary-text-emphasis: rgb(43.0588235294%, 65.8823529412%, 99.5294117647%);\n  --bs-secondary-text-emphasis: rgb(65.4117647059%, 67.5294117647%, 69.4117647059%);\n  --bs-success-text-emphasis: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);\n  --bs-info-text-emphasis: rgb(43.0588235294%, 87.5294117647%, 96.4705882353%);\n  --bs-warning-text-emphasis: rgb(100%, 85.4117647059%, 41.6470588235%);\n  --bs-danger-text-emphasis: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);\n  --bs-light-text-emphasis: #f8f9fa;\n  --bs-dark-text-emphasis: #dee2e6;\n  --bs-primary-bg-subtle: rgb(1.0196078431%, 8.6274509804%, 19.8431372549%);\n  --bs-secondary-bg-subtle: rgb(8.4705882353%, 9.1764705882%, 9.8039215686%);\n  --bs-success-bg-subtle: rgb(1.9607843137%, 10.5882352941%, 6.5882352941%);\n  --bs-info-bg-subtle: rgb(1.0196078431%, 15.8431372549%, 18.8235294118%);\n  --bs-warning-bg-subtle: rgb(20%, 15.137254902%, 0.5490196078%);\n  --bs-danger-bg-subtle: rgb(17.2549019608%, 4.1568627451%, 5.4117647059%);\n  --bs-light-bg-subtle: #343a40;\n  --bs-dark-bg-subtle: #1a1d20;\n  --bs-primary-border-subtle: rgb(3.0588235294%, 25.8823529412%, 59.5294117647%);\n  --bs-secondary-border-subtle: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);\n  --bs-success-border-subtle: rgb(5.8823529412%, 31.7647058824%, 19.7647058824%);\n  --bs-info-border-subtle: rgb(3.0588235294%, 47.5294117647%, 56.4705882353%);\n  --bs-warning-border-subtle: rgb(60%, 45.4117647059%, 1.6470588235%);\n  --bs-danger-border-subtle: rgb(51.7647058824%, 12.4705882353%, 16.2352941176%);\n  --bs-light-border-subtle: #495057;\n  --bs-dark-border-subtle: #343a40;\n  --bs-heading-color: inherit;\n  --bs-link-color: rgb(43.0588235294%, 65.8823529412%, 99.5294117647%);\n  --bs-link-hover-color: rgb(54.4470588235%, 72.7058823529%, 99.6235294118%);\n  --bs-link-color-rgb: 110, 168, 254;\n  --bs-link-hover-color-rgb: 139, 185, 254;\n  --bs-code-color: rgb(90.3529411765%, 52%, 71.0588235294%);\n  --bs-highlight-color: #dee2e6;\n  --bs-highlight-bg: rgb(40%, 30.2745098039%, 1.0980392157%);\n  --bs-border-color: #495057;\n  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);\n  --bs-form-valid-color: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);\n  --bs-form-valid-border-color: rgb(45.8823529412%, 71.7647058824%, 59.7647058824%);\n  --bs-form-invalid-color: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);\n  --bs-form-invalid-border-color: rgb(91.7647058824%, 52.4705882353%, 56.2352941176%);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: 0 solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.75rem;\n  font-weight: 500;\n  line-height: 1.1;\n  color: var(--bs-heading-color);\n}\n\nh1, .h1 {\n  font-size: calc(1.35rem + 1.2vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 2.25rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.3125rem + 0.75vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 1.875rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.5rem;\n  }\n}\n\nh4, .h4 {\n  font-size: 1.125rem;\n}\n\nh5, .h5 {\n  font-size: 0.9375rem;\n}\n\nh6, .h6 {\n  font-size: 0.75rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: 0.75rem;\n}\n\nmark, .mark {\n  padding: 0.2em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: none;\n}\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--ct-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 87.5%;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 87.5%;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: var(--ct-kbd-color);\n  background-color: var(--ct-kbd-bg);\n  border-radius: 0.2rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n  font-weight: 700;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.95rem;\n  padding-bottom: 0.95rem;\n  color: var(--ct-table-caption-color);\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend {\n  line-height: inherit;\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.125rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n.display-1 {\n  font-weight: 300;\n  line-height: 1.1;\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n.display-2 {\n  font-weight: 300;\n  line-height: 1.1;\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n.display-3 {\n  font-weight: 300;\n  line-height: 1.1;\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n.display-4 {\n  font-weight: 300;\n  line-height: 1.1;\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n.display-5 {\n  font-weight: 300;\n  line-height: 1.1;\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n.display-6 {\n  font-weight: 300;\n  line-height: 1.1;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 6px;\n}\n\n.initialism {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1.5rem;\n  font-size: 1.125rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1.5rem;\n  margin-bottom: 1.5rem;\n  font-size: 0.75rem;\n  color: var(--ct-blockquote-footer-color);\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--ct-thumbnail-bg);\n  border: 1px solid var(--ct-thumbnail-border-color);\n  border-radius: 0.25rem;\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.75rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.75rem;\n  color: var(--ct-figure-caption-color);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 12px;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n:root {\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1400px;\n}\n\n.row {\n  --bs-gutter-x: 24px;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.375rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.375rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.75rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.75rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 2.25rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 2.25rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 4.5rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 4.5rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.375rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.375rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 4.5rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 4.5rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.375rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.375rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 4.5rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 4.5rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.375rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.375rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 4.5rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 4.5rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.375rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.375rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 4.5rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 4.5rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.375rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.375rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 4.5rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 4.5rem;\n  }\n}\n.table {\n  --bs-table-color-type: initial;\n  --bs-table-bg-type: initial;\n  --bs-table-color-state: initial;\n  --bs-table-bg-state: initial;\n  --bs-table-color: var(--ct-table-color);\n  --bs-table-bg: var(--ct-table-bg);\n  --bs-table-border-color: var(--ct-table-border-color);\n  --bs-table-accent-bg: var(--ct-table-accent-bg);\n  --bs-table-striped-color: var(--ct-table-striped-color);\n  --bs-table-striped-bg: var(--ct-table-striped-bg);\n  --bs-table-active-color: var(--ct-table-active-color);\n  --bs-table-active-bg: var(--ct-table-active-bg);\n  --bs-table-hover-color: var(--ct-table-hover-color);\n  --bs-table-hover-bg: var(--ct-table-hover-bg);\n  width: 100%;\n  margin-bottom: 1.5rem;\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.95rem 0.95rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(1px * 2) solid var(--ct-table-group-separator-color);\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: 1px 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 1px;\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-active {\n  --bs-table-color-state: var(--bs-table-active-color);\n  --bs-table-bg-state: var(--bs-table-active-bg);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-color-state: var(--bs-table-hover-color);\n  --bs-table-bg-state: var(--bs-table-hover-bg);\n}\n\n.table-primary {\n  --bs-table-color: #313a46;\n  --bs-table-bg: rgb(88.9411764706%, 89.7254901961%, 99.2156862745%);\n  --bs-table-border-color: rgb(81.968627451%, 83.0274509804%, 92.0392156863%);\n  --bs-table-striped-bg: #313a46;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(61.0509803922%, 62.9333333333%, 70.5098039216%);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(83.7117647059%, 84.7019607843%, 93.8333333333%);\n  --bs-table-hover-color: #313a46;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #313a46;\n  --bs-table-bg: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);\n  --bs-table-border-color: rgb(81.5450980392%, 82.5333333333%, 83.568627451%);\n  --bs-table-striped-bg: #313a46;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(60.768627451%, 62.6039215686%, 64.862745098%);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(83.2764705882%, 84.1941176471%, 85.1274509804%);\n  --bs-table-hover-color: #313a46;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #313a46;\n  --bs-table-bg: rgb(80.7843137255%, 96.2352941176%, 91.8431372549%);\n  --bs-table-border-color: rgb(74.6274509804%, 88.8862745098%, 85.4039215686%);\n  --bs-table-striped-bg: #313a46;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(56.1568627451%, 66.8392156863%, 66.0862745098%);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(76.1666666667%, 90.7235294118%, 87.0137254902%);\n  --bs-table-hover-color: #313a46;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #313a46;\n  --bs-table-bg: rgb(84.4705882353%, 93.7254901961%, 96.3921568627%);\n  --bs-table-border-color: rgb(77.9450980392%, 86.6274509804%, 89.4980392157%);\n  --bs-table-striped-bg: #313a46;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(58.368627451%, 65.3333333333%, 68.8156862745%);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(79.5764705882%, 88.4019607843%, 91.2215686275%);\n  --bs-table-hover-color: #313a46;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #313a46;\n  --bs-table-bg: rgb(100%, 94.7450980392%, 80%);\n  --bs-table-border-color: rgb(91.9215686275%, 87.5450980392%, 74.7450980392%);\n  --bs-table-striped-bg: #313a46;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(67.6862745098%, 65.9450980392%, 58.9803921569%);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(93.9411764706%, 89.3450980392%, 76.0588235294%);\n  --bs-table-hover-color: #313a46;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #313a46;\n  --bs-table-bg: rgb(99.6078431373%, 87.2156862745%, 89.7254901961%);\n  --bs-table-border-color: rgb(91.568627451%, 80.768627451%, 83.4980392157%);\n  --bs-table-striped-bg: #313a46;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(67.4509803922%, 61.4274509804%, 64.8156862745%);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(93.5784313725%, 82.3803921569%, 85.0549019608%);\n  --bs-table-hover-color: #313a46;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #313a46;\n  --bs-table-bg: #eef2f7;\n  --bs-table-border-color: rgb(85.9215686275%, 87.6862745098%, 89.9215686275%);\n  --bs-table-striped-bg: #313a46;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(63.6862745098%, 66.0392156863%, 69.0980392157%);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(87.7745098039%, 89.4901960784%, 91.6568627451%);\n  --bs-table-hover-color: #313a46;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #fff;\n  --bs-table-bg: #313a46;\n  --bs-table-border-color: rgb(27.2941176471%, 30.4705882353%, 34.7058823529%);\n  --bs-table-striped-bg: white;\n  --bs-table-striped-color: #313a46;\n  --bs-table-active-bg: rgb(51.5294117647%, 53.6470588235%, 56.4705882353%);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(25.2745098039%, 28.5392156863%, 32.8921568627%);\n  --bs-table-hover-color: #fff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.45rem + 1px);\n  padding-bottom: calc(0.45rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: calc(1.2501rem + 0.0012vw);\n}\n@media (min-width: 1200px) {\n  .col-form-label-lg {\n    font-size: 1.251rem;\n  }\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.28rem + 1px);\n  padding-bottom: calc(0.28rem + 1px);\n  font-size: 0.875rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: var(--ct-form-text-color);\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.9rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--ct-input-color);\n  appearance: none;\n  background-color: var(--ct-input-bg);\n  background-clip: padding-box;\n  border: 1px solid var(--ct-input-border-color);\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: var(--ct-input-focus-color);\n  background-color: var(--ct-input-focus-bg);\n  border-color: var(--ct-input-focus-border-color);\n  outline: 0;\n  box-shadow: none;\n}\n.form-control::-webkit-date-and-time-value {\n  min-width: 85px;\n  height: 1.5em;\n  margin: 0;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::placeholder {\n  color: var(--ct-input-placeholder-color);\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: var(--ct-input-disabled-bg);\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.45rem 0.9rem;\n  margin: -0.45rem -0.9rem;\n  margin-inline-end: 0.9rem;\n  color: var(--ct-form-file-button-color);\n  background-color: var(--ct-form-file-button-bg);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--ct-form-file-button-hover-bg);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.45rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: var(--ct-input-plaintext-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 0.56rem + 2px);\n  padding: 0.28rem 0.8rem;\n  font-size: 0.875rem;\n  border-radius: 0.2rem;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.28rem 0.8rem;\n  margin: -0.28rem -0.8rem;\n  margin-inline-end: 0.8rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: calc(1.2501rem + 0.0012vw);\n}\n@media (min-width: 1200px) {\n  .form-control-lg {\n    font-size: 1.251rem;\n  }\n}\n.form-control-lg {\n  border-radius: 0.3rem;\n}\n.form-control-lg::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 0.9rem + 2px);\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 0.56rem + 2px);\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1rem + 2px);\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 0.9rem + 2px);\n  padding: 0.45rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: 0.25rem;\n}\n.form-control-color::-webkit-color-swatch {\n  border: 0 !important;\n  border-radius: 0.25rem;\n}\n.form-control-color.form-control-sm {\n  height: calc(1.5em + 0.56rem + 2px);\n}\n.form-control-color.form-control-lg {\n  height: calc(1.5em + 1rem + 2px);\n}\n\n.form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%238b96a0' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.45rem 2.7rem 0.45rem 0.9rem;\n  font-size: 0.9rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--ct-form-select-color);\n  appearance: none;\n  background-color: var(--ct-form-select-bg);\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 0.9rem center;\n  background-size: 14px 10px;\n  border: 1px solid var(--ct-input-border-color);\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: var(--ct-input-focus-border-color);\n  outline: 0;\n  box-shadow: none;\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.9rem;\n  background-image: none;\n}\n.form-select:disabled {\n  color: var(--ct-form-select-disabled-color);\n  background-color: var(--ct-form-select-disabled-bg);\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 var(--ct-form-select-color);\n}\n\n.form-select-sm {\n  padding-top: 0.28rem;\n  padding-bottom: 0.28rem;\n  padding-left: 0.8rem;\n  font-size: 0.875rem;\n  border-radius: 0.2rem;\n}\n\n.form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: calc(1.2501rem + 0.0012vw);\n}\n@media (min-width: 1200px) {\n  .form-select-lg {\n    font-size: 1.251rem;\n  }\n}\n.form-select-lg {\n  border-radius: 0.3rem;\n}\n\n[data-bs-theme=dark] .form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dee2e6' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check {\n  display: block;\n  min-height: 1.35rem;\n  padding-left: 1.612em;\n  margin-bottom: 0;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.612em;\n}\n\n.form-check-reverse {\n  padding-right: 1.612em;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -1.612em;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: var(--ct-form-check-input-bg);\n  flex-shrink: 0;\n  width: 1.112em;\n  height: 1.112em;\n  margin-top: 0.194em;\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: var(--ct-form-check-input-border);\n  print-color-adjust: exact;\n  transition: background-color 0.15s ease-in-out, background-position 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-check-input {\n    transition: none;\n  }\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: var(--ct-input-focus-border-color);\n  outline: 0;\n  box-shadow: none;\n}\n.form-check-input:checked {\n  background-color: var(--ct-form-check-input-checked-bg-color);\n  border-color: var(--ct-form-check-input-checked-border-color);\n}\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: var(--ct-component-active-bg);\n  border-color: var(--ct-component-active-bg);\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%238b96a0' opacity='0.5'/%3e%3c/svg%3e\");\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%238b96a0' opacity='0.5'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 2.5em;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -2.5em;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-range {\n  width: 100%;\n  height: 1.4rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fafbfe, none;\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fafbfe, none;\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  appearance: none;\n  background-color: var(--ct-component-active-bg);\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: var(--ct-form-range-thumb-active-bg);\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--ct-form-range-track-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  appearance: none;\n  background-color: var(--ct-component-active-bg);\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: var(--ct-form-range-thumb-active-bg);\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--ct-form-range-track-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--ct-form-range-thumb-disabled-bg);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--ct-form-range-thumb-disabled-bg);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem + 2px);\n  min-height: calc(3.5rem + 2px);\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  height: 100%;\n  padding: 1rem 0.9rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: 1px solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 0.9rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-select ~ label::after {\n  position: absolute;\n  inset: 1rem 0.45rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: var(--ct-input-bg);\n  border-radius: 0.25rem;\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: 1px 0;\n}\n.form-floating > :disabled ~ label,\n.form-floating > .form-control:disabled ~ label {\n  color: #6c757d;\n}\n.form-floating > :disabled ~ label::after,\n.form-floating > .form-control:disabled ~ label::after {\n  background-color: var(--ct-input-disabled-bg);\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.9rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--ct-input-group-addon-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--ct-input-group-addon-bg);\n  border: 1px solid var(--ct-input-group-addon-border-color);\n  border-radius: 0.25rem;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: calc(1.2501rem + 0.0012vw);\n}\n@media (min-width: 1200px) {\n  .input-group-lg > .form-control,\n  .input-group-lg > .form-select,\n  .input-group-lg > .input-group-text,\n  .input-group-lg > .btn {\n    font-size: 1.251rem;\n  }\n}\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  border-radius: 0.3rem;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.28rem 0.8rem;\n  font-size: 0.875rem;\n  border-radius: 0.2rem;\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 3.6rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: calc(1px * -1);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: #0acf97;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.4rem 0.8rem;\n  margin-top: 0.1rem;\n  font-size: 0.8125rem;\n  color: #fff;\n  background-color: rgba(10, 207, 151, 0.9);\n  border-radius: 0.2rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: #0acf97;\n  padding-right: calc(1.5em + 0.9rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%230acf97' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.225rem) center;\n  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: #0acf97;\n  box-shadow: 0 0 0 0.2rem rgba(10, 207, 151, 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.9rem);\n  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: #0acf97;\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%230acf97' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  padding-right: 4.95rem;\n  background-position: right 0.9rem center, center right 2.7rem;\n  background-size: 14px 10px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: #0acf97;\n  box-shadow: 0 0 0 0.2rem rgba(10, 207, 151, 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 0.9rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: #0acf97;\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: #0acf97;\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.2rem rgba(10, 207, 151, 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #0acf97;\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: #fa5c7c;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.4rem 0.8rem;\n  margin-top: 0.1rem;\n  font-size: 0.8125rem;\n  color: #fff;\n  background-color: rgba(250, 92, 124, 0.9);\n  border-radius: 0.2rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: #fa5c7c;\n  padding-right: calc(1.5em + 0.9rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23fa5c7c'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23fa5c7c' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.225rem) center;\n  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: #fa5c7c;\n  box-shadow: 0 0 0 0.2rem rgba(250, 92, 124, 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.9rem);\n  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: #fa5c7c;\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23fa5c7c'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23fa5c7c' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 4.95rem;\n  background-position: right 0.9rem center, center right 2.7rem;\n  background-size: 14px 10px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: #fa5c7c;\n  box-shadow: 0 0 0 0.2rem rgba(250, 92, 124, 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 0.9rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: #fa5c7c;\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: #fa5c7c;\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.2rem rgba(250, 92, 124, 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #fa5c7c;\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 0.9rem;\n  --bs-btn-padding-y: 0.45rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 0.9rem;\n  --bs-btn-font-weight: 400;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: 1px;\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: 0.15rem;\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: 0px 2px 6px 0px;\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0.2rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked:focus-visible + .btn {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n}\n\n.btn-primary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #727cf5;\n  --bs-btn-border-color: #727cf5;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(38%, 41.3333333333%, 81.6666666667%);\n  --bs-btn-hover-border-color: rgb(35.7647058824%, 38.9019607843%, 76.862745098%);\n  --bs-btn-focus-shadow-rgb: 135, 144, 247;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(35.7647058824%, 38.9019607843%, 76.862745098%);\n  --bs-btn-active-border-color: rgb(33.5294117647%, 36.4705882353%, 72.0588235294%);\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #727cf5;\n  --bs-btn-disabled-border-color: #727cf5;\n}\n\n.btn-secondary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #6c757d;\n  --bs-btn-border-color: #6c757d;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(36%, 39%, 41.6666666667%);\n  --bs-btn-hover-border-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);\n  --bs-btn-focus-shadow-rgb: 130, 138, 145;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);\n  --bs-btn-active-border-color: rgb(31.7647058824%, 34.4117647059%, 36.7647058824%);\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #6c757d;\n  --bs-btn-disabled-border-color: #6c757d;\n}\n\n.btn-success {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #0acf97;\n  --bs-btn-border-color: #0acf97;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(3.3333333333%, 69%, 50.3333333333%);\n  --bs-btn-hover-border-color: rgb(3.137254902%, 64.9411764706%, 47.3725490196%);\n  --bs-btn-focus-shadow-rgb: 47, 214, 167;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(3.137254902%, 64.9411764706%, 47.3725490196%);\n  --bs-btn-active-border-color: rgb(2.9411764706%, 60.8823529412%, 44.4117647059%);\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #0acf97;\n  --bs-btn-disabled-border-color: #0acf97;\n}\n\n.btn-info {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #39afd1;\n  --bs-btn-border-color: #39afd1;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(19%, 58.3333333333%, 69.6666666667%);\n  --bs-btn-hover-border-color: rgb(17.8823529412%, 54.9019607843%, 65.568627451%);\n  --bs-btn-focus-shadow-rgb: 87, 187, 216;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(17.8823529412%, 54.9019607843%, 65.568627451%);\n  --bs-btn-active-border-color: rgb(16.7647058824%, 51.4705882353%, 61.4705882353%);\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #39afd1;\n  --bs-btn-disabled-border-color: #39afd1;\n}\n\n.btn-warning {\n  --bs-btn-color: #313a46;\n  --bs-btn-bg: #ffbc00;\n  --bs-btn-border-color: #ffbc00;\n  --bs-btn-hover-color: #313a46;\n  --bs-btn-hover-bg: rgb(100%, 77.6666666667%, 15%);\n  --bs-btn-hover-border-color: rgb(100%, 76.3529411765%, 10%);\n  --bs-btn-focus-shadow-rgb: 224, 168, 11;\n  --bs-btn-active-color: #313a46;\n  --bs-btn-active-bg: rgb(100%, 78.9803921569%, 20%);\n  --bs-btn-active-border-color: rgb(100%, 76.3529411765%, 10%);\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #313a46;\n  --bs-btn-disabled-bg: #ffbc00;\n  --bs-btn-disabled-border-color: #ffbc00;\n}\n\n.btn-danger {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #fa5c7c;\n  --bs-btn-border-color: #fa5c7c;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(83.3333333333%, 30.6666666667%, 41.3333333333%);\n  --bs-btn-hover-border-color: rgb(78.431372549%, 28.862745098%, 38.9019607843%);\n  --bs-btn-focus-shadow-rgb: 251, 116, 144;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(78.431372549%, 28.862745098%, 38.9019607843%);\n  --bs-btn-active-border-color: rgb(73.5294117647%, 27.0588235294%, 36.4705882353%);\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #fa5c7c;\n  --bs-btn-disabled-border-color: #fa5c7c;\n}\n\n.btn-light {\n  --bs-btn-color: #313a46;\n  --bs-btn-bg: #eef2f7;\n  --bs-btn-border-color: #eef2f7;\n  --bs-btn-hover-color: #313a46;\n  --bs-btn-hover-bg: rgb(79.3333333333%, 80.6666666667%, 82.3333333333%);\n  --bs-btn-hover-border-color: rgb(74.6666666667%, 75.9215686275%, 77.4901960784%);\n  --bs-btn-focus-shadow-rgb: 210, 214, 220;\n  --bs-btn-active-color: #313a46;\n  --bs-btn-active-bg: rgb(74.6666666667%, 75.9215686275%, 77.4901960784%);\n  --bs-btn-active-border-color: rgb(70%, 71.1764705882%, 72.6470588235%);\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #313a46;\n  --bs-btn-disabled-bg: #eef2f7;\n  --bs-btn-disabled-border-color: #eef2f7;\n}\n\n.btn-dark {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #313a46;\n  --bs-btn-border-color: #313a46;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(31.3333333333%, 34.3333333333%, 38.3333333333%);\n  --bs-btn-hover-border-color: rgb(27.2941176471%, 30.4705882353%, 34.7058823529%);\n  --bs-btn-focus-shadow-rgb: 80, 88, 98;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(35.3725490196%, 38.1960784314%, 41.9607843137%);\n  --bs-btn-active-border-color: rgb(27.2941176471%, 30.4705882353%, 34.7058823529%);\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #313a46;\n  --bs-btn-disabled-border-color: #313a46;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #727cf5;\n  --bs-btn-border-color: #727cf5;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #727cf5;\n  --bs-btn-hover-border-color: #727cf5;\n  --bs-btn-focus-shadow-rgb: 114, 124, 245;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #727cf5;\n  --bs-btn-active-border-color: #727cf5;\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #727cf5;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #727cf5;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #6c757d;\n  --bs-btn-border-color: #6c757d;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #6c757d;\n  --bs-btn-hover-border-color: #6c757d;\n  --bs-btn-focus-shadow-rgb: 108, 117, 125;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #6c757d;\n  --bs-btn-active-border-color: #6c757d;\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #6c757d;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #0acf97;\n  --bs-btn-border-color: #0acf97;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0acf97;\n  --bs-btn-hover-border-color: #0acf97;\n  --bs-btn-focus-shadow-rgb: 10, 207, 151;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0acf97;\n  --bs-btn-active-border-color: #0acf97;\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #0acf97;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0acf97;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #39afd1;\n  --bs-btn-border-color: #39afd1;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #39afd1;\n  --bs-btn-hover-border-color: #39afd1;\n  --bs-btn-focus-shadow-rgb: 57, 175, 209;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #39afd1;\n  --bs-btn-active-border-color: #39afd1;\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #39afd1;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #39afd1;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #ffbc00;\n  --bs-btn-border-color: #ffbc00;\n  --bs-btn-hover-color: #313a46;\n  --bs-btn-hover-bg: #ffbc00;\n  --bs-btn-hover-border-color: #ffbc00;\n  --bs-btn-focus-shadow-rgb: 255, 188, 0;\n  --bs-btn-active-color: #313a46;\n  --bs-btn-active-bg: #ffbc00;\n  --bs-btn-active-border-color: #ffbc00;\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #ffbc00;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffbc00;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #fa5c7c;\n  --bs-btn-border-color: #fa5c7c;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #fa5c7c;\n  --bs-btn-hover-border-color: #fa5c7c;\n  --bs-btn-focus-shadow-rgb: 250, 92, 124;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #fa5c7c;\n  --bs-btn-active-border-color: #fa5c7c;\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #fa5c7c;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #fa5c7c;\n  --bs-gradient: none;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #eef2f7;\n  --bs-btn-border-color: #eef2f7;\n  --bs-btn-hover-color: #313a46;\n  --bs-btn-hover-bg: #eef2f7;\n  --bs-btn-hover-border-color: #eef2f7;\n  --bs-btn-focus-shadow-rgb: 238, 242, 247;\n  --bs-btn-active-color: #313a46;\n  --bs-btn-active-bg: #eef2f7;\n  --bs-btn-active-border-color: #eef2f7;\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #eef2f7;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #eef2f7;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #313a46;\n  --bs-btn-border-color: #313a46;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #313a46;\n  --bs-btn-hover-border-color: #313a46;\n  --bs-btn-focus-shadow-rgb: 49, 58, 70;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #313a46;\n  --bs-btn-active-border-color: #313a46;\n  --bs-btn-active-shadow: var(--ct-btn-active-box-shadow);\n  --bs-btn-disabled-color: #313a46;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #313a46;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: var(--ct-btn-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--ct-btn-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--ct-btn-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: var(--ct-btn-link-disabled-color);\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: 0 0 0 #000;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  text-decoration: none;\n}\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.5rem;\n  --bs-btn-padding-x: 1rem;\n  --bs-btn-font-size: calc(1.2501rem + 0.0012vw);\n}\n@media (min-width: 1200px) {\n  .btn-lg, .btn-group-lg > .btn {\n    --bs-btn-font-size: 1.251rem;\n  }\n}\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-border-radius: 0.15rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.28rem;\n  --bs-btn-padding-x: 0.8rem;\n  --bs-btn-font-size: 0.875rem;\n  --bs-btn-border-radius: 0.15rem;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.2125em;\n  vertical-align: 0.2125em;\n  content: \"\";\n  border-top: 0.25em solid;\n  border-right: 0.25em solid transparent;\n  border-bottom: 0;\n  border-left: 0.25em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.25rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 0.9rem;\n  --bs-dropdown-color: var(--ct-dropdown-color);\n  --bs-dropdown-bg: var(--ct-dropdown-bg);\n  --bs-dropdown-border-color: var(--ct-dropdown-border-color);\n  --bs-dropdown-border-radius: 0.25rem;\n  --bs-dropdown-border-width: 1px;\n  --bs-dropdown-inner-border-radius: calc(0.25rem - 1px);\n  --bs-dropdown-divider-bg: var(--ct-dropdown-divider-bg);\n  --bs-dropdown-divider-margin-y: 0.75rem;\n  --bs-dropdown-box-shadow: var(--ct-dropdown-box-shadow);\n  --bs-dropdown-link-color: var(--ct-dropdown-link-color);\n  --bs-dropdown-link-hover-color: var(--ct-dropdown-link-hover-color);\n  --bs-dropdown-link-hover-bg: var(--ct-dropdown-link-hover-bg);\n  --bs-dropdown-link-active-color: var(--ct-dropdown-link-active-color);\n  --bs-dropdown-link-active-bg: var(--ct-dropdown-link-active-bg);\n  --bs-dropdown-link-disabled-color: var(--ct-dropdown-link-disabled-color);\n  --bs-dropdown-item-padding-x: 1.5rem;\n  --bs-dropdown-item-padding-y: 0.375rem;\n  --bs-dropdown-header-color: inherit;\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.2125em;\n  vertical-align: 0.2125em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.25em solid transparent;\n  border-bottom: 0.25em solid;\n  border-left: 0.25em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.2125em;\n  vertical-align: 0.2125em;\n  content: \"\";\n  border-top: 0.25em solid transparent;\n  border-right: 0;\n  border-bottom: 0.25em solid transparent;\n  border-left: 0.25em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.2125em;\n  vertical-align: 0.2125em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.2125em;\n  vertical-align: 0.2125em;\n  content: \"\";\n  border-top: 0.25em solid transparent;\n  border-right: 0.25em solid;\n  border-bottom: 0.25em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: var(--ct-dropdown-dark-color);\n  --bs-dropdown-bg: var(--ct-dropdown-dark-bg);\n  --bs-dropdown-border-color: var(--ct-dropdown-dark-border-color);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: var(--ct-dropdown-dark-link-color);\n  --bs-dropdown-link-hover-color: var(--ct-dropdown-dark-link-hover-color);\n  --bs-dropdown-divider-bg: var(--ct-dropdown-dark-divider-bg);\n  --bs-dropdown-link-hover-bg: var(--ct-dropdown-dark-link-hover-bg);\n  --bs-dropdown-link-active-color: var(--ct-dropdown-dark-link-active-color);\n  --bs-dropdown-link-active-bg: var(--ct-dropdown-dark-link-active-bg);\n  --bs-dropdown-link-disabled-color: var(--ct-dropdown-dark-link-disabled-color);\n  --bs-dropdown-header-color: var(--ct-dropdown-dark-header-color);\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: 0.15rem;\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: calc(1px * -1);\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.675rem;\n  padding-left: 0.675rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.6rem;\n  padding-left: 0.6rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: calc(1px * -1);\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 1rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: var(--ct-nav-link-disabled-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  background: none;\n  border: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-link:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.nav-link.disabled, .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: 1px;\n  --bs-nav-tabs-border-color: var(--ct-nav-tabs-border-color);\n  --bs-nav-tabs-border-radius: 0.25rem;\n  --bs-nav-tabs-link-hover-border-color: var(--ct-nav-tabs-link-hover-border-color);\n  --bs-nav-tabs-link-active-color: var(--ct-nav-tabs-link-active-color);\n  --bs-nav-tabs-link-active-bg: var(--ct-nav-tabs-link-active-bg);\n  --bs-nav-tabs-link-active-border-color: var(--ct-nav-tabs-link-active-border-color);\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: 0.25rem;\n  --bs-nav-pills-link-active-color: var(--ct-component-active-color);\n  --bs-nav-pills-link-active-bg: var(--ct-component-active-bg);\n}\n.nav-pills .nav-link {\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-underline {\n  --bs-nav-underline-gap: 1rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n}\n.nav-underline .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n}\n.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {\n  border-bottom-color: currentcolor;\n}\n.nav-underline .nav-link.active,\n.nav-underline .show > .nav-link {\n  font-weight: 700;\n  color: var(--bs-nav-underline-link-active-color);\n  border-bottom-color: currentcolor;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.75rem;\n  --bs-navbar-color: var(--ct-navbar-light-color);\n  --bs-navbar-hover-color: var(--ct-navbar-light-hover-color);\n  --bs-navbar-disabled-color: var(--ct-navbar-light-disabled-color);\n  --bs-navbar-active-color: var(--ct-navbar-light-active-color);\n  --bs-navbar-brand-padding-y: 0.23675rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1.251rem;\n  --bs-navbar-brand-color: var(--ct-navbar-light-active-color);\n  --bs-navbar-brand-hover-color: var(--ct-navbar-light-active-color);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1.251rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='var%28--ct-navbar-light-color%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);\n  --bs-navbar-toggler-border-radius: 0.15rem;\n  --bs-navbar-toggler-focus-width: 0.2rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n  --bs-navbar-color: var(--ct-navbar-dark-color);\n  --bs-navbar-hover-color: var(--ct-navbar-dark-hover-color);\n  --bs-navbar-disabled-color: var(--ct-navbar-dark-disabled-color);\n  --bs-navbar-active-color: var(--ct-navbar-dark-active-color);\n  --bs-navbar-brand-color: var(--ct-navbar-dark-active-color);\n  --bs-navbar-brand-hover-color: var(--ct-navbar-dark-active-color);\n  --bs-navbar-toggler-border-color: var(--ct-navbar-dark-toggler-border-color);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='var%28--ct-navbar-dark-color%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .navbar-toggler-icon {\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='var%28--ct-navbar-dark-color%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1.5rem;\n  --bs-card-spacer-x: 1.5rem;\n  --bs-card-title-spacer-y: 0.75rem;\n  --bs-card-title-color: ;\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: 1px;\n  --bs-card-border-color: var(--ct-card-border-color);\n  --bs-card-border-radius: 0.25rem;\n  --bs-card-box-shadow: var(--ct-card-box-shadow);\n  --bs-card-inner-border-radius: calc(0.25rem - 1px);\n  --bs-card-cap-padding-y: 0.75rem;\n  --bs-card-cap-padding-x: 1.5rem;\n  --bs-card-cap-bg: var(--ct-card-cap-bg);\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: var(--ct-card-bg);\n  --bs-card-img-overlay-padding: 1.25rem;\n  --bs-card-group-margin: 12px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: var(--ct-accordion-color);\n  --bs-accordion-bg: transparent;\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: var(--ct-accordion-border-color);\n  --bs-accordion-border-width: 1px;\n  --bs-accordion-border-radius: 0.25rem;\n  --bs-accordion-inner-border-radius: calc(0.25rem - 1px);\n  --bs-accordion-btn-padding-x: 1.25rem;\n  --bs-accordion-btn-padding-y: 1rem;\n  --bs-accordion-btn-color: var(--ct-accordion-color);\n  --bs-accordion-btn-bg: transparent;\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='var%28--ct-accordion-color%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.25rem;\n  --bs-accordion-btn-icon-transform: rotate(180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='var%28--ct-accordion-button-active-color%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-box-shadow: var(--ct-accordion-button-focus-box-shadow);\n  --bs-accordion-body-padding-x: 1.25rem;\n  --bs-accordion-body-padding-y: 1rem;\n  --bs-accordion-active-color: var(--ct-accordion-button-active-color);\n  --bs-accordion-active-bg: var(--ct-accordion-button-active-bg);\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 0.9rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type > .accordion-header .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type > .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush > .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush > .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush > .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {\n  border-radius: 0;\n}\n.accordion-flush > .accordion-item > .accordion-collapse {\n  border-radius: 0;\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2843.0588235294%, 65.8823529412%, 99.5294117647%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2843.0588235294%, 65.8823529412%, 99.5294117647%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 1.5rem;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: var(--ct-breadcrumb-divider-color);\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: var(--ct-breadcrumb-active-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"\\f0142\") /* rtl: var(--bs-breadcrumb-divider, \"\\f0142\") */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 1rem;\n  --bs-pagination-color: var(--ct-pagination-color);\n  --bs-pagination-bg: var(--ct-pagination-bg);\n  --bs-pagination-border-width: 1px;\n  --bs-pagination-border-color: var(--ct-pagination-border-color);\n  --bs-pagination-border-radius: 0.25rem;\n  --bs-pagination-hover-color: var(--ct-pagination-hover-color);\n  --bs-pagination-hover-bg: var(--ct-pagination-hover-bg);\n  --bs-pagination-hover-border-color: var(--ct-pagination-hover-border-color);\n  --bs-pagination-focus-color: var(--ct-pagination-focus-color);\n  --bs-pagination-focus-bg: var(--ct-pagination-focus-bg);\n  --bs-pagination-focus-box-shadow: var(--ct-pagination-focus-box-shadow);\n  --bs-pagination-active-color: var(--ct-component-active-color);\n  --bs-pagination-active-bg: var(--ct-component-active-bg);\n  --bs-pagination-active-border-color: var(--ct-component-active-bg);\n  --bs-pagination-disabled-color: var(--ct-pagination-disabled-color);\n  --bs-pagination-disabled-bg: var(--ct-pagination-disabled-bg);\n  --bs-pagination-disabled-border-color: var(--ct-pagination-disabled-border-color);\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: -1px;\n}\n.page-item .page-link {\n  border-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: calc(1.2501rem + 0.0012vw);\n}\n@media (min-width: 1200px) {\n  .pagination-lg {\n    --bs-pagination-font-size: 1.251rem;\n  }\n}\n.pagination-lg {\n  --bs-pagination-border-radius: 0.3rem;\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.875rem;\n  --bs-pagination-border-radius: 0.2rem;\n}\n\n.badge {\n  --bs-badge-padding-x: 0.4em;\n  --bs-badge-padding-y: 0.25em;\n  --bs-badge-font-size: 0.75em;\n  --bs-badge-font-weight: 700;\n  --bs-badge-color: var(--ct-badge-color);\n  --bs-badge-border-radius: 0.25rem;\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1.25rem;\n  --bs-alert-padding-y: 0.75rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: 1px solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: 0.25rem;\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3.75rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 0.9375rem 1.25rem;\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text-emphasis);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text-emphasis);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text-emphasis);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text-emphasis);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text-emphasis);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text-emphasis);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text-emphasis);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text-emphasis);\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text-emphasis);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text-emphasis);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text-emphasis);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text-emphasis);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.progress,\n.progress-stacked {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.675rem;\n  --bs-progress-bg: var(--ct-progress-bg);\n  --bs-progress-border-radius: 0.25rem;\n  --bs-progress-box-shadow: var(--ct-progress-box-shadow);\n  --bs-progress-bar-color: var(--ct-progress-bar-color);\n  --bs-progress-bar-bg: var(--ct-progress-bar-bg);\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: var(--ct-list-group-color);\n  --bs-list-group-bg: var(--ct-list-group-bg);\n  --bs-list-group-border-color: var(--ct-list-group-border-color);\n  --bs-list-group-border-width: 1px;\n  --bs-list-group-border-radius: 0.25rem;\n  --bs-list-group-item-padding-x: 1.2rem;\n  --bs-list-group-item-padding-y: 0.75rem;\n  --bs-list-group-action-color: var(--ct-list-group-action-color);\n  --bs-list-group-action-hover-color: var(--ct-list-group-action-color);\n  --bs-list-group-action-hover-bg: var(--ct-list-group-hover-bg);\n  --bs-list-group-action-active-color: var(--ct-list-group-action-active-color);\n  --bs-list-group-action-active-bg: var(--ct-list-group-action-active-bg);\n  --bs-list-group-disabled-color: var(--ct-list-group-disabled-color);\n  --bs-list-group-disabled-bg: var(--ct-list-group-disabled-bg);\n  --bs-list-group-active-color: var(--ct-component-active-color);\n  --bs-list-group-active-bg: var(--ct-component-active-bg);\n  --bs-list-group-active-border-color: var(--ct-component-active-bg);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text-emphasis);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text-emphasis);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n}\n\n.btn-close {\n  --bs-btn-close-color: var(--ct-btn-close-color);\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%238b96a0'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 1;\n  --bs-btn-close-hover-opacity: 0.8;\n  --bs-btn-close-focus-shadow: none;\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.25rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n[data-bs-theme=dark] .btn-close {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 12px;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: inherit;\n  --bs-toast-bg: var(--ct-toast-background-color);\n  --bs-toast-border-width: 1px;\n  --bs-toast-border-color: var(--ct-toast-border-color);\n  --bs-toast-border-radius: 0.25rem;\n  --bs-toast-box-shadow: var(--ct-box-shadow);\n  --bs-toast-header-color: inherit;\n  --bs-toast-header-bg: var(--ct-toast-header-background-color);\n  --bs-toast-header-border-color: var(--ct-toast-header-border-color);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: ;\n  --bs-modal-bg: var(--ct-modal-content-bg);\n  --bs-modal-border-color: transparent;\n  --bs-modal-border-width: 1px;\n  --bs-modal-border-radius: 0.2rem;\n  --bs-modal-box-shadow: var(--ct-modal-content-box-shadow-xs);\n  --bs-modal-inner-border-radius: calc(0.2rem - 1px);\n  --bs-modal-header-padding-x: 1rem;\n  --bs-modal-header-padding-y: 1rem;\n  --bs-modal-header-padding: 1rem 1rem;\n  --bs-modal-header-border-color: var(--ct-modal-header-border-color);\n  --bs-modal-header-border-width: 1px;\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--ct-modal-footer-border-color);\n  --bs-modal-footer-border-width: 1px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.fade .modal-dialog {\n  transform: translate(0, -50px);\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: var(--ct-modal-backdrop-bg);\n  --bs-backdrop-opacity: 0.7;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: var(--ct-modal-content-box-shadow-sm-up);\n  }\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 0.8rem;\n  --bs-tooltip-padding-y: 0.4rem;\n  --bs-tooltip-margin: 0;\n  --bs-tooltip-font-size: 0.8125rem;\n  --bs-tooltip-color: var(--ct-tooltip-color);\n  --bs-tooltip-bg: var(--ct-tooltip-bg);\n  --bs-tooltip-border-radius: 0.2rem;\n  --bs-tooltip-opacity: 0.9;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  margin: var(--bs-tooltip-margin);\n  font-family: \"Nunito\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 0.875rem;\n  --bs-popover-bg: var(--ct-popover-bg);\n  --bs-popover-border-width: 1px;\n  --bs-popover-border-color: var(--ct-popover-border-color);\n  --bs-popover-border-radius: 0.3rem;\n  --bs-popover-inner-border-radius: calc(0.3rem - 1px);\n  --bs-popover-box-shadow: var(--ct-box-shadow);\n  --bs-popover-header-padding-x: 0.8rem;\n  --bs-popover-header-padding-y: 0.7rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: var(--ct-popover-header-color);\n  --bs-popover-header-bg: var(--ct-popover-header-bg);\n  --bs-popover-body-padding-x: 0.75rem;\n  --bs-popover-body-padding-y: 0.5rem;\n  --bs-popover-body-color: var(--ct-popover-body-color);\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: \"Nunito\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: var(--ct-carousel-control-color);\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: var(--ct-carousel-control-color);\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: var(--ct-carousel-indicator-active-bg);\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: var(--ct-carousel-caption-color);\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: var(--ct-carousel-dark-indicator-active-bg);\n}\n.carousel-dark .carousel-caption {\n  color: var(--ct-carousel-dark-caption-color);\n}\n\n[data-bs-theme=dark] .carousel .carousel-control-prev-icon,\n[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,\n[data-bs-theme=dark].carousel .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {\n  background-color: var(--ct-carousel-dark-indicator-active-bg);\n}\n[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {\n  color: var(--ct-carousel-dark-caption-color);\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.25em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    --bs-spinner-animation-speed: 1.5s;\n  }\n}\n.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1rem;\n  --bs-offcanvas-padding-y: 1rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: var(--ct-modal-content-bg);\n  --bs-offcanvas-border-width: 1px;\n  --bs-offcanvas-border-color: transparent;\n  --bs-offcanvas-box-shadow: var(--ct-modal-content-box-shadow-xs);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.5;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  transition: var(--bs-offcanvas-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--ct-modal-backdrop-bg);\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.7;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--bs-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-primary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #313a46 !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #313a46 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(97, 105, 208, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(97, 105, 208, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(92, 99, 106, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(92, 99, 106, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(9, 176, 128, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(9, 176, 128, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(48, 149, 178, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(48, 149, 178, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(255, 198, 38, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 198, 38, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(213, 78, 105, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(213, 78, 105, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(241, 244, 248, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(241, 244, 248, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(42, 49, 60, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(42, 49, 60, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-0 {\n  border-width: 0 !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.375rem !important;\n}\n\n.m-2 {\n  margin: 0.75rem !important;\n}\n\n.m-3 {\n  margin: 1.5rem !important;\n}\n\n.m-4 {\n  margin: 2.25rem !important;\n}\n\n.m-5 {\n  margin: 4.5rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.375rem !important;\n  margin-left: 0.375rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.75rem !important;\n  margin-left: 0.75rem !important;\n}\n\n.mx-3 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-4 {\n  margin-right: 2.25rem !important;\n  margin-left: 2.25rem !important;\n}\n\n.mx-5 {\n  margin-right: 4.5rem !important;\n  margin-left: 4.5rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.375rem !important;\n  margin-bottom: 0.375rem !important;\n}\n\n.my-2 {\n  margin-top: 0.75rem !important;\n  margin-bottom: 0.75rem !important;\n}\n\n.my-3 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-4 {\n  margin-top: 2.25rem !important;\n  margin-bottom: 2.25rem !important;\n}\n\n.my-5 {\n  margin-top: 4.5rem !important;\n  margin-bottom: 4.5rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.375rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.75rem !important;\n}\n\n.mt-3 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-4 {\n  margin-top: 2.25rem !important;\n}\n\n.mt-5 {\n  margin-top: 4.5rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.375rem !important;\n}\n\n.me-2 {\n  margin-right: 0.75rem !important;\n}\n\n.me-3 {\n  margin-right: 1.5rem !important;\n}\n\n.me-4 {\n  margin-right: 2.25rem !important;\n}\n\n.me-5 {\n  margin-right: 4.5rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.375rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.75rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 2.25rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 4.5rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.375rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.75rem !important;\n}\n\n.ms-3 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-4 {\n  margin-left: 2.25rem !important;\n}\n\n.ms-5 {\n  margin-left: 4.5rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.m-n1 {\n  margin: -0.375rem !important;\n}\n\n.m-n2 {\n  margin: -0.75rem !important;\n}\n\n.m-n3 {\n  margin: -1.5rem !important;\n}\n\n.m-n4 {\n  margin: -2.25rem !important;\n}\n\n.m-n5 {\n  margin: -4.5rem !important;\n}\n\n.mx-n1 {\n  margin-right: -0.375rem !important;\n  margin-left: -0.375rem !important;\n}\n\n.mx-n2 {\n  margin-right: -0.75rem !important;\n  margin-left: -0.75rem !important;\n}\n\n.mx-n3 {\n  margin-right: -1.5rem !important;\n  margin-left: -1.5rem !important;\n}\n\n.mx-n4 {\n  margin-right: -2.25rem !important;\n  margin-left: -2.25rem !important;\n}\n\n.mx-n5 {\n  margin-right: -4.5rem !important;\n  margin-left: -4.5rem !important;\n}\n\n.my-n1 {\n  margin-top: -0.375rem !important;\n  margin-bottom: -0.375rem !important;\n}\n\n.my-n2 {\n  margin-top: -0.75rem !important;\n  margin-bottom: -0.75rem !important;\n}\n\n.my-n3 {\n  margin-top: -1.5rem !important;\n  margin-bottom: -1.5rem !important;\n}\n\n.my-n4 {\n  margin-top: -2.25rem !important;\n  margin-bottom: -2.25rem !important;\n}\n\n.my-n5 {\n  margin-top: -4.5rem !important;\n  margin-bottom: -4.5rem !important;\n}\n\n.mt-n1 {\n  margin-top: -0.375rem !important;\n}\n\n.mt-n2 {\n  margin-top: -0.75rem !important;\n}\n\n.mt-n3 {\n  margin-top: -1.5rem !important;\n}\n\n.mt-n4 {\n  margin-top: -2.25rem !important;\n}\n\n.mt-n5 {\n  margin-top: -4.5rem !important;\n}\n\n.me-n1 {\n  margin-right: -0.375rem !important;\n}\n\n.me-n2 {\n  margin-right: -0.75rem !important;\n}\n\n.me-n3 {\n  margin-right: -1.5rem !important;\n}\n\n.me-n4 {\n  margin-right: -2.25rem !important;\n}\n\n.me-n5 {\n  margin-right: -4.5rem !important;\n}\n\n.mb-n1 {\n  margin-bottom: -0.375rem !important;\n}\n\n.mb-n2 {\n  margin-bottom: -0.75rem !important;\n}\n\n.mb-n3 {\n  margin-bottom: -1.5rem !important;\n}\n\n.mb-n4 {\n  margin-bottom: -2.25rem !important;\n}\n\n.mb-n5 {\n  margin-bottom: -4.5rem !important;\n}\n\n.ms-n1 {\n  margin-left: -0.375rem !important;\n}\n\n.ms-n2 {\n  margin-left: -0.75rem !important;\n}\n\n.ms-n3 {\n  margin-left: -1.5rem !important;\n}\n\n.ms-n4 {\n  margin-left: -2.25rem !important;\n}\n\n.ms-n5 {\n  margin-left: -4.5rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.375rem !important;\n}\n\n.p-2 {\n  padding: 0.75rem !important;\n}\n\n.p-3 {\n  padding: 1.5rem !important;\n}\n\n.p-4 {\n  padding: 2.25rem !important;\n}\n\n.p-5 {\n  padding: 4.5rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.375rem !important;\n  padding-left: 0.375rem !important;\n}\n\n.px-2 {\n  padding-right: 0.75rem !important;\n  padding-left: 0.75rem !important;\n}\n\n.px-3 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-4 {\n  padding-right: 2.25rem !important;\n  padding-left: 2.25rem !important;\n}\n\n.px-5 {\n  padding-right: 4.5rem !important;\n  padding-left: 4.5rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.375rem !important;\n  padding-bottom: 0.375rem !important;\n}\n\n.py-2 {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}\n\n.py-3 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-4 {\n  padding-top: 2.25rem !important;\n  padding-bottom: 2.25rem !important;\n}\n\n.py-5 {\n  padding-top: 4.5rem !important;\n  padding-bottom: 4.5rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.375rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.75rem !important;\n}\n\n.pt-3 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-4 {\n  padding-top: 2.25rem !important;\n}\n\n.pt-5 {\n  padding-top: 4.5rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.375rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.75rem !important;\n}\n\n.pe-3 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-4 {\n  padding-right: 2.25rem !important;\n}\n\n.pe-5 {\n  padding-right: 4.5rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.375rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.75rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 2.25rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 4.5rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.375rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.75rem !important;\n}\n\n.ps-3 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-4 {\n  padding-left: 2.25rem !important;\n}\n\n.ps-5 {\n  padding-left: 4.5rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.375rem !important;\n}\n\n.gap-2 {\n  gap: 0.75rem !important;\n}\n\n.gap-3 {\n  gap: 1.5rem !important;\n}\n\n.gap-4 {\n  gap: 2.25rem !important;\n}\n\n.gap-5 {\n  gap: 4.5rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.375rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.75rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 2.25rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 4.5rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.375rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.75rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 2.25rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 4.5rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.35rem + 1.2vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.3125rem + 0.75vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-4 {\n  font-size: 1.125rem !important;\n}\n\n.fs-5 {\n  font-size: 0.9375rem !important;\n}\n\n.fs-6 {\n  font-size: 0.75rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.375rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.75rem !important;\n  }\n  .m-sm-3 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-4 {\n    margin: 2.25rem !important;\n  }\n  .m-sm-5 {\n    margin: 4.5rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .m-sm-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-sm-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-sm-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-sm-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-sm-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-sm-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-sm-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-sm-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-sm-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-sm-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-sm-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-sm-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-sm-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-sm-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-sm-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-sm-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-sm-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-sm-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-sm-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-sm-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-sm-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-sm-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-sm-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-sm-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-sm-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-sm-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-sm-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-sm-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-sm-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-sm-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-sm-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-sm-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-sm-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-sm-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.375rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.75rem !important;\n  }\n  .p-sm-3 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-4 {\n    padding: 2.25rem !important;\n  }\n  .p-sm-5 {\n    padding: 4.5rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 4.5rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-sm-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-sm-5 {\n    gap: 4.5rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 0.375rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 4.5rem !important;\n  }\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-1 {\n    column-gap: 0.375rem !important;\n  }\n  .column-gap-sm-2 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-sm-3 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-4 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-sm-5 {\n    column-gap: 4.5rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.375rem !important;\n  }\n  .m-md-2 {\n    margin: 0.75rem !important;\n  }\n  .m-md-3 {\n    margin: 1.5rem !important;\n  }\n  .m-md-4 {\n    margin: 2.25rem !important;\n  }\n  .m-md-5 {\n    margin: 4.5rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-md-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-md-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-md-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-md-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .m-md-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-md-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-md-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-md-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-md-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-md-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-md-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-md-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-md-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-md-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-md-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-md-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-md-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-md-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-md-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-md-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-md-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-md-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-md-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-md-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-md-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-md-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-md-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-md-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-md-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-md-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-md-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-md-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-md-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-md-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-md-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-md-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-md-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-md-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.375rem !important;\n  }\n  .p-md-2 {\n    padding: 0.75rem !important;\n  }\n  .p-md-3 {\n    padding: 1.5rem !important;\n  }\n  .p-md-4 {\n    padding: 2.25rem !important;\n  }\n  .p-md-5 {\n    padding: 4.5rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-md-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-md-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-md-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-md-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 4.5rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-md-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-md-5 {\n    gap: 4.5rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 0.375rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 4.5rem !important;\n  }\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-md-1 {\n    column-gap: 0.375rem !important;\n  }\n  .column-gap-md-2 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-md-3 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-4 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-md-5 {\n    column-gap: 4.5rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.375rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.75rem !important;\n  }\n  .m-lg-3 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-4 {\n    margin: 2.25rem !important;\n  }\n  .m-lg-5 {\n    margin: 4.5rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .m-lg-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-lg-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-lg-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-lg-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-lg-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-lg-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-lg-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-lg-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-lg-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-lg-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-lg-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-lg-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-lg-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-lg-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-lg-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-lg-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-lg-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-lg-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-lg-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-lg-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-lg-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-lg-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-lg-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-lg-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-lg-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-lg-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-lg-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-lg-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-lg-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-lg-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-lg-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-lg-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-lg-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-lg-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.375rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.75rem !important;\n  }\n  .p-lg-3 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-4 {\n    padding: 2.25rem !important;\n  }\n  .p-lg-5 {\n    padding: 4.5rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 4.5rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-lg-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-lg-5 {\n    gap: 4.5rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 0.375rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 4.5rem !important;\n  }\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-1 {\n    column-gap: 0.375rem !important;\n  }\n  .column-gap-lg-2 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-lg-3 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-4 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-lg-5 {\n    column-gap: 4.5rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.375rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.75rem !important;\n  }\n  .m-xl-3 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-4 {\n    margin: 2.25rem !important;\n  }\n  .m-xl-5 {\n    margin: 4.5rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .m-xl-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-xl-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-xl-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-xl-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-xl-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-xl-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-xl-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xl-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-xl-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-xl-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-xl-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-xl-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xl-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-xl-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-xl-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-xl-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-xl-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xl-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-xl-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-xl-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-xl-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-xl-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xl-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-xl-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-xl-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-xl-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-xl-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xl-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-xl-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-xl-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-xl-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-xl-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xl-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-xl-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.375rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.75rem !important;\n  }\n  .p-xl-3 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-4 {\n    padding: 2.25rem !important;\n  }\n  .p-xl-5 {\n    padding: 4.5rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 4.5rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-xl-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-xl-5 {\n    gap: 4.5rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 0.375rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 4.5rem !important;\n  }\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-1 {\n    column-gap: 0.375rem !important;\n  }\n  .column-gap-xl-2 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-xl-3 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-4 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-xl-5 {\n    column-gap: 4.5rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.375rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.75rem !important;\n  }\n  .m-xxl-3 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-4 {\n    margin: 2.25rem !important;\n  }\n  .m-xxl-5 {\n    margin: 4.5rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .m-xxl-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-xxl-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-xxl-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-xxl-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-xxl-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-xxl-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-xxl-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-xxl-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xxl-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-xxl-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-xxl-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-xxl-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-xxl-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xxl-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-xxl-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-xxl-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-xxl-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-xxl-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xxl-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-xxl-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-xxl-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-xxl-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-xxl-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xxl-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-xxl-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-xxl-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-xxl-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-xxl-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xxl-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-xxl-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-xxl-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-xxl-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-xxl-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xxl-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-xxl-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.375rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.75rem !important;\n  }\n  .p-xxl-3 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-4 {\n    padding: 2.25rem !important;\n  }\n  .p-xxl-5 {\n    padding: 4.5rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 4.5rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 4.5rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 0.375rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 4.5rem !important;\n  }\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-1 {\n    column-gap: 0.375rem !important;\n  }\n  .column-gap-xxl-2 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-xxl-3 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-4 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-xxl-5 {\n    column-gap: 4.5rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.25rem !important;\n  }\n  .fs-2 {\n    font-size: 1.875rem !important;\n  }\n  .fs-3 {\n    font-size: 1.5rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\nbody {\n  overflow-x: hidden;\n}\n\n@supports (-webkit-overflow-scrolling: touch) {\n  body {\n    cursor: pointer;\n  }\n}\n.logo {\n  display: block;\n  line-height: 70px;\n  width: 260px;\n  position: fixed;\n  top: 0;\n}\n.logo span.logo-lg {\n  display: block;\n}\n.logo span.logo-sm {\n  display: none;\n}\n.logo.logo-light {\n  display: block;\n}\n.logo.logo-dark {\n  display: none;\n}\n\n.wrapper {\n  height: 100%;\n  width: 100%;\n}\n\n.content-page {\n  margin-left: 260px;\n  min-height: 100vh;\n}\n\n.leftside-menu {\n  width: 260px;\n  z-index: 10;\n  background: var(--ct-bg-leftbar-gradient);\n  bottom: 0;\n  position: fixed;\n  top: 0;\n  padding-top: 70px;\n  box-shadow: var(--ct-box-shadow);\n}\n\n.side-nav {\n  padding-left: 0;\n  list-style-type: none;\n}\n.side-nav ul {\n  list-style-type: none;\n}\n.side-nav .side-nav-link {\n  color: var(--ct-menu-item);\n  display: block;\n  padding: 10px 30px;\n  font-size: 0.8375rem;\n  position: relative;\n  transition: all 0.4s;\n  list-style: none;\n  font-weight: 500 !important;\n}\n.side-nav .side-nav-link:hover, .side-nav .side-nav-link:focus, .side-nav .side-nav-link:active {\n  color: var(--ct-menu-item-hover);\n  text-decoration: none;\n}\n.side-nav .side-nav-link span {\n  vertical-align: middle;\n}\n.side-nav .side-nav-link i {\n  display: inline-block;\n  line-height: 1.0625rem;\n  margin: 0 10px 0 0;\n  font-size: 1.1rem;\n  vertical-align: middle;\n  width: 20px;\n}\n.side-nav .menu-arrow {\n  transition: transform 0.15s;\n  position: absolute;\n  right: 30px;\n  display: inline-block;\n  font-family: \"Material Design Icons\";\n  text-rendering: auto;\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  transform: translate(0, 0);\n}\n.side-nav .menu-arrow:before {\n  content: \"\\f0142\";\n}\n.side-nav .badge {\n  margin-top: 3px;\n}\n.side-nav .side-nav-item > a[aria-expanded=true] > span.menu-arrow {\n  transform: rotate(90deg);\n}\n.side-nav .side-nav-item.menuitem-active > a:not(.collapsed) > span.menu-arrow {\n  transform: rotate(90deg);\n}\n.side-nav .side-nav-title {\n  padding: 12px 30px;\n  letter-spacing: 0.05em;\n  pointer-events: none;\n  cursor: default;\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n  color: var(--ct-menu-item);\n  font-weight: 700;\n}\n.side-nav .menuitem-active > a {\n  color: var(--ct-menu-item-active) !important;\n}\n\n*[dir=ltr] .side-nav .side-nav-item .menu-arrow:before {\n  content: \"\\f0141\" !important;\n}\n\n.side-nav-second-level,\n.side-nav-third-level,\n.side-nav-forth-level {\n  padding-left: 0;\n}\n.side-nav-second-level li a,\n.side-nav-second-level li .side-nav-link,\n.side-nav-third-level li a,\n.side-nav-third-level li .side-nav-link,\n.side-nav-forth-level li a,\n.side-nav-forth-level li .side-nav-link {\n  padding: 8px 30px 8px 65px;\n  color: var(--ct-menu-item);\n  display: block;\n  position: relative;\n  transition: all 0.4s;\n  font-size: 0.89rem;\n}\n.side-nav-second-level li a:focus, .side-nav-second-level li a:hover,\n.side-nav-second-level li .side-nav-link:focus,\n.side-nav-second-level li .side-nav-link:hover,\n.side-nav-third-level li a:focus,\n.side-nav-third-level li a:hover,\n.side-nav-third-level li .side-nav-link:focus,\n.side-nav-third-level li .side-nav-link:hover,\n.side-nav-forth-level li a:focus,\n.side-nav-forth-level li a:hover,\n.side-nav-forth-level li .side-nav-link:focus,\n.side-nav-forth-level li .side-nav-link:hover {\n  color: var(--ct-menu-item-hover);\n}\n.side-nav-second-level li a .menu-arrow,\n.side-nav-second-level li .side-nav-link .menu-arrow,\n.side-nav-third-level li a .menu-arrow,\n.side-nav-third-level li .side-nav-link .menu-arrow,\n.side-nav-forth-level li a .menu-arrow,\n.side-nav-forth-level li .side-nav-link .menu-arrow {\n  line-height: 1.3rem;\n}\n.side-nav-second-level li.active > a,\n.side-nav-third-level li.active > a,\n.side-nav-forth-level li.active > a {\n  color: var(--ct-menu-item-active);\n}\n\n.side-nav-third-level li a,\n.side-nav-third-level li .side-nav-link {\n  padding: 8px 30px 8px 80px;\n}\n\n.side-nav-forth-level li a,\n.side-nav-forth-level li .side-nav-link {\n  padding: 8px 30px 8px 100px;\n}\n\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) {\n  min-height: 1600px;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .leftside-menu {\n  position: absolute;\n  padding-top: 0;\n  width: 70px;\n  z-index: 5;\n  padding-top: 70px;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .leftside-menu .simplebar-mask,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .leftside-menu .simplebar-content-wrapper {\n  overflow: visible !important;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .leftside-menu .simplebar-scrollbar {\n  display: none !important;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .leftside-menu .simplebar-offset {\n  bottom: 0 !important;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .leftside-menu .logo {\n  width: 70px;\n  z-index: 1;\n  background: var(--ct-bg-leftbar-gradient);\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .help-box {\n  display: none;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .content-page {\n  margin-left: 70px;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .navbar-custom,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .wrapper .footer {\n  left: 70px;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-title,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .badge,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .menu-arrow {\n  display: none !important;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapse,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapsing {\n  display: none;\n  height: inherit !important;\n  transition: none !important;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapse .side-nav-second-level,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapse .side-nav-third-level,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapse .side-nav-forth-level,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapsing .side-nav-second-level,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapsing .side-nav-third-level,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .collapsing .side-nav-forth-level {\n  display: none !important;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item {\n  position: relative;\n  white-space: nowrap;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item .side-nav-link {\n  padding: 15px 20px;\n  min-height: 54px;\n  transition: none;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item .side-nav-link:hover, body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item .side-nav-link:active, body[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item .side-nav-link:focus {\n  color: var(--ct-menu-item-hover);\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item .side-nav-link i {\n  font-size: 1.125rem;\n  margin-right: 20px;\n  margin-left: 6px;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item .side-nav-link span {\n  display: none;\n  padding-left: 10px;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover .side-nav-link {\n  position: relative;\n  width: 260px;\n  color: #fff;\n  background: var(--ct-bg-leftbar-gradient);\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover .side-nav-link span {\n  display: inline;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > ul {\n  display: block !important;\n  left: 70px;\n  position: absolute;\n  width: 190px;\n  height: auto !important;\n  padding: 5px 0;\n  z-index: 9999;\n  background: var(--ct-bg-leftbar-gradient);\n  box-shadow: var(--ct-box-shadow);\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > ul a {\n  padding: 8px 20px;\n  position: relative;\n  width: 190px;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > ul a:hover {\n  color: var(--ct-menu-item-hover);\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapse,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapsing {\n  display: block !important;\n  transition: none !important;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapse > ul,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapsing > ul {\n  display: block !important;\n  left: 70px;\n  position: absolute;\n  width: 190px;\n  background: var(--ct-bg-leftbar-gradient);\n  box-shadow: var(--ct-box-shadow);\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapse > ul a,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapsing > ul a {\n  box-shadow: none;\n  padding: 8px 20px;\n  position: relative;\n  width: 190px;\n  z-index: 6;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapse > ul a:hover,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapsing > ul a:hover {\n  color: var(--ct-menu-item-hover);\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapse > ul li:hover > .collapse,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapsing > ul li:hover > .collapse {\n  display: block !important;\n  height: auto !important;\n  transition: none !important;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapse > ul li:hover > .collapse > ul,\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .side-nav .side-nav-item:hover > .collapsing > ul li:hover > .collapse > ul {\n  display: block;\n  left: 190px;\n  top: 0;\n  position: absolute;\n  width: 190px;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .logo span.logo-lg {\n  display: none;\n}\nbody[data-leftbar-compact-mode=condensed]:not(.authentication-bg) .logo span.logo-sm {\n  display: block;\n  line-height: 70px;\n  color: #727cf5;\n}\n\n@media (max-width: 767.98px) {\n  body {\n    overflow-x: hidden;\n  }\n  .leftside-menu {\n    box-shadow: var(--ct-box-shadow);\n    display: none;\n    z-index: 10 !important;\n  }\n  .sidebar-enable .leftside-menu {\n    display: block;\n  }\n  .navbar-nav.navbar-right {\n    float: right;\n  }\n  .content-page {\n    margin-left: 0 !important;\n    padding: 65px 10px 65px;\n  }\n  body[data-leftbar-compact-mode=condensed] .leftside-menu {\n    margin-left: 0px;\n  }\n  .logo span.logo-lg {\n    display: block;\n  }\n  .logo span.logo-sm {\n    display: none;\n  }\n}\n.help-box {\n  border-radius: 5px;\n  padding: 20px;\n  margin: 65px 25px 25px;\n  position: relative;\n  background-color: var(--ct-help-box-light-bg);\n}\n.help-box .close-btn {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\nbody[data-leftbar-theme=light] .help-box {\n  background-color: #727cf5;\n}\nbody[data-leftbar-theme=light] .logo.logo-light {\n  display: none;\n}\nbody[data-leftbar-theme=light] .logo.logo-dark {\n  display: block;\n}\n\nbody[data-layout=topnav] .content-page {\n  margin-left: 0 !important;\n  padding: 0 0 60px 0;\n}\n\nbody[data-layout-mode=boxed] {\n  background-color: var(--ct-boxed-layout-bg);\n}\nbody[data-layout-mode=boxed] .wrapper {\n  max-width: 1300px;\n  margin: 0 auto;\n  background-color: #fafbfe;\n  box-shadow: var(--ct-box-shadow);\n}\nbody[data-layout-mode=boxed][data-leftbar-compact-mode=condensed] .logo {\n  position: relative;\n  margin-top: -70px;\n}\n\n@media (min-width: 1200px) {\n  body[data-leftbar-compact-mode=scrollable]:not([data-layout=topnav]) {\n    padding-bottom: 0;\n  }\n  body[data-leftbar-compact-mode=scrollable]:not([data-layout=topnav]) .wrapper {\n    display: flex;\n  }\n  body[data-leftbar-compact-mode=scrollable]:not([data-layout=topnav]) .leftside-menu {\n    position: relative;\n    min-width: 260px;\n    max-width: 260px;\n    padding-top: 0;\n  }\n  body[data-leftbar-compact-mode=scrollable]:not([data-layout=topnav]) .logo {\n    position: relative;\n    margin-top: 0;\n  }\n  body[data-leftbar-compact-mode=scrollable]:not([data-layout=topnav]) .content-page {\n    margin-left: 0;\n    width: 100%;\n    padding-bottom: 60px;\n  }\n}\nbody[data-layout=detached] {\n  padding-bottom: 0;\n}\n@media (min-width: 992px) {\n  body[data-layout=detached] .container-fluid, body[data-layout=detached] .container-sm, body[data-layout=detached] .container-md, body[data-layout=detached] .container-lg, body[data-layout=detached] .container-xl, body[data-layout=detached] .container-xxl {\n    max-width: 95%;\n  }\n}\nbody[data-layout=detached][data-layout-mode=boxed] .wrapper {\n  max-width: 100%;\n}\nbody[data-layout=detached] .wrapper {\n  display: flex;\n  overflow: inherit;\n}\nbody[data-layout=detached] .content-page {\n  margin-left: 0;\n  overflow: hidden;\n  padding: 0 15px 5px 30px;\n  position: relative;\n  margin-right: -15px;\n  width: 100%;\n  padding-bottom: 60px;\n}\nbody[data-layout=detached] .leftside-menu {\n  position: relative;\n  background: var(--ct-bg-detached-leftbar) !important;\n  min-width: 260px;\n  max-width: 260px;\n  box-shadow: var(--ct-box-shadow);\n  margin-top: 30px;\n  padding-top: 0 !important;\n  z-index: 1001 !important;\n}\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-link {\n  color: var(--ct-menu-item) !important;\n}\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-link:hover, body[data-layout=detached] .leftside-menu .side-nav .side-nav-link:focus, body[data-layout=detached] .leftside-menu .side-nav .side-nav-link:active {\n  color: var(--ct-menu-item-hover) !important;\n}\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-second-level li a,\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-third-level li a,\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-forth-level li a {\n  color: var(--ct-menu-item);\n}\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-second-level li a:focus, body[data-layout=detached] .leftside-menu .side-nav .side-nav-second-level li a:hover,\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-third-level li a:focus,\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-third-level li a:hover,\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-forth-level li a:focus,\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-forth-level li a:hover {\n  color: var(--ct-menu-item-hover);\n}\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-second-level li.mm-active > a,\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-third-level li.mm-active > a,\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-forth-level li.mm-active > a {\n  color: var(--ct-menu-item-active);\n}\nbody[data-layout=detached] .leftside-menu .side-nav .menuitem-active > a {\n  color: var(--ct-menu-item-active) !important;\n}\nbody[data-layout=detached] .leftside-menu .side-nav .side-nav-title {\n  color: var(--ct-menu-item);\n}\nbody[data-layout=detached] .leftbar-user {\n  background: url(\"../../../images/waves.png\") no-repeat;\n  padding: 30px 20px;\n  text-align: center;\n}\nbody[data-layout=detached] .leftbar-user .leftbar-user-name {\n  font-weight: 700;\n  color: #313a46;\n  margin-left: 12px;\n  margin-top: 8px;\n  display: block;\n}\n@media (max-width: 767.98px) {\n  body[data-layout=detached].sidebar-enable .leftside-menu {\n    position: fixed;\n    left: 0;\n    overflow-y: auto;\n    margin-top: 70px;\n  }\n  body[data-layout=detached] .wrapper {\n    max-width: 100%;\n  }\n  body[data-layout=detached] .content-page {\n    margin-left: 0 !important;\n    padding: 0 10px 60px 10px;\n  }\n  body[data-layout=detached] .lang-switch {\n    display: none;\n  }\n  body[data-layout=detached][data-leftbar-compact-mode=condensed].sidebar-enable .leftside-menu {\n    margin-top: 0px;\n  }\n}\nbody[data-layout=detached][data-leftbar-compact-mode=condensed] .wrapper .leftside-menu {\n  max-width: 70px;\n  min-width: 70px;\n  position: relative;\n}\nbody[data-layout=detached][data-leftbar-compact-mode=condensed] .wrapper .leftbar-user {\n  display: none;\n}\nbody[data-layout=detached][data-leftbar-compact-mode=condensed] .wrapper .content-page {\n  margin-left: 0;\n}\nbody[data-layout=detached][data-leftbar-compact-mode=condensed] .wrapper .footer {\n  left: 0;\n}\nbody[data-layout=detached][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:hover, body[data-layout=detached][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:active, body[data-layout=detached][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:focus {\n  color: var(--ct-menu-item-hover);\n}\nbody[data-layout=detached][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover .side-nav-link {\n  background: #727cf5;\n  color: #fff !important;\n  transition: none;\n}\nbody[data-layout=detached][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover ul {\n  background: var(--ct-bg-leftbar) !important;\n  box-shadow: var(--ct-box-shadow);\n}\nbody[data-layout=detached][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover ul a:hover {\n  color: var(--ct-menu-item-hover) !important;\n}\n\n@media (min-width: 992px) {\n  body[data-layout=detached][data-leftbar-compact-mode=scrollable] .wrapper {\n    padding-top: 70px;\n  }\n}\n.button-menu-mobile .lines {\n  width: 18px;\n  display: block;\n  position: relative;\n  height: 16px;\n  transition: all 0.5s ease;\n  margin-top: 26px;\n  margin-left: 10px;\n}\n.button-menu-mobile span {\n  height: 2px;\n  width: 100%;\n  background-color: rgba(255, 255, 255, 0.8);\n  display: block;\n  margin-bottom: 5px;\n  transition: transform 0.5s ease;\n}\n.button-menu-mobile span:nth-of-type(2) {\n  width: 24px;\n}\n.button-menu-mobile.disable-btn {\n  display: none;\n}\n\nbody[data-leftbar-theme=light] .leftside-menu {\n  background: var(--ct-bg-leftbar);\n}\nbody[data-leftbar-theme=light] .leftside-menu .logo {\n  background: var(--ct-bg-leftbar) !important;\n}\nbody[data-leftbar-theme=light] .side-nav .side-nav-link {\n  color: var(--ct-menu-item);\n}\nbody[data-leftbar-theme=light] .side-nav .side-nav-link:hover, body[data-leftbar-theme=light] .side-nav .side-nav-link:focus, body[data-leftbar-theme=light] .side-nav .side-nav-link:active {\n  color: var(--ct-menu-item-hover);\n}\nbody[data-leftbar-theme=light] .side-nav .menuitem-active > a {\n  color: var(--ct-menu-item-active) !important;\n}\nbody[data-leftbar-theme=light] .side-nav .side-nav-title {\n  color: var(--ct-menu-item);\n}\nbody[data-leftbar-theme=light] .side-nav .side-nav-second-level li a,\nbody[data-leftbar-theme=light] .side-nav .side-nav-third-level li a,\nbody[data-leftbar-theme=light] .side-nav .side-nav-forth-level li a {\n  color: var(--ct-menu-item);\n}\nbody[data-leftbar-theme=light] .side-nav .side-nav-second-level li a:focus, body[data-leftbar-theme=light] .side-nav .side-nav-second-level li a:hover,\nbody[data-leftbar-theme=light] .side-nav .side-nav-third-level li a:focus,\nbody[data-leftbar-theme=light] .side-nav .side-nav-third-level li a:hover,\nbody[data-leftbar-theme=light] .side-nav .side-nav-forth-level li a:focus,\nbody[data-leftbar-theme=light] .side-nav .side-nav-forth-level li a:hover {\n  color: var(--ct-menu-item-hover);\n}\nbody[data-leftbar-theme=light] .side-nav .side-nav-second-level li.active > a,\nbody[data-leftbar-theme=light] .side-nav .side-nav-third-level li.active > a,\nbody[data-leftbar-theme=light] .side-nav .side-nav-forth-level li.active > a {\n  color: var(--ct-menu-item-active);\n}\nbody[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:hover, body[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:active, body[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:focus {\n  color: var(--ct-menu-item-hover);\n}\nbody[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover .side-nav-link {\n  background: #727cf5;\n  color: #fff !important;\n  transition: none;\n}\nbody[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > ul {\n  background: var(--ct-bg-leftbar);\n  box-shadow: var(--ct-box-shadow);\n}\nbody[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > ul a:hover {\n  color: var(--ct-menu-item-hover);\n}\nbody[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > .collapse > ul,\nbody[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > .collapsing > ul {\n  background: var(--ct-bg-leftbar);\n}\nbody[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > .collapse > ul a:hover,\nbody[data-leftbar-theme=light][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > .collapsing > ul a:hover {\n  color: var(--ct-menu-item-hover);\n}\n\nbody[data-leftbar-theme=dark] .leftside-menu {\n  background: #313A46 !important;\n}\nbody[data-leftbar-theme=dark] .leftside-menu .logo {\n  background: #313A46 !important;\n}\nbody[data-leftbar-theme=dark] .side-nav .side-nav-link {\n  color: var(--ct-dark-menu-item);\n}\nbody[data-leftbar-theme=dark] .side-nav .side-nav-link:hover, body[data-leftbar-theme=dark] .side-nav .side-nav-link:focus, body[data-leftbar-theme=dark] .side-nav .side-nav-link:active {\n  color: var(--ct-dark-menu-item-hover);\n}\nbody[data-leftbar-theme=dark] .side-nav .menuitem-active > a {\n  color: rgba(236, 172, 55, 0.8901960784) !important;\n  font-weight: 700 !important;\n}\nbody[data-leftbar-theme=dark] .side-nav .side-nav-title {\n  color: var(--ct-dark-menu-item);\n}\nbody[data-leftbar-theme=dark] .side-nav .side-nav-second-level li a,\nbody[data-leftbar-theme=dark] .side-nav .side-nav-third-level li a,\nbody[data-leftbar-theme=dark] .side-nav .side-nav-forth-level li a {\n  color: var(--ct-dark-menu-item);\n}\nbody[data-leftbar-theme=dark] .side-nav .side-nav-second-level li a:focus, body[data-leftbar-theme=dark] .side-nav .side-nav-second-level li a:hover,\nbody[data-leftbar-theme=dark] .side-nav .side-nav-third-level li a:focus,\nbody[data-leftbar-theme=dark] .side-nav .side-nav-third-level li a:hover,\nbody[data-leftbar-theme=dark] .side-nav .side-nav-forth-level li a:focus,\nbody[data-leftbar-theme=dark] .side-nav .side-nav-forth-level li a:hover {\n  color: var(--ct-dark-menu-item-hover);\n}\nbody[data-leftbar-theme=dark] .side-nav .side-nav-second-level li.active > a,\nbody[data-leftbar-theme=dark] .side-nav .side-nav-third-level li.active > a,\nbody[data-leftbar-theme=dark] .side-nav .side-nav-forth-level li.active > a {\n  color: var(--ct-dark-menu-item-active);\n}\nbody[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:hover, body[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:active, body[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item .side-nav-link:focus {\n  color: var(--ct-dark-menu-item-hover);\n}\nbody[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover .side-nav-link {\n  background: #727cf5;\n  color: #fff !important;\n  transition: none;\n}\nbody[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > ul {\n  background: var(--ct-bg-leftbar);\n  box-shadow: var(--ct-box-shadow);\n}\nbody[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > ul a:hover {\n  color: var(--ct-dark-menu-item-hover);\n}\nbody[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > .collapse > ul,\nbody[data-leftbar-theme=dark][data-leftbar-compact-mode=condensed] .side-nav .side-nav-item:hover > .collapsing > ul {\n  background: var(--ct-bg-leftbar);\n}\n\nbody[data-layout=full] .navbar-custom .button-menu-mobile.disable-btn {\n  display: block;\n}\nbody[data-layout=full].hide-menu .wrapper .leftside-menu {\n  width: 0 !important;\n  padding-top: 0;\n}\nbody[data-layout=full].hide-menu .wrapper .leftside-menu .side-nav {\n  opacity: 0.2;\n}\nbody[data-layout=full].hide-menu .wrapper .leftside-menu .logo {\n  width: 70px;\n  background: var(--ct-bg-leftbar-gradient) !important;\n}\nbody[data-layout=full].hide-menu .wrapper .leftside-menu .logo span.logo-lg {\n  display: none;\n}\nbody[data-layout=full].hide-menu .wrapper .leftside-menu .logo span.logo-sm {\n  display: block;\n}\nbody[data-layout=full].hide-menu .content-page {\n  margin-left: 0 !important;\n}\nbody[data-layout=full].hide-menu .content-page .navbar-custom {\n  left: 70px;\n}\nbody[data-layout=full].hide-menu .content-page .footer {\n  left: 0 !important;\n}\nbody[data-layout=full].hide-menu[data-leftbar-compact-mode=condensed] .wrapper .leftside-menu {\n  padding-top: 70px;\n}\nbody[data-layout=full].hide-menu[data-leftbar-compact-mode=condensed] .wrapper .leftside-menu .side-nav {\n  transform: translateX(-50px);\n  visibility: hidden;\n}\nbody[data-layout=full][data-leftbar-compact-mode=scrollable].hide-menu .wrapper .leftside-menu {\n  max-width: 0px;\n  min-width: 0px;\n}\nbody[data-layout=full][data-leftbar-compact-mode=scrollable] .wrapper .leftside-menu {\n  padding-top: 0 !important;\n}\nbody[data-layout=full][data-leftbar-theme=dark].hide-menu .wrapper .leftside-menu .logo {\n  background: var(--ct-bg-leftbar) !important;\n}\nbody[data-layout=full][data-leftbar-theme=light].hide-menu .wrapper .leftside-menu .logo {\n  background: var(--ct-bg-leftbar) !important;\n}\n\nbody[data-layout-color=dark][data-layout-mode=boxed] .wrapper {\n  background-color: var(--ct-body-bg);\n}\nbody[data-layout-color=dark][data-layout=detached] .leftbar-user .leftbar-user-name {\n  color: #f1f1f1;\n}\n\n.navbar-custom {\n  padding: 0 24px;\n  background-color: var(--ct-bg-topbar);\n  box-shadow: var(--ct-box-shadow);\n  height: \"50px!important\";\n  position: fixed;\n  left: 260px;\n  top: 0;\n  right: 0;\n  z-index: 1001;\n}\n.navbar-custom .topbar-left {\n  background-color: var(--ct-bg-topbar);\n  height: 70px;\n  position: fixed;\n  z-index: 1;\n  width: 260px;\n  text-align: center;\n  top: 0;\n  left: 0;\n}\n.navbar-custom .topbar-left .logo {\n  line-height: 70px;\n}\n.navbar-custom .topbar-left .logo i {\n  display: none;\n}\n.navbar-custom .topbar-menu {\n  position: relative;\n  z-index: 1;\n}\n.navbar-custom .topbar-menu li {\n  float: left;\n  max-height: 70px;\n}\n.navbar-custom .topbar-menu li .show.nav-link {\n  color: #6c757d;\n}\n.navbar-custom .topbar-menu .nav-link {\n  padding: 0;\n  color: #98a6ad;\n  min-width: 32px;\n  display: block;\n  text-align: center;\n  margin: 0 10px;\n  position: relative;\n}\n.navbar-custom .app-search {\n  position: static;\n  overflow-y: hidden;\n  padding: calc(32px / 2) 5px calc(32px / 2) 0;\n}\n.navbar-custom .app-search .react-select__control,\n.navbar-custom .app-search .react-select__menu {\n  overflow: hidden;\n  width: 320px !important;\n}\n.navbar-custom .app-search .react-select__control .react-select__option.react-select__option--is-selected .dropdown-item,\n.navbar-custom .app-search .react-select__menu .react-select__option.react-select__option--is-selected .dropdown-item {\n  color: rgba(var(--ct-input-color), 0.7) !important;\n}\n.navbar-custom .app-search .react-select__control .react-select__value-container .react-select__placeholder,\n.navbar-custom .app-search .react-select__menu .react-select__value-container .react-select__placeholder {\n  color: var(--ct-input-color) !important;\n}\n.navbar-custom .app-search .react-select__control .react-select__value-container .react-select__input-container,\n.navbar-custom .app-search .react-select__menu .react-select__value-container .react-select__input-container {\n  color: var(--ct-input-color) !important;\n}\n.navbar-custom .app-search .react-select__control .react-select__value-container .react-select__input-container .react-select__input,\n.navbar-custom .app-search .react-select__menu .react-select__value-container .react-select__input-container .react-select__input {\n  color: var(--ct-input-color) !important;\n}\n\n.topbar-dropdown .nav-link {\n  line-height: 70px;\n}\n\n/* Search */\n.app-search .react-select__control {\n  border: none;\n  height: calc(1.5em + 0.9rem + 2px);\n  padding-left: 40px;\n  background-color: var(--ct-bg-topbar-search);\n  box-shadow: none;\n}\n.app-search .react-select__value-container {\n  padding: 0;\n}\n.app-search .react-select__menu {\n  margin-top: 0;\n}\n.app-search span.search-icon {\n  position: absolute;\n  z-index: 9;\n  font-size: 20px;\n  line-height: 38px;\n  left: 10px;\n  top: 0;\n}\n\n.app-search .form-control {\n  border: none;\n  height: calc(1.5em + 0.9rem + 2px);\n  padding-left: 40px;\n  padding-right: 20px;\n  background-color: var(--ct-bg-topbar-search);\n  box-shadow: none;\n}\n.app-search span.search-icon {\n  position: absolute;\n  z-index: 4;\n  font-size: 20px;\n  line-height: 38px;\n  left: 10px;\n  top: 0;\n}\n.app-search .input-group-text {\n  margin-left: 0;\n  z-index: 4;\n}\n\n/* Notification */\n.notification-list {\n  margin-left: 0;\n}\n.notification-list .noti-title {\n  background-color: transparent;\n  padding: 15px 20px;\n}\n.notification-list .noti-icon {\n  font-size: 22px;\n  vertical-align: middle;\n  line-height: 70px;\n}\n.notification-list .noti-icon-badge {\n  display: inline-block;\n  position: absolute;\n  top: 22px;\n  right: 6px;\n  border-radius: 50%;\n  height: 7px;\n  width: 7px;\n  background-color: #fa5c7c;\n}\n.notification-list .notify-item {\n  padding: 10px 20px;\n}\n.notification-list .notify-item.unread-noti {\n  background-color: rgb(95.3333333333%, 96%, 98.3333333333%);\n}\n.notification-list .notify-item.read-noti {\n  background-color: transparent;\n  border: 1px solid #eef2f7;\n}\n.notification-list .notify-item .card-body {\n  padding: 14px;\n}\n.notification-list .notify-item .card-body .noti-close-btn {\n  position: absolute;\n  top: 3px;\n  right: 5px;\n}\n.notification-list .notify-item .card-body .noti-item-title {\n  margin: 0 0 2px;\n}\n.notification-list .notify-item .card-body .noti-item-title,\n.notification-list .notify-item .card-body .noti-item-subtitle {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.notification-list .notify-item .notify-icon {\n  float: left;\n  height: 36px;\n  width: 36px;\n  line-height: 36px;\n  text-align: center;\n  border-radius: 50%;\n  color: #fff;\n}\n.notification-list .notify-item .notify-details {\n  margin-bottom: 0;\n  overflow: hidden;\n  margin-left: 45px;\n}\n.notification-list .notify-item .notify-details b {\n  font-weight: 500;\n}\n.notification-list .notify-item .notify-details small, .notification-list .notify-item .notify-details .small {\n  display: block;\n}\n.notification-list .notify-item .user-msg {\n  margin-left: 45px;\n  white-space: normal;\n  line-height: 16px;\n}\n.notification-list .topbar-dropdown-menu .notify-item {\n  padding: 7px 20px;\n}\n\n.profile-dropdown {\n  min-width: 170px;\n}\n.profile-dropdown i,\n.profile-dropdown span {\n  vertical-align: middle;\n}\n\n.nav-user {\n  padding: 0px 0px 0px 61px !important;\n  text-align: left !important;\n  position: relative;\n  border-width: 0 1px;\n}\n.nav-user .account-user-avatar {\n  position: absolute;\n  top: calc(70px -8px * 0.5);\n  left: 15px;\n}\n.nav-user .account-user-avatar img {\n  height: 32px;\n  width: 32px;\n}\n.nav-user .account-position {\n  display: block;\n  font-size: 12px;\n  margin-top: -3px;\n}\n.nav-user .account-user-name {\n  display: block;\n  font-weight: 600;\n}\n\n.button-menu-mobile {\n  border: none;\n  color: #313a46;\n  height: 70px;\n  line-height: 70px;\n  width: 60px;\n  background-color: transparent;\n  font-size: 24px;\n  cursor: pointer;\n  float: left;\n  z-index: 1;\n  position: relative;\n  margin-left: -24px;\n}\n.button-menu-mobile.disable-btn {\n  display: none;\n}\n@media (max-width: 767.98px) {\n  .button-menu-mobile {\n    margin: 0 !important;\n  }\n}\n\n[data-keep-enlarged=true] .navbar-custom {\n  padding-left: 0;\n}\n[data-keep-enlarged=true] .button-menu-mobile {\n  margin: 0;\n}\n[data-keep-enlarged=true] .button-menu-mobile.disable-btn {\n  display: inline-block;\n}\n\n@media (max-width: 576px) {\n  .navbar-custom .topbar-menu {\n    position: initial;\n  }\n  .navbar-custom .dropdown {\n    position: static;\n  }\n  .navbar-custom .dropdown .dropdown-menu {\n    left: 10px !important;\n    right: 10px !important;\n  }\n}\n@media (max-width: 1200px) {\n  .navbar-custom {\n    right: 0;\n  }\n  .navbar-custom .app-search {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .nav-user {\n    padding: 17px 5px 17px 57px !important;\n  }\n  .nav-user .account-position,\n  .nav-user .account-user-name {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .navbar-custom {\n    left: 0 !important;\n    padding: 0;\n  }\n  .button-menu-mobile.disable-btn {\n    display: inline-block;\n  }\n}\n@media (max-width: 375px) {\n  .navbar-custom .topbar-menu .nav-link {\n    margin: 0 5px;\n  }\n  .navbar-custom.topnav-navbar .container-fluid, .navbar-custom.topnav-navbar .container-sm, .navbar-custom.topnav-navbar .container-md, .navbar-custom.topnav-navbar .container-lg, .navbar-custom.topnav-navbar .container-xl, .navbar-custom.topnav-navbar .container-xxl {\n    padding-right: 12px;\n    padding-left: 12px;\n  }\n  .navbar-custom.topnav-navbar .navbar-toggle {\n    margin: 27px 3px;\n  }\n  .navbar-custom.topnav-navbar .button-menu-mobile {\n    width: auto;\n  }\n}\n@media (min-width: 992px) {\n  body[data-leftbar-compact-mode=scrollable]:not([data-layout-mode=boxed]):not([data-layout=topnav]) .navbar-custom {\n    position: absolute;\n  }\n}\n.topnav-navbar-dark {\n  background-color: var(--ct-bg-dark-topbar);\n}\n.topnav-navbar-dark .nav-user {\n  background-color: var(--ct-nav-user-bg-dark-topbar) !important;\n  border: 1px solid var(--ct-nav-user-border-dark-topbar) !important;\n}\n.topnav-navbar-dark .topbar-menu li .show.nav-link {\n  color: #fff !important;\n}\n.topnav-navbar-dark .app-search .react-select__control {\n  background-color: var(--ct-bg-dark-topbar-search);\n  color: #fff;\n}\n.topnav-navbar-dark .app-search .react-select__input {\n  color: #fff;\n}\n.topnav-navbar-dark .app-search span,\n.topnav-navbar-dark .app-search .react-select__placeholder {\n  color: #98a6ad;\n}\n.topnav-navbar-dark .navbar-toggle span {\n  background-color: rgba(255, 255, 255, 0.8) !important;\n}\n\nbody[data-layout-mode=boxed] .navbar-custom {\n  position: relative;\n  left: 0 !important;\n  margin: -70px -12px 0;\n}\nbody[data-layout-mode=boxed][data-layout=topnav] .navbar-custom {\n  margin: 0;\n}\n\nbody[data-layout-color=dark] .navbar-custom .topbar-menu li .show.nav-link {\n  color: #dee2e6;\n}\nbody[data-layout-color=dark] .navbar-custom .topbar-menu .nav-link {\n  color: #ced4da;\n}\nbody[data-layout-color=dark] .notification-list .notify-item.unread-noti {\n  background-color: rgb(28.1764705882%, 31.6705882353%, 36.3294117647%);\n}\nbody[data-layout-color=dark] .notification-list .notify-item.read-noti {\n  border: 1px solid #464f5b;\n}\nbody[data-layout-color=dark] .button-menu-mobile {\n  color: #f1f1f1;\n}\nbody[data-layout-color=dark] .nav-user {\n  background-color: rgb(27.2602013778%, 31.0936671966%, 35.7790143084%);\n  border: 1px solid #404954;\n}\nbody[data-layout-color=dark] .topnav-navbar-dark .app-search span,\nbody[data-layout-color=dark] .topnav-navbar-dark .app-search .react-select__placeholder {\n  color: #ced4da;\n}\n\n/* rtl:begin:options: {\n  \"autoRename\": true,\n  \"stringMap\":[]\n} */\n.end-bar {\n  background-color: var(--ct-rightbar-bg);\n  box-shadow: 0 0 24px 0 rgba(49, 58, 70, 0.1), 0 1px 0 0 rgba(49, 58, 70, 0.08);\n  display: block;\n  position: fixed;\n  transition: all 200ms ease-out;\n  width: 280px;\n  z-index: 9999;\n  float: right !important;\n  right: -290px;\n  top: 0;\n  bottom: 0;\n  padding-bottom: 80px;\n}\n.end-bar .rightbar-title {\n  background-color: var(--ct-rightbar-title-bg);\n  padding: 27px 25px;\n  color: var(--ct-rightbar-title-color);\n}\n.end-bar .end-bar-toggle {\n  background-color: var(--ct-rightbar-title-btn-bg);\n  height: 24px;\n  width: 24px;\n  line-height: 22px;\n  color: var(--ct-rightbar-title-btn-color);\n  text-align: center;\n  border-radius: 50%;\n  margin-top: -4px;\n}\n\n.rightbar-overlay {\n  background-color: var(--ct-rightbar-overlay-bg);\n  opacity: 0.2;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: none;\n  z-index: 9998;\n  transition: all 0.2s ease-out;\n}\n\n.end-bar-enabled .end-bar {\n  right: 0;\n}\n.end-bar-enabled .rightbar-overlay {\n  display: block;\n}\n\n@media (max-width: 767.98px) {\n  .end-bar {\n    overflow: auto;\n  }\n}\n.page-title-box .page-title {\n  font-size: 18px;\n  margin: 0;\n  line-height: 75px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: var(--ct-page-title-color);\n}\n.page-title-box .page-title-right {\n  float: right;\n  margin-top: 20px;\n}\n.page-title-box .breadcrumb {\n  padding-top: 8px;\n}\n\n.page-title-box-sm .page-title {\n  line-height: 1 !important;\n  margin-bottom: 25px;\n}\n.page-title-box-sm .page-title-right {\n  float: right;\n  margin-top: 0;\n}\n.page-title-box-sm .breadcrumb {\n  padding-top: 0;\n  margin-top: -3px !important;\n}\n\n.text-title {\n  color: var(--ct-text-title-color);\n}\n.text-title:hover {\n  color: var(--ct-text-title-color);\n}\n\n@media (max-width: 767.98px) {\n  .page-title-box .page-title {\n    display: block;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    line-height: 70px;\n  }\n  .page-title-box .breadcrumb {\n    display: none;\n  }\n  .page-title-box .page-title-right {\n    display: none;\n  }\n}\n@media (max-width: 419px) {\n  .page-title-box .breadcrumb {\n    display: none;\n  }\n}\n.topnav-navbar {\n  padding: 0;\n  margin: 0;\n  min-height: 70px;\n  position: relative;\n  left: 0 !important;\n  z-index: 1002;\n}\n.topnav-navbar .topnav-logo {\n  line-height: 70px;\n  float: left;\n  padding-right: 20px;\n  min-width: 160px;\n}\n.topnav-navbar .topnav-logo .topnav-logo-sm {\n  display: none;\n}\n.topnav-navbar .navbar-toggle {\n  position: relative;\n  cursor: pointer;\n  float: left;\n  margin: 27px 20px;\n  padding: 0;\n  background-color: transparent;\n  border: none;\n}\n.topnav-navbar .navbar-toggle .lines {\n  width: 25px;\n  display: block;\n  position: relative;\n  height: 16px;\n  transition: all 0.5s ease;\n}\n.topnav-navbar .navbar-toggle span {\n  height: 2px;\n  width: 100%;\n  background-color: rgba(49, 58, 70, 0.8);\n  display: block;\n  margin-bottom: 5px;\n  transition: transform 0.5s ease;\n}\n.topnav-navbar .navbar-toggle.open span {\n  position: absolute;\n}\n.topnav-navbar .navbar-toggle.open span:first-child {\n  top: 7px;\n  transform: rotate(45deg);\n}\n.topnav-navbar .navbar-toggle.open span:nth-child(2) {\n  visibility: hidden;\n}\n.topnav-navbar .navbar-toggle.open span:last-child {\n  width: 100%;\n  top: 7px;\n  transform: rotate(-45deg);\n}\n.topnav-navbar .app-search {\n  float: left;\n}\n\n.topnav {\n  background: var(--ct-bg-topnav);\n}\n.topnav .topnav-menu {\n  margin: 0;\n  padding: 0;\n}\n.topnav .navbar-nav .nav-link {\n  font-size: 0.9375rem;\n  position: relative;\n  padding: 1rem 1.3rem;\n}\n.topnav .nav-item.active > a {\n  color: var(--ct-menu-item-active);\n}\n.topnav .navbar-dark .dropdown.active > .nav-link, .topnav .navbar-dark .dropdown:active > .nav-link {\n  color: #fff;\n}\n\n.arrow-down {\n  display: inline-block;\n}\n.arrow-down:after {\n  border-color: initial;\n  border-style: solid;\n  border-width: 0 0 1px 1px;\n  content: \"\";\n  height: 0.4em;\n  display: inline-block;\n  right: 5px;\n  top: 50%;\n  margin-left: 10px;\n  transform: rotate(-45deg) translateY(-50%);\n  transform-origin: top;\n  transition: all 0.3s ease-out;\n  width: 0.4em;\n}\n\nbody[data-layout=topnav] .container-fluid, body[data-layout=topnav] .container-sm, body[data-layout=topnav] .container-md, body[data-layout=topnav] .container-lg, body[data-layout=topnav] .container-xl, body[data-layout=topnav] .container-xxl {\n  padding-right: 24px;\n  padding-left: 24px;\n}\n\n@media (min-width: 992px) {\n  body[data-layout=topnav] .container-fluid, body[data-layout=topnav] .container-sm, body[data-layout=topnav] .container-md, body[data-layout=topnav] .container-lg, body[data-layout=topnav] .container-xl, body[data-layout=topnav] .container-xxl {\n    max-width: 95%;\n  }\n  body[data-layout=topnav][data-layout-mode=boxed] .container-fluid, body[data-layout=topnav][data-layout-mode=boxed] .container-sm, body[data-layout=topnav][data-layout-mode=boxed] .container-md, body[data-layout=topnav][data-layout-mode=boxed] .container-lg, body[data-layout=topnav][data-layout-mode=boxed] .container-xl, body[data-layout=topnav][data-layout-mode=boxed] .container-xxl {\n    max-width: 97%;\n  }\n  .topnav .navbar-nav .nav-item:first-of-type .nav-link {\n    padding-left: 0;\n  }\n  .topnav .dropdown .dropdown-menu {\n    margin-top: 0;\n    border-radius: 0 0 0.25rem 0.25rem;\n    min-width: calc(10rem + 1.5rem);\n    font-size: calc(0.9rem - 0.01rem);\n  }\n  .topnav .dropdown .dropdown-menu .arrow-down::after {\n    right: 15px;\n    transform: rotate(-135deg) translateY(-50%);\n    position: absolute;\n  }\n  .topnav .dropdown .dropdown-menu .dropdown .dropdown-menu {\n    position: absolute;\n    top: 0;\n    left: 100%;\n    display: none;\n  }\n  .topnav .dropdown:hover > .dropdown-menu {\n    display: block;\n  }\n  .topnav .dropdown:hover > .dropdown-menu > .dropdown:hover > .dropdown-menu {\n    display: block;\n  }\n  .dropdown.active > a.dropdown-item {\n    color: var(--ct-dropdown-link-active-color);\n    background-color: var(--ct-dropdown-link-active-bg);\n  }\n}\n@media (min-width: 1400px) {\n  body[data-layout=topnav] .container-fluid, body[data-layout=topnav] .container-sm, body[data-layout=topnav] .container-md, body[data-layout=topnav] .container-lg, body[data-layout=topnav] .container-xl, body[data-layout=topnav] .container-xxl {\n    max-width: 85%;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-toggle {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .topnav-navbar .topnav-logo-lg {\n    display: none;\n  }\n  .topnav-navbar .topnav-logo {\n    min-width: 50px;\n    padding-right: 0;\n    text-align: center;\n  }\n  .topnav-navbar .topnav-logo-sm {\n    display: block !important;\n  }\n  .topnav .navbar-nav .nav-link {\n    padding: 0.75rem 1.3rem;\n  }\n  .topnav .dropdown .dropdown-menu {\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    padding-left: 15px;\n  }\n  .topnav .dropdown .dropdown-item {\n    position: relative;\n    background-color: transparent;\n  }\n  .topnav .navbar-dark .dropdown .dropdown-item {\n    color: rgba(255, 255, 255, 0.5);\n  }\n  .topnav .navbar-dark .dropdown .dropdown-item.active, .topnav .navbar-dark .dropdown .dropdown-item:active {\n    color: #fff;\n  }\n  .topnav .arrow-down::after {\n    right: 15px;\n    position: absolute;\n  }\n}\n@font-face {\n  font-family: \"Nunito\";\n  src: url(\"../../../fonts/Nunito-Light.eot\");\n  src: local(\"Nunito Light\"), local(\"Nunito-Light\"), url(\"../../../fonts/Nunito-Light.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/Nunito-Light.woff\") format(\"woff\"), url(\"../../../fonts/Nunito-Light.ttf\") format(\"truetype\"), url(\"../../../fonts/Nunito-Light.svg#Roboto\") format(\"svg\");\n  font-weight: 300;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Nunito\";\n  src: url(\"../../../fonts/Nunito-Regular.eot\");\n  src: local(\"Nunito Regular\"), local(\"Nunito-Regular\"), url(\"../../../fonts/Nunito-Regular.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/Nunito-Regular.woff\") format(\"woff\"), url(\"../../../fonts/Nunito-Regular.ttf\") format(\"truetype\"), url(\"../../../fonts/Nunito-Regular.svg#Roboto\") format(\"svg\");\n  font-weight: 400;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Nunito\";\n  src: url(\"../../../fonts/Nunito-SemiBold.eot\");\n  src: local(\"Nunito SemiBold\"), local(\"Nunito-SemiBold\"), url(\"../../../fonts/Nunito-SemiBold.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/Nunito-SemiBold.woff\") format(\"woff\"), url(\"../../../fonts/Nunito-SemiBold.ttf\") format(\"truetype\"), url(\"../../../fonts/Nunito-SemiBold.svg#Roboto\") format(\"svg\");\n  font-weight: 600;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Nunito\";\n  src: url(\"../../../fonts/Nunito-Bold.eot\");\n  src: local(\"Nunito Bold\"), local(\"Nunito-Bold\"), url(\"../../../fonts/Nunito-Bold.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/Nunito-Bold.woff\") format(\"woff\"), url(\"../../../fonts/Nunito-Bold.ttf\") format(\"truetype\"), url(\"../../../fonts/Nunito-Bold.svg#Roboto\") format(\"svg\");\n  font-weight: 700;\n  font-style: normal;\n}\n/*\nTemplate Name: Hyper - Responsive Bootstrap 5 Admin Dashboard\nVersion: 1.6.0\nAuthor: CoderThemes\nEmail: support@coderthemes.com\nFile: Icons Css File\n*/\n@font-face {\n  font-family: \"unicons\";\n  src: url(\"../../../../fonts/unicons.eot?34404611\");\n  src: url(\"../../../../fonts/unicons.eot?34404611#iefix\") format(\"embedded-opentype\"), url(\"../../../../fonts/unicons.woff2?34404611\") format(\"woff2\"), url(\"../../../../fonts/unicons.woff?34404611\") format(\"woff\"), url(\"../../../../fonts/unicons.ttf?34404611\") format(\"truetype\"), url(\"../../../../fonts/unicons.svg?34404611#unicons\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */\n/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */\n/*\n@media screen and (-webkit-min-device-pixel-ratio:0) {\n  @font-face {\n    font-family: 'unicons';\n    src: url('../font/unicons.svg?34404611#unicons') format('svg');\n  }\n}\n*/\n[class^=uil-]:before, [class*=\" uil-\"]:before {\n  font-family: \"unicons\";\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n  display: inline-block;\n  text-decoration: inherit;\n  text-align: center;\n  /* For safety - reset parent styles, that can break glyph codes*/\n  font-variant: normal;\n  text-transform: none;\n  /* fix buttons height, for twitter bootstrap */\n  line-height: 1em;\n  /* you can be more comfortable with increased icons size */\n  /* font-size: 120%; */\n  /* Font smoothing. That was taken from TWBS */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* Uncomment for 3D effect */\n  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */\n}\n\n.uil-0-plus:before {\n  content: \"\\e800\";\n} /* '' */\n.uil-10-plus:before {\n  content: \"\\e801\";\n} /* '' */\n.uil-12-plus:before {\n  content: \"\\e802\";\n} /* '' */\n.uil-13-plus:before {\n  content: \"\\e803\";\n} /* '' */\n.uil-16-plus:before {\n  content: \"\\e804\";\n} /* '' */\n.uil-17-plus:before {\n  content: \"\\e805\";\n} /* '' */\n.uil-18-plus:before {\n  content: \"\\e806\";\n} /* '' */\n.uil-21-plus:before {\n  content: \"\\e807\";\n} /* '' */\n.uil-3-plus:before {\n  content: \"\\e808\";\n} /* '' */\n.uil-500px:before {\n  content: \"\\e809\";\n} /* '' */\n.uil-6-plus:before {\n  content: \"\\e80a\";\n} /* '' */\n.uil-abacus:before {\n  content: \"\\e80b\";\n} /* '' */\n.uil-accessible-icon-alt:before {\n  content: \"\\e80c\";\n} /* '' */\n.uil-adjust-alt:before {\n  content: \"\\e80d\";\n} /* '' */\n.uil-adjust-circle:before {\n  content: \"\\e80e\";\n} /* '' */\n.uil-adjust-half:before {\n  content: \"\\e80f\";\n} /* '' */\n.uil-adjust:before {\n  content: \"\\e810\";\n} /* '' */\n.uil-adobe:before {\n  content: \"\\e811\";\n} /* '' */\n.uil-airplay:before {\n  content: \"\\e812\";\n} /* '' */\n.uil-align-alt:before {\n  content: \"\\e813\";\n} /* '' */\n.uil-align-center-alt:before {\n  content: \"\\e814\";\n} /* '' */\n.uil-align-center-h:before {\n  content: \"\\e815\";\n} /* '' */\n.uil-align-center-justify:before {\n  content: \"\\e816\";\n} /* '' */\n.uil-align-center-v:before {\n  content: \"\\e817\";\n} /* '' */\n.uil-align-center:before {\n  content: \"\\e818\";\n} /* '' */\n.uil-align-justify:before {\n  content: \"\\e819\";\n} /* '' */\n.uil-align-left-justify:before {\n  content: \"\\e81a\";\n} /* '' */\n.uil-align-left:before {\n  content: \"\\e81b\";\n} /* '' */\n.uil-align-letter-right:before {\n  content: \"\\e81c\";\n} /* '' */\n.uil-align-right-justify:before {\n  content: \"\\e81d\";\n} /* '' */\n.uil-align-right:before {\n  content: \"\\e81e\";\n} /* '' */\n.uil-align:before {\n  content: \"\\e81f\";\n} /* '' */\n.uil-ambulance:before {\n  content: \"\\e820\";\n} /* '' */\n.uil-analysis:before {\n  content: \"\\e821\";\n} /* '' */\n.uil-analytics:before {\n  content: \"\\e822\";\n} /* '' */\n.uil-anchor:before {\n  content: \"\\e823\";\n} /* '' */\n.uil-android-phone-slash:before {\n  content: \"\\e824\";\n} /* '' */\n.uil-angle-double-down:before {\n  content: \"\\e825\";\n} /* '' */\n.uil-angle-double-left:before {\n  content: \"\\e826\";\n} /* '' */\n.uil-angle-double-right:before {\n  content: \"\\e827\";\n} /* '' */\n.uil-angle-double-up:before {\n  content: \"\\e828\";\n} /* '' */\n.uil-angle-down:before {\n  content: \"\\e829\";\n} /* '' */\n.uil-angle-left:before {\n  content: \"\\e82a\";\n} /* '' */\n.uil-angle-right-b:before {\n  content: \"\\e82b\";\n} /* '' */\n.uil-angle-right:before {\n  content: \"\\e82c\";\n} /* '' */\n.uil-angle-up:before {\n  content: \"\\e82d\";\n} /* '' */\n.uil-angry:before {\n  content: \"\\e82e\";\n} /* '' */\n.uil-ankh:before {\n  content: \"\\e82f\";\n} /* '' */\n.uil-annoyed-alt:before {\n  content: \"\\e830\";\n} /* '' */\n.uil-annoyed:before {\n  content: \"\\e831\";\n} /* '' */\n.uil-apple:before {\n  content: \"\\e832\";\n} /* '' */\n.uil-apps:before {\n  content: \"\\e833\";\n} /* '' */\n.uil-archive-alt:before {\n  content: \"\\e834\";\n} /* '' */\n.uil-archive:before {\n  content: \"\\e835\";\n} /* '' */\n.uil-archway:before {\n  content: \"\\e836\";\n} /* '' */\n.uil-arrow-break:before {\n  content: \"\\e837\";\n} /* '' */\n.uil-arrow-circle-down:before {\n  content: \"\\e838\";\n} /* '' */\n.uil-arrow-circle-left:before {\n  content: \"\\e839\";\n} /* '' */\n.uil-arrow-circle-right:before {\n  content: \"\\e83a\";\n} /* '' */\n.uil-arrow-circle-up:before {\n  content: \"\\e83b\";\n} /* '' */\n.uil-arrow-compress-h:before {\n  content: \"\\e83c\";\n} /* '' */\n.uil-arrow-down-left:before {\n  content: \"\\e83d\";\n} /* '' */\n.uil-arrow-down-right:before {\n  content: \"\\e83e\";\n} /* '' */\n.uil-arrow-down:before {\n  content: \"\\e83f\";\n} /* '' */\n.uil-arrow-from-right:before {\n  content: \"\\e840\";\n} /* '' */\n.uil-arrow-from-top:before {\n  content: \"\\e841\";\n} /* '' */\n.uil-arrow-growth:before {\n  content: \"\\e842\";\n} /* '' */\n.uil-arrow-left:before {\n  content: \"\\e843\";\n} /* '' */\n.uil-arrow-random:before {\n  content: \"\\e844\";\n} /* '' */\n.uil-arrow-resize-diagonal:before {\n  content: \"\\e845\";\n} /* '' */\n.uil-arrow-right:before {\n  content: \"\\e846\";\n} /* '' */\n.uil-arrow-to-bottom:before {\n  content: \"\\e847\";\n} /* '' */\n.uil-arrow-to-right:before {\n  content: \"\\e848\";\n} /* '' */\n.uil-arrow-up-left:before {\n  content: \"\\e849\";\n} /* '' */\n.uil-arrow-up-right:before {\n  content: \"\\e84a\";\n} /* '' */\n.uil-arrow-up:before {\n  content: \"\\e84b\";\n} /* '' */\n.uil-arrows-h-alt:before {\n  content: \"\\e84c\";\n} /* '' */\n.uil-arrows-h:before {\n  content: \"\\e84d\";\n} /* '' */\n.uil-arrows-left-down:before {\n  content: \"\\e84e\";\n} /* '' */\n.uil-arrows-maximize:before {\n  content: \"\\e84f\";\n} /* '' */\n.uil-arrows-merge:before {\n  content: \"\\e850\";\n} /* '' */\n.uil-arrows-resize-h:before {\n  content: \"\\e851\";\n} /* '' */\n.uil-arrows-resize-v:before {\n  content: \"\\e852\";\n} /* '' */\n.uil-arrows-resize:before {\n  content: \"\\e853\";\n} /* '' */\n.uil-arrows-right-down:before {\n  content: \"\\e854\";\n} /* '' */\n.uil-arrows-shrink-h:before {\n  content: \"\\e855\";\n} /* '' */\n.uil-arrows-shrink-v:before {\n  content: \"\\e856\";\n} /* '' */\n.uil-arrows-up-right:before {\n  content: \"\\e857\";\n} /* '' */\n.uil-arrows-v-alt:before {\n  content: \"\\e858\";\n} /* '' */\n.uil-arrows-v:before {\n  content: \"\\e859\";\n} /* '' */\n.uil-assistive-listening-systems:before {\n  content: \"\\e85a\";\n} /* '' */\n.uil-asterisk:before {\n  content: \"\\e85b\";\n} /* '' */\n.uil-at:before {\n  content: \"\\e85c\";\n} /* '' */\n.uil-atm-card:before {\n  content: \"\\e85d\";\n} /* '' */\n.uil-atom:before {\n  content: \"\\e85e\";\n} /* '' */\n.uil-auto-flash:before {\n  content: \"\\e85f\";\n} /* '' */\n.uil-award-alt:before {\n  content: \"\\e860\";\n} /* '' */\n.uil-award:before {\n  content: \"\\e861\";\n} /* '' */\n.uil-baby-carriage:before {\n  content: \"\\e862\";\n} /* '' */\n.uil-backpack:before {\n  content: \"\\e863\";\n} /* '' */\n.uil-backspace:before {\n  content: \"\\e864\";\n} /* '' */\n.uil-backward:before {\n  content: \"\\e865\";\n} /* '' */\n.uil-bag-alt:before {\n  content: \"\\e866\";\n} /* '' */\n.uil-bag-slash:before {\n  content: \"\\e867\";\n} /* '' */\n.uil-bag:before {\n  content: \"\\e868\";\n} /* '' */\n.uil-balance-scale:before {\n  content: \"\\e869\";\n} /* '' */\n.uil-ball:before {\n  content: \"\\e86a\";\n} /* '' */\n.uil-ban:before {\n  content: \"\\e86b\";\n} /* '' */\n.uil-bars:before {\n  content: \"\\e86c\";\n} /* '' */\n.uil-basketball-hoop:before {\n  content: \"\\e86d\";\n} /* '' */\n.uil-basketball:before {\n  content: \"\\e86e\";\n} /* '' */\n.uil-battery-bolt:before {\n  content: \"\\e86f\";\n} /* '' */\n.uil-battery-empty:before {\n  content: \"\\e870\";\n} /* '' */\n.uil-bed-double:before {\n  content: \"\\e871\";\n} /* '' */\n.uil-bed:before {\n  content: \"\\e872\";\n} /* '' */\n.uil-behance:before {\n  content: \"\\e873\";\n} /* '' */\n.uil-bell-school:before {\n  content: \"\\e874\";\n} /* '' */\n.uil-bell-slash:before {\n  content: \"\\e875\";\n} /* '' */\n.uil-bell:before {\n  content: \"\\e876\";\n} /* '' */\n.uil-bill:before {\n  content: \"\\e877\";\n} /* '' */\n.uil-bitcoin-circle:before {\n  content: \"\\e878\";\n} /* '' */\n.uil-bitcoin:before {\n  content: \"\\e879\";\n} /* '' */\n.uil-black-berry:before {\n  content: \"\\e87a\";\n} /* '' */\n.uil-bluetooth-b:before {\n  content: \"\\e87b\";\n} /* '' */\n.uil-bold:before {\n  content: \"\\e87c\";\n} /* '' */\n.uil-bolt-alt:before {\n  content: \"\\e87d\";\n} /* '' */\n.uil-bolt-slash:before {\n  content: \"\\e87e\";\n} /* '' */\n.uil-bolt:before {\n  content: \"\\e87f\";\n} /* '' */\n.uil-book-alt:before {\n  content: \"\\e880\";\n} /* '' */\n.uil-book-medical:before {\n  content: \"\\e881\";\n} /* '' */\n.uil-book-open:before {\n  content: \"\\e882\";\n} /* '' */\n.uil-book-reader:before {\n  content: \"\\e883\";\n} /* '' */\n.uil-book:before {\n  content: \"\\e884\";\n} /* '' */\n.uil-bookmark-full:before {\n  content: \"\\e885\";\n} /* '' */\n.uil-bookmark:before {\n  content: \"\\e886\";\n} /* '' */\n.uil-books:before {\n  content: \"\\e887\";\n} /* '' */\n.uil-boombox:before {\n  content: \"\\e888\";\n} /* '' */\n.uil-border-alt:before {\n  content: \"\\e889\";\n} /* '' */\n.uil-border-bottom:before {\n  content: \"\\e88a\";\n} /* '' */\n.uil-border-clear:before {\n  content: \"\\e88b\";\n} /* '' */\n.uil-border-horizontal:before {\n  content: \"\\e88c\";\n} /* '' */\n.uil-border-inner:before {\n  content: \"\\e88d\";\n} /* '' */\n.uil-border-left:before {\n  content: \"\\e88e\";\n} /* '' */\n.uil-border-out:before {\n  content: \"\\e88f\";\n} /* '' */\n.uil-border-right:before {\n  content: \"\\e890\";\n} /* '' */\n.uil-border-top:before {\n  content: \"\\e891\";\n} /* '' */\n.uil-border-vertical:before {\n  content: \"\\e892\";\n} /* '' */\n.uil-box:before {\n  content: \"\\e893\";\n} /* '' */\n.uil-briefcase-alt:before {\n  content: \"\\e894\";\n} /* '' */\n.uil-briefcase:before {\n  content: \"\\e895\";\n} /* '' */\n.uil-bright:before {\n  content: \"\\e896\";\n} /* '' */\n.uil-brightness-empty:before {\n  content: \"\\e897\";\n} /* '' */\n.uil-brightness-half:before {\n  content: \"\\e898\";\n} /* '' */\n.uil-brightness-low:before {\n  content: \"\\e899\";\n} /* '' */\n.uil-brightness-minus:before {\n  content: \"\\e89a\";\n} /* '' */\n.uil-brightness-plus:before {\n  content: \"\\e89b\";\n} /* '' */\n.uil-brightness:before {\n  content: \"\\e89c\";\n} /* '' */\n.uil-bring-bottom:before {\n  content: \"\\e89d\";\n} /* '' */\n.uil-bring-front:before {\n  content: \"\\e89e\";\n} /* '' */\n.uil-brush-alt:before {\n  content: \"\\e89f\";\n} /* '' */\n.uil-bug:before {\n  content: \"\\e8a0\";\n} /* '' */\n.uil-building:before {\n  content: \"\\e8a1\";\n} /* '' */\n.uil-bullseye:before {\n  content: \"\\e8a2\";\n} /* '' */\n.uil-bus-alt:before {\n  content: \"\\e8a3\";\n} /* '' */\n.uil-bus-school:before {\n  content: \"\\e8a4\";\n} /* '' */\n.uil-bus:before {\n  content: \"\\e8a5\";\n} /* '' */\n.uil-calcualtor:before {\n  content: \"\\e8a6\";\n} /* '' */\n.uil-calculator-alt:before {\n  content: \"\\e8a7\";\n} /* '' */\n.uil-calendar-alt:before {\n  content: \"\\e8a8\";\n} /* '' */\n.uil-calendar-slash:before {\n  content: \"\\e8a9\";\n} /* '' */\n.uil-calender:before {\n  content: \"\\e8aa\";\n} /* '' */\n.uil-calling:before {\n  content: \"\\e8ab\";\n} /* '' */\n.uil-camera-change:before {\n  content: \"\\e8ac\";\n} /* '' */\n.uil-camera-plus:before {\n  content: \"\\e8ad\";\n} /* '' */\n.uil-camera-slash:before {\n  content: \"\\e8ae\";\n} /* '' */\n.uil-camera:before {\n  content: \"\\e8af\";\n} /* '' */\n.uil-cancel:before {\n  content: \"\\e8b0\";\n} /* '' */\n.uil-capsule:before {\n  content: \"\\e8b1\";\n} /* '' */\n.uil-capture:before {\n  content: \"\\e8b2\";\n} /* '' */\n.uil-car-sideview:before {\n  content: \"\\e8b3\";\n} /* '' */\n.uil-car-slash:before {\n  content: \"\\e8b4\";\n} /* '' */\n.uil-car-wash:before {\n  content: \"\\e8b5\";\n} /* '' */\n.uil-car:before {\n  content: \"\\e8b6\";\n} /* '' */\n.uil-card-atm:before {\n  content: \"\\e8b7\";\n} /* '' */\n.uil-caret-right:before {\n  content: \"\\e8b8\";\n} /* '' */\n.uil-cart:before {\n  content: \"\\e8b9\";\n} /* '' */\n.uil-cell:before {\n  content: \"\\e8ba\";\n} /* '' */\n.uil-celsius:before {\n  content: \"\\e8bb\";\n} /* '' */\n.uil-chart-bar-alt:before {\n  content: \"\\e8bc\";\n} /* '' */\n.uil-chart-bar:before {\n  content: \"\\e8bd\";\n} /* '' */\n.uil-chart-down:before {\n  content: \"\\e8be\";\n} /* '' */\n.uil-chart-growth-alt:before {\n  content: \"\\e8bf\";\n} /* '' */\n.uil-chart-growth:before {\n  content: \"\\e8c0\";\n} /* '' */\n.uil-chart-line:before {\n  content: \"\\e8c1\";\n} /* '' */\n.uil-chart-pie-alt:before {\n  content: \"\\e8c2\";\n} /* '' */\n.uil-chart-pie:before {\n  content: \"\\e8c3\";\n} /* '' */\n.uil-chart:before {\n  content: \"\\e8c4\";\n} /* '' */\n.uil-chat-bubble-user:before {\n  content: \"\\e8c5\";\n} /* '' */\n.uil-chat-info:before {\n  content: \"\\e8c6\";\n} /* '' */\n.uil-chat:before {\n  content: \"\\e8c7\";\n} /* '' */\n.uil-check-circle:before {\n  content: \"\\e8c8\";\n} /* '' */\n.uil-check-square:before {\n  content: \"\\e8c9\";\n} /* '' */\n.uil-check:before {\n  content: \"\\e8ca\";\n} /* '' */\n.uil-circle-layer:before {\n  content: \"\\e8cb\";\n} /* '' */\n.uil-circle:before {\n  content: \"\\e8cc\";\n} /* '' */\n.uil-circuit:before {\n  content: \"\\e8cd\";\n} /* '' */\n.uil-clapper-board:before {\n  content: \"\\e8ce\";\n} /* '' */\n.uil-clipboard-alt:before {\n  content: \"\\e8cf\";\n} /* '' */\n.uil-clipboard-blank:before {\n  content: \"\\e8d0\";\n} /* '' */\n.uil-clipboard-notes:before {\n  content: \"\\e8d1\";\n} /* '' */\n.uil-clipboard:before {\n  content: \"\\e8d2\";\n} /* '' */\n.uil-clock-eight:before {\n  content: \"\\e8d3\";\n} /* '' */\n.uil-clock-five:before {\n  content: \"\\e8d4\";\n} /* '' */\n.uil-clock-nine:before {\n  content: \"\\e8d5\";\n} /* '' */\n.uil-clock-seven:before {\n  content: \"\\e8d6\";\n} /* '' */\n.uil-clock-ten:before {\n  content: \"\\e8d7\";\n} /* '' */\n.uil-clock-three:before {\n  content: \"\\e8d8\";\n} /* '' */\n.uil-clock-two:before {\n  content: \"\\e8d9\";\n} /* '' */\n.uil-clock:before {\n  content: \"\\e8da\";\n} /* '' */\n.uil-closed-captioning:before {\n  content: \"\\e8db\";\n} /* '' */\n.uil-cloud-block:before {\n  content: \"\\e8dc\";\n} /* '' */\n.uil-cloud-bookmark:before {\n  content: \"\\e8dd\";\n} /* '' */\n.uil-cloud-check:before {\n  content: \"\\e8de\";\n} /* '' */\n.uil-cloud-computing:before {\n  content: \"\\e8df\";\n} /* '' */\n.uil-cloud-data-connection:before {\n  content: \"\\e8e0\";\n} /* '' */\n.uil-cloud-database-tree:before {\n  content: \"\\e8e1\";\n} /* '' */\n.uil-cloud-download:before {\n  content: \"\\e8e2\";\n} /* '' */\n.uil-cloud-drizzle:before {\n  content: \"\\e8e3\";\n} /* '' */\n.uil-cloud-exclamation:before {\n  content: \"\\e8e4\";\n} /* '' */\n.uil-cloud-hail:before {\n  content: \"\\e8e5\";\n} /* '' */\n.uil-cloud-heart:before {\n  content: \"\\e8e6\";\n} /* '' */\n.uil-cloud-info:before {\n  content: \"\\e8e7\";\n} /* '' */\n.uil-cloud-lock:before {\n  content: \"\\e8e8\";\n} /* '' */\n.uil-cloud-meatball:before {\n  content: \"\\e8e9\";\n} /* '' */\n.uil-cloud-moon-hail:before {\n  content: \"\\e8ea\";\n} /* '' */\n.uil-cloud-moon-meatball:before {\n  content: \"\\e8eb\";\n} /* '' */\n.uil-cloud-moon-rain:before {\n  content: \"\\e8ec\";\n} /* '' */\n.uil-cloud-moon-showers:before {\n  content: \"\\e8ed\";\n} /* '' */\n.uil-cloud-moon:before {\n  content: \"\\e8ee\";\n} /* '' */\n.uil-cloud-question:before {\n  content: \"\\e8ef\";\n} /* '' */\n.uil-cloud-rain-sun:before {\n  content: \"\\e8f0\";\n} /* '' */\n.uil-cloud-rain:before {\n  content: \"\\e8f1\";\n} /* '' */\n.uil-cloud-redo:before {\n  content: \"\\e8f2\";\n} /* '' */\n.uil-cloud-set:before {\n  content: \"\\e8f3\";\n} /* '' */\n.uil-cloud-share:before {\n  content: \"\\e8f4\";\n} /* '' */\n.uil-cloud-shield:before {\n  content: \"\\e8f5\";\n} /* '' */\n.uil-cloud-showers-alt:before {\n  content: \"\\e8f6\";\n} /* '' */\n.uil-cloud-showers-heavy:before {\n  content: \"\\e8f7\";\n} /* '' */\n.uil-cloud-showers:before {\n  content: \"\\e8f8\";\n} /* '' */\n.uil-cloud-slash:before {\n  content: \"\\e8f9\";\n} /* '' */\n.uil-cloud-sun-hail:before {\n  content: \"\\e8fa\";\n} /* '' */\n.uil-cloud-sun-meatball:before {\n  content: \"\\e8fb\";\n} /* '' */\n.uil-cloud-sun-rain-alt:before {\n  content: \"\\e8fc\";\n} /* '' */\n.uil-cloud-sun-rain:before {\n  content: \"\\e8fd\";\n} /* '' */\n.uil-cloud-sun-tear:before {\n  content: \"\\e8fe\";\n} /* '' */\n.uil-cloud-sun:before {\n  content: \"\\e8ff\";\n} /* '' */\n.uil-cloud-times:before {\n  content: \"\\e900\";\n} /* '' */\n.uil-cloud-unlock:before {\n  content: \"\\e901\";\n} /* '' */\n.uil-cloud-upload:before {\n  content: \"\\e902\";\n} /* '' */\n.uil-cloud-wifi:before {\n  content: \"\\e903\";\n} /* '' */\n.uil-cloud-wind:before {\n  content: \"\\e904\";\n} /* '' */\n.uil-cloud:before {\n  content: \"\\e905\";\n} /* '' */\n.uil-clouds:before {\n  content: \"\\e906\";\n} /* '' */\n.uil-club:before {\n  content: \"\\e907\";\n} /* '' */\n.uil-code:before {\n  content: \"\\e908\";\n} /* '' */\n.uil-coffee:before {\n  content: \"\\e909\";\n} /* '' */\n.uil-cog:before {\n  content: \"\\e90a\";\n} /* '' */\n.uil-coins:before {\n  content: \"\\e90b\";\n} /* '' */\n.uil-columns:before {\n  content: \"\\e90c\";\n} /* '' */\n.uil-comment-alt-block:before {\n  content: \"\\e90d\";\n} /* '' */\n.uil-comment-alt-chart-lines:before {\n  content: \"\\e90e\";\n} /* '' */\n.uil-comment-alt-check:before {\n  content: \"\\e90f\";\n} /* '' */\n.uil-comment-alt-dots:before {\n  content: \"\\e910\";\n} /* '' */\n.uil-comment-alt-download:before {\n  content: \"\\e911\";\n} /* '' */\n.uil-comment-alt-edit:before {\n  content: \"\\e912\";\n} /* '' */\n.uil-comment-alt-exclamation:before {\n  content: \"\\e913\";\n} /* '' */\n.uil-comment-alt-heart:before {\n  content: \"\\e914\";\n} /* '' */\n.uil-comment-alt-image:before {\n  content: \"\\e915\";\n} /* '' */\n.uil-comment-alt-info:before {\n  content: \"\\e916\";\n} /* '' */\n.uil-comment-alt-lines:before {\n  content: \"\\e917\";\n} /* '' */\n.uil-comment-alt-lock:before {\n  content: \"\\e918\";\n} /* '' */\n.uil-comment-alt-medical:before {\n  content: \"\\e919\";\n} /* '' */\n.uil-comment-alt-message:before {\n  content: \"\\e91a\";\n} /* '' */\n.uil-comment-alt-notes:before {\n  content: \"\\e91b\";\n} /* '' */\n.uil-comment-alt-plus:before {\n  content: \"\\e91c\";\n} /* '' */\n.uil-comment-alt-question:before {\n  content: \"\\e91d\";\n} /* '' */\n.uil-comment-alt-redo:before {\n  content: \"\\e91e\";\n} /* '' */\n.uil-comment-alt-search:before {\n  content: \"\\e91f\";\n} /* '' */\n.uil-comment-alt-share:before {\n  content: \"\\e920\";\n} /* '' */\n.uil-comment-alt-shield:before {\n  content: \"\\e921\";\n} /* '' */\n.uil-comment-alt-slash:before {\n  content: \"\\e922\";\n} /* '' */\n.uil-comment-alt-upload:before {\n  content: \"\\e923\";\n} /* '' */\n.uil-comment-alt-verify:before {\n  content: \"\\e924\";\n} /* '' */\n.uil-comment-alt:before {\n  content: \"\\e925\";\n} /* '' */\n.uil-comment-block:before {\n  content: \"\\e926\";\n} /* '' */\n.uil-comment-chart-line:before {\n  content: \"\\e927\";\n} /* '' */\n.uil-comment-check:before {\n  content: \"\\e928\";\n} /* '' */\n.uil-comment-dots:before {\n  content: \"\\e929\";\n} /* '' */\n.uil-comment-download:before {\n  content: \"\\e92a\";\n} /* '' */\n.uil-comment-edit:before {\n  content: \"\\e92b\";\n} /* '' */\n.uil-comment-exclamation:before {\n  content: \"\\e92c\";\n} /* '' */\n.uil-comment-heart:before {\n  content: \"\\e92d\";\n} /* '' */\n.uil-comment-image:before {\n  content: \"\\e92e\";\n} /* '' */\n.uil-comment-info-alt:before {\n  content: \"\\e92f\";\n} /* '' */\n.uil-comment-info:before {\n  content: \"\\e930\";\n} /* '' */\n.uil-comment-lines:before {\n  content: \"\\e931\";\n} /* '' */\n.uil-comment-lock:before {\n  content: \"\\e932\";\n} /* '' */\n.uil-comment-medical:before {\n  content: \"\\e933\";\n} /* '' */\n.uil-comment-message:before {\n  content: \"\\e934\";\n} /* '' */\n.uil-comment-notes:before {\n  content: \"\\e935\";\n} /* '' */\n.uil-comment-plus:before {\n  content: \"\\e936\";\n} /* '' */\n.uil-comment-question:before {\n  content: \"\\e937\";\n} /* '' */\n.uil-comment-redo:before {\n  content: \"\\e938\";\n} /* '' */\n.uil-comment-search:before {\n  content: \"\\e939\";\n} /* '' */\n.uil-comment-share:before {\n  content: \"\\e93a\";\n} /* '' */\n.uil-comment-shield:before {\n  content: \"\\e93b\";\n} /* '' */\n.uil-comment-slash:before {\n  content: \"\\e93c\";\n} /* '' */\n.uil-comment-upload:before {\n  content: \"\\e93d\";\n} /* '' */\n.uil-comment-verify:before {\n  content: \"\\e93e\";\n} /* '' */\n.uil-comment:before {\n  content: \"\\e93f\";\n} /* '' */\n.uil-comments-alt:before {\n  content: \"\\e940\";\n} /* '' */\n.uil-comments:before {\n  content: \"\\e941\";\n} /* '' */\n.uil-commnet-alt-slash:before {\n  content: \"\\e942\";\n} /* '' */\n.uil-compact-disc:before {\n  content: \"\\e943\";\n} /* '' */\n.uil-compass:before {\n  content: \"\\e944\";\n} /* '' */\n.uil-compress-alt-left:before {\n  content: \"\\e945\";\n} /* '' */\n.uil-compress-alt:before {\n  content: \"\\e946\";\n} /* '' */\n.uil-compress-arrows:before {\n  content: \"\\e947\";\n} /* '' */\n.uil-compress-lines:before {\n  content: \"\\e948\";\n} /* '' */\n.uil-compress-point:before {\n  content: \"\\e949\";\n} /* '' */\n.uil-compress-v:before {\n  content: \"\\e94a\";\n} /* '' */\n.uil-compress:before {\n  content: \"\\e94b\";\n} /* '' */\n.uil-computer-mouse:before {\n  content: \"\\e94c\";\n} /* '' */\n.uil-confused:before {\n  content: \"\\e94d\";\n} /* '' */\n.uil-constructor:before {\n  content: \"\\e94e\";\n} /* '' */\n.uil-copy-alt:before {\n  content: \"\\e94f\";\n} /* '' */\n.uil-copy-landscape:before {\n  content: \"\\e950\";\n} /* '' */\n.uil-copy:before {\n  content: \"\\e951\";\n} /* '' */\n.uil-copyright:before {\n  content: \"\\e952\";\n} /* '' */\n.uil-corner-down-left:before {\n  content: \"\\e953\";\n} /* '' */\n.uil-corner-down-right-alt:before {\n  content: \"\\e954\";\n} /* '' */\n.uil-corner-down-right:before {\n  content: \"\\e955\";\n} /* '' */\n.uil-corner-left-down:before {\n  content: \"\\e956\";\n} /* '' */\n.uil-corner-right-down:before {\n  content: \"\\e957\";\n} /* '' */\n.uil-corner-up-left-alt:before {\n  content: \"\\e958\";\n} /* '' */\n.uil-corner-up-left:before {\n  content: \"\\e959\";\n} /* '' */\n.uil-corner-up-right-alt:before {\n  content: \"\\e95a\";\n} /* '' */\n.uil-corner-up-right:before {\n  content: \"\\e95b\";\n} /* '' */\n.uil-creative-commons-pd-alt:before {\n  content: \"\\e95c\";\n} /* '' */\n.uil-creative-commons-pd:before {\n  content: \"\\e95d\";\n} /* '' */\n.uil-crockery:before {\n  content: \"\\e95e\";\n} /* '' */\n.uil-crop-alt-rotate-left:before {\n  content: \"\\e95f\";\n} /* '' */\n.uil-crop-alt-rotate-right:before {\n  content: \"\\e960\";\n} /* '' */\n.uil-crop-alt:before {\n  content: \"\\e961\";\n} /* '' */\n.uil-crosshair-alt:before {\n  content: \"\\e962\";\n} /* '' */\n.uil-crosshair:before {\n  content: \"\\e963\";\n} /* '' */\n.uil-crosshairs:before {\n  content: \"\\e964\";\n} /* '' */\n.uil-cube:before {\n  content: \"\\e965\";\n} /* '' */\n.uil-dashboard:before {\n  content: \"\\e966\";\n} /* '' */\n.uil-data-sharing:before {\n  content: \"\\e967\";\n} /* '' */\n.uil-database-alt:before {\n  content: \"\\e968\";\n} /* '' */\n.uil-database:before {\n  content: \"\\e969\";\n} /* '' */\n.uil-desert:before {\n  content: \"\\e96a\";\n} /* '' */\n.uil-desktop-alt-slash:before {\n  content: \"\\e96b\";\n} /* '' */\n.uil-desktop-alt:before {\n  content: \"\\e96c\";\n} /* '' */\n.uil-desktop-cloud-alt:before {\n  content: \"\\e96d\";\n} /* '' */\n.uil-desktop-slash:before {\n  content: \"\\e96e\";\n} /* '' */\n.uil-desktop:before {\n  content: \"\\e96f\";\n} /* '' */\n.uil-dialpad-alt:before {\n  content: \"\\e970\";\n} /* '' */\n.uil-dialpad:before {\n  content: \"\\e971\";\n} /* '' */\n.uil-diamond:before {\n  content: \"\\e972\";\n} /* '' */\n.uil-diary-alt:before {\n  content: \"\\e973\";\n} /* '' */\n.uil-diary:before {\n  content: \"\\e974\";\n} /* '' */\n.uil-dice-five:before {\n  content: \"\\e975\";\n} /* '' */\n.uil-dice-four:before {\n  content: \"\\e976\";\n} /* '' */\n.uil-dice-one:before {\n  content: \"\\e977\";\n} /* '' */\n.uil-dice-six:before {\n  content: \"\\e978\";\n} /* '' */\n.uil-dice-three:before {\n  content: \"\\e979\";\n} /* '' */\n.uil-dice-two:before {\n  content: \"\\e97a\";\n} /* '' */\n.uil-direction:before {\n  content: \"\\e97b\";\n} /* '' */\n.uil-directions:before {\n  content: \"\\e97c\";\n} /* '' */\n.uil-dizzy-meh:before {\n  content: \"\\e97d\";\n} /* '' */\n.uil-dna:before {\n  content: \"\\e97e\";\n} /* '' */\n.uil-document-layout-center:before {\n  content: \"\\e97f\";\n} /* '' */\n.uil-document-layout-left:before {\n  content: \"\\e980\";\n} /* '' */\n.uil-document-layout-right:before {\n  content: \"\\e981\";\n} /* '' */\n.uil-document:before {\n  content: \"\\e982\";\n} /* '' */\n.uil-dollar-alt:before {\n  content: \"\\e983\";\n} /* '' */\n.uil-dollar-sign-alt:before {\n  content: \"\\e984\";\n} /* '' */\n.uil-dollar-sign:before {\n  content: \"\\e985\";\n} /* '' */\n.uil-down-arrow:before {\n  content: \"\\e986\";\n} /* '' */\n.uil-download-alt:before {\n  content: \"\\e987\";\n} /* '' */\n.uil-dribbble:before {\n  content: \"\\e988\";\n} /* '' */\n.uil-drill:before {\n  content: \"\\e989\";\n} /* '' */\n.uil-dropbox:before {\n  content: \"\\e98a\";\n} /* '' */\n.uil-dumbbell:before {\n  content: \"\\e98b\";\n} /* '' */\n.uil-ear:before {\n  content: \"\\e98c\";\n} /* '' */\n.uil-edit-alt:before {\n  content: \"\\e98d\";\n} /* '' */\n.uil-edit:before {\n  content: \"\\e98e\";\n} /* '' */\n.uil-ellipsis-h:before {\n  content: \"\\e98f\";\n} /* '' */\n.uil-ellipsis-v:before {\n  content: \"\\e990\";\n} /* '' */\n.uil-emoji:before {\n  content: \"\\e991\";\n} /* '' */\n.uil-enter:before {\n  content: \"\\e992\";\n} /* '' */\n.uil-entry:before {\n  content: \"\\e993\";\n} /* '' */\n.uil-envelope-add:before {\n  content: \"\\e994\";\n} /* '' */\n.uil-envelope-alt:before {\n  content: \"\\e995\";\n} /* '' */\n.uil-envelope-block:before {\n  content: \"\\e996\";\n} /* '' */\n.uil-envelope-bookmark:before {\n  content: \"\\e997\";\n} /* '' */\n.uil-envelope-check:before {\n  content: \"\\e998\";\n} /* '' */\n.uil-envelope-download-alt:before {\n  content: \"\\e999\";\n} /* '' */\n.uil-envelope-download:before {\n  content: \"\\e99a\";\n} /* '' */\n.uil-envelope-edit:before {\n  content: \"\\e99b\";\n} /* '' */\n.uil-envelope-exclamation:before {\n  content: \"\\e99c\";\n} /* '' */\n.uil-envelope-heart:before {\n  content: \"\\e99d\";\n} /* '' */\n.uil-envelope-info:before {\n  content: \"\\e99e\";\n} /* '' */\n.uil-envelope-lock:before {\n  content: \"\\e99f\";\n} /* '' */\n.uil-envelope-minus:before {\n  content: \"\\e9a0\";\n} /* '' */\n.uil-envelope-open:before {\n  content: \"\\e9a1\";\n} /* '' */\n.uil-envelope-question:before {\n  content: \"\\e9a2\";\n} /* '' */\n.uil-envelope-receive:before {\n  content: \"\\e9a3\";\n} /* '' */\n.uil-envelope-redo:before {\n  content: \"\\e9a4\";\n} /* '' */\n.uil-envelope-search:before {\n  content: \"\\e9a5\";\n} /* '' */\n.uil-envelope-send:before {\n  content: \"\\e9a6\";\n} /* '' */\n.uil-envelope-share:before {\n  content: \"\\e9a7\";\n} /* '' */\n.uil-envelope-shield:before {\n  content: \"\\e9a8\";\n} /* '' */\n.uil-envelope-star:before {\n  content: \"\\e9a9\";\n} /* '' */\n.uil-envelope-times:before {\n  content: \"\\e9aa\";\n} /* '' */\n.uil-envelope-upload-alt:before {\n  content: \"\\e9ab\";\n} /* '' */\n.uil-envelope-upload:before {\n  content: \"\\e9ac\";\n} /* '' */\n.uil-envelope:before {\n  content: \"\\e9ad\";\n} /* '' */\n.uil-envelopes:before {\n  content: \"\\e9ae\";\n} /* '' */\n.uil-equal-circle:before {\n  content: \"\\e9af\";\n} /* '' */\n.uil-euro-circle:before {\n  content: \"\\e9b0\";\n} /* '' */\n.uil-euro:before {\n  content: \"\\e9b1\";\n} /* '' */\n.uil-exchange-alt:before {\n  content: \"\\e9b2\";\n} /* '' */\n.uil-exchange:before {\n  content: \"\\e9b3\";\n} /* '' */\n.uil-exclamation-circle:before {\n  content: \"\\e9b4\";\n} /* '' */\n.uil-exclamation-octagon:before {\n  content: \"\\e9b5\";\n} /* '' */\n.uil-exclamation-triangle:before {\n  content: \"\\e9b6\";\n} /* '' */\n.uil-exclude:before {\n  content: \"\\e9b7\";\n} /* '' */\n.uil-exit:before {\n  content: \"\\e9b8\";\n} /* '' */\n.uil-expand-alt:before {\n  content: \"\\e9b9\";\n} /* '' */\n.uil-expand-arrows-alt:before {\n  content: \"\\e9ba\";\n} /* '' */\n.uil-expand-arrows:before {\n  content: \"\\e9bb\";\n} /* '' */\n.uil-expand-from-corner:before {\n  content: \"\\e9bc\";\n} /* '' */\n.uil-expand-left:before {\n  content: \"\\e9bd\";\n} /* '' */\n.uil-expand-right:before {\n  content: \"\\e9be\";\n} /* '' */\n.uil-export:before {\n  content: \"\\e9bf\";\n} /* '' */\n.uil-exposure-alt:before {\n  content: \"\\e9c0\";\n} /* '' */\n.uil-exposure-increase:before {\n  content: \"\\e9c1\";\n} /* '' */\n.uil-external-link-alt:before {\n  content: \"\\e9c2\";\n} /* '' */\n.uil-eye-slash:before {\n  content: \"\\e9c3\";\n} /* '' */\n.uil-eye:before {\n  content: \"\\e9c4\";\n} /* '' */\n.uil-facebook-f:before {\n  content: \"\\e9c5\";\n} /* '' */\n.uil-facebook-messenger:before {\n  content: \"\\e9c6\";\n} /* '' */\n.uil-facebook:before {\n  content: \"\\e9c7\";\n} /* '' */\n.uil-fahrenheit:before {\n  content: \"\\e9c8\";\n} /* '' */\n.uil-fast-mail-alt:before {\n  content: \"\\e9c9\";\n} /* '' */\n.uil-fast-mail:before {\n  content: \"\\e9ca\";\n} /* '' */\n.uil-favorite:before {\n  content: \"\\e9cb\";\n} /* '' */\n.uil-feedback:before {\n  content: \"\\e9cc\";\n} /* '' */\n.uil-file-alt:before {\n  content: \"\\e9cd\";\n} /* '' */\n.uil-file-blank:before {\n  content: \"\\e9ce\";\n} /* '' */\n.uil-file-block-alt:before {\n  content: \"\\e9cf\";\n} /* '' */\n.uil-file-bookmark-alt:before {\n  content: \"\\e9d0\";\n} /* '' */\n.uil-file-check-alt:before {\n  content: \"\\e9d1\";\n} /* '' */\n.uil-file-check:before {\n  content: \"\\e9d2\";\n} /* '' */\n.uil-file-contract-dollar:before {\n  content: \"\\e9d3\";\n} /* '' */\n.uil-file-copy-alt:before {\n  content: \"\\e9d4\";\n} /* '' */\n.uil-file-download-alt:before {\n  content: \"\\e9d5\";\n} /* '' */\n.uil-file-download:before {\n  content: \"\\e9d6\";\n} /* '' */\n.uil-file-edit-alt:before {\n  content: \"\\e9d7\";\n} /* '' */\n.uil-file-exclamation-alt:before {\n  content: \"\\e9d8\";\n} /* '' */\n.uil-file-exclamation:before {\n  content: \"\\e9d9\";\n} /* '' */\n.uil-file-heart:before {\n  content: \"\\e9da\";\n} /* '' */\n.uil-file-info-alt:before {\n  content: \"\\e9db\";\n} /* '' */\n.uil-file-landscape-alt:before {\n  content: \"\\e9dc\";\n} /* '' */\n.uil-file-landscape:before {\n  content: \"\\e9dd\";\n} /* '' */\n.uil-file-lanscape-slash:before {\n  content: \"\\e9de\";\n} /* '' */\n.uil-file-lock-alt:before {\n  content: \"\\e9df\";\n} /* '' */\n.uil-file-medical-alt:before {\n  content: \"\\e9e0\";\n} /* '' */\n.uil-file-medical:before {\n  content: \"\\e9e1\";\n} /* '' */\n.uil-file-minus-alt:before {\n  content: \"\\e9e2\";\n} /* '' */\n.uil-file-minus:before {\n  content: \"\\e9e3\";\n} /* '' */\n.uil-file-network:before {\n  content: \"\\e9e4\";\n} /* '' */\n.uil-file-plus-alt:before {\n  content: \"\\e9e5\";\n} /* '' */\n.uil-file-plus:before {\n  content: \"\\e9e6\";\n} /* '' */\n.uil-file-question-alt:before {\n  content: \"\\e9e7\";\n} /* '' */\n.uil-file-question:before {\n  content: \"\\e9e8\";\n} /* '' */\n.uil-file-redo-alt:before {\n  content: \"\\e9e9\";\n} /* '' */\n.uil-file-search-alt:before {\n  content: \"\\e9ea\";\n} /* '' */\n.uil-file-share-alt:before {\n  content: \"\\e9eb\";\n} /* '' */\n.uil-file-shield-alt:before {\n  content: \"\\e9ec\";\n} /* '' */\n.uil-file-slash:before {\n  content: \"\\e9ed\";\n} /* '' */\n.uil-file-times-alt:before {\n  content: \"\\e9ee\";\n} /* '' */\n.uil-file-times:before {\n  content: \"\\e9ef\";\n} /* '' */\n.uil-file-upload-alt:before {\n  content: \"\\e9f0\";\n} /* '' */\n.uil-file-upload:before {\n  content: \"\\e9f1\";\n} /* '' */\n.uil-file:before {\n  content: \"\\e9f2\";\n} /* '' */\n.uil-files-landscapes-alt:before {\n  content: \"\\e9f3\";\n} /* '' */\n.uil-files-landscapes:before {\n  content: \"\\e9f4\";\n} /* '' */\n.uil-film:before {\n  content: \"\\e9f5\";\n} /* '' */\n.uil-filter-slash:before {\n  content: \"\\e9f6\";\n} /* '' */\n.uil-filter:before {\n  content: \"\\e9f7\";\n} /* '' */\n.uil-flask-potion:before {\n  content: \"\\e9f8\";\n} /* '' */\n.uil-flask:before {\n  content: \"\\e9f9\";\n} /* '' */\n.uil-flip-h-alt:before {\n  content: \"\\e9fa\";\n} /* '' */\n.uil-flip-h:before {\n  content: \"\\e9fb\";\n} /* '' */\n.uil-flip-v-alt:before {\n  content: \"\\e9fc\";\n} /* '' */\n.uil-flip-v:before {\n  content: \"\\e9fd\";\n} /* '' */\n.uil-flower:before {\n  content: \"\\e9fe\";\n} /* '' */\n.uil-focus-add:before {\n  content: \"\\e9ff\";\n} /* '' */\n.uil-focus-target:before {\n  content: \"\\ea00\";\n} /* '' */\n.uil-focus:before {\n  content: \"\\ea01\";\n} /* '' */\n.uil-folder-check:before {\n  content: \"\\ea02\";\n} /* '' */\n.uil-folder-download:before {\n  content: \"\\ea03\";\n} /* '' */\n.uil-folder-exclamation:before {\n  content: \"\\ea04\";\n} /* '' */\n.uil-folder-heart:before {\n  content: \"\\ea05\";\n} /* '' */\n.uil-folder-info:before {\n  content: \"\\ea06\";\n} /* '' */\n.uil-folder-lock:before {\n  content: \"\\ea07\";\n} /* '' */\n.uil-folder-medical:before {\n  content: \"\\ea08\";\n} /* '' */\n.uil-folder-minus:before {\n  content: \"\\ea09\";\n} /* '' */\n.uil-folder-network:before {\n  content: \"\\ea0a\";\n} /* '' */\n.uil-folder-plus:before {\n  content: \"\\ea0b\";\n} /* '' */\n.uil-folder-question:before {\n  content: \"\\ea0c\";\n} /* '' */\n.uil-folder-slash:before {\n  content: \"\\ea0d\";\n} /* '' */\n.uil-folder-times:before {\n  content: \"\\ea0e\";\n} /* '' */\n.uil-folder-upload:before {\n  content: \"\\ea0f\";\n} /* '' */\n.uil-folder:before {\n  content: \"\\ea10\";\n} /* '' */\n.uil-food:before {\n  content: \"\\ea11\";\n} /* '' */\n.uil-football-american:before {\n  content: \"\\ea12\";\n} /* '' */\n.uil-football-ball:before {\n  content: \"\\ea13\";\n} /* '' */\n.uil-football:before {\n  content: \"\\ea14\";\n} /* '' */\n.uil-forecastcloud-moon-tear:before {\n  content: \"\\ea15\";\n} /* '' */\n.uil-forwaded-call:before {\n  content: \"\\ea16\";\n} /* '' */\n.uil-forward:before {\n  content: \"\\ea17\";\n} /* '' */\n.uil-frown:before {\n  content: \"\\ea18\";\n} /* '' */\n.uil-game-structure:before {\n  content: \"\\ea19\";\n} /* '' */\n.uil-game:before {\n  content: \"\\ea1a\";\n} /* '' */\n.uil-gift:before {\n  content: \"\\ea1b\";\n} /* '' */\n.uil-github-alt:before {\n  content: \"\\ea1c\";\n} /* '' */\n.uil-github:before {\n  content: \"\\ea1d\";\n} /* '' */\n.uil-glass-martini-alt-slash:before {\n  content: \"\\ea1e\";\n} /* '' */\n.uil-glass-martini-alt:before {\n  content: \"\\ea1f\";\n} /* '' */\n.uil-glass-martini:before {\n  content: \"\\ea20\";\n} /* '' */\n.uil-glass-tea:before {\n  content: \"\\ea21\";\n} /* '' */\n.uil-glass:before {\n  content: \"\\ea22\";\n} /* '' */\n.uil-globe:before {\n  content: \"\\ea23\";\n} /* '' */\n.uil-gold:before {\n  content: \"\\ea24\";\n} /* '' */\n.uil-google-drive-alt:before {\n  content: \"\\ea25\";\n} /* '' */\n.uil-google-drive:before {\n  content: \"\\ea26\";\n} /* '' */\n.uil-google-hangouts:before {\n  content: \"\\ea27\";\n} /* '' */\n.uil-google-play:before {\n  content: \"\\ea28\";\n} /* '' */\n.uil-google:before {\n  content: \"\\ea29\";\n} /* '' */\n.uil-graduation-hat:before {\n  content: \"\\ea2a\";\n} /* '' */\n.uil-graph-bar:before {\n  content: \"\\ea2b\";\n} /* '' */\n.uil-grid:before {\n  content: \"\\ea2c\";\n} /* '' */\n.uil-grids:before {\n  content: \"\\ea2d\";\n} /* '' */\n.uil-grin-tongue-wink-alt:before {\n  content: \"\\ea2e\";\n} /* '' */\n.uil-grin-tongue-wink:before {\n  content: \"\\ea2f\";\n} /* '' */\n.uil-grin:before {\n  content: \"\\ea30\";\n} /* '' */\n.uil-grip-horizontal-line:before {\n  content: \"\\ea31\";\n} /* '' */\n.uil-hdd:before {\n  content: \"\\ea32\";\n} /* '' */\n.uil-headphones-alt:before {\n  content: \"\\ea33\";\n} /* '' */\n.uil-headphones:before {\n  content: \"\\ea34\";\n} /* '' */\n.uil-heart-alt:before {\n  content: \"\\ea35\";\n} /* '' */\n.uil-heart-medical:before {\n  content: \"\\ea36\";\n} /* '' */\n.uil-heart-rate:before {\n  content: \"\\ea37\";\n} /* '' */\n.uil-heart-sign:before {\n  content: \"\\ea38\";\n} /* '' */\n.uil-heart:before {\n  content: \"\\ea39\";\n} /* '' */\n.uil-heartbeat:before {\n  content: \"\\ea3a\";\n} /* '' */\n.uil-history-alt:before {\n  content: \"\\ea3b\";\n} /* '' */\n.uil-history:before {\n  content: \"\\ea3c\";\n} /* '' */\n.uil-home-alt:before {\n  content: \"\\ea3d\";\n} /* '' */\n.uil-home:before {\n  content: \"\\ea3e\";\n} /* '' */\n.uil-horizontal-align-center:before {\n  content: \"\\ea3f\";\n} /* '' */\n.uil-horizontal-align-left:before {\n  content: \"\\ea40\";\n} /* '' */\n.uil-horizontal-align-right:before {\n  content: \"\\ea41\";\n} /* '' */\n.uil-horizontal-distribution-center:before {\n  content: \"\\ea42\";\n} /* '' */\n.uil-horizontal-distribution-left:before {\n  content: \"\\ea43\";\n} /* '' */\n.uil-horizontal-distribution-right:before {\n  content: \"\\ea44\";\n} /* '' */\n.uil-hunting:before {\n  content: \"\\ea45\";\n} /* '' */\n.uil-image-alt-slash:before {\n  content: \"\\ea46\";\n} /* '' */\n.uil-image-block:before {\n  content: \"\\ea47\";\n} /* '' */\n.uil-image-broken:before {\n  content: \"\\ea48\";\n} /* '' */\n.uil-image-check:before {\n  content: \"\\ea49\";\n} /* '' */\n.uil-image-download:before {\n  content: \"\\ea4a\";\n} /* '' */\n.uil-image-edit:before {\n  content: \"\\ea4b\";\n} /* '' */\n.uil-image-lock:before {\n  content: \"\\ea4c\";\n} /* '' */\n.uil-image-minus:before {\n  content: \"\\ea4d\";\n} /* '' */\n.uil-image-plus:before {\n  content: \"\\ea4e\";\n} /* '' */\n.uil-image-question:before {\n  content: \"\\ea4f\";\n} /* '' */\n.uil-image-redo:before {\n  content: \"\\ea50\";\n} /* '' */\n.uil-image-resize-landscape:before {\n  content: \"\\ea51\";\n} /* '' */\n.uil-image-resize-square:before {\n  content: \"\\ea52\";\n} /* '' */\n.uil-image-search:before {\n  content: \"\\ea53\";\n} /* '' */\n.uil-image-share:before {\n  content: \"\\ea54\";\n} /* '' */\n.uil-image-shield:before {\n  content: \"\\ea55\";\n} /* '' */\n.uil-image-slash:before {\n  content: \"\\ea56\";\n} /* '' */\n.uil-image-times:before {\n  content: \"\\ea57\";\n} /* '' */\n.uil-image-upload:before {\n  content: \"\\ea58\";\n} /* '' */\n.uil-image-v:before {\n  content: \"\\ea59\";\n} /* '' */\n.uil-image:before {\n  content: \"\\ea5a\";\n} /* '' */\n.uil-images:before {\n  content: \"\\ea5b\";\n} /* '' */\n.uil-incoming-call:before {\n  content: \"\\ea5c\";\n} /* '' */\n.uil-info-circle:before {\n  content: \"\\ea5d\";\n} /* '' */\n.uil-instagram-alt:before {\n  content: \"\\ea5e\";\n} /* '' */\n.uil-instagram:before {\n  content: \"\\ea5f\";\n} /* '' */\n.uil-intercom:before {\n  content: \"\\ea60\";\n} /* '' */\n.uil-invoice:before {\n  content: \"\\ea61\";\n} /* '' */\n.uil-italic:before {\n  content: \"\\ea62\";\n} /* '' */\n.uil-jackhammer:before {\n  content: \"\\ea63\";\n} /* '' */\n.uil-java-script:before {\n  content: \"\\ea64\";\n} /* '' */\n.uil-kayak:before {\n  content: \"\\ea65\";\n} /* '' */\n.uil-key-skeleton-alt:before {\n  content: \"\\ea66\";\n} /* '' */\n.uil-key-skeleton:before {\n  content: \"\\ea67\";\n} /* '' */\n.uil-keyboard-alt:before {\n  content: \"\\ea68\";\n} /* '' */\n.uil-keyboard-hide:before {\n  content: \"\\ea69\";\n} /* '' */\n.uil-keyboard-show:before {\n  content: \"\\ea6a\";\n} /* '' */\n.uil-keyboard:before {\n  content: \"\\ea6b\";\n} /* '' */\n.uil-keyhole-circle:before {\n  content: \"\\ea6c\";\n} /* '' */\n.uil-keyhole-square-full:before {\n  content: \"\\ea6d\";\n} /* '' */\n.uil-keyhole-square:before {\n  content: \"\\ea6e\";\n} /* '' */\n.uil-kid:before {\n  content: \"\\ea6f\";\n} /* '' */\n.uil-label-alt:before {\n  content: \"\\ea70\";\n} /* '' */\n.uil-label:before {\n  content: \"\\ea71\";\n} /* '' */\n.uil-lamp:before {\n  content: \"\\ea72\";\n} /* '' */\n.uil-laptop-cloud:before {\n  content: \"\\ea73\";\n} /* '' */\n.uil-laptop:before {\n  content: \"\\ea74\";\n} /* '' */\n.uil-laughing:before {\n  content: \"\\ea75\";\n} /* '' */\n.uil-layer-group-slash:before {\n  content: \"\\ea76\";\n} /* '' */\n.uil-layer-group:before {\n  content: \"\\ea77\";\n} /* '' */\n.uil-layers-alt:before {\n  content: \"\\ea78\";\n} /* '' */\n.uil-layers-slash:before {\n  content: \"\\ea79\";\n} /* '' */\n.uil-layers:before {\n  content: \"\\ea7a\";\n} /* '' */\n.uil-left-arrow-from-left:before {\n  content: \"\\ea7b\";\n} /* '' */\n.uil-left-arrow-to-left:before {\n  content: \"\\ea7c\";\n} /* '' */\n.uil-left-indent-alt:before {\n  content: \"\\ea7d\";\n} /* '' */\n.uil-left-indent:before {\n  content: \"\\ea7e\";\n} /* '' */\n.uil-left-to-right-text-direction:before {\n  content: \"\\ea7f\";\n} /* '' */\n.uil-life-ring:before {\n  content: \"\\ea80\";\n} /* '' */\n.uil-lightbulb-alt:before {\n  content: \"\\ea81\";\n} /* '' */\n.uil-lightbulb:before {\n  content: \"\\ea82\";\n} /* '' */\n.uil-line-alt:before {\n  content: \"\\ea83\";\n} /* '' */\n.uil-line-spacing:before {\n  content: \"\\ea84\";\n} /* '' */\n.uil-line:before {\n  content: \"\\ea85\";\n} /* '' */\n.uil-link-alt:before {\n  content: \"\\ea86\";\n} /* '' */\n.uil-link-broken:before {\n  content: \"\\ea87\";\n} /* '' */\n.uil-link-h:before {\n  content: \"\\ea88\";\n} /* '' */\n.uil-link:before {\n  content: \"\\ea89\";\n} /* '' */\n.uil-linkedin-alt:before {\n  content: \"\\ea8a\";\n} /* '' */\n.uil-linkedin:before {\n  content: \"\\ea8b\";\n} /* '' */\n.uil-list-ui-alt:before {\n  content: \"\\ea8c\";\n} /* '' */\n.uil-list-ul:before {\n  content: \"\\ea8d\";\n} /* '' */\n.uil-location-arrow-alt:before {\n  content: \"\\ea8e\";\n} /* '' */\n.uil-location-arrow:before {\n  content: \"\\ea8f\";\n} /* '' */\n.uil-location-pin-alt:before {\n  content: \"\\ea90\";\n} /* '' */\n.uil-location-point:before {\n  content: \"\\ea91\";\n} /* '' */\n.uil-location:before {\n  content: \"\\ea92\";\n} /* '' */\n.uil-lock-access:before {\n  content: \"\\ea93\";\n} /* '' */\n.uil-lock-alt:before {\n  content: \"\\ea94\";\n} /* '' */\n.uil-lock-open-alt:before {\n  content: \"\\ea95\";\n} /* '' */\n.uil-lock-slash:before {\n  content: \"\\ea96\";\n} /* '' */\n.uil-lock:before {\n  content: \"\\ea97\";\n} /* '' */\n.uil-mailbox-alt:before {\n  content: \"\\ea98\";\n} /* '' */\n.uil-mailbox:before {\n  content: \"\\ea99\";\n} /* '' */\n.uil-map-marker-alt:before {\n  content: \"\\ea9a\";\n} /* '' */\n.uil-map-marker-edit:before {\n  content: \"\\ea9b\";\n} /* '' */\n.uil-map-marker-info:before {\n  content: \"\\ea9c\";\n} /* '' */\n.uil-map-marker-minus:before {\n  content: \"\\ea9d\";\n} /* '' */\n.uil-map-marker-plus:before {\n  content: \"\\ea9e\";\n} /* '' */\n.uil-map-marker-question:before {\n  content: \"\\ea9f\";\n} /* '' */\n.uil-map-marker-shield:before {\n  content: \"\\eaa0\";\n} /* '' */\n.uil-map-marker-slash:before {\n  content: \"\\eaa1\";\n} /* '' */\n.uil-map-marker:before {\n  content: \"\\eaa2\";\n} /* '' */\n.uil-map-pin-alt:before {\n  content: \"\\eaa3\";\n} /* '' */\n.uil-map-pin:before {\n  content: \"\\eaa4\";\n} /* '' */\n.uil-map:before {\n  content: \"\\eaa5\";\n} /* '' */\n.uil-mars:before {\n  content: \"\\eaa6\";\n} /* '' */\n.uil-maximize-left:before {\n  content: \"\\eaa7\";\n} /* '' */\n.uil-medal:before {\n  content: \"\\eaa8\";\n} /* '' */\n.uil-medical-drip:before {\n  content: \"\\eaa9\";\n} /* '' */\n.uil-medical-square-full:before {\n  content: \"\\eaaa\";\n} /* '' */\n.uil-medical-square:before {\n  content: \"\\eaab\";\n} /* '' */\n.uil-medical:before {\n  content: \"\\eaac\";\n} /* '' */\n.uil-medium-m:before {\n  content: \"\\eaad\";\n} /* '' */\n.uil-medkit:before {\n  content: \"\\eaae\";\n} /* '' */\n.uil-meeting-board:before {\n  content: \"\\eaaf\";\n} /* '' */\n.uil-meh-alt:before {\n  content: \"\\eab0\";\n} /* '' */\n.uil-meh-closed-eye:before {\n  content: \"\\eab1\";\n} /* '' */\n.uil-meh:before {\n  content: \"\\eab2\";\n} /* '' */\n.uil-message:before {\n  content: \"\\eab3\";\n} /* '' */\n.uil-microphone-slash:before {\n  content: \"\\eab4\";\n} /* '' */\n.uil-microphone:before {\n  content: \"\\eab5\";\n} /* '' */\n.uil-minus-circle:before {\n  content: \"\\eab6\";\n} /* '' */\n.uil-minus-path:before {\n  content: \"\\eab7\";\n} /* '' */\n.uil-minus-square-full:before {\n  content: \"\\eab8\";\n} /* '' */\n.uil-minus-square:before {\n  content: \"\\eab9\";\n} /* '' */\n.uil-minus:before {\n  content: \"\\eaba\";\n} /* '' */\n.uil-missed-call:before {\n  content: \"\\eabb\";\n} /* '' */\n.uil-mobey-bill-slash:before {\n  content: \"\\eabc\";\n} /* '' */\n.uil-mobile-android-alt:before {\n  content: \"\\eabd\";\n} /* '' */\n.uil-mobile-android:before {\n  content: \"\\eabe\";\n} /* '' */\n.uil-mobile-vibrate:before {\n  content: \"\\eabf\";\n} /* '' */\n.uil-modem:before {\n  content: \"\\eac0\";\n} /* '' */\n.uil-money-bill-stack:before {\n  content: \"\\eac1\";\n} /* '' */\n.uil-money-bill:before {\n  content: \"\\eac2\";\n} /* '' */\n.uil-money-insert:before {\n  content: \"\\eac3\";\n} /* '' */\n.uil-money-stack:before {\n  content: \"\\eac4\";\n} /* '' */\n.uil-money-withdraw:before {\n  content: \"\\eac5\";\n} /* '' */\n.uil-money-withdrawal:before {\n  content: \"\\eac6\";\n} /* '' */\n.uil-moneybag-alt:before {\n  content: \"\\eac7\";\n} /* '' */\n.uil-moneybag:before {\n  content: \"\\eac8\";\n} /* '' */\n.uil-monitor-heart-rate:before {\n  content: \"\\eac9\";\n} /* '' */\n.uil-monitor:before {\n  content: \"\\eaca\";\n} /* '' */\n.uil-moon-eclipse:before {\n  content: \"\\eacb\";\n} /* '' */\n.uil-moon:before {\n  content: \"\\eacc\";\n} /* '' */\n.uil-moonset:before {\n  content: \"\\eacd\";\n} /* '' */\n.uil-mountains-sun:before {\n  content: \"\\eace\";\n} /* '' */\n.uil-mountains:before {\n  content: \"\\eacf\";\n} /* '' */\n.uil-mouse-alt:before {\n  content: \"\\ead0\";\n} /* '' */\n.uil-mouse:before {\n  content: \"\\ead1\";\n} /* '' */\n.uil-multiply:before {\n  content: \"\\ead2\";\n} /* '' */\n.uil-music-note:before {\n  content: \"\\ead3\";\n} /* '' */\n.uil-music-tune-slash:before {\n  content: \"\\ead4\";\n} /* '' */\n.uil-music:before {\n  content: \"\\ead5\";\n} /* '' */\n.uil-n-a:before {\n  content: \"\\ead6\";\n} /* '' */\n.uil-navigator:before {\n  content: \"\\ead7\";\n} /* '' */\n.uil-nerd:before {\n  content: \"\\ead8\";\n} /* '' */\n.uil-newspaper:before {\n  content: \"\\ead9\";\n} /* '' */\n.uil-ninja:before {\n  content: \"\\eada\";\n} /* '' */\n.uil-no-entry:before {\n  content: \"\\eadb\";\n} /* '' */\n.uil-notebooks:before {\n  content: \"\\eadc\";\n} /* '' */\n.uil-notes:before {\n  content: \"\\eadd\";\n} /* '' */\n.uil-object-group:before {\n  content: \"\\eade\";\n} /* '' */\n.uil-object-ungroup:before {\n  content: \"\\eadf\";\n} /* '' */\n.uil-octagon:before {\n  content: \"\\eae0\";\n} /* '' */\n.uil-outgoing-call:before {\n  content: \"\\eae1\";\n} /* '' */\n.uil-package:before {\n  content: \"\\eae2\";\n} /* '' */\n.uil-padlock:before {\n  content: \"\\eae3\";\n} /* '' */\n.uil-paint-tool:before {\n  content: \"\\eae4\";\n} /* '' */\n.uil-palette:before {\n  content: \"\\eae5\";\n} /* '' */\n.uil-panorama-h-alt:before {\n  content: \"\\eae6\";\n} /* '' */\n.uil-panorama-h:before {\n  content: \"\\eae7\";\n} /* '' */\n.uil-panorama-v:before {\n  content: \"\\eae8\";\n} /* '' */\n.uil-paperclip:before {\n  content: \"\\eae9\";\n} /* '' */\n.uil-paragraph:before {\n  content: \"\\eaea\";\n} /* '' */\n.uil-parcel:before {\n  content: \"\\eaeb\";\n} /* '' */\n.uil-parking-square:before {\n  content: \"\\eaec\";\n} /* '' */\n.uil-pathfinder-unite:before {\n  content: \"\\eaed\";\n} /* '' */\n.uil-pathfinder:before {\n  content: \"\\eaee\";\n} /* '' */\n.uil-pause-circle:before {\n  content: \"\\eaef\";\n} /* '' */\n.uil-pause:before {\n  content: \"\\eaf0\";\n} /* '' */\n.uil-paypal:before {\n  content: \"\\eaf1\";\n} /* '' */\n.uil-pen:before {\n  content: \"\\eaf2\";\n} /* '' */\n.uil-pentagon:before {\n  content: \"\\eaf3\";\n} /* '' */\n.uil-phone-alt:before {\n  content: \"\\eaf4\";\n} /* '' */\n.uil-phone-pause:before {\n  content: \"\\eaf5\";\n} /* '' */\n.uil-phone-slash:before {\n  content: \"\\eaf6\";\n} /* '' */\n.uil-phone-times:before {\n  content: \"\\eaf7\";\n} /* '' */\n.uil-phone-volume:before {\n  content: \"\\eaf8\";\n} /* '' */\n.uil-phone:before {\n  content: \"\\eaf9\";\n} /* '' */\n.uil-picture:before {\n  content: \"\\eafa\";\n} /* '' */\n.uil-plane-arrival:before {\n  content: \"\\eafb\";\n} /* '' */\n.uil-plane-departure:before {\n  content: \"\\eafc\";\n} /* '' */\n.uil-plane-fly:before {\n  content: \"\\eafd\";\n} /* '' */\n.uil-plane:before {\n  content: \"\\eafe\";\n} /* '' */\n.uil-play-circle:before {\n  content: \"\\eaff\";\n} /* '' */\n.uil-play:before {\n  content: \"\\eb00\";\n} /* '' */\n.uil-plug:before {\n  content: \"\\eb01\";\n} /* '' */\n.uil-plus-circle:before {\n  content: \"\\eb02\";\n} /* '' */\n.uil-plus-square:before {\n  content: \"\\eb03\";\n} /* '' */\n.uil-plus:before {\n  content: \"\\eb04\";\n} /* '' */\n.uil-podium:before {\n  content: \"\\eb05\";\n} /* '' */\n.uil-polygon:before {\n  content: \"\\eb06\";\n} /* '' */\n.uil-post-stamp:before {\n  content: \"\\eb07\";\n} /* '' */\n.uil-postcard:before {\n  content: \"\\eb08\";\n} /* '' */\n.uil-pound-circle:before {\n  content: \"\\eb09\";\n} /* '' */\n.uil-pound:before {\n  content: \"\\eb0a\";\n} /* '' */\n.uil-power:before {\n  content: \"\\eb0b\";\n} /* '' */\n.uil-prescription-bottle:before {\n  content: \"\\eb0c\";\n} /* '' */\n.uil-presentation-check:before {\n  content: \"\\eb0d\";\n} /* '' */\n.uil-presentation-edit:before {\n  content: \"\\eb0e\";\n} /* '' */\n.uil-presentation-line:before {\n  content: \"\\eb0f\";\n} /* '' */\n.uil-presentation-lines-alt:before {\n  content: \"\\eb10\";\n} /* '' */\n.uil-presentation-minus:before {\n  content: \"\\eb11\";\n} /* '' */\n.uil-presentation-play:before {\n  content: \"\\eb12\";\n} /* '' */\n.uil-presentation-plus:before {\n  content: \"\\eb13\";\n} /* '' */\n.uil-presentation-times:before {\n  content: \"\\eb14\";\n} /* '' */\n.uil-presentation:before {\n  content: \"\\eb15\";\n} /* '' */\n.uil-previous:before {\n  content: \"\\eb16\";\n} /* '' */\n.uil-pricetag-alt:before {\n  content: \"\\eb17\";\n} /* '' */\n.uil-print-slash:before {\n  content: \"\\eb18\";\n} /* '' */\n.uil-print:before {\n  content: \"\\eb19\";\n} /* '' */\n.uil-processor:before {\n  content: \"\\eb1a\";\n} /* '' */\n.uil-pump:before {\n  content: \"\\eb1b\";\n} /* '' */\n.uil-puzzle-piece:before {\n  content: \"\\eb1c\";\n} /* '' */\n.uil-question-circle:before {\n  content: \"\\eb1d\";\n} /* '' */\n.uil-raddit-alien-alt:before {\n  content: \"\\eb1e\";\n} /* '' */\n.uil-rainbow:before {\n  content: \"\\eb1f\";\n} /* '' */\n.uil-raindrops-alt:before {\n  content: \"\\eb20\";\n} /* '' */\n.uil-raindrops:before {\n  content: \"\\eb21\";\n} /* '' */\n.uil-receipt-alt:before {\n  content: \"\\eb22\";\n} /* '' */\n.uil-receipt:before {\n  content: \"\\eb23\";\n} /* '' */\n.uil-record-audio:before {\n  content: \"\\eb24\";\n} /* '' */\n.uil-redo:before {\n  content: \"\\eb25\";\n} /* '' */\n.uil-refresh:before {\n  content: \"\\eb26\";\n} /* '' */\n.uil-registered:before {\n  content: \"\\eb27\";\n} /* '' */\n.uil-repeat:before {\n  content: \"\\eb28\";\n} /* '' */\n.uil-restaurant:before {\n  content: \"\\eb29\";\n} /* '' */\n.uil-right-indent-alt:before {\n  content: \"\\eb2a\";\n} /* '' */\n.uil-right-to-left-text-direction:before {\n  content: \"\\eb2b\";\n} /* '' */\n.uil-robot:before {\n  content: \"\\eb2c\";\n} /* '' */\n.uil-rope-way:before {\n  content: \"\\eb2d\";\n} /* '' */\n.uil-rotate-360:before {\n  content: \"\\eb2e\";\n} /* '' */\n.uil-rss-alt:before {\n  content: \"\\eb2f\";\n} /* '' */\n.uil-rss-interface:before {\n  content: \"\\eb30\";\n} /* '' */\n.uil-rss:before {\n  content: \"\\eb31\";\n} /* '' */\n.uil-ruler-combined:before {\n  content: \"\\eb32\";\n} /* '' */\n.uil-ruler:before {\n  content: \"\\eb33\";\n} /* '' */\n.uil-sad-cry:before {\n  content: \"\\eb34\";\n} /* '' */\n.uil-sad-crying:before {\n  content: \"\\eb35\";\n} /* '' */\n.uil-sad-dizzy:before {\n  content: \"\\eb36\";\n} /* '' */\n.uil-sad-squint:before {\n  content: \"\\eb37\";\n} /* '' */\n.uil-sad:before {\n  content: \"\\eb38\";\n} /* '' */\n.uil-scaling-left:before {\n  content: \"\\eb39\";\n} /* '' */\n.uil-scaling-right:before {\n  content: \"\\eb3a\";\n} /* '' */\n.uil-scenery:before {\n  content: \"\\eb3b\";\n} /* '' */\n.uil-schedule:before {\n  content: \"\\eb3c\";\n} /* '' */\n.uil-science:before {\n  content: \"\\eb3d\";\n} /* '' */\n.uil-screw:before {\n  content: \"\\eb3e\";\n} /* '' */\n.uil-scroll-h:before {\n  content: \"\\eb3f\";\n} /* '' */\n.uil-scroll:before {\n  content: \"\\eb40\";\n} /* '' */\n.uil-search-alt:before {\n  content: \"\\eb41\";\n} /* '' */\n.uil-search-minus:before {\n  content: \"\\eb42\";\n} /* '' */\n.uil-search-plus:before {\n  content: \"\\eb43\";\n} /* '' */\n.uil-search:before {\n  content: \"\\eb44\";\n} /* '' */\n.uil-selfie:before {\n  content: \"\\eb45\";\n} /* '' */\n.uil-server-alt:before {\n  content: \"\\eb46\";\n} /* '' */\n.uil-server-connection:before {\n  content: \"\\eb47\";\n} /* '' */\n.uil-server-network-alt:before {\n  content: \"\\eb48\";\n} /* '' */\n.uil-server-network:before {\n  content: \"\\eb49\";\n} /* '' */\n.uil-server:before {\n  content: \"\\eb4a\";\n} /* '' */\n.uil-servers:before {\n  content: \"\\eb4b\";\n} /* '' */\n.uil-servicemark:before {\n  content: \"\\eb4c\";\n} /* '' */\n.uil-share-alt:before {\n  content: \"\\eb4d\";\n} /* '' */\n.uil-shield-check:before {\n  content: \"\\eb4e\";\n} /* '' */\n.uil-shield-exclamation:before {\n  content: \"\\eb4f\";\n} /* '' */\n.uil-shield-question:before {\n  content: \"\\eb50\";\n} /* '' */\n.uil-shield-slash:before {\n  content: \"\\eb51\";\n} /* '' */\n.uil-shield:before {\n  content: \"\\eb52\";\n} /* '' */\n.uil-ship:before {\n  content: \"\\eb53\";\n} /* '' */\n.uil-shop:before {\n  content: \"\\eb54\";\n} /* '' */\n.uil-shopping-basket:before {\n  content: \"\\eb55\";\n} /* '' */\n.uil-shopping-cart-alt:before {\n  content: \"\\eb56\";\n} /* '' */\n.uil-shopping-trolley:before {\n  content: \"\\eb57\";\n} /* '' */\n.uil-shovel:before {\n  content: \"\\eb58\";\n} /* '' */\n.uil-shrink:before {\n  content: \"\\eb59\";\n} /* '' */\n.uil-shuffle:before {\n  content: \"\\eb5a\";\n} /* '' */\n.uil-shutter-alt:before {\n  content: \"\\eb5b\";\n} /* '' */\n.uil-shutter:before {\n  content: \"\\eb5c\";\n} /* '' */\n.uil-sick:before {\n  content: \"\\eb5d\";\n} /* '' */\n.uil-sigma:before {\n  content: \"\\eb5e\";\n} /* '' */\n.uil-sign-alt:before {\n  content: \"\\eb5f\";\n} /* '' */\n.uil-sign-in-alt:before {\n  content: \"\\eb60\";\n} /* '' */\n.uil-sign-left:before {\n  content: \"\\eb61\";\n} /* '' */\n.uil-sign-out-alt:before {\n  content: \"\\eb62\";\n} /* '' */\n.uil-sign-right:before {\n  content: \"\\eb63\";\n} /* '' */\n.uil-signal-alt-3:before {\n  content: \"\\eb64\";\n} /* '' */\n.uil-signal-alt:before {\n  content: \"\\eb65\";\n} /* '' */\n.uil-signal:before {\n  content: \"\\eb66\";\n} /* '' */\n.uil-silence:before {\n  content: \"\\eb67\";\n} /* '' */\n.uil-silent-squint:before {\n  content: \"\\eb68\";\n} /* '' */\n.uil-sim-card:before {\n  content: \"\\eb69\";\n} /* '' */\n.uil-sitemap:before {\n  content: \"\\eb6a\";\n} /* '' */\n.uil-skip-forward-alt:before {\n  content: \"\\eb6b\";\n} /* '' */\n.uil-skip-forward-circle:before {\n  content: \"\\eb6c\";\n} /* '' */\n.uil-skip-forward:before {\n  content: \"\\eb6d\";\n} /* '' */\n.uil-slack-alt:before {\n  content: \"\\eb6e\";\n} /* '' */\n.uil-slack:before {\n  content: \"\\eb6f\";\n} /* '' */\n.uil-sliders-v-alt:before {\n  content: \"\\eb70\";\n} /* '' */\n.uil-sliders-v:before {\n  content: \"\\eb71\";\n} /* '' */\n.uil-smile-beam:before {\n  content: \"\\eb72\";\n} /* '' */\n.uil-smile-dizzy:before {\n  content: \"\\eb73\";\n} /* '' */\n.uil-smile-squint-wink-alt:before {\n  content: \"\\eb74\";\n} /* '' */\n.uil-smile-squint-wink:before {\n  content: \"\\eb75\";\n} /* '' */\n.uil-smile-wink-alt:before {\n  content: \"\\eb76\";\n} /* '' */\n.uil-smile-wink:before {\n  content: \"\\eb77\";\n} /* '' */\n.uil-smile:before {\n  content: \"\\eb78\";\n} /* '' */\n.uil-snapchat-ghost:before {\n  content: \"\\eb79\";\n} /* '' */\n.uil-snapchat-square:before {\n  content: \"\\eb7a\";\n} /* '' */\n.uil-snow-flake:before {\n  content: \"\\eb7b\";\n} /* '' */\n.uil-snowflake-alt:before {\n  content: \"\\eb7c\";\n} /* '' */\n.uil-snowflake:before {\n  content: \"\\eb7d\";\n} /* '' */\n.uil-sort-amount-down:before {\n  content: \"\\eb7e\";\n} /* '' */\n.uil-sort-amount-up:before {\n  content: \"\\eb7f\";\n} /* '' */\n.uil-sort:before {\n  content: \"\\eb80\";\n} /* '' */\n.uil-sorting:before {\n  content: \"\\eb81\";\n} /* '' */\n.uil-space-key:before {\n  content: \"\\eb82\";\n} /* '' */\n.uil-spade:before {\n  content: \"\\eb83\";\n} /* '' */\n.uil-sperms:before {\n  content: \"\\eb84\";\n} /* '' */\n.uil-spin:before {\n  content: \"\\eb85\";\n} /* '' */\n.uil-sport:before {\n  content: \"\\eb86\";\n} /* '' */\n.uil-square-full:before {\n  content: \"\\eb87\";\n} /* '' */\n.uil-square-shape:before {\n  content: \"\\eb88\";\n} /* '' */\n.uil-square:before {\n  content: \"\\eb89\";\n} /* '' */\n.uil-squint:before {\n  content: \"\\eb8a\";\n} /* '' */\n.uil-star-half-alt:before {\n  content: \"\\eb8b\";\n} /* '' */\n.uil-star:before {\n  content: \"\\eb8c\";\n} /* '' */\n.uil-step-backward-alt:before {\n  content: \"\\eb8d\";\n} /* '' */\n.uil-step-backward-circle:before {\n  content: \"\\eb8e\";\n} /* '' */\n.uil-step-backward:before {\n  content: \"\\eb8f\";\n} /* '' */\n.uil-step-forward:before {\n  content: \"\\eb90\";\n} /* '' */\n.uil-stop-circle:before {\n  content: \"\\eb91\";\n} /* '' */\n.uil-stopwatch-slash:before {\n  content: \"\\eb92\";\n} /* '' */\n.uil-stopwatch:before {\n  content: \"\\eb93\";\n} /* '' */\n.uil-store-alt:before {\n  content: \"\\eb94\";\n} /* '' */\n.uil-store:before {\n  content: \"\\eb95\";\n} /* '' */\n.uil-streering:before {\n  content: \"\\eb96\";\n} /* '' */\n.uil-stretcher:before {\n  content: \"\\eb97\";\n} /* '' */\n.uil-subject:before {\n  content: \"\\eb98\";\n} /* '' */\n.uil-subway-alt:before {\n  content: \"\\eb99\";\n} /* '' */\n.uil-subway:before {\n  content: \"\\eb9a\";\n} /* '' */\n.uil-suitcase-alt:before {\n  content: \"\\eb9b\";\n} /* '' */\n.uil-suitcase:before {\n  content: \"\\eb9c\";\n} /* '' */\n.uil-sun:before {\n  content: \"\\eb9d\";\n} /* '' */\n.uil-sunset:before {\n  content: \"\\eb9e\";\n} /* '' */\n.uil-surprise:before {\n  content: \"\\eb9f\";\n} /* '' */\n.uil-swatchbook:before {\n  content: \"\\eba0\";\n} /* '' */\n.uil-swimmer:before {\n  content: \"\\eba1\";\n} /* '' */\n.uil-symbol:before {\n  content: \"\\eba2\";\n} /* '' */\n.uil-sync-exclamation:before {\n  content: \"\\eba3\";\n} /* '' */\n.uil-sync-slash:before {\n  content: \"\\eba4\";\n} /* '' */\n.uil-sync:before {\n  content: \"\\eba5\";\n} /* '' */\n.uil-syringe:before {\n  content: \"\\eba6\";\n} /* '' */\n.uil-table:before {\n  content: \"\\eba7\";\n} /* '' */\n.uil-tablet:before {\n  content: \"\\eba8\";\n} /* '' */\n.uil-tablets:before {\n  content: \"\\eba9\";\n} /* '' */\n.uil-tachometer-fast:before {\n  content: \"\\ebaa\";\n} /* '' */\n.uil-tag-alt:before {\n  content: \"\\ebab\";\n} /* '' */\n.uil-tag:before {\n  content: \"\\ebac\";\n} /* '' */\n.uil-tape:before {\n  content: \"\\ebad\";\n} /* '' */\n.uil-taxi:before {\n  content: \"\\ebae\";\n} /* '' */\n.uil-tear:before {\n  content: \"\\ebaf\";\n} /* '' */\n.uil-technology:before {\n  content: \"\\ebb0\";\n} /* '' */\n.uil-telescope:before {\n  content: \"\\ebb1\";\n} /* '' */\n.uil-temperature-empty:before {\n  content: \"\\ebb2\";\n} /* '' */\n.uil-temperature-half:before {\n  content: \"\\ebb3\";\n} /* '' */\n.uil-temperature-minus:before {\n  content: \"\\ebb4\";\n} /* '' */\n.uil-temperature-plus:before {\n  content: \"\\ebb5\";\n} /* '' */\n.uil-temperature-quarter:before {\n  content: \"\\ebb6\";\n} /* '' */\n.uil-temperature-three-quarter:before {\n  content: \"\\ebb7\";\n} /* '' */\n.uil-temperature:before {\n  content: \"\\ebb8\";\n} /* '' */\n.uil-text-fields:before {\n  content: \"\\ebb9\";\n} /* '' */\n.uil-text-size:before {\n  content: \"\\ebba\";\n} /* '' */\n.uil-text-strike-through:before {\n  content: \"\\ebbb\";\n} /* '' */\n.uil-text:before {\n  content: \"\\ebbc\";\n} /* '' */\n.uil-th-large:before {\n  content: \"\\ebbd\";\n} /* '' */\n.uil-th-slash:before {\n  content: \"\\ebbe\";\n} /* '' */\n.uil-th:before {\n  content: \"\\ebbf\";\n} /* '' */\n.uil-thermometer:before {\n  content: \"\\ebc0\";\n} /* '' */\n.uil-thumbs-down:before {\n  content: \"\\ebc1\";\n} /* '' */\n.uil-thumbs-up:before {\n  content: \"\\ebc2\";\n} /* '' */\n.uil-thunderstorm-moon:before {\n  content: \"\\ebc3\";\n} /* '' */\n.uil-thunderstorm-sun:before {\n  content: \"\\ebc4\";\n} /* '' */\n.uil-thunderstorm:before {\n  content: \"\\ebc5\";\n} /* '' */\n.uil-ticket:before {\n  content: \"\\ebc6\";\n} /* '' */\n.uil-times-circle:before {\n  content: \"\\ebc7\";\n} /* '' */\n.uil-times-square:before {\n  content: \"\\ebc8\";\n} /* '' */\n.uil-times:before {\n  content: \"\\ebc9\";\n} /* '' */\n.uil-toggle-off:before {\n  content: \"\\ebca\";\n} /* '' */\n.uil-toggle-on:before {\n  content: \"\\ebcb\";\n} /* '' */\n.uil-top-arrow-from-top:before {\n  content: \"\\ebcc\";\n} /* '' */\n.uil-top-arrow-to-top:before {\n  content: \"\\ebcd\";\n} /* '' */\n.uil-tornado:before {\n  content: \"\\ebce\";\n} /* '' */\n.uil-trademark-circle:before {\n  content: \"\\ebcf\";\n} /* '' */\n.uil-trademark:before {\n  content: \"\\ebd0\";\n} /* '' */\n.uil-traffic-barrier:before {\n  content: \"\\ebd1\";\n} /* '' */\n.uil-trash-alt:before {\n  content: \"\\ebd2\";\n} /* '' */\n.uil-trash:before {\n  content: \"\\ebd3\";\n} /* '' */\n.uil-trees:before {\n  content: \"\\ebd4\";\n} /* '' */\n.uil-triangle:before {\n  content: \"\\ebd5\";\n} /* '' */\n.uil-trophy:before {\n  content: \"\\ebd6\";\n} /* '' */\n.uil-trowel:before {\n  content: \"\\ebd7\";\n} /* '' */\n.uil-truck-case:before {\n  content: \"\\ebd8\";\n} /* '' */\n.uil-truck-loading:before {\n  content: \"\\ebd9\";\n} /* '' */\n.uil-truck:before {\n  content: \"\\ebda\";\n} /* '' */\n.uil-tumblr-square:before {\n  content: \"\\ebdb\";\n} /* '' */\n.uil-tumblr:before {\n  content: \"\\ebdc\";\n} /* '' */\n.uil-tv-retro-slash:before {\n  content: \"\\ebdd\";\n} /* '' */\n.uil-tv-retro:before {\n  content: \"\\ebde\";\n} /* '' */\n.uil-twitter:before {\n  content: \"\\ebdf\";\n} /* '' */\n.uil-umbrella:before {\n  content: \"\\ebe0\";\n} /* '' */\n.uil-unamused:before {\n  content: \"\\ebe1\";\n} /* '' */\n.uil-underline:before {\n  content: \"\\ebe2\";\n} /* '' */\n.uil-unlock-alt:before {\n  content: \"\\ebe3\";\n} /* '' */\n.uil-unlock:before {\n  content: \"\\ebe4\";\n} /* '' */\n.uil-upload-alt:before {\n  content: \"\\ebe5\";\n} /* '' */\n.uil-upload:before {\n  content: \"\\ebe6\";\n} /* '' */\n.uil-usd-circle:before {\n  content: \"\\ebe7\";\n} /* '' */\n.uil-usd-square:before {\n  content: \"\\ebe8\";\n} /* '' */\n.uil-user-check:before {\n  content: \"\\ebe9\";\n} /* '' */\n.uil-user-circle:before {\n  content: \"\\ebea\";\n} /* '' */\n.uil-user-exclamation:before {\n  content: \"\\ebeb\";\n} /* '' */\n.uil-user-hard-hat:before {\n  content: \"\\ebec\";\n} /* '' */\n.uil-user-minus:before {\n  content: \"\\ebed\";\n} /* '' */\n.uil-user-plus:before {\n  content: \"\\ebee\";\n} /* '' */\n.uil-user-square:before {\n  content: \"\\ebef\";\n} /* '' */\n.uil-user-times:before {\n  content: \"\\ebf0\";\n} /* '' */\n.uil-user:before {\n  content: \"\\ebf1\";\n} /* '' */\n.uil-users-alt:before {\n  content: \"\\ebf2\";\n} /* '' */\n.uil-utensils-alt:before {\n  content: \"\\ebf3\";\n} /* '' */\n.uil-utensils:before {\n  content: \"\\ebf4\";\n} /* '' */\n.uil-vector-square-alt:before {\n  content: \"\\ebf5\";\n} /* '' */\n.uil-vector-square:before {\n  content: \"\\ebf6\";\n} /* '' */\n.uil-venus:before {\n  content: \"\\ebf7\";\n} /* '' */\n.uil-vertical-align-bottom:before {\n  content: \"\\ebf8\";\n} /* '' */\n.uil-vertical-align-center:before {\n  content: \"\\ebf9\";\n} /* '' */\n.uil-vertical-align-top:before {\n  content: \"\\ebfa\";\n} /* '' */\n.uil-vertical-distribute-bottom:before {\n  content: \"\\ebfb\";\n} /* '' */\n.uil-vertical-distribution-center:before {\n  content: \"\\ebfc\";\n} /* '' */\n.uil-vertical-distribution-top:before {\n  content: \"\\ebfd\";\n} /* '' */\n.uil-video-slash:before {\n  content: \"\\ebfe\";\n} /* '' */\n.uil-video:before {\n  content: \"\\ebff\";\n} /* '' */\n.uil-visual-studio:before {\n  content: \"\\ec00\";\n} /* '' */\n.uil-voicemail-rectangle:before {\n  content: \"\\ec01\";\n} /* '' */\n.uil-voicemail:before {\n  content: \"\\ec02\";\n} /* '' */\n.uil-volleyball:before {\n  content: \"\\ec03\";\n} /* '' */\n.uil-volume-down:before {\n  content: \"\\ec04\";\n} /* '' */\n.uil-volume-mute:before {\n  content: \"\\ec05\";\n} /* '' */\n.uil-volume-off:before {\n  content: \"\\ec06\";\n} /* '' */\n.uil-volume-up:before {\n  content: \"\\ec07\";\n} /* '' */\n.uil-volume:before {\n  content: \"\\ec08\";\n} /* '' */\n.uil-vuejs-alt:before {\n  content: \"\\ec09\";\n} /* '' */\n.uil-vuejs:before {\n  content: \"\\ec0a\";\n} /* '' */\n.uil-wall:before {\n  content: \"\\ec0b\";\n} /* '' */\n.uil-wallet:before {\n  content: \"\\ec0c\";\n} /* '' */\n.uil-watch-alt:before {\n  content: \"\\ec0d\";\n} /* '' */\n.uil-watch:before {\n  content: \"\\ec0e\";\n} /* '' */\n.uil-water-drop-slash:before {\n  content: \"\\ec0f\";\n} /* '' */\n.uil-water-glass:before {\n  content: \"\\ec10\";\n} /* '' */\n.uil-water:before {\n  content: \"\\ec11\";\n} /* '' */\n.uil-web-grid-alt:before {\n  content: \"\\ec12\";\n} /* '' */\n.uil-web-grid:before {\n  content: \"\\ec13\";\n} /* '' */\n.uil-web-section-alt:before {\n  content: \"\\ec14\";\n} /* '' */\n.uil-web-section:before {\n  content: \"\\ec15\";\n} /* '' */\n.uil-webcam:before {\n  content: \"\\ec16\";\n} /* '' */\n.uil-weight:before {\n  content: \"\\ec17\";\n} /* '' */\n.uil-whatsapp:before {\n  content: \"\\ec18\";\n} /* '' */\n.uil-wheel-barrow:before {\n  content: \"\\ec19\";\n} /* '' */\n.uil-wheelchair-alt:before {\n  content: \"\\ec1a\";\n} /* '' */\n.uil-wheelchair:before {\n  content: \"\\ec1b\";\n} /* '' */\n.uil-wifi-router:before {\n  content: \"\\ec1c\";\n} /* '' */\n.uil-wifi-slash:before {\n  content: \"\\ec1d\";\n} /* '' */\n.uil-wifi:before {\n  content: \"\\ec1e\";\n} /* '' */\n.uil-wind:before {\n  content: \"\\ec1f\";\n} /* '' */\n.uil-window-grid:before {\n  content: \"\\ec20\";\n} /* '' */\n.uil-window-maximize:before {\n  content: \"\\ec21\";\n} /* '' */\n.uil-window-restore:before {\n  content: \"\\ec22\";\n} /* '' */\n.uil-window-section:before {\n  content: \"\\ec23\";\n} /* '' */\n.uil-window:before {\n  content: \"\\ec24\";\n} /* '' */\n.uil-windsock:before {\n  content: \"\\ec25\";\n} /* '' */\n.uil-wrap-text:before {\n  content: \"\\ec26\";\n} /* '' */\n.uil-wrench:before {\n  content: \"\\ec27\";\n} /* '' */\n.uil-yellow:before {\n  content: \"\\ec28\";\n} /* '' */\n.uil-yen-circle:before {\n  content: \"\\ec29\";\n} /* '' */\n.uil-yen:before {\n  content: \"\\ec2a\";\n} /* '' */\n.uil-youtube-alt:before {\n  content: \"\\ec2b\";\n} /* '' */\n.uil-youtube:before {\n  content: \"\\ec2c\";\n} /* '' */\n@font-face {\n  font-family: \"dripicons-v2\";\n  src: url(\"../../../../fonts/dripicons-v2.eot\");\n  src: url(\"../../../../fonts/dripicons-v2.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../../fonts/dripicons-v2.woff\") format(\"woff\"), url(\"../../../../fonts/dripicons-v2.ttf\") format(\"truetype\"), url(\"../../../../fonts/dripicons-v2.svg#dripicons-v2\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n[data-icon]:before {\n  font-family: \"dripicons-v2\" !important;\n  content: attr(data-icon);\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n[class^=dripicons-]:before,\n[class*=\" dripicons-\"]:before {\n  font-family: \"dripicons-v2\" !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  vertical-align: middle;\n  display: inline-block;\n}\n\n.dripicons-alarm:before {\n  content: \"a\";\n}\n\n.dripicons-align-center:before {\n  content: \"b\";\n}\n\n.dripicons-align-justify:before {\n  content: \"c\";\n}\n\n.dripicons-align-left:before {\n  content: \"d\";\n}\n\n.dripicons-align-right:before {\n  content: \"e\";\n}\n\n.dripicons-anchor:before {\n  content: \"f\";\n}\n\n.dripicons-archive:before {\n  content: \"g\";\n}\n\n.dripicons-arrow-down:before {\n  content: \"h\";\n}\n\n.dripicons-arrow-left:before {\n  content: \"i\";\n}\n\n.dripicons-arrow-right:before {\n  content: \"j\";\n}\n\n.dripicons-arrow-thin-down:before {\n  content: \"k\";\n}\n\n.dripicons-arrow-thin-left:before {\n  content: \"l\";\n}\n\n.dripicons-arrow-thin-right:before {\n  content: \"m\";\n}\n\n.dripicons-arrow-thin-up:before {\n  content: \"n\";\n}\n\n.dripicons-arrow-up:before {\n  content: \"o\";\n}\n\n.dripicons-article:before {\n  content: \"p\";\n}\n\n.dripicons-backspace:before {\n  content: \"q\";\n}\n\n.dripicons-basket:before {\n  content: \"r\";\n}\n\n.dripicons-basketball:before {\n  content: \"s\";\n}\n\n.dripicons-battery-empty:before {\n  content: \"t\";\n}\n\n.dripicons-battery-full:before {\n  content: \"u\";\n}\n\n.dripicons-battery-low:before {\n  content: \"v\";\n}\n\n.dripicons-battery-medium:before {\n  content: \"w\";\n}\n\n.dripicons-bell:before {\n  content: \"x\";\n}\n\n.dripicons-blog:before {\n  content: \"y\";\n}\n\n.dripicons-bluetooth:before {\n  content: \"z\";\n}\n\n.dripicons-bold:before {\n  content: \"A\";\n}\n\n.dripicons-bookmark:before {\n  content: \"B\";\n}\n\n.dripicons-bookmarks:before {\n  content: \"C\";\n}\n\n.dripicons-box:before {\n  content: \"D\";\n}\n\n.dripicons-briefcase:before {\n  content: \"E\";\n}\n\n.dripicons-brightness-low:before {\n  content: \"F\";\n}\n\n.dripicons-brightness-max:before {\n  content: \"G\";\n}\n\n.dripicons-brightness-medium:before {\n  content: \"H\";\n}\n\n.dripicons-broadcast:before {\n  content: \"I\";\n}\n\n.dripicons-browser:before {\n  content: \"J\";\n}\n\n.dripicons-browser-upload:before {\n  content: \"K\";\n}\n\n.dripicons-brush:before {\n  content: \"L\";\n}\n\n.dripicons-calendar:before {\n  content: \"M\";\n}\n\n.dripicons-camcorder:before {\n  content: \"N\";\n}\n\n.dripicons-camera:before {\n  content: \"O\";\n}\n\n.dripicons-card:before {\n  content: \"P\";\n}\n\n.dripicons-cart:before {\n  content: \"Q\";\n}\n\n.dripicons-checklist:before {\n  content: \"R\";\n}\n\n.dripicons-checkmark:before {\n  content: \"S\";\n}\n\n.dripicons-chevron-down:before {\n  content: \"T\";\n}\n\n.dripicons-chevron-left:before {\n  content: \"U\";\n}\n\n.dripicons-chevron-right:before {\n  content: \"V\";\n}\n\n.dripicons-chevron-up:before {\n  content: \"W\";\n}\n\n.dripicons-clipboard:before {\n  content: \"X\";\n}\n\n.dripicons-clock:before {\n  content: \"Y\";\n}\n\n.dripicons-clockwise:before {\n  content: \"Z\";\n}\n\n.dripicons-cloud:before {\n  content: \"0\";\n}\n\n.dripicons-cloud-download:before {\n  content: \"1\";\n}\n\n.dripicons-cloud-upload:before {\n  content: \"2\";\n}\n\n.dripicons-code:before {\n  content: \"3\";\n}\n\n.dripicons-contract:before {\n  content: \"4\";\n}\n\n.dripicons-contract-2:before {\n  content: \"5\";\n}\n\n.dripicons-conversation:before {\n  content: \"6\";\n}\n\n.dripicons-copy:before {\n  content: \"7\";\n}\n\n.dripicons-crop:before {\n  content: \"8\";\n}\n\n.dripicons-cross:before {\n  content: \"9\";\n}\n\n.dripicons-crosshair:before {\n  content: \"!\";\n}\n\n.dripicons-cutlery:before {\n  content: '\"';\n}\n\n.dripicons-device-desktop:before {\n  content: \"#\";\n}\n\n.dripicons-device-mobile:before {\n  content: \"$\";\n}\n\n.dripicons-device-tablet:before {\n  content: \"%\";\n}\n\n.dripicons-direction:before {\n  content: \"&\";\n}\n\n.dripicons-disc:before {\n  content: \"'\";\n}\n\n.dripicons-document:before {\n  content: \"(\";\n}\n\n.dripicons-document-delete:before {\n  content: \")\";\n}\n\n.dripicons-document-edit:before {\n  content: \"*\";\n}\n\n.dripicons-document-new:before {\n  content: \"+\";\n}\n\n.dripicons-document-remove:before {\n  content: \",\";\n}\n\n.dripicons-dot:before {\n  content: \"-\";\n}\n\n.dripicons-dots-2:before {\n  content: \".\";\n}\n\n.dripicons-dots-3:before {\n  content: \"/\";\n}\n\n.dripicons-download:before {\n  content: \":\";\n}\n\n.dripicons-duplicate:before {\n  content: \";\";\n}\n\n.dripicons-enter:before {\n  content: \"<\";\n}\n\n.dripicons-exit:before {\n  content: \"=\";\n}\n\n.dripicons-expand:before {\n  content: \">\";\n}\n\n.dripicons-expand-2:before {\n  content: \"?\";\n}\n\n.dripicons-experiment:before {\n  content: \"@\";\n}\n\n.dripicons-export:before {\n  content: \"[\";\n}\n\n.dripicons-feed:before {\n  content: \"]\";\n}\n\n.dripicons-flag:before {\n  content: \"^\";\n}\n\n.dripicons-flashlight:before {\n  content: \"_\";\n}\n\n.dripicons-folder:before {\n  content: \"`\";\n}\n\n.dripicons-folder-open:before {\n  content: \"{\";\n}\n\n.dripicons-forward:before {\n  content: \"|\";\n}\n\n.dripicons-gaming:before {\n  content: \"}\";\n}\n\n.dripicons-gear:before {\n  content: \"~\";\n}\n\n.dripicons-graduation:before {\n  content: \"\\\\\";\n}\n\n.dripicons-graph-bar:before {\n  content: \"\\e000\";\n}\n\n.dripicons-graph-line:before {\n  content: \"\\e001\";\n}\n\n.dripicons-graph-pie:before {\n  content: \"\\e002\";\n}\n\n.dripicons-headset:before {\n  content: \"\\e003\";\n}\n\n.dripicons-heart:before {\n  content: \"\\e004\";\n}\n\n.dripicons-help:before {\n  content: \"\\e005\";\n}\n\n.dripicons-home:before {\n  content: \"\\e006\";\n}\n\n.dripicons-hourglass:before {\n  content: \"\\e007\";\n}\n\n.dripicons-inbox:before {\n  content: \"\\e008\";\n}\n\n.dripicons-information:before {\n  content: \"\\e009\";\n}\n\n.dripicons-italic:before {\n  content: \"\\e00a\";\n}\n\n.dripicons-jewel:before {\n  content: \"\\e00b\";\n}\n\n.dripicons-lifting:before {\n  content: \"\\e00c\";\n}\n\n.dripicons-lightbulb:before {\n  content: \"\\e00d\";\n}\n\n.dripicons-link:before {\n  content: \"\\e00e\";\n}\n\n.dripicons-link-broken:before {\n  content: \"\\e00f\";\n}\n\n.dripicons-list:before {\n  content: \"\\e010\";\n}\n\n.dripicons-loading:before {\n  content: \"\\e011\";\n}\n\n.dripicons-location:before {\n  content: \"\\e012\";\n}\n\n.dripicons-lock:before {\n  content: \"\\e013\";\n}\n\n.dripicons-lock-open:before {\n  content: \"\\e014\";\n}\n\n.dripicons-mail:before {\n  content: \"\\e015\";\n}\n\n.dripicons-map:before {\n  content: \"\\e016\";\n}\n\n.dripicons-media-loop:before {\n  content: \"\\e017\";\n}\n\n.dripicons-media-next:before {\n  content: \"\\e018\";\n}\n\n.dripicons-media-pause:before {\n  content: \"\\e019\";\n}\n\n.dripicons-media-play:before {\n  content: \"\\e01a\";\n}\n\n.dripicons-media-previous:before {\n  content: \"\\e01b\";\n}\n\n.dripicons-media-record:before {\n  content: \"\\e01c\";\n}\n\n.dripicons-media-shuffle:before {\n  content: \"\\e01d\";\n}\n\n.dripicons-media-stop:before {\n  content: \"\\e01e\";\n}\n\n.dripicons-medical:before {\n  content: \"\\e01f\";\n}\n\n.dripicons-menu:before {\n  content: \"\\e020\";\n}\n\n.dripicons-message:before {\n  content: \"\\e021\";\n}\n\n.dripicons-meter:before {\n  content: \"\\e022\";\n}\n\n.dripicons-microphone:before {\n  content: \"\\e023\";\n}\n\n.dripicons-minus:before {\n  content: \"\\e024\";\n}\n\n.dripicons-monitor:before {\n  content: \"\\e025\";\n}\n\n.dripicons-move:before {\n  content: \"\\e026\";\n}\n\n.dripicons-music:before {\n  content: \"\\e027\";\n}\n\n.dripicons-network-1:before {\n  content: \"\\e028\";\n}\n\n.dripicons-network-2:before {\n  content: \"\\e029\";\n}\n\n.dripicons-network-3:before {\n  content: \"\\e02a\";\n}\n\n.dripicons-network-4:before {\n  content: \"\\e02b\";\n}\n\n.dripicons-network-5:before {\n  content: \"\\e02c\";\n}\n\n.dripicons-pamphlet:before {\n  content: \"\\e02d\";\n}\n\n.dripicons-paperclip:before {\n  content: \"\\e02e\";\n}\n\n.dripicons-pencil:before {\n  content: \"\\e02f\";\n}\n\n.dripicons-phone:before {\n  content: \"\\e030\";\n}\n\n.dripicons-photo:before {\n  content: \"\\e031\";\n}\n\n.dripicons-photo-group:before {\n  content: \"\\e032\";\n}\n\n.dripicons-pill:before {\n  content: \"\\e033\";\n}\n\n.dripicons-pin:before {\n  content: \"\\e034\";\n}\n\n.dripicons-plus:before {\n  content: \"\\e035\";\n}\n\n.dripicons-power:before {\n  content: \"\\e036\";\n}\n\n.dripicons-preview:before {\n  content: \"\\e037\";\n}\n\n.dripicons-print:before {\n  content: \"\\e038\";\n}\n\n.dripicons-pulse:before {\n  content: \"\\e039\";\n}\n\n.dripicons-question:before {\n  content: \"\\e03a\";\n}\n\n.dripicons-reply:before {\n  content: \"\\e03b\";\n}\n\n.dripicons-reply-all:before {\n  content: \"\\e03c\";\n}\n\n.dripicons-return:before {\n  content: \"\\e03d\";\n}\n\n.dripicons-retweet:before {\n  content: \"\\e03e\";\n}\n\n.dripicons-rocket:before {\n  content: \"\\e03f\";\n}\n\n.dripicons-scale:before {\n  content: \"\\e040\";\n}\n\n.dripicons-search:before {\n  content: \"\\e041\";\n}\n\n.dripicons-shopping-bag:before {\n  content: \"\\e042\";\n}\n\n.dripicons-skip:before {\n  content: \"\\e043\";\n}\n\n.dripicons-stack:before {\n  content: \"\\e044\";\n}\n\n.dripicons-star:before {\n  content: \"\\e045\";\n}\n\n.dripicons-stopwatch:before {\n  content: \"\\e046\";\n}\n\n.dripicons-store:before {\n  content: \"\\e047\";\n}\n\n.dripicons-suitcase:before {\n  content: \"\\e048\";\n}\n\n.dripicons-swap:before {\n  content: \"\\e049\";\n}\n\n.dripicons-tag:before {\n  content: \"\\e04a\";\n}\n\n.dripicons-tag-delete:before {\n  content: \"\\e04b\";\n}\n\n.dripicons-tags:before {\n  content: \"\\e04c\";\n}\n\n.dripicons-thumbs-down:before {\n  content: \"\\e04d\";\n}\n\n.dripicons-thumbs-up:before {\n  content: \"\\e04e\";\n}\n\n.dripicons-ticket:before {\n  content: \"\\e04f\";\n}\n\n.dripicons-time-reverse:before {\n  content: \"\\e050\";\n}\n\n.dripicons-to-do:before {\n  content: \"\\e051\";\n}\n\n.dripicons-toggles:before {\n  content: \"\\e052\";\n}\n\n.dripicons-trash:before {\n  content: \"\\e053\";\n}\n\n.dripicons-trophy:before {\n  content: \"\\e054\";\n}\n\n.dripicons-upload:before {\n  content: \"\\e055\";\n}\n\n.dripicons-user:before {\n  content: \"\\e056\";\n}\n\n.dripicons-user-group:before {\n  content: \"\\e057\";\n}\n\n.dripicons-user-id:before {\n  content: \"\\e058\";\n}\n\n.dripicons-vibrate:before {\n  content: \"\\e059\";\n}\n\n.dripicons-view-apps:before {\n  content: \"\\e05a\";\n}\n\n.dripicons-view-list:before {\n  content: \"\\e05b\";\n}\n\n.dripicons-view-list-large:before {\n  content: \"\\e05c\";\n}\n\n.dripicons-view-thumb:before {\n  content: \"\\e05d\";\n}\n\n.dripicons-volume-full:before {\n  content: \"\\e05e\";\n}\n\n.dripicons-volume-low:before {\n  content: \"\\e05f\";\n}\n\n.dripicons-volume-medium:before {\n  content: \"\\e060\";\n}\n\n.dripicons-volume-off:before {\n  content: \"\\e061\";\n}\n\n.dripicons-wallet:before {\n  content: \"\\e062\";\n}\n\n.dripicons-warning:before {\n  content: \"\\e063\";\n}\n\n.dripicons-web:before {\n  content: \"\\e064\";\n}\n\n.dripicons-weight:before {\n  content: \"\\e065\";\n}\n\n.dripicons-wifi:before {\n  content: \"\\e066\";\n}\n\n.dripicons-wrong:before {\n  content: \"\\e067\";\n}\n\n.dripicons-zoom-in:before {\n  content: \"\\e068\";\n}\n\n.dripicons-zoom-out:before {\n  content: \"\\e069\";\n}\n\n/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?v=6.5.95\");\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?#iefix&v=6.5.95\") format(\"embedded-opentype\"), url(\"../../../../fonts/materialdesignicons-webfont.woff2?v=6.5.95\") format(\"woff2\"), url(\"../../../../fonts/materialdesignicons-webfont.woff?v=6.5.95\") format(\"woff\"), url(\"../../../../fonts/materialdesignicons-webfont.ttf?v=6.5.95\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.mdi-ab-testing::before {\n  content: \"\\f01c9\";\n}\n\n.mdi-abacus::before {\n  content: \"\\f16e0\";\n}\n\n.mdi-abjad-arabic::before {\n  content: \"\\f1328\";\n}\n\n.mdi-abjad-hebrew::before {\n  content: \"\\f1329\";\n}\n\n.mdi-abugida-devanagari::before {\n  content: \"\\f132a\";\n}\n\n.mdi-abugida-thai::before {\n  content: \"\\f132b\";\n}\n\n.mdi-access-point::before {\n  content: \"\\f0003\";\n}\n\n.mdi-access-point-check::before {\n  content: \"\\f1538\";\n}\n\n.mdi-access-point-minus::before {\n  content: \"\\f1539\";\n}\n\n.mdi-access-point-network::before {\n  content: \"\\f0002\";\n}\n\n.mdi-access-point-network-off::before {\n  content: \"\\f0be1\";\n}\n\n.mdi-access-point-off::before {\n  content: \"\\f1511\";\n}\n\n.mdi-access-point-plus::before {\n  content: \"\\f153a\";\n}\n\n.mdi-access-point-remove::before {\n  content: \"\\f153b\";\n}\n\n.mdi-account::before {\n  content: \"\\f0004\";\n}\n\n.mdi-account-alert::before {\n  content: \"\\f0005\";\n}\n\n.mdi-account-alert-outline::before {\n  content: \"\\f0b50\";\n}\n\n.mdi-account-arrow-down::before {\n  content: \"\\f1868\";\n}\n\n.mdi-account-arrow-down-outline::before {\n  content: \"\\f1869\";\n}\n\n.mdi-account-arrow-left::before {\n  content: \"\\f0b51\";\n}\n\n.mdi-account-arrow-left-outline::before {\n  content: \"\\f0b52\";\n}\n\n.mdi-account-arrow-right::before {\n  content: \"\\f0b53\";\n}\n\n.mdi-account-arrow-right-outline::before {\n  content: \"\\f0b54\";\n}\n\n.mdi-account-arrow-up::before {\n  content: \"\\f1867\";\n}\n\n.mdi-account-arrow-up-outline::before {\n  content: \"\\f186a\";\n}\n\n.mdi-account-box::before {\n  content: \"\\f0006\";\n}\n\n.mdi-account-box-multiple::before {\n  content: \"\\f0934\";\n}\n\n.mdi-account-box-multiple-outline::before {\n  content: \"\\f100a\";\n}\n\n.mdi-account-box-outline::before {\n  content: \"\\f0007\";\n}\n\n.mdi-account-cancel::before {\n  content: \"\\f12df\";\n}\n\n.mdi-account-cancel-outline::before {\n  content: \"\\f12e0\";\n}\n\n.mdi-account-cash::before {\n  content: \"\\f1097\";\n}\n\n.mdi-account-cash-outline::before {\n  content: \"\\f1098\";\n}\n\n.mdi-account-check::before {\n  content: \"\\f0008\";\n}\n\n.mdi-account-check-outline::before {\n  content: \"\\f0be2\";\n}\n\n.mdi-account-child::before {\n  content: \"\\f0a89\";\n}\n\n.mdi-account-child-circle::before {\n  content: \"\\f0a8a\";\n}\n\n.mdi-account-child-outline::before {\n  content: \"\\f10c8\";\n}\n\n.mdi-account-circle::before {\n  content: \"\\f0009\";\n}\n\n.mdi-account-circle-outline::before {\n  content: \"\\f0b55\";\n}\n\n.mdi-account-clock::before {\n  content: \"\\f0b56\";\n}\n\n.mdi-account-clock-outline::before {\n  content: \"\\f0b57\";\n}\n\n.mdi-account-cog::before {\n  content: \"\\f1370\";\n}\n\n.mdi-account-cog-outline::before {\n  content: \"\\f1371\";\n}\n\n.mdi-account-convert::before {\n  content: \"\\f000a\";\n}\n\n.mdi-account-convert-outline::before {\n  content: \"\\f1301\";\n}\n\n.mdi-account-cowboy-hat::before {\n  content: \"\\f0e9b\";\n}\n\n.mdi-account-cowboy-hat-outline::before {\n  content: \"\\f17f3\";\n}\n\n.mdi-account-details::before {\n  content: \"\\f0631\";\n}\n\n.mdi-account-details-outline::before {\n  content: \"\\f1372\";\n}\n\n.mdi-account-edit::before {\n  content: \"\\f06bc\";\n}\n\n.mdi-account-edit-outline::before {\n  content: \"\\f0ffb\";\n}\n\n.mdi-account-eye::before {\n  content: \"\\f0420\";\n}\n\n.mdi-account-eye-outline::before {\n  content: \"\\f127b\";\n}\n\n.mdi-account-filter::before {\n  content: \"\\f0936\";\n}\n\n.mdi-account-filter-outline::before {\n  content: \"\\f0f9d\";\n}\n\n.mdi-account-group::before {\n  content: \"\\f0849\";\n}\n\n.mdi-account-group-outline::before {\n  content: \"\\f0b58\";\n}\n\n.mdi-account-hard-hat::before {\n  content: \"\\f05b5\";\n}\n\n.mdi-account-heart::before {\n  content: \"\\f0899\";\n}\n\n.mdi-account-heart-outline::before {\n  content: \"\\f0be3\";\n}\n\n.mdi-account-injury::before {\n  content: \"\\f1815\";\n}\n\n.mdi-account-injury-outline::before {\n  content: \"\\f1816\";\n}\n\n.mdi-account-key::before {\n  content: \"\\f000b\";\n}\n\n.mdi-account-key-outline::before {\n  content: \"\\f0be4\";\n}\n\n.mdi-account-lock::before {\n  content: \"\\f115e\";\n}\n\n.mdi-account-lock-open::before {\n  content: \"\\f1960\";\n}\n\n.mdi-account-lock-open-outline::before {\n  content: \"\\f1961\";\n}\n\n.mdi-account-lock-outline::before {\n  content: \"\\f115f\";\n}\n\n.mdi-account-minus::before {\n  content: \"\\f000d\";\n}\n\n.mdi-account-minus-outline::before {\n  content: \"\\f0aec\";\n}\n\n.mdi-account-multiple::before {\n  content: \"\\f000e\";\n}\n\n.mdi-account-multiple-check::before {\n  content: \"\\f08c5\";\n}\n\n.mdi-account-multiple-check-outline::before {\n  content: \"\\f11fe\";\n}\n\n.mdi-account-multiple-minus::before {\n  content: \"\\f05d3\";\n}\n\n.mdi-account-multiple-minus-outline::before {\n  content: \"\\f0be5\";\n}\n\n.mdi-account-multiple-outline::before {\n  content: \"\\f000f\";\n}\n\n.mdi-account-multiple-plus::before {\n  content: \"\\f0010\";\n}\n\n.mdi-account-multiple-plus-outline::before {\n  content: \"\\f0800\";\n}\n\n.mdi-account-multiple-remove::before {\n  content: \"\\f120a\";\n}\n\n.mdi-account-multiple-remove-outline::before {\n  content: \"\\f120b\";\n}\n\n.mdi-account-music::before {\n  content: \"\\f0803\";\n}\n\n.mdi-account-music-outline::before {\n  content: \"\\f0ce9\";\n}\n\n.mdi-account-network::before {\n  content: \"\\f0011\";\n}\n\n.mdi-account-network-outline::before {\n  content: \"\\f0be6\";\n}\n\n.mdi-account-off::before {\n  content: \"\\f0012\";\n}\n\n.mdi-account-off-outline::before {\n  content: \"\\f0be7\";\n}\n\n.mdi-account-outline::before {\n  content: \"\\f0013\";\n}\n\n.mdi-account-plus::before {\n  content: \"\\f0014\";\n}\n\n.mdi-account-plus-outline::before {\n  content: \"\\f0801\";\n}\n\n.mdi-account-question::before {\n  content: \"\\f0b59\";\n}\n\n.mdi-account-question-outline::before {\n  content: \"\\f0b5a\";\n}\n\n.mdi-account-reactivate::before {\n  content: \"\\f152b\";\n}\n\n.mdi-account-reactivate-outline::before {\n  content: \"\\f152c\";\n}\n\n.mdi-account-remove::before {\n  content: \"\\f0015\";\n}\n\n.mdi-account-remove-outline::before {\n  content: \"\\f0aed\";\n}\n\n.mdi-account-search::before {\n  content: \"\\f0016\";\n}\n\n.mdi-account-search-outline::before {\n  content: \"\\f0935\";\n}\n\n.mdi-account-settings::before {\n  content: \"\\f0630\";\n}\n\n.mdi-account-settings-outline::before {\n  content: \"\\f10c9\";\n}\n\n.mdi-account-star::before {\n  content: \"\\f0017\";\n}\n\n.mdi-account-star-outline::before {\n  content: \"\\f0be8\";\n}\n\n.mdi-account-supervisor::before {\n  content: \"\\f0a8b\";\n}\n\n.mdi-account-supervisor-circle::before {\n  content: \"\\f0a8c\";\n}\n\n.mdi-account-supervisor-circle-outline::before {\n  content: \"\\f14ec\";\n}\n\n.mdi-account-supervisor-outline::before {\n  content: \"\\f112d\";\n}\n\n.mdi-account-switch::before {\n  content: \"\\f0019\";\n}\n\n.mdi-account-switch-outline::before {\n  content: \"\\f04cb\";\n}\n\n.mdi-account-sync::before {\n  content: \"\\f191b\";\n}\n\n.mdi-account-sync-outline::before {\n  content: \"\\f191c\";\n}\n\n.mdi-account-tie::before {\n  content: \"\\f0ce3\";\n}\n\n.mdi-account-tie-hat::before {\n  content: \"\\f1898\";\n}\n\n.mdi-account-tie-hat-outline::before {\n  content: \"\\f1899\";\n}\n\n.mdi-account-tie-outline::before {\n  content: \"\\f10ca\";\n}\n\n.mdi-account-tie-voice::before {\n  content: \"\\f1308\";\n}\n\n.mdi-account-tie-voice-off::before {\n  content: \"\\f130a\";\n}\n\n.mdi-account-tie-voice-off-outline::before {\n  content: \"\\f130b\";\n}\n\n.mdi-account-tie-voice-outline::before {\n  content: \"\\f1309\";\n}\n\n.mdi-account-voice::before {\n  content: \"\\f05cb\";\n}\n\n.mdi-account-voice-off::before {\n  content: \"\\f0ed4\";\n}\n\n.mdi-account-wrench::before {\n  content: \"\\f189a\";\n}\n\n.mdi-account-wrench-outline::before {\n  content: \"\\f189b\";\n}\n\n.mdi-adjust::before {\n  content: \"\\f001a\";\n}\n\n.mdi-advertisements::before {\n  content: \"\\f192a\";\n}\n\n.mdi-advertisements-off::before {\n  content: \"\\f192b\";\n}\n\n.mdi-air-conditioner::before {\n  content: \"\\f001b\";\n}\n\n.mdi-air-filter::before {\n  content: \"\\f0d43\";\n}\n\n.mdi-air-horn::before {\n  content: \"\\f0dac\";\n}\n\n.mdi-air-humidifier::before {\n  content: \"\\f1099\";\n}\n\n.mdi-air-humidifier-off::before {\n  content: \"\\f1466\";\n}\n\n.mdi-air-purifier::before {\n  content: \"\\f0d44\";\n}\n\n.mdi-airbag::before {\n  content: \"\\f0be9\";\n}\n\n.mdi-airballoon::before {\n  content: \"\\f001c\";\n}\n\n.mdi-airballoon-outline::before {\n  content: \"\\f100b\";\n}\n\n.mdi-airplane::before {\n  content: \"\\f001d\";\n}\n\n.mdi-airplane-alert::before {\n  content: \"\\f187a\";\n}\n\n.mdi-airplane-check::before {\n  content: \"\\f187b\";\n}\n\n.mdi-airplane-clock::before {\n  content: \"\\f187c\";\n}\n\n.mdi-airplane-cog::before {\n  content: \"\\f187d\";\n}\n\n.mdi-airplane-edit::before {\n  content: \"\\f187e\";\n}\n\n.mdi-airplane-landing::before {\n  content: \"\\f05d4\";\n}\n\n.mdi-airplane-marker::before {\n  content: \"\\f187f\";\n}\n\n.mdi-airplane-minus::before {\n  content: \"\\f1880\";\n}\n\n.mdi-airplane-off::before {\n  content: \"\\f001e\";\n}\n\n.mdi-airplane-plus::before {\n  content: \"\\f1881\";\n}\n\n.mdi-airplane-remove::before {\n  content: \"\\f1882\";\n}\n\n.mdi-airplane-search::before {\n  content: \"\\f1883\";\n}\n\n.mdi-airplane-settings::before {\n  content: \"\\f1884\";\n}\n\n.mdi-airplane-takeoff::before {\n  content: \"\\f05d5\";\n}\n\n.mdi-airport::before {\n  content: \"\\f084b\";\n}\n\n.mdi-alarm::before {\n  content: \"\\f0020\";\n}\n\n.mdi-alarm-bell::before {\n  content: \"\\f078e\";\n}\n\n.mdi-alarm-check::before {\n  content: \"\\f0021\";\n}\n\n.mdi-alarm-light::before {\n  content: \"\\f078f\";\n}\n\n.mdi-alarm-light-off::before {\n  content: \"\\f171e\";\n}\n\n.mdi-alarm-light-off-outline::before {\n  content: \"\\f171f\";\n}\n\n.mdi-alarm-light-outline::before {\n  content: \"\\f0bea\";\n}\n\n.mdi-alarm-multiple::before {\n  content: \"\\f0022\";\n}\n\n.mdi-alarm-note::before {\n  content: \"\\f0e71\";\n}\n\n.mdi-alarm-note-off::before {\n  content: \"\\f0e72\";\n}\n\n.mdi-alarm-off::before {\n  content: \"\\f0023\";\n}\n\n.mdi-alarm-panel::before {\n  content: \"\\f15c4\";\n}\n\n.mdi-alarm-panel-outline::before {\n  content: \"\\f15c5\";\n}\n\n.mdi-alarm-plus::before {\n  content: \"\\f0024\";\n}\n\n.mdi-alarm-snooze::before {\n  content: \"\\f068e\";\n}\n\n.mdi-album::before {\n  content: \"\\f0025\";\n}\n\n.mdi-alert::before {\n  content: \"\\f0026\";\n}\n\n.mdi-alert-box::before {\n  content: \"\\f0027\";\n}\n\n.mdi-alert-box-outline::before {\n  content: \"\\f0ce4\";\n}\n\n.mdi-alert-circle::before {\n  content: \"\\f0028\";\n}\n\n.mdi-alert-circle-check::before {\n  content: \"\\f11ed\";\n}\n\n.mdi-alert-circle-check-outline::before {\n  content: \"\\f11ee\";\n}\n\n.mdi-alert-circle-outline::before {\n  content: \"\\f05d6\";\n}\n\n.mdi-alert-decagram::before {\n  content: \"\\f06bd\";\n}\n\n.mdi-alert-decagram-outline::before {\n  content: \"\\f0ce5\";\n}\n\n.mdi-alert-minus::before {\n  content: \"\\f14bb\";\n}\n\n.mdi-alert-minus-outline::before {\n  content: \"\\f14be\";\n}\n\n.mdi-alert-octagon::before {\n  content: \"\\f0029\";\n}\n\n.mdi-alert-octagon-outline::before {\n  content: \"\\f0ce6\";\n}\n\n.mdi-alert-octagram::before {\n  content: \"\\f0767\";\n}\n\n.mdi-alert-octagram-outline::before {\n  content: \"\\f0ce7\";\n}\n\n.mdi-alert-outline::before {\n  content: \"\\f002a\";\n}\n\n.mdi-alert-plus::before {\n  content: \"\\f14ba\";\n}\n\n.mdi-alert-plus-outline::before {\n  content: \"\\f14bd\";\n}\n\n.mdi-alert-remove::before {\n  content: \"\\f14bc\";\n}\n\n.mdi-alert-remove-outline::before {\n  content: \"\\f14bf\";\n}\n\n.mdi-alert-rhombus::before {\n  content: \"\\f11ce\";\n}\n\n.mdi-alert-rhombus-outline::before {\n  content: \"\\f11cf\";\n}\n\n.mdi-alien::before {\n  content: \"\\f089a\";\n}\n\n.mdi-alien-outline::before {\n  content: \"\\f10cb\";\n}\n\n.mdi-align-horizontal-center::before {\n  content: \"\\f11c3\";\n}\n\n.mdi-align-horizontal-distribute::before {\n  content: \"\\f1962\";\n}\n\n.mdi-align-horizontal-left::before {\n  content: \"\\f11c2\";\n}\n\n.mdi-align-horizontal-right::before {\n  content: \"\\f11c4\";\n}\n\n.mdi-align-vertical-bottom::before {\n  content: \"\\f11c5\";\n}\n\n.mdi-align-vertical-center::before {\n  content: \"\\f11c6\";\n}\n\n.mdi-align-vertical-distribute::before {\n  content: \"\\f1963\";\n}\n\n.mdi-align-vertical-top::before {\n  content: \"\\f11c7\";\n}\n\n.mdi-all-inclusive::before {\n  content: \"\\f06be\";\n}\n\n.mdi-all-inclusive-box::before {\n  content: \"\\f188d\";\n}\n\n.mdi-all-inclusive-box-outline::before {\n  content: \"\\f188e\";\n}\n\n.mdi-allergy::before {\n  content: \"\\f1258\";\n}\n\n.mdi-alpha::before {\n  content: \"\\f002b\";\n}\n\n.mdi-alpha-a::before {\n  content: \"\\f0aee\";\n}\n\n.mdi-alpha-a-box::before {\n  content: \"\\f0b08\";\n}\n\n.mdi-alpha-a-box-outline::before {\n  content: \"\\f0beb\";\n}\n\n.mdi-alpha-a-circle::before {\n  content: \"\\f0bec\";\n}\n\n.mdi-alpha-a-circle-outline::before {\n  content: \"\\f0bed\";\n}\n\n.mdi-alpha-b::before {\n  content: \"\\f0aef\";\n}\n\n.mdi-alpha-b-box::before {\n  content: \"\\f0b09\";\n}\n\n.mdi-alpha-b-box-outline::before {\n  content: \"\\f0bee\";\n}\n\n.mdi-alpha-b-circle::before {\n  content: \"\\f0bef\";\n}\n\n.mdi-alpha-b-circle-outline::before {\n  content: \"\\f0bf0\";\n}\n\n.mdi-alpha-c::before {\n  content: \"\\f0af0\";\n}\n\n.mdi-alpha-c-box::before {\n  content: \"\\f0b0a\";\n}\n\n.mdi-alpha-c-box-outline::before {\n  content: \"\\f0bf1\";\n}\n\n.mdi-alpha-c-circle::before {\n  content: \"\\f0bf2\";\n}\n\n.mdi-alpha-c-circle-outline::before {\n  content: \"\\f0bf3\";\n}\n\n.mdi-alpha-d::before {\n  content: \"\\f0af1\";\n}\n\n.mdi-alpha-d-box::before {\n  content: \"\\f0b0b\";\n}\n\n.mdi-alpha-d-box-outline::before {\n  content: \"\\f0bf4\";\n}\n\n.mdi-alpha-d-circle::before {\n  content: \"\\f0bf5\";\n}\n\n.mdi-alpha-d-circle-outline::before {\n  content: \"\\f0bf6\";\n}\n\n.mdi-alpha-e::before {\n  content: \"\\f0af2\";\n}\n\n.mdi-alpha-e-box::before {\n  content: \"\\f0b0c\";\n}\n\n.mdi-alpha-e-box-outline::before {\n  content: \"\\f0bf7\";\n}\n\n.mdi-alpha-e-circle::before {\n  content: \"\\f0bf8\";\n}\n\n.mdi-alpha-e-circle-outline::before {\n  content: \"\\f0bf9\";\n}\n\n.mdi-alpha-f::before {\n  content: \"\\f0af3\";\n}\n\n.mdi-alpha-f-box::before {\n  content: \"\\f0b0d\";\n}\n\n.mdi-alpha-f-box-outline::before {\n  content: \"\\f0bfa\";\n}\n\n.mdi-alpha-f-circle::before {\n  content: \"\\f0bfb\";\n}\n\n.mdi-alpha-f-circle-outline::before {\n  content: \"\\f0bfc\";\n}\n\n.mdi-alpha-g::before {\n  content: \"\\f0af4\";\n}\n\n.mdi-alpha-g-box::before {\n  content: \"\\f0b0e\";\n}\n\n.mdi-alpha-g-box-outline::before {\n  content: \"\\f0bfd\";\n}\n\n.mdi-alpha-g-circle::before {\n  content: \"\\f0bfe\";\n}\n\n.mdi-alpha-g-circle-outline::before {\n  content: \"\\f0bff\";\n}\n\n.mdi-alpha-h::before {\n  content: \"\\f0af5\";\n}\n\n.mdi-alpha-h-box::before {\n  content: \"\\f0b0f\";\n}\n\n.mdi-alpha-h-box-outline::before {\n  content: \"\\f0c00\";\n}\n\n.mdi-alpha-h-circle::before {\n  content: \"\\f0c01\";\n}\n\n.mdi-alpha-h-circle-outline::before {\n  content: \"\\f0c02\";\n}\n\n.mdi-alpha-i::before {\n  content: \"\\f0af6\";\n}\n\n.mdi-alpha-i-box::before {\n  content: \"\\f0b10\";\n}\n\n.mdi-alpha-i-box-outline::before {\n  content: \"\\f0c03\";\n}\n\n.mdi-alpha-i-circle::before {\n  content: \"\\f0c04\";\n}\n\n.mdi-alpha-i-circle-outline::before {\n  content: \"\\f0c05\";\n}\n\n.mdi-alpha-j::before {\n  content: \"\\f0af7\";\n}\n\n.mdi-alpha-j-box::before {\n  content: \"\\f0b11\";\n}\n\n.mdi-alpha-j-box-outline::before {\n  content: \"\\f0c06\";\n}\n\n.mdi-alpha-j-circle::before {\n  content: \"\\f0c07\";\n}\n\n.mdi-alpha-j-circle-outline::before {\n  content: \"\\f0c08\";\n}\n\n.mdi-alpha-k::before {\n  content: \"\\f0af8\";\n}\n\n.mdi-alpha-k-box::before {\n  content: \"\\f0b12\";\n}\n\n.mdi-alpha-k-box-outline::before {\n  content: \"\\f0c09\";\n}\n\n.mdi-alpha-k-circle::before {\n  content: \"\\f0c0a\";\n}\n\n.mdi-alpha-k-circle-outline::before {\n  content: \"\\f0c0b\";\n}\n\n.mdi-alpha-l::before {\n  content: \"\\f0af9\";\n}\n\n.mdi-alpha-l-box::before {\n  content: \"\\f0b13\";\n}\n\n.mdi-alpha-l-box-outline::before {\n  content: \"\\f0c0c\";\n}\n\n.mdi-alpha-l-circle::before {\n  content: \"\\f0c0d\";\n}\n\n.mdi-alpha-l-circle-outline::before {\n  content: \"\\f0c0e\";\n}\n\n.mdi-alpha-m::before {\n  content: \"\\f0afa\";\n}\n\n.mdi-alpha-m-box::before {\n  content: \"\\f0b14\";\n}\n\n.mdi-alpha-m-box-outline::before {\n  content: \"\\f0c0f\";\n}\n\n.mdi-alpha-m-circle::before {\n  content: \"\\f0c10\";\n}\n\n.mdi-alpha-m-circle-outline::before {\n  content: \"\\f0c11\";\n}\n\n.mdi-alpha-n::before {\n  content: \"\\f0afb\";\n}\n\n.mdi-alpha-n-box::before {\n  content: \"\\f0b15\";\n}\n\n.mdi-alpha-n-box-outline::before {\n  content: \"\\f0c12\";\n}\n\n.mdi-alpha-n-circle::before {\n  content: \"\\f0c13\";\n}\n\n.mdi-alpha-n-circle-outline::before {\n  content: \"\\f0c14\";\n}\n\n.mdi-alpha-o::before {\n  content: \"\\f0afc\";\n}\n\n.mdi-alpha-o-box::before {\n  content: \"\\f0b16\";\n}\n\n.mdi-alpha-o-box-outline::before {\n  content: \"\\f0c15\";\n}\n\n.mdi-alpha-o-circle::before {\n  content: \"\\f0c16\";\n}\n\n.mdi-alpha-o-circle-outline::before {\n  content: \"\\f0c17\";\n}\n\n.mdi-alpha-p::before {\n  content: \"\\f0afd\";\n}\n\n.mdi-alpha-p-box::before {\n  content: \"\\f0b17\";\n}\n\n.mdi-alpha-p-box-outline::before {\n  content: \"\\f0c18\";\n}\n\n.mdi-alpha-p-circle::before {\n  content: \"\\f0c19\";\n}\n\n.mdi-alpha-p-circle-outline::before {\n  content: \"\\f0c1a\";\n}\n\n.mdi-alpha-q::before {\n  content: \"\\f0afe\";\n}\n\n.mdi-alpha-q-box::before {\n  content: \"\\f0b18\";\n}\n\n.mdi-alpha-q-box-outline::before {\n  content: \"\\f0c1b\";\n}\n\n.mdi-alpha-q-circle::before {\n  content: \"\\f0c1c\";\n}\n\n.mdi-alpha-q-circle-outline::before {\n  content: \"\\f0c1d\";\n}\n\n.mdi-alpha-r::before {\n  content: \"\\f0aff\";\n}\n\n.mdi-alpha-r-box::before {\n  content: \"\\f0b19\";\n}\n\n.mdi-alpha-r-box-outline::before {\n  content: \"\\f0c1e\";\n}\n\n.mdi-alpha-r-circle::before {\n  content: \"\\f0c1f\";\n}\n\n.mdi-alpha-r-circle-outline::before {\n  content: \"\\f0c20\";\n}\n\n.mdi-alpha-s::before {\n  content: \"\\f0b00\";\n}\n\n.mdi-alpha-s-box::before {\n  content: \"\\f0b1a\";\n}\n\n.mdi-alpha-s-box-outline::before {\n  content: \"\\f0c21\";\n}\n\n.mdi-alpha-s-circle::before {\n  content: \"\\f0c22\";\n}\n\n.mdi-alpha-s-circle-outline::before {\n  content: \"\\f0c23\";\n}\n\n.mdi-alpha-t::before {\n  content: \"\\f0b01\";\n}\n\n.mdi-alpha-t-box::before {\n  content: \"\\f0b1b\";\n}\n\n.mdi-alpha-t-box-outline::before {\n  content: \"\\f0c24\";\n}\n\n.mdi-alpha-t-circle::before {\n  content: \"\\f0c25\";\n}\n\n.mdi-alpha-t-circle-outline::before {\n  content: \"\\f0c26\";\n}\n\n.mdi-alpha-u::before {\n  content: \"\\f0b02\";\n}\n\n.mdi-alpha-u-box::before {\n  content: \"\\f0b1c\";\n}\n\n.mdi-alpha-u-box-outline::before {\n  content: \"\\f0c27\";\n}\n\n.mdi-alpha-u-circle::before {\n  content: \"\\f0c28\";\n}\n\n.mdi-alpha-u-circle-outline::before {\n  content: \"\\f0c29\";\n}\n\n.mdi-alpha-v::before {\n  content: \"\\f0b03\";\n}\n\n.mdi-alpha-v-box::before {\n  content: \"\\f0b1d\";\n}\n\n.mdi-alpha-v-box-outline::before {\n  content: \"\\f0c2a\";\n}\n\n.mdi-alpha-v-circle::before {\n  content: \"\\f0c2b\";\n}\n\n.mdi-alpha-v-circle-outline::before {\n  content: \"\\f0c2c\";\n}\n\n.mdi-alpha-w::before {\n  content: \"\\f0b04\";\n}\n\n.mdi-alpha-w-box::before {\n  content: \"\\f0b1e\";\n}\n\n.mdi-alpha-w-box-outline::before {\n  content: \"\\f0c2d\";\n}\n\n.mdi-alpha-w-circle::before {\n  content: \"\\f0c2e\";\n}\n\n.mdi-alpha-w-circle-outline::before {\n  content: \"\\f0c2f\";\n}\n\n.mdi-alpha-x::before {\n  content: \"\\f0b05\";\n}\n\n.mdi-alpha-x-box::before {\n  content: \"\\f0b1f\";\n}\n\n.mdi-alpha-x-box-outline::before {\n  content: \"\\f0c30\";\n}\n\n.mdi-alpha-x-circle::before {\n  content: \"\\f0c31\";\n}\n\n.mdi-alpha-x-circle-outline::before {\n  content: \"\\f0c32\";\n}\n\n.mdi-alpha-y::before {\n  content: \"\\f0b06\";\n}\n\n.mdi-alpha-y-box::before {\n  content: \"\\f0b20\";\n}\n\n.mdi-alpha-y-box-outline::before {\n  content: \"\\f0c33\";\n}\n\n.mdi-alpha-y-circle::before {\n  content: \"\\f0c34\";\n}\n\n.mdi-alpha-y-circle-outline::before {\n  content: \"\\f0c35\";\n}\n\n.mdi-alpha-z::before {\n  content: \"\\f0b07\";\n}\n\n.mdi-alpha-z-box::before {\n  content: \"\\f0b21\";\n}\n\n.mdi-alpha-z-box-outline::before {\n  content: \"\\f0c36\";\n}\n\n.mdi-alpha-z-circle::before {\n  content: \"\\f0c37\";\n}\n\n.mdi-alpha-z-circle-outline::before {\n  content: \"\\f0c38\";\n}\n\n.mdi-alphabet-aurebesh::before {\n  content: \"\\f132c\";\n}\n\n.mdi-alphabet-cyrillic::before {\n  content: \"\\f132d\";\n}\n\n.mdi-alphabet-greek::before {\n  content: \"\\f132e\";\n}\n\n.mdi-alphabet-latin::before {\n  content: \"\\f132f\";\n}\n\n.mdi-alphabet-piqad::before {\n  content: \"\\f1330\";\n}\n\n.mdi-alphabet-tengwar::before {\n  content: \"\\f1337\";\n}\n\n.mdi-alphabetical::before {\n  content: \"\\f002c\";\n}\n\n.mdi-alphabetical-off::before {\n  content: \"\\f100c\";\n}\n\n.mdi-alphabetical-variant::before {\n  content: \"\\f100d\";\n}\n\n.mdi-alphabetical-variant-off::before {\n  content: \"\\f100e\";\n}\n\n.mdi-altimeter::before {\n  content: \"\\f05d7\";\n}\n\n.mdi-ambulance::before {\n  content: \"\\f002f\";\n}\n\n.mdi-ammunition::before {\n  content: \"\\f0ce8\";\n}\n\n.mdi-ampersand::before {\n  content: \"\\f0a8d\";\n}\n\n.mdi-amplifier::before {\n  content: \"\\f0030\";\n}\n\n.mdi-amplifier-off::before {\n  content: \"\\f11b5\";\n}\n\n.mdi-anchor::before {\n  content: \"\\f0031\";\n}\n\n.mdi-android::before {\n  content: \"\\f0032\";\n}\n\n.mdi-android-messages::before {\n  content: \"\\f0d45\";\n}\n\n.mdi-android-studio::before {\n  content: \"\\f0034\";\n}\n\n.mdi-angle-acute::before {\n  content: \"\\f0937\";\n}\n\n.mdi-angle-obtuse::before {\n  content: \"\\f0938\";\n}\n\n.mdi-angle-right::before {\n  content: \"\\f0939\";\n}\n\n.mdi-angular::before {\n  content: \"\\f06b2\";\n}\n\n.mdi-angularjs::before {\n  content: \"\\f06bf\";\n}\n\n.mdi-animation::before {\n  content: \"\\f05d8\";\n}\n\n.mdi-animation-outline::before {\n  content: \"\\f0a8f\";\n}\n\n.mdi-animation-play::before {\n  content: \"\\f093a\";\n}\n\n.mdi-animation-play-outline::before {\n  content: \"\\f0a90\";\n}\n\n.mdi-ansible::before {\n  content: \"\\f109a\";\n}\n\n.mdi-antenna::before {\n  content: \"\\f1119\";\n}\n\n.mdi-anvil::before {\n  content: \"\\f089b\";\n}\n\n.mdi-apache-kafka::before {\n  content: \"\\f100f\";\n}\n\n.mdi-api::before {\n  content: \"\\f109b\";\n}\n\n.mdi-api-off::before {\n  content: \"\\f1257\";\n}\n\n.mdi-apple::before {\n  content: \"\\f0035\";\n}\n\n.mdi-apple-finder::before {\n  content: \"\\f0036\";\n}\n\n.mdi-apple-icloud::before {\n  content: \"\\f0038\";\n}\n\n.mdi-apple-ios::before {\n  content: \"\\f0037\";\n}\n\n.mdi-apple-keyboard-caps::before {\n  content: \"\\f0632\";\n}\n\n.mdi-apple-keyboard-command::before {\n  content: \"\\f0633\";\n}\n\n.mdi-apple-keyboard-control::before {\n  content: \"\\f0634\";\n}\n\n.mdi-apple-keyboard-option::before {\n  content: \"\\f0635\";\n}\n\n.mdi-apple-keyboard-shift::before {\n  content: \"\\f0636\";\n}\n\n.mdi-apple-safari::before {\n  content: \"\\f0039\";\n}\n\n.mdi-application::before {\n  content: \"\\f08c6\";\n}\n\n.mdi-application-array::before {\n  content: \"\\f10f5\";\n}\n\n.mdi-application-array-outline::before {\n  content: \"\\f10f6\";\n}\n\n.mdi-application-braces::before {\n  content: \"\\f10f7\";\n}\n\n.mdi-application-braces-outline::before {\n  content: \"\\f10f8\";\n}\n\n.mdi-application-brackets::before {\n  content: \"\\f0c8b\";\n}\n\n.mdi-application-brackets-outline::before {\n  content: \"\\f0c8c\";\n}\n\n.mdi-application-cog::before {\n  content: \"\\f0675\";\n}\n\n.mdi-application-cog-outline::before {\n  content: \"\\f1577\";\n}\n\n.mdi-application-edit::before {\n  content: \"\\f00ae\";\n}\n\n.mdi-application-edit-outline::before {\n  content: \"\\f0619\";\n}\n\n.mdi-application-export::before {\n  content: \"\\f0dad\";\n}\n\n.mdi-application-import::before {\n  content: \"\\f0dae\";\n}\n\n.mdi-application-outline::before {\n  content: \"\\f0614\";\n}\n\n.mdi-application-parentheses::before {\n  content: \"\\f10f9\";\n}\n\n.mdi-application-parentheses-outline::before {\n  content: \"\\f10fa\";\n}\n\n.mdi-application-settings::before {\n  content: \"\\f0b60\";\n}\n\n.mdi-application-settings-outline::before {\n  content: \"\\f1555\";\n}\n\n.mdi-application-variable::before {\n  content: \"\\f10fb\";\n}\n\n.mdi-application-variable-outline::before {\n  content: \"\\f10fc\";\n}\n\n.mdi-approximately-equal::before {\n  content: \"\\f0f9e\";\n}\n\n.mdi-approximately-equal-box::before {\n  content: \"\\f0f9f\";\n}\n\n.mdi-apps::before {\n  content: \"\\f003b\";\n}\n\n.mdi-apps-box::before {\n  content: \"\\f0d46\";\n}\n\n.mdi-arch::before {\n  content: \"\\f08c7\";\n}\n\n.mdi-archive::before {\n  content: \"\\f003c\";\n}\n\n.mdi-archive-alert::before {\n  content: \"\\f14fd\";\n}\n\n.mdi-archive-alert-outline::before {\n  content: \"\\f14fe\";\n}\n\n.mdi-archive-arrow-down::before {\n  content: \"\\f1259\";\n}\n\n.mdi-archive-arrow-down-outline::before {\n  content: \"\\f125a\";\n}\n\n.mdi-archive-arrow-up::before {\n  content: \"\\f125b\";\n}\n\n.mdi-archive-arrow-up-outline::before {\n  content: \"\\f125c\";\n}\n\n.mdi-archive-cancel::before {\n  content: \"\\f174b\";\n}\n\n.mdi-archive-cancel-outline::before {\n  content: \"\\f174c\";\n}\n\n.mdi-archive-check::before {\n  content: \"\\f174d\";\n}\n\n.mdi-archive-check-outline::before {\n  content: \"\\f174e\";\n}\n\n.mdi-archive-clock::before {\n  content: \"\\f174f\";\n}\n\n.mdi-archive-clock-outline::before {\n  content: \"\\f1750\";\n}\n\n.mdi-archive-cog::before {\n  content: \"\\f1751\";\n}\n\n.mdi-archive-cog-outline::before {\n  content: \"\\f1752\";\n}\n\n.mdi-archive-edit::before {\n  content: \"\\f1753\";\n}\n\n.mdi-archive-edit-outline::before {\n  content: \"\\f1754\";\n}\n\n.mdi-archive-eye::before {\n  content: \"\\f1755\";\n}\n\n.mdi-archive-eye-outline::before {\n  content: \"\\f1756\";\n}\n\n.mdi-archive-lock::before {\n  content: \"\\f1757\";\n}\n\n.mdi-archive-lock-open::before {\n  content: \"\\f1758\";\n}\n\n.mdi-archive-lock-open-outline::before {\n  content: \"\\f1759\";\n}\n\n.mdi-archive-lock-outline::before {\n  content: \"\\f175a\";\n}\n\n.mdi-archive-marker::before {\n  content: \"\\f175b\";\n}\n\n.mdi-archive-marker-outline::before {\n  content: \"\\f175c\";\n}\n\n.mdi-archive-minus::before {\n  content: \"\\f175d\";\n}\n\n.mdi-archive-minus-outline::before {\n  content: \"\\f175e\";\n}\n\n.mdi-archive-music::before {\n  content: \"\\f175f\";\n}\n\n.mdi-archive-music-outline::before {\n  content: \"\\f1760\";\n}\n\n.mdi-archive-off::before {\n  content: \"\\f1761\";\n}\n\n.mdi-archive-off-outline::before {\n  content: \"\\f1762\";\n}\n\n.mdi-archive-outline::before {\n  content: \"\\f120e\";\n}\n\n.mdi-archive-plus::before {\n  content: \"\\f1763\";\n}\n\n.mdi-archive-plus-outline::before {\n  content: \"\\f1764\";\n}\n\n.mdi-archive-refresh::before {\n  content: \"\\f1765\";\n}\n\n.mdi-archive-refresh-outline::before {\n  content: \"\\f1766\";\n}\n\n.mdi-archive-remove::before {\n  content: \"\\f1767\";\n}\n\n.mdi-archive-remove-outline::before {\n  content: \"\\f1768\";\n}\n\n.mdi-archive-search::before {\n  content: \"\\f1769\";\n}\n\n.mdi-archive-search-outline::before {\n  content: \"\\f176a\";\n}\n\n.mdi-archive-settings::before {\n  content: \"\\f176b\";\n}\n\n.mdi-archive-settings-outline::before {\n  content: \"\\f176c\";\n}\n\n.mdi-archive-star::before {\n  content: \"\\f176d\";\n}\n\n.mdi-archive-star-outline::before {\n  content: \"\\f176e\";\n}\n\n.mdi-archive-sync::before {\n  content: \"\\f176f\";\n}\n\n.mdi-archive-sync-outline::before {\n  content: \"\\f1770\";\n}\n\n.mdi-arm-flex::before {\n  content: \"\\f0fd7\";\n}\n\n.mdi-arm-flex-outline::before {\n  content: \"\\f0fd6\";\n}\n\n.mdi-arrange-bring-forward::before {\n  content: \"\\f003d\";\n}\n\n.mdi-arrange-bring-to-front::before {\n  content: \"\\f003e\";\n}\n\n.mdi-arrange-send-backward::before {\n  content: \"\\f003f\";\n}\n\n.mdi-arrange-send-to-back::before {\n  content: \"\\f0040\";\n}\n\n.mdi-arrow-all::before {\n  content: \"\\f0041\";\n}\n\n.mdi-arrow-bottom-left::before {\n  content: \"\\f0042\";\n}\n\n.mdi-arrow-bottom-left-bold-box::before {\n  content: \"\\f1964\";\n}\n\n.mdi-arrow-bottom-left-bold-box-outline::before {\n  content: \"\\f1965\";\n}\n\n.mdi-arrow-bottom-left-bold-outline::before {\n  content: \"\\f09b7\";\n}\n\n.mdi-arrow-bottom-left-thick::before {\n  content: \"\\f09b8\";\n}\n\n.mdi-arrow-bottom-left-thin::before {\n  content: \"\\f19b6\";\n}\n\n.mdi-arrow-bottom-left-thin-circle-outline::before {\n  content: \"\\f1596\";\n}\n\n.mdi-arrow-bottom-right::before {\n  content: \"\\f0043\";\n}\n\n.mdi-arrow-bottom-right-bold-box::before {\n  content: \"\\f1966\";\n}\n\n.mdi-arrow-bottom-right-bold-box-outline::before {\n  content: \"\\f1967\";\n}\n\n.mdi-arrow-bottom-right-bold-outline::before {\n  content: \"\\f09b9\";\n}\n\n.mdi-arrow-bottom-right-thick::before {\n  content: \"\\f09ba\";\n}\n\n.mdi-arrow-bottom-right-thin::before {\n  content: \"\\f19b7\";\n}\n\n.mdi-arrow-bottom-right-thin-circle-outline::before {\n  content: \"\\f1595\";\n}\n\n.mdi-arrow-collapse::before {\n  content: \"\\f0615\";\n}\n\n.mdi-arrow-collapse-all::before {\n  content: \"\\f0044\";\n}\n\n.mdi-arrow-collapse-down::before {\n  content: \"\\f0792\";\n}\n\n.mdi-arrow-collapse-horizontal::before {\n  content: \"\\f084c\";\n}\n\n.mdi-arrow-collapse-left::before {\n  content: \"\\f0793\";\n}\n\n.mdi-arrow-collapse-right::before {\n  content: \"\\f0794\";\n}\n\n.mdi-arrow-collapse-up::before {\n  content: \"\\f0795\";\n}\n\n.mdi-arrow-collapse-vertical::before {\n  content: \"\\f084d\";\n}\n\n.mdi-arrow-decision::before {\n  content: \"\\f09bb\";\n}\n\n.mdi-arrow-decision-auto::before {\n  content: \"\\f09bc\";\n}\n\n.mdi-arrow-decision-auto-outline::before {\n  content: \"\\f09bd\";\n}\n\n.mdi-arrow-decision-outline::before {\n  content: \"\\f09be\";\n}\n\n.mdi-arrow-down::before {\n  content: \"\\f0045\";\n}\n\n.mdi-arrow-down-bold::before {\n  content: \"\\f072e\";\n}\n\n.mdi-arrow-down-bold-box::before {\n  content: \"\\f072f\";\n}\n\n.mdi-arrow-down-bold-box-outline::before {\n  content: \"\\f0730\";\n}\n\n.mdi-arrow-down-bold-circle::before {\n  content: \"\\f0047\";\n}\n\n.mdi-arrow-down-bold-circle-outline::before {\n  content: \"\\f0048\";\n}\n\n.mdi-arrow-down-bold-hexagon-outline::before {\n  content: \"\\f0049\";\n}\n\n.mdi-arrow-down-bold-outline::before {\n  content: \"\\f09bf\";\n}\n\n.mdi-arrow-down-box::before {\n  content: \"\\f06c0\";\n}\n\n.mdi-arrow-down-circle::before {\n  content: \"\\f0cdb\";\n}\n\n.mdi-arrow-down-circle-outline::before {\n  content: \"\\f0cdc\";\n}\n\n.mdi-arrow-down-drop-circle::before {\n  content: \"\\f004a\";\n}\n\n.mdi-arrow-down-drop-circle-outline::before {\n  content: \"\\f004b\";\n}\n\n.mdi-arrow-down-left::before {\n  content: \"\\f17a1\";\n}\n\n.mdi-arrow-down-left-bold::before {\n  content: \"\\f17a2\";\n}\n\n.mdi-arrow-down-right::before {\n  content: \"\\f17a3\";\n}\n\n.mdi-arrow-down-right-bold::before {\n  content: \"\\f17a4\";\n}\n\n.mdi-arrow-down-thick::before {\n  content: \"\\f0046\";\n}\n\n.mdi-arrow-down-thin::before {\n  content: \"\\f19b3\";\n}\n\n.mdi-arrow-down-thin-circle-outline::before {\n  content: \"\\f1599\";\n}\n\n.mdi-arrow-expand::before {\n  content: \"\\f0616\";\n}\n\n.mdi-arrow-expand-all::before {\n  content: \"\\f004c\";\n}\n\n.mdi-arrow-expand-down::before {\n  content: \"\\f0796\";\n}\n\n.mdi-arrow-expand-horizontal::before {\n  content: \"\\f084e\";\n}\n\n.mdi-arrow-expand-left::before {\n  content: \"\\f0797\";\n}\n\n.mdi-arrow-expand-right::before {\n  content: \"\\f0798\";\n}\n\n.mdi-arrow-expand-up::before {\n  content: \"\\f0799\";\n}\n\n.mdi-arrow-expand-vertical::before {\n  content: \"\\f084f\";\n}\n\n.mdi-arrow-horizontal-lock::before {\n  content: \"\\f115b\";\n}\n\n.mdi-arrow-left::before {\n  content: \"\\f004d\";\n}\n\n.mdi-arrow-left-bold::before {\n  content: \"\\f0731\";\n}\n\n.mdi-arrow-left-bold-box::before {\n  content: \"\\f0732\";\n}\n\n.mdi-arrow-left-bold-box-outline::before {\n  content: \"\\f0733\";\n}\n\n.mdi-arrow-left-bold-circle::before {\n  content: \"\\f004f\";\n}\n\n.mdi-arrow-left-bold-circle-outline::before {\n  content: \"\\f0050\";\n}\n\n.mdi-arrow-left-bold-hexagon-outline::before {\n  content: \"\\f0051\";\n}\n\n.mdi-arrow-left-bold-outline::before {\n  content: \"\\f09c0\";\n}\n\n.mdi-arrow-left-bottom::before {\n  content: \"\\f17a5\";\n}\n\n.mdi-arrow-left-bottom-bold::before {\n  content: \"\\f17a6\";\n}\n\n.mdi-arrow-left-box::before {\n  content: \"\\f06c1\";\n}\n\n.mdi-arrow-left-circle::before {\n  content: \"\\f0cdd\";\n}\n\n.mdi-arrow-left-circle-outline::before {\n  content: \"\\f0cde\";\n}\n\n.mdi-arrow-left-drop-circle::before {\n  content: \"\\f0052\";\n}\n\n.mdi-arrow-left-drop-circle-outline::before {\n  content: \"\\f0053\";\n}\n\n.mdi-arrow-left-right::before {\n  content: \"\\f0e73\";\n}\n\n.mdi-arrow-left-right-bold::before {\n  content: \"\\f0e74\";\n}\n\n.mdi-arrow-left-right-bold-outline::before {\n  content: \"\\f09c1\";\n}\n\n.mdi-arrow-left-thick::before {\n  content: \"\\f004e\";\n}\n\n.mdi-arrow-left-thin::before {\n  content: \"\\f19b1\";\n}\n\n.mdi-arrow-left-thin-circle-outline::before {\n  content: \"\\f159a\";\n}\n\n.mdi-arrow-left-top::before {\n  content: \"\\f17a7\";\n}\n\n.mdi-arrow-left-top-bold::before {\n  content: \"\\f17a8\";\n}\n\n.mdi-arrow-projectile::before {\n  content: \"\\f1840\";\n}\n\n.mdi-arrow-projectile-multiple::before {\n  content: \"\\f183f\";\n}\n\n.mdi-arrow-right::before {\n  content: \"\\f0054\";\n}\n\n.mdi-arrow-right-bold::before {\n  content: \"\\f0734\";\n}\n\n.mdi-arrow-right-bold-box::before {\n  content: \"\\f0735\";\n}\n\n.mdi-arrow-right-bold-box-outline::before {\n  content: \"\\f0736\";\n}\n\n.mdi-arrow-right-bold-circle::before {\n  content: \"\\f0056\";\n}\n\n.mdi-arrow-right-bold-circle-outline::before {\n  content: \"\\f0057\";\n}\n\n.mdi-arrow-right-bold-hexagon-outline::before {\n  content: \"\\f0058\";\n}\n\n.mdi-arrow-right-bold-outline::before {\n  content: \"\\f09c2\";\n}\n\n.mdi-arrow-right-bottom::before {\n  content: \"\\f17a9\";\n}\n\n.mdi-arrow-right-bottom-bold::before {\n  content: \"\\f17aa\";\n}\n\n.mdi-arrow-right-box::before {\n  content: \"\\f06c2\";\n}\n\n.mdi-arrow-right-circle::before {\n  content: \"\\f0cdf\";\n}\n\n.mdi-arrow-right-circle-outline::before {\n  content: \"\\f0ce0\";\n}\n\n.mdi-arrow-right-drop-circle::before {\n  content: \"\\f0059\";\n}\n\n.mdi-arrow-right-drop-circle-outline::before {\n  content: \"\\f005a\";\n}\n\n.mdi-arrow-right-thick::before {\n  content: \"\\f0055\";\n}\n\n.mdi-arrow-right-thin::before {\n  content: \"\\f19b0\";\n}\n\n.mdi-arrow-right-thin-circle-outline::before {\n  content: \"\\f1598\";\n}\n\n.mdi-arrow-right-top::before {\n  content: \"\\f17ab\";\n}\n\n.mdi-arrow-right-top-bold::before {\n  content: \"\\f17ac\";\n}\n\n.mdi-arrow-split-horizontal::before {\n  content: \"\\f093b\";\n}\n\n.mdi-arrow-split-vertical::before {\n  content: \"\\f093c\";\n}\n\n.mdi-arrow-top-left::before {\n  content: \"\\f005b\";\n}\n\n.mdi-arrow-top-left-bold-box::before {\n  content: \"\\f1968\";\n}\n\n.mdi-arrow-top-left-bold-box-outline::before {\n  content: \"\\f1969\";\n}\n\n.mdi-arrow-top-left-bold-outline::before {\n  content: \"\\f09c3\";\n}\n\n.mdi-arrow-top-left-bottom-right::before {\n  content: \"\\f0e75\";\n}\n\n.mdi-arrow-top-left-bottom-right-bold::before {\n  content: \"\\f0e76\";\n}\n\n.mdi-arrow-top-left-thick::before {\n  content: \"\\f09c4\";\n}\n\n.mdi-arrow-top-left-thin::before {\n  content: \"\\f19b5\";\n}\n\n.mdi-arrow-top-left-thin-circle-outline::before {\n  content: \"\\f1593\";\n}\n\n.mdi-arrow-top-right::before {\n  content: \"\\f005c\";\n}\n\n.mdi-arrow-top-right-bold-box::before {\n  content: \"\\f196a\";\n}\n\n.mdi-arrow-top-right-bold-box-outline::before {\n  content: \"\\f196b\";\n}\n\n.mdi-arrow-top-right-bold-outline::before {\n  content: \"\\f09c5\";\n}\n\n.mdi-arrow-top-right-bottom-left::before {\n  content: \"\\f0e77\";\n}\n\n.mdi-arrow-top-right-bottom-left-bold::before {\n  content: \"\\f0e78\";\n}\n\n.mdi-arrow-top-right-thick::before {\n  content: \"\\f09c6\";\n}\n\n.mdi-arrow-top-right-thin::before {\n  content: \"\\f19b4\";\n}\n\n.mdi-arrow-top-right-thin-circle-outline::before {\n  content: \"\\f1594\";\n}\n\n.mdi-arrow-u-down-left::before {\n  content: \"\\f17ad\";\n}\n\n.mdi-arrow-u-down-left-bold::before {\n  content: \"\\f17ae\";\n}\n\n.mdi-arrow-u-down-right::before {\n  content: \"\\f17af\";\n}\n\n.mdi-arrow-u-down-right-bold::before {\n  content: \"\\f17b0\";\n}\n\n.mdi-arrow-u-left-bottom::before {\n  content: \"\\f17b1\";\n}\n\n.mdi-arrow-u-left-bottom-bold::before {\n  content: \"\\f17b2\";\n}\n\n.mdi-arrow-u-left-top::before {\n  content: \"\\f17b3\";\n}\n\n.mdi-arrow-u-left-top-bold::before {\n  content: \"\\f17b4\";\n}\n\n.mdi-arrow-u-right-bottom::before {\n  content: \"\\f17b5\";\n}\n\n.mdi-arrow-u-right-bottom-bold::before {\n  content: \"\\f17b6\";\n}\n\n.mdi-arrow-u-right-top::before {\n  content: \"\\f17b7\";\n}\n\n.mdi-arrow-u-right-top-bold::before {\n  content: \"\\f17b8\";\n}\n\n.mdi-arrow-u-up-left::before {\n  content: \"\\f17b9\";\n}\n\n.mdi-arrow-u-up-left-bold::before {\n  content: \"\\f17ba\";\n}\n\n.mdi-arrow-u-up-right::before {\n  content: \"\\f17bb\";\n}\n\n.mdi-arrow-u-up-right-bold::before {\n  content: \"\\f17bc\";\n}\n\n.mdi-arrow-up::before {\n  content: \"\\f005d\";\n}\n\n.mdi-arrow-up-bold::before {\n  content: \"\\f0737\";\n}\n\n.mdi-arrow-up-bold-box::before {\n  content: \"\\f0738\";\n}\n\n.mdi-arrow-up-bold-box-outline::before {\n  content: \"\\f0739\";\n}\n\n.mdi-arrow-up-bold-circle::before {\n  content: \"\\f005f\";\n}\n\n.mdi-arrow-up-bold-circle-outline::before {\n  content: \"\\f0060\";\n}\n\n.mdi-arrow-up-bold-hexagon-outline::before {\n  content: \"\\f0061\";\n}\n\n.mdi-arrow-up-bold-outline::before {\n  content: \"\\f09c7\";\n}\n\n.mdi-arrow-up-box::before {\n  content: \"\\f06c3\";\n}\n\n.mdi-arrow-up-circle::before {\n  content: \"\\f0ce1\";\n}\n\n.mdi-arrow-up-circle-outline::before {\n  content: \"\\f0ce2\";\n}\n\n.mdi-arrow-up-down::before {\n  content: \"\\f0e79\";\n}\n\n.mdi-arrow-up-down-bold::before {\n  content: \"\\f0e7a\";\n}\n\n.mdi-arrow-up-down-bold-outline::before {\n  content: \"\\f09c8\";\n}\n\n.mdi-arrow-up-drop-circle::before {\n  content: \"\\f0062\";\n}\n\n.mdi-arrow-up-drop-circle-outline::before {\n  content: \"\\f0063\";\n}\n\n.mdi-arrow-up-left::before {\n  content: \"\\f17bd\";\n}\n\n.mdi-arrow-up-left-bold::before {\n  content: \"\\f17be\";\n}\n\n.mdi-arrow-up-right::before {\n  content: \"\\f17bf\";\n}\n\n.mdi-arrow-up-right-bold::before {\n  content: \"\\f17c0\";\n}\n\n.mdi-arrow-up-thick::before {\n  content: \"\\f005e\";\n}\n\n.mdi-arrow-up-thin::before {\n  content: \"\\f19b2\";\n}\n\n.mdi-arrow-up-thin-circle-outline::before {\n  content: \"\\f1597\";\n}\n\n.mdi-arrow-vertical-lock::before {\n  content: \"\\f115c\";\n}\n\n.mdi-artstation::before {\n  content: \"\\f0b5b\";\n}\n\n.mdi-aspect-ratio::before {\n  content: \"\\f0a24\";\n}\n\n.mdi-assistant::before {\n  content: \"\\f0064\";\n}\n\n.mdi-asterisk::before {\n  content: \"\\f06c4\";\n}\n\n.mdi-at::before {\n  content: \"\\f0065\";\n}\n\n.mdi-atlassian::before {\n  content: \"\\f0804\";\n}\n\n.mdi-atm::before {\n  content: \"\\f0d47\";\n}\n\n.mdi-atom::before {\n  content: \"\\f0768\";\n}\n\n.mdi-atom-variant::before {\n  content: \"\\f0e7b\";\n}\n\n.mdi-attachment::before {\n  content: \"\\f0066\";\n}\n\n.mdi-audio-input-rca::before {\n  content: \"\\f186b\";\n}\n\n.mdi-audio-input-stereo-minijack::before {\n  content: \"\\f186c\";\n}\n\n.mdi-audio-input-xlr::before {\n  content: \"\\f186d\";\n}\n\n.mdi-audio-video::before {\n  content: \"\\f093d\";\n}\n\n.mdi-audio-video-off::before {\n  content: \"\\f11b6\";\n}\n\n.mdi-augmented-reality::before {\n  content: \"\\f0850\";\n}\n\n.mdi-auto-download::before {\n  content: \"\\f137e\";\n}\n\n.mdi-auto-fix::before {\n  content: \"\\f0068\";\n}\n\n.mdi-auto-upload::before {\n  content: \"\\f0069\";\n}\n\n.mdi-autorenew::before {\n  content: \"\\f006a\";\n}\n\n.mdi-av-timer::before {\n  content: \"\\f006b\";\n}\n\n.mdi-aws::before {\n  content: \"\\f0e0f\";\n}\n\n.mdi-axe::before {\n  content: \"\\f08c8\";\n}\n\n.mdi-axe-battle::before {\n  content: \"\\f1842\";\n}\n\n.mdi-axis::before {\n  content: \"\\f0d48\";\n}\n\n.mdi-axis-arrow::before {\n  content: \"\\f0d49\";\n}\n\n.mdi-axis-arrow-info::before {\n  content: \"\\f140e\";\n}\n\n.mdi-axis-arrow-lock::before {\n  content: \"\\f0d4a\";\n}\n\n.mdi-axis-lock::before {\n  content: \"\\f0d4b\";\n}\n\n.mdi-axis-x-arrow::before {\n  content: \"\\f0d4c\";\n}\n\n.mdi-axis-x-arrow-lock::before {\n  content: \"\\f0d4d\";\n}\n\n.mdi-axis-x-rotate-clockwise::before {\n  content: \"\\f0d4e\";\n}\n\n.mdi-axis-x-rotate-counterclockwise::before {\n  content: \"\\f0d4f\";\n}\n\n.mdi-axis-x-y-arrow-lock::before {\n  content: \"\\f0d50\";\n}\n\n.mdi-axis-y-arrow::before {\n  content: \"\\f0d51\";\n}\n\n.mdi-axis-y-arrow-lock::before {\n  content: \"\\f0d52\";\n}\n\n.mdi-axis-y-rotate-clockwise::before {\n  content: \"\\f0d53\";\n}\n\n.mdi-axis-y-rotate-counterclockwise::before {\n  content: \"\\f0d54\";\n}\n\n.mdi-axis-z-arrow::before {\n  content: \"\\f0d55\";\n}\n\n.mdi-axis-z-arrow-lock::before {\n  content: \"\\f0d56\";\n}\n\n.mdi-axis-z-rotate-clockwise::before {\n  content: \"\\f0d57\";\n}\n\n.mdi-axis-z-rotate-counterclockwise::before {\n  content: \"\\f0d58\";\n}\n\n.mdi-babel::before {\n  content: \"\\f0a25\";\n}\n\n.mdi-baby::before {\n  content: \"\\f006c\";\n}\n\n.mdi-baby-bottle::before {\n  content: \"\\f0f39\";\n}\n\n.mdi-baby-bottle-outline::before {\n  content: \"\\f0f3a\";\n}\n\n.mdi-baby-buggy::before {\n  content: \"\\f13e0\";\n}\n\n.mdi-baby-carriage::before {\n  content: \"\\f068f\";\n}\n\n.mdi-baby-carriage-off::before {\n  content: \"\\f0fa0\";\n}\n\n.mdi-baby-face::before {\n  content: \"\\f0e7c\";\n}\n\n.mdi-baby-face-outline::before {\n  content: \"\\f0e7d\";\n}\n\n.mdi-backburger::before {\n  content: \"\\f006d\";\n}\n\n.mdi-backspace::before {\n  content: \"\\f006e\";\n}\n\n.mdi-backspace-outline::before {\n  content: \"\\f0b5c\";\n}\n\n.mdi-backspace-reverse::before {\n  content: \"\\f0e7e\";\n}\n\n.mdi-backspace-reverse-outline::before {\n  content: \"\\f0e7f\";\n}\n\n.mdi-backup-restore::before {\n  content: \"\\f006f\";\n}\n\n.mdi-bacteria::before {\n  content: \"\\f0ed5\";\n}\n\n.mdi-bacteria-outline::before {\n  content: \"\\f0ed6\";\n}\n\n.mdi-badge-account::before {\n  content: \"\\f0da7\";\n}\n\n.mdi-badge-account-alert::before {\n  content: \"\\f0da8\";\n}\n\n.mdi-badge-account-alert-outline::before {\n  content: \"\\f0da9\";\n}\n\n.mdi-badge-account-horizontal::before {\n  content: \"\\f0e0d\";\n}\n\n.mdi-badge-account-horizontal-outline::before {\n  content: \"\\f0e0e\";\n}\n\n.mdi-badge-account-outline::before {\n  content: \"\\f0daa\";\n}\n\n.mdi-badminton::before {\n  content: \"\\f0851\";\n}\n\n.mdi-bag-carry-on::before {\n  content: \"\\f0f3b\";\n}\n\n.mdi-bag-carry-on-check::before {\n  content: \"\\f0d65\";\n}\n\n.mdi-bag-carry-on-off::before {\n  content: \"\\f0f3c\";\n}\n\n.mdi-bag-checked::before {\n  content: \"\\f0f3d\";\n}\n\n.mdi-bag-personal::before {\n  content: \"\\f0e10\";\n}\n\n.mdi-bag-personal-off::before {\n  content: \"\\f0e11\";\n}\n\n.mdi-bag-personal-off-outline::before {\n  content: \"\\f0e12\";\n}\n\n.mdi-bag-personal-outline::before {\n  content: \"\\f0e13\";\n}\n\n.mdi-bag-suitcase::before {\n  content: \"\\f158b\";\n}\n\n.mdi-bag-suitcase-off::before {\n  content: \"\\f158d\";\n}\n\n.mdi-bag-suitcase-off-outline::before {\n  content: \"\\f158e\";\n}\n\n.mdi-bag-suitcase-outline::before {\n  content: \"\\f158c\";\n}\n\n.mdi-baguette::before {\n  content: \"\\f0f3e\";\n}\n\n.mdi-balcony::before {\n  content: \"\\f1817\";\n}\n\n.mdi-balloon::before {\n  content: \"\\f0a26\";\n}\n\n.mdi-ballot::before {\n  content: \"\\f09c9\";\n}\n\n.mdi-ballot-outline::before {\n  content: \"\\f09ca\";\n}\n\n.mdi-ballot-recount::before {\n  content: \"\\f0c39\";\n}\n\n.mdi-ballot-recount-outline::before {\n  content: \"\\f0c3a\";\n}\n\n.mdi-bandage::before {\n  content: \"\\f0daf\";\n}\n\n.mdi-bank::before {\n  content: \"\\f0070\";\n}\n\n.mdi-bank-check::before {\n  content: \"\\f1655\";\n}\n\n.mdi-bank-minus::before {\n  content: \"\\f0db0\";\n}\n\n.mdi-bank-off::before {\n  content: \"\\f1656\";\n}\n\n.mdi-bank-off-outline::before {\n  content: \"\\f1657\";\n}\n\n.mdi-bank-outline::before {\n  content: \"\\f0e80\";\n}\n\n.mdi-bank-plus::before {\n  content: \"\\f0db1\";\n}\n\n.mdi-bank-remove::before {\n  content: \"\\f0db2\";\n}\n\n.mdi-bank-transfer::before {\n  content: \"\\f0a27\";\n}\n\n.mdi-bank-transfer-in::before {\n  content: \"\\f0a28\";\n}\n\n.mdi-bank-transfer-out::before {\n  content: \"\\f0a29\";\n}\n\n.mdi-barcode::before {\n  content: \"\\f0071\";\n}\n\n.mdi-barcode-off::before {\n  content: \"\\f1236\";\n}\n\n.mdi-barcode-scan::before {\n  content: \"\\f0072\";\n}\n\n.mdi-barley::before {\n  content: \"\\f0073\";\n}\n\n.mdi-barley-off::before {\n  content: \"\\f0b5d\";\n}\n\n.mdi-barn::before {\n  content: \"\\f0b5e\";\n}\n\n.mdi-barrel::before {\n  content: \"\\f0074\";\n}\n\n.mdi-baseball::before {\n  content: \"\\f0852\";\n}\n\n.mdi-baseball-bat::before {\n  content: \"\\f0853\";\n}\n\n.mdi-baseball-diamond::before {\n  content: \"\\f15ec\";\n}\n\n.mdi-baseball-diamond-outline::before {\n  content: \"\\f15ed\";\n}\n\n.mdi-bash::before {\n  content: \"\\f1183\";\n}\n\n.mdi-basket::before {\n  content: \"\\f0076\";\n}\n\n.mdi-basket-check::before {\n  content: \"\\f18e5\";\n}\n\n.mdi-basket-check-outline::before {\n  content: \"\\f18e6\";\n}\n\n.mdi-basket-fill::before {\n  content: \"\\f0077\";\n}\n\n.mdi-basket-minus::before {\n  content: \"\\f1523\";\n}\n\n.mdi-basket-minus-outline::before {\n  content: \"\\f1524\";\n}\n\n.mdi-basket-off::before {\n  content: \"\\f1525\";\n}\n\n.mdi-basket-off-outline::before {\n  content: \"\\f1526\";\n}\n\n.mdi-basket-outline::before {\n  content: \"\\f1181\";\n}\n\n.mdi-basket-plus::before {\n  content: \"\\f1527\";\n}\n\n.mdi-basket-plus-outline::before {\n  content: \"\\f1528\";\n}\n\n.mdi-basket-remove::before {\n  content: \"\\f1529\";\n}\n\n.mdi-basket-remove-outline::before {\n  content: \"\\f152a\";\n}\n\n.mdi-basket-unfill::before {\n  content: \"\\f0078\";\n}\n\n.mdi-basketball::before {\n  content: \"\\f0806\";\n}\n\n.mdi-basketball-hoop::before {\n  content: \"\\f0c3b\";\n}\n\n.mdi-basketball-hoop-outline::before {\n  content: \"\\f0c3c\";\n}\n\n.mdi-bat::before {\n  content: \"\\f0b5f\";\n}\n\n.mdi-bathtub::before {\n  content: \"\\f1818\";\n}\n\n.mdi-bathtub-outline::before {\n  content: \"\\f1819\";\n}\n\n.mdi-battery::before {\n  content: \"\\f0079\";\n}\n\n.mdi-battery-10::before {\n  content: \"\\f007a\";\n}\n\n.mdi-battery-10-bluetooth::before {\n  content: \"\\f093e\";\n}\n\n.mdi-battery-20::before {\n  content: \"\\f007b\";\n}\n\n.mdi-battery-20-bluetooth::before {\n  content: \"\\f093f\";\n}\n\n.mdi-battery-30::before {\n  content: \"\\f007c\";\n}\n\n.mdi-battery-30-bluetooth::before {\n  content: \"\\f0940\";\n}\n\n.mdi-battery-40::before {\n  content: \"\\f007d\";\n}\n\n.mdi-battery-40-bluetooth::before {\n  content: \"\\f0941\";\n}\n\n.mdi-battery-50::before {\n  content: \"\\f007e\";\n}\n\n.mdi-battery-50-bluetooth::before {\n  content: \"\\f0942\";\n}\n\n.mdi-battery-60::before {\n  content: \"\\f007f\";\n}\n\n.mdi-battery-60-bluetooth::before {\n  content: \"\\f0943\";\n}\n\n.mdi-battery-70::before {\n  content: \"\\f0080\";\n}\n\n.mdi-battery-70-bluetooth::before {\n  content: \"\\f0944\";\n}\n\n.mdi-battery-80::before {\n  content: \"\\f0081\";\n}\n\n.mdi-battery-80-bluetooth::before {\n  content: \"\\f0945\";\n}\n\n.mdi-battery-90::before {\n  content: \"\\f0082\";\n}\n\n.mdi-battery-90-bluetooth::before {\n  content: \"\\f0946\";\n}\n\n.mdi-battery-alert::before {\n  content: \"\\f0083\";\n}\n\n.mdi-battery-alert-bluetooth::before {\n  content: \"\\f0947\";\n}\n\n.mdi-battery-alert-variant::before {\n  content: \"\\f10cc\";\n}\n\n.mdi-battery-alert-variant-outline::before {\n  content: \"\\f10cd\";\n}\n\n.mdi-battery-arrow-down::before {\n  content: \"\\f17de\";\n}\n\n.mdi-battery-arrow-down-outline::before {\n  content: \"\\f17df\";\n}\n\n.mdi-battery-arrow-up::before {\n  content: \"\\f17e0\";\n}\n\n.mdi-battery-arrow-up-outline::before {\n  content: \"\\f17e1\";\n}\n\n.mdi-battery-bluetooth::before {\n  content: \"\\f0948\";\n}\n\n.mdi-battery-bluetooth-variant::before {\n  content: \"\\f0949\";\n}\n\n.mdi-battery-charging::before {\n  content: \"\\f0084\";\n}\n\n.mdi-battery-charging-10::before {\n  content: \"\\f089c\";\n}\n\n.mdi-battery-charging-100::before {\n  content: \"\\f0085\";\n}\n\n.mdi-battery-charging-20::before {\n  content: \"\\f0086\";\n}\n\n.mdi-battery-charging-30::before {\n  content: \"\\f0087\";\n}\n\n.mdi-battery-charging-40::before {\n  content: \"\\f0088\";\n}\n\n.mdi-battery-charging-50::before {\n  content: \"\\f089d\";\n}\n\n.mdi-battery-charging-60::before {\n  content: \"\\f0089\";\n}\n\n.mdi-battery-charging-70::before {\n  content: \"\\f089e\";\n}\n\n.mdi-battery-charging-80::before {\n  content: \"\\f008a\";\n}\n\n.mdi-battery-charging-90::before {\n  content: \"\\f008b\";\n}\n\n.mdi-battery-charging-high::before {\n  content: \"\\f12a6\";\n}\n\n.mdi-battery-charging-low::before {\n  content: \"\\f12a4\";\n}\n\n.mdi-battery-charging-medium::before {\n  content: \"\\f12a5\";\n}\n\n.mdi-battery-charging-outline::before {\n  content: \"\\f089f\";\n}\n\n.mdi-battery-charging-wireless::before {\n  content: \"\\f0807\";\n}\n\n.mdi-battery-charging-wireless-10::before {\n  content: \"\\f0808\";\n}\n\n.mdi-battery-charging-wireless-20::before {\n  content: \"\\f0809\";\n}\n\n.mdi-battery-charging-wireless-30::before {\n  content: \"\\f080a\";\n}\n\n.mdi-battery-charging-wireless-40::before {\n  content: \"\\f080b\";\n}\n\n.mdi-battery-charging-wireless-50::before {\n  content: \"\\f080c\";\n}\n\n.mdi-battery-charging-wireless-60::before {\n  content: \"\\f080d\";\n}\n\n.mdi-battery-charging-wireless-70::before {\n  content: \"\\f080e\";\n}\n\n.mdi-battery-charging-wireless-80::before {\n  content: \"\\f080f\";\n}\n\n.mdi-battery-charging-wireless-90::before {\n  content: \"\\f0810\";\n}\n\n.mdi-battery-charging-wireless-alert::before {\n  content: \"\\f0811\";\n}\n\n.mdi-battery-charging-wireless-outline::before {\n  content: \"\\f0812\";\n}\n\n.mdi-battery-check::before {\n  content: \"\\f17e2\";\n}\n\n.mdi-battery-check-outline::before {\n  content: \"\\f17e3\";\n}\n\n.mdi-battery-heart::before {\n  content: \"\\f120f\";\n}\n\n.mdi-battery-heart-outline::before {\n  content: \"\\f1210\";\n}\n\n.mdi-battery-heart-variant::before {\n  content: \"\\f1211\";\n}\n\n.mdi-battery-high::before {\n  content: \"\\f12a3\";\n}\n\n.mdi-battery-lock::before {\n  content: \"\\f179c\";\n}\n\n.mdi-battery-lock-open::before {\n  content: \"\\f179d\";\n}\n\n.mdi-battery-low::before {\n  content: \"\\f12a1\";\n}\n\n.mdi-battery-medium::before {\n  content: \"\\f12a2\";\n}\n\n.mdi-battery-minus::before {\n  content: \"\\f17e4\";\n}\n\n.mdi-battery-minus-outline::before {\n  content: \"\\f17e5\";\n}\n\n.mdi-battery-minus-variant::before {\n  content: \"\\f008c\";\n}\n\n.mdi-battery-negative::before {\n  content: \"\\f008d\";\n}\n\n.mdi-battery-off::before {\n  content: \"\\f125d\";\n}\n\n.mdi-battery-off-outline::before {\n  content: \"\\f125e\";\n}\n\n.mdi-battery-outline::before {\n  content: \"\\f008e\";\n}\n\n.mdi-battery-plus::before {\n  content: \"\\f17e6\";\n}\n\n.mdi-battery-plus-outline::before {\n  content: \"\\f17e7\";\n}\n\n.mdi-battery-plus-variant::before {\n  content: \"\\f008f\";\n}\n\n.mdi-battery-positive::before {\n  content: \"\\f0090\";\n}\n\n.mdi-battery-remove::before {\n  content: \"\\f17e8\";\n}\n\n.mdi-battery-remove-outline::before {\n  content: \"\\f17e9\";\n}\n\n.mdi-battery-sync::before {\n  content: \"\\f1834\";\n}\n\n.mdi-battery-sync-outline::before {\n  content: \"\\f1835\";\n}\n\n.mdi-battery-unknown::before {\n  content: \"\\f0091\";\n}\n\n.mdi-battery-unknown-bluetooth::before {\n  content: \"\\f094a\";\n}\n\n.mdi-beach::before {\n  content: \"\\f0092\";\n}\n\n.mdi-beaker::before {\n  content: \"\\f0cea\";\n}\n\n.mdi-beaker-alert::before {\n  content: \"\\f1229\";\n}\n\n.mdi-beaker-alert-outline::before {\n  content: \"\\f122a\";\n}\n\n.mdi-beaker-check::before {\n  content: \"\\f122b\";\n}\n\n.mdi-beaker-check-outline::before {\n  content: \"\\f122c\";\n}\n\n.mdi-beaker-minus::before {\n  content: \"\\f122d\";\n}\n\n.mdi-beaker-minus-outline::before {\n  content: \"\\f122e\";\n}\n\n.mdi-beaker-outline::before {\n  content: \"\\f0690\";\n}\n\n.mdi-beaker-plus::before {\n  content: \"\\f122f\";\n}\n\n.mdi-beaker-plus-outline::before {\n  content: \"\\f1230\";\n}\n\n.mdi-beaker-question::before {\n  content: \"\\f1231\";\n}\n\n.mdi-beaker-question-outline::before {\n  content: \"\\f1232\";\n}\n\n.mdi-beaker-remove::before {\n  content: \"\\f1233\";\n}\n\n.mdi-beaker-remove-outline::before {\n  content: \"\\f1234\";\n}\n\n.mdi-bed::before {\n  content: \"\\f02e3\";\n}\n\n.mdi-bed-double::before {\n  content: \"\\f0fd4\";\n}\n\n.mdi-bed-double-outline::before {\n  content: \"\\f0fd3\";\n}\n\n.mdi-bed-empty::before {\n  content: \"\\f08a0\";\n}\n\n.mdi-bed-king::before {\n  content: \"\\f0fd2\";\n}\n\n.mdi-bed-king-outline::before {\n  content: \"\\f0fd1\";\n}\n\n.mdi-bed-outline::before {\n  content: \"\\f0099\";\n}\n\n.mdi-bed-queen::before {\n  content: \"\\f0fd0\";\n}\n\n.mdi-bed-queen-outline::before {\n  content: \"\\f0fdb\";\n}\n\n.mdi-bed-single::before {\n  content: \"\\f106d\";\n}\n\n.mdi-bed-single-outline::before {\n  content: \"\\f106e\";\n}\n\n.mdi-bee::before {\n  content: \"\\f0fa1\";\n}\n\n.mdi-bee-flower::before {\n  content: \"\\f0fa2\";\n}\n\n.mdi-beehive-off-outline::before {\n  content: \"\\f13ed\";\n}\n\n.mdi-beehive-outline::before {\n  content: \"\\f10ce\";\n}\n\n.mdi-beekeeper::before {\n  content: \"\\f14e2\";\n}\n\n.mdi-beer::before {\n  content: \"\\f0098\";\n}\n\n.mdi-beer-outline::before {\n  content: \"\\f130c\";\n}\n\n.mdi-bell::before {\n  content: \"\\f009a\";\n}\n\n.mdi-bell-alert::before {\n  content: \"\\f0d59\";\n}\n\n.mdi-bell-alert-outline::before {\n  content: \"\\f0e81\";\n}\n\n.mdi-bell-badge::before {\n  content: \"\\f116b\";\n}\n\n.mdi-bell-badge-outline::before {\n  content: \"\\f0178\";\n}\n\n.mdi-bell-cancel::before {\n  content: \"\\f13e7\";\n}\n\n.mdi-bell-cancel-outline::before {\n  content: \"\\f13e8\";\n}\n\n.mdi-bell-check::before {\n  content: \"\\f11e5\";\n}\n\n.mdi-bell-check-outline::before {\n  content: \"\\f11e6\";\n}\n\n.mdi-bell-circle::before {\n  content: \"\\f0d5a\";\n}\n\n.mdi-bell-circle-outline::before {\n  content: \"\\f0d5b\";\n}\n\n.mdi-bell-minus::before {\n  content: \"\\f13e9\";\n}\n\n.mdi-bell-minus-outline::before {\n  content: \"\\f13ea\";\n}\n\n.mdi-bell-off::before {\n  content: \"\\f009b\";\n}\n\n.mdi-bell-off-outline::before {\n  content: \"\\f0a91\";\n}\n\n.mdi-bell-outline::before {\n  content: \"\\f009c\";\n}\n\n.mdi-bell-plus::before {\n  content: \"\\f009d\";\n}\n\n.mdi-bell-plus-outline::before {\n  content: \"\\f0a92\";\n}\n\n.mdi-bell-remove::before {\n  content: \"\\f13eb\";\n}\n\n.mdi-bell-remove-outline::before {\n  content: \"\\f13ec\";\n}\n\n.mdi-bell-ring::before {\n  content: \"\\f009e\";\n}\n\n.mdi-bell-ring-outline::before {\n  content: \"\\f009f\";\n}\n\n.mdi-bell-sleep::before {\n  content: \"\\f00a0\";\n}\n\n.mdi-bell-sleep-outline::before {\n  content: \"\\f0a93\";\n}\n\n.mdi-beta::before {\n  content: \"\\f00a1\";\n}\n\n.mdi-betamax::before {\n  content: \"\\f09cb\";\n}\n\n.mdi-biathlon::before {\n  content: \"\\f0e14\";\n}\n\n.mdi-bicycle::before {\n  content: \"\\f109c\";\n}\n\n.mdi-bicycle-basket::before {\n  content: \"\\f1235\";\n}\n\n.mdi-bicycle-cargo::before {\n  content: \"\\f189c\";\n}\n\n.mdi-bicycle-electric::before {\n  content: \"\\f15b4\";\n}\n\n.mdi-bicycle-penny-farthing::before {\n  content: \"\\f15e9\";\n}\n\n.mdi-bike::before {\n  content: \"\\f00a3\";\n}\n\n.mdi-bike-fast::before {\n  content: \"\\f111f\";\n}\n\n.mdi-billboard::before {\n  content: \"\\f1010\";\n}\n\n.mdi-billiards::before {\n  content: \"\\f0b61\";\n}\n\n.mdi-billiards-rack::before {\n  content: \"\\f0b62\";\n}\n\n.mdi-binoculars::before {\n  content: \"\\f00a5\";\n}\n\n.mdi-bio::before {\n  content: \"\\f00a6\";\n}\n\n.mdi-biohazard::before {\n  content: \"\\f00a7\";\n}\n\n.mdi-bird::before {\n  content: \"\\f15c6\";\n}\n\n.mdi-bitbucket::before {\n  content: \"\\f00a8\";\n}\n\n.mdi-bitcoin::before {\n  content: \"\\f0813\";\n}\n\n.mdi-black-mesa::before {\n  content: \"\\f00a9\";\n}\n\n.mdi-blender::before {\n  content: \"\\f0ceb\";\n}\n\n.mdi-blender-outline::before {\n  content: \"\\f181a\";\n}\n\n.mdi-blender-software::before {\n  content: \"\\f00ab\";\n}\n\n.mdi-blinds::before {\n  content: \"\\f00ac\";\n}\n\n.mdi-blinds-open::before {\n  content: \"\\f1011\";\n}\n\n.mdi-block-helper::before {\n  content: \"\\f00ad\";\n}\n\n.mdi-blood-bag::before {\n  content: \"\\f0cec\";\n}\n\n.mdi-bluetooth::before {\n  content: \"\\f00af\";\n}\n\n.mdi-bluetooth-audio::before {\n  content: \"\\f00b0\";\n}\n\n.mdi-bluetooth-connect::before {\n  content: \"\\f00b1\";\n}\n\n.mdi-bluetooth-off::before {\n  content: \"\\f00b2\";\n}\n\n.mdi-bluetooth-settings::before {\n  content: \"\\f00b3\";\n}\n\n.mdi-bluetooth-transfer::before {\n  content: \"\\f00b4\";\n}\n\n.mdi-blur::before {\n  content: \"\\f00b5\";\n}\n\n.mdi-blur-linear::before {\n  content: \"\\f00b6\";\n}\n\n.mdi-blur-off::before {\n  content: \"\\f00b7\";\n}\n\n.mdi-blur-radial::before {\n  content: \"\\f00b8\";\n}\n\n.mdi-bolt::before {\n  content: \"\\f0db3\";\n}\n\n.mdi-bomb::before {\n  content: \"\\f0691\";\n}\n\n.mdi-bomb-off::before {\n  content: \"\\f06c5\";\n}\n\n.mdi-bone::before {\n  content: \"\\f00b9\";\n}\n\n.mdi-book::before {\n  content: \"\\f00ba\";\n}\n\n.mdi-book-account::before {\n  content: \"\\f13ad\";\n}\n\n.mdi-book-account-outline::before {\n  content: \"\\f13ae\";\n}\n\n.mdi-book-alert::before {\n  content: \"\\f167c\";\n}\n\n.mdi-book-alert-outline::before {\n  content: \"\\f167d\";\n}\n\n.mdi-book-alphabet::before {\n  content: \"\\f061d\";\n}\n\n.mdi-book-arrow-down::before {\n  content: \"\\f167e\";\n}\n\n.mdi-book-arrow-down-outline::before {\n  content: \"\\f167f\";\n}\n\n.mdi-book-arrow-left::before {\n  content: \"\\f1680\";\n}\n\n.mdi-book-arrow-left-outline::before {\n  content: \"\\f1681\";\n}\n\n.mdi-book-arrow-right::before {\n  content: \"\\f1682\";\n}\n\n.mdi-book-arrow-right-outline::before {\n  content: \"\\f1683\";\n}\n\n.mdi-book-arrow-up::before {\n  content: \"\\f1684\";\n}\n\n.mdi-book-arrow-up-outline::before {\n  content: \"\\f1685\";\n}\n\n.mdi-book-cancel::before {\n  content: \"\\f1686\";\n}\n\n.mdi-book-cancel-outline::before {\n  content: \"\\f1687\";\n}\n\n.mdi-book-check::before {\n  content: \"\\f14f3\";\n}\n\n.mdi-book-check-outline::before {\n  content: \"\\f14f4\";\n}\n\n.mdi-book-clock::before {\n  content: \"\\f1688\";\n}\n\n.mdi-book-clock-outline::before {\n  content: \"\\f1689\";\n}\n\n.mdi-book-cog::before {\n  content: \"\\f168a\";\n}\n\n.mdi-book-cog-outline::before {\n  content: \"\\f168b\";\n}\n\n.mdi-book-cross::before {\n  content: \"\\f00a2\";\n}\n\n.mdi-book-edit::before {\n  content: \"\\f168c\";\n}\n\n.mdi-book-edit-outline::before {\n  content: \"\\f168d\";\n}\n\n.mdi-book-education::before {\n  content: \"\\f16c9\";\n}\n\n.mdi-book-education-outline::before {\n  content: \"\\f16ca\";\n}\n\n.mdi-book-information-variant::before {\n  content: \"\\f106f\";\n}\n\n.mdi-book-lock::before {\n  content: \"\\f079a\";\n}\n\n.mdi-book-lock-open::before {\n  content: \"\\f079b\";\n}\n\n.mdi-book-lock-open-outline::before {\n  content: \"\\f168e\";\n}\n\n.mdi-book-lock-outline::before {\n  content: \"\\f168f\";\n}\n\n.mdi-book-marker::before {\n  content: \"\\f1690\";\n}\n\n.mdi-book-marker-outline::before {\n  content: \"\\f1691\";\n}\n\n.mdi-book-minus::before {\n  content: \"\\f05d9\";\n}\n\n.mdi-book-minus-multiple::before {\n  content: \"\\f0a94\";\n}\n\n.mdi-book-minus-multiple-outline::before {\n  content: \"\\f090b\";\n}\n\n.mdi-book-minus-outline::before {\n  content: \"\\f1692\";\n}\n\n.mdi-book-multiple::before {\n  content: \"\\f00bb\";\n}\n\n.mdi-book-multiple-outline::before {\n  content: \"\\f0436\";\n}\n\n.mdi-book-music::before {\n  content: \"\\f0067\";\n}\n\n.mdi-book-music-outline::before {\n  content: \"\\f1693\";\n}\n\n.mdi-book-off::before {\n  content: \"\\f1694\";\n}\n\n.mdi-book-off-outline::before {\n  content: \"\\f1695\";\n}\n\n.mdi-book-open::before {\n  content: \"\\f00bd\";\n}\n\n.mdi-book-open-blank-variant::before {\n  content: \"\\f00be\";\n}\n\n.mdi-book-open-outline::before {\n  content: \"\\f0b63\";\n}\n\n.mdi-book-open-page-variant::before {\n  content: \"\\f05da\";\n}\n\n.mdi-book-open-page-variant-outline::before {\n  content: \"\\f15d6\";\n}\n\n.mdi-book-open-variant::before {\n  content: \"\\f14f7\";\n}\n\n.mdi-book-outline::before {\n  content: \"\\f0b64\";\n}\n\n.mdi-book-play::before {\n  content: \"\\f0e82\";\n}\n\n.mdi-book-play-outline::before {\n  content: \"\\f0e83\";\n}\n\n.mdi-book-plus::before {\n  content: \"\\f05db\";\n}\n\n.mdi-book-plus-multiple::before {\n  content: \"\\f0a95\";\n}\n\n.mdi-book-plus-multiple-outline::before {\n  content: \"\\f0ade\";\n}\n\n.mdi-book-plus-outline::before {\n  content: \"\\f1696\";\n}\n\n.mdi-book-refresh::before {\n  content: \"\\f1697\";\n}\n\n.mdi-book-refresh-outline::before {\n  content: \"\\f1698\";\n}\n\n.mdi-book-remove::before {\n  content: \"\\f0a97\";\n}\n\n.mdi-book-remove-multiple::before {\n  content: \"\\f0a96\";\n}\n\n.mdi-book-remove-multiple-outline::before {\n  content: \"\\f04ca\";\n}\n\n.mdi-book-remove-outline::before {\n  content: \"\\f1699\";\n}\n\n.mdi-book-search::before {\n  content: \"\\f0e84\";\n}\n\n.mdi-book-search-outline::before {\n  content: \"\\f0e85\";\n}\n\n.mdi-book-settings::before {\n  content: \"\\f169a\";\n}\n\n.mdi-book-settings-outline::before {\n  content: \"\\f169b\";\n}\n\n.mdi-book-sync::before {\n  content: \"\\f169c\";\n}\n\n.mdi-book-sync-outline::before {\n  content: \"\\f16c8\";\n}\n\n.mdi-book-variant::before {\n  content: \"\\f00bf\";\n}\n\n.mdi-book-variant-multiple::before {\n  content: \"\\f00bc\";\n}\n\n.mdi-bookmark::before {\n  content: \"\\f00c0\";\n}\n\n.mdi-bookmark-box-multiple::before {\n  content: \"\\f196c\";\n}\n\n.mdi-bookmark-box-multiple-outline::before {\n  content: \"\\f196d\";\n}\n\n.mdi-bookmark-check::before {\n  content: \"\\f00c1\";\n}\n\n.mdi-bookmark-check-outline::before {\n  content: \"\\f137b\";\n}\n\n.mdi-bookmark-minus::before {\n  content: \"\\f09cc\";\n}\n\n.mdi-bookmark-minus-outline::before {\n  content: \"\\f09cd\";\n}\n\n.mdi-bookmark-multiple::before {\n  content: \"\\f0e15\";\n}\n\n.mdi-bookmark-multiple-outline::before {\n  content: \"\\f0e16\";\n}\n\n.mdi-bookmark-music::before {\n  content: \"\\f00c2\";\n}\n\n.mdi-bookmark-music-outline::before {\n  content: \"\\f1379\";\n}\n\n.mdi-bookmark-off::before {\n  content: \"\\f09ce\";\n}\n\n.mdi-bookmark-off-outline::before {\n  content: \"\\f09cf\";\n}\n\n.mdi-bookmark-outline::before {\n  content: \"\\f00c3\";\n}\n\n.mdi-bookmark-plus::before {\n  content: \"\\f00c5\";\n}\n\n.mdi-bookmark-plus-outline::before {\n  content: \"\\f00c4\";\n}\n\n.mdi-bookmark-remove::before {\n  content: \"\\f00c6\";\n}\n\n.mdi-bookmark-remove-outline::before {\n  content: \"\\f137a\";\n}\n\n.mdi-bookshelf::before {\n  content: \"\\f125f\";\n}\n\n.mdi-boom-gate::before {\n  content: \"\\f0e86\";\n}\n\n.mdi-boom-gate-alert::before {\n  content: \"\\f0e87\";\n}\n\n.mdi-boom-gate-alert-outline::before {\n  content: \"\\f0e88\";\n}\n\n.mdi-boom-gate-arrow-down::before {\n  content: \"\\f0e89\";\n}\n\n.mdi-boom-gate-arrow-down-outline::before {\n  content: \"\\f0e8a\";\n}\n\n.mdi-boom-gate-arrow-up::before {\n  content: \"\\f0e8c\";\n}\n\n.mdi-boom-gate-arrow-up-outline::before {\n  content: \"\\f0e8d\";\n}\n\n.mdi-boom-gate-outline::before {\n  content: \"\\f0e8b\";\n}\n\n.mdi-boom-gate-up::before {\n  content: \"\\f17f9\";\n}\n\n.mdi-boom-gate-up-outline::before {\n  content: \"\\f17fa\";\n}\n\n.mdi-boombox::before {\n  content: \"\\f05dc\";\n}\n\n.mdi-boomerang::before {\n  content: \"\\f10cf\";\n}\n\n.mdi-bootstrap::before {\n  content: \"\\f06c6\";\n}\n\n.mdi-border-all::before {\n  content: \"\\f00c7\";\n}\n\n.mdi-border-all-variant::before {\n  content: \"\\f08a1\";\n}\n\n.mdi-border-bottom::before {\n  content: \"\\f00c8\";\n}\n\n.mdi-border-bottom-variant::before {\n  content: \"\\f08a2\";\n}\n\n.mdi-border-color::before {\n  content: \"\\f00c9\";\n}\n\n.mdi-border-horizontal::before {\n  content: \"\\f00ca\";\n}\n\n.mdi-border-inside::before {\n  content: \"\\f00cb\";\n}\n\n.mdi-border-left::before {\n  content: \"\\f00cc\";\n}\n\n.mdi-border-left-variant::before {\n  content: \"\\f08a3\";\n}\n\n.mdi-border-none::before {\n  content: \"\\f00cd\";\n}\n\n.mdi-border-none-variant::before {\n  content: \"\\f08a4\";\n}\n\n.mdi-border-outside::before {\n  content: \"\\f00ce\";\n}\n\n.mdi-border-right::before {\n  content: \"\\f00cf\";\n}\n\n.mdi-border-right-variant::before {\n  content: \"\\f08a5\";\n}\n\n.mdi-border-style::before {\n  content: \"\\f00d0\";\n}\n\n.mdi-border-top::before {\n  content: \"\\f00d1\";\n}\n\n.mdi-border-top-variant::before {\n  content: \"\\f08a6\";\n}\n\n.mdi-border-vertical::before {\n  content: \"\\f00d2\";\n}\n\n.mdi-bottle-soda::before {\n  content: \"\\f1070\";\n}\n\n.mdi-bottle-soda-classic::before {\n  content: \"\\f1071\";\n}\n\n.mdi-bottle-soda-classic-outline::before {\n  content: \"\\f1363\";\n}\n\n.mdi-bottle-soda-outline::before {\n  content: \"\\f1072\";\n}\n\n.mdi-bottle-tonic::before {\n  content: \"\\f112e\";\n}\n\n.mdi-bottle-tonic-outline::before {\n  content: \"\\f112f\";\n}\n\n.mdi-bottle-tonic-plus::before {\n  content: \"\\f1130\";\n}\n\n.mdi-bottle-tonic-plus-outline::before {\n  content: \"\\f1131\";\n}\n\n.mdi-bottle-tonic-skull::before {\n  content: \"\\f1132\";\n}\n\n.mdi-bottle-tonic-skull-outline::before {\n  content: \"\\f1133\";\n}\n\n.mdi-bottle-wine::before {\n  content: \"\\f0854\";\n}\n\n.mdi-bottle-wine-outline::before {\n  content: \"\\f1310\";\n}\n\n.mdi-bow-arrow::before {\n  content: \"\\f1841\";\n}\n\n.mdi-bow-tie::before {\n  content: \"\\f0678\";\n}\n\n.mdi-bowl::before {\n  content: \"\\f028e\";\n}\n\n.mdi-bowl-mix::before {\n  content: \"\\f0617\";\n}\n\n.mdi-bowl-mix-outline::before {\n  content: \"\\f02e4\";\n}\n\n.mdi-bowl-outline::before {\n  content: \"\\f02a9\";\n}\n\n.mdi-bowling::before {\n  content: \"\\f00d3\";\n}\n\n.mdi-box::before {\n  content: \"\\f00d4\";\n}\n\n.mdi-box-cutter::before {\n  content: \"\\f00d5\";\n}\n\n.mdi-box-cutter-off::before {\n  content: \"\\f0b4a\";\n}\n\n.mdi-box-shadow::before {\n  content: \"\\f0637\";\n}\n\n.mdi-boxing-glove::before {\n  content: \"\\f0b65\";\n}\n\n.mdi-braille::before {\n  content: \"\\f09d0\";\n}\n\n.mdi-brain::before {\n  content: \"\\f09d1\";\n}\n\n.mdi-bread-slice::before {\n  content: \"\\f0cee\";\n}\n\n.mdi-bread-slice-outline::before {\n  content: \"\\f0cef\";\n}\n\n.mdi-bridge::before {\n  content: \"\\f0618\";\n}\n\n.mdi-briefcase::before {\n  content: \"\\f00d6\";\n}\n\n.mdi-briefcase-account::before {\n  content: \"\\f0cf0\";\n}\n\n.mdi-briefcase-account-outline::before {\n  content: \"\\f0cf1\";\n}\n\n.mdi-briefcase-check::before {\n  content: \"\\f00d7\";\n}\n\n.mdi-briefcase-check-outline::before {\n  content: \"\\f131e\";\n}\n\n.mdi-briefcase-clock::before {\n  content: \"\\f10d0\";\n}\n\n.mdi-briefcase-clock-outline::before {\n  content: \"\\f10d1\";\n}\n\n.mdi-briefcase-download::before {\n  content: \"\\f00d8\";\n}\n\n.mdi-briefcase-download-outline::before {\n  content: \"\\f0c3d\";\n}\n\n.mdi-briefcase-edit::before {\n  content: \"\\f0a98\";\n}\n\n.mdi-briefcase-edit-outline::before {\n  content: \"\\f0c3e\";\n}\n\n.mdi-briefcase-eye::before {\n  content: \"\\f17d9\";\n}\n\n.mdi-briefcase-eye-outline::before {\n  content: \"\\f17da\";\n}\n\n.mdi-briefcase-minus::before {\n  content: \"\\f0a2a\";\n}\n\n.mdi-briefcase-minus-outline::before {\n  content: \"\\f0c3f\";\n}\n\n.mdi-briefcase-off::before {\n  content: \"\\f1658\";\n}\n\n.mdi-briefcase-off-outline::before {\n  content: \"\\f1659\";\n}\n\n.mdi-briefcase-outline::before {\n  content: \"\\f0814\";\n}\n\n.mdi-briefcase-plus::before {\n  content: \"\\f0a2b\";\n}\n\n.mdi-briefcase-plus-outline::before {\n  content: \"\\f0c40\";\n}\n\n.mdi-briefcase-remove::before {\n  content: \"\\f0a2c\";\n}\n\n.mdi-briefcase-remove-outline::before {\n  content: \"\\f0c41\";\n}\n\n.mdi-briefcase-search::before {\n  content: \"\\f0a2d\";\n}\n\n.mdi-briefcase-search-outline::before {\n  content: \"\\f0c42\";\n}\n\n.mdi-briefcase-upload::before {\n  content: \"\\f00d9\";\n}\n\n.mdi-briefcase-upload-outline::before {\n  content: \"\\f0c43\";\n}\n\n.mdi-briefcase-variant::before {\n  content: \"\\f1494\";\n}\n\n.mdi-briefcase-variant-off::before {\n  content: \"\\f165a\";\n}\n\n.mdi-briefcase-variant-off-outline::before {\n  content: \"\\f165b\";\n}\n\n.mdi-briefcase-variant-outline::before {\n  content: \"\\f1495\";\n}\n\n.mdi-brightness-1::before {\n  content: \"\\f00da\";\n}\n\n.mdi-brightness-2::before {\n  content: \"\\f00db\";\n}\n\n.mdi-brightness-3::before {\n  content: \"\\f00dc\";\n}\n\n.mdi-brightness-4::before {\n  content: \"\\f00dd\";\n}\n\n.mdi-brightness-5::before {\n  content: \"\\f00de\";\n}\n\n.mdi-brightness-6::before {\n  content: \"\\f00df\";\n}\n\n.mdi-brightness-7::before {\n  content: \"\\f00e0\";\n}\n\n.mdi-brightness-auto::before {\n  content: \"\\f00e1\";\n}\n\n.mdi-brightness-percent::before {\n  content: \"\\f0cf2\";\n}\n\n.mdi-broadcast::before {\n  content: \"\\f1720\";\n}\n\n.mdi-broadcast-off::before {\n  content: \"\\f1721\";\n}\n\n.mdi-broom::before {\n  content: \"\\f00e2\";\n}\n\n.mdi-brush::before {\n  content: \"\\f00e3\";\n}\n\n.mdi-brush-off::before {\n  content: \"\\f1771\";\n}\n\n.mdi-brush-variant::before {\n  content: \"\\f1813\";\n}\n\n.mdi-bucket::before {\n  content: \"\\f1415\";\n}\n\n.mdi-bucket-outline::before {\n  content: \"\\f1416\";\n}\n\n.mdi-buffet::before {\n  content: \"\\f0578\";\n}\n\n.mdi-bug::before {\n  content: \"\\f00e4\";\n}\n\n.mdi-bug-check::before {\n  content: \"\\f0a2e\";\n}\n\n.mdi-bug-check-outline::before {\n  content: \"\\f0a2f\";\n}\n\n.mdi-bug-outline::before {\n  content: \"\\f0a30\";\n}\n\n.mdi-bugle::before {\n  content: \"\\f0db4\";\n}\n\n.mdi-bulldozer::before {\n  content: \"\\f0b22\";\n}\n\n.mdi-bullet::before {\n  content: \"\\f0cf3\";\n}\n\n.mdi-bulletin-board::before {\n  content: \"\\f00e5\";\n}\n\n.mdi-bullhorn::before {\n  content: \"\\f00e6\";\n}\n\n.mdi-bullhorn-outline::before {\n  content: \"\\f0b23\";\n}\n\n.mdi-bullhorn-variant::before {\n  content: \"\\f196e\";\n}\n\n.mdi-bullhorn-variant-outline::before {\n  content: \"\\f196f\";\n}\n\n.mdi-bullseye::before {\n  content: \"\\f05dd\";\n}\n\n.mdi-bullseye-arrow::before {\n  content: \"\\f08c9\";\n}\n\n.mdi-bulma::before {\n  content: \"\\f12e7\";\n}\n\n.mdi-bunk-bed::before {\n  content: \"\\f1302\";\n}\n\n.mdi-bunk-bed-outline::before {\n  content: \"\\f0097\";\n}\n\n.mdi-bus::before {\n  content: \"\\f00e7\";\n}\n\n.mdi-bus-alert::before {\n  content: \"\\f0a99\";\n}\n\n.mdi-bus-articulated-end::before {\n  content: \"\\f079c\";\n}\n\n.mdi-bus-articulated-front::before {\n  content: \"\\f079d\";\n}\n\n.mdi-bus-clock::before {\n  content: \"\\f08ca\";\n}\n\n.mdi-bus-double-decker::before {\n  content: \"\\f079e\";\n}\n\n.mdi-bus-electric::before {\n  content: \"\\f191d\";\n}\n\n.mdi-bus-marker::before {\n  content: \"\\f1212\";\n}\n\n.mdi-bus-multiple::before {\n  content: \"\\f0f3f\";\n}\n\n.mdi-bus-school::before {\n  content: \"\\f079f\";\n}\n\n.mdi-bus-side::before {\n  content: \"\\f07a0\";\n}\n\n.mdi-bus-stop::before {\n  content: \"\\f1012\";\n}\n\n.mdi-bus-stop-covered::before {\n  content: \"\\f1013\";\n}\n\n.mdi-bus-stop-uncovered::before {\n  content: \"\\f1014\";\n}\n\n.mdi-butterfly::before {\n  content: \"\\f1589\";\n}\n\n.mdi-butterfly-outline::before {\n  content: \"\\f158a\";\n}\n\n.mdi-cabin-a-frame::before {\n  content: \"\\f188c\";\n}\n\n.mdi-cable-data::before {\n  content: \"\\f1394\";\n}\n\n.mdi-cached::before {\n  content: \"\\f00e8\";\n}\n\n.mdi-cactus::before {\n  content: \"\\f0db5\";\n}\n\n.mdi-cake::before {\n  content: \"\\f00e9\";\n}\n\n.mdi-cake-layered::before {\n  content: \"\\f00ea\";\n}\n\n.mdi-cake-variant::before {\n  content: \"\\f00eb\";\n}\n\n.mdi-cake-variant-outline::before {\n  content: \"\\f17f0\";\n}\n\n.mdi-calculator::before {\n  content: \"\\f00ec\";\n}\n\n.mdi-calculator-variant::before {\n  content: \"\\f0a9a\";\n}\n\n.mdi-calculator-variant-outline::before {\n  content: \"\\f15a6\";\n}\n\n.mdi-calendar::before {\n  content: \"\\f00ed\";\n}\n\n.mdi-calendar-account::before {\n  content: \"\\f0ed7\";\n}\n\n.mdi-calendar-account-outline::before {\n  content: \"\\f0ed8\";\n}\n\n.mdi-calendar-alert::before {\n  content: \"\\f0a31\";\n}\n\n.mdi-calendar-arrow-left::before {\n  content: \"\\f1134\";\n}\n\n.mdi-calendar-arrow-right::before {\n  content: \"\\f1135\";\n}\n\n.mdi-calendar-blank::before {\n  content: \"\\f00ee\";\n}\n\n.mdi-calendar-blank-multiple::before {\n  content: \"\\f1073\";\n}\n\n.mdi-calendar-blank-outline::before {\n  content: \"\\f0b66\";\n}\n\n.mdi-calendar-check::before {\n  content: \"\\f00ef\";\n}\n\n.mdi-calendar-check-outline::before {\n  content: \"\\f0c44\";\n}\n\n.mdi-calendar-clock::before {\n  content: \"\\f00f0\";\n}\n\n.mdi-calendar-clock-outline::before {\n  content: \"\\f16e1\";\n}\n\n.mdi-calendar-collapse-horizontal::before {\n  content: \"\\f189d\";\n}\n\n.mdi-calendar-cursor::before {\n  content: \"\\f157b\";\n}\n\n.mdi-calendar-edit::before {\n  content: \"\\f08a7\";\n}\n\n.mdi-calendar-end::before {\n  content: \"\\f166c\";\n}\n\n.mdi-calendar-expand-horizontal::before {\n  content: \"\\f189e\";\n}\n\n.mdi-calendar-export::before {\n  content: \"\\f0b24\";\n}\n\n.mdi-calendar-heart::before {\n  content: \"\\f09d2\";\n}\n\n.mdi-calendar-import::before {\n  content: \"\\f0b25\";\n}\n\n.mdi-calendar-lock::before {\n  content: \"\\f1641\";\n}\n\n.mdi-calendar-lock-outline::before {\n  content: \"\\f1642\";\n}\n\n.mdi-calendar-minus::before {\n  content: \"\\f0d5c\";\n}\n\n.mdi-calendar-month::before {\n  content: \"\\f0e17\";\n}\n\n.mdi-calendar-month-outline::before {\n  content: \"\\f0e18\";\n}\n\n.mdi-calendar-multiple::before {\n  content: \"\\f00f1\";\n}\n\n.mdi-calendar-multiple-check::before {\n  content: \"\\f00f2\";\n}\n\n.mdi-calendar-multiselect::before {\n  content: \"\\f0a32\";\n}\n\n.mdi-calendar-outline::before {\n  content: \"\\f0b67\";\n}\n\n.mdi-calendar-plus::before {\n  content: \"\\f00f3\";\n}\n\n.mdi-calendar-question::before {\n  content: \"\\f0692\";\n}\n\n.mdi-calendar-range::before {\n  content: \"\\f0679\";\n}\n\n.mdi-calendar-range-outline::before {\n  content: \"\\f0b68\";\n}\n\n.mdi-calendar-refresh::before {\n  content: \"\\f01e1\";\n}\n\n.mdi-calendar-refresh-outline::before {\n  content: \"\\f0203\";\n}\n\n.mdi-calendar-remove::before {\n  content: \"\\f00f4\";\n}\n\n.mdi-calendar-remove-outline::before {\n  content: \"\\f0c45\";\n}\n\n.mdi-calendar-search::before {\n  content: \"\\f094c\";\n}\n\n.mdi-calendar-star::before {\n  content: \"\\f09d3\";\n}\n\n.mdi-calendar-start::before {\n  content: \"\\f166d\";\n}\n\n.mdi-calendar-sync::before {\n  content: \"\\f0e8e\";\n}\n\n.mdi-calendar-sync-outline::before {\n  content: \"\\f0e8f\";\n}\n\n.mdi-calendar-text::before {\n  content: \"\\f00f5\";\n}\n\n.mdi-calendar-text-outline::before {\n  content: \"\\f0c46\";\n}\n\n.mdi-calendar-today::before {\n  content: \"\\f00f6\";\n}\n\n.mdi-calendar-week::before {\n  content: \"\\f0a33\";\n}\n\n.mdi-calendar-week-begin::before {\n  content: \"\\f0a34\";\n}\n\n.mdi-calendar-weekend::before {\n  content: \"\\f0ed9\";\n}\n\n.mdi-calendar-weekend-outline::before {\n  content: \"\\f0eda\";\n}\n\n.mdi-call-made::before {\n  content: \"\\f00f7\";\n}\n\n.mdi-call-merge::before {\n  content: \"\\f00f8\";\n}\n\n.mdi-call-missed::before {\n  content: \"\\f00f9\";\n}\n\n.mdi-call-received::before {\n  content: \"\\f00fa\";\n}\n\n.mdi-call-split::before {\n  content: \"\\f00fb\";\n}\n\n.mdi-camcorder::before {\n  content: \"\\f00fc\";\n}\n\n.mdi-camcorder-off::before {\n  content: \"\\f00ff\";\n}\n\n.mdi-camera::before {\n  content: \"\\f0100\";\n}\n\n.mdi-camera-account::before {\n  content: \"\\f08cb\";\n}\n\n.mdi-camera-burst::before {\n  content: \"\\f0693\";\n}\n\n.mdi-camera-control::before {\n  content: \"\\f0b69\";\n}\n\n.mdi-camera-document::before {\n  content: \"\\f1871\";\n}\n\n.mdi-camera-document-off::before {\n  content: \"\\f1872\";\n}\n\n.mdi-camera-enhance::before {\n  content: \"\\f0101\";\n}\n\n.mdi-camera-enhance-outline::before {\n  content: \"\\f0b6a\";\n}\n\n.mdi-camera-flip::before {\n  content: \"\\f15d9\";\n}\n\n.mdi-camera-flip-outline::before {\n  content: \"\\f15da\";\n}\n\n.mdi-camera-front::before {\n  content: \"\\f0102\";\n}\n\n.mdi-camera-front-variant::before {\n  content: \"\\f0103\";\n}\n\n.mdi-camera-gopro::before {\n  content: \"\\f07a1\";\n}\n\n.mdi-camera-image::before {\n  content: \"\\f08cc\";\n}\n\n.mdi-camera-iris::before {\n  content: \"\\f0104\";\n}\n\n.mdi-camera-marker::before {\n  content: \"\\f19a7\";\n}\n\n.mdi-camera-marker-outline::before {\n  content: \"\\f19a8\";\n}\n\n.mdi-camera-metering-center::before {\n  content: \"\\f07a2\";\n}\n\n.mdi-camera-metering-matrix::before {\n  content: \"\\f07a3\";\n}\n\n.mdi-camera-metering-partial::before {\n  content: \"\\f07a4\";\n}\n\n.mdi-camera-metering-spot::before {\n  content: \"\\f07a5\";\n}\n\n.mdi-camera-off::before {\n  content: \"\\f05df\";\n}\n\n.mdi-camera-off-outline::before {\n  content: \"\\f19bf\";\n}\n\n.mdi-camera-outline::before {\n  content: \"\\f0d5d\";\n}\n\n.mdi-camera-party-mode::before {\n  content: \"\\f0105\";\n}\n\n.mdi-camera-plus::before {\n  content: \"\\f0edb\";\n}\n\n.mdi-camera-plus-outline::before {\n  content: \"\\f0edc\";\n}\n\n.mdi-camera-rear::before {\n  content: \"\\f0106\";\n}\n\n.mdi-camera-rear-variant::before {\n  content: \"\\f0107\";\n}\n\n.mdi-camera-retake::before {\n  content: \"\\f0e19\";\n}\n\n.mdi-camera-retake-outline::before {\n  content: \"\\f0e1a\";\n}\n\n.mdi-camera-switch::before {\n  content: \"\\f0108\";\n}\n\n.mdi-camera-switch-outline::before {\n  content: \"\\f084a\";\n}\n\n.mdi-camera-timer::before {\n  content: \"\\f0109\";\n}\n\n.mdi-camera-wireless::before {\n  content: \"\\f0db6\";\n}\n\n.mdi-camera-wireless-outline::before {\n  content: \"\\f0db7\";\n}\n\n.mdi-campfire::before {\n  content: \"\\f0edd\";\n}\n\n.mdi-cancel::before {\n  content: \"\\f073a\";\n}\n\n.mdi-candelabra::before {\n  content: \"\\f17d2\";\n}\n\n.mdi-candelabra-fire::before {\n  content: \"\\f17d3\";\n}\n\n.mdi-candle::before {\n  content: \"\\f05e2\";\n}\n\n.mdi-candy::before {\n  content: \"\\f1970\";\n}\n\n.mdi-candy-off::before {\n  content: \"\\f1971\";\n}\n\n.mdi-candy-off-outline::before {\n  content: \"\\f1972\";\n}\n\n.mdi-candy-outline::before {\n  content: \"\\f1973\";\n}\n\n.mdi-candycane::before {\n  content: \"\\f010a\";\n}\n\n.mdi-cannabis::before {\n  content: \"\\f07a6\";\n}\n\n.mdi-cannabis-off::before {\n  content: \"\\f166e\";\n}\n\n.mdi-caps-lock::before {\n  content: \"\\f0a9b\";\n}\n\n.mdi-car::before {\n  content: \"\\f010b\";\n}\n\n.mdi-car-2-plus::before {\n  content: \"\\f1015\";\n}\n\n.mdi-car-3-plus::before {\n  content: \"\\f1016\";\n}\n\n.mdi-car-arrow-left::before {\n  content: \"\\f13b2\";\n}\n\n.mdi-car-arrow-right::before {\n  content: \"\\f13b3\";\n}\n\n.mdi-car-back::before {\n  content: \"\\f0e1b\";\n}\n\n.mdi-car-battery::before {\n  content: \"\\f010c\";\n}\n\n.mdi-car-brake-abs::before {\n  content: \"\\f0c47\";\n}\n\n.mdi-car-brake-alert::before {\n  content: \"\\f0c48\";\n}\n\n.mdi-car-brake-fluid-level::before {\n  content: \"\\f1909\";\n}\n\n.mdi-car-brake-hold::before {\n  content: \"\\f0d5e\";\n}\n\n.mdi-car-brake-low-pressure::before {\n  content: \"\\f190a\";\n}\n\n.mdi-car-brake-parking::before {\n  content: \"\\f0d5f\";\n}\n\n.mdi-car-brake-retarder::before {\n  content: \"\\f1017\";\n}\n\n.mdi-car-brake-temperature::before {\n  content: \"\\f190b\";\n}\n\n.mdi-car-brake-worn-linings::before {\n  content: \"\\f190c\";\n}\n\n.mdi-car-child-seat::before {\n  content: \"\\f0fa3\";\n}\n\n.mdi-car-clock::before {\n  content: \"\\f1974\";\n}\n\n.mdi-car-clutch::before {\n  content: \"\\f1018\";\n}\n\n.mdi-car-cog::before {\n  content: \"\\f13cc\";\n}\n\n.mdi-car-connected::before {\n  content: \"\\f010d\";\n}\n\n.mdi-car-convertible::before {\n  content: \"\\f07a7\";\n}\n\n.mdi-car-coolant-level::before {\n  content: \"\\f1019\";\n}\n\n.mdi-car-cruise-control::before {\n  content: \"\\f0d60\";\n}\n\n.mdi-car-defrost-front::before {\n  content: \"\\f0d61\";\n}\n\n.mdi-car-defrost-rear::before {\n  content: \"\\f0d62\";\n}\n\n.mdi-car-door::before {\n  content: \"\\f0b6b\";\n}\n\n.mdi-car-door-lock::before {\n  content: \"\\f109d\";\n}\n\n.mdi-car-electric::before {\n  content: \"\\f0b6c\";\n}\n\n.mdi-car-electric-outline::before {\n  content: \"\\f15b5\";\n}\n\n.mdi-car-emergency::before {\n  content: \"\\f160f\";\n}\n\n.mdi-car-esp::before {\n  content: \"\\f0c49\";\n}\n\n.mdi-car-estate::before {\n  content: \"\\f07a8\";\n}\n\n.mdi-car-hatchback::before {\n  content: \"\\f07a9\";\n}\n\n.mdi-car-info::before {\n  content: \"\\f11be\";\n}\n\n.mdi-car-key::before {\n  content: \"\\f0b6d\";\n}\n\n.mdi-car-lifted-pickup::before {\n  content: \"\\f152d\";\n}\n\n.mdi-car-light-alert::before {\n  content: \"\\f190d\";\n}\n\n.mdi-car-light-dimmed::before {\n  content: \"\\f0c4a\";\n}\n\n.mdi-car-light-fog::before {\n  content: \"\\f0c4b\";\n}\n\n.mdi-car-light-high::before {\n  content: \"\\f0c4c\";\n}\n\n.mdi-car-limousine::before {\n  content: \"\\f08cd\";\n}\n\n.mdi-car-multiple::before {\n  content: \"\\f0b6e\";\n}\n\n.mdi-car-off::before {\n  content: \"\\f0e1c\";\n}\n\n.mdi-car-outline::before {\n  content: \"\\f14ed\";\n}\n\n.mdi-car-parking-lights::before {\n  content: \"\\f0d63\";\n}\n\n.mdi-car-pickup::before {\n  content: \"\\f07aa\";\n}\n\n.mdi-car-seat::before {\n  content: \"\\f0fa4\";\n}\n\n.mdi-car-seat-cooler::before {\n  content: \"\\f0fa5\";\n}\n\n.mdi-car-seat-heater::before {\n  content: \"\\f0fa6\";\n}\n\n.mdi-car-select::before {\n  content: \"\\f1879\";\n}\n\n.mdi-car-settings::before {\n  content: \"\\f13cd\";\n}\n\n.mdi-car-shift-pattern::before {\n  content: \"\\f0f40\";\n}\n\n.mdi-car-side::before {\n  content: \"\\f07ab\";\n}\n\n.mdi-car-speed-limiter::before {\n  content: \"\\f190e\";\n}\n\n.mdi-car-sports::before {\n  content: \"\\f07ac\";\n}\n\n.mdi-car-tire-alert::before {\n  content: \"\\f0c4d\";\n}\n\n.mdi-car-traction-control::before {\n  content: \"\\f0d64\";\n}\n\n.mdi-car-turbocharger::before {\n  content: \"\\f101a\";\n}\n\n.mdi-car-wash::before {\n  content: \"\\f010e\";\n}\n\n.mdi-car-windshield::before {\n  content: \"\\f101b\";\n}\n\n.mdi-car-windshield-outline::before {\n  content: \"\\f101c\";\n}\n\n.mdi-car-wireless::before {\n  content: \"\\f1878\";\n}\n\n.mdi-car-wrench::before {\n  content: \"\\f1814\";\n}\n\n.mdi-carabiner::before {\n  content: \"\\f14c0\";\n}\n\n.mdi-caravan::before {\n  content: \"\\f07ad\";\n}\n\n.mdi-card::before {\n  content: \"\\f0b6f\";\n}\n\n.mdi-card-account-details::before {\n  content: \"\\f05d2\";\n}\n\n.mdi-card-account-details-outline::before {\n  content: \"\\f0dab\";\n}\n\n.mdi-card-account-details-star::before {\n  content: \"\\f02a3\";\n}\n\n.mdi-card-account-details-star-outline::before {\n  content: \"\\f06db\";\n}\n\n.mdi-card-account-mail::before {\n  content: \"\\f018e\";\n}\n\n.mdi-card-account-mail-outline::before {\n  content: \"\\f0e98\";\n}\n\n.mdi-card-account-phone::before {\n  content: \"\\f0e99\";\n}\n\n.mdi-card-account-phone-outline::before {\n  content: \"\\f0e9a\";\n}\n\n.mdi-card-bulleted::before {\n  content: \"\\f0b70\";\n}\n\n.mdi-card-bulleted-off::before {\n  content: \"\\f0b71\";\n}\n\n.mdi-card-bulleted-off-outline::before {\n  content: \"\\f0b72\";\n}\n\n.mdi-card-bulleted-outline::before {\n  content: \"\\f0b73\";\n}\n\n.mdi-card-bulleted-settings::before {\n  content: \"\\f0b74\";\n}\n\n.mdi-card-bulleted-settings-outline::before {\n  content: \"\\f0b75\";\n}\n\n.mdi-card-minus::before {\n  content: \"\\f1600\";\n}\n\n.mdi-card-minus-outline::before {\n  content: \"\\f1601\";\n}\n\n.mdi-card-multiple::before {\n  content: \"\\f17f1\";\n}\n\n.mdi-card-multiple-outline::before {\n  content: \"\\f17f2\";\n}\n\n.mdi-card-off::before {\n  content: \"\\f1602\";\n}\n\n.mdi-card-off-outline::before {\n  content: \"\\f1603\";\n}\n\n.mdi-card-outline::before {\n  content: \"\\f0b76\";\n}\n\n.mdi-card-plus::before {\n  content: \"\\f11ff\";\n}\n\n.mdi-card-plus-outline::before {\n  content: \"\\f1200\";\n}\n\n.mdi-card-remove::before {\n  content: \"\\f1604\";\n}\n\n.mdi-card-remove-outline::before {\n  content: \"\\f1605\";\n}\n\n.mdi-card-search::before {\n  content: \"\\f1074\";\n}\n\n.mdi-card-search-outline::before {\n  content: \"\\f1075\";\n}\n\n.mdi-card-text::before {\n  content: \"\\f0b77\";\n}\n\n.mdi-card-text-outline::before {\n  content: \"\\f0b78\";\n}\n\n.mdi-cards::before {\n  content: \"\\f0638\";\n}\n\n.mdi-cards-club::before {\n  content: \"\\f08ce\";\n}\n\n.mdi-cards-club-outline::before {\n  content: \"\\f189f\";\n}\n\n.mdi-cards-diamond::before {\n  content: \"\\f08cf\";\n}\n\n.mdi-cards-diamond-outline::before {\n  content: \"\\f101d\";\n}\n\n.mdi-cards-heart::before {\n  content: \"\\f08d0\";\n}\n\n.mdi-cards-heart-outline::before {\n  content: \"\\f18a0\";\n}\n\n.mdi-cards-outline::before {\n  content: \"\\f0639\";\n}\n\n.mdi-cards-playing::before {\n  content: \"\\f18a1\";\n}\n\n.mdi-cards-playing-club::before {\n  content: \"\\f18a2\";\n}\n\n.mdi-cards-playing-club-multiple::before {\n  content: \"\\f18a3\";\n}\n\n.mdi-cards-playing-club-multiple-outline::before {\n  content: \"\\f18a4\";\n}\n\n.mdi-cards-playing-club-outline::before {\n  content: \"\\f18a5\";\n}\n\n.mdi-cards-playing-diamond::before {\n  content: \"\\f18a6\";\n}\n\n.mdi-cards-playing-diamond-multiple::before {\n  content: \"\\f18a7\";\n}\n\n.mdi-cards-playing-diamond-multiple-outline::before {\n  content: \"\\f18a8\";\n}\n\n.mdi-cards-playing-diamond-outline::before {\n  content: \"\\f18a9\";\n}\n\n.mdi-cards-playing-heart::before {\n  content: \"\\f18aa\";\n}\n\n.mdi-cards-playing-heart-multiple::before {\n  content: \"\\f18ab\";\n}\n\n.mdi-cards-playing-heart-multiple-outline::before {\n  content: \"\\f18ac\";\n}\n\n.mdi-cards-playing-heart-outline::before {\n  content: \"\\f18ad\";\n}\n\n.mdi-cards-playing-outline::before {\n  content: \"\\f063a\";\n}\n\n.mdi-cards-playing-spade::before {\n  content: \"\\f18ae\";\n}\n\n.mdi-cards-playing-spade-multiple::before {\n  content: \"\\f18af\";\n}\n\n.mdi-cards-playing-spade-multiple-outline::before {\n  content: \"\\f18b0\";\n}\n\n.mdi-cards-playing-spade-outline::before {\n  content: \"\\f18b1\";\n}\n\n.mdi-cards-spade::before {\n  content: \"\\f08d1\";\n}\n\n.mdi-cards-spade-outline::before {\n  content: \"\\f18b2\";\n}\n\n.mdi-cards-variant::before {\n  content: \"\\f06c7\";\n}\n\n.mdi-carrot::before {\n  content: \"\\f010f\";\n}\n\n.mdi-cart::before {\n  content: \"\\f0110\";\n}\n\n.mdi-cart-arrow-down::before {\n  content: \"\\f0d66\";\n}\n\n.mdi-cart-arrow-right::before {\n  content: \"\\f0c4e\";\n}\n\n.mdi-cart-arrow-up::before {\n  content: \"\\f0d67\";\n}\n\n.mdi-cart-check::before {\n  content: \"\\f15ea\";\n}\n\n.mdi-cart-heart::before {\n  content: \"\\f18e0\";\n}\n\n.mdi-cart-minus::before {\n  content: \"\\f0d68\";\n}\n\n.mdi-cart-off::before {\n  content: \"\\f066b\";\n}\n\n.mdi-cart-outline::before {\n  content: \"\\f0111\";\n}\n\n.mdi-cart-plus::before {\n  content: \"\\f0112\";\n}\n\n.mdi-cart-remove::before {\n  content: \"\\f0d69\";\n}\n\n.mdi-cart-variant::before {\n  content: \"\\f15eb\";\n}\n\n.mdi-case-sensitive-alt::before {\n  content: \"\\f0113\";\n}\n\n.mdi-cash::before {\n  content: \"\\f0114\";\n}\n\n.mdi-cash-100::before {\n  content: \"\\f0115\";\n}\n\n.mdi-cash-check::before {\n  content: \"\\f14ee\";\n}\n\n.mdi-cash-fast::before {\n  content: \"\\f185c\";\n}\n\n.mdi-cash-lock::before {\n  content: \"\\f14ea\";\n}\n\n.mdi-cash-lock-open::before {\n  content: \"\\f14eb\";\n}\n\n.mdi-cash-marker::before {\n  content: \"\\f0db8\";\n}\n\n.mdi-cash-minus::before {\n  content: \"\\f1260\";\n}\n\n.mdi-cash-multiple::before {\n  content: \"\\f0116\";\n}\n\n.mdi-cash-plus::before {\n  content: \"\\f1261\";\n}\n\n.mdi-cash-refund::before {\n  content: \"\\f0a9c\";\n}\n\n.mdi-cash-register::before {\n  content: \"\\f0cf4\";\n}\n\n.mdi-cash-remove::before {\n  content: \"\\f1262\";\n}\n\n.mdi-cassette::before {\n  content: \"\\f09d4\";\n}\n\n.mdi-cast::before {\n  content: \"\\f0118\";\n}\n\n.mdi-cast-audio::before {\n  content: \"\\f101e\";\n}\n\n.mdi-cast-audio-variant::before {\n  content: \"\\f1749\";\n}\n\n.mdi-cast-connected::before {\n  content: \"\\f0119\";\n}\n\n.mdi-cast-education::before {\n  content: \"\\f0e1d\";\n}\n\n.mdi-cast-off::before {\n  content: \"\\f078a\";\n}\n\n.mdi-cast-variant::before {\n  content: \"\\f001f\";\n}\n\n.mdi-castle::before {\n  content: \"\\f011a\";\n}\n\n.mdi-cat::before {\n  content: \"\\f011b\";\n}\n\n.mdi-cctv::before {\n  content: \"\\f07ae\";\n}\n\n.mdi-cctv-off::before {\n  content: \"\\f185f\";\n}\n\n.mdi-ceiling-fan::before {\n  content: \"\\f1797\";\n}\n\n.mdi-ceiling-fan-light::before {\n  content: \"\\f1798\";\n}\n\n.mdi-ceiling-light::before {\n  content: \"\\f0769\";\n}\n\n.mdi-ceiling-light-multiple::before {\n  content: \"\\f18dd\";\n}\n\n.mdi-ceiling-light-multiple-outline::before {\n  content: \"\\f18de\";\n}\n\n.mdi-ceiling-light-outline::before {\n  content: \"\\f17c7\";\n}\n\n.mdi-cellphone::before {\n  content: \"\\f011c\";\n}\n\n.mdi-cellphone-arrow-down::before {\n  content: \"\\f09d5\";\n}\n\n.mdi-cellphone-basic::before {\n  content: \"\\f011e\";\n}\n\n.mdi-cellphone-charging::before {\n  content: \"\\f1397\";\n}\n\n.mdi-cellphone-check::before {\n  content: \"\\f17fd\";\n}\n\n.mdi-cellphone-cog::before {\n  content: \"\\f0951\";\n}\n\n.mdi-cellphone-dock::before {\n  content: \"\\f011f\";\n}\n\n.mdi-cellphone-information::before {\n  content: \"\\f0f41\";\n}\n\n.mdi-cellphone-key::before {\n  content: \"\\f094e\";\n}\n\n.mdi-cellphone-link::before {\n  content: \"\\f0121\";\n}\n\n.mdi-cellphone-link-off::before {\n  content: \"\\f0122\";\n}\n\n.mdi-cellphone-lock::before {\n  content: \"\\f094f\";\n}\n\n.mdi-cellphone-marker::before {\n  content: \"\\f183a\";\n}\n\n.mdi-cellphone-message::before {\n  content: \"\\f08d3\";\n}\n\n.mdi-cellphone-message-off::before {\n  content: \"\\f10d2\";\n}\n\n.mdi-cellphone-nfc::before {\n  content: \"\\f0e90\";\n}\n\n.mdi-cellphone-nfc-off::before {\n  content: \"\\f12d8\";\n}\n\n.mdi-cellphone-off::before {\n  content: \"\\f0950\";\n}\n\n.mdi-cellphone-play::before {\n  content: \"\\f101f\";\n}\n\n.mdi-cellphone-remove::before {\n  content: \"\\f094d\";\n}\n\n.mdi-cellphone-screenshot::before {\n  content: \"\\f0a35\";\n}\n\n.mdi-cellphone-settings::before {\n  content: \"\\f0123\";\n}\n\n.mdi-cellphone-sound::before {\n  content: \"\\f0952\";\n}\n\n.mdi-cellphone-text::before {\n  content: \"\\f08d2\";\n}\n\n.mdi-cellphone-wireless::before {\n  content: \"\\f0815\";\n}\n\n.mdi-centos::before {\n  content: \"\\f111a\";\n}\n\n.mdi-certificate::before {\n  content: \"\\f0124\";\n}\n\n.mdi-certificate-outline::before {\n  content: \"\\f1188\";\n}\n\n.mdi-chair-rolling::before {\n  content: \"\\f0f48\";\n}\n\n.mdi-chair-school::before {\n  content: \"\\f0125\";\n}\n\n.mdi-chandelier::before {\n  content: \"\\f1793\";\n}\n\n.mdi-charity::before {\n  content: \"\\f0c4f\";\n}\n\n.mdi-chart-arc::before {\n  content: \"\\f0126\";\n}\n\n.mdi-chart-areaspline::before {\n  content: \"\\f0127\";\n}\n\n.mdi-chart-areaspline-variant::before {\n  content: \"\\f0e91\";\n}\n\n.mdi-chart-bar::before {\n  content: \"\\f0128\";\n}\n\n.mdi-chart-bar-stacked::before {\n  content: \"\\f076a\";\n}\n\n.mdi-chart-bell-curve::before {\n  content: \"\\f0c50\";\n}\n\n.mdi-chart-bell-curve-cumulative::before {\n  content: \"\\f0fa7\";\n}\n\n.mdi-chart-box::before {\n  content: \"\\f154d\";\n}\n\n.mdi-chart-box-outline::before {\n  content: \"\\f154e\";\n}\n\n.mdi-chart-box-plus-outline::before {\n  content: \"\\f154f\";\n}\n\n.mdi-chart-bubble::before {\n  content: \"\\f05e3\";\n}\n\n.mdi-chart-donut::before {\n  content: \"\\f07af\";\n}\n\n.mdi-chart-donut-variant::before {\n  content: \"\\f07b0\";\n}\n\n.mdi-chart-gantt::before {\n  content: \"\\f066c\";\n}\n\n.mdi-chart-histogram::before {\n  content: \"\\f0129\";\n}\n\n.mdi-chart-line::before {\n  content: \"\\f012a\";\n}\n\n.mdi-chart-line-stacked::before {\n  content: \"\\f076b\";\n}\n\n.mdi-chart-line-variant::before {\n  content: \"\\f07b1\";\n}\n\n.mdi-chart-multiline::before {\n  content: \"\\f08d4\";\n}\n\n.mdi-chart-multiple::before {\n  content: \"\\f1213\";\n}\n\n.mdi-chart-pie::before {\n  content: \"\\f012b\";\n}\n\n.mdi-chart-ppf::before {\n  content: \"\\f1380\";\n}\n\n.mdi-chart-sankey::before {\n  content: \"\\f11df\";\n}\n\n.mdi-chart-sankey-variant::before {\n  content: \"\\f11e0\";\n}\n\n.mdi-chart-scatter-plot::before {\n  content: \"\\f0e92\";\n}\n\n.mdi-chart-scatter-plot-hexbin::before {\n  content: \"\\f066d\";\n}\n\n.mdi-chart-timeline::before {\n  content: \"\\f066e\";\n}\n\n.mdi-chart-timeline-variant::before {\n  content: \"\\f0e93\";\n}\n\n.mdi-chart-timeline-variant-shimmer::before {\n  content: \"\\f15b6\";\n}\n\n.mdi-chart-tree::before {\n  content: \"\\f0e94\";\n}\n\n.mdi-chart-waterfall::before {\n  content: \"\\f1918\";\n}\n\n.mdi-chat::before {\n  content: \"\\f0b79\";\n}\n\n.mdi-chat-alert::before {\n  content: \"\\f0b7a\";\n}\n\n.mdi-chat-alert-outline::before {\n  content: \"\\f12c9\";\n}\n\n.mdi-chat-minus::before {\n  content: \"\\f1410\";\n}\n\n.mdi-chat-minus-outline::before {\n  content: \"\\f1413\";\n}\n\n.mdi-chat-outline::before {\n  content: \"\\f0ede\";\n}\n\n.mdi-chat-plus::before {\n  content: \"\\f140f\";\n}\n\n.mdi-chat-plus-outline::before {\n  content: \"\\f1412\";\n}\n\n.mdi-chat-processing::before {\n  content: \"\\f0b7b\";\n}\n\n.mdi-chat-processing-outline::before {\n  content: \"\\f12ca\";\n}\n\n.mdi-chat-question::before {\n  content: \"\\f1738\";\n}\n\n.mdi-chat-question-outline::before {\n  content: \"\\f1739\";\n}\n\n.mdi-chat-remove::before {\n  content: \"\\f1411\";\n}\n\n.mdi-chat-remove-outline::before {\n  content: \"\\f1414\";\n}\n\n.mdi-chat-sleep::before {\n  content: \"\\f12d1\";\n}\n\n.mdi-chat-sleep-outline::before {\n  content: \"\\f12d2\";\n}\n\n.mdi-check::before {\n  content: \"\\f012c\";\n}\n\n.mdi-check-all::before {\n  content: \"\\f012d\";\n}\n\n.mdi-check-bold::before {\n  content: \"\\f0e1e\";\n}\n\n.mdi-check-circle::before {\n  content: \"\\f05e0\";\n}\n\n.mdi-check-circle-outline::before {\n  content: \"\\f05e1\";\n}\n\n.mdi-check-decagram::before {\n  content: \"\\f0791\";\n}\n\n.mdi-check-decagram-outline::before {\n  content: \"\\f1740\";\n}\n\n.mdi-check-network::before {\n  content: \"\\f0c53\";\n}\n\n.mdi-check-network-outline::before {\n  content: \"\\f0c54\";\n}\n\n.mdi-check-outline::before {\n  content: \"\\f0855\";\n}\n\n.mdi-check-underline::before {\n  content: \"\\f0e1f\";\n}\n\n.mdi-check-underline-circle::before {\n  content: \"\\f0e20\";\n}\n\n.mdi-check-underline-circle-outline::before {\n  content: \"\\f0e21\";\n}\n\n.mdi-checkbook::before {\n  content: \"\\f0a9d\";\n}\n\n.mdi-checkbox-blank::before {\n  content: \"\\f012e\";\n}\n\n.mdi-checkbox-blank-badge::before {\n  content: \"\\f1176\";\n}\n\n.mdi-checkbox-blank-badge-outline::before {\n  content: \"\\f0117\";\n}\n\n.mdi-checkbox-blank-circle::before {\n  content: \"\\f012f\";\n}\n\n.mdi-checkbox-blank-circle-outline::before {\n  content: \"\\f0130\";\n}\n\n.mdi-checkbox-blank-off::before {\n  content: \"\\f12ec\";\n}\n\n.mdi-checkbox-blank-off-outline::before {\n  content: \"\\f12ed\";\n}\n\n.mdi-checkbox-blank-outline::before {\n  content: \"\\f0131\";\n}\n\n.mdi-checkbox-intermediate::before {\n  content: \"\\f0856\";\n}\n\n.mdi-checkbox-marked::before {\n  content: \"\\f0132\";\n}\n\n.mdi-checkbox-marked-circle::before {\n  content: \"\\f0133\";\n}\n\n.mdi-checkbox-marked-circle-outline::before {\n  content: \"\\f0134\";\n}\n\n.mdi-checkbox-marked-circle-plus-outline::before {\n  content: \"\\f1927\";\n}\n\n.mdi-checkbox-marked-outline::before {\n  content: \"\\f0135\";\n}\n\n.mdi-checkbox-multiple-blank::before {\n  content: \"\\f0136\";\n}\n\n.mdi-checkbox-multiple-blank-circle::before {\n  content: \"\\f063b\";\n}\n\n.mdi-checkbox-multiple-blank-circle-outline::before {\n  content: \"\\f063c\";\n}\n\n.mdi-checkbox-multiple-blank-outline::before {\n  content: \"\\f0137\";\n}\n\n.mdi-checkbox-multiple-marked::before {\n  content: \"\\f0138\";\n}\n\n.mdi-checkbox-multiple-marked-circle::before {\n  content: \"\\f063d\";\n}\n\n.mdi-checkbox-multiple-marked-circle-outline::before {\n  content: \"\\f063e\";\n}\n\n.mdi-checkbox-multiple-marked-outline::before {\n  content: \"\\f0139\";\n}\n\n.mdi-checkbox-multiple-outline::before {\n  content: \"\\f0c51\";\n}\n\n.mdi-checkbox-outline::before {\n  content: \"\\f0c52\";\n}\n\n.mdi-checkerboard::before {\n  content: \"\\f013a\";\n}\n\n.mdi-checkerboard-minus::before {\n  content: \"\\f1202\";\n}\n\n.mdi-checkerboard-plus::before {\n  content: \"\\f1201\";\n}\n\n.mdi-checkerboard-remove::before {\n  content: \"\\f1203\";\n}\n\n.mdi-cheese::before {\n  content: \"\\f12b9\";\n}\n\n.mdi-cheese-off::before {\n  content: \"\\f13ee\";\n}\n\n.mdi-chef-hat::before {\n  content: \"\\f0b7c\";\n}\n\n.mdi-chemical-weapon::before {\n  content: \"\\f013b\";\n}\n\n.mdi-chess-bishop::before {\n  content: \"\\f085c\";\n}\n\n.mdi-chess-king::before {\n  content: \"\\f0857\";\n}\n\n.mdi-chess-knight::before {\n  content: \"\\f0858\";\n}\n\n.mdi-chess-pawn::before {\n  content: \"\\f0859\";\n}\n\n.mdi-chess-queen::before {\n  content: \"\\f085a\";\n}\n\n.mdi-chess-rook::before {\n  content: \"\\f085b\";\n}\n\n.mdi-chevron-double-down::before {\n  content: \"\\f013c\";\n}\n\n.mdi-chevron-double-left::before {\n  content: \"\\f013d\";\n}\n\n.mdi-chevron-double-right::before {\n  content: \"\\f013e\";\n}\n\n.mdi-chevron-double-up::before {\n  content: \"\\f013f\";\n}\n\n.mdi-chevron-down::before {\n  content: \"\\f0140\";\n}\n\n.mdi-chevron-down-box::before {\n  content: \"\\f09d6\";\n}\n\n.mdi-chevron-down-box-outline::before {\n  content: \"\\f09d7\";\n}\n\n.mdi-chevron-down-circle::before {\n  content: \"\\f0b26\";\n}\n\n.mdi-chevron-down-circle-outline::before {\n  content: \"\\f0b27\";\n}\n\n.mdi-chevron-left::before {\n  content: \"\\f0141\";\n}\n\n.mdi-chevron-left-box::before {\n  content: \"\\f09d8\";\n}\n\n.mdi-chevron-left-box-outline::before {\n  content: \"\\f09d9\";\n}\n\n.mdi-chevron-left-circle::before {\n  content: \"\\f0b28\";\n}\n\n.mdi-chevron-left-circle-outline::before {\n  content: \"\\f0b29\";\n}\n\n.mdi-chevron-right::before {\n  content: \"\\f0142\";\n}\n\n.mdi-chevron-right-box::before {\n  content: \"\\f09da\";\n}\n\n.mdi-chevron-right-box-outline::before {\n  content: \"\\f09db\";\n}\n\n.mdi-chevron-right-circle::before {\n  content: \"\\f0b2a\";\n}\n\n.mdi-chevron-right-circle-outline::before {\n  content: \"\\f0b2b\";\n}\n\n.mdi-chevron-triple-down::before {\n  content: \"\\f0db9\";\n}\n\n.mdi-chevron-triple-left::before {\n  content: \"\\f0dba\";\n}\n\n.mdi-chevron-triple-right::before {\n  content: \"\\f0dbb\";\n}\n\n.mdi-chevron-triple-up::before {\n  content: \"\\f0dbc\";\n}\n\n.mdi-chevron-up::before {\n  content: \"\\f0143\";\n}\n\n.mdi-chevron-up-box::before {\n  content: \"\\f09dc\";\n}\n\n.mdi-chevron-up-box-outline::before {\n  content: \"\\f09dd\";\n}\n\n.mdi-chevron-up-circle::before {\n  content: \"\\f0b2c\";\n}\n\n.mdi-chevron-up-circle-outline::before {\n  content: \"\\f0b2d\";\n}\n\n.mdi-chili-alert::before {\n  content: \"\\f17ea\";\n}\n\n.mdi-chili-alert-outline::before {\n  content: \"\\f17eb\";\n}\n\n.mdi-chili-hot::before {\n  content: \"\\f07b2\";\n}\n\n.mdi-chili-hot-outline::before {\n  content: \"\\f17ec\";\n}\n\n.mdi-chili-medium::before {\n  content: \"\\f07b3\";\n}\n\n.mdi-chili-medium-outline::before {\n  content: \"\\f17ed\";\n}\n\n.mdi-chili-mild::before {\n  content: \"\\f07b4\";\n}\n\n.mdi-chili-mild-outline::before {\n  content: \"\\f17ee\";\n}\n\n.mdi-chili-off::before {\n  content: \"\\f1467\";\n}\n\n.mdi-chili-off-outline::before {\n  content: \"\\f17ef\";\n}\n\n.mdi-chip::before {\n  content: \"\\f061a\";\n}\n\n.mdi-church::before {\n  content: \"\\f0144\";\n}\n\n.mdi-cigar::before {\n  content: \"\\f1189\";\n}\n\n.mdi-cigar-off::before {\n  content: \"\\f141b\";\n}\n\n.mdi-circle::before {\n  content: \"\\f0765\";\n}\n\n.mdi-circle-box::before {\n  content: \"\\f15dc\";\n}\n\n.mdi-circle-box-outline::before {\n  content: \"\\f15dd\";\n}\n\n.mdi-circle-double::before {\n  content: \"\\f0e95\";\n}\n\n.mdi-circle-edit-outline::before {\n  content: \"\\f08d5\";\n}\n\n.mdi-circle-expand::before {\n  content: \"\\f0e96\";\n}\n\n.mdi-circle-half::before {\n  content: \"\\f1395\";\n}\n\n.mdi-circle-half-full::before {\n  content: \"\\f1396\";\n}\n\n.mdi-circle-medium::before {\n  content: \"\\f09de\";\n}\n\n.mdi-circle-multiple::before {\n  content: \"\\f0b38\";\n}\n\n.mdi-circle-multiple-outline::before {\n  content: \"\\f0695\";\n}\n\n.mdi-circle-off-outline::before {\n  content: \"\\f10d3\";\n}\n\n.mdi-circle-opacity::before {\n  content: \"\\f1853\";\n}\n\n.mdi-circle-outline::before {\n  content: \"\\f0766\";\n}\n\n.mdi-circle-slice-1::before {\n  content: \"\\f0a9e\";\n}\n\n.mdi-circle-slice-2::before {\n  content: \"\\f0a9f\";\n}\n\n.mdi-circle-slice-3::before {\n  content: \"\\f0aa0\";\n}\n\n.mdi-circle-slice-4::before {\n  content: \"\\f0aa1\";\n}\n\n.mdi-circle-slice-5::before {\n  content: \"\\f0aa2\";\n}\n\n.mdi-circle-slice-6::before {\n  content: \"\\f0aa3\";\n}\n\n.mdi-circle-slice-7::before {\n  content: \"\\f0aa4\";\n}\n\n.mdi-circle-slice-8::before {\n  content: \"\\f0aa5\";\n}\n\n.mdi-circle-small::before {\n  content: \"\\f09df\";\n}\n\n.mdi-circular-saw::before {\n  content: \"\\f0e22\";\n}\n\n.mdi-city::before {\n  content: \"\\f0146\";\n}\n\n.mdi-city-variant::before {\n  content: \"\\f0a36\";\n}\n\n.mdi-city-variant-outline::before {\n  content: \"\\f0a37\";\n}\n\n.mdi-clipboard::before {\n  content: \"\\f0147\";\n}\n\n.mdi-clipboard-account::before {\n  content: \"\\f0148\";\n}\n\n.mdi-clipboard-account-outline::before {\n  content: \"\\f0c55\";\n}\n\n.mdi-clipboard-alert::before {\n  content: \"\\f0149\";\n}\n\n.mdi-clipboard-alert-outline::before {\n  content: \"\\f0cf7\";\n}\n\n.mdi-clipboard-arrow-down::before {\n  content: \"\\f014a\";\n}\n\n.mdi-clipboard-arrow-down-outline::before {\n  content: \"\\f0c56\";\n}\n\n.mdi-clipboard-arrow-left::before {\n  content: \"\\f014b\";\n}\n\n.mdi-clipboard-arrow-left-outline::before {\n  content: \"\\f0cf8\";\n}\n\n.mdi-clipboard-arrow-right::before {\n  content: \"\\f0cf9\";\n}\n\n.mdi-clipboard-arrow-right-outline::before {\n  content: \"\\f0cfa\";\n}\n\n.mdi-clipboard-arrow-up::before {\n  content: \"\\f0c57\";\n}\n\n.mdi-clipboard-arrow-up-outline::before {\n  content: \"\\f0c58\";\n}\n\n.mdi-clipboard-check::before {\n  content: \"\\f014e\";\n}\n\n.mdi-clipboard-check-multiple::before {\n  content: \"\\f1263\";\n}\n\n.mdi-clipboard-check-multiple-outline::before {\n  content: \"\\f1264\";\n}\n\n.mdi-clipboard-check-outline::before {\n  content: \"\\f08a8\";\n}\n\n.mdi-clipboard-clock::before {\n  content: \"\\f16e2\";\n}\n\n.mdi-clipboard-clock-outline::before {\n  content: \"\\f16e3\";\n}\n\n.mdi-clipboard-edit::before {\n  content: \"\\f14e5\";\n}\n\n.mdi-clipboard-edit-outline::before {\n  content: \"\\f14e6\";\n}\n\n.mdi-clipboard-file::before {\n  content: \"\\f1265\";\n}\n\n.mdi-clipboard-file-outline::before {\n  content: \"\\f1266\";\n}\n\n.mdi-clipboard-flow::before {\n  content: \"\\f06c8\";\n}\n\n.mdi-clipboard-flow-outline::before {\n  content: \"\\f1117\";\n}\n\n.mdi-clipboard-list::before {\n  content: \"\\f10d4\";\n}\n\n.mdi-clipboard-list-outline::before {\n  content: \"\\f10d5\";\n}\n\n.mdi-clipboard-minus::before {\n  content: \"\\f1618\";\n}\n\n.mdi-clipboard-minus-outline::before {\n  content: \"\\f1619\";\n}\n\n.mdi-clipboard-multiple::before {\n  content: \"\\f1267\";\n}\n\n.mdi-clipboard-multiple-outline::before {\n  content: \"\\f1268\";\n}\n\n.mdi-clipboard-off::before {\n  content: \"\\f161a\";\n}\n\n.mdi-clipboard-off-outline::before {\n  content: \"\\f161b\";\n}\n\n.mdi-clipboard-outline::before {\n  content: \"\\f014c\";\n}\n\n.mdi-clipboard-play::before {\n  content: \"\\f0c59\";\n}\n\n.mdi-clipboard-play-multiple::before {\n  content: \"\\f1269\";\n}\n\n.mdi-clipboard-play-multiple-outline::before {\n  content: \"\\f126a\";\n}\n\n.mdi-clipboard-play-outline::before {\n  content: \"\\f0c5a\";\n}\n\n.mdi-clipboard-plus::before {\n  content: \"\\f0751\";\n}\n\n.mdi-clipboard-plus-outline::before {\n  content: \"\\f131f\";\n}\n\n.mdi-clipboard-pulse::before {\n  content: \"\\f085d\";\n}\n\n.mdi-clipboard-pulse-outline::before {\n  content: \"\\f085e\";\n}\n\n.mdi-clipboard-remove::before {\n  content: \"\\f161c\";\n}\n\n.mdi-clipboard-remove-outline::before {\n  content: \"\\f161d\";\n}\n\n.mdi-clipboard-search::before {\n  content: \"\\f161e\";\n}\n\n.mdi-clipboard-search-outline::before {\n  content: \"\\f161f\";\n}\n\n.mdi-clipboard-text::before {\n  content: \"\\f014d\";\n}\n\n.mdi-clipboard-text-clock::before {\n  content: \"\\f18f9\";\n}\n\n.mdi-clipboard-text-clock-outline::before {\n  content: \"\\f18fa\";\n}\n\n.mdi-clipboard-text-multiple::before {\n  content: \"\\f126b\";\n}\n\n.mdi-clipboard-text-multiple-outline::before {\n  content: \"\\f126c\";\n}\n\n.mdi-clipboard-text-off::before {\n  content: \"\\f1620\";\n}\n\n.mdi-clipboard-text-off-outline::before {\n  content: \"\\f1621\";\n}\n\n.mdi-clipboard-text-outline::before {\n  content: \"\\f0a38\";\n}\n\n.mdi-clipboard-text-play::before {\n  content: \"\\f0c5b\";\n}\n\n.mdi-clipboard-text-play-outline::before {\n  content: \"\\f0c5c\";\n}\n\n.mdi-clipboard-text-search::before {\n  content: \"\\f1622\";\n}\n\n.mdi-clipboard-text-search-outline::before {\n  content: \"\\f1623\";\n}\n\n.mdi-clippy::before {\n  content: \"\\f014f\";\n}\n\n.mdi-clock::before {\n  content: \"\\f0954\";\n}\n\n.mdi-clock-alert::before {\n  content: \"\\f0955\";\n}\n\n.mdi-clock-alert-outline::before {\n  content: \"\\f05ce\";\n}\n\n.mdi-clock-check::before {\n  content: \"\\f0fa8\";\n}\n\n.mdi-clock-check-outline::before {\n  content: \"\\f0fa9\";\n}\n\n.mdi-clock-digital::before {\n  content: \"\\f0e97\";\n}\n\n.mdi-clock-edit::before {\n  content: \"\\f19ba\";\n}\n\n.mdi-clock-edit-outline::before {\n  content: \"\\f19bb\";\n}\n\n.mdi-clock-end::before {\n  content: \"\\f0151\";\n}\n\n.mdi-clock-fast::before {\n  content: \"\\f0152\";\n}\n\n.mdi-clock-in::before {\n  content: \"\\f0153\";\n}\n\n.mdi-clock-minus::before {\n  content: \"\\f1863\";\n}\n\n.mdi-clock-minus-outline::before {\n  content: \"\\f1864\";\n}\n\n.mdi-clock-out::before {\n  content: \"\\f0154\";\n}\n\n.mdi-clock-outline::before {\n  content: \"\\f0150\";\n}\n\n.mdi-clock-plus::before {\n  content: \"\\f1861\";\n}\n\n.mdi-clock-plus-outline::before {\n  content: \"\\f1862\";\n}\n\n.mdi-clock-remove::before {\n  content: \"\\f1865\";\n}\n\n.mdi-clock-remove-outline::before {\n  content: \"\\f1866\";\n}\n\n.mdi-clock-start::before {\n  content: \"\\f0155\";\n}\n\n.mdi-clock-time-eight::before {\n  content: \"\\f1446\";\n}\n\n.mdi-clock-time-eight-outline::before {\n  content: \"\\f1452\";\n}\n\n.mdi-clock-time-eleven::before {\n  content: \"\\f1449\";\n}\n\n.mdi-clock-time-eleven-outline::before {\n  content: \"\\f1455\";\n}\n\n.mdi-clock-time-five::before {\n  content: \"\\f1443\";\n}\n\n.mdi-clock-time-five-outline::before {\n  content: \"\\f144f\";\n}\n\n.mdi-clock-time-four::before {\n  content: \"\\f1442\";\n}\n\n.mdi-clock-time-four-outline::before {\n  content: \"\\f144e\";\n}\n\n.mdi-clock-time-nine::before {\n  content: \"\\f1447\";\n}\n\n.mdi-clock-time-nine-outline::before {\n  content: \"\\f1453\";\n}\n\n.mdi-clock-time-one::before {\n  content: \"\\f143f\";\n}\n\n.mdi-clock-time-one-outline::before {\n  content: \"\\f144b\";\n}\n\n.mdi-clock-time-seven::before {\n  content: \"\\f1445\";\n}\n\n.mdi-clock-time-seven-outline::before {\n  content: \"\\f1451\";\n}\n\n.mdi-clock-time-six::before {\n  content: \"\\f1444\";\n}\n\n.mdi-clock-time-six-outline::before {\n  content: \"\\f1450\";\n}\n\n.mdi-clock-time-ten::before {\n  content: \"\\f1448\";\n}\n\n.mdi-clock-time-ten-outline::before {\n  content: \"\\f1454\";\n}\n\n.mdi-clock-time-three::before {\n  content: \"\\f1441\";\n}\n\n.mdi-clock-time-three-outline::before {\n  content: \"\\f144d\";\n}\n\n.mdi-clock-time-twelve::before {\n  content: \"\\f144a\";\n}\n\n.mdi-clock-time-twelve-outline::before {\n  content: \"\\f1456\";\n}\n\n.mdi-clock-time-two::before {\n  content: \"\\f1440\";\n}\n\n.mdi-clock-time-two-outline::before {\n  content: \"\\f144c\";\n}\n\n.mdi-close::before {\n  content: \"\\f0156\";\n}\n\n.mdi-close-box::before {\n  content: \"\\f0157\";\n}\n\n.mdi-close-box-multiple::before {\n  content: \"\\f0c5d\";\n}\n\n.mdi-close-box-multiple-outline::before {\n  content: \"\\f0c5e\";\n}\n\n.mdi-close-box-outline::before {\n  content: \"\\f0158\";\n}\n\n.mdi-close-circle::before {\n  content: \"\\f0159\";\n}\n\n.mdi-close-circle-multiple::before {\n  content: \"\\f062a\";\n}\n\n.mdi-close-circle-multiple-outline::before {\n  content: \"\\f0883\";\n}\n\n.mdi-close-circle-outline::before {\n  content: \"\\f015a\";\n}\n\n.mdi-close-network::before {\n  content: \"\\f015b\";\n}\n\n.mdi-close-network-outline::before {\n  content: \"\\f0c5f\";\n}\n\n.mdi-close-octagon::before {\n  content: \"\\f015c\";\n}\n\n.mdi-close-octagon-outline::before {\n  content: \"\\f015d\";\n}\n\n.mdi-close-outline::before {\n  content: \"\\f06c9\";\n}\n\n.mdi-close-thick::before {\n  content: \"\\f1398\";\n}\n\n.mdi-closed-caption::before {\n  content: \"\\f015e\";\n}\n\n.mdi-closed-caption-outline::before {\n  content: \"\\f0dbd\";\n}\n\n.mdi-cloud::before {\n  content: \"\\f015f\";\n}\n\n.mdi-cloud-alert::before {\n  content: \"\\f09e0\";\n}\n\n.mdi-cloud-braces::before {\n  content: \"\\f07b5\";\n}\n\n.mdi-cloud-check::before {\n  content: \"\\f0160\";\n}\n\n.mdi-cloud-check-outline::before {\n  content: \"\\f12cc\";\n}\n\n.mdi-cloud-circle::before {\n  content: \"\\f0161\";\n}\n\n.mdi-cloud-download::before {\n  content: \"\\f0162\";\n}\n\n.mdi-cloud-download-outline::before {\n  content: \"\\f0b7d\";\n}\n\n.mdi-cloud-lock::before {\n  content: \"\\f11f1\";\n}\n\n.mdi-cloud-lock-outline::before {\n  content: \"\\f11f2\";\n}\n\n.mdi-cloud-off-outline::before {\n  content: \"\\f0164\";\n}\n\n.mdi-cloud-outline::before {\n  content: \"\\f0163\";\n}\n\n.mdi-cloud-print::before {\n  content: \"\\f0165\";\n}\n\n.mdi-cloud-print-outline::before {\n  content: \"\\f0166\";\n}\n\n.mdi-cloud-question::before {\n  content: \"\\f0a39\";\n}\n\n.mdi-cloud-refresh::before {\n  content: \"\\f052a\";\n}\n\n.mdi-cloud-search::before {\n  content: \"\\f0956\";\n}\n\n.mdi-cloud-search-outline::before {\n  content: \"\\f0957\";\n}\n\n.mdi-cloud-sync::before {\n  content: \"\\f063f\";\n}\n\n.mdi-cloud-sync-outline::before {\n  content: \"\\f12d6\";\n}\n\n.mdi-cloud-tags::before {\n  content: \"\\f07b6\";\n}\n\n.mdi-cloud-upload::before {\n  content: \"\\f0167\";\n}\n\n.mdi-cloud-upload-outline::before {\n  content: \"\\f0b7e\";\n}\n\n.mdi-clover::before {\n  content: \"\\f0816\";\n}\n\n.mdi-coach-lamp::before {\n  content: \"\\f1020\";\n}\n\n.mdi-coat-rack::before {\n  content: \"\\f109e\";\n}\n\n.mdi-code-array::before {\n  content: \"\\f0168\";\n}\n\n.mdi-code-braces::before {\n  content: \"\\f0169\";\n}\n\n.mdi-code-braces-box::before {\n  content: \"\\f10d6\";\n}\n\n.mdi-code-brackets::before {\n  content: \"\\f016a\";\n}\n\n.mdi-code-equal::before {\n  content: \"\\f016b\";\n}\n\n.mdi-code-greater-than::before {\n  content: \"\\f016c\";\n}\n\n.mdi-code-greater-than-or-equal::before {\n  content: \"\\f016d\";\n}\n\n.mdi-code-json::before {\n  content: \"\\f0626\";\n}\n\n.mdi-code-less-than::before {\n  content: \"\\f016e\";\n}\n\n.mdi-code-less-than-or-equal::before {\n  content: \"\\f016f\";\n}\n\n.mdi-code-not-equal::before {\n  content: \"\\f0170\";\n}\n\n.mdi-code-not-equal-variant::before {\n  content: \"\\f0171\";\n}\n\n.mdi-code-parentheses::before {\n  content: \"\\f0172\";\n}\n\n.mdi-code-parentheses-box::before {\n  content: \"\\f10d7\";\n}\n\n.mdi-code-string::before {\n  content: \"\\f0173\";\n}\n\n.mdi-code-tags::before {\n  content: \"\\f0174\";\n}\n\n.mdi-code-tags-check::before {\n  content: \"\\f0694\";\n}\n\n.mdi-codepen::before {\n  content: \"\\f0175\";\n}\n\n.mdi-coffee::before {\n  content: \"\\f0176\";\n}\n\n.mdi-coffee-maker::before {\n  content: \"\\f109f\";\n}\n\n.mdi-coffee-maker-check::before {\n  content: \"\\f1931\";\n}\n\n.mdi-coffee-maker-check-outline::before {\n  content: \"\\f1932\";\n}\n\n.mdi-coffee-maker-outline::before {\n  content: \"\\f181b\";\n}\n\n.mdi-coffee-off::before {\n  content: \"\\f0faa\";\n}\n\n.mdi-coffee-off-outline::before {\n  content: \"\\f0fab\";\n}\n\n.mdi-coffee-outline::before {\n  content: \"\\f06ca\";\n}\n\n.mdi-coffee-to-go::before {\n  content: \"\\f0177\";\n}\n\n.mdi-coffee-to-go-outline::before {\n  content: \"\\f130e\";\n}\n\n.mdi-coffin::before {\n  content: \"\\f0b7f\";\n}\n\n.mdi-cog::before {\n  content: \"\\f0493\";\n}\n\n.mdi-cog-box::before {\n  content: \"\\f0494\";\n}\n\n.mdi-cog-clockwise::before {\n  content: \"\\f11dd\";\n}\n\n.mdi-cog-counterclockwise::before {\n  content: \"\\f11de\";\n}\n\n.mdi-cog-off::before {\n  content: \"\\f13ce\";\n}\n\n.mdi-cog-off-outline::before {\n  content: \"\\f13cf\";\n}\n\n.mdi-cog-outline::before {\n  content: \"\\f08bb\";\n}\n\n.mdi-cog-pause::before {\n  content: \"\\f1933\";\n}\n\n.mdi-cog-pause-outline::before {\n  content: \"\\f1934\";\n}\n\n.mdi-cog-play::before {\n  content: \"\\f1935\";\n}\n\n.mdi-cog-play-outline::before {\n  content: \"\\f1936\";\n}\n\n.mdi-cog-refresh::before {\n  content: \"\\f145e\";\n}\n\n.mdi-cog-refresh-outline::before {\n  content: \"\\f145f\";\n}\n\n.mdi-cog-stop::before {\n  content: \"\\f1937\";\n}\n\n.mdi-cog-stop-outline::before {\n  content: \"\\f1938\";\n}\n\n.mdi-cog-sync::before {\n  content: \"\\f1460\";\n}\n\n.mdi-cog-sync-outline::before {\n  content: \"\\f1461\";\n}\n\n.mdi-cog-transfer::before {\n  content: \"\\f105b\";\n}\n\n.mdi-cog-transfer-outline::before {\n  content: \"\\f105c\";\n}\n\n.mdi-cogs::before {\n  content: \"\\f08d6\";\n}\n\n.mdi-collage::before {\n  content: \"\\f0640\";\n}\n\n.mdi-collapse-all::before {\n  content: \"\\f0aa6\";\n}\n\n.mdi-collapse-all-outline::before {\n  content: \"\\f0aa7\";\n}\n\n.mdi-color-helper::before {\n  content: \"\\f0179\";\n}\n\n.mdi-comma::before {\n  content: \"\\f0e23\";\n}\n\n.mdi-comma-box::before {\n  content: \"\\f0e2b\";\n}\n\n.mdi-comma-box-outline::before {\n  content: \"\\f0e24\";\n}\n\n.mdi-comma-circle::before {\n  content: \"\\f0e25\";\n}\n\n.mdi-comma-circle-outline::before {\n  content: \"\\f0e26\";\n}\n\n.mdi-comment::before {\n  content: \"\\f017a\";\n}\n\n.mdi-comment-account::before {\n  content: \"\\f017b\";\n}\n\n.mdi-comment-account-outline::before {\n  content: \"\\f017c\";\n}\n\n.mdi-comment-alert::before {\n  content: \"\\f017d\";\n}\n\n.mdi-comment-alert-outline::before {\n  content: \"\\f017e\";\n}\n\n.mdi-comment-arrow-left::before {\n  content: \"\\f09e1\";\n}\n\n.mdi-comment-arrow-left-outline::before {\n  content: \"\\f09e2\";\n}\n\n.mdi-comment-arrow-right::before {\n  content: \"\\f09e3\";\n}\n\n.mdi-comment-arrow-right-outline::before {\n  content: \"\\f09e4\";\n}\n\n.mdi-comment-bookmark::before {\n  content: \"\\f15ae\";\n}\n\n.mdi-comment-bookmark-outline::before {\n  content: \"\\f15af\";\n}\n\n.mdi-comment-check::before {\n  content: \"\\f017f\";\n}\n\n.mdi-comment-check-outline::before {\n  content: \"\\f0180\";\n}\n\n.mdi-comment-edit::before {\n  content: \"\\f11bf\";\n}\n\n.mdi-comment-edit-outline::before {\n  content: \"\\f12c4\";\n}\n\n.mdi-comment-eye::before {\n  content: \"\\f0a3a\";\n}\n\n.mdi-comment-eye-outline::before {\n  content: \"\\f0a3b\";\n}\n\n.mdi-comment-flash::before {\n  content: \"\\f15b0\";\n}\n\n.mdi-comment-flash-outline::before {\n  content: \"\\f15b1\";\n}\n\n.mdi-comment-minus::before {\n  content: \"\\f15df\";\n}\n\n.mdi-comment-minus-outline::before {\n  content: \"\\f15e0\";\n}\n\n.mdi-comment-multiple::before {\n  content: \"\\f085f\";\n}\n\n.mdi-comment-multiple-outline::before {\n  content: \"\\f0181\";\n}\n\n.mdi-comment-off::before {\n  content: \"\\f15e1\";\n}\n\n.mdi-comment-off-outline::before {\n  content: \"\\f15e2\";\n}\n\n.mdi-comment-outline::before {\n  content: \"\\f0182\";\n}\n\n.mdi-comment-plus::before {\n  content: \"\\f09e5\";\n}\n\n.mdi-comment-plus-outline::before {\n  content: \"\\f0183\";\n}\n\n.mdi-comment-processing::before {\n  content: \"\\f0184\";\n}\n\n.mdi-comment-processing-outline::before {\n  content: \"\\f0185\";\n}\n\n.mdi-comment-question::before {\n  content: \"\\f0817\";\n}\n\n.mdi-comment-question-outline::before {\n  content: \"\\f0186\";\n}\n\n.mdi-comment-quote::before {\n  content: \"\\f1021\";\n}\n\n.mdi-comment-quote-outline::before {\n  content: \"\\f1022\";\n}\n\n.mdi-comment-remove::before {\n  content: \"\\f05de\";\n}\n\n.mdi-comment-remove-outline::before {\n  content: \"\\f0187\";\n}\n\n.mdi-comment-search::before {\n  content: \"\\f0a3c\";\n}\n\n.mdi-comment-search-outline::before {\n  content: \"\\f0a3d\";\n}\n\n.mdi-comment-text::before {\n  content: \"\\f0188\";\n}\n\n.mdi-comment-text-multiple::before {\n  content: \"\\f0860\";\n}\n\n.mdi-comment-text-multiple-outline::before {\n  content: \"\\f0861\";\n}\n\n.mdi-comment-text-outline::before {\n  content: \"\\f0189\";\n}\n\n.mdi-compare::before {\n  content: \"\\f018a\";\n}\n\n.mdi-compare-horizontal::before {\n  content: \"\\f1492\";\n}\n\n.mdi-compare-remove::before {\n  content: \"\\f18b3\";\n}\n\n.mdi-compare-vertical::before {\n  content: \"\\f1493\";\n}\n\n.mdi-compass::before {\n  content: \"\\f018b\";\n}\n\n.mdi-compass-off::before {\n  content: \"\\f0b80\";\n}\n\n.mdi-compass-off-outline::before {\n  content: \"\\f0b81\";\n}\n\n.mdi-compass-outline::before {\n  content: \"\\f018c\";\n}\n\n.mdi-compass-rose::before {\n  content: \"\\f1382\";\n}\n\n.mdi-cone::before {\n  content: \"\\f194c\";\n}\n\n.mdi-cone-off::before {\n  content: \"\\f194d\";\n}\n\n.mdi-connection::before {\n  content: \"\\f1616\";\n}\n\n.mdi-console::before {\n  content: \"\\f018d\";\n}\n\n.mdi-console-line::before {\n  content: \"\\f07b7\";\n}\n\n.mdi-console-network::before {\n  content: \"\\f08a9\";\n}\n\n.mdi-console-network-outline::before {\n  content: \"\\f0c60\";\n}\n\n.mdi-consolidate::before {\n  content: \"\\f10d8\";\n}\n\n.mdi-contactless-payment::before {\n  content: \"\\f0d6a\";\n}\n\n.mdi-contactless-payment-circle::before {\n  content: \"\\f0321\";\n}\n\n.mdi-contactless-payment-circle-outline::before {\n  content: \"\\f0408\";\n}\n\n.mdi-contacts::before {\n  content: \"\\f06cb\";\n}\n\n.mdi-contacts-outline::before {\n  content: \"\\f05b8\";\n}\n\n.mdi-contain::before {\n  content: \"\\f0a3e\";\n}\n\n.mdi-contain-end::before {\n  content: \"\\f0a3f\";\n}\n\n.mdi-contain-start::before {\n  content: \"\\f0a40\";\n}\n\n.mdi-content-copy::before {\n  content: \"\\f018f\";\n}\n\n.mdi-content-cut::before {\n  content: \"\\f0190\";\n}\n\n.mdi-content-duplicate::before {\n  content: \"\\f0191\";\n}\n\n.mdi-content-paste::before {\n  content: \"\\f0192\";\n}\n\n.mdi-content-save::before {\n  content: \"\\f0193\";\n}\n\n.mdi-content-save-alert::before {\n  content: \"\\f0f42\";\n}\n\n.mdi-content-save-alert-outline::before {\n  content: \"\\f0f43\";\n}\n\n.mdi-content-save-all::before {\n  content: \"\\f0194\";\n}\n\n.mdi-content-save-all-outline::before {\n  content: \"\\f0f44\";\n}\n\n.mdi-content-save-check::before {\n  content: \"\\f18ea\";\n}\n\n.mdi-content-save-check-outline::before {\n  content: \"\\f18eb\";\n}\n\n.mdi-content-save-cog::before {\n  content: \"\\f145b\";\n}\n\n.mdi-content-save-cog-outline::before {\n  content: \"\\f145c\";\n}\n\n.mdi-content-save-edit::before {\n  content: \"\\f0cfb\";\n}\n\n.mdi-content-save-edit-outline::before {\n  content: \"\\f0cfc\";\n}\n\n.mdi-content-save-move::before {\n  content: \"\\f0e27\";\n}\n\n.mdi-content-save-move-outline::before {\n  content: \"\\f0e28\";\n}\n\n.mdi-content-save-off::before {\n  content: \"\\f1643\";\n}\n\n.mdi-content-save-off-outline::before {\n  content: \"\\f1644\";\n}\n\n.mdi-content-save-outline::before {\n  content: \"\\f0818\";\n}\n\n.mdi-content-save-settings::before {\n  content: \"\\f061b\";\n}\n\n.mdi-content-save-settings-outline::before {\n  content: \"\\f0b2e\";\n}\n\n.mdi-contrast::before {\n  content: \"\\f0195\";\n}\n\n.mdi-contrast-box::before {\n  content: \"\\f0196\";\n}\n\n.mdi-contrast-circle::before {\n  content: \"\\f0197\";\n}\n\n.mdi-controller-classic::before {\n  content: \"\\f0b82\";\n}\n\n.mdi-controller-classic-outline::before {\n  content: \"\\f0b83\";\n}\n\n.mdi-cookie::before {\n  content: \"\\f0198\";\n}\n\n.mdi-cookie-alert::before {\n  content: \"\\f16d0\";\n}\n\n.mdi-cookie-alert-outline::before {\n  content: \"\\f16d1\";\n}\n\n.mdi-cookie-check::before {\n  content: \"\\f16d2\";\n}\n\n.mdi-cookie-check-outline::before {\n  content: \"\\f16d3\";\n}\n\n.mdi-cookie-clock::before {\n  content: \"\\f16e4\";\n}\n\n.mdi-cookie-clock-outline::before {\n  content: \"\\f16e5\";\n}\n\n.mdi-cookie-cog::before {\n  content: \"\\f16d4\";\n}\n\n.mdi-cookie-cog-outline::before {\n  content: \"\\f16d5\";\n}\n\n.mdi-cookie-edit::before {\n  content: \"\\f16e6\";\n}\n\n.mdi-cookie-edit-outline::before {\n  content: \"\\f16e7\";\n}\n\n.mdi-cookie-lock::before {\n  content: \"\\f16e8\";\n}\n\n.mdi-cookie-lock-outline::before {\n  content: \"\\f16e9\";\n}\n\n.mdi-cookie-minus::before {\n  content: \"\\f16da\";\n}\n\n.mdi-cookie-minus-outline::before {\n  content: \"\\f16db\";\n}\n\n.mdi-cookie-off::before {\n  content: \"\\f16ea\";\n}\n\n.mdi-cookie-off-outline::before {\n  content: \"\\f16eb\";\n}\n\n.mdi-cookie-outline::before {\n  content: \"\\f16de\";\n}\n\n.mdi-cookie-plus::before {\n  content: \"\\f16d6\";\n}\n\n.mdi-cookie-plus-outline::before {\n  content: \"\\f16d7\";\n}\n\n.mdi-cookie-refresh::before {\n  content: \"\\f16ec\";\n}\n\n.mdi-cookie-refresh-outline::before {\n  content: \"\\f16ed\";\n}\n\n.mdi-cookie-remove::before {\n  content: \"\\f16d8\";\n}\n\n.mdi-cookie-remove-outline::before {\n  content: \"\\f16d9\";\n}\n\n.mdi-cookie-settings::before {\n  content: \"\\f16dc\";\n}\n\n.mdi-cookie-settings-outline::before {\n  content: \"\\f16dd\";\n}\n\n.mdi-coolant-temperature::before {\n  content: \"\\f03c8\";\n}\n\n.mdi-copyleft::before {\n  content: \"\\f1939\";\n}\n\n.mdi-copyright::before {\n  content: \"\\f05e6\";\n}\n\n.mdi-cordova::before {\n  content: \"\\f0958\";\n}\n\n.mdi-corn::before {\n  content: \"\\f07b8\";\n}\n\n.mdi-corn-off::before {\n  content: \"\\f13ef\";\n}\n\n.mdi-cosine-wave::before {\n  content: \"\\f1479\";\n}\n\n.mdi-counter::before {\n  content: \"\\f0199\";\n}\n\n.mdi-countertop::before {\n  content: \"\\f181c\";\n}\n\n.mdi-countertop-outline::before {\n  content: \"\\f181d\";\n}\n\n.mdi-cow::before {\n  content: \"\\f019a\";\n}\n\n.mdi-cow-off::before {\n  content: \"\\f18fc\";\n}\n\n.mdi-cpu-32-bit::before {\n  content: \"\\f0edf\";\n}\n\n.mdi-cpu-64-bit::before {\n  content: \"\\f0ee0\";\n}\n\n.mdi-cradle::before {\n  content: \"\\f198b\";\n}\n\n.mdi-cradle-outline::before {\n  content: \"\\f1991\";\n}\n\n.mdi-crane::before {\n  content: \"\\f0862\";\n}\n\n.mdi-creation::before {\n  content: \"\\f0674\";\n}\n\n.mdi-creative-commons::before {\n  content: \"\\f0d6b\";\n}\n\n.mdi-credit-card::before {\n  content: \"\\f0fef\";\n}\n\n.mdi-credit-card-check::before {\n  content: \"\\f13d0\";\n}\n\n.mdi-credit-card-check-outline::before {\n  content: \"\\f13d1\";\n}\n\n.mdi-credit-card-chip::before {\n  content: \"\\f190f\";\n}\n\n.mdi-credit-card-chip-outline::before {\n  content: \"\\f1910\";\n}\n\n.mdi-credit-card-clock::before {\n  content: \"\\f0ee1\";\n}\n\n.mdi-credit-card-clock-outline::before {\n  content: \"\\f0ee2\";\n}\n\n.mdi-credit-card-edit::before {\n  content: \"\\f17d7\";\n}\n\n.mdi-credit-card-edit-outline::before {\n  content: \"\\f17d8\";\n}\n\n.mdi-credit-card-fast::before {\n  content: \"\\f1911\";\n}\n\n.mdi-credit-card-fast-outline::before {\n  content: \"\\f1912\";\n}\n\n.mdi-credit-card-lock::before {\n  content: \"\\f18e7\";\n}\n\n.mdi-credit-card-lock-outline::before {\n  content: \"\\f18e8\";\n}\n\n.mdi-credit-card-marker::before {\n  content: \"\\f06a8\";\n}\n\n.mdi-credit-card-marker-outline::before {\n  content: \"\\f0dbe\";\n}\n\n.mdi-credit-card-minus::before {\n  content: \"\\f0fac\";\n}\n\n.mdi-credit-card-minus-outline::before {\n  content: \"\\f0fad\";\n}\n\n.mdi-credit-card-multiple::before {\n  content: \"\\f0ff0\";\n}\n\n.mdi-credit-card-multiple-outline::before {\n  content: \"\\f019c\";\n}\n\n.mdi-credit-card-off::before {\n  content: \"\\f0ff1\";\n}\n\n.mdi-credit-card-off-outline::before {\n  content: \"\\f05e4\";\n}\n\n.mdi-credit-card-outline::before {\n  content: \"\\f019b\";\n}\n\n.mdi-credit-card-plus::before {\n  content: \"\\f0ff2\";\n}\n\n.mdi-credit-card-plus-outline::before {\n  content: \"\\f0676\";\n}\n\n.mdi-credit-card-refresh::before {\n  content: \"\\f1645\";\n}\n\n.mdi-credit-card-refresh-outline::before {\n  content: \"\\f1646\";\n}\n\n.mdi-credit-card-refund::before {\n  content: \"\\f0ff3\";\n}\n\n.mdi-credit-card-refund-outline::before {\n  content: \"\\f0aa8\";\n}\n\n.mdi-credit-card-remove::before {\n  content: \"\\f0fae\";\n}\n\n.mdi-credit-card-remove-outline::before {\n  content: \"\\f0faf\";\n}\n\n.mdi-credit-card-scan::before {\n  content: \"\\f0ff4\";\n}\n\n.mdi-credit-card-scan-outline::before {\n  content: \"\\f019d\";\n}\n\n.mdi-credit-card-search::before {\n  content: \"\\f1647\";\n}\n\n.mdi-credit-card-search-outline::before {\n  content: \"\\f1648\";\n}\n\n.mdi-credit-card-settings::before {\n  content: \"\\f0ff5\";\n}\n\n.mdi-credit-card-settings-outline::before {\n  content: \"\\f08d7\";\n}\n\n.mdi-credit-card-sync::before {\n  content: \"\\f1649\";\n}\n\n.mdi-credit-card-sync-outline::before {\n  content: \"\\f164a\";\n}\n\n.mdi-credit-card-wireless::before {\n  content: \"\\f0802\";\n}\n\n.mdi-credit-card-wireless-off::before {\n  content: \"\\f057a\";\n}\n\n.mdi-credit-card-wireless-off-outline::before {\n  content: \"\\f057b\";\n}\n\n.mdi-credit-card-wireless-outline::before {\n  content: \"\\f0d6c\";\n}\n\n.mdi-cricket::before {\n  content: \"\\f0d6d\";\n}\n\n.mdi-crop::before {\n  content: \"\\f019e\";\n}\n\n.mdi-crop-free::before {\n  content: \"\\f019f\";\n}\n\n.mdi-crop-landscape::before {\n  content: \"\\f01a0\";\n}\n\n.mdi-crop-portrait::before {\n  content: \"\\f01a1\";\n}\n\n.mdi-crop-rotate::before {\n  content: \"\\f0696\";\n}\n\n.mdi-crop-square::before {\n  content: \"\\f01a2\";\n}\n\n.mdi-cross::before {\n  content: \"\\f0953\";\n}\n\n.mdi-cross-bolnisi::before {\n  content: \"\\f0ced\";\n}\n\n.mdi-cross-celtic::before {\n  content: \"\\f0cf5\";\n}\n\n.mdi-cross-outline::before {\n  content: \"\\f0cf6\";\n}\n\n.mdi-crosshairs::before {\n  content: \"\\f01a3\";\n}\n\n.mdi-crosshairs-gps::before {\n  content: \"\\f01a4\";\n}\n\n.mdi-crosshairs-off::before {\n  content: \"\\f0f45\";\n}\n\n.mdi-crosshairs-question::before {\n  content: \"\\f1136\";\n}\n\n.mdi-crowd::before {\n  content: \"\\f1975\";\n}\n\n.mdi-crown::before {\n  content: \"\\f01a5\";\n}\n\n.mdi-crown-circle::before {\n  content: \"\\f17dc\";\n}\n\n.mdi-crown-circle-outline::before {\n  content: \"\\f17dd\";\n}\n\n.mdi-crown-outline::before {\n  content: \"\\f11d0\";\n}\n\n.mdi-cryengine::before {\n  content: \"\\f0959\";\n}\n\n.mdi-crystal-ball::before {\n  content: \"\\f0b2f\";\n}\n\n.mdi-cube::before {\n  content: \"\\f01a6\";\n}\n\n.mdi-cube-off::before {\n  content: \"\\f141c\";\n}\n\n.mdi-cube-off-outline::before {\n  content: \"\\f141d\";\n}\n\n.mdi-cube-outline::before {\n  content: \"\\f01a7\";\n}\n\n.mdi-cube-scan::before {\n  content: \"\\f0b84\";\n}\n\n.mdi-cube-send::before {\n  content: \"\\f01a8\";\n}\n\n.mdi-cube-unfolded::before {\n  content: \"\\f01a9\";\n}\n\n.mdi-cup::before {\n  content: \"\\f01aa\";\n}\n\n.mdi-cup-off::before {\n  content: \"\\f05e5\";\n}\n\n.mdi-cup-off-outline::before {\n  content: \"\\f137d\";\n}\n\n.mdi-cup-outline::before {\n  content: \"\\f130f\";\n}\n\n.mdi-cup-water::before {\n  content: \"\\f01ab\";\n}\n\n.mdi-cupboard::before {\n  content: \"\\f0f46\";\n}\n\n.mdi-cupboard-outline::before {\n  content: \"\\f0f47\";\n}\n\n.mdi-cupcake::before {\n  content: \"\\f095a\";\n}\n\n.mdi-curling::before {\n  content: \"\\f0863\";\n}\n\n.mdi-currency-bdt::before {\n  content: \"\\f0864\";\n}\n\n.mdi-currency-brl::before {\n  content: \"\\f0b85\";\n}\n\n.mdi-currency-btc::before {\n  content: \"\\f01ac\";\n}\n\n.mdi-currency-cny::before {\n  content: \"\\f07ba\";\n}\n\n.mdi-currency-eth::before {\n  content: \"\\f07bb\";\n}\n\n.mdi-currency-eur::before {\n  content: \"\\f01ad\";\n}\n\n.mdi-currency-eur-off::before {\n  content: \"\\f1315\";\n}\n\n.mdi-currency-gbp::before {\n  content: \"\\f01ae\";\n}\n\n.mdi-currency-ils::before {\n  content: \"\\f0c61\";\n}\n\n.mdi-currency-inr::before {\n  content: \"\\f01af\";\n}\n\n.mdi-currency-jpy::before {\n  content: \"\\f07bc\";\n}\n\n.mdi-currency-krw::before {\n  content: \"\\f07bd\";\n}\n\n.mdi-currency-kzt::before {\n  content: \"\\f0865\";\n}\n\n.mdi-currency-mnt::before {\n  content: \"\\f1512\";\n}\n\n.mdi-currency-ngn::before {\n  content: \"\\f01b0\";\n}\n\n.mdi-currency-php::before {\n  content: \"\\f09e6\";\n}\n\n.mdi-currency-rial::before {\n  content: \"\\f0e9c\";\n}\n\n.mdi-currency-rub::before {\n  content: \"\\f01b1\";\n}\n\n.mdi-currency-rupee::before {\n  content: \"\\f1976\";\n}\n\n.mdi-currency-sign::before {\n  content: \"\\f07be\";\n}\n\n.mdi-currency-try::before {\n  content: \"\\f01b2\";\n}\n\n.mdi-currency-twd::before {\n  content: \"\\f07bf\";\n}\n\n.mdi-currency-usd::before {\n  content: \"\\f01c1\";\n}\n\n.mdi-currency-usd-off::before {\n  content: \"\\f067a\";\n}\n\n.mdi-current-ac::before {\n  content: \"\\f1480\";\n}\n\n.mdi-current-dc::before {\n  content: \"\\f095c\";\n}\n\n.mdi-cursor-default::before {\n  content: \"\\f01c0\";\n}\n\n.mdi-cursor-default-click::before {\n  content: \"\\f0cfd\";\n}\n\n.mdi-cursor-default-click-outline::before {\n  content: \"\\f0cfe\";\n}\n\n.mdi-cursor-default-gesture::before {\n  content: \"\\f1127\";\n}\n\n.mdi-cursor-default-gesture-outline::before {\n  content: \"\\f1128\";\n}\n\n.mdi-cursor-default-outline::before {\n  content: \"\\f01bf\";\n}\n\n.mdi-cursor-move::before {\n  content: \"\\f01be\";\n}\n\n.mdi-cursor-pointer::before {\n  content: \"\\f01bd\";\n}\n\n.mdi-cursor-text::before {\n  content: \"\\f05e7\";\n}\n\n.mdi-curtains::before {\n  content: \"\\f1846\";\n}\n\n.mdi-curtains-closed::before {\n  content: \"\\f1847\";\n}\n\n.mdi-cylinder::before {\n  content: \"\\f194e\";\n}\n\n.mdi-cylinder-off::before {\n  content: \"\\f194f\";\n}\n\n.mdi-dance-ballroom::before {\n  content: \"\\f15fb\";\n}\n\n.mdi-dance-pole::before {\n  content: \"\\f1578\";\n}\n\n.mdi-data-matrix::before {\n  content: \"\\f153c\";\n}\n\n.mdi-data-matrix-edit::before {\n  content: \"\\f153d\";\n}\n\n.mdi-data-matrix-minus::before {\n  content: \"\\f153e\";\n}\n\n.mdi-data-matrix-plus::before {\n  content: \"\\f153f\";\n}\n\n.mdi-data-matrix-remove::before {\n  content: \"\\f1540\";\n}\n\n.mdi-data-matrix-scan::before {\n  content: \"\\f1541\";\n}\n\n.mdi-database::before {\n  content: \"\\f01bc\";\n}\n\n.mdi-database-alert::before {\n  content: \"\\f163a\";\n}\n\n.mdi-database-alert-outline::before {\n  content: \"\\f1624\";\n}\n\n.mdi-database-arrow-down::before {\n  content: \"\\f163b\";\n}\n\n.mdi-database-arrow-down-outline::before {\n  content: \"\\f1625\";\n}\n\n.mdi-database-arrow-left::before {\n  content: \"\\f163c\";\n}\n\n.mdi-database-arrow-left-outline::before {\n  content: \"\\f1626\";\n}\n\n.mdi-database-arrow-right::before {\n  content: \"\\f163d\";\n}\n\n.mdi-database-arrow-right-outline::before {\n  content: \"\\f1627\";\n}\n\n.mdi-database-arrow-up::before {\n  content: \"\\f163e\";\n}\n\n.mdi-database-arrow-up-outline::before {\n  content: \"\\f1628\";\n}\n\n.mdi-database-check::before {\n  content: \"\\f0aa9\";\n}\n\n.mdi-database-check-outline::before {\n  content: \"\\f1629\";\n}\n\n.mdi-database-clock::before {\n  content: \"\\f163f\";\n}\n\n.mdi-database-clock-outline::before {\n  content: \"\\f162a\";\n}\n\n.mdi-database-cog::before {\n  content: \"\\f164b\";\n}\n\n.mdi-database-cog-outline::before {\n  content: \"\\f164c\";\n}\n\n.mdi-database-edit::before {\n  content: \"\\f0b86\";\n}\n\n.mdi-database-edit-outline::before {\n  content: \"\\f162b\";\n}\n\n.mdi-database-export::before {\n  content: \"\\f095e\";\n}\n\n.mdi-database-export-outline::before {\n  content: \"\\f162c\";\n}\n\n.mdi-database-eye::before {\n  content: \"\\f191f\";\n}\n\n.mdi-database-eye-off::before {\n  content: \"\\f1920\";\n}\n\n.mdi-database-eye-off-outline::before {\n  content: \"\\f1921\";\n}\n\n.mdi-database-eye-outline::before {\n  content: \"\\f1922\";\n}\n\n.mdi-database-import::before {\n  content: \"\\f095d\";\n}\n\n.mdi-database-import-outline::before {\n  content: \"\\f162d\";\n}\n\n.mdi-database-lock::before {\n  content: \"\\f0aaa\";\n}\n\n.mdi-database-lock-outline::before {\n  content: \"\\f162e\";\n}\n\n.mdi-database-marker::before {\n  content: \"\\f12f6\";\n}\n\n.mdi-database-marker-outline::before {\n  content: \"\\f162f\";\n}\n\n.mdi-database-minus::before {\n  content: \"\\f01bb\";\n}\n\n.mdi-database-minus-outline::before {\n  content: \"\\f1630\";\n}\n\n.mdi-database-off::before {\n  content: \"\\f1640\";\n}\n\n.mdi-database-off-outline::before {\n  content: \"\\f1631\";\n}\n\n.mdi-database-outline::before {\n  content: \"\\f1632\";\n}\n\n.mdi-database-plus::before {\n  content: \"\\f01ba\";\n}\n\n.mdi-database-plus-outline::before {\n  content: \"\\f1633\";\n}\n\n.mdi-database-refresh::before {\n  content: \"\\f05c2\";\n}\n\n.mdi-database-refresh-outline::before {\n  content: \"\\f1634\";\n}\n\n.mdi-database-remove::before {\n  content: \"\\f0d00\";\n}\n\n.mdi-database-remove-outline::before {\n  content: \"\\f1635\";\n}\n\n.mdi-database-search::before {\n  content: \"\\f0866\";\n}\n\n.mdi-database-search-outline::before {\n  content: \"\\f1636\";\n}\n\n.mdi-database-settings::before {\n  content: \"\\f0d01\";\n}\n\n.mdi-database-settings-outline::before {\n  content: \"\\f1637\";\n}\n\n.mdi-database-sync::before {\n  content: \"\\f0cff\";\n}\n\n.mdi-database-sync-outline::before {\n  content: \"\\f1638\";\n}\n\n.mdi-death-star::before {\n  content: \"\\f08d8\";\n}\n\n.mdi-death-star-variant::before {\n  content: \"\\f08d9\";\n}\n\n.mdi-deathly-hallows::before {\n  content: \"\\f0b87\";\n}\n\n.mdi-debian::before {\n  content: \"\\f08da\";\n}\n\n.mdi-debug-step-into::before {\n  content: \"\\f01b9\";\n}\n\n.mdi-debug-step-out::before {\n  content: \"\\f01b8\";\n}\n\n.mdi-debug-step-over::before {\n  content: \"\\f01b7\";\n}\n\n.mdi-decagram::before {\n  content: \"\\f076c\";\n}\n\n.mdi-decagram-outline::before {\n  content: \"\\f076d\";\n}\n\n.mdi-decimal::before {\n  content: \"\\f10a1\";\n}\n\n.mdi-decimal-comma::before {\n  content: \"\\f10a2\";\n}\n\n.mdi-decimal-comma-decrease::before {\n  content: \"\\f10a3\";\n}\n\n.mdi-decimal-comma-increase::before {\n  content: \"\\f10a4\";\n}\n\n.mdi-decimal-decrease::before {\n  content: \"\\f01b6\";\n}\n\n.mdi-decimal-increase::before {\n  content: \"\\f01b5\";\n}\n\n.mdi-delete::before {\n  content: \"\\f01b4\";\n}\n\n.mdi-delete-alert::before {\n  content: \"\\f10a5\";\n}\n\n.mdi-delete-alert-outline::before {\n  content: \"\\f10a6\";\n}\n\n.mdi-delete-circle::before {\n  content: \"\\f0683\";\n}\n\n.mdi-delete-circle-outline::before {\n  content: \"\\f0b88\";\n}\n\n.mdi-delete-clock::before {\n  content: \"\\f1556\";\n}\n\n.mdi-delete-clock-outline::before {\n  content: \"\\f1557\";\n}\n\n.mdi-delete-empty::before {\n  content: \"\\f06cc\";\n}\n\n.mdi-delete-empty-outline::before {\n  content: \"\\f0e9d\";\n}\n\n.mdi-delete-forever::before {\n  content: \"\\f05e8\";\n}\n\n.mdi-delete-forever-outline::before {\n  content: \"\\f0b89\";\n}\n\n.mdi-delete-off::before {\n  content: \"\\f10a7\";\n}\n\n.mdi-delete-off-outline::before {\n  content: \"\\f10a8\";\n}\n\n.mdi-delete-outline::before {\n  content: \"\\f09e7\";\n}\n\n.mdi-delete-restore::before {\n  content: \"\\f0819\";\n}\n\n.mdi-delete-sweep::before {\n  content: \"\\f05e9\";\n}\n\n.mdi-delete-sweep-outline::before {\n  content: \"\\f0c62\";\n}\n\n.mdi-delete-variant::before {\n  content: \"\\f01b3\";\n}\n\n.mdi-delta::before {\n  content: \"\\f01c2\";\n}\n\n.mdi-desk::before {\n  content: \"\\f1239\";\n}\n\n.mdi-desk-lamp::before {\n  content: \"\\f095f\";\n}\n\n.mdi-deskphone::before {\n  content: \"\\f01c3\";\n}\n\n.mdi-desktop-classic::before {\n  content: \"\\f07c0\";\n}\n\n.mdi-desktop-mac::before {\n  content: \"\\f01c4\";\n}\n\n.mdi-desktop-mac-dashboard::before {\n  content: \"\\f09e8\";\n}\n\n.mdi-desktop-tower::before {\n  content: \"\\f01c5\";\n}\n\n.mdi-desktop-tower-monitor::before {\n  content: \"\\f0aab\";\n}\n\n.mdi-details::before {\n  content: \"\\f01c6\";\n}\n\n.mdi-dev-to::before {\n  content: \"\\f0d6e\";\n}\n\n.mdi-developer-board::before {\n  content: \"\\f0697\";\n}\n\n.mdi-deviantart::before {\n  content: \"\\f01c7\";\n}\n\n.mdi-devices::before {\n  content: \"\\f0fb0\";\n}\n\n.mdi-dharmachakra::before {\n  content: \"\\f094b\";\n}\n\n.mdi-diabetes::before {\n  content: \"\\f1126\";\n}\n\n.mdi-dialpad::before {\n  content: \"\\f061c\";\n}\n\n.mdi-diameter::before {\n  content: \"\\f0c63\";\n}\n\n.mdi-diameter-outline::before {\n  content: \"\\f0c64\";\n}\n\n.mdi-diameter-variant::before {\n  content: \"\\f0c65\";\n}\n\n.mdi-diamond::before {\n  content: \"\\f0b8a\";\n}\n\n.mdi-diamond-outline::before {\n  content: \"\\f0b8b\";\n}\n\n.mdi-diamond-stone::before {\n  content: \"\\f01c8\";\n}\n\n.mdi-dice-1::before {\n  content: \"\\f01ca\";\n}\n\n.mdi-dice-1-outline::before {\n  content: \"\\f114a\";\n}\n\n.mdi-dice-2::before {\n  content: \"\\f01cb\";\n}\n\n.mdi-dice-2-outline::before {\n  content: \"\\f114b\";\n}\n\n.mdi-dice-3::before {\n  content: \"\\f01cc\";\n}\n\n.mdi-dice-3-outline::before {\n  content: \"\\f114c\";\n}\n\n.mdi-dice-4::before {\n  content: \"\\f01cd\";\n}\n\n.mdi-dice-4-outline::before {\n  content: \"\\f114d\";\n}\n\n.mdi-dice-5::before {\n  content: \"\\f01ce\";\n}\n\n.mdi-dice-5-outline::before {\n  content: \"\\f114e\";\n}\n\n.mdi-dice-6::before {\n  content: \"\\f01cf\";\n}\n\n.mdi-dice-6-outline::before {\n  content: \"\\f114f\";\n}\n\n.mdi-dice-d10::before {\n  content: \"\\f1153\";\n}\n\n.mdi-dice-d10-outline::before {\n  content: \"\\f076f\";\n}\n\n.mdi-dice-d12::before {\n  content: \"\\f1154\";\n}\n\n.mdi-dice-d12-outline::before {\n  content: \"\\f0867\";\n}\n\n.mdi-dice-d20::before {\n  content: \"\\f1155\";\n}\n\n.mdi-dice-d20-outline::before {\n  content: \"\\f05ea\";\n}\n\n.mdi-dice-d4::before {\n  content: \"\\f1150\";\n}\n\n.mdi-dice-d4-outline::before {\n  content: \"\\f05eb\";\n}\n\n.mdi-dice-d6::before {\n  content: \"\\f1151\";\n}\n\n.mdi-dice-d6-outline::before {\n  content: \"\\f05ed\";\n}\n\n.mdi-dice-d8::before {\n  content: \"\\f1152\";\n}\n\n.mdi-dice-d8-outline::before {\n  content: \"\\f05ec\";\n}\n\n.mdi-dice-multiple::before {\n  content: \"\\f076e\";\n}\n\n.mdi-dice-multiple-outline::before {\n  content: \"\\f1156\";\n}\n\n.mdi-digital-ocean::before {\n  content: \"\\f1237\";\n}\n\n.mdi-dip-switch::before {\n  content: \"\\f07c1\";\n}\n\n.mdi-directions::before {\n  content: \"\\f01d0\";\n}\n\n.mdi-directions-fork::before {\n  content: \"\\f0641\";\n}\n\n.mdi-disc::before {\n  content: \"\\f05ee\";\n}\n\n.mdi-disc-alert::before {\n  content: \"\\f01d1\";\n}\n\n.mdi-disc-player::before {\n  content: \"\\f0960\";\n}\n\n.mdi-discord::before {\n  content: \"\\f066f\";\n}\n\n.mdi-dishwasher::before {\n  content: \"\\f0aac\";\n}\n\n.mdi-dishwasher-alert::before {\n  content: \"\\f11b8\";\n}\n\n.mdi-dishwasher-off::before {\n  content: \"\\f11b9\";\n}\n\n.mdi-disqus::before {\n  content: \"\\f01d2\";\n}\n\n.mdi-distribute-horizontal-center::before {\n  content: \"\\f11c9\";\n}\n\n.mdi-distribute-horizontal-left::before {\n  content: \"\\f11c8\";\n}\n\n.mdi-distribute-horizontal-right::before {\n  content: \"\\f11ca\";\n}\n\n.mdi-distribute-vertical-bottom::before {\n  content: \"\\f11cb\";\n}\n\n.mdi-distribute-vertical-center::before {\n  content: \"\\f11cc\";\n}\n\n.mdi-distribute-vertical-top::before {\n  content: \"\\f11cd\";\n}\n\n.mdi-diversify::before {\n  content: \"\\f1877\";\n}\n\n.mdi-diving::before {\n  content: \"\\f1977\";\n}\n\n.mdi-diving-flippers::before {\n  content: \"\\f0dbf\";\n}\n\n.mdi-diving-helmet::before {\n  content: \"\\f0dc0\";\n}\n\n.mdi-diving-scuba::before {\n  content: \"\\f0dc1\";\n}\n\n.mdi-diving-scuba-flag::before {\n  content: \"\\f0dc2\";\n}\n\n.mdi-diving-scuba-tank::before {\n  content: \"\\f0dc3\";\n}\n\n.mdi-diving-scuba-tank-multiple::before {\n  content: \"\\f0dc4\";\n}\n\n.mdi-diving-snorkel::before {\n  content: \"\\f0dc5\";\n}\n\n.mdi-division::before {\n  content: \"\\f01d4\";\n}\n\n.mdi-division-box::before {\n  content: \"\\f01d5\";\n}\n\n.mdi-dlna::before {\n  content: \"\\f0a41\";\n}\n\n.mdi-dna::before {\n  content: \"\\f0684\";\n}\n\n.mdi-dns::before {\n  content: \"\\f01d6\";\n}\n\n.mdi-dns-outline::before {\n  content: \"\\f0b8c\";\n}\n\n.mdi-dock-bottom::before {\n  content: \"\\f10a9\";\n}\n\n.mdi-dock-left::before {\n  content: \"\\f10aa\";\n}\n\n.mdi-dock-right::before {\n  content: \"\\f10ab\";\n}\n\n.mdi-dock-top::before {\n  content: \"\\f1513\";\n}\n\n.mdi-dock-window::before {\n  content: \"\\f10ac\";\n}\n\n.mdi-docker::before {\n  content: \"\\f0868\";\n}\n\n.mdi-doctor::before {\n  content: \"\\f0a42\";\n}\n\n.mdi-dog::before {\n  content: \"\\f0a43\";\n}\n\n.mdi-dog-service::before {\n  content: \"\\f0aad\";\n}\n\n.mdi-dog-side::before {\n  content: \"\\f0a44\";\n}\n\n.mdi-dog-side-off::before {\n  content: \"\\f16ee\";\n}\n\n.mdi-dolby::before {\n  content: \"\\f06b3\";\n}\n\n.mdi-dolly::before {\n  content: \"\\f0e9e\";\n}\n\n.mdi-dolphin::before {\n  content: \"\\f18b4\";\n}\n\n.mdi-domain::before {\n  content: \"\\f01d7\";\n}\n\n.mdi-domain-off::before {\n  content: \"\\f0d6f\";\n}\n\n.mdi-domain-plus::before {\n  content: \"\\f10ad\";\n}\n\n.mdi-domain-remove::before {\n  content: \"\\f10ae\";\n}\n\n.mdi-dome-light::before {\n  content: \"\\f141e\";\n}\n\n.mdi-domino-mask::before {\n  content: \"\\f1023\";\n}\n\n.mdi-donkey::before {\n  content: \"\\f07c2\";\n}\n\n.mdi-door::before {\n  content: \"\\f081a\";\n}\n\n.mdi-door-closed::before {\n  content: \"\\f081b\";\n}\n\n.mdi-door-closed-lock::before {\n  content: \"\\f10af\";\n}\n\n.mdi-door-open::before {\n  content: \"\\f081c\";\n}\n\n.mdi-door-sliding::before {\n  content: \"\\f181e\";\n}\n\n.mdi-door-sliding-lock::before {\n  content: \"\\f181f\";\n}\n\n.mdi-door-sliding-open::before {\n  content: \"\\f1820\";\n}\n\n.mdi-doorbell::before {\n  content: \"\\f12e6\";\n}\n\n.mdi-doorbell-video::before {\n  content: \"\\f0869\";\n}\n\n.mdi-dot-net::before {\n  content: \"\\f0aae\";\n}\n\n.mdi-dots-circle::before {\n  content: \"\\f1978\";\n}\n\n.mdi-dots-grid::before {\n  content: \"\\f15fc\";\n}\n\n.mdi-dots-hexagon::before {\n  content: \"\\f15ff\";\n}\n\n.mdi-dots-horizontal::before {\n  content: \"\\f01d8\";\n}\n\n.mdi-dots-horizontal-circle::before {\n  content: \"\\f07c3\";\n}\n\n.mdi-dots-horizontal-circle-outline::before {\n  content: \"\\f0b8d\";\n}\n\n.mdi-dots-square::before {\n  content: \"\\f15fd\";\n}\n\n.mdi-dots-triangle::before {\n  content: \"\\f15fe\";\n}\n\n.mdi-dots-vertical::before {\n  content: \"\\f01d9\";\n}\n\n.mdi-dots-vertical-circle::before {\n  content: \"\\f07c4\";\n}\n\n.mdi-dots-vertical-circle-outline::before {\n  content: \"\\f0b8e\";\n}\n\n.mdi-download::before {\n  content: \"\\f01da\";\n}\n\n.mdi-download-box::before {\n  content: \"\\f1462\";\n}\n\n.mdi-download-box-outline::before {\n  content: \"\\f1463\";\n}\n\n.mdi-download-circle::before {\n  content: \"\\f1464\";\n}\n\n.mdi-download-circle-outline::before {\n  content: \"\\f1465\";\n}\n\n.mdi-download-lock::before {\n  content: \"\\f1320\";\n}\n\n.mdi-download-lock-outline::before {\n  content: \"\\f1321\";\n}\n\n.mdi-download-multiple::before {\n  content: \"\\f09e9\";\n}\n\n.mdi-download-network::before {\n  content: \"\\f06f4\";\n}\n\n.mdi-download-network-outline::before {\n  content: \"\\f0c66\";\n}\n\n.mdi-download-off::before {\n  content: \"\\f10b0\";\n}\n\n.mdi-download-off-outline::before {\n  content: \"\\f10b1\";\n}\n\n.mdi-download-outline::before {\n  content: \"\\f0b8f\";\n}\n\n.mdi-drag::before {\n  content: \"\\f01db\";\n}\n\n.mdi-drag-horizontal::before {\n  content: \"\\f01dc\";\n}\n\n.mdi-drag-horizontal-variant::before {\n  content: \"\\f12f0\";\n}\n\n.mdi-drag-variant::before {\n  content: \"\\f0b90\";\n}\n\n.mdi-drag-vertical::before {\n  content: \"\\f01dd\";\n}\n\n.mdi-drag-vertical-variant::before {\n  content: \"\\f12f1\";\n}\n\n.mdi-drama-masks::before {\n  content: \"\\f0d02\";\n}\n\n.mdi-draw::before {\n  content: \"\\f0f49\";\n}\n\n.mdi-draw-pen::before {\n  content: \"\\f19b9\";\n}\n\n.mdi-drawing::before {\n  content: \"\\f01de\";\n}\n\n.mdi-drawing-box::before {\n  content: \"\\f01df\";\n}\n\n.mdi-dresser::before {\n  content: \"\\f0f4a\";\n}\n\n.mdi-dresser-outline::before {\n  content: \"\\f0f4b\";\n}\n\n.mdi-drone::before {\n  content: \"\\f01e2\";\n}\n\n.mdi-dropbox::before {\n  content: \"\\f01e3\";\n}\n\n.mdi-drupal::before {\n  content: \"\\f01e4\";\n}\n\n.mdi-duck::before {\n  content: \"\\f01e5\";\n}\n\n.mdi-dumbbell::before {\n  content: \"\\f01e6\";\n}\n\n.mdi-dump-truck::before {\n  content: \"\\f0c67\";\n}\n\n.mdi-ear-hearing::before {\n  content: \"\\f07c5\";\n}\n\n.mdi-ear-hearing-off::before {\n  content: \"\\f0a45\";\n}\n\n.mdi-earbuds::before {\n  content: \"\\f184f\";\n}\n\n.mdi-earbuds-off::before {\n  content: \"\\f1850\";\n}\n\n.mdi-earbuds-off-outline::before {\n  content: \"\\f1851\";\n}\n\n.mdi-earbuds-outline::before {\n  content: \"\\f1852\";\n}\n\n.mdi-earth::before {\n  content: \"\\f01e7\";\n}\n\n.mdi-earth-arrow-right::before {\n  content: \"\\f1311\";\n}\n\n.mdi-earth-box::before {\n  content: \"\\f06cd\";\n}\n\n.mdi-earth-box-minus::before {\n  content: \"\\f1407\";\n}\n\n.mdi-earth-box-off::before {\n  content: \"\\f06ce\";\n}\n\n.mdi-earth-box-plus::before {\n  content: \"\\f1406\";\n}\n\n.mdi-earth-box-remove::before {\n  content: \"\\f1408\";\n}\n\n.mdi-earth-minus::before {\n  content: \"\\f1404\";\n}\n\n.mdi-earth-off::before {\n  content: \"\\f01e8\";\n}\n\n.mdi-earth-plus::before {\n  content: \"\\f1403\";\n}\n\n.mdi-earth-remove::before {\n  content: \"\\f1405\";\n}\n\n.mdi-egg::before {\n  content: \"\\f0aaf\";\n}\n\n.mdi-egg-easter::before {\n  content: \"\\f0ab0\";\n}\n\n.mdi-egg-fried::before {\n  content: \"\\f184a\";\n}\n\n.mdi-egg-off::before {\n  content: \"\\f13f0\";\n}\n\n.mdi-egg-off-outline::before {\n  content: \"\\f13f1\";\n}\n\n.mdi-egg-outline::before {\n  content: \"\\f13f2\";\n}\n\n.mdi-eiffel-tower::before {\n  content: \"\\f156b\";\n}\n\n.mdi-eight-track::before {\n  content: \"\\f09ea\";\n}\n\n.mdi-eject::before {\n  content: \"\\f01ea\";\n}\n\n.mdi-eject-outline::before {\n  content: \"\\f0b91\";\n}\n\n.mdi-electric-switch::before {\n  content: \"\\f0e9f\";\n}\n\n.mdi-electric-switch-closed::before {\n  content: \"\\f10d9\";\n}\n\n.mdi-electron-framework::before {\n  content: \"\\f1024\";\n}\n\n.mdi-elephant::before {\n  content: \"\\f07c6\";\n}\n\n.mdi-elevation-decline::before {\n  content: \"\\f01eb\";\n}\n\n.mdi-elevation-rise::before {\n  content: \"\\f01ec\";\n}\n\n.mdi-elevator::before {\n  content: \"\\f01ed\";\n}\n\n.mdi-elevator-down::before {\n  content: \"\\f12c2\";\n}\n\n.mdi-elevator-passenger::before {\n  content: \"\\f1381\";\n}\n\n.mdi-elevator-passenger-off::before {\n  content: \"\\f1979\";\n}\n\n.mdi-elevator-passenger-off-outline::before {\n  content: \"\\f197a\";\n}\n\n.mdi-elevator-passenger-outline::before {\n  content: \"\\f197b\";\n}\n\n.mdi-elevator-up::before {\n  content: \"\\f12c1\";\n}\n\n.mdi-ellipse::before {\n  content: \"\\f0ea0\";\n}\n\n.mdi-ellipse-outline::before {\n  content: \"\\f0ea1\";\n}\n\n.mdi-email::before {\n  content: \"\\f01ee\";\n}\n\n.mdi-email-alert::before {\n  content: \"\\f06cf\";\n}\n\n.mdi-email-alert-outline::before {\n  content: \"\\f0d42\";\n}\n\n.mdi-email-box::before {\n  content: \"\\f0d03\";\n}\n\n.mdi-email-check::before {\n  content: \"\\f0ab1\";\n}\n\n.mdi-email-check-outline::before {\n  content: \"\\f0ab2\";\n}\n\n.mdi-email-edit::before {\n  content: \"\\f0ee3\";\n}\n\n.mdi-email-edit-outline::before {\n  content: \"\\f0ee4\";\n}\n\n.mdi-email-fast::before {\n  content: \"\\f186f\";\n}\n\n.mdi-email-fast-outline::before {\n  content: \"\\f1870\";\n}\n\n.mdi-email-lock::before {\n  content: \"\\f01f1\";\n}\n\n.mdi-email-mark-as-unread::before {\n  content: \"\\f0b92\";\n}\n\n.mdi-email-minus::before {\n  content: \"\\f0ee5\";\n}\n\n.mdi-email-minus-outline::before {\n  content: \"\\f0ee6\";\n}\n\n.mdi-email-multiple::before {\n  content: \"\\f0ee7\";\n}\n\n.mdi-email-multiple-outline::before {\n  content: \"\\f0ee8\";\n}\n\n.mdi-email-newsletter::before {\n  content: \"\\f0fb1\";\n}\n\n.mdi-email-off::before {\n  content: \"\\f13e3\";\n}\n\n.mdi-email-off-outline::before {\n  content: \"\\f13e4\";\n}\n\n.mdi-email-open::before {\n  content: \"\\f01ef\";\n}\n\n.mdi-email-open-multiple::before {\n  content: \"\\f0ee9\";\n}\n\n.mdi-email-open-multiple-outline::before {\n  content: \"\\f0eea\";\n}\n\n.mdi-email-open-outline::before {\n  content: \"\\f05ef\";\n}\n\n.mdi-email-outline::before {\n  content: \"\\f01f0\";\n}\n\n.mdi-email-plus::before {\n  content: \"\\f09eb\";\n}\n\n.mdi-email-plus-outline::before {\n  content: \"\\f09ec\";\n}\n\n.mdi-email-receive::before {\n  content: \"\\f10da\";\n}\n\n.mdi-email-receive-outline::before {\n  content: \"\\f10db\";\n}\n\n.mdi-email-remove::before {\n  content: \"\\f1661\";\n}\n\n.mdi-email-remove-outline::before {\n  content: \"\\f1662\";\n}\n\n.mdi-email-seal::before {\n  content: \"\\f195b\";\n}\n\n.mdi-email-seal-outline::before {\n  content: \"\\f195c\";\n}\n\n.mdi-email-search::before {\n  content: \"\\f0961\";\n}\n\n.mdi-email-search-outline::before {\n  content: \"\\f0962\";\n}\n\n.mdi-email-send::before {\n  content: \"\\f10dc\";\n}\n\n.mdi-email-send-outline::before {\n  content: \"\\f10dd\";\n}\n\n.mdi-email-sync::before {\n  content: \"\\f12c7\";\n}\n\n.mdi-email-sync-outline::before {\n  content: \"\\f12c8\";\n}\n\n.mdi-email-variant::before {\n  content: \"\\f05f0\";\n}\n\n.mdi-ember::before {\n  content: \"\\f0b30\";\n}\n\n.mdi-emby::before {\n  content: \"\\f06b4\";\n}\n\n.mdi-emoticon::before {\n  content: \"\\f0c68\";\n}\n\n.mdi-emoticon-angry::before {\n  content: \"\\f0c69\";\n}\n\n.mdi-emoticon-angry-outline::before {\n  content: \"\\f0c6a\";\n}\n\n.mdi-emoticon-confused::before {\n  content: \"\\f10de\";\n}\n\n.mdi-emoticon-confused-outline::before {\n  content: \"\\f10df\";\n}\n\n.mdi-emoticon-cool::before {\n  content: \"\\f0c6b\";\n}\n\n.mdi-emoticon-cool-outline::before {\n  content: \"\\f01f3\";\n}\n\n.mdi-emoticon-cry::before {\n  content: \"\\f0c6c\";\n}\n\n.mdi-emoticon-cry-outline::before {\n  content: \"\\f0c6d\";\n}\n\n.mdi-emoticon-dead::before {\n  content: \"\\f0c6e\";\n}\n\n.mdi-emoticon-dead-outline::before {\n  content: \"\\f069b\";\n}\n\n.mdi-emoticon-devil::before {\n  content: \"\\f0c6f\";\n}\n\n.mdi-emoticon-devil-outline::before {\n  content: \"\\f01f4\";\n}\n\n.mdi-emoticon-excited::before {\n  content: \"\\f0c70\";\n}\n\n.mdi-emoticon-excited-outline::before {\n  content: \"\\f069c\";\n}\n\n.mdi-emoticon-frown::before {\n  content: \"\\f0f4c\";\n}\n\n.mdi-emoticon-frown-outline::before {\n  content: \"\\f0f4d\";\n}\n\n.mdi-emoticon-happy::before {\n  content: \"\\f0c71\";\n}\n\n.mdi-emoticon-happy-outline::before {\n  content: \"\\f01f5\";\n}\n\n.mdi-emoticon-kiss::before {\n  content: \"\\f0c72\";\n}\n\n.mdi-emoticon-kiss-outline::before {\n  content: \"\\f0c73\";\n}\n\n.mdi-emoticon-lol::before {\n  content: \"\\f1214\";\n}\n\n.mdi-emoticon-lol-outline::before {\n  content: \"\\f1215\";\n}\n\n.mdi-emoticon-neutral::before {\n  content: \"\\f0c74\";\n}\n\n.mdi-emoticon-neutral-outline::before {\n  content: \"\\f01f6\";\n}\n\n.mdi-emoticon-outline::before {\n  content: \"\\f01f2\";\n}\n\n.mdi-emoticon-poop::before {\n  content: \"\\f01f7\";\n}\n\n.mdi-emoticon-poop-outline::before {\n  content: \"\\f0c75\";\n}\n\n.mdi-emoticon-sad::before {\n  content: \"\\f0c76\";\n}\n\n.mdi-emoticon-sad-outline::before {\n  content: \"\\f01f8\";\n}\n\n.mdi-emoticon-sick::before {\n  content: \"\\f157c\";\n}\n\n.mdi-emoticon-sick-outline::before {\n  content: \"\\f157d\";\n}\n\n.mdi-emoticon-tongue::before {\n  content: \"\\f01f9\";\n}\n\n.mdi-emoticon-tongue-outline::before {\n  content: \"\\f0c77\";\n}\n\n.mdi-emoticon-wink::before {\n  content: \"\\f0c78\";\n}\n\n.mdi-emoticon-wink-outline::before {\n  content: \"\\f0c79\";\n}\n\n.mdi-engine::before {\n  content: \"\\f01fa\";\n}\n\n.mdi-engine-off::before {\n  content: \"\\f0a46\";\n}\n\n.mdi-engine-off-outline::before {\n  content: \"\\f0a47\";\n}\n\n.mdi-engine-outline::before {\n  content: \"\\f01fb\";\n}\n\n.mdi-epsilon::before {\n  content: \"\\f10e0\";\n}\n\n.mdi-equal::before {\n  content: \"\\f01fc\";\n}\n\n.mdi-equal-box::before {\n  content: \"\\f01fd\";\n}\n\n.mdi-equalizer::before {\n  content: \"\\f0ea2\";\n}\n\n.mdi-equalizer-outline::before {\n  content: \"\\f0ea3\";\n}\n\n.mdi-eraser::before {\n  content: \"\\f01fe\";\n}\n\n.mdi-eraser-variant::before {\n  content: \"\\f0642\";\n}\n\n.mdi-escalator::before {\n  content: \"\\f01ff\";\n}\n\n.mdi-escalator-box::before {\n  content: \"\\f1399\";\n}\n\n.mdi-escalator-down::before {\n  content: \"\\f12c0\";\n}\n\n.mdi-escalator-up::before {\n  content: \"\\f12bf\";\n}\n\n.mdi-eslint::before {\n  content: \"\\f0c7a\";\n}\n\n.mdi-et::before {\n  content: \"\\f0ab3\";\n}\n\n.mdi-ethereum::before {\n  content: \"\\f086a\";\n}\n\n.mdi-ethernet::before {\n  content: \"\\f0200\";\n}\n\n.mdi-ethernet-cable::before {\n  content: \"\\f0201\";\n}\n\n.mdi-ethernet-cable-off::before {\n  content: \"\\f0202\";\n}\n\n.mdi-ev-plug-ccs1::before {\n  content: \"\\f1519\";\n}\n\n.mdi-ev-plug-ccs2::before {\n  content: \"\\f151a\";\n}\n\n.mdi-ev-plug-chademo::before {\n  content: \"\\f151b\";\n}\n\n.mdi-ev-plug-tesla::before {\n  content: \"\\f151c\";\n}\n\n.mdi-ev-plug-type1::before {\n  content: \"\\f151d\";\n}\n\n.mdi-ev-plug-type2::before {\n  content: \"\\f151e\";\n}\n\n.mdi-ev-station::before {\n  content: \"\\f05f1\";\n}\n\n.mdi-evernote::before {\n  content: \"\\f0204\";\n}\n\n.mdi-excavator::before {\n  content: \"\\f1025\";\n}\n\n.mdi-exclamation::before {\n  content: \"\\f0205\";\n}\n\n.mdi-exclamation-thick::before {\n  content: \"\\f1238\";\n}\n\n.mdi-exit-run::before {\n  content: \"\\f0a48\";\n}\n\n.mdi-exit-to-app::before {\n  content: \"\\f0206\";\n}\n\n.mdi-expand-all::before {\n  content: \"\\f0ab4\";\n}\n\n.mdi-expand-all-outline::before {\n  content: \"\\f0ab5\";\n}\n\n.mdi-expansion-card::before {\n  content: \"\\f08ae\";\n}\n\n.mdi-expansion-card-variant::before {\n  content: \"\\f0fb2\";\n}\n\n.mdi-exponent::before {\n  content: \"\\f0963\";\n}\n\n.mdi-exponent-box::before {\n  content: \"\\f0964\";\n}\n\n.mdi-export::before {\n  content: \"\\f0207\";\n}\n\n.mdi-export-variant::before {\n  content: \"\\f0b93\";\n}\n\n.mdi-eye::before {\n  content: \"\\f0208\";\n}\n\n.mdi-eye-arrow-left::before {\n  content: \"\\f18fd\";\n}\n\n.mdi-eye-arrow-left-outline::before {\n  content: \"\\f18fe\";\n}\n\n.mdi-eye-arrow-right::before {\n  content: \"\\f18ff\";\n}\n\n.mdi-eye-arrow-right-outline::before {\n  content: \"\\f1900\";\n}\n\n.mdi-eye-check::before {\n  content: \"\\f0d04\";\n}\n\n.mdi-eye-check-outline::before {\n  content: \"\\f0d05\";\n}\n\n.mdi-eye-circle::before {\n  content: \"\\f0b94\";\n}\n\n.mdi-eye-circle-outline::before {\n  content: \"\\f0b95\";\n}\n\n.mdi-eye-minus::before {\n  content: \"\\f1026\";\n}\n\n.mdi-eye-minus-outline::before {\n  content: \"\\f1027\";\n}\n\n.mdi-eye-off::before {\n  content: \"\\f0209\";\n}\n\n.mdi-eye-off-outline::before {\n  content: \"\\f06d1\";\n}\n\n.mdi-eye-outline::before {\n  content: \"\\f06d0\";\n}\n\n.mdi-eye-plus::before {\n  content: \"\\f086b\";\n}\n\n.mdi-eye-plus-outline::before {\n  content: \"\\f086c\";\n}\n\n.mdi-eye-refresh::before {\n  content: \"\\f197c\";\n}\n\n.mdi-eye-refresh-outline::before {\n  content: \"\\f197d\";\n}\n\n.mdi-eye-remove::before {\n  content: \"\\f15e3\";\n}\n\n.mdi-eye-remove-outline::before {\n  content: \"\\f15e4\";\n}\n\n.mdi-eye-settings::before {\n  content: \"\\f086d\";\n}\n\n.mdi-eye-settings-outline::before {\n  content: \"\\f086e\";\n}\n\n.mdi-eyedropper::before {\n  content: \"\\f020a\";\n}\n\n.mdi-eyedropper-minus::before {\n  content: \"\\f13dd\";\n}\n\n.mdi-eyedropper-off::before {\n  content: \"\\f13df\";\n}\n\n.mdi-eyedropper-plus::before {\n  content: \"\\f13dc\";\n}\n\n.mdi-eyedropper-remove::before {\n  content: \"\\f13de\";\n}\n\n.mdi-eyedropper-variant::before {\n  content: \"\\f020b\";\n}\n\n.mdi-face-agent::before {\n  content: \"\\f0d70\";\n}\n\n.mdi-face-man::before {\n  content: \"\\f0643\";\n}\n\n.mdi-face-man-outline::before {\n  content: \"\\f0b96\";\n}\n\n.mdi-face-man-profile::before {\n  content: \"\\f0644\";\n}\n\n.mdi-face-man-shimmer::before {\n  content: \"\\f15cc\";\n}\n\n.mdi-face-man-shimmer-outline::before {\n  content: \"\\f15cd\";\n}\n\n.mdi-face-mask::before {\n  content: \"\\f1586\";\n}\n\n.mdi-face-mask-outline::before {\n  content: \"\\f1587\";\n}\n\n.mdi-face-recognition::before {\n  content: \"\\f0c7b\";\n}\n\n.mdi-face-woman::before {\n  content: \"\\f1077\";\n}\n\n.mdi-face-woman-outline::before {\n  content: \"\\f1078\";\n}\n\n.mdi-face-woman-profile::before {\n  content: \"\\f1076\";\n}\n\n.mdi-face-woman-shimmer::before {\n  content: \"\\f15ce\";\n}\n\n.mdi-face-woman-shimmer-outline::before {\n  content: \"\\f15cf\";\n}\n\n.mdi-facebook::before {\n  content: \"\\f020c\";\n}\n\n.mdi-facebook-gaming::before {\n  content: \"\\f07dd\";\n}\n\n.mdi-facebook-messenger::before {\n  content: \"\\f020e\";\n}\n\n.mdi-facebook-workplace::before {\n  content: \"\\f0b31\";\n}\n\n.mdi-factory::before {\n  content: \"\\f020f\";\n}\n\n.mdi-family-tree::before {\n  content: \"\\f160e\";\n}\n\n.mdi-fan::before {\n  content: \"\\f0210\";\n}\n\n.mdi-fan-alert::before {\n  content: \"\\f146c\";\n}\n\n.mdi-fan-auto::before {\n  content: \"\\f171d\";\n}\n\n.mdi-fan-chevron-down::before {\n  content: \"\\f146d\";\n}\n\n.mdi-fan-chevron-up::before {\n  content: \"\\f146e\";\n}\n\n.mdi-fan-minus::before {\n  content: \"\\f1470\";\n}\n\n.mdi-fan-off::before {\n  content: \"\\f081d\";\n}\n\n.mdi-fan-plus::before {\n  content: \"\\f146f\";\n}\n\n.mdi-fan-remove::before {\n  content: \"\\f1471\";\n}\n\n.mdi-fan-speed-1::before {\n  content: \"\\f1472\";\n}\n\n.mdi-fan-speed-2::before {\n  content: \"\\f1473\";\n}\n\n.mdi-fan-speed-3::before {\n  content: \"\\f1474\";\n}\n\n.mdi-fast-forward::before {\n  content: \"\\f0211\";\n}\n\n.mdi-fast-forward-10::before {\n  content: \"\\f0d71\";\n}\n\n.mdi-fast-forward-15::before {\n  content: \"\\f193a\";\n}\n\n.mdi-fast-forward-30::before {\n  content: \"\\f0d06\";\n}\n\n.mdi-fast-forward-5::before {\n  content: \"\\f11f8\";\n}\n\n.mdi-fast-forward-60::before {\n  content: \"\\f160b\";\n}\n\n.mdi-fast-forward-outline::before {\n  content: \"\\f06d2\";\n}\n\n.mdi-fax::before {\n  content: \"\\f0212\";\n}\n\n.mdi-feather::before {\n  content: \"\\f06d3\";\n}\n\n.mdi-feature-search::before {\n  content: \"\\f0a49\";\n}\n\n.mdi-feature-search-outline::before {\n  content: \"\\f0a4a\";\n}\n\n.mdi-fedora::before {\n  content: \"\\f08db\";\n}\n\n.mdi-fence::before {\n  content: \"\\f179a\";\n}\n\n.mdi-fence-electric::before {\n  content: \"\\f17f6\";\n}\n\n.mdi-fencing::before {\n  content: \"\\f14c1\";\n}\n\n.mdi-ferris-wheel::before {\n  content: \"\\f0ea4\";\n}\n\n.mdi-ferry::before {\n  content: \"\\f0213\";\n}\n\n.mdi-file::before {\n  content: \"\\f0214\";\n}\n\n.mdi-file-account::before {\n  content: \"\\f073b\";\n}\n\n.mdi-file-account-outline::before {\n  content: \"\\f1028\";\n}\n\n.mdi-file-alert::before {\n  content: \"\\f0a4b\";\n}\n\n.mdi-file-alert-outline::before {\n  content: \"\\f0a4c\";\n}\n\n.mdi-file-cabinet::before {\n  content: \"\\f0ab6\";\n}\n\n.mdi-file-cad::before {\n  content: \"\\f0eeb\";\n}\n\n.mdi-file-cad-box::before {\n  content: \"\\f0eec\";\n}\n\n.mdi-file-cancel::before {\n  content: \"\\f0dc6\";\n}\n\n.mdi-file-cancel-outline::before {\n  content: \"\\f0dc7\";\n}\n\n.mdi-file-certificate::before {\n  content: \"\\f1186\";\n}\n\n.mdi-file-certificate-outline::before {\n  content: \"\\f1187\";\n}\n\n.mdi-file-chart::before {\n  content: \"\\f0215\";\n}\n\n.mdi-file-chart-outline::before {\n  content: \"\\f1029\";\n}\n\n.mdi-file-check::before {\n  content: \"\\f0216\";\n}\n\n.mdi-file-check-outline::before {\n  content: \"\\f0e29\";\n}\n\n.mdi-file-clock::before {\n  content: \"\\f12e1\";\n}\n\n.mdi-file-clock-outline::before {\n  content: \"\\f12e2\";\n}\n\n.mdi-file-cloud::before {\n  content: \"\\f0217\";\n}\n\n.mdi-file-cloud-outline::before {\n  content: \"\\f102a\";\n}\n\n.mdi-file-code::before {\n  content: \"\\f022e\";\n}\n\n.mdi-file-code-outline::before {\n  content: \"\\f102b\";\n}\n\n.mdi-file-cog::before {\n  content: \"\\f107b\";\n}\n\n.mdi-file-cog-outline::before {\n  content: \"\\f107c\";\n}\n\n.mdi-file-compare::before {\n  content: \"\\f08aa\";\n}\n\n.mdi-file-delimited::before {\n  content: \"\\f0218\";\n}\n\n.mdi-file-delimited-outline::before {\n  content: \"\\f0ea5\";\n}\n\n.mdi-file-document::before {\n  content: \"\\f0219\";\n}\n\n.mdi-file-document-edit::before {\n  content: \"\\f0dc8\";\n}\n\n.mdi-file-document-edit-outline::before {\n  content: \"\\f0dc9\";\n}\n\n.mdi-file-document-multiple::before {\n  content: \"\\f1517\";\n}\n\n.mdi-file-document-multiple-outline::before {\n  content: \"\\f1518\";\n}\n\n.mdi-file-document-outline::before {\n  content: \"\\f09ee\";\n}\n\n.mdi-file-download::before {\n  content: \"\\f0965\";\n}\n\n.mdi-file-download-outline::before {\n  content: \"\\f0966\";\n}\n\n.mdi-file-edit::before {\n  content: \"\\f11e7\";\n}\n\n.mdi-file-edit-outline::before {\n  content: \"\\f11e8\";\n}\n\n.mdi-file-excel::before {\n  content: \"\\f021b\";\n}\n\n.mdi-file-excel-box::before {\n  content: \"\\f021c\";\n}\n\n.mdi-file-excel-box-outline::before {\n  content: \"\\f102c\";\n}\n\n.mdi-file-excel-outline::before {\n  content: \"\\f102d\";\n}\n\n.mdi-file-export::before {\n  content: \"\\f021d\";\n}\n\n.mdi-file-export-outline::before {\n  content: \"\\f102e\";\n}\n\n.mdi-file-eye::before {\n  content: \"\\f0dca\";\n}\n\n.mdi-file-eye-outline::before {\n  content: \"\\f0dcb\";\n}\n\n.mdi-file-find::before {\n  content: \"\\f021e\";\n}\n\n.mdi-file-find-outline::before {\n  content: \"\\f0b97\";\n}\n\n.mdi-file-gif-box::before {\n  content: \"\\f0d78\";\n}\n\n.mdi-file-hidden::before {\n  content: \"\\f0613\";\n}\n\n.mdi-file-image::before {\n  content: \"\\f021f\";\n}\n\n.mdi-file-image-marker::before {\n  content: \"\\f1772\";\n}\n\n.mdi-file-image-marker-outline::before {\n  content: \"\\f1773\";\n}\n\n.mdi-file-image-minus::before {\n  content: \"\\f193b\";\n}\n\n.mdi-file-image-minus-outline::before {\n  content: \"\\f193c\";\n}\n\n.mdi-file-image-outline::before {\n  content: \"\\f0eb0\";\n}\n\n.mdi-file-image-plus::before {\n  content: \"\\f193d\";\n}\n\n.mdi-file-image-plus-outline::before {\n  content: \"\\f193e\";\n}\n\n.mdi-file-image-remove::before {\n  content: \"\\f193f\";\n}\n\n.mdi-file-image-remove-outline::before {\n  content: \"\\f1940\";\n}\n\n.mdi-file-import::before {\n  content: \"\\f0220\";\n}\n\n.mdi-file-import-outline::before {\n  content: \"\\f102f\";\n}\n\n.mdi-file-jpg-box::before {\n  content: \"\\f0225\";\n}\n\n.mdi-file-key::before {\n  content: \"\\f1184\";\n}\n\n.mdi-file-key-outline::before {\n  content: \"\\f1185\";\n}\n\n.mdi-file-link::before {\n  content: \"\\f1177\";\n}\n\n.mdi-file-link-outline::before {\n  content: \"\\f1178\";\n}\n\n.mdi-file-lock::before {\n  content: \"\\f0221\";\n}\n\n.mdi-file-lock-outline::before {\n  content: \"\\f1030\";\n}\n\n.mdi-file-marker::before {\n  content: \"\\f1774\";\n}\n\n.mdi-file-marker-outline::before {\n  content: \"\\f1775\";\n}\n\n.mdi-file-move::before {\n  content: \"\\f0ab9\";\n}\n\n.mdi-file-move-outline::before {\n  content: \"\\f1031\";\n}\n\n.mdi-file-multiple::before {\n  content: \"\\f0222\";\n}\n\n.mdi-file-multiple-outline::before {\n  content: \"\\f1032\";\n}\n\n.mdi-file-music::before {\n  content: \"\\f0223\";\n}\n\n.mdi-file-music-outline::before {\n  content: \"\\f0e2a\";\n}\n\n.mdi-file-outline::before {\n  content: \"\\f0224\";\n}\n\n.mdi-file-pdf-box::before {\n  content: \"\\f0226\";\n}\n\n.mdi-file-percent::before {\n  content: \"\\f081e\";\n}\n\n.mdi-file-percent-outline::before {\n  content: \"\\f1033\";\n}\n\n.mdi-file-phone::before {\n  content: \"\\f1179\";\n}\n\n.mdi-file-phone-outline::before {\n  content: \"\\f117a\";\n}\n\n.mdi-file-plus::before {\n  content: \"\\f0752\";\n}\n\n.mdi-file-plus-outline::before {\n  content: \"\\f0eed\";\n}\n\n.mdi-file-png-box::before {\n  content: \"\\f0e2d\";\n}\n\n.mdi-file-powerpoint::before {\n  content: \"\\f0227\";\n}\n\n.mdi-file-powerpoint-box::before {\n  content: \"\\f0228\";\n}\n\n.mdi-file-powerpoint-box-outline::before {\n  content: \"\\f1034\";\n}\n\n.mdi-file-powerpoint-outline::before {\n  content: \"\\f1035\";\n}\n\n.mdi-file-presentation-box::before {\n  content: \"\\f0229\";\n}\n\n.mdi-file-question::before {\n  content: \"\\f086f\";\n}\n\n.mdi-file-question-outline::before {\n  content: \"\\f1036\";\n}\n\n.mdi-file-refresh::before {\n  content: \"\\f0918\";\n}\n\n.mdi-file-refresh-outline::before {\n  content: \"\\f0541\";\n}\n\n.mdi-file-remove::before {\n  content: \"\\f0b98\";\n}\n\n.mdi-file-remove-outline::before {\n  content: \"\\f1037\";\n}\n\n.mdi-file-replace::before {\n  content: \"\\f0b32\";\n}\n\n.mdi-file-replace-outline::before {\n  content: \"\\f0b33\";\n}\n\n.mdi-file-restore::before {\n  content: \"\\f0670\";\n}\n\n.mdi-file-restore-outline::before {\n  content: \"\\f1038\";\n}\n\n.mdi-file-search::before {\n  content: \"\\f0c7c\";\n}\n\n.mdi-file-search-outline::before {\n  content: \"\\f0c7d\";\n}\n\n.mdi-file-send::before {\n  content: \"\\f022a\";\n}\n\n.mdi-file-send-outline::before {\n  content: \"\\f1039\";\n}\n\n.mdi-file-settings::before {\n  content: \"\\f1079\";\n}\n\n.mdi-file-settings-outline::before {\n  content: \"\\f107a\";\n}\n\n.mdi-file-sign::before {\n  content: \"\\f19c3\";\n}\n\n.mdi-file-star::before {\n  content: \"\\f103a\";\n}\n\n.mdi-file-star-outline::before {\n  content: \"\\f103b\";\n}\n\n.mdi-file-swap::before {\n  content: \"\\f0fb4\";\n}\n\n.mdi-file-swap-outline::before {\n  content: \"\\f0fb5\";\n}\n\n.mdi-file-sync::before {\n  content: \"\\f1216\";\n}\n\n.mdi-file-sync-outline::before {\n  content: \"\\f1217\";\n}\n\n.mdi-file-table::before {\n  content: \"\\f0c7e\";\n}\n\n.mdi-file-table-box::before {\n  content: \"\\f10e1\";\n}\n\n.mdi-file-table-box-multiple::before {\n  content: \"\\f10e2\";\n}\n\n.mdi-file-table-box-multiple-outline::before {\n  content: \"\\f10e3\";\n}\n\n.mdi-file-table-box-outline::before {\n  content: \"\\f10e4\";\n}\n\n.mdi-file-table-outline::before {\n  content: \"\\f0c7f\";\n}\n\n.mdi-file-tree::before {\n  content: \"\\f0645\";\n}\n\n.mdi-file-tree-outline::before {\n  content: \"\\f13d2\";\n}\n\n.mdi-file-undo::before {\n  content: \"\\f08dc\";\n}\n\n.mdi-file-undo-outline::before {\n  content: \"\\f103c\";\n}\n\n.mdi-file-upload::before {\n  content: \"\\f0a4d\";\n}\n\n.mdi-file-upload-outline::before {\n  content: \"\\f0a4e\";\n}\n\n.mdi-file-video::before {\n  content: \"\\f022b\";\n}\n\n.mdi-file-video-outline::before {\n  content: \"\\f0e2c\";\n}\n\n.mdi-file-word::before {\n  content: \"\\f022c\";\n}\n\n.mdi-file-word-box::before {\n  content: \"\\f022d\";\n}\n\n.mdi-file-word-box-outline::before {\n  content: \"\\f103d\";\n}\n\n.mdi-file-word-outline::before {\n  content: \"\\f103e\";\n}\n\n.mdi-film::before {\n  content: \"\\f022f\";\n}\n\n.mdi-filmstrip::before {\n  content: \"\\f0230\";\n}\n\n.mdi-filmstrip-box::before {\n  content: \"\\f0332\";\n}\n\n.mdi-filmstrip-box-multiple::before {\n  content: \"\\f0d18\";\n}\n\n.mdi-filmstrip-off::before {\n  content: \"\\f0231\";\n}\n\n.mdi-filter::before {\n  content: \"\\f0232\";\n}\n\n.mdi-filter-check::before {\n  content: \"\\f18ec\";\n}\n\n.mdi-filter-check-outline::before {\n  content: \"\\f18ed\";\n}\n\n.mdi-filter-menu::before {\n  content: \"\\f10e5\";\n}\n\n.mdi-filter-menu-outline::before {\n  content: \"\\f10e6\";\n}\n\n.mdi-filter-minus::before {\n  content: \"\\f0eee\";\n}\n\n.mdi-filter-minus-outline::before {\n  content: \"\\f0eef\";\n}\n\n.mdi-filter-off::before {\n  content: \"\\f14ef\";\n}\n\n.mdi-filter-off-outline::before {\n  content: \"\\f14f0\";\n}\n\n.mdi-filter-outline::before {\n  content: \"\\f0233\";\n}\n\n.mdi-filter-plus::before {\n  content: \"\\f0ef0\";\n}\n\n.mdi-filter-plus-outline::before {\n  content: \"\\f0ef1\";\n}\n\n.mdi-filter-remove::before {\n  content: \"\\f0234\";\n}\n\n.mdi-filter-remove-outline::before {\n  content: \"\\f0235\";\n}\n\n.mdi-filter-variant::before {\n  content: \"\\f0236\";\n}\n\n.mdi-filter-variant-minus::before {\n  content: \"\\f1112\";\n}\n\n.mdi-filter-variant-plus::before {\n  content: \"\\f1113\";\n}\n\n.mdi-filter-variant-remove::before {\n  content: \"\\f103f\";\n}\n\n.mdi-finance::before {\n  content: \"\\f081f\";\n}\n\n.mdi-find-replace::before {\n  content: \"\\f06d4\";\n}\n\n.mdi-fingerprint::before {\n  content: \"\\f0237\";\n}\n\n.mdi-fingerprint-off::before {\n  content: \"\\f0eb1\";\n}\n\n.mdi-fire::before {\n  content: \"\\f0238\";\n}\n\n.mdi-fire-alert::before {\n  content: \"\\f15d7\";\n}\n\n.mdi-fire-circle::before {\n  content: \"\\f1807\";\n}\n\n.mdi-fire-extinguisher::before {\n  content: \"\\f0ef2\";\n}\n\n.mdi-fire-hydrant::before {\n  content: \"\\f1137\";\n}\n\n.mdi-fire-hydrant-alert::before {\n  content: \"\\f1138\";\n}\n\n.mdi-fire-hydrant-off::before {\n  content: \"\\f1139\";\n}\n\n.mdi-fire-off::before {\n  content: \"\\f1722\";\n}\n\n.mdi-fire-truck::before {\n  content: \"\\f08ab\";\n}\n\n.mdi-firebase::before {\n  content: \"\\f0967\";\n}\n\n.mdi-firefox::before {\n  content: \"\\f0239\";\n}\n\n.mdi-fireplace::before {\n  content: \"\\f0e2e\";\n}\n\n.mdi-fireplace-off::before {\n  content: \"\\f0e2f\";\n}\n\n.mdi-firewire::before {\n  content: \"\\f05be\";\n}\n\n.mdi-firework::before {\n  content: \"\\f0e30\";\n}\n\n.mdi-firework-off::before {\n  content: \"\\f1723\";\n}\n\n.mdi-fish::before {\n  content: \"\\f023a\";\n}\n\n.mdi-fish-off::before {\n  content: \"\\f13f3\";\n}\n\n.mdi-fishbowl::before {\n  content: \"\\f0ef3\";\n}\n\n.mdi-fishbowl-outline::before {\n  content: \"\\f0ef4\";\n}\n\n.mdi-fit-to-page::before {\n  content: \"\\f0ef5\";\n}\n\n.mdi-fit-to-page-outline::before {\n  content: \"\\f0ef6\";\n}\n\n.mdi-fit-to-screen::before {\n  content: \"\\f18f4\";\n}\n\n.mdi-fit-to-screen-outline::before {\n  content: \"\\f18f5\";\n}\n\n.mdi-flag::before {\n  content: \"\\f023b\";\n}\n\n.mdi-flag-checkered::before {\n  content: \"\\f023c\";\n}\n\n.mdi-flag-minus::before {\n  content: \"\\f0b99\";\n}\n\n.mdi-flag-minus-outline::before {\n  content: \"\\f10b2\";\n}\n\n.mdi-flag-off::before {\n  content: \"\\f18ee\";\n}\n\n.mdi-flag-off-outline::before {\n  content: \"\\f18ef\";\n}\n\n.mdi-flag-outline::before {\n  content: \"\\f023d\";\n}\n\n.mdi-flag-plus::before {\n  content: \"\\f0b9a\";\n}\n\n.mdi-flag-plus-outline::before {\n  content: \"\\f10b3\";\n}\n\n.mdi-flag-remove::before {\n  content: \"\\f0b9b\";\n}\n\n.mdi-flag-remove-outline::before {\n  content: \"\\f10b4\";\n}\n\n.mdi-flag-triangle::before {\n  content: \"\\f023f\";\n}\n\n.mdi-flag-variant::before {\n  content: \"\\f0240\";\n}\n\n.mdi-flag-variant-outline::before {\n  content: \"\\f023e\";\n}\n\n.mdi-flare::before {\n  content: \"\\f0d72\";\n}\n\n.mdi-flash::before {\n  content: \"\\f0241\";\n}\n\n.mdi-flash-alert::before {\n  content: \"\\f0ef7\";\n}\n\n.mdi-flash-alert-outline::before {\n  content: \"\\f0ef8\";\n}\n\n.mdi-flash-auto::before {\n  content: \"\\f0242\";\n}\n\n.mdi-flash-off::before {\n  content: \"\\f0243\";\n}\n\n.mdi-flash-outline::before {\n  content: \"\\f06d5\";\n}\n\n.mdi-flash-red-eye::before {\n  content: \"\\f067b\";\n}\n\n.mdi-flashlight::before {\n  content: \"\\f0244\";\n}\n\n.mdi-flashlight-off::before {\n  content: \"\\f0245\";\n}\n\n.mdi-flask::before {\n  content: \"\\f0093\";\n}\n\n.mdi-flask-empty::before {\n  content: \"\\f0094\";\n}\n\n.mdi-flask-empty-minus::before {\n  content: \"\\f123a\";\n}\n\n.mdi-flask-empty-minus-outline::before {\n  content: \"\\f123b\";\n}\n\n.mdi-flask-empty-off::before {\n  content: \"\\f13f4\";\n}\n\n.mdi-flask-empty-off-outline::before {\n  content: \"\\f13f5\";\n}\n\n.mdi-flask-empty-outline::before {\n  content: \"\\f0095\";\n}\n\n.mdi-flask-empty-plus::before {\n  content: \"\\f123c\";\n}\n\n.mdi-flask-empty-plus-outline::before {\n  content: \"\\f123d\";\n}\n\n.mdi-flask-empty-remove::before {\n  content: \"\\f123e\";\n}\n\n.mdi-flask-empty-remove-outline::before {\n  content: \"\\f123f\";\n}\n\n.mdi-flask-minus::before {\n  content: \"\\f1240\";\n}\n\n.mdi-flask-minus-outline::before {\n  content: \"\\f1241\";\n}\n\n.mdi-flask-off::before {\n  content: \"\\f13f6\";\n}\n\n.mdi-flask-off-outline::before {\n  content: \"\\f13f7\";\n}\n\n.mdi-flask-outline::before {\n  content: \"\\f0096\";\n}\n\n.mdi-flask-plus::before {\n  content: \"\\f1242\";\n}\n\n.mdi-flask-plus-outline::before {\n  content: \"\\f1243\";\n}\n\n.mdi-flask-remove::before {\n  content: \"\\f1244\";\n}\n\n.mdi-flask-remove-outline::before {\n  content: \"\\f1245\";\n}\n\n.mdi-flask-round-bottom::before {\n  content: \"\\f124b\";\n}\n\n.mdi-flask-round-bottom-empty::before {\n  content: \"\\f124c\";\n}\n\n.mdi-flask-round-bottom-empty-outline::before {\n  content: \"\\f124d\";\n}\n\n.mdi-flask-round-bottom-outline::before {\n  content: \"\\f124e\";\n}\n\n.mdi-fleur-de-lis::before {\n  content: \"\\f1303\";\n}\n\n.mdi-flip-horizontal::before {\n  content: \"\\f10e7\";\n}\n\n.mdi-flip-to-back::before {\n  content: \"\\f0247\";\n}\n\n.mdi-flip-to-front::before {\n  content: \"\\f0248\";\n}\n\n.mdi-flip-vertical::before {\n  content: \"\\f10e8\";\n}\n\n.mdi-floor-lamp::before {\n  content: \"\\f08dd\";\n}\n\n.mdi-floor-lamp-dual::before {\n  content: \"\\f1040\";\n}\n\n.mdi-floor-lamp-dual-outline::before {\n  content: \"\\f17ce\";\n}\n\n.mdi-floor-lamp-outline::before {\n  content: \"\\f17c8\";\n}\n\n.mdi-floor-lamp-torchiere::before {\n  content: \"\\f1747\";\n}\n\n.mdi-floor-lamp-torchiere-outline::before {\n  content: \"\\f17d6\";\n}\n\n.mdi-floor-lamp-torchiere-variant::before {\n  content: \"\\f1041\";\n}\n\n.mdi-floor-lamp-torchiere-variant-outline::before {\n  content: \"\\f17cf\";\n}\n\n.mdi-floor-plan::before {\n  content: \"\\f0821\";\n}\n\n.mdi-floppy::before {\n  content: \"\\f0249\";\n}\n\n.mdi-floppy-variant::before {\n  content: \"\\f09ef\";\n}\n\n.mdi-flower::before {\n  content: \"\\f024a\";\n}\n\n.mdi-flower-outline::before {\n  content: \"\\f09f0\";\n}\n\n.mdi-flower-pollen::before {\n  content: \"\\f1885\";\n}\n\n.mdi-flower-pollen-outline::before {\n  content: \"\\f1886\";\n}\n\n.mdi-flower-poppy::before {\n  content: \"\\f0d08\";\n}\n\n.mdi-flower-tulip::before {\n  content: \"\\f09f1\";\n}\n\n.mdi-flower-tulip-outline::before {\n  content: \"\\f09f2\";\n}\n\n.mdi-focus-auto::before {\n  content: \"\\f0f4e\";\n}\n\n.mdi-focus-field::before {\n  content: \"\\f0f4f\";\n}\n\n.mdi-focus-field-horizontal::before {\n  content: \"\\f0f50\";\n}\n\n.mdi-focus-field-vertical::before {\n  content: \"\\f0f51\";\n}\n\n.mdi-folder::before {\n  content: \"\\f024b\";\n}\n\n.mdi-folder-account::before {\n  content: \"\\f024c\";\n}\n\n.mdi-folder-account-outline::before {\n  content: \"\\f0b9c\";\n}\n\n.mdi-folder-alert::before {\n  content: \"\\f0dcc\";\n}\n\n.mdi-folder-alert-outline::before {\n  content: \"\\f0dcd\";\n}\n\n.mdi-folder-check::before {\n  content: \"\\f197e\";\n}\n\n.mdi-folder-check-outline::before {\n  content: \"\\f197f\";\n}\n\n.mdi-folder-clock::before {\n  content: \"\\f0aba\";\n}\n\n.mdi-folder-clock-outline::before {\n  content: \"\\f0abb\";\n}\n\n.mdi-folder-cog::before {\n  content: \"\\f107f\";\n}\n\n.mdi-folder-cog-outline::before {\n  content: \"\\f1080\";\n}\n\n.mdi-folder-download::before {\n  content: \"\\f024d\";\n}\n\n.mdi-folder-download-outline::before {\n  content: \"\\f10e9\";\n}\n\n.mdi-folder-edit::before {\n  content: \"\\f08de\";\n}\n\n.mdi-folder-edit-outline::before {\n  content: \"\\f0dce\";\n}\n\n.mdi-folder-eye::before {\n  content: \"\\f178a\";\n}\n\n.mdi-folder-eye-outline::before {\n  content: \"\\f178b\";\n}\n\n.mdi-folder-google-drive::before {\n  content: \"\\f024e\";\n}\n\n.mdi-folder-heart::before {\n  content: \"\\f10ea\";\n}\n\n.mdi-folder-heart-outline::before {\n  content: \"\\f10eb\";\n}\n\n.mdi-folder-hidden::before {\n  content: \"\\f179e\";\n}\n\n.mdi-folder-home::before {\n  content: \"\\f10b5\";\n}\n\n.mdi-folder-home-outline::before {\n  content: \"\\f10b6\";\n}\n\n.mdi-folder-image::before {\n  content: \"\\f024f\";\n}\n\n.mdi-folder-information::before {\n  content: \"\\f10b7\";\n}\n\n.mdi-folder-information-outline::before {\n  content: \"\\f10b8\";\n}\n\n.mdi-folder-key::before {\n  content: \"\\f08ac\";\n}\n\n.mdi-folder-key-network::before {\n  content: \"\\f08ad\";\n}\n\n.mdi-folder-key-network-outline::before {\n  content: \"\\f0c80\";\n}\n\n.mdi-folder-key-outline::before {\n  content: \"\\f10ec\";\n}\n\n.mdi-folder-lock::before {\n  content: \"\\f0250\";\n}\n\n.mdi-folder-lock-open::before {\n  content: \"\\f0251\";\n}\n\n.mdi-folder-marker::before {\n  content: \"\\f126d\";\n}\n\n.mdi-folder-marker-outline::before {\n  content: \"\\f126e\";\n}\n\n.mdi-folder-move::before {\n  content: \"\\f0252\";\n}\n\n.mdi-folder-move-outline::before {\n  content: \"\\f1246\";\n}\n\n.mdi-folder-multiple::before {\n  content: \"\\f0253\";\n}\n\n.mdi-folder-multiple-image::before {\n  content: \"\\f0254\";\n}\n\n.mdi-folder-multiple-outline::before {\n  content: \"\\f0255\";\n}\n\n.mdi-folder-multiple-plus::before {\n  content: \"\\f147e\";\n}\n\n.mdi-folder-multiple-plus-outline::before {\n  content: \"\\f147f\";\n}\n\n.mdi-folder-music::before {\n  content: \"\\f1359\";\n}\n\n.mdi-folder-music-outline::before {\n  content: \"\\f135a\";\n}\n\n.mdi-folder-network::before {\n  content: \"\\f0870\";\n}\n\n.mdi-folder-network-outline::before {\n  content: \"\\f0c81\";\n}\n\n.mdi-folder-open::before {\n  content: \"\\f0770\";\n}\n\n.mdi-folder-open-outline::before {\n  content: \"\\f0dcf\";\n}\n\n.mdi-folder-outline::before {\n  content: \"\\f0256\";\n}\n\n.mdi-folder-plus::before {\n  content: \"\\f0257\";\n}\n\n.mdi-folder-plus-outline::before {\n  content: \"\\f0b9d\";\n}\n\n.mdi-folder-pound::before {\n  content: \"\\f0d09\";\n}\n\n.mdi-folder-pound-outline::before {\n  content: \"\\f0d0a\";\n}\n\n.mdi-folder-refresh::before {\n  content: \"\\f0749\";\n}\n\n.mdi-folder-refresh-outline::before {\n  content: \"\\f0542\";\n}\n\n.mdi-folder-remove::before {\n  content: \"\\f0258\";\n}\n\n.mdi-folder-remove-outline::before {\n  content: \"\\f0b9e\";\n}\n\n.mdi-folder-search::before {\n  content: \"\\f0968\";\n}\n\n.mdi-folder-search-outline::before {\n  content: \"\\f0969\";\n}\n\n.mdi-folder-settings::before {\n  content: \"\\f107d\";\n}\n\n.mdi-folder-settings-outline::before {\n  content: \"\\f107e\";\n}\n\n.mdi-folder-star::before {\n  content: \"\\f069d\";\n}\n\n.mdi-folder-star-multiple::before {\n  content: \"\\f13d3\";\n}\n\n.mdi-folder-star-multiple-outline::before {\n  content: \"\\f13d4\";\n}\n\n.mdi-folder-star-outline::before {\n  content: \"\\f0b9f\";\n}\n\n.mdi-folder-swap::before {\n  content: \"\\f0fb6\";\n}\n\n.mdi-folder-swap-outline::before {\n  content: \"\\f0fb7\";\n}\n\n.mdi-folder-sync::before {\n  content: \"\\f0d0b\";\n}\n\n.mdi-folder-sync-outline::before {\n  content: \"\\f0d0c\";\n}\n\n.mdi-folder-table::before {\n  content: \"\\f12e3\";\n}\n\n.mdi-folder-table-outline::before {\n  content: \"\\f12e4\";\n}\n\n.mdi-folder-text::before {\n  content: \"\\f0c82\";\n}\n\n.mdi-folder-text-outline::before {\n  content: \"\\f0c83\";\n}\n\n.mdi-folder-upload::before {\n  content: \"\\f0259\";\n}\n\n.mdi-folder-upload-outline::before {\n  content: \"\\f10ed\";\n}\n\n.mdi-folder-zip::before {\n  content: \"\\f06eb\";\n}\n\n.mdi-folder-zip-outline::before {\n  content: \"\\f07b9\";\n}\n\n.mdi-font-awesome::before {\n  content: \"\\f003a\";\n}\n\n.mdi-food::before {\n  content: \"\\f025a\";\n}\n\n.mdi-food-apple::before {\n  content: \"\\f025b\";\n}\n\n.mdi-food-apple-outline::before {\n  content: \"\\f0c84\";\n}\n\n.mdi-food-croissant::before {\n  content: \"\\f07c8\";\n}\n\n.mdi-food-drumstick::before {\n  content: \"\\f141f\";\n}\n\n.mdi-food-drumstick-off::before {\n  content: \"\\f1468\";\n}\n\n.mdi-food-drumstick-off-outline::before {\n  content: \"\\f1469\";\n}\n\n.mdi-food-drumstick-outline::before {\n  content: \"\\f1420\";\n}\n\n.mdi-food-fork-drink::before {\n  content: \"\\f05f2\";\n}\n\n.mdi-food-halal::before {\n  content: \"\\f1572\";\n}\n\n.mdi-food-hot-dog::before {\n  content: \"\\f184b\";\n}\n\n.mdi-food-kosher::before {\n  content: \"\\f1573\";\n}\n\n.mdi-food-off::before {\n  content: \"\\f05f3\";\n}\n\n.mdi-food-off-outline::before {\n  content: \"\\f1915\";\n}\n\n.mdi-food-outline::before {\n  content: \"\\f1916\";\n}\n\n.mdi-food-steak::before {\n  content: \"\\f146a\";\n}\n\n.mdi-food-steak-off::before {\n  content: \"\\f146b\";\n}\n\n.mdi-food-takeout-box::before {\n  content: \"\\f1836\";\n}\n\n.mdi-food-takeout-box-outline::before {\n  content: \"\\f1837\";\n}\n\n.mdi-food-turkey::before {\n  content: \"\\f171c\";\n}\n\n.mdi-food-variant::before {\n  content: \"\\f025c\";\n}\n\n.mdi-food-variant-off::before {\n  content: \"\\f13e5\";\n}\n\n.mdi-foot-print::before {\n  content: \"\\f0f52\";\n}\n\n.mdi-football::before {\n  content: \"\\f025d\";\n}\n\n.mdi-football-australian::before {\n  content: \"\\f025e\";\n}\n\n.mdi-football-helmet::before {\n  content: \"\\f025f\";\n}\n\n.mdi-forest::before {\n  content: \"\\f1897\";\n}\n\n.mdi-forklift::before {\n  content: \"\\f07c9\";\n}\n\n.mdi-form-dropdown::before {\n  content: \"\\f1400\";\n}\n\n.mdi-form-select::before {\n  content: \"\\f1401\";\n}\n\n.mdi-form-textarea::before {\n  content: \"\\f1095\";\n}\n\n.mdi-form-textbox::before {\n  content: \"\\f060e\";\n}\n\n.mdi-form-textbox-lock::before {\n  content: \"\\f135d\";\n}\n\n.mdi-form-textbox-password::before {\n  content: \"\\f07f5\";\n}\n\n.mdi-format-align-bottom::before {\n  content: \"\\f0753\";\n}\n\n.mdi-format-align-center::before {\n  content: \"\\f0260\";\n}\n\n.mdi-format-align-justify::before {\n  content: \"\\f0261\";\n}\n\n.mdi-format-align-left::before {\n  content: \"\\f0262\";\n}\n\n.mdi-format-align-middle::before {\n  content: \"\\f0754\";\n}\n\n.mdi-format-align-right::before {\n  content: \"\\f0263\";\n}\n\n.mdi-format-align-top::before {\n  content: \"\\f0755\";\n}\n\n.mdi-format-annotation-minus::before {\n  content: \"\\f0abc\";\n}\n\n.mdi-format-annotation-plus::before {\n  content: \"\\f0646\";\n}\n\n.mdi-format-bold::before {\n  content: \"\\f0264\";\n}\n\n.mdi-format-clear::before {\n  content: \"\\f0265\";\n}\n\n.mdi-format-color-fill::before {\n  content: \"\\f0266\";\n}\n\n.mdi-format-color-highlight::before {\n  content: \"\\f0e31\";\n}\n\n.mdi-format-color-marker-cancel::before {\n  content: \"\\f1313\";\n}\n\n.mdi-format-color-text::before {\n  content: \"\\f069e\";\n}\n\n.mdi-format-columns::before {\n  content: \"\\f08df\";\n}\n\n.mdi-format-float-center::before {\n  content: \"\\f0267\";\n}\n\n.mdi-format-float-left::before {\n  content: \"\\f0268\";\n}\n\n.mdi-format-float-none::before {\n  content: \"\\f0269\";\n}\n\n.mdi-format-float-right::before {\n  content: \"\\f026a\";\n}\n\n.mdi-format-font::before {\n  content: \"\\f06d6\";\n}\n\n.mdi-format-font-size-decrease::before {\n  content: \"\\f09f3\";\n}\n\n.mdi-format-font-size-increase::before {\n  content: \"\\f09f4\";\n}\n\n.mdi-format-header-1::before {\n  content: \"\\f026b\";\n}\n\n.mdi-format-header-2::before {\n  content: \"\\f026c\";\n}\n\n.mdi-format-header-3::before {\n  content: \"\\f026d\";\n}\n\n.mdi-format-header-4::before {\n  content: \"\\f026e\";\n}\n\n.mdi-format-header-5::before {\n  content: \"\\f026f\";\n}\n\n.mdi-format-header-6::before {\n  content: \"\\f0270\";\n}\n\n.mdi-format-header-decrease::before {\n  content: \"\\f0271\";\n}\n\n.mdi-format-header-equal::before {\n  content: \"\\f0272\";\n}\n\n.mdi-format-header-increase::before {\n  content: \"\\f0273\";\n}\n\n.mdi-format-header-pound::before {\n  content: \"\\f0274\";\n}\n\n.mdi-format-horizontal-align-center::before {\n  content: \"\\f061e\";\n}\n\n.mdi-format-horizontal-align-left::before {\n  content: \"\\f061f\";\n}\n\n.mdi-format-horizontal-align-right::before {\n  content: \"\\f0620\";\n}\n\n.mdi-format-indent-decrease::before {\n  content: \"\\f0275\";\n}\n\n.mdi-format-indent-increase::before {\n  content: \"\\f0276\";\n}\n\n.mdi-format-italic::before {\n  content: \"\\f0277\";\n}\n\n.mdi-format-letter-case::before {\n  content: \"\\f0b34\";\n}\n\n.mdi-format-letter-case-lower::before {\n  content: \"\\f0b35\";\n}\n\n.mdi-format-letter-case-upper::before {\n  content: \"\\f0b36\";\n}\n\n.mdi-format-letter-ends-with::before {\n  content: \"\\f0fb8\";\n}\n\n.mdi-format-letter-matches::before {\n  content: \"\\f0fb9\";\n}\n\n.mdi-format-letter-spacing::before {\n  content: \"\\f1956\";\n}\n\n.mdi-format-letter-starts-with::before {\n  content: \"\\f0fba\";\n}\n\n.mdi-format-line-spacing::before {\n  content: \"\\f0278\";\n}\n\n.mdi-format-line-style::before {\n  content: \"\\f05c8\";\n}\n\n.mdi-format-line-weight::before {\n  content: \"\\f05c9\";\n}\n\n.mdi-format-list-bulleted::before {\n  content: \"\\f0279\";\n}\n\n.mdi-format-list-bulleted-square::before {\n  content: \"\\f0dd0\";\n}\n\n.mdi-format-list-bulleted-triangle::before {\n  content: \"\\f0eb2\";\n}\n\n.mdi-format-list-bulleted-type::before {\n  content: \"\\f027a\";\n}\n\n.mdi-format-list-checkbox::before {\n  content: \"\\f096a\";\n}\n\n.mdi-format-list-checks::before {\n  content: \"\\f0756\";\n}\n\n.mdi-format-list-group::before {\n  content: \"\\f1860\";\n}\n\n.mdi-format-list-numbered::before {\n  content: \"\\f027b\";\n}\n\n.mdi-format-list-numbered-rtl::before {\n  content: \"\\f0d0d\";\n}\n\n.mdi-format-list-text::before {\n  content: \"\\f126f\";\n}\n\n.mdi-format-overline::before {\n  content: \"\\f0eb3\";\n}\n\n.mdi-format-page-break::before {\n  content: \"\\f06d7\";\n}\n\n.mdi-format-page-split::before {\n  content: \"\\f1917\";\n}\n\n.mdi-format-paint::before {\n  content: \"\\f027c\";\n}\n\n.mdi-format-paragraph::before {\n  content: \"\\f027d\";\n}\n\n.mdi-format-pilcrow::before {\n  content: \"\\f06d8\";\n}\n\n.mdi-format-quote-close::before {\n  content: \"\\f027e\";\n}\n\n.mdi-format-quote-close-outline::before {\n  content: \"\\f11a8\";\n}\n\n.mdi-format-quote-open::before {\n  content: \"\\f0757\";\n}\n\n.mdi-format-quote-open-outline::before {\n  content: \"\\f11a7\";\n}\n\n.mdi-format-rotate-90::before {\n  content: \"\\f06aa\";\n}\n\n.mdi-format-section::before {\n  content: \"\\f069f\";\n}\n\n.mdi-format-size::before {\n  content: \"\\f027f\";\n}\n\n.mdi-format-strikethrough::before {\n  content: \"\\f0280\";\n}\n\n.mdi-format-strikethrough-variant::before {\n  content: \"\\f0281\";\n}\n\n.mdi-format-subscript::before {\n  content: \"\\f0282\";\n}\n\n.mdi-format-superscript::before {\n  content: \"\\f0283\";\n}\n\n.mdi-format-text::before {\n  content: \"\\f0284\";\n}\n\n.mdi-format-text-rotation-angle-down::before {\n  content: \"\\f0fbb\";\n}\n\n.mdi-format-text-rotation-angle-up::before {\n  content: \"\\f0fbc\";\n}\n\n.mdi-format-text-rotation-down::before {\n  content: \"\\f0d73\";\n}\n\n.mdi-format-text-rotation-down-vertical::before {\n  content: \"\\f0fbd\";\n}\n\n.mdi-format-text-rotation-none::before {\n  content: \"\\f0d74\";\n}\n\n.mdi-format-text-rotation-up::before {\n  content: \"\\f0fbe\";\n}\n\n.mdi-format-text-rotation-vertical::before {\n  content: \"\\f0fbf\";\n}\n\n.mdi-format-text-variant::before {\n  content: \"\\f0e32\";\n}\n\n.mdi-format-text-variant-outline::before {\n  content: \"\\f150f\";\n}\n\n.mdi-format-text-wrapping-clip::before {\n  content: \"\\f0d0e\";\n}\n\n.mdi-format-text-wrapping-overflow::before {\n  content: \"\\f0d0f\";\n}\n\n.mdi-format-text-wrapping-wrap::before {\n  content: \"\\f0d10\";\n}\n\n.mdi-format-textbox::before {\n  content: \"\\f0d11\";\n}\n\n.mdi-format-textdirection-l-to-r::before {\n  content: \"\\f0285\";\n}\n\n.mdi-format-textdirection-r-to-l::before {\n  content: \"\\f0286\";\n}\n\n.mdi-format-title::before {\n  content: \"\\f05f4\";\n}\n\n.mdi-format-underline::before {\n  content: \"\\f0287\";\n}\n\n.mdi-format-underline-wavy::before {\n  content: \"\\f18e9\";\n}\n\n.mdi-format-vertical-align-bottom::before {\n  content: \"\\f0621\";\n}\n\n.mdi-format-vertical-align-center::before {\n  content: \"\\f0622\";\n}\n\n.mdi-format-vertical-align-top::before {\n  content: \"\\f0623\";\n}\n\n.mdi-format-wrap-inline::before {\n  content: \"\\f0288\";\n}\n\n.mdi-format-wrap-square::before {\n  content: \"\\f0289\";\n}\n\n.mdi-format-wrap-tight::before {\n  content: \"\\f028a\";\n}\n\n.mdi-format-wrap-top-bottom::before {\n  content: \"\\f028b\";\n}\n\n.mdi-forum::before {\n  content: \"\\f028c\";\n}\n\n.mdi-forum-outline::before {\n  content: \"\\f0822\";\n}\n\n.mdi-forward::before {\n  content: \"\\f028d\";\n}\n\n.mdi-forwardburger::before {\n  content: \"\\f0d75\";\n}\n\n.mdi-fountain::before {\n  content: \"\\f096b\";\n}\n\n.mdi-fountain-pen::before {\n  content: \"\\f0d12\";\n}\n\n.mdi-fountain-pen-tip::before {\n  content: \"\\f0d13\";\n}\n\n.mdi-fraction-one-half::before {\n  content: \"\\f1992\";\n}\n\n.mdi-freebsd::before {\n  content: \"\\f08e0\";\n}\n\n.mdi-french-fries::before {\n  content: \"\\f1957\";\n}\n\n.mdi-frequently-asked-questions::before {\n  content: \"\\f0eb4\";\n}\n\n.mdi-fridge::before {\n  content: \"\\f0290\";\n}\n\n.mdi-fridge-alert::before {\n  content: \"\\f11b1\";\n}\n\n.mdi-fridge-alert-outline::before {\n  content: \"\\f11b2\";\n}\n\n.mdi-fridge-bottom::before {\n  content: \"\\f0292\";\n}\n\n.mdi-fridge-industrial::before {\n  content: \"\\f15ee\";\n}\n\n.mdi-fridge-industrial-alert::before {\n  content: \"\\f15ef\";\n}\n\n.mdi-fridge-industrial-alert-outline::before {\n  content: \"\\f15f0\";\n}\n\n.mdi-fridge-industrial-off::before {\n  content: \"\\f15f1\";\n}\n\n.mdi-fridge-industrial-off-outline::before {\n  content: \"\\f15f2\";\n}\n\n.mdi-fridge-industrial-outline::before {\n  content: \"\\f15f3\";\n}\n\n.mdi-fridge-off::before {\n  content: \"\\f11af\";\n}\n\n.mdi-fridge-off-outline::before {\n  content: \"\\f11b0\";\n}\n\n.mdi-fridge-outline::before {\n  content: \"\\f028f\";\n}\n\n.mdi-fridge-top::before {\n  content: \"\\f0291\";\n}\n\n.mdi-fridge-variant::before {\n  content: \"\\f15f4\";\n}\n\n.mdi-fridge-variant-alert::before {\n  content: \"\\f15f5\";\n}\n\n.mdi-fridge-variant-alert-outline::before {\n  content: \"\\f15f6\";\n}\n\n.mdi-fridge-variant-off::before {\n  content: \"\\f15f7\";\n}\n\n.mdi-fridge-variant-off-outline::before {\n  content: \"\\f15f8\";\n}\n\n.mdi-fridge-variant-outline::before {\n  content: \"\\f15f9\";\n}\n\n.mdi-fruit-cherries::before {\n  content: \"\\f1042\";\n}\n\n.mdi-fruit-cherries-off::before {\n  content: \"\\f13f8\";\n}\n\n.mdi-fruit-citrus::before {\n  content: \"\\f1043\";\n}\n\n.mdi-fruit-citrus-off::before {\n  content: \"\\f13f9\";\n}\n\n.mdi-fruit-grapes::before {\n  content: \"\\f1044\";\n}\n\n.mdi-fruit-grapes-outline::before {\n  content: \"\\f1045\";\n}\n\n.mdi-fruit-pineapple::before {\n  content: \"\\f1046\";\n}\n\n.mdi-fruit-watermelon::before {\n  content: \"\\f1047\";\n}\n\n.mdi-fuel::before {\n  content: \"\\f07ca\";\n}\n\n.mdi-fuel-cell::before {\n  content: \"\\f18b5\";\n}\n\n.mdi-fullscreen::before {\n  content: \"\\f0293\";\n}\n\n.mdi-fullscreen-exit::before {\n  content: \"\\f0294\";\n}\n\n.mdi-function::before {\n  content: \"\\f0295\";\n}\n\n.mdi-function-variant::before {\n  content: \"\\f0871\";\n}\n\n.mdi-furigana-horizontal::before {\n  content: \"\\f1081\";\n}\n\n.mdi-furigana-vertical::before {\n  content: \"\\f1082\";\n}\n\n.mdi-fuse::before {\n  content: \"\\f0c85\";\n}\n\n.mdi-fuse-alert::before {\n  content: \"\\f142d\";\n}\n\n.mdi-fuse-blade::before {\n  content: \"\\f0c86\";\n}\n\n.mdi-fuse-off::before {\n  content: \"\\f142c\";\n}\n\n.mdi-gamepad::before {\n  content: \"\\f0296\";\n}\n\n.mdi-gamepad-circle::before {\n  content: \"\\f0e33\";\n}\n\n.mdi-gamepad-circle-down::before {\n  content: \"\\f0e34\";\n}\n\n.mdi-gamepad-circle-left::before {\n  content: \"\\f0e35\";\n}\n\n.mdi-gamepad-circle-outline::before {\n  content: \"\\f0e36\";\n}\n\n.mdi-gamepad-circle-right::before {\n  content: \"\\f0e37\";\n}\n\n.mdi-gamepad-circle-up::before {\n  content: \"\\f0e38\";\n}\n\n.mdi-gamepad-down::before {\n  content: \"\\f0e39\";\n}\n\n.mdi-gamepad-left::before {\n  content: \"\\f0e3a\";\n}\n\n.mdi-gamepad-outline::before {\n  content: \"\\f1919\";\n}\n\n.mdi-gamepad-right::before {\n  content: \"\\f0e3b\";\n}\n\n.mdi-gamepad-round::before {\n  content: \"\\f0e3c\";\n}\n\n.mdi-gamepad-round-down::before {\n  content: \"\\f0e3d\";\n}\n\n.mdi-gamepad-round-left::before {\n  content: \"\\f0e3e\";\n}\n\n.mdi-gamepad-round-outline::before {\n  content: \"\\f0e3f\";\n}\n\n.mdi-gamepad-round-right::before {\n  content: \"\\f0e40\";\n}\n\n.mdi-gamepad-round-up::before {\n  content: \"\\f0e41\";\n}\n\n.mdi-gamepad-square::before {\n  content: \"\\f0eb5\";\n}\n\n.mdi-gamepad-square-outline::before {\n  content: \"\\f0eb6\";\n}\n\n.mdi-gamepad-up::before {\n  content: \"\\f0e42\";\n}\n\n.mdi-gamepad-variant::before {\n  content: \"\\f0297\";\n}\n\n.mdi-gamepad-variant-outline::before {\n  content: \"\\f0eb7\";\n}\n\n.mdi-gamma::before {\n  content: \"\\f10ee\";\n}\n\n.mdi-gantry-crane::before {\n  content: \"\\f0dd1\";\n}\n\n.mdi-garage::before {\n  content: \"\\f06d9\";\n}\n\n.mdi-garage-alert::before {\n  content: \"\\f0872\";\n}\n\n.mdi-garage-alert-variant::before {\n  content: \"\\f12d5\";\n}\n\n.mdi-garage-lock::before {\n  content: \"\\f17fb\";\n}\n\n.mdi-garage-open::before {\n  content: \"\\f06da\";\n}\n\n.mdi-garage-open-variant::before {\n  content: \"\\f12d4\";\n}\n\n.mdi-garage-variant::before {\n  content: \"\\f12d3\";\n}\n\n.mdi-garage-variant-lock::before {\n  content: \"\\f17fc\";\n}\n\n.mdi-gas-cylinder::before {\n  content: \"\\f0647\";\n}\n\n.mdi-gas-station::before {\n  content: \"\\f0298\";\n}\n\n.mdi-gas-station-off::before {\n  content: \"\\f1409\";\n}\n\n.mdi-gas-station-off-outline::before {\n  content: \"\\f140a\";\n}\n\n.mdi-gas-station-outline::before {\n  content: \"\\f0eb8\";\n}\n\n.mdi-gate::before {\n  content: \"\\f0299\";\n}\n\n.mdi-gate-alert::before {\n  content: \"\\f17f8\";\n}\n\n.mdi-gate-and::before {\n  content: \"\\f08e1\";\n}\n\n.mdi-gate-arrow-left::before {\n  content: \"\\f17f7\";\n}\n\n.mdi-gate-arrow-right::before {\n  content: \"\\f1169\";\n}\n\n.mdi-gate-nand::before {\n  content: \"\\f08e2\";\n}\n\n.mdi-gate-nor::before {\n  content: \"\\f08e3\";\n}\n\n.mdi-gate-not::before {\n  content: \"\\f08e4\";\n}\n\n.mdi-gate-open::before {\n  content: \"\\f116a\";\n}\n\n.mdi-gate-or::before {\n  content: \"\\f08e5\";\n}\n\n.mdi-gate-xnor::before {\n  content: \"\\f08e6\";\n}\n\n.mdi-gate-xor::before {\n  content: \"\\f08e7\";\n}\n\n.mdi-gatsby::before {\n  content: \"\\f0e43\";\n}\n\n.mdi-gauge::before {\n  content: \"\\f029a\";\n}\n\n.mdi-gauge-empty::before {\n  content: \"\\f0873\";\n}\n\n.mdi-gauge-full::before {\n  content: \"\\f0874\";\n}\n\n.mdi-gauge-low::before {\n  content: \"\\f0875\";\n}\n\n.mdi-gavel::before {\n  content: \"\\f029b\";\n}\n\n.mdi-gender-female::before {\n  content: \"\\f029c\";\n}\n\n.mdi-gender-male::before {\n  content: \"\\f029d\";\n}\n\n.mdi-gender-male-female::before {\n  content: \"\\f029e\";\n}\n\n.mdi-gender-male-female-variant::before {\n  content: \"\\f113f\";\n}\n\n.mdi-gender-non-binary::before {\n  content: \"\\f1140\";\n}\n\n.mdi-gender-transgender::before {\n  content: \"\\f029f\";\n}\n\n.mdi-gentoo::before {\n  content: \"\\f08e8\";\n}\n\n.mdi-gesture::before {\n  content: \"\\f07cb\";\n}\n\n.mdi-gesture-double-tap::before {\n  content: \"\\f073c\";\n}\n\n.mdi-gesture-pinch::before {\n  content: \"\\f0abd\";\n}\n\n.mdi-gesture-spread::before {\n  content: \"\\f0abe\";\n}\n\n.mdi-gesture-swipe::before {\n  content: \"\\f0d76\";\n}\n\n.mdi-gesture-swipe-down::before {\n  content: \"\\f073d\";\n}\n\n.mdi-gesture-swipe-horizontal::before {\n  content: \"\\f0abf\";\n}\n\n.mdi-gesture-swipe-left::before {\n  content: \"\\f073e\";\n}\n\n.mdi-gesture-swipe-right::before {\n  content: \"\\f073f\";\n}\n\n.mdi-gesture-swipe-up::before {\n  content: \"\\f0740\";\n}\n\n.mdi-gesture-swipe-vertical::before {\n  content: \"\\f0ac0\";\n}\n\n.mdi-gesture-tap::before {\n  content: \"\\f0741\";\n}\n\n.mdi-gesture-tap-box::before {\n  content: \"\\f12a9\";\n}\n\n.mdi-gesture-tap-button::before {\n  content: \"\\f12a8\";\n}\n\n.mdi-gesture-tap-hold::before {\n  content: \"\\f0d77\";\n}\n\n.mdi-gesture-two-double-tap::before {\n  content: \"\\f0742\";\n}\n\n.mdi-gesture-two-tap::before {\n  content: \"\\f0743\";\n}\n\n.mdi-ghost::before {\n  content: \"\\f02a0\";\n}\n\n.mdi-ghost-off::before {\n  content: \"\\f09f5\";\n}\n\n.mdi-ghost-off-outline::before {\n  content: \"\\f165c\";\n}\n\n.mdi-ghost-outline::before {\n  content: \"\\f165d\";\n}\n\n.mdi-gift::before {\n  content: \"\\f0e44\";\n}\n\n.mdi-gift-off::before {\n  content: \"\\f16ef\";\n}\n\n.mdi-gift-off-outline::before {\n  content: \"\\f16f0\";\n}\n\n.mdi-gift-open::before {\n  content: \"\\f16f1\";\n}\n\n.mdi-gift-open-outline::before {\n  content: \"\\f16f2\";\n}\n\n.mdi-gift-outline::before {\n  content: \"\\f02a1\";\n}\n\n.mdi-git::before {\n  content: \"\\f02a2\";\n}\n\n.mdi-github::before {\n  content: \"\\f02a4\";\n}\n\n.mdi-gitlab::before {\n  content: \"\\f0ba0\";\n}\n\n.mdi-glass-cocktail::before {\n  content: \"\\f0356\";\n}\n\n.mdi-glass-cocktail-off::before {\n  content: \"\\f15e6\";\n}\n\n.mdi-glass-flute::before {\n  content: \"\\f02a5\";\n}\n\n.mdi-glass-fragile::before {\n  content: \"\\f1873\";\n}\n\n.mdi-glass-mug::before {\n  content: \"\\f02a6\";\n}\n\n.mdi-glass-mug-off::before {\n  content: \"\\f15e7\";\n}\n\n.mdi-glass-mug-variant::before {\n  content: \"\\f1116\";\n}\n\n.mdi-glass-mug-variant-off::before {\n  content: \"\\f15e8\";\n}\n\n.mdi-glass-pint-outline::before {\n  content: \"\\f130d\";\n}\n\n.mdi-glass-stange::before {\n  content: \"\\f02a7\";\n}\n\n.mdi-glass-tulip::before {\n  content: \"\\f02a8\";\n}\n\n.mdi-glass-wine::before {\n  content: \"\\f0876\";\n}\n\n.mdi-glasses::before {\n  content: \"\\f02aa\";\n}\n\n.mdi-globe-light::before {\n  content: \"\\f12d7\";\n}\n\n.mdi-globe-model::before {\n  content: \"\\f08e9\";\n}\n\n.mdi-gmail::before {\n  content: \"\\f02ab\";\n}\n\n.mdi-gnome::before {\n  content: \"\\f02ac\";\n}\n\n.mdi-go-kart::before {\n  content: \"\\f0d79\";\n}\n\n.mdi-go-kart-track::before {\n  content: \"\\f0d7a\";\n}\n\n.mdi-gog::before {\n  content: \"\\f0ba1\";\n}\n\n.mdi-gold::before {\n  content: \"\\f124f\";\n}\n\n.mdi-golf::before {\n  content: \"\\f0823\";\n}\n\n.mdi-golf-cart::before {\n  content: \"\\f11a4\";\n}\n\n.mdi-golf-tee::before {\n  content: \"\\f1083\";\n}\n\n.mdi-gondola::before {\n  content: \"\\f0686\";\n}\n\n.mdi-goodreads::before {\n  content: \"\\f0d7b\";\n}\n\n.mdi-google::before {\n  content: \"\\f02ad\";\n}\n\n.mdi-google-ads::before {\n  content: \"\\f0c87\";\n}\n\n.mdi-google-analytics::before {\n  content: \"\\f07cc\";\n}\n\n.mdi-google-assistant::before {\n  content: \"\\f07cd\";\n}\n\n.mdi-google-cardboard::before {\n  content: \"\\f02ae\";\n}\n\n.mdi-google-chrome::before {\n  content: \"\\f02af\";\n}\n\n.mdi-google-circles::before {\n  content: \"\\f02b0\";\n}\n\n.mdi-google-circles-communities::before {\n  content: \"\\f02b1\";\n}\n\n.mdi-google-circles-extended::before {\n  content: \"\\f02b2\";\n}\n\n.mdi-google-circles-group::before {\n  content: \"\\f02b3\";\n}\n\n.mdi-google-classroom::before {\n  content: \"\\f02c0\";\n}\n\n.mdi-google-cloud::before {\n  content: \"\\f11f6\";\n}\n\n.mdi-google-controller::before {\n  content: \"\\f02b4\";\n}\n\n.mdi-google-controller-off::before {\n  content: \"\\f02b5\";\n}\n\n.mdi-google-downasaur::before {\n  content: \"\\f1362\";\n}\n\n.mdi-google-drive::before {\n  content: \"\\f02b6\";\n}\n\n.mdi-google-earth::before {\n  content: \"\\f02b7\";\n}\n\n.mdi-google-fit::before {\n  content: \"\\f096c\";\n}\n\n.mdi-google-glass::before {\n  content: \"\\f02b8\";\n}\n\n.mdi-google-hangouts::before {\n  content: \"\\f02c9\";\n}\n\n.mdi-google-home::before {\n  content: \"\\f0824\";\n}\n\n.mdi-google-keep::before {\n  content: \"\\f06dc\";\n}\n\n.mdi-google-lens::before {\n  content: \"\\f09f6\";\n}\n\n.mdi-google-maps::before {\n  content: \"\\f05f5\";\n}\n\n.mdi-google-my-business::before {\n  content: \"\\f1048\";\n}\n\n.mdi-google-nearby::before {\n  content: \"\\f02b9\";\n}\n\n.mdi-google-play::before {\n  content: \"\\f02bc\";\n}\n\n.mdi-google-plus::before {\n  content: \"\\f02bd\";\n}\n\n.mdi-google-podcast::before {\n  content: \"\\f0eb9\";\n}\n\n.mdi-google-spreadsheet::before {\n  content: \"\\f09f7\";\n}\n\n.mdi-google-street-view::before {\n  content: \"\\f0c88\";\n}\n\n.mdi-google-translate::before {\n  content: \"\\f02bf\";\n}\n\n.mdi-gradient-horizontal::before {\n  content: \"\\f174a\";\n}\n\n.mdi-gradient-vertical::before {\n  content: \"\\f06a0\";\n}\n\n.mdi-grain::before {\n  content: \"\\f0d7c\";\n}\n\n.mdi-graph::before {\n  content: \"\\f1049\";\n}\n\n.mdi-graph-outline::before {\n  content: \"\\f104a\";\n}\n\n.mdi-graphql::before {\n  content: \"\\f0877\";\n}\n\n.mdi-grass::before {\n  content: \"\\f1510\";\n}\n\n.mdi-grave-stone::before {\n  content: \"\\f0ba2\";\n}\n\n.mdi-grease-pencil::before {\n  content: \"\\f0648\";\n}\n\n.mdi-greater-than::before {\n  content: \"\\f096d\";\n}\n\n.mdi-greater-than-or-equal::before {\n  content: \"\\f096e\";\n}\n\n.mdi-greenhouse::before {\n  content: \"\\f002d\";\n}\n\n.mdi-grid::before {\n  content: \"\\f02c1\";\n}\n\n.mdi-grid-large::before {\n  content: \"\\f0758\";\n}\n\n.mdi-grid-off::before {\n  content: \"\\f02c2\";\n}\n\n.mdi-grill::before {\n  content: \"\\f0e45\";\n}\n\n.mdi-grill-outline::before {\n  content: \"\\f118a\";\n}\n\n.mdi-group::before {\n  content: \"\\f02c3\";\n}\n\n.mdi-guitar-acoustic::before {\n  content: \"\\f0771\";\n}\n\n.mdi-guitar-electric::before {\n  content: \"\\f02c4\";\n}\n\n.mdi-guitar-pick::before {\n  content: \"\\f02c5\";\n}\n\n.mdi-guitar-pick-outline::before {\n  content: \"\\f02c6\";\n}\n\n.mdi-guy-fawkes-mask::before {\n  content: \"\\f0825\";\n}\n\n.mdi-hail::before {\n  content: \"\\f0ac1\";\n}\n\n.mdi-hair-dryer::before {\n  content: \"\\f10ef\";\n}\n\n.mdi-hair-dryer-outline::before {\n  content: \"\\f10f0\";\n}\n\n.mdi-halloween::before {\n  content: \"\\f0ba3\";\n}\n\n.mdi-hamburger::before {\n  content: \"\\f0685\";\n}\n\n.mdi-hamburger-check::before {\n  content: \"\\f1776\";\n}\n\n.mdi-hamburger-minus::before {\n  content: \"\\f1777\";\n}\n\n.mdi-hamburger-off::before {\n  content: \"\\f1778\";\n}\n\n.mdi-hamburger-plus::before {\n  content: \"\\f1779\";\n}\n\n.mdi-hamburger-remove::before {\n  content: \"\\f177a\";\n}\n\n.mdi-hammer::before {\n  content: \"\\f08ea\";\n}\n\n.mdi-hammer-screwdriver::before {\n  content: \"\\f1322\";\n}\n\n.mdi-hammer-sickle::before {\n  content: \"\\f1887\";\n}\n\n.mdi-hammer-wrench::before {\n  content: \"\\f1323\";\n}\n\n.mdi-hand-back-left::before {\n  content: \"\\f0e46\";\n}\n\n.mdi-hand-back-left-off::before {\n  content: \"\\f1830\";\n}\n\n.mdi-hand-back-left-off-outline::before {\n  content: \"\\f1832\";\n}\n\n.mdi-hand-back-left-outline::before {\n  content: \"\\f182c\";\n}\n\n.mdi-hand-back-right::before {\n  content: \"\\f0e47\";\n}\n\n.mdi-hand-back-right-off::before {\n  content: \"\\f1831\";\n}\n\n.mdi-hand-back-right-off-outline::before {\n  content: \"\\f1833\";\n}\n\n.mdi-hand-back-right-outline::before {\n  content: \"\\f182d\";\n}\n\n.mdi-hand-clap::before {\n  content: \"\\f194b\";\n}\n\n.mdi-hand-coin::before {\n  content: \"\\f188f\";\n}\n\n.mdi-hand-coin-outline::before {\n  content: \"\\f1890\";\n}\n\n.mdi-hand-extended::before {\n  content: \"\\f18b6\";\n}\n\n.mdi-hand-extended-outline::before {\n  content: \"\\f18b7\";\n}\n\n.mdi-hand-front-left::before {\n  content: \"\\f182b\";\n}\n\n.mdi-hand-front-left-outline::before {\n  content: \"\\f182e\";\n}\n\n.mdi-hand-front-right::before {\n  content: \"\\f0a4f\";\n}\n\n.mdi-hand-front-right-outline::before {\n  content: \"\\f182f\";\n}\n\n.mdi-hand-heart::before {\n  content: \"\\f10f1\";\n}\n\n.mdi-hand-heart-outline::before {\n  content: \"\\f157e\";\n}\n\n.mdi-hand-okay::before {\n  content: \"\\f0a50\";\n}\n\n.mdi-hand-peace::before {\n  content: \"\\f0a51\";\n}\n\n.mdi-hand-peace-variant::before {\n  content: \"\\f0a52\";\n}\n\n.mdi-hand-pointing-down::before {\n  content: \"\\f0a53\";\n}\n\n.mdi-hand-pointing-left::before {\n  content: \"\\f0a54\";\n}\n\n.mdi-hand-pointing-right::before {\n  content: \"\\f02c7\";\n}\n\n.mdi-hand-pointing-up::before {\n  content: \"\\f0a55\";\n}\n\n.mdi-hand-saw::before {\n  content: \"\\f0e48\";\n}\n\n.mdi-hand-wash::before {\n  content: \"\\f157f\";\n}\n\n.mdi-hand-wash-outline::before {\n  content: \"\\f1580\";\n}\n\n.mdi-hand-water::before {\n  content: \"\\f139f\";\n}\n\n.mdi-hand-wave::before {\n  content: \"\\f1821\";\n}\n\n.mdi-hand-wave-outline::before {\n  content: \"\\f1822\";\n}\n\n.mdi-handball::before {\n  content: \"\\f0f53\";\n}\n\n.mdi-handcuffs::before {\n  content: \"\\f113e\";\n}\n\n.mdi-hands-pray::before {\n  content: \"\\f0579\";\n}\n\n.mdi-handshake::before {\n  content: \"\\f1218\";\n}\n\n.mdi-handshake-outline::before {\n  content: \"\\f15a1\";\n}\n\n.mdi-hanger::before {\n  content: \"\\f02c8\";\n}\n\n.mdi-hard-hat::before {\n  content: \"\\f096f\";\n}\n\n.mdi-harddisk::before {\n  content: \"\\f02ca\";\n}\n\n.mdi-harddisk-plus::before {\n  content: \"\\f104b\";\n}\n\n.mdi-harddisk-remove::before {\n  content: \"\\f104c\";\n}\n\n.mdi-hat-fedora::before {\n  content: \"\\f0ba4\";\n}\n\n.mdi-hazard-lights::before {\n  content: \"\\f0c89\";\n}\n\n.mdi-hdr::before {\n  content: \"\\f0d7d\";\n}\n\n.mdi-hdr-off::before {\n  content: \"\\f0d7e\";\n}\n\n.mdi-head::before {\n  content: \"\\f135e\";\n}\n\n.mdi-head-alert::before {\n  content: \"\\f1338\";\n}\n\n.mdi-head-alert-outline::before {\n  content: \"\\f1339\";\n}\n\n.mdi-head-check::before {\n  content: \"\\f133a\";\n}\n\n.mdi-head-check-outline::before {\n  content: \"\\f133b\";\n}\n\n.mdi-head-cog::before {\n  content: \"\\f133c\";\n}\n\n.mdi-head-cog-outline::before {\n  content: \"\\f133d\";\n}\n\n.mdi-head-dots-horizontal::before {\n  content: \"\\f133e\";\n}\n\n.mdi-head-dots-horizontal-outline::before {\n  content: \"\\f133f\";\n}\n\n.mdi-head-flash::before {\n  content: \"\\f1340\";\n}\n\n.mdi-head-flash-outline::before {\n  content: \"\\f1341\";\n}\n\n.mdi-head-heart::before {\n  content: \"\\f1342\";\n}\n\n.mdi-head-heart-outline::before {\n  content: \"\\f1343\";\n}\n\n.mdi-head-lightbulb::before {\n  content: \"\\f1344\";\n}\n\n.mdi-head-lightbulb-outline::before {\n  content: \"\\f1345\";\n}\n\n.mdi-head-minus::before {\n  content: \"\\f1346\";\n}\n\n.mdi-head-minus-outline::before {\n  content: \"\\f1347\";\n}\n\n.mdi-head-outline::before {\n  content: \"\\f135f\";\n}\n\n.mdi-head-plus::before {\n  content: \"\\f1348\";\n}\n\n.mdi-head-plus-outline::before {\n  content: \"\\f1349\";\n}\n\n.mdi-head-question::before {\n  content: \"\\f134a\";\n}\n\n.mdi-head-question-outline::before {\n  content: \"\\f134b\";\n}\n\n.mdi-head-remove::before {\n  content: \"\\f134c\";\n}\n\n.mdi-head-remove-outline::before {\n  content: \"\\f134d\";\n}\n\n.mdi-head-snowflake::before {\n  content: \"\\f134e\";\n}\n\n.mdi-head-snowflake-outline::before {\n  content: \"\\f134f\";\n}\n\n.mdi-head-sync::before {\n  content: \"\\f1350\";\n}\n\n.mdi-head-sync-outline::before {\n  content: \"\\f1351\";\n}\n\n.mdi-headphones::before {\n  content: \"\\f02cb\";\n}\n\n.mdi-headphones-bluetooth::before {\n  content: \"\\f0970\";\n}\n\n.mdi-headphones-box::before {\n  content: \"\\f02cc\";\n}\n\n.mdi-headphones-off::before {\n  content: \"\\f07ce\";\n}\n\n.mdi-headphones-settings::before {\n  content: \"\\f02cd\";\n}\n\n.mdi-headset::before {\n  content: \"\\f02ce\";\n}\n\n.mdi-headset-dock::before {\n  content: \"\\f02cf\";\n}\n\n.mdi-headset-off::before {\n  content: \"\\f02d0\";\n}\n\n.mdi-heart::before {\n  content: \"\\f02d1\";\n}\n\n.mdi-heart-box::before {\n  content: \"\\f02d2\";\n}\n\n.mdi-heart-box-outline::before {\n  content: \"\\f02d3\";\n}\n\n.mdi-heart-broken::before {\n  content: \"\\f02d4\";\n}\n\n.mdi-heart-broken-outline::before {\n  content: \"\\f0d14\";\n}\n\n.mdi-heart-circle::before {\n  content: \"\\f0971\";\n}\n\n.mdi-heart-circle-outline::before {\n  content: \"\\f0972\";\n}\n\n.mdi-heart-cog::before {\n  content: \"\\f1663\";\n}\n\n.mdi-heart-cog-outline::before {\n  content: \"\\f1664\";\n}\n\n.mdi-heart-flash::before {\n  content: \"\\f0ef9\";\n}\n\n.mdi-heart-half::before {\n  content: \"\\f06df\";\n}\n\n.mdi-heart-half-full::before {\n  content: \"\\f06de\";\n}\n\n.mdi-heart-half-outline::before {\n  content: \"\\f06e0\";\n}\n\n.mdi-heart-minus::before {\n  content: \"\\f142f\";\n}\n\n.mdi-heart-minus-outline::before {\n  content: \"\\f1432\";\n}\n\n.mdi-heart-multiple::before {\n  content: \"\\f0a56\";\n}\n\n.mdi-heart-multiple-outline::before {\n  content: \"\\f0a57\";\n}\n\n.mdi-heart-off::before {\n  content: \"\\f0759\";\n}\n\n.mdi-heart-off-outline::before {\n  content: \"\\f1434\";\n}\n\n.mdi-heart-outline::before {\n  content: \"\\f02d5\";\n}\n\n.mdi-heart-plus::before {\n  content: \"\\f142e\";\n}\n\n.mdi-heart-plus-outline::before {\n  content: \"\\f1431\";\n}\n\n.mdi-heart-pulse::before {\n  content: \"\\f05f6\";\n}\n\n.mdi-heart-remove::before {\n  content: \"\\f1430\";\n}\n\n.mdi-heart-remove-outline::before {\n  content: \"\\f1433\";\n}\n\n.mdi-heart-settings::before {\n  content: \"\\f1665\";\n}\n\n.mdi-heart-settings-outline::before {\n  content: \"\\f1666\";\n}\n\n.mdi-helicopter::before {\n  content: \"\\f0ac2\";\n}\n\n.mdi-help::before {\n  content: \"\\f02d6\";\n}\n\n.mdi-help-box::before {\n  content: \"\\f078b\";\n}\n\n.mdi-help-circle::before {\n  content: \"\\f02d7\";\n}\n\n.mdi-help-circle-outline::before {\n  content: \"\\f0625\";\n}\n\n.mdi-help-network::before {\n  content: \"\\f06f5\";\n}\n\n.mdi-help-network-outline::before {\n  content: \"\\f0c8a\";\n}\n\n.mdi-help-rhombus::before {\n  content: \"\\f0ba5\";\n}\n\n.mdi-help-rhombus-outline::before {\n  content: \"\\f0ba6\";\n}\n\n.mdi-hexadecimal::before {\n  content: \"\\f12a7\";\n}\n\n.mdi-hexagon::before {\n  content: \"\\f02d8\";\n}\n\n.mdi-hexagon-multiple::before {\n  content: \"\\f06e1\";\n}\n\n.mdi-hexagon-multiple-outline::before {\n  content: \"\\f10f2\";\n}\n\n.mdi-hexagon-outline::before {\n  content: \"\\f02d9\";\n}\n\n.mdi-hexagon-slice-1::before {\n  content: \"\\f0ac3\";\n}\n\n.mdi-hexagon-slice-2::before {\n  content: \"\\f0ac4\";\n}\n\n.mdi-hexagon-slice-3::before {\n  content: \"\\f0ac5\";\n}\n\n.mdi-hexagon-slice-4::before {\n  content: \"\\f0ac6\";\n}\n\n.mdi-hexagon-slice-5::before {\n  content: \"\\f0ac7\";\n}\n\n.mdi-hexagon-slice-6::before {\n  content: \"\\f0ac8\";\n}\n\n.mdi-hexagram::before {\n  content: \"\\f0ac9\";\n}\n\n.mdi-hexagram-outline::before {\n  content: \"\\f0aca\";\n}\n\n.mdi-high-definition::before {\n  content: \"\\f07cf\";\n}\n\n.mdi-high-definition-box::before {\n  content: \"\\f0878\";\n}\n\n.mdi-highway::before {\n  content: \"\\f05f7\";\n}\n\n.mdi-hiking::before {\n  content: \"\\f0d7f\";\n}\n\n.mdi-history::before {\n  content: \"\\f02da\";\n}\n\n.mdi-hockey-puck::before {\n  content: \"\\f0879\";\n}\n\n.mdi-hockey-sticks::before {\n  content: \"\\f087a\";\n}\n\n.mdi-hololens::before {\n  content: \"\\f02db\";\n}\n\n.mdi-home::before {\n  content: \"\\f02dc\";\n}\n\n.mdi-home-account::before {\n  content: \"\\f0826\";\n}\n\n.mdi-home-alert::before {\n  content: \"\\f087b\";\n}\n\n.mdi-home-alert-outline::before {\n  content: \"\\f15d0\";\n}\n\n.mdi-home-analytics::before {\n  content: \"\\f0eba\";\n}\n\n.mdi-home-assistant::before {\n  content: \"\\f07d0\";\n}\n\n.mdi-home-automation::before {\n  content: \"\\f07d1\";\n}\n\n.mdi-home-battery::before {\n  content: \"\\f1901\";\n}\n\n.mdi-home-battery-outline::before {\n  content: \"\\f1902\";\n}\n\n.mdi-home-circle::before {\n  content: \"\\f07d2\";\n}\n\n.mdi-home-circle-outline::before {\n  content: \"\\f104d\";\n}\n\n.mdi-home-city::before {\n  content: \"\\f0d15\";\n}\n\n.mdi-home-city-outline::before {\n  content: \"\\f0d16\";\n}\n\n.mdi-home-edit::before {\n  content: \"\\f1159\";\n}\n\n.mdi-home-edit-outline::before {\n  content: \"\\f115a\";\n}\n\n.mdi-home-export-outline::before {\n  content: \"\\f0f9b\";\n}\n\n.mdi-home-flood::before {\n  content: \"\\f0efa\";\n}\n\n.mdi-home-floor-0::before {\n  content: \"\\f0dd2\";\n}\n\n.mdi-home-floor-1::before {\n  content: \"\\f0d80\";\n}\n\n.mdi-home-floor-2::before {\n  content: \"\\f0d81\";\n}\n\n.mdi-home-floor-3::before {\n  content: \"\\f0d82\";\n}\n\n.mdi-home-floor-a::before {\n  content: \"\\f0d83\";\n}\n\n.mdi-home-floor-b::before {\n  content: \"\\f0d84\";\n}\n\n.mdi-home-floor-g::before {\n  content: \"\\f0d85\";\n}\n\n.mdi-home-floor-l::before {\n  content: \"\\f0d86\";\n}\n\n.mdi-home-floor-negative-1::before {\n  content: \"\\f0dd3\";\n}\n\n.mdi-home-group::before {\n  content: \"\\f0dd4\";\n}\n\n.mdi-home-group-minus::before {\n  content: \"\\f19c1\";\n}\n\n.mdi-home-group-plus::before {\n  content: \"\\f19c0\";\n}\n\n.mdi-home-group-remove::before {\n  content: \"\\f19c2\";\n}\n\n.mdi-home-heart::before {\n  content: \"\\f0827\";\n}\n\n.mdi-home-import-outline::before {\n  content: \"\\f0f9c\";\n}\n\n.mdi-home-lightbulb::before {\n  content: \"\\f1251\";\n}\n\n.mdi-home-lightbulb-outline::before {\n  content: \"\\f1252\";\n}\n\n.mdi-home-lightning-bolt::before {\n  content: \"\\f1903\";\n}\n\n.mdi-home-lightning-bolt-outline::before {\n  content: \"\\f1904\";\n}\n\n.mdi-home-lock::before {\n  content: \"\\f08eb\";\n}\n\n.mdi-home-lock-open::before {\n  content: \"\\f08ec\";\n}\n\n.mdi-home-map-marker::before {\n  content: \"\\f05f8\";\n}\n\n.mdi-home-minus::before {\n  content: \"\\f0974\";\n}\n\n.mdi-home-minus-outline::before {\n  content: \"\\f13d5\";\n}\n\n.mdi-home-modern::before {\n  content: \"\\f02dd\";\n}\n\n.mdi-home-outline::before {\n  content: \"\\f06a1\";\n}\n\n.mdi-home-plus::before {\n  content: \"\\f0975\";\n}\n\n.mdi-home-plus-outline::before {\n  content: \"\\f13d6\";\n}\n\n.mdi-home-remove::before {\n  content: \"\\f1247\";\n}\n\n.mdi-home-remove-outline::before {\n  content: \"\\f13d7\";\n}\n\n.mdi-home-roof::before {\n  content: \"\\f112b\";\n}\n\n.mdi-home-search::before {\n  content: \"\\f13b0\";\n}\n\n.mdi-home-search-outline::before {\n  content: \"\\f13b1\";\n}\n\n.mdi-home-switch::before {\n  content: \"\\f1794\";\n}\n\n.mdi-home-switch-outline::before {\n  content: \"\\f1795\";\n}\n\n.mdi-home-thermometer::before {\n  content: \"\\f0f54\";\n}\n\n.mdi-home-thermometer-outline::before {\n  content: \"\\f0f55\";\n}\n\n.mdi-home-variant::before {\n  content: \"\\f02de\";\n}\n\n.mdi-home-variant-outline::before {\n  content: \"\\f0ba7\";\n}\n\n.mdi-hook::before {\n  content: \"\\f06e2\";\n}\n\n.mdi-hook-off::before {\n  content: \"\\f06e3\";\n}\n\n.mdi-hoop-house::before {\n  content: \"\\f0e56\";\n}\n\n.mdi-hops::before {\n  content: \"\\f02df\";\n}\n\n.mdi-horizontal-rotate-clockwise::before {\n  content: \"\\f10f3\";\n}\n\n.mdi-horizontal-rotate-counterclockwise::before {\n  content: \"\\f10f4\";\n}\n\n.mdi-horse::before {\n  content: \"\\f15bf\";\n}\n\n.mdi-horse-human::before {\n  content: \"\\f15c0\";\n}\n\n.mdi-horse-variant::before {\n  content: \"\\f15c1\";\n}\n\n.mdi-horse-variant-fast::before {\n  content: \"\\f186e\";\n}\n\n.mdi-horseshoe::before {\n  content: \"\\f0a58\";\n}\n\n.mdi-hospital::before {\n  content: \"\\f0ff6\";\n}\n\n.mdi-hospital-box::before {\n  content: \"\\f02e0\";\n}\n\n.mdi-hospital-box-outline::before {\n  content: \"\\f0ff7\";\n}\n\n.mdi-hospital-building::before {\n  content: \"\\f02e1\";\n}\n\n.mdi-hospital-marker::before {\n  content: \"\\f02e2\";\n}\n\n.mdi-hot-tub::before {\n  content: \"\\f0828\";\n}\n\n.mdi-hours-24::before {\n  content: \"\\f1478\";\n}\n\n.mdi-hubspot::before {\n  content: \"\\f0d17\";\n}\n\n.mdi-hulu::before {\n  content: \"\\f0829\";\n}\n\n.mdi-human::before {\n  content: \"\\f02e6\";\n}\n\n.mdi-human-baby-changing-table::before {\n  content: \"\\f138b\";\n}\n\n.mdi-human-cane::before {\n  content: \"\\f1581\";\n}\n\n.mdi-human-capacity-decrease::before {\n  content: \"\\f159b\";\n}\n\n.mdi-human-capacity-increase::before {\n  content: \"\\f159c\";\n}\n\n.mdi-human-child::before {\n  content: \"\\f02e7\";\n}\n\n.mdi-human-dolly::before {\n  content: \"\\f1980\";\n}\n\n.mdi-human-edit::before {\n  content: \"\\f14e8\";\n}\n\n.mdi-human-female::before {\n  content: \"\\f0649\";\n}\n\n.mdi-human-female-boy::before {\n  content: \"\\f0a59\";\n}\n\n.mdi-human-female-dance::before {\n  content: \"\\f15c9\";\n}\n\n.mdi-human-female-female::before {\n  content: \"\\f0a5a\";\n}\n\n.mdi-human-female-girl::before {\n  content: \"\\f0a5b\";\n}\n\n.mdi-human-greeting::before {\n  content: \"\\f17c4\";\n}\n\n.mdi-human-greeting-proximity::before {\n  content: \"\\f159d\";\n}\n\n.mdi-human-greeting-variant::before {\n  content: \"\\f064a\";\n}\n\n.mdi-human-handsdown::before {\n  content: \"\\f064b\";\n}\n\n.mdi-human-handsup::before {\n  content: \"\\f064c\";\n}\n\n.mdi-human-male::before {\n  content: \"\\f064d\";\n}\n\n.mdi-human-male-board::before {\n  content: \"\\f0890\";\n}\n\n.mdi-human-male-board-poll::before {\n  content: \"\\f0846\";\n}\n\n.mdi-human-male-boy::before {\n  content: \"\\f0a5c\";\n}\n\n.mdi-human-male-child::before {\n  content: \"\\f138c\";\n}\n\n.mdi-human-male-female::before {\n  content: \"\\f02e8\";\n}\n\n.mdi-human-male-female-child::before {\n  content: \"\\f1823\";\n}\n\n.mdi-human-male-girl::before {\n  content: \"\\f0a5d\";\n}\n\n.mdi-human-male-height::before {\n  content: \"\\f0efb\";\n}\n\n.mdi-human-male-height-variant::before {\n  content: \"\\f0efc\";\n}\n\n.mdi-human-male-male::before {\n  content: \"\\f0a5e\";\n}\n\n.mdi-human-non-binary::before {\n  content: \"\\f1848\";\n}\n\n.mdi-human-pregnant::before {\n  content: \"\\f05cf\";\n}\n\n.mdi-human-queue::before {\n  content: \"\\f1571\";\n}\n\n.mdi-human-scooter::before {\n  content: \"\\f11e9\";\n}\n\n.mdi-human-wheelchair::before {\n  content: \"\\f138d\";\n}\n\n.mdi-human-white-cane::before {\n  content: \"\\f1981\";\n}\n\n.mdi-humble-bundle::before {\n  content: \"\\f0744\";\n}\n\n.mdi-hvac::before {\n  content: \"\\f1352\";\n}\n\n.mdi-hvac-off::before {\n  content: \"\\f159e\";\n}\n\n.mdi-hydraulic-oil-level::before {\n  content: \"\\f1324\";\n}\n\n.mdi-hydraulic-oil-temperature::before {\n  content: \"\\f1325\";\n}\n\n.mdi-hydro-power::before {\n  content: \"\\f12e5\";\n}\n\n.mdi-hydrogen-station::before {\n  content: \"\\f1894\";\n}\n\n.mdi-ice-cream::before {\n  content: \"\\f082a\";\n}\n\n.mdi-ice-cream-off::before {\n  content: \"\\f0e52\";\n}\n\n.mdi-ice-pop::before {\n  content: \"\\f0efd\";\n}\n\n.mdi-id-card::before {\n  content: \"\\f0fc0\";\n}\n\n.mdi-identifier::before {\n  content: \"\\f0efe\";\n}\n\n.mdi-ideogram-cjk::before {\n  content: \"\\f1331\";\n}\n\n.mdi-ideogram-cjk-variant::before {\n  content: \"\\f1332\";\n}\n\n.mdi-image::before {\n  content: \"\\f02e9\";\n}\n\n.mdi-image-album::before {\n  content: \"\\f02ea\";\n}\n\n.mdi-image-area::before {\n  content: \"\\f02eb\";\n}\n\n.mdi-image-area-close::before {\n  content: \"\\f02ec\";\n}\n\n.mdi-image-auto-adjust::before {\n  content: \"\\f0fc1\";\n}\n\n.mdi-image-broken::before {\n  content: \"\\f02ed\";\n}\n\n.mdi-image-broken-variant::before {\n  content: \"\\f02ee\";\n}\n\n.mdi-image-edit::before {\n  content: \"\\f11e3\";\n}\n\n.mdi-image-edit-outline::before {\n  content: \"\\f11e4\";\n}\n\n.mdi-image-filter-black-white::before {\n  content: \"\\f02f0\";\n}\n\n.mdi-image-filter-center-focus::before {\n  content: \"\\f02f1\";\n}\n\n.mdi-image-filter-center-focus-strong::before {\n  content: \"\\f0eff\";\n}\n\n.mdi-image-filter-center-focus-strong-outline::before {\n  content: \"\\f0f00\";\n}\n\n.mdi-image-filter-center-focus-weak::before {\n  content: \"\\f02f2\";\n}\n\n.mdi-image-filter-drama::before {\n  content: \"\\f02f3\";\n}\n\n.mdi-image-filter-frames::before {\n  content: \"\\f02f4\";\n}\n\n.mdi-image-filter-hdr::before {\n  content: \"\\f02f5\";\n}\n\n.mdi-image-filter-none::before {\n  content: \"\\f02f6\";\n}\n\n.mdi-image-filter-tilt-shift::before {\n  content: \"\\f02f7\";\n}\n\n.mdi-image-filter-vintage::before {\n  content: \"\\f02f8\";\n}\n\n.mdi-image-frame::before {\n  content: \"\\f0e49\";\n}\n\n.mdi-image-marker::before {\n  content: \"\\f177b\";\n}\n\n.mdi-image-marker-outline::before {\n  content: \"\\f177c\";\n}\n\n.mdi-image-minus::before {\n  content: \"\\f1419\";\n}\n\n.mdi-image-move::before {\n  content: \"\\f09f8\";\n}\n\n.mdi-image-multiple::before {\n  content: \"\\f02f9\";\n}\n\n.mdi-image-multiple-outline::before {\n  content: \"\\f02ef\";\n}\n\n.mdi-image-off::before {\n  content: \"\\f082b\";\n}\n\n.mdi-image-off-outline::before {\n  content: \"\\f11d1\";\n}\n\n.mdi-image-outline::before {\n  content: \"\\f0976\";\n}\n\n.mdi-image-plus::before {\n  content: \"\\f087c\";\n}\n\n.mdi-image-remove::before {\n  content: \"\\f1418\";\n}\n\n.mdi-image-search::before {\n  content: \"\\f0977\";\n}\n\n.mdi-image-search-outline::before {\n  content: \"\\f0978\";\n}\n\n.mdi-image-size-select-actual::before {\n  content: \"\\f0c8d\";\n}\n\n.mdi-image-size-select-large::before {\n  content: \"\\f0c8e\";\n}\n\n.mdi-image-size-select-small::before {\n  content: \"\\f0c8f\";\n}\n\n.mdi-image-text::before {\n  content: \"\\f160d\";\n}\n\n.mdi-import::before {\n  content: \"\\f02fa\";\n}\n\n.mdi-inbox::before {\n  content: \"\\f0687\";\n}\n\n.mdi-inbox-arrow-down::before {\n  content: \"\\f02fb\";\n}\n\n.mdi-inbox-arrow-down-outline::before {\n  content: \"\\f1270\";\n}\n\n.mdi-inbox-arrow-up::before {\n  content: \"\\f03d1\";\n}\n\n.mdi-inbox-arrow-up-outline::before {\n  content: \"\\f1271\";\n}\n\n.mdi-inbox-full::before {\n  content: \"\\f1272\";\n}\n\n.mdi-inbox-full-outline::before {\n  content: \"\\f1273\";\n}\n\n.mdi-inbox-multiple::before {\n  content: \"\\f08b0\";\n}\n\n.mdi-inbox-multiple-outline::before {\n  content: \"\\f0ba8\";\n}\n\n.mdi-inbox-outline::before {\n  content: \"\\f1274\";\n}\n\n.mdi-inbox-remove::before {\n  content: \"\\f159f\";\n}\n\n.mdi-inbox-remove-outline::before {\n  content: \"\\f15a0\";\n}\n\n.mdi-incognito::before {\n  content: \"\\f05f9\";\n}\n\n.mdi-incognito-circle::before {\n  content: \"\\f1421\";\n}\n\n.mdi-incognito-circle-off::before {\n  content: \"\\f1422\";\n}\n\n.mdi-incognito-off::before {\n  content: \"\\f0075\";\n}\n\n.mdi-induction::before {\n  content: \"\\f184c\";\n}\n\n.mdi-infinity::before {\n  content: \"\\f06e4\";\n}\n\n.mdi-information::before {\n  content: \"\\f02fc\";\n}\n\n.mdi-information-off::before {\n  content: \"\\f178c\";\n}\n\n.mdi-information-off-outline::before {\n  content: \"\\f178d\";\n}\n\n.mdi-information-outline::before {\n  content: \"\\f02fd\";\n}\n\n.mdi-information-variant::before {\n  content: \"\\f064e\";\n}\n\n.mdi-instagram::before {\n  content: \"\\f02fe\";\n}\n\n.mdi-instrument-triangle::before {\n  content: \"\\f104e\";\n}\n\n.mdi-integrated-circuit-chip::before {\n  content: \"\\f1913\";\n}\n\n.mdi-invert-colors::before {\n  content: \"\\f0301\";\n}\n\n.mdi-invert-colors-off::before {\n  content: \"\\f0e4a\";\n}\n\n.mdi-iobroker::before {\n  content: \"\\f12e8\";\n}\n\n.mdi-ip::before {\n  content: \"\\f0a5f\";\n}\n\n.mdi-ip-network::before {\n  content: \"\\f0a60\";\n}\n\n.mdi-ip-network-outline::before {\n  content: \"\\f0c90\";\n}\n\n.mdi-ip-outline::before {\n  content: \"\\f1982\";\n}\n\n.mdi-ipod::before {\n  content: \"\\f0c91\";\n}\n\n.mdi-iron::before {\n  content: \"\\f1824\";\n}\n\n.mdi-iron-board::before {\n  content: \"\\f1838\";\n}\n\n.mdi-iron-outline::before {\n  content: \"\\f1825\";\n}\n\n.mdi-island::before {\n  content: \"\\f104f\";\n}\n\n.mdi-iv-bag::before {\n  content: \"\\f10b9\";\n}\n\n.mdi-jabber::before {\n  content: \"\\f0dd5\";\n}\n\n.mdi-jeepney::before {\n  content: \"\\f0302\";\n}\n\n.mdi-jellyfish::before {\n  content: \"\\f0f01\";\n}\n\n.mdi-jellyfish-outline::before {\n  content: \"\\f0f02\";\n}\n\n.mdi-jira::before {\n  content: \"\\f0303\";\n}\n\n.mdi-jquery::before {\n  content: \"\\f087d\";\n}\n\n.mdi-jsfiddle::before {\n  content: \"\\f0304\";\n}\n\n.mdi-jump-rope::before {\n  content: \"\\f12ff\";\n}\n\n.mdi-kabaddi::before {\n  content: \"\\f0d87\";\n}\n\n.mdi-kangaroo::before {\n  content: \"\\f1558\";\n}\n\n.mdi-karate::before {\n  content: \"\\f082c\";\n}\n\n.mdi-kayaking::before {\n  content: \"\\f08af\";\n}\n\n.mdi-keg::before {\n  content: \"\\f0305\";\n}\n\n.mdi-kettle::before {\n  content: \"\\f05fa\";\n}\n\n.mdi-kettle-alert::before {\n  content: \"\\f1317\";\n}\n\n.mdi-kettle-alert-outline::before {\n  content: \"\\f1318\";\n}\n\n.mdi-kettle-off::before {\n  content: \"\\f131b\";\n}\n\n.mdi-kettle-off-outline::before {\n  content: \"\\f131c\";\n}\n\n.mdi-kettle-outline::before {\n  content: \"\\f0f56\";\n}\n\n.mdi-kettle-pour-over::before {\n  content: \"\\f173c\";\n}\n\n.mdi-kettle-steam::before {\n  content: \"\\f1319\";\n}\n\n.mdi-kettle-steam-outline::before {\n  content: \"\\f131a\";\n}\n\n.mdi-kettlebell::before {\n  content: \"\\f1300\";\n}\n\n.mdi-key::before {\n  content: \"\\f0306\";\n}\n\n.mdi-key-alert::before {\n  content: \"\\f1983\";\n}\n\n.mdi-key-alert-outline::before {\n  content: \"\\f1984\";\n}\n\n.mdi-key-arrow-right::before {\n  content: \"\\f1312\";\n}\n\n.mdi-key-chain::before {\n  content: \"\\f1574\";\n}\n\n.mdi-key-chain-variant::before {\n  content: \"\\f1575\";\n}\n\n.mdi-key-change::before {\n  content: \"\\f0307\";\n}\n\n.mdi-key-link::before {\n  content: \"\\f119f\";\n}\n\n.mdi-key-minus::before {\n  content: \"\\f0308\";\n}\n\n.mdi-key-outline::before {\n  content: \"\\f0dd6\";\n}\n\n.mdi-key-plus::before {\n  content: \"\\f0309\";\n}\n\n.mdi-key-remove::before {\n  content: \"\\f030a\";\n}\n\n.mdi-key-star::before {\n  content: \"\\f119e\";\n}\n\n.mdi-key-variant::before {\n  content: \"\\f030b\";\n}\n\n.mdi-key-wireless::before {\n  content: \"\\f0fc2\";\n}\n\n.mdi-keyboard::before {\n  content: \"\\f030c\";\n}\n\n.mdi-keyboard-backspace::before {\n  content: \"\\f030d\";\n}\n\n.mdi-keyboard-caps::before {\n  content: \"\\f030e\";\n}\n\n.mdi-keyboard-close::before {\n  content: \"\\f030f\";\n}\n\n.mdi-keyboard-esc::before {\n  content: \"\\f12b7\";\n}\n\n.mdi-keyboard-f1::before {\n  content: \"\\f12ab\";\n}\n\n.mdi-keyboard-f10::before {\n  content: \"\\f12b4\";\n}\n\n.mdi-keyboard-f11::before {\n  content: \"\\f12b5\";\n}\n\n.mdi-keyboard-f12::before {\n  content: \"\\f12b6\";\n}\n\n.mdi-keyboard-f2::before {\n  content: \"\\f12ac\";\n}\n\n.mdi-keyboard-f3::before {\n  content: \"\\f12ad\";\n}\n\n.mdi-keyboard-f4::before {\n  content: \"\\f12ae\";\n}\n\n.mdi-keyboard-f5::before {\n  content: \"\\f12af\";\n}\n\n.mdi-keyboard-f6::before {\n  content: \"\\f12b0\";\n}\n\n.mdi-keyboard-f7::before {\n  content: \"\\f12b1\";\n}\n\n.mdi-keyboard-f8::before {\n  content: \"\\f12b2\";\n}\n\n.mdi-keyboard-f9::before {\n  content: \"\\f12b3\";\n}\n\n.mdi-keyboard-off::before {\n  content: \"\\f0310\";\n}\n\n.mdi-keyboard-off-outline::before {\n  content: \"\\f0e4b\";\n}\n\n.mdi-keyboard-outline::before {\n  content: \"\\f097b\";\n}\n\n.mdi-keyboard-return::before {\n  content: \"\\f0311\";\n}\n\n.mdi-keyboard-settings::before {\n  content: \"\\f09f9\";\n}\n\n.mdi-keyboard-settings-outline::before {\n  content: \"\\f09fa\";\n}\n\n.mdi-keyboard-space::before {\n  content: \"\\f1050\";\n}\n\n.mdi-keyboard-tab::before {\n  content: \"\\f0312\";\n}\n\n.mdi-keyboard-tab-reverse::before {\n  content: \"\\f0325\";\n}\n\n.mdi-keyboard-variant::before {\n  content: \"\\f0313\";\n}\n\n.mdi-khanda::before {\n  content: \"\\f10fd\";\n}\n\n.mdi-kickstarter::before {\n  content: \"\\f0745\";\n}\n\n.mdi-kite::before {\n  content: \"\\f1985\";\n}\n\n.mdi-kite-outline::before {\n  content: \"\\f1986\";\n}\n\n.mdi-kitesurfing::before {\n  content: \"\\f1744\";\n}\n\n.mdi-klingon::before {\n  content: \"\\f135b\";\n}\n\n.mdi-knife::before {\n  content: \"\\f09fb\";\n}\n\n.mdi-knife-military::before {\n  content: \"\\f09fc\";\n}\n\n.mdi-koala::before {\n  content: \"\\f173f\";\n}\n\n.mdi-kodi::before {\n  content: \"\\f0314\";\n}\n\n.mdi-kubernetes::before {\n  content: \"\\f10fe\";\n}\n\n.mdi-label::before {\n  content: \"\\f0315\";\n}\n\n.mdi-label-multiple::before {\n  content: \"\\f1375\";\n}\n\n.mdi-label-multiple-outline::before {\n  content: \"\\f1376\";\n}\n\n.mdi-label-off::before {\n  content: \"\\f0acb\";\n}\n\n.mdi-label-off-outline::before {\n  content: \"\\f0acc\";\n}\n\n.mdi-label-outline::before {\n  content: \"\\f0316\";\n}\n\n.mdi-label-percent::before {\n  content: \"\\f12ea\";\n}\n\n.mdi-label-percent-outline::before {\n  content: \"\\f12eb\";\n}\n\n.mdi-label-variant::before {\n  content: \"\\f0acd\";\n}\n\n.mdi-label-variant-outline::before {\n  content: \"\\f0ace\";\n}\n\n.mdi-ladder::before {\n  content: \"\\f15a2\";\n}\n\n.mdi-ladybug::before {\n  content: \"\\f082d\";\n}\n\n.mdi-lambda::before {\n  content: \"\\f0627\";\n}\n\n.mdi-lamp::before {\n  content: \"\\f06b5\";\n}\n\n.mdi-lamp-outline::before {\n  content: \"\\f17d0\";\n}\n\n.mdi-lamps::before {\n  content: \"\\f1576\";\n}\n\n.mdi-lamps-outline::before {\n  content: \"\\f17d1\";\n}\n\n.mdi-lan::before {\n  content: \"\\f0317\";\n}\n\n.mdi-lan-check::before {\n  content: \"\\f12aa\";\n}\n\n.mdi-lan-connect::before {\n  content: \"\\f0318\";\n}\n\n.mdi-lan-disconnect::before {\n  content: \"\\f0319\";\n}\n\n.mdi-lan-pending::before {\n  content: \"\\f031a\";\n}\n\n.mdi-language-c::before {\n  content: \"\\f0671\";\n}\n\n.mdi-language-cpp::before {\n  content: \"\\f0672\";\n}\n\n.mdi-language-csharp::before {\n  content: \"\\f031b\";\n}\n\n.mdi-language-css3::before {\n  content: \"\\f031c\";\n}\n\n.mdi-language-fortran::before {\n  content: \"\\f121a\";\n}\n\n.mdi-language-go::before {\n  content: \"\\f07d3\";\n}\n\n.mdi-language-haskell::before {\n  content: \"\\f0c92\";\n}\n\n.mdi-language-html5::before {\n  content: \"\\f031d\";\n}\n\n.mdi-language-java::before {\n  content: \"\\f0b37\";\n}\n\n.mdi-language-javascript::before {\n  content: \"\\f031e\";\n}\n\n.mdi-language-kotlin::before {\n  content: \"\\f1219\";\n}\n\n.mdi-language-lua::before {\n  content: \"\\f08b1\";\n}\n\n.mdi-language-markdown::before {\n  content: \"\\f0354\";\n}\n\n.mdi-language-markdown-outline::before {\n  content: \"\\f0f5b\";\n}\n\n.mdi-language-php::before {\n  content: \"\\f031f\";\n}\n\n.mdi-language-python::before {\n  content: \"\\f0320\";\n}\n\n.mdi-language-r::before {\n  content: \"\\f07d4\";\n}\n\n.mdi-language-ruby::before {\n  content: \"\\f0d2d\";\n}\n\n.mdi-language-ruby-on-rails::before {\n  content: \"\\f0acf\";\n}\n\n.mdi-language-rust::before {\n  content: \"\\f1617\";\n}\n\n.mdi-language-swift::before {\n  content: \"\\f06e5\";\n}\n\n.mdi-language-typescript::before {\n  content: \"\\f06e6\";\n}\n\n.mdi-language-xaml::before {\n  content: \"\\f0673\";\n}\n\n.mdi-laptop::before {\n  content: \"\\f0322\";\n}\n\n.mdi-laptop-off::before {\n  content: \"\\f06e7\";\n}\n\n.mdi-laravel::before {\n  content: \"\\f0ad0\";\n}\n\n.mdi-laser-pointer::before {\n  content: \"\\f1484\";\n}\n\n.mdi-lasso::before {\n  content: \"\\f0f03\";\n}\n\n.mdi-lastpass::before {\n  content: \"\\f0446\";\n}\n\n.mdi-latitude::before {\n  content: \"\\f0f57\";\n}\n\n.mdi-launch::before {\n  content: \"\\f0327\";\n}\n\n.mdi-lava-lamp::before {\n  content: \"\\f07d5\";\n}\n\n.mdi-layers::before {\n  content: \"\\f0328\";\n}\n\n.mdi-layers-edit::before {\n  content: \"\\f1892\";\n}\n\n.mdi-layers-minus::before {\n  content: \"\\f0e4c\";\n}\n\n.mdi-layers-off::before {\n  content: \"\\f0329\";\n}\n\n.mdi-layers-off-outline::before {\n  content: \"\\f09fd\";\n}\n\n.mdi-layers-outline::before {\n  content: \"\\f09fe\";\n}\n\n.mdi-layers-plus::before {\n  content: \"\\f0e4d\";\n}\n\n.mdi-layers-remove::before {\n  content: \"\\f0e4e\";\n}\n\n.mdi-layers-search::before {\n  content: \"\\f1206\";\n}\n\n.mdi-layers-search-outline::before {\n  content: \"\\f1207\";\n}\n\n.mdi-layers-triple::before {\n  content: \"\\f0f58\";\n}\n\n.mdi-layers-triple-outline::before {\n  content: \"\\f0f59\";\n}\n\n.mdi-lead-pencil::before {\n  content: \"\\f064f\";\n}\n\n.mdi-leaf::before {\n  content: \"\\f032a\";\n}\n\n.mdi-leaf-circle::before {\n  content: \"\\f1905\";\n}\n\n.mdi-leaf-circle-outline::before {\n  content: \"\\f1906\";\n}\n\n.mdi-leaf-maple::before {\n  content: \"\\f0c93\";\n}\n\n.mdi-leaf-maple-off::before {\n  content: \"\\f12da\";\n}\n\n.mdi-leaf-off::before {\n  content: \"\\f12d9\";\n}\n\n.mdi-leak::before {\n  content: \"\\f0dd7\";\n}\n\n.mdi-leak-off::before {\n  content: \"\\f0dd8\";\n}\n\n.mdi-led-off::before {\n  content: \"\\f032b\";\n}\n\n.mdi-led-on::before {\n  content: \"\\f032c\";\n}\n\n.mdi-led-outline::before {\n  content: \"\\f032d\";\n}\n\n.mdi-led-strip::before {\n  content: \"\\f07d6\";\n}\n\n.mdi-led-strip-variant::before {\n  content: \"\\f1051\";\n}\n\n.mdi-led-variant-off::before {\n  content: \"\\f032e\";\n}\n\n.mdi-led-variant-on::before {\n  content: \"\\f032f\";\n}\n\n.mdi-led-variant-outline::before {\n  content: \"\\f0330\";\n}\n\n.mdi-leek::before {\n  content: \"\\f117d\";\n}\n\n.mdi-less-than::before {\n  content: \"\\f097c\";\n}\n\n.mdi-less-than-or-equal::before {\n  content: \"\\f097d\";\n}\n\n.mdi-library::before {\n  content: \"\\f0331\";\n}\n\n.mdi-library-shelves::before {\n  content: \"\\f0ba9\";\n}\n\n.mdi-license::before {\n  content: \"\\f0fc3\";\n}\n\n.mdi-lifebuoy::before {\n  content: \"\\f087e\";\n}\n\n.mdi-light-flood-down::before {\n  content: \"\\f1987\";\n}\n\n.mdi-light-flood-up::before {\n  content: \"\\f1988\";\n}\n\n.mdi-light-recessed::before {\n  content: \"\\f179b\";\n}\n\n.mdi-light-switch::before {\n  content: \"\\f097e\";\n}\n\n.mdi-lightbulb::before {\n  content: \"\\f0335\";\n}\n\n.mdi-lightbulb-auto::before {\n  content: \"\\f1800\";\n}\n\n.mdi-lightbulb-auto-outline::before {\n  content: \"\\f1801\";\n}\n\n.mdi-lightbulb-cfl::before {\n  content: \"\\f1208\";\n}\n\n.mdi-lightbulb-cfl-off::before {\n  content: \"\\f1209\";\n}\n\n.mdi-lightbulb-cfl-spiral::before {\n  content: \"\\f1275\";\n}\n\n.mdi-lightbulb-cfl-spiral-off::before {\n  content: \"\\f12c3\";\n}\n\n.mdi-lightbulb-fluorescent-tube::before {\n  content: \"\\f1804\";\n}\n\n.mdi-lightbulb-fluorescent-tube-outline::before {\n  content: \"\\f1805\";\n}\n\n.mdi-lightbulb-group::before {\n  content: \"\\f1253\";\n}\n\n.mdi-lightbulb-group-off::before {\n  content: \"\\f12cd\";\n}\n\n.mdi-lightbulb-group-off-outline::before {\n  content: \"\\f12ce\";\n}\n\n.mdi-lightbulb-group-outline::before {\n  content: \"\\f1254\";\n}\n\n.mdi-lightbulb-multiple::before {\n  content: \"\\f1255\";\n}\n\n.mdi-lightbulb-multiple-off::before {\n  content: \"\\f12cf\";\n}\n\n.mdi-lightbulb-multiple-off-outline::before {\n  content: \"\\f12d0\";\n}\n\n.mdi-lightbulb-multiple-outline::before {\n  content: \"\\f1256\";\n}\n\n.mdi-lightbulb-off::before {\n  content: \"\\f0e4f\";\n}\n\n.mdi-lightbulb-off-outline::before {\n  content: \"\\f0e50\";\n}\n\n.mdi-lightbulb-on::before {\n  content: \"\\f06e8\";\n}\n\n.mdi-lightbulb-on-outline::before {\n  content: \"\\f06e9\";\n}\n\n.mdi-lightbulb-outline::before {\n  content: \"\\f0336\";\n}\n\n.mdi-lightbulb-spot::before {\n  content: \"\\f17f4\";\n}\n\n.mdi-lightbulb-spot-off::before {\n  content: \"\\f17f5\";\n}\n\n.mdi-lightbulb-variant::before {\n  content: \"\\f1802\";\n}\n\n.mdi-lightbulb-variant-outline::before {\n  content: \"\\f1803\";\n}\n\n.mdi-lighthouse::before {\n  content: \"\\f09ff\";\n}\n\n.mdi-lighthouse-on::before {\n  content: \"\\f0a00\";\n}\n\n.mdi-lightning-bolt::before {\n  content: \"\\f140b\";\n}\n\n.mdi-lightning-bolt-circle::before {\n  content: \"\\f0820\";\n}\n\n.mdi-lightning-bolt-outline::before {\n  content: \"\\f140c\";\n}\n\n.mdi-line-scan::before {\n  content: \"\\f0624\";\n}\n\n.mdi-lingerie::before {\n  content: \"\\f1476\";\n}\n\n.mdi-link::before {\n  content: \"\\f0337\";\n}\n\n.mdi-link-box::before {\n  content: \"\\f0d1a\";\n}\n\n.mdi-link-box-outline::before {\n  content: \"\\f0d1b\";\n}\n\n.mdi-link-box-variant::before {\n  content: \"\\f0d1c\";\n}\n\n.mdi-link-box-variant-outline::before {\n  content: \"\\f0d1d\";\n}\n\n.mdi-link-lock::before {\n  content: \"\\f10ba\";\n}\n\n.mdi-link-off::before {\n  content: \"\\f0338\";\n}\n\n.mdi-link-plus::before {\n  content: \"\\f0c94\";\n}\n\n.mdi-link-variant::before {\n  content: \"\\f0339\";\n}\n\n.mdi-link-variant-minus::before {\n  content: \"\\f10ff\";\n}\n\n.mdi-link-variant-off::before {\n  content: \"\\f033a\";\n}\n\n.mdi-link-variant-plus::before {\n  content: \"\\f1100\";\n}\n\n.mdi-link-variant-remove::before {\n  content: \"\\f1101\";\n}\n\n.mdi-linkedin::before {\n  content: \"\\f033b\";\n}\n\n.mdi-linux::before {\n  content: \"\\f033d\";\n}\n\n.mdi-linux-mint::before {\n  content: \"\\f08ed\";\n}\n\n.mdi-lipstick::before {\n  content: \"\\f13b5\";\n}\n\n.mdi-liquid-spot::before {\n  content: \"\\f1826\";\n}\n\n.mdi-liquor::before {\n  content: \"\\f191e\";\n}\n\n.mdi-list-status::before {\n  content: \"\\f15ab\";\n}\n\n.mdi-litecoin::before {\n  content: \"\\f0a61\";\n}\n\n.mdi-loading::before {\n  content: \"\\f0772\";\n}\n\n.mdi-location-enter::before {\n  content: \"\\f0fc4\";\n}\n\n.mdi-location-exit::before {\n  content: \"\\f0fc5\";\n}\n\n.mdi-lock::before {\n  content: \"\\f033e\";\n}\n\n.mdi-lock-alert::before {\n  content: \"\\f08ee\";\n}\n\n.mdi-lock-alert-outline::before {\n  content: \"\\f15d1\";\n}\n\n.mdi-lock-check::before {\n  content: \"\\f139a\";\n}\n\n.mdi-lock-check-outline::before {\n  content: \"\\f16a8\";\n}\n\n.mdi-lock-clock::before {\n  content: \"\\f097f\";\n}\n\n.mdi-lock-minus::before {\n  content: \"\\f16a9\";\n}\n\n.mdi-lock-minus-outline::before {\n  content: \"\\f16aa\";\n}\n\n.mdi-lock-off::before {\n  content: \"\\f1671\";\n}\n\n.mdi-lock-off-outline::before {\n  content: \"\\f1672\";\n}\n\n.mdi-lock-open::before {\n  content: \"\\f033f\";\n}\n\n.mdi-lock-open-alert::before {\n  content: \"\\f139b\";\n}\n\n.mdi-lock-open-alert-outline::before {\n  content: \"\\f15d2\";\n}\n\n.mdi-lock-open-check::before {\n  content: \"\\f139c\";\n}\n\n.mdi-lock-open-check-outline::before {\n  content: \"\\f16ab\";\n}\n\n.mdi-lock-open-minus::before {\n  content: \"\\f16ac\";\n}\n\n.mdi-lock-open-minus-outline::before {\n  content: \"\\f16ad\";\n}\n\n.mdi-lock-open-outline::before {\n  content: \"\\f0340\";\n}\n\n.mdi-lock-open-plus::before {\n  content: \"\\f16ae\";\n}\n\n.mdi-lock-open-plus-outline::before {\n  content: \"\\f16af\";\n}\n\n.mdi-lock-open-remove::before {\n  content: \"\\f16b0\";\n}\n\n.mdi-lock-open-remove-outline::before {\n  content: \"\\f16b1\";\n}\n\n.mdi-lock-open-variant::before {\n  content: \"\\f0fc6\";\n}\n\n.mdi-lock-open-variant-outline::before {\n  content: \"\\f0fc7\";\n}\n\n.mdi-lock-outline::before {\n  content: \"\\f0341\";\n}\n\n.mdi-lock-pattern::before {\n  content: \"\\f06ea\";\n}\n\n.mdi-lock-plus::before {\n  content: \"\\f05fb\";\n}\n\n.mdi-lock-plus-outline::before {\n  content: \"\\f16b2\";\n}\n\n.mdi-lock-question::before {\n  content: \"\\f08ef\";\n}\n\n.mdi-lock-remove::before {\n  content: \"\\f16b3\";\n}\n\n.mdi-lock-remove-outline::before {\n  content: \"\\f16b4\";\n}\n\n.mdi-lock-reset::before {\n  content: \"\\f0773\";\n}\n\n.mdi-lock-smart::before {\n  content: \"\\f08b2\";\n}\n\n.mdi-locker::before {\n  content: \"\\f07d7\";\n}\n\n.mdi-locker-multiple::before {\n  content: \"\\f07d8\";\n}\n\n.mdi-login::before {\n  content: \"\\f0342\";\n}\n\n.mdi-login-variant::before {\n  content: \"\\f05fc\";\n}\n\n.mdi-logout::before {\n  content: \"\\f0343\";\n}\n\n.mdi-logout-variant::before {\n  content: \"\\f05fd\";\n}\n\n.mdi-longitude::before {\n  content: \"\\f0f5a\";\n}\n\n.mdi-looks::before {\n  content: \"\\f0344\";\n}\n\n.mdi-lotion::before {\n  content: \"\\f1582\";\n}\n\n.mdi-lotion-outline::before {\n  content: \"\\f1583\";\n}\n\n.mdi-lotion-plus::before {\n  content: \"\\f1584\";\n}\n\n.mdi-lotion-plus-outline::before {\n  content: \"\\f1585\";\n}\n\n.mdi-loupe::before {\n  content: \"\\f0345\";\n}\n\n.mdi-lumx::before {\n  content: \"\\f0346\";\n}\n\n.mdi-lungs::before {\n  content: \"\\f1084\";\n}\n\n.mdi-mace::before {\n  content: \"\\f1843\";\n}\n\n.mdi-magazine-pistol::before {\n  content: \"\\f0324\";\n}\n\n.mdi-magazine-rifle::before {\n  content: \"\\f0323\";\n}\n\n.mdi-magic-staff::before {\n  content: \"\\f1844\";\n}\n\n.mdi-magnet::before {\n  content: \"\\f0347\";\n}\n\n.mdi-magnet-on::before {\n  content: \"\\f0348\";\n}\n\n.mdi-magnify::before {\n  content: \"\\f0349\";\n}\n\n.mdi-magnify-close::before {\n  content: \"\\f0980\";\n}\n\n.mdi-magnify-expand::before {\n  content: \"\\f1874\";\n}\n\n.mdi-magnify-minus::before {\n  content: \"\\f034a\";\n}\n\n.mdi-magnify-minus-cursor::before {\n  content: \"\\f0a62\";\n}\n\n.mdi-magnify-minus-outline::before {\n  content: \"\\f06ec\";\n}\n\n.mdi-magnify-plus::before {\n  content: \"\\f034b\";\n}\n\n.mdi-magnify-plus-cursor::before {\n  content: \"\\f0a63\";\n}\n\n.mdi-magnify-plus-outline::before {\n  content: \"\\f06ed\";\n}\n\n.mdi-magnify-remove-cursor::before {\n  content: \"\\f120c\";\n}\n\n.mdi-magnify-remove-outline::before {\n  content: \"\\f120d\";\n}\n\n.mdi-magnify-scan::before {\n  content: \"\\f1276\";\n}\n\n.mdi-mail::before {\n  content: \"\\f0ebb\";\n}\n\n.mdi-mailbox::before {\n  content: \"\\f06ee\";\n}\n\n.mdi-mailbox-open::before {\n  content: \"\\f0d88\";\n}\n\n.mdi-mailbox-open-outline::before {\n  content: \"\\f0d89\";\n}\n\n.mdi-mailbox-open-up::before {\n  content: \"\\f0d8a\";\n}\n\n.mdi-mailbox-open-up-outline::before {\n  content: \"\\f0d8b\";\n}\n\n.mdi-mailbox-outline::before {\n  content: \"\\f0d8c\";\n}\n\n.mdi-mailbox-up::before {\n  content: \"\\f0d8d\";\n}\n\n.mdi-mailbox-up-outline::before {\n  content: \"\\f0d8e\";\n}\n\n.mdi-manjaro::before {\n  content: \"\\f160a\";\n}\n\n.mdi-map::before {\n  content: \"\\f034d\";\n}\n\n.mdi-map-check::before {\n  content: \"\\f0ebc\";\n}\n\n.mdi-map-check-outline::before {\n  content: \"\\f0ebd\";\n}\n\n.mdi-map-clock::before {\n  content: \"\\f0d1e\";\n}\n\n.mdi-map-clock-outline::before {\n  content: \"\\f0d1f\";\n}\n\n.mdi-map-legend::before {\n  content: \"\\f0a01\";\n}\n\n.mdi-map-marker::before {\n  content: \"\\f034e\";\n}\n\n.mdi-map-marker-account::before {\n  content: \"\\f18e3\";\n}\n\n.mdi-map-marker-account-outline::before {\n  content: \"\\f18e4\";\n}\n\n.mdi-map-marker-alert::before {\n  content: \"\\f0f05\";\n}\n\n.mdi-map-marker-alert-outline::before {\n  content: \"\\f0f06\";\n}\n\n.mdi-map-marker-check::before {\n  content: \"\\f0c95\";\n}\n\n.mdi-map-marker-check-outline::before {\n  content: \"\\f12fb\";\n}\n\n.mdi-map-marker-circle::before {\n  content: \"\\f034f\";\n}\n\n.mdi-map-marker-distance::before {\n  content: \"\\f08f0\";\n}\n\n.mdi-map-marker-down::before {\n  content: \"\\f1102\";\n}\n\n.mdi-map-marker-left::before {\n  content: \"\\f12db\";\n}\n\n.mdi-map-marker-left-outline::before {\n  content: \"\\f12dd\";\n}\n\n.mdi-map-marker-minus::before {\n  content: \"\\f0650\";\n}\n\n.mdi-map-marker-minus-outline::before {\n  content: \"\\f12f9\";\n}\n\n.mdi-map-marker-multiple::before {\n  content: \"\\f0350\";\n}\n\n.mdi-map-marker-multiple-outline::before {\n  content: \"\\f1277\";\n}\n\n.mdi-map-marker-off::before {\n  content: \"\\f0351\";\n}\n\n.mdi-map-marker-off-outline::before {\n  content: \"\\f12fd\";\n}\n\n.mdi-map-marker-outline::before {\n  content: \"\\f07d9\";\n}\n\n.mdi-map-marker-path::before {\n  content: \"\\f0d20\";\n}\n\n.mdi-map-marker-plus::before {\n  content: \"\\f0651\";\n}\n\n.mdi-map-marker-plus-outline::before {\n  content: \"\\f12f8\";\n}\n\n.mdi-map-marker-question::before {\n  content: \"\\f0f07\";\n}\n\n.mdi-map-marker-question-outline::before {\n  content: \"\\f0f08\";\n}\n\n.mdi-map-marker-radius::before {\n  content: \"\\f0352\";\n}\n\n.mdi-map-marker-radius-outline::before {\n  content: \"\\f12fc\";\n}\n\n.mdi-map-marker-remove::before {\n  content: \"\\f0f09\";\n}\n\n.mdi-map-marker-remove-outline::before {\n  content: \"\\f12fa\";\n}\n\n.mdi-map-marker-remove-variant::before {\n  content: \"\\f0f0a\";\n}\n\n.mdi-map-marker-right::before {\n  content: \"\\f12dc\";\n}\n\n.mdi-map-marker-right-outline::before {\n  content: \"\\f12de\";\n}\n\n.mdi-map-marker-star::before {\n  content: \"\\f1608\";\n}\n\n.mdi-map-marker-star-outline::before {\n  content: \"\\f1609\";\n}\n\n.mdi-map-marker-up::before {\n  content: \"\\f1103\";\n}\n\n.mdi-map-minus::before {\n  content: \"\\f0981\";\n}\n\n.mdi-map-outline::before {\n  content: \"\\f0982\";\n}\n\n.mdi-map-plus::before {\n  content: \"\\f0983\";\n}\n\n.mdi-map-search::before {\n  content: \"\\f0984\";\n}\n\n.mdi-map-search-outline::before {\n  content: \"\\f0985\";\n}\n\n.mdi-mapbox::before {\n  content: \"\\f0baa\";\n}\n\n.mdi-margin::before {\n  content: \"\\f0353\";\n}\n\n.mdi-marker::before {\n  content: \"\\f0652\";\n}\n\n.mdi-marker-cancel::before {\n  content: \"\\f0dd9\";\n}\n\n.mdi-marker-check::before {\n  content: \"\\f0355\";\n}\n\n.mdi-mastodon::before {\n  content: \"\\f0ad1\";\n}\n\n.mdi-material-design::before {\n  content: \"\\f0986\";\n}\n\n.mdi-material-ui::before {\n  content: \"\\f0357\";\n}\n\n.mdi-math-compass::before {\n  content: \"\\f0358\";\n}\n\n.mdi-math-cos::before {\n  content: \"\\f0c96\";\n}\n\n.mdi-math-integral::before {\n  content: \"\\f0fc8\";\n}\n\n.mdi-math-integral-box::before {\n  content: \"\\f0fc9\";\n}\n\n.mdi-math-log::before {\n  content: \"\\f1085\";\n}\n\n.mdi-math-norm::before {\n  content: \"\\f0fca\";\n}\n\n.mdi-math-norm-box::before {\n  content: \"\\f0fcb\";\n}\n\n.mdi-math-sin::before {\n  content: \"\\f0c97\";\n}\n\n.mdi-math-tan::before {\n  content: \"\\f0c98\";\n}\n\n.mdi-matrix::before {\n  content: \"\\f0628\";\n}\n\n.mdi-medal::before {\n  content: \"\\f0987\";\n}\n\n.mdi-medal-outline::before {\n  content: \"\\f1326\";\n}\n\n.mdi-medical-bag::before {\n  content: \"\\f06ef\";\n}\n\n.mdi-meditation::before {\n  content: \"\\f117b\";\n}\n\n.mdi-memory::before {\n  content: \"\\f035b\";\n}\n\n.mdi-menorah::before {\n  content: \"\\f17d4\";\n}\n\n.mdi-menorah-fire::before {\n  content: \"\\f17d5\";\n}\n\n.mdi-menu::before {\n  content: \"\\f035c\";\n}\n\n.mdi-menu-down::before {\n  content: \"\\f035d\";\n}\n\n.mdi-menu-down-outline::before {\n  content: \"\\f06b6\";\n}\n\n.mdi-menu-left::before {\n  content: \"\\f035e\";\n}\n\n.mdi-menu-left-outline::before {\n  content: \"\\f0a02\";\n}\n\n.mdi-menu-open::before {\n  content: \"\\f0bab\";\n}\n\n.mdi-menu-right::before {\n  content: \"\\f035f\";\n}\n\n.mdi-menu-right-outline::before {\n  content: \"\\f0a03\";\n}\n\n.mdi-menu-swap::before {\n  content: \"\\f0a64\";\n}\n\n.mdi-menu-swap-outline::before {\n  content: \"\\f0a65\";\n}\n\n.mdi-menu-up::before {\n  content: \"\\f0360\";\n}\n\n.mdi-menu-up-outline::before {\n  content: \"\\f06b7\";\n}\n\n.mdi-merge::before {\n  content: \"\\f0f5c\";\n}\n\n.mdi-message::before {\n  content: \"\\f0361\";\n}\n\n.mdi-message-alert::before {\n  content: \"\\f0362\";\n}\n\n.mdi-message-alert-outline::before {\n  content: \"\\f0a04\";\n}\n\n.mdi-message-arrow-left::before {\n  content: \"\\f12f2\";\n}\n\n.mdi-message-arrow-left-outline::before {\n  content: \"\\f12f3\";\n}\n\n.mdi-message-arrow-right::before {\n  content: \"\\f12f4\";\n}\n\n.mdi-message-arrow-right-outline::before {\n  content: \"\\f12f5\";\n}\n\n.mdi-message-badge::before {\n  content: \"\\f1941\";\n}\n\n.mdi-message-badge-outline::before {\n  content: \"\\f1942\";\n}\n\n.mdi-message-bookmark::before {\n  content: \"\\f15ac\";\n}\n\n.mdi-message-bookmark-outline::before {\n  content: \"\\f15ad\";\n}\n\n.mdi-message-bulleted::before {\n  content: \"\\f06a2\";\n}\n\n.mdi-message-bulleted-off::before {\n  content: \"\\f06a3\";\n}\n\n.mdi-message-cog::before {\n  content: \"\\f06f1\";\n}\n\n.mdi-message-cog-outline::before {\n  content: \"\\f1172\";\n}\n\n.mdi-message-draw::before {\n  content: \"\\f0363\";\n}\n\n.mdi-message-flash::before {\n  content: \"\\f15a9\";\n}\n\n.mdi-message-flash-outline::before {\n  content: \"\\f15aa\";\n}\n\n.mdi-message-image::before {\n  content: \"\\f0364\";\n}\n\n.mdi-message-image-outline::before {\n  content: \"\\f116c\";\n}\n\n.mdi-message-lock::before {\n  content: \"\\f0fcc\";\n}\n\n.mdi-message-lock-outline::before {\n  content: \"\\f116d\";\n}\n\n.mdi-message-minus::before {\n  content: \"\\f116e\";\n}\n\n.mdi-message-minus-outline::before {\n  content: \"\\f116f\";\n}\n\n.mdi-message-off::before {\n  content: \"\\f164d\";\n}\n\n.mdi-message-off-outline::before {\n  content: \"\\f164e\";\n}\n\n.mdi-message-outline::before {\n  content: \"\\f0365\";\n}\n\n.mdi-message-plus::before {\n  content: \"\\f0653\";\n}\n\n.mdi-message-plus-outline::before {\n  content: \"\\f10bb\";\n}\n\n.mdi-message-processing::before {\n  content: \"\\f0366\";\n}\n\n.mdi-message-processing-outline::before {\n  content: \"\\f1170\";\n}\n\n.mdi-message-question::before {\n  content: \"\\f173a\";\n}\n\n.mdi-message-question-outline::before {\n  content: \"\\f173b\";\n}\n\n.mdi-message-reply::before {\n  content: \"\\f0367\";\n}\n\n.mdi-message-reply-outline::before {\n  content: \"\\f173d\";\n}\n\n.mdi-message-reply-text::before {\n  content: \"\\f0368\";\n}\n\n.mdi-message-reply-text-outline::before {\n  content: \"\\f173e\";\n}\n\n.mdi-message-settings::before {\n  content: \"\\f06f0\";\n}\n\n.mdi-message-settings-outline::before {\n  content: \"\\f1171\";\n}\n\n.mdi-message-star::before {\n  content: \"\\f069a\";\n}\n\n.mdi-message-star-outline::before {\n  content: \"\\f1250\";\n}\n\n.mdi-message-text::before {\n  content: \"\\f0369\";\n}\n\n.mdi-message-text-clock::before {\n  content: \"\\f1173\";\n}\n\n.mdi-message-text-clock-outline::before {\n  content: \"\\f1174\";\n}\n\n.mdi-message-text-lock::before {\n  content: \"\\f0fcd\";\n}\n\n.mdi-message-text-lock-outline::before {\n  content: \"\\f1175\";\n}\n\n.mdi-message-text-outline::before {\n  content: \"\\f036a\";\n}\n\n.mdi-message-video::before {\n  content: \"\\f036b\";\n}\n\n.mdi-meteor::before {\n  content: \"\\f0629\";\n}\n\n.mdi-metronome::before {\n  content: \"\\f07da\";\n}\n\n.mdi-metronome-tick::before {\n  content: \"\\f07db\";\n}\n\n.mdi-micro-sd::before {\n  content: \"\\f07dc\";\n}\n\n.mdi-microphone::before {\n  content: \"\\f036c\";\n}\n\n.mdi-microphone-minus::before {\n  content: \"\\f08b3\";\n}\n\n.mdi-microphone-off::before {\n  content: \"\\f036d\";\n}\n\n.mdi-microphone-outline::before {\n  content: \"\\f036e\";\n}\n\n.mdi-microphone-plus::before {\n  content: \"\\f08b4\";\n}\n\n.mdi-microphone-question::before {\n  content: \"\\f1989\";\n}\n\n.mdi-microphone-question-outline::before {\n  content: \"\\f198a\";\n}\n\n.mdi-microphone-settings::before {\n  content: \"\\f036f\";\n}\n\n.mdi-microphone-variant::before {\n  content: \"\\f0370\";\n}\n\n.mdi-microphone-variant-off::before {\n  content: \"\\f0371\";\n}\n\n.mdi-microscope::before {\n  content: \"\\f0654\";\n}\n\n.mdi-microsoft::before {\n  content: \"\\f0372\";\n}\n\n.mdi-microsoft-access::before {\n  content: \"\\f138e\";\n}\n\n.mdi-microsoft-azure::before {\n  content: \"\\f0805\";\n}\n\n.mdi-microsoft-azure-devops::before {\n  content: \"\\f0fd5\";\n}\n\n.mdi-microsoft-bing::before {\n  content: \"\\f00a4\";\n}\n\n.mdi-microsoft-dynamics-365::before {\n  content: \"\\f0988\";\n}\n\n.mdi-microsoft-edge::before {\n  content: \"\\f01e9\";\n}\n\n.mdi-microsoft-excel::before {\n  content: \"\\f138f\";\n}\n\n.mdi-microsoft-internet-explorer::before {\n  content: \"\\f0300\";\n}\n\n.mdi-microsoft-office::before {\n  content: \"\\f03c6\";\n}\n\n.mdi-microsoft-onedrive::before {\n  content: \"\\f03ca\";\n}\n\n.mdi-microsoft-onenote::before {\n  content: \"\\f0747\";\n}\n\n.mdi-microsoft-outlook::before {\n  content: \"\\f0d22\";\n}\n\n.mdi-microsoft-powerpoint::before {\n  content: \"\\f1390\";\n}\n\n.mdi-microsoft-sharepoint::before {\n  content: \"\\f1391\";\n}\n\n.mdi-microsoft-teams::before {\n  content: \"\\f02bb\";\n}\n\n.mdi-microsoft-visual-studio::before {\n  content: \"\\f0610\";\n}\n\n.mdi-microsoft-visual-studio-code::before {\n  content: \"\\f0a1e\";\n}\n\n.mdi-microsoft-windows::before {\n  content: \"\\f05b3\";\n}\n\n.mdi-microsoft-windows-classic::before {\n  content: \"\\f0a21\";\n}\n\n.mdi-microsoft-word::before {\n  content: \"\\f1392\";\n}\n\n.mdi-microsoft-xbox::before {\n  content: \"\\f05b9\";\n}\n\n.mdi-microsoft-xbox-controller::before {\n  content: \"\\f05ba\";\n}\n\n.mdi-microsoft-xbox-controller-battery-alert::before {\n  content: \"\\f074b\";\n}\n\n.mdi-microsoft-xbox-controller-battery-charging::before {\n  content: \"\\f0a22\";\n}\n\n.mdi-microsoft-xbox-controller-battery-empty::before {\n  content: \"\\f074c\";\n}\n\n.mdi-microsoft-xbox-controller-battery-full::before {\n  content: \"\\f074d\";\n}\n\n.mdi-microsoft-xbox-controller-battery-low::before {\n  content: \"\\f074e\";\n}\n\n.mdi-microsoft-xbox-controller-battery-medium::before {\n  content: \"\\f074f\";\n}\n\n.mdi-microsoft-xbox-controller-battery-unknown::before {\n  content: \"\\f0750\";\n}\n\n.mdi-microsoft-xbox-controller-menu::before {\n  content: \"\\f0e6f\";\n}\n\n.mdi-microsoft-xbox-controller-off::before {\n  content: \"\\f05bb\";\n}\n\n.mdi-microsoft-xbox-controller-view::before {\n  content: \"\\f0e70\";\n}\n\n.mdi-microwave::before {\n  content: \"\\f0c99\";\n}\n\n.mdi-microwave-off::before {\n  content: \"\\f1423\";\n}\n\n.mdi-middleware::before {\n  content: \"\\f0f5d\";\n}\n\n.mdi-middleware-outline::before {\n  content: \"\\f0f5e\";\n}\n\n.mdi-midi::before {\n  content: \"\\f08f1\";\n}\n\n.mdi-midi-port::before {\n  content: \"\\f08f2\";\n}\n\n.mdi-mine::before {\n  content: \"\\f0dda\";\n}\n\n.mdi-minecraft::before {\n  content: \"\\f0373\";\n}\n\n.mdi-mini-sd::before {\n  content: \"\\f0a05\";\n}\n\n.mdi-minidisc::before {\n  content: \"\\f0a06\";\n}\n\n.mdi-minus::before {\n  content: \"\\f0374\";\n}\n\n.mdi-minus-box::before {\n  content: \"\\f0375\";\n}\n\n.mdi-minus-box-multiple::before {\n  content: \"\\f1141\";\n}\n\n.mdi-minus-box-multiple-outline::before {\n  content: \"\\f1142\";\n}\n\n.mdi-minus-box-outline::before {\n  content: \"\\f06f2\";\n}\n\n.mdi-minus-circle::before {\n  content: \"\\f0376\";\n}\n\n.mdi-minus-circle-multiple::before {\n  content: \"\\f035a\";\n}\n\n.mdi-minus-circle-multiple-outline::before {\n  content: \"\\f0ad3\";\n}\n\n.mdi-minus-circle-off::before {\n  content: \"\\f1459\";\n}\n\n.mdi-minus-circle-off-outline::before {\n  content: \"\\f145a\";\n}\n\n.mdi-minus-circle-outline::before {\n  content: \"\\f0377\";\n}\n\n.mdi-minus-network::before {\n  content: \"\\f0378\";\n}\n\n.mdi-minus-network-outline::before {\n  content: \"\\f0c9a\";\n}\n\n.mdi-minus-thick::before {\n  content: \"\\f1639\";\n}\n\n.mdi-mirror::before {\n  content: \"\\f11fd\";\n}\n\n.mdi-mirror-rectangle::before {\n  content: \"\\f179f\";\n}\n\n.mdi-mirror-variant::before {\n  content: \"\\f17a0\";\n}\n\n.mdi-mixed-martial-arts::before {\n  content: \"\\f0d8f\";\n}\n\n.mdi-mixed-reality::before {\n  content: \"\\f087f\";\n}\n\n.mdi-molecule::before {\n  content: \"\\f0bac\";\n}\n\n.mdi-molecule-co::before {\n  content: \"\\f12fe\";\n}\n\n.mdi-molecule-co2::before {\n  content: \"\\f07e4\";\n}\n\n.mdi-monitor::before {\n  content: \"\\f0379\";\n}\n\n.mdi-monitor-cellphone::before {\n  content: \"\\f0989\";\n}\n\n.mdi-monitor-cellphone-star::before {\n  content: \"\\f098a\";\n}\n\n.mdi-monitor-dashboard::before {\n  content: \"\\f0a07\";\n}\n\n.mdi-monitor-edit::before {\n  content: \"\\f12c6\";\n}\n\n.mdi-monitor-eye::before {\n  content: \"\\f13b4\";\n}\n\n.mdi-monitor-lock::before {\n  content: \"\\f0ddb\";\n}\n\n.mdi-monitor-multiple::before {\n  content: \"\\f037a\";\n}\n\n.mdi-monitor-off::before {\n  content: \"\\f0d90\";\n}\n\n.mdi-monitor-screenshot::before {\n  content: \"\\f0e51\";\n}\n\n.mdi-monitor-share::before {\n  content: \"\\f1483\";\n}\n\n.mdi-monitor-shimmer::before {\n  content: \"\\f1104\";\n}\n\n.mdi-monitor-small::before {\n  content: \"\\f1876\";\n}\n\n.mdi-monitor-speaker::before {\n  content: \"\\f0f5f\";\n}\n\n.mdi-monitor-speaker-off::before {\n  content: \"\\f0f60\";\n}\n\n.mdi-monitor-star::before {\n  content: \"\\f0ddc\";\n}\n\n.mdi-moon-first-quarter::before {\n  content: \"\\f0f61\";\n}\n\n.mdi-moon-full::before {\n  content: \"\\f0f62\";\n}\n\n.mdi-moon-last-quarter::before {\n  content: \"\\f0f63\";\n}\n\n.mdi-moon-new::before {\n  content: \"\\f0f64\";\n}\n\n.mdi-moon-waning-crescent::before {\n  content: \"\\f0f65\";\n}\n\n.mdi-moon-waning-gibbous::before {\n  content: \"\\f0f66\";\n}\n\n.mdi-moon-waxing-crescent::before {\n  content: \"\\f0f67\";\n}\n\n.mdi-moon-waxing-gibbous::before {\n  content: \"\\f0f68\";\n}\n\n.mdi-moped::before {\n  content: \"\\f1086\";\n}\n\n.mdi-moped-electric::before {\n  content: \"\\f15b7\";\n}\n\n.mdi-moped-electric-outline::before {\n  content: \"\\f15b8\";\n}\n\n.mdi-moped-outline::before {\n  content: \"\\f15b9\";\n}\n\n.mdi-more::before {\n  content: \"\\f037b\";\n}\n\n.mdi-mortar-pestle::before {\n  content: \"\\f1748\";\n}\n\n.mdi-mortar-pestle-plus::before {\n  content: \"\\f03f1\";\n}\n\n.mdi-mosque::before {\n  content: \"\\f1827\";\n}\n\n.mdi-mother-heart::before {\n  content: \"\\f1314\";\n}\n\n.mdi-mother-nurse::before {\n  content: \"\\f0d21\";\n}\n\n.mdi-motion::before {\n  content: \"\\f15b2\";\n}\n\n.mdi-motion-outline::before {\n  content: \"\\f15b3\";\n}\n\n.mdi-motion-pause::before {\n  content: \"\\f1590\";\n}\n\n.mdi-motion-pause-outline::before {\n  content: \"\\f1592\";\n}\n\n.mdi-motion-play::before {\n  content: \"\\f158f\";\n}\n\n.mdi-motion-play-outline::before {\n  content: \"\\f1591\";\n}\n\n.mdi-motion-sensor::before {\n  content: \"\\f0d91\";\n}\n\n.mdi-motion-sensor-off::before {\n  content: \"\\f1435\";\n}\n\n.mdi-motorbike::before {\n  content: \"\\f037c\";\n}\n\n.mdi-motorbike-electric::before {\n  content: \"\\f15ba\";\n}\n\n.mdi-mouse::before {\n  content: \"\\f037d\";\n}\n\n.mdi-mouse-bluetooth::before {\n  content: \"\\f098b\";\n}\n\n.mdi-mouse-move-down::before {\n  content: \"\\f1550\";\n}\n\n.mdi-mouse-move-up::before {\n  content: \"\\f1551\";\n}\n\n.mdi-mouse-move-vertical::before {\n  content: \"\\f1552\";\n}\n\n.mdi-mouse-off::before {\n  content: \"\\f037e\";\n}\n\n.mdi-mouse-variant::before {\n  content: \"\\f037f\";\n}\n\n.mdi-mouse-variant-off::before {\n  content: \"\\f0380\";\n}\n\n.mdi-move-resize::before {\n  content: \"\\f0655\";\n}\n\n.mdi-move-resize-variant::before {\n  content: \"\\f0656\";\n}\n\n.mdi-movie::before {\n  content: \"\\f0381\";\n}\n\n.mdi-movie-check::before {\n  content: \"\\f16f3\";\n}\n\n.mdi-movie-check-outline::before {\n  content: \"\\f16f4\";\n}\n\n.mdi-movie-cog::before {\n  content: \"\\f16f5\";\n}\n\n.mdi-movie-cog-outline::before {\n  content: \"\\f16f6\";\n}\n\n.mdi-movie-edit::before {\n  content: \"\\f1122\";\n}\n\n.mdi-movie-edit-outline::before {\n  content: \"\\f1123\";\n}\n\n.mdi-movie-filter::before {\n  content: \"\\f1124\";\n}\n\n.mdi-movie-filter-outline::before {\n  content: \"\\f1125\";\n}\n\n.mdi-movie-minus::before {\n  content: \"\\f16f7\";\n}\n\n.mdi-movie-minus-outline::before {\n  content: \"\\f16f8\";\n}\n\n.mdi-movie-off::before {\n  content: \"\\f16f9\";\n}\n\n.mdi-movie-off-outline::before {\n  content: \"\\f16fa\";\n}\n\n.mdi-movie-open::before {\n  content: \"\\f0fce\";\n}\n\n.mdi-movie-open-check::before {\n  content: \"\\f16fb\";\n}\n\n.mdi-movie-open-check-outline::before {\n  content: \"\\f16fc\";\n}\n\n.mdi-movie-open-cog::before {\n  content: \"\\f16fd\";\n}\n\n.mdi-movie-open-cog-outline::before {\n  content: \"\\f16fe\";\n}\n\n.mdi-movie-open-edit::before {\n  content: \"\\f16ff\";\n}\n\n.mdi-movie-open-edit-outline::before {\n  content: \"\\f1700\";\n}\n\n.mdi-movie-open-minus::before {\n  content: \"\\f1701\";\n}\n\n.mdi-movie-open-minus-outline::before {\n  content: \"\\f1702\";\n}\n\n.mdi-movie-open-off::before {\n  content: \"\\f1703\";\n}\n\n.mdi-movie-open-off-outline::before {\n  content: \"\\f1704\";\n}\n\n.mdi-movie-open-outline::before {\n  content: \"\\f0fcf\";\n}\n\n.mdi-movie-open-play::before {\n  content: \"\\f1705\";\n}\n\n.mdi-movie-open-play-outline::before {\n  content: \"\\f1706\";\n}\n\n.mdi-movie-open-plus::before {\n  content: \"\\f1707\";\n}\n\n.mdi-movie-open-plus-outline::before {\n  content: \"\\f1708\";\n}\n\n.mdi-movie-open-remove::before {\n  content: \"\\f1709\";\n}\n\n.mdi-movie-open-remove-outline::before {\n  content: \"\\f170a\";\n}\n\n.mdi-movie-open-settings::before {\n  content: \"\\f170b\";\n}\n\n.mdi-movie-open-settings-outline::before {\n  content: \"\\f170c\";\n}\n\n.mdi-movie-open-star::before {\n  content: \"\\f170d\";\n}\n\n.mdi-movie-open-star-outline::before {\n  content: \"\\f170e\";\n}\n\n.mdi-movie-outline::before {\n  content: \"\\f0ddd\";\n}\n\n.mdi-movie-play::before {\n  content: \"\\f170f\";\n}\n\n.mdi-movie-play-outline::before {\n  content: \"\\f1710\";\n}\n\n.mdi-movie-plus::before {\n  content: \"\\f1711\";\n}\n\n.mdi-movie-plus-outline::before {\n  content: \"\\f1712\";\n}\n\n.mdi-movie-remove::before {\n  content: \"\\f1713\";\n}\n\n.mdi-movie-remove-outline::before {\n  content: \"\\f1714\";\n}\n\n.mdi-movie-roll::before {\n  content: \"\\f07de\";\n}\n\n.mdi-movie-search::before {\n  content: \"\\f11d2\";\n}\n\n.mdi-movie-search-outline::before {\n  content: \"\\f11d3\";\n}\n\n.mdi-movie-settings::before {\n  content: \"\\f1715\";\n}\n\n.mdi-movie-settings-outline::before {\n  content: \"\\f1716\";\n}\n\n.mdi-movie-star::before {\n  content: \"\\f1717\";\n}\n\n.mdi-movie-star-outline::before {\n  content: \"\\f1718\";\n}\n\n.mdi-mower::before {\n  content: \"\\f166f\";\n}\n\n.mdi-mower-bag::before {\n  content: \"\\f1670\";\n}\n\n.mdi-muffin::before {\n  content: \"\\f098c\";\n}\n\n.mdi-multicast::before {\n  content: \"\\f1893\";\n}\n\n.mdi-multiplication::before {\n  content: \"\\f0382\";\n}\n\n.mdi-multiplication-box::before {\n  content: \"\\f0383\";\n}\n\n.mdi-mushroom::before {\n  content: \"\\f07df\";\n}\n\n.mdi-mushroom-off::before {\n  content: \"\\f13fa\";\n}\n\n.mdi-mushroom-off-outline::before {\n  content: \"\\f13fb\";\n}\n\n.mdi-mushroom-outline::before {\n  content: \"\\f07e0\";\n}\n\n.mdi-music::before {\n  content: \"\\f075a\";\n}\n\n.mdi-music-accidental-double-flat::before {\n  content: \"\\f0f69\";\n}\n\n.mdi-music-accidental-double-sharp::before {\n  content: \"\\f0f6a\";\n}\n\n.mdi-music-accidental-flat::before {\n  content: \"\\f0f6b\";\n}\n\n.mdi-music-accidental-natural::before {\n  content: \"\\f0f6c\";\n}\n\n.mdi-music-accidental-sharp::before {\n  content: \"\\f0f6d\";\n}\n\n.mdi-music-box::before {\n  content: \"\\f0384\";\n}\n\n.mdi-music-box-multiple::before {\n  content: \"\\f0333\";\n}\n\n.mdi-music-box-multiple-outline::before {\n  content: \"\\f0f04\";\n}\n\n.mdi-music-box-outline::before {\n  content: \"\\f0385\";\n}\n\n.mdi-music-circle::before {\n  content: \"\\f0386\";\n}\n\n.mdi-music-circle-outline::before {\n  content: \"\\f0ad4\";\n}\n\n.mdi-music-clef-alto::before {\n  content: \"\\f0f6e\";\n}\n\n.mdi-music-clef-bass::before {\n  content: \"\\f0f6f\";\n}\n\n.mdi-music-clef-treble::before {\n  content: \"\\f0f70\";\n}\n\n.mdi-music-note::before {\n  content: \"\\f0387\";\n}\n\n.mdi-music-note-bluetooth::before {\n  content: \"\\f05fe\";\n}\n\n.mdi-music-note-bluetooth-off::before {\n  content: \"\\f05ff\";\n}\n\n.mdi-music-note-eighth::before {\n  content: \"\\f0388\";\n}\n\n.mdi-music-note-eighth-dotted::before {\n  content: \"\\f0f71\";\n}\n\n.mdi-music-note-half::before {\n  content: \"\\f0389\";\n}\n\n.mdi-music-note-half-dotted::before {\n  content: \"\\f0f72\";\n}\n\n.mdi-music-note-off::before {\n  content: \"\\f038a\";\n}\n\n.mdi-music-note-off-outline::before {\n  content: \"\\f0f73\";\n}\n\n.mdi-music-note-outline::before {\n  content: \"\\f0f74\";\n}\n\n.mdi-music-note-plus::before {\n  content: \"\\f0dde\";\n}\n\n.mdi-music-note-quarter::before {\n  content: \"\\f038b\";\n}\n\n.mdi-music-note-quarter-dotted::before {\n  content: \"\\f0f75\";\n}\n\n.mdi-music-note-sixteenth::before {\n  content: \"\\f038c\";\n}\n\n.mdi-music-note-sixteenth-dotted::before {\n  content: \"\\f0f76\";\n}\n\n.mdi-music-note-whole::before {\n  content: \"\\f038d\";\n}\n\n.mdi-music-note-whole-dotted::before {\n  content: \"\\f0f77\";\n}\n\n.mdi-music-off::before {\n  content: \"\\f075b\";\n}\n\n.mdi-music-rest-eighth::before {\n  content: \"\\f0f78\";\n}\n\n.mdi-music-rest-half::before {\n  content: \"\\f0f79\";\n}\n\n.mdi-music-rest-quarter::before {\n  content: \"\\f0f7a\";\n}\n\n.mdi-music-rest-sixteenth::before {\n  content: \"\\f0f7b\";\n}\n\n.mdi-music-rest-whole::before {\n  content: \"\\f0f7c\";\n}\n\n.mdi-mustache::before {\n  content: \"\\f15de\";\n}\n\n.mdi-nail::before {\n  content: \"\\f0ddf\";\n}\n\n.mdi-nas::before {\n  content: \"\\f08f3\";\n}\n\n.mdi-nativescript::before {\n  content: \"\\f0880\";\n}\n\n.mdi-nature::before {\n  content: \"\\f038e\";\n}\n\n.mdi-nature-people::before {\n  content: \"\\f038f\";\n}\n\n.mdi-navigation::before {\n  content: \"\\f0390\";\n}\n\n.mdi-navigation-outline::before {\n  content: \"\\f1607\";\n}\n\n.mdi-navigation-variant::before {\n  content: \"\\f18f0\";\n}\n\n.mdi-navigation-variant-outline::before {\n  content: \"\\f18f1\";\n}\n\n.mdi-near-me::before {\n  content: \"\\f05cd\";\n}\n\n.mdi-necklace::before {\n  content: \"\\f0f0b\";\n}\n\n.mdi-needle::before {\n  content: \"\\f0391\";\n}\n\n.mdi-netflix::before {\n  content: \"\\f0746\";\n}\n\n.mdi-network::before {\n  content: \"\\f06f3\";\n}\n\n.mdi-network-off::before {\n  content: \"\\f0c9b\";\n}\n\n.mdi-network-off-outline::before {\n  content: \"\\f0c9c\";\n}\n\n.mdi-network-outline::before {\n  content: \"\\f0c9d\";\n}\n\n.mdi-network-strength-1::before {\n  content: \"\\f08f4\";\n}\n\n.mdi-network-strength-1-alert::before {\n  content: \"\\f08f5\";\n}\n\n.mdi-network-strength-2::before {\n  content: \"\\f08f6\";\n}\n\n.mdi-network-strength-2-alert::before {\n  content: \"\\f08f7\";\n}\n\n.mdi-network-strength-3::before {\n  content: \"\\f08f8\";\n}\n\n.mdi-network-strength-3-alert::before {\n  content: \"\\f08f9\";\n}\n\n.mdi-network-strength-4::before {\n  content: \"\\f08fa\";\n}\n\n.mdi-network-strength-4-alert::before {\n  content: \"\\f08fb\";\n}\n\n.mdi-network-strength-4-cog::before {\n  content: \"\\f191a\";\n}\n\n.mdi-network-strength-off::before {\n  content: \"\\f08fc\";\n}\n\n.mdi-network-strength-off-outline::before {\n  content: \"\\f08fd\";\n}\n\n.mdi-network-strength-outline::before {\n  content: \"\\f08fe\";\n}\n\n.mdi-new-box::before {\n  content: \"\\f0394\";\n}\n\n.mdi-newspaper::before {\n  content: \"\\f0395\";\n}\n\n.mdi-newspaper-check::before {\n  content: \"\\f1943\";\n}\n\n.mdi-newspaper-minus::before {\n  content: \"\\f0f0c\";\n}\n\n.mdi-newspaper-plus::before {\n  content: \"\\f0f0d\";\n}\n\n.mdi-newspaper-remove::before {\n  content: \"\\f1944\";\n}\n\n.mdi-newspaper-variant::before {\n  content: \"\\f1001\";\n}\n\n.mdi-newspaper-variant-multiple::before {\n  content: \"\\f1002\";\n}\n\n.mdi-newspaper-variant-multiple-outline::before {\n  content: \"\\f1003\";\n}\n\n.mdi-newspaper-variant-outline::before {\n  content: \"\\f1004\";\n}\n\n.mdi-nfc::before {\n  content: \"\\f0396\";\n}\n\n.mdi-nfc-search-variant::before {\n  content: \"\\f0e53\";\n}\n\n.mdi-nfc-tap::before {\n  content: \"\\f0397\";\n}\n\n.mdi-nfc-variant::before {\n  content: \"\\f0398\";\n}\n\n.mdi-nfc-variant-off::before {\n  content: \"\\f0e54\";\n}\n\n.mdi-ninja::before {\n  content: \"\\f0774\";\n}\n\n.mdi-nintendo-game-boy::before {\n  content: \"\\f1393\";\n}\n\n.mdi-nintendo-switch::before {\n  content: \"\\f07e1\";\n}\n\n.mdi-nintendo-wii::before {\n  content: \"\\f05ab\";\n}\n\n.mdi-nintendo-wiiu::before {\n  content: \"\\f072d\";\n}\n\n.mdi-nix::before {\n  content: \"\\f1105\";\n}\n\n.mdi-nodejs::before {\n  content: \"\\f0399\";\n}\n\n.mdi-noodles::before {\n  content: \"\\f117e\";\n}\n\n.mdi-not-equal::before {\n  content: \"\\f098d\";\n}\n\n.mdi-not-equal-variant::before {\n  content: \"\\f098e\";\n}\n\n.mdi-note::before {\n  content: \"\\f039a\";\n}\n\n.mdi-note-alert::before {\n  content: \"\\f177d\";\n}\n\n.mdi-note-alert-outline::before {\n  content: \"\\f177e\";\n}\n\n.mdi-note-check::before {\n  content: \"\\f177f\";\n}\n\n.mdi-note-check-outline::before {\n  content: \"\\f1780\";\n}\n\n.mdi-note-edit::before {\n  content: \"\\f1781\";\n}\n\n.mdi-note-edit-outline::before {\n  content: \"\\f1782\";\n}\n\n.mdi-note-minus::before {\n  content: \"\\f164f\";\n}\n\n.mdi-note-minus-outline::before {\n  content: \"\\f1650\";\n}\n\n.mdi-note-multiple::before {\n  content: \"\\f06b8\";\n}\n\n.mdi-note-multiple-outline::before {\n  content: \"\\f06b9\";\n}\n\n.mdi-note-off::before {\n  content: \"\\f1783\";\n}\n\n.mdi-note-off-outline::before {\n  content: \"\\f1784\";\n}\n\n.mdi-note-outline::before {\n  content: \"\\f039b\";\n}\n\n.mdi-note-plus::before {\n  content: \"\\f039c\";\n}\n\n.mdi-note-plus-outline::before {\n  content: \"\\f039d\";\n}\n\n.mdi-note-remove::before {\n  content: \"\\f1651\";\n}\n\n.mdi-note-remove-outline::before {\n  content: \"\\f1652\";\n}\n\n.mdi-note-search::before {\n  content: \"\\f1653\";\n}\n\n.mdi-note-search-outline::before {\n  content: \"\\f1654\";\n}\n\n.mdi-note-text::before {\n  content: \"\\f039e\";\n}\n\n.mdi-note-text-outline::before {\n  content: \"\\f11d7\";\n}\n\n.mdi-notebook::before {\n  content: \"\\f082e\";\n}\n\n.mdi-notebook-check::before {\n  content: \"\\f14f5\";\n}\n\n.mdi-notebook-check-outline::before {\n  content: \"\\f14f6\";\n}\n\n.mdi-notebook-edit::before {\n  content: \"\\f14e7\";\n}\n\n.mdi-notebook-edit-outline::before {\n  content: \"\\f14e9\";\n}\n\n.mdi-notebook-minus::before {\n  content: \"\\f1610\";\n}\n\n.mdi-notebook-minus-outline::before {\n  content: \"\\f1611\";\n}\n\n.mdi-notebook-multiple::before {\n  content: \"\\f0e55\";\n}\n\n.mdi-notebook-outline::before {\n  content: \"\\f0ebf\";\n}\n\n.mdi-notebook-plus::before {\n  content: \"\\f1612\";\n}\n\n.mdi-notebook-plus-outline::before {\n  content: \"\\f1613\";\n}\n\n.mdi-notebook-remove::before {\n  content: \"\\f1614\";\n}\n\n.mdi-notebook-remove-outline::before {\n  content: \"\\f1615\";\n}\n\n.mdi-notification-clear-all::before {\n  content: \"\\f039f\";\n}\n\n.mdi-npm::before {\n  content: \"\\f06f7\";\n}\n\n.mdi-nuke::before {\n  content: \"\\f06a4\";\n}\n\n.mdi-null::before {\n  content: \"\\f07e2\";\n}\n\n.mdi-numeric::before {\n  content: \"\\f03a0\";\n}\n\n.mdi-numeric-0::before {\n  content: \"\\f0b39\";\n}\n\n.mdi-numeric-0-box::before {\n  content: \"\\f03a1\";\n}\n\n.mdi-numeric-0-box-multiple::before {\n  content: \"\\f0f0e\";\n}\n\n.mdi-numeric-0-box-multiple-outline::before {\n  content: \"\\f03a2\";\n}\n\n.mdi-numeric-0-box-outline::before {\n  content: \"\\f03a3\";\n}\n\n.mdi-numeric-0-circle::before {\n  content: \"\\f0c9e\";\n}\n\n.mdi-numeric-0-circle-outline::before {\n  content: \"\\f0c9f\";\n}\n\n.mdi-numeric-1::before {\n  content: \"\\f0b3a\";\n}\n\n.mdi-numeric-1-box::before {\n  content: \"\\f03a4\";\n}\n\n.mdi-numeric-1-box-multiple::before {\n  content: \"\\f0f0f\";\n}\n\n.mdi-numeric-1-box-multiple-outline::before {\n  content: \"\\f03a5\";\n}\n\n.mdi-numeric-1-box-outline::before {\n  content: \"\\f03a6\";\n}\n\n.mdi-numeric-1-circle::before {\n  content: \"\\f0ca0\";\n}\n\n.mdi-numeric-1-circle-outline::before {\n  content: \"\\f0ca1\";\n}\n\n.mdi-numeric-10::before {\n  content: \"\\f0fe9\";\n}\n\n.mdi-numeric-10-box::before {\n  content: \"\\f0f7d\";\n}\n\n.mdi-numeric-10-box-multiple::before {\n  content: \"\\f0fea\";\n}\n\n.mdi-numeric-10-box-multiple-outline::before {\n  content: \"\\f0feb\";\n}\n\n.mdi-numeric-10-box-outline::before {\n  content: \"\\f0f7e\";\n}\n\n.mdi-numeric-10-circle::before {\n  content: \"\\f0fec\";\n}\n\n.mdi-numeric-10-circle-outline::before {\n  content: \"\\f0fed\";\n}\n\n.mdi-numeric-2::before {\n  content: \"\\f0b3b\";\n}\n\n.mdi-numeric-2-box::before {\n  content: \"\\f03a7\";\n}\n\n.mdi-numeric-2-box-multiple::before {\n  content: \"\\f0f10\";\n}\n\n.mdi-numeric-2-box-multiple-outline::before {\n  content: \"\\f03a8\";\n}\n\n.mdi-numeric-2-box-outline::before {\n  content: \"\\f03a9\";\n}\n\n.mdi-numeric-2-circle::before {\n  content: \"\\f0ca2\";\n}\n\n.mdi-numeric-2-circle-outline::before {\n  content: \"\\f0ca3\";\n}\n\n.mdi-numeric-3::before {\n  content: \"\\f0b3c\";\n}\n\n.mdi-numeric-3-box::before {\n  content: \"\\f03aa\";\n}\n\n.mdi-numeric-3-box-multiple::before {\n  content: \"\\f0f11\";\n}\n\n.mdi-numeric-3-box-multiple-outline::before {\n  content: \"\\f03ab\";\n}\n\n.mdi-numeric-3-box-outline::before {\n  content: \"\\f03ac\";\n}\n\n.mdi-numeric-3-circle::before {\n  content: \"\\f0ca4\";\n}\n\n.mdi-numeric-3-circle-outline::before {\n  content: \"\\f0ca5\";\n}\n\n.mdi-numeric-4::before {\n  content: \"\\f0b3d\";\n}\n\n.mdi-numeric-4-box::before {\n  content: \"\\f03ad\";\n}\n\n.mdi-numeric-4-box-multiple::before {\n  content: \"\\f0f12\";\n}\n\n.mdi-numeric-4-box-multiple-outline::before {\n  content: \"\\f03b2\";\n}\n\n.mdi-numeric-4-box-outline::before {\n  content: \"\\f03ae\";\n}\n\n.mdi-numeric-4-circle::before {\n  content: \"\\f0ca6\";\n}\n\n.mdi-numeric-4-circle-outline::before {\n  content: \"\\f0ca7\";\n}\n\n.mdi-numeric-5::before {\n  content: \"\\f0b3e\";\n}\n\n.mdi-numeric-5-box::before {\n  content: \"\\f03b1\";\n}\n\n.mdi-numeric-5-box-multiple::before {\n  content: \"\\f0f13\";\n}\n\n.mdi-numeric-5-box-multiple-outline::before {\n  content: \"\\f03af\";\n}\n\n.mdi-numeric-5-box-outline::before {\n  content: \"\\f03b0\";\n}\n\n.mdi-numeric-5-circle::before {\n  content: \"\\f0ca8\";\n}\n\n.mdi-numeric-5-circle-outline::before {\n  content: \"\\f0ca9\";\n}\n\n.mdi-numeric-6::before {\n  content: \"\\f0b3f\";\n}\n\n.mdi-numeric-6-box::before {\n  content: \"\\f03b3\";\n}\n\n.mdi-numeric-6-box-multiple::before {\n  content: \"\\f0f14\";\n}\n\n.mdi-numeric-6-box-multiple-outline::before {\n  content: \"\\f03b4\";\n}\n\n.mdi-numeric-6-box-outline::before {\n  content: \"\\f03b5\";\n}\n\n.mdi-numeric-6-circle::before {\n  content: \"\\f0caa\";\n}\n\n.mdi-numeric-6-circle-outline::before {\n  content: \"\\f0cab\";\n}\n\n.mdi-numeric-7::before {\n  content: \"\\f0b40\";\n}\n\n.mdi-numeric-7-box::before {\n  content: \"\\f03b6\";\n}\n\n.mdi-numeric-7-box-multiple::before {\n  content: \"\\f0f15\";\n}\n\n.mdi-numeric-7-box-multiple-outline::before {\n  content: \"\\f03b7\";\n}\n\n.mdi-numeric-7-box-outline::before {\n  content: \"\\f03b8\";\n}\n\n.mdi-numeric-7-circle::before {\n  content: \"\\f0cac\";\n}\n\n.mdi-numeric-7-circle-outline::before {\n  content: \"\\f0cad\";\n}\n\n.mdi-numeric-8::before {\n  content: \"\\f0b41\";\n}\n\n.mdi-numeric-8-box::before {\n  content: \"\\f03b9\";\n}\n\n.mdi-numeric-8-box-multiple::before {\n  content: \"\\f0f16\";\n}\n\n.mdi-numeric-8-box-multiple-outline::before {\n  content: \"\\f03ba\";\n}\n\n.mdi-numeric-8-box-outline::before {\n  content: \"\\f03bb\";\n}\n\n.mdi-numeric-8-circle::before {\n  content: \"\\f0cae\";\n}\n\n.mdi-numeric-8-circle-outline::before {\n  content: \"\\f0caf\";\n}\n\n.mdi-numeric-9::before {\n  content: \"\\f0b42\";\n}\n\n.mdi-numeric-9-box::before {\n  content: \"\\f03bc\";\n}\n\n.mdi-numeric-9-box-multiple::before {\n  content: \"\\f0f17\";\n}\n\n.mdi-numeric-9-box-multiple-outline::before {\n  content: \"\\f03bd\";\n}\n\n.mdi-numeric-9-box-outline::before {\n  content: \"\\f03be\";\n}\n\n.mdi-numeric-9-circle::before {\n  content: \"\\f0cb0\";\n}\n\n.mdi-numeric-9-circle-outline::before {\n  content: \"\\f0cb1\";\n}\n\n.mdi-numeric-9-plus::before {\n  content: \"\\f0fee\";\n}\n\n.mdi-numeric-9-plus-box::before {\n  content: \"\\f03bf\";\n}\n\n.mdi-numeric-9-plus-box-multiple::before {\n  content: \"\\f0f18\";\n}\n\n.mdi-numeric-9-plus-box-multiple-outline::before {\n  content: \"\\f03c0\";\n}\n\n.mdi-numeric-9-plus-box-outline::before {\n  content: \"\\f03c1\";\n}\n\n.mdi-numeric-9-plus-circle::before {\n  content: \"\\f0cb2\";\n}\n\n.mdi-numeric-9-plus-circle-outline::before {\n  content: \"\\f0cb3\";\n}\n\n.mdi-numeric-negative-1::before {\n  content: \"\\f1052\";\n}\n\n.mdi-numeric-positive-1::before {\n  content: \"\\f15cb\";\n}\n\n.mdi-nut::before {\n  content: \"\\f06f8\";\n}\n\n.mdi-nutrition::before {\n  content: \"\\f03c2\";\n}\n\n.mdi-nuxt::before {\n  content: \"\\f1106\";\n}\n\n.mdi-oar::before {\n  content: \"\\f067c\";\n}\n\n.mdi-ocarina::before {\n  content: \"\\f0de0\";\n}\n\n.mdi-oci::before {\n  content: \"\\f12e9\";\n}\n\n.mdi-ocr::before {\n  content: \"\\f113a\";\n}\n\n.mdi-octagon::before {\n  content: \"\\f03c3\";\n}\n\n.mdi-octagon-outline::before {\n  content: \"\\f03c4\";\n}\n\n.mdi-octagram::before {\n  content: \"\\f06f9\";\n}\n\n.mdi-octagram-outline::before {\n  content: \"\\f0775\";\n}\n\n.mdi-octahedron::before {\n  content: \"\\f1950\";\n}\n\n.mdi-octahedron-off::before {\n  content: \"\\f1951\";\n}\n\n.mdi-odnoklassniki::before {\n  content: \"\\f03c5\";\n}\n\n.mdi-offer::before {\n  content: \"\\f121b\";\n}\n\n.mdi-office-building::before {\n  content: \"\\f0991\";\n}\n\n.mdi-office-building-cog::before {\n  content: \"\\f1949\";\n}\n\n.mdi-office-building-cog-outline::before {\n  content: \"\\f194a\";\n}\n\n.mdi-office-building-marker::before {\n  content: \"\\f1520\";\n}\n\n.mdi-office-building-marker-outline::before {\n  content: \"\\f1521\";\n}\n\n.mdi-office-building-outline::before {\n  content: \"\\f151f\";\n}\n\n.mdi-oil::before {\n  content: \"\\f03c7\";\n}\n\n.mdi-oil-lamp::before {\n  content: \"\\f0f19\";\n}\n\n.mdi-oil-level::before {\n  content: \"\\f1053\";\n}\n\n.mdi-oil-temperature::before {\n  content: \"\\f0ff8\";\n}\n\n.mdi-om::before {\n  content: \"\\f0973\";\n}\n\n.mdi-omega::before {\n  content: \"\\f03c9\";\n}\n\n.mdi-one-up::before {\n  content: \"\\f0bad\";\n}\n\n.mdi-onepassword::before {\n  content: \"\\f0881\";\n}\n\n.mdi-opacity::before {\n  content: \"\\f05cc\";\n}\n\n.mdi-open-in-app::before {\n  content: \"\\f03cb\";\n}\n\n.mdi-open-in-new::before {\n  content: \"\\f03cc\";\n}\n\n.mdi-open-source-initiative::before {\n  content: \"\\f0bae\";\n}\n\n.mdi-openid::before {\n  content: \"\\f03cd\";\n}\n\n.mdi-opera::before {\n  content: \"\\f03ce\";\n}\n\n.mdi-orbit::before {\n  content: \"\\f0018\";\n}\n\n.mdi-orbit-variant::before {\n  content: \"\\f15db\";\n}\n\n.mdi-order-alphabetical-ascending::before {\n  content: \"\\f020d\";\n}\n\n.mdi-order-alphabetical-descending::before {\n  content: \"\\f0d07\";\n}\n\n.mdi-order-bool-ascending::before {\n  content: \"\\f02be\";\n}\n\n.mdi-order-bool-ascending-variant::before {\n  content: \"\\f098f\";\n}\n\n.mdi-order-bool-descending::before {\n  content: \"\\f1384\";\n}\n\n.mdi-order-bool-descending-variant::before {\n  content: \"\\f0990\";\n}\n\n.mdi-order-numeric-ascending::before {\n  content: \"\\f0545\";\n}\n\n.mdi-order-numeric-descending::before {\n  content: \"\\f0546\";\n}\n\n.mdi-origin::before {\n  content: \"\\f0b43\";\n}\n\n.mdi-ornament::before {\n  content: \"\\f03cf\";\n}\n\n.mdi-ornament-variant::before {\n  content: \"\\f03d0\";\n}\n\n.mdi-outdoor-lamp::before {\n  content: \"\\f1054\";\n}\n\n.mdi-overscan::before {\n  content: \"\\f1005\";\n}\n\n.mdi-owl::before {\n  content: \"\\f03d2\";\n}\n\n.mdi-pac-man::before {\n  content: \"\\f0baf\";\n}\n\n.mdi-package::before {\n  content: \"\\f03d3\";\n}\n\n.mdi-package-down::before {\n  content: \"\\f03d4\";\n}\n\n.mdi-package-up::before {\n  content: \"\\f03d5\";\n}\n\n.mdi-package-variant::before {\n  content: \"\\f03d6\";\n}\n\n.mdi-package-variant-closed::before {\n  content: \"\\f03d7\";\n}\n\n.mdi-page-first::before {\n  content: \"\\f0600\";\n}\n\n.mdi-page-last::before {\n  content: \"\\f0601\";\n}\n\n.mdi-page-layout-body::before {\n  content: \"\\f06fa\";\n}\n\n.mdi-page-layout-footer::before {\n  content: \"\\f06fb\";\n}\n\n.mdi-page-layout-header::before {\n  content: \"\\f06fc\";\n}\n\n.mdi-page-layout-header-footer::before {\n  content: \"\\f0f7f\";\n}\n\n.mdi-page-layout-sidebar-left::before {\n  content: \"\\f06fd\";\n}\n\n.mdi-page-layout-sidebar-right::before {\n  content: \"\\f06fe\";\n}\n\n.mdi-page-next::before {\n  content: \"\\f0bb0\";\n}\n\n.mdi-page-next-outline::before {\n  content: \"\\f0bb1\";\n}\n\n.mdi-page-previous::before {\n  content: \"\\f0bb2\";\n}\n\n.mdi-page-previous-outline::before {\n  content: \"\\f0bb3\";\n}\n\n.mdi-pail::before {\n  content: \"\\f1417\";\n}\n\n.mdi-pail-minus::before {\n  content: \"\\f1437\";\n}\n\n.mdi-pail-minus-outline::before {\n  content: \"\\f143c\";\n}\n\n.mdi-pail-off::before {\n  content: \"\\f1439\";\n}\n\n.mdi-pail-off-outline::before {\n  content: \"\\f143e\";\n}\n\n.mdi-pail-outline::before {\n  content: \"\\f143a\";\n}\n\n.mdi-pail-plus::before {\n  content: \"\\f1436\";\n}\n\n.mdi-pail-plus-outline::before {\n  content: \"\\f143b\";\n}\n\n.mdi-pail-remove::before {\n  content: \"\\f1438\";\n}\n\n.mdi-pail-remove-outline::before {\n  content: \"\\f143d\";\n}\n\n.mdi-palette::before {\n  content: \"\\f03d8\";\n}\n\n.mdi-palette-advanced::before {\n  content: \"\\f03d9\";\n}\n\n.mdi-palette-outline::before {\n  content: \"\\f0e0c\";\n}\n\n.mdi-palette-swatch::before {\n  content: \"\\f08b5\";\n}\n\n.mdi-palette-swatch-outline::before {\n  content: \"\\f135c\";\n}\n\n.mdi-palette-swatch-variant::before {\n  content: \"\\f195a\";\n}\n\n.mdi-palm-tree::before {\n  content: \"\\f1055\";\n}\n\n.mdi-pan::before {\n  content: \"\\f0bb4\";\n}\n\n.mdi-pan-bottom-left::before {\n  content: \"\\f0bb5\";\n}\n\n.mdi-pan-bottom-right::before {\n  content: \"\\f0bb6\";\n}\n\n.mdi-pan-down::before {\n  content: \"\\f0bb7\";\n}\n\n.mdi-pan-horizontal::before {\n  content: \"\\f0bb8\";\n}\n\n.mdi-pan-left::before {\n  content: \"\\f0bb9\";\n}\n\n.mdi-pan-right::before {\n  content: \"\\f0bba\";\n}\n\n.mdi-pan-top-left::before {\n  content: \"\\f0bbb\";\n}\n\n.mdi-pan-top-right::before {\n  content: \"\\f0bbc\";\n}\n\n.mdi-pan-up::before {\n  content: \"\\f0bbd\";\n}\n\n.mdi-pan-vertical::before {\n  content: \"\\f0bbe\";\n}\n\n.mdi-panda::before {\n  content: \"\\f03da\";\n}\n\n.mdi-pandora::before {\n  content: \"\\f03db\";\n}\n\n.mdi-panorama::before {\n  content: \"\\f03dc\";\n}\n\n.mdi-panorama-fisheye::before {\n  content: \"\\f03dd\";\n}\n\n.mdi-panorama-horizontal::before {\n  content: \"\\f1928\";\n}\n\n.mdi-panorama-horizontal-outline::before {\n  content: \"\\f03de\";\n}\n\n.mdi-panorama-outline::before {\n  content: \"\\f198c\";\n}\n\n.mdi-panorama-sphere::before {\n  content: \"\\f198d\";\n}\n\n.mdi-panorama-sphere-outline::before {\n  content: \"\\f198e\";\n}\n\n.mdi-panorama-variant::before {\n  content: \"\\f198f\";\n}\n\n.mdi-panorama-variant-outline::before {\n  content: \"\\f1990\";\n}\n\n.mdi-panorama-vertical::before {\n  content: \"\\f1929\";\n}\n\n.mdi-panorama-vertical-outline::before {\n  content: \"\\f03df\";\n}\n\n.mdi-panorama-wide-angle::before {\n  content: \"\\f195f\";\n}\n\n.mdi-panorama-wide-angle-outline::before {\n  content: \"\\f03e0\";\n}\n\n.mdi-paper-cut-vertical::before {\n  content: \"\\f03e1\";\n}\n\n.mdi-paper-roll::before {\n  content: \"\\f1157\";\n}\n\n.mdi-paper-roll-outline::before {\n  content: \"\\f1158\";\n}\n\n.mdi-paperclip::before {\n  content: \"\\f03e2\";\n}\n\n.mdi-parachute::before {\n  content: \"\\f0cb4\";\n}\n\n.mdi-parachute-outline::before {\n  content: \"\\f0cb5\";\n}\n\n.mdi-paragliding::before {\n  content: \"\\f1745\";\n}\n\n.mdi-parking::before {\n  content: \"\\f03e3\";\n}\n\n.mdi-party-popper::before {\n  content: \"\\f1056\";\n}\n\n.mdi-passport::before {\n  content: \"\\f07e3\";\n}\n\n.mdi-passport-biometric::before {\n  content: \"\\f0de1\";\n}\n\n.mdi-pasta::before {\n  content: \"\\f1160\";\n}\n\n.mdi-patio-heater::before {\n  content: \"\\f0f80\";\n}\n\n.mdi-patreon::before {\n  content: \"\\f0882\";\n}\n\n.mdi-pause::before {\n  content: \"\\f03e4\";\n}\n\n.mdi-pause-circle::before {\n  content: \"\\f03e5\";\n}\n\n.mdi-pause-circle-outline::before {\n  content: \"\\f03e6\";\n}\n\n.mdi-pause-octagon::before {\n  content: \"\\f03e7\";\n}\n\n.mdi-pause-octagon-outline::before {\n  content: \"\\f03e8\";\n}\n\n.mdi-paw::before {\n  content: \"\\f03e9\";\n}\n\n.mdi-paw-off::before {\n  content: \"\\f0657\";\n}\n\n.mdi-paw-off-outline::before {\n  content: \"\\f1676\";\n}\n\n.mdi-paw-outline::before {\n  content: \"\\f1675\";\n}\n\n.mdi-peace::before {\n  content: \"\\f0884\";\n}\n\n.mdi-peanut::before {\n  content: \"\\f0ffc\";\n}\n\n.mdi-peanut-off::before {\n  content: \"\\f0ffd\";\n}\n\n.mdi-peanut-off-outline::before {\n  content: \"\\f0fff\";\n}\n\n.mdi-peanut-outline::before {\n  content: \"\\f0ffe\";\n}\n\n.mdi-pen::before {\n  content: \"\\f03ea\";\n}\n\n.mdi-pen-lock::before {\n  content: \"\\f0de2\";\n}\n\n.mdi-pen-minus::before {\n  content: \"\\f0de3\";\n}\n\n.mdi-pen-off::before {\n  content: \"\\f0de4\";\n}\n\n.mdi-pen-plus::before {\n  content: \"\\f0de5\";\n}\n\n.mdi-pen-remove::before {\n  content: \"\\f0de6\";\n}\n\n.mdi-pencil::before {\n  content: \"\\f03eb\";\n}\n\n.mdi-pencil-box::before {\n  content: \"\\f03ec\";\n}\n\n.mdi-pencil-box-multiple::before {\n  content: \"\\f1144\";\n}\n\n.mdi-pencil-box-multiple-outline::before {\n  content: \"\\f1145\";\n}\n\n.mdi-pencil-box-outline::before {\n  content: \"\\f03ed\";\n}\n\n.mdi-pencil-circle::before {\n  content: \"\\f06ff\";\n}\n\n.mdi-pencil-circle-outline::before {\n  content: \"\\f0776\";\n}\n\n.mdi-pencil-lock::before {\n  content: \"\\f03ee\";\n}\n\n.mdi-pencil-lock-outline::before {\n  content: \"\\f0de7\";\n}\n\n.mdi-pencil-minus::before {\n  content: \"\\f0de8\";\n}\n\n.mdi-pencil-minus-outline::before {\n  content: \"\\f0de9\";\n}\n\n.mdi-pencil-off::before {\n  content: \"\\f03ef\";\n}\n\n.mdi-pencil-off-outline::before {\n  content: \"\\f0dea\";\n}\n\n.mdi-pencil-outline::before {\n  content: \"\\f0cb6\";\n}\n\n.mdi-pencil-plus::before {\n  content: \"\\f0deb\";\n}\n\n.mdi-pencil-plus-outline::before {\n  content: \"\\f0dec\";\n}\n\n.mdi-pencil-remove::before {\n  content: \"\\f0ded\";\n}\n\n.mdi-pencil-remove-outline::before {\n  content: \"\\f0dee\";\n}\n\n.mdi-pencil-ruler::before {\n  content: \"\\f1353\";\n}\n\n.mdi-penguin::before {\n  content: \"\\f0ec0\";\n}\n\n.mdi-pentagon::before {\n  content: \"\\f0701\";\n}\n\n.mdi-pentagon-outline::before {\n  content: \"\\f0700\";\n}\n\n.mdi-pentagram::before {\n  content: \"\\f1667\";\n}\n\n.mdi-percent::before {\n  content: \"\\f03f0\";\n}\n\n.mdi-percent-outline::before {\n  content: \"\\f1278\";\n}\n\n.mdi-periodic-table::before {\n  content: \"\\f08b6\";\n}\n\n.mdi-perspective-less::before {\n  content: \"\\f0d23\";\n}\n\n.mdi-perspective-more::before {\n  content: \"\\f0d24\";\n}\n\n.mdi-ph::before {\n  content: \"\\f17c5\";\n}\n\n.mdi-phone::before {\n  content: \"\\f03f2\";\n}\n\n.mdi-phone-alert::before {\n  content: \"\\f0f1a\";\n}\n\n.mdi-phone-alert-outline::before {\n  content: \"\\f118e\";\n}\n\n.mdi-phone-bluetooth::before {\n  content: \"\\f03f3\";\n}\n\n.mdi-phone-bluetooth-outline::before {\n  content: \"\\f118f\";\n}\n\n.mdi-phone-cancel::before {\n  content: \"\\f10bc\";\n}\n\n.mdi-phone-cancel-outline::before {\n  content: \"\\f1190\";\n}\n\n.mdi-phone-check::before {\n  content: \"\\f11a9\";\n}\n\n.mdi-phone-check-outline::before {\n  content: \"\\f11aa\";\n}\n\n.mdi-phone-classic::before {\n  content: \"\\f0602\";\n}\n\n.mdi-phone-classic-off::before {\n  content: \"\\f1279\";\n}\n\n.mdi-phone-dial::before {\n  content: \"\\f1559\";\n}\n\n.mdi-phone-dial-outline::before {\n  content: \"\\f155a\";\n}\n\n.mdi-phone-forward::before {\n  content: \"\\f03f4\";\n}\n\n.mdi-phone-forward-outline::before {\n  content: \"\\f1191\";\n}\n\n.mdi-phone-hangup::before {\n  content: \"\\f03f5\";\n}\n\n.mdi-phone-hangup-outline::before {\n  content: \"\\f1192\";\n}\n\n.mdi-phone-in-talk::before {\n  content: \"\\f03f6\";\n}\n\n.mdi-phone-in-talk-outline::before {\n  content: \"\\f1182\";\n}\n\n.mdi-phone-incoming::before {\n  content: \"\\f03f7\";\n}\n\n.mdi-phone-incoming-outline::before {\n  content: \"\\f1193\";\n}\n\n.mdi-phone-lock::before {\n  content: \"\\f03f8\";\n}\n\n.mdi-phone-lock-outline::before {\n  content: \"\\f1194\";\n}\n\n.mdi-phone-log::before {\n  content: \"\\f03f9\";\n}\n\n.mdi-phone-log-outline::before {\n  content: \"\\f1195\";\n}\n\n.mdi-phone-message::before {\n  content: \"\\f1196\";\n}\n\n.mdi-phone-message-outline::before {\n  content: \"\\f1197\";\n}\n\n.mdi-phone-minus::before {\n  content: \"\\f0658\";\n}\n\n.mdi-phone-minus-outline::before {\n  content: \"\\f1198\";\n}\n\n.mdi-phone-missed::before {\n  content: \"\\f03fa\";\n}\n\n.mdi-phone-missed-outline::before {\n  content: \"\\f11a5\";\n}\n\n.mdi-phone-off::before {\n  content: \"\\f0def\";\n}\n\n.mdi-phone-off-outline::before {\n  content: \"\\f11a6\";\n}\n\n.mdi-phone-outgoing::before {\n  content: \"\\f03fb\";\n}\n\n.mdi-phone-outgoing-outline::before {\n  content: \"\\f1199\";\n}\n\n.mdi-phone-outline::before {\n  content: \"\\f0df0\";\n}\n\n.mdi-phone-paused::before {\n  content: \"\\f03fc\";\n}\n\n.mdi-phone-paused-outline::before {\n  content: \"\\f119a\";\n}\n\n.mdi-phone-plus::before {\n  content: \"\\f0659\";\n}\n\n.mdi-phone-plus-outline::before {\n  content: \"\\f119b\";\n}\n\n.mdi-phone-refresh::before {\n  content: \"\\f1993\";\n}\n\n.mdi-phone-refresh-outline::before {\n  content: \"\\f1994\";\n}\n\n.mdi-phone-remove::before {\n  content: \"\\f152f\";\n}\n\n.mdi-phone-remove-outline::before {\n  content: \"\\f1530\";\n}\n\n.mdi-phone-return::before {\n  content: \"\\f082f\";\n}\n\n.mdi-phone-return-outline::before {\n  content: \"\\f119c\";\n}\n\n.mdi-phone-ring::before {\n  content: \"\\f11ab\";\n}\n\n.mdi-phone-ring-outline::before {\n  content: \"\\f11ac\";\n}\n\n.mdi-phone-rotate-landscape::before {\n  content: \"\\f0885\";\n}\n\n.mdi-phone-rotate-portrait::before {\n  content: \"\\f0886\";\n}\n\n.mdi-phone-settings::before {\n  content: \"\\f03fd\";\n}\n\n.mdi-phone-settings-outline::before {\n  content: \"\\f119d\";\n}\n\n.mdi-phone-sync::before {\n  content: \"\\f1995\";\n}\n\n.mdi-phone-sync-outline::before {\n  content: \"\\f1996\";\n}\n\n.mdi-phone-voip::before {\n  content: \"\\f03fe\";\n}\n\n.mdi-pi::before {\n  content: \"\\f03ff\";\n}\n\n.mdi-pi-box::before {\n  content: \"\\f0400\";\n}\n\n.mdi-pi-hole::before {\n  content: \"\\f0df1\";\n}\n\n.mdi-piano::before {\n  content: \"\\f067d\";\n}\n\n.mdi-piano-off::before {\n  content: \"\\f0698\";\n}\n\n.mdi-pickaxe::before {\n  content: \"\\f08b7\";\n}\n\n.mdi-picture-in-picture-bottom-right::before {\n  content: \"\\f0e57\";\n}\n\n.mdi-picture-in-picture-bottom-right-outline::before {\n  content: \"\\f0e58\";\n}\n\n.mdi-picture-in-picture-top-right::before {\n  content: \"\\f0e59\";\n}\n\n.mdi-picture-in-picture-top-right-outline::before {\n  content: \"\\f0e5a\";\n}\n\n.mdi-pier::before {\n  content: \"\\f0887\";\n}\n\n.mdi-pier-crane::before {\n  content: \"\\f0888\";\n}\n\n.mdi-pig::before {\n  content: \"\\f0401\";\n}\n\n.mdi-pig-variant::before {\n  content: \"\\f1006\";\n}\n\n.mdi-pig-variant-outline::before {\n  content: \"\\f1678\";\n}\n\n.mdi-piggy-bank::before {\n  content: \"\\f1007\";\n}\n\n.mdi-piggy-bank-outline::before {\n  content: \"\\f1679\";\n}\n\n.mdi-pill::before {\n  content: \"\\f0402\";\n}\n\n.mdi-pillar::before {\n  content: \"\\f0702\";\n}\n\n.mdi-pin::before {\n  content: \"\\f0403\";\n}\n\n.mdi-pin-off::before {\n  content: \"\\f0404\";\n}\n\n.mdi-pin-off-outline::before {\n  content: \"\\f0930\";\n}\n\n.mdi-pin-outline::before {\n  content: \"\\f0931\";\n}\n\n.mdi-pine-tree::before {\n  content: \"\\f0405\";\n}\n\n.mdi-pine-tree-box::before {\n  content: \"\\f0406\";\n}\n\n.mdi-pine-tree-fire::before {\n  content: \"\\f141a\";\n}\n\n.mdi-pinterest::before {\n  content: \"\\f0407\";\n}\n\n.mdi-pinwheel::before {\n  content: \"\\f0ad5\";\n}\n\n.mdi-pinwheel-outline::before {\n  content: \"\\f0ad6\";\n}\n\n.mdi-pipe::before {\n  content: \"\\f07e5\";\n}\n\n.mdi-pipe-disconnected::before {\n  content: \"\\f07e6\";\n}\n\n.mdi-pipe-leak::before {\n  content: \"\\f0889\";\n}\n\n.mdi-pipe-valve::before {\n  content: \"\\f184d\";\n}\n\n.mdi-pipe-wrench::before {\n  content: \"\\f1354\";\n}\n\n.mdi-pirate::before {\n  content: \"\\f0a08\";\n}\n\n.mdi-pistol::before {\n  content: \"\\f0703\";\n}\n\n.mdi-piston::before {\n  content: \"\\f088a\";\n}\n\n.mdi-pitchfork::before {\n  content: \"\\f1553\";\n}\n\n.mdi-pizza::before {\n  content: \"\\f0409\";\n}\n\n.mdi-play::before {\n  content: \"\\f040a\";\n}\n\n.mdi-play-box::before {\n  content: \"\\f127a\";\n}\n\n.mdi-play-box-multiple::before {\n  content: \"\\f0d19\";\n}\n\n.mdi-play-box-multiple-outline::before {\n  content: \"\\f13e6\";\n}\n\n.mdi-play-box-outline::before {\n  content: \"\\f040b\";\n}\n\n.mdi-play-circle::before {\n  content: \"\\f040c\";\n}\n\n.mdi-play-circle-outline::before {\n  content: \"\\f040d\";\n}\n\n.mdi-play-network::before {\n  content: \"\\f088b\";\n}\n\n.mdi-play-network-outline::before {\n  content: \"\\f0cb7\";\n}\n\n.mdi-play-outline::before {\n  content: \"\\f0f1b\";\n}\n\n.mdi-play-pause::before {\n  content: \"\\f040e\";\n}\n\n.mdi-play-protected-content::before {\n  content: \"\\f040f\";\n}\n\n.mdi-play-speed::before {\n  content: \"\\f08ff\";\n}\n\n.mdi-playlist-check::before {\n  content: \"\\f05c7\";\n}\n\n.mdi-playlist-edit::before {\n  content: \"\\f0900\";\n}\n\n.mdi-playlist-minus::before {\n  content: \"\\f0410\";\n}\n\n.mdi-playlist-music::before {\n  content: \"\\f0cb8\";\n}\n\n.mdi-playlist-music-outline::before {\n  content: \"\\f0cb9\";\n}\n\n.mdi-playlist-play::before {\n  content: \"\\f0411\";\n}\n\n.mdi-playlist-plus::before {\n  content: \"\\f0412\";\n}\n\n.mdi-playlist-remove::before {\n  content: \"\\f0413\";\n}\n\n.mdi-playlist-star::before {\n  content: \"\\f0df2\";\n}\n\n.mdi-plex::before {\n  content: \"\\f06ba\";\n}\n\n.mdi-pliers::before {\n  content: \"\\f19a4\";\n}\n\n.mdi-plus::before {\n  content: \"\\f0415\";\n}\n\n.mdi-plus-box::before {\n  content: \"\\f0416\";\n}\n\n.mdi-plus-box-multiple::before {\n  content: \"\\f0334\";\n}\n\n.mdi-plus-box-multiple-outline::before {\n  content: \"\\f1143\";\n}\n\n.mdi-plus-box-outline::before {\n  content: \"\\f0704\";\n}\n\n.mdi-plus-circle::before {\n  content: \"\\f0417\";\n}\n\n.mdi-plus-circle-multiple::before {\n  content: \"\\f034c\";\n}\n\n.mdi-plus-circle-multiple-outline::before {\n  content: \"\\f0418\";\n}\n\n.mdi-plus-circle-outline::before {\n  content: \"\\f0419\";\n}\n\n.mdi-plus-minus::before {\n  content: \"\\f0992\";\n}\n\n.mdi-plus-minus-box::before {\n  content: \"\\f0993\";\n}\n\n.mdi-plus-minus-variant::before {\n  content: \"\\f14c9\";\n}\n\n.mdi-plus-network::before {\n  content: \"\\f041a\";\n}\n\n.mdi-plus-network-outline::before {\n  content: \"\\f0cba\";\n}\n\n.mdi-plus-outline::before {\n  content: \"\\f0705\";\n}\n\n.mdi-plus-thick::before {\n  content: \"\\f11ec\";\n}\n\n.mdi-podcast::before {\n  content: \"\\f0994\";\n}\n\n.mdi-podium::before {\n  content: \"\\f0d25\";\n}\n\n.mdi-podium-bronze::before {\n  content: \"\\f0d26\";\n}\n\n.mdi-podium-gold::before {\n  content: \"\\f0d27\";\n}\n\n.mdi-podium-silver::before {\n  content: \"\\f0d28\";\n}\n\n.mdi-point-of-sale::before {\n  content: \"\\f0d92\";\n}\n\n.mdi-pokeball::before {\n  content: \"\\f041d\";\n}\n\n.mdi-pokemon-go::before {\n  content: \"\\f0a09\";\n}\n\n.mdi-poker-chip::before {\n  content: \"\\f0830\";\n}\n\n.mdi-polaroid::before {\n  content: \"\\f041e\";\n}\n\n.mdi-police-badge::before {\n  content: \"\\f1167\";\n}\n\n.mdi-police-badge-outline::before {\n  content: \"\\f1168\";\n}\n\n.mdi-police-station::before {\n  content: \"\\f1839\";\n}\n\n.mdi-poll::before {\n  content: \"\\f041f\";\n}\n\n.mdi-polo::before {\n  content: \"\\f14c3\";\n}\n\n.mdi-polymer::before {\n  content: \"\\f0421\";\n}\n\n.mdi-pool::before {\n  content: \"\\f0606\";\n}\n\n.mdi-popcorn::before {\n  content: \"\\f0422\";\n}\n\n.mdi-post::before {\n  content: \"\\f1008\";\n}\n\n.mdi-post-outline::before {\n  content: \"\\f1009\";\n}\n\n.mdi-postage-stamp::before {\n  content: \"\\f0cbb\";\n}\n\n.mdi-pot::before {\n  content: \"\\f02e5\";\n}\n\n.mdi-pot-mix::before {\n  content: \"\\f065b\";\n}\n\n.mdi-pot-mix-outline::before {\n  content: \"\\f0677\";\n}\n\n.mdi-pot-outline::before {\n  content: \"\\f02ff\";\n}\n\n.mdi-pot-steam::before {\n  content: \"\\f065a\";\n}\n\n.mdi-pot-steam-outline::before {\n  content: \"\\f0326\";\n}\n\n.mdi-pound::before {\n  content: \"\\f0423\";\n}\n\n.mdi-pound-box::before {\n  content: \"\\f0424\";\n}\n\n.mdi-pound-box-outline::before {\n  content: \"\\f117f\";\n}\n\n.mdi-power::before {\n  content: \"\\f0425\";\n}\n\n.mdi-power-cycle::before {\n  content: \"\\f0901\";\n}\n\n.mdi-power-off::before {\n  content: \"\\f0902\";\n}\n\n.mdi-power-on::before {\n  content: \"\\f0903\";\n}\n\n.mdi-power-plug::before {\n  content: \"\\f06a5\";\n}\n\n.mdi-power-plug-off::before {\n  content: \"\\f06a6\";\n}\n\n.mdi-power-plug-off-outline::before {\n  content: \"\\f1424\";\n}\n\n.mdi-power-plug-outline::before {\n  content: \"\\f1425\";\n}\n\n.mdi-power-settings::before {\n  content: \"\\f0426\";\n}\n\n.mdi-power-sleep::before {\n  content: \"\\f0904\";\n}\n\n.mdi-power-socket::before {\n  content: \"\\f0427\";\n}\n\n.mdi-power-socket-au::before {\n  content: \"\\f0905\";\n}\n\n.mdi-power-socket-ch::before {\n  content: \"\\f0fb3\";\n}\n\n.mdi-power-socket-de::before {\n  content: \"\\f1107\";\n}\n\n.mdi-power-socket-eu::before {\n  content: \"\\f07e7\";\n}\n\n.mdi-power-socket-fr::before {\n  content: \"\\f1108\";\n}\n\n.mdi-power-socket-it::before {\n  content: \"\\f14ff\";\n}\n\n.mdi-power-socket-jp::before {\n  content: \"\\f1109\";\n}\n\n.mdi-power-socket-uk::before {\n  content: \"\\f07e8\";\n}\n\n.mdi-power-socket-us::before {\n  content: \"\\f07e9\";\n}\n\n.mdi-power-standby::before {\n  content: \"\\f0906\";\n}\n\n.mdi-powershell::before {\n  content: \"\\f0a0a\";\n}\n\n.mdi-prescription::before {\n  content: \"\\f0706\";\n}\n\n.mdi-presentation::before {\n  content: \"\\f0428\";\n}\n\n.mdi-presentation-play::before {\n  content: \"\\f0429\";\n}\n\n.mdi-pretzel::before {\n  content: \"\\f1562\";\n}\n\n.mdi-printer::before {\n  content: \"\\f042a\";\n}\n\n.mdi-printer-3d::before {\n  content: \"\\f042b\";\n}\n\n.mdi-printer-3d-nozzle::before {\n  content: \"\\f0e5b\";\n}\n\n.mdi-printer-3d-nozzle-alert::before {\n  content: \"\\f11c0\";\n}\n\n.mdi-printer-3d-nozzle-alert-outline::before {\n  content: \"\\f11c1\";\n}\n\n.mdi-printer-3d-nozzle-heat::before {\n  content: \"\\f18b8\";\n}\n\n.mdi-printer-3d-nozzle-heat-outline::before {\n  content: \"\\f18b9\";\n}\n\n.mdi-printer-3d-nozzle-outline::before {\n  content: \"\\f0e5c\";\n}\n\n.mdi-printer-alert::before {\n  content: \"\\f042c\";\n}\n\n.mdi-printer-check::before {\n  content: \"\\f1146\";\n}\n\n.mdi-printer-eye::before {\n  content: \"\\f1458\";\n}\n\n.mdi-printer-off::before {\n  content: \"\\f0e5d\";\n}\n\n.mdi-printer-off-outline::before {\n  content: \"\\f1785\";\n}\n\n.mdi-printer-outline::before {\n  content: \"\\f1786\";\n}\n\n.mdi-printer-pos::before {\n  content: \"\\f1057\";\n}\n\n.mdi-printer-search::before {\n  content: \"\\f1457\";\n}\n\n.mdi-printer-settings::before {\n  content: \"\\f0707\";\n}\n\n.mdi-printer-wireless::before {\n  content: \"\\f0a0b\";\n}\n\n.mdi-priority-high::before {\n  content: \"\\f0603\";\n}\n\n.mdi-priority-low::before {\n  content: \"\\f0604\";\n}\n\n.mdi-professional-hexagon::before {\n  content: \"\\f042d\";\n}\n\n.mdi-progress-alert::before {\n  content: \"\\f0cbc\";\n}\n\n.mdi-progress-check::before {\n  content: \"\\f0995\";\n}\n\n.mdi-progress-clock::before {\n  content: \"\\f0996\";\n}\n\n.mdi-progress-close::before {\n  content: \"\\f110a\";\n}\n\n.mdi-progress-download::before {\n  content: \"\\f0997\";\n}\n\n.mdi-progress-pencil::before {\n  content: \"\\f1787\";\n}\n\n.mdi-progress-question::before {\n  content: \"\\f1522\";\n}\n\n.mdi-progress-star::before {\n  content: \"\\f1788\";\n}\n\n.mdi-progress-upload::before {\n  content: \"\\f0998\";\n}\n\n.mdi-progress-wrench::before {\n  content: \"\\f0cbd\";\n}\n\n.mdi-projector::before {\n  content: \"\\f042e\";\n}\n\n.mdi-projector-screen::before {\n  content: \"\\f042f\";\n}\n\n.mdi-projector-screen-off::before {\n  content: \"\\f180d\";\n}\n\n.mdi-projector-screen-off-outline::before {\n  content: \"\\f180e\";\n}\n\n.mdi-projector-screen-outline::before {\n  content: \"\\f1724\";\n}\n\n.mdi-projector-screen-variant::before {\n  content: \"\\f180f\";\n}\n\n.mdi-projector-screen-variant-off::before {\n  content: \"\\f1810\";\n}\n\n.mdi-projector-screen-variant-off-outline::before {\n  content: \"\\f1811\";\n}\n\n.mdi-projector-screen-variant-outline::before {\n  content: \"\\f1812\";\n}\n\n.mdi-propane-tank::before {\n  content: \"\\f1357\";\n}\n\n.mdi-propane-tank-outline::before {\n  content: \"\\f1358\";\n}\n\n.mdi-protocol::before {\n  content: \"\\f0fd8\";\n}\n\n.mdi-publish::before {\n  content: \"\\f06a7\";\n}\n\n.mdi-publish-off::before {\n  content: \"\\f1945\";\n}\n\n.mdi-pulse::before {\n  content: \"\\f0430\";\n}\n\n.mdi-pump::before {\n  content: \"\\f1402\";\n}\n\n.mdi-pumpkin::before {\n  content: \"\\f0bbf\";\n}\n\n.mdi-purse::before {\n  content: \"\\f0f1c\";\n}\n\n.mdi-purse-outline::before {\n  content: \"\\f0f1d\";\n}\n\n.mdi-puzzle::before {\n  content: \"\\f0431\";\n}\n\n.mdi-puzzle-check::before {\n  content: \"\\f1426\";\n}\n\n.mdi-puzzle-check-outline::before {\n  content: \"\\f1427\";\n}\n\n.mdi-puzzle-edit::before {\n  content: \"\\f14d3\";\n}\n\n.mdi-puzzle-edit-outline::before {\n  content: \"\\f14d9\";\n}\n\n.mdi-puzzle-heart::before {\n  content: \"\\f14d4\";\n}\n\n.mdi-puzzle-heart-outline::before {\n  content: \"\\f14da\";\n}\n\n.mdi-puzzle-minus::before {\n  content: \"\\f14d1\";\n}\n\n.mdi-puzzle-minus-outline::before {\n  content: \"\\f14d7\";\n}\n\n.mdi-puzzle-outline::before {\n  content: \"\\f0a66\";\n}\n\n.mdi-puzzle-plus::before {\n  content: \"\\f14d0\";\n}\n\n.mdi-puzzle-plus-outline::before {\n  content: \"\\f14d6\";\n}\n\n.mdi-puzzle-remove::before {\n  content: \"\\f14d2\";\n}\n\n.mdi-puzzle-remove-outline::before {\n  content: \"\\f14d8\";\n}\n\n.mdi-puzzle-star::before {\n  content: \"\\f14d5\";\n}\n\n.mdi-puzzle-star-outline::before {\n  content: \"\\f14db\";\n}\n\n.mdi-pyramid::before {\n  content: \"\\f1952\";\n}\n\n.mdi-pyramid-off::before {\n  content: \"\\f1953\";\n}\n\n.mdi-qi::before {\n  content: \"\\f0999\";\n}\n\n.mdi-qqchat::before {\n  content: \"\\f0605\";\n}\n\n.mdi-qrcode::before {\n  content: \"\\f0432\";\n}\n\n.mdi-qrcode-edit::before {\n  content: \"\\f08b8\";\n}\n\n.mdi-qrcode-minus::before {\n  content: \"\\f118c\";\n}\n\n.mdi-qrcode-plus::before {\n  content: \"\\f118b\";\n}\n\n.mdi-qrcode-remove::before {\n  content: \"\\f118d\";\n}\n\n.mdi-qrcode-scan::before {\n  content: \"\\f0433\";\n}\n\n.mdi-quadcopter::before {\n  content: \"\\f0434\";\n}\n\n.mdi-quality-high::before {\n  content: \"\\f0435\";\n}\n\n.mdi-quality-low::before {\n  content: \"\\f0a0c\";\n}\n\n.mdi-quality-medium::before {\n  content: \"\\f0a0d\";\n}\n\n.mdi-quora::before {\n  content: \"\\f0d29\";\n}\n\n.mdi-rabbit::before {\n  content: \"\\f0907\";\n}\n\n.mdi-racing-helmet::before {\n  content: \"\\f0d93\";\n}\n\n.mdi-racquetball::before {\n  content: \"\\f0d94\";\n}\n\n.mdi-radar::before {\n  content: \"\\f0437\";\n}\n\n.mdi-radiator::before {\n  content: \"\\f0438\";\n}\n\n.mdi-radiator-disabled::before {\n  content: \"\\f0ad7\";\n}\n\n.mdi-radiator-off::before {\n  content: \"\\f0ad8\";\n}\n\n.mdi-radio::before {\n  content: \"\\f0439\";\n}\n\n.mdi-radio-am::before {\n  content: \"\\f0cbe\";\n}\n\n.mdi-radio-fm::before {\n  content: \"\\f0cbf\";\n}\n\n.mdi-radio-handheld::before {\n  content: \"\\f043a\";\n}\n\n.mdi-radio-off::before {\n  content: \"\\f121c\";\n}\n\n.mdi-radio-tower::before {\n  content: \"\\f043b\";\n}\n\n.mdi-radioactive::before {\n  content: \"\\f043c\";\n}\n\n.mdi-radioactive-circle::before {\n  content: \"\\f185d\";\n}\n\n.mdi-radioactive-circle-outline::before {\n  content: \"\\f185e\";\n}\n\n.mdi-radioactive-off::before {\n  content: \"\\f0ec1\";\n}\n\n.mdi-radiobox-blank::before {\n  content: \"\\f043d\";\n}\n\n.mdi-radiobox-marked::before {\n  content: \"\\f043e\";\n}\n\n.mdi-radiology-box::before {\n  content: \"\\f14c5\";\n}\n\n.mdi-radiology-box-outline::before {\n  content: \"\\f14c6\";\n}\n\n.mdi-radius::before {\n  content: \"\\f0cc0\";\n}\n\n.mdi-radius-outline::before {\n  content: \"\\f0cc1\";\n}\n\n.mdi-railroad-light::before {\n  content: \"\\f0f1e\";\n}\n\n.mdi-rake::before {\n  content: \"\\f1544\";\n}\n\n.mdi-raspberry-pi::before {\n  content: \"\\f043f\";\n}\n\n.mdi-ray-end::before {\n  content: \"\\f0440\";\n}\n\n.mdi-ray-end-arrow::before {\n  content: \"\\f0441\";\n}\n\n.mdi-ray-start::before {\n  content: \"\\f0442\";\n}\n\n.mdi-ray-start-arrow::before {\n  content: \"\\f0443\";\n}\n\n.mdi-ray-start-end::before {\n  content: \"\\f0444\";\n}\n\n.mdi-ray-start-vertex-end::before {\n  content: \"\\f15d8\";\n}\n\n.mdi-ray-vertex::before {\n  content: \"\\f0445\";\n}\n\n.mdi-razor-double-edge::before {\n  content: \"\\f1997\";\n}\n\n.mdi-razor-single-edge::before {\n  content: \"\\f1998\";\n}\n\n.mdi-react::before {\n  content: \"\\f0708\";\n}\n\n.mdi-read::before {\n  content: \"\\f0447\";\n}\n\n.mdi-receipt::before {\n  content: \"\\f0449\";\n}\n\n.mdi-record::before {\n  content: \"\\f044a\";\n}\n\n.mdi-record-circle::before {\n  content: \"\\f0ec2\";\n}\n\n.mdi-record-circle-outline::before {\n  content: \"\\f0ec3\";\n}\n\n.mdi-record-player::before {\n  content: \"\\f099a\";\n}\n\n.mdi-record-rec::before {\n  content: \"\\f044b\";\n}\n\n.mdi-rectangle::before {\n  content: \"\\f0e5e\";\n}\n\n.mdi-rectangle-outline::before {\n  content: \"\\f0e5f\";\n}\n\n.mdi-recycle::before {\n  content: \"\\f044c\";\n}\n\n.mdi-recycle-variant::before {\n  content: \"\\f139d\";\n}\n\n.mdi-reddit::before {\n  content: \"\\f044d\";\n}\n\n.mdi-redhat::before {\n  content: \"\\f111b\";\n}\n\n.mdi-redo::before {\n  content: \"\\f044e\";\n}\n\n.mdi-redo-variant::before {\n  content: \"\\f044f\";\n}\n\n.mdi-reflect-horizontal::before {\n  content: \"\\f0a0e\";\n}\n\n.mdi-reflect-vertical::before {\n  content: \"\\f0a0f\";\n}\n\n.mdi-refresh::before {\n  content: \"\\f0450\";\n}\n\n.mdi-refresh-auto::before {\n  content: \"\\f18f2\";\n}\n\n.mdi-refresh-circle::before {\n  content: \"\\f1377\";\n}\n\n.mdi-regex::before {\n  content: \"\\f0451\";\n}\n\n.mdi-registered-trademark::before {\n  content: \"\\f0a67\";\n}\n\n.mdi-reiterate::before {\n  content: \"\\f1588\";\n}\n\n.mdi-relation-many-to-many::before {\n  content: \"\\f1496\";\n}\n\n.mdi-relation-many-to-one::before {\n  content: \"\\f1497\";\n}\n\n.mdi-relation-many-to-one-or-many::before {\n  content: \"\\f1498\";\n}\n\n.mdi-relation-many-to-only-one::before {\n  content: \"\\f1499\";\n}\n\n.mdi-relation-many-to-zero-or-many::before {\n  content: \"\\f149a\";\n}\n\n.mdi-relation-many-to-zero-or-one::before {\n  content: \"\\f149b\";\n}\n\n.mdi-relation-one-or-many-to-many::before {\n  content: \"\\f149c\";\n}\n\n.mdi-relation-one-or-many-to-one::before {\n  content: \"\\f149d\";\n}\n\n.mdi-relation-one-or-many-to-one-or-many::before {\n  content: \"\\f149e\";\n}\n\n.mdi-relation-one-or-many-to-only-one::before {\n  content: \"\\f149f\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-many::before {\n  content: \"\\f14a0\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-one::before {\n  content: \"\\f14a1\";\n}\n\n.mdi-relation-one-to-many::before {\n  content: \"\\f14a2\";\n}\n\n.mdi-relation-one-to-one::before {\n  content: \"\\f14a3\";\n}\n\n.mdi-relation-one-to-one-or-many::before {\n  content: \"\\f14a4\";\n}\n\n.mdi-relation-one-to-only-one::before {\n  content: \"\\f14a5\";\n}\n\n.mdi-relation-one-to-zero-or-many::before {\n  content: \"\\f14a6\";\n}\n\n.mdi-relation-one-to-zero-or-one::before {\n  content: \"\\f14a7\";\n}\n\n.mdi-relation-only-one-to-many::before {\n  content: \"\\f14a8\";\n}\n\n.mdi-relation-only-one-to-one::before {\n  content: \"\\f14a9\";\n}\n\n.mdi-relation-only-one-to-one-or-many::before {\n  content: \"\\f14aa\";\n}\n\n.mdi-relation-only-one-to-only-one::before {\n  content: \"\\f14ab\";\n}\n\n.mdi-relation-only-one-to-zero-or-many::before {\n  content: \"\\f14ac\";\n}\n\n.mdi-relation-only-one-to-zero-or-one::before {\n  content: \"\\f14ad\";\n}\n\n.mdi-relation-zero-or-many-to-many::before {\n  content: \"\\f14ae\";\n}\n\n.mdi-relation-zero-or-many-to-one::before {\n  content: \"\\f14af\";\n}\n\n.mdi-relation-zero-or-many-to-one-or-many::before {\n  content: \"\\f14b0\";\n}\n\n.mdi-relation-zero-or-many-to-only-one::before {\n  content: \"\\f14b1\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-many::before {\n  content: \"\\f14b2\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-one::before {\n  content: \"\\f14b3\";\n}\n\n.mdi-relation-zero-or-one-to-many::before {\n  content: \"\\f14b4\";\n}\n\n.mdi-relation-zero-or-one-to-one::before {\n  content: \"\\f14b5\";\n}\n\n.mdi-relation-zero-or-one-to-one-or-many::before {\n  content: \"\\f14b6\";\n}\n\n.mdi-relation-zero-or-one-to-only-one::before {\n  content: \"\\f14b7\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-many::before {\n  content: \"\\f14b8\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-one::before {\n  content: \"\\f14b9\";\n}\n\n.mdi-relative-scale::before {\n  content: \"\\f0452\";\n}\n\n.mdi-reload::before {\n  content: \"\\f0453\";\n}\n\n.mdi-reload-alert::before {\n  content: \"\\f110b\";\n}\n\n.mdi-reminder::before {\n  content: \"\\f088c\";\n}\n\n.mdi-remote::before {\n  content: \"\\f0454\";\n}\n\n.mdi-remote-desktop::before {\n  content: \"\\f08b9\";\n}\n\n.mdi-remote-off::before {\n  content: \"\\f0ec4\";\n}\n\n.mdi-remote-tv::before {\n  content: \"\\f0ec5\";\n}\n\n.mdi-remote-tv-off::before {\n  content: \"\\f0ec6\";\n}\n\n.mdi-rename-box::before {\n  content: \"\\f0455\";\n}\n\n.mdi-reorder-horizontal::before {\n  content: \"\\f0688\";\n}\n\n.mdi-reorder-vertical::before {\n  content: \"\\f0689\";\n}\n\n.mdi-repeat::before {\n  content: \"\\f0456\";\n}\n\n.mdi-repeat-off::before {\n  content: \"\\f0457\";\n}\n\n.mdi-repeat-once::before {\n  content: \"\\f0458\";\n}\n\n.mdi-repeat-variant::before {\n  content: \"\\f0547\";\n}\n\n.mdi-replay::before {\n  content: \"\\f0459\";\n}\n\n.mdi-reply::before {\n  content: \"\\f045a\";\n}\n\n.mdi-reply-all::before {\n  content: \"\\f045b\";\n}\n\n.mdi-reply-all-outline::before {\n  content: \"\\f0f1f\";\n}\n\n.mdi-reply-circle::before {\n  content: \"\\f11ae\";\n}\n\n.mdi-reply-outline::before {\n  content: \"\\f0f20\";\n}\n\n.mdi-reproduction::before {\n  content: \"\\f045c\";\n}\n\n.mdi-resistor::before {\n  content: \"\\f0b44\";\n}\n\n.mdi-resistor-nodes::before {\n  content: \"\\f0b45\";\n}\n\n.mdi-resize::before {\n  content: \"\\f0a68\";\n}\n\n.mdi-resize-bottom-right::before {\n  content: \"\\f045d\";\n}\n\n.mdi-responsive::before {\n  content: \"\\f045e\";\n}\n\n.mdi-restart::before {\n  content: \"\\f0709\";\n}\n\n.mdi-restart-alert::before {\n  content: \"\\f110c\";\n}\n\n.mdi-restart-off::before {\n  content: \"\\f0d95\";\n}\n\n.mdi-restore::before {\n  content: \"\\f099b\";\n}\n\n.mdi-restore-alert::before {\n  content: \"\\f110d\";\n}\n\n.mdi-rewind::before {\n  content: \"\\f045f\";\n}\n\n.mdi-rewind-10::before {\n  content: \"\\f0d2a\";\n}\n\n.mdi-rewind-15::before {\n  content: \"\\f1946\";\n}\n\n.mdi-rewind-30::before {\n  content: \"\\f0d96\";\n}\n\n.mdi-rewind-5::before {\n  content: \"\\f11f9\";\n}\n\n.mdi-rewind-60::before {\n  content: \"\\f160c\";\n}\n\n.mdi-rewind-outline::before {\n  content: \"\\f070a\";\n}\n\n.mdi-rhombus::before {\n  content: \"\\f070b\";\n}\n\n.mdi-rhombus-medium::before {\n  content: \"\\f0a10\";\n}\n\n.mdi-rhombus-medium-outline::before {\n  content: \"\\f14dc\";\n}\n\n.mdi-rhombus-outline::before {\n  content: \"\\f070c\";\n}\n\n.mdi-rhombus-split::before {\n  content: \"\\f0a11\";\n}\n\n.mdi-rhombus-split-outline::before {\n  content: \"\\f14dd\";\n}\n\n.mdi-ribbon::before {\n  content: \"\\f0460\";\n}\n\n.mdi-rice::before {\n  content: \"\\f07ea\";\n}\n\n.mdi-rickshaw::before {\n  content: \"\\f15bb\";\n}\n\n.mdi-rickshaw-electric::before {\n  content: \"\\f15bc\";\n}\n\n.mdi-ring::before {\n  content: \"\\f07eb\";\n}\n\n.mdi-rivet::before {\n  content: \"\\f0e60\";\n}\n\n.mdi-road::before {\n  content: \"\\f0461\";\n}\n\n.mdi-road-variant::before {\n  content: \"\\f0462\";\n}\n\n.mdi-robber::before {\n  content: \"\\f1058\";\n}\n\n.mdi-robot::before {\n  content: \"\\f06a9\";\n}\n\n.mdi-robot-angry::before {\n  content: \"\\f169d\";\n}\n\n.mdi-robot-angry-outline::before {\n  content: \"\\f169e\";\n}\n\n.mdi-robot-confused::before {\n  content: \"\\f169f\";\n}\n\n.mdi-robot-confused-outline::before {\n  content: \"\\f16a0\";\n}\n\n.mdi-robot-dead::before {\n  content: \"\\f16a1\";\n}\n\n.mdi-robot-dead-outline::before {\n  content: \"\\f16a2\";\n}\n\n.mdi-robot-excited::before {\n  content: \"\\f16a3\";\n}\n\n.mdi-robot-excited-outline::before {\n  content: \"\\f16a4\";\n}\n\n.mdi-robot-happy::before {\n  content: \"\\f1719\";\n}\n\n.mdi-robot-happy-outline::before {\n  content: \"\\f171a\";\n}\n\n.mdi-robot-industrial::before {\n  content: \"\\f0b46\";\n}\n\n.mdi-robot-love::before {\n  content: \"\\f16a5\";\n}\n\n.mdi-robot-love-outline::before {\n  content: \"\\f16a6\";\n}\n\n.mdi-robot-mower::before {\n  content: \"\\f11f7\";\n}\n\n.mdi-robot-mower-outline::before {\n  content: \"\\f11f3\";\n}\n\n.mdi-robot-off::before {\n  content: \"\\f16a7\";\n}\n\n.mdi-robot-off-outline::before {\n  content: \"\\f167b\";\n}\n\n.mdi-robot-outline::before {\n  content: \"\\f167a\";\n}\n\n.mdi-robot-vacuum::before {\n  content: \"\\f070d\";\n}\n\n.mdi-robot-vacuum-variant::before {\n  content: \"\\f0908\";\n}\n\n.mdi-rocket::before {\n  content: \"\\f0463\";\n}\n\n.mdi-rocket-launch::before {\n  content: \"\\f14de\";\n}\n\n.mdi-rocket-launch-outline::before {\n  content: \"\\f14df\";\n}\n\n.mdi-rocket-outline::before {\n  content: \"\\f13af\";\n}\n\n.mdi-rodent::before {\n  content: \"\\f1327\";\n}\n\n.mdi-roller-skate::before {\n  content: \"\\f0d2b\";\n}\n\n.mdi-roller-skate-off::before {\n  content: \"\\f0145\";\n}\n\n.mdi-rollerblade::before {\n  content: \"\\f0d2c\";\n}\n\n.mdi-rollerblade-off::before {\n  content: \"\\f002e\";\n}\n\n.mdi-rollupjs::before {\n  content: \"\\f0bc0\";\n}\n\n.mdi-roman-numeral-1::before {\n  content: \"\\f1088\";\n}\n\n.mdi-roman-numeral-10::before {\n  content: \"\\f1091\";\n}\n\n.mdi-roman-numeral-2::before {\n  content: \"\\f1089\";\n}\n\n.mdi-roman-numeral-3::before {\n  content: \"\\f108a\";\n}\n\n.mdi-roman-numeral-4::before {\n  content: \"\\f108b\";\n}\n\n.mdi-roman-numeral-5::before {\n  content: \"\\f108c\";\n}\n\n.mdi-roman-numeral-6::before {\n  content: \"\\f108d\";\n}\n\n.mdi-roman-numeral-7::before {\n  content: \"\\f108e\";\n}\n\n.mdi-roman-numeral-8::before {\n  content: \"\\f108f\";\n}\n\n.mdi-roman-numeral-9::before {\n  content: \"\\f1090\";\n}\n\n.mdi-room-service::before {\n  content: \"\\f088d\";\n}\n\n.mdi-room-service-outline::before {\n  content: \"\\f0d97\";\n}\n\n.mdi-rotate-360::before {\n  content: \"\\f1999\";\n}\n\n.mdi-rotate-3d::before {\n  content: \"\\f0ec7\";\n}\n\n.mdi-rotate-3d-variant::before {\n  content: \"\\f0464\";\n}\n\n.mdi-rotate-left::before {\n  content: \"\\f0465\";\n}\n\n.mdi-rotate-left-variant::before {\n  content: \"\\f0466\";\n}\n\n.mdi-rotate-orbit::before {\n  content: \"\\f0d98\";\n}\n\n.mdi-rotate-right::before {\n  content: \"\\f0467\";\n}\n\n.mdi-rotate-right-variant::before {\n  content: \"\\f0468\";\n}\n\n.mdi-rounded-corner::before {\n  content: \"\\f0607\";\n}\n\n.mdi-router::before {\n  content: \"\\f11e2\";\n}\n\n.mdi-router-network::before {\n  content: \"\\f1087\";\n}\n\n.mdi-router-wireless::before {\n  content: \"\\f0469\";\n}\n\n.mdi-router-wireless-off::before {\n  content: \"\\f15a3\";\n}\n\n.mdi-router-wireless-settings::before {\n  content: \"\\f0a69\";\n}\n\n.mdi-routes::before {\n  content: \"\\f046a\";\n}\n\n.mdi-routes-clock::before {\n  content: \"\\f1059\";\n}\n\n.mdi-rowing::before {\n  content: \"\\f0608\";\n}\n\n.mdi-rss::before {\n  content: \"\\f046b\";\n}\n\n.mdi-rss-box::before {\n  content: \"\\f046c\";\n}\n\n.mdi-rss-off::before {\n  content: \"\\f0f21\";\n}\n\n.mdi-rug::before {\n  content: \"\\f1475\";\n}\n\n.mdi-rugby::before {\n  content: \"\\f0d99\";\n}\n\n.mdi-ruler::before {\n  content: \"\\f046d\";\n}\n\n.mdi-ruler-square::before {\n  content: \"\\f0cc2\";\n}\n\n.mdi-ruler-square-compass::before {\n  content: \"\\f0ebe\";\n}\n\n.mdi-run::before {\n  content: \"\\f070e\";\n}\n\n.mdi-run-fast::before {\n  content: \"\\f046e\";\n}\n\n.mdi-rv-truck::before {\n  content: \"\\f11d4\";\n}\n\n.mdi-sack::before {\n  content: \"\\f0d2e\";\n}\n\n.mdi-sack-percent::before {\n  content: \"\\f0d2f\";\n}\n\n.mdi-safe::before {\n  content: \"\\f0a6a\";\n}\n\n.mdi-safe-square::before {\n  content: \"\\f127c\";\n}\n\n.mdi-safe-square-outline::before {\n  content: \"\\f127d\";\n}\n\n.mdi-safety-goggles::before {\n  content: \"\\f0d30\";\n}\n\n.mdi-sail-boat::before {\n  content: \"\\f0ec8\";\n}\n\n.mdi-sale::before {\n  content: \"\\f046f\";\n}\n\n.mdi-salesforce::before {\n  content: \"\\f088e\";\n}\n\n.mdi-sass::before {\n  content: \"\\f07ec\";\n}\n\n.mdi-satellite::before {\n  content: \"\\f0470\";\n}\n\n.mdi-satellite-uplink::before {\n  content: \"\\f0909\";\n}\n\n.mdi-satellite-variant::before {\n  content: \"\\f0471\";\n}\n\n.mdi-sausage::before {\n  content: \"\\f08ba\";\n}\n\n.mdi-sausage-off::before {\n  content: \"\\f1789\";\n}\n\n.mdi-saw-blade::before {\n  content: \"\\f0e61\";\n}\n\n.mdi-sawtooth-wave::before {\n  content: \"\\f147a\";\n}\n\n.mdi-saxophone::before {\n  content: \"\\f0609\";\n}\n\n.mdi-scale::before {\n  content: \"\\f0472\";\n}\n\n.mdi-scale-balance::before {\n  content: \"\\f05d1\";\n}\n\n.mdi-scale-bathroom::before {\n  content: \"\\f0473\";\n}\n\n.mdi-scale-off::before {\n  content: \"\\f105a\";\n}\n\n.mdi-scale-unbalanced::before {\n  content: \"\\f19b8\";\n}\n\n.mdi-scan-helper::before {\n  content: \"\\f13d8\";\n}\n\n.mdi-scanner::before {\n  content: \"\\f06ab\";\n}\n\n.mdi-scanner-off::before {\n  content: \"\\f090a\";\n}\n\n.mdi-scatter-plot::before {\n  content: \"\\f0ec9\";\n}\n\n.mdi-scatter-plot-outline::before {\n  content: \"\\f0eca\";\n}\n\n.mdi-scent::before {\n  content: \"\\f1958\";\n}\n\n.mdi-scent-off::before {\n  content: \"\\f1959\";\n}\n\n.mdi-school::before {\n  content: \"\\f0474\";\n}\n\n.mdi-school-outline::before {\n  content: \"\\f1180\";\n}\n\n.mdi-scissors-cutting::before {\n  content: \"\\f0a6b\";\n}\n\n.mdi-scooter::before {\n  content: \"\\f15bd\";\n}\n\n.mdi-scooter-electric::before {\n  content: \"\\f15be\";\n}\n\n.mdi-scoreboard::before {\n  content: \"\\f127e\";\n}\n\n.mdi-scoreboard-outline::before {\n  content: \"\\f127f\";\n}\n\n.mdi-screen-rotation::before {\n  content: \"\\f0475\";\n}\n\n.mdi-screen-rotation-lock::before {\n  content: \"\\f0478\";\n}\n\n.mdi-screw-flat-top::before {\n  content: \"\\f0df3\";\n}\n\n.mdi-screw-lag::before {\n  content: \"\\f0df4\";\n}\n\n.mdi-screw-machine-flat-top::before {\n  content: \"\\f0df5\";\n}\n\n.mdi-screw-machine-round-top::before {\n  content: \"\\f0df6\";\n}\n\n.mdi-screw-round-top::before {\n  content: \"\\f0df7\";\n}\n\n.mdi-screwdriver::before {\n  content: \"\\f0476\";\n}\n\n.mdi-script::before {\n  content: \"\\f0bc1\";\n}\n\n.mdi-script-outline::before {\n  content: \"\\f0477\";\n}\n\n.mdi-script-text::before {\n  content: \"\\f0bc2\";\n}\n\n.mdi-script-text-key::before {\n  content: \"\\f1725\";\n}\n\n.mdi-script-text-key-outline::before {\n  content: \"\\f1726\";\n}\n\n.mdi-script-text-outline::before {\n  content: \"\\f0bc3\";\n}\n\n.mdi-script-text-play::before {\n  content: \"\\f1727\";\n}\n\n.mdi-script-text-play-outline::before {\n  content: \"\\f1728\";\n}\n\n.mdi-sd::before {\n  content: \"\\f0479\";\n}\n\n.mdi-seal::before {\n  content: \"\\f047a\";\n}\n\n.mdi-seal-variant::before {\n  content: \"\\f0fd9\";\n}\n\n.mdi-search-web::before {\n  content: \"\\f070f\";\n}\n\n.mdi-seat::before {\n  content: \"\\f0cc3\";\n}\n\n.mdi-seat-flat::before {\n  content: \"\\f047b\";\n}\n\n.mdi-seat-flat-angled::before {\n  content: \"\\f047c\";\n}\n\n.mdi-seat-individual-suite::before {\n  content: \"\\f047d\";\n}\n\n.mdi-seat-legroom-extra::before {\n  content: \"\\f047e\";\n}\n\n.mdi-seat-legroom-normal::before {\n  content: \"\\f047f\";\n}\n\n.mdi-seat-legroom-reduced::before {\n  content: \"\\f0480\";\n}\n\n.mdi-seat-outline::before {\n  content: \"\\f0cc4\";\n}\n\n.mdi-seat-passenger::before {\n  content: \"\\f1249\";\n}\n\n.mdi-seat-recline-extra::before {\n  content: \"\\f0481\";\n}\n\n.mdi-seat-recline-normal::before {\n  content: \"\\f0482\";\n}\n\n.mdi-seatbelt::before {\n  content: \"\\f0cc5\";\n}\n\n.mdi-security::before {\n  content: \"\\f0483\";\n}\n\n.mdi-security-network::before {\n  content: \"\\f0484\";\n}\n\n.mdi-seed::before {\n  content: \"\\f0e62\";\n}\n\n.mdi-seed-off::before {\n  content: \"\\f13fd\";\n}\n\n.mdi-seed-off-outline::before {\n  content: \"\\f13fe\";\n}\n\n.mdi-seed-outline::before {\n  content: \"\\f0e63\";\n}\n\n.mdi-seesaw::before {\n  content: \"\\f15a4\";\n}\n\n.mdi-segment::before {\n  content: \"\\f0ecb\";\n}\n\n.mdi-select::before {\n  content: \"\\f0485\";\n}\n\n.mdi-select-all::before {\n  content: \"\\f0486\";\n}\n\n.mdi-select-color::before {\n  content: \"\\f0d31\";\n}\n\n.mdi-select-compare::before {\n  content: \"\\f0ad9\";\n}\n\n.mdi-select-drag::before {\n  content: \"\\f0a6c\";\n}\n\n.mdi-select-group::before {\n  content: \"\\f0f82\";\n}\n\n.mdi-select-inverse::before {\n  content: \"\\f0487\";\n}\n\n.mdi-select-marker::before {\n  content: \"\\f1280\";\n}\n\n.mdi-select-multiple::before {\n  content: \"\\f1281\";\n}\n\n.mdi-select-multiple-marker::before {\n  content: \"\\f1282\";\n}\n\n.mdi-select-off::before {\n  content: \"\\f0488\";\n}\n\n.mdi-select-place::before {\n  content: \"\\f0fda\";\n}\n\n.mdi-select-remove::before {\n  content: \"\\f17c1\";\n}\n\n.mdi-select-search::before {\n  content: \"\\f1204\";\n}\n\n.mdi-selection::before {\n  content: \"\\f0489\";\n}\n\n.mdi-selection-drag::before {\n  content: \"\\f0a6d\";\n}\n\n.mdi-selection-ellipse::before {\n  content: \"\\f0d32\";\n}\n\n.mdi-selection-ellipse-arrow-inside::before {\n  content: \"\\f0f22\";\n}\n\n.mdi-selection-ellipse-remove::before {\n  content: \"\\f17c2\";\n}\n\n.mdi-selection-marker::before {\n  content: \"\\f1283\";\n}\n\n.mdi-selection-multiple::before {\n  content: \"\\f1285\";\n}\n\n.mdi-selection-multiple-marker::before {\n  content: \"\\f1284\";\n}\n\n.mdi-selection-off::before {\n  content: \"\\f0777\";\n}\n\n.mdi-selection-remove::before {\n  content: \"\\f17c3\";\n}\n\n.mdi-selection-search::before {\n  content: \"\\f1205\";\n}\n\n.mdi-semantic-web::before {\n  content: \"\\f1316\";\n}\n\n.mdi-send::before {\n  content: \"\\f048a\";\n}\n\n.mdi-send-check::before {\n  content: \"\\f1161\";\n}\n\n.mdi-send-check-outline::before {\n  content: \"\\f1162\";\n}\n\n.mdi-send-circle::before {\n  content: \"\\f0df8\";\n}\n\n.mdi-send-circle-outline::before {\n  content: \"\\f0df9\";\n}\n\n.mdi-send-clock::before {\n  content: \"\\f1163\";\n}\n\n.mdi-send-clock-outline::before {\n  content: \"\\f1164\";\n}\n\n.mdi-send-lock::before {\n  content: \"\\f07ed\";\n}\n\n.mdi-send-lock-outline::before {\n  content: \"\\f1166\";\n}\n\n.mdi-send-outline::before {\n  content: \"\\f1165\";\n}\n\n.mdi-serial-port::before {\n  content: \"\\f065c\";\n}\n\n.mdi-server::before {\n  content: \"\\f048b\";\n}\n\n.mdi-server-minus::before {\n  content: \"\\f048c\";\n}\n\n.mdi-server-network::before {\n  content: \"\\f048d\";\n}\n\n.mdi-server-network-off::before {\n  content: \"\\f048e\";\n}\n\n.mdi-server-off::before {\n  content: \"\\f048f\";\n}\n\n.mdi-server-plus::before {\n  content: \"\\f0490\";\n}\n\n.mdi-server-remove::before {\n  content: \"\\f0491\";\n}\n\n.mdi-server-security::before {\n  content: \"\\f0492\";\n}\n\n.mdi-set-all::before {\n  content: \"\\f0778\";\n}\n\n.mdi-set-center::before {\n  content: \"\\f0779\";\n}\n\n.mdi-set-center-right::before {\n  content: \"\\f077a\";\n}\n\n.mdi-set-left::before {\n  content: \"\\f077b\";\n}\n\n.mdi-set-left-center::before {\n  content: \"\\f077c\";\n}\n\n.mdi-set-left-right::before {\n  content: \"\\f077d\";\n}\n\n.mdi-set-merge::before {\n  content: \"\\f14e0\";\n}\n\n.mdi-set-none::before {\n  content: \"\\f077e\";\n}\n\n.mdi-set-right::before {\n  content: \"\\f077f\";\n}\n\n.mdi-set-split::before {\n  content: \"\\f14e1\";\n}\n\n.mdi-set-square::before {\n  content: \"\\f145d\";\n}\n\n.mdi-set-top-box::before {\n  content: \"\\f099f\";\n}\n\n.mdi-settings-helper::before {\n  content: \"\\f0a6e\";\n}\n\n.mdi-shaker::before {\n  content: \"\\f110e\";\n}\n\n.mdi-shaker-outline::before {\n  content: \"\\f110f\";\n}\n\n.mdi-shape::before {\n  content: \"\\f0831\";\n}\n\n.mdi-shape-circle-plus::before {\n  content: \"\\f065d\";\n}\n\n.mdi-shape-outline::before {\n  content: \"\\f0832\";\n}\n\n.mdi-shape-oval-plus::before {\n  content: \"\\f11fa\";\n}\n\n.mdi-shape-plus::before {\n  content: \"\\f0495\";\n}\n\n.mdi-shape-polygon-plus::before {\n  content: \"\\f065e\";\n}\n\n.mdi-shape-rectangle-plus::before {\n  content: \"\\f065f\";\n}\n\n.mdi-shape-square-plus::before {\n  content: \"\\f0660\";\n}\n\n.mdi-shape-square-rounded-plus::before {\n  content: \"\\f14fa\";\n}\n\n.mdi-share::before {\n  content: \"\\f0496\";\n}\n\n.mdi-share-all::before {\n  content: \"\\f11f4\";\n}\n\n.mdi-share-all-outline::before {\n  content: \"\\f11f5\";\n}\n\n.mdi-share-circle::before {\n  content: \"\\f11ad\";\n}\n\n.mdi-share-off::before {\n  content: \"\\f0f23\";\n}\n\n.mdi-share-off-outline::before {\n  content: \"\\f0f24\";\n}\n\n.mdi-share-outline::before {\n  content: \"\\f0932\";\n}\n\n.mdi-share-variant::before {\n  content: \"\\f0497\";\n}\n\n.mdi-share-variant-outline::before {\n  content: \"\\f1514\";\n}\n\n.mdi-shark::before {\n  content: \"\\f18ba\";\n}\n\n.mdi-shark-fin::before {\n  content: \"\\f1673\";\n}\n\n.mdi-shark-fin-outline::before {\n  content: \"\\f1674\";\n}\n\n.mdi-shark-off::before {\n  content: \"\\f18bb\";\n}\n\n.mdi-sheep::before {\n  content: \"\\f0cc6\";\n}\n\n.mdi-shield::before {\n  content: \"\\f0498\";\n}\n\n.mdi-shield-account::before {\n  content: \"\\f088f\";\n}\n\n.mdi-shield-account-outline::before {\n  content: \"\\f0a12\";\n}\n\n.mdi-shield-account-variant::before {\n  content: \"\\f15a7\";\n}\n\n.mdi-shield-account-variant-outline::before {\n  content: \"\\f15a8\";\n}\n\n.mdi-shield-airplane::before {\n  content: \"\\f06bb\";\n}\n\n.mdi-shield-airplane-outline::before {\n  content: \"\\f0cc7\";\n}\n\n.mdi-shield-alert::before {\n  content: \"\\f0ecc\";\n}\n\n.mdi-shield-alert-outline::before {\n  content: \"\\f0ecd\";\n}\n\n.mdi-shield-bug::before {\n  content: \"\\f13da\";\n}\n\n.mdi-shield-bug-outline::before {\n  content: \"\\f13db\";\n}\n\n.mdi-shield-car::before {\n  content: \"\\f0f83\";\n}\n\n.mdi-shield-check::before {\n  content: \"\\f0565\";\n}\n\n.mdi-shield-check-outline::before {\n  content: \"\\f0cc8\";\n}\n\n.mdi-shield-cross::before {\n  content: \"\\f0cc9\";\n}\n\n.mdi-shield-cross-outline::before {\n  content: \"\\f0cca\";\n}\n\n.mdi-shield-crown::before {\n  content: \"\\f18bc\";\n}\n\n.mdi-shield-crown-outline::before {\n  content: \"\\f18bd\";\n}\n\n.mdi-shield-edit::before {\n  content: \"\\f11a0\";\n}\n\n.mdi-shield-edit-outline::before {\n  content: \"\\f11a1\";\n}\n\n.mdi-shield-half::before {\n  content: \"\\f1360\";\n}\n\n.mdi-shield-half-full::before {\n  content: \"\\f0780\";\n}\n\n.mdi-shield-home::before {\n  content: \"\\f068a\";\n}\n\n.mdi-shield-home-outline::before {\n  content: \"\\f0ccb\";\n}\n\n.mdi-shield-key::before {\n  content: \"\\f0bc4\";\n}\n\n.mdi-shield-key-outline::before {\n  content: \"\\f0bc5\";\n}\n\n.mdi-shield-link-variant::before {\n  content: \"\\f0d33\";\n}\n\n.mdi-shield-link-variant-outline::before {\n  content: \"\\f0d34\";\n}\n\n.mdi-shield-lock::before {\n  content: \"\\f099d\";\n}\n\n.mdi-shield-lock-open::before {\n  content: \"\\f199a\";\n}\n\n.mdi-shield-lock-open-outline::before {\n  content: \"\\f199b\";\n}\n\n.mdi-shield-lock-outline::before {\n  content: \"\\f0ccc\";\n}\n\n.mdi-shield-moon::before {\n  content: \"\\f1828\";\n}\n\n.mdi-shield-moon-outline::before {\n  content: \"\\f1829\";\n}\n\n.mdi-shield-off::before {\n  content: \"\\f099e\";\n}\n\n.mdi-shield-off-outline::before {\n  content: \"\\f099c\";\n}\n\n.mdi-shield-outline::before {\n  content: \"\\f0499\";\n}\n\n.mdi-shield-plus::before {\n  content: \"\\f0ada\";\n}\n\n.mdi-shield-plus-outline::before {\n  content: \"\\f0adb\";\n}\n\n.mdi-shield-refresh::before {\n  content: \"\\f00aa\";\n}\n\n.mdi-shield-refresh-outline::before {\n  content: \"\\f01e0\";\n}\n\n.mdi-shield-remove::before {\n  content: \"\\f0adc\";\n}\n\n.mdi-shield-remove-outline::before {\n  content: \"\\f0add\";\n}\n\n.mdi-shield-search::before {\n  content: \"\\f0d9a\";\n}\n\n.mdi-shield-star::before {\n  content: \"\\f113b\";\n}\n\n.mdi-shield-star-outline::before {\n  content: \"\\f113c\";\n}\n\n.mdi-shield-sun::before {\n  content: \"\\f105d\";\n}\n\n.mdi-shield-sun-outline::before {\n  content: \"\\f105e\";\n}\n\n.mdi-shield-sword::before {\n  content: \"\\f18be\";\n}\n\n.mdi-shield-sword-outline::before {\n  content: \"\\f18bf\";\n}\n\n.mdi-shield-sync::before {\n  content: \"\\f11a2\";\n}\n\n.mdi-shield-sync-outline::before {\n  content: \"\\f11a3\";\n}\n\n.mdi-shimmer::before {\n  content: \"\\f1545\";\n}\n\n.mdi-ship-wheel::before {\n  content: \"\\f0833\";\n}\n\n.mdi-shipping-pallet::before {\n  content: \"\\f184e\";\n}\n\n.mdi-shoe-ballet::before {\n  content: \"\\f15ca\";\n}\n\n.mdi-shoe-cleat::before {\n  content: \"\\f15c7\";\n}\n\n.mdi-shoe-formal::before {\n  content: \"\\f0b47\";\n}\n\n.mdi-shoe-heel::before {\n  content: \"\\f0b48\";\n}\n\n.mdi-shoe-print::before {\n  content: \"\\f0dfa\";\n}\n\n.mdi-shoe-sneaker::before {\n  content: \"\\f15c8\";\n}\n\n.mdi-shopping::before {\n  content: \"\\f049a\";\n}\n\n.mdi-shopping-music::before {\n  content: \"\\f049b\";\n}\n\n.mdi-shopping-outline::before {\n  content: \"\\f11d5\";\n}\n\n.mdi-shopping-search::before {\n  content: \"\\f0f84\";\n}\n\n.mdi-shore::before {\n  content: \"\\f14f9\";\n}\n\n.mdi-shovel::before {\n  content: \"\\f0710\";\n}\n\n.mdi-shovel-off::before {\n  content: \"\\f0711\";\n}\n\n.mdi-shower::before {\n  content: \"\\f09a0\";\n}\n\n.mdi-shower-head::before {\n  content: \"\\f09a1\";\n}\n\n.mdi-shredder::before {\n  content: \"\\f049c\";\n}\n\n.mdi-shuffle::before {\n  content: \"\\f049d\";\n}\n\n.mdi-shuffle-disabled::before {\n  content: \"\\f049e\";\n}\n\n.mdi-shuffle-variant::before {\n  content: \"\\f049f\";\n}\n\n.mdi-shuriken::before {\n  content: \"\\f137f\";\n}\n\n.mdi-sickle::before {\n  content: \"\\f18c0\";\n}\n\n.mdi-sigma::before {\n  content: \"\\f04a0\";\n}\n\n.mdi-sigma-lower::before {\n  content: \"\\f062b\";\n}\n\n.mdi-sign-caution::before {\n  content: \"\\f04a1\";\n}\n\n.mdi-sign-direction::before {\n  content: \"\\f0781\";\n}\n\n.mdi-sign-direction-minus::before {\n  content: \"\\f1000\";\n}\n\n.mdi-sign-direction-plus::before {\n  content: \"\\f0fdc\";\n}\n\n.mdi-sign-direction-remove::before {\n  content: \"\\f0fdd\";\n}\n\n.mdi-sign-pole::before {\n  content: \"\\f14f8\";\n}\n\n.mdi-sign-real-estate::before {\n  content: \"\\f1118\";\n}\n\n.mdi-sign-text::before {\n  content: \"\\f0782\";\n}\n\n.mdi-signal::before {\n  content: \"\\f04a2\";\n}\n\n.mdi-signal-2g::before {\n  content: \"\\f0712\";\n}\n\n.mdi-signal-3g::before {\n  content: \"\\f0713\";\n}\n\n.mdi-signal-4g::before {\n  content: \"\\f0714\";\n}\n\n.mdi-signal-5g::before {\n  content: \"\\f0a6f\";\n}\n\n.mdi-signal-cellular-1::before {\n  content: \"\\f08bc\";\n}\n\n.mdi-signal-cellular-2::before {\n  content: \"\\f08bd\";\n}\n\n.mdi-signal-cellular-3::before {\n  content: \"\\f08be\";\n}\n\n.mdi-signal-cellular-outline::before {\n  content: \"\\f08bf\";\n}\n\n.mdi-signal-distance-variant::before {\n  content: \"\\f0e64\";\n}\n\n.mdi-signal-hspa::before {\n  content: \"\\f0715\";\n}\n\n.mdi-signal-hspa-plus::before {\n  content: \"\\f0716\";\n}\n\n.mdi-signal-off::before {\n  content: \"\\f0783\";\n}\n\n.mdi-signal-variant::before {\n  content: \"\\f060a\";\n}\n\n.mdi-signature::before {\n  content: \"\\f0dfb\";\n}\n\n.mdi-signature-freehand::before {\n  content: \"\\f0dfc\";\n}\n\n.mdi-signature-image::before {\n  content: \"\\f0dfd\";\n}\n\n.mdi-signature-text::before {\n  content: \"\\f0dfe\";\n}\n\n.mdi-silo::before {\n  content: \"\\f0b49\";\n}\n\n.mdi-silverware::before {\n  content: \"\\f04a3\";\n}\n\n.mdi-silverware-clean::before {\n  content: \"\\f0fde\";\n}\n\n.mdi-silverware-fork::before {\n  content: \"\\f04a4\";\n}\n\n.mdi-silverware-fork-knife::before {\n  content: \"\\f0a70\";\n}\n\n.mdi-silverware-spoon::before {\n  content: \"\\f04a5\";\n}\n\n.mdi-silverware-variant::before {\n  content: \"\\f04a6\";\n}\n\n.mdi-sim::before {\n  content: \"\\f04a7\";\n}\n\n.mdi-sim-alert::before {\n  content: \"\\f04a8\";\n}\n\n.mdi-sim-alert-outline::before {\n  content: \"\\f15d3\";\n}\n\n.mdi-sim-off::before {\n  content: \"\\f04a9\";\n}\n\n.mdi-sim-off-outline::before {\n  content: \"\\f15d4\";\n}\n\n.mdi-sim-outline::before {\n  content: \"\\f15d5\";\n}\n\n.mdi-simple-icons::before {\n  content: \"\\f131d\";\n}\n\n.mdi-sina-weibo::before {\n  content: \"\\f0adf\";\n}\n\n.mdi-sine-wave::before {\n  content: \"\\f095b\";\n}\n\n.mdi-sitemap::before {\n  content: \"\\f04aa\";\n}\n\n.mdi-sitemap-outline::before {\n  content: \"\\f199c\";\n}\n\n.mdi-size-l::before {\n  content: \"\\f13a6\";\n}\n\n.mdi-size-m::before {\n  content: \"\\f13a5\";\n}\n\n.mdi-size-s::before {\n  content: \"\\f13a4\";\n}\n\n.mdi-size-xl::before {\n  content: \"\\f13a7\";\n}\n\n.mdi-size-xs::before {\n  content: \"\\f13a3\";\n}\n\n.mdi-size-xxl::before {\n  content: \"\\f13a8\";\n}\n\n.mdi-size-xxs::before {\n  content: \"\\f13a2\";\n}\n\n.mdi-size-xxxl::before {\n  content: \"\\f13a9\";\n}\n\n.mdi-skate::before {\n  content: \"\\f0d35\";\n}\n\n.mdi-skate-off::before {\n  content: \"\\f0699\";\n}\n\n.mdi-skateboard::before {\n  content: \"\\f14c2\";\n}\n\n.mdi-skateboarding::before {\n  content: \"\\f0501\";\n}\n\n.mdi-skew-less::before {\n  content: \"\\f0d36\";\n}\n\n.mdi-skew-more::before {\n  content: \"\\f0d37\";\n}\n\n.mdi-ski::before {\n  content: \"\\f1304\";\n}\n\n.mdi-ski-cross-country::before {\n  content: \"\\f1305\";\n}\n\n.mdi-ski-water::before {\n  content: \"\\f1306\";\n}\n\n.mdi-skip-backward::before {\n  content: \"\\f04ab\";\n}\n\n.mdi-skip-backward-outline::before {\n  content: \"\\f0f25\";\n}\n\n.mdi-skip-forward::before {\n  content: \"\\f04ac\";\n}\n\n.mdi-skip-forward-outline::before {\n  content: \"\\f0f26\";\n}\n\n.mdi-skip-next::before {\n  content: \"\\f04ad\";\n}\n\n.mdi-skip-next-circle::before {\n  content: \"\\f0661\";\n}\n\n.mdi-skip-next-circle-outline::before {\n  content: \"\\f0662\";\n}\n\n.mdi-skip-next-outline::before {\n  content: \"\\f0f27\";\n}\n\n.mdi-skip-previous::before {\n  content: \"\\f04ae\";\n}\n\n.mdi-skip-previous-circle::before {\n  content: \"\\f0663\";\n}\n\n.mdi-skip-previous-circle-outline::before {\n  content: \"\\f0664\";\n}\n\n.mdi-skip-previous-outline::before {\n  content: \"\\f0f28\";\n}\n\n.mdi-skull::before {\n  content: \"\\f068c\";\n}\n\n.mdi-skull-crossbones::before {\n  content: \"\\f0bc6\";\n}\n\n.mdi-skull-crossbones-outline::before {\n  content: \"\\f0bc7\";\n}\n\n.mdi-skull-outline::before {\n  content: \"\\f0bc8\";\n}\n\n.mdi-skull-scan::before {\n  content: \"\\f14c7\";\n}\n\n.mdi-skull-scan-outline::before {\n  content: \"\\f14c8\";\n}\n\n.mdi-skype::before {\n  content: \"\\f04af\";\n}\n\n.mdi-skype-business::before {\n  content: \"\\f04b0\";\n}\n\n.mdi-slack::before {\n  content: \"\\f04b1\";\n}\n\n.mdi-slash-forward::before {\n  content: \"\\f0fdf\";\n}\n\n.mdi-slash-forward-box::before {\n  content: \"\\f0fe0\";\n}\n\n.mdi-sledding::before {\n  content: \"\\f041b\";\n}\n\n.mdi-sleep::before {\n  content: \"\\f04b2\";\n}\n\n.mdi-sleep-off::before {\n  content: \"\\f04b3\";\n}\n\n.mdi-slide::before {\n  content: \"\\f15a5\";\n}\n\n.mdi-slope-downhill::before {\n  content: \"\\f0dff\";\n}\n\n.mdi-slope-uphill::before {\n  content: \"\\f0e00\";\n}\n\n.mdi-slot-machine::before {\n  content: \"\\f1114\";\n}\n\n.mdi-slot-machine-outline::before {\n  content: \"\\f1115\";\n}\n\n.mdi-smart-card::before {\n  content: \"\\f10bd\";\n}\n\n.mdi-smart-card-off::before {\n  content: \"\\f18f7\";\n}\n\n.mdi-smart-card-off-outline::before {\n  content: \"\\f18f8\";\n}\n\n.mdi-smart-card-outline::before {\n  content: \"\\f10be\";\n}\n\n.mdi-smart-card-reader::before {\n  content: \"\\f10bf\";\n}\n\n.mdi-smart-card-reader-outline::before {\n  content: \"\\f10c0\";\n}\n\n.mdi-smog::before {\n  content: \"\\f0a71\";\n}\n\n.mdi-smoke::before {\n  content: \"\\f1799\";\n}\n\n.mdi-smoke-detector::before {\n  content: \"\\f0392\";\n}\n\n.mdi-smoke-detector-alert::before {\n  content: \"\\f192e\";\n}\n\n.mdi-smoke-detector-alert-outline::before {\n  content: \"\\f192f\";\n}\n\n.mdi-smoke-detector-off::before {\n  content: \"\\f1809\";\n}\n\n.mdi-smoke-detector-off-outline::before {\n  content: \"\\f180a\";\n}\n\n.mdi-smoke-detector-outline::before {\n  content: \"\\f1808\";\n}\n\n.mdi-smoke-detector-variant::before {\n  content: \"\\f180b\";\n}\n\n.mdi-smoke-detector-variant-alert::before {\n  content: \"\\f1930\";\n}\n\n.mdi-smoke-detector-variant-off::before {\n  content: \"\\f180c\";\n}\n\n.mdi-smoking::before {\n  content: \"\\f04b4\";\n}\n\n.mdi-smoking-off::before {\n  content: \"\\f04b5\";\n}\n\n.mdi-smoking-pipe::before {\n  content: \"\\f140d\";\n}\n\n.mdi-smoking-pipe-off::before {\n  content: \"\\f1428\";\n}\n\n.mdi-snail::before {\n  content: \"\\f1677\";\n}\n\n.mdi-snake::before {\n  content: \"\\f150e\";\n}\n\n.mdi-snapchat::before {\n  content: \"\\f04b6\";\n}\n\n.mdi-snowboard::before {\n  content: \"\\f1307\";\n}\n\n.mdi-snowflake::before {\n  content: \"\\f0717\";\n}\n\n.mdi-snowflake-alert::before {\n  content: \"\\f0f29\";\n}\n\n.mdi-snowflake-melt::before {\n  content: \"\\f12cb\";\n}\n\n.mdi-snowflake-off::before {\n  content: \"\\f14e3\";\n}\n\n.mdi-snowflake-variant::before {\n  content: \"\\f0f2a\";\n}\n\n.mdi-snowman::before {\n  content: \"\\f04b7\";\n}\n\n.mdi-snowmobile::before {\n  content: \"\\f06dd\";\n}\n\n.mdi-soccer::before {\n  content: \"\\f04b8\";\n}\n\n.mdi-soccer-field::before {\n  content: \"\\f0834\";\n}\n\n.mdi-social-distance-2-meters::before {\n  content: \"\\f1579\";\n}\n\n.mdi-social-distance-6-feet::before {\n  content: \"\\f157a\";\n}\n\n.mdi-sofa::before {\n  content: \"\\f04b9\";\n}\n\n.mdi-sofa-outline::before {\n  content: \"\\f156d\";\n}\n\n.mdi-sofa-single::before {\n  content: \"\\f156e\";\n}\n\n.mdi-sofa-single-outline::before {\n  content: \"\\f156f\";\n}\n\n.mdi-solar-panel::before {\n  content: \"\\f0d9b\";\n}\n\n.mdi-solar-panel-large::before {\n  content: \"\\f0d9c\";\n}\n\n.mdi-solar-power::before {\n  content: \"\\f0a72\";\n}\n\n.mdi-soldering-iron::before {\n  content: \"\\f1092\";\n}\n\n.mdi-solid::before {\n  content: \"\\f068d\";\n}\n\n.mdi-sony-playstation::before {\n  content: \"\\f0414\";\n}\n\n.mdi-sort::before {\n  content: \"\\f04ba\";\n}\n\n.mdi-sort-alphabetical-ascending::before {\n  content: \"\\f05bd\";\n}\n\n.mdi-sort-alphabetical-ascending-variant::before {\n  content: \"\\f1148\";\n}\n\n.mdi-sort-alphabetical-descending::before {\n  content: \"\\f05bf\";\n}\n\n.mdi-sort-alphabetical-descending-variant::before {\n  content: \"\\f1149\";\n}\n\n.mdi-sort-alphabetical-variant::before {\n  content: \"\\f04bb\";\n}\n\n.mdi-sort-ascending::before {\n  content: \"\\f04bc\";\n}\n\n.mdi-sort-bool-ascending::before {\n  content: \"\\f1385\";\n}\n\n.mdi-sort-bool-ascending-variant::before {\n  content: \"\\f1386\";\n}\n\n.mdi-sort-bool-descending::before {\n  content: \"\\f1387\";\n}\n\n.mdi-sort-bool-descending-variant::before {\n  content: \"\\f1388\";\n}\n\n.mdi-sort-calendar-ascending::before {\n  content: \"\\f1547\";\n}\n\n.mdi-sort-calendar-descending::before {\n  content: \"\\f1548\";\n}\n\n.mdi-sort-clock-ascending::before {\n  content: \"\\f1549\";\n}\n\n.mdi-sort-clock-ascending-outline::before {\n  content: \"\\f154a\";\n}\n\n.mdi-sort-clock-descending::before {\n  content: \"\\f154b\";\n}\n\n.mdi-sort-clock-descending-outline::before {\n  content: \"\\f154c\";\n}\n\n.mdi-sort-descending::before {\n  content: \"\\f04bd\";\n}\n\n.mdi-sort-numeric-ascending::before {\n  content: \"\\f1389\";\n}\n\n.mdi-sort-numeric-ascending-variant::before {\n  content: \"\\f090d\";\n}\n\n.mdi-sort-numeric-descending::before {\n  content: \"\\f138a\";\n}\n\n.mdi-sort-numeric-descending-variant::before {\n  content: \"\\f0ad2\";\n}\n\n.mdi-sort-numeric-variant::before {\n  content: \"\\f04be\";\n}\n\n.mdi-sort-reverse-variant::before {\n  content: \"\\f033c\";\n}\n\n.mdi-sort-variant::before {\n  content: \"\\f04bf\";\n}\n\n.mdi-sort-variant-lock::before {\n  content: \"\\f0ccd\";\n}\n\n.mdi-sort-variant-lock-open::before {\n  content: \"\\f0cce\";\n}\n\n.mdi-sort-variant-remove::before {\n  content: \"\\f1147\";\n}\n\n.mdi-soundbar::before {\n  content: \"\\f17db\";\n}\n\n.mdi-soundcloud::before {\n  content: \"\\f04c0\";\n}\n\n.mdi-source-branch::before {\n  content: \"\\f062c\";\n}\n\n.mdi-source-branch-check::before {\n  content: \"\\f14cf\";\n}\n\n.mdi-source-branch-minus::before {\n  content: \"\\f14cb\";\n}\n\n.mdi-source-branch-plus::before {\n  content: \"\\f14ca\";\n}\n\n.mdi-source-branch-refresh::before {\n  content: \"\\f14cd\";\n}\n\n.mdi-source-branch-remove::before {\n  content: \"\\f14cc\";\n}\n\n.mdi-source-branch-sync::before {\n  content: \"\\f14ce\";\n}\n\n.mdi-source-commit::before {\n  content: \"\\f0718\";\n}\n\n.mdi-source-commit-end::before {\n  content: \"\\f0719\";\n}\n\n.mdi-source-commit-end-local::before {\n  content: \"\\f071a\";\n}\n\n.mdi-source-commit-local::before {\n  content: \"\\f071b\";\n}\n\n.mdi-source-commit-next-local::before {\n  content: \"\\f071c\";\n}\n\n.mdi-source-commit-start::before {\n  content: \"\\f071d\";\n}\n\n.mdi-source-commit-start-next-local::before {\n  content: \"\\f071e\";\n}\n\n.mdi-source-fork::before {\n  content: \"\\f04c1\";\n}\n\n.mdi-source-merge::before {\n  content: \"\\f062d\";\n}\n\n.mdi-source-pull::before {\n  content: \"\\f04c2\";\n}\n\n.mdi-source-repository::before {\n  content: \"\\f0ccf\";\n}\n\n.mdi-source-repository-multiple::before {\n  content: \"\\f0cd0\";\n}\n\n.mdi-soy-sauce::before {\n  content: \"\\f07ee\";\n}\n\n.mdi-soy-sauce-off::before {\n  content: \"\\f13fc\";\n}\n\n.mdi-spa::before {\n  content: \"\\f0cd1\";\n}\n\n.mdi-spa-outline::before {\n  content: \"\\f0cd2\";\n}\n\n.mdi-space-invaders::before {\n  content: \"\\f0bc9\";\n}\n\n.mdi-space-station::before {\n  content: \"\\f1383\";\n}\n\n.mdi-spade::before {\n  content: \"\\f0e65\";\n}\n\n.mdi-speaker::before {\n  content: \"\\f04c3\";\n}\n\n.mdi-speaker-bluetooth::before {\n  content: \"\\f09a2\";\n}\n\n.mdi-speaker-multiple::before {\n  content: \"\\f0d38\";\n}\n\n.mdi-speaker-off::before {\n  content: \"\\f04c4\";\n}\n\n.mdi-speaker-wireless::before {\n  content: \"\\f071f\";\n}\n\n.mdi-spear::before {\n  content: \"\\f1845\";\n}\n\n.mdi-speedometer::before {\n  content: \"\\f04c5\";\n}\n\n.mdi-speedometer-medium::before {\n  content: \"\\f0f85\";\n}\n\n.mdi-speedometer-slow::before {\n  content: \"\\f0f86\";\n}\n\n.mdi-spellcheck::before {\n  content: \"\\f04c6\";\n}\n\n.mdi-sphere::before {\n  content: \"\\f1954\";\n}\n\n.mdi-sphere-off::before {\n  content: \"\\f1955\";\n}\n\n.mdi-spider::before {\n  content: \"\\f11ea\";\n}\n\n.mdi-spider-thread::before {\n  content: \"\\f11eb\";\n}\n\n.mdi-spider-web::before {\n  content: \"\\f0bca\";\n}\n\n.mdi-spirit-level::before {\n  content: \"\\f14f1\";\n}\n\n.mdi-spoon-sugar::before {\n  content: \"\\f1429\";\n}\n\n.mdi-spotify::before {\n  content: \"\\f04c7\";\n}\n\n.mdi-spotlight::before {\n  content: \"\\f04c8\";\n}\n\n.mdi-spotlight-beam::before {\n  content: \"\\f04c9\";\n}\n\n.mdi-spray::before {\n  content: \"\\f0665\";\n}\n\n.mdi-spray-bottle::before {\n  content: \"\\f0ae0\";\n}\n\n.mdi-sprinkler::before {\n  content: \"\\f105f\";\n}\n\n.mdi-sprinkler-fire::before {\n  content: \"\\f199d\";\n}\n\n.mdi-sprinkler-variant::before {\n  content: \"\\f1060\";\n}\n\n.mdi-sprout::before {\n  content: \"\\f0e66\";\n}\n\n.mdi-sprout-outline::before {\n  content: \"\\f0e67\";\n}\n\n.mdi-square::before {\n  content: \"\\f0764\";\n}\n\n.mdi-square-circle::before {\n  content: \"\\f1500\";\n}\n\n.mdi-square-edit-outline::before {\n  content: \"\\f090c\";\n}\n\n.mdi-square-medium::before {\n  content: \"\\f0a13\";\n}\n\n.mdi-square-medium-outline::before {\n  content: \"\\f0a14\";\n}\n\n.mdi-square-off::before {\n  content: \"\\f12ee\";\n}\n\n.mdi-square-off-outline::before {\n  content: \"\\f12ef\";\n}\n\n.mdi-square-opacity::before {\n  content: \"\\f1854\";\n}\n\n.mdi-square-outline::before {\n  content: \"\\f0763\";\n}\n\n.mdi-square-root::before {\n  content: \"\\f0784\";\n}\n\n.mdi-square-root-box::before {\n  content: \"\\f09a3\";\n}\n\n.mdi-square-rounded::before {\n  content: \"\\f14fb\";\n}\n\n.mdi-square-rounded-outline::before {\n  content: \"\\f14fc\";\n}\n\n.mdi-square-small::before {\n  content: \"\\f0a15\";\n}\n\n.mdi-square-wave::before {\n  content: \"\\f147b\";\n}\n\n.mdi-squeegee::before {\n  content: \"\\f0ae1\";\n}\n\n.mdi-ssh::before {\n  content: \"\\f08c0\";\n}\n\n.mdi-stack-exchange::before {\n  content: \"\\f060b\";\n}\n\n.mdi-stack-overflow::before {\n  content: \"\\f04cc\";\n}\n\n.mdi-stackpath::before {\n  content: \"\\f0359\";\n}\n\n.mdi-stadium::before {\n  content: \"\\f0ff9\";\n}\n\n.mdi-stadium-variant::before {\n  content: \"\\f0720\";\n}\n\n.mdi-stairs::before {\n  content: \"\\f04cd\";\n}\n\n.mdi-stairs-box::before {\n  content: \"\\f139e\";\n}\n\n.mdi-stairs-down::before {\n  content: \"\\f12be\";\n}\n\n.mdi-stairs-up::before {\n  content: \"\\f12bd\";\n}\n\n.mdi-stamper::before {\n  content: \"\\f0d39\";\n}\n\n.mdi-standard-definition::before {\n  content: \"\\f07ef\";\n}\n\n.mdi-star::before {\n  content: \"\\f04ce\";\n}\n\n.mdi-star-box::before {\n  content: \"\\f0a73\";\n}\n\n.mdi-star-box-multiple::before {\n  content: \"\\f1286\";\n}\n\n.mdi-star-box-multiple-outline::before {\n  content: \"\\f1287\";\n}\n\n.mdi-star-box-outline::before {\n  content: \"\\f0a74\";\n}\n\n.mdi-star-check::before {\n  content: \"\\f1566\";\n}\n\n.mdi-star-check-outline::before {\n  content: \"\\f156a\";\n}\n\n.mdi-star-circle::before {\n  content: \"\\f04cf\";\n}\n\n.mdi-star-circle-outline::before {\n  content: \"\\f09a4\";\n}\n\n.mdi-star-cog::before {\n  content: \"\\f1668\";\n}\n\n.mdi-star-cog-outline::before {\n  content: \"\\f1669\";\n}\n\n.mdi-star-crescent::before {\n  content: \"\\f0979\";\n}\n\n.mdi-star-david::before {\n  content: \"\\f097a\";\n}\n\n.mdi-star-face::before {\n  content: \"\\f09a5\";\n}\n\n.mdi-star-four-points::before {\n  content: \"\\f0ae2\";\n}\n\n.mdi-star-four-points-outline::before {\n  content: \"\\f0ae3\";\n}\n\n.mdi-star-half::before {\n  content: \"\\f0246\";\n}\n\n.mdi-star-half-full::before {\n  content: \"\\f04d0\";\n}\n\n.mdi-star-minus::before {\n  content: \"\\f1564\";\n}\n\n.mdi-star-minus-outline::before {\n  content: \"\\f1568\";\n}\n\n.mdi-star-off::before {\n  content: \"\\f04d1\";\n}\n\n.mdi-star-off-outline::before {\n  content: \"\\f155b\";\n}\n\n.mdi-star-outline::before {\n  content: \"\\f04d2\";\n}\n\n.mdi-star-plus::before {\n  content: \"\\f1563\";\n}\n\n.mdi-star-plus-outline::before {\n  content: \"\\f1567\";\n}\n\n.mdi-star-remove::before {\n  content: \"\\f1565\";\n}\n\n.mdi-star-remove-outline::before {\n  content: \"\\f1569\";\n}\n\n.mdi-star-settings::before {\n  content: \"\\f166a\";\n}\n\n.mdi-star-settings-outline::before {\n  content: \"\\f166b\";\n}\n\n.mdi-star-shooting::before {\n  content: \"\\f1741\";\n}\n\n.mdi-star-shooting-outline::before {\n  content: \"\\f1742\";\n}\n\n.mdi-star-three-points::before {\n  content: \"\\f0ae4\";\n}\n\n.mdi-star-three-points-outline::before {\n  content: \"\\f0ae5\";\n}\n\n.mdi-state-machine::before {\n  content: \"\\f11ef\";\n}\n\n.mdi-steam::before {\n  content: \"\\f04d3\";\n}\n\n.mdi-steering::before {\n  content: \"\\f04d4\";\n}\n\n.mdi-steering-off::before {\n  content: \"\\f090e\";\n}\n\n.mdi-step-backward::before {\n  content: \"\\f04d5\";\n}\n\n.mdi-step-backward-2::before {\n  content: \"\\f04d6\";\n}\n\n.mdi-step-forward::before {\n  content: \"\\f04d7\";\n}\n\n.mdi-step-forward-2::before {\n  content: \"\\f04d8\";\n}\n\n.mdi-stethoscope::before {\n  content: \"\\f04d9\";\n}\n\n.mdi-sticker::before {\n  content: \"\\f1364\";\n}\n\n.mdi-sticker-alert::before {\n  content: \"\\f1365\";\n}\n\n.mdi-sticker-alert-outline::before {\n  content: \"\\f1366\";\n}\n\n.mdi-sticker-check::before {\n  content: \"\\f1367\";\n}\n\n.mdi-sticker-check-outline::before {\n  content: \"\\f1368\";\n}\n\n.mdi-sticker-circle-outline::before {\n  content: \"\\f05d0\";\n}\n\n.mdi-sticker-emoji::before {\n  content: \"\\f0785\";\n}\n\n.mdi-sticker-minus::before {\n  content: \"\\f1369\";\n}\n\n.mdi-sticker-minus-outline::before {\n  content: \"\\f136a\";\n}\n\n.mdi-sticker-outline::before {\n  content: \"\\f136b\";\n}\n\n.mdi-sticker-plus::before {\n  content: \"\\f136c\";\n}\n\n.mdi-sticker-plus-outline::before {\n  content: \"\\f136d\";\n}\n\n.mdi-sticker-remove::before {\n  content: \"\\f136e\";\n}\n\n.mdi-sticker-remove-outline::before {\n  content: \"\\f136f\";\n}\n\n.mdi-sticker-text::before {\n  content: \"\\f178e\";\n}\n\n.mdi-sticker-text-outline::before {\n  content: \"\\f178f\";\n}\n\n.mdi-stocking::before {\n  content: \"\\f04da\";\n}\n\n.mdi-stomach::before {\n  content: \"\\f1093\";\n}\n\n.mdi-stool::before {\n  content: \"\\f195d\";\n}\n\n.mdi-stool-outline::before {\n  content: \"\\f195e\";\n}\n\n.mdi-stop::before {\n  content: \"\\f04db\";\n}\n\n.mdi-stop-circle::before {\n  content: \"\\f0666\";\n}\n\n.mdi-stop-circle-outline::before {\n  content: \"\\f0667\";\n}\n\n.mdi-store::before {\n  content: \"\\f04dc\";\n}\n\n.mdi-store-24-hour::before {\n  content: \"\\f04dd\";\n}\n\n.mdi-store-alert::before {\n  content: \"\\f18c1\";\n}\n\n.mdi-store-alert-outline::before {\n  content: \"\\f18c2\";\n}\n\n.mdi-store-check::before {\n  content: \"\\f18c3\";\n}\n\n.mdi-store-check-outline::before {\n  content: \"\\f18c4\";\n}\n\n.mdi-store-clock::before {\n  content: \"\\f18c5\";\n}\n\n.mdi-store-clock-outline::before {\n  content: \"\\f18c6\";\n}\n\n.mdi-store-cog::before {\n  content: \"\\f18c7\";\n}\n\n.mdi-store-cog-outline::before {\n  content: \"\\f18c8\";\n}\n\n.mdi-store-edit::before {\n  content: \"\\f18c9\";\n}\n\n.mdi-store-edit-outline::before {\n  content: \"\\f18ca\";\n}\n\n.mdi-store-marker::before {\n  content: \"\\f18cb\";\n}\n\n.mdi-store-marker-outline::before {\n  content: \"\\f18cc\";\n}\n\n.mdi-store-minus::before {\n  content: \"\\f165e\";\n}\n\n.mdi-store-minus-outline::before {\n  content: \"\\f18cd\";\n}\n\n.mdi-store-off::before {\n  content: \"\\f18ce\";\n}\n\n.mdi-store-off-outline::before {\n  content: \"\\f18cf\";\n}\n\n.mdi-store-outline::before {\n  content: \"\\f1361\";\n}\n\n.mdi-store-plus::before {\n  content: \"\\f165f\";\n}\n\n.mdi-store-plus-outline::before {\n  content: \"\\f18d0\";\n}\n\n.mdi-store-remove::before {\n  content: \"\\f1660\";\n}\n\n.mdi-store-remove-outline::before {\n  content: \"\\f18d1\";\n}\n\n.mdi-store-search::before {\n  content: \"\\f18d2\";\n}\n\n.mdi-store-search-outline::before {\n  content: \"\\f18d3\";\n}\n\n.mdi-store-settings::before {\n  content: \"\\f18d4\";\n}\n\n.mdi-store-settings-outline::before {\n  content: \"\\f18d5\";\n}\n\n.mdi-storefront::before {\n  content: \"\\f07c7\";\n}\n\n.mdi-storefront-outline::before {\n  content: \"\\f10c1\";\n}\n\n.mdi-stove::before {\n  content: \"\\f04de\";\n}\n\n.mdi-strategy::before {\n  content: \"\\f11d6\";\n}\n\n.mdi-stretch-to-page::before {\n  content: \"\\f0f2b\";\n}\n\n.mdi-stretch-to-page-outline::before {\n  content: \"\\f0f2c\";\n}\n\n.mdi-string-lights::before {\n  content: \"\\f12ba\";\n}\n\n.mdi-string-lights-off::before {\n  content: \"\\f12bb\";\n}\n\n.mdi-subdirectory-arrow-left::before {\n  content: \"\\f060c\";\n}\n\n.mdi-subdirectory-arrow-right::before {\n  content: \"\\f060d\";\n}\n\n.mdi-submarine::before {\n  content: \"\\f156c\";\n}\n\n.mdi-subtitles::before {\n  content: \"\\f0a16\";\n}\n\n.mdi-subtitles-outline::before {\n  content: \"\\f0a17\";\n}\n\n.mdi-subway::before {\n  content: \"\\f06ac\";\n}\n\n.mdi-subway-alert-variant::before {\n  content: \"\\f0d9d\";\n}\n\n.mdi-subway-variant::before {\n  content: \"\\f04df\";\n}\n\n.mdi-summit::before {\n  content: \"\\f0786\";\n}\n\n.mdi-sun-compass::before {\n  content: \"\\f19a5\";\n}\n\n.mdi-sun-snowflake::before {\n  content: \"\\f1796\";\n}\n\n.mdi-sun-thermometer::before {\n  content: \"\\f18d6\";\n}\n\n.mdi-sun-thermometer-outline::before {\n  content: \"\\f18d7\";\n}\n\n.mdi-sun-wireless::before {\n  content: \"\\f17fe\";\n}\n\n.mdi-sun-wireless-outline::before {\n  content: \"\\f17ff\";\n}\n\n.mdi-sunglasses::before {\n  content: \"\\f04e0\";\n}\n\n.mdi-surfing::before {\n  content: \"\\f1746\";\n}\n\n.mdi-surround-sound::before {\n  content: \"\\f05c5\";\n}\n\n.mdi-surround-sound-2-0::before {\n  content: \"\\f07f0\";\n}\n\n.mdi-surround-sound-2-1::before {\n  content: \"\\f1729\";\n}\n\n.mdi-surround-sound-3-1::before {\n  content: \"\\f07f1\";\n}\n\n.mdi-surround-sound-5-1::before {\n  content: \"\\f07f2\";\n}\n\n.mdi-surround-sound-5-1-2::before {\n  content: \"\\f172a\";\n}\n\n.mdi-surround-sound-7-1::before {\n  content: \"\\f07f3\";\n}\n\n.mdi-svg::before {\n  content: \"\\f0721\";\n}\n\n.mdi-swap-horizontal::before {\n  content: \"\\f04e1\";\n}\n\n.mdi-swap-horizontal-bold::before {\n  content: \"\\f0bcd\";\n}\n\n.mdi-swap-horizontal-circle::before {\n  content: \"\\f0fe1\";\n}\n\n.mdi-swap-horizontal-circle-outline::before {\n  content: \"\\f0fe2\";\n}\n\n.mdi-swap-horizontal-variant::before {\n  content: \"\\f08c1\";\n}\n\n.mdi-swap-vertical::before {\n  content: \"\\f04e2\";\n}\n\n.mdi-swap-vertical-bold::before {\n  content: \"\\f0bce\";\n}\n\n.mdi-swap-vertical-circle::before {\n  content: \"\\f0fe3\";\n}\n\n.mdi-swap-vertical-circle-outline::before {\n  content: \"\\f0fe4\";\n}\n\n.mdi-swap-vertical-variant::before {\n  content: \"\\f08c2\";\n}\n\n.mdi-swim::before {\n  content: \"\\f04e3\";\n}\n\n.mdi-switch::before {\n  content: \"\\f04e4\";\n}\n\n.mdi-sword::before {\n  content: \"\\f04e5\";\n}\n\n.mdi-sword-cross::before {\n  content: \"\\f0787\";\n}\n\n.mdi-syllabary-hangul::before {\n  content: \"\\f1333\";\n}\n\n.mdi-syllabary-hiragana::before {\n  content: \"\\f1334\";\n}\n\n.mdi-syllabary-katakana::before {\n  content: \"\\f1335\";\n}\n\n.mdi-syllabary-katakana-halfwidth::before {\n  content: \"\\f1336\";\n}\n\n.mdi-symbol::before {\n  content: \"\\f1501\";\n}\n\n.mdi-symfony::before {\n  content: \"\\f0ae6\";\n}\n\n.mdi-sync::before {\n  content: \"\\f04e6\";\n}\n\n.mdi-sync-alert::before {\n  content: \"\\f04e7\";\n}\n\n.mdi-sync-circle::before {\n  content: \"\\f1378\";\n}\n\n.mdi-sync-off::before {\n  content: \"\\f04e8\";\n}\n\n.mdi-tab::before {\n  content: \"\\f04e9\";\n}\n\n.mdi-tab-minus::before {\n  content: \"\\f0b4b\";\n}\n\n.mdi-tab-plus::before {\n  content: \"\\f075c\";\n}\n\n.mdi-tab-remove::before {\n  content: \"\\f0b4c\";\n}\n\n.mdi-tab-search::before {\n  content: \"\\f199e\";\n}\n\n.mdi-tab-unselected::before {\n  content: \"\\f04ea\";\n}\n\n.mdi-table::before {\n  content: \"\\f04eb\";\n}\n\n.mdi-table-account::before {\n  content: \"\\f13b9\";\n}\n\n.mdi-table-alert::before {\n  content: \"\\f13ba\";\n}\n\n.mdi-table-arrow-down::before {\n  content: \"\\f13bb\";\n}\n\n.mdi-table-arrow-left::before {\n  content: \"\\f13bc\";\n}\n\n.mdi-table-arrow-right::before {\n  content: \"\\f13bd\";\n}\n\n.mdi-table-arrow-up::before {\n  content: \"\\f13be\";\n}\n\n.mdi-table-border::before {\n  content: \"\\f0a18\";\n}\n\n.mdi-table-cancel::before {\n  content: \"\\f13bf\";\n}\n\n.mdi-table-chair::before {\n  content: \"\\f1061\";\n}\n\n.mdi-table-check::before {\n  content: \"\\f13c0\";\n}\n\n.mdi-table-clock::before {\n  content: \"\\f13c1\";\n}\n\n.mdi-table-cog::before {\n  content: \"\\f13c2\";\n}\n\n.mdi-table-column::before {\n  content: \"\\f0835\";\n}\n\n.mdi-table-column-plus-after::before {\n  content: \"\\f04ec\";\n}\n\n.mdi-table-column-plus-before::before {\n  content: \"\\f04ed\";\n}\n\n.mdi-table-column-remove::before {\n  content: \"\\f04ee\";\n}\n\n.mdi-table-column-width::before {\n  content: \"\\f04ef\";\n}\n\n.mdi-table-edit::before {\n  content: \"\\f04f0\";\n}\n\n.mdi-table-eye::before {\n  content: \"\\f1094\";\n}\n\n.mdi-table-eye-off::before {\n  content: \"\\f13c3\";\n}\n\n.mdi-table-furniture::before {\n  content: \"\\f05bc\";\n}\n\n.mdi-table-headers-eye::before {\n  content: \"\\f121d\";\n}\n\n.mdi-table-headers-eye-off::before {\n  content: \"\\f121e\";\n}\n\n.mdi-table-heart::before {\n  content: \"\\f13c4\";\n}\n\n.mdi-table-key::before {\n  content: \"\\f13c5\";\n}\n\n.mdi-table-large::before {\n  content: \"\\f04f1\";\n}\n\n.mdi-table-large-plus::before {\n  content: \"\\f0f87\";\n}\n\n.mdi-table-large-remove::before {\n  content: \"\\f0f88\";\n}\n\n.mdi-table-lock::before {\n  content: \"\\f13c6\";\n}\n\n.mdi-table-merge-cells::before {\n  content: \"\\f09a6\";\n}\n\n.mdi-table-minus::before {\n  content: \"\\f13c7\";\n}\n\n.mdi-table-multiple::before {\n  content: \"\\f13c8\";\n}\n\n.mdi-table-network::before {\n  content: \"\\f13c9\";\n}\n\n.mdi-table-of-contents::before {\n  content: \"\\f0836\";\n}\n\n.mdi-table-off::before {\n  content: \"\\f13ca\";\n}\n\n.mdi-table-picnic::before {\n  content: \"\\f1743\";\n}\n\n.mdi-table-pivot::before {\n  content: \"\\f183c\";\n}\n\n.mdi-table-plus::before {\n  content: \"\\f0a75\";\n}\n\n.mdi-table-refresh::before {\n  content: \"\\f13a0\";\n}\n\n.mdi-table-remove::before {\n  content: \"\\f0a76\";\n}\n\n.mdi-table-row::before {\n  content: \"\\f0837\";\n}\n\n.mdi-table-row-height::before {\n  content: \"\\f04f2\";\n}\n\n.mdi-table-row-plus-after::before {\n  content: \"\\f04f3\";\n}\n\n.mdi-table-row-plus-before::before {\n  content: \"\\f04f4\";\n}\n\n.mdi-table-row-remove::before {\n  content: \"\\f04f5\";\n}\n\n.mdi-table-search::before {\n  content: \"\\f090f\";\n}\n\n.mdi-table-settings::before {\n  content: \"\\f0838\";\n}\n\n.mdi-table-split-cell::before {\n  content: \"\\f142a\";\n}\n\n.mdi-table-star::before {\n  content: \"\\f13cb\";\n}\n\n.mdi-table-sync::before {\n  content: \"\\f13a1\";\n}\n\n.mdi-table-tennis::before {\n  content: \"\\f0e68\";\n}\n\n.mdi-tablet::before {\n  content: \"\\f04f6\";\n}\n\n.mdi-tablet-android::before {\n  content: \"\\f04f7\";\n}\n\n.mdi-tablet-cellphone::before {\n  content: \"\\f09a7\";\n}\n\n.mdi-tablet-dashboard::before {\n  content: \"\\f0ece\";\n}\n\n.mdi-taco::before {\n  content: \"\\f0762\";\n}\n\n.mdi-tag::before {\n  content: \"\\f04f9\";\n}\n\n.mdi-tag-arrow-down::before {\n  content: \"\\f172b\";\n}\n\n.mdi-tag-arrow-down-outline::before {\n  content: \"\\f172c\";\n}\n\n.mdi-tag-arrow-left::before {\n  content: \"\\f172d\";\n}\n\n.mdi-tag-arrow-left-outline::before {\n  content: \"\\f172e\";\n}\n\n.mdi-tag-arrow-right::before {\n  content: \"\\f172f\";\n}\n\n.mdi-tag-arrow-right-outline::before {\n  content: \"\\f1730\";\n}\n\n.mdi-tag-arrow-up::before {\n  content: \"\\f1731\";\n}\n\n.mdi-tag-arrow-up-outline::before {\n  content: \"\\f1732\";\n}\n\n.mdi-tag-faces::before {\n  content: \"\\f04fa\";\n}\n\n.mdi-tag-heart::before {\n  content: \"\\f068b\";\n}\n\n.mdi-tag-heart-outline::before {\n  content: \"\\f0bcf\";\n}\n\n.mdi-tag-minus::before {\n  content: \"\\f0910\";\n}\n\n.mdi-tag-minus-outline::before {\n  content: \"\\f121f\";\n}\n\n.mdi-tag-multiple::before {\n  content: \"\\f04fb\";\n}\n\n.mdi-tag-multiple-outline::before {\n  content: \"\\f12f7\";\n}\n\n.mdi-tag-off::before {\n  content: \"\\f1220\";\n}\n\n.mdi-tag-off-outline::before {\n  content: \"\\f1221\";\n}\n\n.mdi-tag-outline::before {\n  content: \"\\f04fc\";\n}\n\n.mdi-tag-plus::before {\n  content: \"\\f0722\";\n}\n\n.mdi-tag-plus-outline::before {\n  content: \"\\f1222\";\n}\n\n.mdi-tag-remove::before {\n  content: \"\\f0723\";\n}\n\n.mdi-tag-remove-outline::before {\n  content: \"\\f1223\";\n}\n\n.mdi-tag-search::before {\n  content: \"\\f1907\";\n}\n\n.mdi-tag-search-outline::before {\n  content: \"\\f1908\";\n}\n\n.mdi-tag-text::before {\n  content: \"\\f1224\";\n}\n\n.mdi-tag-text-outline::before {\n  content: \"\\f04fd\";\n}\n\n.mdi-tailwind::before {\n  content: \"\\f13ff\";\n}\n\n.mdi-tangram::before {\n  content: \"\\f04f8\";\n}\n\n.mdi-tank::before {\n  content: \"\\f0d3a\";\n}\n\n.mdi-tanker-truck::before {\n  content: \"\\f0fe5\";\n}\n\n.mdi-tape-drive::before {\n  content: \"\\f16df\";\n}\n\n.mdi-tape-measure::before {\n  content: \"\\f0b4d\";\n}\n\n.mdi-target::before {\n  content: \"\\f04fe\";\n}\n\n.mdi-target-account::before {\n  content: \"\\f0bd0\";\n}\n\n.mdi-target-variant::before {\n  content: \"\\f0a77\";\n}\n\n.mdi-taxi::before {\n  content: \"\\f04ff\";\n}\n\n.mdi-tea::before {\n  content: \"\\f0d9e\";\n}\n\n.mdi-tea-outline::before {\n  content: \"\\f0d9f\";\n}\n\n.mdi-teamviewer::before {\n  content: \"\\f0500\";\n}\n\n.mdi-teddy-bear::before {\n  content: \"\\f18fb\";\n}\n\n.mdi-telescope::before {\n  content: \"\\f0b4e\";\n}\n\n.mdi-television::before {\n  content: \"\\f0502\";\n}\n\n.mdi-television-ambient-light::before {\n  content: \"\\f1356\";\n}\n\n.mdi-television-box::before {\n  content: \"\\f0839\";\n}\n\n.mdi-television-classic::before {\n  content: \"\\f07f4\";\n}\n\n.mdi-television-classic-off::before {\n  content: \"\\f083a\";\n}\n\n.mdi-television-guide::before {\n  content: \"\\f0503\";\n}\n\n.mdi-television-off::before {\n  content: \"\\f083b\";\n}\n\n.mdi-television-pause::before {\n  content: \"\\f0f89\";\n}\n\n.mdi-television-play::before {\n  content: \"\\f0ecf\";\n}\n\n.mdi-television-shimmer::before {\n  content: \"\\f1110\";\n}\n\n.mdi-television-stop::before {\n  content: \"\\f0f8a\";\n}\n\n.mdi-temperature-celsius::before {\n  content: \"\\f0504\";\n}\n\n.mdi-temperature-fahrenheit::before {\n  content: \"\\f0505\";\n}\n\n.mdi-temperature-kelvin::before {\n  content: \"\\f0506\";\n}\n\n.mdi-tennis::before {\n  content: \"\\f0da0\";\n}\n\n.mdi-tennis-ball::before {\n  content: \"\\f0507\";\n}\n\n.mdi-tent::before {\n  content: \"\\f0508\";\n}\n\n.mdi-terraform::before {\n  content: \"\\f1062\";\n}\n\n.mdi-terrain::before {\n  content: \"\\f0509\";\n}\n\n.mdi-test-tube::before {\n  content: \"\\f0668\";\n}\n\n.mdi-test-tube-empty::before {\n  content: \"\\f0911\";\n}\n\n.mdi-test-tube-off::before {\n  content: \"\\f0912\";\n}\n\n.mdi-text::before {\n  content: \"\\f09a8\";\n}\n\n.mdi-text-account::before {\n  content: \"\\f1570\";\n}\n\n.mdi-text-box::before {\n  content: \"\\f021a\";\n}\n\n.mdi-text-box-check::before {\n  content: \"\\f0ea6\";\n}\n\n.mdi-text-box-check-outline::before {\n  content: \"\\f0ea7\";\n}\n\n.mdi-text-box-minus::before {\n  content: \"\\f0ea8\";\n}\n\n.mdi-text-box-minus-outline::before {\n  content: \"\\f0ea9\";\n}\n\n.mdi-text-box-multiple::before {\n  content: \"\\f0ab7\";\n}\n\n.mdi-text-box-multiple-outline::before {\n  content: \"\\f0ab8\";\n}\n\n.mdi-text-box-outline::before {\n  content: \"\\f09ed\";\n}\n\n.mdi-text-box-plus::before {\n  content: \"\\f0eaa\";\n}\n\n.mdi-text-box-plus-outline::before {\n  content: \"\\f0eab\";\n}\n\n.mdi-text-box-remove::before {\n  content: \"\\f0eac\";\n}\n\n.mdi-text-box-remove-outline::before {\n  content: \"\\f0ead\";\n}\n\n.mdi-text-box-search::before {\n  content: \"\\f0eae\";\n}\n\n.mdi-text-box-search-outline::before {\n  content: \"\\f0eaf\";\n}\n\n.mdi-text-long::before {\n  content: \"\\f09aa\";\n}\n\n.mdi-text-recognition::before {\n  content: \"\\f113d\";\n}\n\n.mdi-text-search::before {\n  content: \"\\f13b8\";\n}\n\n.mdi-text-shadow::before {\n  content: \"\\f0669\";\n}\n\n.mdi-text-short::before {\n  content: \"\\f09a9\";\n}\n\n.mdi-text-to-speech::before {\n  content: \"\\f050a\";\n}\n\n.mdi-text-to-speech-off::before {\n  content: \"\\f050b\";\n}\n\n.mdi-texture::before {\n  content: \"\\f050c\";\n}\n\n.mdi-texture-box::before {\n  content: \"\\f0fe6\";\n}\n\n.mdi-theater::before {\n  content: \"\\f050d\";\n}\n\n.mdi-theme-light-dark::before {\n  content: \"\\f050e\";\n}\n\n.mdi-thermometer::before {\n  content: \"\\f050f\";\n}\n\n.mdi-thermometer-alert::before {\n  content: \"\\f0e01\";\n}\n\n.mdi-thermometer-bluetooth::before {\n  content: \"\\f1895\";\n}\n\n.mdi-thermometer-chevron-down::before {\n  content: \"\\f0e02\";\n}\n\n.mdi-thermometer-chevron-up::before {\n  content: \"\\f0e03\";\n}\n\n.mdi-thermometer-high::before {\n  content: \"\\f10c2\";\n}\n\n.mdi-thermometer-lines::before {\n  content: \"\\f0510\";\n}\n\n.mdi-thermometer-low::before {\n  content: \"\\f10c3\";\n}\n\n.mdi-thermometer-minus::before {\n  content: \"\\f0e04\";\n}\n\n.mdi-thermometer-off::before {\n  content: \"\\f1531\";\n}\n\n.mdi-thermometer-plus::before {\n  content: \"\\f0e05\";\n}\n\n.mdi-thermostat::before {\n  content: \"\\f0393\";\n}\n\n.mdi-thermostat-box::before {\n  content: \"\\f0891\";\n}\n\n.mdi-thought-bubble::before {\n  content: \"\\f07f6\";\n}\n\n.mdi-thought-bubble-outline::before {\n  content: \"\\f07f7\";\n}\n\n.mdi-thumb-down::before {\n  content: \"\\f0511\";\n}\n\n.mdi-thumb-down-outline::before {\n  content: \"\\f0512\";\n}\n\n.mdi-thumb-up::before {\n  content: \"\\f0513\";\n}\n\n.mdi-thumb-up-outline::before {\n  content: \"\\f0514\";\n}\n\n.mdi-thumbs-up-down::before {\n  content: \"\\f0515\";\n}\n\n.mdi-thumbs-up-down-outline::before {\n  content: \"\\f1914\";\n}\n\n.mdi-ticket::before {\n  content: \"\\f0516\";\n}\n\n.mdi-ticket-account::before {\n  content: \"\\f0517\";\n}\n\n.mdi-ticket-confirmation::before {\n  content: \"\\f0518\";\n}\n\n.mdi-ticket-confirmation-outline::before {\n  content: \"\\f13aa\";\n}\n\n.mdi-ticket-outline::before {\n  content: \"\\f0913\";\n}\n\n.mdi-ticket-percent::before {\n  content: \"\\f0724\";\n}\n\n.mdi-ticket-percent-outline::before {\n  content: \"\\f142b\";\n}\n\n.mdi-tie::before {\n  content: \"\\f0519\";\n}\n\n.mdi-tilde::before {\n  content: \"\\f0725\";\n}\n\n.mdi-tilde-off::before {\n  content: \"\\f18f3\";\n}\n\n.mdi-timelapse::before {\n  content: \"\\f051a\";\n}\n\n.mdi-timeline::before {\n  content: \"\\f0bd1\";\n}\n\n.mdi-timeline-alert::before {\n  content: \"\\f0f95\";\n}\n\n.mdi-timeline-alert-outline::before {\n  content: \"\\f0f98\";\n}\n\n.mdi-timeline-check::before {\n  content: \"\\f1532\";\n}\n\n.mdi-timeline-check-outline::before {\n  content: \"\\f1533\";\n}\n\n.mdi-timeline-clock::before {\n  content: \"\\f11fb\";\n}\n\n.mdi-timeline-clock-outline::before {\n  content: \"\\f11fc\";\n}\n\n.mdi-timeline-help::before {\n  content: \"\\f0f99\";\n}\n\n.mdi-timeline-help-outline::before {\n  content: \"\\f0f9a\";\n}\n\n.mdi-timeline-minus::before {\n  content: \"\\f1534\";\n}\n\n.mdi-timeline-minus-outline::before {\n  content: \"\\f1535\";\n}\n\n.mdi-timeline-outline::before {\n  content: \"\\f0bd2\";\n}\n\n.mdi-timeline-plus::before {\n  content: \"\\f0f96\";\n}\n\n.mdi-timeline-plus-outline::before {\n  content: \"\\f0f97\";\n}\n\n.mdi-timeline-remove::before {\n  content: \"\\f1536\";\n}\n\n.mdi-timeline-remove-outline::before {\n  content: \"\\f1537\";\n}\n\n.mdi-timeline-text::before {\n  content: \"\\f0bd3\";\n}\n\n.mdi-timeline-text-outline::before {\n  content: \"\\f0bd4\";\n}\n\n.mdi-timer::before {\n  content: \"\\f13ab\";\n}\n\n.mdi-timer-10::before {\n  content: \"\\f051c\";\n}\n\n.mdi-timer-3::before {\n  content: \"\\f051d\";\n}\n\n.mdi-timer-cog::before {\n  content: \"\\f1925\";\n}\n\n.mdi-timer-cog-outline::before {\n  content: \"\\f1926\";\n}\n\n.mdi-timer-off::before {\n  content: \"\\f13ac\";\n}\n\n.mdi-timer-off-outline::before {\n  content: \"\\f051e\";\n}\n\n.mdi-timer-outline::before {\n  content: \"\\f051b\";\n}\n\n.mdi-timer-sand::before {\n  content: \"\\f051f\";\n}\n\n.mdi-timer-sand-complete::before {\n  content: \"\\f199f\";\n}\n\n.mdi-timer-sand-empty::before {\n  content: \"\\f06ad\";\n}\n\n.mdi-timer-sand-full::before {\n  content: \"\\f078c\";\n}\n\n.mdi-timer-sand-paused::before {\n  content: \"\\f19a0\";\n}\n\n.mdi-timer-settings::before {\n  content: \"\\f1923\";\n}\n\n.mdi-timer-settings-outline::before {\n  content: \"\\f1924\";\n}\n\n.mdi-timetable::before {\n  content: \"\\f0520\";\n}\n\n.mdi-tire::before {\n  content: \"\\f1896\";\n}\n\n.mdi-toaster::before {\n  content: \"\\f1063\";\n}\n\n.mdi-toaster-off::before {\n  content: \"\\f11b7\";\n}\n\n.mdi-toaster-oven::before {\n  content: \"\\f0cd3\";\n}\n\n.mdi-toggle-switch::before {\n  content: \"\\f0521\";\n}\n\n.mdi-toggle-switch-off::before {\n  content: \"\\f0522\";\n}\n\n.mdi-toggle-switch-off-outline::before {\n  content: \"\\f0a19\";\n}\n\n.mdi-toggle-switch-outline::before {\n  content: \"\\f0a1a\";\n}\n\n.mdi-toilet::before {\n  content: \"\\f09ab\";\n}\n\n.mdi-toolbox::before {\n  content: \"\\f09ac\";\n}\n\n.mdi-toolbox-outline::before {\n  content: \"\\f09ad\";\n}\n\n.mdi-tools::before {\n  content: \"\\f1064\";\n}\n\n.mdi-tooltip::before {\n  content: \"\\f0523\";\n}\n\n.mdi-tooltip-account::before {\n  content: \"\\f000c\";\n}\n\n.mdi-tooltip-cellphone::before {\n  content: \"\\f183b\";\n}\n\n.mdi-tooltip-check::before {\n  content: \"\\f155c\";\n}\n\n.mdi-tooltip-check-outline::before {\n  content: \"\\f155d\";\n}\n\n.mdi-tooltip-edit::before {\n  content: \"\\f0524\";\n}\n\n.mdi-tooltip-edit-outline::before {\n  content: \"\\f12c5\";\n}\n\n.mdi-tooltip-image::before {\n  content: \"\\f0525\";\n}\n\n.mdi-tooltip-image-outline::before {\n  content: \"\\f0bd5\";\n}\n\n.mdi-tooltip-minus::before {\n  content: \"\\f155e\";\n}\n\n.mdi-tooltip-minus-outline::before {\n  content: \"\\f155f\";\n}\n\n.mdi-tooltip-outline::before {\n  content: \"\\f0526\";\n}\n\n.mdi-tooltip-plus::before {\n  content: \"\\f0bd6\";\n}\n\n.mdi-tooltip-plus-outline::before {\n  content: \"\\f0527\";\n}\n\n.mdi-tooltip-remove::before {\n  content: \"\\f1560\";\n}\n\n.mdi-tooltip-remove-outline::before {\n  content: \"\\f1561\";\n}\n\n.mdi-tooltip-text::before {\n  content: \"\\f0528\";\n}\n\n.mdi-tooltip-text-outline::before {\n  content: \"\\f0bd7\";\n}\n\n.mdi-tooth::before {\n  content: \"\\f08c3\";\n}\n\n.mdi-tooth-outline::before {\n  content: \"\\f0529\";\n}\n\n.mdi-toothbrush::before {\n  content: \"\\f1129\";\n}\n\n.mdi-toothbrush-electric::before {\n  content: \"\\f112c\";\n}\n\n.mdi-toothbrush-paste::before {\n  content: \"\\f112a\";\n}\n\n.mdi-torch::before {\n  content: \"\\f1606\";\n}\n\n.mdi-tortoise::before {\n  content: \"\\f0d3b\";\n}\n\n.mdi-toslink::before {\n  content: \"\\f12b8\";\n}\n\n.mdi-tournament::before {\n  content: \"\\f09ae\";\n}\n\n.mdi-tow-truck::before {\n  content: \"\\f083c\";\n}\n\n.mdi-tower-beach::before {\n  content: \"\\f0681\";\n}\n\n.mdi-tower-fire::before {\n  content: \"\\f0682\";\n}\n\n.mdi-town-hall::before {\n  content: \"\\f1875\";\n}\n\n.mdi-toy-brick::before {\n  content: \"\\f1288\";\n}\n\n.mdi-toy-brick-marker::before {\n  content: \"\\f1289\";\n}\n\n.mdi-toy-brick-marker-outline::before {\n  content: \"\\f128a\";\n}\n\n.mdi-toy-brick-minus::before {\n  content: \"\\f128b\";\n}\n\n.mdi-toy-brick-minus-outline::before {\n  content: \"\\f128c\";\n}\n\n.mdi-toy-brick-outline::before {\n  content: \"\\f128d\";\n}\n\n.mdi-toy-brick-plus::before {\n  content: \"\\f128e\";\n}\n\n.mdi-toy-brick-plus-outline::before {\n  content: \"\\f128f\";\n}\n\n.mdi-toy-brick-remove::before {\n  content: \"\\f1290\";\n}\n\n.mdi-toy-brick-remove-outline::before {\n  content: \"\\f1291\";\n}\n\n.mdi-toy-brick-search::before {\n  content: \"\\f1292\";\n}\n\n.mdi-toy-brick-search-outline::before {\n  content: \"\\f1293\";\n}\n\n.mdi-track-light::before {\n  content: \"\\f0914\";\n}\n\n.mdi-trackpad::before {\n  content: \"\\f07f8\";\n}\n\n.mdi-trackpad-lock::before {\n  content: \"\\f0933\";\n}\n\n.mdi-tractor::before {\n  content: \"\\f0892\";\n}\n\n.mdi-tractor-variant::before {\n  content: \"\\f14c4\";\n}\n\n.mdi-trademark::before {\n  content: \"\\f0a78\";\n}\n\n.mdi-traffic-cone::before {\n  content: \"\\f137c\";\n}\n\n.mdi-traffic-light::before {\n  content: \"\\f052b\";\n}\n\n.mdi-traffic-light-outline::before {\n  content: \"\\f182a\";\n}\n\n.mdi-train::before {\n  content: \"\\f052c\";\n}\n\n.mdi-train-car::before {\n  content: \"\\f0bd8\";\n}\n\n.mdi-train-car-passenger::before {\n  content: \"\\f1733\";\n}\n\n.mdi-train-car-passenger-door::before {\n  content: \"\\f1734\";\n}\n\n.mdi-train-car-passenger-door-open::before {\n  content: \"\\f1735\";\n}\n\n.mdi-train-car-passenger-variant::before {\n  content: \"\\f1736\";\n}\n\n.mdi-train-variant::before {\n  content: \"\\f08c4\";\n}\n\n.mdi-tram::before {\n  content: \"\\f052d\";\n}\n\n.mdi-tram-side::before {\n  content: \"\\f0fe7\";\n}\n\n.mdi-transcribe::before {\n  content: \"\\f052e\";\n}\n\n.mdi-transcribe-close::before {\n  content: \"\\f052f\";\n}\n\n.mdi-transfer::before {\n  content: \"\\f1065\";\n}\n\n.mdi-transfer-down::before {\n  content: \"\\f0da1\";\n}\n\n.mdi-transfer-left::before {\n  content: \"\\f0da2\";\n}\n\n.mdi-transfer-right::before {\n  content: \"\\f0530\";\n}\n\n.mdi-transfer-up::before {\n  content: \"\\f0da3\";\n}\n\n.mdi-transit-connection::before {\n  content: \"\\f0d3c\";\n}\n\n.mdi-transit-connection-horizontal::before {\n  content: \"\\f1546\";\n}\n\n.mdi-transit-connection-variant::before {\n  content: \"\\f0d3d\";\n}\n\n.mdi-transit-detour::before {\n  content: \"\\f0f8b\";\n}\n\n.mdi-transit-skip::before {\n  content: \"\\f1515\";\n}\n\n.mdi-transit-transfer::before {\n  content: \"\\f06ae\";\n}\n\n.mdi-transition::before {\n  content: \"\\f0915\";\n}\n\n.mdi-transition-masked::before {\n  content: \"\\f0916\";\n}\n\n.mdi-translate::before {\n  content: \"\\f05ca\";\n}\n\n.mdi-translate-off::before {\n  content: \"\\f0e06\";\n}\n\n.mdi-transmission-tower::before {\n  content: \"\\f0d3e\";\n}\n\n.mdi-transmission-tower-export::before {\n  content: \"\\f192c\";\n}\n\n.mdi-transmission-tower-import::before {\n  content: \"\\f192d\";\n}\n\n.mdi-trash-can::before {\n  content: \"\\f0a79\";\n}\n\n.mdi-trash-can-outline::before {\n  content: \"\\f0a7a\";\n}\n\n.mdi-tray::before {\n  content: \"\\f1294\";\n}\n\n.mdi-tray-alert::before {\n  content: \"\\f1295\";\n}\n\n.mdi-tray-arrow-down::before {\n  content: \"\\f0120\";\n}\n\n.mdi-tray-arrow-up::before {\n  content: \"\\f011d\";\n}\n\n.mdi-tray-full::before {\n  content: \"\\f1296\";\n}\n\n.mdi-tray-minus::before {\n  content: \"\\f1297\";\n}\n\n.mdi-tray-plus::before {\n  content: \"\\f1298\";\n}\n\n.mdi-tray-remove::before {\n  content: \"\\f1299\";\n}\n\n.mdi-treasure-chest::before {\n  content: \"\\f0726\";\n}\n\n.mdi-tree::before {\n  content: \"\\f0531\";\n}\n\n.mdi-tree-outline::before {\n  content: \"\\f0e69\";\n}\n\n.mdi-trello::before {\n  content: \"\\f0532\";\n}\n\n.mdi-trending-down::before {\n  content: \"\\f0533\";\n}\n\n.mdi-trending-neutral::before {\n  content: \"\\f0534\";\n}\n\n.mdi-trending-up::before {\n  content: \"\\f0535\";\n}\n\n.mdi-triangle::before {\n  content: \"\\f0536\";\n}\n\n.mdi-triangle-outline::before {\n  content: \"\\f0537\";\n}\n\n.mdi-triangle-wave::before {\n  content: \"\\f147c\";\n}\n\n.mdi-triforce::before {\n  content: \"\\f0bd9\";\n}\n\n.mdi-trophy::before {\n  content: \"\\f0538\";\n}\n\n.mdi-trophy-award::before {\n  content: \"\\f0539\";\n}\n\n.mdi-trophy-broken::before {\n  content: \"\\f0da4\";\n}\n\n.mdi-trophy-outline::before {\n  content: \"\\f053a\";\n}\n\n.mdi-trophy-variant::before {\n  content: \"\\f053b\";\n}\n\n.mdi-trophy-variant-outline::before {\n  content: \"\\f053c\";\n}\n\n.mdi-truck::before {\n  content: \"\\f053d\";\n}\n\n.mdi-truck-cargo-container::before {\n  content: \"\\f18d8\";\n}\n\n.mdi-truck-check::before {\n  content: \"\\f0cd4\";\n}\n\n.mdi-truck-check-outline::before {\n  content: \"\\f129a\";\n}\n\n.mdi-truck-delivery::before {\n  content: \"\\f053e\";\n}\n\n.mdi-truck-delivery-outline::before {\n  content: \"\\f129b\";\n}\n\n.mdi-truck-fast::before {\n  content: \"\\f0788\";\n}\n\n.mdi-truck-fast-outline::before {\n  content: \"\\f129c\";\n}\n\n.mdi-truck-flatbed::before {\n  content: \"\\f1891\";\n}\n\n.mdi-truck-minus::before {\n  content: \"\\f19ae\";\n}\n\n.mdi-truck-minus-outline::before {\n  content: \"\\f19bd\";\n}\n\n.mdi-truck-outline::before {\n  content: \"\\f129d\";\n}\n\n.mdi-truck-plus::before {\n  content: \"\\f19ad\";\n}\n\n.mdi-truck-plus-outline::before {\n  content: \"\\f19bc\";\n}\n\n.mdi-truck-remove::before {\n  content: \"\\f19af\";\n}\n\n.mdi-truck-remove-outline::before {\n  content: \"\\f19be\";\n}\n\n.mdi-truck-snowflake::before {\n  content: \"\\f19a6\";\n}\n\n.mdi-truck-trailer::before {\n  content: \"\\f0727\";\n}\n\n.mdi-trumpet::before {\n  content: \"\\f1096\";\n}\n\n.mdi-tshirt-crew::before {\n  content: \"\\f0a7b\";\n}\n\n.mdi-tshirt-crew-outline::before {\n  content: \"\\f053f\";\n}\n\n.mdi-tshirt-v::before {\n  content: \"\\f0a7c\";\n}\n\n.mdi-tshirt-v-outline::before {\n  content: \"\\f0540\";\n}\n\n.mdi-tumble-dryer::before {\n  content: \"\\f0917\";\n}\n\n.mdi-tumble-dryer-alert::before {\n  content: \"\\f11ba\";\n}\n\n.mdi-tumble-dryer-off::before {\n  content: \"\\f11bb\";\n}\n\n.mdi-tune::before {\n  content: \"\\f062e\";\n}\n\n.mdi-tune-variant::before {\n  content: \"\\f1542\";\n}\n\n.mdi-tune-vertical::before {\n  content: \"\\f066a\";\n}\n\n.mdi-tune-vertical-variant::before {\n  content: \"\\f1543\";\n}\n\n.mdi-tunnel::before {\n  content: \"\\f183d\";\n}\n\n.mdi-tunnel-outline::before {\n  content: \"\\f183e\";\n}\n\n.mdi-turkey::before {\n  content: \"\\f171b\";\n}\n\n.mdi-turnstile::before {\n  content: \"\\f0cd5\";\n}\n\n.mdi-turnstile-outline::before {\n  content: \"\\f0cd6\";\n}\n\n.mdi-turtle::before {\n  content: \"\\f0cd7\";\n}\n\n.mdi-twitch::before {\n  content: \"\\f0543\";\n}\n\n.mdi-twitter::before {\n  content: \"\\f0544\";\n}\n\n.mdi-two-factor-authentication::before {\n  content: \"\\f09af\";\n}\n\n.mdi-typewriter::before {\n  content: \"\\f0f2d\";\n}\n\n.mdi-ubisoft::before {\n  content: \"\\f0bda\";\n}\n\n.mdi-ubuntu::before {\n  content: \"\\f0548\";\n}\n\n.mdi-ufo::before {\n  content: \"\\f10c4\";\n}\n\n.mdi-ufo-outline::before {\n  content: \"\\f10c5\";\n}\n\n.mdi-ultra-high-definition::before {\n  content: \"\\f07f9\";\n}\n\n.mdi-umbraco::before {\n  content: \"\\f0549\";\n}\n\n.mdi-umbrella::before {\n  content: \"\\f054a\";\n}\n\n.mdi-umbrella-beach::before {\n  content: \"\\f188a\";\n}\n\n.mdi-umbrella-beach-outline::before {\n  content: \"\\f188b\";\n}\n\n.mdi-umbrella-closed::before {\n  content: \"\\f09b0\";\n}\n\n.mdi-umbrella-closed-outline::before {\n  content: \"\\f13e2\";\n}\n\n.mdi-umbrella-closed-variant::before {\n  content: \"\\f13e1\";\n}\n\n.mdi-umbrella-outline::before {\n  content: \"\\f054b\";\n}\n\n.mdi-undo::before {\n  content: \"\\f054c\";\n}\n\n.mdi-undo-variant::before {\n  content: \"\\f054d\";\n}\n\n.mdi-unfold-less-horizontal::before {\n  content: \"\\f054e\";\n}\n\n.mdi-unfold-less-vertical::before {\n  content: \"\\f0760\";\n}\n\n.mdi-unfold-more-horizontal::before {\n  content: \"\\f054f\";\n}\n\n.mdi-unfold-more-vertical::before {\n  content: \"\\f0761\";\n}\n\n.mdi-ungroup::before {\n  content: \"\\f0550\";\n}\n\n.mdi-unicode::before {\n  content: \"\\f0ed0\";\n}\n\n.mdi-unicorn::before {\n  content: \"\\f15c2\";\n}\n\n.mdi-unicorn-variant::before {\n  content: \"\\f15c3\";\n}\n\n.mdi-unicycle::before {\n  content: \"\\f15e5\";\n}\n\n.mdi-unity::before {\n  content: \"\\f06af\";\n}\n\n.mdi-unreal::before {\n  content: \"\\f09b1\";\n}\n\n.mdi-update::before {\n  content: \"\\f06b0\";\n}\n\n.mdi-upload::before {\n  content: \"\\f0552\";\n}\n\n.mdi-upload-lock::before {\n  content: \"\\f1373\";\n}\n\n.mdi-upload-lock-outline::before {\n  content: \"\\f1374\";\n}\n\n.mdi-upload-multiple::before {\n  content: \"\\f083d\";\n}\n\n.mdi-upload-network::before {\n  content: \"\\f06f6\";\n}\n\n.mdi-upload-network-outline::before {\n  content: \"\\f0cd8\";\n}\n\n.mdi-upload-off::before {\n  content: \"\\f10c6\";\n}\n\n.mdi-upload-off-outline::before {\n  content: \"\\f10c7\";\n}\n\n.mdi-upload-outline::before {\n  content: \"\\f0e07\";\n}\n\n.mdi-usb::before {\n  content: \"\\f0553\";\n}\n\n.mdi-usb-flash-drive::before {\n  content: \"\\f129e\";\n}\n\n.mdi-usb-flash-drive-outline::before {\n  content: \"\\f129f\";\n}\n\n.mdi-usb-port::before {\n  content: \"\\f11f0\";\n}\n\n.mdi-vacuum::before {\n  content: \"\\f19a1\";\n}\n\n.mdi-vacuum-outline::before {\n  content: \"\\f19a2\";\n}\n\n.mdi-valve::before {\n  content: \"\\f1066\";\n}\n\n.mdi-valve-closed::before {\n  content: \"\\f1067\";\n}\n\n.mdi-valve-open::before {\n  content: \"\\f1068\";\n}\n\n.mdi-van-passenger::before {\n  content: \"\\f07fa\";\n}\n\n.mdi-van-utility::before {\n  content: \"\\f07fb\";\n}\n\n.mdi-vanish::before {\n  content: \"\\f07fc\";\n}\n\n.mdi-vanish-quarter::before {\n  content: \"\\f1554\";\n}\n\n.mdi-vanity-light::before {\n  content: \"\\f11e1\";\n}\n\n.mdi-variable::before {\n  content: \"\\f0ae7\";\n}\n\n.mdi-variable-box::before {\n  content: \"\\f1111\";\n}\n\n.mdi-vector-arrange-above::before {\n  content: \"\\f0554\";\n}\n\n.mdi-vector-arrange-below::before {\n  content: \"\\f0555\";\n}\n\n.mdi-vector-bezier::before {\n  content: \"\\f0ae8\";\n}\n\n.mdi-vector-circle::before {\n  content: \"\\f0556\";\n}\n\n.mdi-vector-circle-variant::before {\n  content: \"\\f0557\";\n}\n\n.mdi-vector-combine::before {\n  content: \"\\f0558\";\n}\n\n.mdi-vector-curve::before {\n  content: \"\\f0559\";\n}\n\n.mdi-vector-difference::before {\n  content: \"\\f055a\";\n}\n\n.mdi-vector-difference-ab::before {\n  content: \"\\f055b\";\n}\n\n.mdi-vector-difference-ba::before {\n  content: \"\\f055c\";\n}\n\n.mdi-vector-ellipse::before {\n  content: \"\\f0893\";\n}\n\n.mdi-vector-intersection::before {\n  content: \"\\f055d\";\n}\n\n.mdi-vector-line::before {\n  content: \"\\f055e\";\n}\n\n.mdi-vector-link::before {\n  content: \"\\f0fe8\";\n}\n\n.mdi-vector-point::before {\n  content: \"\\f055f\";\n}\n\n.mdi-vector-polygon::before {\n  content: \"\\f0560\";\n}\n\n.mdi-vector-polygon-variant::before {\n  content: \"\\f1856\";\n}\n\n.mdi-vector-polyline::before {\n  content: \"\\f0561\";\n}\n\n.mdi-vector-polyline-edit::before {\n  content: \"\\f1225\";\n}\n\n.mdi-vector-polyline-minus::before {\n  content: \"\\f1226\";\n}\n\n.mdi-vector-polyline-plus::before {\n  content: \"\\f1227\";\n}\n\n.mdi-vector-polyline-remove::before {\n  content: \"\\f1228\";\n}\n\n.mdi-vector-radius::before {\n  content: \"\\f074a\";\n}\n\n.mdi-vector-rectangle::before {\n  content: \"\\f05c6\";\n}\n\n.mdi-vector-selection::before {\n  content: \"\\f0562\";\n}\n\n.mdi-vector-square::before {\n  content: \"\\f0001\";\n}\n\n.mdi-vector-square-close::before {\n  content: \"\\f1857\";\n}\n\n.mdi-vector-square-edit::before {\n  content: \"\\f18d9\";\n}\n\n.mdi-vector-square-minus::before {\n  content: \"\\f18da\";\n}\n\n.mdi-vector-square-open::before {\n  content: \"\\f1858\";\n}\n\n.mdi-vector-square-plus::before {\n  content: \"\\f18db\";\n}\n\n.mdi-vector-square-remove::before {\n  content: \"\\f18dc\";\n}\n\n.mdi-vector-triangle::before {\n  content: \"\\f0563\";\n}\n\n.mdi-vector-union::before {\n  content: \"\\f0564\";\n}\n\n.mdi-vhs::before {\n  content: \"\\f0a1b\";\n}\n\n.mdi-vibrate::before {\n  content: \"\\f0566\";\n}\n\n.mdi-vibrate-off::before {\n  content: \"\\f0cd9\";\n}\n\n.mdi-video::before {\n  content: \"\\f0567\";\n}\n\n.mdi-video-3d::before {\n  content: \"\\f07fd\";\n}\n\n.mdi-video-3d-off::before {\n  content: \"\\f13d9\";\n}\n\n.mdi-video-3d-variant::before {\n  content: \"\\f0ed1\";\n}\n\n.mdi-video-4k-box::before {\n  content: \"\\f083e\";\n}\n\n.mdi-video-account::before {\n  content: \"\\f0919\";\n}\n\n.mdi-video-box::before {\n  content: \"\\f00fd\";\n}\n\n.mdi-video-box-off::before {\n  content: \"\\f00fe\";\n}\n\n.mdi-video-check::before {\n  content: \"\\f1069\";\n}\n\n.mdi-video-check-outline::before {\n  content: \"\\f106a\";\n}\n\n.mdi-video-high-definition::before {\n  content: \"\\f152e\";\n}\n\n.mdi-video-image::before {\n  content: \"\\f091a\";\n}\n\n.mdi-video-input-antenna::before {\n  content: \"\\f083f\";\n}\n\n.mdi-video-input-component::before {\n  content: \"\\f0840\";\n}\n\n.mdi-video-input-hdmi::before {\n  content: \"\\f0841\";\n}\n\n.mdi-video-input-scart::before {\n  content: \"\\f0f8c\";\n}\n\n.mdi-video-input-svideo::before {\n  content: \"\\f0842\";\n}\n\n.mdi-video-marker::before {\n  content: \"\\f19a9\";\n}\n\n.mdi-video-marker-outline::before {\n  content: \"\\f19aa\";\n}\n\n.mdi-video-minus::before {\n  content: \"\\f09b2\";\n}\n\n.mdi-video-minus-outline::before {\n  content: \"\\f02ba\";\n}\n\n.mdi-video-off::before {\n  content: \"\\f0568\";\n}\n\n.mdi-video-off-outline::before {\n  content: \"\\f0bdb\";\n}\n\n.mdi-video-outline::before {\n  content: \"\\f0bdc\";\n}\n\n.mdi-video-plus::before {\n  content: \"\\f09b3\";\n}\n\n.mdi-video-plus-outline::before {\n  content: \"\\f01d3\";\n}\n\n.mdi-video-stabilization::before {\n  content: \"\\f091b\";\n}\n\n.mdi-video-switch::before {\n  content: \"\\f0569\";\n}\n\n.mdi-video-switch-outline::before {\n  content: \"\\f0790\";\n}\n\n.mdi-video-vintage::before {\n  content: \"\\f0a1c\";\n}\n\n.mdi-video-wireless::before {\n  content: \"\\f0ed2\";\n}\n\n.mdi-video-wireless-outline::before {\n  content: \"\\f0ed3\";\n}\n\n.mdi-view-agenda::before {\n  content: \"\\f056a\";\n}\n\n.mdi-view-agenda-outline::before {\n  content: \"\\f11d8\";\n}\n\n.mdi-view-array::before {\n  content: \"\\f056b\";\n}\n\n.mdi-view-array-outline::before {\n  content: \"\\f1485\";\n}\n\n.mdi-view-carousel::before {\n  content: \"\\f056c\";\n}\n\n.mdi-view-carousel-outline::before {\n  content: \"\\f1486\";\n}\n\n.mdi-view-column::before {\n  content: \"\\f056d\";\n}\n\n.mdi-view-column-outline::before {\n  content: \"\\f1487\";\n}\n\n.mdi-view-comfy::before {\n  content: \"\\f0e6a\";\n}\n\n.mdi-view-comfy-outline::before {\n  content: \"\\f1488\";\n}\n\n.mdi-view-compact::before {\n  content: \"\\f0e6b\";\n}\n\n.mdi-view-compact-outline::before {\n  content: \"\\f0e6c\";\n}\n\n.mdi-view-dashboard::before {\n  content: \"\\f056e\";\n}\n\n.mdi-view-dashboard-edit::before {\n  content: \"\\f1947\";\n}\n\n.mdi-view-dashboard-edit-outline::before {\n  content: \"\\f1948\";\n}\n\n.mdi-view-dashboard-outline::before {\n  content: \"\\f0a1d\";\n}\n\n.mdi-view-dashboard-variant::before {\n  content: \"\\f0843\";\n}\n\n.mdi-view-dashboard-variant-outline::before {\n  content: \"\\f1489\";\n}\n\n.mdi-view-day::before {\n  content: \"\\f056f\";\n}\n\n.mdi-view-day-outline::before {\n  content: \"\\f148a\";\n}\n\n.mdi-view-gallery::before {\n  content: \"\\f1888\";\n}\n\n.mdi-view-gallery-outline::before {\n  content: \"\\f1889\";\n}\n\n.mdi-view-grid::before {\n  content: \"\\f0570\";\n}\n\n.mdi-view-grid-outline::before {\n  content: \"\\f11d9\";\n}\n\n.mdi-view-grid-plus::before {\n  content: \"\\f0f8d\";\n}\n\n.mdi-view-grid-plus-outline::before {\n  content: \"\\f11da\";\n}\n\n.mdi-view-headline::before {\n  content: \"\\f0571\";\n}\n\n.mdi-view-list::before {\n  content: \"\\f0572\";\n}\n\n.mdi-view-list-outline::before {\n  content: \"\\f148b\";\n}\n\n.mdi-view-module::before {\n  content: \"\\f0573\";\n}\n\n.mdi-view-module-outline::before {\n  content: \"\\f148c\";\n}\n\n.mdi-view-parallel::before {\n  content: \"\\f0728\";\n}\n\n.mdi-view-parallel-outline::before {\n  content: \"\\f148d\";\n}\n\n.mdi-view-quilt::before {\n  content: \"\\f0574\";\n}\n\n.mdi-view-quilt-outline::before {\n  content: \"\\f148e\";\n}\n\n.mdi-view-sequential::before {\n  content: \"\\f0729\";\n}\n\n.mdi-view-sequential-outline::before {\n  content: \"\\f148f\";\n}\n\n.mdi-view-split-horizontal::before {\n  content: \"\\f0bcb\";\n}\n\n.mdi-view-split-vertical::before {\n  content: \"\\f0bcc\";\n}\n\n.mdi-view-stream::before {\n  content: \"\\f0575\";\n}\n\n.mdi-view-stream-outline::before {\n  content: \"\\f1490\";\n}\n\n.mdi-view-week::before {\n  content: \"\\f0576\";\n}\n\n.mdi-view-week-outline::before {\n  content: \"\\f1491\";\n}\n\n.mdi-vimeo::before {\n  content: \"\\f0577\";\n}\n\n.mdi-violin::before {\n  content: \"\\f060f\";\n}\n\n.mdi-virtual-reality::before {\n  content: \"\\f0894\";\n}\n\n.mdi-virus::before {\n  content: \"\\f13b6\";\n}\n\n.mdi-virus-off::before {\n  content: \"\\f18e1\";\n}\n\n.mdi-virus-off-outline::before {\n  content: \"\\f18e2\";\n}\n\n.mdi-virus-outline::before {\n  content: \"\\f13b7\";\n}\n\n.mdi-vlc::before {\n  content: \"\\f057c\";\n}\n\n.mdi-voicemail::before {\n  content: \"\\f057d\";\n}\n\n.mdi-volleyball::before {\n  content: \"\\f09b4\";\n}\n\n.mdi-volume-high::before {\n  content: \"\\f057e\";\n}\n\n.mdi-volume-low::before {\n  content: \"\\f057f\";\n}\n\n.mdi-volume-medium::before {\n  content: \"\\f0580\";\n}\n\n.mdi-volume-minus::before {\n  content: \"\\f075e\";\n}\n\n.mdi-volume-mute::before {\n  content: \"\\f075f\";\n}\n\n.mdi-volume-off::before {\n  content: \"\\f0581\";\n}\n\n.mdi-volume-plus::before {\n  content: \"\\f075d\";\n}\n\n.mdi-volume-source::before {\n  content: \"\\f1120\";\n}\n\n.mdi-volume-variant-off::before {\n  content: \"\\f0e08\";\n}\n\n.mdi-volume-vibrate::before {\n  content: \"\\f1121\";\n}\n\n.mdi-vote::before {\n  content: \"\\f0a1f\";\n}\n\n.mdi-vote-outline::before {\n  content: \"\\f0a20\";\n}\n\n.mdi-vpn::before {\n  content: \"\\f0582\";\n}\n\n.mdi-vuejs::before {\n  content: \"\\f0844\";\n}\n\n.mdi-vuetify::before {\n  content: \"\\f0e6d\";\n}\n\n.mdi-walk::before {\n  content: \"\\f0583\";\n}\n\n.mdi-wall::before {\n  content: \"\\f07fe\";\n}\n\n.mdi-wall-sconce::before {\n  content: \"\\f091c\";\n}\n\n.mdi-wall-sconce-flat::before {\n  content: \"\\f091d\";\n}\n\n.mdi-wall-sconce-flat-outline::before {\n  content: \"\\f17c9\";\n}\n\n.mdi-wall-sconce-flat-variant::before {\n  content: \"\\f041c\";\n}\n\n.mdi-wall-sconce-flat-variant-outline::before {\n  content: \"\\f17ca\";\n}\n\n.mdi-wall-sconce-outline::before {\n  content: \"\\f17cb\";\n}\n\n.mdi-wall-sconce-round::before {\n  content: \"\\f0748\";\n}\n\n.mdi-wall-sconce-round-outline::before {\n  content: \"\\f17cc\";\n}\n\n.mdi-wall-sconce-round-variant::before {\n  content: \"\\f091e\";\n}\n\n.mdi-wall-sconce-round-variant-outline::before {\n  content: \"\\f17cd\";\n}\n\n.mdi-wallet::before {\n  content: \"\\f0584\";\n}\n\n.mdi-wallet-giftcard::before {\n  content: \"\\f0585\";\n}\n\n.mdi-wallet-membership::before {\n  content: \"\\f0586\";\n}\n\n.mdi-wallet-outline::before {\n  content: \"\\f0bdd\";\n}\n\n.mdi-wallet-plus::before {\n  content: \"\\f0f8e\";\n}\n\n.mdi-wallet-plus-outline::before {\n  content: \"\\f0f8f\";\n}\n\n.mdi-wallet-travel::before {\n  content: \"\\f0587\";\n}\n\n.mdi-wallpaper::before {\n  content: \"\\f0e09\";\n}\n\n.mdi-wan::before {\n  content: \"\\f0588\";\n}\n\n.mdi-wardrobe::before {\n  content: \"\\f0f90\";\n}\n\n.mdi-wardrobe-outline::before {\n  content: \"\\f0f91\";\n}\n\n.mdi-warehouse::before {\n  content: \"\\f0f81\";\n}\n\n.mdi-washing-machine::before {\n  content: \"\\f072a\";\n}\n\n.mdi-washing-machine-alert::before {\n  content: \"\\f11bc\";\n}\n\n.mdi-washing-machine-off::before {\n  content: \"\\f11bd\";\n}\n\n.mdi-watch::before {\n  content: \"\\f0589\";\n}\n\n.mdi-watch-export::before {\n  content: \"\\f058a\";\n}\n\n.mdi-watch-export-variant::before {\n  content: \"\\f0895\";\n}\n\n.mdi-watch-import::before {\n  content: \"\\f058b\";\n}\n\n.mdi-watch-import-variant::before {\n  content: \"\\f0896\";\n}\n\n.mdi-watch-variant::before {\n  content: \"\\f0897\";\n}\n\n.mdi-watch-vibrate::before {\n  content: \"\\f06b1\";\n}\n\n.mdi-watch-vibrate-off::before {\n  content: \"\\f0cda\";\n}\n\n.mdi-water::before {\n  content: \"\\f058c\";\n}\n\n.mdi-water-alert::before {\n  content: \"\\f1502\";\n}\n\n.mdi-water-alert-outline::before {\n  content: \"\\f1503\";\n}\n\n.mdi-water-boiler::before {\n  content: \"\\f0f92\";\n}\n\n.mdi-water-boiler-alert::before {\n  content: \"\\f11b3\";\n}\n\n.mdi-water-boiler-off::before {\n  content: \"\\f11b4\";\n}\n\n.mdi-water-check::before {\n  content: \"\\f1504\";\n}\n\n.mdi-water-check-outline::before {\n  content: \"\\f1505\";\n}\n\n.mdi-water-circle::before {\n  content: \"\\f1806\";\n}\n\n.mdi-water-minus::before {\n  content: \"\\f1506\";\n}\n\n.mdi-water-minus-outline::before {\n  content: \"\\f1507\";\n}\n\n.mdi-water-off::before {\n  content: \"\\f058d\";\n}\n\n.mdi-water-off-outline::before {\n  content: \"\\f1508\";\n}\n\n.mdi-water-opacity::before {\n  content: \"\\f1855\";\n}\n\n.mdi-water-outline::before {\n  content: \"\\f0e0a\";\n}\n\n.mdi-water-percent::before {\n  content: \"\\f058e\";\n}\n\n.mdi-water-percent-alert::before {\n  content: \"\\f1509\";\n}\n\n.mdi-water-plus::before {\n  content: \"\\f150a\";\n}\n\n.mdi-water-plus-outline::before {\n  content: \"\\f150b\";\n}\n\n.mdi-water-polo::before {\n  content: \"\\f12a0\";\n}\n\n.mdi-water-pump::before {\n  content: \"\\f058f\";\n}\n\n.mdi-water-pump-off::before {\n  content: \"\\f0f93\";\n}\n\n.mdi-water-remove::before {\n  content: \"\\f150c\";\n}\n\n.mdi-water-remove-outline::before {\n  content: \"\\f150d\";\n}\n\n.mdi-water-sync::before {\n  content: \"\\f17c6\";\n}\n\n.mdi-water-well::before {\n  content: \"\\f106b\";\n}\n\n.mdi-water-well-outline::before {\n  content: \"\\f106c\";\n}\n\n.mdi-waterfall::before {\n  content: \"\\f1849\";\n}\n\n.mdi-watering-can::before {\n  content: \"\\f1481\";\n}\n\n.mdi-watering-can-outline::before {\n  content: \"\\f1482\";\n}\n\n.mdi-watermark::before {\n  content: \"\\f0612\";\n}\n\n.mdi-wave::before {\n  content: \"\\f0f2e\";\n}\n\n.mdi-waveform::before {\n  content: \"\\f147d\";\n}\n\n.mdi-waves::before {\n  content: \"\\f078d\";\n}\n\n.mdi-waves-arrow-left::before {\n  content: \"\\f1859\";\n}\n\n.mdi-waves-arrow-right::before {\n  content: \"\\f185a\";\n}\n\n.mdi-waves-arrow-up::before {\n  content: \"\\f185b\";\n}\n\n.mdi-waze::before {\n  content: \"\\f0bde\";\n}\n\n.mdi-weather-cloudy::before {\n  content: \"\\f0590\";\n}\n\n.mdi-weather-cloudy-alert::before {\n  content: \"\\f0f2f\";\n}\n\n.mdi-weather-cloudy-arrow-right::before {\n  content: \"\\f0e6e\";\n}\n\n.mdi-weather-cloudy-clock::before {\n  content: \"\\f18f6\";\n}\n\n.mdi-weather-fog::before {\n  content: \"\\f0591\";\n}\n\n.mdi-weather-hail::before {\n  content: \"\\f0592\";\n}\n\n.mdi-weather-hazy::before {\n  content: \"\\f0f30\";\n}\n\n.mdi-weather-hurricane::before {\n  content: \"\\f0898\";\n}\n\n.mdi-weather-lightning::before {\n  content: \"\\f0593\";\n}\n\n.mdi-weather-lightning-rainy::before {\n  content: \"\\f067e\";\n}\n\n.mdi-weather-night::before {\n  content: \"\\f0594\";\n}\n\n.mdi-weather-night-partly-cloudy::before {\n  content: \"\\f0f31\";\n}\n\n.mdi-weather-partly-cloudy::before {\n  content: \"\\f0595\";\n}\n\n.mdi-weather-partly-lightning::before {\n  content: \"\\f0f32\";\n}\n\n.mdi-weather-partly-rainy::before {\n  content: \"\\f0f33\";\n}\n\n.mdi-weather-partly-snowy::before {\n  content: \"\\f0f34\";\n}\n\n.mdi-weather-partly-snowy-rainy::before {\n  content: \"\\f0f35\";\n}\n\n.mdi-weather-pouring::before {\n  content: \"\\f0596\";\n}\n\n.mdi-weather-rainy::before {\n  content: \"\\f0597\";\n}\n\n.mdi-weather-snowy::before {\n  content: \"\\f0598\";\n}\n\n.mdi-weather-snowy-heavy::before {\n  content: \"\\f0f36\";\n}\n\n.mdi-weather-snowy-rainy::before {\n  content: \"\\f067f\";\n}\n\n.mdi-weather-sunny::before {\n  content: \"\\f0599\";\n}\n\n.mdi-weather-sunny-alert::before {\n  content: \"\\f0f37\";\n}\n\n.mdi-weather-sunny-off::before {\n  content: \"\\f14e4\";\n}\n\n.mdi-weather-sunset::before {\n  content: \"\\f059a\";\n}\n\n.mdi-weather-sunset-down::before {\n  content: \"\\f059b\";\n}\n\n.mdi-weather-sunset-up::before {\n  content: \"\\f059c\";\n}\n\n.mdi-weather-tornado::before {\n  content: \"\\f0f38\";\n}\n\n.mdi-weather-windy::before {\n  content: \"\\f059d\";\n}\n\n.mdi-weather-windy-variant::before {\n  content: \"\\f059e\";\n}\n\n.mdi-web::before {\n  content: \"\\f059f\";\n}\n\n.mdi-web-box::before {\n  content: \"\\f0f94\";\n}\n\n.mdi-web-cancel::before {\n  content: \"\\f1790\";\n}\n\n.mdi-web-check::before {\n  content: \"\\f0789\";\n}\n\n.mdi-web-clock::before {\n  content: \"\\f124a\";\n}\n\n.mdi-web-minus::before {\n  content: \"\\f10a0\";\n}\n\n.mdi-web-off::before {\n  content: \"\\f0a8e\";\n}\n\n.mdi-web-plus::before {\n  content: \"\\f0033\";\n}\n\n.mdi-web-refresh::before {\n  content: \"\\f1791\";\n}\n\n.mdi-web-remove::before {\n  content: \"\\f0551\";\n}\n\n.mdi-web-sync::before {\n  content: \"\\f1792\";\n}\n\n.mdi-webcam::before {\n  content: \"\\f05a0\";\n}\n\n.mdi-webcam-off::before {\n  content: \"\\f1737\";\n}\n\n.mdi-webhook::before {\n  content: \"\\f062f\";\n}\n\n.mdi-webpack::before {\n  content: \"\\f072b\";\n}\n\n.mdi-webrtc::before {\n  content: \"\\f1248\";\n}\n\n.mdi-wechat::before {\n  content: \"\\f0611\";\n}\n\n.mdi-weight::before {\n  content: \"\\f05a1\";\n}\n\n.mdi-weight-gram::before {\n  content: \"\\f0d3f\";\n}\n\n.mdi-weight-kilogram::before {\n  content: \"\\f05a2\";\n}\n\n.mdi-weight-lifter::before {\n  content: \"\\f115d\";\n}\n\n.mdi-weight-pound::before {\n  content: \"\\f09b5\";\n}\n\n.mdi-whatsapp::before {\n  content: \"\\f05a3\";\n}\n\n.mdi-wheel-barrow::before {\n  content: \"\\f14f2\";\n}\n\n.mdi-wheelchair-accessibility::before {\n  content: \"\\f05a4\";\n}\n\n.mdi-whistle::before {\n  content: \"\\f09b6\";\n}\n\n.mdi-whistle-outline::before {\n  content: \"\\f12bc\";\n}\n\n.mdi-white-balance-auto::before {\n  content: \"\\f05a5\";\n}\n\n.mdi-white-balance-incandescent::before {\n  content: \"\\f05a6\";\n}\n\n.mdi-white-balance-iridescent::before {\n  content: \"\\f05a7\";\n}\n\n.mdi-white-balance-sunny::before {\n  content: \"\\f05a8\";\n}\n\n.mdi-widgets::before {\n  content: \"\\f072c\";\n}\n\n.mdi-widgets-outline::before {\n  content: \"\\f1355\";\n}\n\n.mdi-wifi::before {\n  content: \"\\f05a9\";\n}\n\n.mdi-wifi-alert::before {\n  content: \"\\f16b5\";\n}\n\n.mdi-wifi-arrow-down::before {\n  content: \"\\f16b6\";\n}\n\n.mdi-wifi-arrow-left::before {\n  content: \"\\f16b7\";\n}\n\n.mdi-wifi-arrow-left-right::before {\n  content: \"\\f16b8\";\n}\n\n.mdi-wifi-arrow-right::before {\n  content: \"\\f16b9\";\n}\n\n.mdi-wifi-arrow-up::before {\n  content: \"\\f16ba\";\n}\n\n.mdi-wifi-arrow-up-down::before {\n  content: \"\\f16bb\";\n}\n\n.mdi-wifi-cancel::before {\n  content: \"\\f16bc\";\n}\n\n.mdi-wifi-check::before {\n  content: \"\\f16bd\";\n}\n\n.mdi-wifi-cog::before {\n  content: \"\\f16be\";\n}\n\n.mdi-wifi-lock::before {\n  content: \"\\f16bf\";\n}\n\n.mdi-wifi-lock-open::before {\n  content: \"\\f16c0\";\n}\n\n.mdi-wifi-marker::before {\n  content: \"\\f16c1\";\n}\n\n.mdi-wifi-minus::before {\n  content: \"\\f16c2\";\n}\n\n.mdi-wifi-off::before {\n  content: \"\\f05aa\";\n}\n\n.mdi-wifi-plus::before {\n  content: \"\\f16c3\";\n}\n\n.mdi-wifi-refresh::before {\n  content: \"\\f16c4\";\n}\n\n.mdi-wifi-remove::before {\n  content: \"\\f16c5\";\n}\n\n.mdi-wifi-settings::before {\n  content: \"\\f16c6\";\n}\n\n.mdi-wifi-star::before {\n  content: \"\\f0e0b\";\n}\n\n.mdi-wifi-strength-1::before {\n  content: \"\\f091f\";\n}\n\n.mdi-wifi-strength-1-alert::before {\n  content: \"\\f0920\";\n}\n\n.mdi-wifi-strength-1-lock::before {\n  content: \"\\f0921\";\n}\n\n.mdi-wifi-strength-1-lock-open::before {\n  content: \"\\f16cb\";\n}\n\n.mdi-wifi-strength-2::before {\n  content: \"\\f0922\";\n}\n\n.mdi-wifi-strength-2-alert::before {\n  content: \"\\f0923\";\n}\n\n.mdi-wifi-strength-2-lock::before {\n  content: \"\\f0924\";\n}\n\n.mdi-wifi-strength-2-lock-open::before {\n  content: \"\\f16cc\";\n}\n\n.mdi-wifi-strength-3::before {\n  content: \"\\f0925\";\n}\n\n.mdi-wifi-strength-3-alert::before {\n  content: \"\\f0926\";\n}\n\n.mdi-wifi-strength-3-lock::before {\n  content: \"\\f0927\";\n}\n\n.mdi-wifi-strength-3-lock-open::before {\n  content: \"\\f16cd\";\n}\n\n.mdi-wifi-strength-4::before {\n  content: \"\\f0928\";\n}\n\n.mdi-wifi-strength-4-alert::before {\n  content: \"\\f0929\";\n}\n\n.mdi-wifi-strength-4-lock::before {\n  content: \"\\f092a\";\n}\n\n.mdi-wifi-strength-4-lock-open::before {\n  content: \"\\f16ce\";\n}\n\n.mdi-wifi-strength-alert-outline::before {\n  content: \"\\f092b\";\n}\n\n.mdi-wifi-strength-lock-open-outline::before {\n  content: \"\\f16cf\";\n}\n\n.mdi-wifi-strength-lock-outline::before {\n  content: \"\\f092c\";\n}\n\n.mdi-wifi-strength-off::before {\n  content: \"\\f092d\";\n}\n\n.mdi-wifi-strength-off-outline::before {\n  content: \"\\f092e\";\n}\n\n.mdi-wifi-strength-outline::before {\n  content: \"\\f092f\";\n}\n\n.mdi-wifi-sync::before {\n  content: \"\\f16c7\";\n}\n\n.mdi-wikipedia::before {\n  content: \"\\f05ac\";\n}\n\n.mdi-wind-turbine::before {\n  content: \"\\f0da5\";\n}\n\n.mdi-wind-turbine-alert::before {\n  content: \"\\f19ab\";\n}\n\n.mdi-wind-turbine-check::before {\n  content: \"\\f19ac\";\n}\n\n.mdi-window-close::before {\n  content: \"\\f05ad\";\n}\n\n.mdi-window-closed::before {\n  content: \"\\f05ae\";\n}\n\n.mdi-window-closed-variant::before {\n  content: \"\\f11db\";\n}\n\n.mdi-window-maximize::before {\n  content: \"\\f05af\";\n}\n\n.mdi-window-minimize::before {\n  content: \"\\f05b0\";\n}\n\n.mdi-window-open::before {\n  content: \"\\f05b1\";\n}\n\n.mdi-window-open-variant::before {\n  content: \"\\f11dc\";\n}\n\n.mdi-window-restore::before {\n  content: \"\\f05b2\";\n}\n\n.mdi-window-shutter::before {\n  content: \"\\f111c\";\n}\n\n.mdi-window-shutter-alert::before {\n  content: \"\\f111d\";\n}\n\n.mdi-window-shutter-open::before {\n  content: \"\\f111e\";\n}\n\n.mdi-windsock::before {\n  content: \"\\f15fa\";\n}\n\n.mdi-wiper::before {\n  content: \"\\f0ae9\";\n}\n\n.mdi-wiper-wash::before {\n  content: \"\\f0da6\";\n}\n\n.mdi-wiper-wash-alert::before {\n  content: \"\\f18df\";\n}\n\n.mdi-wizard-hat::before {\n  content: \"\\f1477\";\n}\n\n.mdi-wordpress::before {\n  content: \"\\f05b4\";\n}\n\n.mdi-wrap::before {\n  content: \"\\f05b6\";\n}\n\n.mdi-wrap-disabled::before {\n  content: \"\\f0bdf\";\n}\n\n.mdi-wrench::before {\n  content: \"\\f05b7\";\n}\n\n.mdi-wrench-clock::before {\n  content: \"\\f19a3\";\n}\n\n.mdi-wrench-outline::before {\n  content: \"\\f0be0\";\n}\n\n.mdi-xamarin::before {\n  content: \"\\f0845\";\n}\n\n.mdi-xml::before {\n  content: \"\\f05c0\";\n}\n\n.mdi-xmpp::before {\n  content: \"\\f07ff\";\n}\n\n.mdi-yahoo::before {\n  content: \"\\f0b4f\";\n}\n\n.mdi-yeast::before {\n  content: \"\\f05c1\";\n}\n\n.mdi-yin-yang::before {\n  content: \"\\f0680\";\n}\n\n.mdi-yoga::before {\n  content: \"\\f117c\";\n}\n\n.mdi-youtube::before {\n  content: \"\\f05c3\";\n}\n\n.mdi-youtube-gaming::before {\n  content: \"\\f0848\";\n}\n\n.mdi-youtube-studio::before {\n  content: \"\\f0847\";\n}\n\n.mdi-youtube-subscription::before {\n  content: \"\\f0d40\";\n}\n\n.mdi-youtube-tv::before {\n  content: \"\\f0448\";\n}\n\n.mdi-yurt::before {\n  content: \"\\f1516\";\n}\n\n.mdi-z-wave::before {\n  content: \"\\f0aea\";\n}\n\n.mdi-zend::before {\n  content: \"\\f0aeb\";\n}\n\n.mdi-zigbee::before {\n  content: \"\\f0d41\";\n}\n\n.mdi-zip-box::before {\n  content: \"\\f05c4\";\n}\n\n.mdi-zip-box-outline::before {\n  content: \"\\f0ffa\";\n}\n\n.mdi-zip-disk::before {\n  content: \"\\f0a23\";\n}\n\n.mdi-zodiac-aquarius::before {\n  content: \"\\f0a7d\";\n}\n\n.mdi-zodiac-aries::before {\n  content: \"\\f0a7e\";\n}\n\n.mdi-zodiac-cancer::before {\n  content: \"\\f0a7f\";\n}\n\n.mdi-zodiac-capricorn::before {\n  content: \"\\f0a80\";\n}\n\n.mdi-zodiac-gemini::before {\n  content: \"\\f0a81\";\n}\n\n.mdi-zodiac-leo::before {\n  content: \"\\f0a82\";\n}\n\n.mdi-zodiac-libra::before {\n  content: \"\\f0a83\";\n}\n\n.mdi-zodiac-pisces::before {\n  content: \"\\f0a84\";\n}\n\n.mdi-zodiac-sagittarius::before {\n  content: \"\\f0a85\";\n}\n\n.mdi-zodiac-scorpio::before {\n  content: \"\\f0a86\";\n}\n\n.mdi-zodiac-taurus::before {\n  content: \"\\f0a87\";\n}\n\n.mdi-zodiac-virgo::before {\n  content: \"\\f0a88\";\n}\n\n.mdi-blank::before {\n  content: \"\\f68c\";\n  visibility: hidden;\n}\n\n.mdi-18px.mdi-set, .mdi-18px.mdi:before {\n  font-size: 18px;\n}\n\n.mdi-24px.mdi-set, .mdi-24px.mdi:before {\n  font-size: 24px;\n}\n\n.mdi-36px.mdi-set, .mdi-36px.mdi:before {\n  font-size: 36px;\n}\n\n.mdi-48px.mdi-set, .mdi-48px.mdi:before {\n  font-size: 48px;\n}\n\n.mdi-dark:before {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, 0.26);\n}\n\n.mdi-light:before {\n  color: white;\n}\n\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mdi-rotate-45 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(45deg);\n            transform: scaleX(-1) rotate(45deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: scaleY(-1) rotate(45deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.mdi-rotate-90 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(90deg);\n            transform: scaleX(-1) rotate(90deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(90deg);\n            -ms-transform: rotate(90deg);\n            transform: scaleY(-1) rotate(90deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.mdi-rotate-135 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(135deg);\n            -ms-transform: rotate(135deg);\n            transform: scaleY(-1) rotate(135deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n.mdi-rotate-180 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(180deg);\n            transform: scaleX(-1) rotate(180deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(180deg);\n            -ms-transform: rotate(180deg);\n            transform: scaleY(-1) rotate(180deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.mdi-rotate-225 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(225deg);\n            transform: scaleX(-1) rotate(225deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(225deg);\n            -ms-transform: rotate(225deg);\n            transform: scaleY(-1) rotate(225deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n\n.mdi-rotate-270 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(270deg);\n            transform: scaleX(-1) rotate(270deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(270deg);\n            -ms-transform: rotate(270deg);\n            transform: scaleY(-1) rotate(270deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.mdi-rotate-315 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(315deg);\n            transform: scaleX(-1) rotate(315deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(315deg);\n            -ms-transform: rotate(315deg);\n            transform: scaleY(-1) rotate(315deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n  -ms-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipV;\n  -ms-filter: \"FlipV\";\n}\n\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n  animation: mdi-spin 2s infinite linear;\n}\n\n@-webkit-keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n","/*\nTemplate Name: Hyper - Responsive Bootstrap 5 Admin Dashboard\nVersion: 3.4.0\nAuthor: CoderThemes\nEmail: support@coderthemes.com\nFile: Main Css File\n*/\n\n//Core files\n\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"config/saas/variables\";\n\n@import \"./config/saas/light-mode\";\n@import \"./config/saas/dark-mode\";\n@import \"config/saas/custom-variables\";\n\n@import \"./node_modules/bootstrap/scss/bootstrap\";\n\n// Structure\n@import \"custom/structure/general\";\n@import \"custom/structure/left-menu\";\n@import \"custom/structure/topbar\";\n@import \"custom/structure/right-sidebar\";\n@import \"custom/structure/page-head\";\n// horizontal nav\n@import \"custom/structure/horizontal-nav\";\n\n//Fonts\n@import \"custom/fonts/nunito\";\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Prefix for :root CSS variables\n$variable-prefix:                                 'ct-';\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f1f3fa;\n$gray-200: #eef2f7;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #98a6ad;\n$gray-700: #6c757d;\n$gray-800: #343a40 !default;\n$gray-900: #313a46;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n);\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:       #2c8ef8;\n$indigo:     #727cf5;\n$purple:     #6b5eae;\n$pink:       #ff679b;\n$red:        #fa5c7c;\n$orange:     #fd7e14;\n$yellow:     #ffbc00;\n$green:      #0acf97;\n$teal:       #02a8b5;\n$cyan:       #39afd1;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n);\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary:       $indigo;\n$secondary:     $gray-700;\n$success:       $green;\n$info:          $cyan;\n$warning:       $yellow;\n$danger:        $red;\n$light:         $gray-200;\n$dark:          $gray-900;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n);\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\");\n// scss-docs-end theme-colors-rgb\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   1.8;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $gray-900;\n$color-contrast-light:     $white;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%);\n$blue-200: tint-color($blue, 60%);\n$blue-300: tint-color($blue, 40%);\n$blue-400: tint-color($blue, 20%);\n$blue-500: $blue;\n$blue-600: shade-color($blue, 20%);\n$blue-700: shade-color($blue, 40%);\n$blue-800: shade-color($blue, 60%);\n$blue-900: shade-color($blue, 80%);\n\n$indigo-100: tint-color($indigo, 80%);\n$indigo-200: tint-color($indigo, 60%);\n$indigo-300: tint-color($indigo, 40%);\n$indigo-400: tint-color($indigo, 20%);\n$indigo-500: $indigo;\n$indigo-600: shade-color($indigo, 20%);\n$indigo-700: shade-color($indigo, 40%);\n$indigo-800: shade-color($indigo, 60%);\n$indigo-900: shade-color($indigo, 80%);\n\n$purple-100: tint-color($purple, 80%);\n$purple-200: tint-color($purple, 60%);\n$purple-300: tint-color($purple, 40%);\n$purple-400: tint-color($purple, 20%);\n$purple-500: $purple;\n$purple-600: shade-color($purple, 20%);\n$purple-700: shade-color($purple, 40%);\n$purple-800: shade-color($purple, 60%);\n$purple-900: shade-color($purple, 80%);\n\n$pink-100: tint-color($pink, 80%);\n$pink-200: tint-color($pink, 60%);\n$pink-300: tint-color($pink, 40%);\n$pink-400: tint-color($pink, 20%);\n$pink-500: $pink;\n$pink-600: shade-color($pink, 20%);\n$pink-700: shade-color($pink, 40%);\n$pink-800: shade-color($pink, 60%);\n$pink-900: shade-color($pink, 80%);\n\n$red-100: tint-color($red, 80%);\n$red-200: tint-color($red, 60%);\n$red-300: tint-color($red, 40%);\n$red-400: tint-color($red, 20%);\n$red-500: $red;\n$red-600: shade-color($red, 20%);\n$red-700: shade-color($red, 40%);\n$red-800: shade-color($red, 60%);\n$red-900: shade-color($red, 80%);\n\n$orange-100: tint-color($orange, 80%);\n$orange-200: tint-color($orange, 60%);\n$orange-300: tint-color($orange, 40%);\n$orange-400: tint-color($orange, 20%);\n$orange-500: $orange;\n$orange-600: shade-color($orange, 20%);\n$orange-700: shade-color($orange, 40%);\n$orange-800: shade-color($orange, 60%);\n$orange-900: shade-color($orange, 80%);\n\n$yellow-100: tint-color($yellow, 80%);\n$yellow-200: tint-color($yellow, 60%);\n$yellow-300: tint-color($yellow, 40%);\n$yellow-400: tint-color($yellow, 20%);\n$yellow-500: $yellow;\n$yellow-600: shade-color($yellow, 20%);\n$yellow-700: shade-color($yellow, 40%);\n$yellow-800: shade-color($yellow, 60%);\n$yellow-900: shade-color($yellow, 80%);\n\n$green-100: tint-color($green, 80%);\n$green-200: tint-color($green, 60%);\n$green-300: tint-color($green, 40%);\n$green-400: tint-color($green, 20%);\n$green-500: $green;\n$green-600: shade-color($green, 20%);\n$green-700: shade-color($green, 40%);\n$green-800: shade-color($green, 60%);\n$green-900: shade-color($green, 80%);\n\n$teal-100: tint-color($teal, 80%);\n$teal-200: tint-color($teal, 60%);\n$teal-300: tint-color($teal, 40%);\n$teal-400: tint-color($teal, 20%);\n$teal-500: $teal;\n$teal-600: shade-color($teal, 20%);\n$teal-700: shade-color($teal, 40%);\n$teal-800: shade-color($teal, 60%);\n$teal-900: shade-color($teal, 80%);\n\n$cyan-100: tint-color($cyan, 80%);\n$cyan-200: tint-color($cyan, 60%);\n$cyan-300: tint-color($cyan, 40%);\n$cyan-400: tint-color($cyan, 20%);\n$cyan-500: $cyan;\n$cyan-600: shade-color($cyan, 20%);\n$cyan-700: shade-color($cyan, 40%);\n$cyan-800: shade-color($cyan, 60%);\n$cyan-900: shade-color($cyan, 80%);\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n);\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n);\n\n$purples: (\n  \"purple-100\": $purple-200,\n  \"purple-200\": $purple-100,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n);\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n);\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n);\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n);\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n);\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n);\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n);\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n);\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n);\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true;\n$enable-rounded:              true;\n$enable-shadows:              false;\n$enable-gradients:            false;\n$enable-transitions:          true;\n$enable-reduced-motion:       true;\n$enable-smooth-scroll:        true;\n$enable-grid-classes:         true;\n$enable-container-classes:    true;\n$enable-cssgrid:              false;\n$enable-button-pointers:      true;\n$enable-rfs:                  true;\n$enable-validation-icons:     true;\n$enable-negative-margins:     true;\n$enable-deprecation-messages: true;\n$enable-important-utilities:  true;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0));\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1.5rem;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n);\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n);\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   #fafbfe;\n$body-color:                $gray-700;\n$body-text-align:           null;\n\n// Utilities maps\n//\n// Extends the default `$theme-colors` maps to help create our utilities.\n\n// Come v6, we'll de-dupe these variables. Until then, for backward compatibility, we keep them to reassign.\n// scss-docs-start utilities-colors\n$utilities-colors: $theme-colors-rgb;\n// scss-docs-end utilities-colors\n\n// scss-docs-start utilities-text-colors\n$utilities-text: map-merge(\n  $utilities-colors,\n  (\n    \"black\": to-rgb($black),\n    \"white\": to-rgb($white),\n    \"body\": to-rgb($body-color)\n  )\n);\n$utilities-text-colors: map-loop($utilities-text, rgba-css-var, \"$key\", \"text\");\n// scss-docs-end utilities-text-colors\n\n// scss-docs-start utilities-bg-colors\n$utilities-bg: map-merge(\n  $utilities-colors,\n  (\n    \"black\": to-rgb($black),\n    \"white\": to-rgb($white),\n    \"body\": to-rgb($body-bg)\n  )\n);\n$utilities-bg-colors: map-loop($utilities-bg, rgba-css-var, \"$key\", \"bg\");\n// scss-docs-end utilities-bg-colors\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              var(--#{$variable-prefix}link-color);\n$link-decoration:                         none;\n$link-shade-percentage:                   15%;\n$link-hover-color:                        var(--#{$variable-prefix}link-hover-color);\n$link-hover-decoration:                   null;\n\n$stretched-link-pseudo-element:           after;\n$stretched-link-z-index:                  1;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n);\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n);\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12;\n$grid-gutter-width:           24px;\n$grid-row-columns:            6;\n\n$gutters: $spacers;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * .5;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px;\n$border-widths: (\n  0: 0,\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n);\n\n$border-color:                var(--#{$variable-prefix}border-color);\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem;\n$border-radius-sm:            .2rem;\n$border-radius-lg:            .3rem;\n$border-radius-pill:          50rem;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  var(--#{$variable-prefix}box-shadow);\n$box-shadow-sm:               var(--#{$variable-prefix}box-shadow-sm);\n$box-shadow-lg:               var(--#{$variable-prefix}box-shadow-lg);\n$box-shadow-inset:            var(--#{$variable-prefix}box-shadow-inset);\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      var(--#{$variable-prefix}component-active-color);\n$component-active-bg:         var(--#{$variable-prefix}component-active-bg);\n\n// scss-docs-start caret-variables\n$caret-width:                 .25em;\n$caret-vertical-align:        $caret-width * .85;\n$caret-spacing:               $caret-width * .85;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out;\n$transition-fade:             opacity .15s linear;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease;\n$transition-collapse-width:   width .35s ease;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n);\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      'Nunito', sans-serif;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n// stylelint-enable value-keyword-case\n$font-family-base:            $font-family-sans-serif;\n$font-family-code:            var(--#{$variable-prefix}font-monospace);\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null;\n$font-size-base:              0.9rem; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base - .025;\n$font-size-lg:                $font-size-base * 1.390;\n\n$font-weight-lighter:         lighter;\n$font-weight-light:           300;\n$font-weight-normal:          400;\n$font-weight-bold:            700;\n$font-weight-bolder:          bolder;\n\n$font-weight-base:            $font-weight-normal;\n\n$line-height-base:            1.5;\n$line-height-sm:              1.25;\n$line-height-lg:              2;\n\n$h1-font-size:                2.25rem;\n$h2-font-size:                1.875rem;\n$h3-font-size:                1.5rem;\n$h4-font-size:                1.125rem;\n$h5-font-size:                0.9375rem;\n$h6-font-size:                0.75rem;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n);\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5;\n$headings-font-family:        null;\n$headings-font-style:         null;\n$headings-font-weight:        500;\n$headings-line-height:        1.1;\n$headings-color:              null;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n);\n\n$display-font-weight: 300;\n$display-line-height: $headings-line-height;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25;\n$lead-font-weight:            300;\n\n$small-font-size:             0.75rem;\n\n$sub-sup-font-size:           .75em;\n\n$text-muted:                  var(--#{$variable-prefix}text-muted);\n\n$initialism-font-size:        $small-font-size;\n\n$blockquote-margin-y:         $spacer;\n$blockquote-font-size:        $font-size-base * 1.25;\n$blockquote-footer-color:     var(--#{$variable-prefix}blockquote-footer-color);\n$blockquote-footer-font-size: $small-font-size;\n\n$hr-margin-y:                 $spacer - 0.5rem;\n$hr-color:                    inherit;\n$hr-bg-color:                 currentColor;\n$hr-border-width:             0;\n$hr-height:                   $border-width;\n$hr-opacity:                  .25;\n\n$legend-margin-bottom:        .5rem;\n$legend-font-size:            1.5rem;\n$legend-font-weight:          null;\n\n$mark-padding:                .2em;\n\n$dt-font-weight:              $font-weight-bold;\n\n$nested-kbd-font-weight:      $font-weight-bold;\n\n$list-inline-padding:         6px;\n\n$mark-bg:                     var(--#{$variable-prefix}mark-bg);\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .95rem;\n$table-cell-padding-x:        .95rem;\n$table-cell-padding-y-sm:     .5rem;\n$table-cell-padding-x-sm:     .5rem;\n\n$table-cell-vertical-align:   top;\n\n$table-color:                 var(--#{$variable-prefix}table-color);\n$table-bg:                    var(--#{$variable-prefix}table-bg);\n$table-accent-bg:             var(--#{$variable-prefix}table-accent-bg);\n\n$table-th-font-weight:        null;\n\n$table-striped-color:         var(--#{$variable-prefix}table-striped-color);\n$table-striped-bg-factor:     1;\n$table-striped-bg:            var(--#{$variable-prefix}table-striped-bg);\n\n$table-active-color:          var(--#{$variable-prefix}table-active-color);\n$table-active-bg-factor:      .4;\n$table-active-bg:             var(--#{$variable-prefix}table-active-bg);\n\n$table-hover-color:           var(--#{$variable-prefix}table-hover-color);\n$table-hover-bg-factor:       .075;\n$table-hover-bg:              var(--#{$variable-prefix}table-hover-bg);\n\n$table-border-factor:         .1;\n$table-border-width:          $border-width;\n$table-border-color:          var(--#{$variable-prefix}table-border-color);\n\n$table-striped-order:         odd;\n\n$table-group-separator-color: var(--#{$variable-prefix}table-group-separator-color);\n\n$table-caption-color:         var(--#{$variable-prefix}table-caption-color);\n\n$table-bg-scale:              -80%;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $gray-200,\n  \"dark\":       $gray-900,\n);\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .45rem;\n$input-btn-padding-x:         .90rem;\n$input-btn-font-family:       null;\n$input-btn-font-size:         $font-size-base;\n$input-btn-line-height:       $line-height-base;\n\n$input-btn-focus-width:         .2rem;\n$input-btn-focus-color-opacity: .25;\n$input-btn-focus-color:         var(--#{$variable-prefix}input-btn-focus-color);\n$input-btn-focus-blur:          0;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color;\n\n$input-btn-padding-y-sm:      .28rem;\n$input-btn-padding-x-sm:      .8rem;\n$input-btn-font-size-sm:      $font-size-sm;\n\n$input-btn-padding-y-lg:      .5rem;\n$input-btn-padding-x-lg:      1rem;\n$input-btn-font-size-lg:      $font-size-lg;\n\n$input-btn-border-width:      $border-width;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y;\n$btn-padding-x:               $input-btn-padding-x;\n$btn-font-family:             $input-btn-font-family;\n$btn-font-size:               $input-btn-font-size;\n$btn-line-height:             $input-btn-line-height;\n$btn-white-space:             null; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm;\n$btn-padding-x-sm:            $input-btn-padding-x-sm;\n$btn-font-size-sm:            $input-btn-font-size-sm;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg;\n$btn-padding-x-lg:            $input-btn-padding-x-lg;\n$btn-font-size-lg:            $input-btn-font-size-lg;\n\n$btn-border-width:            $input-btn-border-width;\n\n$btn-font-weight:             $font-weight-normal;\n$btn-box-shadow:              0px 2px 6px 0px;  // button box shadow\n$btn-focus-width:             $input-btn-focus-width;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow;\n$btn-disabled-opacity:        .65;\n$btn-active-box-shadow:       var(--#{$variable-prefix}btn-active-box-shadow);\n\n$btn-link-color:              var(--#{$variable-prefix}btn-link-color);\n$btn-link-hover-color:        var(--#{$variable-prefix}btn-link-hover-color);\n$btn-link-disabled-color:     var(--#{$variable-prefix}btn-link-disabled-color);\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           .15rem;\n$btn-border-radius-sm:        .15rem;\n$btn-border-radius-lg:        .15rem;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$btn-hover-bg-shade-amount:       15%;\n$btn-hover-bg-tint-amount:        15%;\n$btn-hover-border-shade-amount:   20%;\n$btn-hover-border-tint-amount:    10%;\n$btn-active-bg-shade-amount:      20%;\n$btn-active-bg-tint-amount:       20%;\n$btn-active-border-shade-amount:  25%;\n$btn-active-border-tint-amount:   10%;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem;\n$form-text-font-size:                   $small-font-size;\n$form-text-font-style:                  null;\n$form-text-font-weight:                 null;\n$form-text-color:                       var(--#{$variable-prefix}form-text-color);\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem;\n$form-label-font-size:                  null;\n$form-label-font-style:                 null;\n$form-label-font-weight:                null;\n$form-label-color:                      null;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y;\n$input-padding-x:                       $input-btn-padding-x;\n$input-font-family:                     $input-btn-font-family;\n$input-font-size:                       $input-btn-font-size;\n$input-font-weight:                     $font-weight-base;\n$input-line-height:                     $input-btn-line-height;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm;\n$input-padding-x-sm:                    $input-btn-padding-x-sm;\n$input-font-size-sm:                    $input-btn-font-size-sm;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg;\n$input-padding-x-lg:                    $input-btn-padding-x-lg;\n$input-font-size-lg:                    $input-btn-font-size-lg;\n\n$input-bg:                              var(--#{$variable-prefix}input-bg);\n$input-disabled-bg:                     var(--#{$variable-prefix}input-disabled-bg);\n$input-disabled-border-color:           null;\n\n$input-color:                           var(--#{$variable-prefix}input-color);\n$input-border-color:                    var(--#{$variable-prefix}input-border-color);\n$input-border-width:                    1px;\n$input-box-shadow:                      var(--#{$variable-prefix}input-box-shadow);\n\n$input-border-radius:                   0.25rem;\n$input-border-radius-sm:                $border-radius-sm;\n$input-border-radius-lg:                $border-radius-lg;\n\n$input-focus-bg:                        var(--#{$variable-prefix}input-focus-bg);\n$input-focus-border-color:              var(--#{$variable-prefix}input-focus-border-color);\n$input-focus-color:                     var(--#{$variable-prefix}input-focus-color);\n$input-focus-width:                     $input-btn-focus-width;\n$input-focus-box-shadow:                none;\n\n$input-placeholder-color:               var(--#{$variable-prefix}input-placeholder-color);\n$input-plaintext-color:                 var(--#{$variable-prefix}input-plaintext-color);\n\n$input-height-border:                   $input-border-width * 2;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2);\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y);\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5);\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false));\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false));\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false));\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$form-color-width:                      3rem;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1.112em;\n$form-check-min-height:                   $font-size-base * $line-height-base;\n$form-check-padding-start:                $form-check-input-width + .5em;\n$form-check-margin-bottom:                0;\n$form-check-label-color:                  null;\n$form-check-label-cursor:                 null;\n$form-check-transition:                   background-color .15s ease-in-out, background-position .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$form-check-input-active-filter:          brightness(90%);\n\n$form-check-input-bg:                     var(--#{$variable-prefix}form-check-input-bg);\n$form-check-input-border:                 var(--#{$variable-prefix}form-check-input-border);\n$form-check-input-border-radius:          .25em;\n$form-check-radio-border-radius:          50%;\n$form-check-input-focus-border:           $input-focus-border-color;\n$form-check-input-focus-box-shadow:       none;\n\n$form-check-input-checked-color:          var(--#{$variable-prefix}form-check-input-checked-color);\n$form-check-input-checked-bg-color:       var(--#{$variable-prefix}form-check-input-checked-bg-color);\n$form-check-input-checked-border-color:   var(--#{$variable-prefix}form-check-input-checked-border-color);\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\");\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='%23fff'/></svg>\");\n\n$form-check-input-indeterminate-color:          $component-active-color;\n$form-check-input-indeterminate-bg-color:       $component-active-bg;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\n\n$form-check-input-disabled-opacity:        .5;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity;\n\n$form-check-inline-margin-end:    1rem;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               var(--#{$variable-prefix}form-switch-color);\n$form-switch-width:               2em;\n$form-switch-padding-start:       $form-switch-width + .5em;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#8b96a0' opacity='0.5'/></svg>\");\n$form-switch-border-radius:       $form-switch-width;\n$form-switch-transition:          background-position .15s ease-in-out;\n\n$form-switch-focus-color:         $input-focus-border-color;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#8b96a0' opacity='0.5'/></svg>\");\n\n$form-switch-checked-color:       $component-active-color;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='%23fff'/></svg>\");\n$form-switch-checked-bg-position: right center;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y;\n$input-group-addon-padding-x:           $input-padding-x;\n$input-group-addon-font-weight:         $input-font-weight;\n$input-group-addon-color:               var(--#{$variable-prefix}input-group-addon-color);\n$input-group-addon-bg:                  var(--#{$variable-prefix}input-group-addon-bg);\n$input-group-addon-border-color:        var(--#{$variable-prefix}input-group-addon-border-color);\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             .45rem;\n$form-select-padding-x:             .90rem;\n$form-select-font-family:           $input-font-family;\n$form-select-font-size:             $input-font-size;\n$form-select-indicator-padding:     $form-select-padding-x * 3; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight;\n$form-select-line-height:           $input-line-height;\n$form-select-color:                 var(--#{$variable-prefix}form-select-color);\n$form-select-bg:                    var(--#{$variable-prefix}form-select-bg);\n$form-select-disabled-color:        var(--#{$variable-prefix}form-select-disabled-color);\n$form-select-disabled-bg:           var(--#{$variable-prefix}form-select-disabled-bg);\n$form-select-disabled-border-color: $input-disabled-border-color;\n$form-select-bg-position:           right $form-select-padding-x center;\n$form-select-bg-size:               14px 10px; // In pixels because image dimensions\n$form-select-indicator-color:       var(--#{$variable-prefix}form-select-indicator-color);\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#8b96a0' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half;\n\n$form-select-border-width:        $input-border-width;\n$form-select-border-color:        $input-border-color;\n$form-select-border-radius:       $border-radius;\n$form-select-box-shadow:          none;\n\n$form-select-focus-border-color:  $input-focus-border-color;\n$form-select-focus-width:         $input-focus-width;\n$form-select-focus-box-shadow:    none;\n\n$form-select-padding-y-sm:        $input-padding-y-sm;\n$form-select-padding-x-sm:        $input-padding-x-sm;\n$form-select-font-size-sm:        $input-font-size-sm;\n$form-select-border-radius-sm:    $input-border-radius-sm;\n\n$form-select-padding-y-lg:        $input-padding-y-lg;\n$form-select-padding-x-lg:        $input-padding-x-lg;\n$form-select-font-size-lg:        $input-font-size-lg;\n$form-select-border-radius-lg:    $input-border-radius-lg;\n\n$form-select-transition:          $input-transition;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100%;\n$form-range-track-height:         .5rem;\n$form-range-track-cursor:         pointer;\n$form-range-track-bg:             var(--#{$variable-prefix}form-range-track-bg);\n$form-range-track-border-radius:  1rem;\n$form-range-track-box-shadow:     var(--#{$variable-prefix}form-range-track-box-shadow);\n\n$form-range-thumb-width:                   1rem;\n$form-range-thumb-height:                  $form-range-thumb-width;\n$form-range-thumb-bg:                      $component-active-bg;\n$form-range-thumb-border:                  0;\n$form-range-thumb-border-radius:           1rem;\n$form-range-thumb-box-shadow:              var(--#{$variable-prefix}form-range-thumb-box-shadow);\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               var(--#{$variable-prefix}form-range-thumb-active-bg);\n$form-range-thumb-disabled-bg:             var(--#{$variable-prefix}form-range-thumb-disabled-bg);\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          var(--#{$variable-prefix}form-file-button-color);\n$form-file-button-bg:             var(--#{$variable-prefix}form-file-button-bg);\n$form-file-button-hover-bg:       var(--#{$variable-prefix}form-file-button-hover-bg);\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border);\n$form-floating-line-height:       1.25;\n$form-floating-padding-x:         $input-padding-x;\n$form-floating-padding-y:         1rem;\n$form-floating-input-padding-t:   1.625rem;\n$form-floating-input-padding-b:   .625rem;\n$form-floating-label-opacity:     .65;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem);\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top;\n$form-feedback-font-size:           $form-text-font-size;\n$form-feedback-font-style:          $form-text-font-style;\n$form-feedback-valid-color:         $success;\n$form-feedback-invalid-color:       $danger;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n);\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000;\n$zindex-sticky:                     1020;\n$zindex-fixed:                      1030;\n$zindex-offcanvas-backdrop:         1040;\n$zindex-offcanvas:                  1045;\n$zindex-modal-backdrop:             1050;\n$zindex-modal:                      1055;\n$zindex-popover:                    1070;\n$zindex-tooltip:                    1080;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem;\n$nav-link-padding-x:                1rem;\n$nav-link-font-size:                null;\n$nav-link-font-weight:              null;\n$nav-link-color:                    null;\n$nav-link-hover-color:              null;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\n$nav-link-disabled-color:           var(--#{$variable-prefix}nav-link-disabled-color);\n\n$nav-tabs-border-color:             var(--#{$variable-prefix}nav-tabs-border-color);\n$nav-tabs-border-width:             $border-width;\n$nav-tabs-border-radius:            $border-radius;\n$nav-tabs-link-hover-border-color:  var(--#{$variable-prefix}nav-tabs-link-hover-border-color);\n$nav-tabs-link-active-color:        var(--#{$variable-prefix}nav-tabs-link-active-color);\n$nav-tabs-link-active-bg:           var(--#{$variable-prefix}nav-tabs-link-active-bg);\n$nav-tabs-link-active-border-color: var(--#{$variable-prefix}nav-tabs-link-active-border-color);\n\n$nav-pills-border-radius:           $border-radius;\n$nav-pills-link-active-color:       $component-active-color;\n$nav-pills-link-active-bg:          $component-active-bg;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5;\n$navbar-padding-x:                  null;\n\n$navbar-nav-link-padding-x:         .5rem;\n\n$navbar-brand-font-size:            $font-size-lg;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5;\n$navbar-brand-margin-end:           1rem;\n\n$navbar-toggler-padding-y:          .25rem;\n$navbar-toggler-padding-x:          .75rem;\n$navbar-toggler-font-size:          $font-size-lg;\n$navbar-toggler-border-radius:      $btn-border-radius;\n$navbar-toggler-focus-width:        $btn-focus-width;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color:                 var(--#{$variable-prefix}navbar-dark-color);\n$navbar-dark-hover-color:           var(--#{$variable-prefix}navbar-dark-hover-color);\n$navbar-dark-active-color:          var(--#{$variable-prefix}navbar-dark-active-color);\n$navbar-dark-disabled-color:        var(--#{$variable-prefix}navbar-dark-disabled-color);\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-dark-toggler-border-color:  var(--#{$variable-prefix}navbar-dark-toggler-border-color);\n\n$navbar-light-color:                var(--#{$variable-prefix}navbar-light-color);\n$navbar-light-hover-color:          var(--#{$variable-prefix}navbar-light-hover-color);\n$navbar-light-active-color:         var(--#{$variable-prefix}navbar-light-active-color);\n$navbar-light-disabled-color:       var(--#{$variable-prefix}navbar-light-disabled-color);\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-light-toggler-border-color: rgba($black, .1);\n\n$navbar-light-brand-color:                $navbar-light-active-color;\n$navbar-light-brand-hover-color:          $navbar-light-active-color;\n$navbar-dark-brand-color:                 $navbar-dark-active-color;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color;\n// scss-docs-end navbar-theme-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem;\n$dropdown-padding-x:                0;\n$dropdown-padding-y:                .25rem;\n$dropdown-spacer:                   .125rem;\n$dropdown-font-size:                $font-size-base;\n$dropdown-color:                    var(--#{$variable-prefix}dropdown-color);\n$dropdown-bg:                       var(--#{$variable-prefix}dropdown-bg);\n$dropdown-border-color:             var(--#{$variable-prefix}dropdown-border-color);\n$dropdown-border-radius:            $border-radius;\n$dropdown-border-width:             $border-width;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width);\n$dropdown-divider-bg:               var(--#{$variable-prefix}dropdown-divider-bg);\n$dropdown-divider-margin-y:         $spacer * .5;\n$dropdown-box-shadow:               var(--#{$variable-prefix}dropdown-box-shadow);\n\n$dropdown-link-color:               var(--#{$variable-prefix}dropdown-link-color);\n$dropdown-link-hover-color:         var(--#{$variable-prefix}dropdown-link-hover-color);\n$dropdown-link-hover-bg:            var(--#{$variable-prefix}dropdown-link-hover-bg);\n\n$dropdown-link-active-color:        var(--#{$variable-prefix}dropdown-link-active-color);\n$dropdown-link-active-bg:           var(--#{$variable-prefix}dropdown-link-active-bg);\n\n$dropdown-link-disabled-color:      var(--#{$variable-prefix}dropdown-link-disabled-color);\n\n$dropdown-item-padding-y:           .375rem;\n$dropdown-item-padding-x:           $spacer;\n\n$dropdown-header-color:             inherit;\n$dropdown-header-padding:           .5rem 1.5rem;\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               var(--#{$variable-prefix}dropdown-dark-color);\n$dropdown-dark-bg:                  var(--#{$variable-prefix}dropdown-dark-bg);\n$dropdown-dark-border-color:        var(--#{$variable-prefix}dropdown-dark-border-color);\n$dropdown-dark-divider-bg:          var(--#{$variable-prefix}dropdown-dark-divider-bg);\n$dropdown-dark-box-shadow:          null;\n$dropdown-dark-link-color:          var(--#{$variable-prefix}dropdown-dark-link-color);\n$dropdown-dark-link-hover-color:    var(--#{$variable-prefix}dropdown-dark-link-hover-color);\n$dropdown-dark-link-hover-bg:       var(--#{$variable-prefix}dropdown-dark-link-hover-bg);\n$dropdown-dark-link-active-color:   var(--#{$variable-prefix}dropdown-dark-link-active-color);\n$dropdown-dark-link-active-bg:      var(--#{$variable-prefix}dropdown-dark-link-active-bg);\n$dropdown-dark-link-disabled-color: var(--#{$variable-prefix}dropdown-dark-link-disabled-color);\n$dropdown-dark-header-color:        var(--#{$variable-prefix}dropdown-dark-header-color);\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem;\n$pagination-padding-x:              .75rem;\n$pagination-padding-y-sm:           .25rem;\n$pagination-padding-x-sm:           .5rem;\n$pagination-padding-y-lg:           .75rem;\n$pagination-padding-x-lg:           1.5rem;\n\n$pagination-color:                  var(--#{$variable-prefix}pagination-color);\n$pagination-bg:                     var(--#{$variable-prefix}pagination-bg);\n$pagination-border-width:           $border-width;\n$pagination-border-radius:          $border-radius;\n$pagination-margin-start:           -$pagination-border-width;\n$pagination-border-color:           var(--#{$variable-prefix}pagination-border-color);\n\n$pagination-focus-color:            var(--#{$variable-prefix}pagination-focus-color);\n$pagination-focus-bg:               var(--#{$variable-prefix}pagination-focus-bg);\n$pagination-focus-box-shadow:       var(--#{$variable-prefix}pagination-focus-box-shadow);\n$pagination-focus-outline:          0;\n\n$pagination-hover-color:            var(--#{$variable-prefix}pagination-hover-color);\n$pagination-hover-bg:               var(--#{$variable-prefix}pagination-hover-bg);\n$pagination-hover-border-color:     var(--#{$variable-prefix}pagination-hover-border-color);\n\n$pagination-active-color:           $component-active-color;\n$pagination-active-bg:              $component-active-bg;\n$pagination-active-border-color:    $pagination-active-bg;\n\n$pagination-disabled-color:         var(--#{$variable-prefix}pagination-disabled-color);\n$pagination-disabled-bg:            var(--#{$variable-prefix}pagination-disabled-bg);\n$pagination-disabled-border-color:  var(--#{$variable-prefix}pagination-disabled-border-color);\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$pagination-border-radius-sm:       $border-radius-sm;\n$pagination-border-radius-lg:       $border-radius-lg;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5;\n$placeholder-opacity-min:           .2;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer;\n$card-spacer-x:                     $spacer;\n$card-title-spacer-y:               $spacer * .5;\n$card-border-width:                 $border-width;\n$card-border-color:                 var(--#{$variable-prefix}card-border-color);\n$card-border-radius:                $border-radius;\n$card-box-shadow:                   var(--#{$variable-prefix}card-box-shadow);\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width);\n$card-cap-padding-y:                $card-spacer-y * .5;\n$card-cap-padding-x:                $card-spacer-x;\n$card-cap-bg:                       var(--#{$variable-prefix}card-cap-bg);\n$card-cap-color:                    null;\n$card-height:                       null;\n$card-color:                        null;\n$card-bg:                           var(--#{$variable-prefix}card-bg);\n$card-img-overlay-padding:          $spacer - 0.25rem;\n$card-group-margin:                 $grid-gutter-width * .5;\n// scss-docs-end card-variables\n\n// Accordion\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem;\n$accordion-padding-x:                     1.25rem;\n$accordion-color:                         var(--#{$variable-prefix}accordion-color);\n$accordion-bg:                            transparent;\n$accordion-border-width:                  $border-width;\n$accordion-border-color:                  var(--#{$variable-prefix}accordion-border-color);\n$accordion-border-radius:                 $border-radius;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width);\n\n$accordion-body-padding-y:                $accordion-padding-y;\n$accordion-body-padding-x:                $accordion-padding-x;\n\n$accordion-button-padding-y:              $accordion-padding-y;\n$accordion-button-padding-x:              $accordion-padding-x;\n$accordion-button-color:                  $accordion-color;\n$accordion-button-bg:                     $accordion-bg;\n$accordion-transition:                    $btn-transition, border-radius .15s ease;\n$accordion-button-active-bg:              var(--#{$variable-prefix}accordion-button-active-bg);\n$accordion-button-active-color:           var(--#{$variable-prefix}accordion-button-active-color);\n\n$accordion-button-focus-border-color:     var(--#{$variable-prefix}accordion-button-focus-border-color);\n$accordion-button-focus-box-shadow:       var(--#{$variable-prefix}accordion-button-focus-box-shadow);\n\n$accordion-icon-width:                    1.25rem;\n$accordion-icon-color:                    $accordion-color;\n$accordion-icon-active-color:             $accordion-button-active-color;\n$accordion-icon-transition:               transform .2s ease-in-out;\n$accordion-icon-transform:                rotate(180deg);\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 13px;\n$tooltip-max-width:                 200px;\n$tooltip-color:                     var(--#{$variable-prefix}tooltip-color);\n$tooltip-bg:                        var(--#{$variable-prefix}tooltip-bg);\n$tooltip-border-radius:             0.2rem;\n$tooltip-opacity:                   .9;\n$tooltip-padding-y:                 .4rem;\n$tooltip-padding-x:                 .8rem;\n$tooltip-margin:                    0;\n\n$tooltip-arrow-width:               .8rem;\n$tooltip-arrow-height:              .4rem;\n$tooltip-arrow-color:               $tooltip-bg;\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x;\n$form-feedback-tooltip-font-size:     $tooltip-font-size;\n$form-feedback-tooltip-line-height:   null;\n$form-feedback-tooltip-opacity:       $tooltip-opacity;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\n// scss-docs-start tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm;\n$popover-bg:                        var(--#{$variable-prefix}popover-bg);\n$popover-max-width:                 276px;\n$popover-border-width:              $border-width;\n$popover-border-color:              var(--#{$variable-prefix}popover-border-color);\n$popover-border-radius:             $border-radius-lg;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width);\n$popover-box-shadow:                $box-shadow;\n\n$popover-header-bg:                 var(--#{$variable-prefix}popover-header-bg);\n$popover-header-color:              var(--#{$variable-prefix}popover-header-color);\n$popover-header-padding-y:          .7rem;\n$popover-header-padding-x:          .8rem;\n\n$popover-body-color:                var(--#{$variable-prefix}popover-body-color);\n$popover-body-padding-y:            .5rem;\n$popover-body-padding-x:            .75rem;\n\n$popover-arrow-width:               1rem;\n$popover-arrow-height:              .5rem;\n$popover-arrow-color:               var(--#{$variable-prefix}popover-arrow-color);\n\n$popover-arrow-outer-color:         var(--#{$variable-prefix}popover-arrow-outer-color);\n// scss-docs-end popover-variables\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px;\n$toast-padding-x:                   .75rem;\n$toast-padding-y:                   .5rem;\n$toast-font-size:                   .875rem;\n$toast-color:                       inherit;\n$toast-background-color:            var(--#{$variable-prefix}toast-background-color);\n$toast-border-width:                1px;\n$toast-border-color:                var(--#{$variable-prefix}toast-border-color);\n$toast-border-radius:               $border-radius;\n$toast-box-shadow:                  $box-shadow;\n$toast-spacing:                     $container-padding-x;\n\n$toast-header-color:                inherit;\n$toast-header-background-color:     var(--#{$variable-prefix}toast-header-background-color);\n$toast-header-border-color:         var(--#{$variable-prefix}toast-header-border-color);\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em;\n$badge-font-weight:                 $font-weight-bold;\n$badge-color:                       var(--#{$variable-prefix}badge-color);\n$badge-padding-y:                   .25em;\n$badge-padding-x:                   .4em;\n$badge-border-radius:               $border-radius;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer - 0.5rem;\n\n$modal-footer-margin-between:       .5rem;\n\n$modal-dialog-margin:               .5rem;\n$modal-dialog-margin-y-sm-up:       1.75rem;\n\n$modal-title-line-height:           $line-height-base;\n\n$modal-content-color:               null;\n$modal-content-bg:                  var(--#{$variable-prefix}modal-content-bg);\n$modal-content-border-color:        transparent;\n$modal-content-border-width:        $border-width;\n$modal-content-border-radius:       0.2rem;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width);\n$modal-content-box-shadow-xs:       var(--#{$variable-prefix}modal-content-box-shadow-xs);\n$modal-content-box-shadow-sm-up:    var(--#{$variable-prefix}modal-content-box-shadow-sm-up);\n\n$modal-backdrop-bg:                 var(--#{$variable-prefix}modal-backdrop-bg);\n$modal-backdrop-opacity:            .7;\n$modal-header-border-color:         var(--#{$variable-prefix}modal-header-border-color);\n$modal-footer-border-color:         var(--#{$variable-prefix}modal-footer-border-color);\n$modal-header-border-width:         $modal-content-border-width;\n$modal-footer-border-width:         $modal-header-border-width;\n$modal-header-padding-y:            $modal-inner-padding;\n$modal-header-padding-x:            $modal-inner-padding;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\n\n$modal-sm:                          300px;\n$modal-md:                          500px;\n$modal-lg:                          800px;\n$modal-xl:                          1140px;\n\n$modal-fade-transform:              translate(0, -50px);\n$modal-show-transform:              none;\n$modal-transition:                  transform .3s ease-out;\n$modal-scale-transform:             scale(1.02);\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               .75rem;\n$alert-padding-x:               1.25rem;\n$alert-margin-bottom:           1rem;\n$alert-border-radius:           $border-radius;\n$alert-link-font-weight:        $font-weight-bold;\n$alert-border-width:            $border-width;\n$alert-bg-scale:                -80%;\n$alert-border-scale:            -70%;\n$alert-color-scale:             40%;\n$alert-dismissible-padding-r:   $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem;\n$progress-font-size:                $font-size-base * .75;\n$progress-bg:                       var(--#{$variable-prefix}progress-bg);\n$progress-border-radius:            $border-radius;\n$progress-box-shadow:               var(--#{$variable-prefix}progress-box-shadow);\n$progress-bar-color:                var(--#{$variable-prefix}progress-bar-color);\n$progress-bar-bg:                   var(--#{$variable-prefix}progress-bar-bg);\n$progress-bar-animation-timing:     1s linear infinite;\n$progress-bar-transition:           width .6s ease;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$variable-prefix}list-group-color);\n$list-group-bg:                     var(--#{$variable-prefix}list-group-bg);\n$list-group-border-color:           var(--#{$variable-prefix}list-group-border-color);\n$list-group-border-width:           $border-width;\n$list-group-border-radius:          $border-radius;\n\n$list-group-item-padding-y:         $spacer * .5;\n$list-group-item-padding-x:         $spacer * .8;\n$list-group-item-bg-scale:          -70%;\n$list-group-item-color-scale:       40%;\n\n$list-group-hover-bg:               var(--#{$variable-prefix}list-group-hover-bg);\n$list-group-active-color:           $component-active-color;\n$list-group-active-bg:              $component-active-bg;\n$list-group-active-border-color:    $list-group-active-bg;\n\n$list-group-disabled-color:         var(--#{$variable-prefix}list-group-disabled-color);\n$list-group-disabled-bg:            var(--#{$variable-prefix}list-group-disabled-bg);\n\n$list-group-action-color:           var(--#{$variable-prefix}list-group-action-color);\n$list-group-action-hover-color:     $list-group-action-color;\n\n$list-group-action-active-color:    var(--#{$variable-prefix}list-group-action-active-color);\n$list-group-action-active-bg:       var(--#{$variable-prefix}list-group-action-active-bg);\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem;\n$thumbnail-bg:                      var(--#{$variable-prefix}thumbnail-bg);\n$thumbnail-border-width:            $border-width;\n$thumbnail-border-color:            var(--#{$variable-prefix}thumbnail-border-color);\n$thumbnail-border-radius:           $border-radius;\n$thumbnail-box-shadow:              var(--#{$variable-prefix}thumbnail-box-shadow);\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size;\n$figure-caption-color:              var(--#{$variable-prefix}figure-caption-color);\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null;\n$breadcrumb-padding-y:              $spacer * 1;\n$breadcrumb-padding-x:              0;\n$breadcrumb-item-padding-x:         .5rem;\n$breadcrumb-margin-bottom:          1rem;\n$breadcrumb-bg:                     null;\n$breadcrumb-divider-color:          var(--#{$variable-prefix}breadcrumb-divider-color);\n$breadcrumb-active-color:           var(--#{$variable-prefix}breadcrumb-active-color);\n$breadcrumb-divider:                quote(\"\\F0142\");\n$breadcrumb-divider-flipped:        $breadcrumb-divider;\n$breadcrumb-border-radius:          null;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             var(--#{$variable-prefix}carousel-control-color);\n$carousel-control-width:             15%;\n$carousel-control-opacity:           .5;\n$carousel-control-hover-opacity:     .9;\n$carousel-control-transition:        opacity .15s ease;\n\n$carousel-indicator-width:           30px;\n$carousel-indicator-height:          3px;\n$carousel-indicator-hit-area-height: 10px;\n$carousel-indicator-spacer:          3px;\n$carousel-indicator-opacity:         .5;\n$carousel-indicator-active-bg:       var(--#{$variable-prefix}carousel-indicator-active-bg);\n$carousel-indicator-active-opacity:  1;\n$carousel-indicator-transition:      opacity .6s ease;\n\n$carousel-caption-width:             70%;\n$carousel-caption-color:             var(--#{$variable-prefix}carousel-caption-color);\n$carousel-caption-padding-y:         1.25rem;\n$carousel-caption-spacer:            1.25rem;\n\n$carousel-control-icon-width:        2rem;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\n\n$carousel-transition-duration:       .6s;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  var(--#{$variable-prefix}carousel-dark-indicator-active-bg);\n$carousel-dark-caption-color:        var(--#{$variable-prefix}carousel-dark-caption-color);\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100);\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem;\n$spinner-height:          $spinner-width;\n$spinner-vertical-align:  -.125em;\n$spinner-border-width:    .25em;\n$spinner-animation-speed: .75s;\n\n$spinner-width-sm:        1rem;\n$spinner-height-sm:       $spinner-width-sm;\n$spinner-border-width-sm: .2em;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em;\n$btn-close-height:           $btn-close-width;\n$btn-close-padding-x:        .25em;\n$btn-close-padding-y:        $btn-close-padding-x;\n$btn-close-color:            var(--#{$variable-prefix}btn-close-color);\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#8b96a0'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n$btn-close-focus-shadow:     none;\n$btn-close-opacity:          1;\n$btn-close-hover-opacity:    .8;\n$btn-close-focus-opacity:    1;\n$btn-close-disabled-opacity: .25;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%);\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding;\n$offcanvas-padding-x:               $modal-inner-padding;\n$offcanvas-horizontal-width:        400px;\n$offcanvas-vertical-height:         30vh;\n$offcanvas-transition-duration:     .3s;\n$offcanvas-border-color:            $modal-content-border-color;\n$offcanvas-border-width:            $modal-content-border-width;\n$offcanvas-title-line-height:       $modal-title-line-height;\n$offcanvas-bg-color:                $modal-content-bg;\n$offcanvas-color:                   $modal-content-color;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    87.5%;\n$code-color:                        var(--#{$variable-prefix}code-color);\n\n$kbd-padding-y:                     .2rem;\n$kbd-padding-x:                     .4rem;\n$kbd-font-size:                     $code-font-size;\n$kbd-color:                         var(--#{$variable-prefix}kbd-color);\n$kbd-bg:                            var(--#{$variable-prefix}kbd-bg);\n\n$pre-color:                         null;\n\n\n// scss-docs-start pre-variables\n// SCSS variable (for Bootstrap)\n$link-color: #0d6efd;\n$link-hover-color: #0a58ca;\n \n// Optional CSS variables (for runtime use)\n:root {\n  --ct-link-color: #{$link-color};\n  --ct-link-hover-color: #{$link-hover-color};\n}","// \n// light-mode.scss\n// \n\n\n:root {\n\n    // <=============================================>\n    // Bootstrap variable\n    // <=============================================>\n\n    // Link Variable\n    --#{$variable-prefix}link-color:                                    #{$primary};\n    --#{$variable-prefix}link-hover-color:                              #{shade-color($primary, $link-shade-percentage)};\n\n    // Border Variable\n    --#{$variable-prefix}border-color:                                  #{map-get($grays, \"300\")};\n\n    // scss-docs-start box-shadow-variables\n    --#{$variable-prefix}box-shadow:                                    0px 0px 35px 0px #{rgba(154, 161, 171, 0.15)};\n    --#{$variable-prefix}box-shadow-sm:                                 0 .125rem .25rem #{rgba($black, .075)};\n    --#{$variable-prefix}box-shadow-lg:                                 0 0 45px 0 #{rgba(0, 0, 0, 0.12)};\n    --#{$variable-prefix}box-shadow-inset:                              inset 0 1px 2px #{rgba($black, .075)};\n\n    // scss-docs-end box-shadow-variables\n    --#{$variable-prefix}component-active-color:                        #{$white};\n    --#{$variable-prefix}component-active-bg:                           #{$primary};\n\n    // scss-docs-start type-variables\n    --#{$variable-prefix}text-muted:                                    #{map-get($grays, \"600\")};\n    --#{$variable-prefix}blockquote-footer-color:                       #{map-get($grays, \"600\")};\n\n    --#{$variable-prefix}mark-bg:                                       #fcf8e3;\n\n    // scss-docs-start table-variables\n    --#{$variable-prefix}table-color:                                    #{$body-color};\n    --#{$variable-prefix}table-bg:                                       transparent;\n    --#{$variable-prefix}table-accent-bg:                                transparent;\n    --#{$variable-prefix}table-striped-color:                            #{map-get($grays, \"700\")};\n    --#{$variable-prefix}table-striped-bg:                               #{rgba(map-get($grays, '100'), 0.8)};\n    --#{$variable-prefix}table-active-color:                             #{$table-color};\n    --#{$variable-prefix}table-active-bg:                                #{rgba(map-get($grays, '300'), $table-active-bg-factor)};\n    --#{$variable-prefix}table-hover-color:                              #{$table-color};\n    --#{$variable-prefix}table-hover-bg:                                 #{map-get($grays, \"100\")};\n    --#{$variable-prefix}table-border-color:                             #{map-get($grays, \"200\")};\n    --#{$variable-prefix}table-group-separator-color:                    #{lighten(map-get($grays, \"300\"), 5%)};\n    --#{$variable-prefix}table-caption-color:                            #{$text-muted};\n\n    // scss-docs-start input-btn-variables\n    --#{$variable-prefix}input-btn-focus-color:                          #{rgba($primary, .25)};\n\n    // scss-docs-start btn-variables\n    --#{$variable-prefix}btn-active-box-shadow:                          inset 0 3px 5px #{rgba($black, .125)};\n    --#{$variable-prefix}btn-link-color:                                 #{$link-color};\n    --#{$variable-prefix}btn-link-hover-color:                           #{$link-hover-color};\n    --#{$variable-prefix}btn-link-disabled-color:                        #{map-get($grays, \"500\")};\n\n    // scss-docs-start form-text-variables\n    --#{$variable-prefix}form-text-color:                                #{$text-muted};\n\n    // scss-docs-start form-input-variables\n    --#{$variable-prefix}input-bg:                                       #{$white};\n    --#{$variable-prefix}input-disabled-bg:                              #{map-get($grays, \"200\")};\n    --#{$variable-prefix}input-color:                                    #{$body-color};\n    --#{$variable-prefix}input-border-color:                             #{map-get($grays, \"300\")};\n    --#{$variable-prefix}input-box-shadow:                               #{$box-shadow-inset};\n    --#{$variable-prefix}input-focus-bg:                                 #{$input-bg};\n    --#{$variable-prefix}input-focus-border-color:                       #{shade-color(map-get($grays, \"300\"),10%)};\n    --#{$variable-prefix}input-focus-color:                              #{$input-color};\n    --#{$variable-prefix}input-placeholder-color:                        #{map-get($grays, \"500\")};\n    --#{$variable-prefix}input-plaintext-color:                          #{$body-color};\n\n    // scss-docs-start form-check-variables\n    --#{$variable-prefix}form-check-input-bg:                            #{$white};\n    --#{$variable-prefix}form-check-input-border:                        #{$border-width solid (map-get($grays, \"300\"))};\n    --#{$variable-prefix}form-check-input-checked-color:                 #{$component-active-color};\n    --#{$variable-prefix}form-check-input-checked-bg-color:              #{$component-active-bg};\n    --#{$variable-prefix}form-check-input-checked-border-color:          #{$form-check-input-checked-bg-color};\n    --#{$variable-prefix}form-check-input-indeterminate-color:           #{$component-active-color};\n    --#{$variable-prefix}form-check-input-indeterminate-bg-color:        #{$component-active-bg};\n    --#{$variable-prefix}form-check-input-indeterminate-border-color:    #{$form-check-input-indeterminate-bg-color};\n\n    // scss-docs-start form-switch-variables\n    --#{$variable-prefix}form-switch-color:                              #{map-get($grays, \"300\")};\n\n    // scss-docs-start input-group-variables\n    --#{$variable-prefix}input-group-addon-color:                        #{$input-color};\n    --#{$variable-prefix}input-group-addon-bg:                           #{map-get($grays, \"200\")};\n    --#{$variable-prefix}input-group-addon-border-color:                 #{map-get($grays, \"300\")};\n\n    // scss-docs-start form-select-variables\n    --#{$variable-prefix}form-select-color:                              #{$input-color};\n    --#{$variable-prefix}form-select-bg:                                 #{$input-bg};\n    --#{$variable-prefix}form-select-disabled-color:                     #{map-get($grays, \"600\")};\n    --#{$variable-prefix}form-select-disabled-bg:                        #{map-get($grays, \"200\")};\n    --#{$variable-prefix}form-select-indicator-color:                    #{map-get($grays, \"800\")};\n\n    // scss-docs-start form-range-variables\n    --#{$variable-prefix}form-range-track-bg:                            #{map-get($grays, \"300\")};\n    --#{$variable-prefix}form-range-track-box-shadow:                    #{$box-shadow-inset};\n    --#{$variable-prefix}form-range-thumb-box-shadow:                    0 .1rem .25rem #{rgba($black, .1)};\n    --#{$variable-prefix}form-range-thumb-active-bg:                     #{tint-color($primary, 70%)};\n    --#{$variable-prefix}form-range-thumb-disabled-bg:                   #{map-get($grays, \"500\")};\n\n    // scss-docs-start form-file-variables\n    --#{$variable-prefix}form-file-button-color:                         #{$input-color};\n    --#{$variable-prefix}form-file-button-bg:                            #{map-get($grays, \"200\")};\n    --#{$variable-prefix}form-file-button-hover-bg:                      #{shade-color(map-get($grays, \"200\"), 5%)};\n\n    // scss-docs-start nav-variables\n    --#{$variable-prefix}nav-link-disabled-color:                        #{map-get($grays, \"600\")};\n    --#{$variable-prefix}nav-tabs-border-color:                          #{map-get($grays, \"300\")};\n    --#{$variable-prefix}nav-tabs-link-hover-border-color:               #{map-get($grays, \"200\")} #{map-get($grays, \"200\")} #{$nav-tabs-border-color};\n    --#{$variable-prefix}nav-tabs-link-active-color:                     #{shade-color(map-get($grays, \"700\"), 20%)};\n    --#{$variable-prefix}nav-tabs-link-active-bg:                        #{$white};\n    --#{$variable-prefix}nav-tabs-link-active-border-color:              #{map-get($grays, \"300\") map-get($grays, \"300\") $nav-tabs-link-active-bg};\n   \n    // scss-docs-start navbar-theme-variables\n    --#{$variable-prefix}navbar-dark-color:                              #{rgba($white, .55)};\n    --#{$variable-prefix}navbar-dark-hover-color:                        #{rgba($white, .75)};\n    --#{$variable-prefix}navbar-dark-active-color:                       #{$white};\n    --#{$variable-prefix}navbar-dark-disabled-color:                     #{rgba($white, .25)};\n    --#{$variable-prefix}navbar-dark-toggler-border-color:               #{rgba($white, .1)};\n    --#{$variable-prefix}navbar-light-color:                             #{shade-color(map-get($grays, \"700\"),5%)};\n    --#{$variable-prefix}navbar-light-hover-color:                       #{map-get($grays, \"800\")};\n    --#{$variable-prefix}navbar-light-active-color:                      #{rgba($black, .9)};\n    --#{$variable-prefix}navbar-light-disabled-color:                    #{map-get($grays, \"500\")};\n\n    // scss-docs-start dropdown-variables\n    --#{$variable-prefix}dropdown-color:                                 #{$body-color};\n    --#{$variable-prefix}dropdown-bg:                                    #{$white};\n    --#{$variable-prefix}dropdown-border-color:                          #{shade-color($light, 3%)};\n    --#{$variable-prefix}dropdown-divider-bg:                            #{shade-color($light, 3%)};\n    --#{$variable-prefix}dropdown-box-shadow:                            #{$box-shadow};\n    --#{$variable-prefix}dropdown-link-color:                            #{$body-color};\n    --#{$variable-prefix}dropdown-link-hover-color:                      #{shade-color(map-get($grays, \"900\"), 10%)};\n    --#{$variable-prefix}dropdown-link-hover-bg:                         #{tint-color(map-get($grays, \"100\"), 22%)};\n    --#{$variable-prefix}dropdown-link-active-color:                     #{$dark};\n    --#{$variable-prefix}dropdown-link-active-bg:                        #{tint-color($light, 24%)};\n    --#{$variable-prefix}dropdown-link-disabled-color:                   #{map-get($grays, \"600\")};\n\n    // scss-docs-start dropdown-dark-variables\n    --#{$variable-prefix}dropdown-dark-color:                            #{map-get($grays, \"300\")};\n    --#{$variable-prefix}dropdown-dark-bg:                               #{map-get($grays, \"800\")};\n    --#{$variable-prefix}dropdown-dark-border-color:                     #{$dropdown-border-color};\n    --#{$variable-prefix}dropdown-dark-divider-bg:                       #{$dropdown-divider-bg};\n    --#{$variable-prefix}dropdown-dark-link-color:                       #{$dropdown-dark-color};\n    --#{$variable-prefix}dropdown-dark-link-hover-color:                 #{$white};\n    --#{$variable-prefix}dropdown-dark-link-hover-bg:                    #{rgba($white, .15)};\n    --#{$variable-prefix}dropdown-dark-link-active-color:                #{$dropdown-link-active-color};\n    --#{$variable-prefix}dropdown-dark-link-active-bg:                   #{$dropdown-link-active-bg};\n    --#{$variable-prefix}dropdown-dark-link-disabled-color:              #{map-get($grays, \"500\")};\n    --#{$variable-prefix}dropdown-dark-header-color:                     #{map-get($grays, \"500\")};\n\n    // scss-docs-start pagination-variables\n    --#{$variable-prefix}pagination-color:                               #{$dark};\n    --#{$variable-prefix}pagination-bg:                                  #{$white};\n    --#{$variable-prefix}pagination-border-color:                        #{map-get($grays, \"300\")};\n    --#{$variable-prefix}pagination-focus-color:                         #{$link-hover-color};\n    --#{$variable-prefix}pagination-focus-bg:                            #{map-get($grays, \"200\")};\n    --#{$variable-prefix}pagination-focus-box-shadow:                    #{$input-btn-focus-box-shadow};\n    --#{$variable-prefix}pagination-hover-color:                         #{$dark};\n    --#{$variable-prefix}pagination-hover-bg:                            #{map-get($grays, \"200\")};\n    --#{$variable-prefix}pagination-hover-border-color:                  #{map-get($grays, \"300\")};\n    --#{$variable-prefix}pagination-disabled-color:                      #{map-get($grays, \"600\")};\n    --#{$variable-prefix}pagination-disabled-bg:                         #{$white};\n    --#{$variable-prefix}pagination-disabled-border-color:               #{map-get($grays, \"300\")};\n\n    // scss-docs-start card-variables\n    --#{$variable-prefix}card-border-color:                              #{rgba($black, .125)};\n    --#{$variable-prefix}card-box-shadow:                                #{$box-shadow};\n    --#{$variable-prefix}card-cap-bg:                                    #{$white};\n    --#{$variable-prefix}card-bg:                                        #{$white};\n\n    // scss-docs-start accordion-variables\n    --#{$variable-prefix}accordion-color:                                #{$body-color};\n    --#{$variable-prefix}accordion-border-color:                         #{rgba($black, .125)};\n    --#{$variable-prefix}accordion-button-active-bg:                     #{tint-color($primary, 90%)};\n    --#{$variable-prefix}accordion-button-active-color:                  #{shade-color($primary, 10%)};\n    --#{$variable-prefix}accordion-button-focus-border-color:            #{$input-focus-border-color};\n    --#{$variable-prefix}accordion-button-focus-box-shadow:              #{$btn-focus-box-shadow};\n\n    // scss-docs-start tooltip-variables\n    --#{$variable-prefix}tooltip-color:                                  #{map-get($grays, \"100\")};\n    --#{$variable-prefix}tooltip-bg:                                     #{map-get($grays, \"800\")};\n\n    // scss-docs-start popover-variables\n    --#{$variable-prefix}popover-bg:                                     #{$white};\n    --#{$variable-prefix}popover-border-color:                           #{map-get($grays, \"300\")};\n    --#{$variable-prefix}popover-header-bg:                              #{map-get($grays, \"100\")};\n    --#{$variable-prefix}popover-header-color:                           #{$headings-color};\n    --#{$variable-prefix}popover-body-color:                             #{$body-color};\n    --#{$variable-prefix}popover-arrow-color:                            #{$white};\n    --#{$variable-prefix}popover-arrow-outer-color:                      #{map-get($grays, \"400\")};\n\n    // scss-docs-start toast-variables\n    --#{$variable-prefix}toast-background-color:                         #{rgba($white, .85)};\n    --#{$variable-prefix}toast-border-color:                             #{rgba(map-get($grays, \"900\"), .1)};\n    --#{$variable-prefix}toast-header-background-color:                  #{rgba($white, .85)};\n    --#{$variable-prefix}toast-header-border-color:                      #{rgba(map-get($grays, \"900\"), .05)};\n\n    // scss-docs-start badge-variables\n    --#{$variable-prefix}badge-color:                                    #{$white};\n\n    // scss-docs-start modal-variables\n    --#{$variable-prefix}modal-content-bg:                               #{$white};\n    --#{$variable-prefix}modal-content-box-shadow-xs:                    #{$box-shadow-sm};\n    --#{$variable-prefix}modal-content-box-shadow-sm-up:                 #{$box-shadow};\n    --#{$variable-prefix}modal-backdrop-bg:                              #{map-get($grays, \"900\")};\n    --#{$variable-prefix}modal-header-border-color:                      #{$border-color};\n    --#{$variable-prefix}modal-footer-border-color:                      #{$border-color};\n\n    // scss-docs-start progress-variables\n    --#{$variable-prefix}progress-bg:                                    #{map-get($grays, \"200\")};\n    --#{$variable-prefix}progress-box-shadow:                            #{$box-shadow-inset};\n    --#{$variable-prefix}progress-bar-color:                             #{$white};\n    --#{$variable-prefix}progress-bar-bg:                                #{$primary};\n\n    // scss-docs-start list-group-variables\n    --#{$variable-prefix}list-group-color:                               #{map-get($grays, \"900\")};\n    --#{$variable-prefix}list-group-bg:                                  #{$white};\n    --#{$variable-prefix}list-group-border-color:                        #{map-get($grays, \"200\")};\n    --#{$variable-prefix}list-group-hover-bg:                            #{map-get($grays, \"100\")};\n    --#{$variable-prefix}list-group-disabled-color:                      #{map-get($grays, \"700\")};\n    --#{$variable-prefix}list-group-disabled-bg:                         #{tint-color(map-get($grays, \"100\"),30%)};\n    --#{$variable-prefix}list-group-action-color:                        #{map-get($grays, \"700\")};\n    --#{$variable-prefix}list-group-action-active-color:                 #{$body-color};\n    --#{$variable-prefix}list-group-action-active-bg:                    #{map-get($grays, \"200\")};\n\n    // scss-docs-start thumbnail-variables\n    --#{$variable-prefix}thumbnail-bg:                                   #{$white};\n    --#{$variable-prefix}thumbnail-border-color:                         #{map-get($grays, \"300\")};\n    --#{$variable-prefix}thumbnail-box-shadow:                           #{$box-shadow-sm};\n\n    // scss-docs-start figure-variables\n    --#{$variable-prefix}figure-caption-color:                           #{map-get($grays, \"600\")};\n\n    // scss-docs-start breadcrumb-variables\n    --#{$variable-prefix}breadcrumb-divider-color:                       #{map-get($grays, \"400\")};\n    --#{$variable-prefix}breadcrumb-active-color:                        #{map-get($grays, \"500\")};\n\n    // scss-docs-start carousel-variables\n    --#{$variable-prefix}carousel-control-color:                         #{$white};\n    --#{$variable-prefix}carousel-indicator-active-bg:                   #{$white};\n    --#{$variable-prefix}carousel-caption-color:                         #{$white};\n    --#{$variable-prefix}carousel-dark-indicator-active-bg:              #{$black};\n    --#{$variable-prefix}carousel-dark-caption-color:                    #{$black};\n\n    // scss-docs-start close-variables\n    --#{$variable-prefix}btn-close-color:                                #{map-get($grays, \"900\")};\n\n    // Code\n    --#{$variable-prefix}code-color:                                     #{$cyan};\n\n    --#{$variable-prefix}kbd-color:                                      #{$white};\n    --#{$variable-prefix}kbd-bg:                                         #{map-get($grays, \"900\")};\n    --#{$variable-prefix}pre-color:                                      #{null};\n\n\n    \n    // <=============================================>\n    // Custome variable\n    // <=============================================>\n\n    // Left Sidebar\n    --#{$variable-prefix}bg-leftbar:                      #{$white};\n\n    // Menu\n    --#{$variable-prefix}menu-item:                       #{map-get($grays, \"700\")};\n    --#{$variable-prefix}menu-item-hover:                 #{$primary};\n    --#{$variable-prefix}menu-item-active:                #{$primary};\n\n    // Topbar\n    --#{$variable-prefix}bg-topbar:                       #{$white};\n    --#{$variable-prefix}bg-topbar-search:                #{map-get($grays, \"100\")};\n    --#{$variable-prefix}nav-user-bg-topbar:              #3c4655;\n    --#{$variable-prefix}nav-user-border-topbar:          #414d5d;\n\n    // Dark Topbar\n    --#{$variable-prefix}bg-dark-topbar:                  #313a46;\n    --#{$variable-prefix}bg-dark-topbar-search:           #3c4655;\n    --#{$variable-prefix}nav-user-bg-dark-topbar:         #3c4655;\n    --#{$variable-prefix}nav-user-border-dark-topbar:     #414d5d;\n\n\n\n    // Rightbar Width\n    --#{$variable-prefix}rightbar-bg:                     #{$white};\n    --#{$variable-prefix}rightbar-title-bg:               #{map-get($grays, \"900\")};\n    --#{$variable-prefix}rightbar-title-color:            #{$white};\n    --#{$variable-prefix}rightbar-title-btn-bg:           #444e5a;\n    --#{$variable-prefix}rightbar-title-btn-color:        #{$white};\n    --#{$variable-prefix}rightbar-overlay-bg:             #37404a;\n\n    // Deatched left sidenav\n    --#{$variable-prefix}bg-detached-leftbar:             #{$white};\n\n    // Background left-sidebar\n    --#{$variable-prefix}bg-leftbar-gradient:             #{linear-gradient(135deg, #8f75da 0%, #727cf5 60%)};\n    --#{$variable-prefix}bg-topnav:                       #313a46;\n\n    // Boxed Layout\n    --#{$variable-prefix}boxed-layout-bg:                 #{$white};\n\n    // Helpbox\n    --#{$variable-prefix}help-box-light-bg:               #{rgba($white, 0.07)};\n    --#{$variable-prefix}help-box-dark-bg:                #{$primary};\n\n    // Nav-pill background\n    --#{$variable-prefix}nav-pills-bg:                    #eef2f7;\n\n    // Custom-accordion\n    --#{$variable-prefix}custom-accordion-title-color:    #{map-get($grays, \"900\")};\n\n    // Dragula demo background\n    --#{$variable-prefix}dragula-bg:                      #f7f9fb;\n\n    // Form wizard header background\n    --#{$variable-prefix}form-wizard-header-bg:           #eef2f7;\n\n    // Text title color\n    --#{$variable-prefix}text-title-color:                #6c757d;\n\n    // Page title color\n    --#{$variable-prefix}page-title-color:                #{map-get($grays, \"700\")};\n\n    // card Loader background\n    --#{$variable-prefix}card-loader-bg:                  #{map-get($grays, \"900\")};\n\n    // Chat widget\n    --#{$variable-prefix}chat-primary-user-bg:            #fef5e4;\n    --#{$variable-prefix}chat-secondary-user-bg:          #f1f3fa;\n\n    // User authentication Background\n    --#{$variable-prefix}auth-bg:                         #{$white};\n\n    // Apex chart\n    --#{$variable-prefix}apex-grid-color:                 #f9f9fd;\n\n    // Hero\n    --#{$variable-prefix}hero-bg:                         #{linear-gradient(to bottom,#8669ed,#727cf5)};\n}\n\nbody[data-leftbar-theme=\"dark\"] {\n    // Left Sidebar\n   --#{$variable-prefix}bg-leftbar:                       #{map-get($grays, \"900\")};\n\n   // Menu\n   --#{$variable-prefix}dark-menu-item:                   #8391a2;\n   --#{$variable-prefix}dark-menu-item-hover:             #bccee4;\n   --#{$variable-prefix}dark-menu-item-active:            #{$white};\n}\n\n\n\nbody[data-leftbar-theme=\"default\"] {\n    // Menu\n--#{$variable-prefix}menu-item:                           #cedce4;\n--#{$variable-prefix}menu-item-hover:                     #{$white};\n--#{$variable-prefix}menu-item-active:                    #{$white};\n}\n\n","//\n// dark-mode.scss\n//\n\n// Dark Variable\n\n// Dark Grays\n$dark-grays: (\n     \"100\": #404954,\n     \"200\": #37404a,\n     \"300\": #464f5b,\n     \"400\": #8391a2,\n     \"500\": #aab8c5,\n     \"600\": #ced4da,\n     \"700\": #dee2e6,\n     \"800\": #e3eaef,\n     \"900\": #f1f1f1,\n);\n\n// Dark Theme Color Map\n$dark-theme-colors: (\n     \"primary\": $primary,\n     \"secondary\": map-get($dark-grays, \"600\"),\n     \"success\": $success,\n     \"info\": $info,\n     \"warning\": $warning,\n     \"danger\": $danger,\n     \"light\": map-get($dark-grays, \"300\"),\n     \"dark\": map-get($dark-grays, \"900\"),\n);\n\n// Theme Color RGB\n$dark-theme-colors-rgb: map-loop($dark-theme-colors, to-rgb, \"$value\");\n\n// Dark Utilities Color\n$dark-utilities-colors: $dark-theme-colors-rgb;\n\n// Dark Utilities Text\n$dark-utilities-text: map-merge(\n     $dark-utilities-colors,\n     (\n          \"black\": to-rgb($black),\n          \"white\": to-rgb($white),\n          \"body\": to-rgb($body-color),\n     )\n);\n$dark-utilities-text-colors: map-loop($dark-utilities-text, rgba-css-var, \"$key\", \"text\");\n\n// Dark Utilities Bg Color\n$dark-utilities-bg: map-merge(\n     $dark-utilities-colors,\n     (\n          \"black\": to-rgb($black),\n          \"white\": to-rgb($white),\n          \"body\": to-rgb($body-bg),\n     )\n);\n$dark-utilities-bg-colors: map-loop($dark-utilities-bg, rgba-css-var, \"$key\", \"bg\");\n\nbody[data-layout-color=\"dark\"] {\n     // <=============================================>\n     // Bootstrap variable\n     // <=============================================>\n\n     // Body Variable\n     --#{$variable-prefix}body-bg: #343a40;\n     --#{$variable-prefix}body-color: #{map-get($dark-grays, \"500\")};\n\n     // Link Variable\n     --#{$variable-prefix}link-color: #{$primary};\n     --#{$variable-prefix}link-hover-color: #{shade-color($primary, $link-shade-percentage)};\n\n     // Border Variable\n     --#{$variable-prefix}border-color: #{map-get($dark-grays, \"300\")};\n\n     // scss-docs-start box-shadow-variables\n     --#{$variable-prefix}box-shadow: 0px 0px 35px 0px #{rgba(49, 57, 66, 0.5)};\n     --#{$variable-prefix}box-shadow-sm: 0 0.125rem 0.25rem #{rgba($black, 0.075)};\n     --#{$variable-prefix}box-shadow-lg: 0 0 45px 0 #{rgba(0, 0, 0, 0.12)};\n     --#{$variable-prefix}box-shadow-inset: inset 0 1px 2px #{rgba($black, 0.075)};\n\n     // scss-docs-end box-shadow-variables\n     --#{$variable-prefix}component-active-color: #{$white};\n     --#{$variable-prefix}component-active-bg: #{$primary};\n\n     // scss-docs-start type-variables\n     --#{$variable-prefix}text-muted: #{map-get($dark-grays, \"400\")};\n     --#{$variable-prefix}blockquote-footer-color: #{map-get($dark-grays, \"600\")};\n\n     --#{$variable-prefix}mark-bg: #fcf8e3;\n\n     // scss-docs-start table-variables\n     --#{$variable-prefix}table-color: #{map-get($dark-grays, \"500\")};\n     --#{$variable-prefix}table-bg: transparent;\n     --#{$variable-prefix}table-accent-bg: transparent;\n     --#{$variable-prefix}table-striped-color: #{map-get($dark-grays, \"500\")};\n     --#{$variable-prefix}table-striped-bg: #{rgba(map-get($dark-grays, \"100\"), 0.8)};\n     --#{$variable-prefix}table-active-color: #{$table-color};\n     --#{$variable-prefix}table-active-bg: #{rgba(map-get($dark-grays, \"300\"), $table-active-bg-factor)};\n     --#{$variable-prefix}table-hover-color: #{$table-color};\n     --#{$variable-prefix}table-hover-bg: #{map-get($dark-grays, \"100\")};\n     --#{$variable-prefix}table-border-color: #{map-get($dark-grays, \"300\")};\n     --#{$variable-prefix}table-group-separator-color: #{lighten(map-get($dark-grays, \"300\"), 5%)};\n     --#{$variable-prefix}table-caption-color: #{$text-muted};\n\n     // scss-docs-start input-btn-variables\n     --#{$variable-prefix}input-btn-focus-color: #{rgba($primary, 0.25)};\n\n     // scss-docs-start btn-variables\n     --#{$variable-prefix}btn-active-box-shadow: inset 0 3px 5px #{rgba($black, 0.125)};\n     --#{$variable-prefix}btn-link-color: #{$link-color};\n     --#{$variable-prefix}btn-link-hover-color: #{$link-hover-color};\n     --#{$variable-prefix}btn-link-disabled-color: #{map-get($dark-grays, \"500\")};\n\n     // scss-docs-start form-text-variables\n     --#{$variable-prefix}form-text-color: #{$text-muted};\n\n     // scss-docs-start form-input-variables\n     --#{$variable-prefix}input-bg: #{map-get($dark-grays, \"100\")};\n     --#{$variable-prefix}input-disabled-bg: #{map-get($dark-grays, \"200\")};\n     --#{$variable-prefix}input-color: #{map-get($dark-grays, \"800\")};\n     --#{$variable-prefix}input-border-color: #{tint-color(map-get($dark-grays, \"100\"), 5%)};\n     --#{$variable-prefix}input-box-shadow: #{$box-shadow-inset};\n     --#{$variable-prefix}input-focus-bg: #{lighten(map-get($dark-grays, \"100\"), 2.5%)};\n     --#{$variable-prefix}input-focus-border-color: #{lighten(tint-color(map-get($dark-grays, \"100\"), 5%), 5%)};\n     --#{$variable-prefix}input-focus-color: #{$input-color};\n     --#{$variable-prefix}input-placeholder-color: #{map-get($dark-grays, \"400\")};\n     --#{$variable-prefix}input-plaintext-color: #{$body-color};\n\n     // scss-docs-start form-check-variables\n     --#{$variable-prefix}form-check-input-bg: transparent;\n     --#{$variable-prefix}form-check-input-border: #{$border-width} solid #{tint-color(map-get($dark-grays, \"100\"), 5%)};\n     --#{$variable-prefix}form-check-input-checked-color: #{$component-active-color};\n     --#{$variable-prefix}form-check-input-checked-bg-color: #{$component-active-bg};\n     --#{$variable-prefix}form-check-input-checked-border-color: #{$form-check-input-checked-bg-color};\n     --#{$variable-prefix}form-check-input-indeterminate-color: #{$component-active-color};\n     --#{$variable-prefix}form-check-input-indeterminate-bg-color: #{$component-active-bg};\n     --#{$variable-prefix}form-check-input-indeterminate-border-color: #{$form-check-input-indeterminate-bg-color};\n\n     // scss-docs-start form-switch-variables\n     --#{$variable-prefix}form-switch-color: #{tiny-color(map-get($dark-grays, \"300\"), 6%)};\n\n     // scss-docs-start input-group-variables\n     --#{$variable-prefix}input-group-addon-color: #{$input-color};\n     --#{$variable-prefix}input-group-addon-bg: #{tint-color(map-get($dark-grays, \"300\"), 1%)};\n     --#{$variable-prefix}input-group-addon-border-color: #{$input-border-color};\n\n     // scss-docs-start form-select-variables\n     --#{$variable-prefix}form-select-color: #{$input-color};\n     --#{$variable-prefix}form-select-bg: #{$input-bg};\n     --#{$variable-prefix}form-select-disabled-color: #{map-get($dark-grays, \"600\")};\n     --#{$variable-prefix}form-select-disabled-bg: #{map-get($dark-grays, \"200\")};\n     --#{$variable-prefix}form-select-indicator-color: #{map-get($dark-grays, \"800\")};\n\n     // scss-docs-start form-range-variables\n     --#{$variable-prefix}form-range-track-bg: #{map-get($dark-grays, \"300\")};\n     --#{$variable-prefix}form-range-track-box-shadow: inset 0 0.25rem 0.25rem #{rgba($black, 0.1)};\n     --#{$variable-prefix}form-range-thumb-box-shadow: 0 0.1rem 0.25rem #{rgba($black, 0.1)};\n     --#{$variable-prefix}form-range-thumb-active-bg: #{tint-color($primary, 70%)};\n     --#{$variable-prefix}form-range-thumb-disabled-bg: #{map-get($dark-grays, \"500\")};\n\n     // scss-docs-start form-file-variables\n     --#{$variable-prefix}form-file-button-color: #{$input-color};\n     --#{$variable-prefix}form-file-button-bg: #{tint-color(map-get($dark-grays, \"300\"), 1%)};\n     --#{$variable-prefix}form-file-button-hover-bg: #{shade-color(map-get($dark-grays, \"300\"), 5%)};\n\n     // scss-docs-start nav-variables\n     --#{$variable-prefix}nav-link-disabled-color: #{map-get($dark-grays, \"600\")};\n     --#{$variable-prefix}nav-tabs-border-color: #{map-get($dark-grays, \"300\")};\n     --#{$variable-prefix}nav-tabs-link-hover-border-color: #{map-get($dark-grays, \"200\")} #{map-get(\n               $dark-grays,\n               \"200\"\n          )} #{$nav-tabs-border-color};\n     --#{$variable-prefix}nav-tabs-link-active-color: #{map-get($dark-grays, \"800\")};\n     --#{$variable-prefix}nav-tabs-link-active-bg: #{tint-color(map-get($dark-grays, \"100\"), 5%)};\n     --#{$variable-prefix}nav-tabs-link-active-border-color: #{map-get($dark-grays, \"300\") map-get($dark-grays, \"300\")\n          $nav-tabs-link-active-bg};\n\n     // scss-docs-start navbar-theme-variables\n     --#{$variable-prefix}navbar-dark-color: #{rgba($white, 0.55)};\n     --#{$variable-prefix}navbar-dark-hover-color: #{rgba($white, 0.75)};\n     --#{$variable-prefix}navbar-dark-active-color: #{$white};\n     --#{$variable-prefix}navbar-dark-disabled-color: #{rgba($white, 0.25)};\n     --#{$variable-prefix}navbar-dark-toggler-border-color: #{rgba($white, 0.1)};\n     --#{$variable-prefix}navbar-light-color: #{shade-color(map-get($dark-grays, \"700\"), 5%)};\n     --#{$variable-prefix}navbar-light-hover-color: #{map-get($dark-grays, \"800\")};\n     --#{$variable-prefix}navbar-light-active-color: #{rgba($white, 0.9)};\n     --#{$variable-prefix}navbar-light-disabled-color: #{map-get($dark-grays, \"500\")};\n\n     // scss-docs-start dropdown-variables\n     --#{$variable-prefix}dropdown-color: #{map-get($dark-grays, \"500\")};\n     --#{$variable-prefix}dropdown-bg: #{tint-color(map-get($dark-grays, \"200\"), 2%)};\n     --#{$variable-prefix}dropdown-border-color: #{tint-color(map-get($dark-grays, \"200\"), 6%)};\n     --#{$variable-prefix}dropdown-divider-bg: #{tint-color(map-get($dark-grays, \"300\"), 4%)};\n     --#{$variable-prefix}dropdown-box-shadow: #{$box-shadow};\n     --#{$variable-prefix}dropdown-link-color: #{map-get($dark-grays, \"500\")};\n     --#{$variable-prefix}dropdown-link-hover-color: #{shade-color(map-get($dark-grays, \"900\"), 10%)};\n     --#{$variable-prefix}dropdown-link-hover-bg: #{tint-color(map-get($dark-grays, \"300\"), 1%)};\n     --#{$variable-prefix}dropdown-link-active-color: #{$white};\n     --#{$variable-prefix}dropdown-link-active-bg: #{tint-color(map-get($dark-grays, \"300\"), 28%)};\n     --#{$variable-prefix}dropdown-link-disabled-color: #{map-get($dark-grays, \"600\")};\n\n     // scss-docs-start dropdown-dark-variables\n     --#{$variable-prefix}dropdown-dark-color: #{map-get($dark-grays, \"300\")};\n     --#{$variable-prefix}dropdown-dark-bg: #{map-get($dark-grays, \"800\")};\n     --#{$variable-prefix}dropdown-dark-border-color: #{$dropdown-border-color};\n     --#{$variable-prefix}dropdown-dark-divider-bg: #{$dropdown-divider-bg};\n     --#{$variable-prefix}dropdown-dark-link-color: #{$dropdown-dark-color};\n     --#{$variable-prefix}dropdown-dark-link-hover-color: #{$white};\n     --#{$variable-prefix}dropdown-dark-link-hover-bg: #{rgba($white, 0.15)};\n     --#{$variable-prefix}dropdown-dark-link-active-color: #{$dropdown-link-active-color};\n     --#{$variable-prefix}dropdown-dark-link-active-bg: #{$dropdown-link-active-bg};\n     --#{$variable-prefix}dropdown-dark-link-disabled-color: #{map-get($dark-grays, \"500\")};\n     --#{$variable-prefix}dropdown-dark-header-color: #{map-get($dark-grays, \"500\")};\n\n     // scss-docs-start pagination-variables\n     --#{$variable-prefix}pagination-color: #{map-get($dark-grays, \"400\")};\n     --#{$variable-prefix}pagination-bg: #{tint-color(map-get($dark-grays, \"200\"), 4%)};\n     --#{$variable-prefix}pagination-border-color: #{map-get($dark-grays, \"300\")};\n     --#{$variable-prefix}pagination-focus-color: #{$link-hover-color};\n     --#{$variable-prefix}pagination-focus-bg: #{map-get($dark-grays, \"200\")};\n     --#{$variable-prefix}pagination-focus-box-shadow: #{$input-btn-focus-box-shadow};\n     --#{$variable-prefix}pagination-hover-color: #{map-get($dark-grays, \"900\")};\n     --#{$variable-prefix}pagination-hover-bg: #{tint-color(map-get($dark-grays, \"200\"), 8%)};\n     --#{$variable-prefix}pagination-hover-border-color: #{map-get($dark-grays, \"300\")};\n     --#{$variable-prefix}pagination-disabled-color: #{map-get($dark-grays, \"400\")};\n     --#{$variable-prefix}pagination-disabled-bg: #{lighten(tint-color(map-get($dark-grays, \"200\"), 4%), 5%)};\n     --#{$variable-prefix}pagination-disabled-border-color: #{lighten(tint-color(map-get($dark-grays, \"200\"), 4%), 5%)};\n\n     // scss-docs-start card-variables\n     --#{$variable-prefix}card-border-color: #{rgba($black, 0.125)};\n     --#{$variable-prefix}card-box-shadow: #{$box-shadow};\n     --#{$variable-prefix}card-cap-bg: #{map-get($dark-grays, \"300\")};\n     --#{$variable-prefix}card-bg: #{map-get($dark-grays, \"200\")};\n\n     // scss-docs-start accordion-variables\n     --#{$variable-prefix}accordion-color: #{$body-color};\n     --#{$variable-prefix}accordion-border-color: #{rgba($black, 0.125)};\n     --#{$variable-prefix}accordion-button-active-bg: #{tint-color($primary, 90%)};\n     --#{$variable-prefix}accordion-button-active-color: #{shade-color($primary, 10%)};\n     --#{$variable-prefix}accordion-button-focus-border-color: #{$input-focus-border-color};\n     --#{$variable-prefix}accordion-button-focus-box-shadow: #{$btn-focus-box-shadow};\n\n     // scss-docs-start tooltip-variables\n     --#{$variable-prefix}tooltip-color: #{map-get($dark-grays, \"200\")};\n     --#{$variable-prefix}tooltip-bg: #{map-get($dark-grays, \"700\")};\n\n     // scss-docs-start popover-variables\n     --#{$variable-prefix}popover-bg: #{map-get($dark-grays, \"200\")};\n     --#{$variable-prefix}popover-border-color: #{map-get($dark-grays, \"300\")};\n     --#{$variable-prefix}popover-header-bg: #{lighten(map-get($dark-grays, \"200\"), 2.5%)};\n     --#{$variable-prefix}popover-header-color: #{map-get($dark-grays, \"700\")};\n     --#{$variable-prefix}popover-body-color: #{map-get($dark-grays, \"700\")};\n     --#{$variable-prefix}popover-arrow-color: #{map-get($dark-grays, \"200\")};\n     --#{$variable-prefix}popover-arrow-outer-color: #{map-get($dark-grays, \"300\")};\n\n     // scss-docs-start toast-variables\n     --#{$variable-prefix}toast-background-color: #{map-get($dark-grays, \"100\")};\n     --#{$variable-prefix}toast-border-color: #{rgba(map-get($dark-grays, \"900\"), 0.12)};\n     --#{$variable-prefix}toast-header-background-color: #{rgba(map-get($dark-grays, \"100\"), 0.2)};\n     --#{$variable-prefix}toast-header-border-color: #{rgba(map-get($dark-grays, \"900\"), 0.05)};\n\n     // scss-docs-start badge-variables\n     --#{$variable-prefix}badge-color: #{$white};\n\n     // scss-docs-start modal-variables\n     --#{$variable-prefix}modal-content-bg: #{tint-color(map-get($dark-grays, \"200\"), 2%)};\n     --#{$variable-prefix}modal-content-box-shadow-xs: #{$box-shadow-sm};\n     --#{$variable-prefix}modal-content-box-shadow-sm-up: #{$box-shadow};\n     --#{$variable-prefix}modal-backdrop-bg: #{map-get($dark-grays, \"500\")};\n     --#{$variable-prefix}modal-header-border-color: #{lighten(map-get($dark-grays, \"300\"), 5%)};\n     --#{$variable-prefix}modal-footer-border-color: #{lighten(map-get($dark-grays, \"300\"), 5%)};\n\n     // scss-docs-start progress-variables\n     --#{$variable-prefix}progress-bg: #{map-get($dark-grays, \"300\")};\n     --#{$variable-prefix}progress-box-shadow: #{$box-shadow-inset};\n     --#{$variable-prefix}progress-bar-color: #{$white};\n     --#{$variable-prefix}progress-bar-bg: #{$primary};\n\n     // scss-docs-start list-group-variables\n     --#{$variable-prefix}list-group-color: #{map-get($dark-grays, \"900\")};\n     --#{$variable-prefix}list-group-bg: #{$card-bg};\n     --#{$variable-prefix}list-group-border-color: #{tint-color(map-get($dark-grays, \"300\"), 4%)};\n     --#{$variable-prefix}list-group-hover-bg: #{map-get($dark-grays, \"100\")};\n     --#{$variable-prefix}list-group-disabled-color: #{map-get($dark-grays, \"400\")};\n     --#{$variable-prefix}list-group-disabled-bg: #{map-get($dark-grays, \"100\")};\n     --#{$variable-prefix}list-group-action-color: #{map-get($dark-grays, \"500\")};\n     --#{$variable-prefix}list-group-action-active-color: #{map-get($dark-grays, \"700\")};\n     --#{$variable-prefix}list-group-action-active-bg: #{map-get($dark-grays, \"100\")};\n\n     // scss-docs-start thumbnail-variables\n     --#{$variable-prefix}thumbnail-bg: #{map-get($dark-grays, \"300\")};\n     --#{$variable-prefix}thumbnail-border-color: #{map-get($dark-grays, \"300\")};\n     --#{$variable-prefix}thumbnail-box-shadow: #{$box-shadow-sm};\n\n     // scss-docs-start figure-variables\n     --#{$variable-prefix}figure-caption-color: #{map-get($dark-grays, \"600\")};\n\n     // scss-docs-start breadcrumb-variables\n     --#{$variable-prefix}breadcrumb-divider-color: #{map-get($dark-grays, \"400\")};\n     --#{$variable-prefix}breadcrumb-active-color: #{map-get($dark-grays, \"500\")};\n\n     // scss-docs-start carousel-variables\n     --#{$variable-prefix}carousel-control-color: #{$white};\n     --#{$variable-prefix}carousel-indicator-active-bg: #{$white};\n     --#{$variable-prefix}carousel-caption-color: #{$white};\n     --#{$variable-prefix}carousel-dark-indicator-active-bg: #{$black};\n     --#{$variable-prefix}carousel-dark-caption-color: #{$black};\n\n     // scss-docs-start close-variables\n     --#{$variable-prefix}btn-close-color: #{map-get($dark-grays, \"800\")};\n\n     // Code\n     --#{$variable-prefix}code-color: #{$cyan};\n\n     --#{$variable-prefix}kbd-color: #{$white};\n     --#{$variable-prefix}kbd-bg: #{map-get($dark-grays, \"900\")};\n     --#{$variable-prefix}pre-color: #{map-get($dark-grays, \"500\")};\n\n     // <=============================================>\n     // Custome variable\n     // <=============================================>\n\n     // Left Sidebar\n     --#{$variable-prefix}bg-leftbar: #3a444e;\n\n     // Menu\n     --#{$variable-prefix}menu-item: #cedce4;\n     --#{$variable-prefix}menu-item-hover: #{$white};\n     --#{$variable-prefix}menu-item-active: #{$white};\n\n     // Topbar\n     --#{$variable-prefix}bg-topbar: #3a444e;\n     --#{$variable-prefix}bg-topbar-search: #464f5b;\n     --#{$variable-prefix}nav-user-bg-topbar: #45515d;\n     --#{$variable-prefix}nav-user-border-topbar: #4a5764;\n\n     // Dark Topbar\n     --#{$variable-prefix}bg-dark-topbar: #3a444e;\n     --#{$variable-prefix}bg-dark-topbar-search: #464f5b;\n     --#{$variable-prefix}nav-user-bg-dark-topbar: #45515d;\n     --#{$variable-prefix}nav-user-border-dark-topbar: #4a5764;\n\n     // Rightbar Width\n     --#{$variable-prefix}rightbar-bg: #37404a;\n     --#{$variable-prefix}rightbar-title-bg: #{$primary};\n     --#{$variable-prefix}rightbar-title-color: #{$white};\n     --#{$variable-prefix}rightbar-title-btn-bg: #{lighten($primary, 5%)};\n     --#{$variable-prefix}rightbar-title-btn-color: #{$white};\n     --#{$variable-prefix}rightbar-overlay-bg: #{$black};\n\n     // Deatched left sidenav\n     --#{$variable-prefix}bg-detached-leftbar: #37404a;\n\n     // Background left-sidebar\n     --#{$variable-prefix}bg-leftbar-gradient: #{linear-gradient(135deg, #8f75da 0, #727cf5 60%)};\n     --#{$variable-prefix}bg-topnav: #{linear-gradient(to bottom, #8f75da, #727cf5)};\n\n     // Boxed Layout\n     --#{$variable-prefix}boxed-layout-bg: #3e4853;\n\n     // Helpbox\n     --#{$variable-prefix}help-box-light-bg: #{rgba($white, 0.1)};\n     --#{$variable-prefix}help-box-dark-bg: #{$primary};\n\n     // Nav-pill background\n     --#{$variable-prefix}nav-pills-bg: #404954;\n\n     // Custom-accordion\n     --#{$variable-prefix}custom-accordion-title-color: #{map-get($dark-grays, \"400\")};\n\n     // Dragula demo background\n     --#{$variable-prefix}dragula-bg: #404954;\n\n     // Form wizard header background\n     --#{$variable-prefix}form-wizard-header-bg: #404954;\n\n     // Text title color\n     --#{$variable-prefix}text-title-color: #{$white};\n\n     // Page title color\n     --#{$variable-prefix}page-title-color: #{$white};\n\n     // card Loader background\n     --#{$variable-prefix}card-loader-bg: #{map-get($dark-grays, \"900\")};\n\n     // Chat widget\n     --#{$variable-prefix}chat-primary-user-bg: #404954;\n     --#{$variable-prefix}chat-secondary-user-bg: #404954;\n\n     // User authentication Background\n     --#{$variable-prefix}auth-bg: #404954;\n\n     // Apex chart\n     --#{$variable-prefix}apex-grid-color: #404954;\n\n     // Hero\n     --#{$variable-prefix}hero-bg: #{linear-gradient(to bottom, #697ded, #5e30c1)};\n}\n\nbody[data-layout-color=\"dark\"][data-layout=\"detached\"] {\n     // Menu\n     --#{$variable-prefix}menu-item: #8391a2;\n     --#{$variable-prefix}menu-item-hover: #{$primary};\n     --#{$variable-prefix}menu-item-active: #{$primary};\n}\n\nbody[data-leftbar-theme=\"light\"] {\n     // Left Sidebar\n     --#{$variable-prefix}bg-leftbar: #{$white};\n\n     // Menu\n     --#{$variable-prefix}menu-item: #{map-get($grays, \"700\")};\n     --#{$variable-prefix}menu-item-hover: #{$primary};\n     --#{$variable-prefix}menu-item-active: #{$primary};\n}\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","// \n// general.scss\n//\n\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\nbody {\n  overflow-x: hidden;\n}\n\n// Fix event bubbling on iOS devices\n@supports (-webkit-overflow-scrolling: touch) {\n  body {\n    cursor: pointer;\n  }\n}","//\n// menu.scss\n//\n\n// Logo\n.logo {\n    display: block;\n    line-height: $topbar-height;\n    width: $leftbar-width;\n    position: fixed;\n    top: 0;\n\n    span.logo-lg {\n        display: block;\n    }\n    span.logo-sm {\n        display: none;\n    }\n\n    &.logo-light {\n        display: $logo-light-display;\n    }\n    &.logo-dark {\n        display: $logo-dark-display;\n    }\n}\n\n// Wrapper\n.wrapper {\n    height: 100%;\n    // overflow: hidden;\n    width: 100%;\n}\n\n//Content Page\n.content-page {\n    margin-left: $leftbar-width;\n    // overflow: hidden;\n    // padding: 30px 25px 25px 25px;\n    min-height: 100vh;\n    // background: black !important;\n}\n\n// Left Side-menu (Default dark)\n.leftside-menu {\n    width: $leftbar-width;\n    z-index: 10;\n    background: $bg-leftbar-gradient;\n    bottom: 0;\n    position: fixed;\n    top: 0;\n    padding-top: $topbar-height;\n    box-shadow: $box-shadow;\n}\n\n// Side-nav\n.side-nav {\n    padding-left: 0;\n    list-style-type: none;\n    ul {\n        list-style-type: none;\n    }\n    .side-nav-link {\n        color: $menu-item;\n        display: block;\n        padding: 10px 30px;\n        font-size: 0.8375rem;\n        position: relative;\n        transition: all 0.4s;\n        list-style: none;\n        font-weight: 500 !important;\n\n        &:hover,\n        &:focus,\n        &:active {\n            color: $menu-item-hover;\n            text-decoration: none;\n        }\n\n        span {\n            vertical-align: middle;\n        }\n\n        i {\n            display: inline-block;\n            line-height: 1.0625rem;\n            margin: 0 10px 0 0;\n            font-size: 1.1rem;\n            vertical-align: middle;\n            width: 20px;\n        }\n    }\n\n    .menu-arrow {\n        transition: transform 0.15s;\n        position: absolute;\n        right: 30px;\n        display: inline-block;\n        font-family: 'Material Design Icons';\n        text-rendering: auto;\n        line-height: 1.5rem;\n        font-size: 1.1rem;\n        transform: translate(0, 0);\n        &:before {\n            content: '\\F0142';\n        }\n    }\n\n    .badge {\n        margin-top: 3px;\n    }\n\n    .side-nav-item {\n        > a[aria-expanded='true'] {\n            > span.menu-arrow {\n                transform: rotate(90deg);\n            }\n        }\n\n        &.menuitem-active {\n            > a:not(.collapsed) {\n                > span.menu-arrow {\n                    transform: rotate(90deg);\n                }\n            }\n        }\n    }\n\n    .side-nav-title {\n        padding: 12px 30px;\n        letter-spacing: 0.05em;\n        pointer-events: none;\n        cursor: default;\n        font-size: 0.6875rem;\n        text-transform: uppercase;\n        color: $menu-item;\n        font-weight: $font-weight-bold;\n    }\n\n    .menuitem-active {\n        > a {\n            color: $menu-item-active !important;\n        }\n    }\n}\n\n*[dir='ltr'] {\n    .side-nav {\n        .side-nav-item {\n            .menu-arrow {\n                &:before {\n                    content: '\\F0141' !important;\n                }\n            }\n        }\n    }\n}\n\n.side-nav-second-level,\n.side-nav-third-level,\n.side-nav-forth-level {\n    padding-left: 0;\n\n    li {\n        a,\n        .side-nav-link {\n            padding: 8px 30px 8px 65px;\n            color: $menu-item;\n            display: block;\n            position: relative;\n            transition: all 0.4s;\n            font-size: 0.89rem;\n            &:focus,\n            &:hover {\n                color: $menu-item-hover;\n            }\n\n            .menu-arrow {\n                line-height: 1.3rem;\n            }\n        }\n        &.active {\n            > a {\n                color: $menu-item-active;\n            }\n        }\n    }\n}\n\n.side-nav-third-level {\n    li {\n        a,\n        .side-nav-link {\n            padding: 8px 30px 8px 80px;\n        }\n    }\n}\n\n.side-nav-forth-level {\n    li {\n        a,\n        .side-nav-link {\n            padding: 8px 30px 8px 100px;\n        }\n    }\n}\n\n// Enlarge menu\nbody[data-leftbar-compact-mode='condensed']:not(.authentication-bg) {\n    min-height: 1600px;\n\n    .wrapper {\n        // Side menu\n        .leftside-menu {\n            position: absolute;\n            padding-top: 0;\n            width: 70px;\n            z-index: 5;\n            padding-top: $topbar-height;\n\n            .simplebar-mask,\n            .simplebar-content-wrapper {\n                overflow: visible !important;\n            }\n\n            .simplebar-scrollbar {\n                display: none !important;\n            }\n\n            .simplebar-offset {\n                bottom: 0 !important;\n            }\n\n            .logo {\n                width: 70px;\n                z-index: 1;\n                background: $bg-leftbar-gradient;\n            }\n        }\n\n        // Help Box\n        .help-box {\n            display: none;\n        }\n\n        // Content Page\n        .content-page {\n            margin-left: 70px;\n        }\n\n        //Navbar & Footer\n        .navbar-custom,\n        .footer {\n            left: 70px;\n        }\n    }\n\n    // Sidebar Menu\n    .side-nav {\n        .side-nav-title,\n        .badge,\n        .menu-arrow {\n            display: none !important;\n        }\n        .collapse,\n        .collapsing {\n            display: none;\n            height: inherit !important;\n            transition: none !important;\n\n            .side-nav-second-level,\n            .side-nav-third-level,\n            .side-nav-forth-level {\n                display: none !important;\n            }\n        }\n\n        .side-nav-item {\n            position: relative;\n            white-space: nowrap;\n\n            .side-nav-link {\n                padding: 15px 20px;\n                min-height: 54px;\n                transition: none;\n\n                &:hover,\n                &:active,\n                &:focus {\n                    color: $menu-item-hover;\n                }\n\n                i {\n                    font-size: 1.125rem;\n                    margin-right: 20px;\n                    margin-left: 6px;\n                }\n\n                span {\n                    display: none;\n                    padding-left: 10px;\n                }\n            }\n\n            &:hover {\n                .side-nav-link {\n                    position: relative;\n                    width: 260px;\n                    color: $white;\n                    background: $bg-leftbar-gradient;\n\n                    span {\n                        display: inline;\n                    }\n                }\n\n                > ul {\n                    display: block !important;\n                    left: 70px;\n                    position: absolute;\n                    width: 190px;\n                    height: auto !important;\n                    padding: 5px 0;\n                    z-index: 9999;\n                    background: $bg-leftbar-gradient;\n                    box-shadow: $box-shadow;\n\n                    a {\n                        padding: 8px 20px;\n                        position: relative;\n                        width: 190px;\n\n                        &:hover {\n                            color: $menu-item-hover;\n                        }\n                    }\n                }\n\n                > .collapse,\n                > .collapsing {\n                    display: block !important;\n                    transition: none !important;\n\n                    > ul {\n                        display: block !important;\n                        left: 70px;\n                        position: absolute;\n                        width: 190px;\n                        background: $bg-leftbar-gradient;\n                        box-shadow: $box-shadow;\n\n                        a {\n                            box-shadow: none;\n                            padding: 8px 20px;\n                            position: relative;\n                            width: 190px;\n                            z-index: 6;\n\n                            &:hover {\n                                color: $menu-item-hover;\n                            }\n                        }\n\n                        li {\n                            &:hover {\n                                > .collapse {\n                                    display: block !important;\n                                    height: auto !important;\n                                    transition: none !important;\n\n                                    > ul {\n                                        display: block;\n                                        left: 190px;\n                                        top: 0;\n                                        position: absolute;\n                                        width: 190px;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .logo {\n        span.logo-lg {\n            display: none;\n        }\n        span.logo-sm {\n            display: block;\n            line-height: 70px;\n            color: $primary;\n        }\n    }\n}\n\n@include media-breakpoint-down(md) {\n    body {\n        overflow-x: hidden;\n    }\n    .leftside-menu {\n        box-shadow: $box-shadow;\n        display: none;\n        z-index: 10 !important;\n    }\n    .sidebar-enable {\n        .leftside-menu {\n            display: block;\n        }\n    }\n    .navbar-nav.navbar-right {\n        float: right;\n    }\n    .content-page {\n        margin-left: 0 !important;\n        padding: 65px 10px 65px;\n    }\n    body[data-leftbar-compact-mode='condensed'] {\n        .leftside-menu {\n            margin-left: 0px;\n        }\n    }\n    .logo {\n        span.logo-lg {\n            display: block;\n        }\n        span.logo-sm {\n            display: none;\n        }\n    }\n}\n\n/// Help-box\n.help-box {\n    border-radius: 5px;\n    padding: 20px;\n    margin: 65px 25px 25px;\n    position: relative;\n    background-color: $help-box-light-bg;\n\n    .close-btn {\n        position: absolute;\n        right: 10px;\n        top: 10px;\n    }\n}\n// Light\nbody[data-leftbar-theme='light'] {\n    .help-box {\n        background-color: $primary;\n    }\n\n    .logo {\n        &.logo-light {\n            display: $logo-dark-display;\n        }\n        &.logo-dark {\n            display: $logo-light-display;\n        }\n    }\n}\n\n// Layout -topnav\nbody[data-layout='topnav'] {\n    .content-page {\n        margin-left: 0 !important;\n        padding: 0 0 60px 0;\n    }\n}\n\n// Layout-boxed\nbody[data-layout-mode='boxed'] {\n    background-color: $boxed-layout-bg;\n\n    .wrapper {\n        max-width: $boxed-layout-width;\n        margin: 0 auto;\n        background-color: $body-bg;\n        box-shadow: $box-shadow;\n    }\n\n    &[data-leftbar-compact-mode='condensed'] {\n        .logo {\n            position: relative;\n            margin-top: -$topbar-height;\n        }\n    }\n}\n\n// Scrollable Layout\n\n@include media-breakpoint-up(xl) {\n    body[data-leftbar-compact-mode='scrollable']:not([data-layout='topnav']) {\n        padding-bottom: 0;\n\n        .wrapper {\n            display: flex;\n        }\n\n        .leftside-menu {\n            position: relative;\n            min-width: $leftbar-width;\n            max-width: $leftbar-width;\n            padding-top: 0;\n        }\n\n        .logo {\n            position: relative;\n            margin-top: 0;\n        }\n\n        .content-page {\n            margin-left: 0;\n            width: 100%;\n            padding-bottom: 60px;\n        }\n    }\n}\n\n// Detached Left sidebar\n\nbody[data-layout='detached'] {\n    padding-bottom: 0;\n\n    @include media-breakpoint-up(lg) {\n        .container-fluid {\n            max-width: 95%;\n        }\n    }\n\n    &[data-layout-mode='boxed'] {\n        .wrapper {\n            max-width: 100%;\n        }\n    }\n\n    .wrapper {\n        display: flex;\n        overflow: inherit;\n    }\n    .content-page {\n        margin-left: 0;\n        overflow: hidden;\n        padding: 0 15px 5px 30px;\n        position: relative;\n        margin-right: -15px;\n        width: 100%;\n        padding-bottom: 60px;\n    }\n\n    .leftside-menu {\n        position: relative;\n        background: $bg-detached-leftbar !important;\n        min-width: $leftbar-width;\n        max-width: $leftbar-width;\n        box-shadow: $box-shadow;\n        margin-top: 30px;\n        padding-top: 0 !important;\n        z-index: 1001 !important;\n\n        .side-nav {\n            .side-nav-link {\n                color: $menu-item !important;\n                &:hover,\n                &:focus,\n                &:active {\n                    color: $menu-item-hover !important;\n                }\n            }\n\n            .side-nav-second-level,\n            .side-nav-third-level,\n            .side-nav-forth-level {\n                li {\n                    a {\n                        color: $menu-item;\n                        &:focus,\n                        &:hover {\n                            color: $menu-item-hover;\n                        }\n                    }\n                    &.mm-active {\n                        > a {\n                            color: $menu-item-active;\n                        }\n                    }\n                }\n            }\n\n            .menuitem-active {\n                > a {\n                    color: $menu-item-active !important;\n                }\n            }\n\n            .side-nav-title {\n                color: $menu-item;\n            }\n        }\n    }\n\n    .leftbar-user {\n        background: url('../../../images/waves.png') no-repeat;\n        padding: 30px 20px;\n        text-align: center;\n\n        .leftbar-user-name {\n            font-weight: 700;\n            color: #{map-get($grays, '900')};\n            margin-left: 12px;\n            margin-top: 8px;\n            display: block;\n        }\n    }\n\n    @include media-breakpoint-down(md) {\n        &.sidebar-enable {\n            .leftside-menu {\n                position: fixed;\n                left: 0;\n                overflow-y: auto;\n                margin-top: 70px;\n            }\n        }\n        .wrapper {\n            max-width: 100%;\n        }\n        .content-page {\n            margin-left: 0 !important;\n            padding: 0 10px 60px 10px;\n        }\n\n        .lang-switch {\n            display: none;\n        }\n        &[data-leftbar-compact-mode='condensed'] {\n            &.sidebar-enable {\n                .leftside-menu {\n                    margin-top: 0px;\n                }\n            }\n        }\n    }\n\n    // Enlarge menu\n    &[data-leftbar-compact-mode='condensed'] {\n        .wrapper {\n            // Side menu\n            .leftside-menu {\n                max-width: 70px;\n                min-width: 70px;\n                position: relative;\n            }\n            .leftbar-user {\n                display: none;\n            }\n\n            // Content Page\n            .content-page {\n                margin-left: 0;\n            }\n\n            //Footer\n            .footer {\n                left: 0;\n            }\n        }\n        // Sidebar Menu\n        .side-nav {\n            .side-nav-item {\n                .side-nav-link {\n                    &:hover,\n                    &:active,\n                    &:focus {\n                        color: $menu-item-hover;\n                    }\n                }\n\n                &:hover {\n                    .side-nav-link {\n                        background: $primary;\n                        color: $white !important;\n                        transition: none;\n                    }\n\n                    ul {\n                        background: $bg-leftbar !important;\n                        box-shadow: $box-shadow;\n\n                        a {\n                            &:hover {\n                                color: $menu-item-hover !important;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// reaponsive detached mode\n@include media-breakpoint-up(lg) {\n    body[data-layout='detached'] {\n        &[data-leftbar-compact-mode='scrollable'] {\n            .wrapper {\n                padding-top: 70px;\n            }\n        }\n    }\n}\n\n.button-menu-mobile {\n    .lines {\n        width: 18px;\n        display: block;\n        position: relative;\n        height: 16px;\n        transition: all 0.5s ease;\n        margin-top: 26px;\n        margin-left: 10px;\n    }\n    span {\n        height: 2px;\n        width: 100%;\n        background-color: rgba($white, 0.8);\n        display: block;\n        margin-bottom: 5px;\n        transition: transform 0.5s ease;\n\n        &:nth-of-type(2) {\n            width: 24px;\n        }\n    }\n\n    &.disable-btn {\n        display: none;\n    }\n}\n\n// Light sidebar\n\nbody[data-leftbar-theme='light'] {\n    .leftside-menu {\n        background: $bg-leftbar;\n\n        .logo {\n            background: $bg-leftbar !important;\n        }\n    }\n\n    .side-nav {\n        .side-nav-link {\n            color: $menu-item;\n            &:hover,\n            &:focus,\n            &:active {\n                color: $menu-item-hover;\n            }\n        }\n\n        .menuitem-active {\n            > a {\n                color: $menu-item-active !important;\n            }\n        }\n\n        .side-nav-title {\n            color: $menu-item;\n        }\n\n        .side-nav-second-level,\n        .side-nav-third-level,\n        .side-nav-forth-level {\n            li {\n                a {\n                    color: $menu-item;\n                    &:focus,\n                    &:hover {\n                        color: $menu-item-hover;\n                    }\n                }\n                &.active {\n                    > a {\n                        color: $menu-item-active;\n                    }\n                }\n            }\n        }\n    }\n\n    // Enlarge menu\n    &[data-leftbar-compact-mode='condensed'] {\n        // Sidebar Menu\n        .side-nav {\n            .side-nav-item {\n                .side-nav-link {\n                    &:hover,\n                    &:active,\n                    &:focus {\n                        color: $menu-item-hover;\n                    }\n                }\n\n                &:hover {\n                    .side-nav-link {\n                        background: $primary;\n                        color: $white !important;\n                        transition: none;\n                    }\n\n                    > ul {\n                        background: $bg-leftbar;\n                        box-shadow: $box-shadow;\n\n                        a {\n                            &:hover {\n                                color: $menu-item-hover;\n                            }\n                        }\n                    }\n\n                    > .collapse,\n                    > .collapsing {\n                        > ul {\n                            background: $bg-leftbar;\n\n                            a {\n                                &:hover {\n                                    color: $menu-item-hover;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Dark sidenav\nbody[data-leftbar-theme='dark'] {\n    .leftside-menu {\n        background: #313A46!important;\n\n        .logo {\n            background: #313A46!important;\n        }\n    }\n\n    .side-nav {\n        .side-nav-link {\n            color: $sidebar-dark-menu-item;\n            &:hover,\n            &:focus,\n            &:active {\n                color: $sidebar-dark-menu-item-hover;\n            }\n        }\n\n        .menuitem-active {\n            > a {\n                color: #ecac37e3 !important;\n                font-weight: 700 !important;\n            }\n        }\n\n        .side-nav-title {\n            color: $sidebar-dark-menu-item;\n        }\n\n        .side-nav-second-level,\n        .side-nav-third-level,\n        .side-nav-forth-level {\n            li {\n                a {\n                    color: $sidebar-dark-menu-item;\n                    &:focus,\n                    &:hover {\n                        color: $sidebar-dark-menu-item-hover;\n                    }\n                }\n                &.active {\n                    > a {\n                        color: $sidebar-dark-menu-item-active;\n                    }\n                }\n            }\n        }\n    }\n\n    // Enlarge menu\n    &[data-leftbar-compact-mode='condensed'] {\n        // Sidebar Menu\n        .side-nav {\n            .side-nav-item {\n                .side-nav-link {\n                    &:hover,\n                    &:active,\n                    &:focus {\n                        color: $sidebar-dark-menu-item-hover;\n                    }\n                }\n\n                &:hover {\n                    .side-nav-link {\n                        background: $primary;\n                        color: $white !important;\n                        transition: none;\n                    }\n\n                    > ul {\n                        background: $bg-leftbar;\n                        box-shadow: $box-shadow;\n\n                        a {\n                            &:hover {\n                                color: $sidebar-dark-menu-item-hover;\n                            }\n                        }\n                    }\n\n                    > .collapse,\n                    > .collapsing {\n                        > ul {\n                            background: $bg-leftbar;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// left-sidebar hide\n\nbody {\n    &[data-layout='full'] {\n        .navbar-custom {\n            .button-menu-mobile {\n                &.disable-btn {\n                    display: block;\n                }\n            }\n        }\n        &.hide-menu {\n            .wrapper {\n                .leftside-menu {\n                    width: 0 !important;\n                    padding-top: 0;\n                    .side-nav {\n                        opacity: 0.2;\n                    }\n                    .logo {\n                        width: 70px;\n                        background: $bg-leftbar-gradient !important;\n                        // transition: $transition-base;\n                        span {\n                            &.logo-lg {\n                                display: none;\n                            }\n                            &.logo-sm {\n                                display: block;\n                            }\n                        }\n                    }\n                }\n            }\n            .content-page {\n                margin-left: 0 !important;\n                .navbar-custom {\n                    left: 70px;\n                }\n                .footer {\n                    left: 0 !important;\n                }\n            }\n            &[data-leftbar-compact-mode='condensed'] {\n                .wrapper {\n                    .leftside-menu {\n                        padding-top: $topbar-height;\n                        .side-nav {\n                            transform: translateX(-50px);\n                            visibility: hidden;\n                        }\n                    }\n                }\n            }\n        }\n        &[data-leftbar-compact-mode='scrollable'] {\n            &.hide-menu {\n                .wrapper {\n                    .leftside-menu {\n                        max-width: 0px;\n                        min-width: 0px;\n                        // padding-top: 0 !important;\n                    }\n                }\n            }\n            .wrapper {\n                .leftside-menu {\n                    padding-top: 0 !important;\n                }\n            }\n        }\n        &[data-leftbar-theme='dark'] {\n            &.hide-menu {\n                .wrapper {\n                    .leftside-menu {\n                        .logo {\n                            background: $bg-leftbar !important;\n                        }\n                    }\n                }\n            }\n        }\n        &[data-leftbar-theme='light'] {\n            &.hide-menu {\n                .wrapper {\n                    .leftside-menu {\n                        .logo {\n                            background: $bg-leftbar !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Dark mode\nbody[data-layout-color='dark'] {\n    &[data-layout-mode='boxed'] {\n        .wrapper {\n            background-color: var(--#{$variable-prefix}body-bg);\n        }\n    }\n    &[data-layout='detached'] {\n        .leftbar-user {\n            .leftbar-user-name {\n                color: #{map-get($dark-grays, '900')};\n            }\n        }\n    }\n}\n","//\n// custom-variables.scss\n//\n\n\n// Left Sidebar\n$leftbar-width:                     260px;\n$bg-leftbar:                        var(--#{$variable-prefix}bg-leftbar);\n\n// Menu\n$menu-item:                         var(--#{$variable-prefix}menu-item);\n$menu-item-hover:                   var(--#{$variable-prefix}menu-item-hover);\n$menu-item-active:                  var(--#{$variable-prefix}menu-item-active);\n\n// Dark sidenav Menu item color\n$sidebar-dark-menu-item:          var(--#{$variable-prefix}dark-menu-item);\n$sidebar-dark-menu-item-hover:    var(--#{$variable-prefix}dark-menu-item-hover);\n$sidebar-dark-menu-item-active:   var(--#{$variable-prefix}dark-menu-item-active);\n\n// Topbar\n$topbar-height:                     70px;\n$bg-topbar:                         var(--#{$variable-prefix}bg-topbar);\n$bg-topbar-search:                  var(--#{$variable-prefix}bg-topbar-search);\n$nav-user-bg-topbar:                var(--#{$variable-prefix}nav-user-bg-topbar);\n$nav-user-border-topbar:            var(--#{$variable-prefix}nav-user-border-topbar);\n\n\n// Dark Topbar\n$bg-dark-topbar:                  var(--#{$variable-prefix}bg-dark-topbar);\n$bg-dark-topbar-search:           var(--#{$variable-prefix}bg-dark-topbar-search);\n$nav-user-bg-dark-topbar:         var(--#{$variable-prefix}nav-user-bg-dark-topbar);\n$nav-user-border-dark-topbar:     var(--#{$variable-prefix}nav-user-border-dark-topbar);\n\n// Rightbar Width\n$rightbar-width:                  280px;\n$rightbar-bg:                     var(--#{$variable-prefix}rightbar-bg);\n$rightbar-title-bg:               var(--#{$variable-prefix}rightbar-title-bg);\n$rightbar-title-color:            var(--#{$variable-prefix}rightbar-title-color);\n$rightbar-title-btn-bg:           var(--#{$variable-prefix}rightbar-title-btn-bg);\n$rightbar-title-btn-color:        var(--#{$variable-prefix}rightbar-title-btn-color);\n$rightbar-overlay-bg:             var(--#{$variable-prefix}rightbar-overlay-bg);\n\n// Deatched left sidenav\n$bg-detached-leftbar:             var(--#{$variable-prefix}bg-detached-leftbar);\n\n// Background left-sidebar\n$bg-leftbar-gradient:             var(--#{$variable-prefix}bg-leftbar-gradient);\n$bg-topnav:                       var(--#{$variable-prefix}bg-topnav);\n\n// Boxed Layout\n$boxed-layout-width:              1300px;\n$boxed-layout-bg:                 var(--#{$variable-prefix}boxed-layout-bg);\n\n// Helpbox\n$help-box-light-bg:               var(--#{$variable-prefix}help-box-light-bg);\n$help-box-dark-bg:                var(--#{$variable-prefix}help-box-dark-bg);\n\n// Font weight\n$font-weight-semibold:            600;\n\n// Dropdown Large\n$dropdown-lg-width:               320px;\n\n// Page title color\n$page-title-color:                var(--#{$variable-prefix}page-title-color);\n\n// Nav-pill background\n$nav-pills-bg:                    var(--#{$variable-prefix}nav-pills-bg);\n\n// Custom-accordion\n$custom-accordion-title-color:    var(--#{$variable-prefix}custom-accordion-title-color);\n\n// Dragula demo background\n$dragula-bg:                      var(--#{$variable-prefix}dragula-bg);\n\n// Form wizard header background\n$form-wizard-header-bg:           var(--#{$variable-prefix}form-wizard-header-bg);\n\n// Text title color\n$text-title-color:                var(--#{$variable-prefix}text-title-color);\n\n// card Loader background\n$card-loader-bg:                  var(--#{$variable-prefix}card-loader-bg);\n\n// Chat widget\n$chat-primary-user-bg:            var(--#{$variable-prefix}chat-primary-user-bg);\n$chat-secondary-user-bg:          var(--#{$variable-prefix}chat-secondary-user-bg);\n\n// User authentication Background\n$auth-bg:                         var(--#{$variable-prefix}auth-bg);\n$auth-bg-pattern-img:             url(\"../../../images/bg-pattern-light.svg\");\n\n// Apex chart\n$apex-grid-color:                 var(--#{$variable-prefix}apex-grid-color);\n\n// Hero\n$hero-bg:                         var(--#{$variable-prefix}hero-bg);\n\n// Logo Display\n$logo-light-display:                block;\n$logo-dark-display:                 none;\n\n// Logo auth display\n$logo-auth-light-display:                none;\n$logo-auth-dark-display:                 block;\n\n","//\n// topbar.scss\n//\n\n.navbar-custom {\n    padding: 0 $grid-gutter-width;\n    background-color: $bg-topbar;\n    box-shadow: $box-shadow;\n    // min-height: $topbar-height;\n    height:'50px!important';\n    position: fixed;\n    left: $leftbar-width;\n    top: 0;\n    right: 0;\n    z-index: 1001;\n\n    .topbar-left {\n        background-color: $bg-topbar;\n        height: $topbar-height;\n        position: fixed;\n        z-index: 1;\n        width: $leftbar-width;\n        text-align: center;\n        top: 0;\n        left: 0;\n        .logo {\n            line-height: $topbar-height;\n            i {\n                display: none;\n            }\n        }\n    }\n    .topbar-menu {\n        position: relative;\n        z-index: 1;\n\n        li {\n            float: left;\n            max-height: $topbar-height;\n\n            .show {\n                &.nav-link {\n                    color: #{map-get($grays, '700')};\n                }\n            }\n        }\n        .nav-link {\n            padding: 0;\n            color: #{map-get($grays, '600')};\n            min-width: 32px;\n            display: block;\n            text-align: center;\n            margin: 0 10px;\n            position: relative;\n        }\n    }\n\n    .app-search {\n        position: static;\n        overflow-y: hidden;\n        padding: calc(#{$topbar-height - 38px} / 2) 5px calc(#{$topbar-height - 38px} / 2) 0;\n\n        .react-select__control,\n        .react-select__menu {\n            overflow: hidden;\n            width: 320px !important;\n\n            .react-select__option {\n                &.react-select__option--is-selected {\n                    .dropdown-item {\n                        color: rgba($input-color, 0.7) !important;\n                    }\n                }\n            }\n            .react-select__value-container {\n                .react-select__placeholder {\n                    color: $input-color !important;\n                }\n                .react-select__input-container {\n                    color: $input-color !important;\n                    .react-select__input {\n                        color: $input-color !important;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.topbar-dropdown {\n    .nav-link {\n        line-height: $topbar-height;\n    }\n}\n\n/* Search */\n\n.app-search {\n    .react-select__control {\n        border: none;\n        height: $input-height;\n        padding-left: 40px;\n        background-color: $bg-topbar-search;\n        box-shadow: none;\n    }\n    .react-select__value-container {\n        padding: 0;\n    }\n    .react-select__menu {\n        margin-top: 0;\n    }\n    span.search-icon {\n        position: absolute;\n        z-index: 9;\n        font-size: 20px;\n        line-height: 38px;\n        left: 10px;\n        top: 0;\n    }\n}\n\n.app-search {\n    .form-control {\n        border: none;\n        height: $input-height;\n        padding-left: 40px;\n        padding-right: 20px;\n        background-color: $bg-topbar-search;\n        box-shadow: none;\n    }\n    span.search-icon {\n        position: absolute;\n        z-index: 4;\n        font-size: 20px;\n        line-height: 38px;\n        left: 10px;\n        top: 0;\n    }\n    .input-group-text {\n        margin-left: 0;\n        z-index: 4;\n    }\n}\n\n/* Notification */\n.notification-list {\n    margin-left: 0;\n\n    .noti-title {\n        background-color: transparent;\n        padding: 15px 20px;\n    }\n\n    .noti-icon {\n        font-size: 22px;\n        vertical-align: middle;\n        line-height: $topbar-height;\n    }\n\n    .noti-icon-badge {\n        display: inline-block;\n        position: absolute;\n        top: 22px;\n        right: 6px;\n        border-radius: 50%;\n        height: 7px;\n        width: 7px;\n        background-color: $danger;\n    }\n\n    .notify-item {\n        padding: 10px 20px;\n        &.unread-noti {\n            background-color: #{tint-color(map-get($grays, '100'), 15%)};\n        }\n        &.read-noti {\n            background-color: transparent;\n            border: #{$border-width} solid #{map-get($grays, '200')};\n        }\n        .card-body {\n            padding: 14px;\n            .noti-close-btn {\n                position: absolute;\n                top: 3px;\n                right: 5px;\n            }\n            .noti-item-title {\n                margin: 0 0 2px;\n            }\n            .noti-item-title,\n            .noti-item-subtitle {\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n            }\n        }\n\n        .notify-icon {\n            float: left;\n            height: 36px;\n            width: 36px;\n            line-height: 36px;\n            text-align: center;\n            border-radius: 50%;\n            color: $white;\n        }\n\n        .notify-details {\n            margin-bottom: 0;\n            overflow: hidden;\n            margin-left: 45px;\n\n            b {\n                font-weight: 500;\n            }\n            small {\n                display: block;\n            }\n        }\n\n        .user-msg {\n            margin-left: 45px;\n            white-space: normal;\n            line-height: 16px;\n        }\n    }\n    .topbar-dropdown-menu {\n        .notify-item {\n            padding: 7px 20px;\n        }\n    }\n}\n\n.profile-dropdown {\n    min-width: 170px;\n\n    i,\n    span {\n        vertical-align: middle;\n    }\n}\n\n.nav-user {\n    padding: calc(0px * 0.5) 0px calc(0px * 0.5) 61px !important;\n    text-align: left !important;\n    position: relative;\n    // background-color: #{lighten(map-get($grays, \"100\"), 2.5%)};\n    // border: #{($border-width) solid map-get($grays, '100')};\n    border-width: 0 1px;\n    // min-height: $topbar-height;\n\n    .account-user-avatar {\n        position: absolute;\n        top: calc(#{$topbar-height -8px} * 0.5);\n        left: 15px;\n\n        img {\n            height: 32px;\n            width: 32px;\n        }\n    }\n    .account-position {\n        display: block;\n        font-size: 12px;\n        margin-top: -3px;\n    }\n    .account-user-name {\n        display: block;\n        font-weight: $font-weight-semibold;\n    }\n}\n\n.button-menu-mobile {\n    border: none;\n    color: #{map-get($grays, '900')};\n    height: $topbar-height;\n    line-height: $topbar-height;\n    width: 60px;\n    background-color: transparent;\n    font-size: 24px;\n    cursor: pointer;\n    float: left;\n    z-index: 1;\n    position: relative;\n    margin-left: -$grid-gutter-width;\n\n    &.disable-btn {\n        display: none;\n    }\n\n    @include media-breakpoint-down(md) {\n        margin: 0 !important;\n    }\n}\n\n[data-keep-enlarged='true'] {\n    .navbar-custom {\n        padding-left: 0;\n    }\n\n    .button-menu-mobile {\n        margin: 0;\n\n        &.disable-btn {\n            display: inline-block;\n        }\n    }\n}\n\n@media (max-width: 576px) {\n    .navbar-custom {\n        .topbar-menu {\n            position: initial;\n        }\n\n        .dropdown {\n            position: static;\n\n            .dropdown-menu {\n                left: 10px !important;\n                right: 10px !important;\n            }\n        }\n    }\n}\n\n@media (max-width: 1200px) {\n    .navbar-custom {\n        right: 0;\n\n        .app-search {\n            display: none;\n        }\n    }\n}\n\n@include media-breakpoint-down(lg) {\n    .nav-user {\n        padding: 17px 5px 17px 57px !important;\n\n        .account-position,\n        .account-user-name {\n            display: none;\n        }\n    }\n}\n\n@include media-breakpoint-down(md) {\n    .navbar-custom {\n        left: 0 !important;\n        padding: 0;\n    }\n    .button-menu-mobile {\n        &.disable-btn {\n            display: inline-block;\n        }\n    }\n}\n\n@media (max-width: 375px) {\n    .navbar-custom {\n        .topbar-menu {\n            .nav-link {\n                margin: 0 5px;\n            }\n        }\n\n        &.topnav-navbar {\n            .container-fluid {\n                padding-right: 12px;\n                padding-left: 12px;\n            }\n            .navbar-toggle {\n                margin: 27px 3px;\n            }\n            .button-menu-mobile {\n                width: auto;\n            }\n        }\n    }\n}\n\n// Scrollable Layout\n\n@include media-breakpoint-up(lg) {\n    body[data-leftbar-compact-mode='scrollable']:not([data-layout-mode='boxed']):not([data-layout='topnav']) {\n        .navbar-custom {\n            position: absolute;\n        }\n    }\n}\n\n// Topbar Dark\n.topnav-navbar-dark {\n    background-color: $bg-dark-topbar;\n\n    .nav-user {\n        background-color: $nav-user-bg-dark-topbar !important;\n        border: 1px solid $nav-user-border-dark-topbar !important;\n    }\n\n    .topbar-menu {\n        li {\n            .show {\n                &.nav-link {\n                    color: $white !important;\n                }\n            }\n        }\n    }\n\n    .app-search {\n        .react-select__control {\n            background-color: $bg-dark-topbar-search;\n            color: $white;\n        }\n        .react-select__input {\n            color: $white;\n        }\n        span,\n        .react-select__placeholder {\n            color: #{map-get($grays, '600')};\n        }\n    }\n\n    .navbar-toggle {\n        span {\n            background-color: rgba($white, 0.8) !important;\n        }\n    }\n}\n\nbody[data-layout-mode='boxed'] {\n    .navbar-custom {\n        position: relative;\n        left: 0 !important;\n        margin: -$topbar-height (-$grid-gutter-width * 0.5) 0;\n    }\n\n    &[data-layout='topnav'] {\n        .navbar-custom {\n            margin: 0;\n        }\n    }\n}\n\n// Dark mode\nbody[data-layout-color='dark'] {\n    .navbar-custom {\n        .topbar-menu {\n            li {\n                .show {\n                    &.nav-link {\n                        color: #{map-get($dark-grays, '700')};\n                    }\n                }\n            }\n            .nav-link {\n                color: #{map-get($dark-grays, '600')};\n            }\n        }\n    }\n    .notification-list {\n        .notify-item {\n            &.unread-noti {\n                background-color: #{tint-color(map-get($dark-grays, '300'), 1%)};\n            }\n            &.read-noti {\n                border: #{$border-width} solid #{map-get($dark-grays, '300')};\n            }\n        }\n    }\n\n    .button-menu-mobile {\n        color: #{map-get($dark-grays, '900')};\n    }\n\n    .nav-user {\n        background-color: #{lighten(map-get($dark-grays, '100'), 2.5%)};\n        border: #{($border-width) solid map-get($dark-grays, '100')};\n    }\n\n    .topnav-navbar-dark {\n        .app-search {\n            span,\n            .react-select__placeholder {\n                color: #{map-get($dark-grays, '600')};\n            }\n        }\n    }\n}\n","// \n// right-sidebar.scss\n//\n\n/* rtl:begin:options: {\n  \"autoRename\": true,\n  \"stringMap\":[]\n} */\n\n.end-bar {\n    background-color: $rightbar-bg;\n    box-shadow: 0 0 24px 0 rgba($dark, 0.1), 0 1px 0 0 rgba($dark, 0.08);\n    display: block;\n    position: fixed;\n    transition: all 200ms ease-out;\n    width: $rightbar-width;\n    z-index: 9999;\n    float: right !important;\n    right: -($rightbar-width + 10px);\n    top: 0;\n    bottom: 0;\n    padding-bottom: 80px;\n\n    .rightbar-title {\n        background-color: $rightbar-title-bg;\n        padding: 27px 25px;\n        color: $rightbar-title-color;\n    }\n    .end-bar-toggle {\n        background-color: $rightbar-title-btn-bg;\n        height: 24px;\n        width: 24px;\n        line-height: 22px;\n        color: $rightbar-title-btn-color;\n        text-align: center;\n        border-radius: 50%;\n        margin-top: -4px;\n    }\n}\n\n.rightbar-overlay {\n    background-color: $rightbar-overlay-bg;\n    opacity: 0.2;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 9998;\n    transition: all .2s ease-out;\n}\n\n.end-bar-enabled {\n    .end-bar {\n        right: 0;\n    }\n    .rightbar-overlay {\n        display: block;\n    }\n}\n\n\n@include media-breakpoint-down(md) {\n    .end-bar {\n        overflow: auto;\n    }\n}","// \n// page-head.scss\n//\n\n.page-title-box {\n    .page-title {\n        font-size: 18px;\n        margin: 0;\n        line-height: 75px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        color: $page-title-color;\n    }\n    .page-title-right {\n        float: right;\n        margin-top: 20px;\n    }\n\n    .breadcrumb {\n        padding-top: 8px;\n    }\n}\n\n.page-title-box-sm {\n    .page-title {\n        line-height: 1 !important;\n        margin-bottom: 25px;\n    }\n    .page-title-right {\n        float: right;\n        margin-top: 0;\n    }\n\n    .breadcrumb {\n        padding-top: 0;\n        margin-top: -3px !important;\n    }\n}\n\n\n.text-title {\n    color: $text-title-color;\n\n    &:hover {\n        color: $text-title-color;\n    }\n}\n\n@include media-breakpoint-down(md) {\n    .page-title-box {\n        .page-title {\n            display: block;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            line-height: 70px;\n        }\n        .breadcrumb {\n            display: none;\n        }\n        .page-title-right {\n            display: none;\n        }\n    }\n}\n\n@media (max-width: 419px) {\n    .page-title-box .breadcrumb {\n        display: none;\n    }\n}","// \n// horizontal-nav.scss\n//\n\n.topnav-navbar  {\n    padding: 0;\n    margin: 0;\n    min-height: 70px;\n    position: relative;\n    left: 0 !important;\n    z-index: 1002;\n\n    .topnav-logo {\n        line-height: 70px;\n        float: left;\n        padding-right: 20px;\n        min-width: 160px;\n\n        .topnav-logo-sm {\n            display: none;\n        }\n    }\n\n    .navbar-toggle {\n        position: relative;\n        cursor: pointer;\n        float: left;\n        margin: 27px 20px;\n        padding: 0;\n        background-color: transparent;\n        border: none;\n\n        .lines {\n            width: 25px;\n            display: block;\n            position: relative;\n            height: 16px;\n            transition: all .5s ease;\n        }\n        span {\n            height: 2px;\n            width: 100%;\n            background-color: rgba($dark, 0.8);\n            display: block;\n            margin-bottom: 5px;\n            transition: transform .5s ease;\n        }\n        &.open {\n            span {\n                position: absolute;\n                &:first-child {\n                    top: 7px;\n                    transform: rotate(45deg);\n                }\n                &:nth-child(2) {\n                    visibility: hidden;\n                }\n                &:last-child {\n                    width: 100%;\n                    top: 7px;\n                    transform: rotate(-45deg);\n                }\n            }\n        }\n    }\n\n    .app-search {\n        float: left;\n    }\n}\n\n.topnav {\n    background: $bg-topnav;\n\n    .topnav-menu {\n        margin: 0;\n        padding: 0;\n    }\n    .navbar-nav {\n        .nav-link {\n            font-size: .9375rem;\n            position: relative;\n            padding: 1rem 1.3rem;\n        }\n    }\n    .nav-item {\n        &.active {\n            > a {\n                color: $menu-item-active;\n            }\n        }\n    }\n    .navbar-dark {\n        .dropdown {\n            &.active, &:active {\n                >.nav-link {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n\n.arrow-down {\n    display: inline-block;\n\n    &:after {\n        border-color: initial;\n        border-style: solid;\n        border-width: 0 0 1px 1px;\n        content: \"\";\n        height: .4em;\n        display: inline-block;\n        right: 5px;\n        top: 50%;\n        margin-left: 10px;\n        transform: rotate(-45deg) translateY(-50%);\n        transform-origin: top;\n        transition: all .3s ease-out;\n        width: .4em;\n    }\n}\n\nbody[data-layout=\"topnav\"] {\n    .container-fluid {\n        padding-right: $grid-gutter-width;\n        padding-left: $grid-gutter-width;\n    }\n}\n\n@include media-breakpoint-up(lg) {\n    body[data-layout=\"topnav\"] {\n        .container-fluid {\n            max-width: 95%;\n        }\n        &[data-layout-mode=\"boxed\"]{\n            .container-fluid {\n                max-width: 97%;\n            }\n        }\n    }\n\n    .topnav {\n        .navbar-nav {\n            .nav-item {\n                &:first-of-type {\n                    .nav-link {\n                        padding-left: 0;\n                    }\n                }\n            }\n        }\n        .dropdown {\n            .dropdown-menu  {\n                margin-top: 0;\n                border-radius: 0 0 $dropdown-border-radius $dropdown-border-radius;\n                min-width: calc(#{$dropdown-min-width} + 1.5rem);\n                @include font-size(calc(#{$dropdown-font-size} - 0.01rem));\n\n                .arrow-down {\n                    &::after {\n                        right: 15px;\n                        transform: rotate(-135deg) translateY(-50%);\n                        position: absolute;\n                    }\n                }\n\n                .dropdown  {\n                    .dropdown-menu  {\n                        position: absolute;\n                        top: 0;\n                        left: 100%;\n                        display: none\n                    }\n                }\n            }\n\n            &:hover {\n                > .dropdown-menu {\n                    display: block;\n                }\n            }\n        }\n        .dropdown:hover > .dropdown-menu >.dropdown:hover > .dropdown-menu {\n            display: block\n        }\n    }\n    \n    .dropdown.active > a.dropdown-item {\n        color: $dropdown-link-active-color;\n        @include gradient-bg($dropdown-link-active-bg);\n    }\n}\n\n@include media-breakpoint-up(xxl) {\n    body[data-layout=\"topnav\"] {\n        .container-fluid {\n            max-width: 85%;\n        }\n    }\n}\n\n@include media-breakpoint-up(lg) {\n    .navbar-toggle {\n        display: none;\n    }\n}\n\n@include media-breakpoint-down(lg) {\n    .topnav-navbar  {\n        .topnav-logo-lg {\n            display: none;\n        }\n        .topnav-logo {\n            min-width: 50px;\n            padding-right: 0;\n            text-align: center;\n        }\n        .topnav-logo-sm {\n            display: block !important;\n        }\n    }\n\n    .topnav {\n        .navbar-nav {\n            .nav-link {\n                padding: 0.75rem 1.3rem;\n            }\n        }\n        .dropdown {\n            .dropdown-menu  {\n                background-color: transparent;\n                border: none;\n                box-shadow: none;\n                padding-left: 15px;\n            }\n            .dropdown-item {\n                position: relative;\n                background-color: transparent;\n            }\n        }\n        .navbar-dark {\n            .dropdown {\n                .dropdown-item {\n                    color: rgba($white, 0.5);\n    \n                    &.active, &:active {\n                        color: $white;\n                    }\n                }\n            }\n        }\n        .arrow-down {\n            &::after {\n                right: 15px;\n                position: absolute;\n            }\n        }\n    }\n}","//\n// Nunito fonts\n//\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('../../../fonts/Nunito-Light.eot');\n  src: local('Nunito Light'), local('Nunito-Light'), url('../../../fonts/Nunito-Light.eot?#iefix') format('embedded-opentype'), url('../../../fonts/Nunito-Light.woff') format('woff'), url('../../../fonts/Nunito-Light.ttf') format('truetype'), url('../../../fonts/Nunito-Light.svg#Roboto') format('svg');\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('../../../fonts/Nunito-Regular.eot');\n  src: local('Nunito Regular'), local('Nunito-Regular'), url('../../../fonts/Nunito-Regular.eot?#iefix') format('embedded-opentype'), url('../../../fonts/Nunito-Regular.woff') format('woff'), url('../../../fonts/Nunito-Regular.ttf') format('truetype'), url('../../../fonts/Nunito-Regular.svg#Roboto') format('svg');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('../../../fonts/Nunito-SemiBold.eot');\n  src: local('Nunito SemiBold'), local('Nunito-SemiBold'), url('../../../fonts/Nunito-SemiBold.eot?#iefix') format('embedded-opentype'), url('../../../fonts/Nunito-SemiBold.woff') format('woff'), url('../../../fonts/Nunito-SemiBold.ttf') format('truetype'), url('../../../fonts/Nunito-SemiBold.svg#Roboto') format('svg');\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('../../../fonts/Nunito-Bold.eot');\n  src: local('Nunito Bold'), local('Nunito-Bold'), url('../../../fonts/Nunito-Bold.eot?#iefix') format('embedded-opentype'), url('../../../fonts/Nunito-Bold.woff') format('woff'), url('../../../fonts/Nunito-Bold.ttf') format('truetype'), url('../../../fonts/Nunito-Bold.svg#Roboto') format('svg');\n  font-weight: 700;\n  font-style: normal;\n}","/*\nTemplate Name: Hyper - Responsive Bootstrap 5 Admin Dashboard\nVersion: 1.6.0\nAuthor: CoderThemes\nEmail: support@coderthemes.com\nFile: Icons Css File\n*/\n\n// Icons\n@import \"custom/plugins/icons\";","@font-face {\n  font-family: 'unicons';\n  src: url('../../../../fonts/unicons.eot?34404611');\n  src: url('../../../../fonts/unicons.eot?34404611#iefix') format('embedded-opentype'),\n       url('../../../../fonts/unicons.woff2?34404611') format('woff2'),\n       url('../../../../fonts/unicons.woff?34404611') format('woff'),\n       url('../../../../fonts/unicons.ttf?34404611') format('truetype'),\n       url('../../../../fonts/unicons.svg?34404611#unicons') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */\n/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */\n/*\n@media screen and (-webkit-min-device-pixel-ratio:0) {\n  @font-face {\n    font-family: 'unicons';\n    src: url('../font/unicons.svg?34404611#unicons') format('svg');\n  }\n}\n*/\n \n [class^=\"uil-\"]:before, [class*=\" uil-\"]:before {\n  font-family: \"unicons\";\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n  display: inline-block;\n  text-decoration: inherit;\n  text-align: center;\n  /* For safety - reset parent styles, that can break glyph codes*/\n  font-variant: normal;\n  text-transform: none;\n \n  /* fix buttons height, for twitter bootstrap */\n  line-height: 1em;\n \n  /* you can be more comfortable with increased icons size */\n  /* font-size: 120%; */\n \n  /* Font smoothing. That was taken from TWBS */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n \n  /* Uncomment for 3D effect */\n  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */\n}\n \n.uil-0-plus:before { content: '\\e800'; } /* '' */\n.uil-10-plus:before { content: '\\e801'; } /* '' */\n.uil-12-plus:before { content: '\\e802'; } /* '' */\n.uil-13-plus:before { content: '\\e803'; } /* '' */\n.uil-16-plus:before { content: '\\e804'; } /* '' */\n.uil-17-plus:before { content: '\\e805'; } /* '' */\n.uil-18-plus:before { content: '\\e806'; } /* '' */\n.uil-21-plus:before { content: '\\e807'; } /* '' */\n.uil-3-plus:before { content: '\\e808'; } /* '' */\n.uil-500px:before { content: '\\e809'; } /* '' */\n.uil-6-plus:before { content: '\\e80a'; } /* '' */\n.uil-abacus:before { content: '\\e80b'; } /* '' */\n.uil-accessible-icon-alt:before { content: '\\e80c'; } /* '' */\n.uil-adjust-alt:before { content: '\\e80d'; } /* '' */\n.uil-adjust-circle:before { content: '\\e80e'; } /* '' */\n.uil-adjust-half:before { content: '\\e80f'; } /* '' */\n.uil-adjust:before { content: '\\e810'; } /* '' */\n.uil-adobe:before { content: '\\e811'; } /* '' */\n.uil-airplay:before { content: '\\e812'; } /* '' */\n.uil-align-alt:before { content: '\\e813'; } /* '' */\n.uil-align-center-alt:before { content: '\\e814'; } /* '' */\n.uil-align-center-h:before { content: '\\e815'; } /* '' */\n.uil-align-center-justify:before { content: '\\e816'; } /* '' */\n.uil-align-center-v:before { content: '\\e817'; } /* '' */\n.uil-align-center:before { content: '\\e818'; } /* '' */\n.uil-align-justify:before { content: '\\e819'; } /* '' */\n.uil-align-left-justify:before { content: '\\e81a'; } /* '' */\n.uil-align-left:before { content: '\\e81b'; } /* '' */\n.uil-align-letter-right:before { content: '\\e81c'; } /* '' */\n.uil-align-right-justify:before { content: '\\e81d'; } /* '' */\n.uil-align-right:before { content: '\\e81e'; } /* '' */\n.uil-align:before { content: '\\e81f'; } /* '' */\n.uil-ambulance:before { content: '\\e820'; } /* '' */\n.uil-analysis:before { content: '\\e821'; } /* '' */\n.uil-analytics:before { content: '\\e822'; } /* '' */\n.uil-anchor:before { content: '\\e823'; } /* '' */\n.uil-android-phone-slash:before { content: '\\e824'; } /* '' */\n.uil-angle-double-down:before { content: '\\e825'; } /* '' */\n.uil-angle-double-left:before { content: '\\e826'; } /* '' */\n.uil-angle-double-right:before { content: '\\e827'; } /* '' */\n.uil-angle-double-up:before { content: '\\e828'; } /* '' */\n.uil-angle-down:before { content: '\\e829'; } /* '' */\n.uil-angle-left:before { content: '\\e82a'; } /* '' */\n.uil-angle-right-b:before { content: '\\e82b'; } /* '' */\n.uil-angle-right:before { content: '\\e82c'; } /* '' */\n.uil-angle-up:before { content: '\\e82d'; } /* '' */\n.uil-angry:before { content: '\\e82e'; } /* '' */\n.uil-ankh:before { content: '\\e82f'; } /* '' */\n.uil-annoyed-alt:before { content: '\\e830'; } /* '' */\n.uil-annoyed:before { content: '\\e831'; } /* '' */\n.uil-apple:before { content: '\\e832'; } /* '' */\n.uil-apps:before { content: '\\e833'; } /* '' */\n.uil-archive-alt:before { content: '\\e834'; } /* '' */\n.uil-archive:before { content: '\\e835'; } /* '' */\n.uil-archway:before { content: '\\e836'; } /* '' */\n.uil-arrow-break:before { content: '\\e837'; } /* '' */\n.uil-arrow-circle-down:before { content: '\\e838'; } /* '' */\n.uil-arrow-circle-left:before { content: '\\e839'; } /* '' */\n.uil-arrow-circle-right:before { content: '\\e83a'; } /* '' */\n.uil-arrow-circle-up:before { content: '\\e83b'; } /* '' */\n.uil-arrow-compress-h:before { content: '\\e83c'; } /* '' */\n.uil-arrow-down-left:before { content: '\\e83d'; } /* '' */\n.uil-arrow-down-right:before { content: '\\e83e'; } /* '' */\n.uil-arrow-down:before { content: '\\e83f'; } /* '' */\n.uil-arrow-from-right:before { content: '\\e840'; } /* '' */\n.uil-arrow-from-top:before { content: '\\e841'; } /* '' */\n.uil-arrow-growth:before { content: '\\e842'; } /* '' */\n.uil-arrow-left:before { content: '\\e843'; } /* '' */\n.uil-arrow-random:before { content: '\\e844'; } /* '' */\n.uil-arrow-resize-diagonal:before { content: '\\e845'; } /* '' */\n.uil-arrow-right:before { content: '\\e846'; } /* '' */\n.uil-arrow-to-bottom:before { content: '\\e847'; } /* '' */\n.uil-arrow-to-right:before { content: '\\e848'; } /* '' */\n.uil-arrow-up-left:before { content: '\\e849'; } /* '' */\n.uil-arrow-up-right:before { content: '\\e84a'; } /* '' */\n.uil-arrow-up:before { content: '\\e84b'; } /* '' */\n.uil-arrows-h-alt:before { content: '\\e84c'; } /* '' */\n.uil-arrows-h:before { content: '\\e84d'; } /* '' */\n.uil-arrows-left-down:before { content: '\\e84e'; } /* '' */\n.uil-arrows-maximize:before { content: '\\e84f'; } /* '' */\n.uil-arrows-merge:before { content: '\\e850'; } /* '' */\n.uil-arrows-resize-h:before { content: '\\e851'; } /* '' */\n.uil-arrows-resize-v:before { content: '\\e852'; } /* '' */\n.uil-arrows-resize:before { content: '\\e853'; } /* '' */\n.uil-arrows-right-down:before { content: '\\e854'; } /* '' */\n.uil-arrows-shrink-h:before { content: '\\e855'; } /* '' */\n.uil-arrows-shrink-v:before { content: '\\e856'; } /* '' */\n.uil-arrows-up-right:before { content: '\\e857'; } /* '' */\n.uil-arrows-v-alt:before { content: '\\e858'; } /* '' */\n.uil-arrows-v:before { content: '\\e859'; } /* '' */\n.uil-assistive-listening-systems:before { content: '\\e85a'; } /* '' */\n.uil-asterisk:before { content: '\\e85b'; } /* '' */\n.uil-at:before { content: '\\e85c'; } /* '' */\n.uil-atm-card:before { content: '\\e85d'; } /* '' */\n.uil-atom:before { content: '\\e85e'; } /* '' */\n.uil-auto-flash:before { content: '\\e85f'; } /* '' */\n.uil-award-alt:before { content: '\\e860'; } /* '' */\n.uil-award:before { content: '\\e861'; } /* '' */\n.uil-baby-carriage:before { content: '\\e862'; } /* '' */\n.uil-backpack:before { content: '\\e863'; } /* '' */\n.uil-backspace:before { content: '\\e864'; } /* '' */\n.uil-backward:before { content: '\\e865'; } /* '' */\n.uil-bag-alt:before { content: '\\e866'; } /* '' */\n.uil-bag-slash:before { content: '\\e867'; } /* '' */\n.uil-bag:before { content: '\\e868'; } /* '' */\n.uil-balance-scale:before { content: '\\e869'; } /* '' */\n.uil-ball:before { content: '\\e86a'; } /* '' */\n.uil-ban:before { content: '\\e86b'; } /* '' */\n.uil-bars:before { content: '\\e86c'; } /* '' */\n.uil-basketball-hoop:before { content: '\\e86d'; } /* '' */\n.uil-basketball:before { content: '\\e86e'; } /* '' */\n.uil-battery-bolt:before { content: '\\e86f'; } /* '' */\n.uil-battery-empty:before { content: '\\e870'; } /* '' */\n.uil-bed-double:before { content: '\\e871'; } /* '' */\n.uil-bed:before { content: '\\e872'; } /* '' */\n.uil-behance:before { content: '\\e873'; } /* '' */\n.uil-bell-school:before { content: '\\e874'; } /* '' */\n.uil-bell-slash:before { content: '\\e875'; } /* '' */\n.uil-bell:before { content: '\\e876'; } /* '' */\n.uil-bill:before { content: '\\e877'; } /* '' */\n.uil-bitcoin-circle:before { content: '\\e878'; } /* '' */\n.uil-bitcoin:before { content: '\\e879'; } /* '' */\n.uil-black-berry:before { content: '\\e87a'; } /* '' */\n.uil-bluetooth-b:before { content: '\\e87b'; } /* '' */\n.uil-bold:before { content: '\\e87c'; } /* '' */\n.uil-bolt-alt:before { content: '\\e87d'; } /* '' */\n.uil-bolt-slash:before { content: '\\e87e'; } /* '' */\n.uil-bolt:before { content: '\\e87f'; } /* '' */\n.uil-book-alt:before { content: '\\e880'; } /* '' */\n.uil-book-medical:before { content: '\\e881'; } /* '' */\n.uil-book-open:before { content: '\\e882'; } /* '' */\n.uil-book-reader:before { content: '\\e883'; } /* '' */\n.uil-book:before { content: '\\e884'; } /* '' */\n.uil-bookmark-full:before { content: '\\e885'; } /* '' */\n.uil-bookmark:before { content: '\\e886'; } /* '' */\n.uil-books:before { content: '\\e887'; } /* '' */\n.uil-boombox:before { content: '\\e888'; } /* '' */\n.uil-border-alt:before { content: '\\e889'; } /* '' */\n.uil-border-bottom:before { content: '\\e88a'; } /* '' */\n.uil-border-clear:before { content: '\\e88b'; } /* '' */\n.uil-border-horizontal:before { content: '\\e88c'; } /* '' */\n.uil-border-inner:before { content: '\\e88d'; } /* '' */\n.uil-border-left:before { content: '\\e88e'; } /* '' */\n.uil-border-out:before { content: '\\e88f'; } /* '' */\n.uil-border-right:before { content: '\\e890'; } /* '' */\n.uil-border-top:before { content: '\\e891'; } /* '' */\n.uil-border-vertical:before { content: '\\e892'; } /* '' */\n.uil-box:before { content: '\\e893'; } /* '' */\n.uil-briefcase-alt:before { content: '\\e894'; } /* '' */\n.uil-briefcase:before { content: '\\e895'; } /* '' */\n.uil-bright:before { content: '\\e896'; } /* '' */\n.uil-brightness-empty:before { content: '\\e897'; } /* '' */\n.uil-brightness-half:before { content: '\\e898'; } /* '' */\n.uil-brightness-low:before { content: '\\e899'; } /* '' */\n.uil-brightness-minus:before { content: '\\e89a'; } /* '' */\n.uil-brightness-plus:before { content: '\\e89b'; } /* '' */\n.uil-brightness:before { content: '\\e89c'; } /* '' */\n.uil-bring-bottom:before { content: '\\e89d'; } /* '' */\n.uil-bring-front:before { content: '\\e89e'; } /* '' */\n.uil-brush-alt:before { content: '\\e89f'; } /* '' */\n.uil-bug:before { content: '\\e8a0'; } /* '' */\n.uil-building:before { content: '\\e8a1'; } /* '' */\n.uil-bullseye:before { content: '\\e8a2'; } /* '' */\n.uil-bus-alt:before { content: '\\e8a3'; } /* '' */\n.uil-bus-school:before { content: '\\e8a4'; } /* '' */\n.uil-bus:before { content: '\\e8a5'; } /* '' */\n.uil-calcualtor:before { content: '\\e8a6'; } /* '' */\n.uil-calculator-alt:before { content: '\\e8a7'; } /* '' */\n.uil-calendar-alt:before { content: '\\e8a8'; } /* '' */\n.uil-calendar-slash:before { content: '\\e8a9'; } /* '' */\n.uil-calender:before { content: '\\e8aa'; } /* '' */\n.uil-calling:before { content: '\\e8ab'; } /* '' */\n.uil-camera-change:before { content: '\\e8ac'; } /* '' */\n.uil-camera-plus:before { content: '\\e8ad'; } /* '' */\n.uil-camera-slash:before { content: '\\e8ae'; } /* '' */\n.uil-camera:before { content: '\\e8af'; } /* '' */\n.uil-cancel:before { content: '\\e8b0'; } /* '' */\n.uil-capsule:before { content: '\\e8b1'; } /* '' */\n.uil-capture:before { content: '\\e8b2'; } /* '' */\n.uil-car-sideview:before { content: '\\e8b3'; } /* '' */\n.uil-car-slash:before { content: '\\e8b4'; } /* '' */\n.uil-car-wash:before { content: '\\e8b5'; } /* '' */\n.uil-car:before { content: '\\e8b6'; } /* '' */\n.uil-card-atm:before { content: '\\e8b7'; } /* '' */\n.uil-caret-right:before { content: '\\e8b8'; } /* '' */\n.uil-cart:before { content: '\\e8b9'; } /* '' */\n.uil-cell:before { content: '\\e8ba'; } /* '' */\n.uil-celsius:before { content: '\\e8bb'; } /* '' */\n.uil-chart-bar-alt:before { content: '\\e8bc'; } /* '' */\n.uil-chart-bar:before { content: '\\e8bd'; } /* '' */\n.uil-chart-down:before { content: '\\e8be'; } /* '' */\n.uil-chart-growth-alt:before { content: '\\e8bf'; } /* '' */\n.uil-chart-growth:before { content: '\\e8c0'; } /* '' */\n.uil-chart-line:before { content: '\\e8c1'; } /* '' */\n.uil-chart-pie-alt:before { content: '\\e8c2'; } /* '' */\n.uil-chart-pie:before { content: '\\e8c3'; } /* '' */\n.uil-chart:before { content: '\\e8c4'; } /* '' */\n.uil-chat-bubble-user:before { content: '\\e8c5'; } /* '' */\n.uil-chat-info:before { content: '\\e8c6'; } /* '' */\n.uil-chat:before { content: '\\e8c7'; } /* '' */\n.uil-check-circle:before { content: '\\e8c8'; } /* '' */\n.uil-check-square:before { content: '\\e8c9'; } /* '' */\n.uil-check:before { content: '\\e8ca'; } /* '' */\n.uil-circle-layer:before { content: '\\e8cb'; } /* '' */\n.uil-circle:before { content: '\\e8cc'; } /* '' */\n.uil-circuit:before { content: '\\e8cd'; } /* '' */\n.uil-clapper-board:before { content: '\\e8ce'; } /* '' */\n.uil-clipboard-alt:before { content: '\\e8cf'; } /* '' */\n.uil-clipboard-blank:before { content: '\\e8d0'; } /* '' */\n.uil-clipboard-notes:before { content: '\\e8d1'; } /* '' */\n.uil-clipboard:before { content: '\\e8d2'; } /* '' */\n.uil-clock-eight:before { content: '\\e8d3'; } /* '' */\n.uil-clock-five:before { content: '\\e8d4'; } /* '' */\n.uil-clock-nine:before { content: '\\e8d5'; } /* '' */\n.uil-clock-seven:before { content: '\\e8d6'; } /* '' */\n.uil-clock-ten:before { content: '\\e8d7'; } /* '' */\n.uil-clock-three:before { content: '\\e8d8'; } /* '' */\n.uil-clock-two:before { content: '\\e8d9'; } /* '' */\n.uil-clock:before { content: '\\e8da'; } /* '' */\n.uil-closed-captioning:before { content: '\\e8db'; } /* '' */\n.uil-cloud-block:before { content: '\\e8dc'; } /* '' */\n.uil-cloud-bookmark:before { content: '\\e8dd'; } /* '' */\n.uil-cloud-check:before { content: '\\e8de'; } /* '' */\n.uil-cloud-computing:before { content: '\\e8df'; } /* '' */\n.uil-cloud-data-connection:before { content: '\\e8e0'; } /* '' */\n.uil-cloud-database-tree:before { content: '\\e8e1'; } /* '' */\n.uil-cloud-download:before { content: '\\e8e2'; } /* '' */\n.uil-cloud-drizzle:before { content: '\\e8e3'; } /* '' */\n.uil-cloud-exclamation:before { content: '\\e8e4'; } /* '' */\n.uil-cloud-hail:before { content: '\\e8e5'; } /* '' */\n.uil-cloud-heart:before { content: '\\e8e6'; } /* '' */\n.uil-cloud-info:before { content: '\\e8e7'; } /* '' */\n.uil-cloud-lock:before { content: '\\e8e8'; } /* '' */\n.uil-cloud-meatball:before { content: '\\e8e9'; } /* '' */\n.uil-cloud-moon-hail:before { content: '\\e8ea'; } /* '' */\n.uil-cloud-moon-meatball:before { content: '\\e8eb'; } /* '' */\n.uil-cloud-moon-rain:before { content: '\\e8ec'; } /* '' */\n.uil-cloud-moon-showers:before { content: '\\e8ed'; } /* '' */\n.uil-cloud-moon:before { content: '\\e8ee'; } /* '' */\n.uil-cloud-question:before { content: '\\e8ef'; } /* '' */\n.uil-cloud-rain-sun:before { content: '\\e8f0'; } /* '' */\n.uil-cloud-rain:before { content: '\\e8f1'; } /* '' */\n.uil-cloud-redo:before { content: '\\e8f2'; } /* '' */\n.uil-cloud-set:before { content: '\\e8f3'; } /* '' */\n.uil-cloud-share:before { content: '\\e8f4'; } /* '' */\n.uil-cloud-shield:before { content: '\\e8f5'; } /* '' */\n.uil-cloud-showers-alt:before { content: '\\e8f6'; } /* '' */\n.uil-cloud-showers-heavy:before { content: '\\e8f7'; } /* '' */\n.uil-cloud-showers:before { content: '\\e8f8'; } /* '' */\n.uil-cloud-slash:before { content: '\\e8f9'; } /* '' */\n.uil-cloud-sun-hail:before { content: '\\e8fa'; } /* '' */\n.uil-cloud-sun-meatball:before { content: '\\e8fb'; } /* '' */\n.uil-cloud-sun-rain-alt:before { content: '\\e8fc'; } /* '' */\n.uil-cloud-sun-rain:before { content: '\\e8fd'; } /* '' */\n.uil-cloud-sun-tear:before { content: '\\e8fe'; } /* '' */\n.uil-cloud-sun:before { content: '\\e8ff'; } /* '' */\n.uil-cloud-times:before { content: '\\e900'; } /* '' */\n.uil-cloud-unlock:before { content: '\\e901'; } /* '' */\n.uil-cloud-upload:before { content: '\\e902'; } /* '' */\n.uil-cloud-wifi:before { content: '\\e903'; } /* '' */\n.uil-cloud-wind:before { content: '\\e904'; } /* '' */\n.uil-cloud:before { content: '\\e905'; } /* '' */\n.uil-clouds:before { content: '\\e906'; } /* '' */\n.uil-club:before { content: '\\e907'; } /* '' */\n.uil-code:before { content: '\\e908'; } /* '' */\n.uil-coffee:before { content: '\\e909'; } /* '' */\n.uil-cog:before { content: '\\e90a'; } /* '' */\n.uil-coins:before { content: '\\e90b'; } /* '' */\n.uil-columns:before { content: '\\e90c'; } /* '' */\n.uil-comment-alt-block:before { content: '\\e90d'; } /* '' */\n.uil-comment-alt-chart-lines:before { content: '\\e90e'; } /* '' */\n.uil-comment-alt-check:before { content: '\\e90f'; } /* '' */\n.uil-comment-alt-dots:before { content: '\\e910'; } /* '' */\n.uil-comment-alt-download:before { content: '\\e911'; } /* '' */\n.uil-comment-alt-edit:before { content: '\\e912'; } /* '' */\n.uil-comment-alt-exclamation:before { content: '\\e913'; } /* '' */\n.uil-comment-alt-heart:before { content: '\\e914'; } /* '' */\n.uil-comment-alt-image:before { content: '\\e915'; } /* '' */\n.uil-comment-alt-info:before { content: '\\e916'; } /* '' */\n.uil-comment-alt-lines:before { content: '\\e917'; } /* '' */\n.uil-comment-alt-lock:before { content: '\\e918'; } /* '' */\n.uil-comment-alt-medical:before { content: '\\e919'; } /* '' */\n.uil-comment-alt-message:before { content: '\\e91a'; } /* '' */\n.uil-comment-alt-notes:before { content: '\\e91b'; } /* '' */\n.uil-comment-alt-plus:before { content: '\\e91c'; } /* '' */\n.uil-comment-alt-question:before { content: '\\e91d'; } /* '' */\n.uil-comment-alt-redo:before { content: '\\e91e'; } /* '' */\n.uil-comment-alt-search:before { content: '\\e91f'; } /* '' */\n.uil-comment-alt-share:before { content: '\\e920'; } /* '' */\n.uil-comment-alt-shield:before { content: '\\e921'; } /* '' */\n.uil-comment-alt-slash:before { content: '\\e922'; } /* '' */\n.uil-comment-alt-upload:before { content: '\\e923'; } /* '' */\n.uil-comment-alt-verify:before { content: '\\e924'; } /* '' */\n.uil-comment-alt:before { content: '\\e925'; } /* '' */\n.uil-comment-block:before { content: '\\e926'; } /* '' */\n.uil-comment-chart-line:before { content: '\\e927'; } /* '' */\n.uil-comment-check:before { content: '\\e928'; } /* '' */\n.uil-comment-dots:before { content: '\\e929'; } /* '' */\n.uil-comment-download:before { content: '\\e92a'; } /* '' */\n.uil-comment-edit:before { content: '\\e92b'; } /* '' */\n.uil-comment-exclamation:before { content: '\\e92c'; } /* '' */\n.uil-comment-heart:before { content: '\\e92d'; } /* '' */\n.uil-comment-image:before { content: '\\e92e'; } /* '' */\n.uil-comment-info-alt:before { content: '\\e92f'; } /* '' */\n.uil-comment-info:before { content: '\\e930'; } /* '' */\n.uil-comment-lines:before { content: '\\e931'; } /* '' */\n.uil-comment-lock:before { content: '\\e932'; } /* '' */\n.uil-comment-medical:before { content: '\\e933'; } /* '' */\n.uil-comment-message:before { content: '\\e934'; } /* '' */\n.uil-comment-notes:before { content: '\\e935'; } /* '' */\n.uil-comment-plus:before { content: '\\e936'; } /* '' */\n.uil-comment-question:before { content: '\\e937'; } /* '' */\n.uil-comment-redo:before { content: '\\e938'; } /* '' */\n.uil-comment-search:before { content: '\\e939'; } /* '' */\n.uil-comment-share:before { content: '\\e93a'; } /* '' */\n.uil-comment-shield:before { content: '\\e93b'; } /* '' */\n.uil-comment-slash:before { content: '\\e93c'; } /* '' */\n.uil-comment-upload:before { content: '\\e93d'; } /* '' */\n.uil-comment-verify:before { content: '\\e93e'; } /* '' */\n.uil-comment:before { content: '\\e93f'; } /* '' */\n.uil-comments-alt:before { content: '\\e940'; } /* '' */\n.uil-comments:before { content: '\\e941'; } /* '' */\n.uil-commnet-alt-slash:before { content: '\\e942'; } /* '' */\n.uil-compact-disc:before { content: '\\e943'; } /* '' */\n.uil-compass:before { content: '\\e944'; } /* '' */\n.uil-compress-alt-left:before { content: '\\e945'; } /* '' */\n.uil-compress-alt:before { content: '\\e946'; } /* '' */\n.uil-compress-arrows:before { content: '\\e947'; } /* '' */\n.uil-compress-lines:before { content: '\\e948'; } /* '' */\n.uil-compress-point:before { content: '\\e949'; } /* '' */\n.uil-compress-v:before { content: '\\e94a'; } /* '' */\n.uil-compress:before { content: '\\e94b'; } /* '' */\n.uil-computer-mouse:before { content: '\\e94c'; } /* '' */\n.uil-confused:before { content: '\\e94d'; } /* '' */\n.uil-constructor:before { content: '\\e94e'; } /* '' */\n.uil-copy-alt:before { content: '\\e94f'; } /* '' */\n.uil-copy-landscape:before { content: '\\e950'; } /* '' */\n.uil-copy:before { content: '\\e951'; } /* '' */\n.uil-copyright:before { content: '\\e952'; } /* '' */\n.uil-corner-down-left:before { content: '\\e953'; } /* '' */\n.uil-corner-down-right-alt:before { content: '\\e954'; } /* '' */\n.uil-corner-down-right:before { content: '\\e955'; } /* '' */\n.uil-corner-left-down:before { content: '\\e956'; } /* '' */\n.uil-corner-right-down:before { content: '\\e957'; } /* '' */\n.uil-corner-up-left-alt:before { content: '\\e958'; } /* '' */\n.uil-corner-up-left:before { content: '\\e959'; } /* '' */\n.uil-corner-up-right-alt:before { content: '\\e95a'; } /* '' */\n.uil-corner-up-right:before { content: '\\e95b'; } /* '' */\n.uil-creative-commons-pd-alt:before { content: '\\e95c'; } /* '' */\n.uil-creative-commons-pd:before { content: '\\e95d'; } /* '' */\n.uil-crockery:before { content: '\\e95e'; } /* '' */\n.uil-crop-alt-rotate-left:before { content: '\\e95f'; } /* '' */\n.uil-crop-alt-rotate-right:before { content: '\\e960'; } /* '' */\n.uil-crop-alt:before { content: '\\e961'; } /* '' */\n.uil-crosshair-alt:before { content: '\\e962'; } /* '' */\n.uil-crosshair:before { content: '\\e963'; } /* '' */\n.uil-crosshairs:before { content: '\\e964'; } /* '' */\n.uil-cube:before { content: '\\e965'; } /* '' */\n.uil-dashboard:before { content: '\\e966'; } /* '' */\n.uil-data-sharing:before { content: '\\e967'; } /* '' */\n.uil-database-alt:before { content: '\\e968'; } /* '' */\n.uil-database:before { content: '\\e969'; } /* '' */\n.uil-desert:before { content: '\\e96a'; } /* '' */\n.uil-desktop-alt-slash:before { content: '\\e96b'; } /* '' */\n.uil-desktop-alt:before { content: '\\e96c'; } /* '' */\n.uil-desktop-cloud-alt:before { content: '\\e96d'; } /* '' */\n.uil-desktop-slash:before { content: '\\e96e'; } /* '' */\n.uil-desktop:before { content: '\\e96f'; } /* '' */\n.uil-dialpad-alt:before { content: '\\e970'; } /* '' */\n.uil-dialpad:before { content: '\\e971'; } /* '' */\n.uil-diamond:before { content: '\\e972'; } /* '' */\n.uil-diary-alt:before { content: '\\e973'; } /* '' */\n.uil-diary:before { content: '\\e974'; } /* '' */\n.uil-dice-five:before { content: '\\e975'; } /* '' */\n.uil-dice-four:before { content: '\\e976'; } /* '' */\n.uil-dice-one:before { content: '\\e977'; } /* '' */\n.uil-dice-six:before { content: '\\e978'; } /* '' */\n.uil-dice-three:before { content: '\\e979'; } /* '' */\n.uil-dice-two:before { content: '\\e97a'; } /* '' */\n.uil-direction:before { content: '\\e97b'; } /* '' */\n.uil-directions:before { content: '\\e97c'; } /* '' */\n.uil-dizzy-meh:before { content: '\\e97d'; } /* '' */\n.uil-dna:before { content: '\\e97e'; } /* '' */\n.uil-document-layout-center:before { content: '\\e97f'; } /* '' */\n.uil-document-layout-left:before { content: '\\e980'; } /* '' */\n.uil-document-layout-right:before { content: '\\e981'; } /* '' */\n.uil-document:before { content: '\\e982'; } /* '' */\n.uil-dollar-alt:before { content: '\\e983'; } /* '' */\n.uil-dollar-sign-alt:before { content: '\\e984'; } /* '' */\n.uil-dollar-sign:before { content: '\\e985'; } /* '' */\n.uil-down-arrow:before { content: '\\e986'; } /* '' */\n.uil-download-alt:before { content: '\\e987'; } /* '' */\n.uil-dribbble:before { content: '\\e988'; } /* '' */\n.uil-drill:before { content: '\\e989'; } /* '' */\n.uil-dropbox:before { content: '\\e98a'; } /* '' */\n.uil-dumbbell:before { content: '\\e98b'; } /* '' */\n.uil-ear:before { content: '\\e98c'; } /* '' */\n.uil-edit-alt:before { content: '\\e98d'; } /* '' */\n.uil-edit:before { content: '\\e98e'; } /* '' */\n.uil-ellipsis-h:before { content: '\\e98f'; } /* '' */\n.uil-ellipsis-v:before { content: '\\e990'; } /* '' */\n.uil-emoji:before { content: '\\e991'; } /* '' */\n.uil-enter:before { content: '\\e992'; } /* '' */\n.uil-entry:before { content: '\\e993'; } /* '' */\n.uil-envelope-add:before { content: '\\e994'; } /* '' */\n.uil-envelope-alt:before { content: '\\e995'; } /* '' */\n.uil-envelope-block:before { content: '\\e996'; } /* '' */\n.uil-envelope-bookmark:before { content: '\\e997'; } /* '' */\n.uil-envelope-check:before { content: '\\e998'; } /* '' */\n.uil-envelope-download-alt:before { content: '\\e999'; } /* '' */\n.uil-envelope-download:before { content: '\\e99a'; } /* '' */\n.uil-envelope-edit:before { content: '\\e99b'; } /* '' */\n.uil-envelope-exclamation:before { content: '\\e99c'; } /* '' */\n.uil-envelope-heart:before { content: '\\e99d'; } /* '' */\n.uil-envelope-info:before { content: '\\e99e'; } /* '' */\n.uil-envelope-lock:before { content: '\\e99f'; } /* '' */\n.uil-envelope-minus:before { content: '\\e9a0'; } /* '' */\n.uil-envelope-open:before { content: '\\e9a1'; } /* '' */\n.uil-envelope-question:before { content: '\\e9a2'; } /* '' */\n.uil-envelope-receive:before { content: '\\e9a3'; } /* '' */\n.uil-envelope-redo:before { content: '\\e9a4'; } /* '' */\n.uil-envelope-search:before { content: '\\e9a5'; } /* '' */\n.uil-envelope-send:before { content: '\\e9a6'; } /* '' */\n.uil-envelope-share:before { content: '\\e9a7'; } /* '' */\n.uil-envelope-shield:before { content: '\\e9a8'; } /* '' */\n.uil-envelope-star:before { content: '\\e9a9'; } /* '' */\n.uil-envelope-times:before { content: '\\e9aa'; } /* '' */\n.uil-envelope-upload-alt:before { content: '\\e9ab'; } /* '' */\n.uil-envelope-upload:before { content: '\\e9ac'; } /* '' */\n.uil-envelope:before { content: '\\e9ad'; } /* '' */\n.uil-envelopes:before { content: '\\e9ae'; } /* '' */\n.uil-equal-circle:before { content: '\\e9af'; } /* '' */\n.uil-euro-circle:before { content: '\\e9b0'; } /* '' */\n.uil-euro:before { content: '\\e9b1'; } /* '' */\n.uil-exchange-alt:before { content: '\\e9b2'; } /* '' */\n.uil-exchange:before { content: '\\e9b3'; } /* '' */\n.uil-exclamation-circle:before { content: '\\e9b4'; } /* '' */\n.uil-exclamation-octagon:before { content: '\\e9b5'; } /* '' */\n.uil-exclamation-triangle:before { content: '\\e9b6'; } /* '' */\n.uil-exclude:before { content: '\\e9b7'; } /* '' */\n.uil-exit:before { content: '\\e9b8'; } /* '' */\n.uil-expand-alt:before { content: '\\e9b9'; } /* '' */\n.uil-expand-arrows-alt:before { content: '\\e9ba'; } /* '' */\n.uil-expand-arrows:before { content: '\\e9bb'; } /* '' */\n.uil-expand-from-corner:before { content: '\\e9bc'; } /* '' */\n.uil-expand-left:before { content: '\\e9bd'; } /* '' */\n.uil-expand-right:before { content: '\\e9be'; } /* '' */\n.uil-export:before { content: '\\e9bf'; } /* '' */\n.uil-exposure-alt:before { content: '\\e9c0'; } /* '' */\n.uil-exposure-increase:before { content: '\\e9c1'; } /* '' */\n.uil-external-link-alt:before { content: '\\e9c2'; } /* '' */\n.uil-eye-slash:before { content: '\\e9c3'; } /* '' */\n.uil-eye:before { content: '\\e9c4'; } /* '' */\n.uil-facebook-f:before { content: '\\e9c5'; } /* '' */\n.uil-facebook-messenger:before { content: '\\e9c6'; } /* '' */\n.uil-facebook:before { content: '\\e9c7'; } /* '' */\n.uil-fahrenheit:before { content: '\\e9c8'; } /* '' */\n.uil-fast-mail-alt:before { content: '\\e9c9'; } /* '' */\n.uil-fast-mail:before { content: '\\e9ca'; } /* '' */\n.uil-favorite:before { content: '\\e9cb'; } /* '' */\n.uil-feedback:before { content: '\\e9cc'; } /* '' */\n.uil-file-alt:before { content: '\\e9cd'; } /* '' */\n.uil-file-blank:before { content: '\\e9ce'; } /* '' */\n.uil-file-block-alt:before { content: '\\e9cf'; } /* '' */\n.uil-file-bookmark-alt:before { content: '\\e9d0'; } /* '' */\n.uil-file-check-alt:before { content: '\\e9d1'; } /* '' */\n.uil-file-check:before { content: '\\e9d2'; } /* '' */\n.uil-file-contract-dollar:before { content: '\\e9d3'; } /* '' */\n.uil-file-copy-alt:before { content: '\\e9d4'; } /* '' */\n.uil-file-download-alt:before { content: '\\e9d5'; } /* '' */\n.uil-file-download:before { content: '\\e9d6'; } /* '' */\n.uil-file-edit-alt:before { content: '\\e9d7'; } /* '' */\n.uil-file-exclamation-alt:before { content: '\\e9d8'; } /* '' */\n.uil-file-exclamation:before { content: '\\e9d9'; } /* '' */\n.uil-file-heart:before { content: '\\e9da'; } /* '' */\n.uil-file-info-alt:before { content: '\\e9db'; } /* '' */\n.uil-file-landscape-alt:before { content: '\\e9dc'; } /* '' */\n.uil-file-landscape:before { content: '\\e9dd'; } /* '' */\n.uil-file-lanscape-slash:before { content: '\\e9de'; } /* '' */\n.uil-file-lock-alt:before { content: '\\e9df'; } /* '' */\n.uil-file-medical-alt:before { content: '\\e9e0'; } /* '' */\n.uil-file-medical:before { content: '\\e9e1'; } /* '' */\n.uil-file-minus-alt:before { content: '\\e9e2'; } /* '' */\n.uil-file-minus:before { content: '\\e9e3'; } /* '' */\n.uil-file-network:before { content: '\\e9e4'; } /* '' */\n.uil-file-plus-alt:before { content: '\\e9e5'; } /* '' */\n.uil-file-plus:before { content: '\\e9e6'; } /* '' */\n.uil-file-question-alt:before { content: '\\e9e7'; } /* '' */\n.uil-file-question:before { content: '\\e9e8'; } /* '' */\n.uil-file-redo-alt:before { content: '\\e9e9'; } /* '' */\n.uil-file-search-alt:before { content: '\\e9ea'; } /* '' */\n.uil-file-share-alt:before { content: '\\e9eb'; } /* '' */\n.uil-file-shield-alt:before { content: '\\e9ec'; } /* '' */\n.uil-file-slash:before { content: '\\e9ed'; } /* '' */\n.uil-file-times-alt:before { content: '\\e9ee'; } /* '' */\n.uil-file-times:before { content: '\\e9ef'; } /* '' */\n.uil-file-upload-alt:before { content: '\\e9f0'; } /* '' */\n.uil-file-upload:before { content: '\\e9f1'; } /* '' */\n.uil-file:before { content: '\\e9f2'; } /* '' */\n.uil-files-landscapes-alt:before { content: '\\e9f3'; } /* '' */\n.uil-files-landscapes:before { content: '\\e9f4'; } /* '' */\n.uil-film:before { content: '\\e9f5'; } /* '' */\n.uil-filter-slash:before { content: '\\e9f6'; } /* '' */\n.uil-filter:before { content: '\\e9f7'; } /* '' */\n.uil-flask-potion:before { content: '\\e9f8'; } /* '' */\n.uil-flask:before { content: '\\e9f9'; } /* '' */\n.uil-flip-h-alt:before { content: '\\e9fa'; } /* '' */\n.uil-flip-h:before { content: '\\e9fb'; } /* '' */\n.uil-flip-v-alt:before { content: '\\e9fc'; } /* '' */\n.uil-flip-v:before { content: '\\e9fd'; } /* '' */\n.uil-flower:before { content: '\\e9fe'; } /* '' */\n.uil-focus-add:before { content: '\\e9ff'; } /* '' */\n.uil-focus-target:before { content: '\\ea00'; } /* '' */\n.uil-focus:before { content: '\\ea01'; } /* '' */\n.uil-folder-check:before { content: '\\ea02'; } /* '' */\n.uil-folder-download:before { content: '\\ea03'; } /* '' */\n.uil-folder-exclamation:before { content: '\\ea04'; } /* '' */\n.uil-folder-heart:before { content: '\\ea05'; } /* '' */\n.uil-folder-info:before { content: '\\ea06'; } /* '' */\n.uil-folder-lock:before { content: '\\ea07'; } /* '' */\n.uil-folder-medical:before { content: '\\ea08'; } /* '' */\n.uil-folder-minus:before { content: '\\ea09'; } /* '' */\n.uil-folder-network:before { content: '\\ea0a'; } /* '' */\n.uil-folder-plus:before { content: '\\ea0b'; } /* '' */\n.uil-folder-question:before { content: '\\ea0c'; } /* '' */\n.uil-folder-slash:before { content: '\\ea0d'; } /* '' */\n.uil-folder-times:before { content: '\\ea0e'; } /* '' */\n.uil-folder-upload:before { content: '\\ea0f'; } /* '' */\n.uil-folder:before { content: '\\ea10'; } /* '' */\n.uil-food:before { content: '\\ea11'; } /* '' */\n.uil-football-american:before { content: '\\ea12'; } /* '' */\n.uil-football-ball:before { content: '\\ea13'; } /* '' */\n.uil-football:before { content: '\\ea14'; } /* '' */\n.uil-forecastcloud-moon-tear:before { content: '\\ea15'; } /* '' */\n.uil-forwaded-call:before { content: '\\ea16'; } /* '' */\n.uil-forward:before { content: '\\ea17'; } /* '' */\n.uil-frown:before { content: '\\ea18'; } /* '' */\n.uil-game-structure:before { content: '\\ea19'; } /* '' */\n.uil-game:before { content: '\\ea1a'; } /* '' */\n.uil-gift:before { content: '\\ea1b'; } /* '' */\n.uil-github-alt:before { content: '\\ea1c'; } /* '' */\n.uil-github:before { content: '\\ea1d'; } /* '' */\n.uil-glass-martini-alt-slash:before { content: '\\ea1e'; } /* '' */\n.uil-glass-martini-alt:before { content: '\\ea1f'; } /* '' */\n.uil-glass-martini:before { content: '\\ea20'; } /* '' */\n.uil-glass-tea:before { content: '\\ea21'; } /* '' */\n.uil-glass:before { content: '\\ea22'; } /* '' */\n.uil-globe:before { content: '\\ea23'; } /* '' */\n.uil-gold:before { content: '\\ea24'; } /* '' */\n.uil-google-drive-alt:before { content: '\\ea25'; } /* '' */\n.uil-google-drive:before { content: '\\ea26'; } /* '' */\n.uil-google-hangouts:before { content: '\\ea27'; } /* '' */\n.uil-google-play:before { content: '\\ea28'; } /* '' */\n.uil-google:before { content: '\\ea29'; } /* '' */\n.uil-graduation-hat:before { content: '\\ea2a'; } /* '' */\n.uil-graph-bar:before { content: '\\ea2b'; } /* '' */\n.uil-grid:before { content: '\\ea2c'; } /* '' */\n.uil-grids:before { content: '\\ea2d'; } /* '' */\n.uil-grin-tongue-wink-alt:before { content: '\\ea2e'; } /* '' */\n.uil-grin-tongue-wink:before { content: '\\ea2f'; } /* '' */\n.uil-grin:before { content: '\\ea30'; } /* '' */\n.uil-grip-horizontal-line:before { content: '\\ea31'; } /* '' */\n.uil-hdd:before { content: '\\ea32'; } /* '' */\n.uil-headphones-alt:before { content: '\\ea33'; } /* '' */\n.uil-headphones:before { content: '\\ea34'; } /* '' */\n.uil-heart-alt:before { content: '\\ea35'; } /* '' */\n.uil-heart-medical:before { content: '\\ea36'; } /* '' */\n.uil-heart-rate:before { content: '\\ea37'; } /* '' */\n.uil-heart-sign:before { content: '\\ea38'; } /* '' */\n.uil-heart:before { content: '\\ea39'; } /* '' */\n.uil-heartbeat:before { content: '\\ea3a'; } /* '' */\n.uil-history-alt:before { content: '\\ea3b'; } /* '' */\n.uil-history:before { content: '\\ea3c'; } /* '' */\n.uil-home-alt:before { content: '\\ea3d'; } /* '' */\n.uil-home:before { content: '\\ea3e'; } /* '' */\n.uil-horizontal-align-center:before { content: '\\ea3f'; } /* '' */\n.uil-horizontal-align-left:before { content: '\\ea40'; } /* '' */\n.uil-horizontal-align-right:before { content: '\\ea41'; } /* '' */\n.uil-horizontal-distribution-center:before { content: '\\ea42'; } /* '' */\n.uil-horizontal-distribution-left:before { content: '\\ea43'; } /* '' */\n.uil-horizontal-distribution-right:before { content: '\\ea44'; } /* '' */\n.uil-hunting:before { content: '\\ea45'; } /* '' */\n.uil-image-alt-slash:before { content: '\\ea46'; } /* '' */\n.uil-image-block:before { content: '\\ea47'; } /* '' */\n.uil-image-broken:before { content: '\\ea48'; } /* '' */\n.uil-image-check:before { content: '\\ea49'; } /* '' */\n.uil-image-download:before { content: '\\ea4a'; } /* '' */\n.uil-image-edit:before { content: '\\ea4b'; } /* '' */\n.uil-image-lock:before { content: '\\ea4c'; } /* '' */\n.uil-image-minus:before { content: '\\ea4d'; } /* '' */\n.uil-image-plus:before { content: '\\ea4e'; } /* '' */\n.uil-image-question:before { content: '\\ea4f'; } /* '' */\n.uil-image-redo:before { content: '\\ea50'; } /* '' */\n.uil-image-resize-landscape:before { content: '\\ea51'; } /* '' */\n.uil-image-resize-square:before { content: '\\ea52'; } /* '' */\n.uil-image-search:before { content: '\\ea53'; } /* '' */\n.uil-image-share:before { content: '\\ea54'; } /* '' */\n.uil-image-shield:before { content: '\\ea55'; } /* '' */\n.uil-image-slash:before { content: '\\ea56'; } /* '' */\n.uil-image-times:before { content: '\\ea57'; } /* '' */\n.uil-image-upload:before { content: '\\ea58'; } /* '' */\n.uil-image-v:before { content: '\\ea59'; } /* '' */\n.uil-image:before { content: '\\ea5a'; } /* '' */\n.uil-images:before { content: '\\ea5b'; } /* '' */\n.uil-incoming-call:before { content: '\\ea5c'; } /* '' */\n.uil-info-circle:before { content: '\\ea5d'; } /* '' */\n.uil-instagram-alt:before { content: '\\ea5e'; } /* '' */\n.uil-instagram:before { content: '\\ea5f'; } /* '' */\n.uil-intercom:before { content: '\\ea60'; } /* '' */\n.uil-invoice:before { content: '\\ea61'; } /* '' */\n.uil-italic:before { content: '\\ea62'; } /* '' */\n.uil-jackhammer:before { content: '\\ea63'; } /* '' */\n.uil-java-script:before { content: '\\ea64'; } /* '' */\n.uil-kayak:before { content: '\\ea65'; } /* '' */\n.uil-key-skeleton-alt:before { content: '\\ea66'; } /* '' */\n.uil-key-skeleton:before { content: '\\ea67'; } /* '' */\n.uil-keyboard-alt:before { content: '\\ea68'; } /* '' */\n.uil-keyboard-hide:before { content: '\\ea69'; } /* '' */\n.uil-keyboard-show:before { content: '\\ea6a'; } /* '' */\n.uil-keyboard:before { content: '\\ea6b'; } /* '' */\n.uil-keyhole-circle:before { content: '\\ea6c'; } /* '' */\n.uil-keyhole-square-full:before { content: '\\ea6d'; } /* '' */\n.uil-keyhole-square:before { content: '\\ea6e'; } /* '' */\n.uil-kid:before { content: '\\ea6f'; } /* '' */\n.uil-label-alt:before { content: '\\ea70'; } /* '' */\n.uil-label:before { content: '\\ea71'; } /* '' */\n.uil-lamp:before { content: '\\ea72'; } /* '' */\n.uil-laptop-cloud:before { content: '\\ea73'; } /* '' */\n.uil-laptop:before { content: '\\ea74'; } /* '' */\n.uil-laughing:before { content: '\\ea75'; } /* '' */\n.uil-layer-group-slash:before { content: '\\ea76'; } /* '' */\n.uil-layer-group:before { content: '\\ea77'; } /* '' */\n.uil-layers-alt:before { content: '\\ea78'; } /* '' */\n.uil-layers-slash:before { content: '\\ea79'; } /* '' */\n.uil-layers:before { content: '\\ea7a'; } /* '' */\n.uil-left-arrow-from-left:before { content: '\\ea7b'; } /* '' */\n.uil-left-arrow-to-left:before { content: '\\ea7c'; } /* '' */\n.uil-left-indent-alt:before { content: '\\ea7d'; } /* '' */\n.uil-left-indent:before { content: '\\ea7e'; } /* '' */\n.uil-left-to-right-text-direction:before { content: '\\ea7f'; } /* '' */\n.uil-life-ring:before { content: '\\ea80'; } /* '' */\n.uil-lightbulb-alt:before { content: '\\ea81'; } /* '' */\n.uil-lightbulb:before { content: '\\ea82'; } /* '' */\n.uil-line-alt:before { content: '\\ea83'; } /* '' */\n.uil-line-spacing:before { content: '\\ea84'; } /* '' */\n.uil-line:before { content: '\\ea85'; } /* '' */\n.uil-link-alt:before { content: '\\ea86'; } /* '' */\n.uil-link-broken:before { content: '\\ea87'; } /* '' */\n.uil-link-h:before { content: '\\ea88'; } /* '' */\n.uil-link:before { content: '\\ea89'; } /* '' */\n.uil-linkedin-alt:before { content: '\\ea8a'; } /* '' */\n.uil-linkedin:before { content: '\\ea8b'; } /* '' */\n.uil-list-ui-alt:before { content: '\\ea8c'; } /* '' */\n.uil-list-ul:before { content: '\\ea8d'; } /* '' */\n.uil-location-arrow-alt:before { content: '\\ea8e'; } /* '' */\n.uil-location-arrow:before { content: '\\ea8f'; } /* '' */\n.uil-location-pin-alt:before { content: '\\ea90'; } /* '' */\n.uil-location-point:before { content: '\\ea91'; } /* '' */\n.uil-location:before { content: '\\ea92'; } /* '' */\n.uil-lock-access:before { content: '\\ea93'; } /* '' */\n.uil-lock-alt:before { content: '\\ea94'; } /* '' */\n.uil-lock-open-alt:before { content: '\\ea95'; } /* '' */\n.uil-lock-slash:before { content: '\\ea96'; } /* '' */\n.uil-lock:before { content: '\\ea97'; } /* '' */\n.uil-mailbox-alt:before { content: '\\ea98'; } /* '' */\n.uil-mailbox:before { content: '\\ea99'; } /* '' */\n.uil-map-marker-alt:before { content: '\\ea9a'; } /* '' */\n.uil-map-marker-edit:before { content: '\\ea9b'; } /* '' */\n.uil-map-marker-info:before { content: '\\ea9c'; } /* '' */\n.uil-map-marker-minus:before { content: '\\ea9d'; } /* '' */\n.uil-map-marker-plus:before { content: '\\ea9e'; } /* '' */\n.uil-map-marker-question:before { content: '\\ea9f'; } /* '' */\n.uil-map-marker-shield:before { content: '\\eaa0'; } /* '' */\n.uil-map-marker-slash:before { content: '\\eaa1'; } /* '' */\n.uil-map-marker:before { content: '\\eaa2'; } /* '' */\n.uil-map-pin-alt:before { content: '\\eaa3'; } /* '' */\n.uil-map-pin:before { content: '\\eaa4'; } /* '' */\n.uil-map:before { content: '\\eaa5'; } /* '' */\n.uil-mars:before { content: '\\eaa6'; } /* '' */\n.uil-maximize-left:before { content: '\\eaa7'; } /* '' */\n.uil-medal:before { content: '\\eaa8'; } /* '' */\n.uil-medical-drip:before { content: '\\eaa9'; } /* '' */\n.uil-medical-square-full:before { content: '\\eaaa'; } /* '' */\n.uil-medical-square:before { content: '\\eaab'; } /* '' */\n.uil-medical:before { content: '\\eaac'; } /* '' */\n.uil-medium-m:before { content: '\\eaad'; } /* '' */\n.uil-medkit:before { content: '\\eaae'; } /* '' */\n.uil-meeting-board:before { content: '\\eaaf'; } /* '' */\n.uil-meh-alt:before { content: '\\eab0'; } /* '' */\n.uil-meh-closed-eye:before { content: '\\eab1'; } /* '' */\n.uil-meh:before { content: '\\eab2'; } /* '' */\n.uil-message:before { content: '\\eab3'; } /* '' */\n.uil-microphone-slash:before { content: '\\eab4'; } /* '' */\n.uil-microphone:before { content: '\\eab5'; } /* '' */\n.uil-minus-circle:before { content: '\\eab6'; } /* '' */\n.uil-minus-path:before { content: '\\eab7'; } /* '' */\n.uil-minus-square-full:before { content: '\\eab8'; } /* '' */\n.uil-minus-square:before { content: '\\eab9'; } /* '' */\n.uil-minus:before { content: '\\eaba'; } /* '' */\n.uil-missed-call:before { content: '\\eabb'; } /* '' */\n.uil-mobey-bill-slash:before { content: '\\eabc'; } /* '' */\n.uil-mobile-android-alt:before { content: '\\eabd'; } /* '' */\n.uil-mobile-android:before { content: '\\eabe'; } /* '' */\n.uil-mobile-vibrate:before { content: '\\eabf'; } /* '' */\n.uil-modem:before { content: '\\eac0'; } /* '' */\n.uil-money-bill-stack:before { content: '\\eac1'; } /* '' */\n.uil-money-bill:before { content: '\\eac2'; } /* '' */\n.uil-money-insert:before { content: '\\eac3'; } /* '' */\n.uil-money-stack:before { content: '\\eac4'; } /* '' */\n.uil-money-withdraw:before { content: '\\eac5'; } /* '' */\n.uil-money-withdrawal:before { content: '\\eac6'; } /* '' */\n.uil-moneybag-alt:before { content: '\\eac7'; } /* '' */\n.uil-moneybag:before { content: '\\eac8'; } /* '' */\n.uil-monitor-heart-rate:before { content: '\\eac9'; } /* '' */\n.uil-monitor:before { content: '\\eaca'; } /* '' */\n.uil-moon-eclipse:before { content: '\\eacb'; } /* '' */\n.uil-moon:before { content: '\\eacc'; } /* '' */\n.uil-moonset:before { content: '\\eacd'; } /* '' */\n.uil-mountains-sun:before { content: '\\eace'; } /* '' */\n.uil-mountains:before { content: '\\eacf'; } /* '' */\n.uil-mouse-alt:before { content: '\\ead0'; } /* '' */\n.uil-mouse:before { content: '\\ead1'; } /* '' */\n.uil-multiply:before { content: '\\ead2'; } /* '' */\n.uil-music-note:before { content: '\\ead3'; } /* '' */\n.uil-music-tune-slash:before { content: '\\ead4'; } /* '' */\n.uil-music:before { content: '\\ead5'; } /* '' */\n.uil-n-a:before { content: '\\ead6'; } /* '' */\n.uil-navigator:before { content: '\\ead7'; } /* '' */\n.uil-nerd:before { content: '\\ead8'; } /* '' */\n.uil-newspaper:before { content: '\\ead9'; } /* '' */\n.uil-ninja:before { content: '\\eada'; } /* '' */\n.uil-no-entry:before { content: '\\eadb'; } /* '' */\n.uil-notebooks:before { content: '\\eadc'; } /* '' */\n.uil-notes:before { content: '\\eadd'; } /* '' */\n.uil-object-group:before { content: '\\eade'; } /* '' */\n.uil-object-ungroup:before { content: '\\eadf'; } /* '' */\n.uil-octagon:before { content: '\\eae0'; } /* '' */\n.uil-outgoing-call:before { content: '\\eae1'; } /* '' */\n.uil-package:before { content: '\\eae2'; } /* '' */\n.uil-padlock:before { content: '\\eae3'; } /* '' */\n.uil-paint-tool:before { content: '\\eae4'; } /* '' */\n.uil-palette:before { content: '\\eae5'; } /* '' */\n.uil-panorama-h-alt:before { content: '\\eae6'; } /* '' */\n.uil-panorama-h:before { content: '\\eae7'; } /* '' */\n.uil-panorama-v:before { content: '\\eae8'; } /* '' */\n.uil-paperclip:before { content: '\\eae9'; } /* '' */\n.uil-paragraph:before { content: '\\eaea'; } /* '' */\n.uil-parcel:before { content: '\\eaeb'; } /* '' */\n.uil-parking-square:before { content: '\\eaec'; } /* '' */\n.uil-pathfinder-unite:before { content: '\\eaed'; } /* '' */\n.uil-pathfinder:before { content: '\\eaee'; } /* '' */\n.uil-pause-circle:before { content: '\\eaef'; } /* '' */\n.uil-pause:before { content: '\\eaf0'; } /* '' */\n.uil-paypal:before { content: '\\eaf1'; } /* '' */\n.uil-pen:before { content: '\\eaf2'; } /* '' */\n.uil-pentagon:before { content: '\\eaf3'; } /* '' */\n.uil-phone-alt:before { content: '\\eaf4'; } /* '' */\n.uil-phone-pause:before { content: '\\eaf5'; } /* '' */\n.uil-phone-slash:before { content: '\\eaf6'; } /* '' */\n.uil-phone-times:before { content: '\\eaf7'; } /* '' */\n.uil-phone-volume:before { content: '\\eaf8'; } /* '' */\n.uil-phone:before { content: '\\eaf9'; } /* '' */\n.uil-picture:before { content: '\\eafa'; } /* '' */\n.uil-plane-arrival:before { content: '\\eafb'; } /* '' */\n.uil-plane-departure:before { content: '\\eafc'; } /* '' */\n.uil-plane-fly:before { content: '\\eafd'; } /* '' */\n.uil-plane:before { content: '\\eafe'; } /* '' */\n.uil-play-circle:before { content: '\\eaff'; } /* '' */\n.uil-play:before { content: '\\eb00'; } /* '' */\n.uil-plug:before { content: '\\eb01'; } /* '' */\n.uil-plus-circle:before { content: '\\eb02'; } /* '' */\n.uil-plus-square:before { content: '\\eb03'; } /* '' */\n.uil-plus:before { content: '\\eb04'; } /* '' */\n.uil-podium:before { content: '\\eb05'; } /* '' */\n.uil-polygon:before { content: '\\eb06'; } /* '' */\n.uil-post-stamp:before { content: '\\eb07'; } /* '' */\n.uil-postcard:before { content: '\\eb08'; } /* '' */\n.uil-pound-circle:before { content: '\\eb09'; } /* '' */\n.uil-pound:before { content: '\\eb0a'; } /* '' */\n.uil-power:before { content: '\\eb0b'; } /* '' */\n.uil-prescription-bottle:before { content: '\\eb0c'; } /* '' */\n.uil-presentation-check:before { content: '\\eb0d'; } /* '' */\n.uil-presentation-edit:before { content: '\\eb0e'; } /* '' */\n.uil-presentation-line:before { content: '\\eb0f'; } /* '' */\n.uil-presentation-lines-alt:before { content: '\\eb10'; } /* '' */\n.uil-presentation-minus:before { content: '\\eb11'; } /* '' */\n.uil-presentation-play:before { content: '\\eb12'; } /* '' */\n.uil-presentation-plus:before { content: '\\eb13'; } /* '' */\n.uil-presentation-times:before { content: '\\eb14'; } /* '' */\n.uil-presentation:before { content: '\\eb15'; } /* '' */\n.uil-previous:before { content: '\\eb16'; } /* '' */\n.uil-pricetag-alt:before { content: '\\eb17'; } /* '' */\n.uil-print-slash:before { content: '\\eb18'; } /* '' */\n.uil-print:before { content: '\\eb19'; } /* '' */\n.uil-processor:before { content: '\\eb1a'; } /* '' */\n.uil-pump:before { content: '\\eb1b'; } /* '' */\n.uil-puzzle-piece:before { content: '\\eb1c'; } /* '' */\n.uil-question-circle:before { content: '\\eb1d'; } /* '' */\n.uil-raddit-alien-alt:before { content: '\\eb1e'; } /* '' */\n.uil-rainbow:before { content: '\\eb1f'; } /* '' */\n.uil-raindrops-alt:before { content: '\\eb20'; } /* '' */\n.uil-raindrops:before { content: '\\eb21'; } /* '' */\n.uil-receipt-alt:before { content: '\\eb22'; } /* '' */\n.uil-receipt:before { content: '\\eb23'; } /* '' */\n.uil-record-audio:before { content: '\\eb24'; } /* '' */\n.uil-redo:before { content: '\\eb25'; } /* '' */\n.uil-refresh:before { content: '\\eb26'; } /* '' */\n.uil-registered:before { content: '\\eb27'; } /* '' */\n.uil-repeat:before { content: '\\eb28'; } /* '' */\n.uil-restaurant:before { content: '\\eb29'; } /* '' */\n.uil-right-indent-alt:before { content: '\\eb2a'; } /* '' */\n.uil-right-to-left-text-direction:before { content: '\\eb2b'; } /* '' */\n.uil-robot:before { content: '\\eb2c'; } /* '' */\n.uil-rope-way:before { content: '\\eb2d'; } /* '' */\n.uil-rotate-360:before { content: '\\eb2e'; } /* '' */\n.uil-rss-alt:before { content: '\\eb2f'; } /* '' */\n.uil-rss-interface:before { content: '\\eb30'; } /* '' */\n.uil-rss:before { content: '\\eb31'; } /* '' */\n.uil-ruler-combined:before { content: '\\eb32'; } /* '' */\n.uil-ruler:before { content: '\\eb33'; } /* '' */\n.uil-sad-cry:before { content: '\\eb34'; } /* '' */\n.uil-sad-crying:before { content: '\\eb35'; } /* '' */\n.uil-sad-dizzy:before { content: '\\eb36'; } /* '' */\n.uil-sad-squint:before { content: '\\eb37'; } /* '' */\n.uil-sad:before { content: '\\eb38'; } /* '' */\n.uil-scaling-left:before { content: '\\eb39'; } /* '' */\n.uil-scaling-right:before { content: '\\eb3a'; } /* '' */\n.uil-scenery:before { content: '\\eb3b'; } /* '' */\n.uil-schedule:before { content: '\\eb3c'; } /* '' */\n.uil-science:before { content: '\\eb3d'; } /* '' */\n.uil-screw:before { content: '\\eb3e'; } /* '' */\n.uil-scroll-h:before { content: '\\eb3f'; } /* '' */\n.uil-scroll:before { content: '\\eb40'; } /* '' */\n.uil-search-alt:before { content: '\\eb41'; } /* '' */\n.uil-search-minus:before { content: '\\eb42'; } /* '' */\n.uil-search-plus:before { content: '\\eb43'; } /* '' */\n.uil-search:before { content: '\\eb44'; } /* '' */\n.uil-selfie:before { content: '\\eb45'; } /* '' */\n.uil-server-alt:before { content: '\\eb46'; } /* '' */\n.uil-server-connection:before { content: '\\eb47'; } /* '' */\n.uil-server-network-alt:before { content: '\\eb48'; } /* '' */\n.uil-server-network:before { content: '\\eb49'; } /* '' */\n.uil-server:before { content: '\\eb4a'; } /* '' */\n.uil-servers:before { content: '\\eb4b'; } /* '' */\n.uil-servicemark:before { content: '\\eb4c'; } /* '' */\n.uil-share-alt:before { content: '\\eb4d'; } /* '' */\n.uil-shield-check:before { content: '\\eb4e'; } /* '' */\n.uil-shield-exclamation:before { content: '\\eb4f'; } /* '' */\n.uil-shield-question:before { content: '\\eb50'; } /* '' */\n.uil-shield-slash:before { content: '\\eb51'; } /* '' */\n.uil-shield:before { content: '\\eb52'; } /* '' */\n.uil-ship:before { content: '\\eb53'; } /* '' */\n.uil-shop:before { content: '\\eb54'; } /* '' */\n.uil-shopping-basket:before { content: '\\eb55'; } /* '' */\n.uil-shopping-cart-alt:before { content: '\\eb56'; } /* '' */\n.uil-shopping-trolley:before { content: '\\eb57'; } /* '' */\n.uil-shovel:before { content: '\\eb58'; } /* '' */\n.uil-shrink:before { content: '\\eb59'; } /* '' */\n.uil-shuffle:before { content: '\\eb5a'; } /* '' */\n.uil-shutter-alt:before { content: '\\eb5b'; } /* '' */\n.uil-shutter:before { content: '\\eb5c'; } /* '' */\n.uil-sick:before { content: '\\eb5d'; } /* '' */\n.uil-sigma:before { content: '\\eb5e'; } /* '' */\n.uil-sign-alt:before { content: '\\eb5f'; } /* '' */\n.uil-sign-in-alt:before { content: '\\eb60'; } /* '' */\n.uil-sign-left:before { content: '\\eb61'; } /* '' */\n.uil-sign-out-alt:before { content: '\\eb62'; } /* '' */\n.uil-sign-right:before { content: '\\eb63'; } /* '' */\n.uil-signal-alt-3:before { content: '\\eb64'; } /* '' */\n.uil-signal-alt:before { content: '\\eb65'; } /* '' */\n.uil-signal:before { content: '\\eb66'; } /* '' */\n.uil-silence:before { content: '\\eb67'; } /* '' */\n.uil-silent-squint:before { content: '\\eb68'; } /* '' */\n.uil-sim-card:before { content: '\\eb69'; } /* '' */\n.uil-sitemap:before { content: '\\eb6a'; } /* '' */\n.uil-skip-forward-alt:before { content: '\\eb6b'; } /* '' */\n.uil-skip-forward-circle:before { content: '\\eb6c'; } /* '' */\n.uil-skip-forward:before { content: '\\eb6d'; } /* '' */\n.uil-slack-alt:before { content: '\\eb6e'; } /* '' */\n.uil-slack:before { content: '\\eb6f'; } /* '' */\n.uil-sliders-v-alt:before { content: '\\eb70'; } /* '' */\n.uil-sliders-v:before { content: '\\eb71'; } /* '' */\n.uil-smile-beam:before { content: '\\eb72'; } /* '' */\n.uil-smile-dizzy:before { content: '\\eb73'; } /* '' */\n.uil-smile-squint-wink-alt:before { content: '\\eb74'; } /* '' */\n.uil-smile-squint-wink:before { content: '\\eb75'; } /* '' */\n.uil-smile-wink-alt:before { content: '\\eb76'; } /* '' */\n.uil-smile-wink:before { content: '\\eb77'; } /* '' */\n.uil-smile:before { content: '\\eb78'; } /* '' */\n.uil-snapchat-ghost:before { content: '\\eb79'; } /* '' */\n.uil-snapchat-square:before { content: '\\eb7a'; } /* '' */\n.uil-snow-flake:before { content: '\\eb7b'; } /* '' */\n.uil-snowflake-alt:before { content: '\\eb7c'; } /* '' */\n.uil-snowflake:before { content: '\\eb7d'; } /* '' */\n.uil-sort-amount-down:before { content: '\\eb7e'; } /* '' */\n.uil-sort-amount-up:before { content: '\\eb7f'; } /* '' */\n.uil-sort:before { content: '\\eb80'; } /* '' */\n.uil-sorting:before { content: '\\eb81'; } /* '' */\n.uil-space-key:before { content: '\\eb82'; } /* '' */\n.uil-spade:before { content: '\\eb83'; } /* '' */\n.uil-sperms:before { content: '\\eb84'; } /* '' */\n.uil-spin:before { content: '\\eb85'; } /* '' */\n.uil-sport:before { content: '\\eb86'; } /* '' */\n.uil-square-full:before { content: '\\eb87'; } /* '' */\n.uil-square-shape:before { content: '\\eb88'; } /* '' */\n.uil-square:before { content: '\\eb89'; } /* '' */\n.uil-squint:before { content: '\\eb8a'; } /* '' */\n.uil-star-half-alt:before { content: '\\eb8b'; } /* '' */\n.uil-star:before { content: '\\eb8c'; } /* '' */\n.uil-step-backward-alt:before { content: '\\eb8d'; } /* '' */\n.uil-step-backward-circle:before { content: '\\eb8e'; } /* '' */\n.uil-step-backward:before { content: '\\eb8f'; } /* '' */\n.uil-step-forward:before { content: '\\eb90'; } /* '' */\n.uil-stop-circle:before { content: '\\eb91'; } /* '' */\n.uil-stopwatch-slash:before { content: '\\eb92'; } /* '' */\n.uil-stopwatch:before { content: '\\eb93'; } /* '' */\n.uil-store-alt:before { content: '\\eb94'; } /* '' */\n.uil-store:before { content: '\\eb95'; } /* '' */\n.uil-streering:before { content: '\\eb96'; } /* '' */\n.uil-stretcher:before { content: '\\eb97'; } /* '' */\n.uil-subject:before { content: '\\eb98'; } /* '' */\n.uil-subway-alt:before { content: '\\eb99'; } /* '' */\n.uil-subway:before { content: '\\eb9a'; } /* '' */\n.uil-suitcase-alt:before { content: '\\eb9b'; } /* '' */\n.uil-suitcase:before { content: '\\eb9c'; } /* '' */\n.uil-sun:before { content: '\\eb9d'; } /* '' */\n.uil-sunset:before { content: '\\eb9e'; } /* '' */\n.uil-surprise:before { content: '\\eb9f'; } /* '' */\n.uil-swatchbook:before { content: '\\eba0'; } /* '' */\n.uil-swimmer:before { content: '\\eba1'; } /* '' */\n.uil-symbol:before { content: '\\eba2'; } /* '' */\n.uil-sync-exclamation:before { content: '\\eba3'; } /* '' */\n.uil-sync-slash:before { content: '\\eba4'; } /* '' */\n.uil-sync:before { content: '\\eba5'; } /* '' */\n.uil-syringe:before { content: '\\eba6'; } /* '' */\n.uil-table:before { content: '\\eba7'; } /* '' */\n.uil-tablet:before { content: '\\eba8'; } /* '' */\n.uil-tablets:before { content: '\\eba9'; } /* '' */\n.uil-tachometer-fast:before { content: '\\ebaa'; } /* '' */\n.uil-tag-alt:before { content: '\\ebab'; } /* '' */\n.uil-tag:before { content: '\\ebac'; } /* '' */\n.uil-tape:before { content: '\\ebad'; } /* '' */\n.uil-taxi:before { content: '\\ebae'; } /* '' */\n.uil-tear:before { content: '\\ebaf'; } /* '' */\n.uil-technology:before { content: '\\ebb0'; } /* '' */\n.uil-telescope:before { content: '\\ebb1'; } /* '' */\n.uil-temperature-empty:before { content: '\\ebb2'; } /* '' */\n.uil-temperature-half:before { content: '\\ebb3'; } /* '' */\n.uil-temperature-minus:before { content: '\\ebb4'; } /* '' */\n.uil-temperature-plus:before { content: '\\ebb5'; } /* '' */\n.uil-temperature-quarter:before { content: '\\ebb6'; } /* '' */\n.uil-temperature-three-quarter:before { content: '\\ebb7'; } /* '' */\n.uil-temperature:before { content: '\\ebb8'; } /* '' */\n.uil-text-fields:before { content: '\\ebb9'; } /* '' */\n.uil-text-size:before { content: '\\ebba'; } /* '' */\n.uil-text-strike-through:before { content: '\\ebbb'; } /* '' */\n.uil-text:before { content: '\\ebbc'; } /* '' */\n.uil-th-large:before { content: '\\ebbd'; } /* '' */\n.uil-th-slash:before { content: '\\ebbe'; } /* '' */\n.uil-th:before { content: '\\ebbf'; } /* '' */\n.uil-thermometer:before { content: '\\ebc0'; } /* '' */\n.uil-thumbs-down:before { content: '\\ebc1'; } /* '' */\n.uil-thumbs-up:before { content: '\\ebc2'; } /* '' */\n.uil-thunderstorm-moon:before { content: '\\ebc3'; } /* '' */\n.uil-thunderstorm-sun:before { content: '\\ebc4'; } /* '' */\n.uil-thunderstorm:before { content: '\\ebc5'; } /* '' */\n.uil-ticket:before { content: '\\ebc6'; } /* '' */\n.uil-times-circle:before { content: '\\ebc7'; } /* '' */\n.uil-times-square:before { content: '\\ebc8'; } /* '' */\n.uil-times:before { content: '\\ebc9'; } /* '' */\n.uil-toggle-off:before { content: '\\ebca'; } /* '' */\n.uil-toggle-on:before { content: '\\ebcb'; } /* '' */\n.uil-top-arrow-from-top:before { content: '\\ebcc'; } /* '' */\n.uil-top-arrow-to-top:before { content: '\\ebcd'; } /* '' */\n.uil-tornado:before { content: '\\ebce'; } /* '' */\n.uil-trademark-circle:before { content: '\\ebcf'; } /* '' */\n.uil-trademark:before { content: '\\ebd0'; } /* '' */\n.uil-traffic-barrier:before { content: '\\ebd1'; } /* '' */\n.uil-trash-alt:before { content: '\\ebd2'; } /* '' */\n.uil-trash:before { content: '\\ebd3'; } /* '' */\n.uil-trees:before { content: '\\ebd4'; } /* '' */\n.uil-triangle:before { content: '\\ebd5'; } /* '' */\n.uil-trophy:before { content: '\\ebd6'; } /* '' */\n.uil-trowel:before { content: '\\ebd7'; } /* '' */\n.uil-truck-case:before { content: '\\ebd8'; } /* '' */\n.uil-truck-loading:before { content: '\\ebd9'; } /* '' */\n.uil-truck:before { content: '\\ebda'; } /* '' */\n.uil-tumblr-square:before { content: '\\ebdb'; } /* '' */\n.uil-tumblr:before { content: '\\ebdc'; } /* '' */\n.uil-tv-retro-slash:before { content: '\\ebdd'; } /* '' */\n.uil-tv-retro:before { content: '\\ebde'; } /* '' */\n.uil-twitter:before { content: '\\ebdf'; } /* '' */\n.uil-umbrella:before { content: '\\ebe0'; } /* '' */\n.uil-unamused:before { content: '\\ebe1'; } /* '' */\n.uil-underline:before { content: '\\ebe2'; } /* '' */\n.uil-unlock-alt:before { content: '\\ebe3'; } /* '' */\n.uil-unlock:before { content: '\\ebe4'; } /* '' */\n.uil-upload-alt:before { content: '\\ebe5'; } /* '' */\n.uil-upload:before { content: '\\ebe6'; } /* '' */\n.uil-usd-circle:before { content: '\\ebe7'; } /* '' */\n.uil-usd-square:before { content: '\\ebe8'; } /* '' */\n.uil-user-check:before { content: '\\ebe9'; } /* '' */\n.uil-user-circle:before { content: '\\ebea'; } /* '' */\n.uil-user-exclamation:before { content: '\\ebeb'; } /* '' */\n.uil-user-hard-hat:before { content: '\\ebec'; } /* '' */\n.uil-user-minus:before { content: '\\ebed'; } /* '' */\n.uil-user-plus:before { content: '\\ebee'; } /* '' */\n.uil-user-square:before { content: '\\ebef'; } /* '' */\n.uil-user-times:before { content: '\\ebf0'; } /* '' */\n.uil-user:before { content: '\\ebf1'; } /* '' */\n.uil-users-alt:before { content: '\\ebf2'; } /* '' */\n.uil-utensils-alt:before { content: '\\ebf3'; } /* '' */\n.uil-utensils:before { content: '\\ebf4'; } /* '' */\n.uil-vector-square-alt:before { content: '\\ebf5'; } /* '' */\n.uil-vector-square:before { content: '\\ebf6'; } /* '' */\n.uil-venus:before { content: '\\ebf7'; } /* '' */\n.uil-vertical-align-bottom:before { content: '\\ebf8'; } /* '' */\n.uil-vertical-align-center:before { content: '\\ebf9'; } /* '' */\n.uil-vertical-align-top:before { content: '\\ebfa'; } /* '' */\n.uil-vertical-distribute-bottom:before { content: '\\ebfb'; } /* '' */\n.uil-vertical-distribution-center:before { content: '\\ebfc'; } /* '' */\n.uil-vertical-distribution-top:before { content: '\\ebfd'; } /* '' */\n.uil-video-slash:before { content: '\\ebfe'; } /* '' */\n.uil-video:before { content: '\\ebff'; } /* '' */\n.uil-visual-studio:before { content: '\\ec00'; } /* '' */\n.uil-voicemail-rectangle:before { content: '\\ec01'; } /* '' */\n.uil-voicemail:before { content: '\\ec02'; } /* '' */\n.uil-volleyball:before { content: '\\ec03'; } /* '' */\n.uil-volume-down:before { content: '\\ec04'; } /* '' */\n.uil-volume-mute:before { content: '\\ec05'; } /* '' */\n.uil-volume-off:before { content: '\\ec06'; } /* '' */\n.uil-volume-up:before { content: '\\ec07'; } /* '' */\n.uil-volume:before { content: '\\ec08'; } /* '' */\n.uil-vuejs-alt:before { content: '\\ec09'; } /* '' */\n.uil-vuejs:before { content: '\\ec0a'; } /* '' */\n.uil-wall:before { content: '\\ec0b'; } /* '' */\n.uil-wallet:before { content: '\\ec0c'; } /* '' */\n.uil-watch-alt:before { content: '\\ec0d'; } /* '' */\n.uil-watch:before { content: '\\ec0e'; } /* '' */\n.uil-water-drop-slash:before { content: '\\ec0f'; } /* '' */\n.uil-water-glass:before { content: '\\ec10'; } /* '' */\n.uil-water:before { content: '\\ec11'; } /* '' */\n.uil-web-grid-alt:before { content: '\\ec12'; } /* '' */\n.uil-web-grid:before { content: '\\ec13'; } /* '' */\n.uil-web-section-alt:before { content: '\\ec14'; } /* '' */\n.uil-web-section:before { content: '\\ec15'; } /* '' */\n.uil-webcam:before { content: '\\ec16'; } /* '' */\n.uil-weight:before { content: '\\ec17'; } /* '' */\n.uil-whatsapp:before { content: '\\ec18'; } /* '' */\n.uil-wheel-barrow:before { content: '\\ec19'; } /* '' */\n.uil-wheelchair-alt:before { content: '\\ec1a'; } /* '' */\n.uil-wheelchair:before { content: '\\ec1b'; } /* '' */\n.uil-wifi-router:before { content: '\\ec1c'; } /* '' */\n.uil-wifi-slash:before { content: '\\ec1d'; } /* '' */\n.uil-wifi:before { content: '\\ec1e'; } /* '' */\n.uil-wind:before { content: '\\ec1f'; } /* '' */\n.uil-window-grid:before { content: '\\ec20'; } /* '' */\n.uil-window-maximize:before { content: '\\ec21'; } /* '' */\n.uil-window-restore:before { content: '\\ec22'; } /* '' */\n.uil-window-section:before { content: '\\ec23'; } /* '' */\n.uil-window:before { content: '\\ec24'; } /* '' */\n.uil-windsock:before { content: '\\ec25'; } /* '' */\n.uil-wrap-text:before { content: '\\ec26'; } /* '' */\n.uil-wrench:before { content: '\\ec27'; } /* '' */\n.uil-yellow:before { content: '\\ec28'; } /* '' */\n.uil-yen-circle:before { content: '\\ec29'; } /* '' */\n.uil-yen:before { content: '\\ec2a'; } /* '' */\n.uil-youtube-alt:before { content: '\\ec2b'; } /* '' */\n.uil-youtube:before { content: '\\ec2c'; } /* '' */","@charset \"UTF-8\";\n\n@font-face {\n  font-family: \"dripicons-v2\";\n  src:url(\"../../../../fonts/dripicons-v2.eot\");\n  src:url(\"../../../../fonts/dripicons-v2.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../../../../fonts/dripicons-v2.woff\") format(\"woff\"),\n    url(\"../../../../fonts/dripicons-v2.ttf\") format(\"truetype\"),\n    url(\"../../../../fonts/dripicons-v2.svg#dripicons-v2\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n[data-icon]:before {\n  font-family: \"dripicons-v2\" !important;\n  content: attr(data-icon);\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n[class^=\"dripicons-\"]:before,\n[class*=\" dripicons-\"]:before {\n  font-family: \"dripicons-v2\" !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  vertical-align: middle;\n  display: inline-block;\n}\n\n.dripicons-alarm:before {\n  content: \"\\61\";\n}\n.dripicons-align-center:before {\n  content: \"\\62\";\n}\n.dripicons-align-justify:before {\n  content: \"\\63\";\n}\n.dripicons-align-left:before {\n  content: \"\\64\";\n}\n.dripicons-align-right:before {\n  content: \"\\65\";\n}\n.dripicons-anchor:before {\n  content: \"\\66\";\n}\n.dripicons-archive:before {\n  content: \"\\67\";\n}\n.dripicons-arrow-down:before {\n  content: \"\\68\";\n}\n.dripicons-arrow-left:before {\n  content: \"\\69\";\n}\n.dripicons-arrow-right:before {\n  content: \"\\6a\";\n}\n.dripicons-arrow-thin-down:before {\n  content: \"\\6b\";\n}\n.dripicons-arrow-thin-left:before {\n  content: \"\\6c\";\n}\n.dripicons-arrow-thin-right:before {\n  content: \"\\6d\";\n}\n.dripicons-arrow-thin-up:before {\n  content: \"\\6e\";\n}\n.dripicons-arrow-up:before {\n  content: \"\\6f\";\n}\n.dripicons-article:before {\n  content: \"\\70\";\n}\n.dripicons-backspace:before {\n  content: \"\\71\";\n}\n.dripicons-basket:before {\n  content: \"\\72\";\n}\n.dripicons-basketball:before {\n  content: \"\\73\";\n}\n.dripicons-battery-empty:before {\n  content: \"\\74\";\n}\n.dripicons-battery-full:before {\n  content: \"\\75\";\n}\n.dripicons-battery-low:before {\n  content: \"\\76\";\n}\n.dripicons-battery-medium:before {\n  content: \"\\77\";\n}\n.dripicons-bell:before {\n  content: \"\\78\";\n}\n.dripicons-blog:before {\n  content: \"\\79\";\n}\n.dripicons-bluetooth:before {\n  content: \"\\7a\";\n}\n.dripicons-bold:before {\n  content: \"\\41\";\n}\n.dripicons-bookmark:before {\n  content: \"\\42\";\n}\n.dripicons-bookmarks:before {\n  content: \"\\43\";\n}\n.dripicons-box:before {\n  content: \"\\44\";\n}\n.dripicons-briefcase:before {\n  content: \"\\45\";\n}\n.dripicons-brightness-low:before {\n  content: \"\\46\";\n}\n.dripicons-brightness-max:before {\n  content: \"\\47\";\n}\n.dripicons-brightness-medium:before {\n  content: \"\\48\";\n}\n.dripicons-broadcast:before {\n  content: \"\\49\";\n}\n.dripicons-browser:before {\n  content: \"\\4a\";\n}\n.dripicons-browser-upload:before {\n  content: \"\\4b\";\n}\n.dripicons-brush:before {\n  content: \"\\4c\";\n}\n.dripicons-calendar:before {\n  content: \"\\4d\";\n}\n.dripicons-camcorder:before {\n  content: \"\\4e\";\n}\n.dripicons-camera:before {\n  content: \"\\4f\";\n}\n.dripicons-card:before {\n  content: \"\\50\";\n}\n.dripicons-cart:before {\n  content: \"\\51\";\n}\n.dripicons-checklist:before {\n  content: \"\\52\";\n}\n.dripicons-checkmark:before {\n  content: \"\\53\";\n}\n.dripicons-chevron-down:before {\n  content: \"\\54\";\n}\n.dripicons-chevron-left:before {\n  content: \"\\55\";\n}\n.dripicons-chevron-right:before {\n  content: \"\\56\";\n}\n.dripicons-chevron-up:before {\n  content: \"\\57\";\n}\n.dripicons-clipboard:before {\n  content: \"\\58\";\n}\n.dripicons-clock:before {\n  content: \"\\59\";\n}\n.dripicons-clockwise:before {\n  content: \"\\5a\";\n}\n.dripicons-cloud:before {\n  content: \"\\30\";\n}\n.dripicons-cloud-download:before {\n  content: \"\\31\";\n}\n.dripicons-cloud-upload:before {\n  content: \"\\32\";\n}\n.dripicons-code:before {\n  content: \"\\33\";\n}\n.dripicons-contract:before {\n  content: \"\\34\";\n}\n.dripicons-contract-2:before {\n  content: \"\\35\";\n}\n.dripicons-conversation:before {\n  content: \"\\36\";\n}\n.dripicons-copy:before {\n  content: \"\\37\";\n}\n.dripicons-crop:before {\n  content: \"\\38\";\n}\n.dripicons-cross:before {\n  content: \"\\39\";\n}\n.dripicons-crosshair:before {\n  content: \"\\21\";\n}\n.dripicons-cutlery:before {\n  content: \"\\22\";\n}\n.dripicons-device-desktop:before {\n  content: \"\\23\";\n}\n.dripicons-device-mobile:before {\n  content: \"\\24\";\n}\n.dripicons-device-tablet:before {\n  content: \"\\25\";\n}\n.dripicons-direction:before {\n  content: \"\\26\";\n}\n.dripicons-disc:before {\n  content: \"\\27\";\n}\n.dripicons-document:before {\n  content: \"\\28\";\n}\n.dripicons-document-delete:before {\n  content: \"\\29\";\n}\n.dripicons-document-edit:before {\n  content: \"\\2a\";\n}\n.dripicons-document-new:before {\n  content: \"\\2b\";\n}\n.dripicons-document-remove:before {\n  content: \"\\2c\";\n}\n.dripicons-dot:before {\n  content: \"\\2d\";\n}\n.dripicons-dots-2:before {\n  content: \"\\2e\";\n}\n.dripicons-dots-3:before {\n  content: \"\\2f\";\n}\n.dripicons-download:before {\n  content: \"\\3a\";\n}\n.dripicons-duplicate:before {\n  content: \"\\3b\";\n}\n.dripicons-enter:before {\n  content: \"\\3c\";\n}\n.dripicons-exit:before {\n  content: \"\\3d\";\n}\n.dripicons-expand:before {\n  content: \"\\3e\";\n}\n.dripicons-expand-2:before {\n  content: \"\\3f\";\n}\n.dripicons-experiment:before {\n  content: \"\\40\";\n}\n.dripicons-export:before {\n  content: \"\\5b\";\n}\n.dripicons-feed:before {\n  content: \"\\5d\";\n}\n.dripicons-flag:before {\n  content: \"\\5e\";\n}\n.dripicons-flashlight:before {\n  content: \"\\5f\";\n}\n.dripicons-folder:before {\n  content: \"\\60\";\n}\n.dripicons-folder-open:before {\n  content: \"\\7b\";\n}\n.dripicons-forward:before {\n  content: \"\\7c\";\n}\n.dripicons-gaming:before {\n  content: \"\\7d\";\n}\n.dripicons-gear:before {\n  content: \"\\7e\";\n}\n.dripicons-graduation:before {\n  content: \"\\5c\";\n}\n.dripicons-graph-bar:before {\n  content: \"\\e000\";\n}\n.dripicons-graph-line:before {\n  content: \"\\e001\";\n}\n.dripicons-graph-pie:before {\n  content: \"\\e002\";\n}\n.dripicons-headset:before {\n  content: \"\\e003\";\n}\n.dripicons-heart:before {\n  content: \"\\e004\";\n}\n.dripicons-help:before {\n  content: \"\\e005\";\n}\n.dripicons-home:before {\n  content: \"\\e006\";\n}\n.dripicons-hourglass:before {\n  content: \"\\e007\";\n}\n.dripicons-inbox:before {\n  content: \"\\e008\";\n}\n.dripicons-information:before {\n  content: \"\\e009\";\n}\n.dripicons-italic:before {\n  content: \"\\e00a\";\n}\n.dripicons-jewel:before {\n  content: \"\\e00b\";\n}\n.dripicons-lifting:before {\n  content: \"\\e00c\";\n}\n.dripicons-lightbulb:before {\n  content: \"\\e00d\";\n}\n.dripicons-link:before {\n  content: \"\\e00e\";\n}\n.dripicons-link-broken:before {\n  content: \"\\e00f\";\n}\n.dripicons-list:before {\n  content: \"\\e010\";\n}\n.dripicons-loading:before {\n  content: \"\\e011\";\n}\n.dripicons-location:before {\n  content: \"\\e012\";\n}\n.dripicons-lock:before {\n  content: \"\\e013\";\n}\n.dripicons-lock-open:before {\n  content: \"\\e014\";\n}\n.dripicons-mail:before {\n  content: \"\\e015\";\n}\n.dripicons-map:before {\n  content: \"\\e016\";\n}\n.dripicons-media-loop:before {\n  content: \"\\e017\";\n}\n.dripicons-media-next:before {\n  content: \"\\e018\";\n}\n.dripicons-media-pause:before {\n  content: \"\\e019\";\n}\n.dripicons-media-play:before {\n  content: \"\\e01a\";\n}\n.dripicons-media-previous:before {\n  content: \"\\e01b\";\n}\n.dripicons-media-record:before {\n  content: \"\\e01c\";\n}\n.dripicons-media-shuffle:before {\n  content: \"\\e01d\";\n}\n.dripicons-media-stop:before {\n  content: \"\\e01e\";\n}\n.dripicons-medical:before {\n  content: \"\\e01f\";\n}\n.dripicons-menu:before {\n  content: \"\\e020\";\n}\n.dripicons-message:before {\n  content: \"\\e021\";\n}\n.dripicons-meter:before {\n  content: \"\\e022\";\n}\n.dripicons-microphone:before {\n  content: \"\\e023\";\n}\n.dripicons-minus:before {\n  content: \"\\e024\";\n}\n.dripicons-monitor:before {\n  content: \"\\e025\";\n}\n.dripicons-move:before {\n  content: \"\\e026\";\n}\n.dripicons-music:before {\n  content: \"\\e027\";\n}\n.dripicons-network-1:before {\n  content: \"\\e028\";\n}\n.dripicons-network-2:before {\n  content: \"\\e029\";\n}\n.dripicons-network-3:before {\n  content: \"\\e02a\";\n}\n.dripicons-network-4:before {\n  content: \"\\e02b\";\n}\n.dripicons-network-5:before {\n  content: \"\\e02c\";\n}\n.dripicons-pamphlet:before {\n  content: \"\\e02d\";\n}\n.dripicons-paperclip:before {\n  content: \"\\e02e\";\n}\n.dripicons-pencil:before {\n  content: \"\\e02f\";\n}\n.dripicons-phone:before {\n  content: \"\\e030\";\n}\n.dripicons-photo:before {\n  content: \"\\e031\";\n}\n.dripicons-photo-group:before {\n  content: \"\\e032\";\n}\n.dripicons-pill:before {\n  content: \"\\e033\";\n}\n.dripicons-pin:before {\n  content: \"\\e034\";\n}\n.dripicons-plus:before {\n  content: \"\\e035\";\n}\n.dripicons-power:before {\n  content: \"\\e036\";\n}\n.dripicons-preview:before {\n  content: \"\\e037\";\n}\n.dripicons-print:before {\n  content: \"\\e038\";\n}\n.dripicons-pulse:before {\n  content: \"\\e039\";\n}\n.dripicons-question:before {\n  content: \"\\e03a\";\n}\n.dripicons-reply:before {\n  content: \"\\e03b\";\n}\n.dripicons-reply-all:before {\n  content: \"\\e03c\";\n}\n.dripicons-return:before {\n  content: \"\\e03d\";\n}\n.dripicons-retweet:before {\n  content: \"\\e03e\";\n}\n.dripicons-rocket:before {\n  content: \"\\e03f\";\n}\n.dripicons-scale:before {\n  content: \"\\e040\";\n}\n.dripicons-search:before {\n  content: \"\\e041\";\n}\n.dripicons-shopping-bag:before {\n  content: \"\\e042\";\n}\n.dripicons-skip:before {\n  content: \"\\e043\";\n}\n.dripicons-stack:before {\n  content: \"\\e044\";\n}\n.dripicons-star:before {\n  content: \"\\e045\";\n}\n.dripicons-stopwatch:before {\n  content: \"\\e046\";\n}\n.dripicons-store:before {\n  content: \"\\e047\";\n}\n.dripicons-suitcase:before {\n  content: \"\\e048\";\n}\n.dripicons-swap:before {\n  content: \"\\e049\";\n}\n.dripicons-tag:before {\n  content: \"\\e04a\";\n}\n.dripicons-tag-delete:before {\n  content: \"\\e04b\";\n}\n.dripicons-tags:before {\n  content: \"\\e04c\";\n}\n.dripicons-thumbs-down:before {\n  content: \"\\e04d\";\n}\n.dripicons-thumbs-up:before {\n  content: \"\\e04e\";\n}\n.dripicons-ticket:before {\n  content: \"\\e04f\";\n}\n.dripicons-time-reverse:before {\n  content: \"\\e050\";\n}\n.dripicons-to-do:before {\n  content: \"\\e051\";\n}\n.dripicons-toggles:before {\n  content: \"\\e052\";\n}\n.dripicons-trash:before {\n  content: \"\\e053\";\n}\n.dripicons-trophy:before {\n  content: \"\\e054\";\n}\n.dripicons-upload:before {\n  content: \"\\e055\";\n}\n.dripicons-user:before {\n  content: \"\\e056\";\n}\n.dripicons-user-group:before {\n  content: \"\\e057\";\n}\n.dripicons-user-id:before {\n  content: \"\\e058\";\n}\n.dripicons-vibrate:before {\n  content: \"\\e059\";\n}\n.dripicons-view-apps:before {\n  content: \"\\e05a\";\n}\n.dripicons-view-list:before {\n  content: \"\\e05b\";\n}\n.dripicons-view-list-large:before {\n  content: \"\\e05c\";\n}\n.dripicons-view-thumb:before {\n  content: \"\\e05d\";\n}\n.dripicons-volume-full:before {\n  content: \"\\e05e\";\n}\n.dripicons-volume-low:before {\n  content: \"\\e05f\";\n}\n.dripicons-volume-medium:before {\n  content: \"\\e060\";\n}\n.dripicons-volume-off:before {\n  content: \"\\e061\";\n}\n.dripicons-wallet:before {\n  content: \"\\e062\";\n}\n.dripicons-warning:before {\n  content: \"\\e063\";\n}\n.dripicons-web:before {\n  content: \"\\e064\";\n}\n.dripicons-weight:before {\n  content: \"\\e065\";\n}\n.dripicons-wifi:before {\n  content: \"\\e066\";\n}\n.dripicons-wrong:before {\n  content: \"\\e067\";\n}\n.dripicons-zoom-in:before {\n  content: \"\\e068\";\n}\n.dripicons-zoom-out:before {\n  content: \"\\e069\";\n}\n","/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?v=6.5.95\");\n  src: url(\"../../../../fonts/materialdesignicons-webfont.eot?#iefix&v=6.5.95\") format(\"embedded-opentype\"), url(\"../../../../fonts/materialdesignicons-webfont.woff2?v=6.5.95\") format(\"woff2\"), url(\"../../../../fonts/materialdesignicons-webfont.woff?v=6.5.95\") format(\"woff\"), url(\"../../../../fonts/materialdesignicons-webfont.ttf?v=6.5.95\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.mdi-ab-testing::before {\n  content: \"\\F01C9\";\n}\n\n.mdi-abacus::before {\n  content: \"\\F16E0\";\n}\n\n.mdi-abjad-arabic::before {\n  content: \"\\F1328\";\n}\n\n.mdi-abjad-hebrew::before {\n  content: \"\\F1329\";\n}\n\n.mdi-abugida-devanagari::before {\n  content: \"\\F132A\";\n}\n\n.mdi-abugida-thai::before {\n  content: \"\\F132B\";\n}\n\n.mdi-access-point::before {\n  content: \"\\F0003\";\n}\n\n.mdi-access-point-check::before {\n  content: \"\\F1538\";\n}\n\n.mdi-access-point-minus::before {\n  content: \"\\F1539\";\n}\n\n.mdi-access-point-network::before {\n  content: \"\\F0002\";\n}\n\n.mdi-access-point-network-off::before {\n  content: \"\\F0BE1\";\n}\n\n.mdi-access-point-off::before {\n  content: \"\\F1511\";\n}\n\n.mdi-access-point-plus::before {\n  content: \"\\F153A\";\n}\n\n.mdi-access-point-remove::before {\n  content: \"\\F153B\";\n}\n\n.mdi-account::before {\n  content: \"\\F0004\";\n}\n\n.mdi-account-alert::before {\n  content: \"\\F0005\";\n}\n\n.mdi-account-alert-outline::before {\n  content: \"\\F0B50\";\n}\n\n.mdi-account-arrow-down::before {\n  content: \"\\F1868\";\n}\n\n.mdi-account-arrow-down-outline::before {\n  content: \"\\F1869\";\n}\n\n.mdi-account-arrow-left::before {\n  content: \"\\F0B51\";\n}\n\n.mdi-account-arrow-left-outline::before {\n  content: \"\\F0B52\";\n}\n\n.mdi-account-arrow-right::before {\n  content: \"\\F0B53\";\n}\n\n.mdi-account-arrow-right-outline::before {\n  content: \"\\F0B54\";\n}\n\n.mdi-account-arrow-up::before {\n  content: \"\\F1867\";\n}\n\n.mdi-account-arrow-up-outline::before {\n  content: \"\\F186A\";\n}\n\n.mdi-account-box::before {\n  content: \"\\F0006\";\n}\n\n.mdi-account-box-multiple::before {\n  content: \"\\F0934\";\n}\n\n.mdi-account-box-multiple-outline::before {\n  content: \"\\F100A\";\n}\n\n.mdi-account-box-outline::before {\n  content: \"\\F0007\";\n}\n\n.mdi-account-cancel::before {\n  content: \"\\F12DF\";\n}\n\n.mdi-account-cancel-outline::before {\n  content: \"\\F12E0\";\n}\n\n.mdi-account-cash::before {\n  content: \"\\F1097\";\n}\n\n.mdi-account-cash-outline::before {\n  content: \"\\F1098\";\n}\n\n.mdi-account-check::before {\n  content: \"\\F0008\";\n}\n\n.mdi-account-check-outline::before {\n  content: \"\\F0BE2\";\n}\n\n.mdi-account-child::before {\n  content: \"\\F0A89\";\n}\n\n.mdi-account-child-circle::before {\n  content: \"\\F0A8A\";\n}\n\n.mdi-account-child-outline::before {\n  content: \"\\F10C8\";\n}\n\n.mdi-account-circle::before {\n  content: \"\\F0009\";\n}\n\n.mdi-account-circle-outline::before {\n  content: \"\\F0B55\";\n}\n\n.mdi-account-clock::before {\n  content: \"\\F0B56\";\n}\n\n.mdi-account-clock-outline::before {\n  content: \"\\F0B57\";\n}\n\n.mdi-account-cog::before {\n  content: \"\\F1370\";\n}\n\n.mdi-account-cog-outline::before {\n  content: \"\\F1371\";\n}\n\n.mdi-account-convert::before {\n  content: \"\\F000A\";\n}\n\n.mdi-account-convert-outline::before {\n  content: \"\\F1301\";\n}\n\n.mdi-account-cowboy-hat::before {\n  content: \"\\F0E9B\";\n}\n\n.mdi-account-cowboy-hat-outline::before {\n  content: \"\\F17F3\";\n}\n\n.mdi-account-details::before {\n  content: \"\\F0631\";\n}\n\n.mdi-account-details-outline::before {\n  content: \"\\F1372\";\n}\n\n.mdi-account-edit::before {\n  content: \"\\F06BC\";\n}\n\n.mdi-account-edit-outline::before {\n  content: \"\\F0FFB\";\n}\n\n.mdi-account-eye::before {\n  content: \"\\F0420\";\n}\n\n.mdi-account-eye-outline::before {\n  content: \"\\F127B\";\n}\n\n.mdi-account-filter::before {\n  content: \"\\F0936\";\n}\n\n.mdi-account-filter-outline::before {\n  content: \"\\F0F9D\";\n}\n\n.mdi-account-group::before {\n  content: \"\\F0849\";\n}\n\n.mdi-account-group-outline::before {\n  content: \"\\F0B58\";\n}\n\n.mdi-account-hard-hat::before {\n  content: \"\\F05B5\";\n}\n\n.mdi-account-heart::before {\n  content: \"\\F0899\";\n}\n\n.mdi-account-heart-outline::before {\n  content: \"\\F0BE3\";\n}\n\n.mdi-account-injury::before {\n  content: \"\\F1815\";\n}\n\n.mdi-account-injury-outline::before {\n  content: \"\\F1816\";\n}\n\n.mdi-account-key::before {\n  content: \"\\F000B\";\n}\n\n.mdi-account-key-outline::before {\n  content: \"\\F0BE4\";\n}\n\n.mdi-account-lock::before {\n  content: \"\\F115E\";\n}\n\n.mdi-account-lock-open::before {\n  content: \"\\F1960\";\n}\n\n.mdi-account-lock-open-outline::before {\n  content: \"\\F1961\";\n}\n\n.mdi-account-lock-outline::before {\n  content: \"\\F115F\";\n}\n\n.mdi-account-minus::before {\n  content: \"\\F000D\";\n}\n\n.mdi-account-minus-outline::before {\n  content: \"\\F0AEC\";\n}\n\n.mdi-account-multiple::before {\n  content: \"\\F000E\";\n}\n\n.mdi-account-multiple-check::before {\n  content: \"\\F08C5\";\n}\n\n.mdi-account-multiple-check-outline::before {\n  content: \"\\F11FE\";\n}\n\n.mdi-account-multiple-minus::before {\n  content: \"\\F05D3\";\n}\n\n.mdi-account-multiple-minus-outline::before {\n  content: \"\\F0BE5\";\n}\n\n.mdi-account-multiple-outline::before {\n  content: \"\\F000F\";\n}\n\n.mdi-account-multiple-plus::before {\n  content: \"\\F0010\";\n}\n\n.mdi-account-multiple-plus-outline::before {\n  content: \"\\F0800\";\n}\n\n.mdi-account-multiple-remove::before {\n  content: \"\\F120A\";\n}\n\n.mdi-account-multiple-remove-outline::before {\n  content: \"\\F120B\";\n}\n\n.mdi-account-music::before {\n  content: \"\\F0803\";\n}\n\n.mdi-account-music-outline::before {\n  content: \"\\F0CE9\";\n}\n\n.mdi-account-network::before {\n  content: \"\\F0011\";\n}\n\n.mdi-account-network-outline::before {\n  content: \"\\F0BE6\";\n}\n\n.mdi-account-off::before {\n  content: \"\\F0012\";\n}\n\n.mdi-account-off-outline::before {\n  content: \"\\F0BE7\";\n}\n\n.mdi-account-outline::before {\n  content: \"\\F0013\";\n}\n\n.mdi-account-plus::before {\n  content: \"\\F0014\";\n}\n\n.mdi-account-plus-outline::before {\n  content: \"\\F0801\";\n}\n\n.mdi-account-question::before {\n  content: \"\\F0B59\";\n}\n\n.mdi-account-question-outline::before {\n  content: \"\\F0B5A\";\n}\n\n.mdi-account-reactivate::before {\n  content: \"\\F152B\";\n}\n\n.mdi-account-reactivate-outline::before {\n  content: \"\\F152C\";\n}\n\n.mdi-account-remove::before {\n  content: \"\\F0015\";\n}\n\n.mdi-account-remove-outline::before {\n  content: \"\\F0AED\";\n}\n\n.mdi-account-search::before {\n  content: \"\\F0016\";\n}\n\n.mdi-account-search-outline::before {\n  content: \"\\F0935\";\n}\n\n.mdi-account-settings::before {\n  content: \"\\F0630\";\n}\n\n.mdi-account-settings-outline::before {\n  content: \"\\F10C9\";\n}\n\n.mdi-account-star::before {\n  content: \"\\F0017\";\n}\n\n.mdi-account-star-outline::before {\n  content: \"\\F0BE8\";\n}\n\n.mdi-account-supervisor::before {\n  content: \"\\F0A8B\";\n}\n\n.mdi-account-supervisor-circle::before {\n  content: \"\\F0A8C\";\n}\n\n.mdi-account-supervisor-circle-outline::before {\n  content: \"\\F14EC\";\n}\n\n.mdi-account-supervisor-outline::before {\n  content: \"\\F112D\";\n}\n\n.mdi-account-switch::before {\n  content: \"\\F0019\";\n}\n\n.mdi-account-switch-outline::before {\n  content: \"\\F04CB\";\n}\n\n.mdi-account-sync::before {\n  content: \"\\F191B\";\n}\n\n.mdi-account-sync-outline::before {\n  content: \"\\F191C\";\n}\n\n.mdi-account-tie::before {\n  content: \"\\F0CE3\";\n}\n\n.mdi-account-tie-hat::before {\n  content: \"\\F1898\";\n}\n\n.mdi-account-tie-hat-outline::before {\n  content: \"\\F1899\";\n}\n\n.mdi-account-tie-outline::before {\n  content: \"\\F10CA\";\n}\n\n.mdi-account-tie-voice::before {\n  content: \"\\F1308\";\n}\n\n.mdi-account-tie-voice-off::before {\n  content: \"\\F130A\";\n}\n\n.mdi-account-tie-voice-off-outline::before {\n  content: \"\\F130B\";\n}\n\n.mdi-account-tie-voice-outline::before {\n  content: \"\\F1309\";\n}\n\n.mdi-account-voice::before {\n  content: \"\\F05CB\";\n}\n\n.mdi-account-voice-off::before {\n  content: \"\\F0ED4\";\n}\n\n.mdi-account-wrench::before {\n  content: \"\\F189A\";\n}\n\n.mdi-account-wrench-outline::before {\n  content: \"\\F189B\";\n}\n\n.mdi-adjust::before {\n  content: \"\\F001A\";\n}\n\n.mdi-advertisements::before {\n  content: \"\\F192A\";\n}\n\n.mdi-advertisements-off::before {\n  content: \"\\F192B\";\n}\n\n.mdi-air-conditioner::before {\n  content: \"\\F001B\";\n}\n\n.mdi-air-filter::before {\n  content: \"\\F0D43\";\n}\n\n.mdi-air-horn::before {\n  content: \"\\F0DAC\";\n}\n\n.mdi-air-humidifier::before {\n  content: \"\\F1099\";\n}\n\n.mdi-air-humidifier-off::before {\n  content: \"\\F1466\";\n}\n\n.mdi-air-purifier::before {\n  content: \"\\F0D44\";\n}\n\n.mdi-airbag::before {\n  content: \"\\F0BE9\";\n}\n\n.mdi-airballoon::before {\n  content: \"\\F001C\";\n}\n\n.mdi-airballoon-outline::before {\n  content: \"\\F100B\";\n}\n\n.mdi-airplane::before {\n  content: \"\\F001D\";\n}\n\n.mdi-airplane-alert::before {\n  content: \"\\F187A\";\n}\n\n.mdi-airplane-check::before {\n  content: \"\\F187B\";\n}\n\n.mdi-airplane-clock::before {\n  content: \"\\F187C\";\n}\n\n.mdi-airplane-cog::before {\n  content: \"\\F187D\";\n}\n\n.mdi-airplane-edit::before {\n  content: \"\\F187E\";\n}\n\n.mdi-airplane-landing::before {\n  content: \"\\F05D4\";\n}\n\n.mdi-airplane-marker::before {\n  content: \"\\F187F\";\n}\n\n.mdi-airplane-minus::before {\n  content: \"\\F1880\";\n}\n\n.mdi-airplane-off::before {\n  content: \"\\F001E\";\n}\n\n.mdi-airplane-plus::before {\n  content: \"\\F1881\";\n}\n\n.mdi-airplane-remove::before {\n  content: \"\\F1882\";\n}\n\n.mdi-airplane-search::before {\n  content: \"\\F1883\";\n}\n\n.mdi-airplane-settings::before {\n  content: \"\\F1884\";\n}\n\n.mdi-airplane-takeoff::before {\n  content: \"\\F05D5\";\n}\n\n.mdi-airport::before {\n  content: \"\\F084B\";\n}\n\n.mdi-alarm::before {\n  content: \"\\F0020\";\n}\n\n.mdi-alarm-bell::before {\n  content: \"\\F078E\";\n}\n\n.mdi-alarm-check::before {\n  content: \"\\F0021\";\n}\n\n.mdi-alarm-light::before {\n  content: \"\\F078F\";\n}\n\n.mdi-alarm-light-off::before {\n  content: \"\\F171E\";\n}\n\n.mdi-alarm-light-off-outline::before {\n  content: \"\\F171F\";\n}\n\n.mdi-alarm-light-outline::before {\n  content: \"\\F0BEA\";\n}\n\n.mdi-alarm-multiple::before {\n  content: \"\\F0022\";\n}\n\n.mdi-alarm-note::before {\n  content: \"\\F0E71\";\n}\n\n.mdi-alarm-note-off::before {\n  content: \"\\F0E72\";\n}\n\n.mdi-alarm-off::before {\n  content: \"\\F0023\";\n}\n\n.mdi-alarm-panel::before {\n  content: \"\\F15C4\";\n}\n\n.mdi-alarm-panel-outline::before {\n  content: \"\\F15C5\";\n}\n\n.mdi-alarm-plus::before {\n  content: \"\\F0024\";\n}\n\n.mdi-alarm-snooze::before {\n  content: \"\\F068E\";\n}\n\n.mdi-album::before {\n  content: \"\\F0025\";\n}\n\n.mdi-alert::before {\n  content: \"\\F0026\";\n}\n\n.mdi-alert-box::before {\n  content: \"\\F0027\";\n}\n\n.mdi-alert-box-outline::before {\n  content: \"\\F0CE4\";\n}\n\n.mdi-alert-circle::before {\n  content: \"\\F0028\";\n}\n\n.mdi-alert-circle-check::before {\n  content: \"\\F11ED\";\n}\n\n.mdi-alert-circle-check-outline::before {\n  content: \"\\F11EE\";\n}\n\n.mdi-alert-circle-outline::before {\n  content: \"\\F05D6\";\n}\n\n.mdi-alert-decagram::before {\n  content: \"\\F06BD\";\n}\n\n.mdi-alert-decagram-outline::before {\n  content: \"\\F0CE5\";\n}\n\n.mdi-alert-minus::before {\n  content: \"\\F14BB\";\n}\n\n.mdi-alert-minus-outline::before {\n  content: \"\\F14BE\";\n}\n\n.mdi-alert-octagon::before {\n  content: \"\\F0029\";\n}\n\n.mdi-alert-octagon-outline::before {\n  content: \"\\F0CE6\";\n}\n\n.mdi-alert-octagram::before {\n  content: \"\\F0767\";\n}\n\n.mdi-alert-octagram-outline::before {\n  content: \"\\F0CE7\";\n}\n\n.mdi-alert-outline::before {\n  content: \"\\F002A\";\n}\n\n.mdi-alert-plus::before {\n  content: \"\\F14BA\";\n}\n\n.mdi-alert-plus-outline::before {\n  content: \"\\F14BD\";\n}\n\n.mdi-alert-remove::before {\n  content: \"\\F14BC\";\n}\n\n.mdi-alert-remove-outline::before {\n  content: \"\\F14BF\";\n}\n\n.mdi-alert-rhombus::before {\n  content: \"\\F11CE\";\n}\n\n.mdi-alert-rhombus-outline::before {\n  content: \"\\F11CF\";\n}\n\n.mdi-alien::before {\n  content: \"\\F089A\";\n}\n\n.mdi-alien-outline::before {\n  content: \"\\F10CB\";\n}\n\n.mdi-align-horizontal-center::before {\n  content: \"\\F11C3\";\n}\n\n.mdi-align-horizontal-distribute::before {\n  content: \"\\F1962\";\n}\n\n.mdi-align-horizontal-left::before {\n  content: \"\\F11C2\";\n}\n\n.mdi-align-horizontal-right::before {\n  content: \"\\F11C4\";\n}\n\n.mdi-align-vertical-bottom::before {\n  content: \"\\F11C5\";\n}\n\n.mdi-align-vertical-center::before {\n  content: \"\\F11C6\";\n}\n\n.mdi-align-vertical-distribute::before {\n  content: \"\\F1963\";\n}\n\n.mdi-align-vertical-top::before {\n  content: \"\\F11C7\";\n}\n\n.mdi-all-inclusive::before {\n  content: \"\\F06BE\";\n}\n\n.mdi-all-inclusive-box::before {\n  content: \"\\F188D\";\n}\n\n.mdi-all-inclusive-box-outline::before {\n  content: \"\\F188E\";\n}\n\n.mdi-allergy::before {\n  content: \"\\F1258\";\n}\n\n.mdi-alpha::before {\n  content: \"\\F002B\";\n}\n\n.mdi-alpha-a::before {\n  content: \"\\F0AEE\";\n}\n\n.mdi-alpha-a-box::before {\n  content: \"\\F0B08\";\n}\n\n.mdi-alpha-a-box-outline::before {\n  content: \"\\F0BEB\";\n}\n\n.mdi-alpha-a-circle::before {\n  content: \"\\F0BEC\";\n}\n\n.mdi-alpha-a-circle-outline::before {\n  content: \"\\F0BED\";\n}\n\n.mdi-alpha-b::before {\n  content: \"\\F0AEF\";\n}\n\n.mdi-alpha-b-box::before {\n  content: \"\\F0B09\";\n}\n\n.mdi-alpha-b-box-outline::before {\n  content: \"\\F0BEE\";\n}\n\n.mdi-alpha-b-circle::before {\n  content: \"\\F0BEF\";\n}\n\n.mdi-alpha-b-circle-outline::before {\n  content: \"\\F0BF0\";\n}\n\n.mdi-alpha-c::before {\n  content: \"\\F0AF0\";\n}\n\n.mdi-alpha-c-box::before {\n  content: \"\\F0B0A\";\n}\n\n.mdi-alpha-c-box-outline::before {\n  content: \"\\F0BF1\";\n}\n\n.mdi-alpha-c-circle::before {\n  content: \"\\F0BF2\";\n}\n\n.mdi-alpha-c-circle-outline::before {\n  content: \"\\F0BF3\";\n}\n\n.mdi-alpha-d::before {\n  content: \"\\F0AF1\";\n}\n\n.mdi-alpha-d-box::before {\n  content: \"\\F0B0B\";\n}\n\n.mdi-alpha-d-box-outline::before {\n  content: \"\\F0BF4\";\n}\n\n.mdi-alpha-d-circle::before {\n  content: \"\\F0BF5\";\n}\n\n.mdi-alpha-d-circle-outline::before {\n  content: \"\\F0BF6\";\n}\n\n.mdi-alpha-e::before {\n  content: \"\\F0AF2\";\n}\n\n.mdi-alpha-e-box::before {\n  content: \"\\F0B0C\";\n}\n\n.mdi-alpha-e-box-outline::before {\n  content: \"\\F0BF7\";\n}\n\n.mdi-alpha-e-circle::before {\n  content: \"\\F0BF8\";\n}\n\n.mdi-alpha-e-circle-outline::before {\n  content: \"\\F0BF9\";\n}\n\n.mdi-alpha-f::before {\n  content: \"\\F0AF3\";\n}\n\n.mdi-alpha-f-box::before {\n  content: \"\\F0B0D\";\n}\n\n.mdi-alpha-f-box-outline::before {\n  content: \"\\F0BFA\";\n}\n\n.mdi-alpha-f-circle::before {\n  content: \"\\F0BFB\";\n}\n\n.mdi-alpha-f-circle-outline::before {\n  content: \"\\F0BFC\";\n}\n\n.mdi-alpha-g::before {\n  content: \"\\F0AF4\";\n}\n\n.mdi-alpha-g-box::before {\n  content: \"\\F0B0E\";\n}\n\n.mdi-alpha-g-box-outline::before {\n  content: \"\\F0BFD\";\n}\n\n.mdi-alpha-g-circle::before {\n  content: \"\\F0BFE\";\n}\n\n.mdi-alpha-g-circle-outline::before {\n  content: \"\\F0BFF\";\n}\n\n.mdi-alpha-h::before {\n  content: \"\\F0AF5\";\n}\n\n.mdi-alpha-h-box::before {\n  content: \"\\F0B0F\";\n}\n\n.mdi-alpha-h-box-outline::before {\n  content: \"\\F0C00\";\n}\n\n.mdi-alpha-h-circle::before {\n  content: \"\\F0C01\";\n}\n\n.mdi-alpha-h-circle-outline::before {\n  content: \"\\F0C02\";\n}\n\n.mdi-alpha-i::before {\n  content: \"\\F0AF6\";\n}\n\n.mdi-alpha-i-box::before {\n  content: \"\\F0B10\";\n}\n\n.mdi-alpha-i-box-outline::before {\n  content: \"\\F0C03\";\n}\n\n.mdi-alpha-i-circle::before {\n  content: \"\\F0C04\";\n}\n\n.mdi-alpha-i-circle-outline::before {\n  content: \"\\F0C05\";\n}\n\n.mdi-alpha-j::before {\n  content: \"\\F0AF7\";\n}\n\n.mdi-alpha-j-box::before {\n  content: \"\\F0B11\";\n}\n\n.mdi-alpha-j-box-outline::before {\n  content: \"\\F0C06\";\n}\n\n.mdi-alpha-j-circle::before {\n  content: \"\\F0C07\";\n}\n\n.mdi-alpha-j-circle-outline::before {\n  content: \"\\F0C08\";\n}\n\n.mdi-alpha-k::before {\n  content: \"\\F0AF8\";\n}\n\n.mdi-alpha-k-box::before {\n  content: \"\\F0B12\";\n}\n\n.mdi-alpha-k-box-outline::before {\n  content: \"\\F0C09\";\n}\n\n.mdi-alpha-k-circle::before {\n  content: \"\\F0C0A\";\n}\n\n.mdi-alpha-k-circle-outline::before {\n  content: \"\\F0C0B\";\n}\n\n.mdi-alpha-l::before {\n  content: \"\\F0AF9\";\n}\n\n.mdi-alpha-l-box::before {\n  content: \"\\F0B13\";\n}\n\n.mdi-alpha-l-box-outline::before {\n  content: \"\\F0C0C\";\n}\n\n.mdi-alpha-l-circle::before {\n  content: \"\\F0C0D\";\n}\n\n.mdi-alpha-l-circle-outline::before {\n  content: \"\\F0C0E\";\n}\n\n.mdi-alpha-m::before {\n  content: \"\\F0AFA\";\n}\n\n.mdi-alpha-m-box::before {\n  content: \"\\F0B14\";\n}\n\n.mdi-alpha-m-box-outline::before {\n  content: \"\\F0C0F\";\n}\n\n.mdi-alpha-m-circle::before {\n  content: \"\\F0C10\";\n}\n\n.mdi-alpha-m-circle-outline::before {\n  content: \"\\F0C11\";\n}\n\n.mdi-alpha-n::before {\n  content: \"\\F0AFB\";\n}\n\n.mdi-alpha-n-box::before {\n  content: \"\\F0B15\";\n}\n\n.mdi-alpha-n-box-outline::before {\n  content: \"\\F0C12\";\n}\n\n.mdi-alpha-n-circle::before {\n  content: \"\\F0C13\";\n}\n\n.mdi-alpha-n-circle-outline::before {\n  content: \"\\F0C14\";\n}\n\n.mdi-alpha-o::before {\n  content: \"\\F0AFC\";\n}\n\n.mdi-alpha-o-box::before {\n  content: \"\\F0B16\";\n}\n\n.mdi-alpha-o-box-outline::before {\n  content: \"\\F0C15\";\n}\n\n.mdi-alpha-o-circle::before {\n  content: \"\\F0C16\";\n}\n\n.mdi-alpha-o-circle-outline::before {\n  content: \"\\F0C17\";\n}\n\n.mdi-alpha-p::before {\n  content: \"\\F0AFD\";\n}\n\n.mdi-alpha-p-box::before {\n  content: \"\\F0B17\";\n}\n\n.mdi-alpha-p-box-outline::before {\n  content: \"\\F0C18\";\n}\n\n.mdi-alpha-p-circle::before {\n  content: \"\\F0C19\";\n}\n\n.mdi-alpha-p-circle-outline::before {\n  content: \"\\F0C1A\";\n}\n\n.mdi-alpha-q::before {\n  content: \"\\F0AFE\";\n}\n\n.mdi-alpha-q-box::before {\n  content: \"\\F0B18\";\n}\n\n.mdi-alpha-q-box-outline::before {\n  content: \"\\F0C1B\";\n}\n\n.mdi-alpha-q-circle::before {\n  content: \"\\F0C1C\";\n}\n\n.mdi-alpha-q-circle-outline::before {\n  content: \"\\F0C1D\";\n}\n\n.mdi-alpha-r::before {\n  content: \"\\F0AFF\";\n}\n\n.mdi-alpha-r-box::before {\n  content: \"\\F0B19\";\n}\n\n.mdi-alpha-r-box-outline::before {\n  content: \"\\F0C1E\";\n}\n\n.mdi-alpha-r-circle::before {\n  content: \"\\F0C1F\";\n}\n\n.mdi-alpha-r-circle-outline::before {\n  content: \"\\F0C20\";\n}\n\n.mdi-alpha-s::before {\n  content: \"\\F0B00\";\n}\n\n.mdi-alpha-s-box::before {\n  content: \"\\F0B1A\";\n}\n\n.mdi-alpha-s-box-outline::before {\n  content: \"\\F0C21\";\n}\n\n.mdi-alpha-s-circle::before {\n  content: \"\\F0C22\";\n}\n\n.mdi-alpha-s-circle-outline::before {\n  content: \"\\F0C23\";\n}\n\n.mdi-alpha-t::before {\n  content: \"\\F0B01\";\n}\n\n.mdi-alpha-t-box::before {\n  content: \"\\F0B1B\";\n}\n\n.mdi-alpha-t-box-outline::before {\n  content: \"\\F0C24\";\n}\n\n.mdi-alpha-t-circle::before {\n  content: \"\\F0C25\";\n}\n\n.mdi-alpha-t-circle-outline::before {\n  content: \"\\F0C26\";\n}\n\n.mdi-alpha-u::before {\n  content: \"\\F0B02\";\n}\n\n.mdi-alpha-u-box::before {\n  content: \"\\F0B1C\";\n}\n\n.mdi-alpha-u-box-outline::before {\n  content: \"\\F0C27\";\n}\n\n.mdi-alpha-u-circle::before {\n  content: \"\\F0C28\";\n}\n\n.mdi-alpha-u-circle-outline::before {\n  content: \"\\F0C29\";\n}\n\n.mdi-alpha-v::before {\n  content: \"\\F0B03\";\n}\n\n.mdi-alpha-v-box::before {\n  content: \"\\F0B1D\";\n}\n\n.mdi-alpha-v-box-outline::before {\n  content: \"\\F0C2A\";\n}\n\n.mdi-alpha-v-circle::before {\n  content: \"\\F0C2B\";\n}\n\n.mdi-alpha-v-circle-outline::before {\n  content: \"\\F0C2C\";\n}\n\n.mdi-alpha-w::before {\n  content: \"\\F0B04\";\n}\n\n.mdi-alpha-w-box::before {\n  content: \"\\F0B1E\";\n}\n\n.mdi-alpha-w-box-outline::before {\n  content: \"\\F0C2D\";\n}\n\n.mdi-alpha-w-circle::before {\n  content: \"\\F0C2E\";\n}\n\n.mdi-alpha-w-circle-outline::before {\n  content: \"\\F0C2F\";\n}\n\n.mdi-alpha-x::before {\n  content: \"\\F0B05\";\n}\n\n.mdi-alpha-x-box::before {\n  content: \"\\F0B1F\";\n}\n\n.mdi-alpha-x-box-outline::before {\n  content: \"\\F0C30\";\n}\n\n.mdi-alpha-x-circle::before {\n  content: \"\\F0C31\";\n}\n\n.mdi-alpha-x-circle-outline::before {\n  content: \"\\F0C32\";\n}\n\n.mdi-alpha-y::before {\n  content: \"\\F0B06\";\n}\n\n.mdi-alpha-y-box::before {\n  content: \"\\F0B20\";\n}\n\n.mdi-alpha-y-box-outline::before {\n  content: \"\\F0C33\";\n}\n\n.mdi-alpha-y-circle::before {\n  content: \"\\F0C34\";\n}\n\n.mdi-alpha-y-circle-outline::before {\n  content: \"\\F0C35\";\n}\n\n.mdi-alpha-z::before {\n  content: \"\\F0B07\";\n}\n\n.mdi-alpha-z-box::before {\n  content: \"\\F0B21\";\n}\n\n.mdi-alpha-z-box-outline::before {\n  content: \"\\F0C36\";\n}\n\n.mdi-alpha-z-circle::before {\n  content: \"\\F0C37\";\n}\n\n.mdi-alpha-z-circle-outline::before {\n  content: \"\\F0C38\";\n}\n\n.mdi-alphabet-aurebesh::before {\n  content: \"\\F132C\";\n}\n\n.mdi-alphabet-cyrillic::before {\n  content: \"\\F132D\";\n}\n\n.mdi-alphabet-greek::before {\n  content: \"\\F132E\";\n}\n\n.mdi-alphabet-latin::before {\n  content: \"\\F132F\";\n}\n\n.mdi-alphabet-piqad::before {\n  content: \"\\F1330\";\n}\n\n.mdi-alphabet-tengwar::before {\n  content: \"\\F1337\";\n}\n\n.mdi-alphabetical::before {\n  content: \"\\F002C\";\n}\n\n.mdi-alphabetical-off::before {\n  content: \"\\F100C\";\n}\n\n.mdi-alphabetical-variant::before {\n  content: \"\\F100D\";\n}\n\n.mdi-alphabetical-variant-off::before {\n  content: \"\\F100E\";\n}\n\n.mdi-altimeter::before {\n  content: \"\\F05D7\";\n}\n\n.mdi-ambulance::before {\n  content: \"\\F002F\";\n}\n\n.mdi-ammunition::before {\n  content: \"\\F0CE8\";\n}\n\n.mdi-ampersand::before {\n  content: \"\\F0A8D\";\n}\n\n.mdi-amplifier::before {\n  content: \"\\F0030\";\n}\n\n.mdi-amplifier-off::before {\n  content: \"\\F11B5\";\n}\n\n.mdi-anchor::before {\n  content: \"\\F0031\";\n}\n\n.mdi-android::before {\n  content: \"\\F0032\";\n}\n\n.mdi-android-messages::before {\n  content: \"\\F0D45\";\n}\n\n.mdi-android-studio::before {\n  content: \"\\F0034\";\n}\n\n.mdi-angle-acute::before {\n  content: \"\\F0937\";\n}\n\n.mdi-angle-obtuse::before {\n  content: \"\\F0938\";\n}\n\n.mdi-angle-right::before {\n  content: \"\\F0939\";\n}\n\n.mdi-angular::before {\n  content: \"\\F06B2\";\n}\n\n.mdi-angularjs::before {\n  content: \"\\F06BF\";\n}\n\n.mdi-animation::before {\n  content: \"\\F05D8\";\n}\n\n.mdi-animation-outline::before {\n  content: \"\\F0A8F\";\n}\n\n.mdi-animation-play::before {\n  content: \"\\F093A\";\n}\n\n.mdi-animation-play-outline::before {\n  content: \"\\F0A90\";\n}\n\n.mdi-ansible::before {\n  content: \"\\F109A\";\n}\n\n.mdi-antenna::before {\n  content: \"\\F1119\";\n}\n\n.mdi-anvil::before {\n  content: \"\\F089B\";\n}\n\n.mdi-apache-kafka::before {\n  content: \"\\F100F\";\n}\n\n.mdi-api::before {\n  content: \"\\F109B\";\n}\n\n.mdi-api-off::before {\n  content: \"\\F1257\";\n}\n\n.mdi-apple::before {\n  content: \"\\F0035\";\n}\n\n.mdi-apple-finder::before {\n  content: \"\\F0036\";\n}\n\n.mdi-apple-icloud::before {\n  content: \"\\F0038\";\n}\n\n.mdi-apple-ios::before {\n  content: \"\\F0037\";\n}\n\n.mdi-apple-keyboard-caps::before {\n  content: \"\\F0632\";\n}\n\n.mdi-apple-keyboard-command::before {\n  content: \"\\F0633\";\n}\n\n.mdi-apple-keyboard-control::before {\n  content: \"\\F0634\";\n}\n\n.mdi-apple-keyboard-option::before {\n  content: \"\\F0635\";\n}\n\n.mdi-apple-keyboard-shift::before {\n  content: \"\\F0636\";\n}\n\n.mdi-apple-safari::before {\n  content: \"\\F0039\";\n}\n\n.mdi-application::before {\n  content: \"\\F08C6\";\n}\n\n.mdi-application-array::before {\n  content: \"\\F10F5\";\n}\n\n.mdi-application-array-outline::before {\n  content: \"\\F10F6\";\n}\n\n.mdi-application-braces::before {\n  content: \"\\F10F7\";\n}\n\n.mdi-application-braces-outline::before {\n  content: \"\\F10F8\";\n}\n\n.mdi-application-brackets::before {\n  content: \"\\F0C8B\";\n}\n\n.mdi-application-brackets-outline::before {\n  content: \"\\F0C8C\";\n}\n\n.mdi-application-cog::before {\n  content: \"\\F0675\";\n}\n\n.mdi-application-cog-outline::before {\n  content: \"\\F1577\";\n}\n\n.mdi-application-edit::before {\n  content: \"\\F00AE\";\n}\n\n.mdi-application-edit-outline::before {\n  content: \"\\F0619\";\n}\n\n.mdi-application-export::before {\n  content: \"\\F0DAD\";\n}\n\n.mdi-application-import::before {\n  content: \"\\F0DAE\";\n}\n\n.mdi-application-outline::before {\n  content: \"\\F0614\";\n}\n\n.mdi-application-parentheses::before {\n  content: \"\\F10F9\";\n}\n\n.mdi-application-parentheses-outline::before {\n  content: \"\\F10FA\";\n}\n\n.mdi-application-settings::before {\n  content: \"\\F0B60\";\n}\n\n.mdi-application-settings-outline::before {\n  content: \"\\F1555\";\n}\n\n.mdi-application-variable::before {\n  content: \"\\F10FB\";\n}\n\n.mdi-application-variable-outline::before {\n  content: \"\\F10FC\";\n}\n\n.mdi-approximately-equal::before {\n  content: \"\\F0F9E\";\n}\n\n.mdi-approximately-equal-box::before {\n  content: \"\\F0F9F\";\n}\n\n.mdi-apps::before {\n  content: \"\\F003B\";\n}\n\n.mdi-apps-box::before {\n  content: \"\\F0D46\";\n}\n\n.mdi-arch::before {\n  content: \"\\F08C7\";\n}\n\n.mdi-archive::before {\n  content: \"\\F003C\";\n}\n\n.mdi-archive-alert::before {\n  content: \"\\F14FD\";\n}\n\n.mdi-archive-alert-outline::before {\n  content: \"\\F14FE\";\n}\n\n.mdi-archive-arrow-down::before {\n  content: \"\\F1259\";\n}\n\n.mdi-archive-arrow-down-outline::before {\n  content: \"\\F125A\";\n}\n\n.mdi-archive-arrow-up::before {\n  content: \"\\F125B\";\n}\n\n.mdi-archive-arrow-up-outline::before {\n  content: \"\\F125C\";\n}\n\n.mdi-archive-cancel::before {\n  content: \"\\F174B\";\n}\n\n.mdi-archive-cancel-outline::before {\n  content: \"\\F174C\";\n}\n\n.mdi-archive-check::before {\n  content: \"\\F174D\";\n}\n\n.mdi-archive-check-outline::before {\n  content: \"\\F174E\";\n}\n\n.mdi-archive-clock::before {\n  content: \"\\F174F\";\n}\n\n.mdi-archive-clock-outline::before {\n  content: \"\\F1750\";\n}\n\n.mdi-archive-cog::before {\n  content: \"\\F1751\";\n}\n\n.mdi-archive-cog-outline::before {\n  content: \"\\F1752\";\n}\n\n.mdi-archive-edit::before {\n  content: \"\\F1753\";\n}\n\n.mdi-archive-edit-outline::before {\n  content: \"\\F1754\";\n}\n\n.mdi-archive-eye::before {\n  content: \"\\F1755\";\n}\n\n.mdi-archive-eye-outline::before {\n  content: \"\\F1756\";\n}\n\n.mdi-archive-lock::before {\n  content: \"\\F1757\";\n}\n\n.mdi-archive-lock-open::before {\n  content: \"\\F1758\";\n}\n\n.mdi-archive-lock-open-outline::before {\n  content: \"\\F1759\";\n}\n\n.mdi-archive-lock-outline::before {\n  content: \"\\F175A\";\n}\n\n.mdi-archive-marker::before {\n  content: \"\\F175B\";\n}\n\n.mdi-archive-marker-outline::before {\n  content: \"\\F175C\";\n}\n\n.mdi-archive-minus::before {\n  content: \"\\F175D\";\n}\n\n.mdi-archive-minus-outline::before {\n  content: \"\\F175E\";\n}\n\n.mdi-archive-music::before {\n  content: \"\\F175F\";\n}\n\n.mdi-archive-music-outline::before {\n  content: \"\\F1760\";\n}\n\n.mdi-archive-off::before {\n  content: \"\\F1761\";\n}\n\n.mdi-archive-off-outline::before {\n  content: \"\\F1762\";\n}\n\n.mdi-archive-outline::before {\n  content: \"\\F120E\";\n}\n\n.mdi-archive-plus::before {\n  content: \"\\F1763\";\n}\n\n.mdi-archive-plus-outline::before {\n  content: \"\\F1764\";\n}\n\n.mdi-archive-refresh::before {\n  content: \"\\F1765\";\n}\n\n.mdi-archive-refresh-outline::before {\n  content: \"\\F1766\";\n}\n\n.mdi-archive-remove::before {\n  content: \"\\F1767\";\n}\n\n.mdi-archive-remove-outline::before {\n  content: \"\\F1768\";\n}\n\n.mdi-archive-search::before {\n  content: \"\\F1769\";\n}\n\n.mdi-archive-search-outline::before {\n  content: \"\\F176A\";\n}\n\n.mdi-archive-settings::before {\n  content: \"\\F176B\";\n}\n\n.mdi-archive-settings-outline::before {\n  content: \"\\F176C\";\n}\n\n.mdi-archive-star::before {\n  content: \"\\F176D\";\n}\n\n.mdi-archive-star-outline::before {\n  content: \"\\F176E\";\n}\n\n.mdi-archive-sync::before {\n  content: \"\\F176F\";\n}\n\n.mdi-archive-sync-outline::before {\n  content: \"\\F1770\";\n}\n\n.mdi-arm-flex::before {\n  content: \"\\F0FD7\";\n}\n\n.mdi-arm-flex-outline::before {\n  content: \"\\F0FD6\";\n}\n\n.mdi-arrange-bring-forward::before {\n  content: \"\\F003D\";\n}\n\n.mdi-arrange-bring-to-front::before {\n  content: \"\\F003E\";\n}\n\n.mdi-arrange-send-backward::before {\n  content: \"\\F003F\";\n}\n\n.mdi-arrange-send-to-back::before {\n  content: \"\\F0040\";\n}\n\n.mdi-arrow-all::before {\n  content: \"\\F0041\";\n}\n\n.mdi-arrow-bottom-left::before {\n  content: \"\\F0042\";\n}\n\n.mdi-arrow-bottom-left-bold-box::before {\n  content: \"\\F1964\";\n}\n\n.mdi-arrow-bottom-left-bold-box-outline::before {\n  content: \"\\F1965\";\n}\n\n.mdi-arrow-bottom-left-bold-outline::before {\n  content: \"\\F09B7\";\n}\n\n.mdi-arrow-bottom-left-thick::before {\n  content: \"\\F09B8\";\n}\n\n.mdi-arrow-bottom-left-thin::before {\n  content: \"\\F19B6\";\n}\n\n.mdi-arrow-bottom-left-thin-circle-outline::before {\n  content: \"\\F1596\";\n}\n\n.mdi-arrow-bottom-right::before {\n  content: \"\\F0043\";\n}\n\n.mdi-arrow-bottom-right-bold-box::before {\n  content: \"\\F1966\";\n}\n\n.mdi-arrow-bottom-right-bold-box-outline::before {\n  content: \"\\F1967\";\n}\n\n.mdi-arrow-bottom-right-bold-outline::before {\n  content: \"\\F09B9\";\n}\n\n.mdi-arrow-bottom-right-thick::before {\n  content: \"\\F09BA\";\n}\n\n.mdi-arrow-bottom-right-thin::before {\n  content: \"\\F19B7\";\n}\n\n.mdi-arrow-bottom-right-thin-circle-outline::before {\n  content: \"\\F1595\";\n}\n\n.mdi-arrow-collapse::before {\n  content: \"\\F0615\";\n}\n\n.mdi-arrow-collapse-all::before {\n  content: \"\\F0044\";\n}\n\n.mdi-arrow-collapse-down::before {\n  content: \"\\F0792\";\n}\n\n.mdi-arrow-collapse-horizontal::before {\n  content: \"\\F084C\";\n}\n\n.mdi-arrow-collapse-left::before {\n  content: \"\\F0793\";\n}\n\n.mdi-arrow-collapse-right::before {\n  content: \"\\F0794\";\n}\n\n.mdi-arrow-collapse-up::before {\n  content: \"\\F0795\";\n}\n\n.mdi-arrow-collapse-vertical::before {\n  content: \"\\F084D\";\n}\n\n.mdi-arrow-decision::before {\n  content: \"\\F09BB\";\n}\n\n.mdi-arrow-decision-auto::before {\n  content: \"\\F09BC\";\n}\n\n.mdi-arrow-decision-auto-outline::before {\n  content: \"\\F09BD\";\n}\n\n.mdi-arrow-decision-outline::before {\n  content: \"\\F09BE\";\n}\n\n.mdi-arrow-down::before {\n  content: \"\\F0045\";\n}\n\n.mdi-arrow-down-bold::before {\n  content: \"\\F072E\";\n}\n\n.mdi-arrow-down-bold-box::before {\n  content: \"\\F072F\";\n}\n\n.mdi-arrow-down-bold-box-outline::before {\n  content: \"\\F0730\";\n}\n\n.mdi-arrow-down-bold-circle::before {\n  content: \"\\F0047\";\n}\n\n.mdi-arrow-down-bold-circle-outline::before {\n  content: \"\\F0048\";\n}\n\n.mdi-arrow-down-bold-hexagon-outline::before {\n  content: \"\\F0049\";\n}\n\n.mdi-arrow-down-bold-outline::before {\n  content: \"\\F09BF\";\n}\n\n.mdi-arrow-down-box::before {\n  content: \"\\F06C0\";\n}\n\n.mdi-arrow-down-circle::before {\n  content: \"\\F0CDB\";\n}\n\n.mdi-arrow-down-circle-outline::before {\n  content: \"\\F0CDC\";\n}\n\n.mdi-arrow-down-drop-circle::before {\n  content: \"\\F004A\";\n}\n\n.mdi-arrow-down-drop-circle-outline::before {\n  content: \"\\F004B\";\n}\n\n.mdi-arrow-down-left::before {\n  content: \"\\F17A1\";\n}\n\n.mdi-arrow-down-left-bold::before {\n  content: \"\\F17A2\";\n}\n\n.mdi-arrow-down-right::before {\n  content: \"\\F17A3\";\n}\n\n.mdi-arrow-down-right-bold::before {\n  content: \"\\F17A4\";\n}\n\n.mdi-arrow-down-thick::before {\n  content: \"\\F0046\";\n}\n\n.mdi-arrow-down-thin::before {\n  content: \"\\F19B3\";\n}\n\n.mdi-arrow-down-thin-circle-outline::before {\n  content: \"\\F1599\";\n}\n\n.mdi-arrow-expand::before {\n  content: \"\\F0616\";\n}\n\n.mdi-arrow-expand-all::before {\n  content: \"\\F004C\";\n}\n\n.mdi-arrow-expand-down::before {\n  content: \"\\F0796\";\n}\n\n.mdi-arrow-expand-horizontal::before {\n  content: \"\\F084E\";\n}\n\n.mdi-arrow-expand-left::before {\n  content: \"\\F0797\";\n}\n\n.mdi-arrow-expand-right::before {\n  content: \"\\F0798\";\n}\n\n.mdi-arrow-expand-up::before {\n  content: \"\\F0799\";\n}\n\n.mdi-arrow-expand-vertical::before {\n  content: \"\\F084F\";\n}\n\n.mdi-arrow-horizontal-lock::before {\n  content: \"\\F115B\";\n}\n\n.mdi-arrow-left::before {\n  content: \"\\F004D\";\n}\n\n.mdi-arrow-left-bold::before {\n  content: \"\\F0731\";\n}\n\n.mdi-arrow-left-bold-box::before {\n  content: \"\\F0732\";\n}\n\n.mdi-arrow-left-bold-box-outline::before {\n  content: \"\\F0733\";\n}\n\n.mdi-arrow-left-bold-circle::before {\n  content: \"\\F004F\";\n}\n\n.mdi-arrow-left-bold-circle-outline::before {\n  content: \"\\F0050\";\n}\n\n.mdi-arrow-left-bold-hexagon-outline::before {\n  content: \"\\F0051\";\n}\n\n.mdi-arrow-left-bold-outline::before {\n  content: \"\\F09C0\";\n}\n\n.mdi-arrow-left-bottom::before {\n  content: \"\\F17A5\";\n}\n\n.mdi-arrow-left-bottom-bold::before {\n  content: \"\\F17A6\";\n}\n\n.mdi-arrow-left-box::before {\n  content: \"\\F06C1\";\n}\n\n.mdi-arrow-left-circle::before {\n  content: \"\\F0CDD\";\n}\n\n.mdi-arrow-left-circle-outline::before {\n  content: \"\\F0CDE\";\n}\n\n.mdi-arrow-left-drop-circle::before {\n  content: \"\\F0052\";\n}\n\n.mdi-arrow-left-drop-circle-outline::before {\n  content: \"\\F0053\";\n}\n\n.mdi-arrow-left-right::before {\n  content: \"\\F0E73\";\n}\n\n.mdi-arrow-left-right-bold::before {\n  content: \"\\F0E74\";\n}\n\n.mdi-arrow-left-right-bold-outline::before {\n  content: \"\\F09C1\";\n}\n\n.mdi-arrow-left-thick::before {\n  content: \"\\F004E\";\n}\n\n.mdi-arrow-left-thin::before {\n  content: \"\\F19B1\";\n}\n\n.mdi-arrow-left-thin-circle-outline::before {\n  content: \"\\F159A\";\n}\n\n.mdi-arrow-left-top::before {\n  content: \"\\F17A7\";\n}\n\n.mdi-arrow-left-top-bold::before {\n  content: \"\\F17A8\";\n}\n\n.mdi-arrow-projectile::before {\n  content: \"\\F1840\";\n}\n\n.mdi-arrow-projectile-multiple::before {\n  content: \"\\F183F\";\n}\n\n.mdi-arrow-right::before {\n  content: \"\\F0054\";\n}\n\n.mdi-arrow-right-bold::before {\n  content: \"\\F0734\";\n}\n\n.mdi-arrow-right-bold-box::before {\n  content: \"\\F0735\";\n}\n\n.mdi-arrow-right-bold-box-outline::before {\n  content: \"\\F0736\";\n}\n\n.mdi-arrow-right-bold-circle::before {\n  content: \"\\F0056\";\n}\n\n.mdi-arrow-right-bold-circle-outline::before {\n  content: \"\\F0057\";\n}\n\n.mdi-arrow-right-bold-hexagon-outline::before {\n  content: \"\\F0058\";\n}\n\n.mdi-arrow-right-bold-outline::before {\n  content: \"\\F09C2\";\n}\n\n.mdi-arrow-right-bottom::before {\n  content: \"\\F17A9\";\n}\n\n.mdi-arrow-right-bottom-bold::before {\n  content: \"\\F17AA\";\n}\n\n.mdi-arrow-right-box::before {\n  content: \"\\F06C2\";\n}\n\n.mdi-arrow-right-circle::before {\n  content: \"\\F0CDF\";\n}\n\n.mdi-arrow-right-circle-outline::before {\n  content: \"\\F0CE0\";\n}\n\n.mdi-arrow-right-drop-circle::before {\n  content: \"\\F0059\";\n}\n\n.mdi-arrow-right-drop-circle-outline::before {\n  content: \"\\F005A\";\n}\n\n.mdi-arrow-right-thick::before {\n  content: \"\\F0055\";\n}\n\n.mdi-arrow-right-thin::before {\n  content: \"\\F19B0\";\n}\n\n.mdi-arrow-right-thin-circle-outline::before {\n  content: \"\\F1598\";\n}\n\n.mdi-arrow-right-top::before {\n  content: \"\\F17AB\";\n}\n\n.mdi-arrow-right-top-bold::before {\n  content: \"\\F17AC\";\n}\n\n.mdi-arrow-split-horizontal::before {\n  content: \"\\F093B\";\n}\n\n.mdi-arrow-split-vertical::before {\n  content: \"\\F093C\";\n}\n\n.mdi-arrow-top-left::before {\n  content: \"\\F005B\";\n}\n\n.mdi-arrow-top-left-bold-box::before {\n  content: \"\\F1968\";\n}\n\n.mdi-arrow-top-left-bold-box-outline::before {\n  content: \"\\F1969\";\n}\n\n.mdi-arrow-top-left-bold-outline::before {\n  content: \"\\F09C3\";\n}\n\n.mdi-arrow-top-left-bottom-right::before {\n  content: \"\\F0E75\";\n}\n\n.mdi-arrow-top-left-bottom-right-bold::before {\n  content: \"\\F0E76\";\n}\n\n.mdi-arrow-top-left-thick::before {\n  content: \"\\F09C4\";\n}\n\n.mdi-arrow-top-left-thin::before {\n  content: \"\\F19B5\";\n}\n\n.mdi-arrow-top-left-thin-circle-outline::before {\n  content: \"\\F1593\";\n}\n\n.mdi-arrow-top-right::before {\n  content: \"\\F005C\";\n}\n\n.mdi-arrow-top-right-bold-box::before {\n  content: \"\\F196A\";\n}\n\n.mdi-arrow-top-right-bold-box-outline::before {\n  content: \"\\F196B\";\n}\n\n.mdi-arrow-top-right-bold-outline::before {\n  content: \"\\F09C5\";\n}\n\n.mdi-arrow-top-right-bottom-left::before {\n  content: \"\\F0E77\";\n}\n\n.mdi-arrow-top-right-bottom-left-bold::before {\n  content: \"\\F0E78\";\n}\n\n.mdi-arrow-top-right-thick::before {\n  content: \"\\F09C6\";\n}\n\n.mdi-arrow-top-right-thin::before {\n  content: \"\\F19B4\";\n}\n\n.mdi-arrow-top-right-thin-circle-outline::before {\n  content: \"\\F1594\";\n}\n\n.mdi-arrow-u-down-left::before {\n  content: \"\\F17AD\";\n}\n\n.mdi-arrow-u-down-left-bold::before {\n  content: \"\\F17AE\";\n}\n\n.mdi-arrow-u-down-right::before {\n  content: \"\\F17AF\";\n}\n\n.mdi-arrow-u-down-right-bold::before {\n  content: \"\\F17B0\";\n}\n\n.mdi-arrow-u-left-bottom::before {\n  content: \"\\F17B1\";\n}\n\n.mdi-arrow-u-left-bottom-bold::before {\n  content: \"\\F17B2\";\n}\n\n.mdi-arrow-u-left-top::before {\n  content: \"\\F17B3\";\n}\n\n.mdi-arrow-u-left-top-bold::before {\n  content: \"\\F17B4\";\n}\n\n.mdi-arrow-u-right-bottom::before {\n  content: \"\\F17B5\";\n}\n\n.mdi-arrow-u-right-bottom-bold::before {\n  content: \"\\F17B6\";\n}\n\n.mdi-arrow-u-right-top::before {\n  content: \"\\F17B7\";\n}\n\n.mdi-arrow-u-right-top-bold::before {\n  content: \"\\F17B8\";\n}\n\n.mdi-arrow-u-up-left::before {\n  content: \"\\F17B9\";\n}\n\n.mdi-arrow-u-up-left-bold::before {\n  content: \"\\F17BA\";\n}\n\n.mdi-arrow-u-up-right::before {\n  content: \"\\F17BB\";\n}\n\n.mdi-arrow-u-up-right-bold::before {\n  content: \"\\F17BC\";\n}\n\n.mdi-arrow-up::before {\n  content: \"\\F005D\";\n}\n\n.mdi-arrow-up-bold::before {\n  content: \"\\F0737\";\n}\n\n.mdi-arrow-up-bold-box::before {\n  content: \"\\F0738\";\n}\n\n.mdi-arrow-up-bold-box-outline::before {\n  content: \"\\F0739\";\n}\n\n.mdi-arrow-up-bold-circle::before {\n  content: \"\\F005F\";\n}\n\n.mdi-arrow-up-bold-circle-outline::before {\n  content: \"\\F0060\";\n}\n\n.mdi-arrow-up-bold-hexagon-outline::before {\n  content: \"\\F0061\";\n}\n\n.mdi-arrow-up-bold-outline::before {\n  content: \"\\F09C7\";\n}\n\n.mdi-arrow-up-box::before {\n  content: \"\\F06C3\";\n}\n\n.mdi-arrow-up-circle::before {\n  content: \"\\F0CE1\";\n}\n\n.mdi-arrow-up-circle-outline::before {\n  content: \"\\F0CE2\";\n}\n\n.mdi-arrow-up-down::before {\n  content: \"\\F0E79\";\n}\n\n.mdi-arrow-up-down-bold::before {\n  content: \"\\F0E7A\";\n}\n\n.mdi-arrow-up-down-bold-outline::before {\n  content: \"\\F09C8\";\n}\n\n.mdi-arrow-up-drop-circle::before {\n  content: \"\\F0062\";\n}\n\n.mdi-arrow-up-drop-circle-outline::before {\n  content: \"\\F0063\";\n}\n\n.mdi-arrow-up-left::before {\n  content: \"\\F17BD\";\n}\n\n.mdi-arrow-up-left-bold::before {\n  content: \"\\F17BE\";\n}\n\n.mdi-arrow-up-right::before {\n  content: \"\\F17BF\";\n}\n\n.mdi-arrow-up-right-bold::before {\n  content: \"\\F17C0\";\n}\n\n.mdi-arrow-up-thick::before {\n  content: \"\\F005E\";\n}\n\n.mdi-arrow-up-thin::before {\n  content: \"\\F19B2\";\n}\n\n.mdi-arrow-up-thin-circle-outline::before {\n  content: \"\\F1597\";\n}\n\n.mdi-arrow-vertical-lock::before {\n  content: \"\\F115C\";\n}\n\n.mdi-artstation::before {\n  content: \"\\F0B5B\";\n}\n\n.mdi-aspect-ratio::before {\n  content: \"\\F0A24\";\n}\n\n.mdi-assistant::before {\n  content: \"\\F0064\";\n}\n\n.mdi-asterisk::before {\n  content: \"\\F06C4\";\n}\n\n.mdi-at::before {\n  content: \"\\F0065\";\n}\n\n.mdi-atlassian::before {\n  content: \"\\F0804\";\n}\n\n.mdi-atm::before {\n  content: \"\\F0D47\";\n}\n\n.mdi-atom::before {\n  content: \"\\F0768\";\n}\n\n.mdi-atom-variant::before {\n  content: \"\\F0E7B\";\n}\n\n.mdi-attachment::before {\n  content: \"\\F0066\";\n}\n\n.mdi-audio-input-rca::before {\n  content: \"\\F186B\";\n}\n\n.mdi-audio-input-stereo-minijack::before {\n  content: \"\\F186C\";\n}\n\n.mdi-audio-input-xlr::before {\n  content: \"\\F186D\";\n}\n\n.mdi-audio-video::before {\n  content: \"\\F093D\";\n}\n\n.mdi-audio-video-off::before {\n  content: \"\\F11B6\";\n}\n\n.mdi-augmented-reality::before {\n  content: \"\\F0850\";\n}\n\n.mdi-auto-download::before {\n  content: \"\\F137E\";\n}\n\n.mdi-auto-fix::before {\n  content: \"\\F0068\";\n}\n\n.mdi-auto-upload::before {\n  content: \"\\F0069\";\n}\n\n.mdi-autorenew::before {\n  content: \"\\F006A\";\n}\n\n.mdi-av-timer::before {\n  content: \"\\F006B\";\n}\n\n.mdi-aws::before {\n  content: \"\\F0E0F\";\n}\n\n.mdi-axe::before {\n  content: \"\\F08C8\";\n}\n\n.mdi-axe-battle::before {\n  content: \"\\F1842\";\n}\n\n.mdi-axis::before {\n  content: \"\\F0D48\";\n}\n\n.mdi-axis-arrow::before {\n  content: \"\\F0D49\";\n}\n\n.mdi-axis-arrow-info::before {\n  content: \"\\F140E\";\n}\n\n.mdi-axis-arrow-lock::before {\n  content: \"\\F0D4A\";\n}\n\n.mdi-axis-lock::before {\n  content: \"\\F0D4B\";\n}\n\n.mdi-axis-x-arrow::before {\n  content: \"\\F0D4C\";\n}\n\n.mdi-axis-x-arrow-lock::before {\n  content: \"\\F0D4D\";\n}\n\n.mdi-axis-x-rotate-clockwise::before {\n  content: \"\\F0D4E\";\n}\n\n.mdi-axis-x-rotate-counterclockwise::before {\n  content: \"\\F0D4F\";\n}\n\n.mdi-axis-x-y-arrow-lock::before {\n  content: \"\\F0D50\";\n}\n\n.mdi-axis-y-arrow::before {\n  content: \"\\F0D51\";\n}\n\n.mdi-axis-y-arrow-lock::before {\n  content: \"\\F0D52\";\n}\n\n.mdi-axis-y-rotate-clockwise::before {\n  content: \"\\F0D53\";\n}\n\n.mdi-axis-y-rotate-counterclockwise::before {\n  content: \"\\F0D54\";\n}\n\n.mdi-axis-z-arrow::before {\n  content: \"\\F0D55\";\n}\n\n.mdi-axis-z-arrow-lock::before {\n  content: \"\\F0D56\";\n}\n\n.mdi-axis-z-rotate-clockwise::before {\n  content: \"\\F0D57\";\n}\n\n.mdi-axis-z-rotate-counterclockwise::before {\n  content: \"\\F0D58\";\n}\n\n.mdi-babel::before {\n  content: \"\\F0A25\";\n}\n\n.mdi-baby::before {\n  content: \"\\F006C\";\n}\n\n.mdi-baby-bottle::before {\n  content: \"\\F0F39\";\n}\n\n.mdi-baby-bottle-outline::before {\n  content: \"\\F0F3A\";\n}\n\n.mdi-baby-buggy::before {\n  content: \"\\F13E0\";\n}\n\n.mdi-baby-carriage::before {\n  content: \"\\F068F\";\n}\n\n.mdi-baby-carriage-off::before {\n  content: \"\\F0FA0\";\n}\n\n.mdi-baby-face::before {\n  content: \"\\F0E7C\";\n}\n\n.mdi-baby-face-outline::before {\n  content: \"\\F0E7D\";\n}\n\n.mdi-backburger::before {\n  content: \"\\F006D\";\n}\n\n.mdi-backspace::before {\n  content: \"\\F006E\";\n}\n\n.mdi-backspace-outline::before {\n  content: \"\\F0B5C\";\n}\n\n.mdi-backspace-reverse::before {\n  content: \"\\F0E7E\";\n}\n\n.mdi-backspace-reverse-outline::before {\n  content: \"\\F0E7F\";\n}\n\n.mdi-backup-restore::before {\n  content: \"\\F006F\";\n}\n\n.mdi-bacteria::before {\n  content: \"\\F0ED5\";\n}\n\n.mdi-bacteria-outline::before {\n  content: \"\\F0ED6\";\n}\n\n.mdi-badge-account::before {\n  content: \"\\F0DA7\";\n}\n\n.mdi-badge-account-alert::before {\n  content: \"\\F0DA8\";\n}\n\n.mdi-badge-account-alert-outline::before {\n  content: \"\\F0DA9\";\n}\n\n.mdi-badge-account-horizontal::before {\n  content: \"\\F0E0D\";\n}\n\n.mdi-badge-account-horizontal-outline::before {\n  content: \"\\F0E0E\";\n}\n\n.mdi-badge-account-outline::before {\n  content: \"\\F0DAA\";\n}\n\n.mdi-badminton::before {\n  content: \"\\F0851\";\n}\n\n.mdi-bag-carry-on::before {\n  content: \"\\F0F3B\";\n}\n\n.mdi-bag-carry-on-check::before {\n  content: \"\\F0D65\";\n}\n\n.mdi-bag-carry-on-off::before {\n  content: \"\\F0F3C\";\n}\n\n.mdi-bag-checked::before {\n  content: \"\\F0F3D\";\n}\n\n.mdi-bag-personal::before {\n  content: \"\\F0E10\";\n}\n\n.mdi-bag-personal-off::before {\n  content: \"\\F0E11\";\n}\n\n.mdi-bag-personal-off-outline::before {\n  content: \"\\F0E12\";\n}\n\n.mdi-bag-personal-outline::before {\n  content: \"\\F0E13\";\n}\n\n.mdi-bag-suitcase::before {\n  content: \"\\F158B\";\n}\n\n.mdi-bag-suitcase-off::before {\n  content: \"\\F158D\";\n}\n\n.mdi-bag-suitcase-off-outline::before {\n  content: \"\\F158E\";\n}\n\n.mdi-bag-suitcase-outline::before {\n  content: \"\\F158C\";\n}\n\n.mdi-baguette::before {\n  content: \"\\F0F3E\";\n}\n\n.mdi-balcony::before {\n  content: \"\\F1817\";\n}\n\n.mdi-balloon::before {\n  content: \"\\F0A26\";\n}\n\n.mdi-ballot::before {\n  content: \"\\F09C9\";\n}\n\n.mdi-ballot-outline::before {\n  content: \"\\F09CA\";\n}\n\n.mdi-ballot-recount::before {\n  content: \"\\F0C39\";\n}\n\n.mdi-ballot-recount-outline::before {\n  content: \"\\F0C3A\";\n}\n\n.mdi-bandage::before {\n  content: \"\\F0DAF\";\n}\n\n.mdi-bank::before {\n  content: \"\\F0070\";\n}\n\n.mdi-bank-check::before {\n  content: \"\\F1655\";\n}\n\n.mdi-bank-minus::before {\n  content: \"\\F0DB0\";\n}\n\n.mdi-bank-off::before {\n  content: \"\\F1656\";\n}\n\n.mdi-bank-off-outline::before {\n  content: \"\\F1657\";\n}\n\n.mdi-bank-outline::before {\n  content: \"\\F0E80\";\n}\n\n.mdi-bank-plus::before {\n  content: \"\\F0DB1\";\n}\n\n.mdi-bank-remove::before {\n  content: \"\\F0DB2\";\n}\n\n.mdi-bank-transfer::before {\n  content: \"\\F0A27\";\n}\n\n.mdi-bank-transfer-in::before {\n  content: \"\\F0A28\";\n}\n\n.mdi-bank-transfer-out::before {\n  content: \"\\F0A29\";\n}\n\n.mdi-barcode::before {\n  content: \"\\F0071\";\n}\n\n.mdi-barcode-off::before {\n  content: \"\\F1236\";\n}\n\n.mdi-barcode-scan::before {\n  content: \"\\F0072\";\n}\n\n.mdi-barley::before {\n  content: \"\\F0073\";\n}\n\n.mdi-barley-off::before {\n  content: \"\\F0B5D\";\n}\n\n.mdi-barn::before {\n  content: \"\\F0B5E\";\n}\n\n.mdi-barrel::before {\n  content: \"\\F0074\";\n}\n\n.mdi-baseball::before {\n  content: \"\\F0852\";\n}\n\n.mdi-baseball-bat::before {\n  content: \"\\F0853\";\n}\n\n.mdi-baseball-diamond::before {\n  content: \"\\F15EC\";\n}\n\n.mdi-baseball-diamond-outline::before {\n  content: \"\\F15ED\";\n}\n\n.mdi-bash::before {\n  content: \"\\F1183\";\n}\n\n.mdi-basket::before {\n  content: \"\\F0076\";\n}\n\n.mdi-basket-check::before {\n  content: \"\\F18E5\";\n}\n\n.mdi-basket-check-outline::before {\n  content: \"\\F18E6\";\n}\n\n.mdi-basket-fill::before {\n  content: \"\\F0077\";\n}\n\n.mdi-basket-minus::before {\n  content: \"\\F1523\";\n}\n\n.mdi-basket-minus-outline::before {\n  content: \"\\F1524\";\n}\n\n.mdi-basket-off::before {\n  content: \"\\F1525\";\n}\n\n.mdi-basket-off-outline::before {\n  content: \"\\F1526\";\n}\n\n.mdi-basket-outline::before {\n  content: \"\\F1181\";\n}\n\n.mdi-basket-plus::before {\n  content: \"\\F1527\";\n}\n\n.mdi-basket-plus-outline::before {\n  content: \"\\F1528\";\n}\n\n.mdi-basket-remove::before {\n  content: \"\\F1529\";\n}\n\n.mdi-basket-remove-outline::before {\n  content: \"\\F152A\";\n}\n\n.mdi-basket-unfill::before {\n  content: \"\\F0078\";\n}\n\n.mdi-basketball::before {\n  content: \"\\F0806\";\n}\n\n.mdi-basketball-hoop::before {\n  content: \"\\F0C3B\";\n}\n\n.mdi-basketball-hoop-outline::before {\n  content: \"\\F0C3C\";\n}\n\n.mdi-bat::before {\n  content: \"\\F0B5F\";\n}\n\n.mdi-bathtub::before {\n  content: \"\\F1818\";\n}\n\n.mdi-bathtub-outline::before {\n  content: \"\\F1819\";\n}\n\n.mdi-battery::before {\n  content: \"\\F0079\";\n}\n\n.mdi-battery-10::before {\n  content: \"\\F007A\";\n}\n\n.mdi-battery-10-bluetooth::before {\n  content: \"\\F093E\";\n}\n\n.mdi-battery-20::before {\n  content: \"\\F007B\";\n}\n\n.mdi-battery-20-bluetooth::before {\n  content: \"\\F093F\";\n}\n\n.mdi-battery-30::before {\n  content: \"\\F007C\";\n}\n\n.mdi-battery-30-bluetooth::before {\n  content: \"\\F0940\";\n}\n\n.mdi-battery-40::before {\n  content: \"\\F007D\";\n}\n\n.mdi-battery-40-bluetooth::before {\n  content: \"\\F0941\";\n}\n\n.mdi-battery-50::before {\n  content: \"\\F007E\";\n}\n\n.mdi-battery-50-bluetooth::before {\n  content: \"\\F0942\";\n}\n\n.mdi-battery-60::before {\n  content: \"\\F007F\";\n}\n\n.mdi-battery-60-bluetooth::before {\n  content: \"\\F0943\";\n}\n\n.mdi-battery-70::before {\n  content: \"\\F0080\";\n}\n\n.mdi-battery-70-bluetooth::before {\n  content: \"\\F0944\";\n}\n\n.mdi-battery-80::before {\n  content: \"\\F0081\";\n}\n\n.mdi-battery-80-bluetooth::before {\n  content: \"\\F0945\";\n}\n\n.mdi-battery-90::before {\n  content: \"\\F0082\";\n}\n\n.mdi-battery-90-bluetooth::before {\n  content: \"\\F0946\";\n}\n\n.mdi-battery-alert::before {\n  content: \"\\F0083\";\n}\n\n.mdi-battery-alert-bluetooth::before {\n  content: \"\\F0947\";\n}\n\n.mdi-battery-alert-variant::before {\n  content: \"\\F10CC\";\n}\n\n.mdi-battery-alert-variant-outline::before {\n  content: \"\\F10CD\";\n}\n\n.mdi-battery-arrow-down::before {\n  content: \"\\F17DE\";\n}\n\n.mdi-battery-arrow-down-outline::before {\n  content: \"\\F17DF\";\n}\n\n.mdi-battery-arrow-up::before {\n  content: \"\\F17E0\";\n}\n\n.mdi-battery-arrow-up-outline::before {\n  content: \"\\F17E1\";\n}\n\n.mdi-battery-bluetooth::before {\n  content: \"\\F0948\";\n}\n\n.mdi-battery-bluetooth-variant::before {\n  content: \"\\F0949\";\n}\n\n.mdi-battery-charging::before {\n  content: \"\\F0084\";\n}\n\n.mdi-battery-charging-10::before {\n  content: \"\\F089C\";\n}\n\n.mdi-battery-charging-100::before {\n  content: \"\\F0085\";\n}\n\n.mdi-battery-charging-20::before {\n  content: \"\\F0086\";\n}\n\n.mdi-battery-charging-30::before {\n  content: \"\\F0087\";\n}\n\n.mdi-battery-charging-40::before {\n  content: \"\\F0088\";\n}\n\n.mdi-battery-charging-50::before {\n  content: \"\\F089D\";\n}\n\n.mdi-battery-charging-60::before {\n  content: \"\\F0089\";\n}\n\n.mdi-battery-charging-70::before {\n  content: \"\\F089E\";\n}\n\n.mdi-battery-charging-80::before {\n  content: \"\\F008A\";\n}\n\n.mdi-battery-charging-90::before {\n  content: \"\\F008B\";\n}\n\n.mdi-battery-charging-high::before {\n  content: \"\\F12A6\";\n}\n\n.mdi-battery-charging-low::before {\n  content: \"\\F12A4\";\n}\n\n.mdi-battery-charging-medium::before {\n  content: \"\\F12A5\";\n}\n\n.mdi-battery-charging-outline::before {\n  content: \"\\F089F\";\n}\n\n.mdi-battery-charging-wireless::before {\n  content: \"\\F0807\";\n}\n\n.mdi-battery-charging-wireless-10::before {\n  content: \"\\F0808\";\n}\n\n.mdi-battery-charging-wireless-20::before {\n  content: \"\\F0809\";\n}\n\n.mdi-battery-charging-wireless-30::before {\n  content: \"\\F080A\";\n}\n\n.mdi-battery-charging-wireless-40::before {\n  content: \"\\F080B\";\n}\n\n.mdi-battery-charging-wireless-50::before {\n  content: \"\\F080C\";\n}\n\n.mdi-battery-charging-wireless-60::before {\n  content: \"\\F080D\";\n}\n\n.mdi-battery-charging-wireless-70::before {\n  content: \"\\F080E\";\n}\n\n.mdi-battery-charging-wireless-80::before {\n  content: \"\\F080F\";\n}\n\n.mdi-battery-charging-wireless-90::before {\n  content: \"\\F0810\";\n}\n\n.mdi-battery-charging-wireless-alert::before {\n  content: \"\\F0811\";\n}\n\n.mdi-battery-charging-wireless-outline::before {\n  content: \"\\F0812\";\n}\n\n.mdi-battery-check::before {\n  content: \"\\F17E2\";\n}\n\n.mdi-battery-check-outline::before {\n  content: \"\\F17E3\";\n}\n\n.mdi-battery-heart::before {\n  content: \"\\F120F\";\n}\n\n.mdi-battery-heart-outline::before {\n  content: \"\\F1210\";\n}\n\n.mdi-battery-heart-variant::before {\n  content: \"\\F1211\";\n}\n\n.mdi-battery-high::before {\n  content: \"\\F12A3\";\n}\n\n.mdi-battery-lock::before {\n  content: \"\\F179C\";\n}\n\n.mdi-battery-lock-open::before {\n  content: \"\\F179D\";\n}\n\n.mdi-battery-low::before {\n  content: \"\\F12A1\";\n}\n\n.mdi-battery-medium::before {\n  content: \"\\F12A2\";\n}\n\n.mdi-battery-minus::before {\n  content: \"\\F17E4\";\n}\n\n.mdi-battery-minus-outline::before {\n  content: \"\\F17E5\";\n}\n\n.mdi-battery-minus-variant::before {\n  content: \"\\F008C\";\n}\n\n.mdi-battery-negative::before {\n  content: \"\\F008D\";\n}\n\n.mdi-battery-off::before {\n  content: \"\\F125D\";\n}\n\n.mdi-battery-off-outline::before {\n  content: \"\\F125E\";\n}\n\n.mdi-battery-outline::before {\n  content: \"\\F008E\";\n}\n\n.mdi-battery-plus::before {\n  content: \"\\F17E6\";\n}\n\n.mdi-battery-plus-outline::before {\n  content: \"\\F17E7\";\n}\n\n.mdi-battery-plus-variant::before {\n  content: \"\\F008F\";\n}\n\n.mdi-battery-positive::before {\n  content: \"\\F0090\";\n}\n\n.mdi-battery-remove::before {\n  content: \"\\F17E8\";\n}\n\n.mdi-battery-remove-outline::before {\n  content: \"\\F17E9\";\n}\n\n.mdi-battery-sync::before {\n  content: \"\\F1834\";\n}\n\n.mdi-battery-sync-outline::before {\n  content: \"\\F1835\";\n}\n\n.mdi-battery-unknown::before {\n  content: \"\\F0091\";\n}\n\n.mdi-battery-unknown-bluetooth::before {\n  content: \"\\F094A\";\n}\n\n.mdi-beach::before {\n  content: \"\\F0092\";\n}\n\n.mdi-beaker::before {\n  content: \"\\F0CEA\";\n}\n\n.mdi-beaker-alert::before {\n  content: \"\\F1229\";\n}\n\n.mdi-beaker-alert-outline::before {\n  content: \"\\F122A\";\n}\n\n.mdi-beaker-check::before {\n  content: \"\\F122B\";\n}\n\n.mdi-beaker-check-outline::before {\n  content: \"\\F122C\";\n}\n\n.mdi-beaker-minus::before {\n  content: \"\\F122D\";\n}\n\n.mdi-beaker-minus-outline::before {\n  content: \"\\F122E\";\n}\n\n.mdi-beaker-outline::before {\n  content: \"\\F0690\";\n}\n\n.mdi-beaker-plus::before {\n  content: \"\\F122F\";\n}\n\n.mdi-beaker-plus-outline::before {\n  content: \"\\F1230\";\n}\n\n.mdi-beaker-question::before {\n  content: \"\\F1231\";\n}\n\n.mdi-beaker-question-outline::before {\n  content: \"\\F1232\";\n}\n\n.mdi-beaker-remove::before {\n  content: \"\\F1233\";\n}\n\n.mdi-beaker-remove-outline::before {\n  content: \"\\F1234\";\n}\n\n.mdi-bed::before {\n  content: \"\\F02E3\";\n}\n\n.mdi-bed-double::before {\n  content: \"\\F0FD4\";\n}\n\n.mdi-bed-double-outline::before {\n  content: \"\\F0FD3\";\n}\n\n.mdi-bed-empty::before {\n  content: \"\\F08A0\";\n}\n\n.mdi-bed-king::before {\n  content: \"\\F0FD2\";\n}\n\n.mdi-bed-king-outline::before {\n  content: \"\\F0FD1\";\n}\n\n.mdi-bed-outline::before {\n  content: \"\\F0099\";\n}\n\n.mdi-bed-queen::before {\n  content: \"\\F0FD0\";\n}\n\n.mdi-bed-queen-outline::before {\n  content: \"\\F0FDB\";\n}\n\n.mdi-bed-single::before {\n  content: \"\\F106D\";\n}\n\n.mdi-bed-single-outline::before {\n  content: \"\\F106E\";\n}\n\n.mdi-bee::before {\n  content: \"\\F0FA1\";\n}\n\n.mdi-bee-flower::before {\n  content: \"\\F0FA2\";\n}\n\n.mdi-beehive-off-outline::before {\n  content: \"\\F13ED\";\n}\n\n.mdi-beehive-outline::before {\n  content: \"\\F10CE\";\n}\n\n.mdi-beekeeper::before {\n  content: \"\\F14E2\";\n}\n\n.mdi-beer::before {\n  content: \"\\F0098\";\n}\n\n.mdi-beer-outline::before {\n  content: \"\\F130C\";\n}\n\n.mdi-bell::before {\n  content: \"\\F009A\";\n}\n\n.mdi-bell-alert::before {\n  content: \"\\F0D59\";\n}\n\n.mdi-bell-alert-outline::before {\n  content: \"\\F0E81\";\n}\n\n.mdi-bell-badge::before {\n  content: \"\\F116B\";\n}\n\n.mdi-bell-badge-outline::before {\n  content: \"\\F0178\";\n}\n\n.mdi-bell-cancel::before {\n  content: \"\\F13E7\";\n}\n\n.mdi-bell-cancel-outline::before {\n  content: \"\\F13E8\";\n}\n\n.mdi-bell-check::before {\n  content: \"\\F11E5\";\n}\n\n.mdi-bell-check-outline::before {\n  content: \"\\F11E6\";\n}\n\n.mdi-bell-circle::before {\n  content: \"\\F0D5A\";\n}\n\n.mdi-bell-circle-outline::before {\n  content: \"\\F0D5B\";\n}\n\n.mdi-bell-minus::before {\n  content: \"\\F13E9\";\n}\n\n.mdi-bell-minus-outline::before {\n  content: \"\\F13EA\";\n}\n\n.mdi-bell-off::before {\n  content: \"\\F009B\";\n}\n\n.mdi-bell-off-outline::before {\n  content: \"\\F0A91\";\n}\n\n.mdi-bell-outline::before {\n  content: \"\\F009C\";\n}\n\n.mdi-bell-plus::before {\n  content: \"\\F009D\";\n}\n\n.mdi-bell-plus-outline::before {\n  content: \"\\F0A92\";\n}\n\n.mdi-bell-remove::before {\n  content: \"\\F13EB\";\n}\n\n.mdi-bell-remove-outline::before {\n  content: \"\\F13EC\";\n}\n\n.mdi-bell-ring::before {\n  content: \"\\F009E\";\n}\n\n.mdi-bell-ring-outline::before {\n  content: \"\\F009F\";\n}\n\n.mdi-bell-sleep::before {\n  content: \"\\F00A0\";\n}\n\n.mdi-bell-sleep-outline::before {\n  content: \"\\F0A93\";\n}\n\n.mdi-beta::before {\n  content: \"\\F00A1\";\n}\n\n.mdi-betamax::before {\n  content: \"\\F09CB\";\n}\n\n.mdi-biathlon::before {\n  content: \"\\F0E14\";\n}\n\n.mdi-bicycle::before {\n  content: \"\\F109C\";\n}\n\n.mdi-bicycle-basket::before {\n  content: \"\\F1235\";\n}\n\n.mdi-bicycle-cargo::before {\n  content: \"\\F189C\";\n}\n\n.mdi-bicycle-electric::before {\n  content: \"\\F15B4\";\n}\n\n.mdi-bicycle-penny-farthing::before {\n  content: \"\\F15E9\";\n}\n\n.mdi-bike::before {\n  content: \"\\F00A3\";\n}\n\n.mdi-bike-fast::before {\n  content: \"\\F111F\";\n}\n\n.mdi-billboard::before {\n  content: \"\\F1010\";\n}\n\n.mdi-billiards::before {\n  content: \"\\F0B61\";\n}\n\n.mdi-billiards-rack::before {\n  content: \"\\F0B62\";\n}\n\n.mdi-binoculars::before {\n  content: \"\\F00A5\";\n}\n\n.mdi-bio::before {\n  content: \"\\F00A6\";\n}\n\n.mdi-biohazard::before {\n  content: \"\\F00A7\";\n}\n\n.mdi-bird::before {\n  content: \"\\F15C6\";\n}\n\n.mdi-bitbucket::before {\n  content: \"\\F00A8\";\n}\n\n.mdi-bitcoin::before {\n  content: \"\\F0813\";\n}\n\n.mdi-black-mesa::before {\n  content: \"\\F00A9\";\n}\n\n.mdi-blender::before {\n  content: \"\\F0CEB\";\n}\n\n.mdi-blender-outline::before {\n  content: \"\\F181A\";\n}\n\n.mdi-blender-software::before {\n  content: \"\\F00AB\";\n}\n\n.mdi-blinds::before {\n  content: \"\\F00AC\";\n}\n\n.mdi-blinds-open::before {\n  content: \"\\F1011\";\n}\n\n.mdi-block-helper::before {\n  content: \"\\F00AD\";\n}\n\n.mdi-blood-bag::before {\n  content: \"\\F0CEC\";\n}\n\n.mdi-bluetooth::before {\n  content: \"\\F00AF\";\n}\n\n.mdi-bluetooth-audio::before {\n  content: \"\\F00B0\";\n}\n\n.mdi-bluetooth-connect::before {\n  content: \"\\F00B1\";\n}\n\n.mdi-bluetooth-off::before {\n  content: \"\\F00B2\";\n}\n\n.mdi-bluetooth-settings::before {\n  content: \"\\F00B3\";\n}\n\n.mdi-bluetooth-transfer::before {\n  content: \"\\F00B4\";\n}\n\n.mdi-blur::before {\n  content: \"\\F00B5\";\n}\n\n.mdi-blur-linear::before {\n  content: \"\\F00B6\";\n}\n\n.mdi-blur-off::before {\n  content: \"\\F00B7\";\n}\n\n.mdi-blur-radial::before {\n  content: \"\\F00B8\";\n}\n\n.mdi-bolt::before {\n  content: \"\\F0DB3\";\n}\n\n.mdi-bomb::before {\n  content: \"\\F0691\";\n}\n\n.mdi-bomb-off::before {\n  content: \"\\F06C5\";\n}\n\n.mdi-bone::before {\n  content: \"\\F00B9\";\n}\n\n.mdi-book::before {\n  content: \"\\F00BA\";\n}\n\n.mdi-book-account::before {\n  content: \"\\F13AD\";\n}\n\n.mdi-book-account-outline::before {\n  content: \"\\F13AE\";\n}\n\n.mdi-book-alert::before {\n  content: \"\\F167C\";\n}\n\n.mdi-book-alert-outline::before {\n  content: \"\\F167D\";\n}\n\n.mdi-book-alphabet::before {\n  content: \"\\F061D\";\n}\n\n.mdi-book-arrow-down::before {\n  content: \"\\F167E\";\n}\n\n.mdi-book-arrow-down-outline::before {\n  content: \"\\F167F\";\n}\n\n.mdi-book-arrow-left::before {\n  content: \"\\F1680\";\n}\n\n.mdi-book-arrow-left-outline::before {\n  content: \"\\F1681\";\n}\n\n.mdi-book-arrow-right::before {\n  content: \"\\F1682\";\n}\n\n.mdi-book-arrow-right-outline::before {\n  content: \"\\F1683\";\n}\n\n.mdi-book-arrow-up::before {\n  content: \"\\F1684\";\n}\n\n.mdi-book-arrow-up-outline::before {\n  content: \"\\F1685\";\n}\n\n.mdi-book-cancel::before {\n  content: \"\\F1686\";\n}\n\n.mdi-book-cancel-outline::before {\n  content: \"\\F1687\";\n}\n\n.mdi-book-check::before {\n  content: \"\\F14F3\";\n}\n\n.mdi-book-check-outline::before {\n  content: \"\\F14F4\";\n}\n\n.mdi-book-clock::before {\n  content: \"\\F1688\";\n}\n\n.mdi-book-clock-outline::before {\n  content: \"\\F1689\";\n}\n\n.mdi-book-cog::before {\n  content: \"\\F168A\";\n}\n\n.mdi-book-cog-outline::before {\n  content: \"\\F168B\";\n}\n\n.mdi-book-cross::before {\n  content: \"\\F00A2\";\n}\n\n.mdi-book-edit::before {\n  content: \"\\F168C\";\n}\n\n.mdi-book-edit-outline::before {\n  content: \"\\F168D\";\n}\n\n.mdi-book-education::before {\n  content: \"\\F16C9\";\n}\n\n.mdi-book-education-outline::before {\n  content: \"\\F16CA\";\n}\n\n.mdi-book-information-variant::before {\n  content: \"\\F106F\";\n}\n\n.mdi-book-lock::before {\n  content: \"\\F079A\";\n}\n\n.mdi-book-lock-open::before {\n  content: \"\\F079B\";\n}\n\n.mdi-book-lock-open-outline::before {\n  content: \"\\F168E\";\n}\n\n.mdi-book-lock-outline::before {\n  content: \"\\F168F\";\n}\n\n.mdi-book-marker::before {\n  content: \"\\F1690\";\n}\n\n.mdi-book-marker-outline::before {\n  content: \"\\F1691\";\n}\n\n.mdi-book-minus::before {\n  content: \"\\F05D9\";\n}\n\n.mdi-book-minus-multiple::before {\n  content: \"\\F0A94\";\n}\n\n.mdi-book-minus-multiple-outline::before {\n  content: \"\\F090B\";\n}\n\n.mdi-book-minus-outline::before {\n  content: \"\\F1692\";\n}\n\n.mdi-book-multiple::before {\n  content: \"\\F00BB\";\n}\n\n.mdi-book-multiple-outline::before {\n  content: \"\\F0436\";\n}\n\n.mdi-book-music::before {\n  content: \"\\F0067\";\n}\n\n.mdi-book-music-outline::before {\n  content: \"\\F1693\";\n}\n\n.mdi-book-off::before {\n  content: \"\\F1694\";\n}\n\n.mdi-book-off-outline::before {\n  content: \"\\F1695\";\n}\n\n.mdi-book-open::before {\n  content: \"\\F00BD\";\n}\n\n.mdi-book-open-blank-variant::before {\n  content: \"\\F00BE\";\n}\n\n.mdi-book-open-outline::before {\n  content: \"\\F0B63\";\n}\n\n.mdi-book-open-page-variant::before {\n  content: \"\\F05DA\";\n}\n\n.mdi-book-open-page-variant-outline::before {\n  content: \"\\F15D6\";\n}\n\n.mdi-book-open-variant::before {\n  content: \"\\F14F7\";\n}\n\n.mdi-book-outline::before {\n  content: \"\\F0B64\";\n}\n\n.mdi-book-play::before {\n  content: \"\\F0E82\";\n}\n\n.mdi-book-play-outline::before {\n  content: \"\\F0E83\";\n}\n\n.mdi-book-plus::before {\n  content: \"\\F05DB\";\n}\n\n.mdi-book-plus-multiple::before {\n  content: \"\\F0A95\";\n}\n\n.mdi-book-plus-multiple-outline::before {\n  content: \"\\F0ADE\";\n}\n\n.mdi-book-plus-outline::before {\n  content: \"\\F1696\";\n}\n\n.mdi-book-refresh::before {\n  content: \"\\F1697\";\n}\n\n.mdi-book-refresh-outline::before {\n  content: \"\\F1698\";\n}\n\n.mdi-book-remove::before {\n  content: \"\\F0A97\";\n}\n\n.mdi-book-remove-multiple::before {\n  content: \"\\F0A96\";\n}\n\n.mdi-book-remove-multiple-outline::before {\n  content: \"\\F04CA\";\n}\n\n.mdi-book-remove-outline::before {\n  content: \"\\F1699\";\n}\n\n.mdi-book-search::before {\n  content: \"\\F0E84\";\n}\n\n.mdi-book-search-outline::before {\n  content: \"\\F0E85\";\n}\n\n.mdi-book-settings::before {\n  content: \"\\F169A\";\n}\n\n.mdi-book-settings-outline::before {\n  content: \"\\F169B\";\n}\n\n.mdi-book-sync::before {\n  content: \"\\F169C\";\n}\n\n.mdi-book-sync-outline::before {\n  content: \"\\F16C8\";\n}\n\n.mdi-book-variant::before {\n  content: \"\\F00BF\";\n}\n\n.mdi-book-variant-multiple::before {\n  content: \"\\F00BC\";\n}\n\n.mdi-bookmark::before {\n  content: \"\\F00C0\";\n}\n\n.mdi-bookmark-box-multiple::before {\n  content: \"\\F196C\";\n}\n\n.mdi-bookmark-box-multiple-outline::before {\n  content: \"\\F196D\";\n}\n\n.mdi-bookmark-check::before {\n  content: \"\\F00C1\";\n}\n\n.mdi-bookmark-check-outline::before {\n  content: \"\\F137B\";\n}\n\n.mdi-bookmark-minus::before {\n  content: \"\\F09CC\";\n}\n\n.mdi-bookmark-minus-outline::before {\n  content: \"\\F09CD\";\n}\n\n.mdi-bookmark-multiple::before {\n  content: \"\\F0E15\";\n}\n\n.mdi-bookmark-multiple-outline::before {\n  content: \"\\F0E16\";\n}\n\n.mdi-bookmark-music::before {\n  content: \"\\F00C2\";\n}\n\n.mdi-bookmark-music-outline::before {\n  content: \"\\F1379\";\n}\n\n.mdi-bookmark-off::before {\n  content: \"\\F09CE\";\n}\n\n.mdi-bookmark-off-outline::before {\n  content: \"\\F09CF\";\n}\n\n.mdi-bookmark-outline::before {\n  content: \"\\F00C3\";\n}\n\n.mdi-bookmark-plus::before {\n  content: \"\\F00C5\";\n}\n\n.mdi-bookmark-plus-outline::before {\n  content: \"\\F00C4\";\n}\n\n.mdi-bookmark-remove::before {\n  content: \"\\F00C6\";\n}\n\n.mdi-bookmark-remove-outline::before {\n  content: \"\\F137A\";\n}\n\n.mdi-bookshelf::before {\n  content: \"\\F125F\";\n}\n\n.mdi-boom-gate::before {\n  content: \"\\F0E86\";\n}\n\n.mdi-boom-gate-alert::before {\n  content: \"\\F0E87\";\n}\n\n.mdi-boom-gate-alert-outline::before {\n  content: \"\\F0E88\";\n}\n\n.mdi-boom-gate-arrow-down::before {\n  content: \"\\F0E89\";\n}\n\n.mdi-boom-gate-arrow-down-outline::before {\n  content: \"\\F0E8A\";\n}\n\n.mdi-boom-gate-arrow-up::before {\n  content: \"\\F0E8C\";\n}\n\n.mdi-boom-gate-arrow-up-outline::before {\n  content: \"\\F0E8D\";\n}\n\n.mdi-boom-gate-outline::before {\n  content: \"\\F0E8B\";\n}\n\n.mdi-boom-gate-up::before {\n  content: \"\\F17F9\";\n}\n\n.mdi-boom-gate-up-outline::before {\n  content: \"\\F17FA\";\n}\n\n.mdi-boombox::before {\n  content: \"\\F05DC\";\n}\n\n.mdi-boomerang::before {\n  content: \"\\F10CF\";\n}\n\n.mdi-bootstrap::before {\n  content: \"\\F06C6\";\n}\n\n.mdi-border-all::before {\n  content: \"\\F00C7\";\n}\n\n.mdi-border-all-variant::before {\n  content: \"\\F08A1\";\n}\n\n.mdi-border-bottom::before {\n  content: \"\\F00C8\";\n}\n\n.mdi-border-bottom-variant::before {\n  content: \"\\F08A2\";\n}\n\n.mdi-border-color::before {\n  content: \"\\F00C9\";\n}\n\n.mdi-border-horizontal::before {\n  content: \"\\F00CA\";\n}\n\n.mdi-border-inside::before {\n  content: \"\\F00CB\";\n}\n\n.mdi-border-left::before {\n  content: \"\\F00CC\";\n}\n\n.mdi-border-left-variant::before {\n  content: \"\\F08A3\";\n}\n\n.mdi-border-none::before {\n  content: \"\\F00CD\";\n}\n\n.mdi-border-none-variant::before {\n  content: \"\\F08A4\";\n}\n\n.mdi-border-outside::before {\n  content: \"\\F00CE\";\n}\n\n.mdi-border-right::before {\n  content: \"\\F00CF\";\n}\n\n.mdi-border-right-variant::before {\n  content: \"\\F08A5\";\n}\n\n.mdi-border-style::before {\n  content: \"\\F00D0\";\n}\n\n.mdi-border-top::before {\n  content: \"\\F00D1\";\n}\n\n.mdi-border-top-variant::before {\n  content: \"\\F08A6\";\n}\n\n.mdi-border-vertical::before {\n  content: \"\\F00D2\";\n}\n\n.mdi-bottle-soda::before {\n  content: \"\\F1070\";\n}\n\n.mdi-bottle-soda-classic::before {\n  content: \"\\F1071\";\n}\n\n.mdi-bottle-soda-classic-outline::before {\n  content: \"\\F1363\";\n}\n\n.mdi-bottle-soda-outline::before {\n  content: \"\\F1072\";\n}\n\n.mdi-bottle-tonic::before {\n  content: \"\\F112E\";\n}\n\n.mdi-bottle-tonic-outline::before {\n  content: \"\\F112F\";\n}\n\n.mdi-bottle-tonic-plus::before {\n  content: \"\\F1130\";\n}\n\n.mdi-bottle-tonic-plus-outline::before {\n  content: \"\\F1131\";\n}\n\n.mdi-bottle-tonic-skull::before {\n  content: \"\\F1132\";\n}\n\n.mdi-bottle-tonic-skull-outline::before {\n  content: \"\\F1133\";\n}\n\n.mdi-bottle-wine::before {\n  content: \"\\F0854\";\n}\n\n.mdi-bottle-wine-outline::before {\n  content: \"\\F1310\";\n}\n\n.mdi-bow-arrow::before {\n  content: \"\\F1841\";\n}\n\n.mdi-bow-tie::before {\n  content: \"\\F0678\";\n}\n\n.mdi-bowl::before {\n  content: \"\\F028E\";\n}\n\n.mdi-bowl-mix::before {\n  content: \"\\F0617\";\n}\n\n.mdi-bowl-mix-outline::before {\n  content: \"\\F02E4\";\n}\n\n.mdi-bowl-outline::before {\n  content: \"\\F02A9\";\n}\n\n.mdi-bowling::before {\n  content: \"\\F00D3\";\n}\n\n.mdi-box::before {\n  content: \"\\F00D4\";\n}\n\n.mdi-box-cutter::before {\n  content: \"\\F00D5\";\n}\n\n.mdi-box-cutter-off::before {\n  content: \"\\F0B4A\";\n}\n\n.mdi-box-shadow::before {\n  content: \"\\F0637\";\n}\n\n.mdi-boxing-glove::before {\n  content: \"\\F0B65\";\n}\n\n.mdi-braille::before {\n  content: \"\\F09D0\";\n}\n\n.mdi-brain::before {\n  content: \"\\F09D1\";\n}\n\n.mdi-bread-slice::before {\n  content: \"\\F0CEE\";\n}\n\n.mdi-bread-slice-outline::before {\n  content: \"\\F0CEF\";\n}\n\n.mdi-bridge::before {\n  content: \"\\F0618\";\n}\n\n.mdi-briefcase::before {\n  content: \"\\F00D6\";\n}\n\n.mdi-briefcase-account::before {\n  content: \"\\F0CF0\";\n}\n\n.mdi-briefcase-account-outline::before {\n  content: \"\\F0CF1\";\n}\n\n.mdi-briefcase-check::before {\n  content: \"\\F00D7\";\n}\n\n.mdi-briefcase-check-outline::before {\n  content: \"\\F131E\";\n}\n\n.mdi-briefcase-clock::before {\n  content: \"\\F10D0\";\n}\n\n.mdi-briefcase-clock-outline::before {\n  content: \"\\F10D1\";\n}\n\n.mdi-briefcase-download::before {\n  content: \"\\F00D8\";\n}\n\n.mdi-briefcase-download-outline::before {\n  content: \"\\F0C3D\";\n}\n\n.mdi-briefcase-edit::before {\n  content: \"\\F0A98\";\n}\n\n.mdi-briefcase-edit-outline::before {\n  content: \"\\F0C3E\";\n}\n\n.mdi-briefcase-eye::before {\n  content: \"\\F17D9\";\n}\n\n.mdi-briefcase-eye-outline::before {\n  content: \"\\F17DA\";\n}\n\n.mdi-briefcase-minus::before {\n  content: \"\\F0A2A\";\n}\n\n.mdi-briefcase-minus-outline::before {\n  content: \"\\F0C3F\";\n}\n\n.mdi-briefcase-off::before {\n  content: \"\\F1658\";\n}\n\n.mdi-briefcase-off-outline::before {\n  content: \"\\F1659\";\n}\n\n.mdi-briefcase-outline::before {\n  content: \"\\F0814\";\n}\n\n.mdi-briefcase-plus::before {\n  content: \"\\F0A2B\";\n}\n\n.mdi-briefcase-plus-outline::before {\n  content: \"\\F0C40\";\n}\n\n.mdi-briefcase-remove::before {\n  content: \"\\F0A2C\";\n}\n\n.mdi-briefcase-remove-outline::before {\n  content: \"\\F0C41\";\n}\n\n.mdi-briefcase-search::before {\n  content: \"\\F0A2D\";\n}\n\n.mdi-briefcase-search-outline::before {\n  content: \"\\F0C42\";\n}\n\n.mdi-briefcase-upload::before {\n  content: \"\\F00D9\";\n}\n\n.mdi-briefcase-upload-outline::before {\n  content: \"\\F0C43\";\n}\n\n.mdi-briefcase-variant::before {\n  content: \"\\F1494\";\n}\n\n.mdi-briefcase-variant-off::before {\n  content: \"\\F165A\";\n}\n\n.mdi-briefcase-variant-off-outline::before {\n  content: \"\\F165B\";\n}\n\n.mdi-briefcase-variant-outline::before {\n  content: \"\\F1495\";\n}\n\n.mdi-brightness-1::before {\n  content: \"\\F00DA\";\n}\n\n.mdi-brightness-2::before {\n  content: \"\\F00DB\";\n}\n\n.mdi-brightness-3::before {\n  content: \"\\F00DC\";\n}\n\n.mdi-brightness-4::before {\n  content: \"\\F00DD\";\n}\n\n.mdi-brightness-5::before {\n  content: \"\\F00DE\";\n}\n\n.mdi-brightness-6::before {\n  content: \"\\F00DF\";\n}\n\n.mdi-brightness-7::before {\n  content: \"\\F00E0\";\n}\n\n.mdi-brightness-auto::before {\n  content: \"\\F00E1\";\n}\n\n.mdi-brightness-percent::before {\n  content: \"\\F0CF2\";\n}\n\n.mdi-broadcast::before {\n  content: \"\\F1720\";\n}\n\n.mdi-broadcast-off::before {\n  content: \"\\F1721\";\n}\n\n.mdi-broom::before {\n  content: \"\\F00E2\";\n}\n\n.mdi-brush::before {\n  content: \"\\F00E3\";\n}\n\n.mdi-brush-off::before {\n  content: \"\\F1771\";\n}\n\n.mdi-brush-variant::before {\n  content: \"\\F1813\";\n}\n\n.mdi-bucket::before {\n  content: \"\\F1415\";\n}\n\n.mdi-bucket-outline::before {\n  content: \"\\F1416\";\n}\n\n.mdi-buffet::before {\n  content: \"\\F0578\";\n}\n\n.mdi-bug::before {\n  content: \"\\F00E4\";\n}\n\n.mdi-bug-check::before {\n  content: \"\\F0A2E\";\n}\n\n.mdi-bug-check-outline::before {\n  content: \"\\F0A2F\";\n}\n\n.mdi-bug-outline::before {\n  content: \"\\F0A30\";\n}\n\n.mdi-bugle::before {\n  content: \"\\F0DB4\";\n}\n\n.mdi-bulldozer::before {\n  content: \"\\F0B22\";\n}\n\n.mdi-bullet::before {\n  content: \"\\F0CF3\";\n}\n\n.mdi-bulletin-board::before {\n  content: \"\\F00E5\";\n}\n\n.mdi-bullhorn::before {\n  content: \"\\F00E6\";\n}\n\n.mdi-bullhorn-outline::before {\n  content: \"\\F0B23\";\n}\n\n.mdi-bullhorn-variant::before {\n  content: \"\\F196E\";\n}\n\n.mdi-bullhorn-variant-outline::before {\n  content: \"\\F196F\";\n}\n\n.mdi-bullseye::before {\n  content: \"\\F05DD\";\n}\n\n.mdi-bullseye-arrow::before {\n  content: \"\\F08C9\";\n}\n\n.mdi-bulma::before {\n  content: \"\\F12E7\";\n}\n\n.mdi-bunk-bed::before {\n  content: \"\\F1302\";\n}\n\n.mdi-bunk-bed-outline::before {\n  content: \"\\F0097\";\n}\n\n.mdi-bus::before {\n  content: \"\\F00E7\";\n}\n\n.mdi-bus-alert::before {\n  content: \"\\F0A99\";\n}\n\n.mdi-bus-articulated-end::before {\n  content: \"\\F079C\";\n}\n\n.mdi-bus-articulated-front::before {\n  content: \"\\F079D\";\n}\n\n.mdi-bus-clock::before {\n  content: \"\\F08CA\";\n}\n\n.mdi-bus-double-decker::before {\n  content: \"\\F079E\";\n}\n\n.mdi-bus-electric::before {\n  content: \"\\F191D\";\n}\n\n.mdi-bus-marker::before {\n  content: \"\\F1212\";\n}\n\n.mdi-bus-multiple::before {\n  content: \"\\F0F3F\";\n}\n\n.mdi-bus-school::before {\n  content: \"\\F079F\";\n}\n\n.mdi-bus-side::before {\n  content: \"\\F07A0\";\n}\n\n.mdi-bus-stop::before {\n  content: \"\\F1012\";\n}\n\n.mdi-bus-stop-covered::before {\n  content: \"\\F1013\";\n}\n\n.mdi-bus-stop-uncovered::before {\n  content: \"\\F1014\";\n}\n\n.mdi-butterfly::before {\n  content: \"\\F1589\";\n}\n\n.mdi-butterfly-outline::before {\n  content: \"\\F158A\";\n}\n\n.mdi-cabin-a-frame::before {\n  content: \"\\F188C\";\n}\n\n.mdi-cable-data::before {\n  content: \"\\F1394\";\n}\n\n.mdi-cached::before {\n  content: \"\\F00E8\";\n}\n\n.mdi-cactus::before {\n  content: \"\\F0DB5\";\n}\n\n.mdi-cake::before {\n  content: \"\\F00E9\";\n}\n\n.mdi-cake-layered::before {\n  content: \"\\F00EA\";\n}\n\n.mdi-cake-variant::before {\n  content: \"\\F00EB\";\n}\n\n.mdi-cake-variant-outline::before {\n  content: \"\\F17F0\";\n}\n\n.mdi-calculator::before {\n  content: \"\\F00EC\";\n}\n\n.mdi-calculator-variant::before {\n  content: \"\\F0A9A\";\n}\n\n.mdi-calculator-variant-outline::before {\n  content: \"\\F15A6\";\n}\n\n.mdi-calendar::before {\n  content: \"\\F00ED\";\n}\n\n.mdi-calendar-account::before {\n  content: \"\\F0ED7\";\n}\n\n.mdi-calendar-account-outline::before {\n  content: \"\\F0ED8\";\n}\n\n.mdi-calendar-alert::before {\n  content: \"\\F0A31\";\n}\n\n.mdi-calendar-arrow-left::before {\n  content: \"\\F1134\";\n}\n\n.mdi-calendar-arrow-right::before {\n  content: \"\\F1135\";\n}\n\n.mdi-calendar-blank::before {\n  content: \"\\F00EE\";\n}\n\n.mdi-calendar-blank-multiple::before {\n  content: \"\\F1073\";\n}\n\n.mdi-calendar-blank-outline::before {\n  content: \"\\F0B66\";\n}\n\n.mdi-calendar-check::before {\n  content: \"\\F00EF\";\n}\n\n.mdi-calendar-check-outline::before {\n  content: \"\\F0C44\";\n}\n\n.mdi-calendar-clock::before {\n  content: \"\\F00F0\";\n}\n\n.mdi-calendar-clock-outline::before {\n  content: \"\\F16E1\";\n}\n\n.mdi-calendar-collapse-horizontal::before {\n  content: \"\\F189D\";\n}\n\n.mdi-calendar-cursor::before {\n  content: \"\\F157B\";\n}\n\n.mdi-calendar-edit::before {\n  content: \"\\F08A7\";\n}\n\n.mdi-calendar-end::before {\n  content: \"\\F166C\";\n}\n\n.mdi-calendar-expand-horizontal::before {\n  content: \"\\F189E\";\n}\n\n.mdi-calendar-export::before {\n  content: \"\\F0B24\";\n}\n\n.mdi-calendar-heart::before {\n  content: \"\\F09D2\";\n}\n\n.mdi-calendar-import::before {\n  content: \"\\F0B25\";\n}\n\n.mdi-calendar-lock::before {\n  content: \"\\F1641\";\n}\n\n.mdi-calendar-lock-outline::before {\n  content: \"\\F1642\";\n}\n\n.mdi-calendar-minus::before {\n  content: \"\\F0D5C\";\n}\n\n.mdi-calendar-month::before {\n  content: \"\\F0E17\";\n}\n\n.mdi-calendar-month-outline::before {\n  content: \"\\F0E18\";\n}\n\n.mdi-calendar-multiple::before {\n  content: \"\\F00F1\";\n}\n\n.mdi-calendar-multiple-check::before {\n  content: \"\\F00F2\";\n}\n\n.mdi-calendar-multiselect::before {\n  content: \"\\F0A32\";\n}\n\n.mdi-calendar-outline::before {\n  content: \"\\F0B67\";\n}\n\n.mdi-calendar-plus::before {\n  content: \"\\F00F3\";\n}\n\n.mdi-calendar-question::before {\n  content: \"\\F0692\";\n}\n\n.mdi-calendar-range::before {\n  content: \"\\F0679\";\n}\n\n.mdi-calendar-range-outline::before {\n  content: \"\\F0B68\";\n}\n\n.mdi-calendar-refresh::before {\n  content: \"\\F01E1\";\n}\n\n.mdi-calendar-refresh-outline::before {\n  content: \"\\F0203\";\n}\n\n.mdi-calendar-remove::before {\n  content: \"\\F00F4\";\n}\n\n.mdi-calendar-remove-outline::before {\n  content: \"\\F0C45\";\n}\n\n.mdi-calendar-search::before {\n  content: \"\\F094C\";\n}\n\n.mdi-calendar-star::before {\n  content: \"\\F09D3\";\n}\n\n.mdi-calendar-start::before {\n  content: \"\\F166D\";\n}\n\n.mdi-calendar-sync::before {\n  content: \"\\F0E8E\";\n}\n\n.mdi-calendar-sync-outline::before {\n  content: \"\\F0E8F\";\n}\n\n.mdi-calendar-text::before {\n  content: \"\\F00F5\";\n}\n\n.mdi-calendar-text-outline::before {\n  content: \"\\F0C46\";\n}\n\n.mdi-calendar-today::before {\n  content: \"\\F00F6\";\n}\n\n.mdi-calendar-week::before {\n  content: \"\\F0A33\";\n}\n\n.mdi-calendar-week-begin::before {\n  content: \"\\F0A34\";\n}\n\n.mdi-calendar-weekend::before {\n  content: \"\\F0ED9\";\n}\n\n.mdi-calendar-weekend-outline::before {\n  content: \"\\F0EDA\";\n}\n\n.mdi-call-made::before {\n  content: \"\\F00F7\";\n}\n\n.mdi-call-merge::before {\n  content: \"\\F00F8\";\n}\n\n.mdi-call-missed::before {\n  content: \"\\F00F9\";\n}\n\n.mdi-call-received::before {\n  content: \"\\F00FA\";\n}\n\n.mdi-call-split::before {\n  content: \"\\F00FB\";\n}\n\n.mdi-camcorder::before {\n  content: \"\\F00FC\";\n}\n\n.mdi-camcorder-off::before {\n  content: \"\\F00FF\";\n}\n\n.mdi-camera::before {\n  content: \"\\F0100\";\n}\n\n.mdi-camera-account::before {\n  content: \"\\F08CB\";\n}\n\n.mdi-camera-burst::before {\n  content: \"\\F0693\";\n}\n\n.mdi-camera-control::before {\n  content: \"\\F0B69\";\n}\n\n.mdi-camera-document::before {\n  content: \"\\F1871\";\n}\n\n.mdi-camera-document-off::before {\n  content: \"\\F1872\";\n}\n\n.mdi-camera-enhance::before {\n  content: \"\\F0101\";\n}\n\n.mdi-camera-enhance-outline::before {\n  content: \"\\F0B6A\";\n}\n\n.mdi-camera-flip::before {\n  content: \"\\F15D9\";\n}\n\n.mdi-camera-flip-outline::before {\n  content: \"\\F15DA\";\n}\n\n.mdi-camera-front::before {\n  content: \"\\F0102\";\n}\n\n.mdi-camera-front-variant::before {\n  content: \"\\F0103\";\n}\n\n.mdi-camera-gopro::before {\n  content: \"\\F07A1\";\n}\n\n.mdi-camera-image::before {\n  content: \"\\F08CC\";\n}\n\n.mdi-camera-iris::before {\n  content: \"\\F0104\";\n}\n\n.mdi-camera-marker::before {\n  content: \"\\F19A7\";\n}\n\n.mdi-camera-marker-outline::before {\n  content: \"\\F19A8\";\n}\n\n.mdi-camera-metering-center::before {\n  content: \"\\F07A2\";\n}\n\n.mdi-camera-metering-matrix::before {\n  content: \"\\F07A3\";\n}\n\n.mdi-camera-metering-partial::before {\n  content: \"\\F07A4\";\n}\n\n.mdi-camera-metering-spot::before {\n  content: \"\\F07A5\";\n}\n\n.mdi-camera-off::before {\n  content: \"\\F05DF\";\n}\n\n.mdi-camera-off-outline::before {\n  content: \"\\F19BF\";\n}\n\n.mdi-camera-outline::before {\n  content: \"\\F0D5D\";\n}\n\n.mdi-camera-party-mode::before {\n  content: \"\\F0105\";\n}\n\n.mdi-camera-plus::before {\n  content: \"\\F0EDB\";\n}\n\n.mdi-camera-plus-outline::before {\n  content: \"\\F0EDC\";\n}\n\n.mdi-camera-rear::before {\n  content: \"\\F0106\";\n}\n\n.mdi-camera-rear-variant::before {\n  content: \"\\F0107\";\n}\n\n.mdi-camera-retake::before {\n  content: \"\\F0E19\";\n}\n\n.mdi-camera-retake-outline::before {\n  content: \"\\F0E1A\";\n}\n\n.mdi-camera-switch::before {\n  content: \"\\F0108\";\n}\n\n.mdi-camera-switch-outline::before {\n  content: \"\\F084A\";\n}\n\n.mdi-camera-timer::before {\n  content: \"\\F0109\";\n}\n\n.mdi-camera-wireless::before {\n  content: \"\\F0DB6\";\n}\n\n.mdi-camera-wireless-outline::before {\n  content: \"\\F0DB7\";\n}\n\n.mdi-campfire::before {\n  content: \"\\F0EDD\";\n}\n\n.mdi-cancel::before {\n  content: \"\\F073A\";\n}\n\n.mdi-candelabra::before {\n  content: \"\\F17D2\";\n}\n\n.mdi-candelabra-fire::before {\n  content: \"\\F17D3\";\n}\n\n.mdi-candle::before {\n  content: \"\\F05E2\";\n}\n\n.mdi-candy::before {\n  content: \"\\F1970\";\n}\n\n.mdi-candy-off::before {\n  content: \"\\F1971\";\n}\n\n.mdi-candy-off-outline::before {\n  content: \"\\F1972\";\n}\n\n.mdi-candy-outline::before {\n  content: \"\\F1973\";\n}\n\n.mdi-candycane::before {\n  content: \"\\F010A\";\n}\n\n.mdi-cannabis::before {\n  content: \"\\F07A6\";\n}\n\n.mdi-cannabis-off::before {\n  content: \"\\F166E\";\n}\n\n.mdi-caps-lock::before {\n  content: \"\\F0A9B\";\n}\n\n.mdi-car::before {\n  content: \"\\F010B\";\n}\n\n.mdi-car-2-plus::before {\n  content: \"\\F1015\";\n}\n\n.mdi-car-3-plus::before {\n  content: \"\\F1016\";\n}\n\n.mdi-car-arrow-left::before {\n  content: \"\\F13B2\";\n}\n\n.mdi-car-arrow-right::before {\n  content: \"\\F13B3\";\n}\n\n.mdi-car-back::before {\n  content: \"\\F0E1B\";\n}\n\n.mdi-car-battery::before {\n  content: \"\\F010C\";\n}\n\n.mdi-car-brake-abs::before {\n  content: \"\\F0C47\";\n}\n\n.mdi-car-brake-alert::before {\n  content: \"\\F0C48\";\n}\n\n.mdi-car-brake-fluid-level::before {\n  content: \"\\F1909\";\n}\n\n.mdi-car-brake-hold::before {\n  content: \"\\F0D5E\";\n}\n\n.mdi-car-brake-low-pressure::before {\n  content: \"\\F190A\";\n}\n\n.mdi-car-brake-parking::before {\n  content: \"\\F0D5F\";\n}\n\n.mdi-car-brake-retarder::before {\n  content: \"\\F1017\";\n}\n\n.mdi-car-brake-temperature::before {\n  content: \"\\F190B\";\n}\n\n.mdi-car-brake-worn-linings::before {\n  content: \"\\F190C\";\n}\n\n.mdi-car-child-seat::before {\n  content: \"\\F0FA3\";\n}\n\n.mdi-car-clock::before {\n  content: \"\\F1974\";\n}\n\n.mdi-car-clutch::before {\n  content: \"\\F1018\";\n}\n\n.mdi-car-cog::before {\n  content: \"\\F13CC\";\n}\n\n.mdi-car-connected::before {\n  content: \"\\F010D\";\n}\n\n.mdi-car-convertible::before {\n  content: \"\\F07A7\";\n}\n\n.mdi-car-coolant-level::before {\n  content: \"\\F1019\";\n}\n\n.mdi-car-cruise-control::before {\n  content: \"\\F0D60\";\n}\n\n.mdi-car-defrost-front::before {\n  content: \"\\F0D61\";\n}\n\n.mdi-car-defrost-rear::before {\n  content: \"\\F0D62\";\n}\n\n.mdi-car-door::before {\n  content: \"\\F0B6B\";\n}\n\n.mdi-car-door-lock::before {\n  content: \"\\F109D\";\n}\n\n.mdi-car-electric::before {\n  content: \"\\F0B6C\";\n}\n\n.mdi-car-electric-outline::before {\n  content: \"\\F15B5\";\n}\n\n.mdi-car-emergency::before {\n  content: \"\\F160F\";\n}\n\n.mdi-car-esp::before {\n  content: \"\\F0C49\";\n}\n\n.mdi-car-estate::before {\n  content: \"\\F07A8\";\n}\n\n.mdi-car-hatchback::before {\n  content: \"\\F07A9\";\n}\n\n.mdi-car-info::before {\n  content: \"\\F11BE\";\n}\n\n.mdi-car-key::before {\n  content: \"\\F0B6D\";\n}\n\n.mdi-car-lifted-pickup::before {\n  content: \"\\F152D\";\n}\n\n.mdi-car-light-alert::before {\n  content: \"\\F190D\";\n}\n\n.mdi-car-light-dimmed::before {\n  content: \"\\F0C4A\";\n}\n\n.mdi-car-light-fog::before {\n  content: \"\\F0C4B\";\n}\n\n.mdi-car-light-high::before {\n  content: \"\\F0C4C\";\n}\n\n.mdi-car-limousine::before {\n  content: \"\\F08CD\";\n}\n\n.mdi-car-multiple::before {\n  content: \"\\F0B6E\";\n}\n\n.mdi-car-off::before {\n  content: \"\\F0E1C\";\n}\n\n.mdi-car-outline::before {\n  content: \"\\F14ED\";\n}\n\n.mdi-car-parking-lights::before {\n  content: \"\\F0D63\";\n}\n\n.mdi-car-pickup::before {\n  content: \"\\F07AA\";\n}\n\n.mdi-car-seat::before {\n  content: \"\\F0FA4\";\n}\n\n.mdi-car-seat-cooler::before {\n  content: \"\\F0FA5\";\n}\n\n.mdi-car-seat-heater::before {\n  content: \"\\F0FA6\";\n}\n\n.mdi-car-select::before {\n  content: \"\\F1879\";\n}\n\n.mdi-car-settings::before {\n  content: \"\\F13CD\";\n}\n\n.mdi-car-shift-pattern::before {\n  content: \"\\F0F40\";\n}\n\n.mdi-car-side::before {\n  content: \"\\F07AB\";\n}\n\n.mdi-car-speed-limiter::before {\n  content: \"\\F190E\";\n}\n\n.mdi-car-sports::before {\n  content: \"\\F07AC\";\n}\n\n.mdi-car-tire-alert::before {\n  content: \"\\F0C4D\";\n}\n\n.mdi-car-traction-control::before {\n  content: \"\\F0D64\";\n}\n\n.mdi-car-turbocharger::before {\n  content: \"\\F101A\";\n}\n\n.mdi-car-wash::before {\n  content: \"\\F010E\";\n}\n\n.mdi-car-windshield::before {\n  content: \"\\F101B\";\n}\n\n.mdi-car-windshield-outline::before {\n  content: \"\\F101C\";\n}\n\n.mdi-car-wireless::before {\n  content: \"\\F1878\";\n}\n\n.mdi-car-wrench::before {\n  content: \"\\F1814\";\n}\n\n.mdi-carabiner::before {\n  content: \"\\F14C0\";\n}\n\n.mdi-caravan::before {\n  content: \"\\F07AD\";\n}\n\n.mdi-card::before {\n  content: \"\\F0B6F\";\n}\n\n.mdi-card-account-details::before {\n  content: \"\\F05D2\";\n}\n\n.mdi-card-account-details-outline::before {\n  content: \"\\F0DAB\";\n}\n\n.mdi-card-account-details-star::before {\n  content: \"\\F02A3\";\n}\n\n.mdi-card-account-details-star-outline::before {\n  content: \"\\F06DB\";\n}\n\n.mdi-card-account-mail::before {\n  content: \"\\F018E\";\n}\n\n.mdi-card-account-mail-outline::before {\n  content: \"\\F0E98\";\n}\n\n.mdi-card-account-phone::before {\n  content: \"\\F0E99\";\n}\n\n.mdi-card-account-phone-outline::before {\n  content: \"\\F0E9A\";\n}\n\n.mdi-card-bulleted::before {\n  content: \"\\F0B70\";\n}\n\n.mdi-card-bulleted-off::before {\n  content: \"\\F0B71\";\n}\n\n.mdi-card-bulleted-off-outline::before {\n  content: \"\\F0B72\";\n}\n\n.mdi-card-bulleted-outline::before {\n  content: \"\\F0B73\";\n}\n\n.mdi-card-bulleted-settings::before {\n  content: \"\\F0B74\";\n}\n\n.mdi-card-bulleted-settings-outline::before {\n  content: \"\\F0B75\";\n}\n\n.mdi-card-minus::before {\n  content: \"\\F1600\";\n}\n\n.mdi-card-minus-outline::before {\n  content: \"\\F1601\";\n}\n\n.mdi-card-multiple::before {\n  content: \"\\F17F1\";\n}\n\n.mdi-card-multiple-outline::before {\n  content: \"\\F17F2\";\n}\n\n.mdi-card-off::before {\n  content: \"\\F1602\";\n}\n\n.mdi-card-off-outline::before {\n  content: \"\\F1603\";\n}\n\n.mdi-card-outline::before {\n  content: \"\\F0B76\";\n}\n\n.mdi-card-plus::before {\n  content: \"\\F11FF\";\n}\n\n.mdi-card-plus-outline::before {\n  content: \"\\F1200\";\n}\n\n.mdi-card-remove::before {\n  content: \"\\F1604\";\n}\n\n.mdi-card-remove-outline::before {\n  content: \"\\F1605\";\n}\n\n.mdi-card-search::before {\n  content: \"\\F1074\";\n}\n\n.mdi-card-search-outline::before {\n  content: \"\\F1075\";\n}\n\n.mdi-card-text::before {\n  content: \"\\F0B77\";\n}\n\n.mdi-card-text-outline::before {\n  content: \"\\F0B78\";\n}\n\n.mdi-cards::before {\n  content: \"\\F0638\";\n}\n\n.mdi-cards-club::before {\n  content: \"\\F08CE\";\n}\n\n.mdi-cards-club-outline::before {\n  content: \"\\F189F\";\n}\n\n.mdi-cards-diamond::before {\n  content: \"\\F08CF\";\n}\n\n.mdi-cards-diamond-outline::before {\n  content: \"\\F101D\";\n}\n\n.mdi-cards-heart::before {\n  content: \"\\F08D0\";\n}\n\n.mdi-cards-heart-outline::before {\n  content: \"\\F18A0\";\n}\n\n.mdi-cards-outline::before {\n  content: \"\\F0639\";\n}\n\n.mdi-cards-playing::before {\n  content: \"\\F18A1\";\n}\n\n.mdi-cards-playing-club::before {\n  content: \"\\F18A2\";\n}\n\n.mdi-cards-playing-club-multiple::before {\n  content: \"\\F18A3\";\n}\n\n.mdi-cards-playing-club-multiple-outline::before {\n  content: \"\\F18A4\";\n}\n\n.mdi-cards-playing-club-outline::before {\n  content: \"\\F18A5\";\n}\n\n.mdi-cards-playing-diamond::before {\n  content: \"\\F18A6\";\n}\n\n.mdi-cards-playing-diamond-multiple::before {\n  content: \"\\F18A7\";\n}\n\n.mdi-cards-playing-diamond-multiple-outline::before {\n  content: \"\\F18A8\";\n}\n\n.mdi-cards-playing-diamond-outline::before {\n  content: \"\\F18A9\";\n}\n\n.mdi-cards-playing-heart::before {\n  content: \"\\F18AA\";\n}\n\n.mdi-cards-playing-heart-multiple::before {\n  content: \"\\F18AB\";\n}\n\n.mdi-cards-playing-heart-multiple-outline::before {\n  content: \"\\F18AC\";\n}\n\n.mdi-cards-playing-heart-outline::before {\n  content: \"\\F18AD\";\n}\n\n.mdi-cards-playing-outline::before {\n  content: \"\\F063A\";\n}\n\n.mdi-cards-playing-spade::before {\n  content: \"\\F18AE\";\n}\n\n.mdi-cards-playing-spade-multiple::before {\n  content: \"\\F18AF\";\n}\n\n.mdi-cards-playing-spade-multiple-outline::before {\n  content: \"\\F18B0\";\n}\n\n.mdi-cards-playing-spade-outline::before {\n  content: \"\\F18B1\";\n}\n\n.mdi-cards-spade::before {\n  content: \"\\F08D1\";\n}\n\n.mdi-cards-spade-outline::before {\n  content: \"\\F18B2\";\n}\n\n.mdi-cards-variant::before {\n  content: \"\\F06C7\";\n}\n\n.mdi-carrot::before {\n  content: \"\\F010F\";\n}\n\n.mdi-cart::before {\n  content: \"\\F0110\";\n}\n\n.mdi-cart-arrow-down::before {\n  content: \"\\F0D66\";\n}\n\n.mdi-cart-arrow-right::before {\n  content: \"\\F0C4E\";\n}\n\n.mdi-cart-arrow-up::before {\n  content: \"\\F0D67\";\n}\n\n.mdi-cart-check::before {\n  content: \"\\F15EA\";\n}\n\n.mdi-cart-heart::before {\n  content: \"\\F18E0\";\n}\n\n.mdi-cart-minus::before {\n  content: \"\\F0D68\";\n}\n\n.mdi-cart-off::before {\n  content: \"\\F066B\";\n}\n\n.mdi-cart-outline::before {\n  content: \"\\F0111\";\n}\n\n.mdi-cart-plus::before {\n  content: \"\\F0112\";\n}\n\n.mdi-cart-remove::before {\n  content: \"\\F0D69\";\n}\n\n.mdi-cart-variant::before {\n  content: \"\\F15EB\";\n}\n\n.mdi-case-sensitive-alt::before {\n  content: \"\\F0113\";\n}\n\n.mdi-cash::before {\n  content: \"\\F0114\";\n}\n\n.mdi-cash-100::before {\n  content: \"\\F0115\";\n}\n\n.mdi-cash-check::before {\n  content: \"\\F14EE\";\n}\n\n.mdi-cash-fast::before {\n  content: \"\\F185C\";\n}\n\n.mdi-cash-lock::before {\n  content: \"\\F14EA\";\n}\n\n.mdi-cash-lock-open::before {\n  content: \"\\F14EB\";\n}\n\n.mdi-cash-marker::before {\n  content: \"\\F0DB8\";\n}\n\n.mdi-cash-minus::before {\n  content: \"\\F1260\";\n}\n\n.mdi-cash-multiple::before {\n  content: \"\\F0116\";\n}\n\n.mdi-cash-plus::before {\n  content: \"\\F1261\";\n}\n\n.mdi-cash-refund::before {\n  content: \"\\F0A9C\";\n}\n\n.mdi-cash-register::before {\n  content: \"\\F0CF4\";\n}\n\n.mdi-cash-remove::before {\n  content: \"\\F1262\";\n}\n\n.mdi-cassette::before {\n  content: \"\\F09D4\";\n}\n\n.mdi-cast::before {\n  content: \"\\F0118\";\n}\n\n.mdi-cast-audio::before {\n  content: \"\\F101E\";\n}\n\n.mdi-cast-audio-variant::before {\n  content: \"\\F1749\";\n}\n\n.mdi-cast-connected::before {\n  content: \"\\F0119\";\n}\n\n.mdi-cast-education::before {\n  content: \"\\F0E1D\";\n}\n\n.mdi-cast-off::before {\n  content: \"\\F078A\";\n}\n\n.mdi-cast-variant::before {\n  content: \"\\F001F\";\n}\n\n.mdi-castle::before {\n  content: \"\\F011A\";\n}\n\n.mdi-cat::before {\n  content: \"\\F011B\";\n}\n\n.mdi-cctv::before {\n  content: \"\\F07AE\";\n}\n\n.mdi-cctv-off::before {\n  content: \"\\F185F\";\n}\n\n.mdi-ceiling-fan::before {\n  content: \"\\F1797\";\n}\n\n.mdi-ceiling-fan-light::before {\n  content: \"\\F1798\";\n}\n\n.mdi-ceiling-light::before {\n  content: \"\\F0769\";\n}\n\n.mdi-ceiling-light-multiple::before {\n  content: \"\\F18DD\";\n}\n\n.mdi-ceiling-light-multiple-outline::before {\n  content: \"\\F18DE\";\n}\n\n.mdi-ceiling-light-outline::before {\n  content: \"\\F17C7\";\n}\n\n.mdi-cellphone::before {\n  content: \"\\F011C\";\n}\n\n.mdi-cellphone-arrow-down::before {\n  content: \"\\F09D5\";\n}\n\n.mdi-cellphone-basic::before {\n  content: \"\\F011E\";\n}\n\n.mdi-cellphone-charging::before {\n  content: \"\\F1397\";\n}\n\n.mdi-cellphone-check::before {\n  content: \"\\F17FD\";\n}\n\n.mdi-cellphone-cog::before {\n  content: \"\\F0951\";\n}\n\n.mdi-cellphone-dock::before {\n  content: \"\\F011F\";\n}\n\n.mdi-cellphone-information::before {\n  content: \"\\F0F41\";\n}\n\n.mdi-cellphone-key::before {\n  content: \"\\F094E\";\n}\n\n.mdi-cellphone-link::before {\n  content: \"\\F0121\";\n}\n\n.mdi-cellphone-link-off::before {\n  content: \"\\F0122\";\n}\n\n.mdi-cellphone-lock::before {\n  content: \"\\F094F\";\n}\n\n.mdi-cellphone-marker::before {\n  content: \"\\F183A\";\n}\n\n.mdi-cellphone-message::before {\n  content: \"\\F08D3\";\n}\n\n.mdi-cellphone-message-off::before {\n  content: \"\\F10D2\";\n}\n\n.mdi-cellphone-nfc::before {\n  content: \"\\F0E90\";\n}\n\n.mdi-cellphone-nfc-off::before {\n  content: \"\\F12D8\";\n}\n\n.mdi-cellphone-off::before {\n  content: \"\\F0950\";\n}\n\n.mdi-cellphone-play::before {\n  content: \"\\F101F\";\n}\n\n.mdi-cellphone-remove::before {\n  content: \"\\F094D\";\n}\n\n.mdi-cellphone-screenshot::before {\n  content: \"\\F0A35\";\n}\n\n.mdi-cellphone-settings::before {\n  content: \"\\F0123\";\n}\n\n.mdi-cellphone-sound::before {\n  content: \"\\F0952\";\n}\n\n.mdi-cellphone-text::before {\n  content: \"\\F08D2\";\n}\n\n.mdi-cellphone-wireless::before {\n  content: \"\\F0815\";\n}\n\n.mdi-centos::before {\n  content: \"\\F111A\";\n}\n\n.mdi-certificate::before {\n  content: \"\\F0124\";\n}\n\n.mdi-certificate-outline::before {\n  content: \"\\F1188\";\n}\n\n.mdi-chair-rolling::before {\n  content: \"\\F0F48\";\n}\n\n.mdi-chair-school::before {\n  content: \"\\F0125\";\n}\n\n.mdi-chandelier::before {\n  content: \"\\F1793\";\n}\n\n.mdi-charity::before {\n  content: \"\\F0C4F\";\n}\n\n.mdi-chart-arc::before {\n  content: \"\\F0126\";\n}\n\n.mdi-chart-areaspline::before {\n  content: \"\\F0127\";\n}\n\n.mdi-chart-areaspline-variant::before {\n  content: \"\\F0E91\";\n}\n\n.mdi-chart-bar::before {\n  content: \"\\F0128\";\n}\n\n.mdi-chart-bar-stacked::before {\n  content: \"\\F076A\";\n}\n\n.mdi-chart-bell-curve::before {\n  content: \"\\F0C50\";\n}\n\n.mdi-chart-bell-curve-cumulative::before {\n  content: \"\\F0FA7\";\n}\n\n.mdi-chart-box::before {\n  content: \"\\F154D\";\n}\n\n.mdi-chart-box-outline::before {\n  content: \"\\F154E\";\n}\n\n.mdi-chart-box-plus-outline::before {\n  content: \"\\F154F\";\n}\n\n.mdi-chart-bubble::before {\n  content: \"\\F05E3\";\n}\n\n.mdi-chart-donut::before {\n  content: \"\\F07AF\";\n}\n\n.mdi-chart-donut-variant::before {\n  content: \"\\F07B0\";\n}\n\n.mdi-chart-gantt::before {\n  content: \"\\F066C\";\n}\n\n.mdi-chart-histogram::before {\n  content: \"\\F0129\";\n}\n\n.mdi-chart-line::before {\n  content: \"\\F012A\";\n}\n\n.mdi-chart-line-stacked::before {\n  content: \"\\F076B\";\n}\n\n.mdi-chart-line-variant::before {\n  content: \"\\F07B1\";\n}\n\n.mdi-chart-multiline::before {\n  content: \"\\F08D4\";\n}\n\n.mdi-chart-multiple::before {\n  content: \"\\F1213\";\n}\n\n.mdi-chart-pie::before {\n  content: \"\\F012B\";\n}\n\n.mdi-chart-ppf::before {\n  content: \"\\F1380\";\n}\n\n.mdi-chart-sankey::before {\n  content: \"\\F11DF\";\n}\n\n.mdi-chart-sankey-variant::before {\n  content: \"\\F11E0\";\n}\n\n.mdi-chart-scatter-plot::before {\n  content: \"\\F0E92\";\n}\n\n.mdi-chart-scatter-plot-hexbin::before {\n  content: \"\\F066D\";\n}\n\n.mdi-chart-timeline::before {\n  content: \"\\F066E\";\n}\n\n.mdi-chart-timeline-variant::before {\n  content: \"\\F0E93\";\n}\n\n.mdi-chart-timeline-variant-shimmer::before {\n  content: \"\\F15B6\";\n}\n\n.mdi-chart-tree::before {\n  content: \"\\F0E94\";\n}\n\n.mdi-chart-waterfall::before {\n  content: \"\\F1918\";\n}\n\n.mdi-chat::before {\n  content: \"\\F0B79\";\n}\n\n.mdi-chat-alert::before {\n  content: \"\\F0B7A\";\n}\n\n.mdi-chat-alert-outline::before {\n  content: \"\\F12C9\";\n}\n\n.mdi-chat-minus::before {\n  content: \"\\F1410\";\n}\n\n.mdi-chat-minus-outline::before {\n  content: \"\\F1413\";\n}\n\n.mdi-chat-outline::before {\n  content: \"\\F0EDE\";\n}\n\n.mdi-chat-plus::before {\n  content: \"\\F140F\";\n}\n\n.mdi-chat-plus-outline::before {\n  content: \"\\F1412\";\n}\n\n.mdi-chat-processing::before {\n  content: \"\\F0B7B\";\n}\n\n.mdi-chat-processing-outline::before {\n  content: \"\\F12CA\";\n}\n\n.mdi-chat-question::before {\n  content: \"\\F1738\";\n}\n\n.mdi-chat-question-outline::before {\n  content: \"\\F1739\";\n}\n\n.mdi-chat-remove::before {\n  content: \"\\F1411\";\n}\n\n.mdi-chat-remove-outline::before {\n  content: \"\\F1414\";\n}\n\n.mdi-chat-sleep::before {\n  content: \"\\F12D1\";\n}\n\n.mdi-chat-sleep-outline::before {\n  content: \"\\F12D2\";\n}\n\n.mdi-check::before {\n  content: \"\\F012C\";\n}\n\n.mdi-check-all::before {\n  content: \"\\F012D\";\n}\n\n.mdi-check-bold::before {\n  content: \"\\F0E1E\";\n}\n\n.mdi-check-circle::before {\n  content: \"\\F05E0\";\n}\n\n.mdi-check-circle-outline::before {\n  content: \"\\F05E1\";\n}\n\n.mdi-check-decagram::before {\n  content: \"\\F0791\";\n}\n\n.mdi-check-decagram-outline::before {\n  content: \"\\F1740\";\n}\n\n.mdi-check-network::before {\n  content: \"\\F0C53\";\n}\n\n.mdi-check-network-outline::before {\n  content: \"\\F0C54\";\n}\n\n.mdi-check-outline::before {\n  content: \"\\F0855\";\n}\n\n.mdi-check-underline::before {\n  content: \"\\F0E1F\";\n}\n\n.mdi-check-underline-circle::before {\n  content: \"\\F0E20\";\n}\n\n.mdi-check-underline-circle-outline::before {\n  content: \"\\F0E21\";\n}\n\n.mdi-checkbook::before {\n  content: \"\\F0A9D\";\n}\n\n.mdi-checkbox-blank::before {\n  content: \"\\F012E\";\n}\n\n.mdi-checkbox-blank-badge::before {\n  content: \"\\F1176\";\n}\n\n.mdi-checkbox-blank-badge-outline::before {\n  content: \"\\F0117\";\n}\n\n.mdi-checkbox-blank-circle::before {\n  content: \"\\F012F\";\n}\n\n.mdi-checkbox-blank-circle-outline::before {\n  content: \"\\F0130\";\n}\n\n.mdi-checkbox-blank-off::before {\n  content: \"\\F12EC\";\n}\n\n.mdi-checkbox-blank-off-outline::before {\n  content: \"\\F12ED\";\n}\n\n.mdi-checkbox-blank-outline::before {\n  content: \"\\F0131\";\n}\n\n.mdi-checkbox-intermediate::before {\n  content: \"\\F0856\";\n}\n\n.mdi-checkbox-marked::before {\n  content: \"\\F0132\";\n}\n\n.mdi-checkbox-marked-circle::before {\n  content: \"\\F0133\";\n}\n\n.mdi-checkbox-marked-circle-outline::before {\n  content: \"\\F0134\";\n}\n\n.mdi-checkbox-marked-circle-plus-outline::before {\n  content: \"\\F1927\";\n}\n\n.mdi-checkbox-marked-outline::before {\n  content: \"\\F0135\";\n}\n\n.mdi-checkbox-multiple-blank::before {\n  content: \"\\F0136\";\n}\n\n.mdi-checkbox-multiple-blank-circle::before {\n  content: \"\\F063B\";\n}\n\n.mdi-checkbox-multiple-blank-circle-outline::before {\n  content: \"\\F063C\";\n}\n\n.mdi-checkbox-multiple-blank-outline::before {\n  content: \"\\F0137\";\n}\n\n.mdi-checkbox-multiple-marked::before {\n  content: \"\\F0138\";\n}\n\n.mdi-checkbox-multiple-marked-circle::before {\n  content: \"\\F063D\";\n}\n\n.mdi-checkbox-multiple-marked-circle-outline::before {\n  content: \"\\F063E\";\n}\n\n.mdi-checkbox-multiple-marked-outline::before {\n  content: \"\\F0139\";\n}\n\n.mdi-checkbox-multiple-outline::before {\n  content: \"\\F0C51\";\n}\n\n.mdi-checkbox-outline::before {\n  content: \"\\F0C52\";\n}\n\n.mdi-checkerboard::before {\n  content: \"\\F013A\";\n}\n\n.mdi-checkerboard-minus::before {\n  content: \"\\F1202\";\n}\n\n.mdi-checkerboard-plus::before {\n  content: \"\\F1201\";\n}\n\n.mdi-checkerboard-remove::before {\n  content: \"\\F1203\";\n}\n\n.mdi-cheese::before {\n  content: \"\\F12B9\";\n}\n\n.mdi-cheese-off::before {\n  content: \"\\F13EE\";\n}\n\n.mdi-chef-hat::before {\n  content: \"\\F0B7C\";\n}\n\n.mdi-chemical-weapon::before {\n  content: \"\\F013B\";\n}\n\n.mdi-chess-bishop::before {\n  content: \"\\F085C\";\n}\n\n.mdi-chess-king::before {\n  content: \"\\F0857\";\n}\n\n.mdi-chess-knight::before {\n  content: \"\\F0858\";\n}\n\n.mdi-chess-pawn::before {\n  content: \"\\F0859\";\n}\n\n.mdi-chess-queen::before {\n  content: \"\\F085A\";\n}\n\n.mdi-chess-rook::before {\n  content: \"\\F085B\";\n}\n\n.mdi-chevron-double-down::before {\n  content: \"\\F013C\";\n}\n\n.mdi-chevron-double-left::before {\n  content: \"\\F013D\";\n}\n\n.mdi-chevron-double-right::before {\n  content: \"\\F013E\";\n}\n\n.mdi-chevron-double-up::before {\n  content: \"\\F013F\";\n}\n\n.mdi-chevron-down::before {\n  content: \"\\F0140\";\n}\n\n.mdi-chevron-down-box::before {\n  content: \"\\F09D6\";\n}\n\n.mdi-chevron-down-box-outline::before {\n  content: \"\\F09D7\";\n}\n\n.mdi-chevron-down-circle::before {\n  content: \"\\F0B26\";\n}\n\n.mdi-chevron-down-circle-outline::before {\n  content: \"\\F0B27\";\n}\n\n.mdi-chevron-left::before {\n  content: \"\\F0141\";\n}\n\n.mdi-chevron-left-box::before {\n  content: \"\\F09D8\";\n}\n\n.mdi-chevron-left-box-outline::before {\n  content: \"\\F09D9\";\n}\n\n.mdi-chevron-left-circle::before {\n  content: \"\\F0B28\";\n}\n\n.mdi-chevron-left-circle-outline::before {\n  content: \"\\F0B29\";\n}\n\n.mdi-chevron-right::before {\n  content: \"\\F0142\";\n}\n\n.mdi-chevron-right-box::before {\n  content: \"\\F09DA\";\n}\n\n.mdi-chevron-right-box-outline::before {\n  content: \"\\F09DB\";\n}\n\n.mdi-chevron-right-circle::before {\n  content: \"\\F0B2A\";\n}\n\n.mdi-chevron-right-circle-outline::before {\n  content: \"\\F0B2B\";\n}\n\n.mdi-chevron-triple-down::before {\n  content: \"\\F0DB9\";\n}\n\n.mdi-chevron-triple-left::before {\n  content: \"\\F0DBA\";\n}\n\n.mdi-chevron-triple-right::before {\n  content: \"\\F0DBB\";\n}\n\n.mdi-chevron-triple-up::before {\n  content: \"\\F0DBC\";\n}\n\n.mdi-chevron-up::before {\n  content: \"\\F0143\";\n}\n\n.mdi-chevron-up-box::before {\n  content: \"\\F09DC\";\n}\n\n.mdi-chevron-up-box-outline::before {\n  content: \"\\F09DD\";\n}\n\n.mdi-chevron-up-circle::before {\n  content: \"\\F0B2C\";\n}\n\n.mdi-chevron-up-circle-outline::before {\n  content: \"\\F0B2D\";\n}\n\n.mdi-chili-alert::before {\n  content: \"\\F17EA\";\n}\n\n.mdi-chili-alert-outline::before {\n  content: \"\\F17EB\";\n}\n\n.mdi-chili-hot::before {\n  content: \"\\F07B2\";\n}\n\n.mdi-chili-hot-outline::before {\n  content: \"\\F17EC\";\n}\n\n.mdi-chili-medium::before {\n  content: \"\\F07B3\";\n}\n\n.mdi-chili-medium-outline::before {\n  content: \"\\F17ED\";\n}\n\n.mdi-chili-mild::before {\n  content: \"\\F07B4\";\n}\n\n.mdi-chili-mild-outline::before {\n  content: \"\\F17EE\";\n}\n\n.mdi-chili-off::before {\n  content: \"\\F1467\";\n}\n\n.mdi-chili-off-outline::before {\n  content: \"\\F17EF\";\n}\n\n.mdi-chip::before {\n  content: \"\\F061A\";\n}\n\n.mdi-church::before {\n  content: \"\\F0144\";\n}\n\n.mdi-cigar::before {\n  content: \"\\F1189\";\n}\n\n.mdi-cigar-off::before {\n  content: \"\\F141B\";\n}\n\n.mdi-circle::before {\n  content: \"\\F0765\";\n}\n\n.mdi-circle-box::before {\n  content: \"\\F15DC\";\n}\n\n.mdi-circle-box-outline::before {\n  content: \"\\F15DD\";\n}\n\n.mdi-circle-double::before {\n  content: \"\\F0E95\";\n}\n\n.mdi-circle-edit-outline::before {\n  content: \"\\F08D5\";\n}\n\n.mdi-circle-expand::before {\n  content: \"\\F0E96\";\n}\n\n.mdi-circle-half::before {\n  content: \"\\F1395\";\n}\n\n.mdi-circle-half-full::before {\n  content: \"\\F1396\";\n}\n\n.mdi-circle-medium::before {\n  content: \"\\F09DE\";\n}\n\n.mdi-circle-multiple::before {\n  content: \"\\F0B38\";\n}\n\n.mdi-circle-multiple-outline::before {\n  content: \"\\F0695\";\n}\n\n.mdi-circle-off-outline::before {\n  content: \"\\F10D3\";\n}\n\n.mdi-circle-opacity::before {\n  content: \"\\F1853\";\n}\n\n.mdi-circle-outline::before {\n  content: \"\\F0766\";\n}\n\n.mdi-circle-slice-1::before {\n  content: \"\\F0A9E\";\n}\n\n.mdi-circle-slice-2::before {\n  content: \"\\F0A9F\";\n}\n\n.mdi-circle-slice-3::before {\n  content: \"\\F0AA0\";\n}\n\n.mdi-circle-slice-4::before {\n  content: \"\\F0AA1\";\n}\n\n.mdi-circle-slice-5::before {\n  content: \"\\F0AA2\";\n}\n\n.mdi-circle-slice-6::before {\n  content: \"\\F0AA3\";\n}\n\n.mdi-circle-slice-7::before {\n  content: \"\\F0AA4\";\n}\n\n.mdi-circle-slice-8::before {\n  content: \"\\F0AA5\";\n}\n\n.mdi-circle-small::before {\n  content: \"\\F09DF\";\n}\n\n.mdi-circular-saw::before {\n  content: \"\\F0E22\";\n}\n\n.mdi-city::before {\n  content: \"\\F0146\";\n}\n\n.mdi-city-variant::before {\n  content: \"\\F0A36\";\n}\n\n.mdi-city-variant-outline::before {\n  content: \"\\F0A37\";\n}\n\n.mdi-clipboard::before {\n  content: \"\\F0147\";\n}\n\n.mdi-clipboard-account::before {\n  content: \"\\F0148\";\n}\n\n.mdi-clipboard-account-outline::before {\n  content: \"\\F0C55\";\n}\n\n.mdi-clipboard-alert::before {\n  content: \"\\F0149\";\n}\n\n.mdi-clipboard-alert-outline::before {\n  content: \"\\F0CF7\";\n}\n\n.mdi-clipboard-arrow-down::before {\n  content: \"\\F014A\";\n}\n\n.mdi-clipboard-arrow-down-outline::before {\n  content: \"\\F0C56\";\n}\n\n.mdi-clipboard-arrow-left::before {\n  content: \"\\F014B\";\n}\n\n.mdi-clipboard-arrow-left-outline::before {\n  content: \"\\F0CF8\";\n}\n\n.mdi-clipboard-arrow-right::before {\n  content: \"\\F0CF9\";\n}\n\n.mdi-clipboard-arrow-right-outline::before {\n  content: \"\\F0CFA\";\n}\n\n.mdi-clipboard-arrow-up::before {\n  content: \"\\F0C57\";\n}\n\n.mdi-clipboard-arrow-up-outline::before {\n  content: \"\\F0C58\";\n}\n\n.mdi-clipboard-check::before {\n  content: \"\\F014E\";\n}\n\n.mdi-clipboard-check-multiple::before {\n  content: \"\\F1263\";\n}\n\n.mdi-clipboard-check-multiple-outline::before {\n  content: \"\\F1264\";\n}\n\n.mdi-clipboard-check-outline::before {\n  content: \"\\F08A8\";\n}\n\n.mdi-clipboard-clock::before {\n  content: \"\\F16E2\";\n}\n\n.mdi-clipboard-clock-outline::before {\n  content: \"\\F16E3\";\n}\n\n.mdi-clipboard-edit::before {\n  content: \"\\F14E5\";\n}\n\n.mdi-clipboard-edit-outline::before {\n  content: \"\\F14E6\";\n}\n\n.mdi-clipboard-file::before {\n  content: \"\\F1265\";\n}\n\n.mdi-clipboard-file-outline::before {\n  content: \"\\F1266\";\n}\n\n.mdi-clipboard-flow::before {\n  content: \"\\F06C8\";\n}\n\n.mdi-clipboard-flow-outline::before {\n  content: \"\\F1117\";\n}\n\n.mdi-clipboard-list::before {\n  content: \"\\F10D4\";\n}\n\n.mdi-clipboard-list-outline::before {\n  content: \"\\F10D5\";\n}\n\n.mdi-clipboard-minus::before {\n  content: \"\\F1618\";\n}\n\n.mdi-clipboard-minus-outline::before {\n  content: \"\\F1619\";\n}\n\n.mdi-clipboard-multiple::before {\n  content: \"\\F1267\";\n}\n\n.mdi-clipboard-multiple-outline::before {\n  content: \"\\F1268\";\n}\n\n.mdi-clipboard-off::before {\n  content: \"\\F161A\";\n}\n\n.mdi-clipboard-off-outline::before {\n  content: \"\\F161B\";\n}\n\n.mdi-clipboard-outline::before {\n  content: \"\\F014C\";\n}\n\n.mdi-clipboard-play::before {\n  content: \"\\F0C59\";\n}\n\n.mdi-clipboard-play-multiple::before {\n  content: \"\\F1269\";\n}\n\n.mdi-clipboard-play-multiple-outline::before {\n  content: \"\\F126A\";\n}\n\n.mdi-clipboard-play-outline::before {\n  content: \"\\F0C5A\";\n}\n\n.mdi-clipboard-plus::before {\n  content: \"\\F0751\";\n}\n\n.mdi-clipboard-plus-outline::before {\n  content: \"\\F131F\";\n}\n\n.mdi-clipboard-pulse::before {\n  content: \"\\F085D\";\n}\n\n.mdi-clipboard-pulse-outline::before {\n  content: \"\\F085E\";\n}\n\n.mdi-clipboard-remove::before {\n  content: \"\\F161C\";\n}\n\n.mdi-clipboard-remove-outline::before {\n  content: \"\\F161D\";\n}\n\n.mdi-clipboard-search::before {\n  content: \"\\F161E\";\n}\n\n.mdi-clipboard-search-outline::before {\n  content: \"\\F161F\";\n}\n\n.mdi-clipboard-text::before {\n  content: \"\\F014D\";\n}\n\n.mdi-clipboard-text-clock::before {\n  content: \"\\F18F9\";\n}\n\n.mdi-clipboard-text-clock-outline::before {\n  content: \"\\F18FA\";\n}\n\n.mdi-clipboard-text-multiple::before {\n  content: \"\\F126B\";\n}\n\n.mdi-clipboard-text-multiple-outline::before {\n  content: \"\\F126C\";\n}\n\n.mdi-clipboard-text-off::before {\n  content: \"\\F1620\";\n}\n\n.mdi-clipboard-text-off-outline::before {\n  content: \"\\F1621\";\n}\n\n.mdi-clipboard-text-outline::before {\n  content: \"\\F0A38\";\n}\n\n.mdi-clipboard-text-play::before {\n  content: \"\\F0C5B\";\n}\n\n.mdi-clipboard-text-play-outline::before {\n  content: \"\\F0C5C\";\n}\n\n.mdi-clipboard-text-search::before {\n  content: \"\\F1622\";\n}\n\n.mdi-clipboard-text-search-outline::before {\n  content: \"\\F1623\";\n}\n\n.mdi-clippy::before {\n  content: \"\\F014F\";\n}\n\n.mdi-clock::before {\n  content: \"\\F0954\";\n}\n\n.mdi-clock-alert::before {\n  content: \"\\F0955\";\n}\n\n.mdi-clock-alert-outline::before {\n  content: \"\\F05CE\";\n}\n\n.mdi-clock-check::before {\n  content: \"\\F0FA8\";\n}\n\n.mdi-clock-check-outline::before {\n  content: \"\\F0FA9\";\n}\n\n.mdi-clock-digital::before {\n  content: \"\\F0E97\";\n}\n\n.mdi-clock-edit::before {\n  content: \"\\F19BA\";\n}\n\n.mdi-clock-edit-outline::before {\n  content: \"\\F19BB\";\n}\n\n.mdi-clock-end::before {\n  content: \"\\F0151\";\n}\n\n.mdi-clock-fast::before {\n  content: \"\\F0152\";\n}\n\n.mdi-clock-in::before {\n  content: \"\\F0153\";\n}\n\n.mdi-clock-minus::before {\n  content: \"\\F1863\";\n}\n\n.mdi-clock-minus-outline::before {\n  content: \"\\F1864\";\n}\n\n.mdi-clock-out::before {\n  content: \"\\F0154\";\n}\n\n.mdi-clock-outline::before {\n  content: \"\\F0150\";\n}\n\n.mdi-clock-plus::before {\n  content: \"\\F1861\";\n}\n\n.mdi-clock-plus-outline::before {\n  content: \"\\F1862\";\n}\n\n.mdi-clock-remove::before {\n  content: \"\\F1865\";\n}\n\n.mdi-clock-remove-outline::before {\n  content: \"\\F1866\";\n}\n\n.mdi-clock-start::before {\n  content: \"\\F0155\";\n}\n\n.mdi-clock-time-eight::before {\n  content: \"\\F1446\";\n}\n\n.mdi-clock-time-eight-outline::before {\n  content: \"\\F1452\";\n}\n\n.mdi-clock-time-eleven::before {\n  content: \"\\F1449\";\n}\n\n.mdi-clock-time-eleven-outline::before {\n  content: \"\\F1455\";\n}\n\n.mdi-clock-time-five::before {\n  content: \"\\F1443\";\n}\n\n.mdi-clock-time-five-outline::before {\n  content: \"\\F144F\";\n}\n\n.mdi-clock-time-four::before {\n  content: \"\\F1442\";\n}\n\n.mdi-clock-time-four-outline::before {\n  content: \"\\F144E\";\n}\n\n.mdi-clock-time-nine::before {\n  content: \"\\F1447\";\n}\n\n.mdi-clock-time-nine-outline::before {\n  content: \"\\F1453\";\n}\n\n.mdi-clock-time-one::before {\n  content: \"\\F143F\";\n}\n\n.mdi-clock-time-one-outline::before {\n  content: \"\\F144B\";\n}\n\n.mdi-clock-time-seven::before {\n  content: \"\\F1445\";\n}\n\n.mdi-clock-time-seven-outline::before {\n  content: \"\\F1451\";\n}\n\n.mdi-clock-time-six::before {\n  content: \"\\F1444\";\n}\n\n.mdi-clock-time-six-outline::before {\n  content: \"\\F1450\";\n}\n\n.mdi-clock-time-ten::before {\n  content: \"\\F1448\";\n}\n\n.mdi-clock-time-ten-outline::before {\n  content: \"\\F1454\";\n}\n\n.mdi-clock-time-three::before {\n  content: \"\\F1441\";\n}\n\n.mdi-clock-time-three-outline::before {\n  content: \"\\F144D\";\n}\n\n.mdi-clock-time-twelve::before {\n  content: \"\\F144A\";\n}\n\n.mdi-clock-time-twelve-outline::before {\n  content: \"\\F1456\";\n}\n\n.mdi-clock-time-two::before {\n  content: \"\\F1440\";\n}\n\n.mdi-clock-time-two-outline::before {\n  content: \"\\F144C\";\n}\n\n.mdi-close::before {\n  content: \"\\F0156\";\n}\n\n.mdi-close-box::before {\n  content: \"\\F0157\";\n}\n\n.mdi-close-box-multiple::before {\n  content: \"\\F0C5D\";\n}\n\n.mdi-close-box-multiple-outline::before {\n  content: \"\\F0C5E\";\n}\n\n.mdi-close-box-outline::before {\n  content: \"\\F0158\";\n}\n\n.mdi-close-circle::before {\n  content: \"\\F0159\";\n}\n\n.mdi-close-circle-multiple::before {\n  content: \"\\F062A\";\n}\n\n.mdi-close-circle-multiple-outline::before {\n  content: \"\\F0883\";\n}\n\n.mdi-close-circle-outline::before {\n  content: \"\\F015A\";\n}\n\n.mdi-close-network::before {\n  content: \"\\F015B\";\n}\n\n.mdi-close-network-outline::before {\n  content: \"\\F0C5F\";\n}\n\n.mdi-close-octagon::before {\n  content: \"\\F015C\";\n}\n\n.mdi-close-octagon-outline::before {\n  content: \"\\F015D\";\n}\n\n.mdi-close-outline::before {\n  content: \"\\F06C9\";\n}\n\n.mdi-close-thick::before {\n  content: \"\\F1398\";\n}\n\n.mdi-closed-caption::before {\n  content: \"\\F015E\";\n}\n\n.mdi-closed-caption-outline::before {\n  content: \"\\F0DBD\";\n}\n\n.mdi-cloud::before {\n  content: \"\\F015F\";\n}\n\n.mdi-cloud-alert::before {\n  content: \"\\F09E0\";\n}\n\n.mdi-cloud-braces::before {\n  content: \"\\F07B5\";\n}\n\n.mdi-cloud-check::before {\n  content: \"\\F0160\";\n}\n\n.mdi-cloud-check-outline::before {\n  content: \"\\F12CC\";\n}\n\n.mdi-cloud-circle::before {\n  content: \"\\F0161\";\n}\n\n.mdi-cloud-download::before {\n  content: \"\\F0162\";\n}\n\n.mdi-cloud-download-outline::before {\n  content: \"\\F0B7D\";\n}\n\n.mdi-cloud-lock::before {\n  content: \"\\F11F1\";\n}\n\n.mdi-cloud-lock-outline::before {\n  content: \"\\F11F2\";\n}\n\n.mdi-cloud-off-outline::before {\n  content: \"\\F0164\";\n}\n\n.mdi-cloud-outline::before {\n  content: \"\\F0163\";\n}\n\n.mdi-cloud-print::before {\n  content: \"\\F0165\";\n}\n\n.mdi-cloud-print-outline::before {\n  content: \"\\F0166\";\n}\n\n.mdi-cloud-question::before {\n  content: \"\\F0A39\";\n}\n\n.mdi-cloud-refresh::before {\n  content: \"\\F052A\";\n}\n\n.mdi-cloud-search::before {\n  content: \"\\F0956\";\n}\n\n.mdi-cloud-search-outline::before {\n  content: \"\\F0957\";\n}\n\n.mdi-cloud-sync::before {\n  content: \"\\F063F\";\n}\n\n.mdi-cloud-sync-outline::before {\n  content: \"\\F12D6\";\n}\n\n.mdi-cloud-tags::before {\n  content: \"\\F07B6\";\n}\n\n.mdi-cloud-upload::before {\n  content: \"\\F0167\";\n}\n\n.mdi-cloud-upload-outline::before {\n  content: \"\\F0B7E\";\n}\n\n.mdi-clover::before {\n  content: \"\\F0816\";\n}\n\n.mdi-coach-lamp::before {\n  content: \"\\F1020\";\n}\n\n.mdi-coat-rack::before {\n  content: \"\\F109E\";\n}\n\n.mdi-code-array::before {\n  content: \"\\F0168\";\n}\n\n.mdi-code-braces::before {\n  content: \"\\F0169\";\n}\n\n.mdi-code-braces-box::before {\n  content: \"\\F10D6\";\n}\n\n.mdi-code-brackets::before {\n  content: \"\\F016A\";\n}\n\n.mdi-code-equal::before {\n  content: \"\\F016B\";\n}\n\n.mdi-code-greater-than::before {\n  content: \"\\F016C\";\n}\n\n.mdi-code-greater-than-or-equal::before {\n  content: \"\\F016D\";\n}\n\n.mdi-code-json::before {\n  content: \"\\F0626\";\n}\n\n.mdi-code-less-than::before {\n  content: \"\\F016E\";\n}\n\n.mdi-code-less-than-or-equal::before {\n  content: \"\\F016F\";\n}\n\n.mdi-code-not-equal::before {\n  content: \"\\F0170\";\n}\n\n.mdi-code-not-equal-variant::before {\n  content: \"\\F0171\";\n}\n\n.mdi-code-parentheses::before {\n  content: \"\\F0172\";\n}\n\n.mdi-code-parentheses-box::before {\n  content: \"\\F10D7\";\n}\n\n.mdi-code-string::before {\n  content: \"\\F0173\";\n}\n\n.mdi-code-tags::before {\n  content: \"\\F0174\";\n}\n\n.mdi-code-tags-check::before {\n  content: \"\\F0694\";\n}\n\n.mdi-codepen::before {\n  content: \"\\F0175\";\n}\n\n.mdi-coffee::before {\n  content: \"\\F0176\";\n}\n\n.mdi-coffee-maker::before {\n  content: \"\\F109F\";\n}\n\n.mdi-coffee-maker-check::before {\n  content: \"\\F1931\";\n}\n\n.mdi-coffee-maker-check-outline::before {\n  content: \"\\F1932\";\n}\n\n.mdi-coffee-maker-outline::before {\n  content: \"\\F181B\";\n}\n\n.mdi-coffee-off::before {\n  content: \"\\F0FAA\";\n}\n\n.mdi-coffee-off-outline::before {\n  content: \"\\F0FAB\";\n}\n\n.mdi-coffee-outline::before {\n  content: \"\\F06CA\";\n}\n\n.mdi-coffee-to-go::before {\n  content: \"\\F0177\";\n}\n\n.mdi-coffee-to-go-outline::before {\n  content: \"\\F130E\";\n}\n\n.mdi-coffin::before {\n  content: \"\\F0B7F\";\n}\n\n.mdi-cog::before {\n  content: \"\\F0493\";\n}\n\n.mdi-cog-box::before {\n  content: \"\\F0494\";\n}\n\n.mdi-cog-clockwise::before {\n  content: \"\\F11DD\";\n}\n\n.mdi-cog-counterclockwise::before {\n  content: \"\\F11DE\";\n}\n\n.mdi-cog-off::before {\n  content: \"\\F13CE\";\n}\n\n.mdi-cog-off-outline::before {\n  content: \"\\F13CF\";\n}\n\n.mdi-cog-outline::before {\n  content: \"\\F08BB\";\n}\n\n.mdi-cog-pause::before {\n  content: \"\\F1933\";\n}\n\n.mdi-cog-pause-outline::before {\n  content: \"\\F1934\";\n}\n\n.mdi-cog-play::before {\n  content: \"\\F1935\";\n}\n\n.mdi-cog-play-outline::before {\n  content: \"\\F1936\";\n}\n\n.mdi-cog-refresh::before {\n  content: \"\\F145E\";\n}\n\n.mdi-cog-refresh-outline::before {\n  content: \"\\F145F\";\n}\n\n.mdi-cog-stop::before {\n  content: \"\\F1937\";\n}\n\n.mdi-cog-stop-outline::before {\n  content: \"\\F1938\";\n}\n\n.mdi-cog-sync::before {\n  content: \"\\F1460\";\n}\n\n.mdi-cog-sync-outline::before {\n  content: \"\\F1461\";\n}\n\n.mdi-cog-transfer::before {\n  content: \"\\F105B\";\n}\n\n.mdi-cog-transfer-outline::before {\n  content: \"\\F105C\";\n}\n\n.mdi-cogs::before {\n  content: \"\\F08D6\";\n}\n\n.mdi-collage::before {\n  content: \"\\F0640\";\n}\n\n.mdi-collapse-all::before {\n  content: \"\\F0AA6\";\n}\n\n.mdi-collapse-all-outline::before {\n  content: \"\\F0AA7\";\n}\n\n.mdi-color-helper::before {\n  content: \"\\F0179\";\n}\n\n.mdi-comma::before {\n  content: \"\\F0E23\";\n}\n\n.mdi-comma-box::before {\n  content: \"\\F0E2B\";\n}\n\n.mdi-comma-box-outline::before {\n  content: \"\\F0E24\";\n}\n\n.mdi-comma-circle::before {\n  content: \"\\F0E25\";\n}\n\n.mdi-comma-circle-outline::before {\n  content: \"\\F0E26\";\n}\n\n.mdi-comment::before {\n  content: \"\\F017A\";\n}\n\n.mdi-comment-account::before {\n  content: \"\\F017B\";\n}\n\n.mdi-comment-account-outline::before {\n  content: \"\\F017C\";\n}\n\n.mdi-comment-alert::before {\n  content: \"\\F017D\";\n}\n\n.mdi-comment-alert-outline::before {\n  content: \"\\F017E\";\n}\n\n.mdi-comment-arrow-left::before {\n  content: \"\\F09E1\";\n}\n\n.mdi-comment-arrow-left-outline::before {\n  content: \"\\F09E2\";\n}\n\n.mdi-comment-arrow-right::before {\n  content: \"\\F09E3\";\n}\n\n.mdi-comment-arrow-right-outline::before {\n  content: \"\\F09E4\";\n}\n\n.mdi-comment-bookmark::before {\n  content: \"\\F15AE\";\n}\n\n.mdi-comment-bookmark-outline::before {\n  content: \"\\F15AF\";\n}\n\n.mdi-comment-check::before {\n  content: \"\\F017F\";\n}\n\n.mdi-comment-check-outline::before {\n  content: \"\\F0180\";\n}\n\n.mdi-comment-edit::before {\n  content: \"\\F11BF\";\n}\n\n.mdi-comment-edit-outline::before {\n  content: \"\\F12C4\";\n}\n\n.mdi-comment-eye::before {\n  content: \"\\F0A3A\";\n}\n\n.mdi-comment-eye-outline::before {\n  content: \"\\F0A3B\";\n}\n\n.mdi-comment-flash::before {\n  content: \"\\F15B0\";\n}\n\n.mdi-comment-flash-outline::before {\n  content: \"\\F15B1\";\n}\n\n.mdi-comment-minus::before {\n  content: \"\\F15DF\";\n}\n\n.mdi-comment-minus-outline::before {\n  content: \"\\F15E0\";\n}\n\n.mdi-comment-multiple::before {\n  content: \"\\F085F\";\n}\n\n.mdi-comment-multiple-outline::before {\n  content: \"\\F0181\";\n}\n\n.mdi-comment-off::before {\n  content: \"\\F15E1\";\n}\n\n.mdi-comment-off-outline::before {\n  content: \"\\F15E2\";\n}\n\n.mdi-comment-outline::before {\n  content: \"\\F0182\";\n}\n\n.mdi-comment-plus::before {\n  content: \"\\F09E5\";\n}\n\n.mdi-comment-plus-outline::before {\n  content: \"\\F0183\";\n}\n\n.mdi-comment-processing::before {\n  content: \"\\F0184\";\n}\n\n.mdi-comment-processing-outline::before {\n  content: \"\\F0185\";\n}\n\n.mdi-comment-question::before {\n  content: \"\\F0817\";\n}\n\n.mdi-comment-question-outline::before {\n  content: \"\\F0186\";\n}\n\n.mdi-comment-quote::before {\n  content: \"\\F1021\";\n}\n\n.mdi-comment-quote-outline::before {\n  content: \"\\F1022\";\n}\n\n.mdi-comment-remove::before {\n  content: \"\\F05DE\";\n}\n\n.mdi-comment-remove-outline::before {\n  content: \"\\F0187\";\n}\n\n.mdi-comment-search::before {\n  content: \"\\F0A3C\";\n}\n\n.mdi-comment-search-outline::before {\n  content: \"\\F0A3D\";\n}\n\n.mdi-comment-text::before {\n  content: \"\\F0188\";\n}\n\n.mdi-comment-text-multiple::before {\n  content: \"\\F0860\";\n}\n\n.mdi-comment-text-multiple-outline::before {\n  content: \"\\F0861\";\n}\n\n.mdi-comment-text-outline::before {\n  content: \"\\F0189\";\n}\n\n.mdi-compare::before {\n  content: \"\\F018A\";\n}\n\n.mdi-compare-horizontal::before {\n  content: \"\\F1492\";\n}\n\n.mdi-compare-remove::before {\n  content: \"\\F18B3\";\n}\n\n.mdi-compare-vertical::before {\n  content: \"\\F1493\";\n}\n\n.mdi-compass::before {\n  content: \"\\F018B\";\n}\n\n.mdi-compass-off::before {\n  content: \"\\F0B80\";\n}\n\n.mdi-compass-off-outline::before {\n  content: \"\\F0B81\";\n}\n\n.mdi-compass-outline::before {\n  content: \"\\F018C\";\n}\n\n.mdi-compass-rose::before {\n  content: \"\\F1382\";\n}\n\n.mdi-cone::before {\n  content: \"\\F194C\";\n}\n\n.mdi-cone-off::before {\n  content: \"\\F194D\";\n}\n\n.mdi-connection::before {\n  content: \"\\F1616\";\n}\n\n.mdi-console::before {\n  content: \"\\F018D\";\n}\n\n.mdi-console-line::before {\n  content: \"\\F07B7\";\n}\n\n.mdi-console-network::before {\n  content: \"\\F08A9\";\n}\n\n.mdi-console-network-outline::before {\n  content: \"\\F0C60\";\n}\n\n.mdi-consolidate::before {\n  content: \"\\F10D8\";\n}\n\n.mdi-contactless-payment::before {\n  content: \"\\F0D6A\";\n}\n\n.mdi-contactless-payment-circle::before {\n  content: \"\\F0321\";\n}\n\n.mdi-contactless-payment-circle-outline::before {\n  content: \"\\F0408\";\n}\n\n.mdi-contacts::before {\n  content: \"\\F06CB\";\n}\n\n.mdi-contacts-outline::before {\n  content: \"\\F05B8\";\n}\n\n.mdi-contain::before {\n  content: \"\\F0A3E\";\n}\n\n.mdi-contain-end::before {\n  content: \"\\F0A3F\";\n}\n\n.mdi-contain-start::before {\n  content: \"\\F0A40\";\n}\n\n.mdi-content-copy::before {\n  content: \"\\F018F\";\n}\n\n.mdi-content-cut::before {\n  content: \"\\F0190\";\n}\n\n.mdi-content-duplicate::before {\n  content: \"\\F0191\";\n}\n\n.mdi-content-paste::before {\n  content: \"\\F0192\";\n}\n\n.mdi-content-save::before {\n  content: \"\\F0193\";\n}\n\n.mdi-content-save-alert::before {\n  content: \"\\F0F42\";\n}\n\n.mdi-content-save-alert-outline::before {\n  content: \"\\F0F43\";\n}\n\n.mdi-content-save-all::before {\n  content: \"\\F0194\";\n}\n\n.mdi-content-save-all-outline::before {\n  content: \"\\F0F44\";\n}\n\n.mdi-content-save-check::before {\n  content: \"\\F18EA\";\n}\n\n.mdi-content-save-check-outline::before {\n  content: \"\\F18EB\";\n}\n\n.mdi-content-save-cog::before {\n  content: \"\\F145B\";\n}\n\n.mdi-content-save-cog-outline::before {\n  content: \"\\F145C\";\n}\n\n.mdi-content-save-edit::before {\n  content: \"\\F0CFB\";\n}\n\n.mdi-content-save-edit-outline::before {\n  content: \"\\F0CFC\";\n}\n\n.mdi-content-save-move::before {\n  content: \"\\F0E27\";\n}\n\n.mdi-content-save-move-outline::before {\n  content: \"\\F0E28\";\n}\n\n.mdi-content-save-off::before {\n  content: \"\\F1643\";\n}\n\n.mdi-content-save-off-outline::before {\n  content: \"\\F1644\";\n}\n\n.mdi-content-save-outline::before {\n  content: \"\\F0818\";\n}\n\n.mdi-content-save-settings::before {\n  content: \"\\F061B\";\n}\n\n.mdi-content-save-settings-outline::before {\n  content: \"\\F0B2E\";\n}\n\n.mdi-contrast::before {\n  content: \"\\F0195\";\n}\n\n.mdi-contrast-box::before {\n  content: \"\\F0196\";\n}\n\n.mdi-contrast-circle::before {\n  content: \"\\F0197\";\n}\n\n.mdi-controller-classic::before {\n  content: \"\\F0B82\";\n}\n\n.mdi-controller-classic-outline::before {\n  content: \"\\F0B83\";\n}\n\n.mdi-cookie::before {\n  content: \"\\F0198\";\n}\n\n.mdi-cookie-alert::before {\n  content: \"\\F16D0\";\n}\n\n.mdi-cookie-alert-outline::before {\n  content: \"\\F16D1\";\n}\n\n.mdi-cookie-check::before {\n  content: \"\\F16D2\";\n}\n\n.mdi-cookie-check-outline::before {\n  content: \"\\F16D3\";\n}\n\n.mdi-cookie-clock::before {\n  content: \"\\F16E4\";\n}\n\n.mdi-cookie-clock-outline::before {\n  content: \"\\F16E5\";\n}\n\n.mdi-cookie-cog::before {\n  content: \"\\F16D4\";\n}\n\n.mdi-cookie-cog-outline::before {\n  content: \"\\F16D5\";\n}\n\n.mdi-cookie-edit::before {\n  content: \"\\F16E6\";\n}\n\n.mdi-cookie-edit-outline::before {\n  content: \"\\F16E7\";\n}\n\n.mdi-cookie-lock::before {\n  content: \"\\F16E8\";\n}\n\n.mdi-cookie-lock-outline::before {\n  content: \"\\F16E9\";\n}\n\n.mdi-cookie-minus::before {\n  content: \"\\F16DA\";\n}\n\n.mdi-cookie-minus-outline::before {\n  content: \"\\F16DB\";\n}\n\n.mdi-cookie-off::before {\n  content: \"\\F16EA\";\n}\n\n.mdi-cookie-off-outline::before {\n  content: \"\\F16EB\";\n}\n\n.mdi-cookie-outline::before {\n  content: \"\\F16DE\";\n}\n\n.mdi-cookie-plus::before {\n  content: \"\\F16D6\";\n}\n\n.mdi-cookie-plus-outline::before {\n  content: \"\\F16D7\";\n}\n\n.mdi-cookie-refresh::before {\n  content: \"\\F16EC\";\n}\n\n.mdi-cookie-refresh-outline::before {\n  content: \"\\F16ED\";\n}\n\n.mdi-cookie-remove::before {\n  content: \"\\F16D8\";\n}\n\n.mdi-cookie-remove-outline::before {\n  content: \"\\F16D9\";\n}\n\n.mdi-cookie-settings::before {\n  content: \"\\F16DC\";\n}\n\n.mdi-cookie-settings-outline::before {\n  content: \"\\F16DD\";\n}\n\n.mdi-coolant-temperature::before {\n  content: \"\\F03C8\";\n}\n\n.mdi-copyleft::before {\n  content: \"\\F1939\";\n}\n\n.mdi-copyright::before {\n  content: \"\\F05E6\";\n}\n\n.mdi-cordova::before {\n  content: \"\\F0958\";\n}\n\n.mdi-corn::before {\n  content: \"\\F07B8\";\n}\n\n.mdi-corn-off::before {\n  content: \"\\F13EF\";\n}\n\n.mdi-cosine-wave::before {\n  content: \"\\F1479\";\n}\n\n.mdi-counter::before {\n  content: \"\\F0199\";\n}\n\n.mdi-countertop::before {\n  content: \"\\F181C\";\n}\n\n.mdi-countertop-outline::before {\n  content: \"\\F181D\";\n}\n\n.mdi-cow::before {\n  content: \"\\F019A\";\n}\n\n.mdi-cow-off::before {\n  content: \"\\F18FC\";\n}\n\n.mdi-cpu-32-bit::before {\n  content: \"\\F0EDF\";\n}\n\n.mdi-cpu-64-bit::before {\n  content: \"\\F0EE0\";\n}\n\n.mdi-cradle::before {\n  content: \"\\F198B\";\n}\n\n.mdi-cradle-outline::before {\n  content: \"\\F1991\";\n}\n\n.mdi-crane::before {\n  content: \"\\F0862\";\n}\n\n.mdi-creation::before {\n  content: \"\\F0674\";\n}\n\n.mdi-creative-commons::before {\n  content: \"\\F0D6B\";\n}\n\n.mdi-credit-card::before {\n  content: \"\\F0FEF\";\n}\n\n.mdi-credit-card-check::before {\n  content: \"\\F13D0\";\n}\n\n.mdi-credit-card-check-outline::before {\n  content: \"\\F13D1\";\n}\n\n.mdi-credit-card-chip::before {\n  content: \"\\F190F\";\n}\n\n.mdi-credit-card-chip-outline::before {\n  content: \"\\F1910\";\n}\n\n.mdi-credit-card-clock::before {\n  content: \"\\F0EE1\";\n}\n\n.mdi-credit-card-clock-outline::before {\n  content: \"\\F0EE2\";\n}\n\n.mdi-credit-card-edit::before {\n  content: \"\\F17D7\";\n}\n\n.mdi-credit-card-edit-outline::before {\n  content: \"\\F17D8\";\n}\n\n.mdi-credit-card-fast::before {\n  content: \"\\F1911\";\n}\n\n.mdi-credit-card-fast-outline::before {\n  content: \"\\F1912\";\n}\n\n.mdi-credit-card-lock::before {\n  content: \"\\F18E7\";\n}\n\n.mdi-credit-card-lock-outline::before {\n  content: \"\\F18E8\";\n}\n\n.mdi-credit-card-marker::before {\n  content: \"\\F06A8\";\n}\n\n.mdi-credit-card-marker-outline::before {\n  content: \"\\F0DBE\";\n}\n\n.mdi-credit-card-minus::before {\n  content: \"\\F0FAC\";\n}\n\n.mdi-credit-card-minus-outline::before {\n  content: \"\\F0FAD\";\n}\n\n.mdi-credit-card-multiple::before {\n  content: \"\\F0FF0\";\n}\n\n.mdi-credit-card-multiple-outline::before {\n  content: \"\\F019C\";\n}\n\n.mdi-credit-card-off::before {\n  content: \"\\F0FF1\";\n}\n\n.mdi-credit-card-off-outline::before {\n  content: \"\\F05E4\";\n}\n\n.mdi-credit-card-outline::before {\n  content: \"\\F019B\";\n}\n\n.mdi-credit-card-plus::before {\n  content: \"\\F0FF2\";\n}\n\n.mdi-credit-card-plus-outline::before {\n  content: \"\\F0676\";\n}\n\n.mdi-credit-card-refresh::before {\n  content: \"\\F1645\";\n}\n\n.mdi-credit-card-refresh-outline::before {\n  content: \"\\F1646\";\n}\n\n.mdi-credit-card-refund::before {\n  content: \"\\F0FF3\";\n}\n\n.mdi-credit-card-refund-outline::before {\n  content: \"\\F0AA8\";\n}\n\n.mdi-credit-card-remove::before {\n  content: \"\\F0FAE\";\n}\n\n.mdi-credit-card-remove-outline::before {\n  content: \"\\F0FAF\";\n}\n\n.mdi-credit-card-scan::before {\n  content: \"\\F0FF4\";\n}\n\n.mdi-credit-card-scan-outline::before {\n  content: \"\\F019D\";\n}\n\n.mdi-credit-card-search::before {\n  content: \"\\F1647\";\n}\n\n.mdi-credit-card-search-outline::before {\n  content: \"\\F1648\";\n}\n\n.mdi-credit-card-settings::before {\n  content: \"\\F0FF5\";\n}\n\n.mdi-credit-card-settings-outline::before {\n  content: \"\\F08D7\";\n}\n\n.mdi-credit-card-sync::before {\n  content: \"\\F1649\";\n}\n\n.mdi-credit-card-sync-outline::before {\n  content: \"\\F164A\";\n}\n\n.mdi-credit-card-wireless::before {\n  content: \"\\F0802\";\n}\n\n.mdi-credit-card-wireless-off::before {\n  content: \"\\F057A\";\n}\n\n.mdi-credit-card-wireless-off-outline::before {\n  content: \"\\F057B\";\n}\n\n.mdi-credit-card-wireless-outline::before {\n  content: \"\\F0D6C\";\n}\n\n.mdi-cricket::before {\n  content: \"\\F0D6D\";\n}\n\n.mdi-crop::before {\n  content: \"\\F019E\";\n}\n\n.mdi-crop-free::before {\n  content: \"\\F019F\";\n}\n\n.mdi-crop-landscape::before {\n  content: \"\\F01A0\";\n}\n\n.mdi-crop-portrait::before {\n  content: \"\\F01A1\";\n}\n\n.mdi-crop-rotate::before {\n  content: \"\\F0696\";\n}\n\n.mdi-crop-square::before {\n  content: \"\\F01A2\";\n}\n\n.mdi-cross::before {\n  content: \"\\F0953\";\n}\n\n.mdi-cross-bolnisi::before {\n  content: \"\\F0CED\";\n}\n\n.mdi-cross-celtic::before {\n  content: \"\\F0CF5\";\n}\n\n.mdi-cross-outline::before {\n  content: \"\\F0CF6\";\n}\n\n.mdi-crosshairs::before {\n  content: \"\\F01A3\";\n}\n\n.mdi-crosshairs-gps::before {\n  content: \"\\F01A4\";\n}\n\n.mdi-crosshairs-off::before {\n  content: \"\\F0F45\";\n}\n\n.mdi-crosshairs-question::before {\n  content: \"\\F1136\";\n}\n\n.mdi-crowd::before {\n  content: \"\\F1975\";\n}\n\n.mdi-crown::before {\n  content: \"\\F01A5\";\n}\n\n.mdi-crown-circle::before {\n  content: \"\\F17DC\";\n}\n\n.mdi-crown-circle-outline::before {\n  content: \"\\F17DD\";\n}\n\n.mdi-crown-outline::before {\n  content: \"\\F11D0\";\n}\n\n.mdi-cryengine::before {\n  content: \"\\F0959\";\n}\n\n.mdi-crystal-ball::before {\n  content: \"\\F0B2F\";\n}\n\n.mdi-cube::before {\n  content: \"\\F01A6\";\n}\n\n.mdi-cube-off::before {\n  content: \"\\F141C\";\n}\n\n.mdi-cube-off-outline::before {\n  content: \"\\F141D\";\n}\n\n.mdi-cube-outline::before {\n  content: \"\\F01A7\";\n}\n\n.mdi-cube-scan::before {\n  content: \"\\F0B84\";\n}\n\n.mdi-cube-send::before {\n  content: \"\\F01A8\";\n}\n\n.mdi-cube-unfolded::before {\n  content: \"\\F01A9\";\n}\n\n.mdi-cup::before {\n  content: \"\\F01AA\";\n}\n\n.mdi-cup-off::before {\n  content: \"\\F05E5\";\n}\n\n.mdi-cup-off-outline::before {\n  content: \"\\F137D\";\n}\n\n.mdi-cup-outline::before {\n  content: \"\\F130F\";\n}\n\n.mdi-cup-water::before {\n  content: \"\\F01AB\";\n}\n\n.mdi-cupboard::before {\n  content: \"\\F0F46\";\n}\n\n.mdi-cupboard-outline::before {\n  content: \"\\F0F47\";\n}\n\n.mdi-cupcake::before {\n  content: \"\\F095A\";\n}\n\n.mdi-curling::before {\n  content: \"\\F0863\";\n}\n\n.mdi-currency-bdt::before {\n  content: \"\\F0864\";\n}\n\n.mdi-currency-brl::before {\n  content: \"\\F0B85\";\n}\n\n.mdi-currency-btc::before {\n  content: \"\\F01AC\";\n}\n\n.mdi-currency-cny::before {\n  content: \"\\F07BA\";\n}\n\n.mdi-currency-eth::before {\n  content: \"\\F07BB\";\n}\n\n.mdi-currency-eur::before {\n  content: \"\\F01AD\";\n}\n\n.mdi-currency-eur-off::before {\n  content: \"\\F1315\";\n}\n\n.mdi-currency-gbp::before {\n  content: \"\\F01AE\";\n}\n\n.mdi-currency-ils::before {\n  content: \"\\F0C61\";\n}\n\n.mdi-currency-inr::before {\n  content: \"\\F01AF\";\n}\n\n.mdi-currency-jpy::before {\n  content: \"\\F07BC\";\n}\n\n.mdi-currency-krw::before {\n  content: \"\\F07BD\";\n}\n\n.mdi-currency-kzt::before {\n  content: \"\\F0865\";\n}\n\n.mdi-currency-mnt::before {\n  content: \"\\F1512\";\n}\n\n.mdi-currency-ngn::before {\n  content: \"\\F01B0\";\n}\n\n.mdi-currency-php::before {\n  content: \"\\F09E6\";\n}\n\n.mdi-currency-rial::before {\n  content: \"\\F0E9C\";\n}\n\n.mdi-currency-rub::before {\n  content: \"\\F01B1\";\n}\n\n.mdi-currency-rupee::before {\n  content: \"\\F1976\";\n}\n\n.mdi-currency-sign::before {\n  content: \"\\F07BE\";\n}\n\n.mdi-currency-try::before {\n  content: \"\\F01B2\";\n}\n\n.mdi-currency-twd::before {\n  content: \"\\F07BF\";\n}\n\n.mdi-currency-usd::before {\n  content: \"\\F01C1\";\n}\n\n.mdi-currency-usd-off::before {\n  content: \"\\F067A\";\n}\n\n.mdi-current-ac::before {\n  content: \"\\F1480\";\n}\n\n.mdi-current-dc::before {\n  content: \"\\F095C\";\n}\n\n.mdi-cursor-default::before {\n  content: \"\\F01C0\";\n}\n\n.mdi-cursor-default-click::before {\n  content: \"\\F0CFD\";\n}\n\n.mdi-cursor-default-click-outline::before {\n  content: \"\\F0CFE\";\n}\n\n.mdi-cursor-default-gesture::before {\n  content: \"\\F1127\";\n}\n\n.mdi-cursor-default-gesture-outline::before {\n  content: \"\\F1128\";\n}\n\n.mdi-cursor-default-outline::before {\n  content: \"\\F01BF\";\n}\n\n.mdi-cursor-move::before {\n  content: \"\\F01BE\";\n}\n\n.mdi-cursor-pointer::before {\n  content: \"\\F01BD\";\n}\n\n.mdi-cursor-text::before {\n  content: \"\\F05E7\";\n}\n\n.mdi-curtains::before {\n  content: \"\\F1846\";\n}\n\n.mdi-curtains-closed::before {\n  content: \"\\F1847\";\n}\n\n.mdi-cylinder::before {\n  content: \"\\F194E\";\n}\n\n.mdi-cylinder-off::before {\n  content: \"\\F194F\";\n}\n\n.mdi-dance-ballroom::before {\n  content: \"\\F15FB\";\n}\n\n.mdi-dance-pole::before {\n  content: \"\\F1578\";\n}\n\n.mdi-data-matrix::before {\n  content: \"\\F153C\";\n}\n\n.mdi-data-matrix-edit::before {\n  content: \"\\F153D\";\n}\n\n.mdi-data-matrix-minus::before {\n  content: \"\\F153E\";\n}\n\n.mdi-data-matrix-plus::before {\n  content: \"\\F153F\";\n}\n\n.mdi-data-matrix-remove::before {\n  content: \"\\F1540\";\n}\n\n.mdi-data-matrix-scan::before {\n  content: \"\\F1541\";\n}\n\n.mdi-database::before {\n  content: \"\\F01BC\";\n}\n\n.mdi-database-alert::before {\n  content: \"\\F163A\";\n}\n\n.mdi-database-alert-outline::before {\n  content: \"\\F1624\";\n}\n\n.mdi-database-arrow-down::before {\n  content: \"\\F163B\";\n}\n\n.mdi-database-arrow-down-outline::before {\n  content: \"\\F1625\";\n}\n\n.mdi-database-arrow-left::before {\n  content: \"\\F163C\";\n}\n\n.mdi-database-arrow-left-outline::before {\n  content: \"\\F1626\";\n}\n\n.mdi-database-arrow-right::before {\n  content: \"\\F163D\";\n}\n\n.mdi-database-arrow-right-outline::before {\n  content: \"\\F1627\";\n}\n\n.mdi-database-arrow-up::before {\n  content: \"\\F163E\";\n}\n\n.mdi-database-arrow-up-outline::before {\n  content: \"\\F1628\";\n}\n\n.mdi-database-check::before {\n  content: \"\\F0AA9\";\n}\n\n.mdi-database-check-outline::before {\n  content: \"\\F1629\";\n}\n\n.mdi-database-clock::before {\n  content: \"\\F163F\";\n}\n\n.mdi-database-clock-outline::before {\n  content: \"\\F162A\";\n}\n\n.mdi-database-cog::before {\n  content: \"\\F164B\";\n}\n\n.mdi-database-cog-outline::before {\n  content: \"\\F164C\";\n}\n\n.mdi-database-edit::before {\n  content: \"\\F0B86\";\n}\n\n.mdi-database-edit-outline::before {\n  content: \"\\F162B\";\n}\n\n.mdi-database-export::before {\n  content: \"\\F095E\";\n}\n\n.mdi-database-export-outline::before {\n  content: \"\\F162C\";\n}\n\n.mdi-database-eye::before {\n  content: \"\\F191F\";\n}\n\n.mdi-database-eye-off::before {\n  content: \"\\F1920\";\n}\n\n.mdi-database-eye-off-outline::before {\n  content: \"\\F1921\";\n}\n\n.mdi-database-eye-outline::before {\n  content: \"\\F1922\";\n}\n\n.mdi-database-import::before {\n  content: \"\\F095D\";\n}\n\n.mdi-database-import-outline::before {\n  content: \"\\F162D\";\n}\n\n.mdi-database-lock::before {\n  content: \"\\F0AAA\";\n}\n\n.mdi-database-lock-outline::before {\n  content: \"\\F162E\";\n}\n\n.mdi-database-marker::before {\n  content: \"\\F12F6\";\n}\n\n.mdi-database-marker-outline::before {\n  content: \"\\F162F\";\n}\n\n.mdi-database-minus::before {\n  content: \"\\F01BB\";\n}\n\n.mdi-database-minus-outline::before {\n  content: \"\\F1630\";\n}\n\n.mdi-database-off::before {\n  content: \"\\F1640\";\n}\n\n.mdi-database-off-outline::before {\n  content: \"\\F1631\";\n}\n\n.mdi-database-outline::before {\n  content: \"\\F1632\";\n}\n\n.mdi-database-plus::before {\n  content: \"\\F01BA\";\n}\n\n.mdi-database-plus-outline::before {\n  content: \"\\F1633\";\n}\n\n.mdi-database-refresh::before {\n  content: \"\\F05C2\";\n}\n\n.mdi-database-refresh-outline::before {\n  content: \"\\F1634\";\n}\n\n.mdi-database-remove::before {\n  content: \"\\F0D00\";\n}\n\n.mdi-database-remove-outline::before {\n  content: \"\\F1635\";\n}\n\n.mdi-database-search::before {\n  content: \"\\F0866\";\n}\n\n.mdi-database-search-outline::before {\n  content: \"\\F1636\";\n}\n\n.mdi-database-settings::before {\n  content: \"\\F0D01\";\n}\n\n.mdi-database-settings-outline::before {\n  content: \"\\F1637\";\n}\n\n.mdi-database-sync::before {\n  content: \"\\F0CFF\";\n}\n\n.mdi-database-sync-outline::before {\n  content: \"\\F1638\";\n}\n\n.mdi-death-star::before {\n  content: \"\\F08D8\";\n}\n\n.mdi-death-star-variant::before {\n  content: \"\\F08D9\";\n}\n\n.mdi-deathly-hallows::before {\n  content: \"\\F0B87\";\n}\n\n.mdi-debian::before {\n  content: \"\\F08DA\";\n}\n\n.mdi-debug-step-into::before {\n  content: \"\\F01B9\";\n}\n\n.mdi-debug-step-out::before {\n  content: \"\\F01B8\";\n}\n\n.mdi-debug-step-over::before {\n  content: \"\\F01B7\";\n}\n\n.mdi-decagram::before {\n  content: \"\\F076C\";\n}\n\n.mdi-decagram-outline::before {\n  content: \"\\F076D\";\n}\n\n.mdi-decimal::before {\n  content: \"\\F10A1\";\n}\n\n.mdi-decimal-comma::before {\n  content: \"\\F10A2\";\n}\n\n.mdi-decimal-comma-decrease::before {\n  content: \"\\F10A3\";\n}\n\n.mdi-decimal-comma-increase::before {\n  content: \"\\F10A4\";\n}\n\n.mdi-decimal-decrease::before {\n  content: \"\\F01B6\";\n}\n\n.mdi-decimal-increase::before {\n  content: \"\\F01B5\";\n}\n\n.mdi-delete::before {\n  content: \"\\F01B4\";\n}\n\n.mdi-delete-alert::before {\n  content: \"\\F10A5\";\n}\n\n.mdi-delete-alert-outline::before {\n  content: \"\\F10A6\";\n}\n\n.mdi-delete-circle::before {\n  content: \"\\F0683\";\n}\n\n.mdi-delete-circle-outline::before {\n  content: \"\\F0B88\";\n}\n\n.mdi-delete-clock::before {\n  content: \"\\F1556\";\n}\n\n.mdi-delete-clock-outline::before {\n  content: \"\\F1557\";\n}\n\n.mdi-delete-empty::before {\n  content: \"\\F06CC\";\n}\n\n.mdi-delete-empty-outline::before {\n  content: \"\\F0E9D\";\n}\n\n.mdi-delete-forever::before {\n  content: \"\\F05E8\";\n}\n\n.mdi-delete-forever-outline::before {\n  content: \"\\F0B89\";\n}\n\n.mdi-delete-off::before {\n  content: \"\\F10A7\";\n}\n\n.mdi-delete-off-outline::before {\n  content: \"\\F10A8\";\n}\n\n.mdi-delete-outline::before {\n  content: \"\\F09E7\";\n}\n\n.mdi-delete-restore::before {\n  content: \"\\F0819\";\n}\n\n.mdi-delete-sweep::before {\n  content: \"\\F05E9\";\n}\n\n.mdi-delete-sweep-outline::before {\n  content: \"\\F0C62\";\n}\n\n.mdi-delete-variant::before {\n  content: \"\\F01B3\";\n}\n\n.mdi-delta::before {\n  content: \"\\F01C2\";\n}\n\n.mdi-desk::before {\n  content: \"\\F1239\";\n}\n\n.mdi-desk-lamp::before {\n  content: \"\\F095F\";\n}\n\n.mdi-deskphone::before {\n  content: \"\\F01C3\";\n}\n\n.mdi-desktop-classic::before {\n  content: \"\\F07C0\";\n}\n\n.mdi-desktop-mac::before {\n  content: \"\\F01C4\";\n}\n\n.mdi-desktop-mac-dashboard::before {\n  content: \"\\F09E8\";\n}\n\n.mdi-desktop-tower::before {\n  content: \"\\F01C5\";\n}\n\n.mdi-desktop-tower-monitor::before {\n  content: \"\\F0AAB\";\n}\n\n.mdi-details::before {\n  content: \"\\F01C6\";\n}\n\n.mdi-dev-to::before {\n  content: \"\\F0D6E\";\n}\n\n.mdi-developer-board::before {\n  content: \"\\F0697\";\n}\n\n.mdi-deviantart::before {\n  content: \"\\F01C7\";\n}\n\n.mdi-devices::before {\n  content: \"\\F0FB0\";\n}\n\n.mdi-dharmachakra::before {\n  content: \"\\F094B\";\n}\n\n.mdi-diabetes::before {\n  content: \"\\F1126\";\n}\n\n.mdi-dialpad::before {\n  content: \"\\F061C\";\n}\n\n.mdi-diameter::before {\n  content: \"\\F0C63\";\n}\n\n.mdi-diameter-outline::before {\n  content: \"\\F0C64\";\n}\n\n.mdi-diameter-variant::before {\n  content: \"\\F0C65\";\n}\n\n.mdi-diamond::before {\n  content: \"\\F0B8A\";\n}\n\n.mdi-diamond-outline::before {\n  content: \"\\F0B8B\";\n}\n\n.mdi-diamond-stone::before {\n  content: \"\\F01C8\";\n}\n\n.mdi-dice-1::before {\n  content: \"\\F01CA\";\n}\n\n.mdi-dice-1-outline::before {\n  content: \"\\F114A\";\n}\n\n.mdi-dice-2::before {\n  content: \"\\F01CB\";\n}\n\n.mdi-dice-2-outline::before {\n  content: \"\\F114B\";\n}\n\n.mdi-dice-3::before {\n  content: \"\\F01CC\";\n}\n\n.mdi-dice-3-outline::before {\n  content: \"\\F114C\";\n}\n\n.mdi-dice-4::before {\n  content: \"\\F01CD\";\n}\n\n.mdi-dice-4-outline::before {\n  content: \"\\F114D\";\n}\n\n.mdi-dice-5::before {\n  content: \"\\F01CE\";\n}\n\n.mdi-dice-5-outline::before {\n  content: \"\\F114E\";\n}\n\n.mdi-dice-6::before {\n  content: \"\\F01CF\";\n}\n\n.mdi-dice-6-outline::before {\n  content: \"\\F114F\";\n}\n\n.mdi-dice-d10::before {\n  content: \"\\F1153\";\n}\n\n.mdi-dice-d10-outline::before {\n  content: \"\\F076F\";\n}\n\n.mdi-dice-d12::before {\n  content: \"\\F1154\";\n}\n\n.mdi-dice-d12-outline::before {\n  content: \"\\F0867\";\n}\n\n.mdi-dice-d20::before {\n  content: \"\\F1155\";\n}\n\n.mdi-dice-d20-outline::before {\n  content: \"\\F05EA\";\n}\n\n.mdi-dice-d4::before {\n  content: \"\\F1150\";\n}\n\n.mdi-dice-d4-outline::before {\n  content: \"\\F05EB\";\n}\n\n.mdi-dice-d6::before {\n  content: \"\\F1151\";\n}\n\n.mdi-dice-d6-outline::before {\n  content: \"\\F05ED\";\n}\n\n.mdi-dice-d8::before {\n  content: \"\\F1152\";\n}\n\n.mdi-dice-d8-outline::before {\n  content: \"\\F05EC\";\n}\n\n.mdi-dice-multiple::before {\n  content: \"\\F076E\";\n}\n\n.mdi-dice-multiple-outline::before {\n  content: \"\\F1156\";\n}\n\n.mdi-digital-ocean::before {\n  content: \"\\F1237\";\n}\n\n.mdi-dip-switch::before {\n  content: \"\\F07C1\";\n}\n\n.mdi-directions::before {\n  content: \"\\F01D0\";\n}\n\n.mdi-directions-fork::before {\n  content: \"\\F0641\";\n}\n\n.mdi-disc::before {\n  content: \"\\F05EE\";\n}\n\n.mdi-disc-alert::before {\n  content: \"\\F01D1\";\n}\n\n.mdi-disc-player::before {\n  content: \"\\F0960\";\n}\n\n.mdi-discord::before {\n  content: \"\\F066F\";\n}\n\n.mdi-dishwasher::before {\n  content: \"\\F0AAC\";\n}\n\n.mdi-dishwasher-alert::before {\n  content: \"\\F11B8\";\n}\n\n.mdi-dishwasher-off::before {\n  content: \"\\F11B9\";\n}\n\n.mdi-disqus::before {\n  content: \"\\F01D2\";\n}\n\n.mdi-distribute-horizontal-center::before {\n  content: \"\\F11C9\";\n}\n\n.mdi-distribute-horizontal-left::before {\n  content: \"\\F11C8\";\n}\n\n.mdi-distribute-horizontal-right::before {\n  content: \"\\F11CA\";\n}\n\n.mdi-distribute-vertical-bottom::before {\n  content: \"\\F11CB\";\n}\n\n.mdi-distribute-vertical-center::before {\n  content: \"\\F11CC\";\n}\n\n.mdi-distribute-vertical-top::before {\n  content: \"\\F11CD\";\n}\n\n.mdi-diversify::before {\n  content: \"\\F1877\";\n}\n\n.mdi-diving::before {\n  content: \"\\F1977\";\n}\n\n.mdi-diving-flippers::before {\n  content: \"\\F0DBF\";\n}\n\n.mdi-diving-helmet::before {\n  content: \"\\F0DC0\";\n}\n\n.mdi-diving-scuba::before {\n  content: \"\\F0DC1\";\n}\n\n.mdi-diving-scuba-flag::before {\n  content: \"\\F0DC2\";\n}\n\n.mdi-diving-scuba-tank::before {\n  content: \"\\F0DC3\";\n}\n\n.mdi-diving-scuba-tank-multiple::before {\n  content: \"\\F0DC4\";\n}\n\n.mdi-diving-snorkel::before {\n  content: \"\\F0DC5\";\n}\n\n.mdi-division::before {\n  content: \"\\F01D4\";\n}\n\n.mdi-division-box::before {\n  content: \"\\F01D5\";\n}\n\n.mdi-dlna::before {\n  content: \"\\F0A41\";\n}\n\n.mdi-dna::before {\n  content: \"\\F0684\";\n}\n\n.mdi-dns::before {\n  content: \"\\F01D6\";\n}\n\n.mdi-dns-outline::before {\n  content: \"\\F0B8C\";\n}\n\n.mdi-dock-bottom::before {\n  content: \"\\F10A9\";\n}\n\n.mdi-dock-left::before {\n  content: \"\\F10AA\";\n}\n\n.mdi-dock-right::before {\n  content: \"\\F10AB\";\n}\n\n.mdi-dock-top::before {\n  content: \"\\F1513\";\n}\n\n.mdi-dock-window::before {\n  content: \"\\F10AC\";\n}\n\n.mdi-docker::before {\n  content: \"\\F0868\";\n}\n\n.mdi-doctor::before {\n  content: \"\\F0A42\";\n}\n\n.mdi-dog::before {\n  content: \"\\F0A43\";\n}\n\n.mdi-dog-service::before {\n  content: \"\\F0AAD\";\n}\n\n.mdi-dog-side::before {\n  content: \"\\F0A44\";\n}\n\n.mdi-dog-side-off::before {\n  content: \"\\F16EE\";\n}\n\n.mdi-dolby::before {\n  content: \"\\F06B3\";\n}\n\n.mdi-dolly::before {\n  content: \"\\F0E9E\";\n}\n\n.mdi-dolphin::before {\n  content: \"\\F18B4\";\n}\n\n.mdi-domain::before {\n  content: \"\\F01D7\";\n}\n\n.mdi-domain-off::before {\n  content: \"\\F0D6F\";\n}\n\n.mdi-domain-plus::before {\n  content: \"\\F10AD\";\n}\n\n.mdi-domain-remove::before {\n  content: \"\\F10AE\";\n}\n\n.mdi-dome-light::before {\n  content: \"\\F141E\";\n}\n\n.mdi-domino-mask::before {\n  content: \"\\F1023\";\n}\n\n.mdi-donkey::before {\n  content: \"\\F07C2\";\n}\n\n.mdi-door::before {\n  content: \"\\F081A\";\n}\n\n.mdi-door-closed::before {\n  content: \"\\F081B\";\n}\n\n.mdi-door-closed-lock::before {\n  content: \"\\F10AF\";\n}\n\n.mdi-door-open::before {\n  content: \"\\F081C\";\n}\n\n.mdi-door-sliding::before {\n  content: \"\\F181E\";\n}\n\n.mdi-door-sliding-lock::before {\n  content: \"\\F181F\";\n}\n\n.mdi-door-sliding-open::before {\n  content: \"\\F1820\";\n}\n\n.mdi-doorbell::before {\n  content: \"\\F12E6\";\n}\n\n.mdi-doorbell-video::before {\n  content: \"\\F0869\";\n}\n\n.mdi-dot-net::before {\n  content: \"\\F0AAE\";\n}\n\n.mdi-dots-circle::before {\n  content: \"\\F1978\";\n}\n\n.mdi-dots-grid::before {\n  content: \"\\F15FC\";\n}\n\n.mdi-dots-hexagon::before {\n  content: \"\\F15FF\";\n}\n\n.mdi-dots-horizontal::before {\n  content: \"\\F01D8\";\n}\n\n.mdi-dots-horizontal-circle::before {\n  content: \"\\F07C3\";\n}\n\n.mdi-dots-horizontal-circle-outline::before {\n  content: \"\\F0B8D\";\n}\n\n.mdi-dots-square::before {\n  content: \"\\F15FD\";\n}\n\n.mdi-dots-triangle::before {\n  content: \"\\F15FE\";\n}\n\n.mdi-dots-vertical::before {\n  content: \"\\F01D9\";\n}\n\n.mdi-dots-vertical-circle::before {\n  content: \"\\F07C4\";\n}\n\n.mdi-dots-vertical-circle-outline::before {\n  content: \"\\F0B8E\";\n}\n\n.mdi-download::before {\n  content: \"\\F01DA\";\n}\n\n.mdi-download-box::before {\n  content: \"\\F1462\";\n}\n\n.mdi-download-box-outline::before {\n  content: \"\\F1463\";\n}\n\n.mdi-download-circle::before {\n  content: \"\\F1464\";\n}\n\n.mdi-download-circle-outline::before {\n  content: \"\\F1465\";\n}\n\n.mdi-download-lock::before {\n  content: \"\\F1320\";\n}\n\n.mdi-download-lock-outline::before {\n  content: \"\\F1321\";\n}\n\n.mdi-download-multiple::before {\n  content: \"\\F09E9\";\n}\n\n.mdi-download-network::before {\n  content: \"\\F06F4\";\n}\n\n.mdi-download-network-outline::before {\n  content: \"\\F0C66\";\n}\n\n.mdi-download-off::before {\n  content: \"\\F10B0\";\n}\n\n.mdi-download-off-outline::before {\n  content: \"\\F10B1\";\n}\n\n.mdi-download-outline::before {\n  content: \"\\F0B8F\";\n}\n\n.mdi-drag::before {\n  content: \"\\F01DB\";\n}\n\n.mdi-drag-horizontal::before {\n  content: \"\\F01DC\";\n}\n\n.mdi-drag-horizontal-variant::before {\n  content: \"\\F12F0\";\n}\n\n.mdi-drag-variant::before {\n  content: \"\\F0B90\";\n}\n\n.mdi-drag-vertical::before {\n  content: \"\\F01DD\";\n}\n\n.mdi-drag-vertical-variant::before {\n  content: \"\\F12F1\";\n}\n\n.mdi-drama-masks::before {\n  content: \"\\F0D02\";\n}\n\n.mdi-draw::before {\n  content: \"\\F0F49\";\n}\n\n.mdi-draw-pen::before {\n  content: \"\\F19B9\";\n}\n\n.mdi-drawing::before {\n  content: \"\\F01DE\";\n}\n\n.mdi-drawing-box::before {\n  content: \"\\F01DF\";\n}\n\n.mdi-dresser::before {\n  content: \"\\F0F4A\";\n}\n\n.mdi-dresser-outline::before {\n  content: \"\\F0F4B\";\n}\n\n.mdi-drone::before {\n  content: \"\\F01E2\";\n}\n\n.mdi-dropbox::before {\n  content: \"\\F01E3\";\n}\n\n.mdi-drupal::before {\n  content: \"\\F01E4\";\n}\n\n.mdi-duck::before {\n  content: \"\\F01E5\";\n}\n\n.mdi-dumbbell::before {\n  content: \"\\F01E6\";\n}\n\n.mdi-dump-truck::before {\n  content: \"\\F0C67\";\n}\n\n.mdi-ear-hearing::before {\n  content: \"\\F07C5\";\n}\n\n.mdi-ear-hearing-off::before {\n  content: \"\\F0A45\";\n}\n\n.mdi-earbuds::before {\n  content: \"\\F184F\";\n}\n\n.mdi-earbuds-off::before {\n  content: \"\\F1850\";\n}\n\n.mdi-earbuds-off-outline::before {\n  content: \"\\F1851\";\n}\n\n.mdi-earbuds-outline::before {\n  content: \"\\F1852\";\n}\n\n.mdi-earth::before {\n  content: \"\\F01E7\";\n}\n\n.mdi-earth-arrow-right::before {\n  content: \"\\F1311\";\n}\n\n.mdi-earth-box::before {\n  content: \"\\F06CD\";\n}\n\n.mdi-earth-box-minus::before {\n  content: \"\\F1407\";\n}\n\n.mdi-earth-box-off::before {\n  content: \"\\F06CE\";\n}\n\n.mdi-earth-box-plus::before {\n  content: \"\\F1406\";\n}\n\n.mdi-earth-box-remove::before {\n  content: \"\\F1408\";\n}\n\n.mdi-earth-minus::before {\n  content: \"\\F1404\";\n}\n\n.mdi-earth-off::before {\n  content: \"\\F01E8\";\n}\n\n.mdi-earth-plus::before {\n  content: \"\\F1403\";\n}\n\n.mdi-earth-remove::before {\n  content: \"\\F1405\";\n}\n\n.mdi-egg::before {\n  content: \"\\F0AAF\";\n}\n\n.mdi-egg-easter::before {\n  content: \"\\F0AB0\";\n}\n\n.mdi-egg-fried::before {\n  content: \"\\F184A\";\n}\n\n.mdi-egg-off::before {\n  content: \"\\F13F0\";\n}\n\n.mdi-egg-off-outline::before {\n  content: \"\\F13F1\";\n}\n\n.mdi-egg-outline::before {\n  content: \"\\F13F2\";\n}\n\n.mdi-eiffel-tower::before {\n  content: \"\\F156B\";\n}\n\n.mdi-eight-track::before {\n  content: \"\\F09EA\";\n}\n\n.mdi-eject::before {\n  content: \"\\F01EA\";\n}\n\n.mdi-eject-outline::before {\n  content: \"\\F0B91\";\n}\n\n.mdi-electric-switch::before {\n  content: \"\\F0E9F\";\n}\n\n.mdi-electric-switch-closed::before {\n  content: \"\\F10D9\";\n}\n\n.mdi-electron-framework::before {\n  content: \"\\F1024\";\n}\n\n.mdi-elephant::before {\n  content: \"\\F07C6\";\n}\n\n.mdi-elevation-decline::before {\n  content: \"\\F01EB\";\n}\n\n.mdi-elevation-rise::before {\n  content: \"\\F01EC\";\n}\n\n.mdi-elevator::before {\n  content: \"\\F01ED\";\n}\n\n.mdi-elevator-down::before {\n  content: \"\\F12C2\";\n}\n\n.mdi-elevator-passenger::before {\n  content: \"\\F1381\";\n}\n\n.mdi-elevator-passenger-off::before {\n  content: \"\\F1979\";\n}\n\n.mdi-elevator-passenger-off-outline::before {\n  content: \"\\F197A\";\n}\n\n.mdi-elevator-passenger-outline::before {\n  content: \"\\F197B\";\n}\n\n.mdi-elevator-up::before {\n  content: \"\\F12C1\";\n}\n\n.mdi-ellipse::before {\n  content: \"\\F0EA0\";\n}\n\n.mdi-ellipse-outline::before {\n  content: \"\\F0EA1\";\n}\n\n.mdi-email::before {\n  content: \"\\F01EE\";\n}\n\n.mdi-email-alert::before {\n  content: \"\\F06CF\";\n}\n\n.mdi-email-alert-outline::before {\n  content: \"\\F0D42\";\n}\n\n.mdi-email-box::before {\n  content: \"\\F0D03\";\n}\n\n.mdi-email-check::before {\n  content: \"\\F0AB1\";\n}\n\n.mdi-email-check-outline::before {\n  content: \"\\F0AB2\";\n}\n\n.mdi-email-edit::before {\n  content: \"\\F0EE3\";\n}\n\n.mdi-email-edit-outline::before {\n  content: \"\\F0EE4\";\n}\n\n.mdi-email-fast::before {\n  content: \"\\F186F\";\n}\n\n.mdi-email-fast-outline::before {\n  content: \"\\F1870\";\n}\n\n.mdi-email-lock::before {\n  content: \"\\F01F1\";\n}\n\n.mdi-email-mark-as-unread::before {\n  content: \"\\F0B92\";\n}\n\n.mdi-email-minus::before {\n  content: \"\\F0EE5\";\n}\n\n.mdi-email-minus-outline::before {\n  content: \"\\F0EE6\";\n}\n\n.mdi-email-multiple::before {\n  content: \"\\F0EE7\";\n}\n\n.mdi-email-multiple-outline::before {\n  content: \"\\F0EE8\";\n}\n\n.mdi-email-newsletter::before {\n  content: \"\\F0FB1\";\n}\n\n.mdi-email-off::before {\n  content: \"\\F13E3\";\n}\n\n.mdi-email-off-outline::before {\n  content: \"\\F13E4\";\n}\n\n.mdi-email-open::before {\n  content: \"\\F01EF\";\n}\n\n.mdi-email-open-multiple::before {\n  content: \"\\F0EE9\";\n}\n\n.mdi-email-open-multiple-outline::before {\n  content: \"\\F0EEA\";\n}\n\n.mdi-email-open-outline::before {\n  content: \"\\F05EF\";\n}\n\n.mdi-email-outline::before {\n  content: \"\\F01F0\";\n}\n\n.mdi-email-plus::before {\n  content: \"\\F09EB\";\n}\n\n.mdi-email-plus-outline::before {\n  content: \"\\F09EC\";\n}\n\n.mdi-email-receive::before {\n  content: \"\\F10DA\";\n}\n\n.mdi-email-receive-outline::before {\n  content: \"\\F10DB\";\n}\n\n.mdi-email-remove::before {\n  content: \"\\F1661\";\n}\n\n.mdi-email-remove-outline::before {\n  content: \"\\F1662\";\n}\n\n.mdi-email-seal::before {\n  content: \"\\F195B\";\n}\n\n.mdi-email-seal-outline::before {\n  content: \"\\F195C\";\n}\n\n.mdi-email-search::before {\n  content: \"\\F0961\";\n}\n\n.mdi-email-search-outline::before {\n  content: \"\\F0962\";\n}\n\n.mdi-email-send::before {\n  content: \"\\F10DC\";\n}\n\n.mdi-email-send-outline::before {\n  content: \"\\F10DD\";\n}\n\n.mdi-email-sync::before {\n  content: \"\\F12C7\";\n}\n\n.mdi-email-sync-outline::before {\n  content: \"\\F12C8\";\n}\n\n.mdi-email-variant::before {\n  content: \"\\F05F0\";\n}\n\n.mdi-ember::before {\n  content: \"\\F0B30\";\n}\n\n.mdi-emby::before {\n  content: \"\\F06B4\";\n}\n\n.mdi-emoticon::before {\n  content: \"\\F0C68\";\n}\n\n.mdi-emoticon-angry::before {\n  content: \"\\F0C69\";\n}\n\n.mdi-emoticon-angry-outline::before {\n  content: \"\\F0C6A\";\n}\n\n.mdi-emoticon-confused::before {\n  content: \"\\F10DE\";\n}\n\n.mdi-emoticon-confused-outline::before {\n  content: \"\\F10DF\";\n}\n\n.mdi-emoticon-cool::before {\n  content: \"\\F0C6B\";\n}\n\n.mdi-emoticon-cool-outline::before {\n  content: \"\\F01F3\";\n}\n\n.mdi-emoticon-cry::before {\n  content: \"\\F0C6C\";\n}\n\n.mdi-emoticon-cry-outline::before {\n  content: \"\\F0C6D\";\n}\n\n.mdi-emoticon-dead::before {\n  content: \"\\F0C6E\";\n}\n\n.mdi-emoticon-dead-outline::before {\n  content: \"\\F069B\";\n}\n\n.mdi-emoticon-devil::before {\n  content: \"\\F0C6F\";\n}\n\n.mdi-emoticon-devil-outline::before {\n  content: \"\\F01F4\";\n}\n\n.mdi-emoticon-excited::before {\n  content: \"\\F0C70\";\n}\n\n.mdi-emoticon-excited-outline::before {\n  content: \"\\F069C\";\n}\n\n.mdi-emoticon-frown::before {\n  content: \"\\F0F4C\";\n}\n\n.mdi-emoticon-frown-outline::before {\n  content: \"\\F0F4D\";\n}\n\n.mdi-emoticon-happy::before {\n  content: \"\\F0C71\";\n}\n\n.mdi-emoticon-happy-outline::before {\n  content: \"\\F01F5\";\n}\n\n.mdi-emoticon-kiss::before {\n  content: \"\\F0C72\";\n}\n\n.mdi-emoticon-kiss-outline::before {\n  content: \"\\F0C73\";\n}\n\n.mdi-emoticon-lol::before {\n  content: \"\\F1214\";\n}\n\n.mdi-emoticon-lol-outline::before {\n  content: \"\\F1215\";\n}\n\n.mdi-emoticon-neutral::before {\n  content: \"\\F0C74\";\n}\n\n.mdi-emoticon-neutral-outline::before {\n  content: \"\\F01F6\";\n}\n\n.mdi-emoticon-outline::before {\n  content: \"\\F01F2\";\n}\n\n.mdi-emoticon-poop::before {\n  content: \"\\F01F7\";\n}\n\n.mdi-emoticon-poop-outline::before {\n  content: \"\\F0C75\";\n}\n\n.mdi-emoticon-sad::before {\n  content: \"\\F0C76\";\n}\n\n.mdi-emoticon-sad-outline::before {\n  content: \"\\F01F8\";\n}\n\n.mdi-emoticon-sick::before {\n  content: \"\\F157C\";\n}\n\n.mdi-emoticon-sick-outline::before {\n  content: \"\\F157D\";\n}\n\n.mdi-emoticon-tongue::before {\n  content: \"\\F01F9\";\n}\n\n.mdi-emoticon-tongue-outline::before {\n  content: \"\\F0C77\";\n}\n\n.mdi-emoticon-wink::before {\n  content: \"\\F0C78\";\n}\n\n.mdi-emoticon-wink-outline::before {\n  content: \"\\F0C79\";\n}\n\n.mdi-engine::before {\n  content: \"\\F01FA\";\n}\n\n.mdi-engine-off::before {\n  content: \"\\F0A46\";\n}\n\n.mdi-engine-off-outline::before {\n  content: \"\\F0A47\";\n}\n\n.mdi-engine-outline::before {\n  content: \"\\F01FB\";\n}\n\n.mdi-epsilon::before {\n  content: \"\\F10E0\";\n}\n\n.mdi-equal::before {\n  content: \"\\F01FC\";\n}\n\n.mdi-equal-box::before {\n  content: \"\\F01FD\";\n}\n\n.mdi-equalizer::before {\n  content: \"\\F0EA2\";\n}\n\n.mdi-equalizer-outline::before {\n  content: \"\\F0EA3\";\n}\n\n.mdi-eraser::before {\n  content: \"\\F01FE\";\n}\n\n.mdi-eraser-variant::before {\n  content: \"\\F0642\";\n}\n\n.mdi-escalator::before {\n  content: \"\\F01FF\";\n}\n\n.mdi-escalator-box::before {\n  content: \"\\F1399\";\n}\n\n.mdi-escalator-down::before {\n  content: \"\\F12C0\";\n}\n\n.mdi-escalator-up::before {\n  content: \"\\F12BF\";\n}\n\n.mdi-eslint::before {\n  content: \"\\F0C7A\";\n}\n\n.mdi-et::before {\n  content: \"\\F0AB3\";\n}\n\n.mdi-ethereum::before {\n  content: \"\\F086A\";\n}\n\n.mdi-ethernet::before {\n  content: \"\\F0200\";\n}\n\n.mdi-ethernet-cable::before {\n  content: \"\\F0201\";\n}\n\n.mdi-ethernet-cable-off::before {\n  content: \"\\F0202\";\n}\n\n.mdi-ev-plug-ccs1::before {\n  content: \"\\F1519\";\n}\n\n.mdi-ev-plug-ccs2::before {\n  content: \"\\F151A\";\n}\n\n.mdi-ev-plug-chademo::before {\n  content: \"\\F151B\";\n}\n\n.mdi-ev-plug-tesla::before {\n  content: \"\\F151C\";\n}\n\n.mdi-ev-plug-type1::before {\n  content: \"\\F151D\";\n}\n\n.mdi-ev-plug-type2::before {\n  content: \"\\F151E\";\n}\n\n.mdi-ev-station::before {\n  content: \"\\F05F1\";\n}\n\n.mdi-evernote::before {\n  content: \"\\F0204\";\n}\n\n.mdi-excavator::before {\n  content: \"\\F1025\";\n}\n\n.mdi-exclamation::before {\n  content: \"\\F0205\";\n}\n\n.mdi-exclamation-thick::before {\n  content: \"\\F1238\";\n}\n\n.mdi-exit-run::before {\n  content: \"\\F0A48\";\n}\n\n.mdi-exit-to-app::before {\n  content: \"\\F0206\";\n}\n\n.mdi-expand-all::before {\n  content: \"\\F0AB4\";\n}\n\n.mdi-expand-all-outline::before {\n  content: \"\\F0AB5\";\n}\n\n.mdi-expansion-card::before {\n  content: \"\\F08AE\";\n}\n\n.mdi-expansion-card-variant::before {\n  content: \"\\F0FB2\";\n}\n\n.mdi-exponent::before {\n  content: \"\\F0963\";\n}\n\n.mdi-exponent-box::before {\n  content: \"\\F0964\";\n}\n\n.mdi-export::before {\n  content: \"\\F0207\";\n}\n\n.mdi-export-variant::before {\n  content: \"\\F0B93\";\n}\n\n.mdi-eye::before {\n  content: \"\\F0208\";\n}\n\n.mdi-eye-arrow-left::before {\n  content: \"\\F18FD\";\n}\n\n.mdi-eye-arrow-left-outline::before {\n  content: \"\\F18FE\";\n}\n\n.mdi-eye-arrow-right::before {\n  content: \"\\F18FF\";\n}\n\n.mdi-eye-arrow-right-outline::before {\n  content: \"\\F1900\";\n}\n\n.mdi-eye-check::before {\n  content: \"\\F0D04\";\n}\n\n.mdi-eye-check-outline::before {\n  content: \"\\F0D05\";\n}\n\n.mdi-eye-circle::before {\n  content: \"\\F0B94\";\n}\n\n.mdi-eye-circle-outline::before {\n  content: \"\\F0B95\";\n}\n\n.mdi-eye-minus::before {\n  content: \"\\F1026\";\n}\n\n.mdi-eye-minus-outline::before {\n  content: \"\\F1027\";\n}\n\n.mdi-eye-off::before {\n  content: \"\\F0209\";\n}\n\n.mdi-eye-off-outline::before {\n  content: \"\\F06D1\";\n}\n\n.mdi-eye-outline::before {\n  content: \"\\F06D0\";\n}\n\n.mdi-eye-plus::before {\n  content: \"\\F086B\";\n}\n\n.mdi-eye-plus-outline::before {\n  content: \"\\F086C\";\n}\n\n.mdi-eye-refresh::before {\n  content: \"\\F197C\";\n}\n\n.mdi-eye-refresh-outline::before {\n  content: \"\\F197D\";\n}\n\n.mdi-eye-remove::before {\n  content: \"\\F15E3\";\n}\n\n.mdi-eye-remove-outline::before {\n  content: \"\\F15E4\";\n}\n\n.mdi-eye-settings::before {\n  content: \"\\F086D\";\n}\n\n.mdi-eye-settings-outline::before {\n  content: \"\\F086E\";\n}\n\n.mdi-eyedropper::before {\n  content: \"\\F020A\";\n}\n\n.mdi-eyedropper-minus::before {\n  content: \"\\F13DD\";\n}\n\n.mdi-eyedropper-off::before {\n  content: \"\\F13DF\";\n}\n\n.mdi-eyedropper-plus::before {\n  content: \"\\F13DC\";\n}\n\n.mdi-eyedropper-remove::before {\n  content: \"\\F13DE\";\n}\n\n.mdi-eyedropper-variant::before {\n  content: \"\\F020B\";\n}\n\n.mdi-face-agent::before {\n  content: \"\\F0D70\";\n}\n\n.mdi-face-man::before {\n  content: \"\\F0643\";\n}\n\n.mdi-face-man-outline::before {\n  content: \"\\F0B96\";\n}\n\n.mdi-face-man-profile::before {\n  content: \"\\F0644\";\n}\n\n.mdi-face-man-shimmer::before {\n  content: \"\\F15CC\";\n}\n\n.mdi-face-man-shimmer-outline::before {\n  content: \"\\F15CD\";\n}\n\n.mdi-face-mask::before {\n  content: \"\\F1586\";\n}\n\n.mdi-face-mask-outline::before {\n  content: \"\\F1587\";\n}\n\n.mdi-face-recognition::before {\n  content: \"\\F0C7B\";\n}\n\n.mdi-face-woman::before {\n  content: \"\\F1077\";\n}\n\n.mdi-face-woman-outline::before {\n  content: \"\\F1078\";\n}\n\n.mdi-face-woman-profile::before {\n  content: \"\\F1076\";\n}\n\n.mdi-face-woman-shimmer::before {\n  content: \"\\F15CE\";\n}\n\n.mdi-face-woman-shimmer-outline::before {\n  content: \"\\F15CF\";\n}\n\n.mdi-facebook::before {\n  content: \"\\F020C\";\n}\n\n.mdi-facebook-gaming::before {\n  content: \"\\F07DD\";\n}\n\n.mdi-facebook-messenger::before {\n  content: \"\\F020E\";\n}\n\n.mdi-facebook-workplace::before {\n  content: \"\\F0B31\";\n}\n\n.mdi-factory::before {\n  content: \"\\F020F\";\n}\n\n.mdi-family-tree::before {\n  content: \"\\F160E\";\n}\n\n.mdi-fan::before {\n  content: \"\\F0210\";\n}\n\n.mdi-fan-alert::before {\n  content: \"\\F146C\";\n}\n\n.mdi-fan-auto::before {\n  content: \"\\F171D\";\n}\n\n.mdi-fan-chevron-down::before {\n  content: \"\\F146D\";\n}\n\n.mdi-fan-chevron-up::before {\n  content: \"\\F146E\";\n}\n\n.mdi-fan-minus::before {\n  content: \"\\F1470\";\n}\n\n.mdi-fan-off::before {\n  content: \"\\F081D\";\n}\n\n.mdi-fan-plus::before {\n  content: \"\\F146F\";\n}\n\n.mdi-fan-remove::before {\n  content: \"\\F1471\";\n}\n\n.mdi-fan-speed-1::before {\n  content: \"\\F1472\";\n}\n\n.mdi-fan-speed-2::before {\n  content: \"\\F1473\";\n}\n\n.mdi-fan-speed-3::before {\n  content: \"\\F1474\";\n}\n\n.mdi-fast-forward::before {\n  content: \"\\F0211\";\n}\n\n.mdi-fast-forward-10::before {\n  content: \"\\F0D71\";\n}\n\n.mdi-fast-forward-15::before {\n  content: \"\\F193A\";\n}\n\n.mdi-fast-forward-30::before {\n  content: \"\\F0D06\";\n}\n\n.mdi-fast-forward-5::before {\n  content: \"\\F11F8\";\n}\n\n.mdi-fast-forward-60::before {\n  content: \"\\F160B\";\n}\n\n.mdi-fast-forward-outline::before {\n  content: \"\\F06D2\";\n}\n\n.mdi-fax::before {\n  content: \"\\F0212\";\n}\n\n.mdi-feather::before {\n  content: \"\\F06D3\";\n}\n\n.mdi-feature-search::before {\n  content: \"\\F0A49\";\n}\n\n.mdi-feature-search-outline::before {\n  content: \"\\F0A4A\";\n}\n\n.mdi-fedora::before {\n  content: \"\\F08DB\";\n}\n\n.mdi-fence::before {\n  content: \"\\F179A\";\n}\n\n.mdi-fence-electric::before {\n  content: \"\\F17F6\";\n}\n\n.mdi-fencing::before {\n  content: \"\\F14C1\";\n}\n\n.mdi-ferris-wheel::before {\n  content: \"\\F0EA4\";\n}\n\n.mdi-ferry::before {\n  content: \"\\F0213\";\n}\n\n.mdi-file::before {\n  content: \"\\F0214\";\n}\n\n.mdi-file-account::before {\n  content: \"\\F073B\";\n}\n\n.mdi-file-account-outline::before {\n  content: \"\\F1028\";\n}\n\n.mdi-file-alert::before {\n  content: \"\\F0A4B\";\n}\n\n.mdi-file-alert-outline::before {\n  content: \"\\F0A4C\";\n}\n\n.mdi-file-cabinet::before {\n  content: \"\\F0AB6\";\n}\n\n.mdi-file-cad::before {\n  content: \"\\F0EEB\";\n}\n\n.mdi-file-cad-box::before {\n  content: \"\\F0EEC\";\n}\n\n.mdi-file-cancel::before {\n  content: \"\\F0DC6\";\n}\n\n.mdi-file-cancel-outline::before {\n  content: \"\\F0DC7\";\n}\n\n.mdi-file-certificate::before {\n  content: \"\\F1186\";\n}\n\n.mdi-file-certificate-outline::before {\n  content: \"\\F1187\";\n}\n\n.mdi-file-chart::before {\n  content: \"\\F0215\";\n}\n\n.mdi-file-chart-outline::before {\n  content: \"\\F1029\";\n}\n\n.mdi-file-check::before {\n  content: \"\\F0216\";\n}\n\n.mdi-file-check-outline::before {\n  content: \"\\F0E29\";\n}\n\n.mdi-file-clock::before {\n  content: \"\\F12E1\";\n}\n\n.mdi-file-clock-outline::before {\n  content: \"\\F12E2\";\n}\n\n.mdi-file-cloud::before {\n  content: \"\\F0217\";\n}\n\n.mdi-file-cloud-outline::before {\n  content: \"\\F102A\";\n}\n\n.mdi-file-code::before {\n  content: \"\\F022E\";\n}\n\n.mdi-file-code-outline::before {\n  content: \"\\F102B\";\n}\n\n.mdi-file-cog::before {\n  content: \"\\F107B\";\n}\n\n.mdi-file-cog-outline::before {\n  content: \"\\F107C\";\n}\n\n.mdi-file-compare::before {\n  content: \"\\F08AA\";\n}\n\n.mdi-file-delimited::before {\n  content: \"\\F0218\";\n}\n\n.mdi-file-delimited-outline::before {\n  content: \"\\F0EA5\";\n}\n\n.mdi-file-document::before {\n  content: \"\\F0219\";\n}\n\n.mdi-file-document-edit::before {\n  content: \"\\F0DC8\";\n}\n\n.mdi-file-document-edit-outline::before {\n  content: \"\\F0DC9\";\n}\n\n.mdi-file-document-multiple::before {\n  content: \"\\F1517\";\n}\n\n.mdi-file-document-multiple-outline::before {\n  content: \"\\F1518\";\n}\n\n.mdi-file-document-outline::before {\n  content: \"\\F09EE\";\n}\n\n.mdi-file-download::before {\n  content: \"\\F0965\";\n}\n\n.mdi-file-download-outline::before {\n  content: \"\\F0966\";\n}\n\n.mdi-file-edit::before {\n  content: \"\\F11E7\";\n}\n\n.mdi-file-edit-outline::before {\n  content: \"\\F11E8\";\n}\n\n.mdi-file-excel::before {\n  content: \"\\F021B\";\n}\n\n.mdi-file-excel-box::before {\n  content: \"\\F021C\";\n}\n\n.mdi-file-excel-box-outline::before {\n  content: \"\\F102C\";\n}\n\n.mdi-file-excel-outline::before {\n  content: \"\\F102D\";\n}\n\n.mdi-file-export::before {\n  content: \"\\F021D\";\n}\n\n.mdi-file-export-outline::before {\n  content: \"\\F102E\";\n}\n\n.mdi-file-eye::before {\n  content: \"\\F0DCA\";\n}\n\n.mdi-file-eye-outline::before {\n  content: \"\\F0DCB\";\n}\n\n.mdi-file-find::before {\n  content: \"\\F021E\";\n}\n\n.mdi-file-find-outline::before {\n  content: \"\\F0B97\";\n}\n\n.mdi-file-gif-box::before {\n  content: \"\\F0D78\";\n}\n\n.mdi-file-hidden::before {\n  content: \"\\F0613\";\n}\n\n.mdi-file-image::before {\n  content: \"\\F021F\";\n}\n\n.mdi-file-image-marker::before {\n  content: \"\\F1772\";\n}\n\n.mdi-file-image-marker-outline::before {\n  content: \"\\F1773\";\n}\n\n.mdi-file-image-minus::before {\n  content: \"\\F193B\";\n}\n\n.mdi-file-image-minus-outline::before {\n  content: \"\\F193C\";\n}\n\n.mdi-file-image-outline::before {\n  content: \"\\F0EB0\";\n}\n\n.mdi-file-image-plus::before {\n  content: \"\\F193D\";\n}\n\n.mdi-file-image-plus-outline::before {\n  content: \"\\F193E\";\n}\n\n.mdi-file-image-remove::before {\n  content: \"\\F193F\";\n}\n\n.mdi-file-image-remove-outline::before {\n  content: \"\\F1940\";\n}\n\n.mdi-file-import::before {\n  content: \"\\F0220\";\n}\n\n.mdi-file-import-outline::before {\n  content: \"\\F102F\";\n}\n\n.mdi-file-jpg-box::before {\n  content: \"\\F0225\";\n}\n\n.mdi-file-key::before {\n  content: \"\\F1184\";\n}\n\n.mdi-file-key-outline::before {\n  content: \"\\F1185\";\n}\n\n.mdi-file-link::before {\n  content: \"\\F1177\";\n}\n\n.mdi-file-link-outline::before {\n  content: \"\\F1178\";\n}\n\n.mdi-file-lock::before {\n  content: \"\\F0221\";\n}\n\n.mdi-file-lock-outline::before {\n  content: \"\\F1030\";\n}\n\n.mdi-file-marker::before {\n  content: \"\\F1774\";\n}\n\n.mdi-file-marker-outline::before {\n  content: \"\\F1775\";\n}\n\n.mdi-file-move::before {\n  content: \"\\F0AB9\";\n}\n\n.mdi-file-move-outline::before {\n  content: \"\\F1031\";\n}\n\n.mdi-file-multiple::before {\n  content: \"\\F0222\";\n}\n\n.mdi-file-multiple-outline::before {\n  content: \"\\F1032\";\n}\n\n.mdi-file-music::before {\n  content: \"\\F0223\";\n}\n\n.mdi-file-music-outline::before {\n  content: \"\\F0E2A\";\n}\n\n.mdi-file-outline::before {\n  content: \"\\F0224\";\n}\n\n.mdi-file-pdf-box::before {\n  content: \"\\F0226\";\n}\n\n.mdi-file-percent::before {\n  content: \"\\F081E\";\n}\n\n.mdi-file-percent-outline::before {\n  content: \"\\F1033\";\n}\n\n.mdi-file-phone::before {\n  content: \"\\F1179\";\n}\n\n.mdi-file-phone-outline::before {\n  content: \"\\F117A\";\n}\n\n.mdi-file-plus::before {\n  content: \"\\F0752\";\n}\n\n.mdi-file-plus-outline::before {\n  content: \"\\F0EED\";\n}\n\n.mdi-file-png-box::before {\n  content: \"\\F0E2D\";\n}\n\n.mdi-file-powerpoint::before {\n  content: \"\\F0227\";\n}\n\n.mdi-file-powerpoint-box::before {\n  content: \"\\F0228\";\n}\n\n.mdi-file-powerpoint-box-outline::before {\n  content: \"\\F1034\";\n}\n\n.mdi-file-powerpoint-outline::before {\n  content: \"\\F1035\";\n}\n\n.mdi-file-presentation-box::before {\n  content: \"\\F0229\";\n}\n\n.mdi-file-question::before {\n  content: \"\\F086F\";\n}\n\n.mdi-file-question-outline::before {\n  content: \"\\F1036\";\n}\n\n.mdi-file-refresh::before {\n  content: \"\\F0918\";\n}\n\n.mdi-file-refresh-outline::before {\n  content: \"\\F0541\";\n}\n\n.mdi-file-remove::before {\n  content: \"\\F0B98\";\n}\n\n.mdi-file-remove-outline::before {\n  content: \"\\F1037\";\n}\n\n.mdi-file-replace::before {\n  content: \"\\F0B32\";\n}\n\n.mdi-file-replace-outline::before {\n  content: \"\\F0B33\";\n}\n\n.mdi-file-restore::before {\n  content: \"\\F0670\";\n}\n\n.mdi-file-restore-outline::before {\n  content: \"\\F1038\";\n}\n\n.mdi-file-search::before {\n  content: \"\\F0C7C\";\n}\n\n.mdi-file-search-outline::before {\n  content: \"\\F0C7D\";\n}\n\n.mdi-file-send::before {\n  content: \"\\F022A\";\n}\n\n.mdi-file-send-outline::before {\n  content: \"\\F1039\";\n}\n\n.mdi-file-settings::before {\n  content: \"\\F1079\";\n}\n\n.mdi-file-settings-outline::before {\n  content: \"\\F107A\";\n}\n\n.mdi-file-sign::before {\n  content: \"\\F19C3\";\n}\n\n.mdi-file-star::before {\n  content: \"\\F103A\";\n}\n\n.mdi-file-star-outline::before {\n  content: \"\\F103B\";\n}\n\n.mdi-file-swap::before {\n  content: \"\\F0FB4\";\n}\n\n.mdi-file-swap-outline::before {\n  content: \"\\F0FB5\";\n}\n\n.mdi-file-sync::before {\n  content: \"\\F1216\";\n}\n\n.mdi-file-sync-outline::before {\n  content: \"\\F1217\";\n}\n\n.mdi-file-table::before {\n  content: \"\\F0C7E\";\n}\n\n.mdi-file-table-box::before {\n  content: \"\\F10E1\";\n}\n\n.mdi-file-table-box-multiple::before {\n  content: \"\\F10E2\";\n}\n\n.mdi-file-table-box-multiple-outline::before {\n  content: \"\\F10E3\";\n}\n\n.mdi-file-table-box-outline::before {\n  content: \"\\F10E4\";\n}\n\n.mdi-file-table-outline::before {\n  content: \"\\F0C7F\";\n}\n\n.mdi-file-tree::before {\n  content: \"\\F0645\";\n}\n\n.mdi-file-tree-outline::before {\n  content: \"\\F13D2\";\n}\n\n.mdi-file-undo::before {\n  content: \"\\F08DC\";\n}\n\n.mdi-file-undo-outline::before {\n  content: \"\\F103C\";\n}\n\n.mdi-file-upload::before {\n  content: \"\\F0A4D\";\n}\n\n.mdi-file-upload-outline::before {\n  content: \"\\F0A4E\";\n}\n\n.mdi-file-video::before {\n  content: \"\\F022B\";\n}\n\n.mdi-file-video-outline::before {\n  content: \"\\F0E2C\";\n}\n\n.mdi-file-word::before {\n  content: \"\\F022C\";\n}\n\n.mdi-file-word-box::before {\n  content: \"\\F022D\";\n}\n\n.mdi-file-word-box-outline::before {\n  content: \"\\F103D\";\n}\n\n.mdi-file-word-outline::before {\n  content: \"\\F103E\";\n}\n\n.mdi-film::before {\n  content: \"\\F022F\";\n}\n\n.mdi-filmstrip::before {\n  content: \"\\F0230\";\n}\n\n.mdi-filmstrip-box::before {\n  content: \"\\F0332\";\n}\n\n.mdi-filmstrip-box-multiple::before {\n  content: \"\\F0D18\";\n}\n\n.mdi-filmstrip-off::before {\n  content: \"\\F0231\";\n}\n\n.mdi-filter::before {\n  content: \"\\F0232\";\n}\n\n.mdi-filter-check::before {\n  content: \"\\F18EC\";\n}\n\n.mdi-filter-check-outline::before {\n  content: \"\\F18ED\";\n}\n\n.mdi-filter-menu::before {\n  content: \"\\F10E5\";\n}\n\n.mdi-filter-menu-outline::before {\n  content: \"\\F10E6\";\n}\n\n.mdi-filter-minus::before {\n  content: \"\\F0EEE\";\n}\n\n.mdi-filter-minus-outline::before {\n  content: \"\\F0EEF\";\n}\n\n.mdi-filter-off::before {\n  content: \"\\F14EF\";\n}\n\n.mdi-filter-off-outline::before {\n  content: \"\\F14F0\";\n}\n\n.mdi-filter-outline::before {\n  content: \"\\F0233\";\n}\n\n.mdi-filter-plus::before {\n  content: \"\\F0EF0\";\n}\n\n.mdi-filter-plus-outline::before {\n  content: \"\\F0EF1\";\n}\n\n.mdi-filter-remove::before {\n  content: \"\\F0234\";\n}\n\n.mdi-filter-remove-outline::before {\n  content: \"\\F0235\";\n}\n\n.mdi-filter-variant::before {\n  content: \"\\F0236\";\n}\n\n.mdi-filter-variant-minus::before {\n  content: \"\\F1112\";\n}\n\n.mdi-filter-variant-plus::before {\n  content: \"\\F1113\";\n}\n\n.mdi-filter-variant-remove::before {\n  content: \"\\F103F\";\n}\n\n.mdi-finance::before {\n  content: \"\\F081F\";\n}\n\n.mdi-find-replace::before {\n  content: \"\\F06D4\";\n}\n\n.mdi-fingerprint::before {\n  content: \"\\F0237\";\n}\n\n.mdi-fingerprint-off::before {\n  content: \"\\F0EB1\";\n}\n\n.mdi-fire::before {\n  content: \"\\F0238\";\n}\n\n.mdi-fire-alert::before {\n  content: \"\\F15D7\";\n}\n\n.mdi-fire-circle::before {\n  content: \"\\F1807\";\n}\n\n.mdi-fire-extinguisher::before {\n  content: \"\\F0EF2\";\n}\n\n.mdi-fire-hydrant::before {\n  content: \"\\F1137\";\n}\n\n.mdi-fire-hydrant-alert::before {\n  content: \"\\F1138\";\n}\n\n.mdi-fire-hydrant-off::before {\n  content: \"\\F1139\";\n}\n\n.mdi-fire-off::before {\n  content: \"\\F1722\";\n}\n\n.mdi-fire-truck::before {\n  content: \"\\F08AB\";\n}\n\n.mdi-firebase::before {\n  content: \"\\F0967\";\n}\n\n.mdi-firefox::before {\n  content: \"\\F0239\";\n}\n\n.mdi-fireplace::before {\n  content: \"\\F0E2E\";\n}\n\n.mdi-fireplace-off::before {\n  content: \"\\F0E2F\";\n}\n\n.mdi-firewire::before {\n  content: \"\\F05BE\";\n}\n\n.mdi-firework::before {\n  content: \"\\F0E30\";\n}\n\n.mdi-firework-off::before {\n  content: \"\\F1723\";\n}\n\n.mdi-fish::before {\n  content: \"\\F023A\";\n}\n\n.mdi-fish-off::before {\n  content: \"\\F13F3\";\n}\n\n.mdi-fishbowl::before {\n  content: \"\\F0EF3\";\n}\n\n.mdi-fishbowl-outline::before {\n  content: \"\\F0EF4\";\n}\n\n.mdi-fit-to-page::before {\n  content: \"\\F0EF5\";\n}\n\n.mdi-fit-to-page-outline::before {\n  content: \"\\F0EF6\";\n}\n\n.mdi-fit-to-screen::before {\n  content: \"\\F18F4\";\n}\n\n.mdi-fit-to-screen-outline::before {\n  content: \"\\F18F5\";\n}\n\n.mdi-flag::before {\n  content: \"\\F023B\";\n}\n\n.mdi-flag-checkered::before {\n  content: \"\\F023C\";\n}\n\n.mdi-flag-minus::before {\n  content: \"\\F0B99\";\n}\n\n.mdi-flag-minus-outline::before {\n  content: \"\\F10B2\";\n}\n\n.mdi-flag-off::before {\n  content: \"\\F18EE\";\n}\n\n.mdi-flag-off-outline::before {\n  content: \"\\F18EF\";\n}\n\n.mdi-flag-outline::before {\n  content: \"\\F023D\";\n}\n\n.mdi-flag-plus::before {\n  content: \"\\F0B9A\";\n}\n\n.mdi-flag-plus-outline::before {\n  content: \"\\F10B3\";\n}\n\n.mdi-flag-remove::before {\n  content: \"\\F0B9B\";\n}\n\n.mdi-flag-remove-outline::before {\n  content: \"\\F10B4\";\n}\n\n.mdi-flag-triangle::before {\n  content: \"\\F023F\";\n}\n\n.mdi-flag-variant::before {\n  content: \"\\F0240\";\n}\n\n.mdi-flag-variant-outline::before {\n  content: \"\\F023E\";\n}\n\n.mdi-flare::before {\n  content: \"\\F0D72\";\n}\n\n.mdi-flash::before {\n  content: \"\\F0241\";\n}\n\n.mdi-flash-alert::before {\n  content: \"\\F0EF7\";\n}\n\n.mdi-flash-alert-outline::before {\n  content: \"\\F0EF8\";\n}\n\n.mdi-flash-auto::before {\n  content: \"\\F0242\";\n}\n\n.mdi-flash-off::before {\n  content: \"\\F0243\";\n}\n\n.mdi-flash-outline::before {\n  content: \"\\F06D5\";\n}\n\n.mdi-flash-red-eye::before {\n  content: \"\\F067B\";\n}\n\n.mdi-flashlight::before {\n  content: \"\\F0244\";\n}\n\n.mdi-flashlight-off::before {\n  content: \"\\F0245\";\n}\n\n.mdi-flask::before {\n  content: \"\\F0093\";\n}\n\n.mdi-flask-empty::before {\n  content: \"\\F0094\";\n}\n\n.mdi-flask-empty-minus::before {\n  content: \"\\F123A\";\n}\n\n.mdi-flask-empty-minus-outline::before {\n  content: \"\\F123B\";\n}\n\n.mdi-flask-empty-off::before {\n  content: \"\\F13F4\";\n}\n\n.mdi-flask-empty-off-outline::before {\n  content: \"\\F13F5\";\n}\n\n.mdi-flask-empty-outline::before {\n  content: \"\\F0095\";\n}\n\n.mdi-flask-empty-plus::before {\n  content: \"\\F123C\";\n}\n\n.mdi-flask-empty-plus-outline::before {\n  content: \"\\F123D\";\n}\n\n.mdi-flask-empty-remove::before {\n  content: \"\\F123E\";\n}\n\n.mdi-flask-empty-remove-outline::before {\n  content: \"\\F123F\";\n}\n\n.mdi-flask-minus::before {\n  content: \"\\F1240\";\n}\n\n.mdi-flask-minus-outline::before {\n  content: \"\\F1241\";\n}\n\n.mdi-flask-off::before {\n  content: \"\\F13F6\";\n}\n\n.mdi-flask-off-outline::before {\n  content: \"\\F13F7\";\n}\n\n.mdi-flask-outline::before {\n  content: \"\\F0096\";\n}\n\n.mdi-flask-plus::before {\n  content: \"\\F1242\";\n}\n\n.mdi-flask-plus-outline::before {\n  content: \"\\F1243\";\n}\n\n.mdi-flask-remove::before {\n  content: \"\\F1244\";\n}\n\n.mdi-flask-remove-outline::before {\n  content: \"\\F1245\";\n}\n\n.mdi-flask-round-bottom::before {\n  content: \"\\F124B\";\n}\n\n.mdi-flask-round-bottom-empty::before {\n  content: \"\\F124C\";\n}\n\n.mdi-flask-round-bottom-empty-outline::before {\n  content: \"\\F124D\";\n}\n\n.mdi-flask-round-bottom-outline::before {\n  content: \"\\F124E\";\n}\n\n.mdi-fleur-de-lis::before {\n  content: \"\\F1303\";\n}\n\n.mdi-flip-horizontal::before {\n  content: \"\\F10E7\";\n}\n\n.mdi-flip-to-back::before {\n  content: \"\\F0247\";\n}\n\n.mdi-flip-to-front::before {\n  content: \"\\F0248\";\n}\n\n.mdi-flip-vertical::before {\n  content: \"\\F10E8\";\n}\n\n.mdi-floor-lamp::before {\n  content: \"\\F08DD\";\n}\n\n.mdi-floor-lamp-dual::before {\n  content: \"\\F1040\";\n}\n\n.mdi-floor-lamp-dual-outline::before {\n  content: \"\\F17CE\";\n}\n\n.mdi-floor-lamp-outline::before {\n  content: \"\\F17C8\";\n}\n\n.mdi-floor-lamp-torchiere::before {\n  content: \"\\F1747\";\n}\n\n.mdi-floor-lamp-torchiere-outline::before {\n  content: \"\\F17D6\";\n}\n\n.mdi-floor-lamp-torchiere-variant::before {\n  content: \"\\F1041\";\n}\n\n.mdi-floor-lamp-torchiere-variant-outline::before {\n  content: \"\\F17CF\";\n}\n\n.mdi-floor-plan::before {\n  content: \"\\F0821\";\n}\n\n.mdi-floppy::before {\n  content: \"\\F0249\";\n}\n\n.mdi-floppy-variant::before {\n  content: \"\\F09EF\";\n}\n\n.mdi-flower::before {\n  content: \"\\F024A\";\n}\n\n.mdi-flower-outline::before {\n  content: \"\\F09F0\";\n}\n\n.mdi-flower-pollen::before {\n  content: \"\\F1885\";\n}\n\n.mdi-flower-pollen-outline::before {\n  content: \"\\F1886\";\n}\n\n.mdi-flower-poppy::before {\n  content: \"\\F0D08\";\n}\n\n.mdi-flower-tulip::before {\n  content: \"\\F09F1\";\n}\n\n.mdi-flower-tulip-outline::before {\n  content: \"\\F09F2\";\n}\n\n.mdi-focus-auto::before {\n  content: \"\\F0F4E\";\n}\n\n.mdi-focus-field::before {\n  content: \"\\F0F4F\";\n}\n\n.mdi-focus-field-horizontal::before {\n  content: \"\\F0F50\";\n}\n\n.mdi-focus-field-vertical::before {\n  content: \"\\F0F51\";\n}\n\n.mdi-folder::before {\n  content: \"\\F024B\";\n}\n\n.mdi-folder-account::before {\n  content: \"\\F024C\";\n}\n\n.mdi-folder-account-outline::before {\n  content: \"\\F0B9C\";\n}\n\n.mdi-folder-alert::before {\n  content: \"\\F0DCC\";\n}\n\n.mdi-folder-alert-outline::before {\n  content: \"\\F0DCD\";\n}\n\n.mdi-folder-check::before {\n  content: \"\\F197E\";\n}\n\n.mdi-folder-check-outline::before {\n  content: \"\\F197F\";\n}\n\n.mdi-folder-clock::before {\n  content: \"\\F0ABA\";\n}\n\n.mdi-folder-clock-outline::before {\n  content: \"\\F0ABB\";\n}\n\n.mdi-folder-cog::before {\n  content: \"\\F107F\";\n}\n\n.mdi-folder-cog-outline::before {\n  content: \"\\F1080\";\n}\n\n.mdi-folder-download::before {\n  content: \"\\F024D\";\n}\n\n.mdi-folder-download-outline::before {\n  content: \"\\F10E9\";\n}\n\n.mdi-folder-edit::before {\n  content: \"\\F08DE\";\n}\n\n.mdi-folder-edit-outline::before {\n  content: \"\\F0DCE\";\n}\n\n.mdi-folder-eye::before {\n  content: \"\\F178A\";\n}\n\n.mdi-folder-eye-outline::before {\n  content: \"\\F178B\";\n}\n\n.mdi-folder-google-drive::before {\n  content: \"\\F024E\";\n}\n\n.mdi-folder-heart::before {\n  content: \"\\F10EA\";\n}\n\n.mdi-folder-heart-outline::before {\n  content: \"\\F10EB\";\n}\n\n.mdi-folder-hidden::before {\n  content: \"\\F179E\";\n}\n\n.mdi-folder-home::before {\n  content: \"\\F10B5\";\n}\n\n.mdi-folder-home-outline::before {\n  content: \"\\F10B6\";\n}\n\n.mdi-folder-image::before {\n  content: \"\\F024F\";\n}\n\n.mdi-folder-information::before {\n  content: \"\\F10B7\";\n}\n\n.mdi-folder-information-outline::before {\n  content: \"\\F10B8\";\n}\n\n.mdi-folder-key::before {\n  content: \"\\F08AC\";\n}\n\n.mdi-folder-key-network::before {\n  content: \"\\F08AD\";\n}\n\n.mdi-folder-key-network-outline::before {\n  content: \"\\F0C80\";\n}\n\n.mdi-folder-key-outline::before {\n  content: \"\\F10EC\";\n}\n\n.mdi-folder-lock::before {\n  content: \"\\F0250\";\n}\n\n.mdi-folder-lock-open::before {\n  content: \"\\F0251\";\n}\n\n.mdi-folder-marker::before {\n  content: \"\\F126D\";\n}\n\n.mdi-folder-marker-outline::before {\n  content: \"\\F126E\";\n}\n\n.mdi-folder-move::before {\n  content: \"\\F0252\";\n}\n\n.mdi-folder-move-outline::before {\n  content: \"\\F1246\";\n}\n\n.mdi-folder-multiple::before {\n  content: \"\\F0253\";\n}\n\n.mdi-folder-multiple-image::before {\n  content: \"\\F0254\";\n}\n\n.mdi-folder-multiple-outline::before {\n  content: \"\\F0255\";\n}\n\n.mdi-folder-multiple-plus::before {\n  content: \"\\F147E\";\n}\n\n.mdi-folder-multiple-plus-outline::before {\n  content: \"\\F147F\";\n}\n\n.mdi-folder-music::before {\n  content: \"\\F1359\";\n}\n\n.mdi-folder-music-outline::before {\n  content: \"\\F135A\";\n}\n\n.mdi-folder-network::before {\n  content: \"\\F0870\";\n}\n\n.mdi-folder-network-outline::before {\n  content: \"\\F0C81\";\n}\n\n.mdi-folder-open::before {\n  content: \"\\F0770\";\n}\n\n.mdi-folder-open-outline::before {\n  content: \"\\F0DCF\";\n}\n\n.mdi-folder-outline::before {\n  content: \"\\F0256\";\n}\n\n.mdi-folder-plus::before {\n  content: \"\\F0257\";\n}\n\n.mdi-folder-plus-outline::before {\n  content: \"\\F0B9D\";\n}\n\n.mdi-folder-pound::before {\n  content: \"\\F0D09\";\n}\n\n.mdi-folder-pound-outline::before {\n  content: \"\\F0D0A\";\n}\n\n.mdi-folder-refresh::before {\n  content: \"\\F0749\";\n}\n\n.mdi-folder-refresh-outline::before {\n  content: \"\\F0542\";\n}\n\n.mdi-folder-remove::before {\n  content: \"\\F0258\";\n}\n\n.mdi-folder-remove-outline::before {\n  content: \"\\F0B9E\";\n}\n\n.mdi-folder-search::before {\n  content: \"\\F0968\";\n}\n\n.mdi-folder-search-outline::before {\n  content: \"\\F0969\";\n}\n\n.mdi-folder-settings::before {\n  content: \"\\F107D\";\n}\n\n.mdi-folder-settings-outline::before {\n  content: \"\\F107E\";\n}\n\n.mdi-folder-star::before {\n  content: \"\\F069D\";\n}\n\n.mdi-folder-star-multiple::before {\n  content: \"\\F13D3\";\n}\n\n.mdi-folder-star-multiple-outline::before {\n  content: \"\\F13D4\";\n}\n\n.mdi-folder-star-outline::before {\n  content: \"\\F0B9F\";\n}\n\n.mdi-folder-swap::before {\n  content: \"\\F0FB6\";\n}\n\n.mdi-folder-swap-outline::before {\n  content: \"\\F0FB7\";\n}\n\n.mdi-folder-sync::before {\n  content: \"\\F0D0B\";\n}\n\n.mdi-folder-sync-outline::before {\n  content: \"\\F0D0C\";\n}\n\n.mdi-folder-table::before {\n  content: \"\\F12E3\";\n}\n\n.mdi-folder-table-outline::before {\n  content: \"\\F12E4\";\n}\n\n.mdi-folder-text::before {\n  content: \"\\F0C82\";\n}\n\n.mdi-folder-text-outline::before {\n  content: \"\\F0C83\";\n}\n\n.mdi-folder-upload::before {\n  content: \"\\F0259\";\n}\n\n.mdi-folder-upload-outline::before {\n  content: \"\\F10ED\";\n}\n\n.mdi-folder-zip::before {\n  content: \"\\F06EB\";\n}\n\n.mdi-folder-zip-outline::before {\n  content: \"\\F07B9\";\n}\n\n.mdi-font-awesome::before {\n  content: \"\\F003A\";\n}\n\n.mdi-food::before {\n  content: \"\\F025A\";\n}\n\n.mdi-food-apple::before {\n  content: \"\\F025B\";\n}\n\n.mdi-food-apple-outline::before {\n  content: \"\\F0C84\";\n}\n\n.mdi-food-croissant::before {\n  content: \"\\F07C8\";\n}\n\n.mdi-food-drumstick::before {\n  content: \"\\F141F\";\n}\n\n.mdi-food-drumstick-off::before {\n  content: \"\\F1468\";\n}\n\n.mdi-food-drumstick-off-outline::before {\n  content: \"\\F1469\";\n}\n\n.mdi-food-drumstick-outline::before {\n  content: \"\\F1420\";\n}\n\n.mdi-food-fork-drink::before {\n  content: \"\\F05F2\";\n}\n\n.mdi-food-halal::before {\n  content: \"\\F1572\";\n}\n\n.mdi-food-hot-dog::before {\n  content: \"\\F184B\";\n}\n\n.mdi-food-kosher::before {\n  content: \"\\F1573\";\n}\n\n.mdi-food-off::before {\n  content: \"\\F05F3\";\n}\n\n.mdi-food-off-outline::before {\n  content: \"\\F1915\";\n}\n\n.mdi-food-outline::before {\n  content: \"\\F1916\";\n}\n\n.mdi-food-steak::before {\n  content: \"\\F146A\";\n}\n\n.mdi-food-steak-off::before {\n  content: \"\\F146B\";\n}\n\n.mdi-food-takeout-box::before {\n  content: \"\\F1836\";\n}\n\n.mdi-food-takeout-box-outline::before {\n  content: \"\\F1837\";\n}\n\n.mdi-food-turkey::before {\n  content: \"\\F171C\";\n}\n\n.mdi-food-variant::before {\n  content: \"\\F025C\";\n}\n\n.mdi-food-variant-off::before {\n  content: \"\\F13E5\";\n}\n\n.mdi-foot-print::before {\n  content: \"\\F0F52\";\n}\n\n.mdi-football::before {\n  content: \"\\F025D\";\n}\n\n.mdi-football-australian::before {\n  content: \"\\F025E\";\n}\n\n.mdi-football-helmet::before {\n  content: \"\\F025F\";\n}\n\n.mdi-forest::before {\n  content: \"\\F1897\";\n}\n\n.mdi-forklift::before {\n  content: \"\\F07C9\";\n}\n\n.mdi-form-dropdown::before {\n  content: \"\\F1400\";\n}\n\n.mdi-form-select::before {\n  content: \"\\F1401\";\n}\n\n.mdi-form-textarea::before {\n  content: \"\\F1095\";\n}\n\n.mdi-form-textbox::before {\n  content: \"\\F060E\";\n}\n\n.mdi-form-textbox-lock::before {\n  content: \"\\F135D\";\n}\n\n.mdi-form-textbox-password::before {\n  content: \"\\F07F5\";\n}\n\n.mdi-format-align-bottom::before {\n  content: \"\\F0753\";\n}\n\n.mdi-format-align-center::before {\n  content: \"\\F0260\";\n}\n\n.mdi-format-align-justify::before {\n  content: \"\\F0261\";\n}\n\n.mdi-format-align-left::before {\n  content: \"\\F0262\";\n}\n\n.mdi-format-align-middle::before {\n  content: \"\\F0754\";\n}\n\n.mdi-format-align-right::before {\n  content: \"\\F0263\";\n}\n\n.mdi-format-align-top::before {\n  content: \"\\F0755\";\n}\n\n.mdi-format-annotation-minus::before {\n  content: \"\\F0ABC\";\n}\n\n.mdi-format-annotation-plus::before {\n  content: \"\\F0646\";\n}\n\n.mdi-format-bold::before {\n  content: \"\\F0264\";\n}\n\n.mdi-format-clear::before {\n  content: \"\\F0265\";\n}\n\n.mdi-format-color-fill::before {\n  content: \"\\F0266\";\n}\n\n.mdi-format-color-highlight::before {\n  content: \"\\F0E31\";\n}\n\n.mdi-format-color-marker-cancel::before {\n  content: \"\\F1313\";\n}\n\n.mdi-format-color-text::before {\n  content: \"\\F069E\";\n}\n\n.mdi-format-columns::before {\n  content: \"\\F08DF\";\n}\n\n.mdi-format-float-center::before {\n  content: \"\\F0267\";\n}\n\n.mdi-format-float-left::before {\n  content: \"\\F0268\";\n}\n\n.mdi-format-float-none::before {\n  content: \"\\F0269\";\n}\n\n.mdi-format-float-right::before {\n  content: \"\\F026A\";\n}\n\n.mdi-format-font::before {\n  content: \"\\F06D6\";\n}\n\n.mdi-format-font-size-decrease::before {\n  content: \"\\F09F3\";\n}\n\n.mdi-format-font-size-increase::before {\n  content: \"\\F09F4\";\n}\n\n.mdi-format-header-1::before {\n  content: \"\\F026B\";\n}\n\n.mdi-format-header-2::before {\n  content: \"\\F026C\";\n}\n\n.mdi-format-header-3::before {\n  content: \"\\F026D\";\n}\n\n.mdi-format-header-4::before {\n  content: \"\\F026E\";\n}\n\n.mdi-format-header-5::before {\n  content: \"\\F026F\";\n}\n\n.mdi-format-header-6::before {\n  content: \"\\F0270\";\n}\n\n.mdi-format-header-decrease::before {\n  content: \"\\F0271\";\n}\n\n.mdi-format-header-equal::before {\n  content: \"\\F0272\";\n}\n\n.mdi-format-header-increase::before {\n  content: \"\\F0273\";\n}\n\n.mdi-format-header-pound::before {\n  content: \"\\F0274\";\n}\n\n.mdi-format-horizontal-align-center::before {\n  content: \"\\F061E\";\n}\n\n.mdi-format-horizontal-align-left::before {\n  content: \"\\F061F\";\n}\n\n.mdi-format-horizontal-align-right::before {\n  content: \"\\F0620\";\n}\n\n.mdi-format-indent-decrease::before {\n  content: \"\\F0275\";\n}\n\n.mdi-format-indent-increase::before {\n  content: \"\\F0276\";\n}\n\n.mdi-format-italic::before {\n  content: \"\\F0277\";\n}\n\n.mdi-format-letter-case::before {\n  content: \"\\F0B34\";\n}\n\n.mdi-format-letter-case-lower::before {\n  content: \"\\F0B35\";\n}\n\n.mdi-format-letter-case-upper::before {\n  content: \"\\F0B36\";\n}\n\n.mdi-format-letter-ends-with::before {\n  content: \"\\F0FB8\";\n}\n\n.mdi-format-letter-matches::before {\n  content: \"\\F0FB9\";\n}\n\n.mdi-format-letter-spacing::before {\n  content: \"\\F1956\";\n}\n\n.mdi-format-letter-starts-with::before {\n  content: \"\\F0FBA\";\n}\n\n.mdi-format-line-spacing::before {\n  content: \"\\F0278\";\n}\n\n.mdi-format-line-style::before {\n  content: \"\\F05C8\";\n}\n\n.mdi-format-line-weight::before {\n  content: \"\\F05C9\";\n}\n\n.mdi-format-list-bulleted::before {\n  content: \"\\F0279\";\n}\n\n.mdi-format-list-bulleted-square::before {\n  content: \"\\F0DD0\";\n}\n\n.mdi-format-list-bulleted-triangle::before {\n  content: \"\\F0EB2\";\n}\n\n.mdi-format-list-bulleted-type::before {\n  content: \"\\F027A\";\n}\n\n.mdi-format-list-checkbox::before {\n  content: \"\\F096A\";\n}\n\n.mdi-format-list-checks::before {\n  content: \"\\F0756\";\n}\n\n.mdi-format-list-group::before {\n  content: \"\\F1860\";\n}\n\n.mdi-format-list-numbered::before {\n  content: \"\\F027B\";\n}\n\n.mdi-format-list-numbered-rtl::before {\n  content: \"\\F0D0D\";\n}\n\n.mdi-format-list-text::before {\n  content: \"\\F126F\";\n}\n\n.mdi-format-overline::before {\n  content: \"\\F0EB3\";\n}\n\n.mdi-format-page-break::before {\n  content: \"\\F06D7\";\n}\n\n.mdi-format-page-split::before {\n  content: \"\\F1917\";\n}\n\n.mdi-format-paint::before {\n  content: \"\\F027C\";\n}\n\n.mdi-format-paragraph::before {\n  content: \"\\F027D\";\n}\n\n.mdi-format-pilcrow::before {\n  content: \"\\F06D8\";\n}\n\n.mdi-format-quote-close::before {\n  content: \"\\F027E\";\n}\n\n.mdi-format-quote-close-outline::before {\n  content: \"\\F11A8\";\n}\n\n.mdi-format-quote-open::before {\n  content: \"\\F0757\";\n}\n\n.mdi-format-quote-open-outline::before {\n  content: \"\\F11A7\";\n}\n\n.mdi-format-rotate-90::before {\n  content: \"\\F06AA\";\n}\n\n.mdi-format-section::before {\n  content: \"\\F069F\";\n}\n\n.mdi-format-size::before {\n  content: \"\\F027F\";\n}\n\n.mdi-format-strikethrough::before {\n  content: \"\\F0280\";\n}\n\n.mdi-format-strikethrough-variant::before {\n  content: \"\\F0281\";\n}\n\n.mdi-format-subscript::before {\n  content: \"\\F0282\";\n}\n\n.mdi-format-superscript::before {\n  content: \"\\F0283\";\n}\n\n.mdi-format-text::before {\n  content: \"\\F0284\";\n}\n\n.mdi-format-text-rotation-angle-down::before {\n  content: \"\\F0FBB\";\n}\n\n.mdi-format-text-rotation-angle-up::before {\n  content: \"\\F0FBC\";\n}\n\n.mdi-format-text-rotation-down::before {\n  content: \"\\F0D73\";\n}\n\n.mdi-format-text-rotation-down-vertical::before {\n  content: \"\\F0FBD\";\n}\n\n.mdi-format-text-rotation-none::before {\n  content: \"\\F0D74\";\n}\n\n.mdi-format-text-rotation-up::before {\n  content: \"\\F0FBE\";\n}\n\n.mdi-format-text-rotation-vertical::before {\n  content: \"\\F0FBF\";\n}\n\n.mdi-format-text-variant::before {\n  content: \"\\F0E32\";\n}\n\n.mdi-format-text-variant-outline::before {\n  content: \"\\F150F\";\n}\n\n.mdi-format-text-wrapping-clip::before {\n  content: \"\\F0D0E\";\n}\n\n.mdi-format-text-wrapping-overflow::before {\n  content: \"\\F0D0F\";\n}\n\n.mdi-format-text-wrapping-wrap::before {\n  content: \"\\F0D10\";\n}\n\n.mdi-format-textbox::before {\n  content: \"\\F0D11\";\n}\n\n.mdi-format-textdirection-l-to-r::before {\n  content: \"\\F0285\";\n}\n\n.mdi-format-textdirection-r-to-l::before {\n  content: \"\\F0286\";\n}\n\n.mdi-format-title::before {\n  content: \"\\F05F4\";\n}\n\n.mdi-format-underline::before {\n  content: \"\\F0287\";\n}\n\n.mdi-format-underline-wavy::before {\n  content: \"\\F18E9\";\n}\n\n.mdi-format-vertical-align-bottom::before {\n  content: \"\\F0621\";\n}\n\n.mdi-format-vertical-align-center::before {\n  content: \"\\F0622\";\n}\n\n.mdi-format-vertical-align-top::before {\n  content: \"\\F0623\";\n}\n\n.mdi-format-wrap-inline::before {\n  content: \"\\F0288\";\n}\n\n.mdi-format-wrap-square::before {\n  content: \"\\F0289\";\n}\n\n.mdi-format-wrap-tight::before {\n  content: \"\\F028A\";\n}\n\n.mdi-format-wrap-top-bottom::before {\n  content: \"\\F028B\";\n}\n\n.mdi-forum::before {\n  content: \"\\F028C\";\n}\n\n.mdi-forum-outline::before {\n  content: \"\\F0822\";\n}\n\n.mdi-forward::before {\n  content: \"\\F028D\";\n}\n\n.mdi-forwardburger::before {\n  content: \"\\F0D75\";\n}\n\n.mdi-fountain::before {\n  content: \"\\F096B\";\n}\n\n.mdi-fountain-pen::before {\n  content: \"\\F0D12\";\n}\n\n.mdi-fountain-pen-tip::before {\n  content: \"\\F0D13\";\n}\n\n.mdi-fraction-one-half::before {\n  content: \"\\F1992\";\n}\n\n.mdi-freebsd::before {\n  content: \"\\F08E0\";\n}\n\n.mdi-french-fries::before {\n  content: \"\\F1957\";\n}\n\n.mdi-frequently-asked-questions::before {\n  content: \"\\F0EB4\";\n}\n\n.mdi-fridge::before {\n  content: \"\\F0290\";\n}\n\n.mdi-fridge-alert::before {\n  content: \"\\F11B1\";\n}\n\n.mdi-fridge-alert-outline::before {\n  content: \"\\F11B2\";\n}\n\n.mdi-fridge-bottom::before {\n  content: \"\\F0292\";\n}\n\n.mdi-fridge-industrial::before {\n  content: \"\\F15EE\";\n}\n\n.mdi-fridge-industrial-alert::before {\n  content: \"\\F15EF\";\n}\n\n.mdi-fridge-industrial-alert-outline::before {\n  content: \"\\F15F0\";\n}\n\n.mdi-fridge-industrial-off::before {\n  content: \"\\F15F1\";\n}\n\n.mdi-fridge-industrial-off-outline::before {\n  content: \"\\F15F2\";\n}\n\n.mdi-fridge-industrial-outline::before {\n  content: \"\\F15F3\";\n}\n\n.mdi-fridge-off::before {\n  content: \"\\F11AF\";\n}\n\n.mdi-fridge-off-outline::before {\n  content: \"\\F11B0\";\n}\n\n.mdi-fridge-outline::before {\n  content: \"\\F028F\";\n}\n\n.mdi-fridge-top::before {\n  content: \"\\F0291\";\n}\n\n.mdi-fridge-variant::before {\n  content: \"\\F15F4\";\n}\n\n.mdi-fridge-variant-alert::before {\n  content: \"\\F15F5\";\n}\n\n.mdi-fridge-variant-alert-outline::before {\n  content: \"\\F15F6\";\n}\n\n.mdi-fridge-variant-off::before {\n  content: \"\\F15F7\";\n}\n\n.mdi-fridge-variant-off-outline::before {\n  content: \"\\F15F8\";\n}\n\n.mdi-fridge-variant-outline::before {\n  content: \"\\F15F9\";\n}\n\n.mdi-fruit-cherries::before {\n  content: \"\\F1042\";\n}\n\n.mdi-fruit-cherries-off::before {\n  content: \"\\F13F8\";\n}\n\n.mdi-fruit-citrus::before {\n  content: \"\\F1043\";\n}\n\n.mdi-fruit-citrus-off::before {\n  content: \"\\F13F9\";\n}\n\n.mdi-fruit-grapes::before {\n  content: \"\\F1044\";\n}\n\n.mdi-fruit-grapes-outline::before {\n  content: \"\\F1045\";\n}\n\n.mdi-fruit-pineapple::before {\n  content: \"\\F1046\";\n}\n\n.mdi-fruit-watermelon::before {\n  content: \"\\F1047\";\n}\n\n.mdi-fuel::before {\n  content: \"\\F07CA\";\n}\n\n.mdi-fuel-cell::before {\n  content: \"\\F18B5\";\n}\n\n.mdi-fullscreen::before {\n  content: \"\\F0293\";\n}\n\n.mdi-fullscreen-exit::before {\n  content: \"\\F0294\";\n}\n\n.mdi-function::before {\n  content: \"\\F0295\";\n}\n\n.mdi-function-variant::before {\n  content: \"\\F0871\";\n}\n\n.mdi-furigana-horizontal::before {\n  content: \"\\F1081\";\n}\n\n.mdi-furigana-vertical::before {\n  content: \"\\F1082\";\n}\n\n.mdi-fuse::before {\n  content: \"\\F0C85\";\n}\n\n.mdi-fuse-alert::before {\n  content: \"\\F142D\";\n}\n\n.mdi-fuse-blade::before {\n  content: \"\\F0C86\";\n}\n\n.mdi-fuse-off::before {\n  content: \"\\F142C\";\n}\n\n.mdi-gamepad::before {\n  content: \"\\F0296\";\n}\n\n.mdi-gamepad-circle::before {\n  content: \"\\F0E33\";\n}\n\n.mdi-gamepad-circle-down::before {\n  content: \"\\F0E34\";\n}\n\n.mdi-gamepad-circle-left::before {\n  content: \"\\F0E35\";\n}\n\n.mdi-gamepad-circle-outline::before {\n  content: \"\\F0E36\";\n}\n\n.mdi-gamepad-circle-right::before {\n  content: \"\\F0E37\";\n}\n\n.mdi-gamepad-circle-up::before {\n  content: \"\\F0E38\";\n}\n\n.mdi-gamepad-down::before {\n  content: \"\\F0E39\";\n}\n\n.mdi-gamepad-left::before {\n  content: \"\\F0E3A\";\n}\n\n.mdi-gamepad-outline::before {\n  content: \"\\F1919\";\n}\n\n.mdi-gamepad-right::before {\n  content: \"\\F0E3B\";\n}\n\n.mdi-gamepad-round::before {\n  content: \"\\F0E3C\";\n}\n\n.mdi-gamepad-round-down::before {\n  content: \"\\F0E3D\";\n}\n\n.mdi-gamepad-round-left::before {\n  content: \"\\F0E3E\";\n}\n\n.mdi-gamepad-round-outline::before {\n  content: \"\\F0E3F\";\n}\n\n.mdi-gamepad-round-right::before {\n  content: \"\\F0E40\";\n}\n\n.mdi-gamepad-round-up::before {\n  content: \"\\F0E41\";\n}\n\n.mdi-gamepad-square::before {\n  content: \"\\F0EB5\";\n}\n\n.mdi-gamepad-square-outline::before {\n  content: \"\\F0EB6\";\n}\n\n.mdi-gamepad-up::before {\n  content: \"\\F0E42\";\n}\n\n.mdi-gamepad-variant::before {\n  content: \"\\F0297\";\n}\n\n.mdi-gamepad-variant-outline::before {\n  content: \"\\F0EB7\";\n}\n\n.mdi-gamma::before {\n  content: \"\\F10EE\";\n}\n\n.mdi-gantry-crane::before {\n  content: \"\\F0DD1\";\n}\n\n.mdi-garage::before {\n  content: \"\\F06D9\";\n}\n\n.mdi-garage-alert::before {\n  content: \"\\F0872\";\n}\n\n.mdi-garage-alert-variant::before {\n  content: \"\\F12D5\";\n}\n\n.mdi-garage-lock::before {\n  content: \"\\F17FB\";\n}\n\n.mdi-garage-open::before {\n  content: \"\\F06DA\";\n}\n\n.mdi-garage-open-variant::before {\n  content: \"\\F12D4\";\n}\n\n.mdi-garage-variant::before {\n  content: \"\\F12D3\";\n}\n\n.mdi-garage-variant-lock::before {\n  content: \"\\F17FC\";\n}\n\n.mdi-gas-cylinder::before {\n  content: \"\\F0647\";\n}\n\n.mdi-gas-station::before {\n  content: \"\\F0298\";\n}\n\n.mdi-gas-station-off::before {\n  content: \"\\F1409\";\n}\n\n.mdi-gas-station-off-outline::before {\n  content: \"\\F140A\";\n}\n\n.mdi-gas-station-outline::before {\n  content: \"\\F0EB8\";\n}\n\n.mdi-gate::before {\n  content: \"\\F0299\";\n}\n\n.mdi-gate-alert::before {\n  content: \"\\F17F8\";\n}\n\n.mdi-gate-and::before {\n  content: \"\\F08E1\";\n}\n\n.mdi-gate-arrow-left::before {\n  content: \"\\F17F7\";\n}\n\n.mdi-gate-arrow-right::before {\n  content: \"\\F1169\";\n}\n\n.mdi-gate-nand::before {\n  content: \"\\F08E2\";\n}\n\n.mdi-gate-nor::before {\n  content: \"\\F08E3\";\n}\n\n.mdi-gate-not::before {\n  content: \"\\F08E4\";\n}\n\n.mdi-gate-open::before {\n  content: \"\\F116A\";\n}\n\n.mdi-gate-or::before {\n  content: \"\\F08E5\";\n}\n\n.mdi-gate-xnor::before {\n  content: \"\\F08E6\";\n}\n\n.mdi-gate-xor::before {\n  content: \"\\F08E7\";\n}\n\n.mdi-gatsby::before {\n  content: \"\\F0E43\";\n}\n\n.mdi-gauge::before {\n  content: \"\\F029A\";\n}\n\n.mdi-gauge-empty::before {\n  content: \"\\F0873\";\n}\n\n.mdi-gauge-full::before {\n  content: \"\\F0874\";\n}\n\n.mdi-gauge-low::before {\n  content: \"\\F0875\";\n}\n\n.mdi-gavel::before {\n  content: \"\\F029B\";\n}\n\n.mdi-gender-female::before {\n  content: \"\\F029C\";\n}\n\n.mdi-gender-male::before {\n  content: \"\\F029D\";\n}\n\n.mdi-gender-male-female::before {\n  content: \"\\F029E\";\n}\n\n.mdi-gender-male-female-variant::before {\n  content: \"\\F113F\";\n}\n\n.mdi-gender-non-binary::before {\n  content: \"\\F1140\";\n}\n\n.mdi-gender-transgender::before {\n  content: \"\\F029F\";\n}\n\n.mdi-gentoo::before {\n  content: \"\\F08E8\";\n}\n\n.mdi-gesture::before {\n  content: \"\\F07CB\";\n}\n\n.mdi-gesture-double-tap::before {\n  content: \"\\F073C\";\n}\n\n.mdi-gesture-pinch::before {\n  content: \"\\F0ABD\";\n}\n\n.mdi-gesture-spread::before {\n  content: \"\\F0ABE\";\n}\n\n.mdi-gesture-swipe::before {\n  content: \"\\F0D76\";\n}\n\n.mdi-gesture-swipe-down::before {\n  content: \"\\F073D\";\n}\n\n.mdi-gesture-swipe-horizontal::before {\n  content: \"\\F0ABF\";\n}\n\n.mdi-gesture-swipe-left::before {\n  content: \"\\F073E\";\n}\n\n.mdi-gesture-swipe-right::before {\n  content: \"\\F073F\";\n}\n\n.mdi-gesture-swipe-up::before {\n  content: \"\\F0740\";\n}\n\n.mdi-gesture-swipe-vertical::before {\n  content: \"\\F0AC0\";\n}\n\n.mdi-gesture-tap::before {\n  content: \"\\F0741\";\n}\n\n.mdi-gesture-tap-box::before {\n  content: \"\\F12A9\";\n}\n\n.mdi-gesture-tap-button::before {\n  content: \"\\F12A8\";\n}\n\n.mdi-gesture-tap-hold::before {\n  content: \"\\F0D77\";\n}\n\n.mdi-gesture-two-double-tap::before {\n  content: \"\\F0742\";\n}\n\n.mdi-gesture-two-tap::before {\n  content: \"\\F0743\";\n}\n\n.mdi-ghost::before {\n  content: \"\\F02A0\";\n}\n\n.mdi-ghost-off::before {\n  content: \"\\F09F5\";\n}\n\n.mdi-ghost-off-outline::before {\n  content: \"\\F165C\";\n}\n\n.mdi-ghost-outline::before {\n  content: \"\\F165D\";\n}\n\n.mdi-gift::before {\n  content: \"\\F0E44\";\n}\n\n.mdi-gift-off::before {\n  content: \"\\F16EF\";\n}\n\n.mdi-gift-off-outline::before {\n  content: \"\\F16F0\";\n}\n\n.mdi-gift-open::before {\n  content: \"\\F16F1\";\n}\n\n.mdi-gift-open-outline::before {\n  content: \"\\F16F2\";\n}\n\n.mdi-gift-outline::before {\n  content: \"\\F02A1\";\n}\n\n.mdi-git::before {\n  content: \"\\F02A2\";\n}\n\n.mdi-github::before {\n  content: \"\\F02A4\";\n}\n\n.mdi-gitlab::before {\n  content: \"\\F0BA0\";\n}\n\n.mdi-glass-cocktail::before {\n  content: \"\\F0356\";\n}\n\n.mdi-glass-cocktail-off::before {\n  content: \"\\F15E6\";\n}\n\n.mdi-glass-flute::before {\n  content: \"\\F02A5\";\n}\n\n.mdi-glass-fragile::before {\n  content: \"\\F1873\";\n}\n\n.mdi-glass-mug::before {\n  content: \"\\F02A6\";\n}\n\n.mdi-glass-mug-off::before {\n  content: \"\\F15E7\";\n}\n\n.mdi-glass-mug-variant::before {\n  content: \"\\F1116\";\n}\n\n.mdi-glass-mug-variant-off::before {\n  content: \"\\F15E8\";\n}\n\n.mdi-glass-pint-outline::before {\n  content: \"\\F130D\";\n}\n\n.mdi-glass-stange::before {\n  content: \"\\F02A7\";\n}\n\n.mdi-glass-tulip::before {\n  content: \"\\F02A8\";\n}\n\n.mdi-glass-wine::before {\n  content: \"\\F0876\";\n}\n\n.mdi-glasses::before {\n  content: \"\\F02AA\";\n}\n\n.mdi-globe-light::before {\n  content: \"\\F12D7\";\n}\n\n.mdi-globe-model::before {\n  content: \"\\F08E9\";\n}\n\n.mdi-gmail::before {\n  content: \"\\F02AB\";\n}\n\n.mdi-gnome::before {\n  content: \"\\F02AC\";\n}\n\n.mdi-go-kart::before {\n  content: \"\\F0D79\";\n}\n\n.mdi-go-kart-track::before {\n  content: \"\\F0D7A\";\n}\n\n.mdi-gog::before {\n  content: \"\\F0BA1\";\n}\n\n.mdi-gold::before {\n  content: \"\\F124F\";\n}\n\n.mdi-golf::before {\n  content: \"\\F0823\";\n}\n\n.mdi-golf-cart::before {\n  content: \"\\F11A4\";\n}\n\n.mdi-golf-tee::before {\n  content: \"\\F1083\";\n}\n\n.mdi-gondola::before {\n  content: \"\\F0686\";\n}\n\n.mdi-goodreads::before {\n  content: \"\\F0D7B\";\n}\n\n.mdi-google::before {\n  content: \"\\F02AD\";\n}\n\n.mdi-google-ads::before {\n  content: \"\\F0C87\";\n}\n\n.mdi-google-analytics::before {\n  content: \"\\F07CC\";\n}\n\n.mdi-google-assistant::before {\n  content: \"\\F07CD\";\n}\n\n.mdi-google-cardboard::before {\n  content: \"\\F02AE\";\n}\n\n.mdi-google-chrome::before {\n  content: \"\\F02AF\";\n}\n\n.mdi-google-circles::before {\n  content: \"\\F02B0\";\n}\n\n.mdi-google-circles-communities::before {\n  content: \"\\F02B1\";\n}\n\n.mdi-google-circles-extended::before {\n  content: \"\\F02B2\";\n}\n\n.mdi-google-circles-group::before {\n  content: \"\\F02B3\";\n}\n\n.mdi-google-classroom::before {\n  content: \"\\F02C0\";\n}\n\n.mdi-google-cloud::before {\n  content: \"\\F11F6\";\n}\n\n.mdi-google-controller::before {\n  content: \"\\F02B4\";\n}\n\n.mdi-google-controller-off::before {\n  content: \"\\F02B5\";\n}\n\n.mdi-google-downasaur::before {\n  content: \"\\F1362\";\n}\n\n.mdi-google-drive::before {\n  content: \"\\F02B6\";\n}\n\n.mdi-google-earth::before {\n  content: \"\\F02B7\";\n}\n\n.mdi-google-fit::before {\n  content: \"\\F096C\";\n}\n\n.mdi-google-glass::before {\n  content: \"\\F02B8\";\n}\n\n.mdi-google-hangouts::before {\n  content: \"\\F02C9\";\n}\n\n.mdi-google-home::before {\n  content: \"\\F0824\";\n}\n\n.mdi-google-keep::before {\n  content: \"\\F06DC\";\n}\n\n.mdi-google-lens::before {\n  content: \"\\F09F6\";\n}\n\n.mdi-google-maps::before {\n  content: \"\\F05F5\";\n}\n\n.mdi-google-my-business::before {\n  content: \"\\F1048\";\n}\n\n.mdi-google-nearby::before {\n  content: \"\\F02B9\";\n}\n\n.mdi-google-play::before {\n  content: \"\\F02BC\";\n}\n\n.mdi-google-plus::before {\n  content: \"\\F02BD\";\n}\n\n.mdi-google-podcast::before {\n  content: \"\\F0EB9\";\n}\n\n.mdi-google-spreadsheet::before {\n  content: \"\\F09F7\";\n}\n\n.mdi-google-street-view::before {\n  content: \"\\F0C88\";\n}\n\n.mdi-google-translate::before {\n  content: \"\\F02BF\";\n}\n\n.mdi-gradient-horizontal::before {\n  content: \"\\F174A\";\n}\n\n.mdi-gradient-vertical::before {\n  content: \"\\F06A0\";\n}\n\n.mdi-grain::before {\n  content: \"\\F0D7C\";\n}\n\n.mdi-graph::before {\n  content: \"\\F1049\";\n}\n\n.mdi-graph-outline::before {\n  content: \"\\F104A\";\n}\n\n.mdi-graphql::before {\n  content: \"\\F0877\";\n}\n\n.mdi-grass::before {\n  content: \"\\F1510\";\n}\n\n.mdi-grave-stone::before {\n  content: \"\\F0BA2\";\n}\n\n.mdi-grease-pencil::before {\n  content: \"\\F0648\";\n}\n\n.mdi-greater-than::before {\n  content: \"\\F096D\";\n}\n\n.mdi-greater-than-or-equal::before {\n  content: \"\\F096E\";\n}\n\n.mdi-greenhouse::before {\n  content: \"\\F002D\";\n}\n\n.mdi-grid::before {\n  content: \"\\F02C1\";\n}\n\n.mdi-grid-large::before {\n  content: \"\\F0758\";\n}\n\n.mdi-grid-off::before {\n  content: \"\\F02C2\";\n}\n\n.mdi-grill::before {\n  content: \"\\F0E45\";\n}\n\n.mdi-grill-outline::before {\n  content: \"\\F118A\";\n}\n\n.mdi-group::before {\n  content: \"\\F02C3\";\n}\n\n.mdi-guitar-acoustic::before {\n  content: \"\\F0771\";\n}\n\n.mdi-guitar-electric::before {\n  content: \"\\F02C4\";\n}\n\n.mdi-guitar-pick::before {\n  content: \"\\F02C5\";\n}\n\n.mdi-guitar-pick-outline::before {\n  content: \"\\F02C6\";\n}\n\n.mdi-guy-fawkes-mask::before {\n  content: \"\\F0825\";\n}\n\n.mdi-hail::before {\n  content: \"\\F0AC1\";\n}\n\n.mdi-hair-dryer::before {\n  content: \"\\F10EF\";\n}\n\n.mdi-hair-dryer-outline::before {\n  content: \"\\F10F0\";\n}\n\n.mdi-halloween::before {\n  content: \"\\F0BA3\";\n}\n\n.mdi-hamburger::before {\n  content: \"\\F0685\";\n}\n\n.mdi-hamburger-check::before {\n  content: \"\\F1776\";\n}\n\n.mdi-hamburger-minus::before {\n  content: \"\\F1777\";\n}\n\n.mdi-hamburger-off::before {\n  content: \"\\F1778\";\n}\n\n.mdi-hamburger-plus::before {\n  content: \"\\F1779\";\n}\n\n.mdi-hamburger-remove::before {\n  content: \"\\F177A\";\n}\n\n.mdi-hammer::before {\n  content: \"\\F08EA\";\n}\n\n.mdi-hammer-screwdriver::before {\n  content: \"\\F1322\";\n}\n\n.mdi-hammer-sickle::before {\n  content: \"\\F1887\";\n}\n\n.mdi-hammer-wrench::before {\n  content: \"\\F1323\";\n}\n\n.mdi-hand-back-left::before {\n  content: \"\\F0E46\";\n}\n\n.mdi-hand-back-left-off::before {\n  content: \"\\F1830\";\n}\n\n.mdi-hand-back-left-off-outline::before {\n  content: \"\\F1832\";\n}\n\n.mdi-hand-back-left-outline::before {\n  content: \"\\F182C\";\n}\n\n.mdi-hand-back-right::before {\n  content: \"\\F0E47\";\n}\n\n.mdi-hand-back-right-off::before {\n  content: \"\\F1831\";\n}\n\n.mdi-hand-back-right-off-outline::before {\n  content: \"\\F1833\";\n}\n\n.mdi-hand-back-right-outline::before {\n  content: \"\\F182D\";\n}\n\n.mdi-hand-clap::before {\n  content: \"\\F194B\";\n}\n\n.mdi-hand-coin::before {\n  content: \"\\F188F\";\n}\n\n.mdi-hand-coin-outline::before {\n  content: \"\\F1890\";\n}\n\n.mdi-hand-extended::before {\n  content: \"\\F18B6\";\n}\n\n.mdi-hand-extended-outline::before {\n  content: \"\\F18B7\";\n}\n\n.mdi-hand-front-left::before {\n  content: \"\\F182B\";\n}\n\n.mdi-hand-front-left-outline::before {\n  content: \"\\F182E\";\n}\n\n.mdi-hand-front-right::before {\n  content: \"\\F0A4F\";\n}\n\n.mdi-hand-front-right-outline::before {\n  content: \"\\F182F\";\n}\n\n.mdi-hand-heart::before {\n  content: \"\\F10F1\";\n}\n\n.mdi-hand-heart-outline::before {\n  content: \"\\F157E\";\n}\n\n.mdi-hand-okay::before {\n  content: \"\\F0A50\";\n}\n\n.mdi-hand-peace::before {\n  content: \"\\F0A51\";\n}\n\n.mdi-hand-peace-variant::before {\n  content: \"\\F0A52\";\n}\n\n.mdi-hand-pointing-down::before {\n  content: \"\\F0A53\";\n}\n\n.mdi-hand-pointing-left::before {\n  content: \"\\F0A54\";\n}\n\n.mdi-hand-pointing-right::before {\n  content: \"\\F02C7\";\n}\n\n.mdi-hand-pointing-up::before {\n  content: \"\\F0A55\";\n}\n\n.mdi-hand-saw::before {\n  content: \"\\F0E48\";\n}\n\n.mdi-hand-wash::before {\n  content: \"\\F157F\";\n}\n\n.mdi-hand-wash-outline::before {\n  content: \"\\F1580\";\n}\n\n.mdi-hand-water::before {\n  content: \"\\F139F\";\n}\n\n.mdi-hand-wave::before {\n  content: \"\\F1821\";\n}\n\n.mdi-hand-wave-outline::before {\n  content: \"\\F1822\";\n}\n\n.mdi-handball::before {\n  content: \"\\F0F53\";\n}\n\n.mdi-handcuffs::before {\n  content: \"\\F113E\";\n}\n\n.mdi-hands-pray::before {\n  content: \"\\F0579\";\n}\n\n.mdi-handshake::before {\n  content: \"\\F1218\";\n}\n\n.mdi-handshake-outline::before {\n  content: \"\\F15A1\";\n}\n\n.mdi-hanger::before {\n  content: \"\\F02C8\";\n}\n\n.mdi-hard-hat::before {\n  content: \"\\F096F\";\n}\n\n.mdi-harddisk::before {\n  content: \"\\F02CA\";\n}\n\n.mdi-harddisk-plus::before {\n  content: \"\\F104B\";\n}\n\n.mdi-harddisk-remove::before {\n  content: \"\\F104C\";\n}\n\n.mdi-hat-fedora::before {\n  content: \"\\F0BA4\";\n}\n\n.mdi-hazard-lights::before {\n  content: \"\\F0C89\";\n}\n\n.mdi-hdr::before {\n  content: \"\\F0D7D\";\n}\n\n.mdi-hdr-off::before {\n  content: \"\\F0D7E\";\n}\n\n.mdi-head::before {\n  content: \"\\F135E\";\n}\n\n.mdi-head-alert::before {\n  content: \"\\F1338\";\n}\n\n.mdi-head-alert-outline::before {\n  content: \"\\F1339\";\n}\n\n.mdi-head-check::before {\n  content: \"\\F133A\";\n}\n\n.mdi-head-check-outline::before {\n  content: \"\\F133B\";\n}\n\n.mdi-head-cog::before {\n  content: \"\\F133C\";\n}\n\n.mdi-head-cog-outline::before {\n  content: \"\\F133D\";\n}\n\n.mdi-head-dots-horizontal::before {\n  content: \"\\F133E\";\n}\n\n.mdi-head-dots-horizontal-outline::before {\n  content: \"\\F133F\";\n}\n\n.mdi-head-flash::before {\n  content: \"\\F1340\";\n}\n\n.mdi-head-flash-outline::before {\n  content: \"\\F1341\";\n}\n\n.mdi-head-heart::before {\n  content: \"\\F1342\";\n}\n\n.mdi-head-heart-outline::before {\n  content: \"\\F1343\";\n}\n\n.mdi-head-lightbulb::before {\n  content: \"\\F1344\";\n}\n\n.mdi-head-lightbulb-outline::before {\n  content: \"\\F1345\";\n}\n\n.mdi-head-minus::before {\n  content: \"\\F1346\";\n}\n\n.mdi-head-minus-outline::before {\n  content: \"\\F1347\";\n}\n\n.mdi-head-outline::before {\n  content: \"\\F135F\";\n}\n\n.mdi-head-plus::before {\n  content: \"\\F1348\";\n}\n\n.mdi-head-plus-outline::before {\n  content: \"\\F1349\";\n}\n\n.mdi-head-question::before {\n  content: \"\\F134A\";\n}\n\n.mdi-head-question-outline::before {\n  content: \"\\F134B\";\n}\n\n.mdi-head-remove::before {\n  content: \"\\F134C\";\n}\n\n.mdi-head-remove-outline::before {\n  content: \"\\F134D\";\n}\n\n.mdi-head-snowflake::before {\n  content: \"\\F134E\";\n}\n\n.mdi-head-snowflake-outline::before {\n  content: \"\\F134F\";\n}\n\n.mdi-head-sync::before {\n  content: \"\\F1350\";\n}\n\n.mdi-head-sync-outline::before {\n  content: \"\\F1351\";\n}\n\n.mdi-headphones::before {\n  content: \"\\F02CB\";\n}\n\n.mdi-headphones-bluetooth::before {\n  content: \"\\F0970\";\n}\n\n.mdi-headphones-box::before {\n  content: \"\\F02CC\";\n}\n\n.mdi-headphones-off::before {\n  content: \"\\F07CE\";\n}\n\n.mdi-headphones-settings::before {\n  content: \"\\F02CD\";\n}\n\n.mdi-headset::before {\n  content: \"\\F02CE\";\n}\n\n.mdi-headset-dock::before {\n  content: \"\\F02CF\";\n}\n\n.mdi-headset-off::before {\n  content: \"\\F02D0\";\n}\n\n.mdi-heart::before {\n  content: \"\\F02D1\";\n}\n\n.mdi-heart-box::before {\n  content: \"\\F02D2\";\n}\n\n.mdi-heart-box-outline::before {\n  content: \"\\F02D3\";\n}\n\n.mdi-heart-broken::before {\n  content: \"\\F02D4\";\n}\n\n.mdi-heart-broken-outline::before {\n  content: \"\\F0D14\";\n}\n\n.mdi-heart-circle::before {\n  content: \"\\F0971\";\n}\n\n.mdi-heart-circle-outline::before {\n  content: \"\\F0972\";\n}\n\n.mdi-heart-cog::before {\n  content: \"\\F1663\";\n}\n\n.mdi-heart-cog-outline::before {\n  content: \"\\F1664\";\n}\n\n.mdi-heart-flash::before {\n  content: \"\\F0EF9\";\n}\n\n.mdi-heart-half::before {\n  content: \"\\F06DF\";\n}\n\n.mdi-heart-half-full::before {\n  content: \"\\F06DE\";\n}\n\n.mdi-heart-half-outline::before {\n  content: \"\\F06E0\";\n}\n\n.mdi-heart-minus::before {\n  content: \"\\F142F\";\n}\n\n.mdi-heart-minus-outline::before {\n  content: \"\\F1432\";\n}\n\n.mdi-heart-multiple::before {\n  content: \"\\F0A56\";\n}\n\n.mdi-heart-multiple-outline::before {\n  content: \"\\F0A57\";\n}\n\n.mdi-heart-off::before {\n  content: \"\\F0759\";\n}\n\n.mdi-heart-off-outline::before {\n  content: \"\\F1434\";\n}\n\n.mdi-heart-outline::before {\n  content: \"\\F02D5\";\n}\n\n.mdi-heart-plus::before {\n  content: \"\\F142E\";\n}\n\n.mdi-heart-plus-outline::before {\n  content: \"\\F1431\";\n}\n\n.mdi-heart-pulse::before {\n  content: \"\\F05F6\";\n}\n\n.mdi-heart-remove::before {\n  content: \"\\F1430\";\n}\n\n.mdi-heart-remove-outline::before {\n  content: \"\\F1433\";\n}\n\n.mdi-heart-settings::before {\n  content: \"\\F1665\";\n}\n\n.mdi-heart-settings-outline::before {\n  content: \"\\F1666\";\n}\n\n.mdi-helicopter::before {\n  content: \"\\F0AC2\";\n}\n\n.mdi-help::before {\n  content: \"\\F02D6\";\n}\n\n.mdi-help-box::before {\n  content: \"\\F078B\";\n}\n\n.mdi-help-circle::before {\n  content: \"\\F02D7\";\n}\n\n.mdi-help-circle-outline::before {\n  content: \"\\F0625\";\n}\n\n.mdi-help-network::before {\n  content: \"\\F06F5\";\n}\n\n.mdi-help-network-outline::before {\n  content: \"\\F0C8A\";\n}\n\n.mdi-help-rhombus::before {\n  content: \"\\F0BA5\";\n}\n\n.mdi-help-rhombus-outline::before {\n  content: \"\\F0BA6\";\n}\n\n.mdi-hexadecimal::before {\n  content: \"\\F12A7\";\n}\n\n.mdi-hexagon::before {\n  content: \"\\F02D8\";\n}\n\n.mdi-hexagon-multiple::before {\n  content: \"\\F06E1\";\n}\n\n.mdi-hexagon-multiple-outline::before {\n  content: \"\\F10F2\";\n}\n\n.mdi-hexagon-outline::before {\n  content: \"\\F02D9\";\n}\n\n.mdi-hexagon-slice-1::before {\n  content: \"\\F0AC3\";\n}\n\n.mdi-hexagon-slice-2::before {\n  content: \"\\F0AC4\";\n}\n\n.mdi-hexagon-slice-3::before {\n  content: \"\\F0AC5\";\n}\n\n.mdi-hexagon-slice-4::before {\n  content: \"\\F0AC6\";\n}\n\n.mdi-hexagon-slice-5::before {\n  content: \"\\F0AC7\";\n}\n\n.mdi-hexagon-slice-6::before {\n  content: \"\\F0AC8\";\n}\n\n.mdi-hexagram::before {\n  content: \"\\F0AC9\";\n}\n\n.mdi-hexagram-outline::before {\n  content: \"\\F0ACA\";\n}\n\n.mdi-high-definition::before {\n  content: \"\\F07CF\";\n}\n\n.mdi-high-definition-box::before {\n  content: \"\\F0878\";\n}\n\n.mdi-highway::before {\n  content: \"\\F05F7\";\n}\n\n.mdi-hiking::before {\n  content: \"\\F0D7F\";\n}\n\n.mdi-history::before {\n  content: \"\\F02DA\";\n}\n\n.mdi-hockey-puck::before {\n  content: \"\\F0879\";\n}\n\n.mdi-hockey-sticks::before {\n  content: \"\\F087A\";\n}\n\n.mdi-hololens::before {\n  content: \"\\F02DB\";\n}\n\n.mdi-home::before {\n  content: \"\\F02DC\";\n}\n\n.mdi-home-account::before {\n  content: \"\\F0826\";\n}\n\n.mdi-home-alert::before {\n  content: \"\\F087B\";\n}\n\n.mdi-home-alert-outline::before {\n  content: \"\\F15D0\";\n}\n\n.mdi-home-analytics::before {\n  content: \"\\F0EBA\";\n}\n\n.mdi-home-assistant::before {\n  content: \"\\F07D0\";\n}\n\n.mdi-home-automation::before {\n  content: \"\\F07D1\";\n}\n\n.mdi-home-battery::before {\n  content: \"\\F1901\";\n}\n\n.mdi-home-battery-outline::before {\n  content: \"\\F1902\";\n}\n\n.mdi-home-circle::before {\n  content: \"\\F07D2\";\n}\n\n.mdi-home-circle-outline::before {\n  content: \"\\F104D\";\n}\n\n.mdi-home-city::before {\n  content: \"\\F0D15\";\n}\n\n.mdi-home-city-outline::before {\n  content: \"\\F0D16\";\n}\n\n.mdi-home-edit::before {\n  content: \"\\F1159\";\n}\n\n.mdi-home-edit-outline::before {\n  content: \"\\F115A\";\n}\n\n.mdi-home-export-outline::before {\n  content: \"\\F0F9B\";\n}\n\n.mdi-home-flood::before {\n  content: \"\\F0EFA\";\n}\n\n.mdi-home-floor-0::before {\n  content: \"\\F0DD2\";\n}\n\n.mdi-home-floor-1::before {\n  content: \"\\F0D80\";\n}\n\n.mdi-home-floor-2::before {\n  content: \"\\F0D81\";\n}\n\n.mdi-home-floor-3::before {\n  content: \"\\F0D82\";\n}\n\n.mdi-home-floor-a::before {\n  content: \"\\F0D83\";\n}\n\n.mdi-home-floor-b::before {\n  content: \"\\F0D84\";\n}\n\n.mdi-home-floor-g::before {\n  content: \"\\F0D85\";\n}\n\n.mdi-home-floor-l::before {\n  content: \"\\F0D86\";\n}\n\n.mdi-home-floor-negative-1::before {\n  content: \"\\F0DD3\";\n}\n\n.mdi-home-group::before {\n  content: \"\\F0DD4\";\n}\n\n.mdi-home-group-minus::before {\n  content: \"\\F19C1\";\n}\n\n.mdi-home-group-plus::before {\n  content: \"\\F19C0\";\n}\n\n.mdi-home-group-remove::before {\n  content: \"\\F19C2\";\n}\n\n.mdi-home-heart::before {\n  content: \"\\F0827\";\n}\n\n.mdi-home-import-outline::before {\n  content: \"\\F0F9C\";\n}\n\n.mdi-home-lightbulb::before {\n  content: \"\\F1251\";\n}\n\n.mdi-home-lightbulb-outline::before {\n  content: \"\\F1252\";\n}\n\n.mdi-home-lightning-bolt::before {\n  content: \"\\F1903\";\n}\n\n.mdi-home-lightning-bolt-outline::before {\n  content: \"\\F1904\";\n}\n\n.mdi-home-lock::before {\n  content: \"\\F08EB\";\n}\n\n.mdi-home-lock-open::before {\n  content: \"\\F08EC\";\n}\n\n.mdi-home-map-marker::before {\n  content: \"\\F05F8\";\n}\n\n.mdi-home-minus::before {\n  content: \"\\F0974\";\n}\n\n.mdi-home-minus-outline::before {\n  content: \"\\F13D5\";\n}\n\n.mdi-home-modern::before {\n  content: \"\\F02DD\";\n}\n\n.mdi-home-outline::before {\n  content: \"\\F06A1\";\n}\n\n.mdi-home-plus::before {\n  content: \"\\F0975\";\n}\n\n.mdi-home-plus-outline::before {\n  content: \"\\F13D6\";\n}\n\n.mdi-home-remove::before {\n  content: \"\\F1247\";\n}\n\n.mdi-home-remove-outline::before {\n  content: \"\\F13D7\";\n}\n\n.mdi-home-roof::before {\n  content: \"\\F112B\";\n}\n\n.mdi-home-search::before {\n  content: \"\\F13B0\";\n}\n\n.mdi-home-search-outline::before {\n  content: \"\\F13B1\";\n}\n\n.mdi-home-switch::before {\n  content: \"\\F1794\";\n}\n\n.mdi-home-switch-outline::before {\n  content: \"\\F1795\";\n}\n\n.mdi-home-thermometer::before {\n  content: \"\\F0F54\";\n}\n\n.mdi-home-thermometer-outline::before {\n  content: \"\\F0F55\";\n}\n\n.mdi-home-variant::before {\n  content: \"\\F02DE\";\n}\n\n.mdi-home-variant-outline::before {\n  content: \"\\F0BA7\";\n}\n\n.mdi-hook::before {\n  content: \"\\F06E2\";\n}\n\n.mdi-hook-off::before {\n  content: \"\\F06E3\";\n}\n\n.mdi-hoop-house::before {\n  content: \"\\F0E56\";\n}\n\n.mdi-hops::before {\n  content: \"\\F02DF\";\n}\n\n.mdi-horizontal-rotate-clockwise::before {\n  content: \"\\F10F3\";\n}\n\n.mdi-horizontal-rotate-counterclockwise::before {\n  content: \"\\F10F4\";\n}\n\n.mdi-horse::before {\n  content: \"\\F15BF\";\n}\n\n.mdi-horse-human::before {\n  content: \"\\F15C0\";\n}\n\n.mdi-horse-variant::before {\n  content: \"\\F15C1\";\n}\n\n.mdi-horse-variant-fast::before {\n  content: \"\\F186E\";\n}\n\n.mdi-horseshoe::before {\n  content: \"\\F0A58\";\n}\n\n.mdi-hospital::before {\n  content: \"\\F0FF6\";\n}\n\n.mdi-hospital-box::before {\n  content: \"\\F02E0\";\n}\n\n.mdi-hospital-box-outline::before {\n  content: \"\\F0FF7\";\n}\n\n.mdi-hospital-building::before {\n  content: \"\\F02E1\";\n}\n\n.mdi-hospital-marker::before {\n  content: \"\\F02E2\";\n}\n\n.mdi-hot-tub::before {\n  content: \"\\F0828\";\n}\n\n.mdi-hours-24::before {\n  content: \"\\F1478\";\n}\n\n.mdi-hubspot::before {\n  content: \"\\F0D17\";\n}\n\n.mdi-hulu::before {\n  content: \"\\F0829\";\n}\n\n.mdi-human::before {\n  content: \"\\F02E6\";\n}\n\n.mdi-human-baby-changing-table::before {\n  content: \"\\F138B\";\n}\n\n.mdi-human-cane::before {\n  content: \"\\F1581\";\n}\n\n.mdi-human-capacity-decrease::before {\n  content: \"\\F159B\";\n}\n\n.mdi-human-capacity-increase::before {\n  content: \"\\F159C\";\n}\n\n.mdi-human-child::before {\n  content: \"\\F02E7\";\n}\n\n.mdi-human-dolly::before {\n  content: \"\\F1980\";\n}\n\n.mdi-human-edit::before {\n  content: \"\\F14E8\";\n}\n\n.mdi-human-female::before {\n  content: \"\\F0649\";\n}\n\n.mdi-human-female-boy::before {\n  content: \"\\F0A59\";\n}\n\n.mdi-human-female-dance::before {\n  content: \"\\F15C9\";\n}\n\n.mdi-human-female-female::before {\n  content: \"\\F0A5A\";\n}\n\n.mdi-human-female-girl::before {\n  content: \"\\F0A5B\";\n}\n\n.mdi-human-greeting::before {\n  content: \"\\F17C4\";\n}\n\n.mdi-human-greeting-proximity::before {\n  content: \"\\F159D\";\n}\n\n.mdi-human-greeting-variant::before {\n  content: \"\\F064A\";\n}\n\n.mdi-human-handsdown::before {\n  content: \"\\F064B\";\n}\n\n.mdi-human-handsup::before {\n  content: \"\\F064C\";\n}\n\n.mdi-human-male::before {\n  content: \"\\F064D\";\n}\n\n.mdi-human-male-board::before {\n  content: \"\\F0890\";\n}\n\n.mdi-human-male-board-poll::before {\n  content: \"\\F0846\";\n}\n\n.mdi-human-male-boy::before {\n  content: \"\\F0A5C\";\n}\n\n.mdi-human-male-child::before {\n  content: \"\\F138C\";\n}\n\n.mdi-human-male-female::before {\n  content: \"\\F02E8\";\n}\n\n.mdi-human-male-female-child::before {\n  content: \"\\F1823\";\n}\n\n.mdi-human-male-girl::before {\n  content: \"\\F0A5D\";\n}\n\n.mdi-human-male-height::before {\n  content: \"\\F0EFB\";\n}\n\n.mdi-human-male-height-variant::before {\n  content: \"\\F0EFC\";\n}\n\n.mdi-human-male-male::before {\n  content: \"\\F0A5E\";\n}\n\n.mdi-human-non-binary::before {\n  content: \"\\F1848\";\n}\n\n.mdi-human-pregnant::before {\n  content: \"\\F05CF\";\n}\n\n.mdi-human-queue::before {\n  content: \"\\F1571\";\n}\n\n.mdi-human-scooter::before {\n  content: \"\\F11E9\";\n}\n\n.mdi-human-wheelchair::before {\n  content: \"\\F138D\";\n}\n\n.mdi-human-white-cane::before {\n  content: \"\\F1981\";\n}\n\n.mdi-humble-bundle::before {\n  content: \"\\F0744\";\n}\n\n.mdi-hvac::before {\n  content: \"\\F1352\";\n}\n\n.mdi-hvac-off::before {\n  content: \"\\F159E\";\n}\n\n.mdi-hydraulic-oil-level::before {\n  content: \"\\F1324\";\n}\n\n.mdi-hydraulic-oil-temperature::before {\n  content: \"\\F1325\";\n}\n\n.mdi-hydro-power::before {\n  content: \"\\F12E5\";\n}\n\n.mdi-hydrogen-station::before {\n  content: \"\\F1894\";\n}\n\n.mdi-ice-cream::before {\n  content: \"\\F082A\";\n}\n\n.mdi-ice-cream-off::before {\n  content: \"\\F0E52\";\n}\n\n.mdi-ice-pop::before {\n  content: \"\\F0EFD\";\n}\n\n.mdi-id-card::before {\n  content: \"\\F0FC0\";\n}\n\n.mdi-identifier::before {\n  content: \"\\F0EFE\";\n}\n\n.mdi-ideogram-cjk::before {\n  content: \"\\F1331\";\n}\n\n.mdi-ideogram-cjk-variant::before {\n  content: \"\\F1332\";\n}\n\n.mdi-image::before {\n  content: \"\\F02E9\";\n}\n\n.mdi-image-album::before {\n  content: \"\\F02EA\";\n}\n\n.mdi-image-area::before {\n  content: \"\\F02EB\";\n}\n\n.mdi-image-area-close::before {\n  content: \"\\F02EC\";\n}\n\n.mdi-image-auto-adjust::before {\n  content: \"\\F0FC1\";\n}\n\n.mdi-image-broken::before {\n  content: \"\\F02ED\";\n}\n\n.mdi-image-broken-variant::before {\n  content: \"\\F02EE\";\n}\n\n.mdi-image-edit::before {\n  content: \"\\F11E3\";\n}\n\n.mdi-image-edit-outline::before {\n  content: \"\\F11E4\";\n}\n\n.mdi-image-filter-black-white::before {\n  content: \"\\F02F0\";\n}\n\n.mdi-image-filter-center-focus::before {\n  content: \"\\F02F1\";\n}\n\n.mdi-image-filter-center-focus-strong::before {\n  content: \"\\F0EFF\";\n}\n\n.mdi-image-filter-center-focus-strong-outline::before {\n  content: \"\\F0F00\";\n}\n\n.mdi-image-filter-center-focus-weak::before {\n  content: \"\\F02F2\";\n}\n\n.mdi-image-filter-drama::before {\n  content: \"\\F02F3\";\n}\n\n.mdi-image-filter-frames::before {\n  content: \"\\F02F4\";\n}\n\n.mdi-image-filter-hdr::before {\n  content: \"\\F02F5\";\n}\n\n.mdi-image-filter-none::before {\n  content: \"\\F02F6\";\n}\n\n.mdi-image-filter-tilt-shift::before {\n  content: \"\\F02F7\";\n}\n\n.mdi-image-filter-vintage::before {\n  content: \"\\F02F8\";\n}\n\n.mdi-image-frame::before {\n  content: \"\\F0E49\";\n}\n\n.mdi-image-marker::before {\n  content: \"\\F177B\";\n}\n\n.mdi-image-marker-outline::before {\n  content: \"\\F177C\";\n}\n\n.mdi-image-minus::before {\n  content: \"\\F1419\";\n}\n\n.mdi-image-move::before {\n  content: \"\\F09F8\";\n}\n\n.mdi-image-multiple::before {\n  content: \"\\F02F9\";\n}\n\n.mdi-image-multiple-outline::before {\n  content: \"\\F02EF\";\n}\n\n.mdi-image-off::before {\n  content: \"\\F082B\";\n}\n\n.mdi-image-off-outline::before {\n  content: \"\\F11D1\";\n}\n\n.mdi-image-outline::before {\n  content: \"\\F0976\";\n}\n\n.mdi-image-plus::before {\n  content: \"\\F087C\";\n}\n\n.mdi-image-remove::before {\n  content: \"\\F1418\";\n}\n\n.mdi-image-search::before {\n  content: \"\\F0977\";\n}\n\n.mdi-image-search-outline::before {\n  content: \"\\F0978\";\n}\n\n.mdi-image-size-select-actual::before {\n  content: \"\\F0C8D\";\n}\n\n.mdi-image-size-select-large::before {\n  content: \"\\F0C8E\";\n}\n\n.mdi-image-size-select-small::before {\n  content: \"\\F0C8F\";\n}\n\n.mdi-image-text::before {\n  content: \"\\F160D\";\n}\n\n.mdi-import::before {\n  content: \"\\F02FA\";\n}\n\n.mdi-inbox::before {\n  content: \"\\F0687\";\n}\n\n.mdi-inbox-arrow-down::before {\n  content: \"\\F02FB\";\n}\n\n.mdi-inbox-arrow-down-outline::before {\n  content: \"\\F1270\";\n}\n\n.mdi-inbox-arrow-up::before {\n  content: \"\\F03D1\";\n}\n\n.mdi-inbox-arrow-up-outline::before {\n  content: \"\\F1271\";\n}\n\n.mdi-inbox-full::before {\n  content: \"\\F1272\";\n}\n\n.mdi-inbox-full-outline::before {\n  content: \"\\F1273\";\n}\n\n.mdi-inbox-multiple::before {\n  content: \"\\F08B0\";\n}\n\n.mdi-inbox-multiple-outline::before {\n  content: \"\\F0BA8\";\n}\n\n.mdi-inbox-outline::before {\n  content: \"\\F1274\";\n}\n\n.mdi-inbox-remove::before {\n  content: \"\\F159F\";\n}\n\n.mdi-inbox-remove-outline::before {\n  content: \"\\F15A0\";\n}\n\n.mdi-incognito::before {\n  content: \"\\F05F9\";\n}\n\n.mdi-incognito-circle::before {\n  content: \"\\F1421\";\n}\n\n.mdi-incognito-circle-off::before {\n  content: \"\\F1422\";\n}\n\n.mdi-incognito-off::before {\n  content: \"\\F0075\";\n}\n\n.mdi-induction::before {\n  content: \"\\F184C\";\n}\n\n.mdi-infinity::before {\n  content: \"\\F06E4\";\n}\n\n.mdi-information::before {\n  content: \"\\F02FC\";\n}\n\n.mdi-information-off::before {\n  content: \"\\F178C\";\n}\n\n.mdi-information-off-outline::before {\n  content: \"\\F178D\";\n}\n\n.mdi-information-outline::before {\n  content: \"\\F02FD\";\n}\n\n.mdi-information-variant::before {\n  content: \"\\F064E\";\n}\n\n.mdi-instagram::before {\n  content: \"\\F02FE\";\n}\n\n.mdi-instrument-triangle::before {\n  content: \"\\F104E\";\n}\n\n.mdi-integrated-circuit-chip::before {\n  content: \"\\F1913\";\n}\n\n.mdi-invert-colors::before {\n  content: \"\\F0301\";\n}\n\n.mdi-invert-colors-off::before {\n  content: \"\\F0E4A\";\n}\n\n.mdi-iobroker::before {\n  content: \"\\F12E8\";\n}\n\n.mdi-ip::before {\n  content: \"\\F0A5F\";\n}\n\n.mdi-ip-network::before {\n  content: \"\\F0A60\";\n}\n\n.mdi-ip-network-outline::before {\n  content: \"\\F0C90\";\n}\n\n.mdi-ip-outline::before {\n  content: \"\\F1982\";\n}\n\n.mdi-ipod::before {\n  content: \"\\F0C91\";\n}\n\n.mdi-iron::before {\n  content: \"\\F1824\";\n}\n\n.mdi-iron-board::before {\n  content: \"\\F1838\";\n}\n\n.mdi-iron-outline::before {\n  content: \"\\F1825\";\n}\n\n.mdi-island::before {\n  content: \"\\F104F\";\n}\n\n.mdi-iv-bag::before {\n  content: \"\\F10B9\";\n}\n\n.mdi-jabber::before {\n  content: \"\\F0DD5\";\n}\n\n.mdi-jeepney::before {\n  content: \"\\F0302\";\n}\n\n.mdi-jellyfish::before {\n  content: \"\\F0F01\";\n}\n\n.mdi-jellyfish-outline::before {\n  content: \"\\F0F02\";\n}\n\n.mdi-jira::before {\n  content: \"\\F0303\";\n}\n\n.mdi-jquery::before {\n  content: \"\\F087D\";\n}\n\n.mdi-jsfiddle::before {\n  content: \"\\F0304\";\n}\n\n.mdi-jump-rope::before {\n  content: \"\\F12FF\";\n}\n\n.mdi-kabaddi::before {\n  content: \"\\F0D87\";\n}\n\n.mdi-kangaroo::before {\n  content: \"\\F1558\";\n}\n\n.mdi-karate::before {\n  content: \"\\F082C\";\n}\n\n.mdi-kayaking::before {\n  content: \"\\F08AF\";\n}\n\n.mdi-keg::before {\n  content: \"\\F0305\";\n}\n\n.mdi-kettle::before {\n  content: \"\\F05FA\";\n}\n\n.mdi-kettle-alert::before {\n  content: \"\\F1317\";\n}\n\n.mdi-kettle-alert-outline::before {\n  content: \"\\F1318\";\n}\n\n.mdi-kettle-off::before {\n  content: \"\\F131B\";\n}\n\n.mdi-kettle-off-outline::before {\n  content: \"\\F131C\";\n}\n\n.mdi-kettle-outline::before {\n  content: \"\\F0F56\";\n}\n\n.mdi-kettle-pour-over::before {\n  content: \"\\F173C\";\n}\n\n.mdi-kettle-steam::before {\n  content: \"\\F1319\";\n}\n\n.mdi-kettle-steam-outline::before {\n  content: \"\\F131A\";\n}\n\n.mdi-kettlebell::before {\n  content: \"\\F1300\";\n}\n\n.mdi-key::before {\n  content: \"\\F0306\";\n}\n\n.mdi-key-alert::before {\n  content: \"\\F1983\";\n}\n\n.mdi-key-alert-outline::before {\n  content: \"\\F1984\";\n}\n\n.mdi-key-arrow-right::before {\n  content: \"\\F1312\";\n}\n\n.mdi-key-chain::before {\n  content: \"\\F1574\";\n}\n\n.mdi-key-chain-variant::before {\n  content: \"\\F1575\";\n}\n\n.mdi-key-change::before {\n  content: \"\\F0307\";\n}\n\n.mdi-key-link::before {\n  content: \"\\F119F\";\n}\n\n.mdi-key-minus::before {\n  content: \"\\F0308\";\n}\n\n.mdi-key-outline::before {\n  content: \"\\F0DD6\";\n}\n\n.mdi-key-plus::before {\n  content: \"\\F0309\";\n}\n\n.mdi-key-remove::before {\n  content: \"\\F030A\";\n}\n\n.mdi-key-star::before {\n  content: \"\\F119E\";\n}\n\n.mdi-key-variant::before {\n  content: \"\\F030B\";\n}\n\n.mdi-key-wireless::before {\n  content: \"\\F0FC2\";\n}\n\n.mdi-keyboard::before {\n  content: \"\\F030C\";\n}\n\n.mdi-keyboard-backspace::before {\n  content: \"\\F030D\";\n}\n\n.mdi-keyboard-caps::before {\n  content: \"\\F030E\";\n}\n\n.mdi-keyboard-close::before {\n  content: \"\\F030F\";\n}\n\n.mdi-keyboard-esc::before {\n  content: \"\\F12B7\";\n}\n\n.mdi-keyboard-f1::before {\n  content: \"\\F12AB\";\n}\n\n.mdi-keyboard-f10::before {\n  content: \"\\F12B4\";\n}\n\n.mdi-keyboard-f11::before {\n  content: \"\\F12B5\";\n}\n\n.mdi-keyboard-f12::before {\n  content: \"\\F12B6\";\n}\n\n.mdi-keyboard-f2::before {\n  content: \"\\F12AC\";\n}\n\n.mdi-keyboard-f3::before {\n  content: \"\\F12AD\";\n}\n\n.mdi-keyboard-f4::before {\n  content: \"\\F12AE\";\n}\n\n.mdi-keyboard-f5::before {\n  content: \"\\F12AF\";\n}\n\n.mdi-keyboard-f6::before {\n  content: \"\\F12B0\";\n}\n\n.mdi-keyboard-f7::before {\n  content: \"\\F12B1\";\n}\n\n.mdi-keyboard-f8::before {\n  content: \"\\F12B2\";\n}\n\n.mdi-keyboard-f9::before {\n  content: \"\\F12B3\";\n}\n\n.mdi-keyboard-off::before {\n  content: \"\\F0310\";\n}\n\n.mdi-keyboard-off-outline::before {\n  content: \"\\F0E4B\";\n}\n\n.mdi-keyboard-outline::before {\n  content: \"\\F097B\";\n}\n\n.mdi-keyboard-return::before {\n  content: \"\\F0311\";\n}\n\n.mdi-keyboard-settings::before {\n  content: \"\\F09F9\";\n}\n\n.mdi-keyboard-settings-outline::before {\n  content: \"\\F09FA\";\n}\n\n.mdi-keyboard-space::before {\n  content: \"\\F1050\";\n}\n\n.mdi-keyboard-tab::before {\n  content: \"\\F0312\";\n}\n\n.mdi-keyboard-tab-reverse::before {\n  content: \"\\F0325\";\n}\n\n.mdi-keyboard-variant::before {\n  content: \"\\F0313\";\n}\n\n.mdi-khanda::before {\n  content: \"\\F10FD\";\n}\n\n.mdi-kickstarter::before {\n  content: \"\\F0745\";\n}\n\n.mdi-kite::before {\n  content: \"\\F1985\";\n}\n\n.mdi-kite-outline::before {\n  content: \"\\F1986\";\n}\n\n.mdi-kitesurfing::before {\n  content: \"\\F1744\";\n}\n\n.mdi-klingon::before {\n  content: \"\\F135B\";\n}\n\n.mdi-knife::before {\n  content: \"\\F09FB\";\n}\n\n.mdi-knife-military::before {\n  content: \"\\F09FC\";\n}\n\n.mdi-koala::before {\n  content: \"\\F173F\";\n}\n\n.mdi-kodi::before {\n  content: \"\\F0314\";\n}\n\n.mdi-kubernetes::before {\n  content: \"\\F10FE\";\n}\n\n.mdi-label::before {\n  content: \"\\F0315\";\n}\n\n.mdi-label-multiple::before {\n  content: \"\\F1375\";\n}\n\n.mdi-label-multiple-outline::before {\n  content: \"\\F1376\";\n}\n\n.mdi-label-off::before {\n  content: \"\\F0ACB\";\n}\n\n.mdi-label-off-outline::before {\n  content: \"\\F0ACC\";\n}\n\n.mdi-label-outline::before {\n  content: \"\\F0316\";\n}\n\n.mdi-label-percent::before {\n  content: \"\\F12EA\";\n}\n\n.mdi-label-percent-outline::before {\n  content: \"\\F12EB\";\n}\n\n.mdi-label-variant::before {\n  content: \"\\F0ACD\";\n}\n\n.mdi-label-variant-outline::before {\n  content: \"\\F0ACE\";\n}\n\n.mdi-ladder::before {\n  content: \"\\F15A2\";\n}\n\n.mdi-ladybug::before {\n  content: \"\\F082D\";\n}\n\n.mdi-lambda::before {\n  content: \"\\F0627\";\n}\n\n.mdi-lamp::before {\n  content: \"\\F06B5\";\n}\n\n.mdi-lamp-outline::before {\n  content: \"\\F17D0\";\n}\n\n.mdi-lamps::before {\n  content: \"\\F1576\";\n}\n\n.mdi-lamps-outline::before {\n  content: \"\\F17D1\";\n}\n\n.mdi-lan::before {\n  content: \"\\F0317\";\n}\n\n.mdi-lan-check::before {\n  content: \"\\F12AA\";\n}\n\n.mdi-lan-connect::before {\n  content: \"\\F0318\";\n}\n\n.mdi-lan-disconnect::before {\n  content: \"\\F0319\";\n}\n\n.mdi-lan-pending::before {\n  content: \"\\F031A\";\n}\n\n.mdi-language-c::before {\n  content: \"\\F0671\";\n}\n\n.mdi-language-cpp::before {\n  content: \"\\F0672\";\n}\n\n.mdi-language-csharp::before {\n  content: \"\\F031B\";\n}\n\n.mdi-language-css3::before {\n  content: \"\\F031C\";\n}\n\n.mdi-language-fortran::before {\n  content: \"\\F121A\";\n}\n\n.mdi-language-go::before {\n  content: \"\\F07D3\";\n}\n\n.mdi-language-haskell::before {\n  content: \"\\F0C92\";\n}\n\n.mdi-language-html5::before {\n  content: \"\\F031D\";\n}\n\n.mdi-language-java::before {\n  content: \"\\F0B37\";\n}\n\n.mdi-language-javascript::before {\n  content: \"\\F031E\";\n}\n\n.mdi-language-kotlin::before {\n  content: \"\\F1219\";\n}\n\n.mdi-language-lua::before {\n  content: \"\\F08B1\";\n}\n\n.mdi-language-markdown::before {\n  content: \"\\F0354\";\n}\n\n.mdi-language-markdown-outline::before {\n  content: \"\\F0F5B\";\n}\n\n.mdi-language-php::before {\n  content: \"\\F031F\";\n}\n\n.mdi-language-python::before {\n  content: \"\\F0320\";\n}\n\n.mdi-language-r::before {\n  content: \"\\F07D4\";\n}\n\n.mdi-language-ruby::before {\n  content: \"\\F0D2D\";\n}\n\n.mdi-language-ruby-on-rails::before {\n  content: \"\\F0ACF\";\n}\n\n.mdi-language-rust::before {\n  content: \"\\F1617\";\n}\n\n.mdi-language-swift::before {\n  content: \"\\F06E5\";\n}\n\n.mdi-language-typescript::before {\n  content: \"\\F06E6\";\n}\n\n.mdi-language-xaml::before {\n  content: \"\\F0673\";\n}\n\n.mdi-laptop::before {\n  content: \"\\F0322\";\n}\n\n.mdi-laptop-off::before {\n  content: \"\\F06E7\";\n}\n\n.mdi-laravel::before {\n  content: \"\\F0AD0\";\n}\n\n.mdi-laser-pointer::before {\n  content: \"\\F1484\";\n}\n\n.mdi-lasso::before {\n  content: \"\\F0F03\";\n}\n\n.mdi-lastpass::before {\n  content: \"\\F0446\";\n}\n\n.mdi-latitude::before {\n  content: \"\\F0F57\";\n}\n\n.mdi-launch::before {\n  content: \"\\F0327\";\n}\n\n.mdi-lava-lamp::before {\n  content: \"\\F07D5\";\n}\n\n.mdi-layers::before {\n  content: \"\\F0328\";\n}\n\n.mdi-layers-edit::before {\n  content: \"\\F1892\";\n}\n\n.mdi-layers-minus::before {\n  content: \"\\F0E4C\";\n}\n\n.mdi-layers-off::before {\n  content: \"\\F0329\";\n}\n\n.mdi-layers-off-outline::before {\n  content: \"\\F09FD\";\n}\n\n.mdi-layers-outline::before {\n  content: \"\\F09FE\";\n}\n\n.mdi-layers-plus::before {\n  content: \"\\F0E4D\";\n}\n\n.mdi-layers-remove::before {\n  content: \"\\F0E4E\";\n}\n\n.mdi-layers-search::before {\n  content: \"\\F1206\";\n}\n\n.mdi-layers-search-outline::before {\n  content: \"\\F1207\";\n}\n\n.mdi-layers-triple::before {\n  content: \"\\F0F58\";\n}\n\n.mdi-layers-triple-outline::before {\n  content: \"\\F0F59\";\n}\n\n.mdi-lead-pencil::before {\n  content: \"\\F064F\";\n}\n\n.mdi-leaf::before {\n  content: \"\\F032A\";\n}\n\n.mdi-leaf-circle::before {\n  content: \"\\F1905\";\n}\n\n.mdi-leaf-circle-outline::before {\n  content: \"\\F1906\";\n}\n\n.mdi-leaf-maple::before {\n  content: \"\\F0C93\";\n}\n\n.mdi-leaf-maple-off::before {\n  content: \"\\F12DA\";\n}\n\n.mdi-leaf-off::before {\n  content: \"\\F12D9\";\n}\n\n.mdi-leak::before {\n  content: \"\\F0DD7\";\n}\n\n.mdi-leak-off::before {\n  content: \"\\F0DD8\";\n}\n\n.mdi-led-off::before {\n  content: \"\\F032B\";\n}\n\n.mdi-led-on::before {\n  content: \"\\F032C\";\n}\n\n.mdi-led-outline::before {\n  content: \"\\F032D\";\n}\n\n.mdi-led-strip::before {\n  content: \"\\F07D6\";\n}\n\n.mdi-led-strip-variant::before {\n  content: \"\\F1051\";\n}\n\n.mdi-led-variant-off::before {\n  content: \"\\F032E\";\n}\n\n.mdi-led-variant-on::before {\n  content: \"\\F032F\";\n}\n\n.mdi-led-variant-outline::before {\n  content: \"\\F0330\";\n}\n\n.mdi-leek::before {\n  content: \"\\F117D\";\n}\n\n.mdi-less-than::before {\n  content: \"\\F097C\";\n}\n\n.mdi-less-than-or-equal::before {\n  content: \"\\F097D\";\n}\n\n.mdi-library::before {\n  content: \"\\F0331\";\n}\n\n.mdi-library-shelves::before {\n  content: \"\\F0BA9\";\n}\n\n.mdi-license::before {\n  content: \"\\F0FC3\";\n}\n\n.mdi-lifebuoy::before {\n  content: \"\\F087E\";\n}\n\n.mdi-light-flood-down::before {\n  content: \"\\F1987\";\n}\n\n.mdi-light-flood-up::before {\n  content: \"\\F1988\";\n}\n\n.mdi-light-recessed::before {\n  content: \"\\F179B\";\n}\n\n.mdi-light-switch::before {\n  content: \"\\F097E\";\n}\n\n.mdi-lightbulb::before {\n  content: \"\\F0335\";\n}\n\n.mdi-lightbulb-auto::before {\n  content: \"\\F1800\";\n}\n\n.mdi-lightbulb-auto-outline::before {\n  content: \"\\F1801\";\n}\n\n.mdi-lightbulb-cfl::before {\n  content: \"\\F1208\";\n}\n\n.mdi-lightbulb-cfl-off::before {\n  content: \"\\F1209\";\n}\n\n.mdi-lightbulb-cfl-spiral::before {\n  content: \"\\F1275\";\n}\n\n.mdi-lightbulb-cfl-spiral-off::before {\n  content: \"\\F12C3\";\n}\n\n.mdi-lightbulb-fluorescent-tube::before {\n  content: \"\\F1804\";\n}\n\n.mdi-lightbulb-fluorescent-tube-outline::before {\n  content: \"\\F1805\";\n}\n\n.mdi-lightbulb-group::before {\n  content: \"\\F1253\";\n}\n\n.mdi-lightbulb-group-off::before {\n  content: \"\\F12CD\";\n}\n\n.mdi-lightbulb-group-off-outline::before {\n  content: \"\\F12CE\";\n}\n\n.mdi-lightbulb-group-outline::before {\n  content: \"\\F1254\";\n}\n\n.mdi-lightbulb-multiple::before {\n  content: \"\\F1255\";\n}\n\n.mdi-lightbulb-multiple-off::before {\n  content: \"\\F12CF\";\n}\n\n.mdi-lightbulb-multiple-off-outline::before {\n  content: \"\\F12D0\";\n}\n\n.mdi-lightbulb-multiple-outline::before {\n  content: \"\\F1256\";\n}\n\n.mdi-lightbulb-off::before {\n  content: \"\\F0E4F\";\n}\n\n.mdi-lightbulb-off-outline::before {\n  content: \"\\F0E50\";\n}\n\n.mdi-lightbulb-on::before {\n  content: \"\\F06E8\";\n}\n\n.mdi-lightbulb-on-outline::before {\n  content: \"\\F06E9\";\n}\n\n.mdi-lightbulb-outline::before {\n  content: \"\\F0336\";\n}\n\n.mdi-lightbulb-spot::before {\n  content: \"\\F17F4\";\n}\n\n.mdi-lightbulb-spot-off::before {\n  content: \"\\F17F5\";\n}\n\n.mdi-lightbulb-variant::before {\n  content: \"\\F1802\";\n}\n\n.mdi-lightbulb-variant-outline::before {\n  content: \"\\F1803\";\n}\n\n.mdi-lighthouse::before {\n  content: \"\\F09FF\";\n}\n\n.mdi-lighthouse-on::before {\n  content: \"\\F0A00\";\n}\n\n.mdi-lightning-bolt::before {\n  content: \"\\F140B\";\n}\n\n.mdi-lightning-bolt-circle::before {\n  content: \"\\F0820\";\n}\n\n.mdi-lightning-bolt-outline::before {\n  content: \"\\F140C\";\n}\n\n.mdi-line-scan::before {\n  content: \"\\F0624\";\n}\n\n.mdi-lingerie::before {\n  content: \"\\F1476\";\n}\n\n.mdi-link::before {\n  content: \"\\F0337\";\n}\n\n.mdi-link-box::before {\n  content: \"\\F0D1A\";\n}\n\n.mdi-link-box-outline::before {\n  content: \"\\F0D1B\";\n}\n\n.mdi-link-box-variant::before {\n  content: \"\\F0D1C\";\n}\n\n.mdi-link-box-variant-outline::before {\n  content: \"\\F0D1D\";\n}\n\n.mdi-link-lock::before {\n  content: \"\\F10BA\";\n}\n\n.mdi-link-off::before {\n  content: \"\\F0338\";\n}\n\n.mdi-link-plus::before {\n  content: \"\\F0C94\";\n}\n\n.mdi-link-variant::before {\n  content: \"\\F0339\";\n}\n\n.mdi-link-variant-minus::before {\n  content: \"\\F10FF\";\n}\n\n.mdi-link-variant-off::before {\n  content: \"\\F033A\";\n}\n\n.mdi-link-variant-plus::before {\n  content: \"\\F1100\";\n}\n\n.mdi-link-variant-remove::before {\n  content: \"\\F1101\";\n}\n\n.mdi-linkedin::before {\n  content: \"\\F033B\";\n}\n\n.mdi-linux::before {\n  content: \"\\F033D\";\n}\n\n.mdi-linux-mint::before {\n  content: \"\\F08ED\";\n}\n\n.mdi-lipstick::before {\n  content: \"\\F13B5\";\n}\n\n.mdi-liquid-spot::before {\n  content: \"\\F1826\";\n}\n\n.mdi-liquor::before {\n  content: \"\\F191E\";\n}\n\n.mdi-list-status::before {\n  content: \"\\F15AB\";\n}\n\n.mdi-litecoin::before {\n  content: \"\\F0A61\";\n}\n\n.mdi-loading::before {\n  content: \"\\F0772\";\n}\n\n.mdi-location-enter::before {\n  content: \"\\F0FC4\";\n}\n\n.mdi-location-exit::before {\n  content: \"\\F0FC5\";\n}\n\n.mdi-lock::before {\n  content: \"\\F033E\";\n}\n\n.mdi-lock-alert::before {\n  content: \"\\F08EE\";\n}\n\n.mdi-lock-alert-outline::before {\n  content: \"\\F15D1\";\n}\n\n.mdi-lock-check::before {\n  content: \"\\F139A\";\n}\n\n.mdi-lock-check-outline::before {\n  content: \"\\F16A8\";\n}\n\n.mdi-lock-clock::before {\n  content: \"\\F097F\";\n}\n\n.mdi-lock-minus::before {\n  content: \"\\F16A9\";\n}\n\n.mdi-lock-minus-outline::before {\n  content: \"\\F16AA\";\n}\n\n.mdi-lock-off::before {\n  content: \"\\F1671\";\n}\n\n.mdi-lock-off-outline::before {\n  content: \"\\F1672\";\n}\n\n.mdi-lock-open::before {\n  content: \"\\F033F\";\n}\n\n.mdi-lock-open-alert::before {\n  content: \"\\F139B\";\n}\n\n.mdi-lock-open-alert-outline::before {\n  content: \"\\F15D2\";\n}\n\n.mdi-lock-open-check::before {\n  content: \"\\F139C\";\n}\n\n.mdi-lock-open-check-outline::before {\n  content: \"\\F16AB\";\n}\n\n.mdi-lock-open-minus::before {\n  content: \"\\F16AC\";\n}\n\n.mdi-lock-open-minus-outline::before {\n  content: \"\\F16AD\";\n}\n\n.mdi-lock-open-outline::before {\n  content: \"\\F0340\";\n}\n\n.mdi-lock-open-plus::before {\n  content: \"\\F16AE\";\n}\n\n.mdi-lock-open-plus-outline::before {\n  content: \"\\F16AF\";\n}\n\n.mdi-lock-open-remove::before {\n  content: \"\\F16B0\";\n}\n\n.mdi-lock-open-remove-outline::before {\n  content: \"\\F16B1\";\n}\n\n.mdi-lock-open-variant::before {\n  content: \"\\F0FC6\";\n}\n\n.mdi-lock-open-variant-outline::before {\n  content: \"\\F0FC7\";\n}\n\n.mdi-lock-outline::before {\n  content: \"\\F0341\";\n}\n\n.mdi-lock-pattern::before {\n  content: \"\\F06EA\";\n}\n\n.mdi-lock-plus::before {\n  content: \"\\F05FB\";\n}\n\n.mdi-lock-plus-outline::before {\n  content: \"\\F16B2\";\n}\n\n.mdi-lock-question::before {\n  content: \"\\F08EF\";\n}\n\n.mdi-lock-remove::before {\n  content: \"\\F16B3\";\n}\n\n.mdi-lock-remove-outline::before {\n  content: \"\\F16B4\";\n}\n\n.mdi-lock-reset::before {\n  content: \"\\F0773\";\n}\n\n.mdi-lock-smart::before {\n  content: \"\\F08B2\";\n}\n\n.mdi-locker::before {\n  content: \"\\F07D7\";\n}\n\n.mdi-locker-multiple::before {\n  content: \"\\F07D8\";\n}\n\n.mdi-login::before {\n  content: \"\\F0342\";\n}\n\n.mdi-login-variant::before {\n  content: \"\\F05FC\";\n}\n\n.mdi-logout::before {\n  content: \"\\F0343\";\n}\n\n.mdi-logout-variant::before {\n  content: \"\\F05FD\";\n}\n\n.mdi-longitude::before {\n  content: \"\\F0F5A\";\n}\n\n.mdi-looks::before {\n  content: \"\\F0344\";\n}\n\n.mdi-lotion::before {\n  content: \"\\F1582\";\n}\n\n.mdi-lotion-outline::before {\n  content: \"\\F1583\";\n}\n\n.mdi-lotion-plus::before {\n  content: \"\\F1584\";\n}\n\n.mdi-lotion-plus-outline::before {\n  content: \"\\F1585\";\n}\n\n.mdi-loupe::before {\n  content: \"\\F0345\";\n}\n\n.mdi-lumx::before {\n  content: \"\\F0346\";\n}\n\n.mdi-lungs::before {\n  content: \"\\F1084\";\n}\n\n.mdi-mace::before {\n  content: \"\\F1843\";\n}\n\n.mdi-magazine-pistol::before {\n  content: \"\\F0324\";\n}\n\n.mdi-magazine-rifle::before {\n  content: \"\\F0323\";\n}\n\n.mdi-magic-staff::before {\n  content: \"\\F1844\";\n}\n\n.mdi-magnet::before {\n  content: \"\\F0347\";\n}\n\n.mdi-magnet-on::before {\n  content: \"\\F0348\";\n}\n\n.mdi-magnify::before {\n  content: \"\\F0349\";\n}\n\n.mdi-magnify-close::before {\n  content: \"\\F0980\";\n}\n\n.mdi-magnify-expand::before {\n  content: \"\\F1874\";\n}\n\n.mdi-magnify-minus::before {\n  content: \"\\F034A\";\n}\n\n.mdi-magnify-minus-cursor::before {\n  content: \"\\F0A62\";\n}\n\n.mdi-magnify-minus-outline::before {\n  content: \"\\F06EC\";\n}\n\n.mdi-magnify-plus::before {\n  content: \"\\F034B\";\n}\n\n.mdi-magnify-plus-cursor::before {\n  content: \"\\F0A63\";\n}\n\n.mdi-magnify-plus-outline::before {\n  content: \"\\F06ED\";\n}\n\n.mdi-magnify-remove-cursor::before {\n  content: \"\\F120C\";\n}\n\n.mdi-magnify-remove-outline::before {\n  content: \"\\F120D\";\n}\n\n.mdi-magnify-scan::before {\n  content: \"\\F1276\";\n}\n\n.mdi-mail::before {\n  content: \"\\F0EBB\";\n}\n\n.mdi-mailbox::before {\n  content: \"\\F06EE\";\n}\n\n.mdi-mailbox-open::before {\n  content: \"\\F0D88\";\n}\n\n.mdi-mailbox-open-outline::before {\n  content: \"\\F0D89\";\n}\n\n.mdi-mailbox-open-up::before {\n  content: \"\\F0D8A\";\n}\n\n.mdi-mailbox-open-up-outline::before {\n  content: \"\\F0D8B\";\n}\n\n.mdi-mailbox-outline::before {\n  content: \"\\F0D8C\";\n}\n\n.mdi-mailbox-up::before {\n  content: \"\\F0D8D\";\n}\n\n.mdi-mailbox-up-outline::before {\n  content: \"\\F0D8E\";\n}\n\n.mdi-manjaro::before {\n  content: \"\\F160A\";\n}\n\n.mdi-map::before {\n  content: \"\\F034D\";\n}\n\n.mdi-map-check::before {\n  content: \"\\F0EBC\";\n}\n\n.mdi-map-check-outline::before {\n  content: \"\\F0EBD\";\n}\n\n.mdi-map-clock::before {\n  content: \"\\F0D1E\";\n}\n\n.mdi-map-clock-outline::before {\n  content: \"\\F0D1F\";\n}\n\n.mdi-map-legend::before {\n  content: \"\\F0A01\";\n}\n\n.mdi-map-marker::before {\n  content: \"\\F034E\";\n}\n\n.mdi-map-marker-account::before {\n  content: \"\\F18E3\";\n}\n\n.mdi-map-marker-account-outline::before {\n  content: \"\\F18E4\";\n}\n\n.mdi-map-marker-alert::before {\n  content: \"\\F0F05\";\n}\n\n.mdi-map-marker-alert-outline::before {\n  content: \"\\F0F06\";\n}\n\n.mdi-map-marker-check::before {\n  content: \"\\F0C95\";\n}\n\n.mdi-map-marker-check-outline::before {\n  content: \"\\F12FB\";\n}\n\n.mdi-map-marker-circle::before {\n  content: \"\\F034F\";\n}\n\n.mdi-map-marker-distance::before {\n  content: \"\\F08F0\";\n}\n\n.mdi-map-marker-down::before {\n  content: \"\\F1102\";\n}\n\n.mdi-map-marker-left::before {\n  content: \"\\F12DB\";\n}\n\n.mdi-map-marker-left-outline::before {\n  content: \"\\F12DD\";\n}\n\n.mdi-map-marker-minus::before {\n  content: \"\\F0650\";\n}\n\n.mdi-map-marker-minus-outline::before {\n  content: \"\\F12F9\";\n}\n\n.mdi-map-marker-multiple::before {\n  content: \"\\F0350\";\n}\n\n.mdi-map-marker-multiple-outline::before {\n  content: \"\\F1277\";\n}\n\n.mdi-map-marker-off::before {\n  content: \"\\F0351\";\n}\n\n.mdi-map-marker-off-outline::before {\n  content: \"\\F12FD\";\n}\n\n.mdi-map-marker-outline::before {\n  content: \"\\F07D9\";\n}\n\n.mdi-map-marker-path::before {\n  content: \"\\F0D20\";\n}\n\n.mdi-map-marker-plus::before {\n  content: \"\\F0651\";\n}\n\n.mdi-map-marker-plus-outline::before {\n  content: \"\\F12F8\";\n}\n\n.mdi-map-marker-question::before {\n  content: \"\\F0F07\";\n}\n\n.mdi-map-marker-question-outline::before {\n  content: \"\\F0F08\";\n}\n\n.mdi-map-marker-radius::before {\n  content: \"\\F0352\";\n}\n\n.mdi-map-marker-radius-outline::before {\n  content: \"\\F12FC\";\n}\n\n.mdi-map-marker-remove::before {\n  content: \"\\F0F09\";\n}\n\n.mdi-map-marker-remove-outline::before {\n  content: \"\\F12FA\";\n}\n\n.mdi-map-marker-remove-variant::before {\n  content: \"\\F0F0A\";\n}\n\n.mdi-map-marker-right::before {\n  content: \"\\F12DC\";\n}\n\n.mdi-map-marker-right-outline::before {\n  content: \"\\F12DE\";\n}\n\n.mdi-map-marker-star::before {\n  content: \"\\F1608\";\n}\n\n.mdi-map-marker-star-outline::before {\n  content: \"\\F1609\";\n}\n\n.mdi-map-marker-up::before {\n  content: \"\\F1103\";\n}\n\n.mdi-map-minus::before {\n  content: \"\\F0981\";\n}\n\n.mdi-map-outline::before {\n  content: \"\\F0982\";\n}\n\n.mdi-map-plus::before {\n  content: \"\\F0983\";\n}\n\n.mdi-map-search::before {\n  content: \"\\F0984\";\n}\n\n.mdi-map-search-outline::before {\n  content: \"\\F0985\";\n}\n\n.mdi-mapbox::before {\n  content: \"\\F0BAA\";\n}\n\n.mdi-margin::before {\n  content: \"\\F0353\";\n}\n\n.mdi-marker::before {\n  content: \"\\F0652\";\n}\n\n.mdi-marker-cancel::before {\n  content: \"\\F0DD9\";\n}\n\n.mdi-marker-check::before {\n  content: \"\\F0355\";\n}\n\n.mdi-mastodon::before {\n  content: \"\\F0AD1\";\n}\n\n.mdi-material-design::before {\n  content: \"\\F0986\";\n}\n\n.mdi-material-ui::before {\n  content: \"\\F0357\";\n}\n\n.mdi-math-compass::before {\n  content: \"\\F0358\";\n}\n\n.mdi-math-cos::before {\n  content: \"\\F0C96\";\n}\n\n.mdi-math-integral::before {\n  content: \"\\F0FC8\";\n}\n\n.mdi-math-integral-box::before {\n  content: \"\\F0FC9\";\n}\n\n.mdi-math-log::before {\n  content: \"\\F1085\";\n}\n\n.mdi-math-norm::before {\n  content: \"\\F0FCA\";\n}\n\n.mdi-math-norm-box::before {\n  content: \"\\F0FCB\";\n}\n\n.mdi-math-sin::before {\n  content: \"\\F0C97\";\n}\n\n.mdi-math-tan::before {\n  content: \"\\F0C98\";\n}\n\n.mdi-matrix::before {\n  content: \"\\F0628\";\n}\n\n.mdi-medal::before {\n  content: \"\\F0987\";\n}\n\n.mdi-medal-outline::before {\n  content: \"\\F1326\";\n}\n\n.mdi-medical-bag::before {\n  content: \"\\F06EF\";\n}\n\n.mdi-meditation::before {\n  content: \"\\F117B\";\n}\n\n.mdi-memory::before {\n  content: \"\\F035B\";\n}\n\n.mdi-menorah::before {\n  content: \"\\F17D4\";\n}\n\n.mdi-menorah-fire::before {\n  content: \"\\F17D5\";\n}\n\n.mdi-menu::before {\n  content: \"\\F035C\";\n}\n\n.mdi-menu-down::before {\n  content: \"\\F035D\";\n}\n\n.mdi-menu-down-outline::before {\n  content: \"\\F06B6\";\n}\n\n.mdi-menu-left::before {\n  content: \"\\F035E\";\n}\n\n.mdi-menu-left-outline::before {\n  content: \"\\F0A02\";\n}\n\n.mdi-menu-open::before {\n  content: \"\\F0BAB\";\n}\n\n.mdi-menu-right::before {\n  content: \"\\F035F\";\n}\n\n.mdi-menu-right-outline::before {\n  content: \"\\F0A03\";\n}\n\n.mdi-menu-swap::before {\n  content: \"\\F0A64\";\n}\n\n.mdi-menu-swap-outline::before {\n  content: \"\\F0A65\";\n}\n\n.mdi-menu-up::before {\n  content: \"\\F0360\";\n}\n\n.mdi-menu-up-outline::before {\n  content: \"\\F06B7\";\n}\n\n.mdi-merge::before {\n  content: \"\\F0F5C\";\n}\n\n.mdi-message::before {\n  content: \"\\F0361\";\n}\n\n.mdi-message-alert::before {\n  content: \"\\F0362\";\n}\n\n.mdi-message-alert-outline::before {\n  content: \"\\F0A04\";\n}\n\n.mdi-message-arrow-left::before {\n  content: \"\\F12F2\";\n}\n\n.mdi-message-arrow-left-outline::before {\n  content: \"\\F12F3\";\n}\n\n.mdi-message-arrow-right::before {\n  content: \"\\F12F4\";\n}\n\n.mdi-message-arrow-right-outline::before {\n  content: \"\\F12F5\";\n}\n\n.mdi-message-badge::before {\n  content: \"\\F1941\";\n}\n\n.mdi-message-badge-outline::before {\n  content: \"\\F1942\";\n}\n\n.mdi-message-bookmark::before {\n  content: \"\\F15AC\";\n}\n\n.mdi-message-bookmark-outline::before {\n  content: \"\\F15AD\";\n}\n\n.mdi-message-bulleted::before {\n  content: \"\\F06A2\";\n}\n\n.mdi-message-bulleted-off::before {\n  content: \"\\F06A3\";\n}\n\n.mdi-message-cog::before {\n  content: \"\\F06F1\";\n}\n\n.mdi-message-cog-outline::before {\n  content: \"\\F1172\";\n}\n\n.mdi-message-draw::before {\n  content: \"\\F0363\";\n}\n\n.mdi-message-flash::before {\n  content: \"\\F15A9\";\n}\n\n.mdi-message-flash-outline::before {\n  content: \"\\F15AA\";\n}\n\n.mdi-message-image::before {\n  content: \"\\F0364\";\n}\n\n.mdi-message-image-outline::before {\n  content: \"\\F116C\";\n}\n\n.mdi-message-lock::before {\n  content: \"\\F0FCC\";\n}\n\n.mdi-message-lock-outline::before {\n  content: \"\\F116D\";\n}\n\n.mdi-message-minus::before {\n  content: \"\\F116E\";\n}\n\n.mdi-message-minus-outline::before {\n  content: \"\\F116F\";\n}\n\n.mdi-message-off::before {\n  content: \"\\F164D\";\n}\n\n.mdi-message-off-outline::before {\n  content: \"\\F164E\";\n}\n\n.mdi-message-outline::before {\n  content: \"\\F0365\";\n}\n\n.mdi-message-plus::before {\n  content: \"\\F0653\";\n}\n\n.mdi-message-plus-outline::before {\n  content: \"\\F10BB\";\n}\n\n.mdi-message-processing::before {\n  content: \"\\F0366\";\n}\n\n.mdi-message-processing-outline::before {\n  content: \"\\F1170\";\n}\n\n.mdi-message-question::before {\n  content: \"\\F173A\";\n}\n\n.mdi-message-question-outline::before {\n  content: \"\\F173B\";\n}\n\n.mdi-message-reply::before {\n  content: \"\\F0367\";\n}\n\n.mdi-message-reply-outline::before {\n  content: \"\\F173D\";\n}\n\n.mdi-message-reply-text::before {\n  content: \"\\F0368\";\n}\n\n.mdi-message-reply-text-outline::before {\n  content: \"\\F173E\";\n}\n\n.mdi-message-settings::before {\n  content: \"\\F06F0\";\n}\n\n.mdi-message-settings-outline::before {\n  content: \"\\F1171\";\n}\n\n.mdi-message-star::before {\n  content: \"\\F069A\";\n}\n\n.mdi-message-star-outline::before {\n  content: \"\\F1250\";\n}\n\n.mdi-message-text::before {\n  content: \"\\F0369\";\n}\n\n.mdi-message-text-clock::before {\n  content: \"\\F1173\";\n}\n\n.mdi-message-text-clock-outline::before {\n  content: \"\\F1174\";\n}\n\n.mdi-message-text-lock::before {\n  content: \"\\F0FCD\";\n}\n\n.mdi-message-text-lock-outline::before {\n  content: \"\\F1175\";\n}\n\n.mdi-message-text-outline::before {\n  content: \"\\F036A\";\n}\n\n.mdi-message-video::before {\n  content: \"\\F036B\";\n}\n\n.mdi-meteor::before {\n  content: \"\\F0629\";\n}\n\n.mdi-metronome::before {\n  content: \"\\F07DA\";\n}\n\n.mdi-metronome-tick::before {\n  content: \"\\F07DB\";\n}\n\n.mdi-micro-sd::before {\n  content: \"\\F07DC\";\n}\n\n.mdi-microphone::before {\n  content: \"\\F036C\";\n}\n\n.mdi-microphone-minus::before {\n  content: \"\\F08B3\";\n}\n\n.mdi-microphone-off::before {\n  content: \"\\F036D\";\n}\n\n.mdi-microphone-outline::before {\n  content: \"\\F036E\";\n}\n\n.mdi-microphone-plus::before {\n  content: \"\\F08B4\";\n}\n\n.mdi-microphone-question::before {\n  content: \"\\F1989\";\n}\n\n.mdi-microphone-question-outline::before {\n  content: \"\\F198A\";\n}\n\n.mdi-microphone-settings::before {\n  content: \"\\F036F\";\n}\n\n.mdi-microphone-variant::before {\n  content: \"\\F0370\";\n}\n\n.mdi-microphone-variant-off::before {\n  content: \"\\F0371\";\n}\n\n.mdi-microscope::before {\n  content: \"\\F0654\";\n}\n\n.mdi-microsoft::before {\n  content: \"\\F0372\";\n}\n\n.mdi-microsoft-access::before {\n  content: \"\\F138E\";\n}\n\n.mdi-microsoft-azure::before {\n  content: \"\\F0805\";\n}\n\n.mdi-microsoft-azure-devops::before {\n  content: \"\\F0FD5\";\n}\n\n.mdi-microsoft-bing::before {\n  content: \"\\F00A4\";\n}\n\n.mdi-microsoft-dynamics-365::before {\n  content: \"\\F0988\";\n}\n\n.mdi-microsoft-edge::before {\n  content: \"\\F01E9\";\n}\n\n.mdi-microsoft-excel::before {\n  content: \"\\F138F\";\n}\n\n.mdi-microsoft-internet-explorer::before {\n  content: \"\\F0300\";\n}\n\n.mdi-microsoft-office::before {\n  content: \"\\F03C6\";\n}\n\n.mdi-microsoft-onedrive::before {\n  content: \"\\F03CA\";\n}\n\n.mdi-microsoft-onenote::before {\n  content: \"\\F0747\";\n}\n\n.mdi-microsoft-outlook::before {\n  content: \"\\F0D22\";\n}\n\n.mdi-microsoft-powerpoint::before {\n  content: \"\\F1390\";\n}\n\n.mdi-microsoft-sharepoint::before {\n  content: \"\\F1391\";\n}\n\n.mdi-microsoft-teams::before {\n  content: \"\\F02BB\";\n}\n\n.mdi-microsoft-visual-studio::before {\n  content: \"\\F0610\";\n}\n\n.mdi-microsoft-visual-studio-code::before {\n  content: \"\\F0A1E\";\n}\n\n.mdi-microsoft-windows::before {\n  content: \"\\F05B3\";\n}\n\n.mdi-microsoft-windows-classic::before {\n  content: \"\\F0A21\";\n}\n\n.mdi-microsoft-word::before {\n  content: \"\\F1392\";\n}\n\n.mdi-microsoft-xbox::before {\n  content: \"\\F05B9\";\n}\n\n.mdi-microsoft-xbox-controller::before {\n  content: \"\\F05BA\";\n}\n\n.mdi-microsoft-xbox-controller-battery-alert::before {\n  content: \"\\F074B\";\n}\n\n.mdi-microsoft-xbox-controller-battery-charging::before {\n  content: \"\\F0A22\";\n}\n\n.mdi-microsoft-xbox-controller-battery-empty::before {\n  content: \"\\F074C\";\n}\n\n.mdi-microsoft-xbox-controller-battery-full::before {\n  content: \"\\F074D\";\n}\n\n.mdi-microsoft-xbox-controller-battery-low::before {\n  content: \"\\F074E\";\n}\n\n.mdi-microsoft-xbox-controller-battery-medium::before {\n  content: \"\\F074F\";\n}\n\n.mdi-microsoft-xbox-controller-battery-unknown::before {\n  content: \"\\F0750\";\n}\n\n.mdi-microsoft-xbox-controller-menu::before {\n  content: \"\\F0E6F\";\n}\n\n.mdi-microsoft-xbox-controller-off::before {\n  content: \"\\F05BB\";\n}\n\n.mdi-microsoft-xbox-controller-view::before {\n  content: \"\\F0E70\";\n}\n\n.mdi-microwave::before {\n  content: \"\\F0C99\";\n}\n\n.mdi-microwave-off::before {\n  content: \"\\F1423\";\n}\n\n.mdi-middleware::before {\n  content: \"\\F0F5D\";\n}\n\n.mdi-middleware-outline::before {\n  content: \"\\F0F5E\";\n}\n\n.mdi-midi::before {\n  content: \"\\F08F1\";\n}\n\n.mdi-midi-port::before {\n  content: \"\\F08F2\";\n}\n\n.mdi-mine::before {\n  content: \"\\F0DDA\";\n}\n\n.mdi-minecraft::before {\n  content: \"\\F0373\";\n}\n\n.mdi-mini-sd::before {\n  content: \"\\F0A05\";\n}\n\n.mdi-minidisc::before {\n  content: \"\\F0A06\";\n}\n\n.mdi-minus::before {\n  content: \"\\F0374\";\n}\n\n.mdi-minus-box::before {\n  content: \"\\F0375\";\n}\n\n.mdi-minus-box-multiple::before {\n  content: \"\\F1141\";\n}\n\n.mdi-minus-box-multiple-outline::before {\n  content: \"\\F1142\";\n}\n\n.mdi-minus-box-outline::before {\n  content: \"\\F06F2\";\n}\n\n.mdi-minus-circle::before {\n  content: \"\\F0376\";\n}\n\n.mdi-minus-circle-multiple::before {\n  content: \"\\F035A\";\n}\n\n.mdi-minus-circle-multiple-outline::before {\n  content: \"\\F0AD3\";\n}\n\n.mdi-minus-circle-off::before {\n  content: \"\\F1459\";\n}\n\n.mdi-minus-circle-off-outline::before {\n  content: \"\\F145A\";\n}\n\n.mdi-minus-circle-outline::before {\n  content: \"\\F0377\";\n}\n\n.mdi-minus-network::before {\n  content: \"\\F0378\";\n}\n\n.mdi-minus-network-outline::before {\n  content: \"\\F0C9A\";\n}\n\n.mdi-minus-thick::before {\n  content: \"\\F1639\";\n}\n\n.mdi-mirror::before {\n  content: \"\\F11FD\";\n}\n\n.mdi-mirror-rectangle::before {\n  content: \"\\F179F\";\n}\n\n.mdi-mirror-variant::before {\n  content: \"\\F17A0\";\n}\n\n.mdi-mixed-martial-arts::before {\n  content: \"\\F0D8F\";\n}\n\n.mdi-mixed-reality::before {\n  content: \"\\F087F\";\n}\n\n.mdi-molecule::before {\n  content: \"\\F0BAC\";\n}\n\n.mdi-molecule-co::before {\n  content: \"\\F12FE\";\n}\n\n.mdi-molecule-co2::before {\n  content: \"\\F07E4\";\n}\n\n.mdi-monitor::before {\n  content: \"\\F0379\";\n}\n\n.mdi-monitor-cellphone::before {\n  content: \"\\F0989\";\n}\n\n.mdi-monitor-cellphone-star::before {\n  content: \"\\F098A\";\n}\n\n.mdi-monitor-dashboard::before {\n  content: \"\\F0A07\";\n}\n\n.mdi-monitor-edit::before {\n  content: \"\\F12C6\";\n}\n\n.mdi-monitor-eye::before {\n  content: \"\\F13B4\";\n}\n\n.mdi-monitor-lock::before {\n  content: \"\\F0DDB\";\n}\n\n.mdi-monitor-multiple::before {\n  content: \"\\F037A\";\n}\n\n.mdi-monitor-off::before {\n  content: \"\\F0D90\";\n}\n\n.mdi-monitor-screenshot::before {\n  content: \"\\F0E51\";\n}\n\n.mdi-monitor-share::before {\n  content: \"\\F1483\";\n}\n\n.mdi-monitor-shimmer::before {\n  content: \"\\F1104\";\n}\n\n.mdi-monitor-small::before {\n  content: \"\\F1876\";\n}\n\n.mdi-monitor-speaker::before {\n  content: \"\\F0F5F\";\n}\n\n.mdi-monitor-speaker-off::before {\n  content: \"\\F0F60\";\n}\n\n.mdi-monitor-star::before {\n  content: \"\\F0DDC\";\n}\n\n.mdi-moon-first-quarter::before {\n  content: \"\\F0F61\";\n}\n\n.mdi-moon-full::before {\n  content: \"\\F0F62\";\n}\n\n.mdi-moon-last-quarter::before {\n  content: \"\\F0F63\";\n}\n\n.mdi-moon-new::before {\n  content: \"\\F0F64\";\n}\n\n.mdi-moon-waning-crescent::before {\n  content: \"\\F0F65\";\n}\n\n.mdi-moon-waning-gibbous::before {\n  content: \"\\F0F66\";\n}\n\n.mdi-moon-waxing-crescent::before {\n  content: \"\\F0F67\";\n}\n\n.mdi-moon-waxing-gibbous::before {\n  content: \"\\F0F68\";\n}\n\n.mdi-moped::before {\n  content: \"\\F1086\";\n}\n\n.mdi-moped-electric::before {\n  content: \"\\F15B7\";\n}\n\n.mdi-moped-electric-outline::before {\n  content: \"\\F15B8\";\n}\n\n.mdi-moped-outline::before {\n  content: \"\\F15B9\";\n}\n\n.mdi-more::before {\n  content: \"\\F037B\";\n}\n\n.mdi-mortar-pestle::before {\n  content: \"\\F1748\";\n}\n\n.mdi-mortar-pestle-plus::before {\n  content: \"\\F03F1\";\n}\n\n.mdi-mosque::before {\n  content: \"\\F1827\";\n}\n\n.mdi-mother-heart::before {\n  content: \"\\F1314\";\n}\n\n.mdi-mother-nurse::before {\n  content: \"\\F0D21\";\n}\n\n.mdi-motion::before {\n  content: \"\\F15B2\";\n}\n\n.mdi-motion-outline::before {\n  content: \"\\F15B3\";\n}\n\n.mdi-motion-pause::before {\n  content: \"\\F1590\";\n}\n\n.mdi-motion-pause-outline::before {\n  content: \"\\F1592\";\n}\n\n.mdi-motion-play::before {\n  content: \"\\F158F\";\n}\n\n.mdi-motion-play-outline::before {\n  content: \"\\F1591\";\n}\n\n.mdi-motion-sensor::before {\n  content: \"\\F0D91\";\n}\n\n.mdi-motion-sensor-off::before {\n  content: \"\\F1435\";\n}\n\n.mdi-motorbike::before {\n  content: \"\\F037C\";\n}\n\n.mdi-motorbike-electric::before {\n  content: \"\\F15BA\";\n}\n\n.mdi-mouse::before {\n  content: \"\\F037D\";\n}\n\n.mdi-mouse-bluetooth::before {\n  content: \"\\F098B\";\n}\n\n.mdi-mouse-move-down::before {\n  content: \"\\F1550\";\n}\n\n.mdi-mouse-move-up::before {\n  content: \"\\F1551\";\n}\n\n.mdi-mouse-move-vertical::before {\n  content: \"\\F1552\";\n}\n\n.mdi-mouse-off::before {\n  content: \"\\F037E\";\n}\n\n.mdi-mouse-variant::before {\n  content: \"\\F037F\";\n}\n\n.mdi-mouse-variant-off::before {\n  content: \"\\F0380\";\n}\n\n.mdi-move-resize::before {\n  content: \"\\F0655\";\n}\n\n.mdi-move-resize-variant::before {\n  content: \"\\F0656\";\n}\n\n.mdi-movie::before {\n  content: \"\\F0381\";\n}\n\n.mdi-movie-check::before {\n  content: \"\\F16F3\";\n}\n\n.mdi-movie-check-outline::before {\n  content: \"\\F16F4\";\n}\n\n.mdi-movie-cog::before {\n  content: \"\\F16F5\";\n}\n\n.mdi-movie-cog-outline::before {\n  content: \"\\F16F6\";\n}\n\n.mdi-movie-edit::before {\n  content: \"\\F1122\";\n}\n\n.mdi-movie-edit-outline::before {\n  content: \"\\F1123\";\n}\n\n.mdi-movie-filter::before {\n  content: \"\\F1124\";\n}\n\n.mdi-movie-filter-outline::before {\n  content: \"\\F1125\";\n}\n\n.mdi-movie-minus::before {\n  content: \"\\F16F7\";\n}\n\n.mdi-movie-minus-outline::before {\n  content: \"\\F16F8\";\n}\n\n.mdi-movie-off::before {\n  content: \"\\F16F9\";\n}\n\n.mdi-movie-off-outline::before {\n  content: \"\\F16FA\";\n}\n\n.mdi-movie-open::before {\n  content: \"\\F0FCE\";\n}\n\n.mdi-movie-open-check::before {\n  content: \"\\F16FB\";\n}\n\n.mdi-movie-open-check-outline::before {\n  content: \"\\F16FC\";\n}\n\n.mdi-movie-open-cog::before {\n  content: \"\\F16FD\";\n}\n\n.mdi-movie-open-cog-outline::before {\n  content: \"\\F16FE\";\n}\n\n.mdi-movie-open-edit::before {\n  content: \"\\F16FF\";\n}\n\n.mdi-movie-open-edit-outline::before {\n  content: \"\\F1700\";\n}\n\n.mdi-movie-open-minus::before {\n  content: \"\\F1701\";\n}\n\n.mdi-movie-open-minus-outline::before {\n  content: \"\\F1702\";\n}\n\n.mdi-movie-open-off::before {\n  content: \"\\F1703\";\n}\n\n.mdi-movie-open-off-outline::before {\n  content: \"\\F1704\";\n}\n\n.mdi-movie-open-outline::before {\n  content: \"\\F0FCF\";\n}\n\n.mdi-movie-open-play::before {\n  content: \"\\F1705\";\n}\n\n.mdi-movie-open-play-outline::before {\n  content: \"\\F1706\";\n}\n\n.mdi-movie-open-plus::before {\n  content: \"\\F1707\";\n}\n\n.mdi-movie-open-plus-outline::before {\n  content: \"\\F1708\";\n}\n\n.mdi-movie-open-remove::before {\n  content: \"\\F1709\";\n}\n\n.mdi-movie-open-remove-outline::before {\n  content: \"\\F170A\";\n}\n\n.mdi-movie-open-settings::before {\n  content: \"\\F170B\";\n}\n\n.mdi-movie-open-settings-outline::before {\n  content: \"\\F170C\";\n}\n\n.mdi-movie-open-star::before {\n  content: \"\\F170D\";\n}\n\n.mdi-movie-open-star-outline::before {\n  content: \"\\F170E\";\n}\n\n.mdi-movie-outline::before {\n  content: \"\\F0DDD\";\n}\n\n.mdi-movie-play::before {\n  content: \"\\F170F\";\n}\n\n.mdi-movie-play-outline::before {\n  content: \"\\F1710\";\n}\n\n.mdi-movie-plus::before {\n  content: \"\\F1711\";\n}\n\n.mdi-movie-plus-outline::before {\n  content: \"\\F1712\";\n}\n\n.mdi-movie-remove::before {\n  content: \"\\F1713\";\n}\n\n.mdi-movie-remove-outline::before {\n  content: \"\\F1714\";\n}\n\n.mdi-movie-roll::before {\n  content: \"\\F07DE\";\n}\n\n.mdi-movie-search::before {\n  content: \"\\F11D2\";\n}\n\n.mdi-movie-search-outline::before {\n  content: \"\\F11D3\";\n}\n\n.mdi-movie-settings::before {\n  content: \"\\F1715\";\n}\n\n.mdi-movie-settings-outline::before {\n  content: \"\\F1716\";\n}\n\n.mdi-movie-star::before {\n  content: \"\\F1717\";\n}\n\n.mdi-movie-star-outline::before {\n  content: \"\\F1718\";\n}\n\n.mdi-mower::before {\n  content: \"\\F166F\";\n}\n\n.mdi-mower-bag::before {\n  content: \"\\F1670\";\n}\n\n.mdi-muffin::before {\n  content: \"\\F098C\";\n}\n\n.mdi-multicast::before {\n  content: \"\\F1893\";\n}\n\n.mdi-multiplication::before {\n  content: \"\\F0382\";\n}\n\n.mdi-multiplication-box::before {\n  content: \"\\F0383\";\n}\n\n.mdi-mushroom::before {\n  content: \"\\F07DF\";\n}\n\n.mdi-mushroom-off::before {\n  content: \"\\F13FA\";\n}\n\n.mdi-mushroom-off-outline::before {\n  content: \"\\F13FB\";\n}\n\n.mdi-mushroom-outline::before {\n  content: \"\\F07E0\";\n}\n\n.mdi-music::before {\n  content: \"\\F075A\";\n}\n\n.mdi-music-accidental-double-flat::before {\n  content: \"\\F0F69\";\n}\n\n.mdi-music-accidental-double-sharp::before {\n  content: \"\\F0F6A\";\n}\n\n.mdi-music-accidental-flat::before {\n  content: \"\\F0F6B\";\n}\n\n.mdi-music-accidental-natural::before {\n  content: \"\\F0F6C\";\n}\n\n.mdi-music-accidental-sharp::before {\n  content: \"\\F0F6D\";\n}\n\n.mdi-music-box::before {\n  content: \"\\F0384\";\n}\n\n.mdi-music-box-multiple::before {\n  content: \"\\F0333\";\n}\n\n.mdi-music-box-multiple-outline::before {\n  content: \"\\F0F04\";\n}\n\n.mdi-music-box-outline::before {\n  content: \"\\F0385\";\n}\n\n.mdi-music-circle::before {\n  content: \"\\F0386\";\n}\n\n.mdi-music-circle-outline::before {\n  content: \"\\F0AD4\";\n}\n\n.mdi-music-clef-alto::before {\n  content: \"\\F0F6E\";\n}\n\n.mdi-music-clef-bass::before {\n  content: \"\\F0F6F\";\n}\n\n.mdi-music-clef-treble::before {\n  content: \"\\F0F70\";\n}\n\n.mdi-music-note::before {\n  content: \"\\F0387\";\n}\n\n.mdi-music-note-bluetooth::before {\n  content: \"\\F05FE\";\n}\n\n.mdi-music-note-bluetooth-off::before {\n  content: \"\\F05FF\";\n}\n\n.mdi-music-note-eighth::before {\n  content: \"\\F0388\";\n}\n\n.mdi-music-note-eighth-dotted::before {\n  content: \"\\F0F71\";\n}\n\n.mdi-music-note-half::before {\n  content: \"\\F0389\";\n}\n\n.mdi-music-note-half-dotted::before {\n  content: \"\\F0F72\";\n}\n\n.mdi-music-note-off::before {\n  content: \"\\F038A\";\n}\n\n.mdi-music-note-off-outline::before {\n  content: \"\\F0F73\";\n}\n\n.mdi-music-note-outline::before {\n  content: \"\\F0F74\";\n}\n\n.mdi-music-note-plus::before {\n  content: \"\\F0DDE\";\n}\n\n.mdi-music-note-quarter::before {\n  content: \"\\F038B\";\n}\n\n.mdi-music-note-quarter-dotted::before {\n  content: \"\\F0F75\";\n}\n\n.mdi-music-note-sixteenth::before {\n  content: \"\\F038C\";\n}\n\n.mdi-music-note-sixteenth-dotted::before {\n  content: \"\\F0F76\";\n}\n\n.mdi-music-note-whole::before {\n  content: \"\\F038D\";\n}\n\n.mdi-music-note-whole-dotted::before {\n  content: \"\\F0F77\";\n}\n\n.mdi-music-off::before {\n  content: \"\\F075B\";\n}\n\n.mdi-music-rest-eighth::before {\n  content: \"\\F0F78\";\n}\n\n.mdi-music-rest-half::before {\n  content: \"\\F0F79\";\n}\n\n.mdi-music-rest-quarter::before {\n  content: \"\\F0F7A\";\n}\n\n.mdi-music-rest-sixteenth::before {\n  content: \"\\F0F7B\";\n}\n\n.mdi-music-rest-whole::before {\n  content: \"\\F0F7C\";\n}\n\n.mdi-mustache::before {\n  content: \"\\F15DE\";\n}\n\n.mdi-nail::before {\n  content: \"\\F0DDF\";\n}\n\n.mdi-nas::before {\n  content: \"\\F08F3\";\n}\n\n.mdi-nativescript::before {\n  content: \"\\F0880\";\n}\n\n.mdi-nature::before {\n  content: \"\\F038E\";\n}\n\n.mdi-nature-people::before {\n  content: \"\\F038F\";\n}\n\n.mdi-navigation::before {\n  content: \"\\F0390\";\n}\n\n.mdi-navigation-outline::before {\n  content: \"\\F1607\";\n}\n\n.mdi-navigation-variant::before {\n  content: \"\\F18F0\";\n}\n\n.mdi-navigation-variant-outline::before {\n  content: \"\\F18F1\";\n}\n\n.mdi-near-me::before {\n  content: \"\\F05CD\";\n}\n\n.mdi-necklace::before {\n  content: \"\\F0F0B\";\n}\n\n.mdi-needle::before {\n  content: \"\\F0391\";\n}\n\n.mdi-netflix::before {\n  content: \"\\F0746\";\n}\n\n.mdi-network::before {\n  content: \"\\F06F3\";\n}\n\n.mdi-network-off::before {\n  content: \"\\F0C9B\";\n}\n\n.mdi-network-off-outline::before {\n  content: \"\\F0C9C\";\n}\n\n.mdi-network-outline::before {\n  content: \"\\F0C9D\";\n}\n\n.mdi-network-strength-1::before {\n  content: \"\\F08F4\";\n}\n\n.mdi-network-strength-1-alert::before {\n  content: \"\\F08F5\";\n}\n\n.mdi-network-strength-2::before {\n  content: \"\\F08F6\";\n}\n\n.mdi-network-strength-2-alert::before {\n  content: \"\\F08F7\";\n}\n\n.mdi-network-strength-3::before {\n  content: \"\\F08F8\";\n}\n\n.mdi-network-strength-3-alert::before {\n  content: \"\\F08F9\";\n}\n\n.mdi-network-strength-4::before {\n  content: \"\\F08FA\";\n}\n\n.mdi-network-strength-4-alert::before {\n  content: \"\\F08FB\";\n}\n\n.mdi-network-strength-4-cog::before {\n  content: \"\\F191A\";\n}\n\n.mdi-network-strength-off::before {\n  content: \"\\F08FC\";\n}\n\n.mdi-network-strength-off-outline::before {\n  content: \"\\F08FD\";\n}\n\n.mdi-network-strength-outline::before {\n  content: \"\\F08FE\";\n}\n\n.mdi-new-box::before {\n  content: \"\\F0394\";\n}\n\n.mdi-newspaper::before {\n  content: \"\\F0395\";\n}\n\n.mdi-newspaper-check::before {\n  content: \"\\F1943\";\n}\n\n.mdi-newspaper-minus::before {\n  content: \"\\F0F0C\";\n}\n\n.mdi-newspaper-plus::before {\n  content: \"\\F0F0D\";\n}\n\n.mdi-newspaper-remove::before {\n  content: \"\\F1944\";\n}\n\n.mdi-newspaper-variant::before {\n  content: \"\\F1001\";\n}\n\n.mdi-newspaper-variant-multiple::before {\n  content: \"\\F1002\";\n}\n\n.mdi-newspaper-variant-multiple-outline::before {\n  content: \"\\F1003\";\n}\n\n.mdi-newspaper-variant-outline::before {\n  content: \"\\F1004\";\n}\n\n.mdi-nfc::before {\n  content: \"\\F0396\";\n}\n\n.mdi-nfc-search-variant::before {\n  content: \"\\F0E53\";\n}\n\n.mdi-nfc-tap::before {\n  content: \"\\F0397\";\n}\n\n.mdi-nfc-variant::before {\n  content: \"\\F0398\";\n}\n\n.mdi-nfc-variant-off::before {\n  content: \"\\F0E54\";\n}\n\n.mdi-ninja::before {\n  content: \"\\F0774\";\n}\n\n.mdi-nintendo-game-boy::before {\n  content: \"\\F1393\";\n}\n\n.mdi-nintendo-switch::before {\n  content: \"\\F07E1\";\n}\n\n.mdi-nintendo-wii::before {\n  content: \"\\F05AB\";\n}\n\n.mdi-nintendo-wiiu::before {\n  content: \"\\F072D\";\n}\n\n.mdi-nix::before {\n  content: \"\\F1105\";\n}\n\n.mdi-nodejs::before {\n  content: \"\\F0399\";\n}\n\n.mdi-noodles::before {\n  content: \"\\F117E\";\n}\n\n.mdi-not-equal::before {\n  content: \"\\F098D\";\n}\n\n.mdi-not-equal-variant::before {\n  content: \"\\F098E\";\n}\n\n.mdi-note::before {\n  content: \"\\F039A\";\n}\n\n.mdi-note-alert::before {\n  content: \"\\F177D\";\n}\n\n.mdi-note-alert-outline::before {\n  content: \"\\F177E\";\n}\n\n.mdi-note-check::before {\n  content: \"\\F177F\";\n}\n\n.mdi-note-check-outline::before {\n  content: \"\\F1780\";\n}\n\n.mdi-note-edit::before {\n  content: \"\\F1781\";\n}\n\n.mdi-note-edit-outline::before {\n  content: \"\\F1782\";\n}\n\n.mdi-note-minus::before {\n  content: \"\\F164F\";\n}\n\n.mdi-note-minus-outline::before {\n  content: \"\\F1650\";\n}\n\n.mdi-note-multiple::before {\n  content: \"\\F06B8\";\n}\n\n.mdi-note-multiple-outline::before {\n  content: \"\\F06B9\";\n}\n\n.mdi-note-off::before {\n  content: \"\\F1783\";\n}\n\n.mdi-note-off-outline::before {\n  content: \"\\F1784\";\n}\n\n.mdi-note-outline::before {\n  content: \"\\F039B\";\n}\n\n.mdi-note-plus::before {\n  content: \"\\F039C\";\n}\n\n.mdi-note-plus-outline::before {\n  content: \"\\F039D\";\n}\n\n.mdi-note-remove::before {\n  content: \"\\F1651\";\n}\n\n.mdi-note-remove-outline::before {\n  content: \"\\F1652\";\n}\n\n.mdi-note-search::before {\n  content: \"\\F1653\";\n}\n\n.mdi-note-search-outline::before {\n  content: \"\\F1654\";\n}\n\n.mdi-note-text::before {\n  content: \"\\F039E\";\n}\n\n.mdi-note-text-outline::before {\n  content: \"\\F11D7\";\n}\n\n.mdi-notebook::before {\n  content: \"\\F082E\";\n}\n\n.mdi-notebook-check::before {\n  content: \"\\F14F5\";\n}\n\n.mdi-notebook-check-outline::before {\n  content: \"\\F14F6\";\n}\n\n.mdi-notebook-edit::before {\n  content: \"\\F14E7\";\n}\n\n.mdi-notebook-edit-outline::before {\n  content: \"\\F14E9\";\n}\n\n.mdi-notebook-minus::before {\n  content: \"\\F1610\";\n}\n\n.mdi-notebook-minus-outline::before {\n  content: \"\\F1611\";\n}\n\n.mdi-notebook-multiple::before {\n  content: \"\\F0E55\";\n}\n\n.mdi-notebook-outline::before {\n  content: \"\\F0EBF\";\n}\n\n.mdi-notebook-plus::before {\n  content: \"\\F1612\";\n}\n\n.mdi-notebook-plus-outline::before {\n  content: \"\\F1613\";\n}\n\n.mdi-notebook-remove::before {\n  content: \"\\F1614\";\n}\n\n.mdi-notebook-remove-outline::before {\n  content: \"\\F1615\";\n}\n\n.mdi-notification-clear-all::before {\n  content: \"\\F039F\";\n}\n\n.mdi-npm::before {\n  content: \"\\F06F7\";\n}\n\n.mdi-nuke::before {\n  content: \"\\F06A4\";\n}\n\n.mdi-null::before {\n  content: \"\\F07E2\";\n}\n\n.mdi-numeric::before {\n  content: \"\\F03A0\";\n}\n\n.mdi-numeric-0::before {\n  content: \"\\F0B39\";\n}\n\n.mdi-numeric-0-box::before {\n  content: \"\\F03A1\";\n}\n\n.mdi-numeric-0-box-multiple::before {\n  content: \"\\F0F0E\";\n}\n\n.mdi-numeric-0-box-multiple-outline::before {\n  content: \"\\F03A2\";\n}\n\n.mdi-numeric-0-box-outline::before {\n  content: \"\\F03A3\";\n}\n\n.mdi-numeric-0-circle::before {\n  content: \"\\F0C9E\";\n}\n\n.mdi-numeric-0-circle-outline::before {\n  content: \"\\F0C9F\";\n}\n\n.mdi-numeric-1::before {\n  content: \"\\F0B3A\";\n}\n\n.mdi-numeric-1-box::before {\n  content: \"\\F03A4\";\n}\n\n.mdi-numeric-1-box-multiple::before {\n  content: \"\\F0F0F\";\n}\n\n.mdi-numeric-1-box-multiple-outline::before {\n  content: \"\\F03A5\";\n}\n\n.mdi-numeric-1-box-outline::before {\n  content: \"\\F03A6\";\n}\n\n.mdi-numeric-1-circle::before {\n  content: \"\\F0CA0\";\n}\n\n.mdi-numeric-1-circle-outline::before {\n  content: \"\\F0CA1\";\n}\n\n.mdi-numeric-10::before {\n  content: \"\\F0FE9\";\n}\n\n.mdi-numeric-10-box::before {\n  content: \"\\F0F7D\";\n}\n\n.mdi-numeric-10-box-multiple::before {\n  content: \"\\F0FEA\";\n}\n\n.mdi-numeric-10-box-multiple-outline::before {\n  content: \"\\F0FEB\";\n}\n\n.mdi-numeric-10-box-outline::before {\n  content: \"\\F0F7E\";\n}\n\n.mdi-numeric-10-circle::before {\n  content: \"\\F0FEC\";\n}\n\n.mdi-numeric-10-circle-outline::before {\n  content: \"\\F0FED\";\n}\n\n.mdi-numeric-2::before {\n  content: \"\\F0B3B\";\n}\n\n.mdi-numeric-2-box::before {\n  content: \"\\F03A7\";\n}\n\n.mdi-numeric-2-box-multiple::before {\n  content: \"\\F0F10\";\n}\n\n.mdi-numeric-2-box-multiple-outline::before {\n  content: \"\\F03A8\";\n}\n\n.mdi-numeric-2-box-outline::before {\n  content: \"\\F03A9\";\n}\n\n.mdi-numeric-2-circle::before {\n  content: \"\\F0CA2\";\n}\n\n.mdi-numeric-2-circle-outline::before {\n  content: \"\\F0CA3\";\n}\n\n.mdi-numeric-3::before {\n  content: \"\\F0B3C\";\n}\n\n.mdi-numeric-3-box::before {\n  content: \"\\F03AA\";\n}\n\n.mdi-numeric-3-box-multiple::before {\n  content: \"\\F0F11\";\n}\n\n.mdi-numeric-3-box-multiple-outline::before {\n  content: \"\\F03AB\";\n}\n\n.mdi-numeric-3-box-outline::before {\n  content: \"\\F03AC\";\n}\n\n.mdi-numeric-3-circle::before {\n  content: \"\\F0CA4\";\n}\n\n.mdi-numeric-3-circle-outline::before {\n  content: \"\\F0CA5\";\n}\n\n.mdi-numeric-4::before {\n  content: \"\\F0B3D\";\n}\n\n.mdi-numeric-4-box::before {\n  content: \"\\F03AD\";\n}\n\n.mdi-numeric-4-box-multiple::before {\n  content: \"\\F0F12\";\n}\n\n.mdi-numeric-4-box-multiple-outline::before {\n  content: \"\\F03B2\";\n}\n\n.mdi-numeric-4-box-outline::before {\n  content: \"\\F03AE\";\n}\n\n.mdi-numeric-4-circle::before {\n  content: \"\\F0CA6\";\n}\n\n.mdi-numeric-4-circle-outline::before {\n  content: \"\\F0CA7\";\n}\n\n.mdi-numeric-5::before {\n  content: \"\\F0B3E\";\n}\n\n.mdi-numeric-5-box::before {\n  content: \"\\F03B1\";\n}\n\n.mdi-numeric-5-box-multiple::before {\n  content: \"\\F0F13\";\n}\n\n.mdi-numeric-5-box-multiple-outline::before {\n  content: \"\\F03AF\";\n}\n\n.mdi-numeric-5-box-outline::before {\n  content: \"\\F03B0\";\n}\n\n.mdi-numeric-5-circle::before {\n  content: \"\\F0CA8\";\n}\n\n.mdi-numeric-5-circle-outline::before {\n  content: \"\\F0CA9\";\n}\n\n.mdi-numeric-6::before {\n  content: \"\\F0B3F\";\n}\n\n.mdi-numeric-6-box::before {\n  content: \"\\F03B3\";\n}\n\n.mdi-numeric-6-box-multiple::before {\n  content: \"\\F0F14\";\n}\n\n.mdi-numeric-6-box-multiple-outline::before {\n  content: \"\\F03B4\";\n}\n\n.mdi-numeric-6-box-outline::before {\n  content: \"\\F03B5\";\n}\n\n.mdi-numeric-6-circle::before {\n  content: \"\\F0CAA\";\n}\n\n.mdi-numeric-6-circle-outline::before {\n  content: \"\\F0CAB\";\n}\n\n.mdi-numeric-7::before {\n  content: \"\\F0B40\";\n}\n\n.mdi-numeric-7-box::before {\n  content: \"\\F03B6\";\n}\n\n.mdi-numeric-7-box-multiple::before {\n  content: \"\\F0F15\";\n}\n\n.mdi-numeric-7-box-multiple-outline::before {\n  content: \"\\F03B7\";\n}\n\n.mdi-numeric-7-box-outline::before {\n  content: \"\\F03B8\";\n}\n\n.mdi-numeric-7-circle::before {\n  content: \"\\F0CAC\";\n}\n\n.mdi-numeric-7-circle-outline::before {\n  content: \"\\F0CAD\";\n}\n\n.mdi-numeric-8::before {\n  content: \"\\F0B41\";\n}\n\n.mdi-numeric-8-box::before {\n  content: \"\\F03B9\";\n}\n\n.mdi-numeric-8-box-multiple::before {\n  content: \"\\F0F16\";\n}\n\n.mdi-numeric-8-box-multiple-outline::before {\n  content: \"\\F03BA\";\n}\n\n.mdi-numeric-8-box-outline::before {\n  content: \"\\F03BB\";\n}\n\n.mdi-numeric-8-circle::before {\n  content: \"\\F0CAE\";\n}\n\n.mdi-numeric-8-circle-outline::before {\n  content: \"\\F0CAF\";\n}\n\n.mdi-numeric-9::before {\n  content: \"\\F0B42\";\n}\n\n.mdi-numeric-9-box::before {\n  content: \"\\F03BC\";\n}\n\n.mdi-numeric-9-box-multiple::before {\n  content: \"\\F0F17\";\n}\n\n.mdi-numeric-9-box-multiple-outline::before {\n  content: \"\\F03BD\";\n}\n\n.mdi-numeric-9-box-outline::before {\n  content: \"\\F03BE\";\n}\n\n.mdi-numeric-9-circle::before {\n  content: \"\\F0CB0\";\n}\n\n.mdi-numeric-9-circle-outline::before {\n  content: \"\\F0CB1\";\n}\n\n.mdi-numeric-9-plus::before {\n  content: \"\\F0FEE\";\n}\n\n.mdi-numeric-9-plus-box::before {\n  content: \"\\F03BF\";\n}\n\n.mdi-numeric-9-plus-box-multiple::before {\n  content: \"\\F0F18\";\n}\n\n.mdi-numeric-9-plus-box-multiple-outline::before {\n  content: \"\\F03C0\";\n}\n\n.mdi-numeric-9-plus-box-outline::before {\n  content: \"\\F03C1\";\n}\n\n.mdi-numeric-9-plus-circle::before {\n  content: \"\\F0CB2\";\n}\n\n.mdi-numeric-9-plus-circle-outline::before {\n  content: \"\\F0CB3\";\n}\n\n.mdi-numeric-negative-1::before {\n  content: \"\\F1052\";\n}\n\n.mdi-numeric-positive-1::before {\n  content: \"\\F15CB\";\n}\n\n.mdi-nut::before {\n  content: \"\\F06F8\";\n}\n\n.mdi-nutrition::before {\n  content: \"\\F03C2\";\n}\n\n.mdi-nuxt::before {\n  content: \"\\F1106\";\n}\n\n.mdi-oar::before {\n  content: \"\\F067C\";\n}\n\n.mdi-ocarina::before {\n  content: \"\\F0DE0\";\n}\n\n.mdi-oci::before {\n  content: \"\\F12E9\";\n}\n\n.mdi-ocr::before {\n  content: \"\\F113A\";\n}\n\n.mdi-octagon::before {\n  content: \"\\F03C3\";\n}\n\n.mdi-octagon-outline::before {\n  content: \"\\F03C4\";\n}\n\n.mdi-octagram::before {\n  content: \"\\F06F9\";\n}\n\n.mdi-octagram-outline::before {\n  content: \"\\F0775\";\n}\n\n.mdi-octahedron::before {\n  content: \"\\F1950\";\n}\n\n.mdi-octahedron-off::before {\n  content: \"\\F1951\";\n}\n\n.mdi-odnoklassniki::before {\n  content: \"\\F03C5\";\n}\n\n.mdi-offer::before {\n  content: \"\\F121B\";\n}\n\n.mdi-office-building::before {\n  content: \"\\F0991\";\n}\n\n.mdi-office-building-cog::before {\n  content: \"\\F1949\";\n}\n\n.mdi-office-building-cog-outline::before {\n  content: \"\\F194A\";\n}\n\n.mdi-office-building-marker::before {\n  content: \"\\F1520\";\n}\n\n.mdi-office-building-marker-outline::before {\n  content: \"\\F1521\";\n}\n\n.mdi-office-building-outline::before {\n  content: \"\\F151F\";\n}\n\n.mdi-oil::before {\n  content: \"\\F03C7\";\n}\n\n.mdi-oil-lamp::before {\n  content: \"\\F0F19\";\n}\n\n.mdi-oil-level::before {\n  content: \"\\F1053\";\n}\n\n.mdi-oil-temperature::before {\n  content: \"\\F0FF8\";\n}\n\n.mdi-om::before {\n  content: \"\\F0973\";\n}\n\n.mdi-omega::before {\n  content: \"\\F03C9\";\n}\n\n.mdi-one-up::before {\n  content: \"\\F0BAD\";\n}\n\n.mdi-onepassword::before {\n  content: \"\\F0881\";\n}\n\n.mdi-opacity::before {\n  content: \"\\F05CC\";\n}\n\n.mdi-open-in-app::before {\n  content: \"\\F03CB\";\n}\n\n.mdi-open-in-new::before {\n  content: \"\\F03CC\";\n}\n\n.mdi-open-source-initiative::before {\n  content: \"\\F0BAE\";\n}\n\n.mdi-openid::before {\n  content: \"\\F03CD\";\n}\n\n.mdi-opera::before {\n  content: \"\\F03CE\";\n}\n\n.mdi-orbit::before {\n  content: \"\\F0018\";\n}\n\n.mdi-orbit-variant::before {\n  content: \"\\F15DB\";\n}\n\n.mdi-order-alphabetical-ascending::before {\n  content: \"\\F020D\";\n}\n\n.mdi-order-alphabetical-descending::before {\n  content: \"\\F0D07\";\n}\n\n.mdi-order-bool-ascending::before {\n  content: \"\\F02BE\";\n}\n\n.mdi-order-bool-ascending-variant::before {\n  content: \"\\F098F\";\n}\n\n.mdi-order-bool-descending::before {\n  content: \"\\F1384\";\n}\n\n.mdi-order-bool-descending-variant::before {\n  content: \"\\F0990\";\n}\n\n.mdi-order-numeric-ascending::before {\n  content: \"\\F0545\";\n}\n\n.mdi-order-numeric-descending::before {\n  content: \"\\F0546\";\n}\n\n.mdi-origin::before {\n  content: \"\\F0B43\";\n}\n\n.mdi-ornament::before {\n  content: \"\\F03CF\";\n}\n\n.mdi-ornament-variant::before {\n  content: \"\\F03D0\";\n}\n\n.mdi-outdoor-lamp::before {\n  content: \"\\F1054\";\n}\n\n.mdi-overscan::before {\n  content: \"\\F1005\";\n}\n\n.mdi-owl::before {\n  content: \"\\F03D2\";\n}\n\n.mdi-pac-man::before {\n  content: \"\\F0BAF\";\n}\n\n.mdi-package::before {\n  content: \"\\F03D3\";\n}\n\n.mdi-package-down::before {\n  content: \"\\F03D4\";\n}\n\n.mdi-package-up::before {\n  content: \"\\F03D5\";\n}\n\n.mdi-package-variant::before {\n  content: \"\\F03D6\";\n}\n\n.mdi-package-variant-closed::before {\n  content: \"\\F03D7\";\n}\n\n.mdi-page-first::before {\n  content: \"\\F0600\";\n}\n\n.mdi-page-last::before {\n  content: \"\\F0601\";\n}\n\n.mdi-page-layout-body::before {\n  content: \"\\F06FA\";\n}\n\n.mdi-page-layout-footer::before {\n  content: \"\\F06FB\";\n}\n\n.mdi-page-layout-header::before {\n  content: \"\\F06FC\";\n}\n\n.mdi-page-layout-header-footer::before {\n  content: \"\\F0F7F\";\n}\n\n.mdi-page-layout-sidebar-left::before {\n  content: \"\\F06FD\";\n}\n\n.mdi-page-layout-sidebar-right::before {\n  content: \"\\F06FE\";\n}\n\n.mdi-page-next::before {\n  content: \"\\F0BB0\";\n}\n\n.mdi-page-next-outline::before {\n  content: \"\\F0BB1\";\n}\n\n.mdi-page-previous::before {\n  content: \"\\F0BB2\";\n}\n\n.mdi-page-previous-outline::before {\n  content: \"\\F0BB3\";\n}\n\n.mdi-pail::before {\n  content: \"\\F1417\";\n}\n\n.mdi-pail-minus::before {\n  content: \"\\F1437\";\n}\n\n.mdi-pail-minus-outline::before {\n  content: \"\\F143C\";\n}\n\n.mdi-pail-off::before {\n  content: \"\\F1439\";\n}\n\n.mdi-pail-off-outline::before {\n  content: \"\\F143E\";\n}\n\n.mdi-pail-outline::before {\n  content: \"\\F143A\";\n}\n\n.mdi-pail-plus::before {\n  content: \"\\F1436\";\n}\n\n.mdi-pail-plus-outline::before {\n  content: \"\\F143B\";\n}\n\n.mdi-pail-remove::before {\n  content: \"\\F1438\";\n}\n\n.mdi-pail-remove-outline::before {\n  content: \"\\F143D\";\n}\n\n.mdi-palette::before {\n  content: \"\\F03D8\";\n}\n\n.mdi-palette-advanced::before {\n  content: \"\\F03D9\";\n}\n\n.mdi-palette-outline::before {\n  content: \"\\F0E0C\";\n}\n\n.mdi-palette-swatch::before {\n  content: \"\\F08B5\";\n}\n\n.mdi-palette-swatch-outline::before {\n  content: \"\\F135C\";\n}\n\n.mdi-palette-swatch-variant::before {\n  content: \"\\F195A\";\n}\n\n.mdi-palm-tree::before {\n  content: \"\\F1055\";\n}\n\n.mdi-pan::before {\n  content: \"\\F0BB4\";\n}\n\n.mdi-pan-bottom-left::before {\n  content: \"\\F0BB5\";\n}\n\n.mdi-pan-bottom-right::before {\n  content: \"\\F0BB6\";\n}\n\n.mdi-pan-down::before {\n  content: \"\\F0BB7\";\n}\n\n.mdi-pan-horizontal::before {\n  content: \"\\F0BB8\";\n}\n\n.mdi-pan-left::before {\n  content: \"\\F0BB9\";\n}\n\n.mdi-pan-right::before {\n  content: \"\\F0BBA\";\n}\n\n.mdi-pan-top-left::before {\n  content: \"\\F0BBB\";\n}\n\n.mdi-pan-top-right::before {\n  content: \"\\F0BBC\";\n}\n\n.mdi-pan-up::before {\n  content: \"\\F0BBD\";\n}\n\n.mdi-pan-vertical::before {\n  content: \"\\F0BBE\";\n}\n\n.mdi-panda::before {\n  content: \"\\F03DA\";\n}\n\n.mdi-pandora::before {\n  content: \"\\F03DB\";\n}\n\n.mdi-panorama::before {\n  content: \"\\F03DC\";\n}\n\n.mdi-panorama-fisheye::before {\n  content: \"\\F03DD\";\n}\n\n.mdi-panorama-horizontal::before {\n  content: \"\\F1928\";\n}\n\n.mdi-panorama-horizontal-outline::before {\n  content: \"\\F03DE\";\n}\n\n.mdi-panorama-outline::before {\n  content: \"\\F198C\";\n}\n\n.mdi-panorama-sphere::before {\n  content: \"\\F198D\";\n}\n\n.mdi-panorama-sphere-outline::before {\n  content: \"\\F198E\";\n}\n\n.mdi-panorama-variant::before {\n  content: \"\\F198F\";\n}\n\n.mdi-panorama-variant-outline::before {\n  content: \"\\F1990\";\n}\n\n.mdi-panorama-vertical::before {\n  content: \"\\F1929\";\n}\n\n.mdi-panorama-vertical-outline::before {\n  content: \"\\F03DF\";\n}\n\n.mdi-panorama-wide-angle::before {\n  content: \"\\F195F\";\n}\n\n.mdi-panorama-wide-angle-outline::before {\n  content: \"\\F03E0\";\n}\n\n.mdi-paper-cut-vertical::before {\n  content: \"\\F03E1\";\n}\n\n.mdi-paper-roll::before {\n  content: \"\\F1157\";\n}\n\n.mdi-paper-roll-outline::before {\n  content: \"\\F1158\";\n}\n\n.mdi-paperclip::before {\n  content: \"\\F03E2\";\n}\n\n.mdi-parachute::before {\n  content: \"\\F0CB4\";\n}\n\n.mdi-parachute-outline::before {\n  content: \"\\F0CB5\";\n}\n\n.mdi-paragliding::before {\n  content: \"\\F1745\";\n}\n\n.mdi-parking::before {\n  content: \"\\F03E3\";\n}\n\n.mdi-party-popper::before {\n  content: \"\\F1056\";\n}\n\n.mdi-passport::before {\n  content: \"\\F07E3\";\n}\n\n.mdi-passport-biometric::before {\n  content: \"\\F0DE1\";\n}\n\n.mdi-pasta::before {\n  content: \"\\F1160\";\n}\n\n.mdi-patio-heater::before {\n  content: \"\\F0F80\";\n}\n\n.mdi-patreon::before {\n  content: \"\\F0882\";\n}\n\n.mdi-pause::before {\n  content: \"\\F03E4\";\n}\n\n.mdi-pause-circle::before {\n  content: \"\\F03E5\";\n}\n\n.mdi-pause-circle-outline::before {\n  content: \"\\F03E6\";\n}\n\n.mdi-pause-octagon::before {\n  content: \"\\F03E7\";\n}\n\n.mdi-pause-octagon-outline::before {\n  content: \"\\F03E8\";\n}\n\n.mdi-paw::before {\n  content: \"\\F03E9\";\n}\n\n.mdi-paw-off::before {\n  content: \"\\F0657\";\n}\n\n.mdi-paw-off-outline::before {\n  content: \"\\F1676\";\n}\n\n.mdi-paw-outline::before {\n  content: \"\\F1675\";\n}\n\n.mdi-peace::before {\n  content: \"\\F0884\";\n}\n\n.mdi-peanut::before {\n  content: \"\\F0FFC\";\n}\n\n.mdi-peanut-off::before {\n  content: \"\\F0FFD\";\n}\n\n.mdi-peanut-off-outline::before {\n  content: \"\\F0FFF\";\n}\n\n.mdi-peanut-outline::before {\n  content: \"\\F0FFE\";\n}\n\n.mdi-pen::before {\n  content: \"\\F03EA\";\n}\n\n.mdi-pen-lock::before {\n  content: \"\\F0DE2\";\n}\n\n.mdi-pen-minus::before {\n  content: \"\\F0DE3\";\n}\n\n.mdi-pen-off::before {\n  content: \"\\F0DE4\";\n}\n\n.mdi-pen-plus::before {\n  content: \"\\F0DE5\";\n}\n\n.mdi-pen-remove::before {\n  content: \"\\F0DE6\";\n}\n\n.mdi-pencil::before {\n  content: \"\\F03EB\";\n}\n\n.mdi-pencil-box::before {\n  content: \"\\F03EC\";\n}\n\n.mdi-pencil-box-multiple::before {\n  content: \"\\F1144\";\n}\n\n.mdi-pencil-box-multiple-outline::before {\n  content: \"\\F1145\";\n}\n\n.mdi-pencil-box-outline::before {\n  content: \"\\F03ED\";\n}\n\n.mdi-pencil-circle::before {\n  content: \"\\F06FF\";\n}\n\n.mdi-pencil-circle-outline::before {\n  content: \"\\F0776\";\n}\n\n.mdi-pencil-lock::before {\n  content: \"\\F03EE\";\n}\n\n.mdi-pencil-lock-outline::before {\n  content: \"\\F0DE7\";\n}\n\n.mdi-pencil-minus::before {\n  content: \"\\F0DE8\";\n}\n\n.mdi-pencil-minus-outline::before {\n  content: \"\\F0DE9\";\n}\n\n.mdi-pencil-off::before {\n  content: \"\\F03EF\";\n}\n\n.mdi-pencil-off-outline::before {\n  content: \"\\F0DEA\";\n}\n\n.mdi-pencil-outline::before {\n  content: \"\\F0CB6\";\n}\n\n.mdi-pencil-plus::before {\n  content: \"\\F0DEB\";\n}\n\n.mdi-pencil-plus-outline::before {\n  content: \"\\F0DEC\";\n}\n\n.mdi-pencil-remove::before {\n  content: \"\\F0DED\";\n}\n\n.mdi-pencil-remove-outline::before {\n  content: \"\\F0DEE\";\n}\n\n.mdi-pencil-ruler::before {\n  content: \"\\F1353\";\n}\n\n.mdi-penguin::before {\n  content: \"\\F0EC0\";\n}\n\n.mdi-pentagon::before {\n  content: \"\\F0701\";\n}\n\n.mdi-pentagon-outline::before {\n  content: \"\\F0700\";\n}\n\n.mdi-pentagram::before {\n  content: \"\\F1667\";\n}\n\n.mdi-percent::before {\n  content: \"\\F03F0\";\n}\n\n.mdi-percent-outline::before {\n  content: \"\\F1278\";\n}\n\n.mdi-periodic-table::before {\n  content: \"\\F08B6\";\n}\n\n.mdi-perspective-less::before {\n  content: \"\\F0D23\";\n}\n\n.mdi-perspective-more::before {\n  content: \"\\F0D24\";\n}\n\n.mdi-ph::before {\n  content: \"\\F17C5\";\n}\n\n.mdi-phone::before {\n  content: \"\\F03F2\";\n}\n\n.mdi-phone-alert::before {\n  content: \"\\F0F1A\";\n}\n\n.mdi-phone-alert-outline::before {\n  content: \"\\F118E\";\n}\n\n.mdi-phone-bluetooth::before {\n  content: \"\\F03F3\";\n}\n\n.mdi-phone-bluetooth-outline::before {\n  content: \"\\F118F\";\n}\n\n.mdi-phone-cancel::before {\n  content: \"\\F10BC\";\n}\n\n.mdi-phone-cancel-outline::before {\n  content: \"\\F1190\";\n}\n\n.mdi-phone-check::before {\n  content: \"\\F11A9\";\n}\n\n.mdi-phone-check-outline::before {\n  content: \"\\F11AA\";\n}\n\n.mdi-phone-classic::before {\n  content: \"\\F0602\";\n}\n\n.mdi-phone-classic-off::before {\n  content: \"\\F1279\";\n}\n\n.mdi-phone-dial::before {\n  content: \"\\F1559\";\n}\n\n.mdi-phone-dial-outline::before {\n  content: \"\\F155A\";\n}\n\n.mdi-phone-forward::before {\n  content: \"\\F03F4\";\n}\n\n.mdi-phone-forward-outline::before {\n  content: \"\\F1191\";\n}\n\n.mdi-phone-hangup::before {\n  content: \"\\F03F5\";\n}\n\n.mdi-phone-hangup-outline::before {\n  content: \"\\F1192\";\n}\n\n.mdi-phone-in-talk::before {\n  content: \"\\F03F6\";\n}\n\n.mdi-phone-in-talk-outline::before {\n  content: \"\\F1182\";\n}\n\n.mdi-phone-incoming::before {\n  content: \"\\F03F7\";\n}\n\n.mdi-phone-incoming-outline::before {\n  content: \"\\F1193\";\n}\n\n.mdi-phone-lock::before {\n  content: \"\\F03F8\";\n}\n\n.mdi-phone-lock-outline::before {\n  content: \"\\F1194\";\n}\n\n.mdi-phone-log::before {\n  content: \"\\F03F9\";\n}\n\n.mdi-phone-log-outline::before {\n  content: \"\\F1195\";\n}\n\n.mdi-phone-message::before {\n  content: \"\\F1196\";\n}\n\n.mdi-phone-message-outline::before {\n  content: \"\\F1197\";\n}\n\n.mdi-phone-minus::before {\n  content: \"\\F0658\";\n}\n\n.mdi-phone-minus-outline::before {\n  content: \"\\F1198\";\n}\n\n.mdi-phone-missed::before {\n  content: \"\\F03FA\";\n}\n\n.mdi-phone-missed-outline::before {\n  content: \"\\F11A5\";\n}\n\n.mdi-phone-off::before {\n  content: \"\\F0DEF\";\n}\n\n.mdi-phone-off-outline::before {\n  content: \"\\F11A6\";\n}\n\n.mdi-phone-outgoing::before {\n  content: \"\\F03FB\";\n}\n\n.mdi-phone-outgoing-outline::before {\n  content: \"\\F1199\";\n}\n\n.mdi-phone-outline::before {\n  content: \"\\F0DF0\";\n}\n\n.mdi-phone-paused::before {\n  content: \"\\F03FC\";\n}\n\n.mdi-phone-paused-outline::before {\n  content: \"\\F119A\";\n}\n\n.mdi-phone-plus::before {\n  content: \"\\F0659\";\n}\n\n.mdi-phone-plus-outline::before {\n  content: \"\\F119B\";\n}\n\n.mdi-phone-refresh::before {\n  content: \"\\F1993\";\n}\n\n.mdi-phone-refresh-outline::before {\n  content: \"\\F1994\";\n}\n\n.mdi-phone-remove::before {\n  content: \"\\F152F\";\n}\n\n.mdi-phone-remove-outline::before {\n  content: \"\\F1530\";\n}\n\n.mdi-phone-return::before {\n  content: \"\\F082F\";\n}\n\n.mdi-phone-return-outline::before {\n  content: \"\\F119C\";\n}\n\n.mdi-phone-ring::before {\n  content: \"\\F11AB\";\n}\n\n.mdi-phone-ring-outline::before {\n  content: \"\\F11AC\";\n}\n\n.mdi-phone-rotate-landscape::before {\n  content: \"\\F0885\";\n}\n\n.mdi-phone-rotate-portrait::before {\n  content: \"\\F0886\";\n}\n\n.mdi-phone-settings::before {\n  content: \"\\F03FD\";\n}\n\n.mdi-phone-settings-outline::before {\n  content: \"\\F119D\";\n}\n\n.mdi-phone-sync::before {\n  content: \"\\F1995\";\n}\n\n.mdi-phone-sync-outline::before {\n  content: \"\\F1996\";\n}\n\n.mdi-phone-voip::before {\n  content: \"\\F03FE\";\n}\n\n.mdi-pi::before {\n  content: \"\\F03FF\";\n}\n\n.mdi-pi-box::before {\n  content: \"\\F0400\";\n}\n\n.mdi-pi-hole::before {\n  content: \"\\F0DF1\";\n}\n\n.mdi-piano::before {\n  content: \"\\F067D\";\n}\n\n.mdi-piano-off::before {\n  content: \"\\F0698\";\n}\n\n.mdi-pickaxe::before {\n  content: \"\\F08B7\";\n}\n\n.mdi-picture-in-picture-bottom-right::before {\n  content: \"\\F0E57\";\n}\n\n.mdi-picture-in-picture-bottom-right-outline::before {\n  content: \"\\F0E58\";\n}\n\n.mdi-picture-in-picture-top-right::before {\n  content: \"\\F0E59\";\n}\n\n.mdi-picture-in-picture-top-right-outline::before {\n  content: \"\\F0E5A\";\n}\n\n.mdi-pier::before {\n  content: \"\\F0887\";\n}\n\n.mdi-pier-crane::before {\n  content: \"\\F0888\";\n}\n\n.mdi-pig::before {\n  content: \"\\F0401\";\n}\n\n.mdi-pig-variant::before {\n  content: \"\\F1006\";\n}\n\n.mdi-pig-variant-outline::before {\n  content: \"\\F1678\";\n}\n\n.mdi-piggy-bank::before {\n  content: \"\\F1007\";\n}\n\n.mdi-piggy-bank-outline::before {\n  content: \"\\F1679\";\n}\n\n.mdi-pill::before {\n  content: \"\\F0402\";\n}\n\n.mdi-pillar::before {\n  content: \"\\F0702\";\n}\n\n.mdi-pin::before {\n  content: \"\\F0403\";\n}\n\n.mdi-pin-off::before {\n  content: \"\\F0404\";\n}\n\n.mdi-pin-off-outline::before {\n  content: \"\\F0930\";\n}\n\n.mdi-pin-outline::before {\n  content: \"\\F0931\";\n}\n\n.mdi-pine-tree::before {\n  content: \"\\F0405\";\n}\n\n.mdi-pine-tree-box::before {\n  content: \"\\F0406\";\n}\n\n.mdi-pine-tree-fire::before {\n  content: \"\\F141A\";\n}\n\n.mdi-pinterest::before {\n  content: \"\\F0407\";\n}\n\n.mdi-pinwheel::before {\n  content: \"\\F0AD5\";\n}\n\n.mdi-pinwheel-outline::before {\n  content: \"\\F0AD6\";\n}\n\n.mdi-pipe::before {\n  content: \"\\F07E5\";\n}\n\n.mdi-pipe-disconnected::before {\n  content: \"\\F07E6\";\n}\n\n.mdi-pipe-leak::before {\n  content: \"\\F0889\";\n}\n\n.mdi-pipe-valve::before {\n  content: \"\\F184D\";\n}\n\n.mdi-pipe-wrench::before {\n  content: \"\\F1354\";\n}\n\n.mdi-pirate::before {\n  content: \"\\F0A08\";\n}\n\n.mdi-pistol::before {\n  content: \"\\F0703\";\n}\n\n.mdi-piston::before {\n  content: \"\\F088A\";\n}\n\n.mdi-pitchfork::before {\n  content: \"\\F1553\";\n}\n\n.mdi-pizza::before {\n  content: \"\\F0409\";\n}\n\n.mdi-play::before {\n  content: \"\\F040A\";\n}\n\n.mdi-play-box::before {\n  content: \"\\F127A\";\n}\n\n.mdi-play-box-multiple::before {\n  content: \"\\F0D19\";\n}\n\n.mdi-play-box-multiple-outline::before {\n  content: \"\\F13E6\";\n}\n\n.mdi-play-box-outline::before {\n  content: \"\\F040B\";\n}\n\n.mdi-play-circle::before {\n  content: \"\\F040C\";\n}\n\n.mdi-play-circle-outline::before {\n  content: \"\\F040D\";\n}\n\n.mdi-play-network::before {\n  content: \"\\F088B\";\n}\n\n.mdi-play-network-outline::before {\n  content: \"\\F0CB7\";\n}\n\n.mdi-play-outline::before {\n  content: \"\\F0F1B\";\n}\n\n.mdi-play-pause::before {\n  content: \"\\F040E\";\n}\n\n.mdi-play-protected-content::before {\n  content: \"\\F040F\";\n}\n\n.mdi-play-speed::before {\n  content: \"\\F08FF\";\n}\n\n.mdi-playlist-check::before {\n  content: \"\\F05C7\";\n}\n\n.mdi-playlist-edit::before {\n  content: \"\\F0900\";\n}\n\n.mdi-playlist-minus::before {\n  content: \"\\F0410\";\n}\n\n.mdi-playlist-music::before {\n  content: \"\\F0CB8\";\n}\n\n.mdi-playlist-music-outline::before {\n  content: \"\\F0CB9\";\n}\n\n.mdi-playlist-play::before {\n  content: \"\\F0411\";\n}\n\n.mdi-playlist-plus::before {\n  content: \"\\F0412\";\n}\n\n.mdi-playlist-remove::before {\n  content: \"\\F0413\";\n}\n\n.mdi-playlist-star::before {\n  content: \"\\F0DF2\";\n}\n\n.mdi-plex::before {\n  content: \"\\F06BA\";\n}\n\n.mdi-pliers::before {\n  content: \"\\F19A4\";\n}\n\n.mdi-plus::before {\n  content: \"\\F0415\";\n}\n\n.mdi-plus-box::before {\n  content: \"\\F0416\";\n}\n\n.mdi-plus-box-multiple::before {\n  content: \"\\F0334\";\n}\n\n.mdi-plus-box-multiple-outline::before {\n  content: \"\\F1143\";\n}\n\n.mdi-plus-box-outline::before {\n  content: \"\\F0704\";\n}\n\n.mdi-plus-circle::before {\n  content: \"\\F0417\";\n}\n\n.mdi-plus-circle-multiple::before {\n  content: \"\\F034C\";\n}\n\n.mdi-plus-circle-multiple-outline::before {\n  content: \"\\F0418\";\n}\n\n.mdi-plus-circle-outline::before {\n  content: \"\\F0419\";\n}\n\n.mdi-plus-minus::before {\n  content: \"\\F0992\";\n}\n\n.mdi-plus-minus-box::before {\n  content: \"\\F0993\";\n}\n\n.mdi-plus-minus-variant::before {\n  content: \"\\F14C9\";\n}\n\n.mdi-plus-network::before {\n  content: \"\\F041A\";\n}\n\n.mdi-plus-network-outline::before {\n  content: \"\\F0CBA\";\n}\n\n.mdi-plus-outline::before {\n  content: \"\\F0705\";\n}\n\n.mdi-plus-thick::before {\n  content: \"\\F11EC\";\n}\n\n.mdi-podcast::before {\n  content: \"\\F0994\";\n}\n\n.mdi-podium::before {\n  content: \"\\F0D25\";\n}\n\n.mdi-podium-bronze::before {\n  content: \"\\F0D26\";\n}\n\n.mdi-podium-gold::before {\n  content: \"\\F0D27\";\n}\n\n.mdi-podium-silver::before {\n  content: \"\\F0D28\";\n}\n\n.mdi-point-of-sale::before {\n  content: \"\\F0D92\";\n}\n\n.mdi-pokeball::before {\n  content: \"\\F041D\";\n}\n\n.mdi-pokemon-go::before {\n  content: \"\\F0A09\";\n}\n\n.mdi-poker-chip::before {\n  content: \"\\F0830\";\n}\n\n.mdi-polaroid::before {\n  content: \"\\F041E\";\n}\n\n.mdi-police-badge::before {\n  content: \"\\F1167\";\n}\n\n.mdi-police-badge-outline::before {\n  content: \"\\F1168\";\n}\n\n.mdi-police-station::before {\n  content: \"\\F1839\";\n}\n\n.mdi-poll::before {\n  content: \"\\F041F\";\n}\n\n.mdi-polo::before {\n  content: \"\\F14C3\";\n}\n\n.mdi-polymer::before {\n  content: \"\\F0421\";\n}\n\n.mdi-pool::before {\n  content: \"\\F0606\";\n}\n\n.mdi-popcorn::before {\n  content: \"\\F0422\";\n}\n\n.mdi-post::before {\n  content: \"\\F1008\";\n}\n\n.mdi-post-outline::before {\n  content: \"\\F1009\";\n}\n\n.mdi-postage-stamp::before {\n  content: \"\\F0CBB\";\n}\n\n.mdi-pot::before {\n  content: \"\\F02E5\";\n}\n\n.mdi-pot-mix::before {\n  content: \"\\F065B\";\n}\n\n.mdi-pot-mix-outline::before {\n  content: \"\\F0677\";\n}\n\n.mdi-pot-outline::before {\n  content: \"\\F02FF\";\n}\n\n.mdi-pot-steam::before {\n  content: \"\\F065A\";\n}\n\n.mdi-pot-steam-outline::before {\n  content: \"\\F0326\";\n}\n\n.mdi-pound::before {\n  content: \"\\F0423\";\n}\n\n.mdi-pound-box::before {\n  content: \"\\F0424\";\n}\n\n.mdi-pound-box-outline::before {\n  content: \"\\F117F\";\n}\n\n.mdi-power::before {\n  content: \"\\F0425\";\n}\n\n.mdi-power-cycle::before {\n  content: \"\\F0901\";\n}\n\n.mdi-power-off::before {\n  content: \"\\F0902\";\n}\n\n.mdi-power-on::before {\n  content: \"\\F0903\";\n}\n\n.mdi-power-plug::before {\n  content: \"\\F06A5\";\n}\n\n.mdi-power-plug-off::before {\n  content: \"\\F06A6\";\n}\n\n.mdi-power-plug-off-outline::before {\n  content: \"\\F1424\";\n}\n\n.mdi-power-plug-outline::before {\n  content: \"\\F1425\";\n}\n\n.mdi-power-settings::before {\n  content: \"\\F0426\";\n}\n\n.mdi-power-sleep::before {\n  content: \"\\F0904\";\n}\n\n.mdi-power-socket::before {\n  content: \"\\F0427\";\n}\n\n.mdi-power-socket-au::before {\n  content: \"\\F0905\";\n}\n\n.mdi-power-socket-ch::before {\n  content: \"\\F0FB3\";\n}\n\n.mdi-power-socket-de::before {\n  content: \"\\F1107\";\n}\n\n.mdi-power-socket-eu::before {\n  content: \"\\F07E7\";\n}\n\n.mdi-power-socket-fr::before {\n  content: \"\\F1108\";\n}\n\n.mdi-power-socket-it::before {\n  content: \"\\F14FF\";\n}\n\n.mdi-power-socket-jp::before {\n  content: \"\\F1109\";\n}\n\n.mdi-power-socket-uk::before {\n  content: \"\\F07E8\";\n}\n\n.mdi-power-socket-us::before {\n  content: \"\\F07E9\";\n}\n\n.mdi-power-standby::before {\n  content: \"\\F0906\";\n}\n\n.mdi-powershell::before {\n  content: \"\\F0A0A\";\n}\n\n.mdi-prescription::before {\n  content: \"\\F0706\";\n}\n\n.mdi-presentation::before {\n  content: \"\\F0428\";\n}\n\n.mdi-presentation-play::before {\n  content: \"\\F0429\";\n}\n\n.mdi-pretzel::before {\n  content: \"\\F1562\";\n}\n\n.mdi-printer::before {\n  content: \"\\F042A\";\n}\n\n.mdi-printer-3d::before {\n  content: \"\\F042B\";\n}\n\n.mdi-printer-3d-nozzle::before {\n  content: \"\\F0E5B\";\n}\n\n.mdi-printer-3d-nozzle-alert::before {\n  content: \"\\F11C0\";\n}\n\n.mdi-printer-3d-nozzle-alert-outline::before {\n  content: \"\\F11C1\";\n}\n\n.mdi-printer-3d-nozzle-heat::before {\n  content: \"\\F18B8\";\n}\n\n.mdi-printer-3d-nozzle-heat-outline::before {\n  content: \"\\F18B9\";\n}\n\n.mdi-printer-3d-nozzle-outline::before {\n  content: \"\\F0E5C\";\n}\n\n.mdi-printer-alert::before {\n  content: \"\\F042C\";\n}\n\n.mdi-printer-check::before {\n  content: \"\\F1146\";\n}\n\n.mdi-printer-eye::before {\n  content: \"\\F1458\";\n}\n\n.mdi-printer-off::before {\n  content: \"\\F0E5D\";\n}\n\n.mdi-printer-off-outline::before {\n  content: \"\\F1785\";\n}\n\n.mdi-printer-outline::before {\n  content: \"\\F1786\";\n}\n\n.mdi-printer-pos::before {\n  content: \"\\F1057\";\n}\n\n.mdi-printer-search::before {\n  content: \"\\F1457\";\n}\n\n.mdi-printer-settings::before {\n  content: \"\\F0707\";\n}\n\n.mdi-printer-wireless::before {\n  content: \"\\F0A0B\";\n}\n\n.mdi-priority-high::before {\n  content: \"\\F0603\";\n}\n\n.mdi-priority-low::before {\n  content: \"\\F0604\";\n}\n\n.mdi-professional-hexagon::before {\n  content: \"\\F042D\";\n}\n\n.mdi-progress-alert::before {\n  content: \"\\F0CBC\";\n}\n\n.mdi-progress-check::before {\n  content: \"\\F0995\";\n}\n\n.mdi-progress-clock::before {\n  content: \"\\F0996\";\n}\n\n.mdi-progress-close::before {\n  content: \"\\F110A\";\n}\n\n.mdi-progress-download::before {\n  content: \"\\F0997\";\n}\n\n.mdi-progress-pencil::before {\n  content: \"\\F1787\";\n}\n\n.mdi-progress-question::before {\n  content: \"\\F1522\";\n}\n\n.mdi-progress-star::before {\n  content: \"\\F1788\";\n}\n\n.mdi-progress-upload::before {\n  content: \"\\F0998\";\n}\n\n.mdi-progress-wrench::before {\n  content: \"\\F0CBD\";\n}\n\n.mdi-projector::before {\n  content: \"\\F042E\";\n}\n\n.mdi-projector-screen::before {\n  content: \"\\F042F\";\n}\n\n.mdi-projector-screen-off::before {\n  content: \"\\F180D\";\n}\n\n.mdi-projector-screen-off-outline::before {\n  content: \"\\F180E\";\n}\n\n.mdi-projector-screen-outline::before {\n  content: \"\\F1724\";\n}\n\n.mdi-projector-screen-variant::before {\n  content: \"\\F180F\";\n}\n\n.mdi-projector-screen-variant-off::before {\n  content: \"\\F1810\";\n}\n\n.mdi-projector-screen-variant-off-outline::before {\n  content: \"\\F1811\";\n}\n\n.mdi-projector-screen-variant-outline::before {\n  content: \"\\F1812\";\n}\n\n.mdi-propane-tank::before {\n  content: \"\\F1357\";\n}\n\n.mdi-propane-tank-outline::before {\n  content: \"\\F1358\";\n}\n\n.mdi-protocol::before {\n  content: \"\\F0FD8\";\n}\n\n.mdi-publish::before {\n  content: \"\\F06A7\";\n}\n\n.mdi-publish-off::before {\n  content: \"\\F1945\";\n}\n\n.mdi-pulse::before {\n  content: \"\\F0430\";\n}\n\n.mdi-pump::before {\n  content: \"\\F1402\";\n}\n\n.mdi-pumpkin::before {\n  content: \"\\F0BBF\";\n}\n\n.mdi-purse::before {\n  content: \"\\F0F1C\";\n}\n\n.mdi-purse-outline::before {\n  content: \"\\F0F1D\";\n}\n\n.mdi-puzzle::before {\n  content: \"\\F0431\";\n}\n\n.mdi-puzzle-check::before {\n  content: \"\\F1426\";\n}\n\n.mdi-puzzle-check-outline::before {\n  content: \"\\F1427\";\n}\n\n.mdi-puzzle-edit::before {\n  content: \"\\F14D3\";\n}\n\n.mdi-puzzle-edit-outline::before {\n  content: \"\\F14D9\";\n}\n\n.mdi-puzzle-heart::before {\n  content: \"\\F14D4\";\n}\n\n.mdi-puzzle-heart-outline::before {\n  content: \"\\F14DA\";\n}\n\n.mdi-puzzle-minus::before {\n  content: \"\\F14D1\";\n}\n\n.mdi-puzzle-minus-outline::before {\n  content: \"\\F14D7\";\n}\n\n.mdi-puzzle-outline::before {\n  content: \"\\F0A66\";\n}\n\n.mdi-puzzle-plus::before {\n  content: \"\\F14D0\";\n}\n\n.mdi-puzzle-plus-outline::before {\n  content: \"\\F14D6\";\n}\n\n.mdi-puzzle-remove::before {\n  content: \"\\F14D2\";\n}\n\n.mdi-puzzle-remove-outline::before {\n  content: \"\\F14D8\";\n}\n\n.mdi-puzzle-star::before {\n  content: \"\\F14D5\";\n}\n\n.mdi-puzzle-star-outline::before {\n  content: \"\\F14DB\";\n}\n\n.mdi-pyramid::before {\n  content: \"\\F1952\";\n}\n\n.mdi-pyramid-off::before {\n  content: \"\\F1953\";\n}\n\n.mdi-qi::before {\n  content: \"\\F0999\";\n}\n\n.mdi-qqchat::before {\n  content: \"\\F0605\";\n}\n\n.mdi-qrcode::before {\n  content: \"\\F0432\";\n}\n\n.mdi-qrcode-edit::before {\n  content: \"\\F08B8\";\n}\n\n.mdi-qrcode-minus::before {\n  content: \"\\F118C\";\n}\n\n.mdi-qrcode-plus::before {\n  content: \"\\F118B\";\n}\n\n.mdi-qrcode-remove::before {\n  content: \"\\F118D\";\n}\n\n.mdi-qrcode-scan::before {\n  content: \"\\F0433\";\n}\n\n.mdi-quadcopter::before {\n  content: \"\\F0434\";\n}\n\n.mdi-quality-high::before {\n  content: \"\\F0435\";\n}\n\n.mdi-quality-low::before {\n  content: \"\\F0A0C\";\n}\n\n.mdi-quality-medium::before {\n  content: \"\\F0A0D\";\n}\n\n.mdi-quora::before {\n  content: \"\\F0D29\";\n}\n\n.mdi-rabbit::before {\n  content: \"\\F0907\";\n}\n\n.mdi-racing-helmet::before {\n  content: \"\\F0D93\";\n}\n\n.mdi-racquetball::before {\n  content: \"\\F0D94\";\n}\n\n.mdi-radar::before {\n  content: \"\\F0437\";\n}\n\n.mdi-radiator::before {\n  content: \"\\F0438\";\n}\n\n.mdi-radiator-disabled::before {\n  content: \"\\F0AD7\";\n}\n\n.mdi-radiator-off::before {\n  content: \"\\F0AD8\";\n}\n\n.mdi-radio::before {\n  content: \"\\F0439\";\n}\n\n.mdi-radio-am::before {\n  content: \"\\F0CBE\";\n}\n\n.mdi-radio-fm::before {\n  content: \"\\F0CBF\";\n}\n\n.mdi-radio-handheld::before {\n  content: \"\\F043A\";\n}\n\n.mdi-radio-off::before {\n  content: \"\\F121C\";\n}\n\n.mdi-radio-tower::before {\n  content: \"\\F043B\";\n}\n\n.mdi-radioactive::before {\n  content: \"\\F043C\";\n}\n\n.mdi-radioactive-circle::before {\n  content: \"\\F185D\";\n}\n\n.mdi-radioactive-circle-outline::before {\n  content: \"\\F185E\";\n}\n\n.mdi-radioactive-off::before {\n  content: \"\\F0EC1\";\n}\n\n.mdi-radiobox-blank::before {\n  content: \"\\F043D\";\n}\n\n.mdi-radiobox-marked::before {\n  content: \"\\F043E\";\n}\n\n.mdi-radiology-box::before {\n  content: \"\\F14C5\";\n}\n\n.mdi-radiology-box-outline::before {\n  content: \"\\F14C6\";\n}\n\n.mdi-radius::before {\n  content: \"\\F0CC0\";\n}\n\n.mdi-radius-outline::before {\n  content: \"\\F0CC1\";\n}\n\n.mdi-railroad-light::before {\n  content: \"\\F0F1E\";\n}\n\n.mdi-rake::before {\n  content: \"\\F1544\";\n}\n\n.mdi-raspberry-pi::before {\n  content: \"\\F043F\";\n}\n\n.mdi-ray-end::before {\n  content: \"\\F0440\";\n}\n\n.mdi-ray-end-arrow::before {\n  content: \"\\F0441\";\n}\n\n.mdi-ray-start::before {\n  content: \"\\F0442\";\n}\n\n.mdi-ray-start-arrow::before {\n  content: \"\\F0443\";\n}\n\n.mdi-ray-start-end::before {\n  content: \"\\F0444\";\n}\n\n.mdi-ray-start-vertex-end::before {\n  content: \"\\F15D8\";\n}\n\n.mdi-ray-vertex::before {\n  content: \"\\F0445\";\n}\n\n.mdi-razor-double-edge::before {\n  content: \"\\F1997\";\n}\n\n.mdi-razor-single-edge::before {\n  content: \"\\F1998\";\n}\n\n.mdi-react::before {\n  content: \"\\F0708\";\n}\n\n.mdi-read::before {\n  content: \"\\F0447\";\n}\n\n.mdi-receipt::before {\n  content: \"\\F0449\";\n}\n\n.mdi-record::before {\n  content: \"\\F044A\";\n}\n\n.mdi-record-circle::before {\n  content: \"\\F0EC2\";\n}\n\n.mdi-record-circle-outline::before {\n  content: \"\\F0EC3\";\n}\n\n.mdi-record-player::before {\n  content: \"\\F099A\";\n}\n\n.mdi-record-rec::before {\n  content: \"\\F044B\";\n}\n\n.mdi-rectangle::before {\n  content: \"\\F0E5E\";\n}\n\n.mdi-rectangle-outline::before {\n  content: \"\\F0E5F\";\n}\n\n.mdi-recycle::before {\n  content: \"\\F044C\";\n}\n\n.mdi-recycle-variant::before {\n  content: \"\\F139D\";\n}\n\n.mdi-reddit::before {\n  content: \"\\F044D\";\n}\n\n.mdi-redhat::before {\n  content: \"\\F111B\";\n}\n\n.mdi-redo::before {\n  content: \"\\F044E\";\n}\n\n.mdi-redo-variant::before {\n  content: \"\\F044F\";\n}\n\n.mdi-reflect-horizontal::before {\n  content: \"\\F0A0E\";\n}\n\n.mdi-reflect-vertical::before {\n  content: \"\\F0A0F\";\n}\n\n.mdi-refresh::before {\n  content: \"\\F0450\";\n}\n\n.mdi-refresh-auto::before {\n  content: \"\\F18F2\";\n}\n\n.mdi-refresh-circle::before {\n  content: \"\\F1377\";\n}\n\n.mdi-regex::before {\n  content: \"\\F0451\";\n}\n\n.mdi-registered-trademark::before {\n  content: \"\\F0A67\";\n}\n\n.mdi-reiterate::before {\n  content: \"\\F1588\";\n}\n\n.mdi-relation-many-to-many::before {\n  content: \"\\F1496\";\n}\n\n.mdi-relation-many-to-one::before {\n  content: \"\\F1497\";\n}\n\n.mdi-relation-many-to-one-or-many::before {\n  content: \"\\F1498\";\n}\n\n.mdi-relation-many-to-only-one::before {\n  content: \"\\F1499\";\n}\n\n.mdi-relation-many-to-zero-or-many::before {\n  content: \"\\F149A\";\n}\n\n.mdi-relation-many-to-zero-or-one::before {\n  content: \"\\F149B\";\n}\n\n.mdi-relation-one-or-many-to-many::before {\n  content: \"\\F149C\";\n}\n\n.mdi-relation-one-or-many-to-one::before {\n  content: \"\\F149D\";\n}\n\n.mdi-relation-one-or-many-to-one-or-many::before {\n  content: \"\\F149E\";\n}\n\n.mdi-relation-one-or-many-to-only-one::before {\n  content: \"\\F149F\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-many::before {\n  content: \"\\F14A0\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-one::before {\n  content: \"\\F14A1\";\n}\n\n.mdi-relation-one-to-many::before {\n  content: \"\\F14A2\";\n}\n\n.mdi-relation-one-to-one::before {\n  content: \"\\F14A3\";\n}\n\n.mdi-relation-one-to-one-or-many::before {\n  content: \"\\F14A4\";\n}\n\n.mdi-relation-one-to-only-one::before {\n  content: \"\\F14A5\";\n}\n\n.mdi-relation-one-to-zero-or-many::before {\n  content: \"\\F14A6\";\n}\n\n.mdi-relation-one-to-zero-or-one::before {\n  content: \"\\F14A7\";\n}\n\n.mdi-relation-only-one-to-many::before {\n  content: \"\\F14A8\";\n}\n\n.mdi-relation-only-one-to-one::before {\n  content: \"\\F14A9\";\n}\n\n.mdi-relation-only-one-to-one-or-many::before {\n  content: \"\\F14AA\";\n}\n\n.mdi-relation-only-one-to-only-one::before {\n  content: \"\\F14AB\";\n}\n\n.mdi-relation-only-one-to-zero-or-many::before {\n  content: \"\\F14AC\";\n}\n\n.mdi-relation-only-one-to-zero-or-one::before {\n  content: \"\\F14AD\";\n}\n\n.mdi-relation-zero-or-many-to-many::before {\n  content: \"\\F14AE\";\n}\n\n.mdi-relation-zero-or-many-to-one::before {\n  content: \"\\F14AF\";\n}\n\n.mdi-relation-zero-or-many-to-one-or-many::before {\n  content: \"\\F14B0\";\n}\n\n.mdi-relation-zero-or-many-to-only-one::before {\n  content: \"\\F14B1\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-many::before {\n  content: \"\\F14B2\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-one::before {\n  content: \"\\F14B3\";\n}\n\n.mdi-relation-zero-or-one-to-many::before {\n  content: \"\\F14B4\";\n}\n\n.mdi-relation-zero-or-one-to-one::before {\n  content: \"\\F14B5\";\n}\n\n.mdi-relation-zero-or-one-to-one-or-many::before {\n  content: \"\\F14B6\";\n}\n\n.mdi-relation-zero-or-one-to-only-one::before {\n  content: \"\\F14B7\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-many::before {\n  content: \"\\F14B8\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-one::before {\n  content: \"\\F14B9\";\n}\n\n.mdi-relative-scale::before {\n  content: \"\\F0452\";\n}\n\n.mdi-reload::before {\n  content: \"\\F0453\";\n}\n\n.mdi-reload-alert::before {\n  content: \"\\F110B\";\n}\n\n.mdi-reminder::before {\n  content: \"\\F088C\";\n}\n\n.mdi-remote::before {\n  content: \"\\F0454\";\n}\n\n.mdi-remote-desktop::before {\n  content: \"\\F08B9\";\n}\n\n.mdi-remote-off::before {\n  content: \"\\F0EC4\";\n}\n\n.mdi-remote-tv::before {\n  content: \"\\F0EC5\";\n}\n\n.mdi-remote-tv-off::before {\n  content: \"\\F0EC6\";\n}\n\n.mdi-rename-box::before {\n  content: \"\\F0455\";\n}\n\n.mdi-reorder-horizontal::before {\n  content: \"\\F0688\";\n}\n\n.mdi-reorder-vertical::before {\n  content: \"\\F0689\";\n}\n\n.mdi-repeat::before {\n  content: \"\\F0456\";\n}\n\n.mdi-repeat-off::before {\n  content: \"\\F0457\";\n}\n\n.mdi-repeat-once::before {\n  content: \"\\F0458\";\n}\n\n.mdi-repeat-variant::before {\n  content: \"\\F0547\";\n}\n\n.mdi-replay::before {\n  content: \"\\F0459\";\n}\n\n.mdi-reply::before {\n  content: \"\\F045A\";\n}\n\n.mdi-reply-all::before {\n  content: \"\\F045B\";\n}\n\n.mdi-reply-all-outline::before {\n  content: \"\\F0F1F\";\n}\n\n.mdi-reply-circle::before {\n  content: \"\\F11AE\";\n}\n\n.mdi-reply-outline::before {\n  content: \"\\F0F20\";\n}\n\n.mdi-reproduction::before {\n  content: \"\\F045C\";\n}\n\n.mdi-resistor::before {\n  content: \"\\F0B44\";\n}\n\n.mdi-resistor-nodes::before {\n  content: \"\\F0B45\";\n}\n\n.mdi-resize::before {\n  content: \"\\F0A68\";\n}\n\n.mdi-resize-bottom-right::before {\n  content: \"\\F045D\";\n}\n\n.mdi-responsive::before {\n  content: \"\\F045E\";\n}\n\n.mdi-restart::before {\n  content: \"\\F0709\";\n}\n\n.mdi-restart-alert::before {\n  content: \"\\F110C\";\n}\n\n.mdi-restart-off::before {\n  content: \"\\F0D95\";\n}\n\n.mdi-restore::before {\n  content: \"\\F099B\";\n}\n\n.mdi-restore-alert::before {\n  content: \"\\F110D\";\n}\n\n.mdi-rewind::before {\n  content: \"\\F045F\";\n}\n\n.mdi-rewind-10::before {\n  content: \"\\F0D2A\";\n}\n\n.mdi-rewind-15::before {\n  content: \"\\F1946\";\n}\n\n.mdi-rewind-30::before {\n  content: \"\\F0D96\";\n}\n\n.mdi-rewind-5::before {\n  content: \"\\F11F9\";\n}\n\n.mdi-rewind-60::before {\n  content: \"\\F160C\";\n}\n\n.mdi-rewind-outline::before {\n  content: \"\\F070A\";\n}\n\n.mdi-rhombus::before {\n  content: \"\\F070B\";\n}\n\n.mdi-rhombus-medium::before {\n  content: \"\\F0A10\";\n}\n\n.mdi-rhombus-medium-outline::before {\n  content: \"\\F14DC\";\n}\n\n.mdi-rhombus-outline::before {\n  content: \"\\F070C\";\n}\n\n.mdi-rhombus-split::before {\n  content: \"\\F0A11\";\n}\n\n.mdi-rhombus-split-outline::before {\n  content: \"\\F14DD\";\n}\n\n.mdi-ribbon::before {\n  content: \"\\F0460\";\n}\n\n.mdi-rice::before {\n  content: \"\\F07EA\";\n}\n\n.mdi-rickshaw::before {\n  content: \"\\F15BB\";\n}\n\n.mdi-rickshaw-electric::before {\n  content: \"\\F15BC\";\n}\n\n.mdi-ring::before {\n  content: \"\\F07EB\";\n}\n\n.mdi-rivet::before {\n  content: \"\\F0E60\";\n}\n\n.mdi-road::before {\n  content: \"\\F0461\";\n}\n\n.mdi-road-variant::before {\n  content: \"\\F0462\";\n}\n\n.mdi-robber::before {\n  content: \"\\F1058\";\n}\n\n.mdi-robot::before {\n  content: \"\\F06A9\";\n}\n\n.mdi-robot-angry::before {\n  content: \"\\F169D\";\n}\n\n.mdi-robot-angry-outline::before {\n  content: \"\\F169E\";\n}\n\n.mdi-robot-confused::before {\n  content: \"\\F169F\";\n}\n\n.mdi-robot-confused-outline::before {\n  content: \"\\F16A0\";\n}\n\n.mdi-robot-dead::before {\n  content: \"\\F16A1\";\n}\n\n.mdi-robot-dead-outline::before {\n  content: \"\\F16A2\";\n}\n\n.mdi-robot-excited::before {\n  content: \"\\F16A3\";\n}\n\n.mdi-robot-excited-outline::before {\n  content: \"\\F16A4\";\n}\n\n.mdi-robot-happy::before {\n  content: \"\\F1719\";\n}\n\n.mdi-robot-happy-outline::before {\n  content: \"\\F171A\";\n}\n\n.mdi-robot-industrial::before {\n  content: \"\\F0B46\";\n}\n\n.mdi-robot-love::before {\n  content: \"\\F16A5\";\n}\n\n.mdi-robot-love-outline::before {\n  content: \"\\F16A6\";\n}\n\n.mdi-robot-mower::before {\n  content: \"\\F11F7\";\n}\n\n.mdi-robot-mower-outline::before {\n  content: \"\\F11F3\";\n}\n\n.mdi-robot-off::before {\n  content: \"\\F16A7\";\n}\n\n.mdi-robot-off-outline::before {\n  content: \"\\F167B\";\n}\n\n.mdi-robot-outline::before {\n  content: \"\\F167A\";\n}\n\n.mdi-robot-vacuum::before {\n  content: \"\\F070D\";\n}\n\n.mdi-robot-vacuum-variant::before {\n  content: \"\\F0908\";\n}\n\n.mdi-rocket::before {\n  content: \"\\F0463\";\n}\n\n.mdi-rocket-launch::before {\n  content: \"\\F14DE\";\n}\n\n.mdi-rocket-launch-outline::before {\n  content: \"\\F14DF\";\n}\n\n.mdi-rocket-outline::before {\n  content: \"\\F13AF\";\n}\n\n.mdi-rodent::before {\n  content: \"\\F1327\";\n}\n\n.mdi-roller-skate::before {\n  content: \"\\F0D2B\";\n}\n\n.mdi-roller-skate-off::before {\n  content: \"\\F0145\";\n}\n\n.mdi-rollerblade::before {\n  content: \"\\F0D2C\";\n}\n\n.mdi-rollerblade-off::before {\n  content: \"\\F002E\";\n}\n\n.mdi-rollupjs::before {\n  content: \"\\F0BC0\";\n}\n\n.mdi-roman-numeral-1::before {\n  content: \"\\F1088\";\n}\n\n.mdi-roman-numeral-10::before {\n  content: \"\\F1091\";\n}\n\n.mdi-roman-numeral-2::before {\n  content: \"\\F1089\";\n}\n\n.mdi-roman-numeral-3::before {\n  content: \"\\F108A\";\n}\n\n.mdi-roman-numeral-4::before {\n  content: \"\\F108B\";\n}\n\n.mdi-roman-numeral-5::before {\n  content: \"\\F108C\";\n}\n\n.mdi-roman-numeral-6::before {\n  content: \"\\F108D\";\n}\n\n.mdi-roman-numeral-7::before {\n  content: \"\\F108E\";\n}\n\n.mdi-roman-numeral-8::before {\n  content: \"\\F108F\";\n}\n\n.mdi-roman-numeral-9::before {\n  content: \"\\F1090\";\n}\n\n.mdi-room-service::before {\n  content: \"\\F088D\";\n}\n\n.mdi-room-service-outline::before {\n  content: \"\\F0D97\";\n}\n\n.mdi-rotate-360::before {\n  content: \"\\F1999\";\n}\n\n.mdi-rotate-3d::before {\n  content: \"\\F0EC7\";\n}\n\n.mdi-rotate-3d-variant::before {\n  content: \"\\F0464\";\n}\n\n.mdi-rotate-left::before {\n  content: \"\\F0465\";\n}\n\n.mdi-rotate-left-variant::before {\n  content: \"\\F0466\";\n}\n\n.mdi-rotate-orbit::before {\n  content: \"\\F0D98\";\n}\n\n.mdi-rotate-right::before {\n  content: \"\\F0467\";\n}\n\n.mdi-rotate-right-variant::before {\n  content: \"\\F0468\";\n}\n\n.mdi-rounded-corner::before {\n  content: \"\\F0607\";\n}\n\n.mdi-router::before {\n  content: \"\\F11E2\";\n}\n\n.mdi-router-network::before {\n  content: \"\\F1087\";\n}\n\n.mdi-router-wireless::before {\n  content: \"\\F0469\";\n}\n\n.mdi-router-wireless-off::before {\n  content: \"\\F15A3\";\n}\n\n.mdi-router-wireless-settings::before {\n  content: \"\\F0A69\";\n}\n\n.mdi-routes::before {\n  content: \"\\F046A\";\n}\n\n.mdi-routes-clock::before {\n  content: \"\\F1059\";\n}\n\n.mdi-rowing::before {\n  content: \"\\F0608\";\n}\n\n.mdi-rss::before {\n  content: \"\\F046B\";\n}\n\n.mdi-rss-box::before {\n  content: \"\\F046C\";\n}\n\n.mdi-rss-off::before {\n  content: \"\\F0F21\";\n}\n\n.mdi-rug::before {\n  content: \"\\F1475\";\n}\n\n.mdi-rugby::before {\n  content: \"\\F0D99\";\n}\n\n.mdi-ruler::before {\n  content: \"\\F046D\";\n}\n\n.mdi-ruler-square::before {\n  content: \"\\F0CC2\";\n}\n\n.mdi-ruler-square-compass::before {\n  content: \"\\F0EBE\";\n}\n\n.mdi-run::before {\n  content: \"\\F070E\";\n}\n\n.mdi-run-fast::before {\n  content: \"\\F046E\";\n}\n\n.mdi-rv-truck::before {\n  content: \"\\F11D4\";\n}\n\n.mdi-sack::before {\n  content: \"\\F0D2E\";\n}\n\n.mdi-sack-percent::before {\n  content: \"\\F0D2F\";\n}\n\n.mdi-safe::before {\n  content: \"\\F0A6A\";\n}\n\n.mdi-safe-square::before {\n  content: \"\\F127C\";\n}\n\n.mdi-safe-square-outline::before {\n  content: \"\\F127D\";\n}\n\n.mdi-safety-goggles::before {\n  content: \"\\F0D30\";\n}\n\n.mdi-sail-boat::before {\n  content: \"\\F0EC8\";\n}\n\n.mdi-sale::before {\n  content: \"\\F046F\";\n}\n\n.mdi-salesforce::before {\n  content: \"\\F088E\";\n}\n\n.mdi-sass::before {\n  content: \"\\F07EC\";\n}\n\n.mdi-satellite::before {\n  content: \"\\F0470\";\n}\n\n.mdi-satellite-uplink::before {\n  content: \"\\F0909\";\n}\n\n.mdi-satellite-variant::before {\n  content: \"\\F0471\";\n}\n\n.mdi-sausage::before {\n  content: \"\\F08BA\";\n}\n\n.mdi-sausage-off::before {\n  content: \"\\F1789\";\n}\n\n.mdi-saw-blade::before {\n  content: \"\\F0E61\";\n}\n\n.mdi-sawtooth-wave::before {\n  content: \"\\F147A\";\n}\n\n.mdi-saxophone::before {\n  content: \"\\F0609\";\n}\n\n.mdi-scale::before {\n  content: \"\\F0472\";\n}\n\n.mdi-scale-balance::before {\n  content: \"\\F05D1\";\n}\n\n.mdi-scale-bathroom::before {\n  content: \"\\F0473\";\n}\n\n.mdi-scale-off::before {\n  content: \"\\F105A\";\n}\n\n.mdi-scale-unbalanced::before {\n  content: \"\\F19B8\";\n}\n\n.mdi-scan-helper::before {\n  content: \"\\F13D8\";\n}\n\n.mdi-scanner::before {\n  content: \"\\F06AB\";\n}\n\n.mdi-scanner-off::before {\n  content: \"\\F090A\";\n}\n\n.mdi-scatter-plot::before {\n  content: \"\\F0EC9\";\n}\n\n.mdi-scatter-plot-outline::before {\n  content: \"\\F0ECA\";\n}\n\n.mdi-scent::before {\n  content: \"\\F1958\";\n}\n\n.mdi-scent-off::before {\n  content: \"\\F1959\";\n}\n\n.mdi-school::before {\n  content: \"\\F0474\";\n}\n\n.mdi-school-outline::before {\n  content: \"\\F1180\";\n}\n\n.mdi-scissors-cutting::before {\n  content: \"\\F0A6B\";\n}\n\n.mdi-scooter::before {\n  content: \"\\F15BD\";\n}\n\n.mdi-scooter-electric::before {\n  content: \"\\F15BE\";\n}\n\n.mdi-scoreboard::before {\n  content: \"\\F127E\";\n}\n\n.mdi-scoreboard-outline::before {\n  content: \"\\F127F\";\n}\n\n.mdi-screen-rotation::before {\n  content: \"\\F0475\";\n}\n\n.mdi-screen-rotation-lock::before {\n  content: \"\\F0478\";\n}\n\n.mdi-screw-flat-top::before {\n  content: \"\\F0DF3\";\n}\n\n.mdi-screw-lag::before {\n  content: \"\\F0DF4\";\n}\n\n.mdi-screw-machine-flat-top::before {\n  content: \"\\F0DF5\";\n}\n\n.mdi-screw-machine-round-top::before {\n  content: \"\\F0DF6\";\n}\n\n.mdi-screw-round-top::before {\n  content: \"\\F0DF7\";\n}\n\n.mdi-screwdriver::before {\n  content: \"\\F0476\";\n}\n\n.mdi-script::before {\n  content: \"\\F0BC1\";\n}\n\n.mdi-script-outline::before {\n  content: \"\\F0477\";\n}\n\n.mdi-script-text::before {\n  content: \"\\F0BC2\";\n}\n\n.mdi-script-text-key::before {\n  content: \"\\F1725\";\n}\n\n.mdi-script-text-key-outline::before {\n  content: \"\\F1726\";\n}\n\n.mdi-script-text-outline::before {\n  content: \"\\F0BC3\";\n}\n\n.mdi-script-text-play::before {\n  content: \"\\F1727\";\n}\n\n.mdi-script-text-play-outline::before {\n  content: \"\\F1728\";\n}\n\n.mdi-sd::before {\n  content: \"\\F0479\";\n}\n\n.mdi-seal::before {\n  content: \"\\F047A\";\n}\n\n.mdi-seal-variant::before {\n  content: \"\\F0FD9\";\n}\n\n.mdi-search-web::before {\n  content: \"\\F070F\";\n}\n\n.mdi-seat::before {\n  content: \"\\F0CC3\";\n}\n\n.mdi-seat-flat::before {\n  content: \"\\F047B\";\n}\n\n.mdi-seat-flat-angled::before {\n  content: \"\\F047C\";\n}\n\n.mdi-seat-individual-suite::before {\n  content: \"\\F047D\";\n}\n\n.mdi-seat-legroom-extra::before {\n  content: \"\\F047E\";\n}\n\n.mdi-seat-legroom-normal::before {\n  content: \"\\F047F\";\n}\n\n.mdi-seat-legroom-reduced::before {\n  content: \"\\F0480\";\n}\n\n.mdi-seat-outline::before {\n  content: \"\\F0CC4\";\n}\n\n.mdi-seat-passenger::before {\n  content: \"\\F1249\";\n}\n\n.mdi-seat-recline-extra::before {\n  content: \"\\F0481\";\n}\n\n.mdi-seat-recline-normal::before {\n  content: \"\\F0482\";\n}\n\n.mdi-seatbelt::before {\n  content: \"\\F0CC5\";\n}\n\n.mdi-security::before {\n  content: \"\\F0483\";\n}\n\n.mdi-security-network::before {\n  content: \"\\F0484\";\n}\n\n.mdi-seed::before {\n  content: \"\\F0E62\";\n}\n\n.mdi-seed-off::before {\n  content: \"\\F13FD\";\n}\n\n.mdi-seed-off-outline::before {\n  content: \"\\F13FE\";\n}\n\n.mdi-seed-outline::before {\n  content: \"\\F0E63\";\n}\n\n.mdi-seesaw::before {\n  content: \"\\F15A4\";\n}\n\n.mdi-segment::before {\n  content: \"\\F0ECB\";\n}\n\n.mdi-select::before {\n  content: \"\\F0485\";\n}\n\n.mdi-select-all::before {\n  content: \"\\F0486\";\n}\n\n.mdi-select-color::before {\n  content: \"\\F0D31\";\n}\n\n.mdi-select-compare::before {\n  content: \"\\F0AD9\";\n}\n\n.mdi-select-drag::before {\n  content: \"\\F0A6C\";\n}\n\n.mdi-select-group::before {\n  content: \"\\F0F82\";\n}\n\n.mdi-select-inverse::before {\n  content: \"\\F0487\";\n}\n\n.mdi-select-marker::before {\n  content: \"\\F1280\";\n}\n\n.mdi-select-multiple::before {\n  content: \"\\F1281\";\n}\n\n.mdi-select-multiple-marker::before {\n  content: \"\\F1282\";\n}\n\n.mdi-select-off::before {\n  content: \"\\F0488\";\n}\n\n.mdi-select-place::before {\n  content: \"\\F0FDA\";\n}\n\n.mdi-select-remove::before {\n  content: \"\\F17C1\";\n}\n\n.mdi-select-search::before {\n  content: \"\\F1204\";\n}\n\n.mdi-selection::before {\n  content: \"\\F0489\";\n}\n\n.mdi-selection-drag::before {\n  content: \"\\F0A6D\";\n}\n\n.mdi-selection-ellipse::before {\n  content: \"\\F0D32\";\n}\n\n.mdi-selection-ellipse-arrow-inside::before {\n  content: \"\\F0F22\";\n}\n\n.mdi-selection-ellipse-remove::before {\n  content: \"\\F17C2\";\n}\n\n.mdi-selection-marker::before {\n  content: \"\\F1283\";\n}\n\n.mdi-selection-multiple::before {\n  content: \"\\F1285\";\n}\n\n.mdi-selection-multiple-marker::before {\n  content: \"\\F1284\";\n}\n\n.mdi-selection-off::before {\n  content: \"\\F0777\";\n}\n\n.mdi-selection-remove::before {\n  content: \"\\F17C3\";\n}\n\n.mdi-selection-search::before {\n  content: \"\\F1205\";\n}\n\n.mdi-semantic-web::before {\n  content: \"\\F1316\";\n}\n\n.mdi-send::before {\n  content: \"\\F048A\";\n}\n\n.mdi-send-check::before {\n  content: \"\\F1161\";\n}\n\n.mdi-send-check-outline::before {\n  content: \"\\F1162\";\n}\n\n.mdi-send-circle::before {\n  content: \"\\F0DF8\";\n}\n\n.mdi-send-circle-outline::before {\n  content: \"\\F0DF9\";\n}\n\n.mdi-send-clock::before {\n  content: \"\\F1163\";\n}\n\n.mdi-send-clock-outline::before {\n  content: \"\\F1164\";\n}\n\n.mdi-send-lock::before {\n  content: \"\\F07ED\";\n}\n\n.mdi-send-lock-outline::before {\n  content: \"\\F1166\";\n}\n\n.mdi-send-outline::before {\n  content: \"\\F1165\";\n}\n\n.mdi-serial-port::before {\n  content: \"\\F065C\";\n}\n\n.mdi-server::before {\n  content: \"\\F048B\";\n}\n\n.mdi-server-minus::before {\n  content: \"\\F048C\";\n}\n\n.mdi-server-network::before {\n  content: \"\\F048D\";\n}\n\n.mdi-server-network-off::before {\n  content: \"\\F048E\";\n}\n\n.mdi-server-off::before {\n  content: \"\\F048F\";\n}\n\n.mdi-server-plus::before {\n  content: \"\\F0490\";\n}\n\n.mdi-server-remove::before {\n  content: \"\\F0491\";\n}\n\n.mdi-server-security::before {\n  content: \"\\F0492\";\n}\n\n.mdi-set-all::before {\n  content: \"\\F0778\";\n}\n\n.mdi-set-center::before {\n  content: \"\\F0779\";\n}\n\n.mdi-set-center-right::before {\n  content: \"\\F077A\";\n}\n\n.mdi-set-left::before {\n  content: \"\\F077B\";\n}\n\n.mdi-set-left-center::before {\n  content: \"\\F077C\";\n}\n\n.mdi-set-left-right::before {\n  content: \"\\F077D\";\n}\n\n.mdi-set-merge::before {\n  content: \"\\F14E0\";\n}\n\n.mdi-set-none::before {\n  content: \"\\F077E\";\n}\n\n.mdi-set-right::before {\n  content: \"\\F077F\";\n}\n\n.mdi-set-split::before {\n  content: \"\\F14E1\";\n}\n\n.mdi-set-square::before {\n  content: \"\\F145D\";\n}\n\n.mdi-set-top-box::before {\n  content: \"\\F099F\";\n}\n\n.mdi-settings-helper::before {\n  content: \"\\F0A6E\";\n}\n\n.mdi-shaker::before {\n  content: \"\\F110E\";\n}\n\n.mdi-shaker-outline::before {\n  content: \"\\F110F\";\n}\n\n.mdi-shape::before {\n  content: \"\\F0831\";\n}\n\n.mdi-shape-circle-plus::before {\n  content: \"\\F065D\";\n}\n\n.mdi-shape-outline::before {\n  content: \"\\F0832\";\n}\n\n.mdi-shape-oval-plus::before {\n  content: \"\\F11FA\";\n}\n\n.mdi-shape-plus::before {\n  content: \"\\F0495\";\n}\n\n.mdi-shape-polygon-plus::before {\n  content: \"\\F065E\";\n}\n\n.mdi-shape-rectangle-plus::before {\n  content: \"\\F065F\";\n}\n\n.mdi-shape-square-plus::before {\n  content: \"\\F0660\";\n}\n\n.mdi-shape-square-rounded-plus::before {\n  content: \"\\F14FA\";\n}\n\n.mdi-share::before {\n  content: \"\\F0496\";\n}\n\n.mdi-share-all::before {\n  content: \"\\F11F4\";\n}\n\n.mdi-share-all-outline::before {\n  content: \"\\F11F5\";\n}\n\n.mdi-share-circle::before {\n  content: \"\\F11AD\";\n}\n\n.mdi-share-off::before {\n  content: \"\\F0F23\";\n}\n\n.mdi-share-off-outline::before {\n  content: \"\\F0F24\";\n}\n\n.mdi-share-outline::before {\n  content: \"\\F0932\";\n}\n\n.mdi-share-variant::before {\n  content: \"\\F0497\";\n}\n\n.mdi-share-variant-outline::before {\n  content: \"\\F1514\";\n}\n\n.mdi-shark::before {\n  content: \"\\F18BA\";\n}\n\n.mdi-shark-fin::before {\n  content: \"\\F1673\";\n}\n\n.mdi-shark-fin-outline::before {\n  content: \"\\F1674\";\n}\n\n.mdi-shark-off::before {\n  content: \"\\F18BB\";\n}\n\n.mdi-sheep::before {\n  content: \"\\F0CC6\";\n}\n\n.mdi-shield::before {\n  content: \"\\F0498\";\n}\n\n.mdi-shield-account::before {\n  content: \"\\F088F\";\n}\n\n.mdi-shield-account-outline::before {\n  content: \"\\F0A12\";\n}\n\n.mdi-shield-account-variant::before {\n  content: \"\\F15A7\";\n}\n\n.mdi-shield-account-variant-outline::before {\n  content: \"\\F15A8\";\n}\n\n.mdi-shield-airplane::before {\n  content: \"\\F06BB\";\n}\n\n.mdi-shield-airplane-outline::before {\n  content: \"\\F0CC7\";\n}\n\n.mdi-shield-alert::before {\n  content: \"\\F0ECC\";\n}\n\n.mdi-shield-alert-outline::before {\n  content: \"\\F0ECD\";\n}\n\n.mdi-shield-bug::before {\n  content: \"\\F13DA\";\n}\n\n.mdi-shield-bug-outline::before {\n  content: \"\\F13DB\";\n}\n\n.mdi-shield-car::before {\n  content: \"\\F0F83\";\n}\n\n.mdi-shield-check::before {\n  content: \"\\F0565\";\n}\n\n.mdi-shield-check-outline::before {\n  content: \"\\F0CC8\";\n}\n\n.mdi-shield-cross::before {\n  content: \"\\F0CC9\";\n}\n\n.mdi-shield-cross-outline::before {\n  content: \"\\F0CCA\";\n}\n\n.mdi-shield-crown::before {\n  content: \"\\F18BC\";\n}\n\n.mdi-shield-crown-outline::before {\n  content: \"\\F18BD\";\n}\n\n.mdi-shield-edit::before {\n  content: \"\\F11A0\";\n}\n\n.mdi-shield-edit-outline::before {\n  content: \"\\F11A1\";\n}\n\n.mdi-shield-half::before {\n  content: \"\\F1360\";\n}\n\n.mdi-shield-half-full::before {\n  content: \"\\F0780\";\n}\n\n.mdi-shield-home::before {\n  content: \"\\F068A\";\n}\n\n.mdi-shield-home-outline::before {\n  content: \"\\F0CCB\";\n}\n\n.mdi-shield-key::before {\n  content: \"\\F0BC4\";\n}\n\n.mdi-shield-key-outline::before {\n  content: \"\\F0BC5\";\n}\n\n.mdi-shield-link-variant::before {\n  content: \"\\F0D33\";\n}\n\n.mdi-shield-link-variant-outline::before {\n  content: \"\\F0D34\";\n}\n\n.mdi-shield-lock::before {\n  content: \"\\F099D\";\n}\n\n.mdi-shield-lock-open::before {\n  content: \"\\F199A\";\n}\n\n.mdi-shield-lock-open-outline::before {\n  content: \"\\F199B\";\n}\n\n.mdi-shield-lock-outline::before {\n  content: \"\\F0CCC\";\n}\n\n.mdi-shield-moon::before {\n  content: \"\\F1828\";\n}\n\n.mdi-shield-moon-outline::before {\n  content: \"\\F1829\";\n}\n\n.mdi-shield-off::before {\n  content: \"\\F099E\";\n}\n\n.mdi-shield-off-outline::before {\n  content: \"\\F099C\";\n}\n\n.mdi-shield-outline::before {\n  content: \"\\F0499\";\n}\n\n.mdi-shield-plus::before {\n  content: \"\\F0ADA\";\n}\n\n.mdi-shield-plus-outline::before {\n  content: \"\\F0ADB\";\n}\n\n.mdi-shield-refresh::before {\n  content: \"\\F00AA\";\n}\n\n.mdi-shield-refresh-outline::before {\n  content: \"\\F01E0\";\n}\n\n.mdi-shield-remove::before {\n  content: \"\\F0ADC\";\n}\n\n.mdi-shield-remove-outline::before {\n  content: \"\\F0ADD\";\n}\n\n.mdi-shield-search::before {\n  content: \"\\F0D9A\";\n}\n\n.mdi-shield-star::before {\n  content: \"\\F113B\";\n}\n\n.mdi-shield-star-outline::before {\n  content: \"\\F113C\";\n}\n\n.mdi-shield-sun::before {\n  content: \"\\F105D\";\n}\n\n.mdi-shield-sun-outline::before {\n  content: \"\\F105E\";\n}\n\n.mdi-shield-sword::before {\n  content: \"\\F18BE\";\n}\n\n.mdi-shield-sword-outline::before {\n  content: \"\\F18BF\";\n}\n\n.mdi-shield-sync::before {\n  content: \"\\F11A2\";\n}\n\n.mdi-shield-sync-outline::before {\n  content: \"\\F11A3\";\n}\n\n.mdi-shimmer::before {\n  content: \"\\F1545\";\n}\n\n.mdi-ship-wheel::before {\n  content: \"\\F0833\";\n}\n\n.mdi-shipping-pallet::before {\n  content: \"\\F184E\";\n}\n\n.mdi-shoe-ballet::before {\n  content: \"\\F15CA\";\n}\n\n.mdi-shoe-cleat::before {\n  content: \"\\F15C7\";\n}\n\n.mdi-shoe-formal::before {\n  content: \"\\F0B47\";\n}\n\n.mdi-shoe-heel::before {\n  content: \"\\F0B48\";\n}\n\n.mdi-shoe-print::before {\n  content: \"\\F0DFA\";\n}\n\n.mdi-shoe-sneaker::before {\n  content: \"\\F15C8\";\n}\n\n.mdi-shopping::before {\n  content: \"\\F049A\";\n}\n\n.mdi-shopping-music::before {\n  content: \"\\F049B\";\n}\n\n.mdi-shopping-outline::before {\n  content: \"\\F11D5\";\n}\n\n.mdi-shopping-search::before {\n  content: \"\\F0F84\";\n}\n\n.mdi-shore::before {\n  content: \"\\F14F9\";\n}\n\n.mdi-shovel::before {\n  content: \"\\F0710\";\n}\n\n.mdi-shovel-off::before {\n  content: \"\\F0711\";\n}\n\n.mdi-shower::before {\n  content: \"\\F09A0\";\n}\n\n.mdi-shower-head::before {\n  content: \"\\F09A1\";\n}\n\n.mdi-shredder::before {\n  content: \"\\F049C\";\n}\n\n.mdi-shuffle::before {\n  content: \"\\F049D\";\n}\n\n.mdi-shuffle-disabled::before {\n  content: \"\\F049E\";\n}\n\n.mdi-shuffle-variant::before {\n  content: \"\\F049F\";\n}\n\n.mdi-shuriken::before {\n  content: \"\\F137F\";\n}\n\n.mdi-sickle::before {\n  content: \"\\F18C0\";\n}\n\n.mdi-sigma::before {\n  content: \"\\F04A0\";\n}\n\n.mdi-sigma-lower::before {\n  content: \"\\F062B\";\n}\n\n.mdi-sign-caution::before {\n  content: \"\\F04A1\";\n}\n\n.mdi-sign-direction::before {\n  content: \"\\F0781\";\n}\n\n.mdi-sign-direction-minus::before {\n  content: \"\\F1000\";\n}\n\n.mdi-sign-direction-plus::before {\n  content: \"\\F0FDC\";\n}\n\n.mdi-sign-direction-remove::before {\n  content: \"\\F0FDD\";\n}\n\n.mdi-sign-pole::before {\n  content: \"\\F14F8\";\n}\n\n.mdi-sign-real-estate::before {\n  content: \"\\F1118\";\n}\n\n.mdi-sign-text::before {\n  content: \"\\F0782\";\n}\n\n.mdi-signal::before {\n  content: \"\\F04A2\";\n}\n\n.mdi-signal-2g::before {\n  content: \"\\F0712\";\n}\n\n.mdi-signal-3g::before {\n  content: \"\\F0713\";\n}\n\n.mdi-signal-4g::before {\n  content: \"\\F0714\";\n}\n\n.mdi-signal-5g::before {\n  content: \"\\F0A6F\";\n}\n\n.mdi-signal-cellular-1::before {\n  content: \"\\F08BC\";\n}\n\n.mdi-signal-cellular-2::before {\n  content: \"\\F08BD\";\n}\n\n.mdi-signal-cellular-3::before {\n  content: \"\\F08BE\";\n}\n\n.mdi-signal-cellular-outline::before {\n  content: \"\\F08BF\";\n}\n\n.mdi-signal-distance-variant::before {\n  content: \"\\F0E64\";\n}\n\n.mdi-signal-hspa::before {\n  content: \"\\F0715\";\n}\n\n.mdi-signal-hspa-plus::before {\n  content: \"\\F0716\";\n}\n\n.mdi-signal-off::before {\n  content: \"\\F0783\";\n}\n\n.mdi-signal-variant::before {\n  content: \"\\F060A\";\n}\n\n.mdi-signature::before {\n  content: \"\\F0DFB\";\n}\n\n.mdi-signature-freehand::before {\n  content: \"\\F0DFC\";\n}\n\n.mdi-signature-image::before {\n  content: \"\\F0DFD\";\n}\n\n.mdi-signature-text::before {\n  content: \"\\F0DFE\";\n}\n\n.mdi-silo::before {\n  content: \"\\F0B49\";\n}\n\n.mdi-silverware::before {\n  content: \"\\F04A3\";\n}\n\n.mdi-silverware-clean::before {\n  content: \"\\F0FDE\";\n}\n\n.mdi-silverware-fork::before {\n  content: \"\\F04A4\";\n}\n\n.mdi-silverware-fork-knife::before {\n  content: \"\\F0A70\";\n}\n\n.mdi-silverware-spoon::before {\n  content: \"\\F04A5\";\n}\n\n.mdi-silverware-variant::before {\n  content: \"\\F04A6\";\n}\n\n.mdi-sim::before {\n  content: \"\\F04A7\";\n}\n\n.mdi-sim-alert::before {\n  content: \"\\F04A8\";\n}\n\n.mdi-sim-alert-outline::before {\n  content: \"\\F15D3\";\n}\n\n.mdi-sim-off::before {\n  content: \"\\F04A9\";\n}\n\n.mdi-sim-off-outline::before {\n  content: \"\\F15D4\";\n}\n\n.mdi-sim-outline::before {\n  content: \"\\F15D5\";\n}\n\n.mdi-simple-icons::before {\n  content: \"\\F131D\";\n}\n\n.mdi-sina-weibo::before {\n  content: \"\\F0ADF\";\n}\n\n.mdi-sine-wave::before {\n  content: \"\\F095B\";\n}\n\n.mdi-sitemap::before {\n  content: \"\\F04AA\";\n}\n\n.mdi-sitemap-outline::before {\n  content: \"\\F199C\";\n}\n\n.mdi-size-l::before {\n  content: \"\\F13A6\";\n}\n\n.mdi-size-m::before {\n  content: \"\\F13A5\";\n}\n\n.mdi-size-s::before {\n  content: \"\\F13A4\";\n}\n\n.mdi-size-xl::before {\n  content: \"\\F13A7\";\n}\n\n.mdi-size-xs::before {\n  content: \"\\F13A3\";\n}\n\n.mdi-size-xxl::before {\n  content: \"\\F13A8\";\n}\n\n.mdi-size-xxs::before {\n  content: \"\\F13A2\";\n}\n\n.mdi-size-xxxl::before {\n  content: \"\\F13A9\";\n}\n\n.mdi-skate::before {\n  content: \"\\F0D35\";\n}\n\n.mdi-skate-off::before {\n  content: \"\\F0699\";\n}\n\n.mdi-skateboard::before {\n  content: \"\\F14C2\";\n}\n\n.mdi-skateboarding::before {\n  content: \"\\F0501\";\n}\n\n.mdi-skew-less::before {\n  content: \"\\F0D36\";\n}\n\n.mdi-skew-more::before {\n  content: \"\\F0D37\";\n}\n\n.mdi-ski::before {\n  content: \"\\F1304\";\n}\n\n.mdi-ski-cross-country::before {\n  content: \"\\F1305\";\n}\n\n.mdi-ski-water::before {\n  content: \"\\F1306\";\n}\n\n.mdi-skip-backward::before {\n  content: \"\\F04AB\";\n}\n\n.mdi-skip-backward-outline::before {\n  content: \"\\F0F25\";\n}\n\n.mdi-skip-forward::before {\n  content: \"\\F04AC\";\n}\n\n.mdi-skip-forward-outline::before {\n  content: \"\\F0F26\";\n}\n\n.mdi-skip-next::before {\n  content: \"\\F04AD\";\n}\n\n.mdi-skip-next-circle::before {\n  content: \"\\F0661\";\n}\n\n.mdi-skip-next-circle-outline::before {\n  content: \"\\F0662\";\n}\n\n.mdi-skip-next-outline::before {\n  content: \"\\F0F27\";\n}\n\n.mdi-skip-previous::before {\n  content: \"\\F04AE\";\n}\n\n.mdi-skip-previous-circle::before {\n  content: \"\\F0663\";\n}\n\n.mdi-skip-previous-circle-outline::before {\n  content: \"\\F0664\";\n}\n\n.mdi-skip-previous-outline::before {\n  content: \"\\F0F28\";\n}\n\n.mdi-skull::before {\n  content: \"\\F068C\";\n}\n\n.mdi-skull-crossbones::before {\n  content: \"\\F0BC6\";\n}\n\n.mdi-skull-crossbones-outline::before {\n  content: \"\\F0BC7\";\n}\n\n.mdi-skull-outline::before {\n  content: \"\\F0BC8\";\n}\n\n.mdi-skull-scan::before {\n  content: \"\\F14C7\";\n}\n\n.mdi-skull-scan-outline::before {\n  content: \"\\F14C8\";\n}\n\n.mdi-skype::before {\n  content: \"\\F04AF\";\n}\n\n.mdi-skype-business::before {\n  content: \"\\F04B0\";\n}\n\n.mdi-slack::before {\n  content: \"\\F04B1\";\n}\n\n.mdi-slash-forward::before {\n  content: \"\\F0FDF\";\n}\n\n.mdi-slash-forward-box::before {\n  content: \"\\F0FE0\";\n}\n\n.mdi-sledding::before {\n  content: \"\\F041B\";\n}\n\n.mdi-sleep::before {\n  content: \"\\F04B2\";\n}\n\n.mdi-sleep-off::before {\n  content: \"\\F04B3\";\n}\n\n.mdi-slide::before {\n  content: \"\\F15A5\";\n}\n\n.mdi-slope-downhill::before {\n  content: \"\\F0DFF\";\n}\n\n.mdi-slope-uphill::before {\n  content: \"\\F0E00\";\n}\n\n.mdi-slot-machine::before {\n  content: \"\\F1114\";\n}\n\n.mdi-slot-machine-outline::before {\n  content: \"\\F1115\";\n}\n\n.mdi-smart-card::before {\n  content: \"\\F10BD\";\n}\n\n.mdi-smart-card-off::before {\n  content: \"\\F18F7\";\n}\n\n.mdi-smart-card-off-outline::before {\n  content: \"\\F18F8\";\n}\n\n.mdi-smart-card-outline::before {\n  content: \"\\F10BE\";\n}\n\n.mdi-smart-card-reader::before {\n  content: \"\\F10BF\";\n}\n\n.mdi-smart-card-reader-outline::before {\n  content: \"\\F10C0\";\n}\n\n.mdi-smog::before {\n  content: \"\\F0A71\";\n}\n\n.mdi-smoke::before {\n  content: \"\\F1799\";\n}\n\n.mdi-smoke-detector::before {\n  content: \"\\F0392\";\n}\n\n.mdi-smoke-detector-alert::before {\n  content: \"\\F192E\";\n}\n\n.mdi-smoke-detector-alert-outline::before {\n  content: \"\\F192F\";\n}\n\n.mdi-smoke-detector-off::before {\n  content: \"\\F1809\";\n}\n\n.mdi-smoke-detector-off-outline::before {\n  content: \"\\F180A\";\n}\n\n.mdi-smoke-detector-outline::before {\n  content: \"\\F1808\";\n}\n\n.mdi-smoke-detector-variant::before {\n  content: \"\\F180B\";\n}\n\n.mdi-smoke-detector-variant-alert::before {\n  content: \"\\F1930\";\n}\n\n.mdi-smoke-detector-variant-off::before {\n  content: \"\\F180C\";\n}\n\n.mdi-smoking::before {\n  content: \"\\F04B4\";\n}\n\n.mdi-smoking-off::before {\n  content: \"\\F04B5\";\n}\n\n.mdi-smoking-pipe::before {\n  content: \"\\F140D\";\n}\n\n.mdi-smoking-pipe-off::before {\n  content: \"\\F1428\";\n}\n\n.mdi-snail::before {\n  content: \"\\F1677\";\n}\n\n.mdi-snake::before {\n  content: \"\\F150E\";\n}\n\n.mdi-snapchat::before {\n  content: \"\\F04B6\";\n}\n\n.mdi-snowboard::before {\n  content: \"\\F1307\";\n}\n\n.mdi-snowflake::before {\n  content: \"\\F0717\";\n}\n\n.mdi-snowflake-alert::before {\n  content: \"\\F0F29\";\n}\n\n.mdi-snowflake-melt::before {\n  content: \"\\F12CB\";\n}\n\n.mdi-snowflake-off::before {\n  content: \"\\F14E3\";\n}\n\n.mdi-snowflake-variant::before {\n  content: \"\\F0F2A\";\n}\n\n.mdi-snowman::before {\n  content: \"\\F04B7\";\n}\n\n.mdi-snowmobile::before {\n  content: \"\\F06DD\";\n}\n\n.mdi-soccer::before {\n  content: \"\\F04B8\";\n}\n\n.mdi-soccer-field::before {\n  content: \"\\F0834\";\n}\n\n.mdi-social-distance-2-meters::before {\n  content: \"\\F1579\";\n}\n\n.mdi-social-distance-6-feet::before {\n  content: \"\\F157A\";\n}\n\n.mdi-sofa::before {\n  content: \"\\F04B9\";\n}\n\n.mdi-sofa-outline::before {\n  content: \"\\F156D\";\n}\n\n.mdi-sofa-single::before {\n  content: \"\\F156E\";\n}\n\n.mdi-sofa-single-outline::before {\n  content: \"\\F156F\";\n}\n\n.mdi-solar-panel::before {\n  content: \"\\F0D9B\";\n}\n\n.mdi-solar-panel-large::before {\n  content: \"\\F0D9C\";\n}\n\n.mdi-solar-power::before {\n  content: \"\\F0A72\";\n}\n\n.mdi-soldering-iron::before {\n  content: \"\\F1092\";\n}\n\n.mdi-solid::before {\n  content: \"\\F068D\";\n}\n\n.mdi-sony-playstation::before {\n  content: \"\\F0414\";\n}\n\n.mdi-sort::before {\n  content: \"\\F04BA\";\n}\n\n.mdi-sort-alphabetical-ascending::before {\n  content: \"\\F05BD\";\n}\n\n.mdi-sort-alphabetical-ascending-variant::before {\n  content: \"\\F1148\";\n}\n\n.mdi-sort-alphabetical-descending::before {\n  content: \"\\F05BF\";\n}\n\n.mdi-sort-alphabetical-descending-variant::before {\n  content: \"\\F1149\";\n}\n\n.mdi-sort-alphabetical-variant::before {\n  content: \"\\F04BB\";\n}\n\n.mdi-sort-ascending::before {\n  content: \"\\F04BC\";\n}\n\n.mdi-sort-bool-ascending::before {\n  content: \"\\F1385\";\n}\n\n.mdi-sort-bool-ascending-variant::before {\n  content: \"\\F1386\";\n}\n\n.mdi-sort-bool-descending::before {\n  content: \"\\F1387\";\n}\n\n.mdi-sort-bool-descending-variant::before {\n  content: \"\\F1388\";\n}\n\n.mdi-sort-calendar-ascending::before {\n  content: \"\\F1547\";\n}\n\n.mdi-sort-calendar-descending::before {\n  content: \"\\F1548\";\n}\n\n.mdi-sort-clock-ascending::before {\n  content: \"\\F1549\";\n}\n\n.mdi-sort-clock-ascending-outline::before {\n  content: \"\\F154A\";\n}\n\n.mdi-sort-clock-descending::before {\n  content: \"\\F154B\";\n}\n\n.mdi-sort-clock-descending-outline::before {\n  content: \"\\F154C\";\n}\n\n.mdi-sort-descending::before {\n  content: \"\\F04BD\";\n}\n\n.mdi-sort-numeric-ascending::before {\n  content: \"\\F1389\";\n}\n\n.mdi-sort-numeric-ascending-variant::before {\n  content: \"\\F090D\";\n}\n\n.mdi-sort-numeric-descending::before {\n  content: \"\\F138A\";\n}\n\n.mdi-sort-numeric-descending-variant::before {\n  content: \"\\F0AD2\";\n}\n\n.mdi-sort-numeric-variant::before {\n  content: \"\\F04BE\";\n}\n\n.mdi-sort-reverse-variant::before {\n  content: \"\\F033C\";\n}\n\n.mdi-sort-variant::before {\n  content: \"\\F04BF\";\n}\n\n.mdi-sort-variant-lock::before {\n  content: \"\\F0CCD\";\n}\n\n.mdi-sort-variant-lock-open::before {\n  content: \"\\F0CCE\";\n}\n\n.mdi-sort-variant-remove::before {\n  content: \"\\F1147\";\n}\n\n.mdi-soundbar::before {\n  content: \"\\F17DB\";\n}\n\n.mdi-soundcloud::before {\n  content: \"\\F04C0\";\n}\n\n.mdi-source-branch::before {\n  content: \"\\F062C\";\n}\n\n.mdi-source-branch-check::before {\n  content: \"\\F14CF\";\n}\n\n.mdi-source-branch-minus::before {\n  content: \"\\F14CB\";\n}\n\n.mdi-source-branch-plus::before {\n  content: \"\\F14CA\";\n}\n\n.mdi-source-branch-refresh::before {\n  content: \"\\F14CD\";\n}\n\n.mdi-source-branch-remove::before {\n  content: \"\\F14CC\";\n}\n\n.mdi-source-branch-sync::before {\n  content: \"\\F14CE\";\n}\n\n.mdi-source-commit::before {\n  content: \"\\F0718\";\n}\n\n.mdi-source-commit-end::before {\n  content: \"\\F0719\";\n}\n\n.mdi-source-commit-end-local::before {\n  content: \"\\F071A\";\n}\n\n.mdi-source-commit-local::before {\n  content: \"\\F071B\";\n}\n\n.mdi-source-commit-next-local::before {\n  content: \"\\F071C\";\n}\n\n.mdi-source-commit-start::before {\n  content: \"\\F071D\";\n}\n\n.mdi-source-commit-start-next-local::before {\n  content: \"\\F071E\";\n}\n\n.mdi-source-fork::before {\n  content: \"\\F04C1\";\n}\n\n.mdi-source-merge::before {\n  content: \"\\F062D\";\n}\n\n.mdi-source-pull::before {\n  content: \"\\F04C2\";\n}\n\n.mdi-source-repository::before {\n  content: \"\\F0CCF\";\n}\n\n.mdi-source-repository-multiple::before {\n  content: \"\\F0CD0\";\n}\n\n.mdi-soy-sauce::before {\n  content: \"\\F07EE\";\n}\n\n.mdi-soy-sauce-off::before {\n  content: \"\\F13FC\";\n}\n\n.mdi-spa::before {\n  content: \"\\F0CD1\";\n}\n\n.mdi-spa-outline::before {\n  content: \"\\F0CD2\";\n}\n\n.mdi-space-invaders::before {\n  content: \"\\F0BC9\";\n}\n\n.mdi-space-station::before {\n  content: \"\\F1383\";\n}\n\n.mdi-spade::before {\n  content: \"\\F0E65\";\n}\n\n.mdi-speaker::before {\n  content: \"\\F04C3\";\n}\n\n.mdi-speaker-bluetooth::before {\n  content: \"\\F09A2\";\n}\n\n.mdi-speaker-multiple::before {\n  content: \"\\F0D38\";\n}\n\n.mdi-speaker-off::before {\n  content: \"\\F04C4\";\n}\n\n.mdi-speaker-wireless::before {\n  content: \"\\F071F\";\n}\n\n.mdi-spear::before {\n  content: \"\\F1845\";\n}\n\n.mdi-speedometer::before {\n  content: \"\\F04C5\";\n}\n\n.mdi-speedometer-medium::before {\n  content: \"\\F0F85\";\n}\n\n.mdi-speedometer-slow::before {\n  content: \"\\F0F86\";\n}\n\n.mdi-spellcheck::before {\n  content: \"\\F04C6\";\n}\n\n.mdi-sphere::before {\n  content: \"\\F1954\";\n}\n\n.mdi-sphere-off::before {\n  content: \"\\F1955\";\n}\n\n.mdi-spider::before {\n  content: \"\\F11EA\";\n}\n\n.mdi-spider-thread::before {\n  content: \"\\F11EB\";\n}\n\n.mdi-spider-web::before {\n  content: \"\\F0BCA\";\n}\n\n.mdi-spirit-level::before {\n  content: \"\\F14F1\";\n}\n\n.mdi-spoon-sugar::before {\n  content: \"\\F1429\";\n}\n\n.mdi-spotify::before {\n  content: \"\\F04C7\";\n}\n\n.mdi-spotlight::before {\n  content: \"\\F04C8\";\n}\n\n.mdi-spotlight-beam::before {\n  content: \"\\F04C9\";\n}\n\n.mdi-spray::before {\n  content: \"\\F0665\";\n}\n\n.mdi-spray-bottle::before {\n  content: \"\\F0AE0\";\n}\n\n.mdi-sprinkler::before {\n  content: \"\\F105F\";\n}\n\n.mdi-sprinkler-fire::before {\n  content: \"\\F199D\";\n}\n\n.mdi-sprinkler-variant::before {\n  content: \"\\F1060\";\n}\n\n.mdi-sprout::before {\n  content: \"\\F0E66\";\n}\n\n.mdi-sprout-outline::before {\n  content: \"\\F0E67\";\n}\n\n.mdi-square::before {\n  content: \"\\F0764\";\n}\n\n.mdi-square-circle::before {\n  content: \"\\F1500\";\n}\n\n.mdi-square-edit-outline::before {\n  content: \"\\F090C\";\n}\n\n.mdi-square-medium::before {\n  content: \"\\F0A13\";\n}\n\n.mdi-square-medium-outline::before {\n  content: \"\\F0A14\";\n}\n\n.mdi-square-off::before {\n  content: \"\\F12EE\";\n}\n\n.mdi-square-off-outline::before {\n  content: \"\\F12EF\";\n}\n\n.mdi-square-opacity::before {\n  content: \"\\F1854\";\n}\n\n.mdi-square-outline::before {\n  content: \"\\F0763\";\n}\n\n.mdi-square-root::before {\n  content: \"\\F0784\";\n}\n\n.mdi-square-root-box::before {\n  content: \"\\F09A3\";\n}\n\n.mdi-square-rounded::before {\n  content: \"\\F14FB\";\n}\n\n.mdi-square-rounded-outline::before {\n  content: \"\\F14FC\";\n}\n\n.mdi-square-small::before {\n  content: \"\\F0A15\";\n}\n\n.mdi-square-wave::before {\n  content: \"\\F147B\";\n}\n\n.mdi-squeegee::before {\n  content: \"\\F0AE1\";\n}\n\n.mdi-ssh::before {\n  content: \"\\F08C0\";\n}\n\n.mdi-stack-exchange::before {\n  content: \"\\F060B\";\n}\n\n.mdi-stack-overflow::before {\n  content: \"\\F04CC\";\n}\n\n.mdi-stackpath::before {\n  content: \"\\F0359\";\n}\n\n.mdi-stadium::before {\n  content: \"\\F0FF9\";\n}\n\n.mdi-stadium-variant::before {\n  content: \"\\F0720\";\n}\n\n.mdi-stairs::before {\n  content: \"\\F04CD\";\n}\n\n.mdi-stairs-box::before {\n  content: \"\\F139E\";\n}\n\n.mdi-stairs-down::before {\n  content: \"\\F12BE\";\n}\n\n.mdi-stairs-up::before {\n  content: \"\\F12BD\";\n}\n\n.mdi-stamper::before {\n  content: \"\\F0D39\";\n}\n\n.mdi-standard-definition::before {\n  content: \"\\F07EF\";\n}\n\n.mdi-star::before {\n  content: \"\\F04CE\";\n}\n\n.mdi-star-box::before {\n  content: \"\\F0A73\";\n}\n\n.mdi-star-box-multiple::before {\n  content: \"\\F1286\";\n}\n\n.mdi-star-box-multiple-outline::before {\n  content: \"\\F1287\";\n}\n\n.mdi-star-box-outline::before {\n  content: \"\\F0A74\";\n}\n\n.mdi-star-check::before {\n  content: \"\\F1566\";\n}\n\n.mdi-star-check-outline::before {\n  content: \"\\F156A\";\n}\n\n.mdi-star-circle::before {\n  content: \"\\F04CF\";\n}\n\n.mdi-star-circle-outline::before {\n  content: \"\\F09A4\";\n}\n\n.mdi-star-cog::before {\n  content: \"\\F1668\";\n}\n\n.mdi-star-cog-outline::before {\n  content: \"\\F1669\";\n}\n\n.mdi-star-crescent::before {\n  content: \"\\F0979\";\n}\n\n.mdi-star-david::before {\n  content: \"\\F097A\";\n}\n\n.mdi-star-face::before {\n  content: \"\\F09A5\";\n}\n\n.mdi-star-four-points::before {\n  content: \"\\F0AE2\";\n}\n\n.mdi-star-four-points-outline::before {\n  content: \"\\F0AE3\";\n}\n\n.mdi-star-half::before {\n  content: \"\\F0246\";\n}\n\n.mdi-star-half-full::before {\n  content: \"\\F04D0\";\n}\n\n.mdi-star-minus::before {\n  content: \"\\F1564\";\n}\n\n.mdi-star-minus-outline::before {\n  content: \"\\F1568\";\n}\n\n.mdi-star-off::before {\n  content: \"\\F04D1\";\n}\n\n.mdi-star-off-outline::before {\n  content: \"\\F155B\";\n}\n\n.mdi-star-outline::before {\n  content: \"\\F04D2\";\n}\n\n.mdi-star-plus::before {\n  content: \"\\F1563\";\n}\n\n.mdi-star-plus-outline::before {\n  content: \"\\F1567\";\n}\n\n.mdi-star-remove::before {\n  content: \"\\F1565\";\n}\n\n.mdi-star-remove-outline::before {\n  content: \"\\F1569\";\n}\n\n.mdi-star-settings::before {\n  content: \"\\F166A\";\n}\n\n.mdi-star-settings-outline::before {\n  content: \"\\F166B\";\n}\n\n.mdi-star-shooting::before {\n  content: \"\\F1741\";\n}\n\n.mdi-star-shooting-outline::before {\n  content: \"\\F1742\";\n}\n\n.mdi-star-three-points::before {\n  content: \"\\F0AE4\";\n}\n\n.mdi-star-three-points-outline::before {\n  content: \"\\F0AE5\";\n}\n\n.mdi-state-machine::before {\n  content: \"\\F11EF\";\n}\n\n.mdi-steam::before {\n  content: \"\\F04D3\";\n}\n\n.mdi-steering::before {\n  content: \"\\F04D4\";\n}\n\n.mdi-steering-off::before {\n  content: \"\\F090E\";\n}\n\n.mdi-step-backward::before {\n  content: \"\\F04D5\";\n}\n\n.mdi-step-backward-2::before {\n  content: \"\\F04D6\";\n}\n\n.mdi-step-forward::before {\n  content: \"\\F04D7\";\n}\n\n.mdi-step-forward-2::before {\n  content: \"\\F04D8\";\n}\n\n.mdi-stethoscope::before {\n  content: \"\\F04D9\";\n}\n\n.mdi-sticker::before {\n  content: \"\\F1364\";\n}\n\n.mdi-sticker-alert::before {\n  content: \"\\F1365\";\n}\n\n.mdi-sticker-alert-outline::before {\n  content: \"\\F1366\";\n}\n\n.mdi-sticker-check::before {\n  content: \"\\F1367\";\n}\n\n.mdi-sticker-check-outline::before {\n  content: \"\\F1368\";\n}\n\n.mdi-sticker-circle-outline::before {\n  content: \"\\F05D0\";\n}\n\n.mdi-sticker-emoji::before {\n  content: \"\\F0785\";\n}\n\n.mdi-sticker-minus::before {\n  content: \"\\F1369\";\n}\n\n.mdi-sticker-minus-outline::before {\n  content: \"\\F136A\";\n}\n\n.mdi-sticker-outline::before {\n  content: \"\\F136B\";\n}\n\n.mdi-sticker-plus::before {\n  content: \"\\F136C\";\n}\n\n.mdi-sticker-plus-outline::before {\n  content: \"\\F136D\";\n}\n\n.mdi-sticker-remove::before {\n  content: \"\\F136E\";\n}\n\n.mdi-sticker-remove-outline::before {\n  content: \"\\F136F\";\n}\n\n.mdi-sticker-text::before {\n  content: \"\\F178E\";\n}\n\n.mdi-sticker-text-outline::before {\n  content: \"\\F178F\";\n}\n\n.mdi-stocking::before {\n  content: \"\\F04DA\";\n}\n\n.mdi-stomach::before {\n  content: \"\\F1093\";\n}\n\n.mdi-stool::before {\n  content: \"\\F195D\";\n}\n\n.mdi-stool-outline::before {\n  content: \"\\F195E\";\n}\n\n.mdi-stop::before {\n  content: \"\\F04DB\";\n}\n\n.mdi-stop-circle::before {\n  content: \"\\F0666\";\n}\n\n.mdi-stop-circle-outline::before {\n  content: \"\\F0667\";\n}\n\n.mdi-store::before {\n  content: \"\\F04DC\";\n}\n\n.mdi-store-24-hour::before {\n  content: \"\\F04DD\";\n}\n\n.mdi-store-alert::before {\n  content: \"\\F18C1\";\n}\n\n.mdi-store-alert-outline::before {\n  content: \"\\F18C2\";\n}\n\n.mdi-store-check::before {\n  content: \"\\F18C3\";\n}\n\n.mdi-store-check-outline::before {\n  content: \"\\F18C4\";\n}\n\n.mdi-store-clock::before {\n  content: \"\\F18C5\";\n}\n\n.mdi-store-clock-outline::before {\n  content: \"\\F18C6\";\n}\n\n.mdi-store-cog::before {\n  content: \"\\F18C7\";\n}\n\n.mdi-store-cog-outline::before {\n  content: \"\\F18C8\";\n}\n\n.mdi-store-edit::before {\n  content: \"\\F18C9\";\n}\n\n.mdi-store-edit-outline::before {\n  content: \"\\F18CA\";\n}\n\n.mdi-store-marker::before {\n  content: \"\\F18CB\";\n}\n\n.mdi-store-marker-outline::before {\n  content: \"\\F18CC\";\n}\n\n.mdi-store-minus::before {\n  content: \"\\F165E\";\n}\n\n.mdi-store-minus-outline::before {\n  content: \"\\F18CD\";\n}\n\n.mdi-store-off::before {\n  content: \"\\F18CE\";\n}\n\n.mdi-store-off-outline::before {\n  content: \"\\F18CF\";\n}\n\n.mdi-store-outline::before {\n  content: \"\\F1361\";\n}\n\n.mdi-store-plus::before {\n  content: \"\\F165F\";\n}\n\n.mdi-store-plus-outline::before {\n  content: \"\\F18D0\";\n}\n\n.mdi-store-remove::before {\n  content: \"\\F1660\";\n}\n\n.mdi-store-remove-outline::before {\n  content: \"\\F18D1\";\n}\n\n.mdi-store-search::before {\n  content: \"\\F18D2\";\n}\n\n.mdi-store-search-outline::before {\n  content: \"\\F18D3\";\n}\n\n.mdi-store-settings::before {\n  content: \"\\F18D4\";\n}\n\n.mdi-store-settings-outline::before {\n  content: \"\\F18D5\";\n}\n\n.mdi-storefront::before {\n  content: \"\\F07C7\";\n}\n\n.mdi-storefront-outline::before {\n  content: \"\\F10C1\";\n}\n\n.mdi-stove::before {\n  content: \"\\F04DE\";\n}\n\n.mdi-strategy::before {\n  content: \"\\F11D6\";\n}\n\n.mdi-stretch-to-page::before {\n  content: \"\\F0F2B\";\n}\n\n.mdi-stretch-to-page-outline::before {\n  content: \"\\F0F2C\";\n}\n\n.mdi-string-lights::before {\n  content: \"\\F12BA\";\n}\n\n.mdi-string-lights-off::before {\n  content: \"\\F12BB\";\n}\n\n.mdi-subdirectory-arrow-left::before {\n  content: \"\\F060C\";\n}\n\n.mdi-subdirectory-arrow-right::before {\n  content: \"\\F060D\";\n}\n\n.mdi-submarine::before {\n  content: \"\\F156C\";\n}\n\n.mdi-subtitles::before {\n  content: \"\\F0A16\";\n}\n\n.mdi-subtitles-outline::before {\n  content: \"\\F0A17\";\n}\n\n.mdi-subway::before {\n  content: \"\\F06AC\";\n}\n\n.mdi-subway-alert-variant::before {\n  content: \"\\F0D9D\";\n}\n\n.mdi-subway-variant::before {\n  content: \"\\F04DF\";\n}\n\n.mdi-summit::before {\n  content: \"\\F0786\";\n}\n\n.mdi-sun-compass::before {\n  content: \"\\F19A5\";\n}\n\n.mdi-sun-snowflake::before {\n  content: \"\\F1796\";\n}\n\n.mdi-sun-thermometer::before {\n  content: \"\\F18D6\";\n}\n\n.mdi-sun-thermometer-outline::before {\n  content: \"\\F18D7\";\n}\n\n.mdi-sun-wireless::before {\n  content: \"\\F17FE\";\n}\n\n.mdi-sun-wireless-outline::before {\n  content: \"\\F17FF\";\n}\n\n.mdi-sunglasses::before {\n  content: \"\\F04E0\";\n}\n\n.mdi-surfing::before {\n  content: \"\\F1746\";\n}\n\n.mdi-surround-sound::before {\n  content: \"\\F05C5\";\n}\n\n.mdi-surround-sound-2-0::before {\n  content: \"\\F07F0\";\n}\n\n.mdi-surround-sound-2-1::before {\n  content: \"\\F1729\";\n}\n\n.mdi-surround-sound-3-1::before {\n  content: \"\\F07F1\";\n}\n\n.mdi-surround-sound-5-1::before {\n  content: \"\\F07F2\";\n}\n\n.mdi-surround-sound-5-1-2::before {\n  content: \"\\F172A\";\n}\n\n.mdi-surround-sound-7-1::before {\n  content: \"\\F07F3\";\n}\n\n.mdi-svg::before {\n  content: \"\\F0721\";\n}\n\n.mdi-swap-horizontal::before {\n  content: \"\\F04E1\";\n}\n\n.mdi-swap-horizontal-bold::before {\n  content: \"\\F0BCD\";\n}\n\n.mdi-swap-horizontal-circle::before {\n  content: \"\\F0FE1\";\n}\n\n.mdi-swap-horizontal-circle-outline::before {\n  content: \"\\F0FE2\";\n}\n\n.mdi-swap-horizontal-variant::before {\n  content: \"\\F08C1\";\n}\n\n.mdi-swap-vertical::before {\n  content: \"\\F04E2\";\n}\n\n.mdi-swap-vertical-bold::before {\n  content: \"\\F0BCE\";\n}\n\n.mdi-swap-vertical-circle::before {\n  content: \"\\F0FE3\";\n}\n\n.mdi-swap-vertical-circle-outline::before {\n  content: \"\\F0FE4\";\n}\n\n.mdi-swap-vertical-variant::before {\n  content: \"\\F08C2\";\n}\n\n.mdi-swim::before {\n  content: \"\\F04E3\";\n}\n\n.mdi-switch::before {\n  content: \"\\F04E4\";\n}\n\n.mdi-sword::before {\n  content: \"\\F04E5\";\n}\n\n.mdi-sword-cross::before {\n  content: \"\\F0787\";\n}\n\n.mdi-syllabary-hangul::before {\n  content: \"\\F1333\";\n}\n\n.mdi-syllabary-hiragana::before {\n  content: \"\\F1334\";\n}\n\n.mdi-syllabary-katakana::before {\n  content: \"\\F1335\";\n}\n\n.mdi-syllabary-katakana-halfwidth::before {\n  content: \"\\F1336\";\n}\n\n.mdi-symbol::before {\n  content: \"\\F1501\";\n}\n\n.mdi-symfony::before {\n  content: \"\\F0AE6\";\n}\n\n.mdi-sync::before {\n  content: \"\\F04E6\";\n}\n\n.mdi-sync-alert::before {\n  content: \"\\F04E7\";\n}\n\n.mdi-sync-circle::before {\n  content: \"\\F1378\";\n}\n\n.mdi-sync-off::before {\n  content: \"\\F04E8\";\n}\n\n.mdi-tab::before {\n  content: \"\\F04E9\";\n}\n\n.mdi-tab-minus::before {\n  content: \"\\F0B4B\";\n}\n\n.mdi-tab-plus::before {\n  content: \"\\F075C\";\n}\n\n.mdi-tab-remove::before {\n  content: \"\\F0B4C\";\n}\n\n.mdi-tab-search::before {\n  content: \"\\F199E\";\n}\n\n.mdi-tab-unselected::before {\n  content: \"\\F04EA\";\n}\n\n.mdi-table::before {\n  content: \"\\F04EB\";\n}\n\n.mdi-table-account::before {\n  content: \"\\F13B9\";\n}\n\n.mdi-table-alert::before {\n  content: \"\\F13BA\";\n}\n\n.mdi-table-arrow-down::before {\n  content: \"\\F13BB\";\n}\n\n.mdi-table-arrow-left::before {\n  content: \"\\F13BC\";\n}\n\n.mdi-table-arrow-right::before {\n  content: \"\\F13BD\";\n}\n\n.mdi-table-arrow-up::before {\n  content: \"\\F13BE\";\n}\n\n.mdi-table-border::before {\n  content: \"\\F0A18\";\n}\n\n.mdi-table-cancel::before {\n  content: \"\\F13BF\";\n}\n\n.mdi-table-chair::before {\n  content: \"\\F1061\";\n}\n\n.mdi-table-check::before {\n  content: \"\\F13C0\";\n}\n\n.mdi-table-clock::before {\n  content: \"\\F13C1\";\n}\n\n.mdi-table-cog::before {\n  content: \"\\F13C2\";\n}\n\n.mdi-table-column::before {\n  content: \"\\F0835\";\n}\n\n.mdi-table-column-plus-after::before {\n  content: \"\\F04EC\";\n}\n\n.mdi-table-column-plus-before::before {\n  content: \"\\F04ED\";\n}\n\n.mdi-table-column-remove::before {\n  content: \"\\F04EE\";\n}\n\n.mdi-table-column-width::before {\n  content: \"\\F04EF\";\n}\n\n.mdi-table-edit::before {\n  content: \"\\F04F0\";\n}\n\n.mdi-table-eye::before {\n  content: \"\\F1094\";\n}\n\n.mdi-table-eye-off::before {\n  content: \"\\F13C3\";\n}\n\n.mdi-table-furniture::before {\n  content: \"\\F05BC\";\n}\n\n.mdi-table-headers-eye::before {\n  content: \"\\F121D\";\n}\n\n.mdi-table-headers-eye-off::before {\n  content: \"\\F121E\";\n}\n\n.mdi-table-heart::before {\n  content: \"\\F13C4\";\n}\n\n.mdi-table-key::before {\n  content: \"\\F13C5\";\n}\n\n.mdi-table-large::before {\n  content: \"\\F04F1\";\n}\n\n.mdi-table-large-plus::before {\n  content: \"\\F0F87\";\n}\n\n.mdi-table-large-remove::before {\n  content: \"\\F0F88\";\n}\n\n.mdi-table-lock::before {\n  content: \"\\F13C6\";\n}\n\n.mdi-table-merge-cells::before {\n  content: \"\\F09A6\";\n}\n\n.mdi-table-minus::before {\n  content: \"\\F13C7\";\n}\n\n.mdi-table-multiple::before {\n  content: \"\\F13C8\";\n}\n\n.mdi-table-network::before {\n  content: \"\\F13C9\";\n}\n\n.mdi-table-of-contents::before {\n  content: \"\\F0836\";\n}\n\n.mdi-table-off::before {\n  content: \"\\F13CA\";\n}\n\n.mdi-table-picnic::before {\n  content: \"\\F1743\";\n}\n\n.mdi-table-pivot::before {\n  content: \"\\F183C\";\n}\n\n.mdi-table-plus::before {\n  content: \"\\F0A75\";\n}\n\n.mdi-table-refresh::before {\n  content: \"\\F13A0\";\n}\n\n.mdi-table-remove::before {\n  content: \"\\F0A76\";\n}\n\n.mdi-table-row::before {\n  content: \"\\F0837\";\n}\n\n.mdi-table-row-height::before {\n  content: \"\\F04F2\";\n}\n\n.mdi-table-row-plus-after::before {\n  content: \"\\F04F3\";\n}\n\n.mdi-table-row-plus-before::before {\n  content: \"\\F04F4\";\n}\n\n.mdi-table-row-remove::before {\n  content: \"\\F04F5\";\n}\n\n.mdi-table-search::before {\n  content: \"\\F090F\";\n}\n\n.mdi-table-settings::before {\n  content: \"\\F0838\";\n}\n\n.mdi-table-split-cell::before {\n  content: \"\\F142A\";\n}\n\n.mdi-table-star::before {\n  content: \"\\F13CB\";\n}\n\n.mdi-table-sync::before {\n  content: \"\\F13A1\";\n}\n\n.mdi-table-tennis::before {\n  content: \"\\F0E68\";\n}\n\n.mdi-tablet::before {\n  content: \"\\F04F6\";\n}\n\n.mdi-tablet-android::before {\n  content: \"\\F04F7\";\n}\n\n.mdi-tablet-cellphone::before {\n  content: \"\\F09A7\";\n}\n\n.mdi-tablet-dashboard::before {\n  content: \"\\F0ECE\";\n}\n\n.mdi-taco::before {\n  content: \"\\F0762\";\n}\n\n.mdi-tag::before {\n  content: \"\\F04F9\";\n}\n\n.mdi-tag-arrow-down::before {\n  content: \"\\F172B\";\n}\n\n.mdi-tag-arrow-down-outline::before {\n  content: \"\\F172C\";\n}\n\n.mdi-tag-arrow-left::before {\n  content: \"\\F172D\";\n}\n\n.mdi-tag-arrow-left-outline::before {\n  content: \"\\F172E\";\n}\n\n.mdi-tag-arrow-right::before {\n  content: \"\\F172F\";\n}\n\n.mdi-tag-arrow-right-outline::before {\n  content: \"\\F1730\";\n}\n\n.mdi-tag-arrow-up::before {\n  content: \"\\F1731\";\n}\n\n.mdi-tag-arrow-up-outline::before {\n  content: \"\\F1732\";\n}\n\n.mdi-tag-faces::before {\n  content: \"\\F04FA\";\n}\n\n.mdi-tag-heart::before {\n  content: \"\\F068B\";\n}\n\n.mdi-tag-heart-outline::before {\n  content: \"\\F0BCF\";\n}\n\n.mdi-tag-minus::before {\n  content: \"\\F0910\";\n}\n\n.mdi-tag-minus-outline::before {\n  content: \"\\F121F\";\n}\n\n.mdi-tag-multiple::before {\n  content: \"\\F04FB\";\n}\n\n.mdi-tag-multiple-outline::before {\n  content: \"\\F12F7\";\n}\n\n.mdi-tag-off::before {\n  content: \"\\F1220\";\n}\n\n.mdi-tag-off-outline::before {\n  content: \"\\F1221\";\n}\n\n.mdi-tag-outline::before {\n  content: \"\\F04FC\";\n}\n\n.mdi-tag-plus::before {\n  content: \"\\F0722\";\n}\n\n.mdi-tag-plus-outline::before {\n  content: \"\\F1222\";\n}\n\n.mdi-tag-remove::before {\n  content: \"\\F0723\";\n}\n\n.mdi-tag-remove-outline::before {\n  content: \"\\F1223\";\n}\n\n.mdi-tag-search::before {\n  content: \"\\F1907\";\n}\n\n.mdi-tag-search-outline::before {\n  content: \"\\F1908\";\n}\n\n.mdi-tag-text::before {\n  content: \"\\F1224\";\n}\n\n.mdi-tag-text-outline::before {\n  content: \"\\F04FD\";\n}\n\n.mdi-tailwind::before {\n  content: \"\\F13FF\";\n}\n\n.mdi-tangram::before {\n  content: \"\\F04F8\";\n}\n\n.mdi-tank::before {\n  content: \"\\F0D3A\";\n}\n\n.mdi-tanker-truck::before {\n  content: \"\\F0FE5\";\n}\n\n.mdi-tape-drive::before {\n  content: \"\\F16DF\";\n}\n\n.mdi-tape-measure::before {\n  content: \"\\F0B4D\";\n}\n\n.mdi-target::before {\n  content: \"\\F04FE\";\n}\n\n.mdi-target-account::before {\n  content: \"\\F0BD0\";\n}\n\n.mdi-target-variant::before {\n  content: \"\\F0A77\";\n}\n\n.mdi-taxi::before {\n  content: \"\\F04FF\";\n}\n\n.mdi-tea::before {\n  content: \"\\F0D9E\";\n}\n\n.mdi-tea-outline::before {\n  content: \"\\F0D9F\";\n}\n\n.mdi-teamviewer::before {\n  content: \"\\F0500\";\n}\n\n.mdi-teddy-bear::before {\n  content: \"\\F18FB\";\n}\n\n.mdi-telescope::before {\n  content: \"\\F0B4E\";\n}\n\n.mdi-television::before {\n  content: \"\\F0502\";\n}\n\n.mdi-television-ambient-light::before {\n  content: \"\\F1356\";\n}\n\n.mdi-television-box::before {\n  content: \"\\F0839\";\n}\n\n.mdi-television-classic::before {\n  content: \"\\F07F4\";\n}\n\n.mdi-television-classic-off::before {\n  content: \"\\F083A\";\n}\n\n.mdi-television-guide::before {\n  content: \"\\F0503\";\n}\n\n.mdi-television-off::before {\n  content: \"\\F083B\";\n}\n\n.mdi-television-pause::before {\n  content: \"\\F0F89\";\n}\n\n.mdi-television-play::before {\n  content: \"\\F0ECF\";\n}\n\n.mdi-television-shimmer::before {\n  content: \"\\F1110\";\n}\n\n.mdi-television-stop::before {\n  content: \"\\F0F8A\";\n}\n\n.mdi-temperature-celsius::before {\n  content: \"\\F0504\";\n}\n\n.mdi-temperature-fahrenheit::before {\n  content: \"\\F0505\";\n}\n\n.mdi-temperature-kelvin::before {\n  content: \"\\F0506\";\n}\n\n.mdi-tennis::before {\n  content: \"\\F0DA0\";\n}\n\n.mdi-tennis-ball::before {\n  content: \"\\F0507\";\n}\n\n.mdi-tent::before {\n  content: \"\\F0508\";\n}\n\n.mdi-terraform::before {\n  content: \"\\F1062\";\n}\n\n.mdi-terrain::before {\n  content: \"\\F0509\";\n}\n\n.mdi-test-tube::before {\n  content: \"\\F0668\";\n}\n\n.mdi-test-tube-empty::before {\n  content: \"\\F0911\";\n}\n\n.mdi-test-tube-off::before {\n  content: \"\\F0912\";\n}\n\n.mdi-text::before {\n  content: \"\\F09A8\";\n}\n\n.mdi-text-account::before {\n  content: \"\\F1570\";\n}\n\n.mdi-text-box::before {\n  content: \"\\F021A\";\n}\n\n.mdi-text-box-check::before {\n  content: \"\\F0EA6\";\n}\n\n.mdi-text-box-check-outline::before {\n  content: \"\\F0EA7\";\n}\n\n.mdi-text-box-minus::before {\n  content: \"\\F0EA8\";\n}\n\n.mdi-text-box-minus-outline::before {\n  content: \"\\F0EA9\";\n}\n\n.mdi-text-box-multiple::before {\n  content: \"\\F0AB7\";\n}\n\n.mdi-text-box-multiple-outline::before {\n  content: \"\\F0AB8\";\n}\n\n.mdi-text-box-outline::before {\n  content: \"\\F09ED\";\n}\n\n.mdi-text-box-plus::before {\n  content: \"\\F0EAA\";\n}\n\n.mdi-text-box-plus-outline::before {\n  content: \"\\F0EAB\";\n}\n\n.mdi-text-box-remove::before {\n  content: \"\\F0EAC\";\n}\n\n.mdi-text-box-remove-outline::before {\n  content: \"\\F0EAD\";\n}\n\n.mdi-text-box-search::before {\n  content: \"\\F0EAE\";\n}\n\n.mdi-text-box-search-outline::before {\n  content: \"\\F0EAF\";\n}\n\n.mdi-text-long::before {\n  content: \"\\F09AA\";\n}\n\n.mdi-text-recognition::before {\n  content: \"\\F113D\";\n}\n\n.mdi-text-search::before {\n  content: \"\\F13B8\";\n}\n\n.mdi-text-shadow::before {\n  content: \"\\F0669\";\n}\n\n.mdi-text-short::before {\n  content: \"\\F09A9\";\n}\n\n.mdi-text-to-speech::before {\n  content: \"\\F050A\";\n}\n\n.mdi-text-to-speech-off::before {\n  content: \"\\F050B\";\n}\n\n.mdi-texture::before {\n  content: \"\\F050C\";\n}\n\n.mdi-texture-box::before {\n  content: \"\\F0FE6\";\n}\n\n.mdi-theater::before {\n  content: \"\\F050D\";\n}\n\n.mdi-theme-light-dark::before {\n  content: \"\\F050E\";\n}\n\n.mdi-thermometer::before {\n  content: \"\\F050F\";\n}\n\n.mdi-thermometer-alert::before {\n  content: \"\\F0E01\";\n}\n\n.mdi-thermometer-bluetooth::before {\n  content: \"\\F1895\";\n}\n\n.mdi-thermometer-chevron-down::before {\n  content: \"\\F0E02\";\n}\n\n.mdi-thermometer-chevron-up::before {\n  content: \"\\F0E03\";\n}\n\n.mdi-thermometer-high::before {\n  content: \"\\F10C2\";\n}\n\n.mdi-thermometer-lines::before {\n  content: \"\\F0510\";\n}\n\n.mdi-thermometer-low::before {\n  content: \"\\F10C3\";\n}\n\n.mdi-thermometer-minus::before {\n  content: \"\\F0E04\";\n}\n\n.mdi-thermometer-off::before {\n  content: \"\\F1531\";\n}\n\n.mdi-thermometer-plus::before {\n  content: \"\\F0E05\";\n}\n\n.mdi-thermostat::before {\n  content: \"\\F0393\";\n}\n\n.mdi-thermostat-box::before {\n  content: \"\\F0891\";\n}\n\n.mdi-thought-bubble::before {\n  content: \"\\F07F6\";\n}\n\n.mdi-thought-bubble-outline::before {\n  content: \"\\F07F7\";\n}\n\n.mdi-thumb-down::before {\n  content: \"\\F0511\";\n}\n\n.mdi-thumb-down-outline::before {\n  content: \"\\F0512\";\n}\n\n.mdi-thumb-up::before {\n  content: \"\\F0513\";\n}\n\n.mdi-thumb-up-outline::before {\n  content: \"\\F0514\";\n}\n\n.mdi-thumbs-up-down::before {\n  content: \"\\F0515\";\n}\n\n.mdi-thumbs-up-down-outline::before {\n  content: \"\\F1914\";\n}\n\n.mdi-ticket::before {\n  content: \"\\F0516\";\n}\n\n.mdi-ticket-account::before {\n  content: \"\\F0517\";\n}\n\n.mdi-ticket-confirmation::before {\n  content: \"\\F0518\";\n}\n\n.mdi-ticket-confirmation-outline::before {\n  content: \"\\F13AA\";\n}\n\n.mdi-ticket-outline::before {\n  content: \"\\F0913\";\n}\n\n.mdi-ticket-percent::before {\n  content: \"\\F0724\";\n}\n\n.mdi-ticket-percent-outline::before {\n  content: \"\\F142B\";\n}\n\n.mdi-tie::before {\n  content: \"\\F0519\";\n}\n\n.mdi-tilde::before {\n  content: \"\\F0725\";\n}\n\n.mdi-tilde-off::before {\n  content: \"\\F18F3\";\n}\n\n.mdi-timelapse::before {\n  content: \"\\F051A\";\n}\n\n.mdi-timeline::before {\n  content: \"\\F0BD1\";\n}\n\n.mdi-timeline-alert::before {\n  content: \"\\F0F95\";\n}\n\n.mdi-timeline-alert-outline::before {\n  content: \"\\F0F98\";\n}\n\n.mdi-timeline-check::before {\n  content: \"\\F1532\";\n}\n\n.mdi-timeline-check-outline::before {\n  content: \"\\F1533\";\n}\n\n.mdi-timeline-clock::before {\n  content: \"\\F11FB\";\n}\n\n.mdi-timeline-clock-outline::before {\n  content: \"\\F11FC\";\n}\n\n.mdi-timeline-help::before {\n  content: \"\\F0F99\";\n}\n\n.mdi-timeline-help-outline::before {\n  content: \"\\F0F9A\";\n}\n\n.mdi-timeline-minus::before {\n  content: \"\\F1534\";\n}\n\n.mdi-timeline-minus-outline::before {\n  content: \"\\F1535\";\n}\n\n.mdi-timeline-outline::before {\n  content: \"\\F0BD2\";\n}\n\n.mdi-timeline-plus::before {\n  content: \"\\F0F96\";\n}\n\n.mdi-timeline-plus-outline::before {\n  content: \"\\F0F97\";\n}\n\n.mdi-timeline-remove::before {\n  content: \"\\F1536\";\n}\n\n.mdi-timeline-remove-outline::before {\n  content: \"\\F1537\";\n}\n\n.mdi-timeline-text::before {\n  content: \"\\F0BD3\";\n}\n\n.mdi-timeline-text-outline::before {\n  content: \"\\F0BD4\";\n}\n\n.mdi-timer::before {\n  content: \"\\F13AB\";\n}\n\n.mdi-timer-10::before {\n  content: \"\\F051C\";\n}\n\n.mdi-timer-3::before {\n  content: \"\\F051D\";\n}\n\n.mdi-timer-cog::before {\n  content: \"\\F1925\";\n}\n\n.mdi-timer-cog-outline::before {\n  content: \"\\F1926\";\n}\n\n.mdi-timer-off::before {\n  content: \"\\F13AC\";\n}\n\n.mdi-timer-off-outline::before {\n  content: \"\\F051E\";\n}\n\n.mdi-timer-outline::before {\n  content: \"\\F051B\";\n}\n\n.mdi-timer-sand::before {\n  content: \"\\F051F\";\n}\n\n.mdi-timer-sand-complete::before {\n  content: \"\\F199F\";\n}\n\n.mdi-timer-sand-empty::before {\n  content: \"\\F06AD\";\n}\n\n.mdi-timer-sand-full::before {\n  content: \"\\F078C\";\n}\n\n.mdi-timer-sand-paused::before {\n  content: \"\\F19A0\";\n}\n\n.mdi-timer-settings::before {\n  content: \"\\F1923\";\n}\n\n.mdi-timer-settings-outline::before {\n  content: \"\\F1924\";\n}\n\n.mdi-timetable::before {\n  content: \"\\F0520\";\n}\n\n.mdi-tire::before {\n  content: \"\\F1896\";\n}\n\n.mdi-toaster::before {\n  content: \"\\F1063\";\n}\n\n.mdi-toaster-off::before {\n  content: \"\\F11B7\";\n}\n\n.mdi-toaster-oven::before {\n  content: \"\\F0CD3\";\n}\n\n.mdi-toggle-switch::before {\n  content: \"\\F0521\";\n}\n\n.mdi-toggle-switch-off::before {\n  content: \"\\F0522\";\n}\n\n.mdi-toggle-switch-off-outline::before {\n  content: \"\\F0A19\";\n}\n\n.mdi-toggle-switch-outline::before {\n  content: \"\\F0A1A\";\n}\n\n.mdi-toilet::before {\n  content: \"\\F09AB\";\n}\n\n.mdi-toolbox::before {\n  content: \"\\F09AC\";\n}\n\n.mdi-toolbox-outline::before {\n  content: \"\\F09AD\";\n}\n\n.mdi-tools::before {\n  content: \"\\F1064\";\n}\n\n.mdi-tooltip::before {\n  content: \"\\F0523\";\n}\n\n.mdi-tooltip-account::before {\n  content: \"\\F000C\";\n}\n\n.mdi-tooltip-cellphone::before {\n  content: \"\\F183B\";\n}\n\n.mdi-tooltip-check::before {\n  content: \"\\F155C\";\n}\n\n.mdi-tooltip-check-outline::before {\n  content: \"\\F155D\";\n}\n\n.mdi-tooltip-edit::before {\n  content: \"\\F0524\";\n}\n\n.mdi-tooltip-edit-outline::before {\n  content: \"\\F12C5\";\n}\n\n.mdi-tooltip-image::before {\n  content: \"\\F0525\";\n}\n\n.mdi-tooltip-image-outline::before {\n  content: \"\\F0BD5\";\n}\n\n.mdi-tooltip-minus::before {\n  content: \"\\F155E\";\n}\n\n.mdi-tooltip-minus-outline::before {\n  content: \"\\F155F\";\n}\n\n.mdi-tooltip-outline::before {\n  content: \"\\F0526\";\n}\n\n.mdi-tooltip-plus::before {\n  content: \"\\F0BD6\";\n}\n\n.mdi-tooltip-plus-outline::before {\n  content: \"\\F0527\";\n}\n\n.mdi-tooltip-remove::before {\n  content: \"\\F1560\";\n}\n\n.mdi-tooltip-remove-outline::before {\n  content: \"\\F1561\";\n}\n\n.mdi-tooltip-text::before {\n  content: \"\\F0528\";\n}\n\n.mdi-tooltip-text-outline::before {\n  content: \"\\F0BD7\";\n}\n\n.mdi-tooth::before {\n  content: \"\\F08C3\";\n}\n\n.mdi-tooth-outline::before {\n  content: \"\\F0529\";\n}\n\n.mdi-toothbrush::before {\n  content: \"\\F1129\";\n}\n\n.mdi-toothbrush-electric::before {\n  content: \"\\F112C\";\n}\n\n.mdi-toothbrush-paste::before {\n  content: \"\\F112A\";\n}\n\n.mdi-torch::before {\n  content: \"\\F1606\";\n}\n\n.mdi-tortoise::before {\n  content: \"\\F0D3B\";\n}\n\n.mdi-toslink::before {\n  content: \"\\F12B8\";\n}\n\n.mdi-tournament::before {\n  content: \"\\F09AE\";\n}\n\n.mdi-tow-truck::before {\n  content: \"\\F083C\";\n}\n\n.mdi-tower-beach::before {\n  content: \"\\F0681\";\n}\n\n.mdi-tower-fire::before {\n  content: \"\\F0682\";\n}\n\n.mdi-town-hall::before {\n  content: \"\\F1875\";\n}\n\n.mdi-toy-brick::before {\n  content: \"\\F1288\";\n}\n\n.mdi-toy-brick-marker::before {\n  content: \"\\F1289\";\n}\n\n.mdi-toy-brick-marker-outline::before {\n  content: \"\\F128A\";\n}\n\n.mdi-toy-brick-minus::before {\n  content: \"\\F128B\";\n}\n\n.mdi-toy-brick-minus-outline::before {\n  content: \"\\F128C\";\n}\n\n.mdi-toy-brick-outline::before {\n  content: \"\\F128D\";\n}\n\n.mdi-toy-brick-plus::before {\n  content: \"\\F128E\";\n}\n\n.mdi-toy-brick-plus-outline::before {\n  content: \"\\F128F\";\n}\n\n.mdi-toy-brick-remove::before {\n  content: \"\\F1290\";\n}\n\n.mdi-toy-brick-remove-outline::before {\n  content: \"\\F1291\";\n}\n\n.mdi-toy-brick-search::before {\n  content: \"\\F1292\";\n}\n\n.mdi-toy-brick-search-outline::before {\n  content: \"\\F1293\";\n}\n\n.mdi-track-light::before {\n  content: \"\\F0914\";\n}\n\n.mdi-trackpad::before {\n  content: \"\\F07F8\";\n}\n\n.mdi-trackpad-lock::before {\n  content: \"\\F0933\";\n}\n\n.mdi-tractor::before {\n  content: \"\\F0892\";\n}\n\n.mdi-tractor-variant::before {\n  content: \"\\F14C4\";\n}\n\n.mdi-trademark::before {\n  content: \"\\F0A78\";\n}\n\n.mdi-traffic-cone::before {\n  content: \"\\F137C\";\n}\n\n.mdi-traffic-light::before {\n  content: \"\\F052B\";\n}\n\n.mdi-traffic-light-outline::before {\n  content: \"\\F182A\";\n}\n\n.mdi-train::before {\n  content: \"\\F052C\";\n}\n\n.mdi-train-car::before {\n  content: \"\\F0BD8\";\n}\n\n.mdi-train-car-passenger::before {\n  content: \"\\F1733\";\n}\n\n.mdi-train-car-passenger-door::before {\n  content: \"\\F1734\";\n}\n\n.mdi-train-car-passenger-door-open::before {\n  content: \"\\F1735\";\n}\n\n.mdi-train-car-passenger-variant::before {\n  content: \"\\F1736\";\n}\n\n.mdi-train-variant::before {\n  content: \"\\F08C4\";\n}\n\n.mdi-tram::before {\n  content: \"\\F052D\";\n}\n\n.mdi-tram-side::before {\n  content: \"\\F0FE7\";\n}\n\n.mdi-transcribe::before {\n  content: \"\\F052E\";\n}\n\n.mdi-transcribe-close::before {\n  content: \"\\F052F\";\n}\n\n.mdi-transfer::before {\n  content: \"\\F1065\";\n}\n\n.mdi-transfer-down::before {\n  content: \"\\F0DA1\";\n}\n\n.mdi-transfer-left::before {\n  content: \"\\F0DA2\";\n}\n\n.mdi-transfer-right::before {\n  content: \"\\F0530\";\n}\n\n.mdi-transfer-up::before {\n  content: \"\\F0DA3\";\n}\n\n.mdi-transit-connection::before {\n  content: \"\\F0D3C\";\n}\n\n.mdi-transit-connection-horizontal::before {\n  content: \"\\F1546\";\n}\n\n.mdi-transit-connection-variant::before {\n  content: \"\\F0D3D\";\n}\n\n.mdi-transit-detour::before {\n  content: \"\\F0F8B\";\n}\n\n.mdi-transit-skip::before {\n  content: \"\\F1515\";\n}\n\n.mdi-transit-transfer::before {\n  content: \"\\F06AE\";\n}\n\n.mdi-transition::before {\n  content: \"\\F0915\";\n}\n\n.mdi-transition-masked::before {\n  content: \"\\F0916\";\n}\n\n.mdi-translate::before {\n  content: \"\\F05CA\";\n}\n\n.mdi-translate-off::before {\n  content: \"\\F0E06\";\n}\n\n.mdi-transmission-tower::before {\n  content: \"\\F0D3E\";\n}\n\n.mdi-transmission-tower-export::before {\n  content: \"\\F192C\";\n}\n\n.mdi-transmission-tower-import::before {\n  content: \"\\F192D\";\n}\n\n.mdi-trash-can::before {\n  content: \"\\F0A79\";\n}\n\n.mdi-trash-can-outline::before {\n  content: \"\\F0A7A\";\n}\n\n.mdi-tray::before {\n  content: \"\\F1294\";\n}\n\n.mdi-tray-alert::before {\n  content: \"\\F1295\";\n}\n\n.mdi-tray-arrow-down::before {\n  content: \"\\F0120\";\n}\n\n.mdi-tray-arrow-up::before {\n  content: \"\\F011D\";\n}\n\n.mdi-tray-full::before {\n  content: \"\\F1296\";\n}\n\n.mdi-tray-minus::before {\n  content: \"\\F1297\";\n}\n\n.mdi-tray-plus::before {\n  content: \"\\F1298\";\n}\n\n.mdi-tray-remove::before {\n  content: \"\\F1299\";\n}\n\n.mdi-treasure-chest::before {\n  content: \"\\F0726\";\n}\n\n.mdi-tree::before {\n  content: \"\\F0531\";\n}\n\n.mdi-tree-outline::before {\n  content: \"\\F0E69\";\n}\n\n.mdi-trello::before {\n  content: \"\\F0532\";\n}\n\n.mdi-trending-down::before {\n  content: \"\\F0533\";\n}\n\n.mdi-trending-neutral::before {\n  content: \"\\F0534\";\n}\n\n.mdi-trending-up::before {\n  content: \"\\F0535\";\n}\n\n.mdi-triangle::before {\n  content: \"\\F0536\";\n}\n\n.mdi-triangle-outline::before {\n  content: \"\\F0537\";\n}\n\n.mdi-triangle-wave::before {\n  content: \"\\F147C\";\n}\n\n.mdi-triforce::before {\n  content: \"\\F0BD9\";\n}\n\n.mdi-trophy::before {\n  content: \"\\F0538\";\n}\n\n.mdi-trophy-award::before {\n  content: \"\\F0539\";\n}\n\n.mdi-trophy-broken::before {\n  content: \"\\F0DA4\";\n}\n\n.mdi-trophy-outline::before {\n  content: \"\\F053A\";\n}\n\n.mdi-trophy-variant::before {\n  content: \"\\F053B\";\n}\n\n.mdi-trophy-variant-outline::before {\n  content: \"\\F053C\";\n}\n\n.mdi-truck::before {\n  content: \"\\F053D\";\n}\n\n.mdi-truck-cargo-container::before {\n  content: \"\\F18D8\";\n}\n\n.mdi-truck-check::before {\n  content: \"\\F0CD4\";\n}\n\n.mdi-truck-check-outline::before {\n  content: \"\\F129A\";\n}\n\n.mdi-truck-delivery::before {\n  content: \"\\F053E\";\n}\n\n.mdi-truck-delivery-outline::before {\n  content: \"\\F129B\";\n}\n\n.mdi-truck-fast::before {\n  content: \"\\F0788\";\n}\n\n.mdi-truck-fast-outline::before {\n  content: \"\\F129C\";\n}\n\n.mdi-truck-flatbed::before {\n  content: \"\\F1891\";\n}\n\n.mdi-truck-minus::before {\n  content: \"\\F19AE\";\n}\n\n.mdi-truck-minus-outline::before {\n  content: \"\\F19BD\";\n}\n\n.mdi-truck-outline::before {\n  content: \"\\F129D\";\n}\n\n.mdi-truck-plus::before {\n  content: \"\\F19AD\";\n}\n\n.mdi-truck-plus-outline::before {\n  content: \"\\F19BC\";\n}\n\n.mdi-truck-remove::before {\n  content: \"\\F19AF\";\n}\n\n.mdi-truck-remove-outline::before {\n  content: \"\\F19BE\";\n}\n\n.mdi-truck-snowflake::before {\n  content: \"\\F19A6\";\n}\n\n.mdi-truck-trailer::before {\n  content: \"\\F0727\";\n}\n\n.mdi-trumpet::before {\n  content: \"\\F1096\";\n}\n\n.mdi-tshirt-crew::before {\n  content: \"\\F0A7B\";\n}\n\n.mdi-tshirt-crew-outline::before {\n  content: \"\\F053F\";\n}\n\n.mdi-tshirt-v::before {\n  content: \"\\F0A7C\";\n}\n\n.mdi-tshirt-v-outline::before {\n  content: \"\\F0540\";\n}\n\n.mdi-tumble-dryer::before {\n  content: \"\\F0917\";\n}\n\n.mdi-tumble-dryer-alert::before {\n  content: \"\\F11BA\";\n}\n\n.mdi-tumble-dryer-off::before {\n  content: \"\\F11BB\";\n}\n\n.mdi-tune::before {\n  content: \"\\F062E\";\n}\n\n.mdi-tune-variant::before {\n  content: \"\\F1542\";\n}\n\n.mdi-tune-vertical::before {\n  content: \"\\F066A\";\n}\n\n.mdi-tune-vertical-variant::before {\n  content: \"\\F1543\";\n}\n\n.mdi-tunnel::before {\n  content: \"\\F183D\";\n}\n\n.mdi-tunnel-outline::before {\n  content: \"\\F183E\";\n}\n\n.mdi-turkey::before {\n  content: \"\\F171B\";\n}\n\n.mdi-turnstile::before {\n  content: \"\\F0CD5\";\n}\n\n.mdi-turnstile-outline::before {\n  content: \"\\F0CD6\";\n}\n\n.mdi-turtle::before {\n  content: \"\\F0CD7\";\n}\n\n.mdi-twitch::before {\n  content: \"\\F0543\";\n}\n\n.mdi-twitter::before {\n  content: \"\\F0544\";\n}\n\n.mdi-two-factor-authentication::before {\n  content: \"\\F09AF\";\n}\n\n.mdi-typewriter::before {\n  content: \"\\F0F2D\";\n}\n\n.mdi-ubisoft::before {\n  content: \"\\F0BDA\";\n}\n\n.mdi-ubuntu::before {\n  content: \"\\F0548\";\n}\n\n.mdi-ufo::before {\n  content: \"\\F10C4\";\n}\n\n.mdi-ufo-outline::before {\n  content: \"\\F10C5\";\n}\n\n.mdi-ultra-high-definition::before {\n  content: \"\\F07F9\";\n}\n\n.mdi-umbraco::before {\n  content: \"\\F0549\";\n}\n\n.mdi-umbrella::before {\n  content: \"\\F054A\";\n}\n\n.mdi-umbrella-beach::before {\n  content: \"\\F188A\";\n}\n\n.mdi-umbrella-beach-outline::before {\n  content: \"\\F188B\";\n}\n\n.mdi-umbrella-closed::before {\n  content: \"\\F09B0\";\n}\n\n.mdi-umbrella-closed-outline::before {\n  content: \"\\F13E2\";\n}\n\n.mdi-umbrella-closed-variant::before {\n  content: \"\\F13E1\";\n}\n\n.mdi-umbrella-outline::before {\n  content: \"\\F054B\";\n}\n\n.mdi-undo::before {\n  content: \"\\F054C\";\n}\n\n.mdi-undo-variant::before {\n  content: \"\\F054D\";\n}\n\n.mdi-unfold-less-horizontal::before {\n  content: \"\\F054E\";\n}\n\n.mdi-unfold-less-vertical::before {\n  content: \"\\F0760\";\n}\n\n.mdi-unfold-more-horizontal::before {\n  content: \"\\F054F\";\n}\n\n.mdi-unfold-more-vertical::before {\n  content: \"\\F0761\";\n}\n\n.mdi-ungroup::before {\n  content: \"\\F0550\";\n}\n\n.mdi-unicode::before {\n  content: \"\\F0ED0\";\n}\n\n.mdi-unicorn::before {\n  content: \"\\F15C2\";\n}\n\n.mdi-unicorn-variant::before {\n  content: \"\\F15C3\";\n}\n\n.mdi-unicycle::before {\n  content: \"\\F15E5\";\n}\n\n.mdi-unity::before {\n  content: \"\\F06AF\";\n}\n\n.mdi-unreal::before {\n  content: \"\\F09B1\";\n}\n\n.mdi-update::before {\n  content: \"\\F06B0\";\n}\n\n.mdi-upload::before {\n  content: \"\\F0552\";\n}\n\n.mdi-upload-lock::before {\n  content: \"\\F1373\";\n}\n\n.mdi-upload-lock-outline::before {\n  content: \"\\F1374\";\n}\n\n.mdi-upload-multiple::before {\n  content: \"\\F083D\";\n}\n\n.mdi-upload-network::before {\n  content: \"\\F06F6\";\n}\n\n.mdi-upload-network-outline::before {\n  content: \"\\F0CD8\";\n}\n\n.mdi-upload-off::before {\n  content: \"\\F10C6\";\n}\n\n.mdi-upload-off-outline::before {\n  content: \"\\F10C7\";\n}\n\n.mdi-upload-outline::before {\n  content: \"\\F0E07\";\n}\n\n.mdi-usb::before {\n  content: \"\\F0553\";\n}\n\n.mdi-usb-flash-drive::before {\n  content: \"\\F129E\";\n}\n\n.mdi-usb-flash-drive-outline::before {\n  content: \"\\F129F\";\n}\n\n.mdi-usb-port::before {\n  content: \"\\F11F0\";\n}\n\n.mdi-vacuum::before {\n  content: \"\\F19A1\";\n}\n\n.mdi-vacuum-outline::before {\n  content: \"\\F19A2\";\n}\n\n.mdi-valve::before {\n  content: \"\\F1066\";\n}\n\n.mdi-valve-closed::before {\n  content: \"\\F1067\";\n}\n\n.mdi-valve-open::before {\n  content: \"\\F1068\";\n}\n\n.mdi-van-passenger::before {\n  content: \"\\F07FA\";\n}\n\n.mdi-van-utility::before {\n  content: \"\\F07FB\";\n}\n\n.mdi-vanish::before {\n  content: \"\\F07FC\";\n}\n\n.mdi-vanish-quarter::before {\n  content: \"\\F1554\";\n}\n\n.mdi-vanity-light::before {\n  content: \"\\F11E1\";\n}\n\n.mdi-variable::before {\n  content: \"\\F0AE7\";\n}\n\n.mdi-variable-box::before {\n  content: \"\\F1111\";\n}\n\n.mdi-vector-arrange-above::before {\n  content: \"\\F0554\";\n}\n\n.mdi-vector-arrange-below::before {\n  content: \"\\F0555\";\n}\n\n.mdi-vector-bezier::before {\n  content: \"\\F0AE8\";\n}\n\n.mdi-vector-circle::before {\n  content: \"\\F0556\";\n}\n\n.mdi-vector-circle-variant::before {\n  content: \"\\F0557\";\n}\n\n.mdi-vector-combine::before {\n  content: \"\\F0558\";\n}\n\n.mdi-vector-curve::before {\n  content: \"\\F0559\";\n}\n\n.mdi-vector-difference::before {\n  content: \"\\F055A\";\n}\n\n.mdi-vector-difference-ab::before {\n  content: \"\\F055B\";\n}\n\n.mdi-vector-difference-ba::before {\n  content: \"\\F055C\";\n}\n\n.mdi-vector-ellipse::before {\n  content: \"\\F0893\";\n}\n\n.mdi-vector-intersection::before {\n  content: \"\\F055D\";\n}\n\n.mdi-vector-line::before {\n  content: \"\\F055E\";\n}\n\n.mdi-vector-link::before {\n  content: \"\\F0FE8\";\n}\n\n.mdi-vector-point::before {\n  content: \"\\F055F\";\n}\n\n.mdi-vector-polygon::before {\n  content: \"\\F0560\";\n}\n\n.mdi-vector-polygon-variant::before {\n  content: \"\\F1856\";\n}\n\n.mdi-vector-polyline::before {\n  content: \"\\F0561\";\n}\n\n.mdi-vector-polyline-edit::before {\n  content: \"\\F1225\";\n}\n\n.mdi-vector-polyline-minus::before {\n  content: \"\\F1226\";\n}\n\n.mdi-vector-polyline-plus::before {\n  content: \"\\F1227\";\n}\n\n.mdi-vector-polyline-remove::before {\n  content: \"\\F1228\";\n}\n\n.mdi-vector-radius::before {\n  content: \"\\F074A\";\n}\n\n.mdi-vector-rectangle::before {\n  content: \"\\F05C6\";\n}\n\n.mdi-vector-selection::before {\n  content: \"\\F0562\";\n}\n\n.mdi-vector-square::before {\n  content: \"\\F0001\";\n}\n\n.mdi-vector-square-close::before {\n  content: \"\\F1857\";\n}\n\n.mdi-vector-square-edit::before {\n  content: \"\\F18D9\";\n}\n\n.mdi-vector-square-minus::before {\n  content: \"\\F18DA\";\n}\n\n.mdi-vector-square-open::before {\n  content: \"\\F1858\";\n}\n\n.mdi-vector-square-plus::before {\n  content: \"\\F18DB\";\n}\n\n.mdi-vector-square-remove::before {\n  content: \"\\F18DC\";\n}\n\n.mdi-vector-triangle::before {\n  content: \"\\F0563\";\n}\n\n.mdi-vector-union::before {\n  content: \"\\F0564\";\n}\n\n.mdi-vhs::before {\n  content: \"\\F0A1B\";\n}\n\n.mdi-vibrate::before {\n  content: \"\\F0566\";\n}\n\n.mdi-vibrate-off::before {\n  content: \"\\F0CD9\";\n}\n\n.mdi-video::before {\n  content: \"\\F0567\";\n}\n\n.mdi-video-3d::before {\n  content: \"\\F07FD\";\n}\n\n.mdi-video-3d-off::before {\n  content: \"\\F13D9\";\n}\n\n.mdi-video-3d-variant::before {\n  content: \"\\F0ED1\";\n}\n\n.mdi-video-4k-box::before {\n  content: \"\\F083E\";\n}\n\n.mdi-video-account::before {\n  content: \"\\F0919\";\n}\n\n.mdi-video-box::before {\n  content: \"\\F00FD\";\n}\n\n.mdi-video-box-off::before {\n  content: \"\\F00FE\";\n}\n\n.mdi-video-check::before {\n  content: \"\\F1069\";\n}\n\n.mdi-video-check-outline::before {\n  content: \"\\F106A\";\n}\n\n.mdi-video-high-definition::before {\n  content: \"\\F152E\";\n}\n\n.mdi-video-image::before {\n  content: \"\\F091A\";\n}\n\n.mdi-video-input-antenna::before {\n  content: \"\\F083F\";\n}\n\n.mdi-video-input-component::before {\n  content: \"\\F0840\";\n}\n\n.mdi-video-input-hdmi::before {\n  content: \"\\F0841\";\n}\n\n.mdi-video-input-scart::before {\n  content: \"\\F0F8C\";\n}\n\n.mdi-video-input-svideo::before {\n  content: \"\\F0842\";\n}\n\n.mdi-video-marker::before {\n  content: \"\\F19A9\";\n}\n\n.mdi-video-marker-outline::before {\n  content: \"\\F19AA\";\n}\n\n.mdi-video-minus::before {\n  content: \"\\F09B2\";\n}\n\n.mdi-video-minus-outline::before {\n  content: \"\\F02BA\";\n}\n\n.mdi-video-off::before {\n  content: \"\\F0568\";\n}\n\n.mdi-video-off-outline::before {\n  content: \"\\F0BDB\";\n}\n\n.mdi-video-outline::before {\n  content: \"\\F0BDC\";\n}\n\n.mdi-video-plus::before {\n  content: \"\\F09B3\";\n}\n\n.mdi-video-plus-outline::before {\n  content: \"\\F01D3\";\n}\n\n.mdi-video-stabilization::before {\n  content: \"\\F091B\";\n}\n\n.mdi-video-switch::before {\n  content: \"\\F0569\";\n}\n\n.mdi-video-switch-outline::before {\n  content: \"\\F0790\";\n}\n\n.mdi-video-vintage::before {\n  content: \"\\F0A1C\";\n}\n\n.mdi-video-wireless::before {\n  content: \"\\F0ED2\";\n}\n\n.mdi-video-wireless-outline::before {\n  content: \"\\F0ED3\";\n}\n\n.mdi-view-agenda::before {\n  content: \"\\F056A\";\n}\n\n.mdi-view-agenda-outline::before {\n  content: \"\\F11D8\";\n}\n\n.mdi-view-array::before {\n  content: \"\\F056B\";\n}\n\n.mdi-view-array-outline::before {\n  content: \"\\F1485\";\n}\n\n.mdi-view-carousel::before {\n  content: \"\\F056C\";\n}\n\n.mdi-view-carousel-outline::before {\n  content: \"\\F1486\";\n}\n\n.mdi-view-column::before {\n  content: \"\\F056D\";\n}\n\n.mdi-view-column-outline::before {\n  content: \"\\F1487\";\n}\n\n.mdi-view-comfy::before {\n  content: \"\\F0E6A\";\n}\n\n.mdi-view-comfy-outline::before {\n  content: \"\\F1488\";\n}\n\n.mdi-view-compact::before {\n  content: \"\\F0E6B\";\n}\n\n.mdi-view-compact-outline::before {\n  content: \"\\F0E6C\";\n}\n\n.mdi-view-dashboard::before {\n  content: \"\\F056E\";\n}\n\n.mdi-view-dashboard-edit::before {\n  content: \"\\F1947\";\n}\n\n.mdi-view-dashboard-edit-outline::before {\n  content: \"\\F1948\";\n}\n\n.mdi-view-dashboard-outline::before {\n  content: \"\\F0A1D\";\n}\n\n.mdi-view-dashboard-variant::before {\n  content: \"\\F0843\";\n}\n\n.mdi-view-dashboard-variant-outline::before {\n  content: \"\\F1489\";\n}\n\n.mdi-view-day::before {\n  content: \"\\F056F\";\n}\n\n.mdi-view-day-outline::before {\n  content: \"\\F148A\";\n}\n\n.mdi-view-gallery::before {\n  content: \"\\F1888\";\n}\n\n.mdi-view-gallery-outline::before {\n  content: \"\\F1889\";\n}\n\n.mdi-view-grid::before {\n  content: \"\\F0570\";\n}\n\n.mdi-view-grid-outline::before {\n  content: \"\\F11D9\";\n}\n\n.mdi-view-grid-plus::before {\n  content: \"\\F0F8D\";\n}\n\n.mdi-view-grid-plus-outline::before {\n  content: \"\\F11DA\";\n}\n\n.mdi-view-headline::before {\n  content: \"\\F0571\";\n}\n\n.mdi-view-list::before {\n  content: \"\\F0572\";\n}\n\n.mdi-view-list-outline::before {\n  content: \"\\F148B\";\n}\n\n.mdi-view-module::before {\n  content: \"\\F0573\";\n}\n\n.mdi-view-module-outline::before {\n  content: \"\\F148C\";\n}\n\n.mdi-view-parallel::before {\n  content: \"\\F0728\";\n}\n\n.mdi-view-parallel-outline::before {\n  content: \"\\F148D\";\n}\n\n.mdi-view-quilt::before {\n  content: \"\\F0574\";\n}\n\n.mdi-view-quilt-outline::before {\n  content: \"\\F148E\";\n}\n\n.mdi-view-sequential::before {\n  content: \"\\F0729\";\n}\n\n.mdi-view-sequential-outline::before {\n  content: \"\\F148F\";\n}\n\n.mdi-view-split-horizontal::before {\n  content: \"\\F0BCB\";\n}\n\n.mdi-view-split-vertical::before {\n  content: \"\\F0BCC\";\n}\n\n.mdi-view-stream::before {\n  content: \"\\F0575\";\n}\n\n.mdi-view-stream-outline::before {\n  content: \"\\F1490\";\n}\n\n.mdi-view-week::before {\n  content: \"\\F0576\";\n}\n\n.mdi-view-week-outline::before {\n  content: \"\\F1491\";\n}\n\n.mdi-vimeo::before {\n  content: \"\\F0577\";\n}\n\n.mdi-violin::before {\n  content: \"\\F060F\";\n}\n\n.mdi-virtual-reality::before {\n  content: \"\\F0894\";\n}\n\n.mdi-virus::before {\n  content: \"\\F13B6\";\n}\n\n.mdi-virus-off::before {\n  content: \"\\F18E1\";\n}\n\n.mdi-virus-off-outline::before {\n  content: \"\\F18E2\";\n}\n\n.mdi-virus-outline::before {\n  content: \"\\F13B7\";\n}\n\n.mdi-vlc::before {\n  content: \"\\F057C\";\n}\n\n.mdi-voicemail::before {\n  content: \"\\F057D\";\n}\n\n.mdi-volleyball::before {\n  content: \"\\F09B4\";\n}\n\n.mdi-volume-high::before {\n  content: \"\\F057E\";\n}\n\n.mdi-volume-low::before {\n  content: \"\\F057F\";\n}\n\n.mdi-volume-medium::before {\n  content: \"\\F0580\";\n}\n\n.mdi-volume-minus::before {\n  content: \"\\F075E\";\n}\n\n.mdi-volume-mute::before {\n  content: \"\\F075F\";\n}\n\n.mdi-volume-off::before {\n  content: \"\\F0581\";\n}\n\n.mdi-volume-plus::before {\n  content: \"\\F075D\";\n}\n\n.mdi-volume-source::before {\n  content: \"\\F1120\";\n}\n\n.mdi-volume-variant-off::before {\n  content: \"\\F0E08\";\n}\n\n.mdi-volume-vibrate::before {\n  content: \"\\F1121\";\n}\n\n.mdi-vote::before {\n  content: \"\\F0A1F\";\n}\n\n.mdi-vote-outline::before {\n  content: \"\\F0A20\";\n}\n\n.mdi-vpn::before {\n  content: \"\\F0582\";\n}\n\n.mdi-vuejs::before {\n  content: \"\\F0844\";\n}\n\n.mdi-vuetify::before {\n  content: \"\\F0E6D\";\n}\n\n.mdi-walk::before {\n  content: \"\\F0583\";\n}\n\n.mdi-wall::before {\n  content: \"\\F07FE\";\n}\n\n.mdi-wall-sconce::before {\n  content: \"\\F091C\";\n}\n\n.mdi-wall-sconce-flat::before {\n  content: \"\\F091D\";\n}\n\n.mdi-wall-sconce-flat-outline::before {\n  content: \"\\F17C9\";\n}\n\n.mdi-wall-sconce-flat-variant::before {\n  content: \"\\F041C\";\n}\n\n.mdi-wall-sconce-flat-variant-outline::before {\n  content: \"\\F17CA\";\n}\n\n.mdi-wall-sconce-outline::before {\n  content: \"\\F17CB\";\n}\n\n.mdi-wall-sconce-round::before {\n  content: \"\\F0748\";\n}\n\n.mdi-wall-sconce-round-outline::before {\n  content: \"\\F17CC\";\n}\n\n.mdi-wall-sconce-round-variant::before {\n  content: \"\\F091E\";\n}\n\n.mdi-wall-sconce-round-variant-outline::before {\n  content: \"\\F17CD\";\n}\n\n.mdi-wallet::before {\n  content: \"\\F0584\";\n}\n\n.mdi-wallet-giftcard::before {\n  content: \"\\F0585\";\n}\n\n.mdi-wallet-membership::before {\n  content: \"\\F0586\";\n}\n\n.mdi-wallet-outline::before {\n  content: \"\\F0BDD\";\n}\n\n.mdi-wallet-plus::before {\n  content: \"\\F0F8E\";\n}\n\n.mdi-wallet-plus-outline::before {\n  content: \"\\F0F8F\";\n}\n\n.mdi-wallet-travel::before {\n  content: \"\\F0587\";\n}\n\n.mdi-wallpaper::before {\n  content: \"\\F0E09\";\n}\n\n.mdi-wan::before {\n  content: \"\\F0588\";\n}\n\n.mdi-wardrobe::before {\n  content: \"\\F0F90\";\n}\n\n.mdi-wardrobe-outline::before {\n  content: \"\\F0F91\";\n}\n\n.mdi-warehouse::before {\n  content: \"\\F0F81\";\n}\n\n.mdi-washing-machine::before {\n  content: \"\\F072A\";\n}\n\n.mdi-washing-machine-alert::before {\n  content: \"\\F11BC\";\n}\n\n.mdi-washing-machine-off::before {\n  content: \"\\F11BD\";\n}\n\n.mdi-watch::before {\n  content: \"\\F0589\";\n}\n\n.mdi-watch-export::before {\n  content: \"\\F058A\";\n}\n\n.mdi-watch-export-variant::before {\n  content: \"\\F0895\";\n}\n\n.mdi-watch-import::before {\n  content: \"\\F058B\";\n}\n\n.mdi-watch-import-variant::before {\n  content: \"\\F0896\";\n}\n\n.mdi-watch-variant::before {\n  content: \"\\F0897\";\n}\n\n.mdi-watch-vibrate::before {\n  content: \"\\F06B1\";\n}\n\n.mdi-watch-vibrate-off::before {\n  content: \"\\F0CDA\";\n}\n\n.mdi-water::before {\n  content: \"\\F058C\";\n}\n\n.mdi-water-alert::before {\n  content: \"\\F1502\";\n}\n\n.mdi-water-alert-outline::before {\n  content: \"\\F1503\";\n}\n\n.mdi-water-boiler::before {\n  content: \"\\F0F92\";\n}\n\n.mdi-water-boiler-alert::before {\n  content: \"\\F11B3\";\n}\n\n.mdi-water-boiler-off::before {\n  content: \"\\F11B4\";\n}\n\n.mdi-water-check::before {\n  content: \"\\F1504\";\n}\n\n.mdi-water-check-outline::before {\n  content: \"\\F1505\";\n}\n\n.mdi-water-circle::before {\n  content: \"\\F1806\";\n}\n\n.mdi-water-minus::before {\n  content: \"\\F1506\";\n}\n\n.mdi-water-minus-outline::before {\n  content: \"\\F1507\";\n}\n\n.mdi-water-off::before {\n  content: \"\\F058D\";\n}\n\n.mdi-water-off-outline::before {\n  content: \"\\F1508\";\n}\n\n.mdi-water-opacity::before {\n  content: \"\\F1855\";\n}\n\n.mdi-water-outline::before {\n  content: \"\\F0E0A\";\n}\n\n.mdi-water-percent::before {\n  content: \"\\F058E\";\n}\n\n.mdi-water-percent-alert::before {\n  content: \"\\F1509\";\n}\n\n.mdi-water-plus::before {\n  content: \"\\F150A\";\n}\n\n.mdi-water-plus-outline::before {\n  content: \"\\F150B\";\n}\n\n.mdi-water-polo::before {\n  content: \"\\F12A0\";\n}\n\n.mdi-water-pump::before {\n  content: \"\\F058F\";\n}\n\n.mdi-water-pump-off::before {\n  content: \"\\F0F93\";\n}\n\n.mdi-water-remove::before {\n  content: \"\\F150C\";\n}\n\n.mdi-water-remove-outline::before {\n  content: \"\\F150D\";\n}\n\n.mdi-water-sync::before {\n  content: \"\\F17C6\";\n}\n\n.mdi-water-well::before {\n  content: \"\\F106B\";\n}\n\n.mdi-water-well-outline::before {\n  content: \"\\F106C\";\n}\n\n.mdi-waterfall::before {\n  content: \"\\F1849\";\n}\n\n.mdi-watering-can::before {\n  content: \"\\F1481\";\n}\n\n.mdi-watering-can-outline::before {\n  content: \"\\F1482\";\n}\n\n.mdi-watermark::before {\n  content: \"\\F0612\";\n}\n\n.mdi-wave::before {\n  content: \"\\F0F2E\";\n}\n\n.mdi-waveform::before {\n  content: \"\\F147D\";\n}\n\n.mdi-waves::before {\n  content: \"\\F078D\";\n}\n\n.mdi-waves-arrow-left::before {\n  content: \"\\F1859\";\n}\n\n.mdi-waves-arrow-right::before {\n  content: \"\\F185A\";\n}\n\n.mdi-waves-arrow-up::before {\n  content: \"\\F185B\";\n}\n\n.mdi-waze::before {\n  content: \"\\F0BDE\";\n}\n\n.mdi-weather-cloudy::before {\n  content: \"\\F0590\";\n}\n\n.mdi-weather-cloudy-alert::before {\n  content: \"\\F0F2F\";\n}\n\n.mdi-weather-cloudy-arrow-right::before {\n  content: \"\\F0E6E\";\n}\n\n.mdi-weather-cloudy-clock::before {\n  content: \"\\F18F6\";\n}\n\n.mdi-weather-fog::before {\n  content: \"\\F0591\";\n}\n\n.mdi-weather-hail::before {\n  content: \"\\F0592\";\n}\n\n.mdi-weather-hazy::before {\n  content: \"\\F0F30\";\n}\n\n.mdi-weather-hurricane::before {\n  content: \"\\F0898\";\n}\n\n.mdi-weather-lightning::before {\n  content: \"\\F0593\";\n}\n\n.mdi-weather-lightning-rainy::before {\n  content: \"\\F067E\";\n}\n\n.mdi-weather-night::before {\n  content: \"\\F0594\";\n}\n\n.mdi-weather-night-partly-cloudy::before {\n  content: \"\\F0F31\";\n}\n\n.mdi-weather-partly-cloudy::before {\n  content: \"\\F0595\";\n}\n\n.mdi-weather-partly-lightning::before {\n  content: \"\\F0F32\";\n}\n\n.mdi-weather-partly-rainy::before {\n  content: \"\\F0F33\";\n}\n\n.mdi-weather-partly-snowy::before {\n  content: \"\\F0F34\";\n}\n\n.mdi-weather-partly-snowy-rainy::before {\n  content: \"\\F0F35\";\n}\n\n.mdi-weather-pouring::before {\n  content: \"\\F0596\";\n}\n\n.mdi-weather-rainy::before {\n  content: \"\\F0597\";\n}\n\n.mdi-weather-snowy::before {\n  content: \"\\F0598\";\n}\n\n.mdi-weather-snowy-heavy::before {\n  content: \"\\F0F36\";\n}\n\n.mdi-weather-snowy-rainy::before {\n  content: \"\\F067F\";\n}\n\n.mdi-weather-sunny::before {\n  content: \"\\F0599\";\n}\n\n.mdi-weather-sunny-alert::before {\n  content: \"\\F0F37\";\n}\n\n.mdi-weather-sunny-off::before {\n  content: \"\\F14E4\";\n}\n\n.mdi-weather-sunset::before {\n  content: \"\\F059A\";\n}\n\n.mdi-weather-sunset-down::before {\n  content: \"\\F059B\";\n}\n\n.mdi-weather-sunset-up::before {\n  content: \"\\F059C\";\n}\n\n.mdi-weather-tornado::before {\n  content: \"\\F0F38\";\n}\n\n.mdi-weather-windy::before {\n  content: \"\\F059D\";\n}\n\n.mdi-weather-windy-variant::before {\n  content: \"\\F059E\";\n}\n\n.mdi-web::before {\n  content: \"\\F059F\";\n}\n\n.mdi-web-box::before {\n  content: \"\\F0F94\";\n}\n\n.mdi-web-cancel::before {\n  content: \"\\F1790\";\n}\n\n.mdi-web-check::before {\n  content: \"\\F0789\";\n}\n\n.mdi-web-clock::before {\n  content: \"\\F124A\";\n}\n\n.mdi-web-minus::before {\n  content: \"\\F10A0\";\n}\n\n.mdi-web-off::before {\n  content: \"\\F0A8E\";\n}\n\n.mdi-web-plus::before {\n  content: \"\\F0033\";\n}\n\n.mdi-web-refresh::before {\n  content: \"\\F1791\";\n}\n\n.mdi-web-remove::before {\n  content: \"\\F0551\";\n}\n\n.mdi-web-sync::before {\n  content: \"\\F1792\";\n}\n\n.mdi-webcam::before {\n  content: \"\\F05A0\";\n}\n\n.mdi-webcam-off::before {\n  content: \"\\F1737\";\n}\n\n.mdi-webhook::before {\n  content: \"\\F062F\";\n}\n\n.mdi-webpack::before {\n  content: \"\\F072B\";\n}\n\n.mdi-webrtc::before {\n  content: \"\\F1248\";\n}\n\n.mdi-wechat::before {\n  content: \"\\F0611\";\n}\n\n.mdi-weight::before {\n  content: \"\\F05A1\";\n}\n\n.mdi-weight-gram::before {\n  content: \"\\F0D3F\";\n}\n\n.mdi-weight-kilogram::before {\n  content: \"\\F05A2\";\n}\n\n.mdi-weight-lifter::before {\n  content: \"\\F115D\";\n}\n\n.mdi-weight-pound::before {\n  content: \"\\F09B5\";\n}\n\n.mdi-whatsapp::before {\n  content: \"\\F05A3\";\n}\n\n.mdi-wheel-barrow::before {\n  content: \"\\F14F2\";\n}\n\n.mdi-wheelchair-accessibility::before {\n  content: \"\\F05A4\";\n}\n\n.mdi-whistle::before {\n  content: \"\\F09B6\";\n}\n\n.mdi-whistle-outline::before {\n  content: \"\\F12BC\";\n}\n\n.mdi-white-balance-auto::before {\n  content: \"\\F05A5\";\n}\n\n.mdi-white-balance-incandescent::before {\n  content: \"\\F05A6\";\n}\n\n.mdi-white-balance-iridescent::before {\n  content: \"\\F05A7\";\n}\n\n.mdi-white-balance-sunny::before {\n  content: \"\\F05A8\";\n}\n\n.mdi-widgets::before {\n  content: \"\\F072C\";\n}\n\n.mdi-widgets-outline::before {\n  content: \"\\F1355\";\n}\n\n.mdi-wifi::before {\n  content: \"\\F05A9\";\n}\n\n.mdi-wifi-alert::before {\n  content: \"\\F16B5\";\n}\n\n.mdi-wifi-arrow-down::before {\n  content: \"\\F16B6\";\n}\n\n.mdi-wifi-arrow-left::before {\n  content: \"\\F16B7\";\n}\n\n.mdi-wifi-arrow-left-right::before {\n  content: \"\\F16B8\";\n}\n\n.mdi-wifi-arrow-right::before {\n  content: \"\\F16B9\";\n}\n\n.mdi-wifi-arrow-up::before {\n  content: \"\\F16BA\";\n}\n\n.mdi-wifi-arrow-up-down::before {\n  content: \"\\F16BB\";\n}\n\n.mdi-wifi-cancel::before {\n  content: \"\\F16BC\";\n}\n\n.mdi-wifi-check::before {\n  content: \"\\F16BD\";\n}\n\n.mdi-wifi-cog::before {\n  content: \"\\F16BE\";\n}\n\n.mdi-wifi-lock::before {\n  content: \"\\F16BF\";\n}\n\n.mdi-wifi-lock-open::before {\n  content: \"\\F16C0\";\n}\n\n.mdi-wifi-marker::before {\n  content: \"\\F16C1\";\n}\n\n.mdi-wifi-minus::before {\n  content: \"\\F16C2\";\n}\n\n.mdi-wifi-off::before {\n  content: \"\\F05AA\";\n}\n\n.mdi-wifi-plus::before {\n  content: \"\\F16C3\";\n}\n\n.mdi-wifi-refresh::before {\n  content: \"\\F16C4\";\n}\n\n.mdi-wifi-remove::before {\n  content: \"\\F16C5\";\n}\n\n.mdi-wifi-settings::before {\n  content: \"\\F16C6\";\n}\n\n.mdi-wifi-star::before {\n  content: \"\\F0E0B\";\n}\n\n.mdi-wifi-strength-1::before {\n  content: \"\\F091F\";\n}\n\n.mdi-wifi-strength-1-alert::before {\n  content: \"\\F0920\";\n}\n\n.mdi-wifi-strength-1-lock::before {\n  content: \"\\F0921\";\n}\n\n.mdi-wifi-strength-1-lock-open::before {\n  content: \"\\F16CB\";\n}\n\n.mdi-wifi-strength-2::before {\n  content: \"\\F0922\";\n}\n\n.mdi-wifi-strength-2-alert::before {\n  content: \"\\F0923\";\n}\n\n.mdi-wifi-strength-2-lock::before {\n  content: \"\\F0924\";\n}\n\n.mdi-wifi-strength-2-lock-open::before {\n  content: \"\\F16CC\";\n}\n\n.mdi-wifi-strength-3::before {\n  content: \"\\F0925\";\n}\n\n.mdi-wifi-strength-3-alert::before {\n  content: \"\\F0926\";\n}\n\n.mdi-wifi-strength-3-lock::before {\n  content: \"\\F0927\";\n}\n\n.mdi-wifi-strength-3-lock-open::before {\n  content: \"\\F16CD\";\n}\n\n.mdi-wifi-strength-4::before {\n  content: \"\\F0928\";\n}\n\n.mdi-wifi-strength-4-alert::before {\n  content: \"\\F0929\";\n}\n\n.mdi-wifi-strength-4-lock::before {\n  content: \"\\F092A\";\n}\n\n.mdi-wifi-strength-4-lock-open::before {\n  content: \"\\F16CE\";\n}\n\n.mdi-wifi-strength-alert-outline::before {\n  content: \"\\F092B\";\n}\n\n.mdi-wifi-strength-lock-open-outline::before {\n  content: \"\\F16CF\";\n}\n\n.mdi-wifi-strength-lock-outline::before {\n  content: \"\\F092C\";\n}\n\n.mdi-wifi-strength-off::before {\n  content: \"\\F092D\";\n}\n\n.mdi-wifi-strength-off-outline::before {\n  content: \"\\F092E\";\n}\n\n.mdi-wifi-strength-outline::before {\n  content: \"\\F092F\";\n}\n\n.mdi-wifi-sync::before {\n  content: \"\\F16C7\";\n}\n\n.mdi-wikipedia::before {\n  content: \"\\F05AC\";\n}\n\n.mdi-wind-turbine::before {\n  content: \"\\F0DA5\";\n}\n\n.mdi-wind-turbine-alert::before {\n  content: \"\\F19AB\";\n}\n\n.mdi-wind-turbine-check::before {\n  content: \"\\F19AC\";\n}\n\n.mdi-window-close::before {\n  content: \"\\F05AD\";\n}\n\n.mdi-window-closed::before {\n  content: \"\\F05AE\";\n}\n\n.mdi-window-closed-variant::before {\n  content: \"\\F11DB\";\n}\n\n.mdi-window-maximize::before {\n  content: \"\\F05AF\";\n}\n\n.mdi-window-minimize::before {\n  content: \"\\F05B0\";\n}\n\n.mdi-window-open::before {\n  content: \"\\F05B1\";\n}\n\n.mdi-window-open-variant::before {\n  content: \"\\F11DC\";\n}\n\n.mdi-window-restore::before {\n  content: \"\\F05B2\";\n}\n\n.mdi-window-shutter::before {\n  content: \"\\F111C\";\n}\n\n.mdi-window-shutter-alert::before {\n  content: \"\\F111D\";\n}\n\n.mdi-window-shutter-open::before {\n  content: \"\\F111E\";\n}\n\n.mdi-windsock::before {\n  content: \"\\F15FA\";\n}\n\n.mdi-wiper::before {\n  content: \"\\F0AE9\";\n}\n\n.mdi-wiper-wash::before {\n  content: \"\\F0DA6\";\n}\n\n.mdi-wiper-wash-alert::before {\n  content: \"\\F18DF\";\n}\n\n.mdi-wizard-hat::before {\n  content: \"\\F1477\";\n}\n\n.mdi-wordpress::before {\n  content: \"\\F05B4\";\n}\n\n.mdi-wrap::before {\n  content: \"\\F05B6\";\n}\n\n.mdi-wrap-disabled::before {\n  content: \"\\F0BDF\";\n}\n\n.mdi-wrench::before {\n  content: \"\\F05B7\";\n}\n\n.mdi-wrench-clock::before {\n  content: \"\\F19A3\";\n}\n\n.mdi-wrench-outline::before {\n  content: \"\\F0BE0\";\n}\n\n.mdi-xamarin::before {\n  content: \"\\F0845\";\n}\n\n.mdi-xml::before {\n  content: \"\\F05C0\";\n}\n\n.mdi-xmpp::before {\n  content: \"\\F07FF\";\n}\n\n.mdi-yahoo::before {\n  content: \"\\F0B4F\";\n}\n\n.mdi-yeast::before {\n  content: \"\\F05C1\";\n}\n\n.mdi-yin-yang::before {\n  content: \"\\F0680\";\n}\n\n.mdi-yoga::before {\n  content: \"\\F117C\";\n}\n\n.mdi-youtube::before {\n  content: \"\\F05C3\";\n}\n\n.mdi-youtube-gaming::before {\n  content: \"\\F0848\";\n}\n\n.mdi-youtube-studio::before {\n  content: \"\\F0847\";\n}\n\n.mdi-youtube-subscription::before {\n  content: \"\\F0D40\";\n}\n\n.mdi-youtube-tv::before {\n  content: \"\\F0448\";\n}\n\n.mdi-yurt::before {\n  content: \"\\F1516\";\n}\n\n.mdi-z-wave::before {\n  content: \"\\F0AEA\";\n}\n\n.mdi-zend::before {\n  content: \"\\F0AEB\";\n}\n\n.mdi-zigbee::before {\n  content: \"\\F0D41\";\n}\n\n.mdi-zip-box::before {\n  content: \"\\F05C4\";\n}\n\n.mdi-zip-box-outline::before {\n  content: \"\\F0FFA\";\n}\n\n.mdi-zip-disk::before {\n  content: \"\\F0A23\";\n}\n\n.mdi-zodiac-aquarius::before {\n  content: \"\\F0A7D\";\n}\n\n.mdi-zodiac-aries::before {\n  content: \"\\F0A7E\";\n}\n\n.mdi-zodiac-cancer::before {\n  content: \"\\F0A7F\";\n}\n\n.mdi-zodiac-capricorn::before {\n  content: \"\\F0A80\";\n}\n\n.mdi-zodiac-gemini::before {\n  content: \"\\F0A81\";\n}\n\n.mdi-zodiac-leo::before {\n  content: \"\\F0A82\";\n}\n\n.mdi-zodiac-libra::before {\n  content: \"\\F0A83\";\n}\n\n.mdi-zodiac-pisces::before {\n  content: \"\\F0A84\";\n}\n\n.mdi-zodiac-sagittarius::before {\n  content: \"\\F0A85\";\n}\n\n.mdi-zodiac-scorpio::before {\n  content: \"\\F0A86\";\n}\n\n.mdi-zodiac-taurus::before {\n  content: \"\\F0A87\";\n}\n\n.mdi-zodiac-virgo::before {\n  content: \"\\F0A88\";\n}\n\n.mdi-blank::before {\n  content: \"\\F68C\";\n  visibility: hidden;\n}\n\n.mdi-18px.mdi-set, .mdi-18px.mdi:before {\n  font-size: 18px;\n}\n\n.mdi-24px.mdi-set, .mdi-24px.mdi:before {\n  font-size: 24px;\n}\n\n.mdi-36px.mdi-set, .mdi-36px.mdi:before {\n  font-size: 36px;\n}\n\n.mdi-48px.mdi-set, .mdi-48px.mdi:before {\n  font-size: 48px;\n}\n\n.mdi-dark:before {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, 0.26);\n}\n\n.mdi-light:before {\n  color: white;\n}\n\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mdi-rotate-45 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(45deg);\n            transform: scaleX(-1) rotate(45deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: scaleY(-1) rotate(45deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.mdi-rotate-90 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(90deg);\n            transform: scaleX(-1) rotate(90deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(90deg);\n            -ms-transform: rotate(90deg);\n            transform: scaleY(-1) rotate(90deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.mdi-rotate-135 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(135deg);\n            -ms-transform: rotate(135deg);\n            transform: scaleY(-1) rotate(135deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n.mdi-rotate-180 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(180deg);\n            transform: scaleX(-1) rotate(180deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(180deg);\n            -ms-transform: rotate(180deg);\n            transform: scaleY(-1) rotate(180deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.mdi-rotate-225 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(225deg);\n            transform: scaleX(-1) rotate(225deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(225deg);\n            -ms-transform: rotate(225deg);\n            transform: scaleY(-1) rotate(225deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n\n.mdi-rotate-270 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(270deg);\n            transform: scaleX(-1) rotate(270deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(270deg);\n            -ms-transform: rotate(270deg);\n            transform: scaleY(-1) rotate(270deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.mdi-rotate-315 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(315deg);\n            transform: scaleX(-1) rotate(315deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(315deg);\n            -ms-transform: rotate(315deg);\n            transform: scaleY(-1) rotate(315deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n  -ms-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipV;\n  -ms-filter: \"FlipV\";\n}\n\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n  animation: mdi-spin 2s infinite linear;\n}\n\n@-webkit-keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n/*# sourceMappingURL=materialdesignicons.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
